/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/include-every-customer/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 149);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(156);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(168)();
}


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACCORDION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ACCORDION_PANEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ALERT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ALERT_CONTAINER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return APP_LAUNCHER; });
/* unused harmony export APP_LAUNCHER_SECTION */
/* unused harmony export APP_LAUNCHER_TILE */
/* unused harmony export APP_LAUNCHER_HEADER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return AVATAR; });
/* unused harmony export BREAD_CRUMB */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return BREADCRUMB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return BUTTON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return BUTTON_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return BUTTON_STATEFUL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return BUTTON_ICON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CARD_BODY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CARD_EMPTY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CARD_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return CARD_FOOTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CARD_HEADER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return COMBOBOX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return DATA_TABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return DATA_TABLE_CELL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return DATA_TABLE_COLUMN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return DATA_TABLE_HEAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return DATA_TABLE_HEADER_CELL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return DATA_TABLE_ROW_ACTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return DATA_TABLE_ROW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return DATE_PICKER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return DIALOG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CHECKBOX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return FORMS_INLINE_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return INPUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return TEXTAREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return GLOBAL_HEADER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return GLOBAL_HEADER_PROFILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return GLOBAL_HEADER_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return GLOBAL_HEADER_TOOL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return GLOBAL_NAVIGATION_BAR; });
/* unused harmony export GLOBAL_NAVIGATION_BAR_BUTTON */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return GLOBAL_NAVIGATION_BAR_DROPDOWN; });
/* unused harmony export GLOBAL_NAVIGATION_BAR_LABEL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return GLOBAL_NAVIGATION_BAR_LINK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return GLOBAL_NAVIGATION_BAR_REGION; });
/* unused harmony export GLOBAL_NAVIGATION_BAR_APP_LAUNCHER */
/* unused harmony export GRID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return HIGHLIGHTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return ICON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return ICON_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return ICON_INPUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return ILLUSTRATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return LIST_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return LIST_ITEM_LABEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return LOOKUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return MEDIA_OBJECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return MENU_DROPDOWN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return MENU_DROPDOWN_TRIGGER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return MENU_PICKLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return MODAL; });
/* unused harmony export NOTIFICATION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return PANEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return PANEL_FILTER_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return PANEL_FILTER_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return PANEL_FILTER_LIST_HEADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return PAGE_HEADER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return PILL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return POPOVER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return POPOVER_TOOLTIP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return PROGRESS_INDICATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return PROGRESS_INDICATOR_PROGRESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return PROGRESS_INDICATOR_STEP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return PROGRESS_RING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return SLIDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return SPINNER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return SPLIT_VIEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return SPLIT_VIEW_HEADER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return SPLIT_VIEW_LISTBOX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return RADIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return RADIO_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return RADIO_BUTTON_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return TAB; });
/* unused harmony export TAB_ITEM */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return TAB_PANEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return TABS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return TABS_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return TABS_PANEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return TIME_PICKER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return TOAST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return TOAST_CONTAINER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return TREE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return TREE_BRANCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return TREE_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return VERTICAL_NAVIGATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return VERTICAL_NAVIGATION_ITEM; });
// ## Components
var ACCORDION = 'SLDSAccordion';
var ACCORDION_PANEL = 'SLDSAccordionPanel';
var ALERT = 'SLDSAlert';
var ALERT_CONTAINER = 'SLDSAlertContainer';
var APP_LAUNCHER = 'SLDSAppLauncher';
var APP_LAUNCHER_SECTION = 'SLDSAppLauncherSection';
var APP_LAUNCHER_TILE = 'SLDSAppLauncherTile';
var APP_LAUNCHER_HEADER = 'SLDSAppLauncherHeader';
var AVATAR = 'SLDSAvatar';
/* Remove at next breaking change */

var BREAD_CRUMB = 'SLDSBreadcrumb';
var BREADCRUMB = 'SLDSBreadcrumb';
var BUTTON = 'SLDSButton';
var BUTTON_GROUP = 'SLDSButtonGroup';
var BUTTON_STATEFUL = 'SLDSButtonStateful';
var BUTTON_ICON = 'SLDSButtonIcon'; // a non-interctive icon wrapper for SLDSUtilityIcon

var CARD = 'SLDSCard';
var CARD_BODY = 'SLDSCardBody';
var CARD_EMPTY = 'SLDSCardEmpty';
var CARD_FILTER = 'SLDSCardFilter';
var CARD_FOOTER = 'SLDSCardFooter';
var CARD_HEADER = 'SLDSCardHeader';
var COMBOBOX = 'SLDSCombobox';
var DATA_TABLE = 'SLDSDataTable';
var DATA_TABLE_CELL = 'SLDSDataTableCell';
var DATA_TABLE_COLUMN = 'SLDSDataTableColumn';
var DATA_TABLE_HEAD = 'SLDSDataTableHead';
var DATA_TABLE_HEADER_CELL = 'SLDSDataTableHeaderCell';
var DATA_TABLE_ROW_ACTIONS = 'SLDSDataTableRowActions';
var DATA_TABLE_ROW = 'SLDSDataTableRow';
var DATE_PICKER = 'SLDSDatePicker';
var DIALOG = 'SLDSDialog';
var FILTER = 'SLDSFilter';
var CHECKBOX = 'SLDSCheckbox';
var FORMS_INLINE_EDIT = 'SLDSInlineEdit';
var INPUT = 'SLDSInput';
var TEXTAREA = 'SLDSTextarea';
var SEARCH = 'SLDSSearch';
var GLOBAL_HEADER = 'SLDSGlobalHeader';
var GLOBAL_HEADER_PROFILE = 'SLDSGlobalHeaderProfile';
var GLOBAL_HEADER_SEARCH = 'SLDSGlobalHeaderSearch';
var GLOBAL_HEADER_TOOL = 'SLDSGlobalHeaderTool';
var GLOBAL_NAVIGATION_BAR = 'SLDSGlobalNavigationBar';
var GLOBAL_NAVIGATION_BAR_BUTTON = 'SLDSGlobalNavigationBarButton';
var GLOBAL_NAVIGATION_BAR_DROPDOWN = 'SLDSGlobalNavigationBarDropdown';
var GLOBAL_NAVIGATION_BAR_LABEL = 'SLDSGlobalNavigationBarLabel';
var GLOBAL_NAVIGATION_BAR_LINK = 'SLDSGlobalNavigationBarLink';
var GLOBAL_NAVIGATION_BAR_REGION = 'SLDSGlobalNavigationBarRegion';
var GLOBAL_NAVIGATION_BAR_APP_LAUNCHER = 'SLDSGlobalNavigationBarAppLauncher';
var GRID = 'SLDSGrid';
var HIGHLIGHTER = 'SLDSHighlighter';
var ICON = 'SLDSIcon';
var ICON_SETTINGS = 'SLDSIconSettings';
var ICON_INPUT = 'SLDSIconInput';
var ILLUSTRATION = 'SLDSIllustration';
var LIST = 'SLDSList';
var LIST_ITEM = 'SLDSListItem';
var LIST_ITEM_LABEL = 'SLDSListItemLabel';
var LOOKUP = 'SLDSLookup';
var MEDIA_OBJECT = 'SLDSMediaObject';
var MENU_DROPDOWN = 'SLDSMenuDropdown';
var MENU_DROPDOWN_TRIGGER = 'SLDSMenuDropdownTrigger';
var MENU_PICKLIST = 'SLDSMenuPicklist';
var MODAL = 'SLDSModal';
var NOTIFICATION = 'SLDSNotification';
var PANEL = 'SLDSPanel';
var PANEL_FILTER_GROUP = 'SLDSFilterGroup';
var PANEL_FILTER_LIST = 'SLDSFilterList';
var PANEL_FILTER_LIST_HEADING = 'SLDSPanelFilterListHeading';
var PAGE_HEADER = 'SLDSPageHeader';
var PILL = 'SLDSPill';
var POPOVER = 'SLDSPopover';
var POPOVER_TOOLTIP = 'SLDSPopoverTooltip';
var PROGRESS_INDICATOR = 'SLDSProgressIndicator';
var PROGRESS_INDICATOR_PROGRESS = 'SLDSProgressIndicatorProgress';
var PROGRESS_INDICATOR_STEP = 'SLDSProgressIndicatorStep';
var PROGRESS_RING = 'SLDSProgressRing';
var SLIDER = 'SLDSSlider';
var SPINNER = 'SLDSSpinner';
var SPLIT_VIEW = 'SLDSSplitView';
var SPLIT_VIEW_HEADER = 'SLDSSplitViewHeader';
var SPLIT_VIEW_LISTBOX = 'SLDSSplitViewListbox';
var RADIO = 'SLDSRadio';
var RADIO_GROUP = 'SLDSRadioGroup';
var RADIO_BUTTON_GROUP = 'SLDSRadioButtonGroup';
var TAB = 'SLDSTab';
var TAB_ITEM = 'SLDSTabItem';
var TAB_PANEL = 'SLDSTabPanel';
var TABS = 'SLDSTabs';
var TABS_LIST = 'SLDSTabsList';
var TABS_PANEL = 'SLDSTabsPanel';
var TIME_PICKER = 'SLDSTimepicker';
var TOAST = 'SLDSToast';
var TOAST_CONTAINER = 'SLDSToastContainer';
var TREE = 'SLDSTree';
var TREE_BRANCH = 'SLDSTreeBranch';
var TREE_ITEM = 'SLDSTreeItem';
var VERTICAL_NAVIGATION = 'SLDSVerticalNavigation';
var VERTICAL_NAVIGATION_ITEM = 'SLDSVerticalNavigationItem';
//# sourceMappingURL=constants.js.map

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(0);
var factory = __webpack_require__(184);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = __webpack_require__(176);


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_required_if__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_required_if___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_required_if__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__icon_button_icon__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__check_props__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__popover_tooltip__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utilities_constants__ = __webpack_require__(2);
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// Implements the [Button design pattern](https://lightningdesignsystem.com/components/buttons/) in React.
// Based on SLDS v2.2.1









var defaultProps = {
  assistiveText: {
    icon: ''
  },
  disabled: false,
  hint: false,
  iconSize: 'medium',
  responsive: false,
  type: 'button',
  variant: 'neutral'
};
/**
 * The Button component is the Lightning Design System Button component. The Button should be used for label buttons, icon buttons, or buttons that have both labels and icons.
 * Either a <code>label</code> or <code>assistiveText.icon</code> is required; see the Prop Details table below.
 * For buttons that maintain selected/unselected states, use the <a href="#/button-stateful">ButtonStateful</a> component.
 */

var Button = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: __WEBPACK_IMPORTED_MODULE_8__utilities_constants__["h" /* BUTTON */],
  propTypes: {
    /**
     * Used if the Button triggers a tooltip. The value should match the `id` of the element with `role="tooltip"`.
     */
    'aria-describedby': __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,

    /**
     * Establishes a relationship between an interactive parent element and a child element to indicate which child element a parent element affects. Frequently used in cases where buttons or tabs are associated with exposing expandable regions.
     */
    'aria-controls': __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,

    /**
     * Used if the Button triggers a menu or popup. Bool indicates if the menu or popup is open or closed.
     */
    'aria-expanded': __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string]),

    /**
     * True if Button triggers a menu or popup to open/close.
     */
    'aria-haspopup': __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string]),

    /**
     * **Assistive text for accessibility.**
     * This object is merged with the default props object on every render.
     * * `icon`: Text that is visually hidden but read aloud by screenreaders to tell the user what the icon means. If the button has an icon and a visible label, you can omit the <code>assistiveText.icon</code> prop and use the <code>label</code> prop.
     */
    assistiveText: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
      icon: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
    }),

    /**
     * Callback that passes in the DOM reference of the `<button>` DOM node within this component. Primary use is to allow `focus` to be called. You should still test if the node exists, since rendering is asynchronous. `buttonRef={(component) => { if(component) console.log(component); }}`
     */
    buttonRef: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,

    /**
     * CSS classes to be added to button.
     */
    className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string]),

    /**
     * Disables the button and adds disabled styling.
     */
    disabled: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,

    /**
     * Associates an icon button with another element on the page by changes the color of the SVG. Please reference <a href="http://www.lightningdesignsystem.com/components/buttons/#hint">Lightning Design System Buttons > Hint</a>.
     */
    hint: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,

    /**
     * Name of the icon category. Visit <a href="http://www.lightningdesignsystem.com/resources/icons">Lightning Design System Icons</a> to reference icon categories.
     */
    iconCategory: __WEBPACK_IMPORTED_MODULE_2_react_required_if___default()(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['action', 'custom', 'doctype', 'standard', 'utility']), function (props) {
      return !!props.iconName;
    }),

    /**
     * CSS classes to be added to icon.
     */
    iconClassName: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string]),

    /**
     * Name of the icon. Visit <a href="http://www.lightningdesignsystem.com/resources/icons">Lightning Design System Icons</a> to reference icon names.
     */
    iconName: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,

    /**
     * Path to the icon. This will override any global icon settings.
     */
    iconPath: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,

    /**
     * If omitted, icon position is centered.
     */
    iconPosition: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['left', 'right']),

    /**
     * Determines the size of the icon.
     */
    iconSize: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['x-small', 'small', 'medium', 'large']),

    /**
     * For icon variants, please reference <a href="http://www.lightningdesignsystem.com/components/buttons/#icon">Lightning Design System Icons</a>.
     */
    iconVariant: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['bare', 'container', 'border', 'border-filled', 'more', 'global-header']),

    /**
     * Id string applied to button node.
     */
    id: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,

    /**
     * If true, button/icon is white. Meant for buttons or utility icons on dark backgrounds.
     */
    inverse: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,

    /**
     * Visible label on the button. If the button is an icon button with no label, you must use the <code>assistiveText.icon</code> prop.
     */
    label: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),

    /**
     * Triggered when focus is removed.
     */
    onBlur: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,

    /**
     * Triggered when the button is clicked.
     */
    onClick: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,

    /**
     * Triggered when component is focused.
     */
    onFocus: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,

    /**
     * Triggered when a key is pressed down
     */
    onKeyDown: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,

    /**
     * Triggered when a key is pressed and released
     */
    onKeyPress: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,

    /**
     * Triggered when a key is released
     */
    onKeyUp: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,

    /**
     * Triggered when a mouse button is pressed down
     */
    onMouseDown: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,

    /**
     * Triggered when a mouse arrow hovers
     */
    onMouseEnter: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,

    /**
     * Triggered when a mouse arrow no longer hovers
     */
    onMouseLeave: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,

    /**
     * If true, button scales to 100% width on small form factors.
     */
    responsive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,

    /**
     * Write <code>"-1"</code> if you don't want the user to tab to the button.
     */
    tabIndex: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,

    /**
     * Button type
     */
    type: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['reset', 'submit', 'button']),

    /**
     * HTML title attribute
     */
    title: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,

    /**
     * [Deprecated] Tooltip on button. Button should be a child of `Tooltip` instead.
     */
    tooltip: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,

    /**
     * Different types of buttons
     */
    variant: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['base', 'link', 'neutral', 'brand', 'destructive', 'success', 'icon'])
  },
  getDefaultProps: function getDefaultProps() {
    return defaultProps;
  },
  componentWillMount: function componentWillMount() {
    // `checkProps` issues warnings to developers about properties (similar to React's built in development tools)
    Object(__WEBPACK_IMPORTED_MODULE_6__check_props__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_8__utilities_constants__["h" /* BUTTON */], this.props);
  },
  getClassName: function getClassName() {
    var _classNames;

    var isIcon = this.props.variant === 'icon';
    var iconVariant = this.props.iconVariant;
    var iconMore = iconVariant === 'more';
    var iconBorder = iconVariant === 'border';
    var iconGlobalHeader = iconVariant === 'global-header';
    var showButtonVariant = this.props.variant !== 'base' && !iconVariant && !this.props.inverse && this.props.variant !== 'link' || iconVariant === 'bare';
    var plainInverseBtn = this.props.inverse && !isIcon;
    var plainInverseIcon = this.props.inverse && isIcon && !iconMore && !iconBorder;
    var moreInverseIcon = this.props.inverse && iconMore;
    var borderInverseIcon = this.props.inverse && iconBorder; // After hijacking `iconVariant` to let `Button` know it's in the header, we reset to container style for the actual button CSS.

    if (iconVariant === 'global-header') {
      iconVariant = 'container';
    }

    return __WEBPACK_IMPORTED_MODULE_4_classnames___default()((_classNames = {
      'slds-button': this.props.variant !== 'link'
    }, _defineProperty(_classNames, "slds-button--".concat(this.props.variant), showButtonVariant), _defineProperty(_classNames, 'slds-button--inverse', plainInverseBtn), _defineProperty(_classNames, 'slds-button--icon-inverse', plainInverseIcon || moreInverseIcon), _defineProperty(_classNames, 'slds-button--icon-border-inverse', borderInverseIcon), _defineProperty(_classNames, "slds-button--icon-".concat(iconVariant), iconVariant && !borderInverseIcon), _defineProperty(_classNames, 'slds-global-header__button--icon', iconGlobalHeader), _defineProperty(_classNames, "slds-button--icon-".concat(this.props.iconSize), iconVariant && this.props.iconSize !== 'medium'), _defineProperty(_classNames, 'slds-button--reset', this.props.variant === 'link'), _defineProperty(_classNames, 'slds-text-link', this.props.variant === 'link'), _classNames), this.props.className);
  },
  handleClick: function handleClick(event) {
    if (this.props.onClick) {
      this.props.onClick(event, {});
    }
  },
  renderIcon: function renderIcon(name) {
    var iconSize = this.props.iconSize === '' || this.props.iconVariant ? null : this.props.iconSize;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__icon_button_icon__["a" /* default */], {
      category: this.props.iconCategory || 'utility' // BREAKING CHANGE we will introduce in 1.0. For the moment, set default prop here if none specified.
      ,
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()({
        'slds-global-header__icon': this.props.iconVariant === 'global-header'
      }, this.props.iconClassName),
      hint: this.props.hint,
      inverse: this.props.inverse,
      name: name,
      path: this.props.iconPath,
      position: this.props.iconPosition,
      size: iconSize
    });
  },
  renderLabel: function renderLabel() {
    var iconOnly = this.props.iconName || this.props.iconPath;
    var assistiveTextIcon = typeof this.props.assistiveText === 'string' ? this.props.assistiveText : _objectSpread({}, defaultProps.assistiveText, this.props.assistiveText).icon;
    return iconOnly && assistiveTextIcon ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: "slds-assistive-text"
    }, assistiveTextIcon) : this.props.label;
  },
  renderButton: function renderButton() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
      "aria-controls": this.props['aria-controls'],
      "aria-describedby": this.props['aria-describedby'],
      "aria-expanded": this.props['aria-expanded'],
      "aria-haspopup": this.props['aria-haspopup'],
      className: this.getClassName(),
      disabled: this.props.disabled,
      id: this.props.id,
      onBlur: this.props.onBlur,
      onClick: this.handleClick,
      onFocus: this.props.onFocus,
      onKeyDown: this.props.onKeyDown,
      onKeyPress: this.props.onKeyPress,
      onKeyUp: this.props.onKeyUp,
      onMouseDown: this.props.onMouseDown,
      onMouseEnter: this.props.onMouseEnter,
      onMouseLeave: this.props.onMouseLeave,
      ref: function ref(component) {
        if (_this.props.buttonRef) {
          _this.props.buttonRef(component);
        }
      },
      tabIndex: this.props.tabIndex,
      title: this.props.title,
      type: this.props.type
    }, this.props.iconPosition === 'right' ? this.renderLabel() : null, this.props.iconName || this.props.iconPath ? this.renderIcon(this.props.iconName) : null, this.props.iconVariant === 'more' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__icon_button_icon__["a" /* default */], {
      category: "utility",
      name: "down",
      size: "x-small"
    }) : null, this.props.iconPosition === 'left' || !this.props.iconPosition ? this.renderLabel() : null, this.props.children // eslint-disable-line react/prop-types
    );
  },
  // This is present for backwards compatibility and should be removed at a future breaking change release. Please wrap a `Button` in a `PopoverTooltip` to achieve the same result. There will be an extra trigger `div` wrapping the `Button` though.
  renderTooltip: function renderTooltip() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__popover_tooltip__["a" /* default */], {
      content: this.props.tooltip
    }, this.renderButton);
  },
  render: function render() {
    return this.props.tooltip ? this.renderTooltip() : this.renderButton();
  }
});
/* harmony default export */ __webpack_exports__["a"] = (Button);
//# sourceMappingURL=index.js.map

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
var EventUtil = {
  trapEvent: function trapEvent(event) {
    if (!event) return;
    event.preventDefault();
    event.stopPropagation();

    if (event.nativeEvent && event.nativeEvent.preventDefault) {
      event.nativeEvent.preventDefault();
    }

    if (event.nativeEvent && event.nativeEvent.stopPropagation) {
      event.nativeEvent.stopPropagation();
    }
  },
  trap: function trap(event) {
    return EventUtil.trapEvent(event);
  },
  trapImmediate: function trapImmediate(event) {
    if (event.stopImmediatePropagation) {
      event.stopImmediatePropagation();
    }

    if (event.nativeEvent && event.nativeEvent.stopImmediatePropagation) {
      event.nativeEvent.stopImmediatePropagation();
    }

    EventUtil.trap(event);
  }
};
/* harmony default export */ __webpack_exports__["a"] = (EventUtil);
//# sourceMappingURL=event.js.map

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export keyObjects */
var keys = {
  ENTER: 13,
  ESCAPE: 27,
  SPACE: 32,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  TAB: 9,
  DELETE: 46,
  BACKSPACE: 8
}; // Helpful for interaction/event tests. Use with simulate:
// `nodes.input.simulate('keyDown', keyObjects.DOWN);`

var keyObjects = {
  ENTER: {
    key: 'Enter',
    keyCode: keys.ENTER,
    which: keys.ENTER
  },
  ESCAPE: {
    key: 'Escape',
    keyCode: keys.ESCAPE,
    which: keys.ESCAPE
  },
  SPACE: {
    key: 'Space',
    keyCode: keys.SPACE,
    which: keys.SPACE
  },
  LEFT: {
    key: 'Left',
    keyCode: keys.LEFT,
    which: keys.LEFT
  },
  UP: {
    key: 'Up',
    keyCode: keys.UP,
    which: keys.ESCAPE
  },
  RIGHT: {
    key: 'Right',
    keyCode: keys.RIGHT,
    which: keys.RIGHT
  },
  DOWN: {
    key: 'Down',
    keyCode: keys.DOWN,
    which: keys.DOWN
  },
  TAB: {
    key: 'Tab',
    keyCode: keys.TAB,
    which: keys.TAB
  },
  DELETE: {
    key: 'Delete',
    keyCode: keys.DELETE,
    which: keys.DELETE
  },
  BACKSPACE: {
    key: 'Backspace',
    keyCode: keys.BACKSPACE,
    which: keys.BACKSPACE
  }
};
/* harmony default export */ __webpack_exports__["a"] = (keys);

//# sourceMappingURL=key-code.js.map

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__check_props__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_class_names__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_utility_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_constants__ = __webpack_require__(2);
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// # Icon Component


 // ### classNames
// [github.com/JedWatson/classnames](https://github.com/JedWatson/classnames)
// A simple javascript utility for conditionally joining classNames together.

 // ## Children



var defaultProps = {
  assistiveText: {},
  category: 'standard',
  colorVariant: 'default',
  size: 'medium'
};
/**
 * The Icon component is the Lightning Design System Icon component and should be used for naked icons. For icons that are buttons, use the <a href='/components/buttons/'>Button component</a> component with <code>variant='icon'</code>.
 */

var Icon = function Icon(props) {
  Object(__WEBPACK_IMPORTED_MODULE_2__check_props__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5__utilities_constants__["N" /* ICON */], props);
  var category = props.category,
      className = props.className,
      colorVariant = props.colorVariant,
      containerClassName = props.containerClassName,
      icon = props.icon,
      inverse = props.inverse,
      name = props.name,
      path = props.path,
      size = props.size,
      style = props.style,
      title = props.title;
  var assistiveText = typeof props.assistiveText === 'string' ? props.assistiveText : _objectSpread({}, defaultProps.assistiveText, props.assistiveText).label;
  var kababCaseName = name ? name.replace(/_/g, '-') : '';
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: Object(__WEBPACK_IMPORTED_MODULE_3__utilities_class_names__["a" /* default */])(_defineProperty({
      'slds-icon_container': category !== 'utility',
      'slds-icon_container--circle': category === 'action'
    }, "slds-icon-".concat(category, "-").concat(kababCaseName), category !== 'utility' && category !== 'doctype' && !path), containerClassName),
    title: title
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__utilities_utility_icon__["a" /* default */], {
    "aria-hidden": "true",
    category: category,
    className: Object(__WEBPACK_IMPORTED_MODULE_3__utilities_class_names__["a" /* default */])(className, 'slds-icon', {
      'slds-icon--xx-small': size === 'xx-small',
      'slds-icon--x-small': size === 'x-small',
      'slds-icon--small': size === 'small',
      // medium intentially not present
      'slds-icon--large': size === 'large',
      // if category is `utility` and `inverse` is false (default), icon will be dark // return true
      // if category is `utility` and `inverse` is true, icon will be light // return false
      // if category is NOT `utility` and `inverse` is false (default), icon will be light // return false
      // if category is NOT `utility` and `inverse` is true, icon will be dark // return true
      'slds-icon-text-default': colorVariant === 'default' && category === 'utility' ? !inverse : inverse,
      'slds-icon-text-warning': colorVariant === 'warning',
      'slds-icon-text-error': colorVariant === 'error',
      'slds-icon-text-light': colorVariant === 'light'
    }),
    icon: icon,
    name: name,
    path: path,
    style: style
  }), assistiveText ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "slds-assistive-text"
  }, assistiveText) : '');
}; // ### Display Name
// Always use the canonical component name as the React display name.


Icon.displayName = __WEBPACK_IMPORTED_MODULE_5__utilities_constants__["N" /* ICON */]; // ### Prop Types

Icon.propTypes = {
  /**
   * **Assistive text for accessibility.**
   * This object is merged with the default props object on every render.
   * * `label`: Text that is visually hidden but read aloud by screenreaders to tell the user what the icon means. Naked icons must have assistive text, however, if you also have visible descriptive text with the icon, declare this prop as <code>assistiveText=''</code>.
   */
  assistiveText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),

  /**
   * Icon category from [lightningdesignsystem.com/icons/](https://www.lightningdesignsystem.com/icons/)
   */
  category: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['action', 'custom', 'doctype', 'standard', 'utility']).isRequired,

  /**
   * CSS classes that are applied to the SVG.
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * CSS classes that are applied to the span.
   */
  containerClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * Icon color variants
   */
  colorVariant: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['base', 'default', 'error', 'light', 'warning']),

  /**
   * A custom SVG object to use instead of the supplied SLDS icons, look in `design-system-react/icons` for examples and syntax.
   */
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * Setting `inverse` to true will switch the color of the icon: light to dark, dark to light.
   */
  inverse: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Name of the icon. Visit <a href='http://www.lightningdesignsystem.com/resources/icons'>Lightning Design System Icons</a> to reference icon names.
   */
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Path to the icon. This will override any global icon settings
   */
  path: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Size of the icon. Visit [lightningdesignsystem.com/components/icons/#flavor-sizes](https://www.lightningdesignsystem.com/components/icons/#flavor-sizes)
   */
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['xx-small', 'x-small', 'small', 'medium', 'large']),

  /**
   * Custom styles to be passed to the SVG. Could be used to change icon or background color.
   */
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * Title attribute for the icon container
   */
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
Icon.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Icon);
//# sourceMappingURL=index.js.map

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    nullTag = '[object Null]',
    proxyTag = '[object Proxy]',
    undefinedTag = '[object Undefined]';

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isFunction;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable import/no-mutable-exports */
// This function will deliver an error message to the browser console about the removal of a property.


var sunset = function sunset() {};

if (false) {
  var hasWarned = {};

  sunset = function sunset(control, propValue, oldProp, comment) {
    var additionalComment = comment ? " ".concat(comment) : '';

    if (!hasWarned[control + oldProp]) {
      /* eslint-disable max-len */
      warning(!propValue, "[Design System React] `".concat(oldProp, "` has reached End-of-Life and has been removed from the API of ").concat(control, ". Please update your API.").concat(additionalComment));
      /* eslint-enable max-len */

      hasWarned[control + oldProp] = !!propValue;
    }
  };
}

/* unused harmony default export */ var _unused_webpack_default_export = (sunset);
//# sourceMappingURL=sunset-property.js.map

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(157);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable import/no-mutable-exports */
// This function will deliver an error message to the browser console about the removal of a property.


var deprecated = function deprecated() {};

if (false) {
  var hasWarned = {};

  deprecated = function deprecated(control, propValue, oldProp, newProp, comment) {
    var additionalComment = comment ? " ".concat(comment) : '';
    var newProperty = newProp ? "Use `".concat(newProp, "`") : '';
    var newPropertySentence = newProp ? " ".concat(newProperty, " instead.") : '';

    if (!hasWarned[control + oldProp]) {
      /* eslint-disable max-len */
      warning(propValue === undefined, "[Design System React] `".concat(oldProp, "` will be removed in the next major version of ").concat(control, ".").concat(newPropertySentence).concat(additionalComment));
      /* eslint-enable max-len */

      hasWarned[control + oldProp] = propValue !== undefined;
    }
  };
}

/* unused harmony default export */ var _unused_webpack_default_export = (deprecated);
//# sourceMappingURL=deprecated-property.js.map

/***/ }),
/* 15 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object),
    nativeMax = Math.max;

/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = assign;


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isfunction__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isfunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isfunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_utility_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_constants__ = __webpack_require__(2);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// ### React

 // ### classNames
// [github.com/JedWatson/classnames](https://github.com/JedWatson/classnames)
// A simple javascript utility for conditionally joining classNames together.

 // ### isFunction

 // ## Children


 // ## Constants


/**
 * A wrapper for icons that will be rendered inside of an Input
 *
 * If the `onClick` function prop is provided, the `design-system-react/components/button` component is used.
 * If not, the icon will be an instance of `design-system-react/components/utilities/utility-icon`.
 * Checkout out the appropriate component to see what props can be passed along via the `{...props}` rest operator
 */

var InputIcon = function InputIcon(props) {
  var category = props.category,
      iconPosition = props.iconPosition,
      name = props.name,
      path = props.path,
      onClick = props.onClick,
      variant = props.variant,
      rest = _objectWithoutProperties(props, ["category", "iconPosition", "name", "path", "onClick", "variant"]); // need to pass click event up on SVG


  var variants = {
    combobox: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: "slds-icon_container slds-input__icon slds-input__icon_right"
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__utilities_utility_icon__["a" /* default */], _extends({
      "aria-hidden": true,
      category: category,
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('slds-icon slds-icon_x-small slds-icon-text-default'),
      name: name,
      path: path
    }, rest))),
    base: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__utilities_utility_icon__["a" /* default */], _extends({
      "aria-hidden": true,
      category: category,
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('slds-input__icon slds-icon-text-default', _defineProperty({}, "slds-input__icon--".concat(iconPosition), iconPosition)),
      name: name,
      path: path
    }, rest))
  };
  return __WEBPACK_IMPORTED_MODULE_3_lodash_isfunction___default()(onClick) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__button__["a" /* default */], _extends({
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('slds-input__icon', _defineProperty({}, "slds-input__icon_".concat(iconPosition), iconPosition)),
    iconCategory: category,
    iconName: name,
    iconPath: path,
    onClick: onClick,
    variant: "icon"
  }, rest)) : variants[variant];
};

InputIcon.displayName = __WEBPACK_IMPORTED_MODULE_6__utilities_constants__["O" /* ICON_INPUT */];
InputIcon.propTypes = {
  /**
   * Icon category from [lightningdesignsystem.com/icons/](https://www.lightningdesignsystem.com/icons/)
   */
  category: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * This is only needed if an input contains two icons, the Input component handles this prop for you.
   */
  iconPosition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['left', 'right']),

  /**
   * Name of the icon. Visit <a href='http://www.lightningdesignsystem.com/resources/icons'>Lightning Design System Icons</a> to reference icon names.
   */
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Path to the icon. This will override any global icon settings.
   */
  path: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * This event fires when the icon is clicked.
   */
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Changes styles of the InputIcon.
   */
  variant: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['base', 'combobox'])
};
InputIcon.defaultProps = {
  category: 'utility',
  variant: 'base'
};
/* harmony default export */ __webpack_exports__["a"] = (InputIcon);
//# sourceMappingURL=index.js.map

/***/ }),
/* 17 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__settings__ = __webpack_require__(46);
/* unused harmony reexport SLDSSettings */
/* unused harmony reexport Settings */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__icon_settings__ = __webpack_require__(47);
/* unused harmony reexport SLDSIconSettings */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_1__icon_settings__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__accordion__ = __webpack_require__(78);
/* unused harmony reexport SLDSAccordion */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__accordion__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__accordion_panel__ = __webpack_require__(79);
/* unused harmony reexport SLDSAccordionPanel */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__accordion_panel__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__alert__ = __webpack_require__(84);
/* unused harmony reexport SLDSAlert */
/* unused harmony reexport Alert */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__alert_container__ = __webpack_require__(85);
/* unused harmony reexport SLDSAlertContainer */
/* unused harmony reexport AlertContainer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app_launcher__ = __webpack_require__(86);
/* unused harmony reexport SLDSAppLauncher */
/* unused harmony reexport AppLauncher */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__avatar__ = __webpack_require__(88);
/* unused harmony reexport SLDSAvatar */
/* unused harmony reexport Avatar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__button__ = __webpack_require__(6);
/* unused harmony reexport SLDSButton */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_8__button__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__button_group__ = __webpack_require__(89);
/* unused harmony reexport SLDSButtonGroup */
/* unused harmony reexport ButtonGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__button_stateful__ = __webpack_require__(90);
/* unused harmony reexport SLDSButtonStateful */
/* unused harmony reexport ButtonStateful */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__breadcrumb__ = __webpack_require__(31);
/* unused harmony reexport SLDSBreadCrumb */
/* unused harmony reexport BreadCrumb */
/* unused harmony reexport SLDSBreadcrumb */
/* unused harmony reexport Breadcrumb */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__card__ = __webpack_require__(91);
/* unused harmony reexport SLDSCard */
/* unused harmony reexport Card */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__card_empty__ = __webpack_require__(50);
/* unused harmony reexport SLDSCardEmpty */
/* unused harmony reexport CardEmpty */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__card_filter__ = __webpack_require__(92);
/* unused harmony reexport SLDSCardFilter */
/* unused harmony reexport CardFilter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__forms_checkbox__ = __webpack_require__(95);
/* unused harmony reexport SLDSCheckbox */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_15__forms_checkbox__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__combobox__ = __webpack_require__(96);
/* unused harmony reexport SLDSCombobox */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_16__combobox__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__combobox_filter__ = __webpack_require__(100);
/* unused harmony reexport SLDSComboboxFilterAndLimit */
/* unused harmony reexport comboboxFilterAndLimit */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__combobox_add_subheadings__ = __webpack_require__(223);
/* unused harmony reexport comboboxAddSubheadings */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__global_header__ = __webpack_require__(101);
/* unused harmony reexport SLDSGlobalHeader */
/* unused harmony reexport GlobalHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__global_header_button__ = __webpack_require__(58);
/* unused harmony reexport SLDSGlobalHeaderButton */
/* unused harmony reexport GlobalHeaderButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__global_header_dropdown__ = __webpack_require__(102);
/* unused harmony reexport SLDSGlobalHeaderDropdown */
/* unused harmony reexport GlobalHeaderDropdown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__global_header_profile__ = __webpack_require__(107);
/* unused harmony reexport SLDSGlobalHeaderProfile */
/* unused harmony reexport GlobalHeaderProfile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__global_header_search__ = __webpack_require__(108);
/* unused harmony reexport SLDSGlobalHeaderSearch */
/* unused harmony reexport GlobalHeaderSearch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__global_navigation_bar__ = __webpack_require__(109);
/* unused harmony reexport SLDSGlobalNavigationBar */
/* unused harmony reexport GlobalNavigationBar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__global_navigation_bar_region__ = __webpack_require__(110);
/* unused harmony reexport SLDSGlobalNavigationBarRegion */
/* unused harmony reexport GlobalNavigationBarRegion */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__global_navigation_bar_link__ = __webpack_require__(111);
/* unused harmony reexport SLDSGlobalNavigationBarLink */
/* unused harmony reexport GlobalNavigationBarLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__global_navigation_bar_dropdown__ = __webpack_require__(112);
/* unused harmony reexport SLDSGlobalNavigationBarDropdown */
/* unused harmony reexport GlobalNavigationBarDropdown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__data_table__ = __webpack_require__(114);
/* unused harmony reexport SLDSDataTable */
/* unused harmony reexport DataTable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__data_table_cell__ = __webpack_require__(65);
/* unused harmony reexport SLDSDataTableCell */
/* unused harmony reexport DataTableCell */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__data_table_column__ = __webpack_require__(66);
/* unused harmony reexport SLDSDataTableColumn */
/* unused harmony reexport DataTableColumn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__data_table_row_actions__ = __webpack_require__(67);
/* unused harmony reexport SLDSDataTableRowActions */
/* unused harmony reexport DataTableRowActions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__date_picker__ = __webpack_require__(115);
/* unused harmony reexport SLDSDatepicker */
/* unused harmony reexport Datepicker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__icon__ = __webpack_require__(9);
/* unused harmony reexport SLDSIcon */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_33__icon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__illustration__ = __webpack_require__(116);
/* unused harmony reexport SLDSIllustration */
/* unused harmony reexport Illustration */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__icon_button_icon__ = __webpack_require__(28);
/* unused harmony reexport SLDSButtonIcon */
/* unused harmony reexport ButtonIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__filter__ = __webpack_require__(117);
/* unused harmony reexport SLDSFilter */
/* unused harmony reexport Filter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__forms_input_inline__ = __webpack_require__(118);
/* unused harmony reexport SLDSInlineEdit */
/* unused harmony reexport InlineEdit */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__input__ = __webpack_require__(20);
/* unused harmony reexport SLDSInput */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_38__input__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__input_search__ = __webpack_require__(119);
/* unused harmony reexport SLDSSearch */
/* unused harmony reexport Search */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__icon_input_icon__ = __webpack_require__(16);
/* unused harmony reexport SLDSInputIcon */
/* unused harmony reexport InputIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__lookup__ = __webpack_require__(61);
/* unused harmony reexport SLDSLookup */
/* unused harmony reexport Lookup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__lookup_menu_default_footer__ = __webpack_require__(62);
/* unused harmony reexport SLDSLookupDefaultFooter */
/* unused harmony reexport LookupDefaultFooter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__lookup_menu_default_header__ = __webpack_require__(63);
/* unused harmony reexport SLDSLookupDefaultHeader */
/* unused harmony reexport LookupDefaultHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__lookup_menu_default_section_divider__ = __webpack_require__(64);
/* unused harmony reexport SLDSLookupDefaultSectionDivider */
/* unused harmony reexport LookupDefaultSectionDivider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__media_object__ = __webpack_require__(26);
/* unused harmony reexport SLDSMediaObject */
/* unused harmony reexport MediaObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__menu_dropdown__ = __webpack_require__(24);
/* unused harmony reexport SLDSMenuDropdown */
/* unused harmony reexport Dropdown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__menu_dropdown_button_trigger__ = __webpack_require__(60);
/* unused harmony reexport SLDSDropdownTrigger */
/* unused harmony reexport DropdownTrigger */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__menu_picklist__ = __webpack_require__(120);
/* unused harmony reexport SLDSMenuPicklist */
/* unused harmony reexport Picklist */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__modal__ = __webpack_require__(37);
/* unused harmony reexport SLDSModal */
/* unused harmony reexport Modal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__modal_trigger__ = __webpack_require__(121);
/* unused harmony reexport SLDSModalTrigger */
/* unused harmony reexport ModalTrigger */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__navigation__ = __webpack_require__(122);
/* unused harmony reexport SLDSNavigation */
/* unused harmony reexport Navigation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__notification__ = __webpack_require__(123);
/* unused harmony reexport SLDSNotification */
/* unused harmony reexport Notification */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__panel__ = __webpack_require__(124);
/* unused harmony reexport SLDSPanel */
/* unused harmony reexport Panel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__panel_filtering_group__ = __webpack_require__(125);
/* unused harmony reexport SLDSPanelFilterGroup */
/* unused harmony reexport PanelFilterGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__panel_filtering_list__ = __webpack_require__(126);
/* unused harmony reexport SLDSPanelFilterList */
/* unused harmony reexport PanelFilterList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__panel_filtering_list_heading__ = __webpack_require__(127);
/* unused harmony reexport SLDSPanelFilterListHeading */
/* unused harmony reexport PanelFilterListHeading */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__page_header__ = __webpack_require__(70);
/* unused harmony reexport SLDSPageHeader */
/* unused harmony reexport PageHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__pill__ = __webpack_require__(55);
/* unused harmony reexport SLDSPill */
/* unused harmony reexport Pill */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__popover__ = __webpack_require__(68);
/* unused harmony reexport SLDSPopover */
/* unused harmony reexport Popover */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__tooltip__ = __webpack_require__(21);
/* unused harmony reexport SLDSPopoverTooltip */
/* unused harmony reexport PopoverTooltip */
/* unused harmony reexport SLDSTooltip */
/* unused harmony reexport Tooltip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__progress_indicator__ = __webpack_require__(130);
/* unused harmony reexport SLDSProgressIndicator */
/* unused harmony reexport ProgressIndicator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__progress_ring__ = __webpack_require__(131);
/* unused harmony reexport SLDSProgressRing */
/* unused harmony reexport ProgressRing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__radio__ = __webpack_require__(132);
/* unused harmony reexport SLDSRadio */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_63__radio__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__radio_button_group__ = __webpack_require__(133);
/* unused harmony reexport SLDSRadioButtonGroup */
/* unused harmony reexport RadioButtonGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__radio_group__ = __webpack_require__(134);
/* unused harmony reexport SLDSRadioGroup */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_65__radio_group__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__slider__ = __webpack_require__(135);
/* unused harmony reexport SLDSSlider */
/* unused harmony reexport Slider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__spinner__ = __webpack_require__(51);
/* unused harmony reexport SLDSSpinner */
/* unused harmony reexport Spinner */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__split_view__ = __webpack_require__(42);
/* unused harmony reexport SLDSSplitview */
/* unused harmony reexport Splitview */
/* unused harmony reexport SLDSSplitView */
/* unused harmony reexport SplitView */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__split_view_header__ = __webpack_require__(136);
/* unused harmony reexport SLDSSplitViewHeader */
/* unused harmony reexport SplitViewHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__split_view_listbox__ = __webpack_require__(137);
/* unused harmony reexport SLDSSplitViewListbox */
/* unused harmony reexport SplitViewListbox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__textarea__ = __webpack_require__(138);
/* unused harmony reexport SLDSTextarea */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_71__textarea__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__time_picker__ = __webpack_require__(139);
/* unused harmony reexport SLDSTimepicker */
/* unused harmony reexport Timepicker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__tabs__ = __webpack_require__(140);
/* unused harmony reexport SLDSTabs */
/* unused harmony reexport Tabs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__tabs_panel__ = __webpack_require__(141);
/* unused harmony reexport SLDSTabsPanel */
/* unused harmony reexport TabsPanel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__toast__ = __webpack_require__(142);
/* unused harmony reexport SLDSToast */
/* unused harmony reexport Toast */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__toast_container__ = __webpack_require__(143);
/* unused harmony reexport SLDSToastContainer */
/* unused harmony reexport ToastContainer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__utilities_utility_icon__ = __webpack_require__(25);
/* unused harmony reexport SLDSUtilityIcon */
/* unused harmony reexport UtilityIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__tree__ = __webpack_require__(144);
/* unused harmony reexport SLDSTree */
/* unused harmony reexport Tree */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__vertical_navigation__ = __webpack_require__(69);
/* unused harmony reexport SLDSVerticalNavigation */
/* unused harmony reexport VerticalNavigation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__utilities_log__ = __webpack_require__(295);
/* unused harmony reexport log */
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */












































/* Remove at next breaking change */


































































































 // TODO: Should probably be removed from export and only used internally. This component does not implement Button Icons per SLDS, but only the icons in buttons








































































































































 // Remove at next breaking change




















































 // Library utilities



//# sourceMappingURL=index.js.map

/***/ }),
/* 19 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var boolTag = '[object Boolean]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */
function isBoolean(value) {
  return value === true || value === false ||
    (isObjectLike(value) && objectToString.call(value) == boolTag);
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

module.exports = isBoolean;


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shortid__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shortid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_shortid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tooltip__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__icon_input_icon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__private_inner_input__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utilities_label__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__check_props__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utilities_constants__ = __webpack_require__(2);
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// # Input Component
// Implements the [Input design pattern](https://lightningdesignsystem.com/components/forms/#flavor-input) in React. Does not yet implement [fixed text](https://lightningdesignsystem.com/components/forms/#flavor-input-input-fixed-text).
// Based on SLDS v2.2.1
//
// ### React


 // ### classNames
// [github.com/JedWatson/classnames](https://github.com/JedWatson/classnames)
// This project uses `classnames`, "a simple javascript utility for conditionally
// joining classNames together."

 // ### shortid
// [npmjs.com/package/shortid](https://www.npmjs.com/package/shortid)
// shortid is a short, non-sequential, url-friendly, unique id generator



 // ## Children



 // This component's `checkProps` which issues warnings to developers about properties when in development mode (similar to React's built in development tools)



var defaultProps = {
  assistiveText: {
    fieldLevelHelpButton: 'Help'
  },
  type: 'text'
};
/**
 * The HTML `input` with a label and error messaging.
 */

var Input = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: __WEBPACK_IMPORTED_MODULE_11__utilities_constants__["R" /* INPUT */],
  propTypes: {
    /**
     * The aria-activedescendant attribute contains the ID of the currently active child object that is part of a composite widget within the Document Object Model. It makes do with the overhead of having all or more than one child focusable. As the name specifies, it helps in managing the current active child of the composite widget.
     */
    'aria-activedescendant': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * Indicates if the suggestions in a composite widget are values that complete the current textbox input.
     */
    'aria-autocomplete': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * An HTML ID that is shared with ARIA-supported devices with the
     * `aria-controls` attribute in order to relate the input with
     * another region of the page. An example would be a select box
     * that shows or hides a panel.
     */
    'aria-controls': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * The `aria-describedby` attribute is used to indicate the IDs of the elements that describe the object. It is used to establish a relationship between widgets or groups and text that described them. This is very similar to aria-labelledby: a label describes the essence of an object, while a description provides more information that the user might need.
     */
    'aria-describedby': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * Use the `aria-expanded` state to indicate whether regions of the content are collapsible, and to expose whether a region is currently expanded or collapsed.
     */
    'aria-expanded': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * Indicates that the element has a popup context menu or sub-level menu.
     */
    'aria-haspopup': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * The aria-labelledby attribute contains the element IDs of labels in objects such as input elements, widgets, and groups. The attribute establishes relationships between objects and their labels. Assistive technology, such as screen readers, use this attribute to catalog the objects in a document so that users can navigate between them. Without an element ID, the assistive technology cannot catalog the object.
     */
    'aria-labelledby': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * An HTML ID that is shared with ARIA-supported devices with the
     * `aria-controls` attribute in order to relate the input with
     * another region of the page. An example would be a search field
     * that shows search results.
     */
    'aria-owns': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * The `aria-required` attribute is used to indicate that user input is required on an element before a form can be submitted.
     */
    'aria-required': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * **Assistive text for accessibility**
     * * `label`: Visually hidden label but read out loud by screen readers.
     * * `spinner`: Text for loading spinner icon.
     * * `fieldLevelHelpButton`: The field level help button, by default an 'info' icon.
     */
    assistiveText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
      label: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
      spinner: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
      fieldLevelHelpButton: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
    }),

    /**
     * Elements are added after the `input`.
     */
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,

    /**
     * Class names to be added to the outer container of the input.
     */
    className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),

    /**
     * This is the initial value of an uncontrolled form element and
     * is present only to provide compatibility with hybrid framework
     * applications that are not entirely React. It should only be used
     * in an application without centralized state (Redux, Flux).
     * "Controlled components" with centralized state is highly recommended.
     * See [Code Overview](https://github.com/salesforce/design-system-react/blob/master/docs/codebase-overview.md#controlled-and-uncontrolled-components) for more information.
     */
    defaultValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * Disables the input and prevents editing the contents.
     */
    disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * Message to display when the input is in an error state. When this is present, also visually highlights the component as in error.
     */
    errorText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),

    /**
     * A [Tooltip](https://react.lightningdesignsystem.com/components/tooltips/) component that is displayed next to the label. The props from the component will be merged and override any default props.
     */
    fieldLevelHelpTooltip: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,

    /**
     * Displays text or node to the left of the input. This follows the fixed text input UX pattern.
     */
    fixedTextLeft: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),

    /**
     * Displays text or node to the right of the input. This follows the fixed text input UX pattern.
     */
    fixedTextRight: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),

    /**
     * If true, loading spinner appears inside input on right hand side.
     */
    hasSpinner: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * Left aligned icon, must be instace of `design-system-react/components/icon/input-icon`
     */
    iconLeft: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,

    /**
     * Right aligned icon, must be instace of `design-system-react/components/icon/input-icon`
     */
    iconRight: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,

    /**
     * Every input must have a unique ID in order to support keyboard navigation and ARIA support.
     */
    id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * Displays help text under the input.
     */
    inlineHelpText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),

    /**
     * This callback exposes the input reference / DOM node to parent components. `<Parent inputRef={(inputComponent) => this.input = inputComponent} />
     */
    inputRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Displays the value of the input statically. This follows the static input UX pattern.
     */
    isStatic: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * This label appears above the input.
     */
    label: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * Triggered when focus is removed.
     */
    onBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * This callback fires when the input changes. The synthetic React event will be the first parameter to the callback. You will probably want to reference `event.target.value` in your callback. No custom data object is provided.
     */
    onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * This event fires when the input is clicked.
     */
    onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Triggered when component is focused.
     */
    onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Similar to `onchange`. Triggered when an element gets user input.
     */
    onInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Triggered when a submittable `<input>` element is invalid.
     */
    onInvalid: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Triggered when a key is pressed down
     */
    onKeyDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Triggered when a key is pressed and released
     */
    onKeyPress: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Triggered when a key is released
     */
    onKeyUp: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Triggered after some text has been selected in an element.
     */
    onSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Fires when a form is submitted.
     */
    onSubmit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Text that will appear in an empty input.
     */
    placeholder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * Sets the minimum number of characters that an `<input>` can accept.
     */
    minLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * Sets the maximum number of characters that an `<input>` can accept.
     */
    maxLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * Name of the submitted form parameter.
     */
    name: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * Displays the value of the input as read-only. This is used in the inline edit UX pattern.
     */
    readOnly: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * Highlights the input as a required field (does not perform any validation).
     */
    required: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * ARIA role
     */
    role: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * The `<Input>` element includes support for all HTML5 types.
     */
    type: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['text', 'password', 'datetime', 'datetime-local', 'date', 'month', 'time', 'week', 'number', 'email', 'url', 'search', 'tel', 'color']),

    /**
     * The input is a controlled component, and will always display this value.
     */
    value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
  },
  getDefaultProps: function getDefaultProps() {
    return defaultProps;
  },
  componentWillMount: function componentWillMount() {
    // `checkProps` issues warnings to developers about properties (similar to React's built in development tools)
    Object(__WEBPACK_IMPORTED_MODULE_10__check_props__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_11__utilities_constants__["R" /* INPUT */], this.props);
    this.generatedId = __WEBPACK_IMPORTED_MODULE_4_shortid___default.a.generate();

    if (this.props.errorText) {
      this.generatedErrorId = __WEBPACK_IMPORTED_MODULE_4_shortid___default.a.generate();
    }
  },
  getId: function getId() {
    return this.props.id || this.generatedId;
  },
  getErrorId: function getErrorId() {
    return this.props['aria-describedby'] || this.generatedErrorId;
  },
  // This is convuluted to maintain backwards compatibility. Please remove deprecatedProps on next breaking change.
  getIconRender: function getIconRender(position, iconPositionProp) {
    var icon; // Remove at next breaking change

    /* eslint-disable react/prop-types */

    var deprecatedProps = {
      assistiveText: {
        icon: this.props[iconPositionProp] && this.props[iconPositionProp].props.assistiveText || this.props.iconAssistiveText
      },
      category: this.props[iconPositionProp] && this.props[iconPositionProp].props.category || this.props.iconCategory,
      name: this.props[iconPositionProp] && this.props[iconPositionProp].props.name || this.props.iconName,
      onClick: this.props[iconPositionProp] && this.props[iconPositionProp].props.onClick || this.props.onIconClick
    };
    /* eslint-enable react/prop-types */

    if (this.props[iconPositionProp] && position && this.props[iconPositionProp]) {
      icon = __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(this.props[iconPositionProp], {
        iconPosition: "".concat(position)
      });
    } else if (deprecatedProps.name) {
      icon = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__icon_input_icon__["a" /* default */], _extends({
        iconPosition: position
      }, deprecatedProps));
    }

    return icon;
  },
  render: function render() {
    // Remove at next breaking change
    // this is a hack to make left the default prop unless overwritten by `iconPosition="right"`
    var hasLeftIcon = !!this.props.iconLeft || (this.props.iconPosition === 'left' || this.props.iconPosition === undefined) && !!this.props.iconName;
    var hasRightIcon = !!this.props.iconRight || this.props.iconPosition === 'right' && !!this.props.iconName;

    var assistiveText = _objectSpread({}, defaultProps.assistiveText, this.props.assistiveText);

    var fieldLevelHelpTooltip;

    if ((this.props.label || this.props.assistiveText && this.props.assistiveText.label) && this.props.fieldLevelHelpTooltip) {
      var defaultTooltipProps = {
        triggerClassName: 'slds-form-element__icon',
        triggerStyle: {
          position: 'static'
        },
        children: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__button__["a" /* default */], {
          assistiveText: {
            icon: assistiveText.fieldLevelHelpButton
          },
          iconCategory: "utility",
          iconName: "info",
          variant: "icon"
        })
      };

      var tooltipProps = _objectSpread({}, defaultTooltipProps, this.props.fieldLevelHelpTooltip.props);

      fieldLevelHelpTooltip = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__tooltip__["a" /* default */], tooltipProps);
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('slds-form-element', {
        'slds-has-error': this.props.errorText
      }, this.props.className)
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__utilities_label__["a" /* default */], {
      assistiveText: this.props.assistiveText,
      htmlFor: this.props.isStatic ? undefined : this.getId(),
      label: this.props.label,
      required: this.props.required,
      variant: this.props.isStatic ? 'static' : 'base'
    }), fieldLevelHelpTooltip, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__private_inner_input__["a" /* default */], {
      "aria-activedescendant": this.props['aria-activedescendant'],
      "aria-autocomplete": this.props['aria-autocomplete'],
      "aria-controls": this.props['aria-controls'],
      "aria-labelledby": this.props['aria-labelledby'],
      "aria-describedby": this.getErrorId(),
      "aria-expanded": this.props['aria-expanded'],
      "aria-owns": this.props['aria-owns'],
      "aria-required": this.props['aria-required'],
      containerProps: {
        className: 'slds-form-element__control'
      },
      defaultValue: this.props.defaultValue,
      disabled: this.props.disabled,
      fixedTextLeft: this.props.fixedTextLeft,
      fixedTextRight: this.props.fixedTextRight,
      hasSpinner: this.props.hasSpinner,
      id: this.getId(),
      iconLeft: hasLeftIcon ? this.getIconRender('left', 'iconLeft') : null,
      iconRight: hasRightIcon ? this.getIconRender('right', 'iconRight') : null,
      inlineEditTrigger: this.props.inlineEditTrigger,
      inlineHelpText: this.props.inlineHelpText,
      isStatic: this.props.isStatic,
      minLength: this.props.minLength,
      maxLength: this.props.maxLength,
      name: this.props.name,
      onBlur: this.props.onBlur,
      onChange: this.props.onChange,
      onClick: this.props.onClick,
      onFocus: this.props.onFocus,
      onInput: this.props.onInput,
      onInvalid: this.props.onInvalid,
      onKeyDown: this.props.onKeyDown,
      onKeyPress: this.props.onKeyPress,
      onKeyUp: this.props.onKeyUp,
      onSelect: this.props.onSelect,
      onSubmit: this.props.onSubmit,
      placeholder: this.props.placeholder,
      inputRef: this.props.inputRef,
      readOnly: this.props.readOnly,
      required: this.props.required,
      role: this.props.role,
      assistiveText: this.props.assistiveText,
      type: this.props.type,
      value: this.props.value
    }), this.props.errorText && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      id: this.getErrorId(),
      className: "slds-form-element__help"
    }, this.props.errorText), this.props.children);
  }
});
/* harmony default export */ __webpack_exports__["a"] = (Input);
//# sourceMappingURL=index.js.map

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shortid__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shortid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shortid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_dialog__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__icon__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__check_props__ = __webpack_require__(200);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// # Tooltip


 // ### shortid
// [npmjs.com/package/shortid](https://www.npmjs.com/package/shortid)
// shortid is a short, non-sequential, url-friendly, unique id generator




 // This component's `checkProps` which issues warnings to developers about properties when in development mode (similar to React's built in development tools)

 // ### Display Name
// Always use the canonical component name as the React display name.

var displayName = __WEBPACK_IMPORTED_MODULE_4__utilities_constants__["_8" /* POPOVER_TOOLTIP */];
var propTypes = {
  /**
   * Alignment of the Tooltip relative to the element that triggers it.
   */
  align: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['top', 'top left', 'top right', 'right', 'right top', 'right bottom', 'bottom', 'bottom left', 'bottom right', 'left', 'left top', 'left bottom']).isRequired,

  /**
   * **Assistive text for accessibility**
   * This object is merged with the default props object on every render.
   * * `tooltipTipLearnMoreIcon`: This text is inside the info icon within the tooltip content and exists to "complete the sentence" for assistive tech users.
   * * `triggerLearnMoreIcon`: This text is inside the info icon that triggers the tooltip in order to have text within the link.
   */
  assistiveText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    tooltipTipLearnMoreIcon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    triggerLearnMoreIcon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),

  /**
   * Pass the one element that triggers the Tooltip as a child. It must be an element with `tabIndex` or an element that already has a `tabIndex` set such as an anchor or a button, so that keyboard users can tab to it.
   */
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * Content inside Tooltip.
   */
  content: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,

  /**
   * By default, dialogs will flip their alignment (such as bottom to top) if they extend beyond a boundary element such as a scrolling parent or a window/viewpoint. `hasStaticAlignment` disables this behavior and allows this component to extend beyond boundary elements. _Not tested._
   */
  hasStaticAlignment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Delay on Tooltip closing.
   */
  hoverCloseDelay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * A unique ID is needed in order to support keyboard navigation, ARIA support, and connect the popover to the triggering element.
   */
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * **Text labels for internationalization**
   * This object is merged with the default props object on every render.
   * * `learnMoreAfter`: This label appears in the tooltip after the info icon.
   * * `learnMoreBefore`: This label appears in the tooltip before the info icon.
   */
  labels: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    learnMoreAfter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    learnMoreBefore: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),

  /**
   * Forces tooltip to be open. A value of `false` will disable any interaction with the tooltip.
   */
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * CSS classes to be added to tag with `slds-tooltip-trigger`.
   */
  triggerClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * Please select one of the following:
   * * `absolute` - (default) The dialog will use `position: absolute` and style attributes to position itself. This allows inverted placement or flipping of the dialog.
   * * `overflowBoundaryElement` - The dialog will overflow scrolling parents. Use on elements that are aligned to the left or right of their target and don't care about the target being within a scrolling parent. Typically this is a popover or tooltip. Dropdown menus can usually open up and down if no room exists. In order to achieve this a portal element will be created and attached to `body`. This element will render into that detached render tree.
   * * `relative` - No styling or portals will be used. Menus will be positioned relative to their triggers. This is a great choice for HTML snapshot testing.
   */
  position: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['absolute', 'overflowBoundaryElement', 'relative']),

  /**
   * Custom styles to be added to wrapping triggering `div`.
   */
  triggerStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * Determines the theme of tooltip: for informative purpose (blue background) or warning purpose (red background). This used to be `variant`.
   */
  theme: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['info', 'error']),

  /**
   * Determines the type of the tooltip.
   */
  variant: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['base', 'learnMore'])
};
var defaultProps = {
  assistiveText: {
    tooltipTipLearnMoreIcon: 'this link',
    triggerLearnMoreIcon: 'Learn More'
  },
  align: 'top',
  content: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Tooltip"),
  labels: {
    learnMoreAfter: 'to learn more.',
    learnMoreBefore: 'Click'
  },
  hoverCloseDelay: 50,
  position: 'absolute',
  theme: 'info',
  variant: 'base'
};
/**
 * The PopoverTooltip component is variant of the Lightning Design System Popover component. This component wraps an element that triggers it to open. It must be a focusable child element (either a button or an anchor), so that keyboard users can navigate to it.
 */

var Tooltip =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Tooltip, _React$Component);

  function Tooltip(props) {
    var _this;

    _classCallCheck(this, Tooltip);

    _this = _possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, props));
    Object.defineProperty(_assertThisInitialized(_this), "handleCancel", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        _this.setState({
          isOpen: false,
          isClosing: false
        });
      }
    });
    Object.defineProperty(_assertThisInitialized(_this), "handleMouseEnter", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        _this.setState({
          isOpen: true,
          isClosing: false
        });
      }
    });
    Object.defineProperty(_assertThisInitialized(_this), "handleMouseLeave", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        _this.setState({
          isClosing: true
        });

        setTimeout(function () {
          if (!_this.isUnmounting && _this.state.isClosing) {
            _this.setState({
              isOpen: false,
              isClosing: false
            });
          }
        }, _this.props.hoverCloseDelay);
      }
    });
    Object.defineProperty(_assertThisInitialized(_this), "saveTriggerRef", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(component) {
        _this.trigger = component; // yes, this is a re-render triggered by a render.
        // Dialog/Popper.js cannot place the popover until
        // the trigger/target DOM node is mounted. This
        // way `findDOMNode` is not called and parent
        // DOM nodes are not queried.

        if (!_this.state.triggerRendered) {
          _this.setState({
            triggerRendered: true
          });
        }
      }
    });
    _this.state = {
      isClosing: false,
      isOpen: false
    };
    return _this;
  }

  _createClass(Tooltip, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      // `checkProps` issues warnings to developers about properties (similar to React's built in development tools)
      Object(__WEBPACK_IMPORTED_MODULE_7__check_props__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__utilities_constants__["_8" /* POPOVER_TOOLTIP */], this.props);
      this.generatedId = __WEBPACK_IMPORTED_MODULE_3_shortid___default.a.generate();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.isUnmounting = true;
    }
  }, {
    key: "getContent",
    value: function getContent() {
      var _this2 = this;

      var children;

      if (__WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.count(this.props.children) === 0) {
        children = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
          href: "javascript:void(0)",
          onClick: this.props.onClickTrigger
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__icon__["a" /* default */], {
          category: "utility",
          name: "info",
          assistiveText: {
            label: this.props.assistiveText.triggerLearnMoreIcon
          },
          size: "x-small"
        }))];
      } else {
        children = this.props.children;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(children, function (child, i) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, {
          key: i,
          'aria-describedby': _this2.getId(),
          onBlur: _this2.handleMouseLeave,
          onFocus: _this2.handleMouseEnter,
          onMouseEnter: _this2.handleMouseEnter,
          onMouseLeave: _this2.handleMouseLeave
        });
      });
    }
  }, {
    key: "getId",
    value: function getId() {
      return this.props.id || this.generatedId;
    }
  }, {
    key: "getTooltip",
    value: function getTooltip() {
      var _this3 = this;

      var isOpen = this.props.isOpen === undefined ? this.state.isOpen : this.props.isOpen;
      var align = this.props.align; // REMOVE AT NEXT BREAKING CHANGE (v1.0 or v0.9)

      var deprecatedWay = this.props.variant === 'error';
      return isOpen ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__utilities_dialog__["a" /* default */], {
        closeOnTabKey: true,
        hasNubbin: true,
        contentsClassName: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('slds-popover', 'slds-popover--tooltip', {
          'slds-theme_error': this.props.theme === 'error' || deprecatedWay
        }),
        align: align,
        context: this.context,
        hasStaticAlignment: this.props.hasStaticAlignment,
        onClose: this.handleCancel,
        onRequestTargetElement: function onRequestTargetElement() {
          return _this3.getTooltipTarget();
        },
        position: this.props.position,
        variant: "tooltip",
        containerProps: {
          id: this.getId()
        }
      }, this.getTooltipContent()) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null);
    }
  }, {
    key: "getTooltipContent",
    value: function getTooltipContent() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "slds-popover__body"
      }, this.props.content, this.props.variant === 'learnMore' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "slds-m-top_x-small"
      }, this.props.labels.learnMoreBefore, ' ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__icon__["a" /* default */], {
        assistiveText: {
          label: this.props.assistiveText.tooltipTipLearnMoreIcon
        },
        category: "utility",
        inverse: true,
        name: "info",
        size: "x-small"
      }), ' ', this.props.labels.learnMoreAfter, ' ') : null);
    }
  }, {
    key: "getTooltipTarget",
    value: function getTooltipTarget() {
      return this.props.target ? this.props.target : this.trigger;
    }
  }, {
    key: "render",
    value: function render() {
      var containerStyles = _objectSpread({
        display: 'inline-block'
      }, this.props.triggerStyle);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('slds-tooltip-trigger', this.props.triggerClassName),
        style: containerStyles,
        ref: this.saveTriggerRef
      }, this.getContent(), this.getTooltip());
    }
  }]);

  return Tooltip;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Tooltip.contextTypes = {
  iconPath: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
Tooltip.displayName = displayName;
Tooltip.propTypes = propTypes;
Tooltip.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Tooltip);
//# sourceMappingURL=index.js.map

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_popper_js__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isequal__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isequal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__portal__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utilities_event__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utilities_key_code__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utilities_dom_element_focus__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utilities_dialog_helpers__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utilities_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__icon_settings__ = __webpack_require__(47);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */




 // ### classNames
// [github.com/JedWatson/classnames](https://github.com/JedWatson/classnames)
// This project uses `classnames`, "a simple javascript utility for conditionally
// joining classNames together."







 // #### Dialog doesn't pass down <IconSettings> context so repassing it here.


/*
 * A Dialog is content that is separate from the typical flow of a page. It typically overlays other elements in the document flow. This is achieved with elevation (`z-index`) and one of the following: relative position, absolute position, or a new top-level React render tree (portal). A boundary element is a scrolling ancestor element or the edge of the browser (window/viewport). This element typically has an overflow (overflow-y/overflow-x) style that is scroll, hidden, or auto. Inverted placement is the flipping of the overlay element from top to bottom or left to right in order stay within a boundary element.
 *
 * * Dropdown menu (Combobox, DatePicker, et al.) placement is typically bottom-aligned and should be allowed to invert its placement when inside a boundary element this often happens within a modal. Dropdowns should not overflow boundary elements , since most boundary elements scroll vertically and have space for the menu.
 *
 * * If they are hidden, left and right placed overlay elements (such as Popover and Tooltip) should be placed within a portal element attached to the DOM <body>, but styled to align to its target/trigger. Since scrolling typically occurs on the vertical axis, this allows them to overflow boundary elements and still allow scrolling of content, yet still invert placement for the browser viewport. Portal elements are only necessary if an original ancestor boundary element exists. **No portals are created by default.**
 *
 * * Nubbins/arrows should be repositioned for any new placement/alignment.
 *
 * Allow Overflowing of Boundary Element: Allow applications to create a portal element attached to the DOM <body> to be outside of boundary elements if manual testing shows confusing alignment/poor usability/readability. This should be exception and not the default.
 *
 * Allow Inverted placement: Allow applications to prevent inverted placement if manual testing shows confusing alignment/poor usability/readability.
 *
 * ### How this new Dialog component works
 * * There is no longer an inline render within components. All overlays should go through `Dialog`. `position: relative` just passes on the markup with some additional event listeners. No positional library is used.
 * * The default `position: absolute` will run through three renders. It will first render the overlay at `0px/0px` offset of its parent. It will then store the target DOM node, once the DOM node is set, a state change will occur and tell a PopperJS instance to be created on update, once it is created, a third render is done to update the styles created by PopperJS.
 * * `position: overflowBoundaryElement` will do the same three renders as `absolute` except that the initial render will create a disconnected render tree (portal) on the `body`. Then, the position will change once the target is stored. The portal itself will be rendered multiple times. The first will result in `onOpen` executing. Each update will result in a re-render of the disconnected render-tree.
 *
 * This component is private.
 */

var Dialog = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: __WEBPACK_IMPORTED_MODULE_11__utilities_constants__["B" /* DIALOG */],
  propTypes: {
    /**
     * Aligns the right or left side of the dialog with the respective side of the target.
     */
    align: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['top', 'top left', 'top right', 'right', 'right top', 'right bottom', 'bottom', 'bottom left', 'bottom right', 'left', 'left top', 'left bottom']),

    /**
     * CSS classes to be added to the absolutely positioned element.
     */
    className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),

    /**
     * CSS classes to be added to the wrapping `div` of the contents of the dialog.
     */
    contentsClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),

    /**
     * Contents of dialog
     */
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node.isRequired,

    /**
     * Closes dialog when tab key is pressed
     */
    closeOnTabKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * Props passed along to wrapping div. This allows one less wrapping `div` to be in the markup. dialog children are expected to be wrapper in a single `div`.
     */
    containerProps: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,

    /**
     * Will show the nubbin pointing from the dialog to the reference element. Positioning and offsets will be handled.
     */
    hasNubbin: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * By default, dialogs will flip their alignment (such as bottom to top) if they extend beyond a boundary element such as a scrolling parent or a window/viewpoint. `hasStaticAlignment` disables this behavior and allows this component to extend beyond boundary elements.
     */
    hasStaticAlignment: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * Sets the dialog width to the width of either 'target' (Menus attached to `input` typically follow this UX pattern), 'menu' or 'none.
     */
    inheritWidthOf: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['target', 'menu', 'none']),

    /**
     * DEPRECATED - do not add checkProp deprecation message at this level. It is handled at higher level components.
     * TODO - to be removed.
     * Offset adds pixels to the absolutely positioned dropdown menu in the format: ([vertical]px [horizontal]px). SHOULD BE OBJECT -----------
     */
    offset: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * Called when dialog closes and unmounts.
     */
    onClose: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Called when a key pressed.
     */
    onKeyDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Called when mouse hovers over the trigger button. This is only called if `this.props.openOn` is set to `hover`.
     */
    onMouseEnter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Called when mouse hover leaves the trigger button. This is only called if `this.props.openOn` is set to `hover`.
     */
    onMouseLeave: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Called when dialog opens (that is mounts). The parameters are `undefined, { portal: this.portal }`.
     */
    onOpen: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * React component to be aligned with. Function should return a DOM `ref` from the parent component.
     */
    onRequestTargetElement: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,

    /**
     * Triggered when an item in the menu is clicked.
     */
    outsideClickIgnoreClass: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * If a dialog is `positione="overflowBoundaryElement"`, it will be rendered in a portal or separate render tree. This `portalMount` callback will be triggered instead of the the default `ReactDOM.unstable_renderSubtreeIntoContainer` and the function will mount the portal itself. Consider the following code that bypasses the internal mount and uses an Enzyme wrapper to mount the React root tree to the DOM.
     *
     * ```
     * <Popover
     *   isOpen
     *   portalMount={({ instance, reactElement, domContainerNode }) => {
     *     portalWrapper = Enzyme.mount(reactElement, { attachTo: domContainerNode });
     *   }}
     *   onOpen={() => {
     *     expect(portalWrapper.find(`#my-heading`)).to.exist;
     *     done();
     *   }}
     *   />
     * ```
     */
    portalMount: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Please select one of the following:
     * * `absolute` - (default) The dialog will use `position: absolute` and style attributes to position itself. This allows inverted placement or flipping of the dialog.
     * * `overflowBoundaryElement` - The dialog will overflow scrolling parents. Use on elements that are aligned to the left or right of their target and don't care about the target being within a scrolling parent. Typically this is a popover or tooltip. Dropdown menus can usually open up and down if no room exists. In order to achieve this a portal element will be created and attached to `body`. This element will render into that detached render tree.
     * * `relative` - No styling or portals will be used. Menus will be positioned relative to their triggers. This is a great choice for HTML snapshot testing.
     */
    position: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['absolute', 'overflowBoundaryElement', 'relative']).isRequired,

    /**
     * An object of CSS styles that are applied to the immediate parent `div` of the contents. Use this instead of margin props.
     */
    style: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,

    /**
     * Sets which focus UX pattern to follow. For instance, popovers trap focus and must be exited to regain focus. Dropdowns and Tooltips never have focus.
     */
    variant: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['dropdown', 'popover', 'tooltip'])
  },
  getDefaultProps: function getDefaultProps() {
    return {
      align: 'bottom left',
      offset: '0px 0px',
      outsideClickIgnoreClass: 'ignore-react-onclickoutside'
    };
  },
  getInitialState: function getInitialState() {
    return {
      triggerPopperJS: false,
      isOpen: false
    };
  },
  componentDidMount: function componentDidMount() {
    if (this.props.position === 'absolute' || this.props.position === 'relative') {
      this.handleOpen();
    }
  },
  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
    if (this.state.triggerPopperJS === true && prevState.triggerPopperJS === false && (this.props.position === 'absolute' || this.props.position === 'overflowBoundaryElement') && this.dialogContent && this.props.onRequestTargetElement()) {
      this.createPopper();
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    if (this.props.variant === 'popover') {
      __WEBPACK_IMPORTED_MODULE_9__utilities_dom_element_focus__["a" /* default */].teardownScopedFocus();
      __WEBPACK_IMPORTED_MODULE_9__utilities_dom_element_focus__["a" /* default */].returnFocusToStoredElement();
    }

    if (this.props.position === 'absolute' || this.props.position === 'overflowBoundaryElement') {
      this.destroyPopper();
    }

    this.handleClose(undefined, {
      componentWillUnmount: true
    });
  },
  getPropOffsetsInPixels: function getPropOffsetsInPixels(offsetString) {
    var offsetArray = offsetString.split(' ');
    return {
      vertical: parseInt(offsetArray[0], 10),
      horizontal: parseInt(offsetArray[1], 10)
    };
  },
  getPopperStyles: function getPopperStyles() {
    var popperData = this.state.popperData;

    if (!this.popper || !popperData) {
      return {
        position: 'absolute',
        pointerEvents: 'none'
      };
    }

    var position = popperData.offsets.popper.position;
    var propOffsets = this.getPropOffsetsInPixels(this.props.offset); // FIXME before merge - gotta rename from margin to offset

    var nubbinOffsets = this.props.hasNubbin ? Object(__WEBPACK_IMPORTED_MODULE_10__utilities_dialog_helpers__["b" /* getNubbinMargins */])(this.state.popperData) : {
      left: 0,
      top: 0
    };
    var left = popperData.offsets.popper.left + nubbinOffsets.left + propOffsets.horizontal;
    var top = popperData.offsets.popper.top + nubbinOffsets.top + propOffsets.vertical; // A Dropdown with overflowBoundaryElement position and 'align=right' uses max-width instead of inherited children width

    var right = 'inherit';
    return _objectSpread({}, popperData.style, {
      left: left,
      top: top,
      right: right,
      position: position
    });
  },
  // Render
  setDialogContent: function setDialogContent(component) {
    this.dialogContent = component;

    if (!this.state.triggerPopperJS) {
      this.setState({
        triggerPopperJS: true
      });
    }
  },

  /**
   * Events
   */
  handleClickOutside: function handleClickOutside() {
    this.handleClose();
  },
  handleClose: function handleClose(event, data) {
    this.setState({
      triggerPopperJS: true
    });

    if (this.props.onClose) {
      this.props.onClose(event, data);
    }
  },
  handleClick: function handleClick(event) {
    if (event.nativeEvent) {
      event.nativeEvent.preventDefault();
      event.nativeEvent.stopPropagation();
    }
  },
  handleKeyDown: function handleKeyDown(event) {
    if (event.keyCode === __WEBPACK_IMPORTED_MODULE_8__utilities_key_code__["a" /* default */].TAB) {
      if (this.props.closeOnTabKey) {
        __WEBPACK_IMPORTED_MODULE_7__utilities_event__["a" /* default */].trap(event);
        this.handleClose(event);
      }
    }

    if (this.props.onKeyDown) {
      this.props.onKeyDown(event);
    }
  },
  handleOpen: function handleOpen() {
    if (this.props.variant === 'popover' && this.dialogContent) {
      __WEBPACK_IMPORTED_MODULE_9__utilities_dom_element_focus__["a" /* default */].storeActiveElement();
      __WEBPACK_IMPORTED_MODULE_9__utilities_dom_element_focus__["a" /* default */].setupScopedFocus({
        ancestorElement: this.dialogContent
      }); // eslint-disable-line react/no-find-dom-node
      // Don't steal focus from inner elements

      if (!__WEBPACK_IMPORTED_MODULE_9__utilities_dom_element_focus__["a" /* default */].hasOrAncestorHasFocus()) {
        __WEBPACK_IMPORTED_MODULE_9__utilities_dom_element_focus__["a" /* default */].focusAncestor();
      }
    }

    if (this.props.onOpen) {
      this.props.onOpen(undefined, {
        portal: this.dialogContent
      });
    }
  },

  /**
   * Popper API and helper functions
   */
  createPopper: function createPopper() {
    var _this = this;

    var reference = this.props.onRequestTargetElement(); // eslint-disable-line react/no-find-dom-node

    var popper = this.dialogContent;
    var placement = Object(__WEBPACK_IMPORTED_MODULE_10__utilities_dialog_helpers__["c" /* mapPropToPopperPlacement */])(this.props.align);
    var eventsEnabled = true; // Lets popper listen to events (resize, scroll, etc.)

    var modifiers = {
      applyStyle: {
        enabled: false
      },
      // moves dialog in order to not extend a boundary element such as a scrolling parent or a window/viewpoint.
      preventOverflow: {
        enabled: !this.props.hasStaticAlignment,
        boundariesElement: this.props.position === 'absolute' ? 'scrollParent' : 'viewport'
      },
      // By default, dialogs will flip their alignment if they extend beyond a boundary element such as a scrolling parent or a window/viewpoint
      flip: {
        enabled: !this.props.hasStaticAlignment
      },
      removeOnDestroy: true,
      updateState: {
        enabled: true,
        order: 900,
        fn: function fn(popperData) {
          if (_this.state.popperData && !__WEBPACK_IMPORTED_MODULE_4_lodash_isequal___default()(popperData.offsets, _this.state.popperData.offsets) || !_this.state.popperData) {
            _this.setState({
              popperData: popperData
            });
          }

          return popperData;
        }
      } // arrow property can also point to an element

    };

    if (!reference) {
      console.error('Target node not found!', reference); // eslint-disable-line no-console
    }

    if (!popper) {
      console.error('Popper node not found!', popper); // eslint-disable-line no-console
    }

    this.popper = new __WEBPACK_IMPORTED_MODULE_3_popper_js__["a" /* default */](reference, popper, {
      placement: placement,
      eventsEnabled: eventsEnabled,
      modifiers: modifiers
    });
    this.popper.scheduleUpdate();
  },
  destroyPopper: function destroyPopper() {
    if (this.popper) {
      this.popper.destroy();
    }
  },
  render: function render() {
    var _this2 = this;

    var style = {};

    if (this.props.position === 'absolute' || this.props.position === 'overflowBoundaryElement') {
      style = _objectSpread({}, style, {
        outline: 0
      }, this.getPopperStyles());
    }

    if (this.props.inheritWidthOf === 'target' && this.props.onRequestTargetElement()) {
      style.width = this.props.onRequestTargetElement().getBoundingClientRect().width;
    } else if (this.props.inheritWidthOf === 'menu' && this.dialogContent && this.dialogContent.querySelector('.slds-listbox')) {
      // inherit menu renderer width
      style.width = this.dialogContent.querySelector('.slds-listbox').getBoundingClientRect().width;
    }

    style = _objectSpread({}, style, this.props.style);
    var contents = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({
      // eslint-disable-line jsx-a11y/no-static-element-interactions
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(_defineProperty({
        'absolute-positioned': this.props.position === 'absolute',
        'portal-positioned': this.props.position === 'overflowBoundaryElement'
      }, "".concat(this.props.outsideClickIgnoreClass), this.props.position === 'overflowBoundaryElement'), this.props.hasNubbin && Object(__WEBPACK_IMPORTED_MODULE_10__utilities_dialog_helpers__["a" /* getNubbinClassName */])(this.props.align, this.state.popperData), this.props.contentsClassName) || undefined,
      style: style,
      onKeyDown: this.handleKeyDown,
      onMouseEnter: this.props.onMouseEnter,
      onMouseLeave: this.props.onMouseLeave,
      ref: this.setDialogContent,
      role: this.props.variant,
      tabIndex: this.props.variant === 'popover' ? '-1' : undefined
    }, this.props.containerProps), this.props.children);
    var subRenders = {
      absolute: function absolute() {
        return contents;
      },
      relative: function relative() {
        return contents;
      },
      overflowBoundaryElement: function overflowBoundaryElement() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__portal__["a" /* default */], {
          onOpen: _this2.handleOpen,
          portalMount: _this2.props.portalMount
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__icon_settings__["a" /* default */], {
          iconPath: _this2.context.iconPath
        }, contents));
      }
    };
    return subRenders[this.props.position] && subRenders[this.props.position]();
  }
});
Dialog.contextTypes = {
  iconPath: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};
/* harmony default export */ __webpack_exports__["a"] = (Dialog);
//# sourceMappingURL=index.js.map

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
// ### classNames
// [github.com/JedWatson/classnames](https://github.com/JedWatson/classnames)
// This project uses `classnames`, "a simple javascript utility for conditionally
// joining classNames together."


var classNamesWrapper = function classNamesWrapper() {
  var string = __WEBPACK_IMPORTED_MODULE_0_classnames___default.a.apply(void 0, arguments);
  return string === '' ? undefined : string;
};

/* harmony default export */ __webpack_exports__["a"] = (classNamesWrapper);
//# sourceMappingURL=class-names.js.map

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_onclickoutside__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__menu_dropdown__ = __webpack_require__(225);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// ### onClickOutside
// Listen for clicks that occur somewhere in the document, outside of the element itself


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_onclickoutside__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__menu_dropdown__["a" /* default */]));
//# sourceMappingURL=index.js.map

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__check_props__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__icons_utility__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__icons_action__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__icons_custom__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__icons_doctype__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__icons_standard__ = __webpack_require__(192);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

 // This component's `checkProps` which issues warnings to developers about properties
// when in development mode (similar to React's built in development tools)








/*
 * If inline icons are present and icon bundle imports are not just an empty object, then inline icons will be used instead of external icons that require HTTP access.
 */

var UtilityIcon = function UtilityIcon(_ref, context) {
  var _ref$name = _ref.name,
      name = _ref$name === void 0 ? '' : _ref$name,
      assistiveText = _ref.assistiveText,
      category = _ref.category,
      icon = _ref.icon,
      path = _ref.path,
      rest = _objectWithoutProperties(_ref, ["name", "assistiveText", "category", "icon", "path"]);

  Object(__WEBPACK_IMPORTED_MODULE_2__check_props__["a" /* default */])('UtilityIcon', {
    name: name,
    category: category,
    path: path,
    context: context
  });
  var inlineIcons = {
    action: __WEBPACK_IMPORTED_MODULE_5__icons_action__["a" /* default */],
    custom: __WEBPACK_IMPORTED_MODULE_6__icons_custom__["a" /* default */],
    doctype: __WEBPACK_IMPORTED_MODULE_7__icons_doctype__["a" /* default */],
    standard: __WEBPACK_IMPORTED_MODULE_8__icons_standard__["a" /* default */],
    utility: __WEBPACK_IMPORTED_MODULE_4__icons_utility__["a" /* default */]
  };
  var inlineData;

  if (icon) {
    // Use SVG data passed in with `icon` prop
    inlineData = icon;
  } else if (Object.keys(inlineIcons[category]).length) {
    // Use inline icon data if it exists. ENV variables will have to set to allow this.
    inlineData = inlineIcons[category][name.toLowerCase()];
    inlineData.viewBox = inlineIcons[category].viewBox;
  }

  var modifiedPath;

  if (path) {
    // Use `path` prop of Icon if present
    modifiedPath = path;
  } else if (context["".concat(category, "Sprite")]) {
    // Use category sprite file from IconSettings if present
    modifiedPath = "".concat(context["".concat(category, "Sprite")], "#").concat(name);
  } else {
    // Otherwise, use external URLs for icons
    modifiedPath = context.iconPath && "".concat(context.iconPath, "/").concat(category, "-sprite/svg/symbols.svg#").concat(name);
  }

  return inlineData ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__svg__["a" /* default */], _extends({
    data: inlineData,
    name: name
  }, rest)) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    key: "".concat(name, "_").concat(category)
  }, rest), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("use", {
    xlinkHref: modifiedPath
  }));
};

UtilityIcon.displayName = 'UtilityIcon';
UtilityIcon.propTypes = {
  assistiveText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  category: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['action', 'custom', 'doctype', 'standard', 'utility']),

  /**
   * An SVG object to use instead of name / category, look in `design-system-react/icons` for examples
   */
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * Name of the icon. Visit <a href='http://www.lightningdesignsystem.com/resources/icons'>Lightning Design System Icons</a> to reference icon names.
   */
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Path to the icon. This will override any global icon settings.
   */
  path: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
UtilityIcon.defaultProps = {
  category: 'utility'
};
UtilityIcon.contextTypes = {
  iconPath: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  actionSprite: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  customSprite: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  doctypeSprite: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  standardSprite: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  utilitySprite: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
/* harmony default export */ __webpack_exports__["a"] = (UtilityIcon);
//# sourceMappingURL=index.js.map

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export cssClasses */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_constants__ = __webpack_require__(2);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// ### React


 // ### classNames
// [github.com/JedWatson/classnames](https://github.com/JedWatson/classnames)
// This project uses `classnames`, "a simple javascript utility for conditionally
// joining classNames together."


 // Allow for predicatable DOM queries with `querySelectorAll(cssClasses.base)`

var cssClasses = {
  base: 'slds-media',
  figure: 'slds-media__figure',
  body: 'slds-media__body'
};
/**
 * When you need text and a figure next to each other, use a media object.
 */

var MediaObject = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  // ### Display Name
  // Always use the canonical component name as the React display name.
  displayName: __WEBPACK_IMPORTED_MODULE_4__utilities_constants__["W" /* MEDIA_OBJECT */],
  // ### Prop Types
  propTypes: {
    /**
     * Often the body may need to be truncated for correct layout. This is only applicable if using the component within a flexbox container.
     */
    canTruncate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * Class names to be added to the component's HTML tag with `slds-media` class.
     */
    className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),

    /**
     * The body is often text such as a heading or paragraph.
     */
    body: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,

    /**
     * The figure is the optional visualization of the text within the body.
     */
    figure: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,

    /**
     * Vertically centers the body with the middle of the figure.
     */
    verticalCenter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
  },
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(cssClasses.base, {
        'slds-media--center': this.props.verticalCenter,
        'slds-has-flexi-truncate': this.props.canTruncate
      }, this.props.className)
    }, this.props.figure ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: cssClasses.figure
    }, this.props.figure, " ") : null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: cssClasses.body
    }, this.props.body));
  }
});
/* harmony default export */ __webpack_exports__["a"] = (MediaObject);
//# sourceMappingURL=index.js.map

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CONFERENCE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return EMAIL_ADDRESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DISCOUNT_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return EMAIL_BANNER; });
// ## Labels
var CONFERENCE_NAME='Wilderness Ways';var EMAIL_ADDRESS='no-reply@wildernessways.com';var DISCOUNT_CODE='43qj7';var EMAIL_BANNER='Wilderness Ways, San Francisco. September 25-28.';

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__check_props__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_utility_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_constants__ = __webpack_require__(2);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// ### React

 // ### classNames
// [github.com/JedWatson/classnames](https://github.com/JedWatson/classnames)
// This project uses `classnames`, "a simple javascript utility for conditionally
// joining classNames together."

 // This component's `checkProps` which issues warnings to developers about properties when in development mode (similar to React's built in development tools)

 // ### Children



/**
 * This is a non-interactive wrapper component for `UtilityIcon` that specifies button icon classes for an icon inside a `button` tag. Use of this component by itself is not recommended, but should be used as part of other components to obtain the correct styling for icons within buttons. This component only partially implements [Button Icons](http://www.lightningdesignsystem.com/components/button-icons). It does not return a `button` HTML tag. It only returns an icon for use within a button. Assistive text must also be rendered by the parent.
 */

var ButtonIcon = function ButtonIcon(props) {
  var _classNames;

  Object(__WEBPACK_IMPORTED_MODULE_3__check_props__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5__utilities_constants__["j" /* BUTTON_ICON */], props);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__utilities_utility_icon__["a" /* default */], {
    "aria-hidden": "true",
    category: props.category,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('slds-button__icon', (_classNames = {}, _defineProperty(_classNames, "slds-button__icon--".concat(props.size), props.size && props.size !== 'medium'), _defineProperty(_classNames, 'slds-button__icon--inverse-hint', props.inverse && props.hint), _defineProperty(_classNames, 'slds-button__icon--hint', props.hint && !props.inverse), _defineProperty(_classNames, "slds-button__icon--".concat(props.position), props.position), _classNames), props.className) // iconClassName has been deprecated
    ,
    icon: props.icon,
    name: props.name,
    path: props.path
  });
};

var propTypes = {
  /**
   * Icon category from [lightningdesignsystem.com/icons/](https://www.lightningdesignsystem.com/icons/)
   */
  category: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['action', 'custom', 'doctype', 'standard', 'utility']).isRequired,

  /**
   * Associates an icon button with another element on the page by changes the color of the SVG. Please reference <a href="http://www.lightningdesignsystem.com/components/buttons/#hint">Lightning Design System Buttons > Hint</a>.
   */
  hint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * An SVG object to use instead of name / category, look in `design-system-react/icons` for examples
   */
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * Class names to be added to the SVG.
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * Setting `inverse` to true will switch the color of the icon: light to dark, dark to light.
   */
  inverse: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Name of the icon. Visit <a href='http://www.lightningdesignsystem.com/resources/icons'>Lightning Design System Icons</a> to reference icon names.
   */
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Path to the icon. This will override any global icon settings.
   */
  path: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Adds additional spacing on the opposite side specified between button icon and the button label
   */
  position: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['left', 'right']),

  /**
   * Size of the icon. Visit [lightningdesignsystem.com/components/icons/#flavor-sizes](https://www.lightningdesignsystem.com/components/icons/#flavor-sizes)
   */
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['x-small', 'small', 'medium', 'large'])
};
var defaultProps = {
  category: 'utility',
  size: 'medium'
};
ButtonIcon.displayName = __WEBPACK_IMPORTED_MODULE_5__utilities_constants__["j" /* BUTTON_ICON */];
ButtonIcon.propTypes = propTypes;
ButtonIcon.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (ButtonIcon);
//# sourceMappingURL=index.js.map

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    asyncTag = '[object AsyncFunction]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    nullTag = '[object Null]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    proxyTag = '[object Proxy]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    undefinedTag = '[object Undefined]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = isEqual;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17), __webpack_require__(30)(module)))

/***/ }),
/* 30 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__check_props__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_constants__ = __webpack_require__(2);
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable jsx-a11y/no-redundant-roles */
// # Breadcrumbs
// Implements the [Breadcrumbs design pattern](https://www.lightningdesignsystem.com/components/breadcrumbs) in React.
// Based on SLDS v2.1.0-rc.2
// ## Dependencies
// ### React

 // This component's `checkProps` which issues warnings to developers about properties when in development mode (similar to React's built in development tools)

 // ## Constants


var defaultProps = {
  assistiveText: {
    label: 'Breadcrumbs'
  }
};
/**
 * Use breadcrumbs to note the path of a record and help the user to navigate back to the parent.Breadcrumb based on SLDS 2.1.0-dev
 */

var Breadcrumb = function Breadcrumb(props) {
  Object(__WEBPACK_IMPORTED_MODULE_2__check_props__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__utilities_constants__["g" /* BREADCRUMB */], props);
  var trail = props.trail;
  var assistiveText = typeof props.assistiveText === 'string' ? props.assistiveText : _objectSpread({}, defaultProps.assistiveText, props.assistiveText).label;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("nav", {
    role: "navigation",
    "aria-label": assistiveText
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol", {
    className: "slds-breadcrumb slds-list--horizontal"
  }, trail.map(function (crumb, index) {
    return (
      /* eslint-disable react/no-array-index-key */
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
        key: index // There isn't any better reasonable way to identity these
        ,
        className: "slds-breadcrumb__item slds-text-title--caps"
      }, crumb)
    );
  })));
};

Breadcrumb.displayName = __WEBPACK_IMPORTED_MODULE_3__utilities_constants__["g" /* BREADCRUMB */];
Breadcrumb.propTypes = {
  /**
   * **Assistive text for accessibility.**
   * This object is merged with the default props object on every render.
   * * `label`: The assistive text for the breadcrumb trail.
   */
  assistiveText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),

  /**
   * An array of react elements presumably anchor elements.
   */
  trail: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};
Breadcrumb.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Breadcrumb);
//# sourceMappingURL=index.js.map

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IGNORE_CLASS_NAME */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);



function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/**
 * Check whether some DOM node is our Component's node.
 */
function isNodeFound(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // SVG <use/> elements do not technically reside in the rendered DOM, so
  // they do not have classList directly, but they offer a link to their
  // corresponding element, which can have classList. This extra check is for
  // that case.
  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17


  if (current.correspondingElement) {
    return current.correspondingElement.classList.contains(ignoreClass);
  }

  return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */

function findHighest(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // If source=local then this event came from 'somewhere'
  // inside and should be ignored. We could handle this with
  // a layered approach, too, but that requires going back to
  // thinking in terms of Dom node nesting, running counter
  // to React's 'you shouldn't care about the DOM' philosophy.


  while (current.parentNode) {
    if (isNodeFound(current, componentNode, ignoreClass)) {
      return true;
    }

    current = current.parentNode;
  }

  return current;
}
/**
 * Check if the browser scrollbar was clicked
 */

function clickedScrollbar(evt) {
  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
}

// ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var testPassiveEventSupport = function testPassiveEventSupport() {
  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
    return;
  }

  var passive = false;
  var options = Object.defineProperty({}, 'passive', {
    get: function get() {
      passive = true;
    }
  });

  var noop = function noop() {};

  window.addEventListener('testPassiveEventSupport', noop, options);
  window.removeEventListener('testPassiveEventSupport', noop, options);
  return passive;
};

function autoInc(seed) {
  if (seed === void 0) {
    seed = 0;
  }

  return function () {
    return ++seed;
  };
}

var uid = autoInc();

var passiveEventSupport;
var handlersMap = {};
var enabledInstances = {};
var touchEvents = ['touchstart', 'touchmove'];
var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
/**
 * Options for addEventHandler and removeEventHandler
 */

function getEventHandlerOptions(instance, eventName) {
  var handlerOptions = null;
  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;

  if (isTouchEvent && passiveEventSupport) {
    handlerOptions = {
      passive: !instance.props.preventDefault
    };
  }

  return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */


function onClickOutsideHOC(WrappedComponent, config) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inheritsLoose(onClickOutside, _Component);

    function onClickOutside(props) {
      var _this;

      _this = _Component.call(this, props) || this;

      _this.__outsideClickHandler = function (event) {
        if (typeof _this.__clickOutsideHandlerProp === 'function') {
          _this.__clickOutsideHandlerProp(event);

          return;
        }

        var instance = _this.getInstance();

        if (typeof instance.props.handleClickOutside === 'function') {
          instance.props.handleClickOutside(event);
          return;
        }

        if (typeof instance.handleClickOutside === 'function') {
          instance.handleClickOutside(event);
          return;
        }

        throw new Error('WrappedComponent lacks a handleClickOutside(event) function for processing outside click events.');
      };

      _this.enableOnClickOutside = function () {
        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
          return;
        }

        if (typeof passiveEventSupport === 'undefined') {
          passiveEventSupport = testPassiveEventSupport();
        }

        enabledInstances[_this._uid] = true;
        var events = _this.props.eventTypes;

        if (!events.forEach) {
          events = [events];
        }

        handlersMap[_this._uid] = function (event) {
          if (_this.props.disableOnClickOutside) return;
          if (_this.componentNode === null) return;

          if (_this.props.preventDefault) {
            event.preventDefault();
          }

          if (_this.props.stopPropagation) {
            event.stopPropagation();
          }

          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
          var current = event.target;

          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
            return;
          }

          _this.__outsideClickHandler(event);
        };

        events.forEach(function (eventName) {
          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_this, eventName));
        });
      };

      _this.disableOnClickOutside = function () {
        delete enabledInstances[_this._uid];
        var fn = handlersMap[_this._uid];

        if (fn && typeof document !== 'undefined') {
          var events = _this.props.eventTypes;

          if (!events.forEach) {
            events = [events];
          }

          events.forEach(function (eventName) {
            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_this, eventName));
          });
          delete handlersMap[_this._uid];
        }
      };

      _this.getRef = function (ref) {
        return _this.instanceRef = ref;
      };

      _this._uid = uid();
      return _this;
    }
    /**
     * Access the WrappedComponent's instance.
     */


    var _proto = onClickOutside.prototype;

    _proto.getInstance = function getInstance() {
      if (!WrappedComponent.prototype.isReactComponent) {
        return this;
      }

      var ref = this.instanceRef;
      return ref.getInstance ? ref.getInstance() : ref;
    };

    /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */
    _proto.componentDidMount = function componentDidMount() {
      // If we are in an environment without a DOM such
      // as shallow rendering or snapshots then we exit
      // early to prevent any unhandled errors being thrown.
      if (typeof document === 'undefined' || !document.createElement) {
        return;
      }

      var instance = this.getInstance();

      if (config && typeof config.handleClickOutside === 'function') {
        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);

        if (typeof this.__clickOutsideHandlerProp !== 'function') {
          throw new Error('WrappedComponent lacks a function for processing outside click events specified by the handleClickOutside config option.');
        }
      }

      this.componentNode = Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(this.getInstance());
      this.enableOnClickOutside();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      this.componentNode = Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(this.getInstance());
    };
    /**
     * Remove all document's event listeners for this component
     */


    _proto.componentWillUnmount = function componentWillUnmount() {
      this.disableOnClickOutside();
    };
    /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */


    /**
     * Pass-through render
     */
    _proto.render = function render() {
      // eslint-disable-next-line no-unused-vars
      var _props = this.props,
          excludeScrollbar = _props.excludeScrollbar,
          props = _objectWithoutProperties(_props, ["excludeScrollbar"]);

      if (WrappedComponent.prototype.isReactComponent) {
        props.ref = this.getRef;
      } else {
        props.wrappedRef = this.getRef;
      }

      props.disableOnClickOutside = this.disableOnClickOutside;
      props.enableOnClickOutside = this.enableOnClickOutside;
      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(WrappedComponent, props);
    };

    return onClickOutside;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.displayName = "OnClickOutside(" + (WrappedComponent.displayName || WrappedComponent.name || 'Component') + ")", _class.defaultProps = {
    eventTypes: ['mousedown', 'touchstart'],
    excludeScrollbar: config && config.excludeScrollbar || false,
    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
    preventDefault: false,
    stopPropagation: false
  }, _class.getClass = function () {
    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
  }, _temp;
}


/* harmony default export */ __webpack_exports__["a"] = (onClickOutsideHOC);


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__low_priority_warning__ = __webpack_require__(54);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable import/no-mutable-exports */
// This function will deliver a warning message to the browser console about the component being a deprecated component.


var isPrototype = function isPrototype() {};

if (false) {
  var hasWarned = {};

  isPrototype = function isPrototype(control, comment) {
    var additionalComment = comment ? " ".concat(comment) : '';

    if (!hasWarned[control]) {
      /* eslint-disable max-len */
      lowPriorityWarning(false, "[Design System React] ".concat(control, " is a deprecated component. Bugfixes can be contributed, but new features and additional alignment with SLDS may be declined.").concat(additionalComment));
      /* eslint-enable max-len */

      hasWarned[control] = true;
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (isPrototype);
//# sourceMappingURL=component-is-deprecated.js.map

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var propTypes={currentScreenIndex:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};var BrowserContainer=function(_Component){_inherits(BrowserContainer,_Component);function BrowserContainer(props){_classCallCheck(this,BrowserContainer);var _this=_possibleConstructorReturn(this,(BrowserContainer.__proto__||Object.getPrototypeOf(BrowserContainer)).call(this,props));_this.browserTitle=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();return _this;}_createClass(BrowserContainer,[{key:'componentDidMount',value:function componentDidMount(){this.browserTitle.current.focus();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'ht-full container-chrome bra-25','aria-label':'Browser Window: '+this.props.label},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'df df-vert-center bdr-s brt-25 container-chrome-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'mlm mrxs dib chrome-button chrome-red'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'mhxs dib chrome-button chrome-yellow'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'mhxs dib chrome-button chrome-green'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'f4 horz-center no-focus-halo',tabIndex:'-1',ref:this.browserTitle},this.props.label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'container-chrome-spacer'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-chrome-body brb-25 scroll-y'},this.props.children));}}]);return BrowserContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);BrowserContainer.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (BrowserContainer);

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var randomFromSeed = __webpack_require__(177);

var ORIGINAL = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_-';
var alphabet;
var previousSeed;

var shuffled;

function reset() {
    shuffled = false;
}

function setCharacters(_alphabet_) {
    if (!_alphabet_) {
        if (alphabet !== ORIGINAL) {
            alphabet = ORIGINAL;
            reset();
        }
        return;
    }

    if (_alphabet_ === alphabet) {
        return;
    }

    if (_alphabet_.length !== ORIGINAL.length) {
        throw new Error('Custom alphabet for shortid must be ' + ORIGINAL.length + ' unique characters. You submitted ' + _alphabet_.length + ' characters: ' + _alphabet_);
    }

    var unique = _alphabet_.split('').filter(function(item, ind, arr){
       return ind !== arr.lastIndexOf(item);
    });

    if (unique.length) {
        throw new Error('Custom alphabet for shortid must be ' + ORIGINAL.length + ' unique characters. These characters were not unique: ' + unique.join(', '));
    }

    alphabet = _alphabet_;
    reset();
}

function characters(_alphabet_) {
    setCharacters(_alphabet_);
    return alphabet;
}

function setSeed(seed) {
    randomFromSeed.seed(seed);
    if (previousSeed !== seed) {
        reset();
        previousSeed = seed;
    }
}

function shuffle() {
    if (!alphabet) {
        setCharacters(ORIGINAL);
    }

    var sourceArray = alphabet.split('');
    var targetArray = [];
    var r = randomFromSeed.nextValue();
    var characterIndex;

    while (sourceArray.length > 0) {
        r = randomFromSeed.nextValue();
        characterIndex = Math.floor(r * sourceArray.length);
        targetArray.push(sourceArray.splice(characterIndex, 1)[0]);
    }
    return targetArray.join('');
}

function getShuffled() {
    if (shuffled) {
        return shuffled;
    }
    shuffled = shuffle();
    return shuffled;
}

/**
 * lookup shuffled letter
 * @param index
 * @returns {string}
 */
function lookup(index) {
    var alphabetShuffled = getShuffled();
    return alphabetShuffled[index];
}

function get () {
  return alphabet || ORIGINAL;
}

module.exports = {
    get: get,
    characters: characters,
    seed: setSeed,
    lookup: lookup,
    shuffled: getShuffled
};


/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_modal__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isboolean__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isboolean___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_isboolean__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shortid__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shortid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_shortid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__check_props__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utilities_warning_check_app_element_set__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utilities_constants__ = __webpack_require__(2);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable react/prefer-es6-class, jsx-a11y/no-noninteractive-element-interactions */
// Implements the [Modal design pattern](https://lightningdesignsystem.com/components/modals/) in React.
// Based on SLDS v2.2.1




 // ### isBoolean

 // ### shortid
// [npmjs.com/package/shortid](https://www.npmjs.com/package/shortid)
// shortid is a short, non-sequential, url-friendly, unique id generator

 // This component's `checkProps` which issues warnings to developers about properties when in development mode (similar to React's built in development tools)





var propTypes = {
  /**
   * Vertical alignment of Modal.
   */
  align: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['top', 'center']),

  /**
   * Boolean indicating if the appElement should be hidden.
   */
  ariaHideApp: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * **Assistive text for accessibility.**
   * This object is merged with the default props object on every render.
   * * `dialogLabel`: This is a visually hidden label for the dialog. If not provided, `title` is used.
   * * `closeButton`: This is a visually hidden label for the close button.
   */
  assistiveText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    dialogLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    closeButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),

  /**
   * Modal content.
   */
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,

  /**
   * Custom CSS classes for the modal's container. This is the element with `.slds-modal__container`. Use `classNames` [API](https://github.com/JedWatson/classnames).
   */
  containerClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * Custom CSS classes for the modal's body. This is the element that has overflow rules and should be used to set a static height if desired. Use `classNames` [API](https://github.com/JedWatson/classnames).
   */
  contentClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * Custom styles for the modal's body. This is the element that has overflow rules and should be used to set a static height if desired.
   */
  contentStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * If true, modal footer buttons render left and right. An example use case would be for "back" and "next" buttons.
   */
  directional: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * If true, Modals can be dismissed by clicking on the close icon or pressing esc key.
   */
  dismissible: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * If true, Modals can be dismissed by clicking outside of modal. If unspecified, defaults to dismissible.
   */
  dismissOnClickOutside: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Callback to fire with Modal is dismissed
   */
  onRequestClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Accepts a node or array of nodes that are typically a `Button` or `ProgressIndicator`. If an array, the nodes render on the right side first but are then floated left and right if <code>directional</code> prop is `true`.
   */
  footer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]),

  /**
   * Allows for a custom modal header that does not scroll with modal content. If this is defined, `title` and `tagline` will be ignored. The close button will still be present.
   */
  header: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * Adds CSS classes to the container surrounding the modal header and the close button. Use `classNames` [API](https://github.com/JedWatson/classnames).
   */
  headerClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * Forces the modal to be open or closed.
   */
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,

  /**
   * Function whose return value is the mount node to insert the Modal element into. The default is `() => document.body`.
   */
  parentSelector: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Custom CSS classes for the portal DOM node. This node is a direct descendant of the `body` and is the parent of `ReactModal__Overlay`. Use `classNames` [API](https://github.com/JedWatson/classnames).
   */
  portalClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * Styles the modal as a prompt.
   */
  prompt: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['success', 'warning', 'error', 'wrench', 'offline', 'info']),

  /**
   * Specifiies the modal's width. May be deprecated in favor of `width` in the future.
   */
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['medium', 'large']),

  /**
   * Content underneath the title in the modal header.
   */
  tagline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * Text heading at the top of a modal.
   */
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * Allows adding additional notifications within the modal.
   */
  toast: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};
var defaultProps = {
  assistiveText: {
    dialogLabel: '',
    closeButton: 'Close'
  },
  align: 'center',
  ariaHideApp: true,
  dismissible: true
};
/**
 * The Modal component is used for the Lightning Design System Modal and Notification > Prompt components. The Modal opens from a state change outside of the component itself (pass this state to the <code>isOpen</code> prop). For more details on the Prompt markup, please review the <a href="http://www.lightningdesignsystem.com/components/notifications#prompt">Notifications > Prompt</a>.
 *
 * By default, `Modal` will add `aria-hidden=true` to the `body` tag, but this disables some assistive technologies. To prevent this you can add the following to your application with `#mount` being the root node of your application that you would like to hide from assistive technologies when the `Modal` is open.
 * ```
 * import settings from 'design-system-react/components/settings';
 * settings.setAppElement('#mount');
 * ```
 * This component uses a portalMount (a disconnected React subtree mount) to create a modal as a child of `body`.
 */

var Modal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Modal, _React$Component);

  function Modal(props) {
    var _this;

    _classCallCheck(this, Modal);

    _this = _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, props));
    _this.state = {
      isClosing: false
    }; // Bind

    _this.handleModalClick = _this.handleModalClick.bind(_assertThisInitialized(_this));
    _this.closeModal = _this.closeModal.bind(_assertThisInitialized(_this));
    _this.dismissModalOnClickOutside = _this.dismissModalOnClickOutside.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Modal, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.generatedId = __WEBPACK_IMPORTED_MODULE_6_shortid___default.a.generate();
      Object(__WEBPACK_IMPORTED_MODULE_7__check_props__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_10__utilities_constants__["_0" /* MODAL */], this.props);

      if (this.props.ariaHideApp) {
        Object(__WEBPACK_IMPORTED_MODULE_8__utilities_warning_check_app_element_set__["a" /* default */])();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setReturnFocus();
      this.updateBodyScroll();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.isOpen !== prevProps.isOpen) {
        this.updateBodyScroll();
      }

      if (this.state.isClosing !== prevState.isClosing) {
        if (this.state.isClosing) {
          // This section of code should be removed once trigger.jsx
          // and manager.jsx are removed. They appear to have
          // been created in order to do modals in portals.
          if (!this.isUnmounting) {
            var el = __WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.findDOMNode(this); // eslint-disable-line react/no-find-dom-node

            if (el && el.parentNode && el.parentNode.getAttribute('data-slds-modal')) {
              __WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.unmountComponentAtNode(el);
              document.body.removeChild(el);
            }
          }
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.isUnmounting = true;
      this.clearBodyScroll();
    }
  }, {
    key: "getId",
    value: function getId() {
      return this.props.id || this.generatedId;
    }
  }, {
    key: "getModal",
    value: function getModal() {
      var modalStyle = this.props.align === 'top' ? {
        justifyContent: 'flex-start'
      } : null;
      var borderRadius = this.props.title || this.props.header ? {} : {
        borderRadius: '.25rem'
      };
      var contentStyleFromProps = this.props.contentStyle || {};

      var contentStyle = _objectSpread({}, borderRadius, contentStyleFromProps);

      return (// temporarily disabling eslint for the onClicks on the div tags

        /* eslint-disable */
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          "aria-label": this.props.assistiveText.dialogLabel,
          "aria-labelledby": !this.props.assistiveText.dialogLabel && this.props.title ? this.getId() : null,
          className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()({
            'slds-modal': true,
            'slds-fade-in-open': true,
            'slds-modal--large': this.props.size === 'large',
            'slds-modal--prompt': this.isPrompt()
          }),
          onClick: this.dismissModalOnClickOutside,
          role: this.props.dismissible ? 'dialog' : 'alertdialog'
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('slds-modal__container', this.props.containerClassName),
          style: modalStyle
        }, this.headerComponent(), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('slds-modal__content', this.props.contentClassName),
          style: contentStyle,
          onClick: this.handleModalClick
        }, this.props.children), this.footerComponent()))
        /* eslint-enable */

      );
    }
  }, {
    key: "setReturnFocus",
    value: function setReturnFocus() {
      this.setState({
        returnFocusTo: document.activeElement
      });
    } // eslint-disable-next-line class-methods-use-this

  }, {
    key: "clearBodyScroll",
    value: function clearBodyScroll() {
      if (window && document && document.body) {
        document.body.style.overflow = 'inherit';
      }
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      if (this.props.dismissible) {
        this.dismissModal();
      }
    }
  }, {
    key: "dismissModal",
    value: function dismissModal() {
      this.setState({
        isClosing: true
      });

      if (this.state.returnFocusTo && this.state.returnFocusTo.focus) {
        this.state.returnFocusTo.focus();
      }

      if (this.props.onRequestClose) {
        this.props.onRequestClose();
      }
    }
  }, {
    key: "dismissModalOnClickOutside",
    value: function dismissModalOnClickOutside() {
      // if dismissOnClickOutside is not set, default its value to dismissible
      var dismissOnClickOutside = __WEBPACK_IMPORTED_MODULE_5_lodash_isboolean___default()(this.props.dismissOnClickOutside) ? this.props.dismissOnClickOutside : this.props.dismissible;

      if (dismissOnClickOutside) {
        this.dismissModal();
      }
    }
  }, {
    key: "footerComponent",
    value: function footerComponent() {
      var footer = null;
      var hasFooter = this.props.footer;
      var footerClass = {
        'slds-modal__footer': true,
        'slds-modal__footer--directional': this.props.directional,
        'slds-theme--default': this.isPrompt()
      };

      if (hasFooter) {
        footer = // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/no-noninteractive-element-interactions
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("footer", {
          className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(footerClass, this.props.footerClassNames),
          onClick: this.handleModalClick
        }, this.props.footer);
      }

      return footer;
    } // eslint-disable-next-line class-methods-use-this

  }, {
    key: "handleModalClick",
    value: function handleModalClick(event) {
      if (event && event.stopPropagation) {
        event.stopPropagation();
      }
    }
  }, {
    key: "handleSubmitModal",
    value: function handleSubmitModal() {
      this.closeModal();
    }
  }, {
    key: "headerComponent",
    value: function headerComponent() {
      var _classNames;

      var headerContent = this.props.header;
      var headerEmpty = !headerContent && !this.props.title && !this.props.tagline;

      var assistiveText = _objectSpread({}, defaultProps.assistiveText, this.props.assistiveText);

      var closeButtonAssistiveText = this.props.closeButtonAssistiveText || assistiveText.closeButton;
      var closeButton = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__button__["a" /* default */], {
        assistiveText: {
          icon: closeButtonAssistiveText
        },
        iconCategory: "utility",
        iconName: "close",
        iconSize: "large",
        inverse: true,
        className: "slds-modal__close",
        onClick: this.closeModal,
        title: closeButtonAssistiveText,
        variant: "icon"
      });

      if (!headerContent && this.props.title || this.props.tagline) {
        headerContent = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, this.props.toast, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", {
          className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()({
            'slds-text-heading--small': this.isPrompt(),
            'slds-text-heading--medium': !this.isPrompt()
          }),
          id: this.getId()
        }, this.props.title), this.props.tagline ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
          className: "slds-m-top--x-small"
        }, this.props.tagline) : null);
      }

      return (// eslint-disable-next-line jsx-a11y/no-static-element-interactions
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("header", {
          className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('slds-modal__header', (_classNames = {
            'slds-modal__header--empty': headerEmpty
          }, _defineProperty(_classNames, "slds-theme--".concat(this.props.prompt), this.isPrompt()), _defineProperty(_classNames, 'slds-theme--alert-texture', this.isPrompt()), _classNames), this.props.headerClassName),
          onClick: this.handleModalClick
        }, this.props.dismissible ? closeButton : null, headerContent)
      );
    }
  }, {
    key: "isPrompt",
    value: function isPrompt() {
      return this.props.prompt !== undefined;
    }
  }, {
    key: "updateBodyScroll",
    value: function updateBodyScroll() {
      if (window && document && document.body) {
        if (this.props.isOpen) {
          document.body.style.overflow = 'hidden';
        } else {
          document.body.style.overflow = 'inherit';
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var customStyles = {
        content: {
          position: 'default',
          top: 'default',
          left: 'default',
          right: 'default',
          bottom: 'default',
          border: 'default',
          background: 'default',
          overflow: 'default',
          WebkitOverflowScrolling: 'default',
          borderRadius: 'default',
          outline: 'default',
          padding: 'default'
        },
        overlay: {
          zIndex: 8000,
          // following SLDS guideline for z-index overlay
          backgroundColor: 'default'
        }
      };
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_modal___default.a, {
        ariaHideApp: this.props.ariaHideApp,
        contentLabel: "Modal",
        isOpen: this.props.isOpen,
        onRequestClose: this.closeModal,
        style: customStyles,
        parentSelector: this.props.parentSelector,
        portalClassName: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('ReactModalPortal', this.props.portalClassName)
      }, this.getModal(), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "slds-backdrop slds-backdrop--open"
      }));
    }
  }]);

  return Modal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Modal.displayName = __WEBPACK_IMPORTED_MODULE_10__utilities_constants__["_0" /* MODAL */];
Modal.propTypes = propTypes;
Modal.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Modal);
//# sourceMappingURL=index.js.map

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to compose bitmasks for comparison styles. */
var UNORDERED_COMPARE_FLAG = 1,
    PARTIAL_COMPARE_FLAG = 2;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991,
    MAX_INTEGER = 1.7976931348623157e+308,
    NAN = 0 / 0;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object),
    nativeMax = Math.max;

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values ? values.length : 0;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, customizer, bitmask, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = arrayTag,
      othTag = arrayTag;

  if (!objIsArr) {
    objTag = getTag(object);
    objTag = objTag == argsTag ? objectTag : objTag;
  }
  if (!othIsArr) {
    othTag = getTag(other);
    othTag = othTag == argsTag ? objectTag : othTag;
  }
  var objIsObj = objTag == objectTag && !isHostObject(object),
      othIsObj = othTag == objectTag && !isHostObject(other),
      isSameTag = objTag == othTag;

  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
      : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
  }
  if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
}

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
  };
}

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!seen.has(othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
              return seen.add(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, customizer, bitmask, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= UNORDERED_COMPARE_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      objProps = keys(object),
      objLength = objProps.length,
      othProps = keys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = isKey(path, object) ? [path] : castPath(path);

  var result,
      index = -1,
      length = path.length;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result) {
    return result;
  }
  var length = object ? object.length : 0;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity]
 *  The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array ? array.length : 0;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity]
 *  The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = find;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17), __webpack_require__(30)(module)))

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event__ = __webpack_require__(7);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/*
 * Helper function that has callbacks passed into it with the key
 * being the keycode of the event. This allows an object literal to
 * control key event callback mapping and avoids a long conditional
 * if statement and uses an enumeration pattern instead.
 */

var mapKeyEventCallbacks = function mapKeyEventCallbacks(event, _ref) {
  var _ref$callbacks = _ref.callbacks,
      callbacks = _ref$callbacks === void 0 ? {} : _ref$callbacks,
      _ref$shiftCallbacks = _ref.shiftCallbacks,
      shiftCallbacks = _ref$shiftCallbacks === void 0 ? {} : _ref$shiftCallbacks,
      _ref$stopPropagation = _ref.stopPropagation,
      stopPropagation = _ref$stopPropagation === void 0 ? true : _ref$stopPropagation;

  if (event.shiftKey && event.keyCode && shiftCallbacks[event.keyCode]) {
    if (stopPropagation) {
      __WEBPACK_IMPORTED_MODULE_0__event__["a" /* default */].trapEvent(event);
    }

    shiftCallbacks[event.keyCode].callback(event, shiftCallbacks[event.keyCode].data);
  } else if (event.keyCode && callbacks[event.keyCode]) {
    if (stopPropagation) {
      __WEBPACK_IMPORTED_MODULE_0__event__["a" /* default */].trapEvent(event);
    }

    callbacks[event.keyCode].callback(event, callbacks[event.keyCode].data);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (mapKeyEventCallbacks);
//# sourceMappingURL=key-callbacks.js.map

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable import/no-mutable-exports */
// This function will deliver an error message to the browser console when all of the props passed in are undefined (falsey).

var oneOfRequired;

if (false) {
  var hasWarned = {};

  oneOfRequired = function oneOfRequired(control, selectedProps, comment) {
    var additionalComment = comment ? " ".concat(comment) : '';
    var atLeastOnePropIsSet = false;
    var keys = Object.keys(selectedProps);
    keys.forEach(function (key) {
      if (selectedProps[key]) {
        atLeastOnePropIsSet = true;
      }
    });

    if (!hasWarned[control]) {
      /* eslint-disable max-len */
      warning(atLeastOnePropIsSet, "[Design System React] One of the following props are required by ".concat(control, ": [").concat(keys.join(), "].").concat(additionalComment));
      /* eslint-enable max-len */

      hasWarned[control] = !!selectedProps;
    }
  };
} else {
  oneOfRequired = function oneOfRequired() {};
}

/* unused harmony default export */ var _unused_webpack_default_export = (oneOfRequired);
//# sourceMappingURL=one-of-required-property.js.map

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
var DateUtil = {
  firstDayOfMonth: function firstDayOfMonth(date) {
    var newDate = new Date(date);
    newDate.setDate(1);
    return newDate;
  },
  isFirstDayOfMonth: function isFirstDayOfMonth(date) {
    return date.getDate() === 1;
  },
  isLastDayOfMonth: function isLastDayOfMonth(date) {
    return !DateUtil.isSameMonth(date, DateUtil.addDays(date, 1));
  },
  isSameMonth: function isSameMonth(d1, d2) {
    if (!d1 || !d2) {
      return false;
    }

    return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth();
  },
  isSameDay: function isSameDay(d1, d2) {
    if (!d1 || !d2) {
      return false;
    }

    return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
  },
  isCurrentMonth: function isCurrentMonth(date) {
    if (!date) {
      return false;
    }

    return DateUtil.isSameMonth(date, new Date());
  },
  isToday: function isToday(date) {
    if (!date) {
      return false;
    }

    return DateUtil.isSameDay(date, new Date());
  },
  isEqual: function isEqual(d1, d2) {
    return d1.getTime() === d2.getTime();
  },
  addDays: function addDays(date, deltaDays) {
    var newDate = new Date(date);
    newDate.setDate(newDate.getDate() + parseInt(deltaDays, 10));
    return newDate;
  },
  addWeeks: function addWeeks(date, deltaWeeks) {
    return DateUtil.addDays(date, parseInt(deltaWeeks, 10) * 7);
  },
  nearestWeekDay: function nearestWeekDay(date, weekDayIndex) {
    var delta = weekDayIndex - date.getDay();

    if (delta < 0) {
      delta += 7;
    }

    return DateUtil.addDays(date, delta);
  },
  isLeapYear: function isLeapYear(year) {
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
  },
  getDaysInMonth: function getDaysInMonth(year, month) {
    return [31, DateUtil.isLeapYear(year) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
  },
  addMonths: function addMonths(date, value) {
    var newDate = new Date(date);
    var dateOfNewDate = newDate.getDate();
    newDate.setDate(1);
    newDate.setMonth(newDate.getMonth() + value);
    newDate.setDate(Math.min(dateOfNewDate, DateUtil.getDaysInMonth(newDate.getFullYear(), newDate.getMonth())));
    return newDate;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (DateUtil);
//# sourceMappingURL=date.js.map

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shortid__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shortid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_shortid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isboolean__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isboolean___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isboolean__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__private_toggle_button__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_constants__ = __webpack_require__(2);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */







var propTypes = {
  /**
   * **Assistive text for accessibility**
   * * `toggleButtonOpen`: The button used to open the split view.
   * * `toggleButtonClose`: The button used to close the split view.
   */
  assistiveText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    toggleButtonOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    toggleButtonClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),

  /**
   * HTML Id for the component.
   */
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * CSS classes to be added to the root `div` tag. Uses `classNames` [API](https://github.com/JedWatson/classnames).
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * Sets the split view to be open or closed.
   */
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Event Callbacks
   * * `onClose`: Triggered when the split view has closed.
   * * `onOpen`: Triggered when the split view has opened.
   */
  events: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    onOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  }),

  /**
   * The React component that is rendered in the master section.
   * You need to pass in an array of elements in order for the scrolling to in the SplitViewList to work correctly.
   * React requires that you also supply a unique `key` for each element [React Lists and Keys](https://reactjs.org/docs/lists-and-keys.html#keys).
   */
  master: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element]).isRequired,

  /**
   * The width of the master section.
   */
  masterWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * The React component that is rendered in the detail section.
   */
  detail: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element]).isRequired
};
var defaultProps = {
  assistiveText: {
    toggleButtonOpen: 'Close split view',
    toggleButtonClose: 'Open split view'
  },
  events: {},
  masterWidth: '20rem'
};
/**
 * Split view is used to navigate between records in a list while staying on the same screen.
 */

var SplitView =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SplitView, _React$Component);

  function SplitView(props) {
    var _this;

    _classCallCheck(this, SplitView);

    _this = _possibleConstructorReturn(this, (SplitView.__proto__ || Object.getPrototypeOf(SplitView)).call(this, props));
    _this.state = {
      isOpen: true
    };
    return _this;
  }

  _createClass(SplitView, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.generatedId = __WEBPACK_IMPORTED_MODULE_2_shortid___default.a.generate();
      this.setIsOpen(this.props.isOpen);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.isOpen !== this.props.isOpen) {
        this.setIsOpen(nextProps.isOpen);
      }
    }
  }, {
    key: "getId",
    value: function getId() {
      return this.props.id || this.generatedId;
    }
  }, {
    key: "getMasterViewId",
    value: function getMasterViewId() {
      return "master_view_".concat(this.getId());
    }
  }, {
    key: "setIsOpen",
    value: function setIsOpen(isOpen) {
      if (__WEBPACK_IMPORTED_MODULE_4_lodash_isboolean___default()(isOpen)) {
        this.setState({
          isOpen: isOpen
        });
      }
    }
  }, {
    key: "toggle",
    value: function toggle(event) {
      this.setIsOpen(!this.state.isOpen);

      if (this.state.isOpen && this.props.events.onClose) {
        this.props.events.onClose(event);
      } else if (!this.state.isOpen && this.props.events.onOpen) {
        this.props.events.onOpen(event);
      }
    }
  }, {
    key: "masterContent",
    value: function masterContent() {
      return this.state.isOpen ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("article", {
        id: this.getMasterViewId(),
        className: "slds-split-view slds-grid slds-grid_vertical slds-grow slds-scrollable_none"
      }, this.props.master) : null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        id: this.getId(),
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('slds-grid', this.props.className),
        style: {
          height: '100%'
        }
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        style: {
          maxWidth: this.state.isOpen ? this.props.masterWidth : '0'
        },
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('slds-split-view_container', {
          'slds-is-open': this.state.isOpen
        }, {
          'slds-is-closed': !this.state.isOpen
        })
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__private_toggle_button__["b" /* default */], {
        assistiveText: this.props.assistiveText,
        ariaControls: this.getMasterViewId(),
        isOpen: this.state.isOpen,
        events: {
          onClick: function onClick(event) {
            return _this2.toggle(event);
          }
        }
      }), this.masterContent()), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        style: {
          marginLeft: __WEBPACK_IMPORTED_MODULE_5__private_toggle_button__["a" /* TOGGLE_BUTTON_WIDTH */]
        },
        className: "slds-grow slds-scrollable_y"
      }, this.props.detail));
    }
  }]);

  return SplitView;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Object.defineProperty(SplitView, "displayName", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: __WEBPACK_IMPORTED_MODULE_6__utilities_constants__["_19" /* SPLIT_VIEW */]
});
Object.defineProperty(SplitView, "propTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: propTypes
});
Object.defineProperty(SplitView, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: defaultProps
});
/* unused harmony default export */ var _unused_webpack_default_export = (SplitView);
//# sourceMappingURL=index.js.map

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_transition_group__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__salesforce_design_system_react__ = __webpack_require__(18);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var propTypes={pause:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,recap:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,nextLabel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,nextFunc:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};var RecapContainer=function(_Component){_inherits(RecapContainer,_Component);function RecapContainer(props){_classCallCheck(this,RecapContainer);var _this=_possibleConstructorReturn(this,(RecapContainer.__proto__||Object.getPrototypeOf(RecapContainer)).call(this,props));_this.state={showRecap:true};_this.summaryTitle=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();return _this;}_createClass(RecapContainer,[{key:'componentDidMount',value:function componentDidMount(){this.summaryTitle.current.focus();}},{key:'renderPause',value:function renderPause(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'pbl'},'Before we continue...'),this.props.pause,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__salesforce_design_system_react__["c" /* Button */],{className:'mvl',label:'What was this step all about?',onClick:function onClick(){_this2.setState({showRecap:true});},variant:'neutral'}));}},{key:'renderRecap',value:function renderRecap(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{tabIndex:'-1',ref:this.summaryTitle,className:'pal bg-recap no-focus-halo'},'Summary: ',this.props.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pal'},this.props.recap,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__salesforce_design_system_react__["c" /* Button */],{className:'mvl',label:this.props.nextLabel,onClick:this.props.nextFunc,variant:'neutral'})));}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'bg-darkblue recap-container','aria-label':'Summary: '+this.props.title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_transition_group__["CSSTransitionGroup"],{transitionName:'recap',transitionAppear:true,transitionEnter:true,transitionLeave:false,transitionAppearTimeout:500,transitionEnterTimeout:500},this.state.showRecap?this.renderRecap():this.renderPause()));}}]);return RecapContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);RecapContainer.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (RecapContainer);

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_modal__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_modal__);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/*
 * The following are component utility methods that aid in global settings.
*/

var assetsPath = 'assets/';
var appRoot;
var settings = {
  setAssetsPath: function setAssetsPath(path) {
    if (path) {
      assetsPath = path;
    }
  },
  getAssetsPath: function getAssetsPath() {
    return String(assetsPath);
  },

  /*
   * The app element allows you to specify the portion of your app that should be hidden (via aria-hidden)
  to prevent assistive technologies such as screenreaders from reading content outside of the content of
  your modal.  It can be specified in the following ways:
   * element
  Modal.setAppElement(appElement);
   * query selector - uses the first element found if you pass in a class.
  Modal.setAppElement('#your-app-element');
  */
  setAppElement: function setAppElement(el) {
    if (el) {
      appRoot = el;
      __WEBPACK_IMPORTED_MODULE_0_react_modal___default.a.setAppElement(el);
    }
  },
  getAppElement: function getAppElement() {
    return appRoot;
  }
};
/* unused harmony default export */ var _unused_webpack_default_export = (settings);
//# sourceMappingURL=settings.js.map

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_constants__ = __webpack_require__(2);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */



/**
 * The Icon Settings component allows for the path to the icons to be specified in all child components and is recommended to be used at the root of the application. It's render function is `return this.props.children`, so it can only have one child node.
 *
 * **Individual sprites**
 * If you are using webpack it is advised to use the sprite properties
 * {actionSprite, standardSprite...} to specify the individual sprite paths so that webpack can
 * easily re-write the paths.
 * ```
 * import actionSprite from '......';
 *
 * <IconSettings actionSprite={actionSprite} ......>
 * ```
 * **Root icon path**
 * Otherwise use the iconPath to specify the root path to where the icon files will be located in you application
 * such as `/assets/icons`.
 */

var IconSettings =
/*#__PURE__*/
function (_React$Component) {
  _inherits(IconSettings, _React$Component);

  function IconSettings() {
    _classCallCheck(this, IconSettings);

    return _possibleConstructorReturn(this, (IconSettings.__proto__ || Object.getPrototypeOf(IconSettings)).apply(this, arguments));
  }

  _createClass(IconSettings, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        iconPath: this.props.iconPath,
        actionSprite: this.props.actionSprite,
        customSprite: this.props.customSprite,
        doctypeSprite: this.props.doctypeSprite,
        standardSprite: this.props.standardSprite,
        utilitySprite: this.props.utilitySprite
      };
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);

  return IconSettings;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

IconSettings.displayName = __WEBPACK_IMPORTED_MODULE_2__utilities_constants__["P" /* ICON_SETTINGS */];
IconSettings.childContextTypes = {
  iconPath: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  actionSprite: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  customSprite: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  doctypeSprite: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  standardSprite: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  utilitySprite: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
IconSettings.propTypes = {
  /**
   * Path to the root icon folder
   * example: `/assets/icons`
   */
  iconPath: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Path to the action sprite
   * example: '@salesforce-ux/design-system/assets/icons/action-sprite/svg/symbols.svg';
   */
  actionSprite: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Path to the custom sprite
   * example: '@salesforce-ux/design-system/assets/icons/custom-sprite/svg/symbols.svg';
   */
  customSprite: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Path to the doctype sprite
   * example: '@salesforce-ux/design-system/assets/icons/doctype-sprite/svg/symbols.svg';
   */
  doctypeSprite: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Path to the standard sprite
   * example: '@salesforce-ux/design-system/assets/icons/standard-sprite/svg/symbols.svg';
   */
  standardSprite: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Path to the utility sprite
   * example: '@salesforce-ux/design-system/assets/icons/utility-sprite/svg/symbols.svg';
   */
  utilitySprite: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
/* harmony default export */ __webpack_exports__["a"] = (IconSettings);
//# sourceMappingURL=index.js.map

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tabbable__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__key_code__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__execution_environment__ = __webpack_require__(197);



var ancestor = null;
var focusLaterElement = null;

var handleScopedKeyDown = function handleScopedKeyDown(event) {
  if (!__WEBPACK_IMPORTED_MODULE_2__execution_environment__["a" /* canUseDOM */] || !ancestor || event.keyCode !== __WEBPACK_IMPORTED_MODULE_1__key_code__["a" /* default */].TAB) {
    return;
  }

  var tabbableElements = Object(__WEBPACK_IMPORTED_MODULE_0__tabbable__["a" /* default */])(ancestor);
  var finalTabbable = tabbableElements[event.shiftKey ? 0 : tabbableElements.length - 1];
  var leavingFinalTabbable = finalTabbable === document.activeElement || // handle immediate shift+tab after opening with mouse
  ancestor === document.activeElement;
  if (!leavingFinalTabbable) return;
  event.preventDefault();
  var target = tabbableElements[event.shiftKey ? tabbableElements.length - 1 : 0];
  target.focus();
}; // PUBLIC methods


var ElementFocus = {
  focusAncestor: function focusAncestor() {
    if (__WEBPACK_IMPORTED_MODULE_2__execution_environment__["a" /* canUseDOM */]) {
      ancestor.focus();
    }
  },
  hasOrAncestorHasFocus: function hasOrAncestorHasFocus() {
    return __WEBPACK_IMPORTED_MODULE_2__execution_environment__["a" /* canUseDOM */] && (document.activeElement === ancestor || ancestor.contains(document.activeElement));
  },
  returnFocusToStoredElement: function returnFocusToStoredElement() {
    if (__WEBPACK_IMPORTED_MODULE_2__execution_environment__["a" /* canUseDOM */]) {
      try {
        focusLaterElement.focus();
      } catch (e) {
        // eslint-disable-next-line no-console
        console.warn("You tried to return focus to ".concat(focusLaterElement, " but it is not in the DOM anymore"));
      }

      focusLaterElement = null;
    }
  },
  setupScopedFocus: function setupScopedFocus(_ref) {
    var ancestorElement = _ref.ancestorElement;
    ancestor = ancestorElement;
    window.addEventListener('keydown', handleScopedKeyDown, false);
  },
  storeActiveElement: function storeActiveElement() {
    focusLaterElement = __WEBPACK_IMPORTED_MODULE_2__execution_environment__["a" /* canUseDOM */] ? document.activeElement : null;
  },
  teardownScopedFocus: function teardownScopedFocus() {
    ancestor = null;

    if (__WEBPACK_IMPORTED_MODULE_2__execution_environment__["a" /* canUseDOM */]) {
      window.removeEventListener('keydown', handleScopedKeyDown);
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (ElementFocus);
//# sourceMappingURL=dom-element-focus.js.map

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable import/no-mutable-exports */


var hasMoved = function hasMoved() {};

if (false) {
  var hasWarned = {};

  hasMoved = function hasMoved(control, _ref) {
    var oldFileLocation = _ref.oldFileLocation,
        newFileLocation = _ref.newFileLocation,
        comment = _ref.comment;
    var additionalComment = comment ? " ".concat(comment) : '';

    if (!hasWarned[control]) {
      /* eslint-disable max-len */
      warning(false, "[Design System React] ".concat(control, " file import path has changed. Old import path was `design-system-react/").concat(oldFileLocation, "`. New import path is `design-system-react/").concat(newFileLocation, "`.").concat(additionalComment));
      /* eslint-enable max-len */

      hasWarned[control] = true;
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (hasMoved);
//# sourceMappingURL=component-has-moved.js.map

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_constants__ = __webpack_require__(2);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// ### React
// React is an external dependency of the project.



/**
 * A default empty state for Cards.
 */

var CardEmpty = function CardEmpty(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "slds-p-horizontal--small"
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "slds-text-align--center slds-m-bottom--x-large"
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3", {
    className: "slds-text-heading--small slds-p-top--large slds-p-bottom--large"
  }, props.heading), props.children));
}; // ### Display Name
// Always use the canonical component name as the React display name.


CardEmpty.displayName = __WEBPACK_IMPORTED_MODULE_2__utilities_constants__["n" /* CARD_EMPTY */]; // ### Prop Types

CardEmpty.propTypes = {
  /**
   * Additional call to actions that will render under the heading. Often this is an "Add Item" button.
   */
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * Primary text for an Empty Card.
   */
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
CardEmpty.defaultProps = {
  heading: 'No Related Items'
};
/* harmony default export */ __webpack_exports__["a"] = (CardEmpty);
//# sourceMappingURL=empty.js.map

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__check_props__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_constants__ = __webpack_require__(2);
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// # Spinner Component --- SLDS for React
// Implements the [Spinner design pattern - 2.1.0-beta.3 (204)](https://latest-204.lightningdesignsystem.com/components/spinners) in React.
// ### React



 // ## Constants

 // ### Prop Types

var propTypes = {
  /**
   * **Assistive text for accessibility.**
   * This object is merged with the default props object on every render.
   * * `label`: Assistive text that is read out loud to screen readers.
   */
  assistiveText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),

  /**
   * Custom css classes applied to Spinner container
   */
  containerClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Unique html id placed on div with role="status".
   */
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Add styling to support a spinner inside an input field.
   */
  isInput: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Determines the size of the spinner
   */
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['x-small', 'small', 'medium', 'large']),

  /**
   * Determines the color of the spinner: `base` is gray, `brand` is blue, and `inverse` is white.
   */
  variant: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['base', 'brand', 'inverse'])
};
var defaultProps = {
  assistiveText: {
    label: 'Loading...'
  },
  size: 'medium',
  variant: 'base'
};
/**
 * Spinners are CSS loading indicators that should be shown when retrieving data or performing slow computations. In some cases, the first time a parent component loads, a stencil is preferred to indicate network activity.
 */

var Spinner = function Spinner(props) {
  Object(__WEBPACK_IMPORTED_MODULE_3__check_props__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__utilities_constants__["_18" /* SPINNER */], props);
  var containerClassName = props.containerClassName,
      id = props.id,
      isInput = props.isInput,
      size = props.size,
      variant = props.variant;
  var assistiveText = typeof props.assistiveText === 'string' ? props.assistiveText : _objectSpread({}, defaultProps.assistiveText, props.assistiveText).label;
  var spinnerClassName = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('slds-spinner', _defineProperty({
    'slds-input__spinner': isInput,
    'slds-spinner_brand': variant === 'brand',
    'slds-spinner_inverse': variant === 'inverse'
  }, "slds-spinner_".concat(size), size));
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(containerClassName, 'slds-spinner_container')
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    "aria-hidden": "false",
    className: spinnerClassName,
    id: id,
    role: "status"
  }, assistiveText && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "slds-assistive-text"
  }, assistiveText), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "slds-spinner__dot-a"
  }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "slds-spinner__dot-b"
  })));
};

Spinner.displayName = __WEBPACK_IMPORTED_MODULE_4__utilities_constants__["_18" /* SPINNER */];
Spinner.propTypes = propTypes;
Spinner.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Spinner);
//# sourceMappingURL=index.js.map

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable import/no-mutable-exports */
// This function will deliver an warning message to the browser console if extraneous properties are defined (falsey).


var onlyOneOf = function onlyOneOf() {};

if (false) {
  var hasWarned = {};

  onlyOneOf = function onlyOneOf(control, selectedProps, comment) {
    var additionalComment = comment ? " ".concat(comment) : '';
    var keys = Object.keys(selectedProps);
    keys = keys.filter(function (key) {
      return selectedProps[key];
    });

    if (!hasWarned[control]) {
      /* eslint-disable max-len */
      warning(keys.length <= 1, "[Design System React] Only one of the following props is needed by ".concat(control, ": [").concat(keys.join(), "].").concat(additionalComment));
      /* eslint-enable max-len */

      hasWarned[control] = !!selectedProps;
    }
  };
}

/* unused harmony default export */ var _unused_webpack_default_export = (onlyOneOf);
//# sourceMappingURL=only-one-of-properties.js.map

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shortid__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shortid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shortid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_key_code__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_event__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__check_props__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utilities_constants__ = __webpack_require__(2);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// # Checkbox Component
// Implements the [Checkbox design pattern](https://www.lightningdesignsystem.com/components/forms/#checkbox) in React.


 // ### shortid
// [npmjs.com/package/shortid](https://www.npmjs.com/package/shortid)
// shortid is a short, non-sequential, url-friendly, unique id generator

 // ### Event Helpers


 // This component's `checkProps` which issues warnings to developers about properties when in development mode (similar to React's built in development tools)



var propTypes = {
  /**
   * An HTML ID that is shared with ARIA-supported devices with the
   * `aria-controls` attribute in order to relate the input with
   * another region of the page. An example would be a select box
   * that shows or hides a panel.
   */
  'aria-controls': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * The `aria-describedby` attribute is used to indicate the IDs of the elements that describe the object. It is used to establish a relationship between widgets or groups and text that described them. This is very similar to aria-labelledby: a label describes the essence of an object, while a description provides more information that the user might need.
   */
  'aria-describedby': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * `aria-owns` indicate that an element depends on the current one when the relation can't be determined by the hierarchy structure.
   */
  'aria-owns': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * The `aria-required` attribute is used to indicate that user input is required on an element before a form can be submitted.
   */
  'aria-required': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * **Assistive text for accessibility**
   * This object is merged with the default props object on every render.
   * * `label`: This is used as a visually hidden label if, no `labels.label` is provided.
   */
  assistiveText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),

  /**
   * The Checkbox should be a controlled component, and will always be in the state specified. If checked is not defined, the state of the uncontrolled native `input` component will be used.
   */
  checked: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * This is the initial value of an uncontrolled form element and is present only
   * to provide compatibility with hybrid framework applications that are not
   * entirely React. It should only be used in an application without centralized
   * state (Redux, Flux). "Controlled components" with centralized state is highly recommended. See [Code Overview](https://github.com/salesforce/design-system-react/blob/master/docs/codebase-overview.md#controlled-and-uncontrolled-components) for more information.
   */
  defaultChecked: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Class names to be added to the outer container of the Checkbox.
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * Disables the Checkbox and prevents clicking it.
   */
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Message to display when the Checkbox is in an error state. When this is present, also visually highlights the component as in error.
   */
  errorText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * A unique ID is needed in order to support keyboard navigation and ARIA support. This ID is added to the `input` element
   */
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * The Checkbox will be indeterminate if its state can not be figured out or is partially checked. Once a checkbox is indeterminate, a click should cause it to be checked. Since a user cannot put a checkbox into an indeterminate state, it is assumed you are controlling the value of `checked` with the parent, also, and that this is a controlled component. **Note:** `indeterminate` proptype does nothing in the `toggle` variant, as [SLDS does not support it](https://lightningdesignsystem.com/components/forms/#flavor-checkbox-toggle-checkbox-toggle).
   */
  indeterminate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * **Text labels for internationalization**
   * This object is merged with the default props object on every render.
   * * `label`: Label for the _enabled_ state of the Toggle variant. Defaults to "Enabled".
   * * `toggleDisabled`: Label for the _disabled_ state of the Toggle variant. Defaults to "Disabled". Note that this uses SLDS language, and meaning, of "Enabled" and "Disabled"; referring to the state of whatever the checkbox is _toggling_, not whether the checkbox itself is enabled or disabled.
   * * `toggleEnabled`: Label for the _enabled_ state of the Toggle variant. Defaults to "Enabled".
   */
  labels: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    toggleDisabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    toggleEnabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),

  /**
   * Name of the submitted form parameter.
   */
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * This event fires when the Checkbox looses focus. It passes in `{ event }`.
   */
  onBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * This event fires when the Checkbox changes. Passes in `event, { checked }`. This used to be `checked, event, { checked }`.
   */
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * This event fires when the Checkbox is focused. It passes in `{ event }`.
   */
  onFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * This event fires when a key is pressed down. It passes in `{ event }`.
   */
  onKeyDown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * This event fires when a character is typed. See [this article](http://www.bloggingdeveloper.com/post/KeyPress-KeyDown-KeyUp-The-Difference-Between-Javascript-Key-Events.aspx) for more information. It passes in `{ event }`.
   */
  onKeyPress: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * This event fires when a pressed key is released. It passes in `{ event }`.
   */
  onKeyUp: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Displays the value of the input, but does not allow changes.
   */
  readOnly: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Highlights the Checkbox as a required field (does not perform any validation).
   */
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * The aria-role of the checkbox.
   */
  role: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Which UX pattern of checkbox? The default is `base` while other option is `toggle`. (**Note:** `toggle` variant does not support the `indeterminate` feature, because [SLDS does not support it](https://lightningdesignsystem.com/components/forms/#flavor-checkbox-toggle-checkbox-toggle).)
   */
  variant: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['base', 'toggle', 'button-group'])
};
var defaultProps = {
  assistiveText: {},
  labels: {
    toggleDisabled: 'Disabled',
    toggleEnabled: 'Enabled'
  },
  variant: 'base'
};
/**
 * The ability to style checkboxes with CSS varies across browsers. Using this component ensures checkboxes look the same everywhere.
 */

var Checkbox =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Checkbox, _React$Component);

  function Checkbox() {
    var _ref;

    var _temp, _this;

    _classCallCheck(this, Checkbox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_ref = Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call.apply(_ref, [this].concat(args))), Object.defineProperty(_assertThisInitialized(_this), "getId", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.id || _this.generatedId;
      }
    }), Object.defineProperty(_assertThisInitialized(_this), "handleChange", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(event) {
        var _this$props = _this.props,
            checked = _this$props.checked,
            indeterminate = _this$props.indeterminate,
            onChange = _this$props.onChange;

        if (typeof onChange === 'function') {
          // `target.checked` is present twice to maintain backwards compatibility. Please remove first parameter `value` on the next breaking change or when `forms/checkbox` is removed.
          if (_this.props.oldEventParameterOrder) {
            onChange(event.target.checked, event, {
              checked: indeterminate ? true : !checked,
              indeterminate: false
            });
          } else {
            // NEW API
            onChange(event, {
              checked: indeterminate ? true : !checked,
              indeterminate: false
            });
          }
        }
      }
    }), Object.defineProperty(_assertThisInitialized(_this), "handleKeyDown", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(event) {
        if (event.keyCode) {
          if (event.keyCode === __WEBPACK_IMPORTED_MODULE_4__utilities_key_code__["a" /* default */].ENTER || event.keyCode === __WEBPACK_IMPORTED_MODULE_4__utilities_key_code__["a" /* default */].SPACE) {
            __WEBPACK_IMPORTED_MODULE_5__utilities_event__["a" /* default */].trapImmediate(event);

            _this.handleChange(event);
          }
        }
      }
    }), Object.defineProperty(_assertThisInitialized(_this), "renderButtonGroupVariant", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(props, assistiveText, labels) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
          className: "slds-button slds-checkbox--button"
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
          "aria-controls": _this.props['aria-controls'],
          "aria-describedby": _this.props['aria-describedby'],
          "aria-owns": _this.props['aria-owns'],
          "aria-required": _this.props['aria-required'],
          disabled: props.disabled,
          checked: props.checked,
          defaultChecked: props.defaultChecked,
          id: _this.getId(),
          name: props.name,
          onBlur: props.onBlur,
          onChange: _this.handleChange,
          onFocus: props.onFocus,
          onKeyDown: props.onKeyDown,
          onKeyPress: props.onKeyPress,
          onKeyUp: props.onKeyUp,
          ref: function ref(component) {
            _this.input = component;
          },
          role: props.role,
          required: props.required,
          type: "checkbox"
        }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", {
          className: "slds-checkbox--button__label",
          htmlFor: _this.getId()
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
          className: "slds-checkbox--faux"
        }, labels.label), assistiveText.label ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
          className: "slds-assistive-text"
        }, assistiveText.label) : null));
      }
    }), Object.defineProperty(_assertThisInitialized(_this), "renderBaseVariant", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(props, assistiveText, labels) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('slds-form-element', {
            'is-required': props.required,
            'slds-has-error': props.errorText
          }, props.className)
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          className: "slds-form-element__control"
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
          className: "slds-checkbox"
        }, props.required ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("abbr", {
          className: "slds-required",
          title: "required"
        }, "*") : null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
          "aria-controls": _this.props['aria-controls'],
          "aria-describedby": _this.props['aria-describedby'],
          "aria-owns": _this.props['aria-owns'],
          "aria-required": _this.props['aria-required'],
          disabled: props.disabled,
          checked: props.checked,
          defaultChecked: props.defaultChecked,
          id: _this.getId(),
          name: props.name,
          onBlur: props.onBlur,
          onChange: _this.handleChange,
          onFocus: props.onFocus,
          onKeyDown: props.onKeyDown,
          onKeyPress: props.onKeyPress,
          onKeyUp: props.onKeyUp,
          ref: function ref(component) {
            if (component) {
              component.indeterminate = props.indeterminate;
            }

            _this.input = component;
          },
          role: props.role,
          required: props.required,
          type: "checkbox"
        }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", {
          className: "slds-checkbox__label",
          htmlFor: _this.getId()
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
          className: "slds-checkbox--faux"
        }), labels.label ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
          className: "slds-form-element__label"
        }, labels.label) : null, assistiveText.label ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
          className: "slds-assistive-text"
        }, assistiveText.label) : null))), props.errorText ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          className: "slds-form-element__help"
        }, props.errorText) : null);
      }
    }), Object.defineProperty(_assertThisInitialized(_this), "renderToggleVariant", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(props, assistiveText, labels) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('slds-form-element', {
            'is-required': props.required,
            'slds-has-error': props.errorText
          }, props.className)
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", {
          className: "slds-checkbox--toggle slds-grid",
          htmlFor: _this.getId()
        }, props.required ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("abbr", {
          className: "slds-required",
          title: "required"
        }, "*") : null, labels.label ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
          className: "slds-form-element__label slds-m-bottom--none"
        }, labels.label) : null, assistiveText.label ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
          className: "slds-assistive-text"
        }, assistiveText.label) : null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
          "aria-controls": _this.props['aria-controls'],
          "aria-describedby": "".concat(_this.getId(), "-desc"),
          "aria-owns": _this.props['aria-owns'],
          "aria-required": _this.props['aria-required'],
          disabled: props.disabled,
          id: _this.getId(),
          checked: props.checked,
          defaultChecked: props.defaultChecked,
          name: props.name,
          onBlur: props.onBlur,
          onChange: _this.handleChange,
          onFocus: props.onFocus,
          onKeyDown: props.onKeyDown,
          onKeyPress: props.onKeyPress,
          onKeyUp: props.onKeyUp,
          ref: function ref(component) {
            _this.input = component;
          },
          role: props.role,
          required: props.required,
          type: "checkbox"
        }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
          id: "".concat(_this.getId(), "-desc"),
          className: "slds-checkbox--faux_container",
          "aria-live": "assertive"
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
          className: "slds-checkbox--faux"
        }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
          className: "slds-checkbox--on"
        }, labels.toggleEnabled), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
          className: "slds-checkbox--off"
        }, labels.toggleDisabled))), props.errorText ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          className: "slds-form-element__help"
        }, props.errorText) : null);
      }
    }), _temp));
  }

  _createClass(Checkbox, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      Object(__WEBPACK_IMPORTED_MODULE_6__check_props__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_7__utilities_constants__["r" /* CHECKBOX */], this.props);
      this.generatedId = __WEBPACK_IMPORTED_MODULE_3_shortid___default.a.generate();
    }
  }, {
    key: "render",
    value: function render() {
      var assistiveText = _objectSpread({}, defaultProps.assistiveText, typeof this.props.assistiveText === 'string' ? {
        label: this.props.assistiveText
      } : {}, _typeof(this.props.assistiveText) === 'object' ? this.props.assistiveText : {});

      var labels = _objectSpread({}, defaultProps.labels, this.props.label ? {
        label: this.props.label
      } : {}, this.props.labels);

      var subRenders = {
        base: this.renderBaseVariant,
        'button-group': this.renderButtonGroupVariant,
        toggle: this.renderToggleVariant
      };
      var variantExists = subRenders[this.props.variant];
      return variantExists ? subRenders[this.props.variant](this.props, assistiveText, labels) : subRenders.base(this.props, assistiveText, labels);
    }
  }]);

  return Checkbox;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Checkbox.displayName = __WEBPACK_IMPORTED_MODULE_7__utilities_constants__["r" /* CHECKBOX */];
Checkbox.propTypes = propTypes;
Checkbox.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Checkbox);
//# sourceMappingURL=index.js.map

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable import/no-mutable-exports */
var lowPriorityWarning = function lowPriorityWarning() {};

if (false) {
  var printWarning = function printWarning(originalMessage) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = "Warning: ".concat(originalMessage.replace(/%s/g, function () {
      var argument = args[argIndex];
      argIndex += 1;
      return argument;
    }));

    if (typeof console !== 'undefined') {
      console.warn(message); // eslint-disable-line no-console
    }

    try {
      // Throw error to enable tracing the callstack.
      throw new Error(message);
    } catch (event) {} // eslint-disable-line no-empty

  };

  lowPriorityWarning = function lowPriorityWarning(condition, originalMessage) {
    if (!condition && originalMessage) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(void 0, [originalMessage].concat(args));
    }
  };
}

/* unused harmony default export */ var _unused_webpack_default_export = (lowPriorityWarning);
//# sourceMappingURL=low-priority-warning.js.map

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_utility_icon__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_key_code__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_event__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__check_props__ = __webpack_require__(221);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// # Pill Component
// Implements the [Pill design pattern](https://lightningdesignsystem.com/components/pills/) in React.






 // This component's `checkProps` which issues warnings to developers about properties when in development mode (similar to React's built in development tools)


var propTypes = {
  /**
   * **Assistive text for accessibility**
   * This object is merged with the default props object on every render.
   * * `remove`: This is a visually hidden label for the close button.
   * _Tested with snapshot testing._
   */
  assistiveText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    remove: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),

  /**
   * SLDSAvatar component to show on the left of the pill.
   * _Tested with Mocha framework._
   */
  avatar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,

  /**
   * Applies the bare style to the component.
   * _Tested with Mocha framework._
   */
  bare: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * This is a way to specify custom contents for the pill in the case a simple text label is not enough.
   * _Tested with Mocha framework._
   */
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * CSS classes to be added to tag with `.slds-pill`. Uses `classNames` [API](https://github.com/JedWatson/classnames).
   * _Tested with Mocha framework._
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * Applies the error style to the component.
   * _Tested with Mocha framework._
   */
  hasError: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * An href to use if the pill is shown as a link.
   * _Tested with Mocha framework._
   */
  href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * SLDSIcon component to show on the left of the pill.
   * _Tested with Mocha framework._
   */
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,

  /**
   * **Text labels for internationalization**
   * This object is merged with the default props object on every render.
   * * `label`: Pill's label.
   * * `title`: Pill's title.
   * * `removeTitle`: A title to use for the remove icon.
   *
   * _Tested with snapshot testing._
   */
  labels: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    removeTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),

  /**
   * `onBlur` callback executes when the component loses focus.
   * _Tested with Mocha framework._
   */
  onBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * `onClick` callback executes when a user clicks on the pill or presses the Enter key.
   * _Tested with Mocha framework._
   */
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * `onFocus` callback executes when the component receives focus.
   * _Tested with Mocha framework._
   */
  onFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * `onKeyDown` callback executes when a user presses a key.
   * _Tested with Mocha framework._
   */
  onKeyDown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * `onRemove` callback executes when a user clicks on the pill's remove icon or presses the delete or the backspace keys.
   * _Tested with Mocha framework._
   */
  onRemove: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * A variant of a pill
   * _Tested with Mocha framework._
   */
  variant: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['link', 'option'])
};
/**
 * A pill represents an object that can be viewed with or without an icon.
 */

var Pill =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Pill, _React$Component);

  function Pill() {
    var _ref;

    var _temp, _this;

    _classCallCheck(this, Pill);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_ref = Pill.__proto__ || Object.getPrototypeOf(Pill)).call.apply(_ref, [this].concat(args))), Object.defineProperty(_assertThisInitialized(_this), "getHref", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        return typeof _this.props.href === 'string' ? _this.props.href : 'javascript:void(0);';
      }
    }), Object.defineProperty(_assertThisInitialized(_this), "blur", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        _this.root.blur();
      }
    }), Object.defineProperty(_assertThisInitialized(_this), "focus", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        _this.root.focus();
      }
    }), Object.defineProperty(_assertThisInitialized(_this), "handleKeyDown", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(event) {
        if (typeof _this.props.onKeyDown === 'function') {
          var _this$props$onKeyDown;

          for (var _len2 = arguments.length, rest = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            rest[_key2 - 1] = arguments[_key2];
          }

          // Make a callback to onKeyDown.
          (_this$props$onKeyDown = _this.props.onKeyDown).call.apply(_this$props$onKeyDown, [null, event].concat(rest)); // Cancel further handling if the default handling for the event was prevented.


          if (event.defaultPrevented) {
            return;
          }
        }

        switch (event.keyCode) {
          case __WEBPACK_IMPORTED_MODULE_5__utilities_key_code__["a" /* default */].ENTER:
            if (typeof _this.props.onClick === 'function') {
              __WEBPACK_IMPORTED_MODULE_6__utilities_event__["a" /* default */].trap(event);

              _this.props.onClick();
            }

            break;

          case __WEBPACK_IMPORTED_MODULE_5__utilities_key_code__["a" /* default */].BACKSPACE:
          case __WEBPACK_IMPORTED_MODULE_5__utilities_key_code__["a" /* default */].DELETE:
            if (typeof _this.props.onRemove === 'function') {
              __WEBPACK_IMPORTED_MODULE_6__utilities_event__["a" /* default */].trap(event);

              _this.props.onRemove();
            }

            break;

          default:
            break;
        }
      }
    }), Object.defineProperty(_assertThisInitialized(_this), "handleRef", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(root) {
        // Keeping the top-most element to support focus() and blur()
        _this.root = root;
      }
    }), Object.defineProperty(_assertThisInitialized(_this), "restProps", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            bare = _this$props.bare,
            hasError = _this$props.hasError,
            variant = _this$props.variant,
            className = _this$props.className,
            onClick = _this$props.onClick,
            onRemove = _this$props.onRemove,
            labels = _this$props.labels,
            assistiveText = _this$props.assistiveText,
            children = _this$props.children,
            href = _this$props.href,
            icon = _this$props.icon,
            avatar = _this$props.avatar,
            onKeyDown = _this$props.onKeyDown,
            other = _objectWithoutProperties(_this$props, ["bare", "hasError", "variant", "className", "onClick", "onRemove", "labels", "assistiveText", "children", "href", "icon", "avatar", "onKeyDown"]);

        return other;
      }
    }), Object.defineProperty(_assertThisInitialized(_this), "renderIcon", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        var icon = _this.props.icon || _this.props.avatar;

        if (icon) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
            className: "slds-pill__icon_container"
          }, icon);
        }

        return null;
      }
    }), Object.defineProperty(_assertThisInitialized(_this), "renderLabel", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        if (_this.props.labels.label) {
          if (_this.props.variant === 'link') {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
              href: _this.getHref(),
              className: "slds-pill__action",
              title: _this.props.labels.title || _this.props.labels.label,
              onClick: _this.props.onClick
            }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
              className: "slds-pill__label"
            }, _this.props.labels.label));
          }

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
            className: "slds-pill__label",
            title: _this.props.labels.title || _this.props.labels.label
          }, _this.props.labels.label);
        }

        return _this.props.children;
      }
    }), Object.defineProperty(_assertThisInitialized(_this), "renderRemoveIcon", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        if (typeof _this.props.onRemove === 'function') {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
            // eslint-disable-line jsx-a11y/interactive-supports-focus
            className: "slds-icon_container slds-pill__remove",
            title: _this.props.labels.removeTitle,
            role: "button",
            onClick: _this.props.onRemove
          }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__utilities_utility_icon__["a" /* default */], {
            style: {
              cursor: 'pointer'
            } // remove when fixed by SLDS CSS
            ,
            category: "utility",
            className: "slds-icon slds-icon--x-small slds-icon-text-default",
            name: "close"
          }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
            className: "slds-assistive-text"
          }, _this.props.assistiveText.remove || _this.props.labels.removeTitle));
        }

        return null;
      }
    }), _temp));
  }

  _createClass(Pill, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      Object(__WEBPACK_IMPORTED_MODULE_7__check_props__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__utilities_constants__["_6" /* PILL */]);
    }
  }, {
    key: "render",
    value: function render() {
      var role;

      switch (this.props.variant) {
        case 'link':
          role = 'button';
          break;

        case 'option':
          role = 'option';
          break;

        default:
      }

      return (
        /* eslint-disable jsx-a11y/no-static-element-interactions */
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", _extends({}, this.restProps(), {
          role: role,
          className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('slds-pill', {
            'slds-pill_link': this.props.variant === 'link',
            'slds-has-error': this.props.hasError,
            'slds-pill_bare': this.props.bare
          }, this.props.className),
          onClick: !this.props.labels.label || this.props.variant !== 'link' ? this.props.onClick : null,
          onKeyDown: typeof this.props.onRemove === 'function' ? this.handleKeyDown : null,
          ref: this.handleRef
        }), this.renderIcon(), this.renderLabel(), this.renderRemoveIcon())
      );
    }
  }]);

  return Pill;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Pill.displayName = __WEBPACK_IMPORTED_MODULE_3__utilities_constants__["_6" /* PILL */];
Pill.defaultProps = {
  variant: 'link',
  labels: {},
  assistiveText: {}
};
Pill.propTypes = propTypes;
/* harmony default export */ __webpack_exports__["a"] = (Pill);
//# sourceMappingURL=index.js.map

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__low_priority_warning__ = __webpack_require__(54);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable import/no-mutable-exports */
// This function will deliver a warning message to the browser console about the component being a prototype component.


var isPrototype = function isPrototype() {};

if (false) {
  var hasWarned = {};

  isPrototype = function isPrototype(control, comment) {
    var additionalComment = comment ? " ".concat(comment) : '';

    if (!hasWarned[control]) {
      /* eslint-disable max-len */
      lowPriorityWarning(false, "[Design System React] ".concat(control, " is a prototype. (a) Props may change within a minor release. (b) Web Content Accessibility Guidelines may not be met. (c) CSS imports may be required, since it is being added to SLDS.").concat(additionalComment));
      /* eslint-enable max-len */

      hasWarned[control] = true;
    }
  };
}

/* unused harmony default export */ var _unused_webpack_default_export = (isPrototype);
//# sourceMappingURL=component-is-prototype.js.map

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
    reHasRegExpChar = RegExp(reRegExpChar.source);

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escapeRegExp('[lodash](https://lodash.com/)');
 * // => '\[lodash\]\(https://lodash\.com/\)'
 */
function escapeRegExp(string) {
  string = toString(string);
  return (string && reHasRegExpChar.test(string))
    ? string.replace(reRegExpChar, '\\$&')
    : string;
}

module.exports = escapeRegExp;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_constants__ = __webpack_require__(2);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// # Global Header Button Component
// ## Dependencies
// ### React
 // ### Button

 // ## Constants


/**
 * A helper component that renders a Button in the tools area of the Global Header. Currently defaults to a bare icon, but this can be overriden if text-based buttons are required.
 */

var GlobalHeaderButton = function GlobalHeaderButton(props) {
  var buttonVariant = props.buttonVariant,
      rest = _objectWithoutProperties(props, ["buttonVariant"]);

  var btn = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__button__["a" /* default */], _extends({
    iconVariant: "global-header",
    variant: "icon"
  }, rest));
  return buttonVariant === 'dropdown' ? btn : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, btn);
};

GlobalHeaderButton.displayName = __WEBPACK_IMPORTED_MODULE_2__utilities_constants__["H" /* GLOBAL_HEADER_TOOL */];
/* harmony default export */ __webpack_exports__["a"] = (GlobalHeaderButton);
//# sourceMappingURL=button.js.map

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_constants__ = __webpack_require__(2);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// # List Item Label Component
// ## Dependencies
// ### React

 // ## Constants


/**
 * Component description.
 */

var ListItemLabel = function ListItemLabel(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "slds-truncate"
  }, props.icon, props.label);
};

ListItemLabel.displayName = __WEBPACK_IMPORTED_MODULE_2__utilities_constants__["U" /* LIST_ITEM_LABEL */];
ListItemLabel.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  index: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  inverted: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isSelected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};
ListItemLabel.defaultProps = {
  data: {},
  index: 0,
  inverted: false,
  isSelected: false,
  label: '',
  value: null
};
/* harmony default export */ __webpack_exports__["a"] = (ListItemLabel);
//# sourceMappingURL=item-label.js.map

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_constants__ = __webpack_require__(2);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// # Dropdown Trigger Component (Simple Button Flavor) --- SLDS for React
// ### React
// React is an external dependency of the project.


 // ### classNames
// [github.com/JedWatson/classnames](https://github.com/JedWatson/classnames)
// This project uses `classnames`, "a simple javascript utility for conditionally
// joining classNames together."


 // ### Children


/**
 *  The Dropdown Button Trigger renders the default trigger button for the dropdown menu. If this component has children, it does not render itself to the DOM. Instead, it renders its child element, `Button`, and all that child's properties. This component may be used as a template to create custom triggers that do not use `Button`.
 */

var Trigger = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  // ### Display Name
  // Always use the canonical component name (set in the core) as the React
  // display name.
  displayName: __WEBPACK_IMPORTED_MODULE_5__utilities_constants__["Y" /* MENU_DROPDOWN_TRIGGER */],
  // ### Prop Types
  propTypes: {
    /**
     * Import the module `design-system-react/dropdown/button-trigger` and render a grandchild of the element type `Button`. Any `props` specified on that `Button` will be assigned to the triggering button. Any `id` prop or event hanlders (`onBlur`, `onClick`, etc.) set on the button grandchild will be overwritten by `MenuDropdown` to allow functionality and accessibility.
     * ```
     * <Dropdown>
     *   <Trigger>
     *   <Button iconCategory="utility" iconName="settings" />
     *   </Trigger>
     * </Dropdown>
     * ```
     */
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element,

    /**
     * CSS classes to be added to triggering button.
     */
    className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),

    /**
     * A unique ID is needed in order to support keyboard navigation, ARIA support, and connect the dropdown to the triggering button. This is provided by the `MenuDropdown`. Please use `MenuDropdown` to set.
     */
    id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * Informs the trigger on the open/close state of the dropdown menu
     */
    isOpen: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * By Default the dropdown menu is inside a `Dialog` component.
     */
    menu: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,

    /**
     * Is only called when `openOn` is set to `hover` and when the triggering button loses focus.
     */
    onBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * This prop is passed onto the triggering `Button`. Triggered when the trigger button is clicked.
     */
    onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Is only called when `openOn` is set to `hover` and when the triggering button gains focus.
     */
    onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Called when a key pressed.
     */
    onKeyDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Called when mouse clicks down on the trigger button.
     */
    onMouseDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Called when mouse hovers over the trigger button. This is only called if `this.props.openOn` is set to `hover`.
     */
    onMouseEnter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Called when mouse hover leaves the trigger button. This is only called if `this.props.openOn` is set to `hover`.
     */
    onMouseLeave: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Determines if mouse hover or click opens the dropdown menu. The default of `click` is highly recommended to comply with accessibility standards. If you are planning on using hover, please pause a moment and reconsider.
     */
    openOn: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['hover', 'click', 'hybrid']),

    /**
     * The ref of the actual triggering button.
     */
    triggerRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * CSS classes to be added to wrapping trigger `div` around the button.
     */
    triggerClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string])
  },
  // ### Render
  render: function render() {
    // The following are required for use with dropdown. Any other custom props for `Button` should be set with a `Button` child of this component, and are technically just here for backwards compatibility. See `children` prop description for more information.
    var _props = this.props,
        assistiveText = _props.assistiveText,
        children = _props.children,
        className = _props.className,
        id = _props.id,
        isInline = _props.isInline,
        isOpen = _props.isOpen,
        onBlur = _props.onBlur,
        menu = _props.menu,
        onClick = _props.onClick,
        onFocus = _props.onFocus,
        onKeyDown = _props.onKeyDown,
        onMouseDown = _props.onMouseDown,
        onMouseEnter = _props.onMouseEnter,
        onMouseLeave = _props.onMouseLeave,
        openOn = _props.openOn,
        triggerRef = _props.triggerRef,
        triggerClassName = _props.triggerClassName,
        deprecatedPropsFromMenuDropdown = _objectWithoutProperties(_props, ["assistiveText", "children", "className", "id", "isInline", "isOpen", "onBlur", "menu", "onClick", "onFocus", "onKeyDown", "onMouseDown", "onMouseEnter", "onMouseLeave", "openOn", "triggerRef", "triggerClassName"]); // Trigger manipulation


    var propsFromGrandchildButton = {}; // if there are no children, render the default button

    if (__WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.count(this.props.children) !== 0) {
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(this.props.children, function (child) {
        if (child && child.type.displayName === __WEBPACK_IMPORTED_MODULE_4__button__["a" /* default */].displayName) {
          propsFromGrandchildButton = child.props;
        }
      });
    } // If Trigger has a Button child, then use the explicitly declared child's props layered on top of those passed down by dropdown's props to allow manual override


    return (
      /* eslint-disable jsx-a11y/no-static-element-interactions */
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()("slds-dropdown-trigger slds-dropdown-trigger--".concat(openOn), {
          'slds-is-open': isOpen
        }, triggerClassName),
        id: id,
        onBlur: onBlur,
        onClick: onClick,
        onKeyDown: onKeyDown,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__button__["a" /* default */], _extends({
        assistiveText: assistiveText,
        className: className,
        "aria-expanded": isOpen,
        "aria-haspopup": true
      }, deprecatedPropsFromMenuDropdown, propsFromGrandchildButton, {
        buttonRef: triggerRef
      })), menu)
    );
  }
});
/* harmony default export */ __webpack_exports__["a"] = (Trigger);
//# sourceMappingURL=button-trigger.js.map

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_onclickoutside__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__menu_default_footer__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__menu_default_header__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__menu_default_section_divider__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lookup__ = __webpack_require__(231);
/* unused harmony reexport DefaultHeader */
/* unused harmony reexport DefaultSectionDivider */
/* unused harmony reexport DefaultFooter */
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// ### onClickOutside
// Listen for clicks that occur somewhere in the document, outside of the element itself





/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_onclickoutside__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__lookup__["a" /* default */], {
  excludeScrollbar: true
}));



//# sourceMappingURL=index.js.map

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__header__ = __webpack_require__(228);
// Alias

/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__header__["a" /* default */]);
//# sourceMappingURL=index.js.map

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__footer__ = __webpack_require__(229);
// Alias

/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__footer__["a" /* default */]);
//# sourceMappingURL=index.js.map

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__section_divider__ = __webpack_require__(230);
// Alias

/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__section_divider__["a" /* default */]);
//# sourceMappingURL=index.js.map

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_constants__ = __webpack_require__(2);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// ### React

 // ### classNames

 // ## Constants


/**
 * The default Cell renderer for the DataTable. Pass in any React component with the same `displayName` which takes the same props to provide custom rendering.
 */

var DataTableCell = function DataTableCell(props) {
  var childText = __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(props.children) ? props.children.props.children : props.children;
  var contents = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
      'slds-truncate': props.fixedLayout
    }),
    title: props.title || childText
  }, props.children);
  var cell = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", {
    className: props.className,
    role: props.fixedLayout ? 'gridcell' : null,
    style: props.width ? {
      width: props.width
    } : null
  }, contents);

  if (props.primaryColumn) {
    cell = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", {
      className: props.className,
      role: props.fixedLayout ? 'gridcell' : null,
      style: props.width ? {
        width: props.width
      } : null
    }, contents);
  }

  return cell;
}; // ### Display Name
// Always use the canonical component name as the React display name.


DataTableCell.displayName = __WEBPACK_IMPORTED_MODULE_3__utilities_constants__["u" /* DATA_TABLE_CELL */]; // ### Prop Types

DataTableCell.propTypes = {
  /**
   * The contents of the cell. This can be simple text or DOM nodes. Equivalent to `props.item[props.property]`
   */
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * Class names to be added to the cell.
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * Use this if you are creating an advanced table (selectable, sortable, or resizable rows)
   */
  fixedLayout: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * The item from the items which represents this row.
   */
  item: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * The primary column for a row. This is almost always the first column.
   */
  primaryColumn: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * The property of this item to display.
   */
  property: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Shows on hover. Useful for truncated cells.
   */
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Width of column. This is required for advanced/fixed layout tables. Please provide units. (`rems` are recommended)
   */
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
/* harmony default export */ __webpack_exports__["a"] = (DataTableCell);
//# sourceMappingURL=cell.js.map

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_constants__ = __webpack_require__(2);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// ### React

 // ## Constants

 // extends is used below so that react-docgen can detect the component

/**
 * Columns define the structure of the data displayed in the DataTable.
 */

var DataTableColumn =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DataTableColumn, _React$Component);

  function DataTableColumn() {
    _classCallCheck(this, DataTableColumn);

    return _possibleConstructorReturn(this, (DataTableColumn.__proto__ || Object.getPrototypeOf(DataTableColumn)).apply(this, arguments));
  }

  return DataTableColumn;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component); // ### Display Name
// Always use the canonical component name as the React display name.


DataTableColumn.displayName = __WEBPACK_IMPORTED_MODULE_2__utilities_constants__["v" /* DATA_TABLE_COLUMN */]; // ### Prop Types

DataTableColumn.propTypes = {
  /**
   * Use a _higher-order component_ to customize a data table cell that will override the default cell rendering. `CustomDataTableCell` must have the same `displayName` as `DataTableCell` or it will be ignored. If you want complete control of the HTML, including the wrapping `td`, you don't have to use `DataTableCell`.
   * ```
   * import DataTableCell from 'design-system-react/data-table/cell';
   * const CustomDataTableCell = ({ children, ...props }) => (
   *   <DataTableCell {...props} >
   *     <a href="javascript:void(0);">{children}</a>
   *   </DataTableCell>
   * );
   * CustomDataTableCell.displayName = DataTableCell.displayName;
   *
   * <DataTable>
   *   <DataTableColumn />
   *   <DataTableColumn>
   *     <DataTableCustomCell />
   *   </DataTableColumn>
   *   <DataTableRowActions />
   * </DataTable>
   * ```
   */
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,

  /**
   * Selects this column as the currently sorted column.
   */
  isSorted: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * The column label. If a `string` is not passed in, no `title` attribute will be rendered.
   */
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]),

  /**
   * The primary column for a row. This is almost always the first column.
   */
  primaryColumn: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * The property which corresponds to this column.
   */
  property: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Whether or not the column is sortable.
   */
  sortable: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * The current sort direction. If left out the component will track this internally. Required if `isSorted` is true.
   */
  sortDirection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['desc', 'asc']),

  /**
   * Title used for truncation div within the cell.
   */
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Adds truncate to cell node.
   */
  truncate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Width of column. This is required for advanced/fixed layout tables. Please provide units. (`rems` are recommended)
   */
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
/* harmony default export */ __webpack_exports__["a"] = (DataTableColumn);
//# sourceMappingURL=column.js.map

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isfunction__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isfunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isfunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__menu_dropdown__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_event__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_constants__ = __webpack_require__(2);
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
// ### React


 // ### isFunction

 // ## Children

 // ### Event Helpers

 // ## Constants


/**
 * RowActions provide a mechanism for defining a menu to display alongside each row in the DataTable.
 */

var DataTableRowActions = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  // ### Display Name
  // Always use the canonical component name as the React display name.
  displayName: __WEBPACK_IMPORTED_MODULE_6__utilities_constants__["z" /* DATA_TABLE_ROW_ACTIONS */],
  // ### Prop Types
  propTypes: {
    /**
     * Description of the menu for screenreaders.
     */
    assistiveText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,

    /**
     * Class names to be added to the actions menu.
     */
    className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * HTML ID to be added to the actions menu.
     */
    id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * `DataTable` row item
     */
    item: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,

    /**
     * Disable hint styling which changes the color of the dropdown svg on hover over.
     */
    noHint: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * Triggered when an item is selected.
     */
    onAction: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * `Dropdown` options. See `Dropdown`.
     */
    options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,

    /**
     * A [Dropdown](http://react.lightningdesignsystem.com/components/dropdown-menus/) component. The props from this drop will be merged and override any default props.
     * **Note:** onAction will not be overridden, both `DropDown`'s onSelect(dropDownActionOption) and onAction(rowItem, dropdownActionOption) will be called with appropriate parameters
     */
    dropdown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
  },
  getDefaultProps: function getDefaultProps() {
    return {
      assistiveText: {
        icon: 'Actions'
      },
      noHint: false,
      options: []
    };
  },
  handleClick: function handleClick(e) {
    __WEBPACK_IMPORTED_MODULE_5__utilities_event__["a" /* default */].trap(e);
  },
  handleSelect: function handleSelect(selection) {
    if (__WEBPACK_IMPORTED_MODULE_3_lodash_isfunction___default()(this.props.onAction)) {
      this.props.onAction(this.props.item, selection);
    }

    if (this.props.dropdown && __WEBPACK_IMPORTED_MODULE_3_lodash_isfunction___default()(this.props.dropdown.props.onSelect)) {
      this.props.dropdown.props.onSelect(selection);
    }
  },
  // ### Render
  render: function render() {
    // i18n
    var defaultDropdownProps = {
      align: 'right',
      buttonClassName: 'slds-button--icon-x-small',
      buttonVariant: 'icon',
      iconCategory: 'utility',
      iconName: 'down',
      iconSize: 'small',
      iconVariant: 'border-filled',
      assistiveText: this.props.assistiveText,
      className: this.props.className,
      options: this.props.options,
      hint: !this.props.noHint,
      id: this.props.id
    };
    var props = this.props.dropdown ? this.props.dropdown.props : {};

    var dropdownProps = _objectSpread({}, defaultDropdownProps, props, {
      onSelect: this.handleSelect
    });

    return (
      /* eslint-disable jsx-a11y/no-static-element-interactions */
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", {
        className: "",
        "data-label": "Actions",
        onClick: this.handleClick,
        style: {
          width: '3.25rem'
        }
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__menu_dropdown__["a" /* default */], dropdownProps))
    );
  }
});
/* harmony default export */ __webpack_exports__["a"] = (DataTableRowActions);
//# sourceMappingURL=row-actions.js.map

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_onclickoutside__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__popover__ = __webpack_require__(252);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// ### onClickOutside
// Listen for clicks that occur somewhere in the document, outside of the element itself


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_onclickoutside__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__popover__["a" /* default */]));
//# sourceMappingURL=index.js.map

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shortid__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shortid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_shortid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__private_item__ = __webpack_require__(258);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// Implements the [Vertical Navigation design pattern](https://lightningdesignsystem.com/components/vertical-navigation/) in React.
// Based on SLDS v2.2.1


 // ### classNames
// [github.com/JedWatson/classnames](https://github.com/JedWatson/classnames)
// This project uses `classnames`, 'a simple javascript utility for conditionally
// joining classNames together.'

 // ### shortid
// [npmjs.com/package/shortid](https://www.npmjs.com/package/shortid)
// shortid is a short, non-sequential, url-friendly, unique id generator


 // Child components


/**
 * Vertical Navigation represents a list of links that either take the user to another page or parts of the page the user is in.
 */

var VerticalNavigation = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: __WEBPACK_IMPORTED_MODULE_5__utilities_constants__["_34" /* VERTICAL_NAVIGATION */],
  propTypes: {
    /**
     * HTML id for component. _Tested with snapshot testing._
     */
    id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * CSS class names to be added to the container element. _Tested with snapshot testing._
     */
    className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),

    /**
     * Array of categories. The required shape is: `{id: string, label: string, items: array}`. The required shape of an item is `{id: string, label: string, url: string}`. All item ids are expected to be unique. _Tested with snapshot testing._
     */
    categories: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,

    /**
     * The ID of the item that is currently selected. Defaults to the ID of the first item. _Tested with Mocha framework._
     */
    selectedId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * Triggered when the selection changes. It receives an event and an item object in the shape: `event, {item: [object] }`. _Tested with Mocha framework._
     */
    onSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Determines component style. _Tested with snapshot testing._
     */
    variant: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['default', 'shade'])
  },
  getDefaultProps: function getDefaultProps() {
    return {
      variant: 'default'
    };
  },
  componentWillMount: function componentWillMount() {
    this.generatedId = __WEBPACK_IMPORTED_MODULE_4_shortid___default.a.generate();
  },
  getId: function getId() {
    return this.props.id || this.generatedId;
  },
  getVariant: function getVariant() {
    return this.props.variant === 'shade' ? 'shade' : 'default';
  },
  getSelectedId: function getSelectedId() {
    var categories = this.props.categories;
    var selectedId;

    if (this.props.selectedId) {
      selectedId = this.props.selectedId;
    } else if (categories.length > 0 && categories[0].items && categories[0].items.length > 0) {
      selectedId = categories[0].items[0].id;
    }

    return selectedId;
  },
  render: function render() {
    var _this = this;

    var rootId = this.getId();
    var variant = this.getVariant();
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      id: rootId,
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('slds-grid', 'slds-grid--vertical', 'slds-navigation-list--vertical', {
        'slds-navigation-list--vertical-inverse': variant === 'shade'
      }, this.props.className)
    }, this.props.categories.map(function (category) {
      var categoryId = "".concat(rootId, "-").concat(category.id);

      var selectedId = _this.getSelectedId();

      return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", {
        id: categoryId,
        key: "".concat(categoryId, "-header"),
        className: "slds-text-title--caps slds-p-around--medium"
      }, category.label), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
        key: categoryId
      }, category.items.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__private_item__["a" /* default */], {
          key: item.id,
          item: item,
          isSelected: item.id === selectedId,
          categoryId: categoryId,
          onSelect: _this.props.onSelect
        });
      }))];
    }));
  }
});
/* harmony default export */ __webpack_exports__["a"] = (VerticalNavigation);
//# sourceMappingURL=index.js.map

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__private_info__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__private_title__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__private_detail_row__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__private_detail_block__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__private_base__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__private_record_home__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__private_object_home__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__private_related_list__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__icon__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__breadcrumb__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utilities_constants__ = __webpack_require__(2);
/* unused harmony reexport Info */
/* unused harmony reexport Title */
/* unused harmony reexport DetailRow */
/* unused harmony reexport DetailBlock */
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable jsx-a11y/no-redundant-roles */
// # Page Header Component
// Implements the [Page Header design pattern](https://www.lightningdesignsystem.com/components/page-headers) in React.
// Based on SLDS v2.2.1
// ## Dependencies












 // ## Constants


var displayName = __WEBPACK_IMPORTED_MODULE_13__utilities_constants__["_1" /* PAGE_HEADER */];
var propTypes = {
  /**
   * Optional class name
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * The type of component
   */
  variant: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * The info property can be a string or a React element
   */
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element]),

  /**
   * The title property can be a string or a React element
   */
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element]),

  /**
   * The info property can be a string or a React element
   */
  info: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element]),

  /**
   * The page header icon
   */
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,

  /**
   * Name of the icon. Visit <a href="http://www.lightningdesignsystem.com/resources/icons">Lightning Design System Icons</a> to reference icon names.
   */
  iconName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * The icons category
   */
  iconCategory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['action', 'custom', 'doctype', 'standard', 'utility']),

  /**
   * If omitted, icon position is centered.
   */
  iconPosition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['left', 'right']),

  /**
   * Determines the size of the icon.
   */
  iconSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['x-small', 'small', 'medium', 'large']),

  /**
   * For icon variants, please reference <a href='http://www.lightningdesignsystem.com/components/buttons/#icon'>Lightning Design System Icons</a>.
   */
  iconVariant: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['container', 'border', 'border-filled', 'small', 'more']),

  /**
   * Content to appear on the right hand side of the page header
   */
  contentRight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element]),

  /**
   * An array of buttons which appear on the component's right hand side.
   */
  details: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,

  /**
   * Nav content which appears in the upper right hand corner.
   */
  navRight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element]),

  /**
   * An array of react elements presumably anchor <a> elements.
   */
  trail: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};
var defaultProps = {
  className: '',
  variant: 'base',
  navRight: '',
  contentRight: '',
  details: [],
  trail: []
};
/**
 * The PageHeader component adds PageHeader, PageHeader.Info, PageHeader.Title, PageHeader.DetailRow, and PageHeader.DetailBlock.
 */

var PageHeader =
/*#__PURE__*/
function (_Component) {
  _inherits(PageHeader, _Component);

  function PageHeader() {
    _classCallCheck(this, PageHeader);

    return _possibleConstructorReturn(this, (PageHeader.__proto__ || Object.getPrototypeOf(PageHeader)).apply(this, arguments));
  }

  _createClass(PageHeader, [{
    key: "_getClassNames",
    value: function _getClassNames(className) {
      return __WEBPACK_IMPORTED_MODULE_2_classnames___default()('slds-page-header', {
        'slds-page-header--object-home': this.props.variant === 'objectHome'
      }, className);
    }
  }, {
    key: "render",
    value: function render() {
      /**
       * OPTIMIZE ES7 style object destructuring removes the need for _.omit.
       * Example: const {foo, ...bar} = this.props;
       */
      var _props = this.props,
          className = _props.className,
          contentRight = _props.contentRight,
          details = _props.details,
          icon = _props.icon,
          iconCategory = _props.iconCategory,
          iconName = _props.iconName,
          iconPosition = _props.iconPosition,
          iconSize = _props.iconSize,
          iconVariant = _props.iconVariant,
          info = _props.info,
          label = _props.label,
          navRight = _props.navRight,
          title = _props.title,
          trail = _props.trail,
          variant = _props.variant;

      var classes = this._getClassNames(className);
      /**
       * Render the icon
       */


      var renderIcon = function renderIcon() {
        if (iconName) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__icon__["a" /* default */], {
            name: iconName,
            category: iconCategory,
            position: iconPosition,
            size: iconSize,
            variant: iconVariant
          });
        }

        return icon;
      };
      /**
       * Render the label
       */


      var renderLabel = function renderLabel() {
        var type = _typeof(label);

        if (trail.length > 0) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("nav", {
            className: "slds-m-bottom--xx-small",
            role: "navigation"
          }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__breadcrumb__["a" /* default */], {
            trail: trail
          }));
        }

        if (type === 'string') {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
            className: "slds-text-title--caps slds-line-height--reset"
          }, label);
        }

        return label;
      };
      /**
       * Render the title
       */


      var renderTitle = function renderTitle() {
        var type = _typeof(title);

        if (type === 'string') {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__private_title__["a" /* default */], {
            title: title
          });
        }

        return title;
      };
      /**
       * Render info
       */


      var renderInfo = function renderInfo() {
        var type = _typeof(info);

        if (type === 'string') {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__private_info__["a" /* default */], null, info);
        }

        return info;
      };
      /**
       * Steal contentRight's children
       */


      var renderNavRight = function renderNavRight() {
        var type = _typeof(navRight);

        if (type !== 'string') {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({
            className: "slds-col slds-no-flex slds-grid slds-align-top"
          }, navRight.props));
        }

        return navRight;
      };
      /**
       * Steal contentRight's children
       */


      var renderContentRight = function renderContentRight() {
        var type = _typeof(contentRight);

        if (type !== 'string') {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({
            className: "slds-grid"
          }, contentRight.props));
        }

        return contentRight;
      };

      var Variant;

      switch (variant) {
        case 'objectHome':
          Variant = __WEBPACK_IMPORTED_MODULE_9__private_object_home__["a" /* default */];
          break;

        case 'recordHome':
          Variant = __WEBPACK_IMPORTED_MODULE_8__private_record_home__["a" /* default */];
          break;

        case 'relatedList':
          Variant = __WEBPACK_IMPORTED_MODULE_10__private_related_list__["a" /* default */];
          break;

        default:
          Variant = __WEBPACK_IMPORTED_MODULE_7__private_base__["a" /* default */];
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: classes
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Variant, {
        label: renderLabel(),
        icon: renderIcon(),
        title: renderTitle(),
        info: renderInfo(),
        contentRight: renderContentRight(),
        navRight: renderNavRight(),
        details: details
      }));
    }
  }]);

  return PageHeader;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

PageHeader.displayName = displayName;
PageHeader.propTypes = propTypes;
PageHeader.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (PageHeader);

//# sourceMappingURL=index.js.map

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return sessions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return keynotes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return lunchTimes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return mealOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return drinkOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dessertOptions; });
// ## Data
var sessions=[{id:1,title:'Portaging for Posers',speaker:'Trey Smith',blurb:'How to look like you know how to carry a canoe, without actually carrying a canoe.',location:'9 Parakeet Pond',day:'Thursday',time:'9:00 AM',duration:'30 Minutes',workshop:false},{id:2,title:'Is this edible?',speaker:'Will Smith',blurb:'Berries and mushrooms and herbs, oh my! Learn how to spot the difference between nature’s candy and nature’s poison.',location:'2 Wallaby Way',day:'Thursday',time:'9:00 AM',duration:'45 Minutes',workshop:true},{id:3,title:'Litter-ature',speaker:'Jada Smith',blurb:'In this paws-on session, we’ll create effective and engaging signage to discourage visitors from littering.',location:'7 Salamander Street',day:'Thursday',time:'9:00 AM',duration:'45 Minutes',workshop:true},{id:4,title:'S’mores Sesh',speaker:'Jaden Smith',blurb:'The best session of them all, S’mores Sesh is basically a chance to sit around and eat s’mores.',location:'4 Lagoon Lane',day:'Thursday',time:'9:00 AM',duration:'30 Minutes',workshop:false},{id:4,title:'Basket Weaving 102',speaker:'Willow Smith',blurb:'Hot on the trail of Basket Weaving 101, we’ll explore how to make even bigger baskets!',location:'6 Meerkat Mall',day:'Thursday',time:'9:00 AM',duration:'60 Minutes',workshop:false}];var DAY='Wednesday';var TIME='10:00 AM - 11:00 AM';var keynotes=[{id:1,title:'Choosing Your Path',blurb:'Listen as Jamie discusses choosing your own path.',date:DAY,time:TIME,location:'7 Garden Grove',videoSrc:'assets/videos/blueShirt.mov',captionSrc:'assets/videos/captionManager.vtt',transcript:'I think Choosing Your Path will really appeal to anyone looking to make the transition from "doer" to "manager." We\'ll have a diverse panel of speakers who\'ve been there, done that, and have insight into the challenges of becoming a manager for the first time.'},{id:2,title:'Forging Your Trail',blurb:'Listen as Morgan shares more about forging your trail!',date:DAY,time:TIME,location:'4 Lagoon Lane',videoSrc:'assets/videos/yellowShirt.mov',captionSrc:'assets/videos/captionDeveloper.vtt',transcript:'Look, as a developer, I love staying up-to-date with the latest trends in technology. But it can be really hard, you know, with how much is changing. Forging a Trail will give you a broad overview of the trends shaping the developer\'s world, and a high-level look at what tools and frameworks you should be aware of.'}];var lunchTimes=['11:00','11:30','12:00','12:30'];var mealOptions=['Salad (Vegan)','Salad (Veggie)','Sandwich (Chicken)','Sandwich (Chicken, Gluten-Free)','Sandwich (Veggie)','Sandwich (Veggie, Gluten-Free)'].map(function(value,i){return{id:i,label:value};});var drinkOptions=['Apple Juice','Lemonade','Iced Tea','Cola','Diet Cola'].map(function(value,i){return{id:i,label:value};});var dessertOptions=['Nothing for me, thanks!','Brownie','Cupcake (Chocolate)','Cupcake (Red Velvet)','Cupcake (Vanilla)','Cookie (Chocolate Chip)','Cookie (Oatmeal Raisin)','Cookie (Peanut Butter)','Watermelon'].map(function(value,i){return{id:i,label:value};});

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(152);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Modal = __webpack_require__(167);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Modal2.default;
module.exports = exports["default"];

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

var tabbableNode = /input|select|textarea|button|object/;

function hidesContents(element) {
  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;

  // If the node is empty, this is good enough
  if (zeroSize && !element.innerHTML) return true;

  // Otherwise we need to check some styles
  var style = window.getComputedStyle(element);
  return zeroSize ? style.getPropertyValue("overflow") !== "visible" : style.getPropertyValue("display") == "none";
}

function visible(element) {
  var parentElement = element;
  while (parentElement) {
    if (parentElement === document.body) break;
    if (hidesContents(parentElement)) return false;
    parentElement = parentElement.parentNode;
  }
  return true;
}

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}

function tabbable(element) {
  var tabIndex = element.getAttribute("tabindex");
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  return [].slice.call(element.querySelectorAll("*"), 0).filter(tabbable);
}
module.exports = exports["default"];

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assertNodeList = assertNodeList;
exports.setElement = setElement;
exports.validateElement = validateElement;
exports.hide = hide;
exports.show = show;
exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
exports.resetForTesting = resetForTesting;

var _warning = __webpack_require__(12);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var globalElement = null;

function assertNodeList(nodeList, selector) {
  if (!nodeList || !nodeList.length) {
    throw new Error("react-modal: No elements were found for selector " + selector + ".");
  }
}

function setElement(element) {
  var useElement = element;
  if (typeof useElement === "string") {
    var el = document.querySelectorAll(useElement);
    assertNodeList(el, useElement);
    useElement = "length" in el ? el[0] : el;
  }
  globalElement = useElement || globalElement;
  return globalElement;
}

function validateElement(appElement) {
  if (!appElement && !globalElement) {
    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));

    return false;
  }

  return true;
}

function hide(appElement) {
  if (validateElement(appElement)) {
    (appElement || globalElement).setAttribute("aria-hidden", "true");
  }
}

function show(appElement) {
  if (validateElement(appElement)) {
    (appElement || globalElement).removeAttribute("aria-hidden");
  }
}

function documentNotReadyOrSSRTesting() {
  globalElement = null;
}

function resetForTesting() {
  globalElement = null;
}

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canUseDOM = undefined;

var _exenv = __webpack_require__(174);

var _exenv2 = _interopRequireDefault(_exenv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EE = _exenv2.default;

var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};

var canUseDOM = exports.canUseDOM = EE.canUseDOM;

exports.default = SafeHTMLElement;

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shortid__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shortid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shortid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_constants__ = __webpack_require__(2);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// Implements the [Accordion design
// pattern](https://www.lightningdesignsystem.com/components/accordion/) in
// React. Based on SLDS v2.4.3





var propTypes = {
  /**
   * CSS class names to be added to the accordion component. _Tested with snapshot testing._
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * HTML id for accordion component. _Tested with snapshot testing._
   */
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * The panel content for the Accordion component. Accordion panels should be added as <AccordionPanel />. Event handler for the accordion panels should be added to `<AccordionPanel />`. Optional `panelContentActions` component may be passed as prop. _Tested with Mocha framework and snapshot testing._
   *
   * Example:
   * ```
   * <SLDSAccordion>
   *   <SLDSAccordionpanel />
   *   <SLDSAccordionpanel />
   *   <SLDSAccordionpanel />
   * </SLDSAccordion>
   * ```
   */
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired
};
/**
 * An accordion allows a user to toggle the display of sections of content.
 * The accordion component wraps accordion panels that can be selected and expanded. It accepts children to define the content displayed within.
 */

var Accordion =
/*#__PURE__*/
function (_Component) {
  _inherits(Accordion, _Component);

  function Accordion() {
    _classCallCheck(this, Accordion);

    return _possibleConstructorReturn(this, (Accordion.__proto__ || Object.getPrototypeOf(Accordion)).apply(this, arguments));
  }

  _createClass(Accordion, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.generatedId = __WEBPACK_IMPORTED_MODULE_3_shortid___default.a.generate();
    }
  }, {
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
        name: this.props.id || this.generatedId,
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('slds-accordion', this.props.className)
      }, this.props.children);
    }
  }]);

  return Accordion;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Accordion.displayName = __WEBPACK_IMPORTED_MODULE_4__utilities_constants__["a" /* ACCORDION */];
Accordion.propTypes = propTypes;
/* harmony default export */ __webpack_exports__["a"] = (Accordion);
//# sourceMappingURL=index.js.map

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_constants__ = __webpack_require__(2);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// Implements the [Accordion design
// pattern](https://www.lightningdesignsystem.com/components/accordion/) in
// React. Based on SLDS v2.3.2





var propTypes = {
  /**
   * The panel content for the Accordion component. Accordion panels should be added as <AccordionPanel />. Event handler for the accordion panels should be added to `<AccordionPanel />`. Optional `panelContentActions` component may be passed as prop. _Tested with Mocha framework and snapshot testing._
   */
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * Indicates whether item is expanded or not, which should be handled by `onTogglePanel`. _Tested with Mocha framework and snapshot testing._
   */
  expanded: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,

  /**
   * Id of the item belonging to this panel. _Tested with snapshot testing._
   */
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired,

  /**
   * Component that can be passed as prop to `<Panel />`. As an example, a menu dropdown could be used here to handle additional actions for each accordion panel. _Tested with Mocha framework._
   */
  panelContentActions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * Callback that will run whenever a panel is toggled. Function should handle state to toggle `expanded` prop. _Tested with Mocha framework._
   */
  onTogglePanel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,

  /**
   * Summary in the span element in the header of this panel. The summary is truncated and so the title element should contain the full text so that it is accessible on hover. _Tested with snapshot testing._
   */
  summary: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]).isRequired,

  /**
   * HTML title attribute. _Tested with snapshot testing._
   */
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
/**
 * The panel content for the Accordion component.
 */

var AccordionPanel = function AccordionPanel(_ref) {
  var children = _ref.children,
      expanded = _ref.expanded,
      id = _ref.id,
      panelContentActions = _ref.panelContentActions,
      summary = _ref.summary,
      title = _ref.title,
      onTogglePanel = _ref.onTogglePanel;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
    className: "slds-accordion__list-item"
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section", {
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('slds-accordion__section', {
      'slds-is-open': expanded
    })
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "slds-accordion__summary"
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3", {
    className: "slds-text-heading_small slds-accordion__summary-heading slds-has-flexi-truncate"
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__button__["a" /* default */], {
    "aria-controls": "".concat(id, "-accordion-panel"),
    "aria-expanded": expanded,
    className: "slds-button_reset slds-accordion__summary-action",
    iconCategory: "utility",
    iconClassName: "slds-accordion__summary-action-icon slds-button__icon slds-button__icon_left",
    iconName: "switch",
    onClick: onTogglePanel,
    variant: "base"
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "slds-truncate",
    title: title || summary
  }, summary))), panelContentActions), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    "aria-hidden": !expanded,
    className: "slds-accordion__content",
    id: "".concat(id, "-accordion-panel")
  }, children)));
};

/* harmony default export */ __webpack_exports__["a"] = (AccordionPanel);
AccordionPanel.propTypes = propTypes;
AccordionPanel.displayName = __WEBPACK_IMPORTED_MODULE_4__utilities_constants__["b" /* ACCORDION_PANEL */];
//# sourceMappingURL=panel.js.map

/***/ }),
/* 80 */
/***/ (function(module, exports) {

module.exports = function requiredIf(type, condition) {
  return function(props, propName, componentName) {
    if (typeof type !== "function") {
      return new Error(
        'Invalid react-required-if prop type supplied to ' + componentName + '. Validation failed.'
      );
    }

    if (typeof condition !== "function") {
      return new Error(
        'Invalid react-required-if condition supplied to ' + componentName + '. Validation failed.'
      );
    }

    var test = condition(props) ? type.isRequired : type;
    return test.apply(this, arguments);
  };
};


/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */


var Svg = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'Svg',
  getPaths: function getPaths(paths) {
    if (paths instanceof Array) {
      return paths.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", item);
      });
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", _extends({
      key: "pathSVG"
    }, paths));
  },
  getCircles: function getCircles(circles) {
    if (circles instanceof Array) {
      return circles.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", item);
      });
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", _extends({
      key: "circleSVG"
    }, circles));
  },
  getEllipses: function getEllipses(ellipses) {
    if (ellipses instanceof Array) {
      return ellipses.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse", item);
      });
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse", _extends({
      key: "ellipseSVG"
    }, ellipses));
  },
  getGroups: function getGroups(groups) {
    var _this = this;

    if (groups instanceof Array) {
      return groups.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null, _this.getShapes(item));
      });
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
      key: "groupsSVG"
    }, this.getShapes(groups));
  },
  getShapes: function getShapes(data) {
    var shapes = [];

    if (data) {
      if (data.g) {
        shapes.push(this.getGroups(data.g));
      }

      if (data.ellipse) {
        shapes.push(this.getEllipses(data.ellipse));
      }

      if (data.circle) {
        shapes.push(this.getCircles(data.circle));
      }

      if (data.path) {
        shapes.push(this.getPaths(data.path));
      }
    }

    return shapes;
  },
  getSVG: function getSVG(_ref, props) {
    var viewBox = _ref.viewBox,
        rest = _objectWithoutProperties(_ref, ["viewBox"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
      "aria-hidden": props['aria-hidden'],
      className: props.className,
      viewBox: viewBox,
      name: props.name,
      style: props.style
    }, this.getShapes(rest));
  },
  render: function render() {
    var _props = this.props,
        data = _props.data,
        props = _objectWithoutProperties(_props, ["data"]);

    return data ? this.getSVG(data, props) : null;
  }
});
/* harmony default export */ __webpack_exports__["a"] = (Svg);
//# sourceMappingURL=svg.js.map

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable import/no-mutable-exports */
// This function will deliver an error message to the browser console one property is used but not both that are required. Either use neither or both properties.

var ifOneThenBothRequiredProperty;

if (false) {
  var hasWarned = {};

  ifOneThenBothRequiredProperty = function ifOneThenBothRequiredProperty(control, props, selectedProps, comment) {
    var additionalComment = comment ? " ".concat(comment) : '';
    var bothOrNoneAreSet = false;
    var keys = Object.keys(selectedProps);
    var values = keys.map(function (key) {
      return selectedProps[key];
    });
    var allTruthy = values.every(function (element) {
      return !!element;
    });
    var allFalsey = values.every(function (element) {
      return !element;
    });
    bothOrNoneAreSet = allTruthy || allFalsey;

    if (!hasWarned[control]) {
      /* eslint-disable max-len */
      warning(bothOrNoneAreSet, "[Design System React] If one of the following props are used, then both of the following properties are required by ".concat(control, ": [").concat(keys.join(), "].").concat(additionalComment));
      /* eslint-enable max-len */

      hasWarned[control] = !!selectedProps;
    }
  };
} else {
  ifOneThenBothRequiredProperty = function ifOneThenBothRequiredProperty() {};
}

/* unused harmony default export */ var _unused_webpack_default_export = (ifOneThenBothRequiredProperty);
//# sourceMappingURL=if-one-then-both-required-property.js.map

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tooltip__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities_warning_component_has_moved__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_constants__ = __webpack_require__(2);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// Alias



Object(__WEBPACK_IMPORTED_MODULE_1__utilities_warning_component_has_moved__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__utilities_constants__["_8" /* POPOVER_TOOLTIP */], {
  oldFileLocation: 'components/popover-tooltip',
  newFileLocation: 'components/tooltip'
});
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__tooltip__["a" /* default */]);
//# sourceMappingURL=index.js.map

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_assign__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_class_names__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__icon__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__check_props__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utilities_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utilities_dom_element_focus__ = __webpack_require__(48);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// # Alert Component
// Implements the [Alert design pattern](https://lightningdesignsystem.com/components/alert/) in React.









var propTypes = {
  /**
   * **Assistive text for accessibility**
   * This object is merged with the default props object on every render.
   * * `closeButton`: This is a visually hidden label for the close button.
   * _Tested with snapshot testing._
   */
  assistiveText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    closeButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node])
  }),

  /**
   * CSS classes to be added to tag with `.slds-notify_alert`. Uses `classNames` [API](https://github.com/JedWatson/classnames).
   * _Tested with snapshot testing._
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * Allows user to click a close button. Banners should be dismissible only if they communicate future impact to the system,
   * _Tested with snapshot testing._
   */
  dismissible: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Icon of type `~/components/icon`. This icon will be cloned and additional props appended. The default icons are:
   * * info variant: `utility:info`
   * * error variant: `utility:error`
   * * offline variant: `utility:offline`
   * * warning variant: `utility:warning`
   *
   * _Tested with snapshot testing._
   */
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * **Text labels for internationalization**
   * This object is merged with the default props object on every render.
   * * `heading`: text within heading tag
   * * `headingLink`: Text of link that triggers `onClickHeadingLink`. Inline links should pass a keyed array of React components into `labels.heading`.
   *
   * _Tested with snapshot testing._
   */
  labels: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]),
    headingLink: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node])
  }),

  /**
   * Triggered by link. _Tested with Mocha testing._
   */
  onClickHeadingLink: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Triggered by close button. This is a controlled component. _Tested with Mocha testing._
   */
  onRequestClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * The type of alert. _Tested with snapshot testing._
   */
  variant: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['error', 'info', 'offline', 'warning']).isRequired
};
var defaultProps = {
  assistiveText: {
    closeButton: 'Close'
  },
  labels: {},
  variant: 'info'
};
/**
 * Alert banners communicate a state that affects the entire system, not just a feature or page. It persists over a session and appears without the user initiating the action. View [banner guidelines](https://www.lightningdesignsystem.com/guidelines/messaging/components/banners/).
 */

var Alert =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Alert, _React$Component);

  function Alert(props) {
    var _this;

    _classCallCheck(this, Alert);

    _this = _possibleConstructorReturn(this, (Alert.__proto__ || Object.getPrototypeOf(Alert)).call(this, props));
    Object.defineProperty(_assertThisInitialized(_this), "saveButtonRef", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(component) {
        _this.closeButton = component;

        if (_this.state.isInitialRender) {
          __WEBPACK_IMPORTED_MODULE_8__utilities_dom_element_focus__["a" /* default */].storeActiveElement();

          if (_this.closeButton) {
            _this.closeButton.focus();
          }

          _this.setState({
            isInitialRender: false
          });
        }
      }
    });
    _this.state = {
      isInitialRender: true
    };
    return _this;
  }

  _createClass(Alert, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      // `checkProps` issues warnings to developers about properties (similar to React's built in development tools)
      Object(__WEBPACK_IMPORTED_MODULE_6__check_props__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_7__utilities_constants__["c" /* ALERT */], this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      __WEBPACK_IMPORTED_MODULE_8__utilities_dom_element_focus__["a" /* default */].returnFocusToStoredElement();
    }
  }, {
    key: "render",
    value: function render() {
      // Merge objects of strings with their default object
      var assistiveText = __WEBPACK_IMPORTED_MODULE_2_lodash_assign___default()({}, defaultProps.assistiveText, this.props.assistiveText);
      var labels = __WEBPACK_IMPORTED_MODULE_2_lodash_assign___default()({}, defaultProps.labels, this.props.labels); // BACKWARD COMPATIBILITY WITH NOTIFICATION

      var heading = labels.heading || this.props.content; // eslint-disable-line react/prop-types

      var onRequestClose = this.props.onRequestClose || this.props.onDismiss; // eslint-disable-line react/prop-types

      var assistiveTextVariant = {
        info: 'info',
        warning: 'warning',
        error: 'error',
        offline: 'offline'
      };
      var defaultIcons = {
        info: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__icon__["a" /* default */], {
          category: "utility",
          name: "info"
        }),
        offline: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__icon__["a" /* default */], {
          category: "utility",
          name: "offline"
        }),
        warning: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__icon__["a" /* default */], {
          category: "utility",
          name: "warning"
        }),
        error: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__icon__["a" /* default */], {
          category: "utility",
          name: "error"
        })
      };
      var icon = this.props.icon ? this.props.icon : defaultIcons[this.props.variant]; // BACKWARD COMPATIBILITY WITH NOTIFICATION

      if (this.props.iconName && this.props.iconCategory) {
        // eslint-disable-line react/prop-types
        icon = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__icon__["a" /* default */], {
          category: this.props.iconCategory,
          name: this.props.iconName
        });
      }

      var clonedIcon = __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(icon, {
        containerClassName: 'slds-m-right--x-small',
        inverse: true,
        size: 'x-small'
      });
      /* eslint-disable no-script-url */

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: Object(__WEBPACK_IMPORTED_MODULE_3__utilities_class_names__["a" /* default */])('slds-notify slds-notify_alert slds-theme_alert-texture', {
          'slds-theme_info': this.props.variant === 'info',
          'slds-theme_warning': this.props.variant === 'warning',
          'slds-theme_error': this.props.variant === 'error',
          'slds-theme_offline': this.props.variant === 'offline'
        }, this.props.className),
        role: "alert"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "slds-assistive-text"
      }, assistiveTextVariant[this.props.variant]), clonedIcon, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", null, heading, ' ', labels.headingLink ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
        onClick: this.props.onClickHeadingLink,
        href: "javascript:void(0);"
      }, labels.headingLink) : null), this.props.dismissible ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__button__["a" /* default */], {
        assistiveText: {
          icon: assistiveText.closeButton
        },
        buttonRef: this.saveButtonRef,
        className: "slds-notify__close",
        iconCategory: "utility",
        iconName: "close",
        iconSize: "medium",
        inverse: true,
        onClick: onRequestClose,
        title: assistiveText.closeButton,
        variant: "icon"
      }) : null);
    }
  }]);

  return Alert;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Alert.defaultProps = defaultProps;
Alert.displayName = __WEBPACK_IMPORTED_MODULE_7__utilities_constants__["c" /* ALERT */];
Alert.propTypes = propTypes;
/* unused harmony default export */ var _unused_webpack_default_export = (Alert);
//# sourceMappingURL=index.js.map

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_class_names__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_constants__ = __webpack_require__(2);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// # Alert Container Component




var propTypes = {
  /**
   * CSS classes to be added to tag with `.slds-notify_alert`. Uses `classNames` [API](https://github.com/JedWatson/classnames).
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * Alert components
   */
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};
/**
 * A fixed container for alert banners.
 */

var AlertContainer =
/*#__PURE__*/
function (_React$Component) {
  _inherits(AlertContainer, _React$Component);

  function AlertContainer() {
    _classCallCheck(this, AlertContainer);

    return _possibleConstructorReturn(this, (AlertContainer.__proto__ || Object.getPrototypeOf(AlertContainer)).apply(this, arguments));
  }

  _createClass(AlertContainer, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: Object(__WEBPACK_IMPORTED_MODULE_2__utilities_class_names__["a" /* default */])('slds-notify-container', this.props.className)
      }, this.props.children);
    }
  }]);

  return AlertContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

AlertContainer.displayName = __WEBPACK_IMPORTED_MODULE_3__utilities_constants__["d" /* ALERT_CONTAINER */];
AlertContainer.propTypes = propTypes;
/* unused harmony default export */ var _unused_webpack_default_export = (AlertContainer);
//# sourceMappingURL=container.js.map

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isfunction__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isfunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isfunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__check_props__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modal__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utilities_constants__ = __webpack_require__(2);
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// # App Launcher Component
// Based on SLDS v2.1.0-rc.2
// ## Dependencies
// ### React


 // ### classNames

 // ### isFunction

 // This component's `checkProps` which issues warnings to developers about properties when in development mode (similar to React's built in development tools)

 // ## Children

 // ## Constants


var defaultProps = {
  assistiveText: {
    trigger: 'Open App Launcher'
  },
  ariaHideApp: true,
  title: 'App Launcher'
};
/**
 * The App Launcher allows the user to quickly access all the apps and functionality with their organization.
 * The App Launcher should generally only be used as a sub-component of the [Global Navigation Bar](/components/global-navigation-bar)
 *
 * Also note: App Launcher is not included in the standard component export. To import it, you must reference it directly via its path.
 * Example:
 * ```
 * import AppLauncher from 'design-system-react/components/app-launcher';
 * import AppLauncherTile from 'design-system-react/components/app-launcher/tile';
 * import AppLauncherSection from 'design-system-react/components/app-launcher/section';
 * ```
 *
 * USAGE EXAMPLE:
 * ```
 * <AppLauncher>
 * 	<AppLauncherSection>
 * 		<AppLauncherTile />
 * 		<AppLauncherTile />
 * 		<AppLauncherTile />
 * 	</AppLauncherSection>
 * 	<AppLauncherSection>
 * 		<AppLauncherTile />
 * 		<AppLauncherTile />
 * 	</AppLauncherSection>
 * </AppLauncher>
 * ```
 *
 * By default, `Modal`, a child component of App Launcher, will add `aria-hidden=true` to the `body` tag, but this disables some assistive technologies. To prevent this you can add the following to your application with `#mount` being the root node of your application that you would like to hide from assistive technologies when the `Modal` is open.
 * ```
 * import settings from 'design-system-react/components/settings';
 * settings.setAppElement('#mount');
 * ```
 */

var AppLauncher = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  // ### Display Name
  // Always use the canonical component name as the React display name.
  displayName: __WEBPACK_IMPORTED_MODULE_7__utilities_constants__["e" /* APP_LAUNCHER */],
  // ### Prop Types
  propTypes: {
    /**
     * **Assistive text for accessibility.**
     * This object is merged with the default props object on every render.
     * * `trigger`: This is a visually hidden label for the app launcher icon.
     */
    assistiveText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
      trigger: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
    }),

    /**
     * Boolean indicating if the appElement should be hidden.
     */
    ariaHideApp: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * One or more `<AppLauncherSection />`s each containing one or more `<AppLauncherTile />`s
     */
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node.isRequired,

    /**
     * Control the open/close state of the App Launcher
     */
    isOpen: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * CSS classes to be added to App Launcher Modal.
     */
    modalClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),

    /**
     * Button that exists in the upper right hand corner of the App Launcher modal
     */
    modalHeaderButton: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,

    /**
     * Allows longer application names without truncating them.
     */
    noTruncate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * Callback when the App Launcher Modal is closed
     */
    onClose: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Search bar for the Modal's header. Will typically be an instance of `design-system-react/input/search`
     */
    search: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,

    /**
     * Set the App Launcher's title text (for localization)
     */
    title: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * This is typically the name of the cloud or application
     */
    triggerName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,

    /**
     * Callback when the App Launcher icon is clicked
     */
    triggerOnClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
  },
  getDefaultProps: function getDefaultProps() {
    return defaultProps;
  },
  getInitialState: function getInitialState() {
    return {
      isOpen: false
    };
  },
  componentWillMount: function componentWillMount() {
    // `checkProps` issues warnings to developers about properties (similar to React's built in development tools)
    Object(__WEBPACK_IMPORTED_MODULE_5__check_props__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_7__utilities_constants__["e" /* APP_LAUNCHER */], this.props);
  },
  openAppLauncher: function openAppLauncher(event) {
    this.setState({
      isOpen: true
    });

    if (__WEBPACK_IMPORTED_MODULE_4_lodash_isfunction___default()(this.props.triggerOnClick)) {
      this.props.triggerOnClick(event, {});
    }
  },
  closeAppLauncher: function closeAppLauncher(event) {
    this.setState({
      isOpen: false
    });

    if (__WEBPACK_IMPORTED_MODULE_4_lodash_isfunction___default()(this.props.onClose)) {
      this.props.onClose(event, {});
    }
  },
  renderSearch: function renderSearch() {
    var _this = this;

    var returnVal;

    if (this.props.search) {
      returnVal = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "slds-app-launcher__header-search",
        ref: function ref(component) {
          if (component) {
            if (!_this.focusedOnSearch) {
              var input = component.querySelector('input');

              if (input) {
                // push to end of stack so click event doesn't blur the focus
                setTimeout(function () {
                  input.focus();
                  _this.focusedOnSearch = true;
                }, 0);
              }
            }
          } else {
            _this.focusedOnSearch = false;
          }
        }
      }, this.props.search);
    }

    return returnVal;
  },
  render: function render() {
    var isOpen = this.props.isOpen !== undefined ? this.props.isOpen : this.state.isOpen; // Should be removed in the future by adding a reset class of some sort.

    var style = this.props.noTruncate ? {
      maxWidth: 'none'
    } : null;
    var customModalHeader = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "slds-grid slds-grid--align-spread slds-grid--vertical-align-center"
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", {
      className: "slds-text-heading--medium"
    }, this.props.title), this.renderSearch(), this.props.modalHeaderButton ? this.props.modalHeaderButton : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: "slds-size--1-of-7"
    })); // Not present in SLDS, but is consistent with other implementations of App Launcher. This also prevents resizing/jumping around when filtering. It will start clipping the modal close button at 600px viewport height.

    var modalContentStaticHeight = '90%';

    var assistiveText = _objectSpread({}, defaultProps.assistiveText, this.props.assistiveText);

    var triggerAssistiveText = this.props.triggerAssistiveText || assistiveText.trigger;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "slds-context-bar__item slds-no-hover",
      style: style
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "slds-context-bar__icon-action"
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
      "aria-haspopup": "true",
      className: "slds-button slds-icon-waffle_container slds-context-bar__button",
      onClick: this.openAppLauncher
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: "slds-icon-waffle"
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: "slds-r1"
    }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: "slds-r2"
    }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: "slds-r3"
    }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: "slds-r4"
    }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: "slds-r5"
    }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: "slds-r6"
    }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: "slds-r7"
    }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: "slds-r8"
    }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: "slds-r9"
    })), triggerAssistiveText && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: "slds-assistive-text"
    }, triggerAssistiveText))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__modal__["a" /* default */], {
      ariaHideApp: this.props.ariaHideApp,
      contentClassName: "slds-modal__content slds-app-launcher__content slds-p-around--medium",
      contentStyle: {
        minHeight: modalContentStaticHeight
      },
      isOpen: isOpen,
      onRequestClose: this.closeAppLauncher,
      containerClassName: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('app-launcher', this.props.modalClassName),
      size: "large",
      header: customModalHeader,
      headerClassName: "slds-app-launcher__header"
    }, this.props.children), this.props.triggerName ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('slds-context-bar__label-action slds-context-bar__app-name', {
        'slds-truncate': !this.props.noTruncate
      })
    }, this.props.triggerName) : null);
  }
});
/* unused harmony default export */ var _unused_webpack_default_export = (AppLauncher);
//# sourceMappingURL=index.js.map

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable import/no-mutable-exports */
// This function will deliver an error message to the browser console when all of the props passed in are undefined (falsey).


var oneOfComponent = function oneOfComponent() {};

if (false) {
  var hasWarned = {};

  oneOfComponent = function oneOfComponent(control, props, propName, allowedComponents, comment) {
    var additionalComment = comment ? " ".concat(comment) : '';
    var componentType;

    if (typeof props[propName].type === 'string') {
      componentType = props[propName].type;
    } else {
      componentType = props[propName].type.displayName;
    }

    var allowedComponentFound = allowedComponents.indexOf(componentType) > -1;

    if (!hasWarned[control]) {
      /* eslint-disable max-len */
      warning(allowedComponentFound, "[Design System React] ".concat(control, " requires that prop '").concat(propName, "' is an instance of one of the following components: ").concat(allowedComponents.join(', '), ". An instance of '").concat(componentType, "' was given.").concat(additionalComment));
      /* eslint-enable max-len */

      hasWarned[control] = !!allowedComponentFound;
    }
  };
}

/* unused harmony default export */ var _unused_webpack_default_export = (oneOfComponent);
//# sourceMappingURL=one-of-component.js.map

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__check_props__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_class_names__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__icon__ = __webpack_require__(9);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// # Avatar Component
// Implements the [Avatar design pattern](https://lightningdesignsystem.com/components/avatar/) in React.
// ### React

 // This component's `checkProps` which issues warnings to developers about properties when in development mode (similar to React's built in development tools)

 // ### classNames
// [github.com/JedWatson/classnames](https://github.com/JedWatson/classnames) A
// simple javascript utility for conditionally joining classNames together.



 // ### Display Name Always use the canonical component name as the React display
// name.

var displayName = __WEBPACK_IMPORTED_MODULE_4__utilities_constants__["f" /* AVATAR */]; // ### Prop Types

var propTypes = {
  /**
   * **Assistive text for accessibility.**
   * This object is merged with the default props object on every render.
   * * `icon`: Assistive text for accessibility that labels the icon.
   */
  assistiveText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),

  /**
   * Class names to be applied to Avatar component.
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Alt attribute to be applied to image (base case) element.
   */
  imgAlt: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Source attribute to be applied to image (base case) element.
   */
  imgSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Initials attribute to optionally pass in initials directly in case of "initials" fallback case.
   */
  initials: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Label attibute to display inside "initials" fallback case. Will be passed as title prop in `abbr` element to provide more specificity.
   */
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Avatar variants to apply relevant styling (circle: user, square: entity) and icon rendering if applicable.
   */
  variant: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['entity', 'user']).isRequired,

  /**
   * Size of the icon in "icon" fallback case.
   */
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['x-small', 'small', 'medium', 'large']).isRequired,

  /**
   * Title attribute for the avatar container.
   */
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
var defaultProps = {
  assistiveText: {
    icon: 'User or Account Icon'
  },
  imgAlt: '',
  size: 'medium',
  title: 'user avatar',
  variant: 'user'
};
/**
 * The avatar component represents an object or entity. An image is the preferred format for an avatar.
 If the `imgSrc` prop is undefined, and if a `label` or `initials` prop is available, the fallback avatar will render with initials. If initals are passed in directly in the `initials` prop, this will render in the fallback avatar. If `initals` prop is unavailable but a `label` prop is available, the fallback avatar will render with built initials of the user name or entity name.

 Intials built from the `label` prop will apply the following logic: If the label name contains two words, like first and last name, the first letter of each will be capitalized and returned. For labels that only have a single word name, the first two letters of that word, using one capital and one lower case letter, will be returned. For labels that contain three or more words, the first character of the first and last words will be capitalized and returned.

 If `initials` or `label` are not available, the fallback avatar will render a standard icon. If `variant='user'`, a user icon will
 render. If `variant='entity'`, an account icon will render.
 */

var Avatar =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Avatar, _React$Component);

  function Avatar(props) {
    var _this;

    _classCallCheck(this, Avatar);

    _this = _possibleConstructorReturn(this, (Avatar.__proto__ || Object.getPrototypeOf(Avatar)).call(this, props));
    _this.state = {
      imgLoadError: false
    };
    return _this;
  }

  _createClass(Avatar, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      Object(__WEBPACK_IMPORTED_MODULE_2__check_props__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__utilities_constants__["f" /* AVATAR */], this.props);
    }
  }, {
    key: "buildInitials",
    value: function buildInitials() {
      var label = this.props.label;
      var name = label.trim();
      var nameParts = name.split(' ');

      if (nameParts.length > 1) {
        return nameParts[0].charAt(0).toUpperCase() + nameParts[nameParts.length - 1].charAt(0).toUpperCase();
      }

      return (name[0] || '').toUpperCase() + (name[1] || '').toLowerCase();
    }
  }, {
    key: "handleImageError",
    value: function handleImageError() {
      return this.setState(function () {
        return {
          imgLoadError: true
        };
      });
    }
  }, {
    key: "renderBaseAvatar",
    value: function renderBaseAvatar() {
      var _this2 = this;

      var _props = this.props,
          imgAlt = _props.imgAlt,
          imgSrc = _props.imgSrc,
          title = _props.title;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        alt: imgAlt,
        src: imgSrc,
        onError: function onError() {
          return _this2.handleImageError();
        },
        title: title
      });
    }
  }, {
    key: "renderIconAvatar",
    value: function renderIconAvatar() {
      var variant = this.props.variant;
      var iconAssistiveText = typeof this.props.assistiveText === 'string' ? this.props.assistiveText : _objectSpread({}, defaultProps.assistiveText, this.props.assistiveText).icon;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__icon__["a" /* default */], {
        assistiveText: {
          label: iconAssistiveText
        },
        category: "standard",
        name: variant === 'entity' ? 'account' : 'user'
      });
    }
  }, {
    key: "renderInitialsAvatar",
    value: function renderInitialsAvatar() {
      var _props2 = this.props,
          initials = _props2.initials,
          label = _props2.label,
          variant = _props2.variant;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("abbr", {
        className: Object(__WEBPACK_IMPORTED_MODULE_3__utilities_class_names__["a" /* default */])('slds-avatar__initials', {
          'slds-icon-standard-account': variant === 'entity',
          'slds-icon-standard-user': variant === 'user'
        }),
        title: label
      }, initials ? initials : this.buildInitials());
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _props3 = this.props,
          imgSrc = _props3.imgSrc,
          initials = _props3.initials,
          variant = _props3.variant,
          label = _props3.label,
          size = _props3.size;

      var renderAvatar = function renderAvatar() {
        /* eslint no-unneeded-ternary: */
        if (!_this3.state.imgLoadError && imgSrc) {
          return _this3.renderBaseAvatar();
        }

        if (initials || label && label.trim()) {
          return _this3.renderInitialsAvatar();
        }

        return _this3.renderIconAvatar();
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: Object(__WEBPACK_IMPORTED_MODULE_3__utilities_class_names__["a" /* default */])('slds-avatar', {
          'slds-avatar_circle': variant === 'user',
          'slds-avatar_x-small': size === 'x-small',
          'slds-avatar_small': size === 'small',
          'slds-avatar_medium': size === 'medium',
          'slds-avatar_large': size === 'large'
        })
      }, renderAvatar()));
    }
  }]);

  return Avatar;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Avatar.defaultProps = defaultProps;
Avatar.displayName = displayName;
Avatar.propTypes = propTypes;
/* unused harmony default export */ var _unused_webpack_default_export = (Avatar);
//# sourceMappingURL=index.js.map

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_assign__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_constants__ = __webpack_require__(2);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// Implements the [Button Group design pattern](https://lightningdesignsystem.com/components/button-groups/) in React.
// Based on SLDS v2.1.1





var propTypes = {
  /**
   * Children are expected to be components. If last button triggers a dropdown menu, use Dropdown instead of Button. _Tested with snapshot testing._
   */
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,

  /**
   * CSS classes added to `slds-button-group` or `slds-checkbox--button-group` tag
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * **Text labels for internationalization**
   * This object is merged with the default props object on every render.
   * * `error`: Message to display when any of Checkboxes are in an error state. _Tested with snapshot testing._
   * * `label`: This label appears above the button group. _Tested with snapshot testing._
   */
  labels: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    error: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),

  /**
   * Use checkbox variant for "Checkbox Button Group" styling and add Checkbox components as children _Tested with snapshot testing._
   */
  variant: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['checkbox'])
};
var defaultProps = {
  labels: {}
};
/**
 * The ButtonGroup component wraps other components (ie. Button, MenuDropdown, PopoverTooltip, Checkboxes, etc).
 */

var ButtonGroup = function ButtonGroup(props) {
  // Merge objects of strings with their default object
  var labels = props ? __WEBPACK_IMPORTED_MODULE_3_lodash_assign___default()({}, defaultProps.labels, props.labels) : defaultProps.labels;
  var children = props.children;
  var zeroIndexLength = __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.count(props.children) - 1;

  if (zeroIndexLength > 0) {
    children = __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(props.children, function (child, index) {
      var newChild;

      if (index === zeroIndexLength) {
        newChild = __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, {
          triggerClassName: 'slds-button--last'
        });
      }

      return newChild || child;
    });
  }

  if (props.variant === 'checkbox') {
    children = __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(props.children, function (child) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, {
        variant: 'button-group'
      });
    });
  }

  if (props.variant === 'checkbox') {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("fieldset", {
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('slds-form-element', {
        'slds-has-error': labels.error
      })
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("legend", {
      className: "slds-form-element__legend slds-form-element__label"
    }, props.labels.label), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "slds-form-element__control"
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('slds-checkbox--button-group', props.className)
    }, children), labels.error ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "slds-form-element__help"
    }, labels.error) : null));
  } // default


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('slds-button-group', props.className),
    role: "group"
  }, children);
};

ButtonGroup.displayName = __WEBPACK_IMPORTED_MODULE_4__utilities_constants__["i" /* BUTTON_GROUP */];
ButtonGroup.propTypes = propTypes;
ButtonGroup.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (ButtonGroup);
//# sourceMappingURL=index.js.map

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isboolean__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isboolean___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isboolean__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isfunction__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isfunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isfunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__check_props__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__icon_button_icon__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utilities_constants__ = __webpack_require__(2);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// Implements the [Button Stateful design pattern](https://lightningdesignsystem.com/components/buttons/#flavor-stateful) in React.
// Based on SLDS v2.1.1
// ## Dependencies
// ### React

 // ### classNames

 // ### isBoolean

 // ### isFunction

 // This component's `checkProps` which issues warnings to developers about properties when in development mode (similar to React's built in development tools)

 // ## Children



var propTypes = {
  /**
   * Specifies the current state of the button. If set, the button will act as a ['controlled' component](https://facebook.github.io/react/docs/forms.html#controlled-components).
   */
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * **Assistive text for accessibility.**
   * This object is merged with the default props object on every render.
   * * `icon`: Text that is visually hidden but read aloud by screenreaders to tell the user what the icon means. This should also include the state of the button. If the button has an icon and a visible label, you can omit the <code>icon</code> prop and use the <code>label</code> prop.
   */
  assistiveText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),

  /**
   * Disables the button and adds disabled styling.
   */
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Name of the icon. Visit <a href='http://www.lightningdesignsystem.com/resources/icons'>Lightning Design System Icons</a> to reference icon names.
   */
  iconName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Determines the size of the icon.
   */
  iconSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['x-small', 'small', 'medium', 'large']),

  /**
   * If true, button/icon is white. Meant for buttons or utility icons on dark backgrounds.
   */
  inverse: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Triggered when focus is removed.
   */
  onBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Triggered when the button is clicked.
   */
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Triggered when component is focused.
   */
  onFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Triggered when a key is pressed down
   */
  onKeyDown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Triggered when a key is pressed and released
   */
  onKeyPress: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Triggered when a key is released
   */
  onKeyUp: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Triggered when a mouse button is pressed down
   */
  onMouseDown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Triggered when a mouse arrow hovers
   */
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Triggered when a mouse arrow no longer hovers
   */
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * If true, button scales to 100% width on small form factors.
   */
  responsive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Initial label and icon (optional) of button.
   */
  stateOne: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * Selected label and icon (optional) of button.
   */
  stateTwo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * Deselect label and icon (optional) of button.
   */
  stateThree: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * Write "-1" if you don't want the user to tab to the button.
   */
  tabIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * [Deprecated] Tooltip on button. Button should be a child of `Tooltip` instead.
   */
  tooltip: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * Different types of buttons
   */
  variant: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['base', 'neutral', 'brand', 'destructive', 'icon'])
}; // i18n

var defaultProps = {
  assistiveText: {
    icon: ''
  },
  disabled: false,
  iconSize: 'medium',
  responsive: false,
  stateOne: {
    iconName: 'add',
    label: 'Follow'
  },
  stateTwo: {
    iconName: 'check',
    label: 'Following'
  },
  stateThree: {
    iconName: 'close',
    label: 'Unfollow'
  }
};
/**
 * The ButtonStateful component is a variant of the Lightning Design System Button component. It is used for buttons that have a state of unselected or selected.
 * For icon buttons, use <code>variant='icon'</code>. For buttons with labels or buttons with labels and icons, pass data to the state props (ie. <code>stateOne={{iconName: 'add', label: 'Join'}}</code>).
 */

var ButtonStateful =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ButtonStateful, _React$Component);

  function ButtonStateful(props) {
    var _this;

    _classCallCheck(this, ButtonStateful);

    _this = _possibleConstructorReturn(this, (ButtonStateful.__proto__ || Object.getPrototypeOf(ButtonStateful)).call(this, props));
    Object.defineProperty(_assertThisInitialized(_this), "handleBlur", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(e) {
        if (_this.props.onBlur) _this.props.onBlur(e);
        e.currentTarget.blur();
      }
    });
    Object.defineProperty(_assertThisInitialized(_this), "handleClick", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(e) {
        if (__WEBPACK_IMPORTED_MODULE_4_lodash_isfunction___default()(_this.props.onClick)) _this.props.onClick(e);

        if (!__WEBPACK_IMPORTED_MODULE_3_lodash_isboolean___default()(_this.props.active)) {
          _this.setState({
            active: !_this.state.active
          });
        }
      }
    });
    _this.state = {
      active: false
    };
    return _this;
  }

  _createClass(ButtonStateful, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      Object(__WEBPACK_IMPORTED_MODULE_5__check_props__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_7__utilities_constants__["k" /* BUTTON_STATEFUL */], this.props);
    }
  }, {
    key: "getClassName",
    value: function getClassName(active) {
      return __WEBPACK_IMPORTED_MODULE_2_classnames___default()(this.props.className, 'slds-button', {
        'slds-button--neutral': this.props.variant !== 'icon',
        'slds-button--inverse': this.props.variant === 'inverse',
        'slds-not-selected': !active,
        'slds-is-selected': active,
        'slds-max-small-button--stretch': this.props.responsive,
        'slds-button--icon-border': this.props.variant === 'icon'
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          active = _props.active,
          disabled = _props.disabled,
          iconName = _props.iconName,
          iconSize = _props.iconSize,
          id = _props.id,
          onFocus = _props.onFocus,
          onKeyDown = _props.onKeyDown,
          onKeyPress = _props.onKeyPress,
          onKeyUp = _props.onKeyUp,
          onMouseDown = _props.onMouseDown,
          onMouseEnter = _props.onMouseEnter,
          stateOne = _props.stateOne,
          stateTwo = _props.stateTwo,
          stateThree = _props.stateThree,
          tabIndex = _props.tabIndex,
          variant = _props.variant;
      var iconAssistiveText = typeof this.props.assistiveText === 'string' ? this.props.assistiveText : _objectSpread({}, defaultProps.assistiveText, this.props.assistiveText).icon;
      var isActive = __WEBPACK_IMPORTED_MODULE_3_lodash_isboolean___default()(active) ? active : this.state.active;

      if (variant === 'icon') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
          "aria-live": "polite",
          className: this.getClassName(isActive),
          disabled: disabled,
          id: id,
          onBlur: this.handleBlur,
          onClick: this.handleClick,
          onFocus: onFocus,
          onKeyDown: onKeyDown,
          onKeyPress: onKeyPress,
          onKeyUp: onKeyUp,
          onMouseDown: onMouseDown,
          onMouseEnter: onMouseEnter,
          onMouseLeave: this.handleBlur,
          tabIndex: tabIndex
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__icon_button_icon__["a" /* default */], {
          disabled: disabled,
          name: iconName,
          size: iconSize,
          className: "slds-button__icon--stateful"
        }), iconAssistiveText ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
          className: "slds-assistive-text"
        }, iconAssistiveText) : null);
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        "aria-live": "assertive",
        className: this.getClassName(isActive),
        disabled: disabled,
        id: id,
        onBlur: this.handleBlur,
        onClick: this.handleClick,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onKeyPress: onKeyPress,
        onKeyUp: onKeyUp,
        onMouseEnter: onMouseEnter,
        onMouseLeave: this.handleBlur,
        tabIndex: tabIndex
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "slds-text-not-selected"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__icon_button_icon__["a" /* default */], {
        disabled: disabled,
        name: stateOne.iconName,
        size: "small",
        position: "left",
        className: "slds-button__icon--stateful"
      }), stateOne.label), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "slds-text-selected"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__icon_button_icon__["a" /* default */], {
        disabled: disabled,
        name: stateTwo.iconName,
        size: "small",
        position: "left",
        className: "slds-button__icon--stateful"
      }), stateTwo.label), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "slds-text-selected-focus"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__icon_button_icon__["a" /* default */], {
        disabled: disabled,
        name: stateThree.iconName,
        size: "small",
        position: "left",
        className: "slds-button__icon--stateful"
      }), stateThree.label));
    }
  }]);

  return ButtonStateful;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ButtonStateful.displayName = __WEBPACK_IMPORTED_MODULE_7__utilities_constants__["k" /* BUTTON_STATEFUL */];
ButtonStateful.propTypes = propTypes;
ButtonStateful.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (ButtonStateful);
//# sourceMappingURL=index.js.map

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export idSuffixes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__private_header__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__private_body__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__private_footer__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__empty__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utilities_constants__ = __webpack_require__(2);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// # Card Component
// Implements the [Card design pattern](https://www.lightningdesignsystem.com/components/cards/) in React.
// Based on SLDS v2.2.1
// ### React

 // ### classNames
// [github.com/JedWatson/classnames](https://github.com/JedWatson/classnames)
// This project uses `classnames`, "a simple javascript utility for conditionally
// joining classNames together."

 // ## Children






var idSuffixes = {
  body: '__body',
  headerActions: '__header-actions',
  heading: '__heading',
  filter: '__filter-input'
};
/**
 * Cards are used to apply a container around a related grouping of information. It has a header, a body, and an optional footer. It often contains a DataTable or Tile (coming soon). Actions associated with selected items or with all items are included within the header actions. Footer often contains pagination.
 */

var Card = function Card(props) {
  var bodyId = props.id ? props.id + idSuffixes.body : null;
  var filterId = props.id ? props.id + idSuffixes.filter : null;
  var headingId = props.id ? props.id + idSuffixes.heading : null;
  var headerActionsId = props.id ? props.id + idSuffixes.headerActions : null;
  var empty = props.empty;

  if (empty === true) {
    // Can be overridden by passing in a node to the empty prop
    empty = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__empty__["a" /* default */], {
      id: props.id,
      heading: props.heading
    });
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("article", {
    id: props.id,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('slds-card', props.className),
    style: props.style
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__private_header__["a" /* default */], {
    header: props.header,
    headingId: headingId,
    icon: props.icon,
    filter: props.filter,
    filterId: filterId,
    heading: props.heading,
    headerActions: props.headerActions,
    headerActionsId: headerActionsId
  }), !empty ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__private_body__["a" /* default */], {
    id: bodyId,
    className: props.bodyClassName
  }, props.children) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__private_body__["a" /* default */], {
    id: bodyId,
    className: props.bodyClassName
  }, empty), props.footer ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__private_footer__["a" /* default */], null, props.footer) : null);
}; // ### Display Name
// Always use the canonical component name as the React display name.


Card.displayName = __WEBPACK_IMPORTED_MODULE_7__utilities_constants__["l" /* CARD */];
Card.defaultProps = {
  heading: 'Related Items'
}; // ### Prop Types

Card.propTypes = {
  /**
   * CSS classes to be added to the card body (wraps children).
   */
  bodyClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * The main section of the card. It often contains a `DataTable` or `Tile`.
   */
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * CSS classes to be added to the card.
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * Replaces the body (that is the children) with the specified empty state, this will also remove header actions, the filter, and the icon. If the default empty state is wanted, set to `true`.
   */
  empty: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]),

  /**
   * Adds a filter input to the card header.
   */
  filter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * Footer often contains pagination.
   */
  footer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * Allows a custom header (the media object with the icon in the first column). `icon`, `heading` and other props are passed into the media object from Card if present. Use `design-system-react/components/media-object` to create your own custom header.
   */
  header: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * The heading is the name of the related item group and should only contain inline elements.
   */
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired,

  /**
   * Actions to perform on selected items or actions that are not specific to one item such as adding an item. If no group actions are needed, then the number of selected items is often present.
   */
  headerActions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * Icon associated with the items within the `body`.
   */
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * Set the HTML `id` of the card. This also sets the `id` of the filter and the header actions.
   */
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Custom styles to be added to the card.
   */
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
/* unused harmony default export */ var _unused_webpack_default_export = (Card);

//# sourceMappingURL=index.js.map

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__input__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__icon_input_icon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_constants__ = __webpack_require__(2);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// ### React





/**
 * A default filter or search input for Cards that contain items.
 */

var Filter = function Filter(props) {
  var id = props.id,
      placeholder = props.placeholder,
      onChange = props.onChange,
      rest = _objectWithoutProperties(props, ["id", "placeholder", "onChange"]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__input__["a" /* default */], _extends({}, rest, {
    assistiveText: {
      label: placeholder
    },
    iconLeft: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__icon_input_icon__["a" /* default */], {
      name: "search",
      category: "utility"
    }),
    id: id,
    onChange: onChange,
    placeholder: placeholder
  }));
}; // ### Display Name
// Always use the canonical component name as the React display name.


Filter.displayName = __WEBPACK_IMPORTED_MODULE_4__utilities_constants__["o" /* CARD_FILTER */]; // ### Prop Types

Filter.propTypes = {
  /**
   * The HTML `id` from the card with a suffixe.
   */
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * This callback fires when the input changes.
   */
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Text present in input until the user enters text. This text will also be used for a visually hidden label on the filter `input` element for accessibility.
   */
  placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};
Filter.defaultProps = {
  placeholder: 'Find in List'
};
/* unused harmony default export */ var _unused_webpack_default_export = (Filter);
//# sourceMappingURL=filter.js.map

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_spinner__ = __webpack_require__(51);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable jsx-a11y/aria-activedescendant-has-tabindex */
// ### React




var propTypes = {
  'aria-activedescendant': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  'aria-autocomplete': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * An HTML ID that is shared with ARIA-supported devices with the
   * `aria-controls` attribute in order to relate the input with
   * another region of the page. An example would be a select box
   * that shows or hides a panel.
   */
  'aria-controls': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  'aria-describedby': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  'aria-expanded': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  'aria-haspopup': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  'aria-labelledby': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * An HTML ID that is shared with ARIA-supported devices with the
   * `aria-controls` attribute in order to relate the input with
   * another region of the page. An example would be a search field
   * that shows search results.
   */
  'aria-owns': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  'aria-required': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * **Assistive text for accessibility.**
   * This object is merged with the default props object on every render.
   * * `spinner`: Assistive text on the spinner.
   */
  assistiveText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    spinner: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),

  /**
   * Disabled brower's autocomplete when "off" is used.
   */
  autoComplete: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Class names to be added to the `input` element.
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * Class names to be added to the outer container `div` of the input.
   */
  containerClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * Props to be added to the outer container `div` of the input (excluding `containerClassName`).
   */
  containerProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * Disables the input and prevents editing the contents.
   */
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Displays text or node to the left of the input. This follows the fixed text input UX pattern.
   */
  fixedTextLeft: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * Displays text or node to the right of the input. This follows the fixed text input UX pattern.
   */
  fixedTextRight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * If true, loading spinner appears inside input on right hand side.
   */
  hasSpinner: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Left aligned icon, must be instance of `design-system-react/components/icon/input-icon`
   */
  iconLeft: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * Right aligned icon, must be instance of `design-system-react/components/icon/input-icon`
   */
  iconRight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * Every input must have a unique ID in order to support keyboard navigation and ARIA support.
   */
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,

  /**
   * Displays help text under the input.
   */
  inlineHelpText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * This callback exposes the input reference / DOM node to parent components. `<Parent inputRef={(inputComponent) => this.input = inputComponent} />
   */
  inputRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Displays the value of the input statically. This follows the static input UX pattern.
   */
  isStatic: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * This label appears above the input.
   */
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * This callback fires when the input changes. The synthetic React event will be the first parameter to the callback. You will probably want to reference `event.target.value` in your callback. No custom data object is provided.
   */
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * This event fires when the input is clicked.
   */
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onInput: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onInvalid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onKeyDown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onKeyPress: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onKeyUp: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Text that will appear in an empty input.
   */
  placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  minLength: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  maxLength: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Name of the submitted form parameter.
   */
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Specifies `readOnly` for `input` node.
   */
  readOnly: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Highlights the input as a required field (does not perform any validation).
   */
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * `role` to be added to `input` node
   */
  role: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Style object to be added to `input` node
   */
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * Specifies `tabIndex` for `input` node
   */
  tabIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * The `<Input>` element includes support for all HTML5 types.
   */
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['text', 'password', 'datetime', 'datetime-local', 'date', 'month', 'time', 'week', 'number', 'email', 'url', 'search', 'tel', 'color']),

  /**
   * The input is a controlled component, and will always display this value.
   */
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * This is the initial value of an uncontrolled form element and is present only to provide
   * compatibility with hybrid framework applications that are not entirely React. It should only
   * be used in an application without centralized state (Redux, Flux). "Controlled components"
   * with centralized state is highly recommended.
   * See [Code Overview](https://github.com/salesforce/design-system-react/blob/master/docs/codebase-overview.md#controlled-and-uncontrolled-components) for more information.
   */
  defaultValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
var defaultProps = {
  assistiveText: {
    spinner: 'Loading ...'
  },
  type: 'text'
};
/*
 * This component was created to allow the DIV wrapped input to be used within other components such as combobox. This components API is not public.
 */

var InnerInput = function InnerInput(props) {
  var _props$containerProps = props.containerProps,
      containerClassName = _props$containerProps.className,
      containerProps = _objectWithoutProperties(_props$containerProps, ["className"]);

  var assistiveText = _objectSpread({}, defaultProps.assistiveText, props.assistiveText);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(containerClassName, {
      'slds-input-has-icon': props.iconLeft || props.iconRight,
      'slds-input-has-icon_left': props.iconLeft && !props.iconRight,
      'slds-input-has-icon_right': !props.iconLeft && props.iconRight,
      'slds-input-has-icon_left-right': props.iconLeft && props.iconRight,
      'slds-input-has-fixed-addon': props.fixedTextLeft || props.fixedTextRight,
      'slds-has-divider--bottom': props.isStatic
    })
  }, containerProps), props.iconLeft && props.iconLeft, props.fixedTextLeft && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "slds-form-element__addon"
  }, props.fixedTextLeft), !props.isStatic && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
    "aria-activedescendant": props['aria-activedescendant'],
    "aria-autocomplete": props['aria-autocomplete'],
    "aria-controls": props['aria-controls'],
    "aria-labelledby": props['aria-labelledby'],
    "aria-describedby": props.hasSpinner ? "loading-status-icon ".concat(props['aria-describedby']) : props['aria-describedby'],
    "aria-expanded": props['aria-expanded'],
    "aria-owns": props['aria-owns'],
    "aria-required": props['aria-required'],
    autoComplete: props.autoComplete,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('slds-input', props.className),
    disabled: props.disabled,
    id: props.id,
    minLength: props.minLength,
    maxLength: props.maxLength,
    name: props.name,
    onBlur: props.onBlur,
    onChange: props.onChange,
    onClick: props.onClick,
    onFocus: props.onFocus,
    onInput: props.onInput,
    onInvalid: props.onInvalid,
    onKeyDown: props.onKeyDown,
    onKeyPress: props.onKeyPress,
    onKeyUp: props.onKeyUp,
    onSelect: props.onSelect,
    onSubmit: props.onSubmit,
    placeholder: props.placeholder,
    readOnly: props.readOnly,
    ref: props.inputRef,
    required: props.required,
    role: props.role,
    style: props.style,
    tabIndex: props.tabIndex,
    type: props.type,
    value: props.value,
    defaultValue: props.defaultValue
  }), props.hasSpinner ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "slds-input__icon-group slds-input__icon-group_right"
  }, props.hasSpinner && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_spinner__["a" /* default */], {
    assistiveText: {
      label: assistiveText.spinner
    },
    id: "loading-status-icon",
    isInput: true,
    size: "x-small",
    variant: "brand"
  }), props.iconRight && props.iconRight) : props.iconRight && props.iconRight, props.fixedTextRight && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "slds-form-element__addon"
  }, props.fixedTextRight), props.isStatic && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "slds-form-element__static slds-grid slds-grid_align-spread",
    onClick: props.onClick
  }, props.value, props.inlineEditTrigger), props.inlineHelpText && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "slds-form-element__help"
  }, props.inlineHelpText));
};

InnerInput.displayName = 'SLDSInnerInput';
InnerInput.propTypes = propTypes;
InnerInput.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (InnerInput);
//# sourceMappingURL=inner-input.js.map

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_warning_deprecated_property__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities_warning_sunset_property__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_warning_only_one_of_properties__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_constants__ = __webpack_require__(2);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable import/no-mutable-exports */

/* eslint-disable max-len */

 // import oneOfRequiredProperty from '../../../utilities/warning/one-of-required-property';




var checkProps = function checkProps() {};

if (false) {
  checkProps = function checkProps(COMPONENT, props) {
    if (COMPONENT === INPUT) {
      // Deprecated and changed to another property
      deprecatedProperty(COMPONENT, props.iconCategory, 'iconCategory', undefined, 'Please use `iconLeft` and `iconRight` to pass in a customized <Icon> component.');
      deprecatedProperty(COMPONENT, props.iconName, 'iconName', undefined, 'Please use `iconLeft` and `iconRight` to pass in a customized <Icon> component');
      deprecatedProperty(COMPONENT, props.iconPosition, 'iconPosition', undefined, 'Please use `iconLeft` and `iconRight` to pass in a customized <Icon> component');
      deprecatedProperty(COMPONENT, props.iconAssistiveText, 'iconAssistiveText', undefined, 'Please use `iconLeft` and `iconRight` to pass in a customized <Icon> component');
      deprecatedProperty(COMPONENT, props.onIconClick, 'onIconClick', undefined, 'Please use `iconLeft` and `iconRight` to pass in a customized <Icon> component');

      if (typeof props.assistiveText === 'string') {
        sunsetProperty(COMPONENT, props.assistiveText, 'assistiveText', 'AssistiveText as a string has been deprecated and is now an object to allow for multiple uses in the component. Please use either assistiveText.label or assistiveText.spinner');
      }

      onlyOneOfProperties(COMPONENT, {
        'assistiveText.label': props.assistiveText && props.assistiveText.label,
        label: props.label
      });
      onlyOneOfProperties(COMPONENT, {
        fixedTextLeft: props.fixedTextLeft,
        fixedTextRight: props.fixedTextRight
      });
      /*
      * Once we support horizontal labels, then I think we can enable this check
      *
      if (!props.inlineEditTrigger) {
      	oneOfRequiredProperty(COMPONENT, {
      		assistiveText: props.assistiveText,
      		label: props.label
      	});
      }
      */
    } else if (COMPONENT === SEARCH) {
      if (typeof props.assistiveText === 'string') {
        sunsetProperty(COMPONENT, props.assistiveText, 'assistiveText', '`assistiveText` as a string has been deprecated and is now an object to allow for multiple uses in the component. Please use `assistiveText.label` instead.');
      }
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (checkProps);
//# sourceMappingURL=check-props.js.map

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__checkbox__ = __webpack_require__(53);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
 // Alias



var OldCheckbox = function OldCheckbox(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__checkbox__["a" /* default */], _extends({
    oldEventParameterOrder: true
  }, props));
};

/* harmony default export */ __webpack_exports__["a"] = (OldCheckbox);
//# sourceMappingURL=index.js.map

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_onclickoutside__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combobox__ = __webpack_require__(97);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// ### onClickOutside
// Listen for clicks that occur somewhere in the document, outside of the element itself


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_onclickoutside__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__combobox__["a" /* default */]));
//# sourceMappingURL=index.js.map

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_assign__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_find__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_reject__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_reject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_reject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isequal__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_isequal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_findindex__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_findindex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_findindex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isboolean__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isboolean___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_isboolean__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isfunction__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isfunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_isfunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shortid__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shortid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_shortid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utilities_dialog__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_input_private_inner_input__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__icon_input_icon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__private_menu__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__forms_private_label__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__private_selected_listbox__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utilities_key_code__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utilities_key_callbacks__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__check_props__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utilities_constants__ = __webpack_require__(2);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable jsx-a11y/role-has-required-aria-props */





















var currentOpenDropdown;
var propTypes = {
  /**
   * **Assistive text for accessibility**
   * This object is merged with the default props object on every render.
   * * `label`: This is used as a visually hidden label if, no `labels.label` is provided.
   * * `optionSelectedInMenu`: Added before selected menu items in Read-only variants (Picklists). The default is `Current Selection:`.
   * * `removeSingleSelectedOption`: Used by inline-listbox, single-select variant to remove the selected item (pill). This is a button with focus. The default is `Remove selected option`.
   * * `removePill`: Used by multiple selection Comboboxes to remove a selected item (pill). Focus is on the pill. This is not a button. The default  is `, Press delete or backspace to remove`.
   * * `selectedListboxLabel`: This is a label for the selected listbox. The grouping of pills for multiple selection Comboboxes. The default is `Selected Options:`.
   * _Tested with snapshot testing._
   */
  assistiveText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    optionSelectedInMenu: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    removeSingleSelectedOption: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    removePill: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    selectedListboxLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),

  /**
   * The `aria-describedby` attribute is used to indicate the IDs of the elements that describe the object. It is used to establish a relationship between widgets or groups and text that described them.
   * This is very similar to aria-labelledby: a label describes the essence of an object, while a description provides more information that the user might need. _Tested with snapshot testing._
   */
  'aria-describedby': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * CSS classes to be added to tag with `.slds-combobox`. Uses `classNames` [API](https://github.com/JedWatson/classnames). _Tested with snapshot testing._
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * CSS classes to be added to top level tag with `.slds-form-element` and not on `.slds-combobox_container`. Uses `classNames` [API](https://github.com/JedWatson/classnames). _Tested with snapshot testing._
   */
  classNameContainer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * CSS classes to be added to tag with `.slds-dropdown`. Uses `classNames` [API](https://github.com/JedWatson/classnames). Autocomplete/bass variant menu height should not scroll and should be determined by number items which should be no more than 10. _Tested with snapshot testing._
   */
  classNameMenu: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * CSS classes to be added to tag with `.slds-dropdown__header`. Uses `classNames` [API](https://github.com/JedWatson/classnames).
   */
  classNameMenuSubHeader: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * Event Callbacks
   * * `onBlur`: Called when `input` removes focus.
   * * `onChange`: Called when keyboard events occur within `input`
   * * `onClose`: Triggered when the menu has closed.
   * * `onFocus`: Called when `input` receives focus.
   * * `onOpen`: Triggered when the menu has opened.
   * * `onRequestClose`: Function called when the menu would like to hide. Please use with `isOpen`.
   * * `onRequestOpen`:  Function called when the menu would like to show. Please use with `isOpen`.
   * * `onRequestRemoveSelectedOption`: Function called when a single selection option is to be removed.
   * * `onSelect`: Function called when a menu item is selected
   * * `onSubmit`: Function called when user presses enter or submits the `input`
   * _Tested with Mocha testing._
   */
  events: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    onBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    onFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    onOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    onRequestClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    onRequestOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    onRequestRemoveSelectedOption: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    onSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    onSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  }),

  /**
   * Message to display when the input is in an error state. When this is present, also visually highlights the component as in error. _Tested with snapshot testing._
   */
  errorText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * By default, dialogs will flip their alignment (such as bottom to top) if they extend beyond a boundary element such as a scrolling parent or a window/viewpoint. `hasStaticAlignment` disables this behavior and allows this component to extend beyond boundary elements. _Not tested._
   */
  hasStaticAlignment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * HTML id for component. _Tested with snapshot testing._
   */
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * **Text labels for internationalization**
   * This object is merged with the default props object on every render.
   * * `label`: This label appears above the input.
   * * `multipleOptionsSelected`: This label is used by the readonly variant when multiple options are selected. The default is `${props.selection.length} options selected`. This will override the entire string.
   * * `noOptionsFound`: Custom message that renders when no matches found. The default empty state is just text that says, 'No matches found.'.
   * * `placeholder`: Input placeholder
   * * `placeholderReadOnly`: Placeholder for Picklist-like Combobox
   * * `removePillTitle`: Title on `X` icon
   * _Tested with snapshot testing._
   */
  labels: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
    multipleOptionsSelected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    noOptionsFound: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
    placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    placeholderReadOnly: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    removePillTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),

  /**
   * Forces the dropdown to be open or closed. See controlled/uncontrolled callback/prop pattern for more on suggested use view [Concepts and Best Practices](https://github.com/salesforce-ux/design-system-react/blob/master/CONTRIBUTING.md#concepts-and-best-practices) _Tested with snapshot testing._
   */
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Sets the dialog width to the width of one of the following:
   * * `target`: Sets the dialog width to the width of the target. (Menus attached to `input` typically follow this UX pattern),
   * * `menu`: Consider setting a `menuMaxWidth` if using this value. If not, width will be set to width of largest menu item.
   * * `none`: Does not set a width on the dialog. _Tested with snapshot testing._
   */
  inheritWidthOf: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['target', 'menu', 'none']),

  /**
   * Accepts a custom menu item rendering function that becomes a custom component. It should return a React node. The checkmark is still rendered in readonly variants. This function is passed the following props:
   * * `assistiveText`: Object, `assistiveText` prop that is passed into Combobox
   * * `option`: Object, option data for item being rendered that is passed into Combobox
   * * `selected`: Boolean, allows rendering of `assistiveText.optionSelectedInMenu` in Readonly Combobox
   *
   * _Tested with snapshot testing._
   */
  menuItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Please select one of the following:
   * * `absolute` - (default) The dialog will use `position: absolute` and style attributes to position itself. This allows inverted placement or flipping of the dialog.
   * * `overflowBoundaryElement` - The dialog will overflow scrolling parents. Use on elements that are aligned to the left or right of their target and don't care about the target being within a scrolling parent. Typically this is a popover or tooltip. Dropdown menus can usually open up and down if no room exists. In order to achieve this a portal element will be created and attached to `body`. This element will render into that detached render tree.
   * * `relative` - No styling or portals will be used. Menus will be positioned relative to their triggers. This is a great choice for HTML snapshot testing.
   */
  menuPosition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['absolute', 'overflowBoundaryElement', 'relative']),

  /**
   * Sets a maximum width that the menu will be used if `inheritWidthOf` is set to `menu`. (Example: 500px) _Tested with snapshot testing._
   *
   */
  menuMaxWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Allows multiple selections _Tested with mocha testing._
   */
  multiple: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * **Array of item objects in the dropdown menu.**
   * Each object can contain:
   * * `icon`: An `Icon` component. (not used in read-only variant)
   * * `id`: A unique identifier string.
   * * `label`: A primary string of text for a menu item or group separator.
   * * `subTitle`: A secondary string of text added for clarity. (optional)
   * * `type`: 'separator' is the only type currently used
   * ```
   * {
   * 	id: '2',
   * 	label: 'Salesforce.com, Inc.',
   * 	subTitle: 'Account • San Francisco',
   * 	type: 'account',
   * },
   * ```
   * Note: At the moment, Combobox does not support two consecutive separators. _Tested with snapshot testing._
   */
  options: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.PropTypes.shape({
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    subTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  })).isRequired,

  /**
   * Determines the height of the menu based on SLDS CSS classes. This only applies to the readonly variant. This is a `number`.
   */
  readOnlyMenuItemVisibleLength: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([5, 7, 10]),

  /**
   * Limits auto-complete input submission to one of the provided options. _Tested with mocha testing._
   */
  predefinedOptionsOnly: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Applies label styling for a required form element. _Tested with snapshot testing._
   */
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Accepts an array of item objects. For single selection, pass in an array of one object. For item object keys, see `options` prop. _Tested with snapshot testing._
   */
  selection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.PropTypes.shape({
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    subTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  })).isRequired,

  /**
   * Value of input. _This is a controlled component,_ so you will need to control the input value by passing the `value` from `onChange` to a parent component or state manager, and then pass it back into the componet with this prop. Please see examples for more clarification. _Tested with snapshot testing._
   */
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Changes styles of the input. Currently `entity` is not supported. _Tested with snapshot testing._
   */
  variant: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['base', 'inline-listbox', 'readonly'])
};
var defaultProps = {
  assistiveText: {
    optionSelectedInMenu: 'Current Selection:',
    removeSingleSelectedOption: 'Remove selected option',
    removePill: ', Press delete or backspace to remove',
    selectedListboxLabel: 'Selected Options:'
  },
  events: {},
  labels: {
    noOptionsFound: 'No matches found.',
    placeholderReadOnly: 'Select an Option',
    removePillTitle: 'Remove'
  },
  inheritWidthOf: 'target',
  menuPosition: 'absolute',
  readOnlyMenuItemVisibleLength: 5,
  required: false,
  selection: [],
  variant: 'base'
};
/**
 * A widget that provides a user with an input field that is either an autocomplete or readonly, accompanied with a listbox of pre-definfined options.
 */

var Combobox =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Combobox, _React$Component);

  function Combobox(props) {
    var _this;

    _classCallCheck(this, Combobox);

    _this = _possibleConstructorReturn(this, (Combobox.__proto__ || Object.getPrototypeOf(Combobox)).call(this, props));

    _initialiseProps.call(_assertThisInitialized(_this));

    _this.state = {
      isOpen: false,
      activeOption: undefined,
      activeOptionIndex: -1,
      // seeding initial state with this.props.selection[0]
      activeSelectedOption: _this.props.selection && _this.props.selection[0] || undefined,
      activeSelectedOptionIndex: 0
    };
    return _this;
  }
  /**
   * Lifecycle methods
   */


  _createClass(Combobox, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      // `checkProps` issues warnings to developers about properties (similar to React's built in development tools)
      Object(__WEBPACK_IMPORTED_MODULE_19__check_props__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_20__utilities_constants__["s" /* COMBOBOX */], this.props);
      this.generatedId = __WEBPACK_IMPORTED_MODULE_10_shortid___default.a.generate();

      if (this.props.errorText) {
        this.generatedErrorId = __WEBPACK_IMPORTED_MODULE_10_shortid___default.a.generate();
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      // This logic will maintain the active highlight even when the
      // option order changes. One example would be the server pushes
      // data out as the user has the menu open. This logic clears
      // `activeOption` if the active option is no longer in the options
      // list. If it's in the options list, then find the new index and
      // set `activeOptionIndex`
      if (!__WEBPACK_IMPORTED_MODULE_5_lodash_isequal___default()(this.props.options, nextProps.options)) {
        var index = __WEBPACK_IMPORTED_MODULE_6_lodash_findindex___default()(nextProps.options, function (item) {
          return __WEBPACK_IMPORTED_MODULE_5_lodash_isequal___default()(item, _this2.state.activeOption);
        });

        if (index !== -1) {
          this.setState({
            activeOptionIndex: index
          });
        } else {
          this.setState({
            activeOption: undefined,
            activeOptionIndex: -1
          });
        }
      } else if (this.props.isOpen !== nextProps.isOpen) {
        this.setState({
          isOpen: nextProps.isOpen
        });
      } // there may be issues with tabindex/focus if the app removes an item
      // from selection while the user is using the listbox


      var selectedOptionsRenderIsInitialRender = this.props.selection && this.props.selection.length === 0 && nextProps.selection.length > 0;

      if (selectedOptionsRenderIsInitialRender) {
        this.setState({
          activeSelectedOption: nextProps.selection[0],
          activeSelectedOptionIndex: 0
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (currentOpenDropdown === this) {
        currentOpenDropdown = undefined;
      }
    }
  }, {
    key: "getDialog",
    value: function getDialog(_ref) {
      var menuRenderer = _ref.menuRenderer;
      // FOR BACKWARDS COMPATIBILITY
      var menuPosition = this.props.isInline ? 'relative' : this.props.menuPosition; // eslint-disable-line react/prop-types

      return !this.props.disabled && this.getIsOpen() ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__utilities_dialog__["a" /* default */], {
        align: "bottom left",
        context: this.context,
        hasStaticAlignment: this.props.hasStaticAlignment,
        inheritWidthOf: this.props.inheritWidthOf,
        onClose: this.handleClose,
        onOpen: this.handleOpen,
        onRequestTargetElement: this.getTargetElement,
        position: menuPosition,
        containerProps: {
          id: "".concat(this.getId(), "-listbox"),
          role: 'listbox'
        }
      }, menuRenderer) : null;
    }
  }, {
    key: "getErrorId",
    value: function getErrorId() {
      return this.props['aria-describedby'] || this.generatedErrorId;
    }
    /**
     * Shared class property getter methods
     */

  }, {
    key: "render",
    value: function render() {
      var props = this.props; // Merge objects of strings with their default object

      var assistiveText = __WEBPACK_IMPORTED_MODULE_2_lodash_assign___default()({}, defaultProps.assistiveText, props.assistiveText);
      var labels = __WEBPACK_IMPORTED_MODULE_2_lodash_assign___default()({}, defaultProps.labels, this.props.labels);
      var subRenderParameters = {
        assistiveText: assistiveText,
        labels: labels,
        props: this.props
      };
      var multipleOrSingle = this.props.multiple ? 'multiple' : 'single';
      var subRenders = {
        base: {
          multiple: this.renderBase,
          // same
          single: this.renderBase
        },
        'inline-listbox': {
          multiple: this.renderInlineMultiple,
          single: this.renderInlineSingle
        },
        readonly: {
          multiple: this.renderReadOnlyMultiple,
          single: this.renderReadOnlySingle
        }
      };
      var variantExists = subRenders[this.props.variant][multipleOrSingle];
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: __WEBPACK_IMPORTED_MODULE_9_classnames___default()('slds-form-element', props.classNameContainer)
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__forms_private_label__["a" /* default */], {
        assistiveText: this.props.assistiveText,
        htmlFor: this.getId(),
        label: labels.label,
        required: props.required
      }), variantExists ? subRenders[this.props.variant][multipleOrSingle](subRenderParameters) : subRenders.base.multiple(subRenderParameters));
    }
  }]);

  return Combobox;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);
/* eslint-enable jsx-a11y/role-supports-aria-props */


var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  Object.defineProperty(this, "getId", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value() {
      return _this3.props.id || _this3.generatedId;
    }
  });
  Object.defineProperty(this, "getIsActiveOption", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value() {
      return _this3.state.activeOption && _this3.state.activeOptionIndex !== -1;
    }
  });
  Object.defineProperty(this, "getIsOpen", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value() {
      return !!(__WEBPACK_IMPORTED_MODULE_7_lodash_isboolean___default()(_this3.props.isOpen) ? _this3.props.isOpen : _this3.state.isOpen);
    }
  });
  Object.defineProperty(this, "getNewActiveOptionIndex", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(_ref2) {
      var activeOptionIndex = _ref2.activeOptionIndex,
          offset = _ref2.offset,
          options = _ref2.options;
      // used by menu listbox and selected options listbox
      var nextIndex = activeOptionIndex + offset;
      var skipIndex = options.length > nextIndex && nextIndex >= 0 && options[nextIndex].type === 'separator';
      var newIndex = skipIndex ? nextIndex + offset : nextIndex;
      var hasNewIndex = options.length > newIndex && newIndex >= 0;
      return hasNewIndex ? newIndex : activeOptionIndex;
    }
  });
  Object.defineProperty(this, "getTargetElement", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value() {
      return _this3.inputRef;
    }
  });
  Object.defineProperty(this, "setInputRef", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(component) {
      _this3.inputRef = component; // yes, this is a render triggered by a render.
      // Dialog/Popper.js cannot place the menu until
      // the trigger/target DOM node is mounted. This
      // way `findDOMNode` is not called and parent
      // DOM nodes are not queried.

      if (!_this3.state.inputRendered) {
        _this3.setState({
          inputRendered: true
        });
      }
    }
  });
  Object.defineProperty(this, "handleBlurPill", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value() {
      _this3.setState({
        listboxHasFocus: false
      });
    }
  });
  Object.defineProperty(this, "handleClickOutside", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(event) {
      _this3.handleRequestClose(event, {});
    }
  });
  Object.defineProperty(this, "handleClose", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(event) {
      var isOpen = _this3.getIsOpen();

      if (isOpen) {
        if (currentOpenDropdown === _this3) {
          currentOpenDropdown = undefined;
        }

        _this3.setState({
          activeOption: undefined,
          activeOptionIndex: -1,
          isOpen: false
        });

        if (_this3.props.events.onClose) {
          _this3.props.events.onClose(event, {});
        }
      }
    }
  });
  Object.defineProperty(this, "handleInputBlur", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(event) {
      // If menu is open when the input's onBlur event fires, it will close before the onClick of the menu item can fire.
      setTimeout(function () {
        _this3.handleClose(event);
      }, 200);

      if (_this3.props.events.onBlur) {
        _this3.props.events.onBlur(event);
      }
    }
  });
  Object.defineProperty(this, "handleInputChange", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(event) {
      _this3.requestOpenMenu();

      _this3.props.events.onChange(event, {
        value: event.target.value
      });
    }
  });
  Object.defineProperty(this, "handleInputFocus", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(event) {
      if (_this3.props.events.onFocus) {
        _this3.props.events.onFocus(event, {});
      }
    }
  });
  Object.defineProperty(this, "handleInputSubmit", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(event) {
      // use menu options
      if (_this3.getIsActiveOption()) {
        _this3.handleSelect(event, {
          option: _this3.state.activeOption,
          selection: _this3.props.selection
        }); // use input value, if not limited to predefined options (in the menu)

      } else if (!_this3.props.predefinedOptionsOnly && event.target.value !== '' && _this3.props.events.onSubmit) {
        _this3.props.events.onSubmit(event, {
          value: event.target.value
        });
      }
    }
  });
  Object.defineProperty(this, "handleKeyDown", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(event) {
      var _callbacks;

      // Helper function that takes an object literal of callbacks that are triggered with a key event
      Object(__WEBPACK_IMPORTED_MODULE_18__utilities_key_callbacks__["a" /* default */])(event, {
        callbacks: (_callbacks = {}, _defineProperty(_callbacks, __WEBPACK_IMPORTED_MODULE_17__utilities_key_code__["a" /* default */].DOWN, {
          callback: _this3.handleKeyDownDown
        }), _defineProperty(_callbacks, __WEBPACK_IMPORTED_MODULE_17__utilities_key_code__["a" /* default */].ENTER, {
          callback: _this3.handleInputSubmit
        }), _defineProperty(_callbacks, __WEBPACK_IMPORTED_MODULE_17__utilities_key_code__["a" /* default */].ESCAPE, {
          callback: _this3.handleClose
        }), _defineProperty(_callbacks, __WEBPACK_IMPORTED_MODULE_17__utilities_key_code__["a" /* default */].UP, {
          callback: _this3.handleKeyDownUp
        }), _callbacks)
      });
    }
  });
  Object.defineProperty(this, "handleKeyDownDown", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(event) {
      // Don't open if user is selecting text
      if (!event.shiftKey) {
        _this3.openDialog();
      }

      _this3.handleNavigateListboxMenu(event, {
        direction: 'next'
      });
    }
  });
  Object.defineProperty(this, "handleKeyDownUp", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(event) {
      // Don't open if user is selecting text
      if (!event.shiftKey && _this3.state.isOpen) {
        _this3.handleNavigateListboxMenu(event, {
          direction: 'previous'
        });
      }
    }
  });
  Object.defineProperty(this, "handleNavigateListboxMenu", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(event, _ref3) {
      var direction = _ref3.direction;
      var offsets = {
        next: 1,
        previous: -1
      }; // takes current/previous state and returns an object with the new state

      _this3.setState(function (prevState) {
        var newIndex = _this3.getNewActiveOptionIndex({
          activeOptionIndex: prevState.activeOptionIndex,
          offset: offsets[direction],
          options: _this3.props.options
        });

        return {
          activeOption: _this3.props.options[newIndex],
          activeOptionIndex: newIndex
        };
      });
    }
  });
  Object.defineProperty(this, "handleNavigateListboxOfPills", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(event, _ref4) {
      var direction = _ref4.direction;
      var offsets = {
        next: 1,
        previous: -1
      };

      _this3.setState(function (prevState) {
        var isLastOptionAndRightIsPressed = prevState.activeSelectedOptionIndex + 1 === _this3.props.selection.length && direction === 'next';
        var isFirstOptionAndLeftIsPressed = prevState.activeSelectedOptionIndex === 0 && direction === 'previous';
        var newState;

        if (isLastOptionAndRightIsPressed) {
          newState = {
            activeSelectedOption: _this3.props.selection[0],
            activeSelectedOptionIndex: 0,
            listboxHasFocus: true
          };
        } else if (isFirstOptionAndLeftIsPressed) {
          newState = {
            activeSelectedOption: _this3.props.selection[_this3.props.selection.length - 1],
            activeSelectedOptionIndex: _this3.props.selection.length - 1,
            listboxHasFocus: true
          };
        } else {
          var newIndex = _this3.getNewActiveOptionIndex({
            activeOptionIndex: prevState.activeSelectedOptionIndex,
            offset: offsets[direction],
            options: _this3.props.selection
          });

          newState = {
            activeSelectedOption: _this3.props.selection[newIndex],
            activeSelectedOptionIndex: newIndex,
            listboxHasFocus: true
          };
        }

        return newState;
      });
    }
  });
  Object.defineProperty(this, "handleOpen", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(event, data) {
      var isOpen = _this3.getIsOpen();

      if (!isOpen) {
        if (currentOpenDropdown && __WEBPACK_IMPORTED_MODULE_8_lodash_isfunction___default()(currentOpenDropdown.handleClose)) {
          currentOpenDropdown.handleClose();
        }
      } else {
        currentOpenDropdown = _this3;

        _this3.setState({
          isOpen: true
        });

        if (_this3.props.events.onOpen) {
          _this3.props.events.onOpen(event, data);
        }
      }
    }
  });
  Object.defineProperty(this, "handlePillClickListboxOfPills", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(event, _ref5) {
      var option = _ref5.option,
          index = _ref5.index;

      // this is clicking the span, not the remove button
      _this3.setState({
        activeSelectedOption: option,
        activeSelectedOptionIndex: index,
        listboxHasFocus: true
      });
    }
  });
  Object.defineProperty(this, "handleRemoveSelectedOption", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(event, _ref6) {
      var option = _ref6.option,
          index = _ref6.index;
      event.preventDefault();
      var onlyOnePillAndInputExists = _this3.props.selection.length === 1;
      var isReadOnlyAndTwoPillsExists = _this3.props.selection.length === 2 && _this3.props.variant === 'readonly' && _this3.props.multiple;
      var lastPillWasRemoved = index + 1 === _this3.props.selection.length;

      if ((onlyOnePillAndInputExists || isReadOnlyAndTwoPillsExists) && _this3.inputRef) {
        _this3.inputRef.focus();
      } else if (lastPillWasRemoved) {
        // set focus to previous option and index
        _this3.setState({
          activeSelectedOption: _this3.props.selection[index - 1],
          activeSelectedOptionIndex: index - 1,
          listboxHasFocus: true
        });
      } else {
        // set focus to next option, but same index
        _this3.setState({
          activeSelectedOption: _this3.props.selection[index + 1],
          activeSelectedOptionIndex: index,
          listboxHasFocus: true
        });
      }

      if (_this3.props.events.onRequestRemoveSelectedOption) {
        _this3.props.events.onRequestRemoveSelectedOption(event, {
          selection: __WEBPACK_IMPORTED_MODULE_4_lodash_reject___default()(_this3.props.selection, option)
        });
      }
    }
  });
  Object.defineProperty(this, "handleRequestClose", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(event, data) {
      if (_this3.props.events.onRequestClose) {
        _this3.props.events.onRequestClose(event, data);
      }

      if (_this3.getIsOpen()) {
        _this3.setState({
          isOpen: false
        });
      }
    }
  });
  Object.defineProperty(this, "handleRequestFocusListboxOfPills", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(event, _ref7) {
      var ref = _ref7.ref;

      if (ref) {
        _this3.activeSelectedOptionRef = ref;

        _this3.activeSelectedOptionRef.focus();
      }
    }
  });
  Object.defineProperty(this, "handleSelect", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(event, _ref8) {
      var selection = _ref8.selection,
          option = _ref8.option;
      var newSelection;

      var isSelected = _this3.isSelected({
        selection: selection,
        option: option
      });

      var singleSelectAndSelectedWasNotClicked = !_this3.props.multiple && !isSelected;
      var multiSelectAndSelectedWasNotClicked = _this3.props.multiple && !isSelected;

      if (singleSelectAndSelectedWasNotClicked) {
        newSelection = [option];
      } else if (multiSelectAndSelectedWasNotClicked) {
        newSelection = _toConsumableArray(_this3.props.selection).concat([option]);
      } else {
        newSelection = __WEBPACK_IMPORTED_MODULE_4_lodash_reject___default()(_this3.props.selection, option);
      }

      if (_this3.props.events.onSelect) {
        _this3.props.events.onSelect(event, {
          selection: newSelection
        });
      }

      _this3.handleClose();

      if (_this3.inputRef) {
        _this3.inputRef.focus();
      }
    }
  });
  Object.defineProperty(this, "isSelected", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(_ref9) {
      var selection = _ref9.selection,
          option = _ref9.option;
      return !!__WEBPACK_IMPORTED_MODULE_3_lodash_find___default()(selection, option);
    }
  });
  Object.defineProperty(this, "openDialog", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value() {
      if (_this3.props.events.onRequestOpen) {
        _this3.props.events.onRequestOpen();
      } else {
        _this3.setState({
          isOpen: true
        });
      }
    }
  });
  Object.defineProperty(this, "requestOpenMenu", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value() {
      var isInlineSingleSelectionAndIsNotSelected = !_this3.props.multiple && _this3.props.selection.length === 0 && _this3.props.variant === 'inline-listbox';

      if (isInlineSingleSelectionAndIsNotSelected || _this3.props.multiple || _this3.props.variant === 'readonly') {
        _this3.openDialog();
      }
    }
  });
  Object.defineProperty(this, "renderBase", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(_ref10) {
      var assistiveText = _ref10.assistiveText,
          labels = _ref10.labels,
          props = _ref10.props;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "slds-form-element__control"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "slds-combobox_container"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: __WEBPACK_IMPORTED_MODULE_9_classnames___default()('slds-combobox', 'slds-dropdown-trigger', 'slds-dropdown-trigger_click', 'ignore-react-onclickoutside', {
          'slds-is-open': _this3.getIsOpen()
        }, {
          'slds-has-error': props.errorText
        }, props.className),
        "aria-expanded": _this3.getIsOpen(),
        "aria-haspopup": "listbox" // eslint-disable-line jsx-a11y/aria-proptypes
        // used on menu's listbox
        ,
        "aria-owns": "".concat(_this3.getId(), "-listbox") // eslint-disable-line jsx-a11y/aria-proptypes
        ,
        role: "combobox"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_input_private_inner_input__["a" /* default */], {
        "aria-autocomplete": "list",
        "aria-controls": "".concat(_this3.getId(), "-listbox"),
        "aria-activedescendant": _this3.state.activeOption ? "".concat(_this3.getId(), "-listbox-option-").concat(_this3.state.activeOption.id) : null,
        "aria-describedby": _this3.getErrorId(),
        autoComplete: "off",
        className: "slds-combobox__input",
        containerProps: {
          className: 'slds-combobox__form-element',
          role: 'none'
        },
        iconRight: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__icon_input_icon__["a" /* default */], {
          category: "utility",
          name: "search",
          title: labels.inputIconTitle
        }),
        id: _this3.getId(),
        onFocus: _this3.handleInputFocus,
        onBlur: _this3.handleInputBlur,
        onKeyDown: _this3.handleKeyDown,
        inputRef: _this3.setInputRef,
        onClick: function onClick() {
          _this3.openDialog();
        },
        onChange: _this3.handleInputChange,
        placeholder: labels.placeholder,
        readOnly: !!(props.predefinedOptionsOnly && _this3.state.activeOption),
        required: props.required,
        role: "textbox",
        value: props.predefinedOptionsOnly ? _this3.state.activeOption && _this3.state.activeOption.label || props.value : props.value
      }), _this3.getDialog({
        menuRenderer: _this3.renderMenu({
          assistiveText: assistiveText,
          labels: labels
        })
      }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__private_selected_listbox__["a" /* default */], {
        activeOption: _this3.state.activeSelectedOption,
        activeOptionIndex: _this3.state.activeSelectedOptionIndex,
        assistiveText: assistiveText,
        events: {
          onBlurPill: _this3.handleBlurPill,
          onClickPill: _this3.handlePillClickListboxOfPills,
          onRequestFocus: _this3.handleRequestFocusListboxOfPills,
          onRequestFocusOnNextPill: _this3.handleNavigateListboxOfPills,
          onRequestFocusOnPreviousPill: _this3.handleNavigateListboxOfPills,
          onRequestRemove: _this3.handleRemoveSelectedOption
        },
        id: _this3.getId(),
        labels: labels,
        selection: props.selection,
        listboxHasFocus: _this3.state.listboxHasFocus
      }), props.errorText && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "slds-has-error"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        id: _this3.getErrorId(),
        className: "slds-form-element__help slds-has-error"
      }, props.errorText)));
    }
  });
  Object.defineProperty(this, "renderInlineMultiple", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(_ref11) {
      var assistiveText = _ref11.assistiveText,
          labels = _ref11.labels,
          props = _ref11.props;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "slds-form-element__control"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: __WEBPACK_IMPORTED_MODULE_9_classnames___default()('slds-combobox_container', {
          'slds-has-inline-listbox': props.selection.length
        })
      }, props.selection.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__private_selected_listbox__["a" /* default */], {
        activeOption: _this3.state.activeSelectedOption,
        activeOptionIndex: _this3.state.activeSelectedOptionIndex,
        assistiveText: assistiveText,
        events: {
          onBlurPill: _this3.handleBlurPill,
          onClickPill: _this3.handlePillClickListboxOfPills,
          onRequestFocus: _this3.handleRequestFocusListboxOfPills,
          onRequestFocusOnNextPill: _this3.handleNavigateListboxOfPills,
          onRequestFocusOnPreviousPill: _this3.handleNavigateListboxOfPills,
          onRequestRemove: _this3.handleRemoveSelectedOption
        },
        id: _this3.getId(),
        labels: labels,
        selection: props.selection,
        listboxHasFocus: _this3.state.listboxHasFocus
      }) : null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: __WEBPACK_IMPORTED_MODULE_9_classnames___default()('slds-combobox', 'slds-dropdown-trigger', 'slds-dropdown-trigger_click', 'ignore-react-onclickoutside', {
          'slds-is-open': _this3.getIsOpen()
        }, {
          'slds-has-error': props.errorText
        }, props.className),
        "aria-expanded": _this3.getIsOpen(),
        "aria-haspopup": "listbox" // eslint-disable-line jsx-a11y/aria-proptypes
        ,
        role: "combobox"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_input_private_inner_input__["a" /* default */], {
        "aria-autocomplete": "list",
        "aria-controls": "".concat(_this3.getId(), "-listbox"),
        "aria-activedescendant": _this3.state.activeOption ? "".concat(_this3.getId(), "-listbox-option-").concat(_this3.state.activeOption.id) : null,
        "aria-describedby": _this3.getErrorId(),
        autoComplete: "off",
        className: "slds-combobox__input",
        containerProps: {
          'aria-expanded': _this3.getIsOpen(),
          'aria-haspopup': 'listbox',
          className: 'slds-combobox__form-element',
          role: 'none'
        },
        iconRight: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__icon_input_icon__["a" /* default */], {
          category: "utility",
          name: "search",
          title: labels.inputIconTitle
        }),
        id: _this3.getId(),
        onFocus: _this3.handleInputFocus,
        onBlur: _this3.handleInputBlur,
        onKeyDown: _this3.handleKeyDown,
        inputRef: _this3.setInputRef,
        onClick: function onClick() {
          _this3.openDialog();
        },
        onChange: _this3.handleInputChange,
        placeholder: labels.placeholder,
        readOnly: !!(props.predefinedOptionsOnly && _this3.state.activeOption),
        required: props.required,
        role: "textbox",
        value: props.predefinedOptionsOnly ? _this3.state.activeOption && _this3.state.activeOption.label || props.value : props.value
      }), _this3.getDialog({
        menuRenderer: _this3.renderMenu({
          assistiveText: assistiveText,
          labels: labels
        })
      }), props.errorText && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        id: _this3.getErrorId(),
        className: "slds-form-element__help"
      }, props.errorText))));
    }
  });
  Object.defineProperty(this, "renderInlineSingle", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(_ref12) {
      var assistiveText = _ref12.assistiveText,
          labels = _ref12.labels,
          props = _ref12.props;
      var iconLeft = props.selection[0] && props.selection[0].icon ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(props.selection[0].icon, {
        containerClassName: 'slds-combobox__input-entity-icon'
      }) : null;
      var value = props.selection[0] && props.selection[0].label ? props.selection[0].label : props.value;
      /* eslint-disable jsx-a11y/role-supports-aria-props */

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "slds-form-element__control"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: __WEBPACK_IMPORTED_MODULE_9_classnames___default()('slds-combobox_container', {
          'slds-has-inline-listbox': props.selection.length
        })
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: __WEBPACK_IMPORTED_MODULE_9_classnames___default()('slds-combobox', 'slds-dropdown-trigger', 'slds-dropdown-trigger_click', 'ignore-react-onclickoutside', {
          'slds-is-open': _this3.getIsOpen()
        }, {
          'slds-has-error': props.errorText
        }, props.className),
        "aria-expanded": _this3.getIsOpen(),
        "aria-haspopup": "listbox" // eslint-disable-line jsx-a11y/aria-proptypes
        ,
        role: "combobox"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_input_private_inner_input__["a" /* default */], {
        "aria-autocomplete": "list",
        "aria-controls": "".concat(_this3.getId(), "-listbox"),
        "aria-activedescendant": _this3.state.activeOption ? "".concat(_this3.getId(), "-listbox-option-").concat(_this3.state.activeOption.id) : null,
        "aria-describedby": _this3.getErrorId(),
        autoComplete: "off",
        className: "slds-combobox__input",
        containerProps: {
          className: 'slds-combobox__form-element',
          role: 'none'
        },
        iconRight: props.selection.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__icon_input_icon__["a" /* default */], {
          assistiveText: {
            icon: assistiveText.removeSingleSelectedOption
          },
          buttonRef: function buttonRef(component) {
            _this3.buttonRef = component;
          },
          category: "utility",
          iconPosition: "right",
          name: "close",
          onClick: function onClick(event) {
            _this3.handleRemoveSelectedOption(event, {
              option: props.selection[0]
            });
          }
        }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__icon_input_icon__["a" /* default */], {
          category: "utility",
          name: "search"
        }),
        iconLeft: iconLeft,
        id: _this3.getId(),
        onFocus: _this3.handleInputFocus,
        onBlur: _this3.handleInputBlur,
        onKeyDown: _this3.handleKeyDown,
        inputRef: _this3.setInputRef,
        onClick: function onClick() {
          _this3.requestOpenMenu();
        },
        onChange: function onChange(event) {
          if (!props.selection.length) {
            _this3.handleInputChange(event);
          }
        },
        placeholder: labels.placeholder,
        readOnly: !!(props.predefinedOptionsOnly && _this3.state.activeOption) || !!props.selection.length,
        required: props.required,
        role: "textbox",
        value: props.predefinedOptionsOnly ? _this3.state.activeOption && _this3.state.activeOption.label || props.value : value
      }), _this3.getDialog({
        menuRenderer: _this3.renderMenu({
          assistiveText: assistiveText,
          labels: labels
        })
      }), props.errorText && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        id: _this3.getErrorId(),
        className: "slds-form-element__help"
      }, props.errorText))));
    }
  });
  Object.defineProperty(this, "renderMenu", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(_ref13) {
      var assistiveText = _ref13.assistiveText,
          labels = _ref13.labels;
      var menuVariant = {
        base: 'icon-title-subtitle',
        'inline-listbox': 'icon-title-subtitle',
        readonly: 'checkbox'
      };
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__private_menu__["a" /* default */], {
        assistiveText: assistiveText,
        activeOption: _this3.state.activeOption,
        activeOptionIndex: _this3.state.activeOptionIndex,
        classNameMenu: _this3.props.classNameMenu,
        classNameMenuSubHeader: _this3.props.classNameMenuSubHeader,
        inheritWidthOf: _this3.props.inheritWidthOf,
        inputId: _this3.getId(),
        inputValue: _this3.props.value,
        isSelected: _this3.isSelected,
        itemVisibleLength: _this3.props.variant === 'readonly' ? _this3.props.readOnlyMenuItemVisibleLength : null,
        labels: labels,
        menuItem: _this3.props.menuItem,
        menuPosition: _this3.props.menuPosition,
        maxWidth: _this3.props.menuMaxWidth,
        options: _this3.props.options,
        onSelect: _this3.handleSelect,
        clearActiveOption: _this3.clearActiveOption,
        selection: _this3.props.selection,
        variant: menuVariant[_this3.props.variant]
      });
    }
  });
  Object.defineProperty(this, "renderReadOnlyMultiple", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(_ref14) {
      var assistiveText = _ref14.assistiveText,
          labels = _ref14.labels,
          props = _ref14.props;
      var value = props.selection.length > 1 ? labels.multipleOptionsSelected || "".concat(props.selection.length, " options selected") : props.selection[0] && props.selection[0].label || '';
      /* eslint-disable jsx-a11y/role-supports-aria-props */

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "slds-form-element__control"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "slds-combobox_container"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: __WEBPACK_IMPORTED_MODULE_9_classnames___default()('slds-combobox', 'slds-dropdown-trigger', 'slds-dropdown-trigger_click', 'ignore-react-onclickoutside', {
          'slds-is-open': _this3.getIsOpen()
        }, {
          'slds-has-error': props.errorText
        }, props.className),
        "aria-expanded": _this3.getIsOpen(),
        "aria-haspopup": "listbox" // eslint-disable-line jsx-a11y/aria-proptypes
        ,
        role: "combobox"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_input_private_inner_input__["a" /* default */], {
        "aria-autocomplete": "list",
        "aria-controls": "".concat(_this3.getId(), "-listbox"),
        "aria-activedescendant": _this3.state.activeOption ? "".concat(_this3.getId(), "-listbox-option-").concat(_this3.state.activeOption.id) : null,
        "aria-describedby": _this3.getErrorId(),
        autoComplete: "off",
        className: "slds-combobox__input",
        containerProps: {
          'aria-expanded': _this3.getIsOpen(),
          'aria-haspopup': 'listbox',
          className: 'slds-combobox__form-element',
          role: 'none'
        },
        iconRight: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__icon_input_icon__["a" /* default */], {
          category: "utility",
          name: "down",
          variant: "combobox"
        }),
        id: _this3.getId(),
        onFocus: _this3.handleInputFocus,
        onBlur: _this3.handleInputBlur,
        onKeyDown: _this3.handleKeyDown,
        inputRef: _this3.setInputRef,
        onClick: function onClick() {
          _this3.requestOpenMenu();
        },
        onChange: function onChange(event) {
          if (!props.selection.length) {
            _this3.handleInputChange(event);
          }
        },
        placeholder: labels.placeholderReadOnly,
        readOnly: true,
        required: props.required,
        role: "textbox",
        value: value
      }), _this3.getDialog({
        menuRenderer: _this3.renderMenu({
          assistiveText: assistiveText,
          labels: labels
        })
      }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__private_selected_listbox__["a" /* default */], {
        activeOption: _this3.state.activeSelectedOption,
        activeOptionIndex: _this3.state.activeSelectedOptionIndex,
        assistiveText: assistiveText,
        events: {
          onBlurPill: _this3.handleBlurPill,
          onClickPill: _this3.handlePillClickListboxOfPills,
          onRequestFocus: _this3.handleRequestFocusListboxOfPills,
          onRequestFocusOnNextPill: _this3.handleNavigateListboxOfPills,
          onRequestFocusOnPreviousPill: _this3.handleNavigateListboxOfPills,
          onRequestRemove: _this3.handleRemoveSelectedOption
        },
        id: _this3.getId(),
        labels: labels,
        selection: props.selection,
        listboxHasFocus: _this3.state.listboxHasFocus,
        variant: _this3.props.variant,
        renderAtSelectionLength: 2
      }), props.errorText && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "slds-has-error"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        id: _this3.getErrorId(),
        className: "slds-form-element__help slds-has-error"
      }, props.errorText)));
    }
  });
  Object.defineProperty(this, "renderReadOnlySingle", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(_ref15) {
      var assistiveText = _ref15.assistiveText,
          labels = _ref15.labels,
          props = _ref15.props;
      var value = props.selection[0] && props.selection[0].label || '';
      /* eslint-disable jsx-a11y/role-supports-aria-props */

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "slds-form-element__control"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "slds-combobox_container"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        // aria attributes have been moved to the `div` wrapping `input` to comply with ARIA 1.1.
        className: __WEBPACK_IMPORTED_MODULE_9_classnames___default()('slds-combobox', 'slds-dropdown-trigger', 'slds-dropdown-trigger_click', 'ignore-react-onclickoutside', {
          'slds-is-open': _this3.getIsOpen()
        }, {
          'slds-has-error': props.errorText
        }, props.className),
        "aria-expanded": _this3.getIsOpen(),
        "aria-haspopup": "listbox" // eslint-disable-line jsx-a11y/aria-proptypes
        ,
        role: "combobox"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_input_private_inner_input__["a" /* default */], {
        "aria-autocomplete": "list",
        "aria-controls": "".concat(_this3.getId(), "-listbox"),
        "aria-activedescendant": _this3.state.activeOption ? "".concat(_this3.getId(), "-listbox-option-").concat(_this3.state.activeOption.id) : null,
        "aria-describedby": _this3.getErrorId(),
        autoComplete: "off",
        className: "slds-combobox__input",
        containerProps: {
          'aria-expanded': _this3.getIsOpen(),
          'aria-haspopup': 'listbox',
          className: 'slds-combobox__form-element',
          role: 'none'
        },
        iconRight: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__icon_input_icon__["a" /* default */], {
          category: "utility",
          name: "down",
          variant: "combobox"
        }),
        id: _this3.getId(),
        onFocus: _this3.handleInputFocus,
        onBlur: _this3.handleInputBlur,
        onKeyDown: _this3.handleKeyDown,
        inputRef: _this3.setInputRef,
        onClick: function onClick() {
          _this3.requestOpenMenu();
        },
        onChange: function onChange(event) {
          if (!props.selection.length) {
            _this3.handleInputChange(event);
          }
        },
        placeholder: labels.placeholderReadOnly,
        readOnly: true,
        required: props.required,
        role: "textbox",
        value: _this3.state.activeOption && _this3.state.activeOption.label || value
      }), _this3.getDialog({
        menuRenderer: _this3.renderMenu({
          assistiveText: assistiveText,
          labels: labels
        })
      }), props.errorText && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        id: _this3.getErrorId(),
        className: "slds-form-element__help"
      }, props.errorText))));
    }
  });
};

Combobox.contextTypes = {
  iconPath: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
Combobox.displayName = __WEBPACK_IMPORTED_MODULE_20__utilities_constants__["s" /* COMBOBOX */];
Combobox.propTypes = propTypes;
Combobox.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Combobox);
//# sourceMappingURL=combobox.js.map

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to compose bitmasks for comparison styles. */
var UNORDERED_COMPARE_FLAG = 1,
    PARTIAL_COMPARE_FLAG = 2;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array ? array.length : 0,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values ? values.length : 0;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter(collection, predicate) {
  var result = [];
  baseEach(collection, function(value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, customizer, bitmask, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = arrayTag,
      othTag = arrayTag;

  if (!objIsArr) {
    objTag = getTag(object);
    objTag = objTag == argsTag ? objectTag : objTag;
  }
  if (!othIsArr) {
    othTag = getTag(other);
    othTag = othTag == argsTag ? objectTag : othTag;
  }
  var objIsObj = objTag == objectTag && !isHostObject(object),
      othIsObj = othTag == objectTag && !isHostObject(other),
      isSameTag = objTag == othTag;

  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
      : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
  }
  if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
}

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
  };
}

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!seen.has(othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
              return seen.add(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, customizer, bitmask, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= UNORDERED_COMPARE_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      objProps = keys(object),
      objLength = objProps.length,
      othProps = keys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = isKey(path, object) ? [path] : castPath(path);

  var result,
      index = -1,
      length = path.length;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result) {
    return result;
  }
  var length = object ? object.length : 0;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * The opposite of `_.filter`; this method returns the elements of `collection`
 * that `predicate` does **not** return truthy for.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.filter
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': true }
 * ];
 *
 * _.reject(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.reject(users, { 'age': 40, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.reject(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.reject(users, 'active');
 * // => objects for ['barney']
 */
function reject(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, negate(baseIteratee(predicate, 3)));
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Creates a function that negates the result of the predicate `func`. The
 * `func` predicate is invoked with the `this` binding and arguments of the
 * created function.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} predicate The predicate to negate.
 * @returns {Function} Returns the new negated function.
 * @example
 *
 * function isEven(n) {
 *   return n % 2 == 0;
 * }
 *
 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
 * // => [1, 3, 5]
 */
function negate(predicate) {
  if (typeof predicate != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  return function() {
    var args = arguments;
    switch (args.length) {
      case 0: return !predicate.call(this);
      case 1: return !predicate.call(this, args[0]);
      case 2: return !predicate.call(this, args[0], args[1]);
      case 3: return !predicate.call(this, args[0], args[1], args[2]);
    }
    return !predicate.apply(this, args);
  };
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = reject;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17), __webpack_require__(30)(module)))

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_assign__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_key_code__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_key_callbacks__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_event__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pill__ = __webpack_require__(55);
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */







var propTypes = {
  /**
   * Pill is the active pill within a listbox of pills. This will request focus on the DOM node.
   */
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * **Assistive text for accessibility**
   * This object is merged with the default props object on every render.
   * * `pressDeleteOrBackspace`: Informs user of keyboard keys to press in order to remove a pill
   */
  assistiveText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    remove: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),

  /*
   * Pills are often used for selection of a type of entity such as days in a daypicker. This prop allows you to pass in data that will be passed back to the event handler.
   */
  eventData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /*
   * Callback called when pill is clicked, delete is pressed, or backspace is pressed.
   */
  events: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    onRequestFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    onRequestFocusOnNextPill: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    onRequestFocusOnPreviousPill: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    onRequestRemove: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
  }),

  /*
   * The icon next to the pill label.
   */
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,

  /*
   * Pill Label
   */
  labels: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    removeTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),

  /*
   * If true and is active pill in listbox, will trigger `events.onRequestFocus`
   */
  requestFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /*
   * Pill Title
   */
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /*
   * Allows the user to tab to the node
   */
  tabIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};
var defaultProps = {
  assistiveText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    remove: ', Press delete or backspace to remove'
  }),
  labels: {
    remove: 'Remove'
  },
  events: {}
};

var handleKeyDown = function handleKeyDown(event, _ref) {
  var _callbacks;

  var events = _ref.events,
      data = _ref.data;
  // Helper function that takes an object literal of callbacks that are triggered with a key event
  Object(__WEBPACK_IMPORTED_MODULE_4__utilities_key_callbacks__["a" /* default */])(event, {
    callbacks: (_callbacks = {}, _defineProperty(_callbacks, __WEBPACK_IMPORTED_MODULE_3__utilities_key_code__["a" /* default */].BACKSPACE, {
      callback: events.onRequestRemove,
      data: data
    }), _defineProperty(_callbacks, __WEBPACK_IMPORTED_MODULE_3__utilities_key_code__["a" /* default */].DELETE, {
      callback: events.onRequestRemove,
      data: data
    }), _defineProperty(_callbacks, __WEBPACK_IMPORTED_MODULE_3__utilities_key_code__["a" /* default */].LEFT, {
      callback: events.onRequestFocusOnPreviousPill,
      data: _objectSpread({}, data, {
        direction: 'previous'
      })
    }), _defineProperty(_callbacks, __WEBPACK_IMPORTED_MODULE_3__utilities_key_code__["a" /* default */].RIGHT, {
      callback: events.onRequestFocusOnNextPill,
      data: _objectSpread({}, data, {
        direction: 'next'
      })
    }), _callbacks)
  });
};

var handleClickRemove = function handleClickRemove(event, _ref2) {
  var events = _ref2.events,
      eventData = _ref2.eventData;
  __WEBPACK_IMPORTED_MODULE_5__utilities_event__["a" /* default */].trap(event);
  events.onRequestRemove(event, eventData);
};

var Pill = function Pill(props) {
  var assistiveText = __WEBPACK_IMPORTED_MODULE_2_lodash_assign___default()({}, defaultProps.assistiveText, props.assistiveText);
  var labels = __WEBPACK_IMPORTED_MODULE_2_lodash_assign___default()({}, defaultProps.labels, props.labels);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_pill__["a" /* default */], {
    tabIndex: props.tabIndex || '0',
    icon: props.icon,
    variant: "option",
    labels: labels,
    assistiveText: {
      remove: assistiveText.remove
    },
    "aria-selected": props.active,
    onBlur: props.events.onBlur,
    onClick: typeof props.events.onClick === 'function' ? function (event) {
      if (props.events.onClick) {
        props.events.onClick(event, {
          option: props.eventData
        });
      }
    } : null,
    onRemove: function onRemove(event) {
      __WEBPACK_IMPORTED_MODULE_5__utilities_event__["a" /* default */].trap(event);
      handleClickRemove(event, {
        events: props.events,
        eventData: props.eventData
      });
    },
    onKeyDown: function onKeyDown(event) {
      handleKeyDown(event, {
        events: props.events,
        data: props.eventData
      });
    },
    ref: function ref(component) {
      if (props.requestFocus && props.active) {
        props.events.onRequestFocus(undefined, {
          ref: component
        });
      }
    }
  });
};

Pill.displayName = 'Pill';
Pill.propTypes = propTypes;
Pill.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Pill);
//# sourceMappingURL=index.js.map

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_escaperegexp__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_escaperegexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_escaperegexp__);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/**
 * SLDS recommends auto-complete/search inputs menus have a limit of 10 items.
 */

var filter = function filter(_ref) {
  var inputValue = _ref.inputValue,
      _ref$limit = _ref.limit,
      limit = _ref$limit === void 0 ? 10 : _ref$limit,
      options = _ref.options,
      selection = _ref.selection;
  return options.filter(function (option) {
    var searchTermFound = option.label ? option.label.match(new RegExp(__WEBPACK_IMPORTED_MODULE_0_lodash_escaperegexp___default()(inputValue), 'ig')) : false;
    var isSeparator = option.type === 'separator';
    var notAlreadySelected = !selection.includes(option);
    return (!inputValue || isSeparator || searchTermFound) && notAlreadySelected;
  }).splice(0, limit);
};

/* unused harmony default export */ var _unused_webpack_default_export = (filter);
//# sourceMappingURL=filter.js.map

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__check_props__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_event__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_constants__ = __webpack_require__(2);
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// # Global Header Component
// Implements the [Global Header design pattern](https://www.lightningdesignsystem.com/components/global-header) in React.
// Based on SLDS v2.1.0-rc.2
// ## Dependencies
// ### React


 // This component's `checkProps` which issues warnings to developers about properties when in development mode (similar to React's built in development tools)

 // ### Event Helpers

 // ## Constants


var defaultProps = {
  assistiveText: {
    skipToNav: 'Skip to Navigation',
    skipToContent: 'Skip to Main Content'
  },
  logoSrc: '/assets/images/logo-noname.svg'
};
/**
 * The global header is the anchor for the Salesforce platform and spans all other parts of the UI. It accepts children to define the items displayed within.
 *
 * Example:
 * ```
 * <SLDSGlobalHeader>
 *   <SLDSGlobalHeaderSearch />
 *   <SLDSGlobalHeaderButton />
 *   <SLDSGlobalHeaderDropdown />
 *   <SLDSGlobalHeaderDropdown />
 *   <SLDSGlobalHeaderProfile />
 * </SLDSGlobalHeader>
 * ```
 */

var GlobalHeader = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: __WEBPACK_IMPORTED_MODULE_5__utilities_constants__["E" /* GLOBAL_HEADER */],
  propTypes: {
    /**
     * **Assistive text for accessibility.**
     * This object is merged with the default props object on every render.
     * * `skipToNav`: The localized text that will be read back for the "Skip to Navigation" accessibility link.
     * * `skipToContent`: The localized text that will be read back for the "Skip to Main Content" accessibility link.
     */
    assistiveText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
      skipToNav: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
      skipToContent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
    }),

    /**
     * See the component description, this accepts some combination of `SLDSGlobalHeaderSearch`, `SLDSGlobalHeaderButton`, `SLDSGlobalHeaderDropdown`, and `SLDSGlobalHeaderProfile` components.
     */
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,

    /**
     * The Salesforce logo to display in the header.
     */
    logoSrc: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * Pass in the Global Navigation Bar component
     */
    navigation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,

    /**
     * Required for accessibility. Should jump the user to the primary content area.
     */
    onSkipToContent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Required for accessibility. Should jump the user to the primary navigation.
     */
    onSkipToNav: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
  },
  getDefaultProps: function getDefaultProps() {
    return defaultProps;
  },
  componentWillMount: function componentWillMount() {
    Object(__WEBPACK_IMPORTED_MODULE_3__check_props__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5__utilities_constants__["E" /* GLOBAL_HEADER */], this.props);
  },
  handleSkipToContent: function handleSkipToContent(e) {
    __WEBPACK_IMPORTED_MODULE_4__utilities_event__["a" /* default */].trap(e);
    this.props.onSkipToContent(e);
  },
  handleSkipToNav: function handleSkipToNav(e) {
    __WEBPACK_IMPORTED_MODULE_4__utilities_event__["a" /* default */].trap(e);
    this.props.onSkipToNav(e);
  },
  render: function render() {
    var tools;
    var search;
    var profile;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(this.props.children, function (child) {
      if (child && child.type.displayName === __WEBPACK_IMPORTED_MODULE_5__utilities_constants__["H" /* GLOBAL_HEADER_TOOL */]) {
        if (!tools) tools = [];
        tools.push(child);
      } else if (child && child.type.displayName === __WEBPACK_IMPORTED_MODULE_5__utilities_constants__["G" /* GLOBAL_HEADER_SEARCH */]) {
        search = child;
      } else if (child && child.type.displayName === __WEBPACK_IMPORTED_MODULE_5__utilities_constants__["F" /* GLOBAL_HEADER_PROFILE */]) {
        profile = child;
      }
    });

    var assistiveText = _objectSpread({}, defaultProps.assistiveText, this.props.assistiveText);
    /* eslint-disable max-len, no-script-url */


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("header", {
      className: "slds-global-header_container"
    }, this.props.onSkipToNav ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
      href: "javascript:void(0);",
      className: "slds-assistive-text slds-assistive-text--focus",
      onClick: this.handleSkipToNav
    }, this.props.skipToNavAssistiveText || assistiveText.skipToNav) : null, this.props.onSkipToContent ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
      href: "javascript:void(0);",
      className: "slds-assistive-text slds-assistive-text--focus",
      onClick: this.handleSkipToContent
    }, this.props.skipToContentAssistiveText || assistiveText.skipToContent) : null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "slds-global-header slds-grid slds-grid--align-spread"
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "slds-global-header__item"
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "slds-global-header__logo",
      style: {
        backgroundImage: "url(".concat(this.props.logoSrc, ")")
      }
    })), search, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
      className: "slds-global-header__item slds-grid slds-grid--vertical-align-center"
    }, tools, profile)), this.props.navigation);
    /* eslint-enable max-len, no-script-url */
  }
});
/* unused harmony default export */ var _unused_webpack_default_export = (GlobalHeader);
//# sourceMappingURL=index.js.map

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__menu_dropdown__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__private_dropdown_trigger__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_constants__ = __webpack_require__(2);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// # Global Header Dropdown Component
// ## Dependencies
// ### React

 // ### Dropdown


 // ## Constants


/**
 * This component is an implementation of `MenuDropdown` with a custom trigger. All the properties listed below are provided to the `MenuDropdown` component. Any additional properties are provided to the Custom Trigger (that is the `Button` or `li` tag).
 */

var GlobalHeaderDropdown = function GlobalHeaderDropdown(props) {
  var globalAction = props.globalAction,
      iconVariant = props.iconVariant,
      rest = _objectWithoutProperties(props, ["globalAction", "iconVariant"]);

  var iconVariantOverride;

  if (globalAction) {
    iconVariantOverride = 'container';
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__menu_dropdown__["a" /* default */], _extends({
    nubbinPosition: "top right"
  }, rest), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__private_dropdown_trigger__["a" /* default */], {
    globalAction: globalAction,
    iconSize: globalAction && 'small',
    iconVariant: iconVariantOverride || iconVariant
  }));
}; // ### Display Name
// Always use the canonical component name (set in the core) as the React
// display name.


GlobalHeaderDropdown.displayName = __WEBPACK_IMPORTED_MODULE_4__utilities_constants__["H" /* GLOBAL_HEADER_TOOL */]; // ### Prop Types

GlobalHeaderDropdown.propTypes = {
  /**
   * Aligns the right or left side of the menu with the respective side of the trigger. This is not intended for use with `nubbinPosition`.
   */
  align: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['left', 'right']),

  /**
   * Extra classnames to apply to the dropdown menu.
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * CSS classes to be added to `li` element.
   */
  buttonClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * Name of the icon. Visit <a href="http://www.lightningdesignsystem.com/resources/icons">Lightning Design System Icons</a> to reference icon names.
   */
  iconName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * For icon variants, please reference <a href="http://www.lightningdesignsystem.com/components/buttons/#icon">Lightning Design System Icons</a>.
   */
  iconVariant: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['bare', 'container', 'border', 'border-filled', 'more', 'global-header']),

  /**
   * A unique ID is needed in order to support keyboard navigation, ARIA support, and connect the dropdown to the triggering button.
   */
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Adds custom styling such as inverse fill and special sizing/spacing
   */
  globalAction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Positions dropdown menu with a nubbin--that is the arrow notch. The placement options correspond to the placement of the nubbin. This is implemeted with CSS classes and is best used with a `Button` with "icon container" styling. Dropdown menus will still be contained to the closest scrolling parent.
   */
  nubbinPosition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['top left', 'top', 'top right', 'bottom left', 'bottom', 'bottom right']),

  /**
   *  Offset adds pixels to the absolutely positioned dropdown menu in the format: ([vertical]px [horizontal]px).
   */
  offset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Triggered when an item in the menu is clicked.
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * An array of menu item.
   */
  options: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired
}; // ### Default Props

GlobalHeaderDropdown.defaultProps = {
  align: 'right',
  buttonVariant: 'icon',
  iconVariant: 'global-header',
  nubbinPosition: 'top right',
  // TODO: Use design tokens to remove "magic numbers" that center nubbin under button
  offset: '12px 16px'
};
/* unused harmony default export */ var _unused_webpack_default_export = (GlobalHeaderDropdown);
//# sourceMappingURL=dropdown.js.map

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__item__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_constants__ = __webpack_require__(2);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// # List Component
// ## Dependencies
// ### React


 // ### classNames

 // ## Children

 // ## Constants


/**
 * Component description.
 */

var List = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: __WEBPACK_IMPORTED_MODULE_5__utilities_constants__["S" /* LIST */],
  propTypes: {
    /**
     * Determines whether or not to show a checkmark for selected items.
     */
    checkmark: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * CSS classes to be added to `<ul />`.
     */
    className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * Used internally to determine the id that will be used for list items.
     */
    getListItemId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Used internally to pass references to the individual menu items back up for focusing / scrolling.
     */
    itemRefs: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * If provided, this function will be used to render the contents of each menu item.
     */
    itemRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Sets the height of the list based on the numeber of items.
     */
    length: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf([null, '5', '7', '10']),

    /**
     * Triggered when a list item is selected (via mouse or keyboard).
     */
    onSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * An array of items to render in the list.
     */
    options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,

    /**
     * The index of the currently selected item in the list.
     */
    selectedIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,

    /**
     * The id of the element which triggered this list (in a menu context).
     */
    triggerId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
  },
  getDefaultProps: function getDefaultProps() {
    return {
      length: '5',
      options: [],
      selectedIndex: -1
    };
  },
  render: function render() {
    var _this = this;

    var lengthClassName;

    if (this.props.length) {
      lengthClassName = "slds-dropdown--length-".concat(this.props.length);
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
      "aria-labelledby": this.props.triggerId,
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('dropdown__list', lengthClassName, this.props.className),
      role: "menu"
    }, this.props.options.map(function (option, index) {
      var id = _this.props.getListItemId(index);

      var isSingleSelected = index === _this.props.selectedIndex;
      var isMultipleSelected = !!_this.props.selectedIndices && _this.props.selectedIndices.indexOf(index) !== -1;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__item__["a" /* default */], _extends({}, option, {
        "aria-disabled": option.disabled,
        checkmark: _this.props.checkmark && (isSingleSelected || isMultipleSelected),
        data: option,
        id: id,
        index: index,
        isSelected: isSingleSelected || isMultipleSelected,
        key: "".concat(id, "-").concat(option.value),
        labelRenderer: _this.props.itemRenderer,
        onSelect: _this.props.onSelect,
        ref: function ref(listItem) {
          return _this.props.itemRefs(listItem, index);
        }
      }));
    }));
  }
});
/* harmony default export */ __webpack_exports__["a"] = (List);
//# sourceMappingURL=index.js.map

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__icon__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__item_label__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_event__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utilities_constants__ = __webpack_require__(2);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
// # List Item Component
// ## Dependencies
// ### React


 // ### classNames

 // ### Icon

 // ## Children

 // ### Event Helpers

 // ## Constants


/**
 * Component description.
 */

var ListItem = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: __WEBPACK_IMPORTED_MODULE_7__utilities_constants__["T" /* LIST_ITEM */],
  propTypes: {
    'aria-disabled': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
    checkmark: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    data: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    divider: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['top', 'bottom']),
    href: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    index: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,
    inverted: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    isSelected: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    label: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    labelRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    leftIcon: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
      category: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
      name: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
    }),
    onSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    rightIcon: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
      category: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
      name: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
    }),
    type: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any
  },
  getDefaultProps: function getDefaultProps() {
    return {
      data: {},
      href: 'javascript:void(0);',
      // eslint-disable-line no-script-url
      inverted: false,
      isSelected: false,
      label: '',
      labelRenderer: __WEBPACK_IMPORTED_MODULE_5__item_label__["a" /* default */],
      value: null
    };
  },
  getLabel: function getLabel() {
    var Label = this.props.labelRenderer;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, {
      checkmark: this.props.checkmark,
      data: this.props.data,
      icon: this.getIcon('left'),
      index: this.props.index,
      inverted: this.props.inverted,
      isSelected: this.props.isSelected,
      label: this.props.label,
      value: this.props.value
    });
  },
  getIcon: function getIcon(position) {
    var classnames = ['slds-icon-text-default'];
    var iconProps = this.props["".concat(position, "Icon")];

    if (position === 'left') {
      if (this.props.checkmark) {
        classnames.push('slds-icon--selected');
        iconProps = {
          category: 'utility',
          name: 'check'
        };
      }

      classnames.push('slds-m-right--x-small');
    } else {
      classnames.push('slds-m-left--small');
    }

    if (iconProps) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__icon__["a" /* default */], _extends({
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(classnames),
        position: position,
        size: "x-small"
      }, iconProps));
    }

    return null;
  },
  handleClick: function handleClick(event) {
    if (this.props.type !== 'link' || this.props.href === 'javascript:void(0);' // eslint-disable-line no-script-url
    ) {
        // eslint-disable-line no-script-url
        __WEBPACK_IMPORTED_MODULE_6__utilities_event__["a" /* default */].trapImmediate(event);
      }

    if (this.props.onSelect) {
      this.props.onSelect(this.props.index);
    }
  },
  handleMouseDown: function handleMouseDown(event) {
    __WEBPACK_IMPORTED_MODULE_6__utilities_event__["a" /* default */].trapImmediate(event);
  },
  render: function render() {
    switch (this.props.type) {
      case 'header':
        {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
            className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('slds-dropdown__header', {
              'slds-has-divider--top-space': this.props.divider === 'top',
              'slds-has-divider--bottom-space': this.props.divider === 'bottom'
            }, this.props.className),
            onMouseDown: this.handleMouseDown,
            role: "separator"
          }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
            className: "slds-text-title--caps"
          }, this.props.label));
        }

      case 'divider':
        {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
            className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('slds-has-divider', this.props.className),
            onMouseDown: this.handleMouseDown,
            role: "separator"
          });
        }

      case 'link':
      case 'item':
      default:
        {
          return (
            /* eslint-disable jsx-a11y/role-supports-aria-props */
            // disabled eslint, but using aria-selected on presentation role seems suspicious...
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
              "aria-selected": this.props.isSelected,
              className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('slds-dropdown__item', {
                'slds-is-selected': this.props.isSelected
              }, this.props.className),
              id: this.props.id,
              onMouseDown: this.handleMouseDown,
              role: "presentation"
            }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
              "aria-disabled": this.props['aria-disabled'],
              href: this.props.href,
              "data-index": this.props.index,
              onClick: this.handleClick,
              role: "menuitem",
              tabIndex: "-1"
            }, this.getLabel(), this.getIcon('right')))
          );
        }
    }
  }
});
/* harmony default export */ __webpack_exports__["a"] = (ListItem);
//# sourceMappingURL=item.js.map

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KeyBuffer */
/* unused harmony export itemIsSelectable */
/* unused harmony export getNavigableItems */
/* unused harmony export keyboardNavigate */
/* unused harmony export KeyboardNavigableMixin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_escaperegexp__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_escaperegexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_escaperegexp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isfunction__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isfunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isfunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__key_code__ = __webpack_require__(8);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// # Keyboard Navigable Trait
// ## Dependencies
// ### React
 // ### escapeRegExp

 // ### isFunction

 // ### Event Helpers


/* eslint-disable react/no-find-dom-node */

var noop = function noop() {};

function KeyBuffer() {
  var _this = this;

  this.buffer = '';
  return function (key) {
    if (_this.timeout) {
      clearTimeout(_this.timeout);
      _this.timeout = undefined;
    }

    _this.timeout = setTimeout(function () {
      _this.buffer = '';
    }, 400);
    _this.buffer = _this.buffer + key;
    return _this.buffer;
  };
}
function itemIsSelectable(item) {
  return item.type !== 'header' && item.type !== 'divider' && !item.disabled;
}
function getNavigableItems(items) {
  var navigableItems = [];
  navigableItems.indexes = [];
  navigableItems.keyBuffer = new KeyBuffer();

  if (Array.isArray(items)) {
    items.forEach(function (item, index) {
      if (itemIsSelectable(item)) {
        navigableItems.push({
          index: index,
          text: "".concat(item.label).toLowerCase()
        });
        navigableItems.indexes.push(index);
      }
    });
  }

  return navigableItems;
}
function keyboardNavigate(_ref) {
  var componentContext = _ref.componentContext,
      currentFocusedIndex = _ref.currentFocusedIndex,
      isOpen = _ref.isOpen,
      event = _ref.event,
      key = _ref.key,
      keyCode = _ref.keyCode,
      navigableItems = _ref.navigableItems,
      onFocus = _ref.onFocus,
      onSelect = _ref.onSelect,
      target = _ref.target,
      toggleOpen = _ref.toggleOpen;
  var indexes = navigableItems.indexes;
  var lastIndex = indexes.length - 1;
  var focusedIndex;
  var ch = key || String.fromCharCode(keyCode);

  if (/^[ -~]$/.test(ch)) {
    ch = ch.toLowerCase();
  } else {
    ch = null;
  }

  var openMenuKeys = keyCode === __WEBPACK_IMPORTED_MODULE_3__key_code__["a" /* default */].ENTER || keyCode === __WEBPACK_IMPORTED_MODULE_3__key_code__["a" /* default */].SPACE || keyCode === __WEBPACK_IMPORTED_MODULE_3__key_code__["a" /* default */].UP;

  if (keyCode === __WEBPACK_IMPORTED_MODULE_3__key_code__["a" /* default */].ESCAPE) {
    if (isOpen) toggleOpen();
  } else if (!isOpen) {
    focusedIndex = indexes[0];

    if (openMenuKeys || ch) {
      toggleOpen();
    }

    if (openMenuKeys && componentContext.trigger && __WEBPACK_IMPORTED_MODULE_0_react_dom___default.a.findDOMNode(componentContext.trigger) === target) {
      // eslint-disable-line react/no-find-dom-node
      componentContext.handleClick(event);
    }
  } else if (keyCode === __WEBPACK_IMPORTED_MODULE_3__key_code__["a" /* default */].ENTER || keyCode === __WEBPACK_IMPORTED_MODULE_3__key_code__["a" /* default */].SPACE) {
    onSelect(currentFocusedIndex);
  } else {
    var navigableIndex = indexes.indexOf(currentFocusedIndex);

    if (keyCode === __WEBPACK_IMPORTED_MODULE_3__key_code__["a" /* default */].DOWN) {
      if (navigableIndex < lastIndex) {
        var newNavigableIndex = navigableIndex + 1;
        focusedIndex = indexes[newNavigableIndex];
      } else {
        focusedIndex = indexes[0];
      }
    } else if (keyCode === __WEBPACK_IMPORTED_MODULE_3__key_code__["a" /* default */].UP) {
      if (navigableIndex > 0) {
        var _newNavigableIndex = navigableIndex - 1;

        focusedIndex = indexes[_newNavigableIndex];
      } else {
        focusedIndex = indexes[lastIndex];
      }
    } else if (ch) {
      // Combine subsequent keypresses
      var pattern = navigableItems.keyBuffer(ch);
      var consecutive = 0; // Support for navigating to the next option of the same letter with repeated presses of the same key

      if (pattern.length > 1 && new RegExp("^[".concat(__WEBPACK_IMPORTED_MODULE_1_lodash_escaperegexp___default()(ch), "]+$")).test(pattern)) {
        consecutive = pattern.length;
      }

      navigableItems.forEach(function (item) {
        if (focusedIndex === undefined && item.text.substr(0, pattern.length) === pattern || consecutive > 0 && item.text.substr(0, 1) === ch) {
          consecutive -= 1;
          focusedIndex = item.index;
        }
      });
    }
  }

  onFocus(focusedIndex);
  return focusedIndex;
}

function getMenu(componentRef) {
  return __WEBPACK_IMPORTED_MODULE_0_react_dom___default.a.findDOMNode(componentRef).querySelector('ul.dropdown__list'); // eslint-disable-line react/no-find-dom-node
}

function getMenuItem(menuItemId) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
  var menuItem;

  if (menuItemId) {
    menuItem = context.getElementById(menuItemId);
  }

  return menuItem;
}

var KeyboardNavigableMixin = {
  componentWillMount: function componentWillMount() {
    this.navigableItems = getNavigableItems(this.props.options);
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (nextProps.options) {
      this.navigableItems = getNavigableItems(nextProps.options);
    }
  },
  // Handling open / close toggling is optional, and a default implementation is provided for handling focus, but selection _must_ be handled
  handleKeyboardNavigate: function handleKeyboardNavigate(_ref2) {
    var event = _ref2.event,
        _ref2$isOpen = _ref2.isOpen,
        isOpen = _ref2$isOpen === void 0 ? true : _ref2$isOpen,
        keyCode = _ref2.keyCode,
        _ref2$onFocus = _ref2.onFocus,
        onFocus = _ref2$onFocus === void 0 ? this.handleKeyboardFocus : _ref2$onFocus,
        onSelect = _ref2.onSelect,
        target = _ref2.target,
        _ref2$toggleOpen = _ref2.toggleOpen,
        toggleOpen = _ref2$toggleOpen === void 0 ? noop : _ref2$toggleOpen;
    keyboardNavigate({
      componentContext: this,
      currentFocusedIndex: this.state.focusedIndex,
      event: event,
      isOpen: isOpen,
      keyCode: keyCode,
      navigableItems: this.navigableItems,
      onFocus: onFocus,
      onSelect: onSelect,
      target: target,
      toggleOpen: toggleOpen
    });
  },
  // This is a bit of an anti-pattern, but it has the upside of being a nice default. Component authors can always override to only set state and do their own focusing in their subcomponents.
  handleKeyboardFocus: function handleKeyboardFocus(focusedIndex) {
    if (this.state.focusedIndex !== focusedIndex) {
      this.setState({
        focusedIndex: focusedIndex
      });
    }

    var menu = __WEBPACK_IMPORTED_MODULE_2_lodash_isfunction___default()(this.getMenu) ? this.getMenu() : getMenu(this);
    var menuItem = __WEBPACK_IMPORTED_MODULE_2_lodash_isfunction___default()(this.getMenuItem) ? this.getMenuItem(focusedIndex, menu) : getMenuItem(this.getListItemId(focusedIndex));

    if (menuItem) {
      this.focusMenuItem(menuItem);
      this.scrollToMenuItem(menu, menuItem);
    }
  },
  getListItemId: function getListItemId(index) {
    var menuItemId;

    if (index !== undefined) {
      var menuId = __WEBPACK_IMPORTED_MODULE_2_lodash_isfunction___default()(this.getId) ? this.getId() : this.props.id;
      menuItemId = "".concat(menuId, "-item-").concat(index);
    }

    return menuItemId;
  },
  focusMenuItem: function focusMenuItem(menuItem) {
    menuItem.getElementsByTagName('a')[0].focus();
  },
  scrollToMenuItem: function scrollToMenuItem(menu, menuItem) {
    if (menu && menuItem) {
      var menuHeight = menu.offsetHeight;
      var menuTop = menu.scrollTop;
      var menuItemTop = menuItem.offsetTop - menu.offsetTop;

      if (menuItemTop < menuTop) {
        menu.scrollTop = menuItemTop;
      } else {
        var menuBottom = menuTop + menuHeight + menu.offsetTop;
        var menuItemBottom = menuItemTop + menuItem.offsetHeight + menu.offsetTop;

        if (menuItemBottom > menuBottom) {
          menu.scrollTop = menuItemBottom - menuHeight - menu.offsetTop;
        }
      }
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (KeyboardNavigableMixin);
//# sourceMappingURL=keyboard-navigable-menu.js.map

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__button__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_constants__ = __webpack_require__(2);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
// # Global Header Dropdown Component
// ## Dependencies
// ### React


 // ### classNames
// [github.com/JedWatson/classnames](https://github.com/JedWatson/classnames)
// This project uses `classnames`, "a simple javascript utility for conditionally
// joining classNames together."

 // ### Dropdown

 // ### Children


/**
 *  The Dropdown Button Trigger renders the default trigger button for the dropdown menu. If this component has children, it does not render itself to the DOM. Instead, it renders its child element, `Button`, and all that child's properties. This component may be used as a template to create custom triggers that do not use `Button`.
 */

var GlobalHeaderDropdownTrigger = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  // TODO: Make this a stateless component, however dropdowns break when this component becomes stateless.
  // ### Display Name
  // Always use the canonical component name (set in the core) as the React
  // display name.
  displayName: __WEBPACK_IMPORTED_MODULE_5__utilities_constants__["Y" /* MENU_DROPDOWN_TRIGGER */],
  // ### Prop Types
  propTypes: {
    /**
     * An image URL to display for the user profile.
     */
    avatar: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * CSS classes to be added to `li` element.
     */
    className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),

    /**
     * A unique ID is needed in order to support keyboard navigation, ARIA support, and connect the dropdown to the triggering button.
     */
    id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * Informs the trigger on the open/close state of the dropdown menu
     */
    isOpen: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * Adds custom styling such as inverse fill and special sizing/spacing
     */
    globalAction: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * The dropdown menu.
     */
    menu: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,

    /**
     * Is only called when `openOn` is set to `hover` and when the triggering li loses focus.
     */
    onBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * This prop is passed onto the triggering `li`. Triggered when the trigger li is clicked.
     */
    onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Is only called when `openOn` is set to `hover` and when the triggering li gains focus.
     */
    onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Called when a key pressed.
     */
    onKeyDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Called when mouse clicks down on the trigger li.
     */
    onMouseDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Called when mouse hovers over the trigger `li`.
     */
    onMouseEnter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Called when mouse leaves trigger `li` or the menu.
     */
    onMouseLeave: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Determines if mouse hover or click opens the dropdown menu. The default of `click` is highly recommended to comply with accessibility standards. If you are planning on using hover, please pause a moment and reconsider.
     */
    openOn: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['hover', 'click', 'hybrid']),

    /**
     * Set to true if menu is inline and relatively positioned with CSS. This is the typical use case for menus with nubbins.
     */
    positioned: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * The ref of the actual triggering button.
     */
    triggerRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
  },
  // ### Render
  render: function render() {
    // The following props are provided to the `li`, all others are passed into the `Button`
    var _props = this.props,
        avatar = _props.avatar,
        className = _props.className,
        id = _props.id,
        isOpen = _props.isOpen,
        globalAction = _props.globalAction,
        menu = _props.menu,
        onBlur = _props.onBlur,
        onClick = _props.onClick,
        onFocus = _props.onFocus,
        onKeyDown = _props.onKeyDown,
        onMouseDown = _props.onMouseDown,
        onMouseEnter = _props.onMouseEnter,
        onMouseLeave = _props.onMouseLeave,
        triggerRef = _props.triggerRef,
        rest = _objectWithoutProperties(_props, ["avatar", "className", "id", "isOpen", "globalAction", "menu", "onBlur", "onClick", "onFocus", "onKeyDown", "onMouseDown", "onMouseEnter", "onMouseLeave", "triggerRef"]); // TODO: Add avatar component for use across multiple components


    return (
      /* eslint-disable jsx-a11y/no-static-element-interactions */
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
        "aria-haspopup": "true",
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('slds-dropdown-trigger slds-dropdown-trigger--click', {
          'slds-is-open': isOpen,
          'slds-p-around--xx-small': globalAction
        }, className),
        id: id,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        ref: triggerRef
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__button__["a" /* default */], _extends({
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()({
          'slds-global-header__button--icon-actions': globalAction
        }),
        iconClassName: __WEBPACK_IMPORTED_MODULE_3_classnames___default()({
          'slds-global-header__icon-actions': globalAction
        }),
        "aria-haspopup": "true",
        buttonVariant: "dropdown"
      }, rest), avatar ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "slds-avatar slds-avatar--circle slds-avatar--medium"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        src: avatar,
        alt: ""
      })) : null), menu)
    );
  }
});
/* harmony default export */ __webpack_exports__["a"] = (GlobalHeaderDropdownTrigger);
//# sourceMappingURL=dropdown-trigger.js.map

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__menu_dropdown__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__private_dropdown_trigger__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_constants__ = __webpack_require__(2);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// # Global Header Button Component
// ## Dependencies
// ### React

 // ### classnames

 // ### Dropdown


 // ## Constants


/**
 * A helper component that renders a MenuDropdown for the user profile.
 */

var GlobalHeaderProfile = function GlobalHeaderProfile(props) {
  var avatar = props.avatar,
      buttonClassName = props.buttonClassName,
      children = props.children,
      rest = _objectWithoutProperties(props, ["avatar", "buttonClassName", "children"]);
  /* eslint-disable max-len */


  var defaultAvatar = 'data:image/jpeg;base64,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';
  /* eslint-enable max-len */

  return (// `slds-m-right--x-small` is present to prevent dropdown menu with a
    // "top right" nubbin from jumping offscreen
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__menu_dropdown__["a" /* default */], _extends({
      menuPosition: "relative",
      nubbinPosition: "top right"
    }, rest), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__private_dropdown_trigger__["a" /* default */], {
      avatar: avatar || defaultAvatar,
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('slds-m-left--x-small', buttonClassName)
    }), children)
  );
}; // ### Display Name
// Always use the canonical component name (set in the core) as the React
// display name.


GlobalHeaderProfile.displayName = __WEBPACK_IMPORTED_MODULE_5__utilities_constants__["F" /* GLOBAL_HEADER_PROFILE */]; // ### Prop Types

GlobalHeaderProfile.propTypes = {
  /**
   * Aligns the right or left side of the menu with the respective side of the trigger. This is not intended for use with `nubbinPosition`.
   */
  align: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['left', 'right']),

  /**
   * By default, any children passed into this component will be rendered inside the dropdown menu. If you need custom content and a list, import 'design-system-react/components/utilities/menu-list/list' and pass in `<List>`.
   *
   * ```
   * <Dropdown>
   *   <div>Look ma! This is Custom Content.</div>
   *   <List options={[myArray]}/>
   * </Dropdown>
   * ```
   */
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * Extra classnames to apply to the dropdown menu.
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * An image URL to display for the user profile.
   */
  avatar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * CSS classes to be added to `li` element.
   */
  buttonClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * A unique ID is needed in order to support keyboard navigation, ARIA support, and connect the dropdown to the triggering button.
   */
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Positions dropdown menu with a nubbin--that is the arrow notch. The placement options correspond to the placement of the nubbin. This is implemeted with CSS classes and is best used with a `Button` with "icon container" styling. Dropdown menus will still be contained to the closest scrolling parent.
   */
  nubbinPosition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['top left', 'top', 'top right', 'bottom left', 'bottom', 'bottom right']),

  /**
   *  Offset adds pixels to the absolutely positioned dropdown menu in the format: ([vertical]px [horizontal]px).
   */
  offset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Triggered when an item in the menu is clicked.
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * An array of menu item.
   */
  options: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
}; // ### Default Props

GlobalHeaderProfile.defaultProps = {
  align: 'right',
  buttonVariant: 'icon',
  iconVariant: 'container',
  nubbinPosition: 'top right',
  // TODO: Use design tokens to remove "magic numbers" that center nubbin under button
  offset: '-12px -18px'
};
/* unused harmony default export */ var _unused_webpack_default_export = (GlobalHeaderProfile);
//# sourceMappingURL=profile.js.map

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lookup__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_constants__ = __webpack_require__(2);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// # Global Header Search Component
// ## Dependencies
// ### React
 // ### Lookup

 // ## Constants


/**
 * The Global Header Search component is currently a Lookup. In the future this wrapper may provide additional presets or features.
 */

var GlobalHeaderSearch = function GlobalHeaderSearch(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "slds-global-header__item slds-global-header__item--search"
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__lookup__["a" /* default */], _extends({
    iconPosition: "left"
  }, props)));
};

GlobalHeaderSearch.displayName = __WEBPACK_IMPORTED_MODULE_2__utilities_constants__["G" /* GLOBAL_HEADER_SEARCH */];
/* unused harmony default export */ var _unused_webpack_default_export = (GlobalHeaderSearch);
//# sourceMappingURL=search.js.map

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_constants__ = __webpack_require__(2);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// # Global Navigation Bar Component
// Implements the [Global Navigation Bar design pattern](https://www.lightningdesignsystem.com/components/global-navigation#flavor-navigation-bar) in React.
// Based on SLDS v2.1.0-rc.2
// ## Dependencies
// ### React

 // ### classNames

 // ## Constants



var auditChildren = function auditChildren(children) {
  var primaryRegion; // there can be multiple secondary navigation regions

  var secondaryRegions = [];
  var tertiaryRegion;
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (child && child.type.displayName === __WEBPACK_IMPORTED_MODULE_3__utilities_constants__["L" /* GLOBAL_NAVIGATION_BAR_REGION */]) {
      if (child.props.region === 'primary') {
        primaryRegion = child;
      } else if (child.props.region === 'secondary') {
        secondaryRegions.push(child);
      } else if (child.props.region === 'tertiary') {
        tertiaryRegion = child;
      }
    }
  });

  if (primaryRegion && secondaryRegions.length > 0) {
    var dividerPosition = primaryRegion.props.dividerPosition === undefined ? 'right' : primaryRegion.props.dividerPosition;
    primaryRegion = __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(primaryRegion, {
      dividerPosition: dividerPosition,
      key: 'primary-region'
    });
  }

  return [primaryRegion].concat(secondaryRegions, [tertiaryRegion]);
};
/**
 * Global Navigation Bar represents a list of links that either take the user to another page or parts of the page the user is in.
 */


var GlobalNavigationBar = function GlobalNavigationBar(props) {
  var _classNames;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('slds-context-bar', (_classNames = {}, _defineProperty(_classNames, "slds-context-bar--theme-".concat(props.cloud), props.cloud), _defineProperty(_classNames, "slds-context-bar--theme-".concat(props.theme), props.theme), _classNames), props.className)
  }, auditChildren(props.children));
}; // ### Prop Types


GlobalNavigationBar.propTypes = {
  /**
   * The items to be displayed in the Global Navigation Bar.
   */
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * CSS class names to be added to the container element.
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * Typically the cloud name (e.g.- "sales" or "marketing"). This primarily changes the background color.
   */
  cloud: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Transforms text and interactions (such as hover) to be more visually accessible.
   */
  theme: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['light', 'dark'])
};
GlobalNavigationBar.defaultProps = {
  cloud: 'default',
  theme: 'dark'
};
GlobalNavigationBar.displayName = __WEBPACK_IMPORTED_MODULE_3__utilities_constants__["I" /* GLOBAL_NAVIGATION_BAR */];
/* unused harmony default export */ var _unused_webpack_default_export = (GlobalNavigationBar);
//# sourceMappingURL=index.js.map

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export regions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_constants__ = __webpack_require__(2);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable jsx-a11y/no-redundant-roles */
// # Global Navigation Bar Region Component
// ## Dependencies
// ### React


 // ### classNames

 // ## Constants

 // List regions for export

var regions = ['primary', 'secondary', 'tertiary'];
/* eslint-disable react/display-name */

var renderPrimary = function renderPrimary(dividerClass, className, children) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('slds-context-bar__primary', dividerClass, className)
  }, children);
};

var renderSecondary = function renderSecondary(dividerClass, className, children, navigation) {
  var region;

  if (navigation) {
    region = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("nav", {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('slds-context-bar__secondary', dividerClass, className),
      role: "navigation"
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
      className: "slds-grid"
    }, children));
  } else {
    region = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('slds-context-bar__secondary', dividerClass, className)
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
      className: "slds-grid"
    }, children));
  }

  return region;
};

var renderTertiary = function renderTertiary(dividerClass, className, children) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('slds-context-bar__tertiary', 'slds-col--bump-left', dividerClass, className)
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
    className: "slds-grid"
  }, children));
};
/* eslint-enable react/display-name */

/**
 * Regions make up a GlobalNavigation Bar and typically contain links and dropdowns. The Primary region contains the AppSwitcher, Application Name, and Object Switcher. The secondary region typically has navigation betweens sections of the application. The tertiary region is aligned to the right side of the screen and contains shortcuts or actions.
 */


var Region = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: __WEBPACK_IMPORTED_MODULE_4__utilities_constants__["L" /* GLOBAL_NAVIGATION_BAR_REGION */],
  propTypes: {
    /**
     * Contents of region. Expects `GlobalNavigationBarLink`, `GlobalNavigationBarDropdown`, `GlobalNavigationBarApplicationName`, `AppSwitcher`, but could be any component. This is the place to pass in an Object Switcher until that is supported.
     */
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,

    /**
     * Determines position of separating bar.
     */
    dividerPosition: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['left', 'right']),

    /**
     * CSS classes to be added to the region
     */
    className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),

    /**
     * Wraps the `secondary` region in a `nav` and adds a role attribute
     */
    navigation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * Region wrap children in styling specific to that region.
     */
    region: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['primary', 'secondary', 'tertiary']).isRequired
  },
  render: function render() {
    var region;
    var dividerClass = this.props.dividerPosition ? "slds-context-bar__item--divider-".concat(this.props.dividerPosition) : null;

    switch (this.props.region) {
      case 'primary':
        region = renderPrimary(dividerClass, this.props.className, this.props.children);
        break;

      case 'secondary':
        region = renderSecondary(dividerClass, this.props.className, this.props.children, this.props.navigation);
        break;

      case 'tertiary':
        region = renderTertiary(dividerClass, this.props.className, this.props.children);
        break;

      default: // do nothing

    }

    return region;
  }
});
/* unused harmony default export */ var _unused_webpack_default_export = (Region);

//# sourceMappingURL=region.js.map

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isfunction__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isfunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isfunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_constants__ = __webpack_require__(2);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// # GlobalNavigationBar Link Component
// ## Dependencies
// ### React

 // ### classNames

 // ### isFunction

 // ## Constants



function handleClick(event, href, onClick) {
  event.preventDefault();
  onClick(event, {
    href: href
  });
}
/**
 * Wraps a link in the proper markup to support use in the GlobalNavigationBar.
 */


var GlobalNavigationBarLink = function GlobalNavigationBarLink(props) {
  // Separate props we care about in order to pass others along passively to the `a` tag
  var active = props.active,
      activeBackgroundColor = props.activeBackgroundColor,
      className = props.className,
      dividerPosition = props.dividerPosition,
      href = props.href,
      id = props.id,
      label = props.label,
      onBlur = props.onBlur,
      onClick = props.onClick,
      onFocus = props.onFocus,
      onKeyDown = props.onKeyDown,
      onKeyPress = props.onKeyPress,
      tabIndex = props.tabIndex;
  var listItemstyle = active ? {
    backgroundColor: activeBackgroundColor,
    borderBottomColor: activeBackgroundColor
  } : null;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('slds-context-bar__item', _defineProperty({
      'slds-is-active': active
    }, "slds-context-bar__item--divider-".concat(dividerPosition), dividerPosition)),
    id: id,
    style: listItemstyle
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: href,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('slds-context-bar__label-action', className),
    onBlur: onBlur,
    onClick: __WEBPACK_IMPORTED_MODULE_3_lodash_isfunction___default()(onClick) ? function (event) {
      return handleClick(event, href, onClick);
    } : null,
    onFocus: onFocus,
    onKeyDown: onKeyDown,
    onKeyPress: onKeyPress,
    tabIndex: tabIndex
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "slds-truncate"
  }, label)));
};

GlobalNavigationBarLink.displayName = __WEBPACK_IMPORTED_MODULE_4__utilities_constants__["K" /* GLOBAL_NAVIGATION_BAR_LINK */]; // ### Prop Types

GlobalNavigationBarLink.propTypes = {
  /**
   * Whether the item is active or not.
   */
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Allows alignment of active item with active application background color. If application background is dark, text color may need to be `#fff`. This can be done with the style prop.
   */
  activeBackgroundColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Class names to be added to the anchor element
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * Determines position of separating bar.
   */
  dividerPosition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['left', 'right']),

  /**
   * The `href` attribute of the link. Please pass in bookmarkable URLs from your routing library. Use `GlobalNavigationBarButton` if a "real URL" is not desired. If the `onClick` callback is specified this URL will still be prevented from changing the browser's location.
   */
  href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * The `id` attribute is applied to the `li` tag. _This was recently changed from being on the anchor tag._
   */
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Text to show for link item.
   */
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Triggered when focus is removed.
   */
  onBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * `function (event, href)` - fires when the link is clicked. If set, the browser location change to the `href` specified will be ignored, but the `href` will be included in an additional parameter passed to the callback.
   */
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Triggered when component is focused.
   */
  onFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Triggered when a key is pressed down
   */
  onKeyDown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Triggered when a key is pressed and released
   */
  onKeyPress: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Triggered when a key is released
   */
  onKeyUp: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Triggered when a mouse arrow hovers
   */
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Triggered when a mouse arrow no longer hovers
   */
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Write "-1" if you don't want the user to tab to the button.
   */
  tabIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
GlobalNavigationBarLink.defaultProps = {
  href: 'javascript:void(0);' // eslint-disable-line no-script-url

};
/* unused harmony default export */ var _unused_webpack_default_export = (GlobalNavigationBarLink);
//# sourceMappingURL=link.js.map

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__check_props__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__menu_dropdown__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dropdown_trigger__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_constants__ = __webpack_require__(2);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// # Global Navigation Dropdown Component
// ## Dependencies
// ### React


 // ### Dropdown


 // ## Constants


/**
 * This component is an implementation of `MenuDropdown` with a custom trigger. All the properties listed below are provided to the `MenuDropdown` component. Any additional properties are provided to the Custom Trigger (that is the `Button` or `li` tag).
 */

var GlobalNavigationBarDropdown = function GlobalNavigationBarDropdown(props) {
  Object(__WEBPACK_IMPORTED_MODULE_2__check_props__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5__utilities_constants__["J" /* GLOBAL_NAVIGATION_BAR_DROPDOWN */], props); // Separate props we care about in order to pass others along passively to the dropdown component

  var active = props.active,
      activeBackgroundColor = props.activeBackgroundColor,
      assistiveText = props.assistiveText,
      dividerPosition = props.dividerPosition,
      rest = _objectWithoutProperties(props, ["active", "activeBackgroundColor", "assistiveText", "dividerPosition"]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__menu_dropdown__["a" /* default */], _extends({
    align: "right",
    hasStaticAlignment: true // only need if using hybrid or hover
    ,
    hoverCloseDelay: 400,
    length: props.length,
    menuPosition: "relative"
  }, rest), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__dropdown_trigger__["a" /* default */], {
    active: active,
    assistiveText: assistiveText,
    activeBackgroundColor: activeBackgroundColor,
    dividerPosition: dividerPosition
  }));
}; // ### Display Name
// Always use the canonical component name (set in the core) as the React
// display name.


GlobalNavigationBarDropdown.displayName = __WEBPACK_IMPORTED_MODULE_5__utilities_constants__["J" /* GLOBAL_NAVIGATION_BAR_DROPDOWN */]; // ### Prop Types

GlobalNavigationBarDropdown.propTypes = {
  /**
   * Whether the item is active or not.
   */
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Allows alignment of active item with active application background color.
   */
  activeBackgroundColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * **Assistive text for accessibility.**
   * This object is merged with the default props object on every render.
   * * `icon`: Text that is visually hidden but read aloud by screenreaders to tell the user what the icon means. If the button has an icon and a visible label, you can omit the <code>assistiveText.icon</code> prop and use the <code>label</code> prop.
   */
  assistiveText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),

  /**
   * Aligns the right or left side of the menu with the respective side of the trigger. This is not intended for use with `nubbinPosition`.
   */
  align: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['left', 'right']),

  /**
   * Extra classnames to apply to the dropdown menu.
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Determines position of separating bar.
   */
  dividerPosition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['left', 'right']),

  /**
   * CSS classes to be added to `li` element.
   */
  buttonClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * A unique ID is needed in order to support keyboard navigation, ARIA support, and connect the dropdown to the triggering button.
   */
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Provided to List to indicate number of items visible in the List. Pass `null` to display all items, or a string containing one of the numeric option values listed under [Dropdown Height](https://www.lightningdesignsystem.com/components/menus/#flavor-dropdown-height) at the right (eg. '5').
   */
  length: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([null, '5', '7', '10']),

  /**
   *  Offset adds pixels to the absolutely positioned dropdown menu in the format: ([vertical]px [horizontal]px).
   */
  offset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Triggered when an item in the menu is clicked.
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * An array of menu item.
   */
  options: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired
}; // ### Default Props

GlobalNavigationBarDropdown.defaultProps = {
  align: 'right',
  length: null
};
/* unused harmony default export */ var _unused_webpack_default_export = (GlobalNavigationBarDropdown);
//# sourceMappingURL=dropdown.js.map

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_warning_sunset_property__ = __webpack_require__(11);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable import/no-mutable-exports */


var checkProps = function checkProps() {};

if (false) {
  checkProps = function checkProps(COMPONENT, props) {
    if (typeof props.assistiveText === 'string') {
      sunsetProperty(COMPONENT, props.assistiveText, 'assistiveText', '`assistiveText` as a string has been deprecated and is now an object to allow for multiple uses in the component. Please use `assistiveText.icon` instead.');
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (checkProps);
//# sourceMappingURL=check-props.js.map

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shortid__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shortid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shortid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_assign__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_reject__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_reject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_reject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__check_props__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__cell__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__column__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__private_head__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__private_row__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__row_actions__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utilities_constants__ = __webpack_require__(2);
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// # Data Table Component
// Implements the [Data Table design pattern](https://www.lightningdesignsystem.com/components/data-tables) in React.
// ## Dependencies
// ### React


 // ### shortid
// [npmjs.com/package/shortid](https://www.npmjs.com/package/shortid)
// shortid is a short, non-sequential, url-friendly, unique id generator

 // ### classNames

 // ### assign

 // ### reject

 // This component's `checkProps` which issues warnings to developers about properties when in development mode (similar to React's built in development tools)

 // ## Children





 // ## Constants

 // Safely get the length of an array, returning 0 for invalid input.

var count = function count(array) {
  return Array.isArray(array) ? array.length : 0;
};

var defaultProps = {
  assistiveText: {
    actionsHeader: 'Actions',
    columnSort: 'Sort by: ',
    columnSortedAscending: 'Sorted Ascending',
    columnSortedDescending: 'Sorted Descending',
    selectAllRows: 'Select all rows',
    selectRow: 'Select row'
  },
  id: __WEBPACK_IMPORTED_MODULE_3_shortid___default.a.generate(),
  selection: []
};
/**
 * DataTables support the display of structured data in rows and columns with an HTML table. To sort, filter or paginate the table, simply update the data passed in the items to the table and it will re-render itself appropriately. The table will throw a sort event as needed, and helper components for paging and filtering are coming soon.
 *
 */

var DataTable = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  // ### Display Name
  // Always use the canonical component name as the React display name.
  displayName: __WEBPACK_IMPORTED_MODULE_13__utilities_constants__["t" /* DATA_TABLE */],
  // ### Prop Types
  propTypes: {
    /**
     * **Assistive text for accessibility.**
     * This object is merged with the default props object on every render.
     * * `actionsHeader`: Text for heading of actions column
     * * `columnSort`: Text for sort action on table column header
     * * `columnSortedAscending`: Text announced once a column is sorted in ascending order
     * * `columnSortedDescending`: Text announced once a column is sorted in descending order
     * * `selectAllRows`: Text for select all checkbox within the table header
     * * `selectRow`: Text for select row
     */
    assistiveText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
      actionsHeader: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
      columnSort: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
      columnSortedAscending: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
      columnSortedDescending: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
      selectAllRows: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
      selectRow: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
    }),

    /**
     * Provide children of the type `<DataTableColumn />` to define the structure of the data being represented and children of the type `<DataTableRowActions />` to define a menu which will be rendered for each item in the grid. Use a _higher-order component_ to customize a data table cell that will override the default cell rendering. `CustomDataTableCell` must have the same `displayName` as `DataTableCell` or it will be ignored. If you want complete control of the HTML, including the wrapping `td`, you don't have to use `DataTableCell`.
     * ```
     * import DataTableCell from 'design-system-react/data-table/cell';
     * const CustomDataTableCell = ({ children, ...props }) => (
     *   <DataTableCell {...props} >
     *   <a href="javascript:void(0);">{children}</a>
     *   </DataTableCell>
     * );
     * CustomDataTableCell.displayName = DataTableCell.displayName;
     *
     * <DataTable>
     *   <DataTableColumn />
     *   <DataTableColumn>
     *   <DataTableCustomCell />
     *   </DataTableColumn>
     *   <DataTableRowActions />
     * </DataTable>
     * ```
     */
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,

    /**
     * Class names to be added to the table.
     */
    className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),

    /**
     * A variant which adds border to the vertical columns.
     */
    columnBordered: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * A unique ID is needed in order to support keyboard navigation and ARIA support.
     */
    id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * Use this if you are creating an advanced table (selectable, sortable, or resizable rows)
     */
    fixedLayout: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * The collection of items to render in the table. This is an array of objects with each object having keys that correspond with the  `property` prop of each `DataTableColumn`.
     */
    items: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
      id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired
    })).isRequired,

    /**
     * A variant which removes hover style on rows
     */
    noRowHover: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * This function fires when the selection of rows changes. This component passes in `event, { selection }` to the function. `selection` is an array of objects from the `items` prop.
     *
     * This used to be `onChange` which is deprecated now, so that the parameters can be consistent with other components. `onChange` passed in the selection first and the event wtihout a data object.
     */
    onRowChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * This function fires when the table should be sorted.
     */
    onSort: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * An array of objects of selected rows. See `items` prop for shape of objects.
     */
    selection: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,

    /**
     * True if rows should be selectable.
     */
    selectRows: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * A variant which modifies table layout by stacking cells to accommodate smaller viewports. Should not be used at the same time as `stackedHorizontal`.
     */
    stacked: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * A variant which modifies table layout by displaying the header and row data side by side for smaller viewports. Should not be used at the same time as `stacked`.
     */
    stackedHorizontal: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * A variant which adds stripes to alternating rows.
     */
    striped: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * Tables have horizontal borders by default. This removes them.
     */
    unborderedRow: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * A variant which removes horizontal padding. CSS class will be removed if `fixedLayout==true`.
     */
    unbufferedCell: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
  },
  getDefaultProps: function getDefaultProps() {
    return defaultProps;
  },
  componentWillMount: function componentWillMount() {
    // `checkProps` issues warnings to developers about properties (similar to React's built in development tools)
    Object(__WEBPACK_IMPORTED_MODULE_7__check_props__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_13__utilities_constants__["t" /* DATA_TABLE */], this.props);
  },
  handleToggleAll: function handleToggleAll(e, _ref) {
    var checked = _ref.checked;

    // REMOVE AT NEXT BREAKING CHANGE
    // `onChange` is deprecated and replaced with `onRowChange`
    if (typeof this.props.onChange === 'function') {
      var selection = checked ? _toConsumableArray(this.props.items) : [];
      this.props.onChange(selection, e);
    }

    if (typeof this.props.onRowChange === 'function') {
      var _selection = checked ? _toConsumableArray(this.props.items) : [];

      this.props.onRowChange(e, {
        selection: _selection
      });
    }
  },
  handleRowToggle: function handleRowToggle(item, selected, e) {
    // REMOVE AT NEXT BREAKING CHANGE
    // `onChange` is deprecated and replaced with `onRowChange`
    if (typeof this.props.onChange === 'function') {
      var selection;

      if (selected) {
        selection = _toConsumableArray(this.props.selection).concat([item]);
      } else {
        selection = __WEBPACK_IMPORTED_MODULE_6_lodash_reject___default()(this.props.selection, item);
      }

      this.props.onChange(selection, e);
    }

    if (typeof this.props.onRowChange === 'function') {
      var _selection2;

      if (selected) {
        _selection2 = _toConsumableArray(this.props.selection).concat([item]);
      } else {
        _selection2 = __WEBPACK_IMPORTED_MODULE_6_lodash_reject___default()(this.props.selection, item);
      }

      this.props.onRowChange(e, {
        selection: _selection2
      });
    }
  },
  // ### Render
  render: function render() {
    var _this = this;

    var numRows = count(this.props.items);
    var numSelected = count(this.props.selection);
    var canSelectRows = this.props.selectRows && numRows > 0;
    var allSelected = canSelectRows && numRows === numSelected;
    var indeterminateSelected = canSelectRows && numRows !== numSelected && numSelected !== 0;
    var columns = [];
    var RowActions = null;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(this.props.children, function (child) {
      if (child && child.type.displayName === __WEBPACK_IMPORTED_MODULE_9__column__["a" /* default */].displayName) {
        var _child$props = child.props,
            children = _child$props.children,
            columnProps = _objectWithoutProperties(_child$props, ["children"]);

        var props = __WEBPACK_IMPORTED_MODULE_5_lodash_assign___default()({}, _this.props);
        delete props.children;
        __WEBPACK_IMPORTED_MODULE_5_lodash_assign___default()(props, columnProps);
        var Cell;

        if (children && children.type.displayName === __WEBPACK_IMPORTED_MODULE_13__utilities_constants__["u" /* DATA_TABLE_CELL */]) {
          Cell = children.type;
          __WEBPACK_IMPORTED_MODULE_5_lodash_assign___default()(props, children.props);
        } else {
          Cell = __WEBPACK_IMPORTED_MODULE_8__cell__["a" /* default */];
        }

        columns.push({
          Cell: Cell,
          props: props,
          dataTableProps: _this.props
        });
      } else if (child && child.type.displayName === __WEBPACK_IMPORTED_MODULE_12__row_actions__["a" /* default */].displayName) {
        RowActions = child;
      }
    });

    var assistiveText = _objectSpread({}, defaultProps.assistiveText, this.props.assistiveText);

    if (this.props.assistiveTextForActionsHeader) {
      assistiveText.actionsHeader = this.props.assistiveTextForActionsHeader;
    }

    if (this.props.assistiveTextForSelectAllRows) {
      assistiveText.selectAllRows = this.props.assistiveTextForSelectAllRows;
    }

    if (this.props.assistiveTextForColumnSortedAscending) {
      assistiveText.columnSortedAscending = this.props.assistiveTextForColumnSortedAscending;
    }

    if (this.props.assistiveTextForColumnSortedDescending) {
      assistiveText.columnSortedDescending = this.props.assistiveTextForColumnSortedDescending;
    }

    if (this.props.assistiveTextForColumnSort) {
      assistiveText.columnSort = this.props.assistiveTextForColumnSort;
    }

    if (this.props.assistiveTextForSelectRow) {
      assistiveText.selectRow = this.props.assistiveTextForSelectRow;
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table", {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('slds-table', {
        'slds-table--fixed-layout': this.props.fixedLayout,
        'slds-table_resizable-cols': this.props.fixedLayout,
        'slds-table_bordered': !this.props.unborderedRow,
        'slds-table_cell-buffer': !this.props.fixedLayout && !this.props.unbufferedCell,
        'slds-max-medium-table_stacked': this.props.stacked,
        'slds-max-medium-table_stacked-horizontalviewports': this.props.stackedHorizontal,
        'slds-table_striped': this.props.striped,
        'slds-table_col-bordered': this.props.columnBordered,
        'slds-no-row-hover': this.props.noRowHover
      }, this.props.className),
      id: this.props.id,
      role: this.props.fixedLayout ? 'grid' : null
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__private_head__["a" /* default */], {
      assistiveText: assistiveText,
      allSelected: allSelected,
      indeterminateSelected: indeterminateSelected,
      canSelectRows: canSelectRows,
      columns: columns,
      id: "".concat(this.props.id, "-").concat(__WEBPACK_IMPORTED_MODULE_13__utilities_constants__["w" /* DATA_TABLE_HEAD */]),
      onToggleAll: this.handleToggleAll,
      onSort: this.props.onSort,
      showRowActions: !!RowActions
    }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody", null, numRows > 0 ? this.props.items.map(function (item) {
      var rowId = "".concat(_this.props.id, "-").concat(__WEBPACK_IMPORTED_MODULE_13__utilities_constants__["y" /* DATA_TABLE_ROW */], "-").concat(item.id) || __WEBPACK_IMPORTED_MODULE_3_shortid___default.a.generate();
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__private_row__["a" /* default */], {
        assistiveText: assistiveText,
        canSelectRows: canSelectRows,
        columns: columns,
        fixedLayout: _this.props.fixedLayout,
        id: rowId,
        item: item,
        key: rowId,
        onToggle: _this.handleRowToggle,
        selection: _this.props.selection,
        rowActions: RowActions
      });
    }) : // Someday this should be an element to render when the table is empty
    null));
  }
});
/* unused harmony default export */ var _unused_webpack_default_export = (DataTable);
//# sourceMappingURL=index.js.map

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_onclickoutside__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__date_picker__ = __webpack_require__(242);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// ### onClickOutside
// Listen for clicks that occur somewhere in the document, outside of the element itself


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0_react_onclickoutside__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__date_picker__["a" /* default */]));
//# sourceMappingURL=index.js.map

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__check_props__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_class_names__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_utility_icon_svg__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_constants__ = __webpack_require__(2);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// # Illustration Component
// Based on SLDS v2.6.2
// ## Dependencies
// ### React

 // This component's `checkProps` which issues warnings to developers about properties
// when in development mode (similar to React's built in development tools)

 // ### classNames
// [github.com/JedWatson/classnames](https://github.com/JedWatson/classnames)
// A simple javascript utility for conditionally joining classNames together.

 // ## SVG

 // ## Constants


/**
 * An illustration is an image and inline text that work in tandem to communicate a state in a more friendly way.
 */

var Illustration = function Illustration(_ref) {
  var className = _ref.className,
      illustration = _ref.illustration,
      internalIllustration = _ref.internalIllustration,
      heading = _ref.heading,
      messageBody = _ref.messageBody,
      name = _ref.name,
      path = _ref.path,
      size = _ref.size,
      style = _ref.style;
  Object(__WEBPACK_IMPORTED_MODULE_2__check_props__["a" /* default */])('Illustration', {
    illustration: illustration,
    internalIllustration: internalIllustration,
    heading: heading,
    path: path
  });
  var kababCaseName = name ? name.replace(/_| /g, '-').toLowerCase() : '';
  var illustrationSvg;

  if (illustration) {
    // Use SVG data passed in with `illustration` prop
    illustrationSvg = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__utilities_utility_icon_svg__["a" /* default */], {
      className: "slds-illustration__svg",
      "aria-hidden": "true",
      data: illustration,
      name: kababCaseName,
      style: style
    });
  } else if (path) {
    illustrationSvg = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
      className: "slds-illustration__svg",
      "aria-hidden": "true",
      name: kababCaseName,
      style: style
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("use", {
      xlinkHref: path
    }));
  } // large illustration svg should have a default height of 400px if not already specified


  if (illustrationSvg && size === 'large' && !style.height) {
    style.height = '400px';
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: Object(__WEBPACK_IMPORTED_MODULE_3__utilities_class_names__["a" /* default */])(className, 'slds-illustration', {
      'slds-illustration_small': size === 'small',
      'slds-illustration_large': size === 'large'
    })
  }, illustrationSvg, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "slds-text-longform"
  }, heading ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3", {
    className: "slds-text-heading_medium"
  }, heading) : null, messageBody ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
    className: "slds-text-body_regular"
  }, messageBody) : null));
}; // ### Display Name
// Always use the canonical component name as the React display name.


Illustration.displayName = __WEBPACK_IMPORTED_MODULE_5__utilities_constants__["Q" /* ILLUSTRATION */]; // ### Prop Types

Illustration.propTypes = {
  /**
   * CSS classes that are applied to the SVG. _Tested with Mocha testing._
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * A heading text. It is required if illustration is present. _Tested with snapshot testing._ _Tested with Mocha testing._
   */
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * A custom SVG object to use instead of the supplied SLDS illustrations, look in `design-system-react/assets/images/illustrations` for examples and syntax. _Tested with snapshot testing._ _Tested with Mocha testing._
   */
  illustration: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * Indicates whether the illustration SVGs are from the design-system-react repo. If yes, set to true.
   */
  internalIllustration: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,

  /**
   * A message body below the heading to further communicate the state of the component. _Tested with snapshot testing._ _Tested with Mocha testing._
   */
  messageBody: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]),

  /**
   * Name of the illustration. Visit <a href='https://lightningdesignsystem.com/components/illustration/'>Lightning Design System Illustration</a> to reference illustration names. _Tested with snapshot testing._ _Tested with Mocha testing._
   */
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Path to the illustration SVG image. _Tested with snapshot testing._
   */
  path: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Size of the illustration. _Tested with snapshot testing._ _Tested with Mocha testing._
   */
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['small', 'large']),

  /**
   * Custom styles to be passed to the illustration SVG. _Tested with Mocha testing._
   */
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
Illustration.defaultProps = {
  internalIllustration: true,
  size: 'small',
  style: {}
};
/* unused harmony default export */ var _unused_webpack_default_export = (Illustration);
//# sourceMappingURL=index.js.map

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_assign__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shortid__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shortid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_shortid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__check_props__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__popover__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utilities_constants__ = __webpack_require__(2);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable no-script-url */
// # Filter
// Implements part of the [Panel design pattern](https://www.lightningdesignsystem.com/components/panels) in React.
// Based on SLDS v2.2.0-rc.1
// ## Dependencies
// ### React


 // ### assign

 // ### classNames

 // ### shortid
// [npmjs.com/package/shortid](https://www.npmjs.com/package/shortid)
// shortid is a short, non-sequential, url-friendly, unique id generator

 // This component's `checkProps` which issues warnings to developers about properties when in development mode (similar to React's built in development tools)



 // ## Constants


/**
 * A Filter is a popover with custom trigger. It can be used by [Panel Filtering](/components/panels/). Menus within a Filter Popover will need to not have "portal mounts" and be inline.
 */

var Filter = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: __WEBPACK_IMPORTED_MODULE_9__utilities_constants__["C" /* FILTER */],
  propTypes: {
    /**
     * Aligns the popover with the respective side of the trigger. That is `left` will place the `Popover` to the left of the Filter.
     */
    align: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['left', 'right']),

    /**
     * **Assistive text for accessibility**
     * * `removeFilter`: Assistive text for removing a filter. The default is `Remove Filter: this.props.property this.props.predicate`.
     * * `editFilter`: Assistive text for changing a filter.
     * * `editFilterHeading`: Assistive text for Popover heading.
     */
    assistiveText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
      editFilter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
      editFilterHeading: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
      removeFilter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
    }),

    /**
     * Contents of popover. That is the dropdowns and inputs that set the filter criteria.
     */
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,

    /**
     * Custom CSS classes for `slds-filters__item` node. Uses `classNames` [API](https://github.com/JedWatson/classnames).
     */
    className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),

    /**
     * Applies error state styling. Per filter error messages are outside this components.
     */
    isError: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * A unique ID is needed in order to support keyboard navigation, ARIA support, and connect the dropdown to the triggering button. An `id` will be generated if none is supplied.
     */
    id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * If true, the filter will not display an editing popover when clicked.
     */
    isLocked: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * Applies new filter styling.
     */
    isNew: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * If true, the filter will not include a remove button.
     */
    isPermanent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * Will be triggered when Done within the Popover is clicked. This is the place to update the filter props displayed. Callback will recieve parameters: `clickEvent, { id }`. An index into your store may be a good setting for `id`, so that it will be passed back here.
     */
    onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Will be triggered when "Remove Filter" button is clicked. Callback will recieve parameters: `clickEvent, { id }`. An index into your store may be a good setting for `id`, so that it will be passed back here.
     */
    onRemove: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Will be triggered when Filter is clicked. This is the place to close/open popover if a custom popover is passed in
     */
    onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * A `Popover` component. The props from this popover will be merged and override any default props. This also allows a Filter's Popover dialog to be a controlled component. _Tested with Mocha framework._
     */
    popover: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,

    /**
     * The criteria you are filtering for. For instance, if "Hair Color is PURPLE" is your filter, "is PURPLE" is your filter predicate.
     */
    predicate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,

    /**
     * The property you are filtering. For instance, if "Hair Color is PURPLE" is your filter, "Hair Color" is your filter property.
     */
    property: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
  },
  getDefaultProps: function getDefaultProps() {
    return {
      align: 'left',
      assistiveText: {
        editFilter: 'Edit filter:',
        editFilterHeading: 'Choose filter criteria'
      },
      predicate: 'New Filter'
    };
  },
  getInitialState: function getInitialState() {
    return {
      popoverIsOpen: this.props.popover ? this.props.popover.props.isOpen : false
    };
  },
  componentWillMount: function componentWillMount() {
    this.generatedId = __WEBPACK_IMPORTED_MODULE_5_shortid___default.a.generate();
    Object(__WEBPACK_IMPORTED_MODULE_6__check_props__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_9__utilities_constants__["C" /* FILTER */]);
  },
  getId: function getId() {
    return this.props.id || this.generatedId;
  },
  getCustomPopoverProps: function getCustomPopoverProps(_ref) {
    var assistiveText = _ref.assistiveText;

    /*
     * Generate the popover props based on passed in popover props. Using the default behavior if not provided by passed in popover
     */
    var popoverBody = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", {
      className: "slds-assistive-text",
      id: "".concat(this.getId(), "-popover-heading")
    }, assistiveText.editFilterHeading), this.props.children, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "slds-m-top--small slds-text-align--right"
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__button__["a" /* default */], {
      className: "slds-col--bump-left",
      label: "Done",
      onClick: this.handleChange
    })));
    var defaultPopoverProps = {
      ariaLabelledby: "".concat(this.getId(), "-popover-heading"),
      align: this.props.align,
      body: popoverBody,
      heading: '',
      id: this.getId(),
      isOpen: this.state.popoverIsOpen,
      // MAGIC NUMBERS - REMOVE/REDESIGN WHEN DESIGN FOR RIGHT-ALIGNED FILTERS ARE ADDED TO SLDS
      offset: this.props.align === 'right' ? '0px -35px' : undefined,
      onClose: this.handleClose,
      onRequestClose: this.handleClose,
      position: 'overflowBoundaryElement',
      triggerClassName: 'slds-grow'
    };
    /* Mixin passed popover's props if there is any to override the default popover props */

    var popoverProps = __WEBPACK_IMPORTED_MODULE_3_lodash_assign___default()(defaultPopoverProps, this.props.popover ? this.props.popover.props : {});
    delete popoverProps.children;
    return popoverProps;
  },
  handleFilterClick: function handleFilterClick() {
    this.setState({
      popoverIsOpen: true
    });

    if (this.props.onClick) {
      this.props.onClick();
    }
  },
  handleClose: function handleClose() {
    this.setState({
      popoverIsOpen: false
    });
  },
  handleChange: function handleChange(event) {
    this.setState({
      popoverIsOpen: false
    });

    if (this.props.onChange) {
      this.props.onChange(event, {
        id: this.getId()
      });
    }
  },
  handleRemove: function handleRemove(event) {
    if (this.props.onRemove) {
      this.props.onRemove(event, {
        id: this.getId()
      });
    }
  },
  render: function render() {
    /* Remove at next breaking change */
    var assistiveText = {
      editFilter: this.props.assistiveTextEditFilter || // eslint-disable-line react/prop-types
      this.props.assistiveText.editFilter,
      editFilterHeading: this.props.assistiveTextEditFilterHeading || // eslint-disable-line react/prop-types
      this.props.assistiveText.editFilterHeading,
      removeFilter: this.props.assistiveTextRemoveFilter || // eslint-disable-line react/prop-types
      this.props.assistiveText.removeFilter || "Remove Filter: ".concat(this.props.property, " ").concat(this.props.predicate)
    };
    /* TODO: Button wrapper for property and predictate should be transitioned to `Button` component. `Button` needs to take custom children first though. */

    var popoverProps = this.getCustomPopoverProps({
      assistiveText: assistiveText
    });
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('slds-filters__item', 'slds-grid', 'slds-grid--vertical-align-center', {
        'slds-is-locked': this.props.isLocked,
        'slds-is-new': this.props.isNew,
        'slds-has-error': this.props.isError
      }, this.props.className)
    }, !this.props.isLocked && (this.props.children || this.props.popover) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__popover__["a" /* default */], popoverProps, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
      className: "slds-button--reset slds-grow slds-has-blur-focus",
      onClick: this.handleFilterClick,
      "aria-describedby": this.props.isError ? "".concat(this.getId(), "-error") : undefined
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: "slds-assistive-text"
    }, assistiveText.editFilter), this.props.property ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
      className: "slds-text-body--small"
    }, this.props.property) : null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, this.props.predicate))) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
      "aria-describedby": this.props.isError ? "".concat(this.getId(), "-error") : undefined,
      className: "slds-button--reset slds-grow slds-has-blur-focus",
      disabled: true
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
      className: "slds-text-body--small"
    }, this.props.property), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, this.props.predicate)), // Remove button
    !this.props.isPermanent && !this.props.isLocked ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__button__["a" /* default */], {
      assistiveText: {
        icon: assistiveText.removeFilter
      },
      hint: true,
      iconCategory: "utility",
      iconName: "close",
      iconSize: "small",
      iconVariant: "bare",
      onClick: this.handleRemove,
      title: assistiveText.removeFilter,
      variant: "icon"
    }) : null);
  }
});
/* unused harmony default export */ var _unused_webpack_default_export = (Filter);
//# sourceMappingURL=index.js.map

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isfunction__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isfunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isfunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__icon_input_icon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_key_code__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__inline_check_props__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utilities_constants__ = __webpack_require__(2);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// # Inline Edit Component
// Implements an inline edit component based on the [Input design pattern](https://www.lightningdesignsystem.com/components/forms/#input) in React.
// ## Dependencies
// ### React

 // ### isFunction

 // ## Children



 // ### Event Helpers

 // This component's `checkProps` which issues warnings to developers about properties when in development mode (similar to React's built in development tools)

 // ## Constants

 // ### Prop Types

var propTypes = {
  /**
   * Class names to be added to the outer container of the input.
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * Name of the submitted form parameter.
   */
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Disables the Inline Edit component and prevents editing the contents.
   */
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Every Inline Edit component must have a unique ID in order to support keyboard navigation and ARIA support.
   */
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,

  /**
   * This event fires when the input changes.
   */
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Function will run when keyup during text edit
   */
  onKeyUp: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Function will run when we enter edit mode
   */
  onEnterEditMode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Function will run when we leave edit mode
   */
  onLeaveEditMode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Typically an Inline Edit component will be of the type text, but like the Input element it includes support for all HTML5 types.
   */
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['text', 'password', 'datetime', 'datetime-local', 'date', 'month', 'time', 'week', 'number', 'email', 'url', 'search', 'tel', 'color']),

  /**
   * Inline Edit is a controlled component, and will always display this value.
   */
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};
var defaultProps = {
  assistiveText: 'Edit text',
  type: 'text'
};
/**
 * An inline input is rendered as a label by default. When clicked (or tabbed in), it's rendered as an input. When the focus is lost, the current input value is saved and the input is rendered as a label again.
 */

var InlineEdit =
/*#__PURE__*/
function (_React$Component) {
  _inherits(InlineEdit, _React$Component);

  function InlineEdit(props) {
    var _this;

    _classCallCheck(this, InlineEdit);

    _this = _possibleConstructorReturn(this, (InlineEdit.__proto__ || Object.getPrototypeOf(InlineEdit)).call(this, props));
    Object.defineProperty(_assertThisInitialized(_this), "endEditMode", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(option) {
        if (_this.willSave) {
          clearTimeout(_this.willSave);
          delete _this.willSave;
        }

        _this.setState({
          isEditing: false,
          value: null
        });

        if (_this.props.onLeaveEditMode && __WEBPACK_IMPORTED_MODULE_2_lodash_isfunction___default()(_this.props.onLeaveEditMode)) {
          _this.props.onLeaveEditMode(undefined, option);
        }
      }
    });
    Object.defineProperty(_assertThisInitialized(_this), "handleBlur", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        if (!_this.willSave) {
          _this.willSave = setTimeout(_this.saveEdits, 200);
        }

        if (_this.props.onLeaveEditMode && __WEBPACK_IMPORTED_MODULE_2_lodash_isfunction___default()(_this.props.onLeaveEditMode)) {
          _this.props.onLeaveEditMode();
        }
      }
    });
    Object.defineProperty(_assertThisInitialized(_this), "handleChange", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(event) {
        _this.setState({
          value: event.target.value
        });
      }
    });
    Object.defineProperty(_assertThisInitialized(_this), "handleKeyDown", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(event) {
        if (event.keyCode) {
          if (event.keyCode === __WEBPACK_IMPORTED_MODULE_6__utilities_key_code__["a" /* default */].ESCAPE) {
            _this.saveEdits({
              cancel: true
            });
          } else if (event.keyCode === __WEBPACK_IMPORTED_MODULE_6__utilities_key_code__["a" /* default */].ENTER) {
            _this.saveEdits();
          }
        }
      }
    });
    Object.defineProperty(_assertThisInitialized(_this), "handleKeyUp", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(event) {
        if (event.keyCode) {
          if (_this.props.onKeyUp && __WEBPACK_IMPORTED_MODULE_2_lodash_isfunction___default()(_this.props.onKeyUp)) {
            _this.props.onKeyUp(event, {
              value: _this.state.value
            });
          }
        }
      }
    });
    Object.defineProperty(_assertThisInitialized(_this), "saveEdits", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(option) {
        if (!(option && option.cancel === true)) {
          if (__WEBPACK_IMPORTED_MODULE_2_lodash_isfunction___default()(_this.props.onChange)) {
            _this.props.onChange({
              value: _this.state.value
            });
          }
        }

        _this.endEditMode(option);
      }
    });
    Object.defineProperty(_assertThisInitialized(_this), "triggerEditMode", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        if (!_this.props.disabled) {
          _this.autoFocus = true;

          _this.setState({
            isEditing: true,
            value: _this.props.value
          });

          if (__WEBPACK_IMPORTED_MODULE_2_lodash_isfunction___default()(_this.props.onEnterEditMode)) {
            _this.props.onEnterEditMode();
          }
        }
      }
    });
    _this.state = {
      isEditing: false,
      value: null
    };
    return _this;
  }

  _createClass(InlineEdit, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      Object(__WEBPACK_IMPORTED_MODULE_7__inline_check_props__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_8__utilities_constants__["D" /* FORMS_INLINE_EDIT */], this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.autoFocus) {
        if (this.inputNode) {
          this.inputNode.focus();
          this.inputNode.select();
        }

        this.autoFocus = false;
      }
    }
  }, {
    key: "render",
    // ### Render
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          assistiveText = _props.assistiveText,
          disabled = _props.disabled,
          value = _props.value,
          name = _props.name,
          rest = _objectWithoutProperties(_props, ["assistiveText", "disabled", "value", "name"]);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__index__["a" /* default */], _extends({}, rest, {
        iconRight: this.state.isEditing ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__icon_input_icon__["a" /* default */], {
          category: "utility",
          name: "close",
          position: "right",
          onClick: this.endEditMode,
          tabIndex: "-1"
        }) : null,
        disabled: disabled,
        inlineEditTrigger: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__button__["a" /* default */], {
          assistiveText: {
            icon: assistiveText
          },
          className: "slds-m-left_x-small",
          disabled: disabled,
          iconCategory: "utility",
          iconName: "edit",
          iconPosition: "right",
          iconSize: "small",
          variant: "icon"
        }),
        onBlur: this.handleBlur,
        onChange: this.handleChange,
        onClick: !this.state.isEditing ? this.triggerEditMode : null,
        onKeyDown: this.handleKeyDown,
        onKeyUp: this.handleKeyUp,
        isStatic: !this.state.isEditing,
        name: name,
        value: this.state.isEditing ? this.state.value : value,
        inputRef: function inputRef(input) {
          _this2.inputNode = input;
        }
      }));
    }
  }]);

  return InlineEdit;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

InlineEdit.displayName = __WEBPACK_IMPORTED_MODULE_8__utilities_constants__["D" /* FORMS_INLINE_EDIT */];
InlineEdit.propTypes = propTypes;
InlineEdit.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (InlineEdit);
//# sourceMappingURL=inline.js.map

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__icon_input_icon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__check_props__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_key_code__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_event__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utilities_constants__ = __webpack_require__(2);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// # Search Component
// Wraps the input to default to a search style.
// ## Dependencies
// ### React

 // ## Children



 // ### Event Helpers


 // ## Constants



var handleKeyDown = function handleKeyDown(event, onSearch) {
  if (event.keyCode === __WEBPACK_IMPORTED_MODULE_5__utilities_key_code__["a" /* default */].ENTER) {
    __WEBPACK_IMPORTED_MODULE_6__utilities_event__["a" /* default */].trapImmediate(event);
    onSearch(event);
  }
};

var defaultProps = {
  assistiveText: {}
};
/**
 * A `Search` is an `Input` which renders the search icon by default. It can be cleared, too. All `Input` props not specified as props already may be used with this component and will override defaults.
 */

var Search = function Search(_ref) {
  var clearable = _ref.clearable,
      onClear = _ref.onClear,
      onSearch = _ref.onSearch,
      placeholder = _ref.placeholder,
      props = _objectWithoutProperties(_ref, ["clearable", "onClear", "onSearch", "placeholder"]);

  Object(__WEBPACK_IMPORTED_MODULE_4__check_props__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_7__utilities_constants__["_16" /* SEARCH */], props);
  var assistiveText = typeof props.assistiveText === 'string' ? props.assistiveText : _objectSpread({}, defaultProps.assistiveText, props.assistiveText).label;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* default */], _extends({
    assistiveText: {
      label: assistiveText
    },
    iconLeft: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__icon_input_icon__["a" /* default */], {
      assistiveText: {
        icon: 'Search'
      },
      category: "utility",
      name: "search",
      onClick: onSearch
    }),
    iconRight: clearable ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__icon_input_icon__["a" /* default */], {
      assistiveText: {
        icon: 'Clear'
      },
      category: "utility",
      name: "clear",
      onClick: onClear
    }) : null,
    onKeyDown: onSearch ? function (event) {
      return handleKeyDown(event, onSearch);
    } : null,
    placeholder: placeholder
  }, props));
};

Search.displayName = __WEBPACK_IMPORTED_MODULE_7__utilities_constants__["_16" /* SEARCH */];
Search.propTypes = {
  /**
   * **Assistive text for accessibility.**
   * This object is merged with the default props object on every render.
   * * `label`: Assistive text to search input
   */
  assistiveText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),

  /**
   * Adds a clear button to right side of the input
   */
  clearable: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Triggers when the clear button is clicked
   */
  onClear: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * This event fires when enter is pressed in the `input` or the search button is clicked.
   */
  onSearch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Placeholder for the input
   */
  placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
Search.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Search);
//# sourceMappingURL=search.js.map

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shortid__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shortid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_shortid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__check_props__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_dialog__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__icon__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utilities_menu_list__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utilities_menu_list_item_label__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utilities_pill__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utilities_keyboard_navigable_menu__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utilities_event__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utilities_key_code__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utilities_constants__ = __webpack_require__(2);
/* unused harmony reexport ListItemLabel */
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// # Picklist Component
// Implements the [Picklist design pattern](https://www.lightningdesignsystem.com/components/menus/#flavor-picklist) in React.
// Based on SLDS v2.1.0-rc.2
// ### React


 // ### classNames
// [github.com/JedWatson/classnames](https://github.com/JedWatson/classnames)
// This project uses `classnames`, "a simple javascript utility for conditionally
// joining classNames together."

 // ### shortid
// [npmjs.com/package/shortid](https://www.npmjs.com/package/shortid)
// shortid is a short, non-sequential, url-friendly, unique id generator

 // This component's `checkProps` which issues warnings to developers about properties
// when in development mode (similar to React's built in development tools)

 // ### Children





 // ### Traits
// #### KeyboardNavigable





/**
 * ** MenuPicklist is deprecated. Please use a read-only Combobox instead.**
 *
 * The MenuPicklist component is a variant of the Lightning Design System Menu component.
 */

var MenuPicklist = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  // ### Display Name
  // Always use the canonical component name as the React display name.
  displayName: __WEBPACK_IMPORTED_MODULE_14__utilities_constants__["Z" /* MENU_PICKLIST */],
  // ### Prop Types
  propTypes: {
    /**
     * Callback that passes in the DOM reference of the `<button>` DOM node within this component. Primary use is to allow `focus` to be called. You should still test if the node exists, since rendering is asynchronous. `buttonRef={(component) => { if(component) console.log(component); }}`
     */
    buttonRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * If true, renders checkmark icon on the selected Menu Item.
     */
    checkmark: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * Message to display when the input is in an error state. When this is present, also visually highlights the component as in error.
     */
    errorText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * A unique ID is needed in order to support keyboard navigation, ARIA support, and connect the dropdown to the triggering button.
     */
    id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * Renders menu within the wrapping trigger as a sibling of the button. By default, you will have an absolutely positioned container at an elevated z-index.
     */
    isInline: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * Form element label
     */
    label: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * **Text labels for internationalization**
     * This object is merged with the default props object on every render.
     * * `multipleOptionsSelected`: Text to be used when multiple items are selected. "2 Options Selected" is a good pattern to use.
     */
    labels: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
      multipleOptionsSelected: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
    }),

    /**
     * Custom element that overrides the default Menu Item component.
     */
    listItemRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Allows multiple items to be selected. Items will be shown in pills. Clicking the item does not close the menu.
     */
    multiple: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * Triggered when the trigger button is clicked to open.
     */
    onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Triggered when an item is selected. Passes in the option object that has been selected and a data object in the format: `{ option, optionIndex }`. The first parameter may be deprecated in the future and changed to an event for consistency. Please use the data object.
     */
    onSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Triggered when a pill is removed. Passes in the option object that has been removed and a data object in the format: `{ option, optionIndex }`. The first parameter may be deprecated in the future and changed to an event for consistency. Please use the data object.
     */
    onPillRemove: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Menu item data.
     */
    options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired,

    /**
     * Text present in trigger button if no items are selected.
     */
    placeholder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * Add styling of a required form element.
     */
    required: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * Current selected item.
     */
    value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,

    /**
     * Initial selected item index.
     */
    initValueIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_11__utilities_keyboard_navigable_menu__["a" /* default */]],
  getDefaultProps: function getDefaultProps() {
    return {
      inheritTargetWidth: true,
      placeholder: 'Select an Option',
      checkmark: true,
      labels: {
        multipleOptionsSelected: 'Multiple Options Selected'
      },
      menuPosition: 'absolute'
    };
  },
  getInitialState: function getInitialState() {
    return {
      focusedIndex: this.props.initValueIndex ? this.props.initValueIndex : -1,
      selectedIndex: this.props.initValueIndex ? this.props.initValueIndex : -1,
      selectedIndices: [],
      currentPillLabel: ''
    };
  },
  componentWillMount: function componentWillMount() {
    // `checkProps` issues warnings to developers about properties (similar to React's built in development tools)
    Object(__WEBPACK_IMPORTED_MODULE_5__check_props__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_14__utilities_constants__["Z" /* MENU_PICKLIST */], this.props);
    this.generatedId = __WEBPACK_IMPORTED_MODULE_4_shortid___default.a.generate();

    if (this.props.errorText) {
      this.generatedErrorId = __WEBPACK_IMPORTED_MODULE_4_shortid___default.a.generate();
    }

    if (typeof window !== 'undefined') {
      window.addEventListener('click', this.closeOnClick, false);
    }

    if (!this.props.multiple) {
      this.setState({
        selectedIndex: this.getIndexByValue(this.props)
      });
    } else {
      var currentSelectedIndex = this.getIndexByValue(this.props);
      var currentIndices = this.state.selectedIndices;

      if (currentSelectedIndex !== -1) {
        currentIndices.push(currentSelectedIndex);
      }

      this.setState({
        selectedIndices: currentIndices
      });
    }
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (this.props.value !== nextProps.value || this.props.options.length !== nextProps.length) {
      if (this.props.multiple !== true) {
        this.setState({
          selectedIndex: this.getIndexByValue(nextProps)
        });
      } else {
        var currentSelectedIndex = this.getIndexByValue(nextProps);

        if (currentSelectedIndex !== -1) {
          var currentIndices = this.state.selectedIndices.concat(currentSelectedIndex);
          this.setState({
            selectedIndices: currentIndices
          });
        }
      }
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    this.isUnmounting = true;
    window.removeEventListener('click', this.closeOnClick, false);
  },
  getId: function getId() {
    return this.props.id || this.generatedId;
  },
  getErrorId: function getErrorId() {
    return this.props['aria-describedby'] || this.generatedErrorId;
  },
  getClickEventName: function getClickEventName() {
    return "SLDS".concat(this.getId(), "ClickEvent");
  },
  getIndexByValue: function getIndexByValue() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props,
        value = _ref.value,
        options = _ref.options;

    var foundIndex = -1;

    if (options && options.length) {
      options.some(function (element, index) {
        if (element && element.value === value) {
          foundIndex = index;
          return true;
        }

        return false;
      });
    }

    return foundIndex;
  },
  getValueByIndex: function getValueByIndex(index) {
    return this.props.options[index];
  },
  getListItemRenderer: function getListItemRenderer() {
    return this.props.listItemRenderer ? this.props.listItemRenderer : __WEBPACK_IMPORTED_MODULE_9__utilities_menu_list_item_label__["a" /* default */];
  },
  setFocus: function setFocus() {
    if (!this.isUnmounting && this.button) {
      this.button.focus();
    }
  },
  handleSelect: function handleSelect(index) {
    if (!this.props.multiple) {
      this.setState({
        selectedIndex: index
      });
      this.handleClose();
      this.setFocus();
    } else {
      var currentIndices;

      if (this.state.selectedIndices.indexOf(index) === -1) {
        currentIndices = this.state.selectedIndices.concat(index);
      } else {
        var deselectIndex = this.state.selectedIndices.indexOf(index);
        currentIndices = this.state.selectedIndices;
        currentIndices.splice(deselectIndex, 1);
      }

      this.setState({
        selectedIndices: currentIndices
      });
    }

    if (this.props.onSelect) {
      var option = this.getValueByIndex(index);
      this.props.onSelect(option, {
        option: option,
        optionIndex: index
      });
    }
  },
  handleClose: function handleClose() {
    this.setState({
      isOpen: false
    });
  },
  handleClick: function handleClick(event) {
    if (event) {
      event.nativeEvent[this.getClickEventName()] = true;
    }

    if (!this.state.isOpen) {
      this.setState({
        isOpen: true
      });
      this.setFocus();

      if (this.props.onClick) {
        this.props.onClick(event);
      }
    } else {
      this.handleClose();
    }
  },
  handleMouseDown: function handleMouseDown(event) {
    if (event) {
      __WEBPACK_IMPORTED_MODULE_12__utilities_event__["a" /* default */].trapImmediate(event);
      event.nativeEvent[this.getClickEventName()] = true;
    }
  },
  handleKeyDown: function handleKeyDown(event) {
    if (event.keyCode) {
      if (event.keyCode === __WEBPACK_IMPORTED_MODULE_13__utilities_key_code__["a" /* default */].ENTER || event.keyCode === __WEBPACK_IMPORTED_MODULE_13__utilities_key_code__["a" /* default */].SPACE || event.keyCode === __WEBPACK_IMPORTED_MODULE_13__utilities_key_code__["a" /* default */].DOWN || event.keyCode === __WEBPACK_IMPORTED_MODULE_13__utilities_key_code__["a" /* default */].UP) {
        __WEBPACK_IMPORTED_MODULE_12__utilities_event__["a" /* default */].trap(event);
      }

      if (event.keyCode !== __WEBPACK_IMPORTED_MODULE_13__utilities_key_code__["a" /* default */].TAB) {
        // The outer div with onKeyDown is overriding button onClick so we need to add it here.
        var openMenuKeys = event.keyCode === __WEBPACK_IMPORTED_MODULE_13__utilities_key_code__["a" /* default */].ENTER || event.keyCode === __WEBPACK_IMPORTED_MODULE_13__utilities_key_code__["a" /* default */].DOWN || event.keyCode === __WEBPACK_IMPORTED_MODULE_13__utilities_key_code__["a" /* default */].UP;
        var isTrigger = event.target.tagName === 'BUTTON';

        if (openMenuKeys && isTrigger && this.props.onClick) {
          this.props.onClick(event);
        }

        this.handleKeyboardNavigate({
          isOpen: this.state.isOpen || false,
          keyCode: event.keyCode,
          onSelect: this.handleSelect,
          toggleOpen: this.toggleOpen
        });
      } else {
        this.handleCancel();
      }
    }
  },
  handleCancel: function handleCancel() {
    this.setFocus();
    this.handleClose();
  },
  closeOnClick: function closeOnClick(event) {
    if (!event[this.getClickEventName()] && this.state.isOpen) {
      this.handleClose();
    }
  },
  toggleOpen: function toggleOpen() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  },
  saveRefToList: function saveRefToList(list) {
    this.list = list;
  },
  saveRefToListItem: function saveRefToListItem(listItem, index) {
    if (!this.listItems) {
      this.listItems = {};
    }

    this.listItems[index] = listItem;

    if (index === this.state.focusedIndex) {
      this.handleKeyboardFocus(this.state.focusedIndex);
    }
  },
  // Trigger opens, closes, and recieves focus on close
  saveRefToTrigger: function saveRefToTrigger(trigger) {
    this.button = trigger;

    if (this.props.buttonRef) {
      this.props.buttonRef(this.button);
    }

    if (!this.state.triggerRendered) {
      this.setState({
        triggerRendered: true
      });
    }
  },
  renderMenuContent: function renderMenuContent() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__utilities_menu_list__["a" /* default */], {
      checkmark: this.props.checkmark,
      getListItemId: this.getListItemId,
      itemRefs: this.saveRefToListItem,
      itemRenderer: this.getListItemRenderer(),
      onCancel: this.handleCancel,
      onSelect: this.handleSelect,
      options: this.props.options,
      ref: this.saveRefToList,
      selectedIndex: !this.props.multiple ? this.state.selectedIndex : undefined,
      selectedIndices: this.props.multiple ? this.state.selectedIndices : undefined,
      triggerId: this.getId()
    });
  },
  renderInlineMenu: function renderInlineMenu() {
    return !this.props.disabled && this.state.isOpen ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "slds-dropdown slds-dropdown--left" // inline style override
      ,
      style: {
        maxHeight: '20em',
        overflowX: 'hidden',
        minWidth: '100%'
      }
    }, this.renderMenuContent()) : null;
  },
  renderDialog: function renderDialog() {
    var _this = this;

    return !this.props.disabled && this.state.isOpen ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__utilities_dialog__["a" /* default */], {
      closeOnTabKey: true,
      constrainToScrollParent: this.props.constrainToScrollParent,
      contentsClassName: "slds-dropdown slds-dropdown--left",
      context: this.context,
      flippable: true,
      onClose: this.handleCancel,
      onKeyDown: this.handleKeyDown,
      onRequestTargetElement: function onRequestTargetElement() {
        return _this.button;
      },
      inheritWidthOf: this.props.inheritTargetWidth ? 'target' : 'none',
      position: this.props.menuPosition
    }, this.renderMenuContent()) : null;
  },
  renderTrigger: function renderTrigger() {
    var isInline;
    /* eslint-disable react/prop-types */

    if (this.props.isInline) {
      isInline = true;
    } else if (this.props.modal !== undefined) {
      isInline = !this.props.modal;
    }
    /* eslint-enable react/prop-types */


    var inputValue;

    if (this.props.multiple && this.state.selectedIndices.length === 0) {
      inputValue = this.props.placeholder;
    } else if (this.props.multiple && this.state.selectedIndices.length === 1) {
      var option = this.props.options[this.state.selectedIndices];
      inputValue = option.label;
    } else if (this.props.multiple && this.state.selectedIndices.length > 1) {
      inputValue = this.props.labels.multipleOptionsSelected;
    } else {
      var _option = this.props.options[this.state.selectedIndex];
      inputValue = _option && _option.label ? _option.label : this.props.placeholder;
    } // TODO: make use of <Button>


    return (// eslint-disable-next-line jsx-a11y/no-static-element-interactions
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('slds-picklist slds-dropdown-trigger slds-dropdown-trigger--click', {
          'slds-is-open': this.state.isOpen
        }, this.props.className),
        onKeyDown: this.handleKeyDown,
        onMouseDown: this.handleMouseDown
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        "aria-describedby": this.getErrorId(),
        "aria-expanded": this.state.isOpen,
        "aria-haspopup": "true",
        className: "slds-button slds-button--neutral slds-picklist__label",
        disabled: this.props.disabled,
        id: this.getId(),
        onClick: !this.props.disabled && this.handleClick,
        ref: this.saveRefToTrigger,
        tabIndex: this.state.isOpen ? -1 : 0,
        type: "button"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "slds-truncate"
      }, inputValue), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__icon__["a" /* default */], {
        name: "down",
        category: "utility"
      })), isInline ? this.renderInlineMenu() : this.renderDialog())
    );
  },
  renderPills: function renderPills() {
    var _this2 = this;

    var selectedPills = this.state.selectedIndices.map(function (selectedPill) {
      var pillLabel = _this2.getValueByIndex(selectedPill).label;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
        className: "slds-listbox__item",
        key: "pill-".concat(selectedPill),
        role: "presentation"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__utilities_pill__["a" /* default */], {
        eventData: {
          item: _this2.props.options[selectedPill],
          index: selectedPill
        },
        events: {
          onRequestRemove: function onRequestRemove(event, data) {
            var newData = _this2.state.selectedIndices;
            var index = data.index;
            newData.splice(_this2.state.selectedIndices.indexOf(index), 1);

            _this2.setState({
              selectedIndices: newData
            });

            if (_this2.props.onPillRemove) {
              var option = _this2.getValueByIndex(index);

              _this2.props.onPillRemove(option, {
                option: option,
                optionIndex: index
              });
            }
          }
        },
        labels: {
          label: pillLabel
        }
      }));
    });
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      id: "listbox-selections-unique-id",
      orientation: "horizontal",
      role: "listbox"
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
      className: "slds-listbox slds-listbox_inline slds-p-top_xxx-small",
      role: "group",
      "aria-label": "Selected Options:"
    }, selectedPills));
  },
  render: function render() {
    var _props = this.props,
        className = _props.className,
        errorText = _props.errorText,
        label = _props.label,
        required = _props.required;
    var requiredElem = required ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      style: {
        color: 'red'
      }
    }, "* ") : null;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('slds-form-element', {
        'slds-has-error': errorText
      }, className)
    }, this.props.label ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", {
      className: "slds-form-element__label",
      htmlFor: this.getId() // inline style override
      ,
      style: {
        width: '100%'
      }
    }, requiredElem, label) : null, this.renderTrigger(), this.renderPills(), errorText && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      id: this.getErrorId(),
      className: "slds-form-element__help"
    }, errorText));
  }
});
MenuPicklist.contextTypes = {
  iconPath: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};
/* unused harmony default export */ var _unused_webpack_default_export = (MenuPicklist);

//# sourceMappingURL=index.js.map

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_warning_component_is_deprecated__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index__ = __webpack_require__(37);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */



 // This component should be deprecated and appears to have
// been created in order to do modals in portals.

var ModalTrigger = {
  open: function open(cfg) {
    Object(__WEBPACK_IMPORTED_MODULE_2__utilities_warning_component_is_deprecated__["a" /* default */])('components/modal/trigger.jsx', 'This component is deprecated and appears to have been created in order to do modals in portals which is what current Modal has done for years.');
    var el = document.createElement('span');
    el.setAttribute('data-slds-modal', true);
    document.body.appendChild(el);
    var comp = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__index__["a" /* default */], {
      title: cfg.title,
      footer: cfg.footer,
      isOpen: true
    }, cfg.content);
    __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(comp, el);
  }
};
/* unused harmony default export */ var _unused_webpack_default_export = (ModalTrigger);
//# sourceMappingURL=trigger.js.map

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vertical_navigation__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities_warning_component_has_moved__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_constants__ = __webpack_require__(2);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// Alias



Object(__WEBPACK_IMPORTED_MODULE_1__utilities_warning_component_has_moved__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__utilities_constants__["_34" /* VERTICAL_NAVIGATION */], {
  oldFileLocation: 'components/navigation',
  newFileLocation: 'components/vertical-navigation'
});
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__vertical_navigation__["a" /* default */]);
//# sourceMappingURL=index.js.map

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__icon__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__check_props__ = __webpack_require__(259);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */






var displayName = 'Notification';
var propTypes = {
  iconCategory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Custom classes applied to Notification element.
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Message for Notification.
   */
  content: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,

  /**
   * If true, close button appears for users to dismiss Notification.
   */
  dismissible: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * If duration exists, the Notification will disappear after that amount of time.
   */
  duration: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * Name of the icon. Visit <a href='http://www.lightningdesignsystem.com/resources/icons'>Lighning Design System Icons</a> to reference icon names.
   */
  iconName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  onDismiss: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Styling for Notification background.
   */
  texture: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Styling for Notification background color. Please reference <a href='http://www.lightningdesignsystem.com/components/utilities/themes/#color'>Lighning Design System Themes > Color</a>.
   */
  theme: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['success', 'warning', 'error', 'offline']),
  variant: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['alert', 'toast']).isRequired
};
var defaultProps = {
  iconCategory: 'utility',
  dismissible: true,
  isOpen: false,
  texture: false
};
/**
 * The Notification component is the Alert and Toast variants of the Lightning Design System Notification component. For prompt notifications, use the <a href='#/modal'>Modal</a> component with <code>prompt={true}</code>.
 * The Notification opens from a state change outside of the component itself (pass this state to the <code>isOpen</code> prop).
 */

var Notification =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Notification, _React$Component);

  function Notification(props) {
    var _this;

    _classCallCheck(this, Notification);

    _this = _possibleConstructorReturn(this, (Notification.__proto__ || Object.getPrototypeOf(Notification)).call(this, props));
    Object.defineProperty(_assertThisInitialized(_this), "onDismiss", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        if (_this.timeout) {
          clearTimeout(_this.timeout);
          _this.timeout = null;
        }

        if (_this.props.onDismiss) _this.props.onDismiss();

        if (_this.state.returnFocusTo && _this.state.returnFocusTo.focus) {
          _this.state.returnFocusTo.focus();
        }
      }
    });
    _this.state = {};
    _this.timeout = null;
    return _this;
  }

  _createClass(Notification, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      Object(__WEBPACK_IMPORTED_MODULE_5__check_props__["a" /* default */])('Notification', this.props);

      if (this.props.duration) {
        this.timeout = setTimeout(function () {
          _this2.onDismiss();
        }, this.props.duration);
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      if (nextProps.duration) {
        if (this.timeout) {
          clearTimeout(this.timeout);
        }

        if (nextProps.isOpen) {
          this.timeout = setTimeout(function () {
            _this3.onDismiss();
          }, this.props.duration);
        }
      }

      if (nextProps.isOpen !== this.props.isOpen) {
        this.setState({
          returnFocusTo: document.activeElement
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.isOpen !== this.props.isOpen) {
        var btn = this.dismissBtnRef;
        if (btn) btn.focus();
      }
    }
  }, {
    key: "getClassName",
    value: function getClassName() {
      var _classNames;

      return __WEBPACK_IMPORTED_MODULE_2_classnames___default()(this.props.className, 'slds-notify', (_classNames = {}, _defineProperty(_classNames, "slds-notify--".concat(this.props.variant), this.props.variant), _defineProperty(_classNames, "slds-theme--".concat(this.props.theme), this.props.theme), _defineProperty(_classNames, 'slds-theme--alert-texture', this.props.texture), _classNames));
    }
    /*
     * The parent container with role='alert' only announces its content if there is a change inside of it.
     * Because React renders the entire element to the DOM, we must switch out a blank div for the real content.
     * Bummer, I know.
     */
    // eslint-disable-next-line class-methods-use-this

  }, {
    key: "blankContent",
    value: function blankContent() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null);
    }
  }, {
    key: "renderAlertContent",
    value: function renderAlertContent() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", {
        id: "dialogTitle"
      }, this.renderIcon(), this.props.content);
    }
  }, {
    key: "renderClose",
    value: function renderClose() {
      var _this4 = this;

      if (this.props.dismissible) {
        var size = null;
        if (this.props.variant === 'toast') size = 'large'; // i18n

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__button__["a" /* default */], {
          assistiveText: {
            icon: 'Dismiss Notification'
          },
          iconCategory: "utility",
          iconName: "close",
          iconSize: size,
          inverse: true,
          className: "slds-notify__close",
          onClick: this.onDismiss,
          buttonRef: function buttonRef(dismissBtn) {
            _this4.dismissBtnRef = dismissBtn;
          },
          variant: "icon"
        });
      }

      return null;
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "slds-assistive-text"
      }, this.props.theme), this.renderClose(), this.props.variant === 'toast' ? this.renderToastContent() : null, this.props.variant === 'alert' ? this.renderAlertContent() : null);
    }
  }, {
    key: "renderIcon",
    value: function renderIcon() {
      if (this.props.iconName) {
        var classes = '';

        if (this.props.variant === 'alert') {
          classes = 'slds-m-right--x-small';
        } else if (this.props.variant === 'toast') {
          classes = 'slds-m-right--small slds-col slds-no-flex';
        }

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__icon__["a" /* default */], {
          category: this.props.iconCategory,
          className: classes,
          inverse: true,
          name: this.props.iconName,
          size: "small"
        });
      }

      return null;
    }
  }, {
    key: "renderToastContent",
    value: function renderToastContent() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section", {
        className: "notify__content slds-grid"
      }, this.renderIcon(), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "slds-col slds-align-middle"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", {
        id: "dialogTitle",
        className: "slds-text-heading--small"
      }, this.props.content)));
    }
  }, {
    key: "render",
    value: function render() {
      // TODO: If there are multiple notifications on a page, we must 'hide' the ones that aren't open.
      // Need to find a better way to do this than using width:0 to override slds-notify-container.
      var styles;

      if (!this.props.isOpen) {
        styles = {
          width: '0px'
        };
      } else {
        styles = this.props.variant === 'toast' ? {
          width: 'auto',
          left: '50%',
          transform: 'translateX(-50%)'
        } : {
          width: '100%'
        };
      }

      var alertStyles = !this.props.isOpen ? {
        display: 'none'
      } : null;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "slds-notify-container",
        style: styles
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: this.getClassName(),
        role: "alertdialog",
        "aria-labelledby": "dialogTitle",
        style: alertStyles
      }, this.props.isOpen ? this.renderContent() : this.blankContent()));
    }
  }]);

  return Notification;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Notification.displayName = displayName;
Notification.propTypes = propTypes;
Notification.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Notification);
//# sourceMappingURL=index.js.map

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__check_props__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_constants__ = __webpack_require__(2);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// # Panel - Filter variant
// Implements the [Panel design pattern](https://www.lightningdesignsystem.com/components/panels) in React.
// Based on SLDS v2.2.0-rc.1
// ## Dependencies
// ### React

 // ### classNames

 // This component's `checkProps` which issues warnings to developers about properties when in development mode (similar to React's built in development tools)

 // ## Constants


/**
 * A panel provides detailed contextual information or contextual filtering options. [Filter](/components/filters/) component should be used as children. Menus within a Filter Popover will need to not have "portal mounts" and be inline. */

var Panel =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Panel, _React$Component);

  function Panel() {
    _classCallCheck(this, Panel);

    return _possibleConstructorReturn(this, (Panel.__proto__ || Object.getPrototypeOf(Panel)).apply(this, arguments));
  }

  _createClass(Panel, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      Object(__WEBPACK_IMPORTED_MODULE_3__check_props__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__utilities_constants__["_2" /* PANEL */]);
    }
  }, {
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('slds-panel', 'slds-grid', 'slds-grid--vertical', 'slds-nowrap', {
          'slds-panel--filters': this.props.variant === 'filters'
        })
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "slds-form--stacked slds-grow slds-scrollable--y slds-grid slds-grid--vertical"
      }, this.props.children));
    }
  }]);

  return Panel;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Panel.displayName = __WEBPACK_IMPORTED_MODULE_4__utilities_constants__["_2" /* PANEL */];
Panel.propTypes = {
  /**
   * The contents of the panel
   */
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * The type of panel
   */
  variant: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['filters'])
};
/* unused harmony default export */ var _unused_webpack_default_export = (Panel);
//# sourceMappingURL=index.js.map

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__check_props__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__private_panel_footer__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__private_panel_header__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_constants__ = __webpack_require__(2);
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// # Panel Filter Group
// Implements the Filter part of [Panel design pattern](https://www.lightningdesignsystem.com/components/panels) in React.
// Based on SLDS v2.2.0-rc.1
// ## Dependencies
// ### React




 // ## Constants


var defaultProps = {
  addFilterLabel: 'Add Filter',
  cancelLabel: 'Cancel',
  assistiveText: {
    closeButton: 'Close Filter Panel'
  },
  heading: 'Filter',
  saveLabel: 'Save',
  removeAllLabel: 'Remove All'
};
/**
 * A filtering panel contextual filtering options.
 */

var PanelFilterGroup = function PanelFilterGroup(props) {
  Object(__WEBPACK_IMPORTED_MODULE_2__check_props__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5__utilities_constants__["_3" /* PANEL_FILTER_GROUP */], props);
  var children = props.children,
      errorLabel = props.errorLabel,
      footer = props.footer,
      header = props.header,
      variant = props.variant,
      addFilterLabel = props.addFilterLabel,
      onClickAdd = props.onClickAdd,
      onClickRemoveAll = props.onClickRemoveAll,
      removeAllLabel = props.removeAllLabel,
      cancelLabel = props.cancelLabel,
      heading = props.heading,
      modified = props.modified,
      onRequestCancel = props.onRequestCancel,
      onRequestClose = props.onRequestClose,
      onRequestSave = props.onRequestSave,
      saveLabel = props.saveLabel;

  var assistiveText = _objectSpread({}, defaultProps.assistiveText, props.assistiveText);

  if (props.assistiveTextCloseFilterPanel) {
    assistiveText.closeButton = props.assistiveTextCloseFilterPanel;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "slds-filters"
  }, variant === 'panel' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__private_panel_header__["a" /* default */], {
    assistiveText: assistiveText,
    cancelLabel: cancelLabel,
    heading: heading,
    modified: modified,
    onRequestCancel: onRequestCancel,
    onRequestClose: onRequestClose,
    onRequestSave: onRequestSave,
    saveLabel: saveLabel
  }) : header || null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "slds-filters__body"
  }, errorLabel ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "slds-text-color--error slds-m-bottom--x-small",
    role: "alert"
  }, errorLabel) : null, children), variant === 'panel' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__private_panel_footer__["a" /* default */], {
    addFilterLabel: addFilterLabel,
    onClickAdd: onClickAdd,
    onClickRemoveAll: onClickRemoveAll,
    removeAllLabel: removeAllLabel
  }) : footer || null);
};

PanelFilterGroup.displayName = __WEBPACK_IMPORTED_MODULE_5__utilities_constants__["_3" /* PANEL_FILTER_GROUP */];
PanelFilterGroup.propTypes = {
  /**
   * **Assistive text for accessibility.**
   * This object is merged with the default props object on every render.
   * * `closeButton`: Localized description of the close button for the panel for screen readers
   */
  assistiveText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    closeButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),

  /**
   * Localized description of the "Add Filter" button in the footer
   */
  addFilterLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * Label for button that cancels modified filters
   */
  cancelLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Pass in `FilterList`'s of `Filters`:
   *
   * ```
   * <FilterGroup
   *   variant="panel"
   * >
   *   <FilterList>
   *   <Filter
   *     property="Show Me"
   *     predicate="All Wackamoles"
   *   >
   *   {popoverContents}
   *   </Filter>
   *   </FilterList>
   * </FilterGroup>
   * ```
   */
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * Label for the error message at the top of the panel.
   */
  errorLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Allows for customization of footer. This will be added after any `FilterList`'s in the DOM. If using Panel Filter Group outside of a panel, do not set the variant to `panel` and header and footer will be removed.
   */
  footer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * Allows for customization of header. This will be added before any `FilterList`'s in the DOM. If using Panel Filter Group outside of a panel, do not set the variant to `panel` and header and footer will be removed.
   */
  header: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * The heading within the header of the filtering panel
   */
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * Shows confirmation heading. Please see `onRequestCancel` and `onRequestSave`.
   */
  modified: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Callback triggered when "Add Filter" is clicked. Recieves an `event`.
   */
  onClickAdd: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Callback triggered when "Remove All" is clicked. Recieves an `event`.
   */
  onClickRemoveAll: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * When the panel's cancel button is clicked in order to reset filter panel to previous state.
   */
  onRequestCancel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * When the panel's close button is clicked. Please place Panel within another element to control position and visibility.
   */
  onRequestClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * When the panel's save button is clicked in order to confirm filter panel state.
   */
  onRequestSave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Localized description of the "Remove All" button in the footer
   */
  removeAllLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * Label for button that saves modified filters
   */
  saveLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Adds in default Panel header and footer
   */
  variant: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['panel'])
};
PanelFilterGroup.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (PanelFilterGroup);
//# sourceMappingURL=group.js.map

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shortid__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shortid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shortid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_constants__ = __webpack_require__(2);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// # Filter List
// Implements the [Panel design pattern](https://www.lightningdesignsystem.com/components/panels) in React.
// Based on SLDS v2.2.0-rc.1
// ## Dependencies
// ### React


 // ### shortid
// [npmjs.com/package/shortid](https://www.npmjs.com/package/shortid)
// shortid is a short, non-sequential, url-friendly, unique id generator

 // ## Constants


/**
 * A list of Filters. This is a higher order component for filters that decorates the filter to work within a Filtering Panel. It also adds support for a Filter error label.
 */

var PanelFilterList = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: __WEBPACK_IMPORTED_MODULE_4__utilities_constants__["_4" /* PANEL_FILTER_LIST */],
  propTypes: function propTypes() {
    return {
      /**
       * Pass in `Filter` components
       */
      children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
    };
  },
  componentWillMount: function componentWillMount() {
    this.generatedId = __WEBPACK_IMPORTED_MODULE_3_shortid___default.a.generate();
  },
  render: function render() {
    var _this = this;

    var children = __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(this.props.children, function (child, index) {
      var id = child && child.props.id ? child.props.id : "".concat(_this.generatedId, "-").concat(index);
      var clonedChild;

      if (child && child.props.errorLabel) {
        clonedChild = __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, {
          isError: true
        });
      }

      return child ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
        className: "slds-item slds-hint-parent"
      }, clonedChild || child, child.props.errorLabel ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
        id: "".concat(id, "-error"),
        className: "slds-text-color--error slds-m-top--xx-small"
      }, child.props.errorLabel) : null) : null;
    });
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol", {
      className: "slds-list--vertical slds-list--vertical-space"
    }, children);
  }
});
/* unused harmony default export */ var _unused_webpack_default_export = (PanelFilterList);
//# sourceMappingURL=list.js.map

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__icon__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_constants__ = __webpack_require__(2);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// # FIlter List Heading
// Implements the [Panel design pattern](https://www.lightningdesignsystem.com/components/panels) in React.
// Based on SLDS v2.2.0-rc.1
// ## Dependencies
// ### React

 // ### classNames


 // ## Constants


/**
 * A filtering panel contextual filtering options.
 */

var PanelFilterListHeading = function PanelFilterListHeading(_ref) {
  var heading = _ref.heading,
      isLocked = _ref.isLocked,
      lockedHeading = _ref.lockedHeading;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3", {
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('slds-text-body--small', 'slds-m-vertical--x-small', {
      'slds-grid': isLocked
    })
  }, isLocked ? lockedHeading : heading, isLocked ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__icon__["a" /* default */], {
    className: "slds-m-left--x-small",
    assistiveText: {
      label: 'locked'
    },
    category: "utility",
    name: "lock",
    size: "x-small"
  }) : null);
};

PanelFilterListHeading.displayName = __WEBPACK_IMPORTED_MODULE_4__utilities_constants__["_5" /* PANEL_FILTER_LIST_HEADING */];
PanelFilterListHeading.propTypes = {
  /**
   * Heading for following PanelFilterList
   */
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * Displayed a heading for a locked list of filters
   */
  isLocked: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Heading for a group of filters that are locked
   */
  lockedHeading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
PanelFilterListHeading.defaultProps = {
  heading: 'Matching all these filters',
  lockedLabel: 'Locked filters'
};
/* unused harmony default export */ var _unused_webpack_default_export = (PanelFilterListHeading);
//# sourceMappingURL=list-heading.js.map

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__detail_block__ = __webpack_require__(129);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */




var displayName = 'PageHeaderDetailRow';
var propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * Optional class name
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * An array of detail blocks
   */
  details: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};
var defaultProps = {};

var DetailRow =
/*#__PURE__*/
function (_Component) {
  _inherits(DetailRow, _Component);

  function DetailRow() {
    _classCallCheck(this, DetailRow);

    return _possibleConstructorReturn(this, (DetailRow.__proto__ || Object.getPrototypeOf(DetailRow)).apply(this, arguments));
  }

  _createClass(DetailRow, [{
    key: "_getClassNames",
    // eslint-disable-next-line class-methods-use-this
    value: function _getClassNames(className) {
      return __WEBPACK_IMPORTED_MODULE_2_classnames___default()('slds-grid slds-page-header__detail-row', className);
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          details = _props.details;

      var classes = this._getClassNames(className);
      /**
       * Render the deets
       */


      var renderDetails = function renderDetails() {
        if (children !== undefined) {
          return children;
        }

        return details.map(function (detail, i) {
          var key = "PageHeader.detailBlock.".concat(i);
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__detail_block__["a" /* default */], {
            key: key,
            flavor: detail.flavor,
            label: detail.label,
            content: detail.content,
            truncate: detail.truncate
          });
        });
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
        className: classes
      }, renderDetails());
    }
  }]);

  return DetailRow;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DetailRow.displayName = displayName;
DetailRow.propTypes = propTypes;
DetailRow.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (DetailRow);
//# sourceMappingURL=detail-row.js.map

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__popover_tooltip__ = __webpack_require__(83);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable jsx-a11y/no-noninteractive-tabindex */




var displayName = 'PageHeaderDetailRow';
var propTypes = {
  /**
   * Optional class name
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * label
   */
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element]),

  /**
   * The content property can be a string or a React element
   */
  content: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element]),

  /**
   * Sets whether the fields truncate
   */
  truncate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  flavor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
var defaultProps = {
  label: '',
  content: ''
};

var DetailBlock =
/*#__PURE__*/
function (_Component) {
  _inherits(DetailBlock, _Component);

  function DetailBlock(props) {
    var _this;

    _classCallCheck(this, DetailBlock);

    _this = _possibleConstructorReturn(this, (DetailBlock.__proto__ || Object.getPrototypeOf(DetailBlock)).call(this, props));
    _this.state = {
      showTooltip: false
    };
    return _this;
  }

  _createClass(DetailBlock, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._renderFieldTruncation();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.content !== prevProps.content) {
        this._renderFieldTruncation();
      }
    } // eslint-disable-next-line class-methods-use-this

  }, {
    key: "_getClassNames",
    value: function _getClassNames(className, flavor) {
      return __WEBPACK_IMPORTED_MODULE_2_classnames___default()('slds-page-header__detail-block', className, _defineProperty({}, "slds-size--".concat(flavor), flavor));
    }
  }, {
    key: "_renderFieldTruncation",
    value: function _renderFieldTruncation() {
      var fieldContent = this.fieldContentRef;
      var isTruncated = fieldContent && fieldContent.scrollWidth > fieldContent.offsetWidth;

      if (isTruncated) {
        this.setState({
          showTooltip: true
        });
      } else {
        this.setState({
          showTooltip: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          content = _props.content,
          flavor = _props.flavor,
          label = _props.label,
          truncate = _props.truncate;

      var classes = this._getClassNames(className, flavor);
      /**
       * Render the label
       */


      var renderLabel = function renderLabel() {
        var type = _typeof(label);

        if (type === 'string') {
          var labelClasses = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('slds-text-title', {
            'slds-truncate': truncate
          });
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
            className: labelClasses,
            title: label
          }, label);
        }

        return label;
      };
      /**
       * Render the content
       */


      var renderContent = function renderContent() {
        var type = _typeof(content);

        if (type === 'string') {
          var labelClasses = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('slds-text-body--regular', {
            'slds-truncate': truncate
          });
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
            ref: function ref(field) {
              _this2.fieldContentRef = field;
            },
            className: labelClasses,
            content: content
          }, content);
        }

        return content;
      };
      /**
       * Render the content with a tooltip (for content that truncates)
       */


      var renderContentWithTooltip = function renderContentWithTooltip() {
        var labelClasses = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('slds-text-body--regular', {
          'slds-truncate': truncate
        });
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__popover_tooltip__["a" /* default */], {
          align: "top",
          content: content
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
          tabIndex: "0",
          className: labelClasses
        }, content));
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
        className: classes
      }, renderLabel(), this.state.showTooltip ? renderContentWithTooltip() : renderContent());
    }
  }]);

  return DetailBlock;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DetailBlock.displayName = displayName;
DetailBlock.propTypes = propTypes;
DetailBlock.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (DetailBlock);
//# sourceMappingURL=detail-block.js.map

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_find__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shortid__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shortid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shortid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__private_step__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__private_progress__ = __webpack_require__(271);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// Implements the [Progress Indicator design pattern](https://lightningdesignsystem.com/components/progress-indicator/) in React.
// Based on SLDS v2.4.0


 // ### shortid
// [npmjs.com/package/shortid](https://www.npmjs.com/package/shortid)
// shortid is a short, non-sequential, url-friendly, unique id generator


 // Child components



var displayName = __WEBPACK_IMPORTED_MODULE_4__utilities_constants__["_9" /* PROGRESS_INDICATOR */];
var propTypes = {
  /**
   * **Assistive text for accessibility**
   * This object is merged with the default props object on every render.
   * * `completedStep`: Label for a completed step. The default is `Completed Step`
   * * `disabledStep`: Label for disabled step. The default is `Disabled Step`
   * * `errorStep`: Label for a step with an error. The default is `Error Step`
   * * `percentage`: Label for Progress Bar. The default is `Progress: [this.props.value]%`. You will need to calculate the percentage yourself if changing this string.
   * * `step`: Label for a step. It will be typically followed by the number of the step such as "Step 1".
   */
  assistiveText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    completedStep: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    disabledStep: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    percentage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    step: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),

  /**
   * CSS class names to be added to the container element. `array`, `object`, or `string` are accepted.
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * Stores all completed steps. It is an array of step objects.
   */
  completedSteps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,

  /**
   * Stores all disabled steps. It is an array of step objects. Steps are still clickable/focusable,
   * this only disables cursor change and removes onClick and onFocus event callbacks.
   */
  disabledSteps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,

  /**
   * Stores all error steps. It is an array of step objects and usually there is only one error step, the current step. If an error occurs a second error icon should be placed to the left of related confirmation buttons (e.g. Cancel, Save) and an Error Popover should appear indicating there are errors. These additional items are NOT part of this component. This note was included for visibility purposes. Please refer to [SLDS website](https://www.lightningdesignsystem.com/components/progress-indicator/) for full details **
   */
  errorSteps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,

  /**
   * HTML id for component.
   */
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Triggered when an individual step is clicked. By default, it receives an event and returns step state and the step object clicked: `{ isCompleted, isDisabled, isError, isSelected, step }`. Users are able to pass a callback handleClick function in forms of: <function name>(event, data) where data is the callback result.
   * ```
   * const handleStepClick = function(event, data) { console.log(data); };
   *   <ProgressIndicator onStepClick={handleStepClick} />
   * ```
   */
  onStepClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Triggered when an individual step is focused. By default, it receives an event and returns step state and the step object clicked: `{ isCompleted, isDisabled, isError, isSelected, step }`. Users are able to pass a callback handleClick function in forms of: <function name>(event, data) where data is the callback result.
   * ```
   * const handleStepFocus = function(event, data) { console.log(data); };
   *   <ProgressIndicator onStepFocus={handleStepFocus} />
   * ```
   */
  onStepFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Represents the currently selected or active step. It is a step object.
   */
  selectedStep: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,

  /**
   * It is an array of step objects in the following form:
   * ```
   *  [{
   *    id: <PropTypes.number> or <PropTypes.string>, has to be unique
   *    label: <PropTypes.string>, representing the tooltip content
   *    assistiveText: <PropTypes.string>, The default is `[Step props.index + 1]: [status]`. Status is if the step has been completed or in an error state.
   *  }],
   *  ```
   */
  steps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,

  /**
   * Stores all steps with opened tooltips. This property is mainly for development purposes. The tooltip should only show on hover for the user.
   */
  tooltipIsOpenSteps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,

  /**
   * Determines component style.
   */
  variant: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['base', 'modal'])
};
var defaultSteps = [{
  id: 0,
  label: 'tooltip label #1'
}, {
  id: 1,
  label: 'tooltip label #2'
}, {
  id: 2,
  label: 'tooltip label #3'
}, {
  id: 3,
  label: 'tooltip label #4'
}, {
  id: 4,
  label: 'tooltip label #5'
}];
var defaultProps = {
  assistiveText: {
    completedStep: 'Completed',
    disabledStep: 'Disabled',
    errorStep: 'Error',
    step: 'Step'
  },
  errorSteps: [],
  completedSteps: [],
  disabledSteps: [],
  selectedStep: defaultSteps[0],
  variant: 'base',
  // click/focus callbacks by default do nothing
  onStepClick: function onStepClick() {},
  onStepFocus: function onStepFocus() {}
};
/**
 * Check if `steps` prop is valid
 */

function checkSteps(steps) {
  var isStepsDefined = steps !== undefined;

  var isLabelDefined = function isLabelDefined(step) {
    return step.label !== undefined;
  };

  var stepLabelsDefined = Array.isArray(steps) && steps.every(isLabelDefined);
  return isStepsDefined && stepLabelsDefined;
}
/**
 * Check if an item is from an array of items when 'items' is an array;
 * Check if an item is equal to the other item after being stringified when 'items' is a JSON object
 */


function findStep(item, items) {
  if (Array.isArray(items)) {
    return !!__WEBPACK_IMPORTED_MODULE_2_lodash_find___default()(items, item);
  }

  return JSON.stringify(item) === JSON.stringify(items);
}
/**
 * Progress Indicator is a component that communicates to the user the progress of a particular process.
 */


var ProgressIndicator =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ProgressIndicator, _React$Component);

  function ProgressIndicator() {
    _classCallCheck(this, ProgressIndicator);

    return _possibleConstructorReturn(this, (ProgressIndicator.__proto__ || Object.getPrototypeOf(ProgressIndicator)).apply(this, arguments));
  }

  _createClass(ProgressIndicator, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.generatedId = __WEBPACK_IMPORTED_MODULE_3_shortid___default.a.generate();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.isUnmounting = true;
    }
    /**
     * Get the progress indicator's HTML id. Generate a new one if no ID present.
     */

  }, {
    key: "getId",
    value: function getId() {
      return this.props.id || this.generatedId;
    }
  }, {
    key: "getSteps",
    value: function getSteps() {
      // check if passed steps are valid
      return checkSteps(this.props.steps) ? this.props.steps : defaultSteps;
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      // Merge objects of strings with their default object
      var assistiveText = _objectSpread({}, defaultProps.assistiveText, this.props.assistiveText);

      var _props = this.props,
          selectedStep = _props.selectedStep,
          disabledSteps = _props.disabledSteps,
          errorSteps = _props.errorSteps,
          completedSteps = _props.completedSteps;
      /** 1. preparing data */

      var allSteps = this.getSteps();
      var currentStep = 0; // find index for the current step

      for (var i = 0; i < allSteps.length; i += 1) {
        // assign step an id if it does not have one
        if (allSteps[i].id === undefined) {
          allSteps[i].id = i;
        }

        if (findStep(allSteps[i], this.props.selectedStep)) {
          currentStep = i;
        }
      }
      /** 2. return DOM */


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__private_progress__["a" /* default */], {
        assistiveText: assistiveText,
        id: this.getId(),
        value: currentStep === 0 ? '0' : "".concat(100 * (currentStep / (allSteps.length - 1))),
        variant: this.props.variant,
        className: this.props.className
      }, allSteps.map(function (step, i) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__private_step__["a" /* default */], {
          assistiveText: assistiveText,
          key: "".concat(_this.getId(), "-").concat(step.id),
          id: _this.getId(),
          index: i,
          isSelected: findStep(step, selectedStep),
          isDisabled: findStep(step, disabledSteps),
          isError: findStep(step, errorSteps),
          isCompleted: findStep(step, completedSteps),
          onClick: _this.props.onStepClick,
          onFocus: _this.props.onStepFocus,
          step: step,
          tooltipIsOpen: findStep(step, _this.props.tooltipIsOpenSteps)
        });
      }));
    }
  }]);

  return ProgressIndicator;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ProgressIndicator.displayName = displayName;
ProgressIndicator.propTypes = propTypes;
ProgressIndicator.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (ProgressIndicator);
//# sourceMappingURL=index.js.map

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export THEME_OPTIONS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__icon__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__private_ring_shape__ = __webpack_require__(273);
var _THEME_CLASSES;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// Implements the [Progress Ring design pattern](https://lightningdesignsystem.com/components/progress-ring/) in React.
// Based on SLDS v2.4.5






/**
 * The themes available for the progress ring
 */

var THEME_OPTIONS = Object.freeze({
  WARNING: 'warning',
  EXPIRED: 'expired',
  COMPLETE: 'complete'
});
/**
 * The CSS classes associated with each theme
 */

var THEME_CLASSES = (_THEME_CLASSES = {}, _defineProperty(_THEME_CLASSES, THEME_OPTIONS.COMPLETE, 'slds-progress-ring_complete'), _defineProperty(_THEME_CLASSES, THEME_OPTIONS.WARNING, 'slds-progress-ring_warning'), _defineProperty(_THEME_CLASSES, THEME_OPTIONS.EXPIRED, 'slds-progress-ring_expired'), _THEME_CLASSES);
var propTypes = {
  /**
   * HTML id for component.
   */
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * CSS classes to be added to tag with `.slds-progress-ring`. Uses `classNames` [API](https://github.com/JedWatson/classnames).
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * The theme applied to the ring.
   */
  theme: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['warning', 'expired', 'complete']),

  /**
   * Overrides the icon to be displayed.
   */
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * Display the icon associated with the theme.
   */
  hasIcon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Percentage of progress completion, ranging [0, 100].
   */
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
};
var defaultProps = {};
/**
 * Customizable and configurable progress ring. Will display progress in a circular progress bar factor, and is capable of displaying iconography inside of the ring structure.
 */

var ProgressRing =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ProgressRing, _React$Component);

  function ProgressRing() {
    _classCallCheck(this, ProgressRing);

    return _possibleConstructorReturn(this, (ProgressRing.__proto__ || Object.getPrototypeOf(ProgressRing)).apply(this, arguments));
  }

  _createClass(ProgressRing, [{
    key: "icon",

    /**
     * Gets the icon to display
     * @returns {node} Icon
     */
    value: function icon() {
      var icon = '';

      if (this.props.hasIcon) {
        if (this.props.icon) {
          icon = this.props.icon;
        } else if (this.props.theme === THEME_OPTIONS.WARNING) {
          icon = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__icon__["a" /* default */], {
            category: "utility",
            name: "warning",
            title: "Warning"
          });
        } else if (this.props.theme === THEME_OPTIONS.EXPIRED) {
          icon = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__icon__["a" /* default */], {
            category: "utility",
            name: "error",
            title: "Expired"
          });
        } else if (this.props.theme === THEME_OPTIONS.COMPLETE) {
          icon = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__icon__["a" /* default */], {
            category: "utility",
            name: "check",
            title: "complete"
          });
        }
      }

      return icon;
    }
    /**
     * Percentage as a decimal
     * @returns {decimal} Percentage
     */

  }, {
    key: "percentDecimal",
    value: function percentDecimal() {
      return this.props.value / 100;
    }
    /**
     * Gets the theme CSS class
     * @returns {string} Class name
     */

  }, {
    key: "themeClass",
    value: function themeClass() {
      return THEME_CLASSES[this.props.theme] || '';
    }
  }, {
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__private_ring_shape__["a" /* default */], {
        id: this.props.id,
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(this.props.className, this.themeClass()),
        fillPercentDecimal: this.percentDecimal()
      }, this.icon());
    }
  }]);

  return ProgressRing;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ProgressRing.displayName = __WEBPACK_IMPORTED_MODULE_3__utilities_constants__["_12" /* PROGRESS_RING */];
ProgressRing.propTypes = propTypes;
ProgressRing.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (ProgressRing);
//# sourceMappingURL=index.js.map

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shortid__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shortid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_shortid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_constants__ = __webpack_require__(2);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */





var propTypes = {
  /**
   * The ID of an element that describes this radio input. Often used for error messages.
   */
  'aria-describedby': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * This is a controlled component. This radio is checked according to this value.
   */
  checked: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * This is the initial value of an uncontrolled form element and is present only to provide compatibility
   * with hybrid framework applications that are not entirely React. It should only be used in an application
   * without centralized state (Redux, Flux). "Controlled components" with centralized state is highly recommended.
   * See [Code Overview](https://github.com/salesforce/design-system-react/blob/master/docs/codebase-overview.md#controlled-and-uncontrolled-components) for more information.
   */
  defaultChecked: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Disable this radio input.
   */
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * A unique ID that is used to associating a label to the `input` element. This ID is added to the `input` element.
   */
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * The string or element that is shown as both the title and the label for this radio input.
   */
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element]).isRequired,

  /**
   * The name of the radio input group.
   */
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * This event fires when the radio selection changes.
   */
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * The value of this radio input.
   */
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Variant of the Radio button. Base is the default and button-group makes the radio button look like a normal button (should be a child of <RadioButtonGroup>).
   */
  variant: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['base', 'button-group'])
};
var defaultProps = {
  variant: 'base'
};
/**
 * A radio input that can have a single input checked at any one time. Radios should be wrapped with
 * a [RadioGroup](/components/radio-group) or [RadioButtonGroup](/components/radio-button-group)
 */

var Radio =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Radio, _React$Component);

  function Radio(props) {
    var _this;

    _classCallCheck(this, Radio);

    _this = _possibleConstructorReturn(this, (Radio.__proto__ || Object.getPrototypeOf(Radio)).call(this, props));
    _this.generatedId = __WEBPACK_IMPORTED_MODULE_2_shortid___default.a.generate();
    return _this;
  }

  _createClass(Radio, [{
    key: "getId",
    value: function getId() {
      return this.props.id || this.generatedId;
    }
  }, {
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()({
          'slds-radio': this.props.variant === 'base',
          'slds-button slds-radio_button': this.props.variant === 'button-group'
        })
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        type: "radio",
        id: this.getId(),
        name: this.props.name,
        value: this.props.value,
        checked: this.props.checked,
        defaultChecked: this.props.defaultChecked,
        onChange: this.props.onChange,
        "aria-describedby": this.props['aria-describedby'],
        disabled: this.props.disabled
      }), this.props.variant === 'button-group' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", {
        className: "slds-radio_button__label",
        htmlFor: this.getId()
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "slds-radio_faux"
      }, this.props.label)) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", {
        className: "slds-radio__label",
        htmlFor: this.getId()
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "slds-radio_faux"
      }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "slds-form-element__label"
      }, this.props.label)));
    }
  }]);

  return Radio;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Radio.displayName = __WEBPACK_IMPORTED_MODULE_4__utilities_constants__["_13" /* RADIO */];
Radio.propTypes = propTypes;
Radio.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Radio);
//# sourceMappingURL=index.js.map

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shortid__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shortid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shortid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_assign__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_constants__ = __webpack_require__(2);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// Implements the [Radio Button Group design pattern](https://lightningdesignsystem.com/components/radio-button-group/) in React.
// Based on SLDS v2.5.0






var propTypes = {
  /**
   * Children are expected to be Radio components.
   */
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,

  /**
   * Custom CSS classes added to `slds-radio_button-group` node.
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * **Text labels for internationalization**
   * This object is merged with the default props object on every render.
   * * `error`: Message to display when any of Checkboxes are in an error state.
   * * `label`: This label appears above the button group.
   */
  labels: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    error: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),

  /**
   * This event fires when the radio selection changes.
   */
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Disable all radio inputs.
   */
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Adds an indicator that this field is required.
   */
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * The name of this radio group.
   */
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * The ID of the error message, for linking to radio inputs with aria-describedby.
   */
  errorId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
var defaultProps = {
  labels: {}
};
/**
 * A styled select list that can have a single entry checked at any one time.
 * The RadioButtonGroup component wraps [Radio](/components/radios) components, which should be used as children.
 */

var RadioButtonGroup =
/*#__PURE__*/
function (_React$Component) {
  _inherits(RadioButtonGroup, _React$Component);

  function RadioButtonGroup(props) {
    var _this;

    _classCallCheck(this, RadioButtonGroup);

    _this = _possibleConstructorReturn(this, (RadioButtonGroup.__proto__ || Object.getPrototypeOf(RadioButtonGroup)).call(this, props)); // Merge objects of strings with their default object

    _this.labels = _this.props.labels ? __WEBPACK_IMPORTED_MODULE_4_lodash_assign___default()({}, defaultProps.labels, _this.props.labels) : defaultProps.labels;
    _this.generatedName = __WEBPACK_IMPORTED_MODULE_3_shortid___default.a.generate();
    _this.generatedErrorId = _this.labels.error ? __WEBPACK_IMPORTED_MODULE_3_shortid___default.a.generate() : null;
    return _this;
  }

  _createClass(RadioButtonGroup, [{
    key: "getErrorId",
    value: function getErrorId() {
      if (this.hasError()) {
        return this.props.errorId || this.generatedErrorId;
      }

      return undefined;
    }
  }, {
    key: "getName",
    value: function getName() {
      return this.props.name || this.generatedName;
    }
  }, {
    key: "hasError",
    value: function hasError() {
      return !!this.labels.error;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var children = __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(this.props.children, function (child) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, {
          name: _this2.getName(),
          onChange: _this2.props.onChange,
          'aria-describedby': _this2.getErrorId(),
          disabled: _this2.props.disabled
        });
      });
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("fieldset", {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('slds-form-element', {
          'slds-has-error': this.labels.error
        })
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("legend", {
        className: "slds-form-element__legend slds-form-element__label"
      }, this.props.required ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("abbr", {
        className: "slds-required",
        title: "required"
      }, "*") : null, this.labels.label), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('slds-form-element__control', this.props.className)
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "slds-radio_button-group"
      }, children), this.labels.error ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        id: this.getErrorId(),
        className: "slds-form-element__help"
      }, this.labels.error) : null));
    }
  }]);

  return RadioButtonGroup;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

RadioButtonGroup.displayName = __WEBPACK_IMPORTED_MODULE_5__utilities_constants__["_14" /* RADIO_BUTTON_GROUP */];
RadioButtonGroup.propTypes = propTypes;
RadioButtonGroup.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (RadioButtonGroup);
//# sourceMappingURL=index.js.map

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shortid__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shortid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shortid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_assign__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_constants__ = __webpack_require__(2);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// Implements the [Radio Group design pattern](https://lightningdesignsystem.com/components/radio-group/) in React.
// Based on SLDS v2.5.0






var propTypes = {
  /**
   * Children are expected to be Radio components.
   */
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,

  /**
   * Custom CSS classes added to the node.
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * **Text labels for internationalization**
   * This object is merged with the default props object on every render.
   * * `error`: Message to display when any of Checkboxes are in an error state.
   * * `label`: This label appears above the radio group.
   */
  labels: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    error: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),

  /**
   * This event fires when the radio selection changes.
   */
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Disable all radio inputs.
   */
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Adds an indicator that this field is required.
   */
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * The name of this radio group.
   */
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * The ID of the error message, for linking to radio inputs with aria-describedby.
   */
  errorId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
var defaultProps = {
  labels: {}
};
/**
 * A styled select list that can have a single entry checked at any one time.
 * The RadioGroup component wraps [Radio](/components/radios) components, which should be used as children.
 */

var RadioGroup =
/*#__PURE__*/
function (_React$Component) {
  _inherits(RadioGroup, _React$Component);

  function RadioGroup(props) {
    var _this;

    _classCallCheck(this, RadioGroup);

    _this = _possibleConstructorReturn(this, (RadioGroup.__proto__ || Object.getPrototypeOf(RadioGroup)).call(this, props)); // Merge objects of strings with their default object

    _this.labels = _this.props.labels ? __WEBPACK_IMPORTED_MODULE_4_lodash_assign___default()({}, defaultProps.labels, _this.props.labels) : defaultProps.labels;
    _this.generatedName = __WEBPACK_IMPORTED_MODULE_3_shortid___default.a.generate();
    _this.generatedErrorId = _this.labels.error ? __WEBPACK_IMPORTED_MODULE_3_shortid___default.a.generate() : null;
    return _this;
  }

  _createClass(RadioGroup, [{
    key: "getErrorId",
    value: function getErrorId() {
      if (this.hasError()) {
        return this.props.errorId || this.generatedErrorId;
      }

      return undefined;
    }
  }, {
    key: "getName",
    value: function getName() {
      return this.props.name || this.generatedName;
    }
  }, {
    key: "hasError",
    value: function hasError() {
      return !!this.labels.error;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var children = __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(this.props.children, function (child) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, {
          name: _this2.getName(),
          onChange: _this2.props.onChange,
          'aria-describedby': _this2.getErrorId(),
          disabled: _this2.props.disabled
        });
      });
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("fieldset", {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('slds-form-element', {
          'slds-has-error': this.labels.error
        })
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("legend", {
        className: "slds-form-element__legend slds-form-element__label"
      }, this.props.required ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("abbr", {
        className: "slds-required",
        title: "required"
      }, "*") : null, this.labels.label), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('slds-form-element__control', this.props.className)
      }, children, this.labels.error ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        id: this.getErrorId(),
        className: "slds-form-element__help"
      }, this.labels.error) : null));
    }
  }]);

  return RadioGroup;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

RadioGroup.displayName = __WEBPACK_IMPORTED_MODULE_5__utilities_constants__["_15" /* RADIO_GROUP */];
RadioGroup.propTypes = propTypes;
RadioGroup.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (RadioGroup);
//# sourceMappingURL=index.js.map

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isfunction__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isfunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isfunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shortid__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shortid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_shortid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_constants__ = __webpack_require__(2);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// # Slider Component
// Implements the [Slider design pattern](https://www.lightningdesignsystem.com/components/slider/) in React.
// ### React

 // ### isFunction

 // ### classNames

 // ### shortid
// [npmjs.com/package/shortid](https://www.npmjs.com/package/shortid)
// shortid is a short, non-sequential, url-friendly, unique id generator



var propTypes = {
  /**
   * The `aria-describedby` attribute is used to indicate the IDs of the elements that describe the object. It is used to establish a relationship between widgets or groups and text that described them. This is very similar to aria-labelledby: a label describes the essence of an object, while a description provides more information that the user might need.
   */
  'aria-describedby': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Assistive text for accessibility**
   * `label`: Visually hidden label but read out loud by screen readers.
   *
   */
  assistiveText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),

  /**
   * Class names to be added to the outer container of the Slider.
   */
  classNameContainer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * This is the initial value of an uncontrolled form element and is present
   * only to provide compatibility with hybrid framework applications that
   * are not entirely React. It should only be used in an application without
   * centralized state (Redux, Flux). "Controlled components" with centralized
   * state is highly recommended. See [Code Overview](https://github.com/salesforce/design-system-react/blob/master/docs/codebase-overview.md#controlled-and-uncontrolled-components) for more information.
   */
  defaultValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * Disables the Slider and prevents clicking it. Only available on the horizontal view.
   */
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Message to display when the Slider is in an error state. When this is present, also visually highlights the component as in error.
   */
  errorText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Set the HTML `id` of the slider.
   */
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * This label appears above the Slider.
   */
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Maximum value of a specified range. Defaults to 100.
   */
  max: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * Minimum value of a specified range. Defaults to 0.
   */
  min: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * Name of the submitted form parameter.
   */
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * This event fires whenever the user has modified the data of the control. This callback recieves the following parameters `event, { value: [string] }`.
   */
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * This event fires when the value is committed. This callback recieves the following parameters `event, { value: [string] }`.
   */
  onInput: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Size of the slider.
   */
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['x-small', 'small', 'medium', 'large']),

  /**
   * By default, the granularity is 1 and the value is always an integer. For example, If you need a value between 5 and 10, accurate to two decimal places, you should set the value of step to 0.01
   */
  step: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * The Slider should be a controlled component, and will always display this value. This should always be used if you are using a Flux/Redux framework.
   */
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * Modifier that makes the slider vertical
   */
  vertical: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
var defaultProps = {
  min: 0,
  max: 100,
  step: 1
};
/**
 * The ability to style sliders with CSS varies across browsers. Using this component ensures sliders look the same everywhere.
 */

var Slider =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Slider, _React$Component);

  function Slider(props) {
    var _this;

    _classCallCheck(this, Slider);

    _this = _possibleConstructorReturn(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, props));
    Object.defineProperty(_assertThisInitialized(_this), "handleChange", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(event) {
        if (__WEBPACK_IMPORTED_MODULE_2_lodash_isfunction___default()(_this.props.onChange)) {
          _this.props.onChange(event, {
            value: Number(event.target.value)
          });
        }
      }
    });
    Object.defineProperty(_assertThisInitialized(_this), "handleInput", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(event) {
        if (__WEBPACK_IMPORTED_MODULE_2_lodash_isfunction___default()(_this.props.onInput)) {
          _this.props.onInput(event, {
            value: Number(event.target.value)
          });
        }
      }
    });
    _this.generatedId = __WEBPACK_IMPORTED_MODULE_4_shortid___default.a.generate();

    if (_this.props.errorText) {
      _this.generatedErrorId = __WEBPACK_IMPORTED_MODULE_4_shortid___default.a.generate();
    }

    return _this;
  }

  _createClass(Slider, [{
    key: "getId",
    value: function getId() {
      return this.props.id || this.generatedId;
    }
  }, {
    key: "getErrorId",
    value: function getErrorId() {
      return this.props['aria-describedby'] || this.generatedErrorId;
    }
  }, {
    key: "render",
    value: function render() {
      var labelText = this.props.label || this.props.assistiveText && this.props.assistiveText.label;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('slds-form-element', {
          'slds-has-error': this.props.errorText
        }, this.props.classNameContainer)
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('slds-form-element__label', {
          'slds-assistive-text': this.props.assistiveText && !this.props.label
        }),
        htmlFor: this.getId()
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "slds-slider-label"
      }, labelText ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "slds-slider-label__label"
      }, labelText) : null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "slds-slider-label__range"
      }, this.props.min, " - ", this.props.max))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "slds-form-element__control"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('slds-slider', {
          'slds-slider_vertical': this.props.vertical,
          'slds-size_x-small': this.props.size === 'x-small',
          'slds-size_small': this.props.size === 'small',
          'slds-size_medium': this.props.size === 'medium',
          'slds-size_large': this.props.size === 'large'
        })
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        type: "range",
        id: this.getId(),
        name: this.props.name,
        className: "slds-slider__range",
        defaultValue: this.props.defaultValue,
        min: this.props.min,
        max: this.props.max,
        step: this.props.step,
        "aria-describedby": this.getErrorId(),
        value: this.props.value,
        disabled: this.props.disabled,
        onChange: this.handleChange,
        onInput: this.handleInput
      }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "slds-slider__value",
        "aria-hidden": "true"
      }, this.props.value || this.props.defaultValue || '0')), this.props.errorText ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        id: this.getErrorId(),
        className: "slds-form-element__help"
      }, this.props.errorText) : null));
    }
  }]);

  return Slider;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Object.defineProperty(Slider, "displayName", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: __WEBPACK_IMPORTED_MODULE_5__utilities_constants__["_17" /* SLIDER */]
});
Object.defineProperty(Slider, "propTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: propTypes
});
Object.defineProperty(Slider, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: defaultProps
});
/* unused harmony default export */ var _unused_webpack_default_export = (Slider);
//# sourceMappingURL=index.js.map

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__page_header__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_constants__ = __webpack_require__(2);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */




var propTypes = {};
var defaultProps = {};
/**
 * The Split View Header takes the same properties as the [PageHeader](https://react.lightningdesignsystem.com/components/page-headers/) component.
 */

var SplitViewHeader = function SplitViewHeader(_ref) {
  var className = _ref.className,
      rest = _objectWithoutProperties(_ref, ["className"]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__page_header__["a" /* default */], _extends({
    className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('slds-split-view__header slds-has-bottom-magnet', className)
  }, rest));
};

SplitViewHeader.displayName = __WEBPACK_IMPORTED_MODULE_3__utilities_constants__["_20" /* SPLIT_VIEW_HEADER */];
SplitViewHeader.propTypes = propTypes;
SplitViewHeader.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (SplitViewHeader);
//# sourceMappingURL=header.js.map

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SORT_OPTIONS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_event__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__icon__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__private_list_item_content__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__private_list_item_with_content__ = __webpack_require__(276);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable class-methods-use-this */








var SORT_OPTIONS = Object.freeze({
  UP: 'up',
  DOWN: 'down'
});
var propTypes = {
  /**
   * **Assistive text for accessibility**
   * * `list`: aria label for the list
   * * `sort`
   *    * `sortedBy`: Clickable sort header for the list.
   *    * `descending`: Descending sorting.
   *    * `ascending`: Ascending sorting.
   */
  assistiveText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    list: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    sort: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      sortedBy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      descending: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
      ascending: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
    }),
    unreadItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),

  /**
   * CSS classes to be added to the parent `div` tag.
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * Event Callbacks
   * * `onSelect`: Called when a list item is selected.
   *    * event {object} List item click event
   *    * Meta {object}
   *       * selectedItems {array} List of selected items.
   *       * item {object} Last selected item.
   * * `onSort`: Called when the list is sorted.
   *    * event {object} Sort click event
   */
  events: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    onSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    onSort: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  }),

  /**
   * HTML id for component.
   */
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * **Text labels for internationalization**
   * * `header`: This is the header of the list.
   */
  labels: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    header: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),

  /**
   * The direction of the sort arrow. Option are:
   * * SORT_OPTIONS.UP: `up`
   * * SORT_OPTIONS.DOWN: `down`
   */
  sortDirection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([SORT_OPTIONS.UP, SORT_OPTIONS.DOWN]),

  /**
   * Allows multiple item to be selection
   */
  multiple: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * The list of items.
   * It is recommended that you have a unique `id` for each item.
   */
  options: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,

  /**
   * Accepts an array of item objects. For single selection, pass in an array of one object.
   */
  selection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,

  /**
   * Accepts an array of item objects. For single unread, pass in an array of one object.
   */
  unread: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,

  /**
   * Custom list item template for the list item content. The select and unread functionality wraps the custom list item.
   * This should be a React component that accepts props.
   */
  listItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
var defaultProps = {
  assistiveText: {
    list: 'Select an item to open it in a new workspace tab.',
    sort: {
      sortedBy: 'Sorted by',
      descending: 'Descending',
      ascending: 'Ascending'
    }
  },
  events: {},
  labels: {},
  selection: [],
  unread: []
};
/**
 * The menu with the ARIA role of a listbox.
 */

var SplitViewListbox =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SplitViewListbox, _React$Component);

  function SplitViewListbox(props) {
    var _this;

    _classCallCheck(this, SplitViewListbox);

    _this = _possibleConstructorReturn(this, (SplitViewListbox.__proto__ || Object.getPrototypeOf(SplitViewListbox)).call(this, props));
    _this.listItemComponents = {};
    _this.state = {
      currentSelectedItem: null,
      currentFocusedListItem: {
        index: 0,
        item: null
      }
    };
    return _this;
  }

  _createClass(SplitViewListbox, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      // Generates the list item template
      this.ListItemWithContent = Object(__WEBPACK_IMPORTED_MODULE_7__private_list_item_with_content__["a" /* default */])(this.props.listItem || __WEBPACK_IMPORTED_MODULE_6__private_list_item_content__["a" /* default */]);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.focusFirstItem();
    }
  }, {
    key: "isListItemFocused",
    value: function isListItemFocused(item) {
      return this.state.currentFocusedListItem.item === item;
    }
  }, {
    key: "isSelected",
    value: function isSelected(item) {
      return this.props.selection.includes(item);
    }
  }, {
    key: "isUnread",
    value: function isUnread(item) {
      return this.props.unread.includes(item);
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(event) {
      if (this.props.multiple && event.key === 'a' && event.ctrlKey) {
        // select / deselect all
        __WEBPACK_IMPORTED_MODULE_3__utilities_event__["a" /* default */].trap(event);

        if (this.props.options === this.props.selection) {
          this.deselectAllListItems(event);
        } else {
          this.selectAllListItems(event);
        }
      } else if (event.key === 'ArrowUp') {
        __WEBPACK_IMPORTED_MODULE_3__utilities_event__["a" /* default */].trap(event);
        this.moveToPreviousItem(event);
      } else if (event.key === 'ArrowDown') {
        __WEBPACK_IMPORTED_MODULE_3__utilities_event__["a" /* default */].trap(event);
        this.moveToNextItem(event);
      }
    }
  }, {
    key: "moveToNextItem",
    value: function moveToNextItem(event) {
      var nextFocusIndex = this.state.currentFocusedListItem.index === this.props.options.length - 1 ? 0 : this.state.currentFocusedListItem.index + 1;
      this.moveToIndex(event, nextFocusIndex);
    }
  }, {
    key: "moveToPreviousItem",
    value: function moveToPreviousItem(event) {
      var previousFocusIndex = this.state.currentFocusedListItem.index === 0 ? this.props.options.length - 1 : this.state.currentFocusedListItem.index - 1;
      this.moveToIndex(event, previousFocusIndex);
    }
  }, {
    key: "moveToIndex",
    value: function moveToIndex(event, index) {
      var item = this.props.options[index];

      if (!event.metaKey && !event.ctrlKey) {
        this.selectListItem(item, event);
      }

      this.focusItem(item);
    }
  }, {
    key: "focusFirstItem",
    value: function focusFirstItem() {
      var _this2 = this;

      var firstSelectedItem = this.props.options.find(function (item) {
        return _this2.props.selection.includes(item);
      }) || this.props.options[0];

      if (firstSelectedItem) {
        this.focusItem(firstSelectedItem, true);
      }
    }
  }, {
    key: "focusItem",
    value: function focusItem(item, setDataOnly) {
      var index = this.props.options.indexOf(item);

      if (!setDataOnly) {
        this.listItemComponents[index].focus();
      }

      this.setState({
        currentFocusedListItem: {
          index: index,
          item: item
        }
      });
    }
  }, {
    key: "deselectAllListItems",
    value: function deselectAllListItems(event) {
      this.setState({
        currentSelectedItem: null
      });
      this.props.events.onSelect(event, {
        selectedItems: [],
        item: null
      });
    }
  }, {
    key: "selectAllListItems",
    value: function selectAllListItems(event) {
      this.props.events.onSelect(event, {
        selectedItems: this.props.options,
        item: this.state.currentSelectedItem
      });
    }
  }, {
    key: "selectListItem",
    value: function selectListItem(item, event) {
      var selectedItems = [item];

      if (this.props.multiple) {
        if (event.metaKey) {
          selectedItems = this.props.selection.includes(item) ? this.props.selection.filter(function (i) {
            return i !== item;
          }) : [item].concat(_toConsumableArray(this.props.selection));
        } else if (event.shiftKey) {
          var _sort = [this.props.options.indexOf(this.state.currentSelectedItem), this.props.options.indexOf(item)].sort(),
              _sort2 = _slicedToArray(_sort, 2),
              begin = _sort2[0],
              end = _sort2[1];

          var addToSelection = this.props.options.slice(begin, end + 1);
          selectedItems = _toConsumableArray(addToSelection).concat(_toConsumableArray(this.props.selection.filter(function (i) {
            return !addToSelection.includes(i);
          })));
        }
      }

      this.setState({
        currentSelectedItem: item
      });
      this.props.events.onSelect(event, {
        selectedItems: selectedItems,
        item: item
      });
    }
  }, {
    key: "handleOnSelect",
    value: function handleOnSelect(event, _ref) {
      var item = _ref.item;
      this.selectListItem(item, event);
      this.focusItem(item);
    }
  }, {
    key: "sortDirection",
    value: function sortDirection() {
      return this.props.sortDirection ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__icon__["a" /* default */], {
        category: "utility",
        name: this.props.sortDirection === SORT_OPTIONS.DOWN ? 'arrowdown' : 'arrowup',
        size: "xx-small",
        className: "slds-align-top"
      }) : null;
    }
  }, {
    key: "headerWrapper",
    value: function headerWrapper(children) {
      return this.props.events.onSort ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
        style: {
          borderTop: '0'
        },
        href: "javascript:void(0);" // eslint-disable-line no-script-url
        ,
        role: "button",
        className: "slds-split-view__list-header slds-grid slds-text-title_caps slds-text-link_reset",
        onClick: this.props.events.onSort
      }, children) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        style: {
          borderTop: '0'
        },
        className: "slds-split-view__list-header slds-grid slds-text-title_caps"
      }, children);
    }
  }, {
    key: "header",
    value: function header() {
      return this.props.labels.header ? this.headerWrapper(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "slds-assistive-text"
      }, this.props.assistiveText.sort.sortedBy, ":"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, this.props.labels.header, this.sortDirection()), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "slds-assistive-text"
      }, "-", ' ', this.props.sortDirection === SORT_OPTIONS.DOWN ? this.props.assistiveText.sort.descending : this.props.assistiveText.sort.ascending))) : null;
    }
  }, {
    key: "addListItemComponent",
    value: function addListItemComponent(component, index) {
      this.listItemComponents[index] = component;
    }
  }, {
    key: "listItems",
    value: function listItems() {
      var _this3 = this;

      var ListItemWithContent = this.ListItemWithContent;
      return this.props.options.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ListItemWithContent, {
          key: item.id || index,
          assistiveText: {
            unreadItem: _this3.props.assistiveText.unreadItem
          },
          listItemRef: function listItemRef(component) {
            _this3.addListItemComponent(component, index);
          },
          item: item,
          isFocused: _this3.isListItemFocused(item),
          isSelected: _this3.isSelected(item),
          isUnread: _this3.isUnread(item),
          events: {
            onClick: function onClick(event, meta) {
              return _this3.handleOnSelect(event, meta);
            }
          },
          multiple: _this3.props.multiple
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        id: this.props.id,
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('slds-grid slds-grid_vertical slds-scrollable_none', this.props.className)
      }, this.header(), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
        className: "slds-scrollable_y",
        "aria-label": this.props.assistiveText.list,
        "aria-multiselectable": this.props.multiple,
        role: "listbox",
        onKeyDown: function onKeyDown(event) {
          return _this4.handleKeyDown(event);
        }
      }, this.listItems()));
    }
  }]);

  return SplitViewListbox;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Object.defineProperty(SplitViewListbox, "displayName", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: __WEBPACK_IMPORTED_MODULE_4__utilities_constants__["_21" /* SPLIT_VIEW_LISTBOX */]
});
Object.defineProperty(SplitViewListbox, "propTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: propTypes
});
Object.defineProperty(SplitViewListbox, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: defaultProps
});
/* unused harmony default export */ var _unused_webpack_default_export = (SplitViewListbox);
//# sourceMappingURL=listbox.js.map

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shortid__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shortid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_shortid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__check_props__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_constants__ = __webpack_require__(2);
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable jsx-a11y/no-autofocus */
// # Textarea Component
// Implements the [Textarea design pattern](https://lightningdesignsystem.com/components/textarea).
// Based on SLDS v2.4.0
//
// ### React


 // ### classNames
// [github.com/JedWatson/classnames](https://github.com/JedWatson/classnames)
// This project uses `classnames`, "a simple javascript utility for conditionally
// joining classNames together."

 // ### shortid
// [npmjs.com/package/shortid](https://www.npmjs.com/package/shortid)
// shortid is a short, non-sequential, url-friendly, unique id generator

 // ## Children
// This component's `checkProps` which issues warnings to developers about properties when in development mode (similar to React's built in development tools)



/**
 * A multi-line plain-text editing control.
 */

var Textarea = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: __WEBPACK_IMPORTED_MODULE_6__utilities_constants__["_27" /* TEXTAREA */],
  propTypes: {
    /**
     * The aria-activedescendant attribute contains the ID of the currently active child object that is part of a composite widget within the Document Object Model. It makes do with the overhead of having all or more than one child focusable. As the name specifies, it helps in managing the current active child of the composite widget.
     */
    'aria-activedescendant': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * Indicates if the suggestions in a composite widget are values that complete the current textbox input.
     */
    'aria-autocomplete': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * An HTML ID that is shared with ARIA-supported devices with the
     * `aria-controls` attribute in order to relate the input with
     * another region of the page. An example would be a select box
     * that shows or hides a panel.
     */
    'aria-controls': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * The `aria-describedby` attribute is used to indicate the IDs of the elements that describe the object. It is used to establish a relationship between widgets or groups and text that described them. This is very similar to aria-labelledby: a label describes the essence of an object, while a description provides more information that the user might need.
     */
    'aria-describedby': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * Use the `aria-expanded` state to indicate whether regions of the content are collapsible, and to expose whether a region is currently expanded or collapsed.
     */
    'aria-expanded': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * Indicates that the element has a popup context menu or sub-level menu.
     */
    'aria-haspopup': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * The aria-labelledby attribute contains the element IDs of labels in objects such as input elements, widgets, and groups. The attribute establishes relationships between objects and their labels. Assistive technology, such as screen readers, use this attribute to catalog the objects in a document so that users can navigate between them. Without an element ID, the assistive technology cannot catalog the object.
     */
    'aria-labelledby': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * An HTML ID that is shared with ARIA-supported devices with the
     * `aria-controls` attribute in order to relate the input with
     * another region of the page. An example would be a search field
     * that shows search results.
     */
    'aria-owns': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * The `aria-required` attribute is used to indicate that user input is required on an element before a form can be submitted.
     */
    'aria-required': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * Specifies is the textarea should automatically get focus when the page loads. This is typically a poor user experience.
     */
    autoFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * **Assistive text for accessibility.**
     * * `label`: If present, the label associated with this `textarea` is overwritten by this text and is visually not shown.
     */
    assistiveText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
      label: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
    }),

    /**
     * Elements are added after the `textarea`.
     */
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,

    /**
     * Class names to be added to the textarea component.
     */
    className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),

    /** Allows for ability to apply classNames to outer textarea div.
     */
    classNameContainer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),

    /**
     * Disables the textarea and prevents editing the contents.
     */
    disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * Message to display when the textarea is in an error state. When this is present, also visually highlights the component as in error.
     */
    errorText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * Every textarea must have a unique ID in order to support keyboard navigation and ARIA support.
     */
    id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * This callback exposes the textarea reference / DOM node to parent components. `<Parent textareaRef={(textareaComponent) => this.textarea = textareaComponent} />
     */
    textareaRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * This label appears above the textarea.
     */
    label: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * Triggered when focus is removed.
     */
    onBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * This callback fires when the textarea changes. The synthetic React event will be the first parameter to the callback. You will probably want to reference `event.target.value` in your callback. No custom data object is provided.
     */
    onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * This event fires when the textarea is clicked.
     */
    onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Triggered when component is focused.
     */
    onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Similar to `onchange`. Triggered when an element gets user input.
     */
    onInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Triggered when a submittable <input> element is invalid.
     */
    onInvalid: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Triggered when a key is pressed down
     */
    onKeyDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Triggered when a key is pressed and released
     */
    onKeyPress: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Triggered when a key is released
     */
    onKeyUp: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Triggered after some text has been selected in an element.
     */
    onSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Fires when a form is submitted.
     */
    onSubmit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Maximum number of characters allowed.
     */
    maxLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * Name of the submitted form parameter.
     */
    name: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * Text that will appear in an empty textarea.
     */
    placeholder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * Highlights the textarea as a required field (does not perform any validation).
     */
    required: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * The textarea is a controlled component, and will always display this value.
     */
    value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * The textarea is a uncontrolled component, and this will be the initial value.
     */
    defaultValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * Specifies how the text in a text area is to be wrapped when submitted in a form.
     */
    wrap: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['soft', 'hard'])
  },
  componentWillMount: function componentWillMount() {
    // `checkProps` issues warnings to developers about properties (similar to React's built in development tools)
    Object(__WEBPACK_IMPORTED_MODULE_5__check_props__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_6__utilities_constants__["_27" /* TEXTAREA */], this.props);
    this.generatedId = __WEBPACK_IMPORTED_MODULE_4_shortid___default.a.generate();

    if (this.props.errorText) {
      this.generatedErrorId = __WEBPACK_IMPORTED_MODULE_4_shortid___default.a.generate();
    }
  },
  getId: function getId() {
    return this.props.id || this.generatedId;
  },
  getErrorId: function getErrorId() {
    return this.props['aria-describedby'] || this.generatedErrorId;
  },
  // ### Render
  render: function render() {
    var _props = this.props,
        autoFocus = _props.autoFocus,
        children = _props.children,
        className = _props.className,
        classNameContainer = _props.classNameContainer,
        disabled = _props.disabled,
        errorText = _props.errorText,
        textareaRef = _props.textareaRef,
        label = _props.label,
        onBlur = _props.onBlur,
        onChange = _props.onChange,
        onClick = _props.onClick,
        onFocus = _props.onFocus,
        onInput = _props.onInput,
        onInvalid = _props.onInvalid,
        onKeyDown = _props.onKeyDown,
        onKeyPress = _props.onKeyPress,
        onKeyUp = _props.onKeyUp,
        onSelect = _props.onSelect,
        onSubmit = _props.onSubmit,
        maxLength = _props.maxLength,
        name = _props.name,
        placeholder = _props.placeholder,
        required = _props.required,
        role = _props.role,
        value = _props.value,
        defaultValue = _props.defaultValue,
        wrap = _props.wrap;
    var assistiveText = typeof this.props.assistiveText === 'string' ? this.props.assistiveText : _objectSpread({}, this.props.assistiveText).label;
    var labelText = label || assistiveText; // One of these is required to pass accessibility tests

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('slds-form-element', {
        'slds-has-error': errorText
      }, classNameContainer)
    }, labelText && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('slds-form-element__label', {
        'slds-assistive-text': assistiveText && !label
      }),
      htmlFor: this.getId()
    }, required && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("abbr", {
      className: "slds-required",
      title: "required"
    }, "*"), labelText), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('slds-form-element__control')
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("textarea", {
      "aria-activedescendant": this.props['aria-activedescendant'],
      "aria-controls": this.props['aria-controls'],
      "aria-labelledby": this.props['aria-labelledby'],
      "aria-describedby": this.getErrorId(),
      "aria-expanded": this.props['aria-expanded'],
      "aria-owns": this.props['aria-owns'],
      "aria-required": this.props['aria-required'],
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('slds-textarea', className),
      autoFocus: autoFocus,
      disabled: disabled,
      id: this.getId(),
      maxLength: maxLength,
      name: name,
      onBlur: onBlur,
      onChange: onChange,
      onClick: onClick,
      onFocus: onFocus,
      onInput: onInput,
      onInvalid: onInvalid,
      onKeyDown: onKeyDown,
      onKeyPress: onKeyPress,
      onKeyUp: onKeyUp,
      onSelect: onSelect,
      onSubmit: onSubmit,
      placeholder: placeholder,
      ref: textareaRef,
      role: role,
      required: required,
      wrap: wrap,
      value: value,
      defaultValue: defaultValue
    })), errorText && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      id: this.getErrorId(),
      className: "slds-form-element__help"
    }, errorText), children);
  }
});
/* harmony default export */ __webpack_exports__["a"] = (Textarea);
//# sourceMappingURL=index.js.map

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isdate__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isdate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isdate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__check_props__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__icon_input_icon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__menu_dropdown__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__private_dropdown_trigger__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utilities_constants__ = __webpack_require__(2);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// # Timepicker Component
// ## Dependencies
// ### React


 // ### isDate

 // This component's `checkProps` which issues warnings to developers about properties when in development mode (similar to React's built in development tools)

 // ### Dropdown



 // ## Constants


/**
 *  Component description.
 */

var Timepicker = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  // ### Display Name
  // Always use the canonical component name as the React display name.
  displayName: __WEBPACK_IMPORTED_MODULE_8__utilities_constants__["_28" /* TIME_PICKER */],
  // ### Prop Types
  propTypes: {
    /**
     * If true, constrains the menu to the scroll parent. See `Dropdown`.
     */
    constrainToScrollParent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * Disables the input and prevents editing the contents.
     */
    disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * Time formatting function
     */
    formatter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Sets the dialog width to the width of the target. Menus attached to `input` typically follow this UX pattern.
     */
    inheritTargetWidth: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * This label appears above the input.
     */
    label: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * Custom element that overrides the default Menu Item component.
     */
    listItemRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Please select one of the following:
     * * `absolute` - (default) The dialog will use `position: absolute` and style attributes to position itself. This allows inverted placement or flipping of the dialog.
     * * `overflowBoundaryElement` - The dialog will overflow scrolling parents. Use on elements that are aligned to the left or right of their target and don't care about the target being within a scrolling parent. Typically this is a popover or tooltip. Dropdown menus can usually open up and down if no room exists. In order to achieve this a portal element will be created and attached to `body`. This element will render into that detached render tree.
     * * `relative` - No styling or portals will be used. Menus will be positioned relative to their triggers. This is a great choice for HTML snapshot testing.
     */
    menuPosition: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['absolute', 'overflowBoundaryElement', 'relative']),

    /**
     * Receives the props `(dateValue, stringValue)`
     */
    onDateChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Parsing date string into Date
     */
    parser: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Text that will appear in an empty input.
     */
    placeholder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * If true, adds asterisk next to input label to indicate it is a required field.
     */
    required: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * Frequency of options
     */
    stepInMinutes: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,

    /**
     * Value for input that is parsed to create an internal state in the `date` format.
     */
    strValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * Instance an internal state in the `date` format.
     */
    value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(Date)
  },
  getDefaultProps: function getDefaultProps() {
    return {
      formatter: function formatter(date) {
        if (date) {
          return date.toLocaleTimeString(navigator.language, {
            hour: '2-digit',
            minute: '2-digit'
          });
        }

        return null;
      },
      parser: function parser(timeStr) {
        var date = new Date();
        var dateStr = date.toLocaleString(navigator.language, {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric'
        });
        return new Date("".concat(dateStr, " ").concat(timeStr));
      },
      menuPosition: 'absolute',
      placeholder: 'Pick Time',
      value: null,
      stepInMinutes: 30
    };
  },
  getInitialState: function getInitialState() {
    return {
      value: this.props.value,
      strValue: this.props.strValue,
      options: this.getOptions()
    };
  },
  componentWillMount: function componentWillMount() {
    // `checkProps` issues warnings to developers about properties (similar to React's built in development tools)
    Object(__WEBPACK_IMPORTED_MODULE_4__check_props__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_8__utilities_constants__["_28" /* TIME_PICKER */], this.props);
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (nextProps.value && this.props.value) {
      var currentTime = this.props.value.getTime();
      var nextTime = nextProps.value.getTime();

      if (currentTime !== nextTime) {
        this.setState({
          value: nextProps.value,
          strValue: this.props.formatter(nextProps.value)
        });
      }
    }
  },
  getOptions: function getOptions() {
    var baseDate = new Date();
    var options = [];
    baseDate.setHours(0);
    baseDate.setMinutes(0);
    baseDate.setSeconds(0);
    baseDate.setMilliseconds(0);
    var curDate = new Date(baseDate);

    while (baseDate.getDate() === curDate.getDate()) {
      var formatted = this.props.formatter(curDate);
      options.push({
        label: formatted,
        value: new Date(curDate)
      });
      curDate.setMinutes(curDate.getMinutes() + this.props.stepInMinutes);
    }

    return options;
  },
  parseDate: function parseDate(strValue) {
    var newDate = this.props.parser(strValue);

    if (__WEBPACK_IMPORTED_MODULE_3_lodash_isdate___default()(newDate)) {
      if (!isNaN(newDate.getTime())) {
        return newDate;
      }
    }

    return new Date();
  },
  handleChange: function handleChange(date, strValue) {
    this.setState({
      value: date,
      strValue: strValue
    });

    if (this.props.onDateChange) {
      this.props.onDateChange(date, strValue);
    }
  },
  handleSelect: function handleSelect(val) {
    if (val && val.value) {
      this.handleChange(val.value, val.label);
    }
  },
  handleInputChange: function handleInputChange(event) {
    var strValue = event.target.value;
    this.setState({
      strValue: strValue
    });

    if (this.props.onDateChange) {
      var parsedDate = this.props.parser(strValue);
      this.props.onDateChange(parsedDate, strValue);
    }
  },
  // ### Render
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__menu_dropdown__["a" /* default */], {
      checkmark: false,
      constrainToScrollParent: this.props.constrainToScrollParent,
      disabled: this.props.disabled,
      inheritTargetWidth: this.props.inheritTargetWidth,
      label: this.props.label,
      listItemRenderer: this.props.listItemRenderer // inline style override
      ,
      menuStyle: {
        maxHeight: '20em',
        overflowX: 'hidden',
        minWidth: '100%'
      },
      menuPosition: this.props.menuPosition,
      onSelect: this.handleSelect,
      options: this.state.options
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__private_dropdown_trigger__["a" /* default */], {
      iconRight: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__icon_input_icon__["a" /* default */], {
        category: "utility",
        name: "clock"
      }),
      onChange: this.handleInputChange,
      placeholder: this.props.placeholder,
      required: this.props.required,
      type: "text",
      value: this.state.strValue
    }));
  }
});
/* unused harmony default export */ var _unused_webpack_default_export = (Timepicker);
//# sourceMappingURL=index.js.map

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shortid__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shortid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_shortid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isfunction__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isfunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isfunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isnumber__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isnumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_isnumber__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__private_tabs_list__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__private_tab__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__private_tab_panel__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utilities_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utilities_key_code__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utilities_event__ = __webpack_require__(7);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// # Tabs Component
// Implements the [Tabs design pattern](https://www.lightningdesignsystem.com/components/tabs/) in React.
// ## Dependencies
// ### React

 // ### shortid
// `shortid` is a short, non-sequential, url-friendly, unique id generator. It is used here to provide unique strings for the HTML attribute `id` on the Tabs components. It is only used if the `id` prop is not provided on the man <Tabs /> component.

 // ### classNames

 // ### isFunction

 // ### isNumber

 // Child components



 // ## Constants

 // ### Event Helpers


 // Determine if a node from event.target is a Tab element

function isTabNode(node) {
  return node.nodeName === 'A' && node.getAttribute('role') === 'tab' || node.nodeName === 'LI' && node.getAttribute('role') === 'tab';
} // Determine if a tab node is disabled


function isTabDisabled(node) {
  if (node.getAttribute) {
    return node.getAttribute('aria-disabled') === 'true';
  }

  return !!node.props.disabled;
}
/**
 * Tabs keeps related content in a single container that is shown and hidden through navigation.
 */


var displayName = __WEBPACK_IMPORTED_MODULE_9__utilities_constants__["_23" /* TABS */];
var propTypes = {
  /**
   * HTML `id` attribute of primary element that has `.slds-tabs--default` on it. Optional: If one is not supplied, a `shortid` will be created.
   */
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * The `children` are the actual tabs and panels to be displayed.
   *
   * Note that the structure of the `<Tabs />` component **does not** correspond to the DOM structure that is rendered. The `<Tabs />` component requires one or more children of type `<TabsPanel />`, which themselves require a `label` property which will be what shows in the `<Tab />` and has `children`, which end up being the _contents of the tab's corresponding panel_.
   *
   * The component iterates through each `<TabsPanel />` and rendering one `<Tab />` and one `<TabPanel />` for each of them. The tab(s) end up being children of the `<TabsList />`.
   *
   * ```
   * <Tabs>
   * 	<TabsPanel label="Tab 1">
   * 		<div>
   * 			<h2 className="slds-text-heading--medium">This is my tab 1 contents!</h2>
   * 			<p>They show when you click the first tab.</p>
   * 		</div>
   * 	</TabsPanel>
   * 	<TabsPanel label="Tab 2">
   * 		<div>
   * 			<h2 className="slds-text-heading--medium">This is my tab 2 contents!</h2>
   * 			<p>They show when you click the second tab.</p>
   * 		</div>
   * 	</TabsPanel>
   * </Tabs>
   * ```
   */
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element]).isRequired,

  /**
   * Class names to be added to the container element and is passed along to its children.
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * The Tab (and corresponding TabPanel) that is selected when the component first renders. Defaults to `0`.
   */
  defaultSelectedIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * This function triggers when a tab is selected.
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * If the Tabs should be scopped, defaults to false
   */
  variant: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['default', 'scoped']),

  /**
   * The Tab (and corresponding TabPanel) that is currently selected.
   */
  selectedIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};
var defaultProps = {
  defaultSelectedIndex: 0,
  variant: 'default'
};
/**
 * A tab keeps related content in a single container that is shown and hidden through navigation.
 */

var Tabs =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Tabs, _React$Component);

  function Tabs(props) {
    var _this;

    _classCallCheck(this, Tabs);

    _this = _possibleConstructorReturn(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call(this, props));
    Object.defineProperty(_assertThisInitialized(_this), "handleClick", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(e) {
        var node = e.target;
        /* eslint-disable no-cond-assign */

        do {
          if (_this.isTabFromContainer(node)) {
            if (isTabDisabled(node)) {
              return;
            }

            var index = [].slice.call(node.parentNode.children).indexOf(node);

            _this.setSelected(index);

            return;
          }
        } while ((node = node.parentNode) !== null);
        /* eslint-enable no-cond-assign */

      }
    });
    Object.defineProperty(_assertThisInitialized(_this), "handleKeyDown", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(event) {
        if (_this.isTabFromContainer(event.target)) {
          var index = _this.getSelectedIndex();

          var preventDefault = false;

          if (event.keyCode === __WEBPACK_IMPORTED_MODULE_10__utilities_key_code__["a" /* default */].LEFT || event.keyCode === __WEBPACK_IMPORTED_MODULE_10__utilities_key_code__["a" /* default */].UP) {
            // Select next tab to the left
            index = _this.getPrevTab(index);
            preventDefault = true;
          } else if (event.keyCode === __WEBPACK_IMPORTED_MODULE_10__utilities_key_code__["a" /* default */].RIGHT || event.keyCode === __WEBPACK_IMPORTED_MODULE_10__utilities_key_code__["a" /* default */].DOWN) {
            // Select next tab to the right
            index = _this.getNextTab(index);
            preventDefault = true;
          } // Prevent any dumn scrollbars from moving around as we type.


          if (preventDefault) {
            __WEBPACK_IMPORTED_MODULE_11__utilities_event__["a" /* default */].trap(event);
          }

          _this.setSelected(index, true);
        }
      }
    });
    _this.tabs = [];
    return _this;
  }

  _createClass(Tabs, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      // If no `id` is supplied in the props we generate one. An HTML ID is _required_ for several elements in a tabs component in order to leverage ARIA attributes for accessibility.
      this.generatedId = __WEBPACK_IMPORTED_MODULE_2_shortid___default.a.generate();
      this.flavor = this.getVariant();
      this.setState({
        selectedIndex: this.props.defaultSelectedIndex
      });
    }
  }, {
    key: "getNextTab",
    value: function getNextTab(index) {
      var count = this.getTabsCount(); // Look for non-disabled tab from index to the last tab on the right
      // eslint-disable-next-line no-plusplus

      for (var i = index + 1; i < count; i++) {
        var tab = this.getTab(i);

        if (!isTabDisabled(tab)) {
          return i;
        }
      } // If no tab found, continue searching from first on left to index
      // eslint-disable-next-line no-plusplus


      for (var _i = 0; _i < index; _i++) {
        var _tab = this.getTab(_i);

        if (!isTabDisabled(_tab)) {
          return _i;
        }
      } // No tabs are disabled, return index


      return index;
    }
  }, {
    key: "getPanelsCount",
    value: function getPanelsCount() {
      return this.props.children ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.count(this.props.children) : 0;
    }
  }, {
    key: "getPrevTab",
    value: function getPrevTab(index) {
      var i = index; // Look for non-disabled tab from index to first tab on the left
      // eslint-disable-next-line no-plusplus

      while (i--) {
        var tab = this.getTab(i);

        if (!isTabDisabled(tab)) {
          return i;
        }
      } // If no tab found, continue searching from last tab on right to index


      i = this.getTabsCount(); // eslint-disable-next-line no-plusplus

      while (i-- > index) {
        var _tab2 = this.getTab(i);

        if (!isTabDisabled(_tab2)) {
          return i;
        }
      } // No tabs are disabled, return index


      return index;
    }
  }, {
    key: "getSelectedIndex",
    value: function getSelectedIndex() {
      return __WEBPACK_IMPORTED_MODULE_5_lodash_isnumber___default()(this.props.selectedIndex) ? this.props.selectedIndex : this.state.selectedIndex;
    }
  }, {
    key: "getTab",
    value: function getTab(index) {
      return this.tabs[index].tab;
    }
  }, {
    key: "getTabNode",
    value: function getTabNode(index) {
      return this.tabs[index].node;
    }
  }, {
    key: "getTabsCount",
    value: function getTabsCount() {
      return this.props.children ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.count(this.props.children) : 0;
    }
  }, {
    key: "getVariant",
    value: function getVariant() {
      return this.props.variant === 'scoped' ? 'scoped' : 'default';
    }
  }, {
    key: "setSelected",
    value: function setSelected(index, focus) {
      // Check index boundary
      if (index < 0 || index >= this.getTabsCount()) {
        return;
      } // Keep reference to last index for event handler


      var last = this.getSelectedIndex();
      /**
       * This is a temporary solution that could be broken in the future without notification,
       * since this component is not a controlled component and only relies on internal state.
       * If this breaks in the future an alternative way to control the state from outside the
       * component should be present.
       * */

      var shouldContinue; // Call change event handler

      if (__WEBPACK_IMPORTED_MODULE_4_lodash_isfunction___default()(this.props.onSelect)) {
        shouldContinue = this.props.onSelect(index, last);
      } // Don't update the state if nothing has changed


      if (shouldContinue !== false && index !== this.state.selectedIndex) {
        this.setState({
          selectedIndex: index,
          focus: focus === true
        });
      }
    }
  }, {
    key: "isTabFromContainer",

    /**
     * Determine if a node from event.target is a Tab element for the current Tabs container.
     * If the clicked element is not a Tab, it returns false.
     * If it finds another Tabs container between the Tab and `this`, it returns false.
     */
    value: function isTabFromContainer(node) {
      // Return immediately if the clicked element is not a Tab. This prevents tab panel content from selecting a tab.
      if (!isTabNode(node)) {
        return false;
      } // Check if the first occurrence of a Tabs container is `this` one.


      var nodeAncestor = node.parentElement;

      do {
        if (nodeAncestor === this.tabsNode) return true;else if (nodeAncestor.getAttribute('data-tabs')) break;
        nodeAncestor = nodeAncestor.parentElement;
      } while (nodeAncestor);

      return false;
    }
  }, {
    key: "renderTabPanels",
    value: function renderTabPanels(parentId) {
      var _this2 = this;

      var children = __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.toArray(this.props.children);
      var selectedIndex = this.getSelectedIndex();
      var result = null;
      result = children.map(function (child, index) {
        var tabId = "".concat(parentId, "-slds-tabs--tab-").concat(index);
        var id = "".concat(parentId, "-slds-tabs--panel-").concat(index);
        var selected = selectedIndex === index;

        var variant = _this2.getVariant();

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__private_tab_panel__["a" /* default */], {
          key: child.key,
          selected: selected,
          id: id,
          tabId: tabId,
          variant: variant
        }, children[index]);
      });
      return result;
    }
  }, {
    key: "renderTabsList",
    value: function renderTabsList(parentId) {
      var _this3 = this;

      var children = __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.toArray(this.props.children);
      return (// `parentId` gets consumed by TabsList, adding a suffix of `-tabs__nav`
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__private_tabs_list__["a" /* default */], {
          id: parentId,
          variant: this.getVariant()
        }, children.map(function (child, index) {
          var id = "".concat(parentId, "-slds-tabs--tab-").concat(index);
          var panelId = "".concat(parentId, "-slds-tabs--panel-").concat(index);
          var selected = _this3.getSelectedIndex() === index;
          var focus = selected && _this3.state.focus;

          var variant = _this3.getVariant();

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__private_tab__["a" /* default */], {
            key: child.key,
            ref: function ref(node) {
              _this3.tabs[index] = {
                tab: child,
                node: node
              };
            },
            focus: focus,
            selected: selected,
            id: id,
            panelId: panelId,
            disabled: child.props.disabled,
            variant: variant
          }, child.props.label);
        }))
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          className = _props.className,
          _props$id = _props.id,
          id = _props$id === void 0 ? this.generatedId : _props$id,
          _props$variant = _props.variant,
          variant = _props$variant === void 0 ? this.getVariant : _props$variant;

      if (this.state.focus) {
        setTimeout(function () {
          _this4.setState({
            focus: false
          });
        }, 0);
      }

      return (
        /* eslint-disable jsx-a11y/no-static-element-interactions */
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          id: id,
          className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()({
            'slds-tabs--default': variant === 'default',
            'slds-tabs--scoped': variant === 'scoped'
          }, className),
          onClick: this.handleClick,
          onKeyDown: this.handleKeyDown,
          "data-tabs": true,
          ref: function ref(node) {
            _this4.tabsNode = node;
          }
        }, this.renderTabsList(id), this.renderTabPanels(id))
      );
    }
  }]);

  return Tabs;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Tabs.displayName = displayName;
Tabs.propTypes = propTypes;
Tabs.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Tabs);
//# sourceMappingURL=index.js.map

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_constants__ = __webpack_require__(2);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */



/**
 * The `<TabsPanel />` component allows us to simplify the structure of the `<Tabs />` component.

 * Rather than require different (deeply nested) children for tabslist, with its tab(s) as well as tabpanel(s), we provide this `TabsPanel` component which takes a `label` property that will become what is shown on the `<Tab />` that will be associated with it.

 * The `children` of the Panel will be fed to the `<TabPanel />` component, while its `label` is handled in `<Tab />`, via `<TabsList />`.
 *
 * ```
 * <TabsPanel label="Tab 1">
 * 	<div>
 * 		<h2 className="slds-text-heading--medium">This is my tab 1 contents!</h2>
 * 		<p>They show when you click the first tab.</p>
 * 	</div>
 * </TabsPanel>
 * ```
 */

var Panel = function Panel(_ref) {
  var children = _ref.children;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.toArray(children));
};

Panel.displayName = __WEBPACK_IMPORTED_MODULE_2__utilities_constants__["_25" /* TABS_PANEL */];
Panel.propTypes = {
  /**
   * The string or element that is handed off to the `<Tab />` component, ends up being the title and the label for the tab associated with its tab panel.
   */
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element]).isRequired,

  /**
   * The `children` are the actual tab panels to be rendered. They get created by [tabs/index.jsx](./index.jsx) in the `renderTabPanels` function.
   *
   * Note that the `<TabsPanel />` component inserts a `div` element around the children, because React requires exactly one "parent" element returned. The `<TabPanel />` component simply dips down into `children` to get the children of this wrapping `div` so that it does not get rendered in the DOM.
   */
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element]).isRequired
};
/* unused harmony default export */ var _unused_webpack_default_export = (Panel);
//# sourceMappingURL=panel.js.map

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_assign__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_class_names__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__icon__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__check_props__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utilities_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utilities_dom_element_focus__ = __webpack_require__(48);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// # Toast Component
// Implements the [Toast design pattern](https://lightningdesignsystem.com/components/toasts/) in React.









var propTypes = {
  /**
   * **Assistive text for accessibility**
   * This object is merged with the default props object on every render.
   * * `closeButton`: This is a visually hidden label for the close button.
   * _Tested with snapshot testing._
   */
  assistiveText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    closeButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node])
  }),

  /**
   * CSS classes to be added to tag with `.slds-notify_toast`. Uses `classNames` [API](https://github.com/JedWatson/classnames).
   * _Tested with snapshot testing._
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * If duration exists, the Toast will disappear after that amount of time. Time in milliseconds. _Tested with Mocha testing._
   */
  duration: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * **Text labels for internationalization**
   * This object is merged with the default props object on every render.
   * * `details`: Secondary text below heading
   * * `heading`: text within heading tag
   * * `headingLink`: Text of link that triggers `onClickHeadingLink`. Inline links should pass a keyed array of React components into `labels.heading`.
   *
   * _Tested with snapshot testing._
   */
  labels: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    details: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]),
    heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]),
    headingLink: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node])
  }),

  /**
   * Triggered by link. _Tested with Mocha testing._
   */
  onClickHeadingLink: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Icon of type `~/components/icon`. This icon will be cloned and additional props appended. The default icons are:
   * * info variant: `utility:info`
   * * error variant: `utility:error`
   * * success variant: `utility:success`
   * * warning variant: `utility:warning`
   *
   * _Tested with snapshot testing._
   */
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * Triggered by close button. _Tested with Mocha testing._
   */
  onRequestClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * The type of Toast. _Tested with snapshot testing._
   */
  variant: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['error', 'info', 'success', 'warning']).isRequired
};
var defaultProps = {
  assistiveText: {
    closeButton: 'Close'
  },
  variant: 'info'
};
/**
 * Toast serves as a feedback & confirmation mechanism after the user takes an action. View [banner guidelines](https://www.lightningdesignsystem.com/guidelines/messaging/components/banners/).
 */

var Toast =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Toast, _React$Component);

  function Toast(props) {
    var _this;

    _classCallCheck(this, Toast);

    _this = _possibleConstructorReturn(this, (Toast.__proto__ || Object.getPrototypeOf(Toast)).call(this, props));
    Object.defineProperty(_assertThisInitialized(_this), "onClose", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        if (_this.timeout) {
          clearTimeout(_this.timeout);
          _this.timeout = null;
        }

        if (_this.props.onRequestClose) {
          _this.props.onRequestClose();
        }
      }
    });
    Object.defineProperty(_assertThisInitialized(_this), "saveButtonRef", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(component) {
        _this.closeButton = component;

        if (_this.state.isInitialRender) {
          __WEBPACK_IMPORTED_MODULE_8__utilities_dom_element_focus__["a" /* default */].storeActiveElement();

          if (_this.closeButton) {
            _this.closeButton.focus();
          }

          _this.setState({
            isInitialRender: false
          });
        }
      }
    });
    _this.state = {
      isInitialRender: true
    };
    _this.timeout = null;
    return _this;
  }

  _createClass(Toast, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      // `checkProps` issues warnings to developers about properties (similar to React's built in development tools)
      Object(__WEBPACK_IMPORTED_MODULE_6__check_props__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_7__utilities_constants__["_29" /* TOAST */], this.props);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.duration) {
        this.timeout = setTimeout(function () {
          _this2.onClose();
        }, this.props.duration);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      __WEBPACK_IMPORTED_MODULE_8__utilities_dom_element_focus__["a" /* default */].returnFocusToStoredElement();
    }
  }, {
    key: "render",
    value: function render() {
      // Merge objects of strings with their default object
      var assistiveText = __WEBPACK_IMPORTED_MODULE_2_lodash_assign___default()({}, defaultProps.assistiveText, this.props.assistiveText);
      var labels = __WEBPACK_IMPORTED_MODULE_2_lodash_assign___default()({}, defaultProps.labels, this.props.labels);
      var heading = labels.heading || this.props.content; // eslint-disable-line react/prop-types

      var assistiveTextVariant = {
        info: 'info',
        success: 'success',
        warning: 'warning',
        error: 'error'
      };
      var defaultIcons = {
        info: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__icon__["a" /* default */], {
          category: "utility",
          name: "info"
        }),
        success: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__icon__["a" /* default */], {
          category: "utility",
          name: "success"
        }),
        warning: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__icon__["a" /* default */], {
          category: "utility",
          name: "warning"
        }),
        error: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__icon__["a" /* default */], {
          category: "utility",
          name: "error"
        })
      };
      var icon = this.props.icon ? this.props.icon : defaultIcons[this.props.variant];
      var clonedIcon = __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(icon, {
        containerClassName: 'slds-m-right_small slds-no-flex slds-align-top',
        inverse: true,
        size: 'small'
      });
      /* eslint-disable no-script-url */

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: Object(__WEBPACK_IMPORTED_MODULE_3__utilities_class_names__["a" /* default */])('slds-notify slds-notify_toast', {
          'slds-theme_info': this.props.variant === 'info',
          'slds-theme_success': this.props.variant === 'success',
          'slds-theme_warning': this.props.variant === 'warning',
          'slds-theme_error': this.props.variant === 'error'
        }, this.props.className),
        role: "alert"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "slds-assistive-text"
      }, assistiveTextVariant[this.props.variant]), clonedIcon, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "slds-notify__content"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", {
        className: "slds-text-heading_small"
      }, heading, ' ', labels.headingLink ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
        onClick: this.props.onClickHeadingLink,
        href: "javascript:void(0);"
      }, labels.headingLink) : null), labels.details ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, labels.details) : null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__button__["a" /* default */], {
        assistiveText: {
          icon: assistiveText.closeButton
        },
        buttonRef: this.saveButtonRef,
        className: "slds-notify__close",
        iconCategory: "utility",
        iconName: "close",
        iconSize: "large",
        inverse: true,
        onClick: this.props.onRequestClose,
        title: assistiveText.closeButton,
        variant: "icon"
      }));
    }
  }]);

  return Toast;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Toast.defaultProps = defaultProps;
Toast.displayName = __WEBPACK_IMPORTED_MODULE_7__utilities_constants__["_29" /* TOAST */];
Toast.propTypes = propTypes;
/* unused harmony default export */ var _unused_webpack_default_export = (Toast);
//# sourceMappingURL=index.js.map

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_class_names__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_constants__ = __webpack_require__(2);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// # Toast Container Component




var propTypes = {
  /**
   * CSS classes to be added to tag with `.slds-notify-container`. Uses `classNames` [API](https://github.com/JedWatson/classnames).
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * Toast components
   */
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};
/**
 * A fixed container for toast banners.
 */

var ToastContainer =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ToastContainer, _React$Component);

  function ToastContainer() {
    _classCallCheck(this, ToastContainer);

    return _possibleConstructorReturn(this, (ToastContainer.__proto__ || Object.getPrototypeOf(ToastContainer)).apply(this, arguments));
  }

  _createClass(ToastContainer, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: Object(__WEBPACK_IMPORTED_MODULE_2__utilities_class_names__["a" /* default */])('slds-notify-container', this.props.className)
      }, this.props.children);
    }
  }]);

  return ToastContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ToastContainer.displayName = __WEBPACK_IMPORTED_MODULE_3__utilities_constants__["_30" /* TOAST_CONTAINER */];
ToastContainer.propTypes = propTypes;
/* unused harmony default export */ var _unused_webpack_default_export = (ToastContainer);
//# sourceMappingURL=container.js.map

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_find__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__private_branch__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__check_props__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_constants__ = __webpack_require__(2);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */



 // Child components

 // Similar to React's PropTypes check. When in development mode, it issues errors in the console about properties.

 // ## Constants

 // ### Prop Types

var propTypes = {
  /**
   * **Assistive text for accessibility.**
   * This object is merged with the default props object on every render.
   * * `label`: For users of assistive technology, if set the heading will be hidden. One of `heading` or `assistiveText.label` must be set in order to label the tree.
   */
  assistiveText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),

  /**
   * Class names to be added to the container element which has the heading and the `ul.slds-tree` element as children.
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * Class names to be added to the top-level `ul` element of the tree.
   */
  listClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * A function that will be called by every branch to receive its child nodes. The parent `node` object with the branch data is passed into this function: `getNodes(node)`. If your state engine is Flux or Redux, then your tree data structure will probably be flattened or normalized within the store. This will allow you to build out your tree without transversing an actual tree of data and may be more performant.
   */
  getNodes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * This is the tree's heading and describes its contents. It can be hidden, see `assistiveText`.
   * */
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * HTML `id` of primary element that has `.slds-tree` on it. This component has a wrapping container element outside of `.slds-tree`.
   */
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,

  /**
   * Array of items starting at the top of the tree. The shape each node in the array is:
   * ```
   * {
   *   expanded: string,
   *   id: string,
   *   label: string or node,
   *   selected: string,
   *   type: string,
   *   nodes: array
   * }
   * ```
   * `assistiveText: string` is optional and helpful if the label is not a string. Only `id` and `label` are required. Use `type: 'branch'` for folder and categories.
   */
  nodes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired,
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired,
    type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  })])).isRequired,

  /**
   * Function that will run whenever an item or branch is selected due to click or keyboard navigation.
   */
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,

  /**
   * This function triggers when the expand or collapse icon is clicked or due to keyboard navigation.
   */
  onExpandClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,

  /**
   * This function triggers when the top-level `ul` element scrolls. This can be used to implement an "infinite scroll" pattern and update the `nodes` prop accordingly.
   */
  onScroll: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Highlights term if found in node label. This does not auto-expand branches.
   */
  searchTerm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Styles to be added to the top-level `ul` element. Useful for `overflow:hidden`.
   */
  listStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
var defaultProps = {
  assistiveText: {},
  getNodes: function getNodes(node) {
    return node.nodes;
  }
};
/**
 * A tree is visualization of a structure hierarchy. A branch can be expanded or collapsed. This is a controlled component, since visual state is present in the `nodes` data.
 */

var Tree =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Tree, _React$Component);

  function Tree(props) {
    var _this;

    _classCallCheck(this, Tree);

    _this = _possibleConstructorReturn(this, (Tree.__proto__ || Object.getPrototypeOf(Tree)).call(this, props)); // Find the first selected node and initialize it properly so that can be tabbed to. If no node is selected, it will be selected upon first focus.

    _initialiseProps.call(_assertThisInitialized(_this));

    var flattenedNodes = _this.flattenTree({
      nodes: _this.props.getNodes({
        nodes: _this.props.nodes
      }),
      expanded: true
    }).slice(1);

    var selectedNode = __WEBPACK_IMPORTED_MODULE_3_lodash_find___default()(flattenedNodes, function (curNode) {
      return curNode.node.selected;
    });
    var selectedNodeIndexes = [];
    var focusedNodeIndex;

    if (selectedNode) {
      selectedNodeIndexes.push(selectedNode.treeIndex);
      focusedNodeIndex = selectedNode.treeIndex;
    }

    _this.state = {
      flattenedNodes: flattenedNodes,
      selectedNodeIndexes: selectedNodeIndexes,
      focusedNodeIndex: focusedNodeIndex
    };
    return _this;
  }

  _createClass(Tree, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      Object(__WEBPACK_IMPORTED_MODULE_5__check_props__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_6__utilities_constants__["_31" /* TREE */], this.props);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        flattenedNodes: this.flattenTree({
          nodes: this.props.getNodes({
            nodes: nextProps.nodes
          }),
          expanded: true
        }).slice(1)
      });
    }
    /* Flattens hierarchical tree structure into a flat array. The
     * first item in the array is the whole tree and therefore should be
     * removed with `slice(1)`.` This means that root cannot call `getNodes()`
     * and should directly reference the `nodes` key. All level after that
     * should use `getNodes()` to access the correct nodes.
    */

  }, {
    key: "render",
    value: function render() {
      // One of these is required to pass accessibility tests
      var assistiveText = typeof this.props.assistiveText === 'string' ? this.props.assistiveText : _objectSpread({}, defaultProps.assistiveText, this.props.assistiveText).label;
      var headingText = assistiveText || this.props.heading; // Start the zero level branch--that is the tree root. There is no label for
      // the tree root, but is required by all other nodes

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        id: this.props.id,
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('slds-tree_container', this.props.className)
        /* role="application" */

      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('slds-text-title--caps', {
          'slds-assistive-text': assistiveText
        }),
        id: "".concat(this.props.id, "__heading")
      }, headingText), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__private_branch__["a" /* default */], {
        getNodes: this.props.getNodes,
        initalClassName: this.props.listClassName,
        htmlId: this.props.id,
        initialStyle: this.props.listStyle,
        level: 0,
        node: {
          nodes: this.props.nodes
        },
        flattenedNodes: this.state.flattenedNodes,
        selectedNodeIndexes: this.state.selectedNodeIndexes,
        focusedNodeIndex: this.state.focusedNodeIndex,
        treeHasFocus: this.treeHasFocus,
        onNodeBlur: this.handleNodeBlur,
        onSelect: this.handleSelect,
        onExpand: this.handleExpand,
        onScroll: this.props.onScroll,
        searchTerm: this.props.searchTerm,
        treeId: this.props.id
      }));
    }
  }]);

  return Tree;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  Object.defineProperty(this, "flattenTree", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(root) {
      var treeIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var firstLevel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      if (!root.nodes) {
        return [{
          node: root,
          treeIndex: treeIndex
        }];
      }

      var nodes = [{
        node: root,
        treeIndex: treeIndex
      }];

      if (root.expanded) {
        for (var index = 0; index < root.nodes.length; index++) {
          var curNode = firstLevel ? root.nodes[index] : _this2.props.getNodes(root)[index];
          nodes = nodes.concat(_this2.flattenTree(curNode, treeIndex ? "".concat(treeIndex, "-").concat(index) : "".concat(index), false));
        }
      }

      return nodes;
    }
  });
  Object.defineProperty(this, "handleSelect", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(_ref) {
      var event = _ref.event,
          data = _ref.data,
          clearSelectedNodes = _ref.clearSelectedNodes,
          fromFocus = _ref.fromFocus;

      // When triggered by a key event, other nodes should be deselected.
      if (clearSelectedNodes) {
        _this2.state.flattenedNodes.forEach(function (flattenedNode) {
          if (flattenedNode.node.selected) {
            flattenedNode.node.selected = false;
          }
        });
      } // Prevent firing twice on first click, due to the handleSelect
      // triggered by a focus event


      if (!fromFocus) {
        _this2.props.onClick(event, data);
      } // Keep track of the currently selected and focused nodes.


      var selectedNodeIndexes;

      if (data.select) {
        selectedNodeIndexes = _this2.state.selectedNodeIndexes.concat([data.treeIndex]);
      } else {
        selectedNodeIndexes = _this2.state.selectedNodeIndexes.filter(function (treeIndex) {
          return treeIndex !== data.treeIndex;
        });
      }

      _this2.treeHasFocus = true;

      _this2.setState({
        focusedNodeIndex: data.treeIndex,
        selectedNodeIndexes: selectedNodeIndexes
      });
    }
  });
  Object.defineProperty(this, "handleNodeBlur", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value() {
      // There is no need to render when blurring a node because focus is either:
      //  - outside of the tree, or
      //  - focused on another node in the tree, which triggers its own render
      _this2.treeHasFocus = false;
    }
  });
  Object.defineProperty(this, "handleExpand", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(_ref2) {
      var event = _ref2.event,
          data = _ref2.data;
      _this2.treeHasFocus = true;

      _this2.props.onExpandClick(event, data);

      if (data.select) {
        _this2.setState({
          focusedNodeIndex: data.treeIndex
        });
      }
    }
  });
};

Tree.displayName = __WEBPACK_IMPORTED_MODULE_6__utilities_constants__["_31" /* TREE */];
Tree.propTypes = propTypes;
Tree.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Tree);
//# sourceMappingURL=index.js.map

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_highlighter__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_highlighter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_highlighter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_constants__ = __webpack_require__(2);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// ### React

 // ### ReactHighlighter

 // ## Constants


/**
 * A utility component that highlights occurrences of a particular pattern in its contents.
 */

var Highlighter = function Highlighter(props) {
  if (props.search) {
    var children;

    if (typeof props.children === 'string') {
      children = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_highlighter___default.a, {
        className: props.className,
        matchClass: null,
        matchElement: "mark",
        search: props.search,
        title: props.children
      }, props.children);
    } else {
      var findString = function findString(nodeArr) {
        return nodeArr.map(function (element) {
          var newElement;

          if (typeof element === 'string') {
            newElement = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_highlighter___default.a, {
              key: element,
              className: props.className,
              matchClass: null,
              matchElement: "mark",
              search: props.search,
              title: element
            }, element);
          } else {
            newElement = element;
          }

          return newElement;
        });
      };

      if (props.children.props) {
        var node = props.children.props.children;
        children = node instanceof Array ? findString(node) : node;
      }
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, children);
  }

  if (typeof props.children === 'string') {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: props.className,
      title: props.children
    }, props.children);
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: props.className
  }, props.children);
}; // ### Display Name


Highlighter.displayName = __WEBPACK_IMPORTED_MODULE_3__utilities_constants__["M" /* HIGHLIGHTER */]; // ### Prop Types

Highlighter.propTypes = {
  /**
   * The full string to display.
   */
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * The string of text (or Regular Expression) to highlight.
   */
  search: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (Highlighter);
//# sourceMappingURL=index.js.map

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _chainFunction = __webpack_require__(301);

var _chainFunction2 = _interopRequireDefault(_chainFunction);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(12);

var _warning2 = _interopRequireDefault(_warning);

var _ChildMapping = __webpack_require__(302);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  component: _propTypes2.default.any,
  childFactory: _propTypes2.default.func,
  children: _propTypes2.default.node
};

var defaultProps = {
  component: 'span',
  childFactory: function childFactory(child) {
    return child;
  }
};

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.performAppear = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillAppear) {
        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
      } else {
        _this._handleDoneAppearing(key, component);
      }
    };

    _this._handleDoneAppearing = function (key, component) {
      if (component.componentDidAppear) {
        component.componentDidAppear();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully appeared. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performEnter = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillEnter) {
        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
      } else {
        _this._handleDoneEntering(key, component);
      }
    };

    _this._handleDoneEntering = function (key, component) {
      if (component.componentDidEnter) {
        component.componentDidEnter();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully entered. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performLeave = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillLeave) {
        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
      } else {
        // Note that this is somewhat dangerous b/c it calls setState()
        // again, effectively mutating the component before all the work
        // is done.
        _this._handleDoneLeaving(key, component);
      }
    };

    _this._handleDoneLeaving = function (key, component) {
      if (component.componentDidLeave) {
        component.componentDidLeave();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
        // This entered again before it fully left. Add it again.
        _this.keysToEnter.push(key);
      } else {
        _this.setState(function (state) {
          var newChildren = _extends({}, state.children);
          delete newChildren[key];
          return { children: newChildren };
        });
      }
    };

    _this.childRefs = Object.create(null);

    _this.state = {
      children: (0, _ChildMapping.getChildMapping)(props.children)
    };
    return _this;
  }

  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
    this.currentlyTransitioningKeys = {};
    this.keysToEnter = [];
    this.keysToLeave = [];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    var initialChildMapping = this.state.children;
    for (var key in initialChildMapping) {
      if (initialChildMapping[key]) {
        this.performAppear(key, this.childRefs[key]);
      }
    }
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
    var prevChildMapping = this.state.children;

    this.setState({
      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
    });

    for (var key in nextChildMapping) {
      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
        this.keysToEnter.push(key);
      }
    }

    for (var _key in prevChildMapping) {
      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
        this.keysToLeave.push(_key);
      }
    }

    // If we want to someday check for reordering, we could do it here.
  };

  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    var keysToEnter = this.keysToEnter;
    this.keysToEnter = [];
    keysToEnter.forEach(function (key) {
      return _this2.performEnter(key, _this2.childRefs[key]);
    });

    var keysToLeave = this.keysToLeave;
    this.keysToLeave = [];
    keysToLeave.forEach(function (key) {
      return _this2.performLeave(key, _this2.childRefs[key]);
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _this3 = this;

    // TODO: we could get rid of the need for the wrapper node
    // by cloning a single child
    var childrenToRender = [];

    var _loop = function _loop(key) {
      var child = _this3.state.children[key];
      if (child) {
        var isCallbackRef = typeof child.ref !== 'string';
        var factoryChild = _this3.props.childFactory(child);
        var ref = function ref(r) {
          _this3.childRefs[key] = r;
        };

         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;

        // Always chaining the refs leads to problems when the childFactory
        // wraps the child. The child ref callback gets called twice with the
        // wrapper and the child. So we only need to chain the ref if the
        // factoryChild is not different from child.
        if (factoryChild === child && isCallbackRef) {
          ref = (0, _chainFunction2.default)(child.ref, ref);
        }

        // You may need to apply reactive updates to a child as it is leaving.
        // The normal React way to do it won't work since the child will have
        // already been removed. In case you need this behavior you can provide
        // a childFactory function to wrap every child, even the ones that are
        // leaving.
        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
          key: key,
          ref: ref
        }));
      }
    };

    for (var key in this.state.children) {
      _loop(key);
    }

    // Do not forward TransitionGroup props to primitive DOM nodes
    var props = _extends({}, this.props);
    delete props.transitionLeave;
    delete props.transitionName;
    delete props.transitionAppear;
    delete props.transitionEnter;
    delete props.childFactory;
    delete props.transitionLeaveTimeout;
    delete props.transitionEnterTimeout;
    delete props.transitionAppearTimeout;
    delete props.component;

    return _react2.default.createElement(this.props.component, props, childrenToRender);
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.displayName = 'TransitionGroup';


TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = TransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
module.exports = exports['default'];

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.nameShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  leaveActive: _propTypes2.default.string,
  appear: _propTypes2.default.string,
  appearActive: _propTypes2.default.string
})]);

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(150);
module.exports = __webpack_require__(155);


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(151).enable();
  window.Promise = __webpack_require__(153);
}

// fetch() polyfill for making API calls.
__webpack_require__(154);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(35);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(72);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(72);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 154 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_css_utilities_css__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_css_utilities_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_css_utilities_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_css_custom_css__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_css_custom_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_css_custom_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__registerServiceWorker__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__salesforce_design_system_react__ = __webpack_require__(18);
__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__salesforce_design_system_react__["g" /* IconSettings */],{iconPath:'icons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */],null)),document.getElementById('root'));Object(__WEBPACK_IMPORTED_MODULE_5__registerServiceWorker__["a" /* default */])();

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.4.2
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var k=__webpack_require__(35),n=__webpack_require__(44),p=__webpack_require__(45),q=__webpack_require__(73),r="function"===typeof Symbol&&Symbol.for,t=r?Symbol.for("react.element"):60103,u=r?Symbol.for("react.portal"):60106,v=r?Symbol.for("react.fragment"):60107,w=r?Symbol.for("react.strict_mode"):60108,x=r?Symbol.for("react.profiler"):60114,y=r?Symbol.for("react.provider"):60109,z=r?Symbol.for("react.context"):60110,A=r?Symbol.for("react.async_mode"):60111,B=
r?Symbol.for("react.forward_ref"):60112;r&&Symbol.for("react.timeout");var C="function"===typeof Symbol&&Symbol.iterator;function D(a){for(var b=arguments.length-1,e="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)e+="&args[]="+encodeURIComponent(arguments[c+1]);n(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",e)}
var E={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function F(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||E}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?D("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function G(){}
G.prototype=F.prototype;function H(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||E}var I=H.prototype=new G;I.constructor=H;k(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,e){var c=void 0,d={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,c)&&!L.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];d.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:t,type:a,key:g,ref:h,props:d,_owner:J.current}}
function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===t}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,e,c){if(P.length){var d=P.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case t:case u:g=!0}}if(g)return e(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){d=a[h];var f=b+T(d,h);g+=S(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=C&&a[C]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),
h=0;!(d=a.next()).done;)d=d.value,f=b+T(d,h++),g+=S(d,f,e,c);else"object"===d&&(e=""+a,D("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function U(a,b){a.func.call(a.context,b,a.count++)}
function V(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?W(a,c,e,q.thatReturnsArgument):null!=a&&(N(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+e,a={$$typeof:t,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function W(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(O,"$&/")+"/");b=Q(b,g,c,d);null==a||S(a,"",V,b);R(b)}
var X={Children:{map:function(a,b,e){if(null==a)return a;var c=[];W(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=Q(null,null,b,e);null==a||S(a,"",U,b);R(b)},count:function(a){return null==a?0:S(a,"",q.thatReturnsNull,null)},toArray:function(a){var b=[];W(a,b,null,q.thatReturnsArgument);return b},only:function(a){N(a)?void 0:D("143");return a}},createRef:function(){return{current:null}},Component:F,PureComponent:H,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:z,
_calculateChangedBits:b,_defaultValue:a,_currentValue:a,_currentValue2:a,_changedBits:0,_changedBits2:0,Provider:null,Consumer:null};a.Provider={$$typeof:y,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:B,render:a}},Fragment:v,StrictMode:w,unstable_AsyncMode:A,unstable_Profiler:x,createElement:M,cloneElement:function(a,b,e){null===a||void 0===a?D("267",a):void 0;var c=void 0,d=k({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(h=b.ref,f=J.current);void 0!==
b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)K.call(b,c)&&!L.hasOwnProperty(c)&&(d[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)d.children=e;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];d.children=l}return{$$typeof:t,type:a.type,key:g,ref:h,props:d,_owner:f}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.4.2",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:J,
assign:k}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default?Z.default:Z;


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.4.2
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(44),ba=__webpack_require__(0),m=__webpack_require__(158),p=__webpack_require__(35),v=__webpack_require__(73),da=__webpack_require__(159),ea=__webpack_require__(160),fa=__webpack_require__(161),ha=__webpack_require__(45);
function A(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);aa(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}ba?void 0:A("227");
function ia(a,b,c,d,e,f,g,h,k){this._hasCaughtError=!1;this._caughtError=null;var n=Array.prototype.slice.call(arguments,3);try{b.apply(c,n)}catch(r){this._caughtError=r,this._hasCaughtError=!0}}
var B={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,invokeGuardedCallback:function(a,b,c,d,e,f,g,h,k){ia.apply(B,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,g,h,k){B.invokeGuardedCallback.apply(this,arguments);if(B.hasCaughtError()){var n=B.clearCaughtError();B._hasRethrowError||(B._hasRethrowError=!0,B._rethrowError=n)}},rethrowCaughtError:function(){return ka.apply(B,arguments)},hasCaughtError:function(){return B._hasCaughtError},clearCaughtError:function(){if(B._hasCaughtError){var a=
B._caughtError;B._caughtError=null;B._hasCaughtError=!1;return a}A("198")}};function ka(){if(B._hasRethrowError){var a=B._rethrowError;B._rethrowError=null;B._hasRethrowError=!1;throw a;}}var la=null,ma={};
function na(){if(la)for(var a in ma){var b=ma[a],c=la.indexOf(a);-1<c?void 0:A("96",a);if(!oa[c]){b.extractEvents?void 0:A("97",a);oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;pa.hasOwnProperty(h)?A("99",h):void 0;pa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&qa(k[e],g,h);e=!0}else f.registrationName?(qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:A("98",d,a)}}}}
function qa(a,b,c){ra[a]?A("100",a):void 0;ra[a]=b;sa[a]=b.eventTypes[c].dependencies}var oa=[],pa={},ra={},sa={};function ta(a){la?A("101"):void 0;la=Array.prototype.slice.call(a);na()}function ua(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];ma.hasOwnProperty(c)&&ma[c]===d||(ma[c]?A("102",c):void 0,ma[c]=d,b=!0)}b&&na()}
var va={plugins:oa,eventNameDispatchConfigs:pa,registrationNameModules:ra,registrationNameDependencies:sa,possibleRegistrationNames:null,injectEventPluginOrder:ta,injectEventPluginsByName:ua},wa=null,xa=null,ya=null;function za(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=ya(d);B.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
function Aa(a,b){null==b?A("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function Ba(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Ca=null;
function Da(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)za(a,b,c[e],d[e]);else c&&za(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function Ea(a){return Da(a,!0)}function Fa(a){return Da(a,!1)}var Ga={injectEventPluginOrder:ta,injectEventPluginsByName:ua};
function Ha(a,b){var c=a.stateNode;if(!c)return null;var d=wa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?A("231",b,typeof c):void 0;
return c}function Ia(a,b){null!==a&&(Ca=Aa(Ca,a));a=Ca;Ca=null;a&&(b?Ba(a,Ea):Ba(a,Fa),Ca?A("95"):void 0,B.rethrowCaughtError())}function Ja(a,b,c,d){for(var e=null,f=0;f<oa.length;f++){var g=oa[f];g&&(g=g.extractEvents(a,b,c,d))&&(e=Aa(e,g))}Ia(e,!1)}var Ka={injection:Ga,getListener:Ha,runEventsInBatch:Ia,runExtractedEventsInBatch:Ja},La=Math.random().toString(36).slice(2),C="__reactInternalInstance$"+La,Ma="__reactEventHandlers$"+La;
function Na(a){if(a[C])return a[C];for(;!a[C];)if(a.parentNode)a=a.parentNode;else return null;a=a[C];return 5===a.tag||6===a.tag?a:null}function Oa(a){if(5===a.tag||6===a.tag)return a.stateNode;A("33")}function Pa(a){return a[Ma]||null}var Qa={precacheFiberNode:function(a,b){b[C]=a},getClosestInstanceFromNode:Na,getInstanceFromNode:function(a){a=a[C];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:Oa,getFiberCurrentPropsFromNode:Pa,updateFiberProps:function(a,b){a[Ma]=b}};
function F(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Ra(a,b,c){for(var d=[];a;)d.push(a),a=F(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}function Sa(a,b,c){if(b=Ha(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=Aa(c._dispatchListeners,b),c._dispatchInstances=Aa(c._dispatchInstances,a)}function Ta(a){a&&a.dispatchConfig.phasedRegistrationNames&&Ra(a._targetInst,Sa,a)}
function Ua(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?F(b):null;Ra(b,Sa,a)}}function Va(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Ha(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=Aa(c._dispatchListeners,b),c._dispatchInstances=Aa(c._dispatchInstances,a))}function Xa(a){a&&a.dispatchConfig.registrationName&&Va(a._targetInst,null,a)}function Ya(a){Ba(a,Ta)}
function Za(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,g=0,h=e;h;h=F(h))g++;h=0;for(var k=f;k;k=F(k))h++;for(;0<g-h;)e=F(e),g--;for(;0<h-g;)f=F(f),h--;for(;g--;){if(e===f||e===f.alternate)break a;e=F(e);f=F(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){g=c.alternate;if(null!==g&&g===f)break;e.push(c);c=F(c)}for(c=[];d&&d!==f;){g=d.alternate;if(null!==g&&g===f)break;c.push(d);d=F(d)}for(d=0;d<e.length;d++)Va(e[d],"bubbled",a);for(a=c.length;0<a--;)Va(c[a],"captured",b)}
var $a={accumulateTwoPhaseDispatches:Ya,accumulateTwoPhaseDispatchesSkipTarget:function(a){Ba(a,Ua)},accumulateEnterLeaveDispatches:Za,accumulateDirectDispatches:function(a){Ba(a,Xa)}};function ab(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
var bb={animationend:ab("Animation","AnimationEnd"),animationiteration:ab("Animation","AnimationIteration"),animationstart:ab("Animation","AnimationStart"),transitionend:ab("Transition","TransitionEnd")},cb={},db={};m.canUseDOM&&(db=document.createElement("div").style,"AnimationEvent"in window||(delete bb.animationend.animation,delete bb.animationiteration.animation,delete bb.animationstart.animation),"TransitionEvent"in window||delete bb.transitionend.transition);
function eb(a){if(cb[a])return cb[a];if(!bb[a])return a;var b=bb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in db)return cb[a]=b[c];return a}var fb=eb("animationend"),gb=eb("animationiteration"),hb=eb("animationstart"),ib=eb("transitionend"),jb="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),kb=null;
function lb(){!kb&&m.canUseDOM&&(kb="textContent"in document.documentElement?"textContent":"innerText");return kb}var G={_root:null,_startText:null,_fallbackText:null};function mb(){if(G._fallbackText)return G._fallbackText;var a,b=G._startText,c=b.length,d,e=nb(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);G._fallbackText=e.slice(a,1<d?1-d:void 0);return G._fallbackText}function nb(){return"value"in G._root?G._root.value:G._root[lb()]}
var ob="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),pb={type:null,target:null,currentTarget:v.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function H(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?v.thatReturnsTrue:v.thatReturnsFalse;this.isPropagationStopped=v.thatReturnsFalse;return this}
p(H.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=v.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=v.thatReturnsTrue)},persist:function(){this.isPersistent=v.thatReturnsTrue},isPersistent:v.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<ob.length;a++)this[ob[a]]=null}});H.Interface=pb;H.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;p(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=p({},d.Interface,a);c.extend=d.extend;qb(c);return c};qb(H);
function rb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function sb(a){a instanceof this?void 0:A("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function qb(a){a.eventPool=[];a.getPooled=rb;a.release=sb}var tb=H.extend({data:null}),ub=H.extend({data:null}),vb=[9,13,27,32],wb=m.canUseDOM&&"CompositionEvent"in window,xb=null;m.canUseDOM&&"documentMode"in document&&(xb=document.documentMode);
var yb=m.canUseDOM&&"TextEvent"in window&&!xb,zb=m.canUseDOM&&(!wb||xb&&8<xb&&11>=xb),Ab=String.fromCharCode(32),Bb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},Cb=!1;
function Db(a,b){switch(a){case "keyup":return-1!==vb.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function Eb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Fb=!1;function Gb(a,b){switch(a){case "compositionend":return Eb(b);case "keypress":if(32!==b.which)return null;Cb=!0;return Ab;case "textInput":return a=b.data,a===Ab&&Cb?null:a;default:return null}}
function Hb(a,b){if(Fb)return"compositionend"===a||!wb&&Db(a,b)?(a=mb(),G._root=null,G._startText=null,G._fallbackText=null,Fb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return zb?null:b.data;default:return null}}
var Ib={eventTypes:Bb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(wb)b:{switch(a){case "compositionstart":e=Bb.compositionStart;break b;case "compositionend":e=Bb.compositionEnd;break b;case "compositionupdate":e=Bb.compositionUpdate;break b}e=void 0}else Fb?Db(a,c)&&(e=Bb.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=Bb.compositionStart);e?(zb&&(Fb||e!==Bb.compositionStart?e===Bb.compositionEnd&&Fb&&(f=mb()):(G._root=d,G._startText=nb(),Fb=!0)),e=tb.getPooled(e,b,c,d),f?e.data=
f:(f=Eb(c),null!==f&&(e.data=f)),Ya(e),f=e):f=null;(a=yb?Gb(a,c):Hb(a,c))?(b=ub.getPooled(Bb.beforeInput,b,c,d),b.data=a,Ya(b)):b=null;return null===f?b:null===b?f:[f,b]}},Jb=null,Kb={injectFiberControlledHostComponent:function(a){Jb=a}},Lb=null,Mb=null;function Nb(a){if(a=xa(a)){Jb&&"function"===typeof Jb.restoreControlledState?void 0:A("194");var b=wa(a.stateNode);Jb.restoreControlledState(a.stateNode,a.type,b)}}function Ob(a){Lb?Mb?Mb.push(a):Mb=[a]:Lb=a}
function Pb(){return null!==Lb||null!==Mb}function Qb(){if(Lb){var a=Lb,b=Mb;Mb=Lb=null;Nb(a);if(b)for(a=0;a<b.length;a++)Nb(b[a])}}var Rb={injection:Kb,enqueueStateRestore:Ob,needsStateRestore:Pb,restoreStateIfNeeded:Qb};function Sb(a,b){return a(b)}function Tb(a,b,c){return a(b,c)}function Ub(){}var Vb=!1;function Wb(a,b){if(Vb)return a(b);Vb=!0;try{return Sb(a,b)}finally{Vb=!1,Pb()&&(Ub(),Qb())}}
var Xb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Yb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Xb[a.type]:"textarea"===b?!0:!1}function Zb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}
function $b(a,b){if(!m.canUseDOM||b&&!("addEventListener"in document))return!1;a="on"+a;b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function ac(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function bc(a){var b=ac(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function cc(a){a._valueTracker||(a._valueTracker=bc(a))}function dc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=ac(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}
var ec=ba.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,fc="function"===typeof Symbol&&Symbol.for,gc=fc?Symbol.for("react.element"):60103,hc=fc?Symbol.for("react.portal"):60106,ic=fc?Symbol.for("react.fragment"):60107,jc=fc?Symbol.for("react.strict_mode"):60108,kc=fc?Symbol.for("react.profiler"):60114,lc=fc?Symbol.for("react.provider"):60109,mc=fc?Symbol.for("react.context"):60110,pc=fc?Symbol.for("react.async_mode"):60111,qc=fc?Symbol.for("react.forward_ref"):60112,rc=fc?Symbol.for("react.timeout"):
60113,sc="function"===typeof Symbol&&Symbol.iterator;function tc(a){if(null===a||"undefined"===typeof a)return null;a=sc&&a[sc]||a["@@iterator"];return"function"===typeof a?a:null}
function uc(a){var b=a.type;if("function"===typeof b)return b.displayName||b.name;if("string"===typeof b)return b;switch(b){case pc:return"AsyncMode";case mc:return"Context.Consumer";case ic:return"ReactFragment";case hc:return"ReactPortal";case kc:return"Profiler("+a.pendingProps.id+")";case lc:return"Context.Provider";case jc:return"StrictMode";case rc:return"Timeout"}if("object"===typeof b&&null!==b)switch(b.$$typeof){case qc:return a=b.render.displayName||b.render.name||"",""!==a?"ForwardRef("+
a+")":"ForwardRef"}return null}function vc(a){var b="";do{a:switch(a.tag){case 0:case 1:case 2:case 5:var c=a._debugOwner,d=a._debugSource;var e=uc(a);var f=null;c&&(f=uc(c));c=d;e="\n    in "+(e||"Unknown")+(c?" (at "+c.fileName.replace(/^.*[\\\/]/,"")+":"+c.lineNumber+")":f?" (created by "+f+")":"");break a;default:e=""}b+=e;a=a.return}while(a);return b}
var wc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,xc=Object.prototype.hasOwnProperty,zc={},Ac={};
function Bc(a){if(xc.call(Ac,a))return!0;if(xc.call(zc,a))return!1;if(wc.test(a))return Ac[a]=!0;zc[a]=!0;return!1}function Cc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function Dc(a,b,c,d){if(null===b||"undefined"===typeof b||Cc(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function I(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var J={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){J[a]=new I(a,0,!1,a,null)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];J[b]=new I(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){J[a]=new I(a,2,!1,a.toLowerCase(),null)});
["autoReverse","externalResourcesRequired","preserveAlpha"].forEach(function(a){J[a]=new I(a,2,!1,a,null)});"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){J[a]=new I(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){J[a]=new I(a,3,!0,a.toLowerCase(),null)});
["capture","download"].forEach(function(a){J[a]=new I(a,4,!1,a.toLowerCase(),null)});["cols","rows","size","span"].forEach(function(a){J[a]=new I(a,6,!1,a.toLowerCase(),null)});["rowSpan","start"].forEach(function(a){J[a]=new I(a,5,!1,a.toLowerCase(),null)});var Ec=/[\-:]([a-z])/g;function Fc(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ec,
Fc);J[b]=new I(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ec,Fc);J[b]=new I(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ec,Fc);J[b]=new I(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});J.tabIndex=new I("tabIndex",1,!1,"tabindex",null);
function Gc(a,b,c,d){var e=J.hasOwnProperty(b)?J[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Dc(b,c,e,d)&&(c=null),d||null===e?Bc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function Hc(a,b){var c=b.checked;return p({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}function Ic(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Jc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Kc(a,b){b=b.checked;null!=b&&Gc(a,"checked",b,!1)}
function Lc(a,b){Kc(a,b);var c=Jc(b.value);if(null!=c)if("number"===b.type){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);b.hasOwnProperty("value")?Mc(a,b.type,c):b.hasOwnProperty("defaultValue")&&Mc(a,b.type,Jc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Nc(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){b=""+a._wrapperState.initialValue;var d=a.value;c||b===d||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==c&&(a.name=c)}function Mc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}
function Jc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}var Oc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Pc(a,b,c){a=H.getPooled(Oc.change,a,b,c);a.type="change";Ob(c);Ya(a);return a}var Qc=null,Rc=null;function Sc(a){Ia(a,!1)}function Tc(a){var b=Oa(a);if(dc(b))return a}
function Uc(a,b){if("change"===a)return b}var Vc=!1;m.canUseDOM&&(Vc=$b("input")&&(!document.documentMode||9<document.documentMode));function Wc(){Qc&&(Qc.detachEvent("onpropertychange",Xc),Rc=Qc=null)}function Xc(a){"value"===a.propertyName&&Tc(Rc)&&(a=Pc(Rc,a,Zb(a)),Wb(Sc,a))}function Yc(a,b,c){"focus"===a?(Wc(),Qc=b,Rc=c,Qc.attachEvent("onpropertychange",Xc)):"blur"===a&&Wc()}function Zc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Tc(Rc)}
function $c(a,b){if("click"===a)return Tc(b)}function ad(a,b){if("input"===a||"change"===a)return Tc(b)}
var bd={eventTypes:Oc,_isInputEventSupported:Vc,extractEvents:function(a,b,c,d){var e=b?Oa(b):window,f=void 0,g=void 0,h=e.nodeName&&e.nodeName.toLowerCase();"select"===h||"input"===h&&"file"===e.type?f=Uc:Yb(e)?Vc?f=ad:(f=Zc,g=Yc):(h=e.nodeName)&&"input"===h.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=$c);if(f&&(f=f(a,b)))return Pc(f,c,d);g&&g(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Mc(e,"number",e.value)}},cd=H.extend({view:null,detail:null}),dd={Alt:"altKey",
Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function ed(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=dd[a])?!!b[a]:!1}function fd(){return ed}
var gd=cd.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:fd,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}}),hd=gd.extend({pointerId:null,width:null,height:null,pressure:null,tiltX:null,tiltY:null,pointerType:null,isPrimary:null}),id={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},
mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",dependencies:["pointerout","pointerover"]}},jd={eventTypes:id,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||
e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Na(b):null):f=null;if(f===b)return null;var g=void 0,h=void 0,k=void 0,n=void 0;if("mouseout"===a||"mouseover"===a)g=gd,h=id.mouseLeave,k=id.mouseEnter,n="mouse";else if("pointerout"===a||"pointerover"===a)g=hd,h=id.pointerLeave,k=id.pointerEnter,n="pointer";a=null==f?e:Oa(f);e=null==b?e:Oa(b);h=g.getPooled(h,f,c,d);h.type=n+"leave";h.target=a;h.relatedTarget=e;c=g.getPooled(k,b,c,d);c.type=n+"enter";c.target=e;c.relatedTarget=a;Za(h,
c,f,b);return[h,c]}};function kd(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function ld(a){2!==kd(a)?A("188"):void 0}
function md(a){var b=a.alternate;if(!b)return b=kd(a),3===b?A("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c.return,f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return ld(e),a;if(g===d)return ld(e),b;g=g.sibling}A("188")}if(c.return!==d.return)c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:A("189")}}c.alternate!==d?A("190"):void 0}3!==c.tag?A("188"):void 0;return c.stateNode.current===c?a:b}function nd(a){a=md(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function od(a){a=md(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}var pd=H.extend({animationName:null,elapsedTime:null,pseudoElement:null}),qd=H.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),rd=cd.extend({relatedTarget:null});
function sd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var td={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},ud={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},vd=cd.extend({key:function(a){if(a.key){var b=td[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=sd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?ud[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:fd,charCode:function(a){return"keypress"===
a.type?sd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?sd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),wd=gd.extend({dataTransfer:null}),xd=cd.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:fd}),yd=H.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),zd=gd.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),Ad=[["abort","abort"],[fb,"animationEnd"],[gb,"animationIteration"],[hb,"animationStart"],["canplay","canPlay"],["canplaythrough","canPlayThrough"],["drag","drag"],["dragenter","dragEnter"],["dragexit","dragExit"],["dragleave","dragLeave"],["dragover","dragOver"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],
["ended","ended"],["error","error"],["gotpointercapture","gotPointerCapture"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["loadstart","loadStart"],["lostpointercapture","lostPointerCapture"],["mousemove","mouseMove"],["mouseout","mouseOut"],["mouseover","mouseOver"],["playing","playing"],["pointermove","pointerMove"],["pointerout","pointerOut"],["pointerover","pointerOver"],["progress","progress"],["scroll","scroll"],["seeking","seeking"],["stalled","stalled"],
["suspend","suspend"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchmove","touchMove"],[ib,"transitionEnd"],["waiting","waiting"],["wheel","wheel"]],Bd={},Cd={};function Dd(a,b){var c=a[0];a=a[1];var d="on"+(a[0].toUpperCase()+a.slice(1));b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};Bd[a]=b;Cd[c]=b}
[["blur","blur"],["cancel","cancel"],["click","click"],["close","close"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragstart","dragStart"],["drop","drop"],["focus","focus"],["input","input"],["invalid","invalid"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["mousedown","mouseDown"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["pointercancel","pointerCancel"],["pointerdown","pointerDown"],
["pointerup","pointerUp"],["ratechange","rateChange"],["reset","reset"],["seeked","seeked"],["submit","submit"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchstart","touchStart"],["volumechange","volumeChange"]].forEach(function(a){Dd(a,!0)});Ad.forEach(function(a){Dd(a,!1)});
var Ed={eventTypes:Bd,isInteractiveTopLevelEventType:function(a){a=Cd[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=Cd[a];if(!e)return null;switch(a){case "keypress":if(0===sd(c))return null;case "keydown":case "keyup":a=vd;break;case "blur":case "focus":a=rd;break;case "click":if(2===c.button)return null;case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=gd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
wd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=xd;break;case fb:case gb:case hb:a=pd;break;case ib:a=yd;break;case "scroll":a=cd;break;case "wheel":a=zd;break;case "copy":case "cut":case "paste":a=qd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=hd;break;default:a=H}b=a.getPooled(e,b,c,d);Ya(b);return b}},Fd=Ed.isInteractiveTopLevelEventType,
Gd=[];function Hd(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c.return;)c=c.return;c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=Na(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],Ja(a.topLevelType,b,a.nativeEvent,Zb(a.nativeEvent))}var Id=!0;function Kd(a){Id=!!a}function K(a,b){if(!b)return null;var c=(Fd(a)?Ld:Md).bind(null,a);b.addEventListener(a,c,!1)}
function Nd(a,b){if(!b)return null;var c=(Fd(a)?Ld:Md).bind(null,a);b.addEventListener(a,c,!0)}function Ld(a,b){Tb(Md,a,b)}function Md(a,b){if(Id){var c=Zb(b);c=Na(c);null===c||"number"!==typeof c.tag||2===kd(c)||(c=null);if(Gd.length){var d=Gd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{Wb(Hd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>Gd.length&&Gd.push(a)}}}
var Od={get _enabled(){return Id},setEnabled:Kd,isEnabled:function(){return Id},trapBubbledEvent:K,trapCapturedEvent:Nd,dispatchEvent:Md},Pd={},Qd=0,Rd="_reactListenersID"+(""+Math.random()).slice(2);function Sd(a){Object.prototype.hasOwnProperty.call(a,Rd)||(a[Rd]=Qd++,Pd[a[Rd]]={});return Pd[a[Rd]]}function Td(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Ud(a,b){var c=Td(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Td(c)}}function Vd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
var Wd=m.canUseDOM&&"documentMode"in document&&11>=document.documentMode,Xd={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu focus keydown keyup mousedown mouseup selectionchange".split(" ")}},Yd=null,Zd=null,$d=null,ae=!1;
function be(a,b){if(ae||null==Yd||Yd!==da())return null;var c=Yd;"selectionStart"in c&&Vd(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return $d&&ea($d,c)?null:($d=c,a=H.getPooled(Xd.select,Zd,a,b),a.type="select",a.target=Yd,Ya(a),a)}
var ce={eventTypes:Xd,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Sd(e);f=sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Oa(b):window;switch(a){case "focus":if(Yb(e)||"true"===e.contentEditable)Yd=e,Zd=b,$d=null;break;case "blur":$d=Zd=Yd=null;break;case "mousedown":ae=!0;break;case "contextmenu":case "mouseup":return ae=!1,be(c,d);case "selectionchange":if(Wd)break;
case "keydown":case "keyup":return be(c,d)}return null}};Ga.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));wa=Qa.getFiberCurrentPropsFromNode;xa=Qa.getInstanceFromNode;ya=Qa.getNodeFromInstance;Ga.injectEventPluginsByName({SimpleEventPlugin:Ed,EnterLeaveEventPlugin:jd,ChangeEventPlugin:bd,SelectEventPlugin:ce,BeforeInputEventPlugin:Ib});
var de="function"===typeof requestAnimationFrame?requestAnimationFrame:void 0,ee=Date,fe=setTimeout,ge=clearTimeout,he=void 0;if("object"===typeof performance&&"function"===typeof performance.now){var ie=performance;he=function(){return ie.now()}}else he=function(){return ee.now()};var je=void 0,ke=void 0;
if(m.canUseDOM){var le="function"===typeof de?de:function(){A("276")},L=null,me=null,ne=-1,oe=!1,pe=!1,qe=0,re=33,se=33,te={didTimeout:!1,timeRemaining:function(){var a=qe-he();return 0<a?a:0}},ve=function(a,b){var c=a.scheduledCallback,d=!1;try{c(b),d=!0}finally{ke(a),d||(oe=!0,window.postMessage(ue,"*"))}},ue="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===ue&&(oe=!1,null!==L)){if(null!==L){var b=he();if(!(-1===
ne||ne>b)){a=-1;for(var c=[],d=L;null!==d;){var e=d.timeoutTime;-1!==e&&e<=b?c.push(d):-1!==e&&(-1===a||e<a)&&(a=e);d=d.next}if(0<c.length)for(te.didTimeout=!0,b=0,d=c.length;b<d;b++)ve(c[b],te);ne=a}}for(a=he();0<qe-a&&null!==L;)a=L,te.didTimeout=!1,ve(a,te),a=he();null===L||pe||(pe=!0,le(we))}},!1);var we=function(a){pe=!1;var b=a-qe+se;b<se&&re<se?(8>b&&(b=8),se=b<re?re:b):re=b;qe=a+se;oe||(oe=!0,window.postMessage(ue,"*"))};je=function(a,b){var c=-1;null!=b&&"number"===typeof b.timeout&&(c=he()+
b.timeout);if(-1===ne||-1!==c&&c<ne)ne=c;a={scheduledCallback:a,timeoutTime:c,prev:null,next:null};null===L?L=a:(b=a.prev=me,null!==b&&(b.next=a));me=a;pe||(pe=!0,le(we));return a};ke=function(a){if(null!==a.prev||L===a){var b=a.next,c=a.prev;a.next=null;a.prev=null;null!==b?null!==c?(c.next=b,b.prev=c):(b.prev=null,L=b):null!==c?(c.next=null,me=c):me=L=null}}}else{var xe=new Map;je=function(a){var b={scheduledCallback:a,timeoutTime:0,next:null,prev:null},c=fe(function(){a({timeRemaining:function(){return Infinity},
didTimeout:!1})});xe.set(a,c);return b};ke=function(a){var b=xe.get(a.scheduledCallback);xe.delete(a);ge(b)}}function ye(a){var b="";ba.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}function ze(a,b){a=p({children:void 0},b);if(b=ye(b.children))a.children=b;return a}
function Ae(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Be(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function Ce(a,b){null!=b.dangerouslySetInnerHTML?A("91"):void 0;return p({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function De(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?A("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:A("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
function Ee(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Fe(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Ge={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function He(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ie(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?He(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Je=void 0,Ke=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Ge.svg||"innerHTML"in a)a.innerHTML=b;else{Je=Je||document.createElement("div");Je.innerHTML="<svg>"+b+"</svg>";for(b=Je.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Le(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var Me={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Ne=["Webkit","ms","Moz","O"];Object.keys(Me).forEach(function(a){Ne.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Me[b]=Me[a]})});
function Oe(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||Me.hasOwnProperty(e)&&Me[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Pe=p({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function Qe(a,b,c){b&&(Pe[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?A("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?A("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:A("61")),null!=b.style&&"object"!==typeof b.style?A("62",c()):void 0)}
function Re(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var Se=v.thatReturns("");
function Te(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Sd(a);b=sa[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.hasOwnProperty(e)||!c[e]){switch(e){case "scroll":Nd("scroll",a);break;case "focus":case "blur":Nd("focus",a);Nd("blur",a);c.blur=!0;c.focus=!0;break;case "cancel":case "close":$b(e,!0)&&Nd(e,a);break;case "invalid":case "submit":case "reset":break;default:-1===jb.indexOf(e)&&K(e,a)}c[e]=!0}}}
function Ue(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===Ge.html&&(d=He(a));d===Ge.html?"script"===a?(a=c.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function Ve(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
function We(a,b,c,d){var e=Re(b,c);switch(b){case "iframe":case "object":K("load",a);var f=c;break;case "video":case "audio":for(f=0;f<jb.length;f++)K(jb[f],a);f=c;break;case "source":K("error",a);f=c;break;case "img":case "image":case "link":K("error",a);K("load",a);f=c;break;case "form":K("reset",a);K("submit",a);f=c;break;case "details":K("toggle",a);f=c;break;case "input":Ic(a,c);f=Hc(a,c);K("invalid",a);Te(d,"onChange");break;case "option":f=ze(a,c);break;case "select":Be(a,c);f=p({},c,{value:void 0});
K("invalid",a);Te(d,"onChange");break;case "textarea":De(a,c);f=Ce(a,c);K("invalid",a);Te(d,"onChange");break;default:f=c}Qe(b,f,Se);var g=f,h;for(h in g)if(g.hasOwnProperty(h)){var k=g[h];"style"===h?Oe(a,k,Se):"dangerouslySetInnerHTML"===h?(k=k?k.__html:void 0,null!=k&&Ke(a,k)):"children"===h?"string"===typeof k?("textarea"!==b||""!==k)&&Le(a,k):"number"===typeof k&&Le(a,""+k):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ra.hasOwnProperty(h)?null!=k&&Te(d,
h):null!=k&&Gc(a,h,k,e))}switch(b){case "input":cc(a);Nc(a,c,!1);break;case "textarea":cc(a);Fe(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?Ae(a,!!c.multiple,b,!1):null!=c.defaultValue&&Ae(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=v)}}
function Xe(a,b,c,d,e){var f=null;switch(b){case "input":c=Hc(a,c);d=Hc(a,d);f=[];break;case "option":c=ze(a,c);d=ze(a,d);f=[];break;case "select":c=p({},c,{value:void 0});d=p({},d,{value:void 0});f=[];break;case "textarea":c=Ce(a,c);d=Ce(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=v)}Qe(b,d,Se);b=a=void 0;var g=null;for(a in c)if(!d.hasOwnProperty(a)&&c.hasOwnProperty(a)&&null!=c[a])if("style"===a){var h=c[a];for(b in h)h.hasOwnProperty(b)&&(g||
(g={}),g[b]="")}else"dangerouslySetInnerHTML"!==a&&"children"!==a&&"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&"autoFocus"!==a&&(ra.hasOwnProperty(a)?f||(f=[]):(f=f||[]).push(a,null));for(a in d){var k=d[a];h=null!=c?c[a]:void 0;if(d.hasOwnProperty(a)&&k!==h&&(null!=k||null!=h))if("style"===a)if(h){for(b in h)!h.hasOwnProperty(b)||k&&k.hasOwnProperty(b)||(g||(g={}),g[b]="");for(b in k)k.hasOwnProperty(b)&&h[b]!==k[b]&&(g||(g={}),g[b]=k[b])}else g||(f||(f=[]),f.push(a,g)),
g=k;else"dangerouslySetInnerHTML"===a?(k=k?k.__html:void 0,h=h?h.__html:void 0,null!=k&&h!==k&&(f=f||[]).push(a,""+k)):"children"===a?h===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(a,""+k):"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&(ra.hasOwnProperty(a)?(null!=k&&Te(e,a),f||h===k||(f=[])):(f=f||[]).push(a,k))}g&&(f=f||[]).push("style",g);return f}
function Ye(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Kc(a,e);Re(c,d);d=Re(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?Oe(a,h,Se):"dangerouslySetInnerHTML"===g?Ke(a,h):"children"===g?Le(a,h):Gc(a,g,h,d)}switch(c){case "input":Lc(a,e);break;case "textarea":Ee(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?Ae(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?
Ae(a,!!e.multiple,e.defaultValue,!0):Ae(a,!!e.multiple,e.multiple?[]:"",!1))}}
function Ze(a,b,c,d,e){switch(b){case "iframe":case "object":K("load",a);break;case "video":case "audio":for(d=0;d<jb.length;d++)K(jb[d],a);break;case "source":K("error",a);break;case "img":case "image":case "link":K("error",a);K("load",a);break;case "form":K("reset",a);K("submit",a);break;case "details":K("toggle",a);break;case "input":Ic(a,c);K("invalid",a);Te(e,"onChange");break;case "select":Be(a,c);K("invalid",a);Te(e,"onChange");break;case "textarea":De(a,c),K("invalid",a),Te(e,"onChange")}Qe(b,
c,Se);d=null;for(var f in c)if(c.hasOwnProperty(f)){var g=c[f];"children"===f?"string"===typeof g?a.textContent!==g&&(d=["children",g]):"number"===typeof g&&a.textContent!==""+g&&(d=["children",""+g]):ra.hasOwnProperty(f)&&null!=g&&Te(e,f)}switch(b){case "input":cc(a);Nc(a,c,!0);break;case "textarea":cc(a);Fe(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&(a.onclick=v)}return d}function $e(a,b){return a.nodeValue!==b}
var af={createElement:Ue,createTextNode:Ve,setInitialProperties:We,diffProperties:Xe,updateProperties:Ye,diffHydratedProperties:Ze,diffHydratedText:$e,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Lc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;
c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Pa(d);e?void 0:A("90");dc(d);Lc(d,e)}}}break;case "textarea":Ee(a,c);break;case "select":b=c.value,null!=b&&Ae(a,!!c.multiple,b,!1)}}},bf=null,cf=null;function df(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function ef(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===typeof b.dangerouslySetInnerHTML.__html}var ff=he,gf=je,hf=ke;function jf(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}function kf(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}new Set;var lf=[],mf=-1;function nf(a){return{current:a}}
function M(a){0>mf||(a.current=lf[mf],lf[mf]=null,mf--)}function N(a,b){mf++;lf[mf]=a.current;a.current=b}var of=nf(ha),O=nf(!1),pf=ha;function qf(a){return rf(a)?pf:of.current}
function sf(a,b){var c=a.type.contextTypes;if(!c)return ha;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function rf(a){return 2===a.tag&&null!=a.type.childContextTypes}function tf(a){rf(a)&&(M(O,a),M(of,a))}function uf(a){M(O,a);M(of,a)}
function vf(a,b,c){of.current!==ha?A("168"):void 0;N(of,b,a);N(O,c,a)}function wf(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:A("108",uc(a)||"Unknown",e);return p({},b,c)}function xf(a){if(!rf(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||ha;pf=of.current;N(of,b,a);N(O,O.current,a);return!0}
function yf(a,b){var c=a.stateNode;c?void 0:A("169");if(b){var d=wf(a,pf);c.__reactInternalMemoizedMergedChildContext=d;M(O,a);M(of,a);N(of,d,a)}else M(O,a);N(O,b,a)}
function zf(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=null;this.index=0;this.ref=null;this.pendingProps=b;this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
function Af(a,b,c){var d=a.alternate;null===d?(d=new zf(a.tag,b,a.key,a.mode),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.pendingProps=b,d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
function Bf(a,b,c){var d=a.type,e=a.key;a=a.props;if("function"===typeof d)var f=d.prototype&&d.prototype.isReactComponent?2:0;else if("string"===typeof d)f=5;else switch(d){case ic:return Cf(a.children,b,c,e);case pc:f=11;b|=3;break;case jc:f=11;b|=2;break;case kc:return d=new zf(15,a,e,b|4),d.type=kc,d.expirationTime=c,d;case rc:f=16;b|=2;break;default:a:{switch("object"===typeof d&&null!==d?d.$$typeof:null){case lc:f=13;break a;case mc:f=12;break a;case qc:f=14;break a;default:A("130",null==d?
d:typeof d,"")}f=void 0}}b=new zf(f,a,e,b);b.type=d;b.expirationTime=c;return b}function Cf(a,b,c,d){a=new zf(10,a,d,b);a.expirationTime=c;return a}function Df(a,b,c){a=new zf(6,a,null,b);a.expirationTime=c;return a}function Ef(a,b,c){b=new zf(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function Ff(a,b,c){b=new zf(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,pendingCommitExpirationTime:0,finishedWork:null,context:null,pendingContext:null,hydrate:c,remainingExpirationTime:0,firstBatch:null,nextScheduledRoot:null};return b.stateNode=a}var Gf=null,Hf=null;function If(a){return function(b){try{return a(b)}catch(c){}}}
function Jf(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Gf=If(function(a){return b.onCommitFiberRoot(c,a)});Hf=If(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function Kf(a){"function"===typeof Gf&&Gf(a)}function Lf(a){"function"===typeof Hf&&Hf(a)}var Mf=!1;
function Nf(a){return{expirationTime:0,baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function Of(a){return{expirationTime:a.expirationTime,baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function Pf(a){return{expirationTime:a,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function Qf(a,b,c){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b);if(0===a.expirationTime||a.expirationTime>c)a.expirationTime=c}
function Rf(a,b,c){var d=a.alternate;if(null===d){var e=a.updateQueue;var f=null;null===e&&(e=a.updateQueue=Nf(a.memoizedState))}else e=a.updateQueue,f=d.updateQueue,null===e?null===f?(e=a.updateQueue=Nf(a.memoizedState),f=d.updateQueue=Nf(d.memoizedState)):e=a.updateQueue=Of(f):null===f&&(f=d.updateQueue=Of(e));null===f||e===f?Qf(e,b,c):null===e.lastUpdate||null===f.lastUpdate?(Qf(e,b,c),Qf(f,b,c)):(Qf(e,b,c),f.lastUpdate=b)}
function Sf(a,b,c){var d=a.updateQueue;d=null===d?a.updateQueue=Nf(a.memoizedState):Tf(a,d);null===d.lastCapturedUpdate?d.firstCapturedUpdate=d.lastCapturedUpdate=b:(d.lastCapturedUpdate.next=b,d.lastCapturedUpdate=b);if(0===d.expirationTime||d.expirationTime>c)d.expirationTime=c}function Tf(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=Of(b));return b}
function Uf(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-1025|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return p({},d,e);case 2:Mf=!0}return d}
function Vf(a,b,c,d,e){Mf=!1;if(!(0===b.expirationTime||b.expirationTime>e)){b=Tf(a,b);for(var f=b.baseState,g=null,h=0,k=b.firstUpdate,n=f;null!==k;){var r=k.expirationTime;if(r>e){if(null===g&&(g=k,f=n),0===h||h>r)h=r}else n=Uf(a,b,k,n,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k));k=k.next}r=null;for(k=b.firstCapturedUpdate;null!==k;){var w=k.expirationTime;if(w>e){if(null===r&&(r=k,null===
g&&(f=n)),0===h||h>w)h=w}else n=Uf(a,b,k,n,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k));k=k.next}null===g&&(b.lastUpdate=null);null===r?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===r&&(f=n);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=r;b.expirationTime=h;a.memoizedState=n}}
function Wf(a,b){"function"!==typeof a?A("191",a):void 0;a.call(b)}
function Xf(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);a=b.firstEffect;for(b.firstEffect=b.lastEffect=null;null!==a;){var d=a.callback;null!==d&&(a.callback=null,Wf(d,c));a=a.nextEffect}a=b.firstCapturedEffect;for(b.firstCapturedEffect=b.lastCapturedEffect=null;null!==a;)b=a.callback,null!==b&&(a.callback=null,Wf(b,c)),a=a.nextEffect}
function Yf(a,b){return{value:a,source:b,stack:vc(b)}}var Zf=nf(null),$f=nf(null),ag=nf(0);function bg(a){var b=a.type._context;N(ag,b._changedBits,a);N($f,b._currentValue,a);N(Zf,a,a);b._currentValue=a.pendingProps.value;b._changedBits=a.stateNode}function cg(a){var b=ag.current,c=$f.current;M(Zf,a);M($f,a);M(ag,a);a=a.type._context;a._currentValue=c;a._changedBits=b}var dg={},eg=nf(dg),fg=nf(dg),gg=nf(dg);function hg(a){a===dg?A("174"):void 0;return a}
function jg(a,b){N(gg,b,a);N(fg,a,a);N(eg,dg,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ie(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=Ie(b,c)}M(eg,a);N(eg,b,a)}function kg(a){M(eg,a);M(fg,a);M(gg,a)}function lg(a){fg.current===a&&(M(eg,a),M(fg,a))}function mg(a,b,c){var d=a.memoizedState;b=b(c,d);d=null===b||void 0===b?d:p({},d,b);a.memoizedState=d;a=a.updateQueue;null!==a&&0===a.expirationTime&&(a.baseState=d)}
var qg={isMounted:function(a){return(a=a._reactInternalFiber)?2===kd(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=ng();d=og(d,a);var e=Pf(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Rf(a,e,d);pg(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=ng();d=og(d,a);var e=Pf(d);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Rf(a,e,d);pg(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=ng();c=og(c,a);var d=Pf(c);d.tag=2;void 0!==
b&&null!==b&&(d.callback=b);Rf(a,d,c);pg(a,c)}};function rg(a,b,c,d,e,f){var g=a.stateNode;a=a.type;return"function"===typeof g.shouldComponentUpdate?g.shouldComponentUpdate(c,e,f):a.prototype&&a.prototype.isPureReactComponent?!ea(b,c)||!ea(d,e):!0}
function sg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&qg.enqueueReplaceState(b,b.state,null)}
function tg(a,b){var c=a.type,d=a.stateNode,e=a.pendingProps,f=qf(a);d.props=e;d.state=a.memoizedState;d.refs=ha;d.context=sf(a,f);f=a.updateQueue;null!==f&&(Vf(a,f,e,d,b),d.state=a.memoizedState);f=a.type.getDerivedStateFromProps;"function"===typeof f&&(mg(a,f,e),d.state=a.memoizedState);"function"===typeof c.getDerivedStateFromProps||"function"===typeof d.getSnapshotBeforeUpdate||"function"!==typeof d.UNSAFE_componentWillMount&&"function"!==typeof d.componentWillMount||(c=d.state,"function"===typeof d.componentWillMount&&
d.componentWillMount(),"function"===typeof d.UNSAFE_componentWillMount&&d.UNSAFE_componentWillMount(),c!==d.state&&qg.enqueueReplaceState(d,d.state,null),f=a.updateQueue,null!==f&&(Vf(a,f,e,d,b),d.state=a.memoizedState));"function"===typeof d.componentDidMount&&(a.effectTag|=4)}var ug=Array.isArray;
function vg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(2!==c.tag?A("110"):void 0,d=c.stateNode);d?void 0:A("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs===ha?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?A("148"):void 0;c._owner?void 0:A("254",a)}return a}
function wg(a,b){"textarea"!==a.type&&A("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function xg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=Af(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Df(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=vg(a,b,c),d.return=a,d;d=Bf(c,a.mode,d);d.ref=vg(a,b,c);d.return=a;return d}function n(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=
Ef(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function r(a,b,c,d,f){if(null===b||10!==b.tag)return b=Cf(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function w(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Df(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case gc:return c=Bf(b,a.mode,c),c.ref=vg(a,null,b),c.return=a,c;case hc:return b=Ef(b,a.mode,c),b.return=a,b}if(ug(b)||tc(b))return b=Cf(b,a.mode,c,null),b.return=
a,b;wg(a,b)}return null}function P(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case gc:return c.key===e?c.type===ic?r(a,b,c.props.children,d,e):k(a,b,c,d):null;case hc:return c.key===e?n(a,b,c,d):null}if(ug(c)||tc(c))return null!==e?null:r(a,b,c,d,null);wg(a,c)}return null}function nc(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||null,h(b,a,""+d,e);
if("object"===typeof d&&null!==d){switch(d.$$typeof){case gc:return a=a.get(null===d.key?c:d.key)||null,d.type===ic?r(b,a,d.props.children,e,d.key):k(b,a,d,e);case hc:return a=a.get(null===d.key?c:d.key)||null,n(b,a,d,e)}if(ug(d)||tc(d))return a=a.get(c)||null,r(b,a,d,e,null);wg(b,d)}return null}function Jd(e,g,h,k){for(var u=null,x=null,t=g,q=g=0,n=null;null!==t&&q<h.length;q++){t.index>q?(n=t,t=null):n=t.sibling;var l=P(e,t,h[q],k);if(null===l){null===t&&(t=n);break}a&&t&&null===l.alternate&&b(e,
t);g=f(l,g,q);null===x?u=l:x.sibling=l;x=l;t=n}if(q===h.length)return c(e,t),u;if(null===t){for(;q<h.length;q++)if(t=w(e,h[q],k))g=f(t,g,q),null===x?u=t:x.sibling=t,x=t;return u}for(t=d(e,t);q<h.length;q++)if(n=nc(t,e,q,h[q],k))a&&null!==n.alternate&&t.delete(null===n.key?q:n.key),g=f(n,g,q),null===x?u=n:x.sibling=n,x=n;a&&t.forEach(function(a){return b(e,a)});return u}function E(e,g,h,k){var u=tc(h);"function"!==typeof u?A("150"):void 0;h=u.call(h);null==h?A("151"):void 0;for(var t=u=null,n=g,x=
g=0,y=null,l=h.next();null!==n&&!l.done;x++,l=h.next()){n.index>x?(y=n,n=null):y=n.sibling;var r=P(e,n,l.value,k);if(null===r){n||(n=y);break}a&&n&&null===r.alternate&&b(e,n);g=f(r,g,x);null===t?u=r:t.sibling=r;t=r;n=y}if(l.done)return c(e,n),u;if(null===n){for(;!l.done;x++,l=h.next())l=w(e,l.value,k),null!==l&&(g=f(l,g,x),null===t?u=l:t.sibling=l,t=l);return u}for(n=d(e,n);!l.done;x++,l=h.next())l=nc(n,e,x,l.value,k),null!==l&&(a&&null!==l.alternate&&n.delete(null===l.key?x:l.key),g=f(l,g,x),null===
t?u=l:t.sibling=l,t=l);a&&n.forEach(function(a){return b(e,a)});return u}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ic&&null===f.key;k&&(f=f.props.children);var n="object"===typeof f&&null!==f;if(n)switch(f.$$typeof){case gc:a:{n=f.key;for(k=d;null!==k;){if(k.key===n)if(10===k.tag?f.type===ic:k.type===f.type){c(a,k.sibling);d=e(k,f.type===ic?f.props.children:f.props,h);d.ref=vg(a,k,f);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=k.sibling}f.type===ic?(d=Cf(f.props.children,
a.mode,h,f.key),d.return=a,a=d):(h=Bf(f,a.mode,h),h.ref=vg(a,d,f),h.return=a,a=h)}return g(a);case hc:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=Ef(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=
a,a=d):(c(a,d),d=Df(f,a.mode,h),d.return=a,a=d),g(a);if(ug(f))return Jd(a,d,f,h);if(tc(f))return E(a,d,f,h);n&&wg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 2:case 1:h=a.type,A("152",h.displayName||h.name||"Component")}return c(a,d)}}var yg=xg(!0),zg=xg(!1),Ag=null,Bg=null,Cg=!1;function Dg(a,b){var c=new zf(5,null,null,0);c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Eg(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;default:return!1}}function Fg(a){if(Cg){var b=Bg;if(b){var c=b;if(!Eg(a,b)){b=jf(c);if(!b||!Eg(a,b)){a.effectTag|=2;Cg=!1;Ag=a;return}Dg(Ag,c)}Ag=a;Bg=kf(b)}else a.effectTag|=2,Cg=!1,Ag=a}}
function Gg(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag;)a=a.return;Ag=a}function Hg(a){if(a!==Ag)return!1;if(!Cg)return Gg(a),Cg=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!ef(b,a.memoizedProps))for(b=Bg;b;)Dg(a,b),b=jf(b);Gg(a);Bg=Ag?jf(a.stateNode):null;return!0}function Ig(){Bg=Ag=null;Cg=!1}function Q(a,b,c){Jg(a,b,c,b.expirationTime)}function Jg(a,b,c,d){b.child=null===a?zg(b,null,c,d):yg(b,a.child,c,d)}
function Kg(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function Lg(a,b,c,d,e){Kg(a,b);var f=0!==(b.effectTag&64);if(!c&&!f)return d&&yf(b,!1),R(a,b);c=b.stateNode;ec.current=b;var g=f?null:c.render();b.effectTag|=1;f&&(Jg(a,b,null,e),b.child=null);Jg(a,b,g,e);b.memoizedState=c.state;b.memoizedProps=c.props;d&&yf(b,!0);return b.child}
function Mg(a){var b=a.stateNode;b.pendingContext?vf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&vf(a,b.context,!1);jg(a,b.containerInfo)}
function Ng(a,b,c,d){var e=a.child;null!==e&&(e.return=a);for(;null!==e;){switch(e.tag){case 12:var f=e.stateNode|0;if(e.type===b&&0!==(f&c)){for(f=e;null!==f;){var g=f.alternate;if(0===f.expirationTime||f.expirationTime>d)f.expirationTime=d,null!==g&&(0===g.expirationTime||g.expirationTime>d)&&(g.expirationTime=d);else if(null!==g&&(0===g.expirationTime||g.expirationTime>d))g.expirationTime=d;else break;f=f.return}f=null}else f=e.child;break;case 13:f=e.type===a.type?null:e.child;break;default:f=
e.child}if(null!==f)f.return=e;else for(f=e;null!==f;){if(f===a){f=null;break}e=f.sibling;if(null!==e){e.return=f.return;f=e;break}f=f.return}e=f}}
function Rg(a,b,c){var d=b.type._context,e=b.pendingProps,f=b.memoizedProps,g=!0;if(O.current)g=!1;else if(f===e)return b.stateNode=0,bg(b),R(a,b);var h=e.value;b.memoizedProps=e;if(null===f)h=1073741823;else if(f.value===e.value){if(f.children===e.children&&g)return b.stateNode=0,bg(b),R(a,b);h=0}else{var k=f.value;if(k===h&&(0!==k||1/k===1/h)||k!==k&&h!==h){if(f.children===e.children&&g)return b.stateNode=0,bg(b),R(a,b);h=0}else if(h="function"===typeof d._calculateChangedBits?d._calculateChangedBits(k,
h):1073741823,h|=0,0===h){if(f.children===e.children&&g)return b.stateNode=0,bg(b),R(a,b)}else Ng(b,d,h,c)}b.stateNode=h;bg(b);Q(a,b,e.children);return b.child}function R(a,b){null!==a&&b.child!==a.child?A("153"):void 0;if(null!==b.child){a=b.child;var c=Af(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Af(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
function Sg(a,b,c){if(0===b.expirationTime||b.expirationTime>c){switch(b.tag){case 3:Mg(b);break;case 2:xf(b);break;case 4:jg(b,b.stateNode.containerInfo);break;case 13:bg(b)}return null}switch(b.tag){case 0:null!==a?A("155"):void 0;var d=b.type,e=b.pendingProps,f=qf(b);f=sf(b,f);d=d(e,f);b.effectTag|=1;"object"===typeof d&&null!==d&&"function"===typeof d.render&&void 0===d.$$typeof?(f=b.type,b.tag=2,b.memoizedState=null!==d.state&&void 0!==d.state?d.state:null,f=f.getDerivedStateFromProps,"function"===
typeof f&&mg(b,f,e),e=xf(b),d.updater=qg,b.stateNode=d,d._reactInternalFiber=b,tg(b,c),a=Lg(a,b,!0,e,c)):(b.tag=1,Q(a,b,d),b.memoizedProps=e,a=b.child);return a;case 1:return e=b.type,c=b.pendingProps,O.current||b.memoizedProps!==c?(d=qf(b),d=sf(b,d),e=e(c,d),b.effectTag|=1,Q(a,b,e),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 2:e=xf(b);if(null===a)if(null===b.stateNode){var g=b.pendingProps,h=b.type;d=qf(b);var k=2===b.tag&&null!=b.type.contextTypes;f=k?sf(b,d):ha;g=new h(g,f);b.memoizedState=null!==
g.state&&void 0!==g.state?g.state:null;g.updater=qg;b.stateNode=g;g._reactInternalFiber=b;k&&(k=b.stateNode,k.__reactInternalMemoizedUnmaskedChildContext=d,k.__reactInternalMemoizedMaskedChildContext=f);tg(b,c);d=!0}else{h=b.type;d=b.stateNode;k=b.memoizedProps;f=b.pendingProps;d.props=k;var n=d.context;g=qf(b);g=sf(b,g);var r=h.getDerivedStateFromProps;(h="function"===typeof r||"function"===typeof d.getSnapshotBeforeUpdate)||"function"!==typeof d.UNSAFE_componentWillReceiveProps&&"function"!==typeof d.componentWillReceiveProps||
(k!==f||n!==g)&&sg(b,d,f,g);Mf=!1;var w=b.memoizedState;n=d.state=w;var P=b.updateQueue;null!==P&&(Vf(b,P,f,d,c),n=b.memoizedState);k!==f||w!==n||O.current||Mf?("function"===typeof r&&(mg(b,r,f),n=b.memoizedState),(k=Mf||rg(b,k,f,w,n,g))?(h||"function"!==typeof d.UNSAFE_componentWillMount&&"function"!==typeof d.componentWillMount||("function"===typeof d.componentWillMount&&d.componentWillMount(),"function"===typeof d.UNSAFE_componentWillMount&&d.UNSAFE_componentWillMount()),"function"===typeof d.componentDidMount&&
(b.effectTag|=4)):("function"===typeof d.componentDidMount&&(b.effectTag|=4),b.memoizedProps=f,b.memoizedState=n),d.props=f,d.state=n,d.context=g,d=k):("function"===typeof d.componentDidMount&&(b.effectTag|=4),d=!1)}else h=b.type,d=b.stateNode,f=b.memoizedProps,k=b.pendingProps,d.props=f,n=d.context,g=qf(b),g=sf(b,g),r=h.getDerivedStateFromProps,(h="function"===typeof r||"function"===typeof d.getSnapshotBeforeUpdate)||"function"!==typeof d.UNSAFE_componentWillReceiveProps&&"function"!==typeof d.componentWillReceiveProps||
(f!==k||n!==g)&&sg(b,d,k,g),Mf=!1,n=b.memoizedState,w=d.state=n,P=b.updateQueue,null!==P&&(Vf(b,P,k,d,c),w=b.memoizedState),f!==k||n!==w||O.current||Mf?("function"===typeof r&&(mg(b,r,k),w=b.memoizedState),(r=Mf||rg(b,f,k,n,w,g))?(h||"function"!==typeof d.UNSAFE_componentWillUpdate&&"function"!==typeof d.componentWillUpdate||("function"===typeof d.componentWillUpdate&&d.componentWillUpdate(k,w,g),"function"===typeof d.UNSAFE_componentWillUpdate&&d.UNSAFE_componentWillUpdate(k,w,g)),"function"===typeof d.componentDidUpdate&&
(b.effectTag|=4),"function"===typeof d.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof d.componentDidUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=4),"function"!==typeof d.getSnapshotBeforeUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=256),b.memoizedProps=k,b.memoizedState=w),d.props=k,d.state=w,d.context=g,d=r):("function"!==typeof d.componentDidUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=4),"function"!==typeof d.getSnapshotBeforeUpdate||
f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=256),d=!1);return Lg(a,b,d,e,c);case 3:Mg(b);e=b.updateQueue;if(null!==e)if(d=b.memoizedState,d=null!==d?d.element:null,Vf(b,e,b.pendingProps,null,c),e=b.memoizedState.element,e===d)Ig(),a=R(a,b);else{d=b.stateNode;if(d=(null===a||null===a.child)&&d.hydrate)Bg=kf(b.stateNode.containerInfo),Ag=b,d=Cg=!0;d?(b.effectTag|=2,b.child=zg(b,null,e,c)):(Ig(),Q(a,b,e));a=b.child}else Ig(),a=R(a,b);return a;case 5:a:{hg(gg.current);e=hg(eg.current);d=Ie(e,
b.type);e!==d&&(N(fg,b,b),N(eg,d,b));null===a&&Fg(b);e=b.type;k=b.memoizedProps;d=b.pendingProps;f=null!==a?a.memoizedProps:null;if(!O.current&&k===d){if(k=b.mode&1&&!!d.hidden)b.expirationTime=1073741823;if(!k||1073741823!==c){a=R(a,b);break a}}k=d.children;ef(e,d)?k=null:f&&ef(e,f)&&(b.effectTag|=16);Kg(a,b);1073741823!==c&&b.mode&1&&d.hidden?(b.expirationTime=1073741823,b.memoizedProps=d,a=null):(Q(a,b,k),b.memoizedProps=d,a=b.child)}return a;case 6:return null===a&&Fg(b),b.memoizedProps=b.pendingProps,
null;case 16:return null;case 4:return jg(b,b.stateNode.containerInfo),e=b.pendingProps,O.current||b.memoizedProps!==e?(null===a?b.child=yg(b,null,e,c):Q(a,b,e),b.memoizedProps=e,a=b.child):a=R(a,b),a;case 14:return e=b.type.render,c=b.pendingProps,d=b.ref,O.current||b.memoizedProps!==c||d!==(null!==a?a.ref:null)?(e=e(c,d),Q(a,b,e),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 10:return c=b.pendingProps,O.current||b.memoizedProps!==c?(Q(a,b,c),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 11:return c=
b.pendingProps.children,O.current||null!==c&&b.memoizedProps!==c?(Q(a,b,c),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 15:return c=b.pendingProps,b.memoizedProps===c?a=R(a,b):(Q(a,b,c.children),b.memoizedProps=c,a=b.child),a;case 13:return Rg(a,b,c);case 12:a:if(d=b.type,f=b.pendingProps,k=b.memoizedProps,e=d._currentValue,g=d._changedBits,O.current||0!==g||k!==f){b.memoizedProps=f;h=f.unstable_observedBits;if(void 0===h||null===h)h=1073741823;b.stateNode=h;if(0!==(g&h))Ng(b,d,g,c);else if(k===f){a=
R(a,b);break a}c=f.children;c=c(e);b.effectTag|=1;Q(a,b,c);a=b.child}else a=R(a,b);return a;default:A("156")}}function Tg(a){a.effectTag|=4}var Ug=void 0,Vg=void 0,Wg=void 0;Ug=function(){};Vg=function(a,b,c){(b.updateQueue=c)&&Tg(b)};Wg=function(a,b,c,d){c!==d&&Tg(b)};
function Xg(a,b){var c=b.pendingProps;switch(b.tag){case 1:return null;case 2:return tf(b),null;case 3:kg(b);uf(b);var d=b.stateNode;d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===a||null===a.child)Hg(b),b.effectTag&=-3;Ug(b);return null;case 5:lg(b);d=hg(gg.current);var e=b.type;if(null!==a&&null!=b.stateNode){var f=a.memoizedProps,g=b.stateNode,h=hg(eg.current);g=Xe(g,e,f,c,d);Vg(a,b,g,e,f,c,d,h);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!c)return null===b.stateNode?
A("166"):void 0,null;a=hg(eg.current);if(Hg(b))c=b.stateNode,e=b.type,f=b.memoizedProps,c[C]=b,c[Ma]=f,d=Ze(c,e,f,a,d),b.updateQueue=d,null!==d&&Tg(b);else{a=Ue(e,c,d,a);a[C]=b;a[Ma]=c;a:for(f=b.child;null!==f;){if(5===f.tag||6===f.tag)a.appendChild(f.stateNode);else if(4!==f.tag&&null!==f.child){f.child.return=f;f=f.child;continue}if(f===b)break;for(;null===f.sibling;){if(null===f.return||f.return===b)break a;f=f.return}f.sibling.return=f.return;f=f.sibling}We(a,e,c,d);df(e,c)&&Tg(b);b.stateNode=
a}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)Wg(a,b,a.memoizedProps,c);else{if("string"!==typeof c)return null===b.stateNode?A("166"):void 0,null;d=hg(gg.current);hg(eg.current);Hg(b)?(d=b.stateNode,c=b.memoizedProps,d[C]=b,$e(d,c)&&Tg(b)):(d=Ve(c,d),d[C]=b,b.stateNode=d)}return null;case 14:return null;case 16:return null;case 10:return null;case 11:return null;case 15:return null;case 4:return kg(b),Ug(b),null;case 13:return cg(b),null;case 12:return null;case 0:A("167");
default:A("156")}}function Yg(a,b){var c=b.source;null===b.stack&&null!==c&&vc(c);null!==c&&uc(c);b=b.value;null!==a&&2===a.tag&&uc(a);try{b&&b.suppressReactErrorLogging||console.error(b)}catch(d){d&&d.suppressReactErrorLogging||console.error(d)}}function Zg(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){$g(a,c)}else b.current=null}
function ah(a){"function"===typeof Lf&&Lf(a);switch(a.tag){case 2:Zg(a);var b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){$g(a,c)}break;case 5:Zg(a);break;case 4:bh(a)}}function ch(a){return 5===a.tag||3===a.tag||4===a.tag}
function dh(a){a:{for(var b=a.return;null!==b;){if(ch(b)){var c=b;break a}b=b.return}A("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:A("161")}c.effectTag&16&&(Le(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||ch(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)if(c)if(d){var f=b,g=e.stateNode,h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(e.stateNode,c);else d?(f=b,g=e.stateNode,8===f.nodeType?f.parentNode.insertBefore(g,f):f.appendChild(g)):b.appendChild(e.stateNode);else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===
e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function bh(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b.return;a:for(;;){null===c?A("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c.return}c=!0}if(5===b.tag||6===b.tag){a:for(var f=b,g=f;;)if(ah(g),null!==g.child&&4!==g.tag)g.child.return=g,g=g.child;else{if(g===f)break;for(;null===g.sibling;){if(null===g.return||g.return===f)break a;g=g.return}g.sibling.return=g.return;g=g.sibling}e?
(f=d,g=b.stateNode,8===f.nodeType?f.parentNode.removeChild(g):f.removeChild(g)):d.removeChild(b.stateNode)}else if(4===b.tag?d=b.stateNode.containerInfo:ah(b),null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return;4===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}
function eh(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&(c[Ma]=d,Ye(c,f,e,a,d))}break;case 6:null===b.stateNode?A("162"):void 0;b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 15:break;case 16:break;default:A("163")}}function fh(a,b,c){c=Pf(c);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){gh(d);Yg(a,b)};return c}
function hh(a,b,c){c=Pf(c);c.tag=3;var d=a.stateNode;null!==d&&"function"===typeof d.componentDidCatch&&(c.callback=function(){null===ih?ih=new Set([this]):ih.add(this);var c=b.value,d=b.stack;Yg(a,b);this.componentDidCatch(c,{componentStack:null!==d?d:""})});return c}
function jh(a,b,c,d,e,f){c.effectTag|=512;c.firstEffect=c.lastEffect=null;d=Yf(d,c);a=b;do{switch(a.tag){case 3:a.effectTag|=1024;d=fh(a,d,f);Sf(a,d,f);return;case 2:if(b=d,c=a.stateNode,0===(a.effectTag&64)&&null!==c&&"function"===typeof c.componentDidCatch&&(null===ih||!ih.has(c))){a.effectTag|=1024;d=hh(a,b,f);Sf(a,d,f);return}}a=a.return}while(null!==a)}
function kh(a){switch(a.tag){case 2:tf(a);var b=a.effectTag;return b&1024?(a.effectTag=b&-1025|64,a):null;case 3:return kg(a),uf(a),b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 5:return lg(a),null;case 16:return b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 4:return kg(a),null;case 13:return cg(a),null;default:return null}}var lh=ff(),mh=2,nh=lh,oh=0,ph=0,qh=!1,S=null,rh=null,T=0,sh=-1,th=!1,U=null,uh=!1,vh=!1,ih=null;
function wh(){if(null!==S)for(var a=S.return;null!==a;){var b=a;switch(b.tag){case 2:tf(b);break;case 3:kg(b);uf(b);break;case 5:lg(b);break;case 4:kg(b);break;case 13:cg(b)}a=a.return}rh=null;T=0;sh=-1;th=!1;S=null;vh=!1}
function xh(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&512)){b=Xg(b,a,T);var e=a;if(1073741823===T||1073741823!==e.expirationTime){var f=0;switch(e.tag){case 3:case 2:var g=e.updateQueue;null!==g&&(f=g.expirationTime)}for(g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&0===(c.effectTag&512)&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&
(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;if(null!==c)a=c;else{vh=!0;break}}else{a=kh(a,th,T);if(null!==a)return a.effectTag&=511,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=512);if(null!==d)return d;if(null!==c)a=c;else break}}return null}
function yh(a){var b=Sg(a.alternate,a,T);null===b&&(b=xh(a));ec.current=null;return b}
function zh(a,b,c){qh?A("243"):void 0;qh=!0;if(b!==T||a!==rh||null===S)wh(),rh=a,T=b,sh=-1,S=Af(rh.current,null,T),a.pendingCommitExpirationTime=0;var d=!1;th=!c||T<=mh;do{try{if(c)for(;null!==S&&!Ah();)S=yh(S);else for(;null!==S;)S=yh(S)}catch(f){if(null===S)d=!0,gh(f);else{null===S?A("271"):void 0;c=S;var e=c.return;if(null===e){d=!0;gh(f);break}jh(a,e,c,f,th,T,nh);S=xh(c)}}break}while(1);qh=!1;if(d)return null;if(null===S){if(vh)return a.pendingCommitExpirationTime=b,a.current.alternate;th?A("262"):
void 0;0<=sh&&setTimeout(function(){var b=a.current.expirationTime;0!==b&&(0===a.remainingExpirationTime||a.remainingExpirationTime<b)&&Bh(a,b)},sh);Ch(a.current.expirationTime)}return null}
function $g(a,b){var c;a:{qh&&!uh?A("263"):void 0;for(c=a.return;null!==c;){switch(c.tag){case 2:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromCatch||"function"===typeof d.componentDidCatch&&(null===ih||!ih.has(d))){a=Yf(b,a);a=hh(c,a,1);Rf(c,a,1);pg(c,1);c=void 0;break a}break;case 3:a=Yf(b,a);a=fh(c,a,1);Rf(c,a,1);pg(c,1);c=void 0;break a}c=c.return}3===a.tag&&(c=Yf(b,a),c=fh(a,c,1),Rf(a,c,1),pg(a,1));c=void 0}return c}
function Dh(){var a=2+25*(((ng()-2+500)/25|0)+1);a<=oh&&(a=oh+1);return oh=a}function og(a,b){a=0!==ph?ph:qh?uh?1:T:b.mode&1?Eh?2+10*(((a-2+15)/10|0)+1):2+25*(((a-2+500)/25|0)+1):1;Eh&&(0===Fh||a>Fh)&&(Fh=a);return a}
function pg(a,b){for(;null!==a;){if(0===a.expirationTime||a.expirationTime>b)a.expirationTime=b;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>b)&&(a.alternate.expirationTime=b);if(null===a.return)if(3===a.tag){var c=a.stateNode;!qh&&0!==T&&b<T&&wh();var d=c.current.expirationTime;qh&&!uh&&rh===c||Bh(c,d);Gh>Hh&&A("185")}else break;a=a.return}}function ng(){nh=ff()-lh;return mh=(nh/10|0)+2}
function Ih(a){var b=ph;ph=2+25*(((ng()-2+500)/25|0)+1);try{return a()}finally{ph=b}}function Jh(a,b,c,d,e){var f=ph;ph=1;try{return a(b,c,d,e)}finally{ph=f}}var Kh=null,V=null,Lh=0,Mh=void 0,W=!1,X=null,Y=0,Fh=0,Nh=!1,Oh=!1,Ph=null,Qh=null,Z=!1,Rh=!1,Eh=!1,Sh=null,Hh=1E3,Gh=0,Th=1;function Uh(a){if(0!==Lh){if(a>Lh)return;null!==Mh&&hf(Mh)}var b=ff()-lh;Lh=a;Mh=gf(Vh,{timeout:10*(a-2)-b})}
function Bh(a,b){if(null===a.nextScheduledRoot)a.remainingExpirationTime=b,null===V?(Kh=V=a,a.nextScheduledRoot=a):(V=V.nextScheduledRoot=a,V.nextScheduledRoot=Kh);else{var c=a.remainingExpirationTime;if(0===c||b<c)a.remainingExpirationTime=b}W||(Z?Rh&&(X=a,Y=1,Wh(a,1,!1)):1===b?Xh():Uh(b))}
function Yh(){var a=0,b=null;if(null!==V)for(var c=V,d=Kh;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===V?A("244"):void 0;if(d===d.nextScheduledRoot){Kh=V=d.nextScheduledRoot=null;break}else if(d===Kh)Kh=e=d.nextScheduledRoot,V.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===V){V=c;V.nextScheduledRoot=Kh;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===V)break;
c=d;d=d.nextScheduledRoot}}c=X;null!==c&&c===b&&1===a?Gh++:Gh=0;X=b;Y=a}function Vh(a){Zh(0,!0,a)}function Xh(){Zh(1,!1,null)}function Zh(a,b,c){Qh=c;Yh();if(b)for(;null!==X&&0!==Y&&(0===a||a>=Y)&&(!Nh||ng()>=Y);)ng(),Wh(X,Y,!Nh),Yh();else for(;null!==X&&0!==Y&&(0===a||a>=Y);)Wh(X,Y,!1),Yh();null!==Qh&&(Lh=0,Mh=null);0!==Y&&Uh(Y);Qh=null;Nh=!1;$h()}function ai(a,b){W?A("253"):void 0;X=a;Y=b;Wh(a,b,!1);Xh();$h()}
function $h(){Gh=0;if(null!==Sh){var a=Sh;Sh=null;for(var b=0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(d){Oh||(Oh=!0,Ph=d)}}}if(Oh)throw a=Ph,Ph=null,Oh=!1,a;}function Wh(a,b,c){W?A("245"):void 0;W=!0;c?(c=a.finishedWork,null!==c?bi(a,c,b):(c=zh(a,b,!0),null!==c&&(Ah()?a.finishedWork=c:bi(a,c,b)))):(c=a.finishedWork,null!==c?bi(a,c,b):(c=zh(a,b,!1),null!==c&&bi(a,c,b)));W=!1}
function bi(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime<=c&&(null===Sh?Sh=[d]:Sh.push(d),d._defer)){a.finishedWork=b;a.remainingExpirationTime=0;return}a.finishedWork=null;uh=qh=!0;c=b.stateNode;c.current===b?A("177"):void 0;d=c.pendingCommitExpirationTime;0===d?A("261"):void 0;c.pendingCommitExpirationTime=0;ng();ec.current=null;if(1<b.effectTag)if(null!==b.lastEffect){b.lastEffect.nextEffect=b;var e=b.firstEffect}else e=b;else e=b.firstEffect;bf=Id;var f=da();if(Vd(f)){if("selectionStart"in
f)var g={start:f.selectionStart,end:f.selectionEnd};else a:{var h=window.getSelection&&window.getSelection();if(h&&0!==h.rangeCount){g=h.anchorNode;var k=h.anchorOffset,n=h.focusNode;h=h.focusOffset;try{g.nodeType,n.nodeType}catch(Wa){g=null;break a}var r=0,w=-1,P=-1,nc=0,Jd=0,E=f,t=null;b:for(;;){for(var x;;){E!==g||0!==k&&3!==E.nodeType||(w=r+k);E!==n||0!==h&&3!==E.nodeType||(P=r+h);3===E.nodeType&&(r+=E.nodeValue.length);if(null===(x=E.firstChild))break;t=E;E=x}for(;;){if(E===f)break b;t===g&&
++nc===k&&(w=r);t===n&&++Jd===h&&(P=r);if(null!==(x=E.nextSibling))break;E=t;t=E.parentNode}E=x}g=-1===w||-1===P?null:{start:w,end:P}}else g=null}g=g||{start:0,end:0}}else g=null;cf={focusedElem:f,selectionRange:g};Kd(!1);for(U=e;null!==U;){f=!1;g=void 0;try{for(;null!==U;){if(U.effectTag&256){var u=U.alternate;k=U;switch(k.tag){case 2:if(k.effectTag&256&&null!==u){var y=u.memoizedProps,D=u.memoizedState,ja=k.stateNode;ja.props=k.memoizedProps;ja.state=k.memoizedState;var ni=ja.getSnapshotBeforeUpdate(y,
D);ja.__reactInternalSnapshotBeforeUpdate=ni}break;case 3:case 5:case 6:case 4:break;default:A("163")}}U=U.nextEffect}}catch(Wa){f=!0,g=Wa}f&&(null===U?A("178"):void 0,$g(U,g),null!==U&&(U=U.nextEffect))}for(U=e;null!==U;){u=!1;y=void 0;try{for(;null!==U;){var q=U.effectTag;q&16&&Le(U.stateNode,"");if(q&128){var z=U.alternate;if(null!==z){var l=z.ref;null!==l&&("function"===typeof l?l(null):l.current=null)}}switch(q&14){case 2:dh(U);U.effectTag&=-3;break;case 6:dh(U);U.effectTag&=-3;eh(U.alternate,
U);break;case 4:eh(U.alternate,U);break;case 8:D=U,bh(D),D.return=null,D.child=null,D.alternate&&(D.alternate.child=null,D.alternate.return=null)}U=U.nextEffect}}catch(Wa){u=!0,y=Wa}u&&(null===U?A("178"):void 0,$g(U,y),null!==U&&(U=U.nextEffect))}l=cf;z=da();q=l.focusedElem;u=l.selectionRange;if(z!==q&&fa(document.documentElement,q)){null!==u&&Vd(q)&&(z=u.start,l=u.end,void 0===l&&(l=z),"selectionStart"in q?(q.selectionStart=z,q.selectionEnd=Math.min(l,q.value.length)):window.getSelection&&(z=window.getSelection(),
y=q[lb()].length,l=Math.min(u.start,y),u=void 0===u.end?l:Math.min(u.end,y),!z.extend&&l>u&&(y=u,u=l,l=y),y=Ud(q,l),D=Ud(q,u),y&&D&&(1!==z.rangeCount||z.anchorNode!==y.node||z.anchorOffset!==y.offset||z.focusNode!==D.node||z.focusOffset!==D.offset)&&(ja=document.createRange(),ja.setStart(y.node,y.offset),z.removeAllRanges(),l>u?(z.addRange(ja),z.extend(D.node,D.offset)):(ja.setEnd(D.node,D.offset),z.addRange(ja)))));z=[];for(l=q;l=l.parentNode;)1===l.nodeType&&z.push({element:l,left:l.scrollLeft,
top:l.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<z.length;q++)l=z[q],l.element.scrollLeft=l.left,l.element.scrollTop=l.top}cf=null;Kd(bf);bf=null;c.current=b;for(U=e;null!==U;){e=!1;q=void 0;try{for(z=d;null!==U;){var ig=U.effectTag;if(ig&36){var oc=U.alternate;l=U;u=z;switch(l.tag){case 2:var ca=l.stateNode;if(l.effectTag&4)if(null===oc)ca.props=l.memoizedProps,ca.state=l.memoizedState,ca.componentDidMount();else{var xi=oc.memoizedProps,yi=oc.memoizedState;ca.props=l.memoizedProps;
ca.state=l.memoizedState;ca.componentDidUpdate(xi,yi,ca.__reactInternalSnapshotBeforeUpdate)}var Og=l.updateQueue;null!==Og&&(ca.props=l.memoizedProps,ca.state=l.memoizedState,Xf(l,Og,ca,u));break;case 3:var Pg=l.updateQueue;if(null!==Pg){y=null;if(null!==l.child)switch(l.child.tag){case 5:y=l.child.stateNode;break;case 2:y=l.child.stateNode}Xf(l,Pg,y,u)}break;case 5:var zi=l.stateNode;null===oc&&l.effectTag&4&&df(l.type,l.memoizedProps)&&zi.focus();break;case 6:break;case 4:break;case 15:break;case 16:break;
default:A("163")}}if(ig&128){l=void 0;var yc=U.ref;if(null!==yc){var Qg=U.stateNode;switch(U.tag){case 5:l=Qg;break;default:l=Qg}"function"===typeof yc?yc(l):yc.current=l}}var Ai=U.nextEffect;U.nextEffect=null;U=Ai}}catch(Wa){e=!0,q=Wa}e&&(null===U?A("178"):void 0,$g(U,q),null!==U&&(U=U.nextEffect))}qh=uh=!1;"function"===typeof Kf&&Kf(b.stateNode);b=c.current.expirationTime;0===b&&(ih=null);a.remainingExpirationTime=b}function Ah(){return null===Qh||Qh.timeRemaining()>Th?!1:Nh=!0}
function gh(a){null===X?A("246"):void 0;X.remainingExpirationTime=0;Oh||(Oh=!0,Ph=a)}function Ch(a){null===X?A("246"):void 0;X.remainingExpirationTime=a}function ci(a,b){var c=Z;Z=!0;try{return a(b)}finally{(Z=c)||W||Xh()}}function di(a,b){if(Z&&!Rh){Rh=!0;try{return a(b)}finally{Rh=!1}}return a(b)}function ei(a,b){W?A("187"):void 0;var c=Z;Z=!0;try{return Jh(a,b)}finally{Z=c,Xh()}}
function fi(a,b,c){if(Eh)return a(b,c);Z||W||0===Fh||(Zh(Fh,!1,null),Fh=0);var d=Eh,e=Z;Z=Eh=!0;try{return a(b,c)}finally{Eh=d,(Z=e)||W||Xh()}}function gi(a){var b=Z;Z=!0;try{Jh(a)}finally{(Z=b)||W||Zh(1,!1,null)}}
function hi(a,b,c,d,e){var f=b.current;if(c){c=c._reactInternalFiber;var g;b:{2===kd(c)&&2===c.tag?void 0:A("170");for(g=c;3!==g.tag;){if(rf(g)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}(g=g.return)?void 0:A("171")}g=g.stateNode.context}c=rf(c)?wf(c,g):g}else c=ha;null===b.context?b.context=c:b.pendingContext=c;b=e;e=Pf(d);e.payload={element:a};b=void 0===b?null:b;null!==b&&(e.callback=b);Rf(f,e,d);pg(f,d);return d}
function ii(a){var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?A("188"):A("268",Object.keys(a)));a=nd(b);return null===a?null:a.stateNode}function ji(a,b,c,d){var e=b.current,f=ng();e=og(f,e);return hi(a,b,c,e,d)}function ki(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}
function li(a){var b=a.findFiberByHostInstance;return Jf(p({},a,{findHostInstanceByFiber:function(a){a=nd(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))}
var mi={updateContainerAtExpirationTime:hi,createContainer:function(a,b,c){return Ff(a,b,c)},updateContainer:ji,flushRoot:ai,requestWork:Bh,computeUniqueAsyncExpiration:Dh,batchedUpdates:ci,unbatchedUpdates:di,deferredUpdates:Ih,syncUpdates:Jh,interactiveUpdates:fi,flushInteractiveUpdates:function(){W||0===Fh||(Zh(Fh,!1,null),Fh=0)},flushControlled:gi,flushSync:ei,getPublicRootInstance:ki,findHostInstance:ii,findHostInstanceWithNoPortals:function(a){a=od(a);return null===a?null:a.stateNode},injectIntoDevTools:li};
function oi(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:hc,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}Kb.injectFiberControlledHostComponent(af);function pi(a){this._expirationTime=Dh();this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}
pi.prototype.render=function(a){this._defer?void 0:A("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new qi;hi(a,b,null,c,d._onCommit);return d};pi.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
pi.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:A("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?A("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;ai(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
null,this._defer=!1};pi.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function qi(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}qi.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
qi.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?A("191",c):void 0;c()}}};function ri(a,b,c){this._internalRoot=Ff(a,b,c)}ri.prototype.render=function(a,b){var c=this._internalRoot,d=new qi;b=void 0===b?null:b;null!==b&&d.then(b);ji(a,c,null,d._onCommit);return d};
ri.prototype.unmount=function(a){var b=this._internalRoot,c=new qi;a=void 0===a?null:a;null!==a&&c.then(a);ji(null,b,null,c._onCommit);return c};ri.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new qi;c=void 0===c?null:c;null!==c&&e.then(c);ji(b,d,a,e._onCommit);return e};
ri.prototype.createBatch=function(){var a=new pi(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime<=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function si(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Sb=mi.batchedUpdates;Tb=mi.interactiveUpdates;Ub=mi.flushInteractiveUpdates;
function ti(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new ri(a,!1,b)}
function ui(a,b,c,d,e){si(c)?void 0:A("200");var f=c._reactRootContainer;if(f){if("function"===typeof e){var g=e;e=function(){var a=ki(f._internalRoot);g.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=ti(c,d);if("function"===typeof e){var h=e;e=function(){var a=ki(f._internalRoot);h.call(a)}}di(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return ki(f._internalRoot)}
function vi(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;si(b)?void 0:A("200");return oi(a,b,null,c)}
var wi={createPortal:vi,findDOMNode:function(a){return null==a?null:1===a.nodeType?a:ii(a)},hydrate:function(a,b,c){return ui(null,a,b,!0,c)},render:function(a,b,c){return ui(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?A("38"):void 0;return ui(a,b,c,!1,d)},unmountComponentAtNode:function(a){si(a)?void 0:A("40");return a._reactRootContainer?(di(function(){ui(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return vi.apply(void 0,
arguments)},unstable_batchedUpdates:ci,unstable_deferredUpdates:Ih,unstable_interactiveUpdates:fi,flushSync:ei,unstable_flushControlled:gi,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:Ka,EventPluginRegistry:va,EventPropagators:$a,ReactControlledComponent:Rb,ReactDOMComponentTree:Qa,ReactDOMEventListener:Od},unstable_createRoot:function(a,b){return new ri(a,!0,null!=b&&!0===b.hydrate)}};li({findFiberByHostInstance:Na,bundleType:0,version:"16.4.2",rendererPackageName:"react-dom"});
var Bi={default:wi},Ci=Bi&&wi||Bi;module.exports=Ci.default?Ci.default:Ci;


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(162);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(163);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 164 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 165 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__salesforce_design_system_react__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__steps_altText_emailScreen__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__steps_altText_registerScreen__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__steps_altText_recap__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__steps_captions_keynoteSelectorScreen__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__steps_captions_recap__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__steps_keyboard_lunchSelectorScreen__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__steps_keyboard_recap__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__steps_color_sessionSelectorScreen__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__steps_color_recap__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__finale__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants__ = __webpack_require__(27);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
 * Dummy component used to easily create screenshot image 
import DiscountCode from './steps/altText/discountCode';
 *
*/var steps=[{title:'Step 1',instructions:'You\'ve received an email to register for '+__WEBPACK_IMPORTED_MODULE_14__constants__["a" /* CONFERENCE_NAME */]+'. Use discount code on Registration form.',screens:[{left:__WEBPACK_IMPORTED_MODULE_4__steps_altText_emailScreen__["a" /* default */],right:null},{left:__WEBPACK_IMPORTED_MODULE_4__steps_altText_emailScreen__["a" /* default */],right:__WEBPACK_IMPORTED_MODULE_5__steps_altText_registerScreen__["a" /* default */]},{left:__WEBPACK_IMPORTED_MODULE_4__steps_altText_emailScreen__["a" /* default */],right:__WEBPACK_IMPORTED_MODULE_6__steps_altText_recap__["a" /* default */]}]},{title:'Step 2',instructions:'Preview these speakers\' unique stories below and choose a keynote to attend.',screens:[{left:__WEBPACK_IMPORTED_MODULE_7__steps_captions_keynoteSelectorScreen__["a" /* default */],right:null},{left:__WEBPACK_IMPORTED_MODULE_7__steps_captions_keynoteSelectorScreen__["a" /* default */],right:__WEBPACK_IMPORTED_MODULE_8__steps_captions_recap__["a" /* default */]}]},{title:'Step 3',instructions:'Sign up for two awesome workshops.',screens:[{left:__WEBPACK_IMPORTED_MODULE_11__steps_color_sessionSelectorScreen__["a" /* default */],right:null},{left:__WEBPACK_IMPORTED_MODULE_11__steps_color_sessionSelectorScreen__["a" /* default */],right:__WEBPACK_IMPORTED_MODULE_12__steps_color_recap__["a" /* default */]}]},{title:'Step 4',instructions:'Your mouse died! Tab to the Meal dropdown and use your arrow keys to select your lunch.',screens:[{left:__WEBPACK_IMPORTED_MODULE_9__steps_keyboard_lunchSelectorScreen__["a" /* default */],right:null},{left:__WEBPACK_IMPORTED_MODULE_9__steps_keyboard_lunchSelectorScreen__["a" /* default */],right:__WEBPACK_IMPORTED_MODULE_10__steps_keyboard_recap__["a" /* default */]}]},{title:null,instructions:'Thanks for joining us!',screens:[{left:__WEBPACK_IMPORTED_MODULE_13__finale__["a" /* default */],right:null}]}];var screens=[];var _loop=function _loop(i){screens=screens.concat(steps[i].screens.map(function(screen){return{step:i,left:screen.left,right:screen.right};}));};for(var i=0;i<steps.length;i++){_loop(i);}var App=function(_Component){_inherits(App,_Component);function App(props){_classCallCheck(this,App);var _this=_possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).call(this,props));_this.getFirstScreenIndex=function(step){for(var i=0;i<this.state.screens.length;i++){if(this.state.screens[i].step===step){return i;}}};_this.getLastScreenIndex=function(step){for(var i=this.state.screens.length-1;i>=0;i--){if(this.state.screens[i].step===step){return i;}}};_this.incrementStep=function(){if(this.state.currentStepIndex<this.state.steps.length){var newScreenIndex=this.getFirstScreenIndex(this.state.currentStepIndex+1);this.setCurrentScreen(newScreenIndex);}};_this.decrementStep=function(){if(this.state.currentStepIndex>0){var newScreenIndex=this.getFirstScreenIndex(this.state.currentStepIndex-1);this.setCurrentScreen(newScreenIndex);}};_this.nextScreen=function(){if(this.state.currentScreenIndex<this.state.screens.length-1){this.setCurrentScreen(this.state.currentScreenIndex+1);}else{this.reset();}};_this.state={screens:screens,currentScreen:screens[0],currentScreenIndex:0,appStarted:false,steps:steps,currentStep:steps[0],currentStepIndex:0};_this.settingsOpenButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.settingsCloseButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.appStarted=_this.appStarted.bind(_this);_this.nextScreen=_this.nextScreen.bind(_this);_this.decrementStep=_this.decrementStep.bind(_this);_this.incrementStep=_this.incrementStep.bind(_this);_this.reset=_this.reset.bind(_this);return _this;}_createClass(App,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(prevState.showSettings!==this.state.showSettings){var buttonToFocus=this.state.showSettings?this.settingsCloseButton:this.settingsOpenButton;__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(buttonToFocus.current).focus();}}},{key:'setCurrentScreen',value:function setCurrentScreen(screenIndex){var screen=this.state.screens[screenIndex];var stepIndex=screen.step;this.setState({currentScreen:screen,currentScreenIndex:screenIndex,currentStep:this.state.steps[stepIndex],currentStepIndex:stepIndex});}},{key:'reset',value:function reset(){window.location.reload();}},{key:'renderPreviousStepButton',value:function renderPreviousStepButton(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slds-float_left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__salesforce_design_system_react__["c" /* Button */],{disabled:this.state.currentStepIndex===0?true:null,assistiveText:{icon:'Previous Step'},iconCategory:'utility',iconName:'back',iconSize:'large',inverse:true,onClick:this.decrementStep,title:'Previous Step',variant:'icon'}));}},{key:'appStarted',value:function appStarted(){return this.setState({appStarted:true});}},{key:'renderNextStepButton',value:function renderNextStepButton(){if(this.state.steps.length>this.state.currentStepIndex+1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slds-float_right'},!this.state.appStarted?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__salesforce_design_system_react__["c" /* Button */],{className:'phl pvs caps f3',onClick:this.appStarted,label:'Start',variant:'brand'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__salesforce_design_system_react__["c" /* Button */],{assistiveText:{icon:'Next Step'},iconCategory:'utility',iconName:'forward',iconSize:'large',inverse:true,onClick:this.incrementStep,title:'Next Step',variant:'icon'}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slds-float_right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__salesforce_design_system_react__["c" /* Button */],{onClick:this.reset,label:'Restart',variant:'neutral'}));}}},{key:'renderContinueButton',value:function renderContinueButton(){if(this.state.currentScreenIndex<this.state.screens.length-1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__salesforce_design_system_react__["c" /* Button */],{label:'Continue',onClick:this.nextScreen,variant:'brand'});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__salesforce_design_system_react__["c" /* Button */],{label:'Reset',onClick:this.reset,variant:'destructive'});}}},{key:'renderLeft',value:function renderLeft(screen){var Left=screen.left;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Left,{appStarted:this.state.appStarted,accessible:this.state.accessible,currentScreenIndex:this.state.currentScreenIndex,nextFunc:this.nextScreen,nextDisabled:this.state.currentScreen.right?true:false});}},{key:'renderRight',value:function renderRight(screen){if(screen.right){var Right=screen.right;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Right,{accessible:this.state.accessible,nextFunc:this.nextScreen});}return null;}},{key:'renderSettings',value:function renderSettings(){var _this2=this;if(this.state.showSettings){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'temporary-accessible-toggle bg-white bra-25'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__salesforce_design_system_react__["c" /* Button */],{assistiveText:{icon:'Close Demo Settings'},iconCategory:'utility',iconName:'close',iconSize:'large',onClick:function onClick(){_this2.setState({showSettings:false});},title:'Next Step',variant:'icon',className:'slds-float_right slds-popover__close',ref:this.settingsCloseButton}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'slds-popover__header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'slds-text-heading_small bold'},'Demo Settings')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slds-popover__body pvm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__salesforce_design_system_react__["d" /* Checkbox */],{label:'Accessible UI',id:'accessibleToggle',variant:'toggle',onChange:function onChange(e){_this2.setState({accessible:!_this2.state.accessible});}})));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'temporary-accessible-toggle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__salesforce_design_system_react__["c" /* Button */],{assistiveText:{icon:'Demo Settings'},iconCategory:'utility',iconName:'settings',iconSize:'large',inverse:true,onClick:function onClick(){_this2.setState({showSettings:true});},title:'Next Step',variant:'icon',className:'pas mas',ref:this.settingsOpenButton}));}}},{key:'render',value:function render(){var step=this.state.currentStep;var screen=this.state.currentScreen;var backgroundStyle={backgroundImage:'url("assets/images/sample-background.jpeg")',backgroundAttachment:'fixed',backgroundSize:'cover',top:0,bottom:0,left:0,right:0,position:'fixed',overflow:'auto'};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'App',style:backgroundStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'app-header bg-darkblue text-white slds-clearfix','aria-label':'Instructions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'slds-text-heading_large dib','aria-live':'polite','aria-atomic':'true'},step.title?step.title+': ':null,step.instructions),this.renderPreviousStepButton(),this.renderNextStepButton()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ptl ht-90 slds-grid'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'ht-full screen-animation-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ht-full screen horz-center'},this.renderLeft(screen))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('ht-full screen-animation-container',{'dn':!screen.right,'show-right-screen':screen.right})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ht-full screen horz-center'},this.renderRight(screen)))),this.renderSettings());}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bodyOpenClassName = exports.portalClassName = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(13);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalPortal = __webpack_require__(170);

var _ModalPortal2 = _interopRequireDefault(_ModalPortal);

var _ariaAppHider = __webpack_require__(76);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _safeHTMLElement = __webpack_require__(77);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _reactLifecyclesCompat = __webpack_require__(175);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var portalClassName = exports.portalClassName = "ReactModalPortal";
var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";

var isReact16 = _reactDom2.default.createPortal !== undefined;
var createPortal = isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
      var parent = getParentElement(_this.props.parentSelector);
      parent.removeChild(_this.node);
    }, _this.portalRef = function (ref) {
      _this.portal = ref;
    }, _this.renderPortal = function (props) {
      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
      _this.portalRef(portal);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_safeHTMLElement.canUseDOM) return;

      if (!isReact16) {
        this.node = document.createElement("div");
      }
      this.node.className = this.props.portalClassName;

      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      var prevParent = getParentElement(prevProps.parentSelector);
      var nextParent = getParentElement(this.props.parentSelector);
      return { prevParent: prevParent, nextParent: nextParent };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, _, snapshot) {
      if (!_safeHTMLElement.canUseDOM) return;
      var _props = this.props,
          isOpen = _props.isOpen,
          portalClassName = _props.portalClassName;


      if (prevProps.portalClassName !== portalClassName) {
        this.node.className = portalClassName;
      }

      // Stop unnecessary renders if modal is remaining closed
      if (!prevProps.isOpen && !isOpen) return;

      var prevParent = snapshot.prevParent,
          nextParent = snapshot.nextParent;

      if (nextParent !== prevParent) {
        prevParent.removeChild(this.node);
        nextParent.appendChild(this.node);
      }

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;

      var state = this.portal.state;
      var now = Date.now();
      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);

      if (closesAt) {
        if (!state.beforeClose) {
          this.portal.closeWithTimeout();
        }

        setTimeout(this.removePortal, closesAt - now);
      } else {
        this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!_safeHTMLElement.canUseDOM || !isReact16) {
        return null;
      }

      if (!this.node && isReact16) {
        this.node = document.createElement("div");
      }

      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
        ref: this.portalRef,
        defaultStyles: Modal.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function setAppElement(element) {
      ariaAppHider.setElement(element);
    }

    /* eslint-disable react/no-unused-prop-types */

    /* eslint-enable react/no-unused-prop-types */

  }]);

  return Modal;
}(_react.Component);

Modal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  portalClassName: _propTypes2.default.string,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  ariaHideApp: _propTypes2.default.bool,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  parentSelector: _propTypes2.default.func,
  aria: _propTypes2.default.object,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func
};
Modal.defaultProps = {
  isOpen: false,
  portalClassName: portalClassName,
  bodyOpenClassName: bodyOpenClassName,
  ariaHideApp: true,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: true,
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: true,
  shouldReturnFocusAfterClose: true,
  parentSelector: function parentSelector() {
    return document.body;
  }
};
Modal.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};


(0, _reactLifecyclesCompat.polyfill)(Modal);

exports.default = Modal;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(169);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _focusManager = __webpack_require__(171);

var focusManager = _interopRequireWildcard(_focusManager);

var _scopeTab = __webpack_require__(172);

var _scopeTab2 = _interopRequireDefault(_scopeTab);

var _ariaAppHider = __webpack_require__(76);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _classList = __webpack_require__(173);

var classList = _interopRequireWildcard(_classList);

var _safeHTMLElement = __webpack_require__(77);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: "ReactModal__Overlay",
  content: "ReactModal__Content"
};

var TAB_KEY = 9;
var ESC_KEY = 27;

var ariaHiddenInstances = 0;

var ModalPortal = function (_Component) {
  _inherits(ModalPortal, _Component);

  function ModalPortal(props) {
    _classCallCheck(this, ModalPortal);

    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));

    _this.setOverlayRef = function (overlay) {
      _this.overlay = overlay;
      _this.props.overlayRef && _this.props.overlayRef(overlay);
    };

    _this.setContentRef = function (content) {
      _this.content = content;
      _this.props.contentRef && _this.props.contentRef(content);
    };

    _this.afterClose = function () {
      var _this$props = _this.props,
          appElement = _this$props.appElement,
          ariaHideApp = _this$props.ariaHideApp,
          htmlOpenClassName = _this$props.htmlOpenClassName,
          bodyOpenClassName = _this$props.bodyOpenClassName;

      // Remove classes.

      classList.remove(document.body, bodyOpenClassName);

      htmlOpenClassName && classList.remove(document.getElementsByTagName("html")[0], htmlOpenClassName);

      // Reset aria-hidden attribute if all modals have been removed
      if (ariaHideApp && ariaHiddenInstances > 0) {
        ariaHiddenInstances -= 1;

        if (ariaHiddenInstances === 0) {
          ariaAppHider.show(appElement);
        }
      }

      if (_this.props.shouldFocusAfterRender) {
        if (_this.props.shouldReturnFocusAfterClose) {
          focusManager.returnFocus();
          focusManager.teardownScopedFocus();
        } else {
          focusManager.popWithoutFocus();
        }
      }
    };

    _this.open = function () {
      _this.beforeOpen();
      if (_this.state.afterOpen && _this.state.beforeClose) {
        clearTimeout(_this.closeTimer);
        _this.setState({ beforeClose: false });
      } else {
        if (_this.props.shouldFocusAfterRender) {
          focusManager.setupScopedFocus(_this.node);
          focusManager.markForFocusLater();
        }

        _this.setState({ isOpen: true }, function () {
          _this.setState({ afterOpen: true });

          if (_this.props.isOpen && _this.props.onAfterOpen) {
            _this.props.onAfterOpen();
          }
        });
      }
    };

    _this.close = function () {
      if (_this.props.closeTimeoutMS > 0) {
        _this.closeWithTimeout();
      } else {
        _this.closeWithoutTimeout();
      }
    };

    _this.focusContent = function () {
      return _this.content && !_this.contentHasFocus() && _this.content.focus();
    };

    _this.closeWithTimeout = function () {
      var closesAt = Date.now() + _this.props.closeTimeoutMS;
      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
      });
    };

    _this.closeWithoutTimeout = function () {
      _this.setState({
        beforeClose: false,
        isOpen: false,
        afterOpen: false,
        closesAt: null
      }, _this.afterClose);
    };

    _this.handleKeyDown = function (event) {
      if (event.keyCode === TAB_KEY) {
        (0, _scopeTab2.default)(_this.content, event);
      }

      if (_this.props.shouldCloseOnEsc && event.keyCode === ESC_KEY) {
        event.stopPropagation();
        _this.requestClose(event);
      }
    };

    _this.handleOverlayOnClick = function (event) {
      if (_this.shouldClose === null) {
        _this.shouldClose = true;
      }

      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
        if (_this.ownerHandlesClose()) {
          _this.requestClose(event);
        } else {
          _this.focusContent();
        }
      }
      _this.shouldClose = null;
    };

    _this.handleContentOnMouseUp = function () {
      _this.shouldClose = false;
    };

    _this.handleOverlayOnMouseDown = function (event) {
      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
        event.preventDefault();
      }
    };

    _this.handleContentOnClick = function () {
      _this.shouldClose = false;
    };

    _this.handleContentOnMouseDown = function () {
      _this.shouldClose = false;
    };

    _this.requestClose = function (event) {
      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
    };

    _this.ownerHandlesClose = function () {
      return _this.props.onRequestClose;
    };

    _this.shouldBeClosed = function () {
      return !_this.state.isOpen && !_this.state.beforeClose;
    };

    _this.contentHasFocus = function () {
      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
    };

    _this.buildClassName = function (which, additional) {
      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
        base: CLASS_NAMES[which],
        afterOpen: CLASS_NAMES[which] + "--after-open",
        beforeClose: CLASS_NAMES[which] + "--before-close"
      };
      var className = classNames.base;
      if (_this.state.afterOpen) {
        className = className + " " + classNames.afterOpen;
      }
      if (_this.state.beforeClose) {
        className = className + " " + classNames.beforeClose;
      }
      return typeof additional === "string" && additional ? className + " " + additional : className;
    };

    _this.ariaAttributes = function (items) {
      return Object.keys(items).reduce(function (acc, name) {
        acc["aria-" + name] = items[name];
        return acc;
      }, {});
    };

    _this.state = {
      afterOpen: false,
      beforeClose: false
    };

    _this.shouldClose = null;
    _this.moveFromContentToOverlay = null;
    return _this;
  }

  _createClass(ModalPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isOpen) {
        this.open();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (false) {
        if (prevProps.bodyOpenClassName !== this.props.bodyOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "bodyOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
        if (prevProps.htmlOpenClassName !== this.props.htmlOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "htmlOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
      }

      if (this.props.isOpen && !prevProps.isOpen) {
        this.open();
      } else if (!this.props.isOpen && prevProps.isOpen) {
        this.close();
      }

      // Focus only needs to be set once when the modal is being opened
      if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
        this.focusContent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.afterClose();
      clearTimeout(this.closeTimer);
    }
  }, {
    key: "beforeOpen",
    value: function beforeOpen() {
      var _props = this.props,
          appElement = _props.appElement,
          ariaHideApp = _props.ariaHideApp,
          htmlOpenClassName = _props.htmlOpenClassName,
          bodyOpenClassName = _props.bodyOpenClassName;

      // Add classes.

      classList.add(document.body, bodyOpenClassName);

      htmlOpenClassName && classList.add(document.getElementsByTagName("html")[0], htmlOpenClassName);

      if (ariaHideApp) {
        ariaHiddenInstances += 1;
        ariaAppHider.hide(appElement);
      }
    }

    // Don't steal focus from inner elements

  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          className = _props2.className,
          overlayClassName = _props2.overlayClassName,
          defaultStyles = _props2.defaultStyles;

      var contentStyles = className ? {} : defaultStyles.content;
      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;

      return this.shouldBeClosed() ? null : _react2.default.createElement(
        "div",
        {
          ref: this.setOverlayRef,
          className: this.buildClassName("overlay", overlayClassName),
          style: _extends({}, overlayStyles, this.props.style.overlay),
          onClick: this.handleOverlayOnClick,
          onMouseDown: this.handleOverlayOnMouseDown,
          "aria-modal": "true"
        },
        _react2.default.createElement(
          "div",
          _extends({
            ref: this.setContentRef,
            style: _extends({}, contentStyles, this.props.style.content),
            className: this.buildClassName("content", className),
            tabIndex: "-1",
            onKeyDown: this.handleKeyDown,
            onMouseDown: this.handleContentOnMouseDown,
            onMouseUp: this.handleContentOnMouseUp,
            onClick: this.handleContentOnClick,
            role: this.props.role,
            "aria-label": this.props.contentLabel
          }, this.ariaAttributes(this.props.aria || {}), {
            "data-testid": this.props.testId
          }),
          this.props.children
        )
      );
    }
  }]);

  return ModalPortal;
}(_react.Component);

ModalPortal.defaultProps = {
  style: {
    overlay: {},
    content: {}
  },
  defaultStyles: {}
};
ModalPortal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  defaultStyles: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  ariaHideApp: _propTypes2.default.bool,
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  aria: _propTypes2.default.object,
  children: _propTypes2.default.node,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  testId: _propTypes2.default.string
};
exports.default = ModalPortal;
module.exports = exports["default"];

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleBlur = handleBlur;
exports.handleFocus = handleFocus;
exports.markForFocusLater = markForFocusLater;
exports.returnFocus = returnFocus;
exports.popWithoutFocus = popWithoutFocus;
exports.setupScopedFocus = setupScopedFocus;
exports.teardownScopedFocus = teardownScopedFocus;

var _tabbable = __webpack_require__(75);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;

function handleBlur() {
  needToFocus = true;
}

function handleFocus() {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.
    setTimeout(function () {
      if (modalElement.contains(document.activeElement)) {
        return;
      }
      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}

function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}

/* eslint-disable no-console */
function returnFocus() {
  var toFocus = null;
  try {
    if (focusLaterElements.length !== 0) {
      toFocus = focusLaterElements.pop();
      toFocus.focus();
    }
    return;
  } catch (e) {
    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
  }
}
/* eslint-enable no-console */

function popWithoutFocus() {
  focusLaterElements.length > 0 && focusLaterElements.pop();
}

function setupScopedFocus(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener("blur", handleBlur, false);
    document.addEventListener("focus", handleFocus, true);
  } else {
    window.attachEvent("onBlur", handleBlur);
    document.attachEvent("onFocus", handleFocus);
  }
}

function teardownScopedFocus() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener("blur", handleBlur);
    document.removeEventListener("focus", handleFocus);
  } else {
    window.detachEvent("onBlur", handleBlur);
    document.detachEvent("onFocus", handleFocus);
  }
}

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scopeTab;

var _tabbable = __webpack_require__(75);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scopeTab(node, event) {
  var tabbable = (0, _tabbable2.default)(node);

  if (!tabbable.length) {
    // Do nothing, since there are no elements that can receive focus.
    event.preventDefault();
    return;
  }

  var shiftKey = event.shiftKey;
  var head = tabbable[0];
  var tail = tabbable[tabbable.length - 1];

  // proceed with default browser behavior on tab.
  // Focus on last element on shift + tab.
  if (node === document.activeElement) {
    if (!shiftKey) return;
    target = tail;
  }

  var target;
  if (tail === document.activeElement && !shiftKey) {
    target = head;
  }

  if (head === document.activeElement && shiftKey) {
    target = tail;
  }

  if (target) {
    event.preventDefault();
    target.focus();
    return;
  }

  // Safari radio issue.
  //
  // Safari does not move the focus to the radio button,
  // so we need to force it to really walk through all elements.
  //
  // This is very error prune, since we are trying to guess
  // if it is a safari browser from the first occurence between
  // chrome or safari.
  //
  // The chrome user agent contains the first ocurrence
  // as the 'chrome/version' and later the 'safari/version'.
  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;

  // If we are not in safari desktop, let the browser control
  // the focus
  if (!isSafariDesktop) return;

  var x = tabbable.indexOf(document.activeElement);

  if (x > -1) {
    x += shiftKey ? -1 : 1;
  }

  event.preventDefault();

  tabbable[x].focus();
}
module.exports = exports["default"];

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dumpClassLists = dumpClassLists;
var htmlClassList = {};
var docBodyClassList = {};

function dumpClassLists() {
  if (false) {
    var classes = document.getElementsByTagName("html")[0].className;
    var buffer = "Show tracked classes:\n\n";

    buffer += "<html /> (" + classes + "):\n";
    for (var x in htmlClassList) {
      buffer += "  " + x + " " + htmlClassList[x] + "\n";
    }

    classes = document.body.className;

    // eslint-disable-next-line max-len
    buffer += "\n\ndoc.body (" + classes + "):\n";
    for (var _x in docBodyClassList) {
      buffer += "  " + _x + " " + docBodyClassList[_x] + "\n";
    }

    buffer += "\n";

    // eslint-disable-next-line no-console
    console.log(buffer);
  }
}

/**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var incrementReference = function incrementReference(poll, className) {
  if (!poll[className]) {
    poll[className] = 0;
  }
  poll[className] += 1;
  return className;
};

/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var decrementReference = function decrementReference(poll, className) {
  if (poll[className]) {
    poll[className] -= 1;
  }
  return className;
};

/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */
var trackClass = function trackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    incrementReference(poll, className);
    classListRef.add(className);
  });
};

/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */
var untrackClass = function untrackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    decrementReference(poll, className);
    poll[className] === 0 && classListRef.remove(className);
  });
};

/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var add = exports.add = function add(element, classString) {
  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var remove = exports.remove = function remove(element, classString) {
  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return ExecutionEnvironment;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var alphabet = __webpack_require__(36);
var build = __webpack_require__(178);
var isValid = __webpack_require__(182);

// if you are using cluster or multiple servers use this to make each instance
// has a unique value for worker
// Note: I don't know if this is automatically set when using third
// party cluster solutions such as pm2.
var clusterWorkerId = __webpack_require__(183) || 0;

/**
 * Set the seed.
 * Highly recommended if you don't want people to try to figure out your id schema.
 * exposed as shortid.seed(int)
 * @param seed Integer value to seed the random alphabet.  ALWAYS USE THE SAME SEED or you might get overlaps.
 */
function seed(seedValue) {
    alphabet.seed(seedValue);
    return module.exports;
}

/**
 * Set the cluster worker or machine id
 * exposed as shortid.worker(int)
 * @param workerId worker must be positive integer.  Number less than 16 is recommended.
 * returns shortid module so it can be chained.
 */
function worker(workerId) {
    clusterWorkerId = workerId;
    return module.exports;
}

/**
 *
 * sets new characters to use in the alphabet
 * returns the shuffled alphabet
 */
function characters(newCharacters) {
    if (newCharacters !== undefined) {
        alphabet.characters(newCharacters);
    }

    return alphabet.shuffled();
}

/**
 * Generate unique id
 * Returns string id
 */
function generate() {
  return build(clusterWorkerId);
}

// Export all other functions as properties of the generate function
module.exports = generate;
module.exports.generate = generate;
module.exports.seed = seed;
module.exports.worker = worker;
module.exports.characters = characters;
module.exports.isValid = isValid;


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Found this seed-based random generator somewhere
// Based on The Central Randomizer 1.3 (C) 1997 by Paul Houle (houle@msc.cornell.edu)

var seed = 1;

/**
 * return a random number based on a seed
 * @param seed
 * @returns {number}
 */
function getNextValue() {
    seed = (seed * 9301 + 49297) % 233280;
    return seed/(233280.0);
}

function setSeed(_seed_) {
    seed = _seed_;
}

module.exports = {
    nextValue: getNextValue,
    seed: setSeed
};


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var generate = __webpack_require__(179);
var alphabet = __webpack_require__(36);

// Ignore all milliseconds before a certain time to reduce the size of the date entropy without sacrificing uniqueness.
// This number should be updated every year or so to keep the generated id short.
// To regenerate `new Date() - 0` and bump the version. Always bump the version!
var REDUCE_TIME = 1459707606518;

// don't change unless we change the algos or REDUCE_TIME
// must be an integer and less than 16
var version = 6;

// Counter is used when shortid is called multiple times in one second.
var counter;

// Remember the last time shortid was called in case counter is needed.
var previousSeconds;

/**
 * Generate unique id
 * Returns string id
 */
function build(clusterWorkerId) {
    var str = '';

    var seconds = Math.floor((Date.now() - REDUCE_TIME) * 0.001);

    if (seconds === previousSeconds) {
        counter++;
    } else {
        counter = 0;
        previousSeconds = seconds;
    }

    str = str + generate(version);
    str = str + generate(clusterWorkerId);
    if (counter > 0) {
        str = str + generate(counter);
    }
    str = str + generate(seconds);
    return str;
}

module.exports = build;


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var alphabet = __webpack_require__(36);
var random = __webpack_require__(180);
var format = __webpack_require__(181);

function generate(number) {
    var loopCounter = 0;
    var done;

    var str = '';

    while (!done) {
        str = str + format(random, alphabet.get(), 1);
        done = number < (Math.pow(16, loopCounter + 1 ) );
        loopCounter++;
    }
    return str;
}

module.exports = generate;


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var crypto = typeof window === 'object' && (window.crypto || window.msCrypto); // IE 11 uses window.msCrypto

var randomByte;

if (!crypto || !crypto.getRandomValues) {
    randomByte = function(size) {
        var bytes = [];
        for (var i = 0; i < size; i++) {
            bytes.push(Math.floor(Math.random() * 256));
        }
        return bytes;
    };
} else {
    randomByte = function(size) {
        return crypto.getRandomValues(new Uint8Array(size));
    };
}

module.exports = randomByte;


/***/ }),
/* 181 */
/***/ (function(module, exports) {

/**
 * Secure random string generator with custom alphabet.
 *
 * Alphabet must contain 256 symbols or less. Otherwise, the generator
 * will not be secure.
 *
 * @param {generator} random The random bytes generator.
 * @param {string} alphabet Symbols to be used in new random string.
 * @param {size} size The number of symbols in new random string.
 *
 * @return {string} Random string.
 *
 * @example
 * const format = require('nanoid/format')
 *
 * function random (size) {
 *   const result = []
 *   for (let i = 0; i < size; i++) {
 *     result.push(randomByte())
 *   }
 *   return result
 * }
 *
 * format(random, "abcdef", 5) //=> "fbaef"
 *
 * @name format
 * @function
 */
module.exports = function (random, alphabet, size) {
  var mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1
  var step = Math.ceil(1.6 * mask * size / alphabet.length)

  var id = ''
  while (true) {
    var bytes = random(step)
    for (var i = 0; i < step; i++) {
      var byte = bytes[i] & mask
      if (alphabet[byte]) {
        id += alphabet[byte]
        if (id.length === size) return id
      }
    }
  }
}

/**
 * @callback generator
 * @param {number} bytes The number of bytes to generate.
 * @return {number[]} Random bytes.
 */


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var alphabet = __webpack_require__(36);

function isShortId(id) {
    if (!id || typeof id !== 'string' || id.length < 6 ) {
        return false;
    }

    var nonAlphabetic = new RegExp('[^' +
      alphabet.get().replace(/[|\\{}()[\]^$+*?.-]/g, '\\$&') +
    ']');
    return !nonAlphabetic.test(id);
}

module.exports = isShortId;


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = 0;


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(35);

var emptyObject = __webpack_require__(45);
var _invariant = __webpack_require__(44);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_warning_sunset_property__ = __webpack_require__(11);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable import/no-mutable-exports */


var checkProps = function checkProps() {};

if (false) {
  checkProps = function checkProps(COMPONENT, props) {
    /* eslint-disable max-len */
    sunsetProperty(COMPONENT, props.assistiveText, 'assistiveText', 'The wrapping span and assistive text has been removed from this component in order to make it a more pure "higher-level component" of `UtilityIcon`.');
  };
}

/* harmony default export */ __webpack_exports__["a"] = (checkProps);
//# sourceMappingURL=check-props.js.map

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_warning_url_exists__ = __webpack_require__(187);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable import/no-mutable-exports */


var checkProps = function checkProps() {};

if (false) {
  checkProps = function checkProps(COMPONENT, props) {
    if (!props.context["".concat(props.category, "Sprite")]) {
      var modifiedPath = props.path || props.context.iconPath;
      urlExists(COMPONENT, "".concat(modifiedPath, "/").concat(props.category, "-sprite/svg/symbols.svg#").concat(props.name));
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (checkProps);
//# sourceMappingURL=check-props.js.map

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable import/no-mutable-exports */

/* global XMLHttpRequest, window */
// This function does an "AJAX" request to warn users on how to setup their icon path.


var urlExists = function urlExists() {};

if (false) {
  var hasWarned = {};
  var hasExecuted;

  var warn = function warn(control, url, comment) {
    return function (res) {
      hasExecuted = true;

      if (res.status === 404) {
        var additionalComment = comment ? " ".concat(comment) : '';
        /* eslint-disable max-len */

        warning(!url, "The icon asset was not found at ".concat(url, ". Make sure the path to the icon asset is correct. You can set the icon path by importing the IconSettings component, `<IconSettings iconPath=[/assets/icons]>` from `components/iconSettings`, and wrap that component around your entire app or around individual components using icons. If you are using the `<Icon>` component, you can also pass the url to `this.props.path`.").concat(additionalComment));
        /* eslint-enable max-len */

        hasWarned["".concat(control, "-path")] = !!url;
      }
    };
  };

  var shouldWarn = function shouldWarn(control) {
    return !hasExecuted && !hasWarned["".concat(control, "-path")] && typeof window !== 'undefined' && process.env.NODE_ENV !== 'test';
  };

  if (typeof fetch === 'function') {
    urlExists = function urlExists(control, url, comment) {
      if (shouldWarn(control)) {
        fetch(url).then(warn(control, url, comment));
      }
    };
  } else {
    // Using XMLHttpRequest can cause problems in non-browser environments. This should be completely removed in production environment and should not execute in a testing environment.
    urlExists = function urlExists(control, url, comment) {
      if (shouldWarn(control) && XMLHttpRequest) {
        var http = new XMLHttpRequest();
        http.open('GET', url, false);
        http.send();
        warn(control, url, comment)(http);
      }
    };
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (urlExists);
//# sourceMappingURL=url-exists.js.map

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
var icons = {};

if (false) {
  icons = {
    activity: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.4 5.4c-.7.2-1.3.4-1.8.6-.3.2-.7.5-1.3.8.1.9.1 1.6 0 2.2 0 .6-.1 1.5-.3 2.6 1.3.9 2.2 1.6 2.8 2.1l.4.4 2-.9c.3-.6.6-1.5.7-2.5.2-.9.2-1.9.1-2.9l-2.6-2.4zm-.7-1.2l-.1-.2c-1.3-.8-2.9-1.2-4.6-1.2-.9 0-1.8.1-2.6.3v1.3c.8.1 1.4.2 2 .4.5.2 1.2.5 2 .9.7-.4 1.2-.7 1.6-.9.5-.2 1-.4 1.7-.6zm-6.5 15.6c1.7-.2 2.8-.3 3.4-.5.7-.1 1.3-.3 1.8-.5.4-.9.6-1.6.7-2.1.1-.4.2-.9.3-1.5-.2-.2-.3-.3-.5-.4-.5-.5-1.5-1.2-2.9-2.2-.6.3-1.2.6-1.7.7-.5.2-1.3.3-2.4.4-.4.9-.7 1.6-.8 2.1-.1.5-.2 1.2-.3 2 .4.5.7.9 1 1.1.3.2.8.5 1.4.9zm-5.8-2.6h2.1c.1-.7.2-1.3.3-1.7.1-.6.3-1.3.7-2.1-.5-.6-1.1-1.3-1.4-1.7-.2-.4-.6-.8-1-1.8-.2 0-.4.1-.6.1-.5.2-1.1.5-1.7.9V12c0 2 .6 3.8 1.6 5.2zm16.5-2.8c.2-.7.3-1.5.3-2.4v-.6c-.1.8-.3 1.4-.6 2 .1.1.2.3.2.4.1.2.1.4.1.6zm-16-5.9v-.1c.7-1 1.2-1.8 1.6-2.2.3-.4.8-.9 1.5-1.5v-1c-2.2 1.1-4 3-4.8 5.4.3-.2.6-.3.9-.4.3-.1.5-.1.8-.2zm12.2 11.2c-.7.3-1.8.6-3.1 1-.7.1-1.9.3-3.5.5.5.1 1 .1 1.5.1 1.9 0 3.7-.6 5.1-1.6zm6-7.7c0 6.2-5 11.2-11.1 11.2S.9 18.2.9 12 5.9.9 12 .9s11.1 5 11.1 11.1z"
      }
    },
    ad_set: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M10.4 2.4H2.5c-.3 0-.7.3-.7.6v7.4c0 .4.4.7.7.7h7.9c.4 0 .7-.3.7-.7V3c0-.3-.3-.6-.7-.6zM9.2 6.1H3.7V4.2h5.5v1.9zm12.3-3.7h-7.9c-.4 0-.7.3-.7.6v7.4c0 .4.3.7.7.7h7.9c.3 0 .7-.3.7-.7V3c0-.3-.4-.6-.7-.6zm-1.2 3.7h-5.5V4.2h5.5v1.9zM10.4 12.9H2.5c-.3 0-.7.3-.7.7V21c0 .3.4.6.7.6h7.9c.4 0 .7-.3.7-.6v-7.4c0-.4-.3-.7-.7-.7zm-1.2 3.8H3.7v-1.9h5.5v1.9zm12.3-3.8h-7.9c-.4 0-.7.3-.7.7V21c0 .3.3.6.7.6h7.9c.3 0 .7-.3.7-.6v-7.4c0-.4-.4-.7-.7-.7zm-1.2 3.8h-5.5v-1.9h5.5v1.9z"
      }
    },
    add: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M13.8 13.4h7.7c.3 0 .7-.3.7-.7v-1.4c0-.4-.4-.7-.7-.7h-7.7c-.2 0-.4-.2-.4-.4V2.5c0-.3-.3-.7-.7-.7h-1.4c-.4 0-.7.4-.7.7v7.7c0 .2-.2.4-.4.4H2.5c-.3 0-.7.3-.7.7v1.4c0 .4.4.7.7.7h7.7c.2 0 .4.2.4.4v7.7c0 .3.3.7.7.7h1.4c.4 0 .7-.4.7-.7v-7.7c0-.2.2-.4.4-.4z"
      }
    },
    adduser: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M10.1 17.1c0-1.3.4-2.7 1.1-3.8.8-1.4 1.6-1.9 2.3-3 1.2-1.7 1.4-4.1.7-6-.8-1.9-2.5-3-4.6-2.9S6 2.7 5.3 4.6c-.7 2-.4 4.5 1.3 6.1.6.7 1.3 1.7.9 2.6-.3 1-1.4 1.4-2.2 1.7-1.8.8-4 1.9-4.3 4.1-.4 1.7.8 3.5 2.7 3.5h7.8c.4 0 .6-.4.4-.7-1.1-1.4-1.8-3.1-1.8-4.8zm7.4-5.6c-3.1 0-5.5 2.5-5.5 5.6s2.4 5.5 5.5 5.5 5.5-2.5 5.5-5.5-2.5-5.6-5.5-5.6zm2.8 6c0 .3-.2.5-.5.5h-1.3v1.4c0 .3-.3.4-.5.4h-1c-.2 0-.4-.1-.4-.4V18h-1.4c-.3 0-.4-.2-.4-.5v-.9c0-.3.1-.4.4-.4h1.4v-1.4c0-.3.2-.5.4-.5h1c.2 0 .5.2.5.5v1.4h1.3c.3 0 .5.1.5.4v.9z"
      }
    },
    anchor: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M22.2 16.5L21 11.8c-.1-.5-.7-.7-1.1-.4l-3.6 3.3c-.4.3-.2 1 .3 1.1l1.5.5c-.1.3-.2.6-.4.9-.9 1.4-2.2 2.3-4.3 2.6V8.2c1.2-.5 2-1.7 2-3.1 0-1.8-1.5-3.3-3.4-3.3-1.8 0-3.3 1.5-3.3 3.3 0 1.4.8 2.6 2 3.1v11.6c-2.1-.3-3.5-1.2-4.3-2.6-.2-.3-.3-.6-.4-.9l1.5-.5c.5-.1.6-.8.3-1.1l-3.6-3.3c-.5-.3-1.1-.1-1.2.4l-1.2 4.7c-.1.5.4.9.9.8l1.2-.4c.2.5.4 1 .7 1.5C5.9 20.6 8.4 22 12 22s6-1.4 7.3-3.6c.3-.5.5-1 .7-1.5l1.2.4c.6.1 1-.3 1-.8zM12 6.6c-.7 0-1.3-.6-1.3-1.4s.6-1.3 1.3-1.3 1.3.6 1.3 1.3-.6 1.4-1.3 1.4z"
      }
    },
    animal_and_nature: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M8 2.1c1.3-.4 2.6-.7 4-.7s2.7.3 4 .7c.4-.7 1.1-1.2 2-1.2 1.3 0 2.3 1.1 2.3 2.3 0 .4-.1.8-.2 1.1.5.5.9 2 1.1 4.5.2 1.4 1.4 5.5 1.4 6.4 0 3.7-3.5 6.3-10.6 7.9-7.1-1.5-10.6-4.2-10.6-7.9 0-.9 1.1-5 1.4-6.4.2-2.5.6-4 1.2-4.5-.2-.3-.3-.7-.3-1.1C3.7 2 4.7.9 6 .9c.9 0 1.6.5 2 1.2zm1.7 8.4c-.8.2-1.4 1-1.3 1.9l.2 2.8c.1 1.8 1.6 3.3 3.4 3.3 1.8 0 3.3-1.5 3.4-3.3l.2-2.8c.1-.8-.5-1.6-1.3-1.9-.8-.2-1.6-.3-2.5-.3-.7 0-1.4.1-2.1.3zm6.9.1c.8 0 1.4-.8 1.4-1.8s-.6-1.9-1.4-1.9-1.4.8-1.4 1.9.7 1.8 1.4 1.8zm-9.2 0c.7 0 1.4-.8 1.4-1.8s-.7-1.9-1.4-1.9S6 7.7 6 8.8s.6 1.8 1.4 1.8zm6 2.2c-.8.9-2.1.9-2.9 0-.8-1-.1-1.7 1.5-1.7s2.2.8 1.4 1.7z"
      }
    },
    announcement: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M10.5 21l-.6-.5c-.7-.5-.7-1.4-.7-1.9v-1.3c0-.4-.3-.7-.7-.7H5.8c-.4 0-.7.3-.7.7v3.6c0 1.2.7 2.2 1.9 2.2h2.2c1.4 0 1.5-.9 1.5-.9s.2-.9-.2-1.2zM20.8 8.3V2c0-1.1-1.4-1.4-2.2-.7l-4.1 3.9c-.6.5-1.4.8-2.3.8h-7C2.8 6 .9 8.1.9 10.5v.1c0 2.4 1.9 4.2 4.3 4.2h7c.9 0 1.7.3 2.4.9l4 4c.8.7 2.2.4 2.2-.7v-6.3c1.4 0 2.2-.9 2.2-2.2 0-1.2-.8-2.2-2.2-2.2z"
      }
    },
    answer: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12 1.8C5.9 1.8.9 6.4.9 12c0 1.8.5 3.5 1.4 5 .1.2.1.4.1.6l-1 3.2c-.2.6.4 1.1 1 .9l3.2-1.1c.2-.1.4-.1.6.1 1.7.9 3.7 1.5 5.8 1.5 6.2 0 11.1-4.5 11.1-10.2C23 6.4 18.1 1.8 12 1.8zm5.3 7.9l-5.6 5.6c-.3.2-.5.3-.8.3-.3 0-.6-.1-.8-.3l-2.7-2.7c-.2-.2-.2-.6 0-.7l.8-.8c.2-.2.5-.2.8 0l1.9 2 4.8-4.8c.3-.3.6-.3.8 0l.8.7c.2.2.2.6 0 .7z"
      }
    },
    answered_twice: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M8.1 5.3C4 5.3.7 8.3.7 12c0 1.2.4 2.4 1 3.4 0 .1.1.2 0 .4L1 17.9c-.1.4.2.7.7.6l2.1-.7c.2-.1.4-.1.4 0 1.2.7 2.5 1 3.9 1 4.1 0 7.4-3 7.4-6.8s-3.3-6.7-7.4-6.7zm3.6 5.2l-3.8 3.7c-.1.2-.3.2-.5.2s-.3 0-.5-.2l-1.8-1.8c-.2-.1-.2-.4 0-.5l.5-.5c.1-.1.4-.1.5 0l1.3 1.3 3.2-3.2c.2-.1.4-.1.5 0l.5.5c.2.2.2.4.1.5zm4.1-5.2h-1.9c2.2 1.5 3.8 4 3.8 6.7 0 2.8-1.7 5.4-3.8 6.8h1.9c4.1 0 7.4-3 7.4-6.8 0-3.7-3.3-6.7-7.4-6.7z"
      }
    },
    apex: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.4 18.5H9.9c-.3 0-.7.3-.7.7v1.3c0 .4.4.7.7.7h12.5c.4 0 .7-.3.7-.7v-1.3c0-.4-.3-.7-.7-.7zm-10.7-8.4L2.8 2.9c-.3-.2-.7-.2-1 .1l-.7 1.2c-.3.3-.2.7.1.9l6.4 5.1c.2.2.2.6 0 .7L1.2 16c-.3.2-.4.7-.1 1l.7 1.2c.3.3.7.4 1 .1l8.9-7.1c.4-.3.4-.9 0-1.1z"
      }
    },
    approval: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M20.9 13.5h-4.1c-1.2 0-2.2-1-2.2-2.2.2-3.3 1.7-3.5 1.8-5.6.2-2.2-1.2-4.2-3.4-4.7-2.8-.6-5.4 1.6-5.4 4.4 0 2.4 1.6 2.4 1.8 5.9 0 1.2-1 2.2-2.2 2.2H3.1c-1.2 0-2.2.9-2.2 2.2v1.5c0 .4.3.7.8.7h20.6c.5 0 .8-.3.8-.7v-1.5c0-1.3-1-2.2-2.2-2.2zm0 6.6H3.1c-.4 0-.7.3-.7.7v.1c0 1.2 1 2.2 2.2 2.2h14.8c1.2 0 2.2-1 2.2-2.2v-.1c0-.4-.3-.7-.7-.7z"
      }
    },
    apps: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M6 1.8H3.2c-.8 0-1.4.6-1.4 1.4V6c0 .8.6 1.4 1.4 1.4H6c.8 0 1.4-.6 1.4-1.4V3.2c0-.8-.6-1.4-1.4-1.4zm0 14.8H3.2c-.8 0-1.4.6-1.4 1.4v2.8c0 .8.6 1.4 1.4 1.4H6c.8 0 1.4-.6 1.4-1.4V18c0-.8-.6-1.4-1.4-1.4zm0-7.4H3.2c-.8 0-1.4.6-1.4 1.4v2.8c0 .8.6 1.4 1.4 1.4H6c.8 0 1.4-.6 1.4-1.4v-2.8c0-.8-.6-1.4-1.4-1.4zm7.4-7.4h-2.8c-.8 0-1.4.6-1.4 1.4V6c0 .8.6 1.4 1.4 1.4h2.8c.8 0 1.4-.6 1.4-1.4V3.2c0-.8-.6-1.4-1.4-1.4zm0 14.8h-2.8c-.8 0-1.4.6-1.4 1.4v2.8c0 .8.6 1.4 1.4 1.4h2.8c.8 0 1.4-.6 1.4-1.4V18c0-.8-.6-1.4-1.4-1.4zm0-7.4h-2.8c-.8 0-1.4.6-1.4 1.4v2.8c0 .8.6 1.4 1.4 1.4h2.8c.8 0 1.4-.6 1.4-1.4v-2.8c0-.8-.6-1.4-1.4-1.4zm7.4-7.4H18c-.8 0-1.4.6-1.4 1.4V6c0 .8.6 1.4 1.4 1.4h2.8c.8 0 1.4-.6 1.4-1.4V3.2c0-.8-.6-1.4-1.4-1.4zm0 14.8H18c-.8 0-1.4.6-1.4 1.4v2.8c0 .8.6 1.4 1.4 1.4h2.8c.8 0 1.4-.6 1.4-1.4V18c0-.8-.6-1.4-1.4-1.4zm0-7.4H18c-.8 0-1.4.6-1.4 1.4v2.8c0 .8.6 1.4 1.4 1.4h2.8c.8 0 1.4-.6 1.4-1.4v-2.8c0-.8-.6-1.4-1.4-1.4z"
      }
    },
    arrowdown: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M4.4 14.3c-.3.4-.3.9 0 1.3l7 6.7c.3.4.9.4 1.2 0l7-6.7c.4-.4.4-.9 0-1.3l-1.3-1.2c-.3-.4-.9-.4-1.3 0l-2.1 2.1c-.4.4-1.1.1-1.1-.4V2.3c0-.5-.4-.9-.9-.9h-1.8c-.5 0-.9.5-.9.9v12.5c0 .5-.7.8-1.1.4L7 13.1c-.4-.4-1-.4-1.3 0l-1.3 1.2z"
      }
    },
    arrowup: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M19.1 9.7c.4-.4.4-.9 0-1.3l-6.9-6.7c-.4-.4-.9-.4-1.3 0L4 8.4c-.4.4-.4.9 0 1.3l1.3 1.2c.3.4.9.4 1.3 0l2.1-2.1c.4-.4 1-.1 1 .4v12.5c0 .5.5.9 1 .9h1.8c.5 0 .9-.5.9-.9V9.2c0-.5.7-.8 1-.4l2.2 2.1c.4.4.9.4 1.3 0l1.2-1.2z"
      }
    },
    attach: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M8.1 16.9c.3.3.7.3 1 0l4.6-4.6c.3-.3.9-.3 1.3 0 .4.4.4 1 0 1.4l-5.7 5.6c-1.2 1.2-3.3 1.2-4.5 0l-.1-.1c-1.2-1.2-1.2-3.3 0-4.5l10-10c1.3-1.3 3.3-1.3 4.6 0 1.3 1.3 1.3 3.3 0 4.6-.2.3-.3.6-.1.9.3.5.5 1 .6 1.6.1.3.6.4.8.2l.7-.7c2.4-2.4 2.4-6.2 0-8.6h-.1C18.9.4 15 .4 12.7 2.7l-10 10c-2.4 2.3-2.4 6.2 0 8.5l.1.1c2.3 2.4 6.1 2.4 8.5 0l5.7-5.7c1.5-1.4 1.4-3.8-.1-5.3-1.5-1.4-3.9-1.3-5.3.1L7.1 15c-.3.2-.3.7 0 1l1 .9z"
      }
    },
    automate: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12 7.6c-2.4 0-4.4 2-4.4 4.4s2 4.5 4.4 4.5c2.5 0 4.5-2 4.5-4.5s-2-4.4-4.5-4.4zm0 7.7c-1.8 0-3.2-1.5-3.2-3.3 0-1.8 1.4-3.3 3.2-3.3 1.8 0 3.3 1.5 3.3 3.3 0 1.8-1.5 3.3-3.3 3.3zm10.8-.5c.2-.9.3-1.8.3-2.8 0-1-.1-1.9-.3-2.8h-1.3c-.2-.7-.5-1.4-.8-2l.9-.8c-1-1.6-2.3-3-4-4l-.8.9c-.6-.3-1.3-.6-2-.8V1.3c-.9-.2-1.8-.4-2.8-.4-1 0-1.9.2-2.8.4v1.2c-.7.2-1.3.5-1.9.8l-.9-.9c-1.7 1-3 2.4-4 4l.9.9c-.3.6-.6 1.2-.8 1.9H1.3c-.2.9-.4 1.8-.4 2.8s.2 1.9.4 2.8h1.2c.2.7.5 1.4.8 2l-.9.8c1 1.6 2.4 3 4 4l.9-.9c.6.3 1.2.6 1.9.8v1.3c.9.2 1.9.3 2.8.3 1 0 1.9-.1 2.9-.3v-1.3c.7-.2 1.3-.5 1.9-.8l.9.9c1.6-1 3-2.3 3.9-4l-.8-.8c.3-.6.6-1.3.8-2h1.2zm-2.7 3c-.3.4-.7.8-1.1 1.2-.4.4-.8.8-1.2 1.1l-.9-.9c-.9.7-2.1 1.2-3.3 1.4v1.2c-.5.1-1 .1-1.6.1-.6 0-1.1 0-1.6-.1v-1.2c-1.2-.2-2.4-.7-3.3-1.4l-.9.9c-.4-.3-.8-.7-1.2-1.1-.4-.4-.8-.8-1.1-1.2l.9-.9c-.7-.9-1.2-2.1-1.4-3.3H2.2c-.1-.5-.1-1-.1-1.6 0-.6 0-1.1.1-1.6h1.3c.2-1.2.7-2.4 1.3-3.3L4 6.2c.3-.4.7-.8 1-1.2.4-.4.8-.8 1.2-1.1l.9.9c1-.7 2.1-1.2 3.3-1.4V2.2c.5-.1 1.1-.1 1.6-.1.6 0 1.1 0 1.7.1v1.3c1.2.2 2.3.7 3.3 1.3l.9-.8c.4.3.8.6 1.2 1 .3.4.7.8 1 1.2l-.9.9c.7 1 1.2 2.1 1.4 3.3h1.3c.1.5.1 1.1.1 1.6 0 .6 0 1.1-.1 1.7h-1.3c-.2 1.2-.7 2.3-1.4 3.3l.9.8z"
      }
    },
    back: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.4 10.6H7.1c-.4 0-.6-.5-.3-.8l4.4-4.4c.3-.3.3-.7 0-1l-1-1c-.3-.3-.7-.3-1 0l-8 8.1c-.3.3-.3.7 0 1l8 8.1c.3.3.7.3 1 0l1-1c.2-.3.2-.7 0-1l-4.5-4.4c-.2-.3-.1-.8.4-.8h15.3c.4 0 .7-.3.7-.7v-1.3c0-.4-.3-.8-.7-.8z"
      }
    },
    ban: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12 .9C5.9.9.9 5.9.9 12s5 11.1 11.1 11.1 11.1-5 11.1-11.1S18.1.9 12 .9zM3.7 12c0-4.6 3.7-8.3 8.3-8.3 1.8 0 3.5.5 4.8 1.5L5.2 16.8c-1-1.3-1.5-3-1.5-4.8zm8.3 8.3c-1.8 0-3.5-.5-4.8-1.5L18.8 7.2c1 1.3 1.5 3 1.5 4.8 0 4.6-3.7 8.3-8.3 8.3z"
      }
    },
    block_visitor: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M29.9 8.8V9v-.2z"
      }, {
        "d": "M10.2 17.1c0-1.3.4-2.7 1-3.8.8-1.4 1.7-1.9 2.4-3 1.1-1.7 1.4-4.1.6-6-.7-1.9-2.5-3-4.5-2.9S6 2.7 5.4 4.6c-.8 2-.5 4.5 1.2 6.1.7.7 1.3 1.7 1 2.6-.4 1-1.5 1.4-2.2 1.7-1.8.8-4 1.9-4.4 4.1-.4 1.7.8 3.5 2.7 3.5h7.9c.4 0 .6-.4.4-.7-1.2-1.4-1.8-3.1-1.8-4.8zm11.3-3.9c-2.2-2.2-5.7-2.2-7.9 0s-2.2 5.6 0 7.8 5.7 2.2 7.9 0 2.1-5.7 0-7.8zm-6.6 1.2c1.3-1.2 3.1-1.4 4.5-.5l-5 5.1c-.9-1.5-.7-3.3.5-4.6zm5.3 5.3c-1.3 1.2-3.1 1.4-4.6.6l5.1-5.1c.9 1.4.7 3.3-.5 4.5z"
      }]
    },
    bold: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.9 8.8c0-2.8-2.2-5.1-4.8-5.1H6.5c-.5 0-1 .4-1 .9v15.2c0 .6.5 1 1 1h7.6c2.6 0 4.8-2.3 4.8-5.1 0-1.3-.5-2.5-1.3-3.5.8-.9 1.3-2.1 1.3-3.4zm-4.8 8.7H8.8v-3.7h5.3c.9 0 1.6.9 1.6 1.9s-.7 1.8-1.6 1.8zm0-6.9H8.8V6.9h5.3c.9 0 1.6.9 1.6 1.9s-.7 1.8-1.6 1.8z"
      }
    },
    bookmark: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.2 22.9l-4.6-4.6c-.2-.3-.6-.3-.9 0l-4.9 4.6c-.3.3-.8.1-.8-.3V2.8C6 1.8 6.8.9 7.8.9h8.4c1 0 1.8.9 1.8 1.9v19.8c0 .4-.5.6-.8.3z"
      }
    },
    breadcrumbs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M3.9 19.4c-.3 0-.5-.2-.5-.5V5c0-.2.2-.4.5-.4h3.7c.2 0 .4.1.6.2l5.3 6.7c.2.3.2.6 0 .9l-5.4 6.8c-.1.1-.3.2-.6.2H3.9zm16.5-7.9L15 4.8c-.2-.2-.6-.3-.9 0l-1.1.8c-.3.3-.4.7-.1 1l4.4 5.4-4.4 5.4c-.2.3-.2.8.1 1l1.1.9c.3.2.7.2.9-.1l5.4-6.7c.2-.4.2-.7 0-1z"
      }
    },
    broadcast: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M.9 8.8c0 2.7 1.1 5.2 3 7.1.4.4 1 .4 1.4 0 .4-.5.4-1.1 0-1.5C3.8 12.9 3 10.9 3 8.8c0-2.2.8-4.2 2.3-5.7.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0C2 3.6.9 6.1.9 8.8zm5.9 4.1c.4.4 1 .4 1.5 0 .4-.4.4-1 0-1.4-.7-.8-1.2-1.7-1.2-2.7 0-1.1.4-2 1.2-2.7.4-.4.4-1.1 0-1.5-.5-.4-1.1-.4-1.5 0-1.1 1.1-1.7 2.6-1.7 4.2 0 1.5.6 3 1.7 4.1zM20.1 1.7c-.4-.4-1.1-.4-1.5 0-.4.4-.4 1 0 1.4 1.5 1.5 2.3 3.5 2.4 5.7-.1 2.1-.9 4.1-2.4 5.6-.4.4-.4 1 0 1.5.4.4 1.1.4 1.5 0C22 14 23 11.5 23 8.8c0-2.7-1-5.2-2.9-7.1zm-1.2 7.1c0-1.6-.7-3.1-1.8-4.2-.4-.4-1-.4-1.4 0-.4.4-.4 1.1 0 1.5.7.7 1.1 1.6 1.1 2.7 0 1-.4 1.9-1.1 2.7-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0 1.1-1.1 1.8-2.6 1.8-4.1zM10.9 11.2c-1-.4-1.6-1.3-1.6-2.5C9.3 7.2 10.5 6 12 6c1.5 0 2.7 1.2 2.7 2.7 0 1.2-.7 2.1-1.7 2.5v10.9c0 .3-.2.5-.5.5h-1.1c-.2 0-.5-.2-.5-.5V11.2z"
      }
    },
    brush: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.8 1.2c-1.6-1.6-10.3 3.4-15.7 12-.2.4-.1.9.3 1.1 1.2.6 2.2 1.6 2.7 2.8.2.5.7.6 1.1.3C19.5 12 24.4 2.9 22.8 1.2zm-17.3 15c-.7 0-1.3.4-1.8.9h-.1c-.2 0-.4.3-.6.7-.7 1.2-.9 2.7-2 4.3-.2.3-.1.7.2.8 1.6.5 4.4 0 5.8-1v.1c.4-.1.3-.3.4-.3.5-.9 1-1.4 1-2.3-.1-1.7-1.3-3.2-2.9-3.2z"
      }
    },
    bucket: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.6 5.1c0-2.9-4.5-4.2-8.8-4.2S5.1 2.2 5.1 5.1v.2C1.1 6.5.5 9 .5 10.4c0 1.4.7 2.8 1.9 3.9 1 .8 2.3 1.3 3.6 1.4h.4c3-.1 5.9-1.1 6.8-2.7-.5-.4-.7-.9-.7-1.5 0-1 .8-1.8 1.8-1.8s1.9.8 1.9 1.8c0 .8-.5 1.5-1.2 1.7-.9 2.6-4.6 4.3-9 4.3v2.8c0 1.5 3.5 2.8 7.8 2.8s7.9-1.3 7.9-2.8V7.1c.6-.6.9-1.2.9-2zm-8.8-1.4c3.1 0 5 .7 5.8 1.2.1.1.1.3 0 .4-.8.5-2.7 1.2-5.8 1.2s-4.9-.7-5.7-1.2c-.1-.1-.1-.3 0-.4.8-.5 2.7-1.2 5.7-1.2zM3.6 12.8c-.8-.6-1.3-1.5-1.3-2.4 0-2 1.9-3 3.6-3.4l.1.1v6.7c-.9 0-1.8-.4-2.4-1z"
      }
    },
    builder: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M5.3 7.8H1.6c-.4 0-.7.4-.7.7v11.8c0 1 .9 1.9 1.9 1.9h2.5c.4 0 .7-.4.7-.7v-13c0-.3-.3-.7-.7-.7zm17.1 0H8.5c-.3 0-.7.4-.7.7v13c0 .3.4.7.7.7h12.7c1 0 1.9-.9 1.9-1.9V8.5c0-.3-.3-.7-.7-.7zm-1.2-6H2.8c-1 0-1.9.9-1.9 1.9v1.6c0 .4.3.7.7.7h20.8c.4 0 .7-.3.7-.7V3.7c0-1-.9-1.9-1.9-1.9z"
      }
    },
    call: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.4 17.5l-2.8-2.3c-.7-.5-1.6-.5-2.2 0L15 16.9c-.3.3-.7.2-1-.1l-3.6-3.2L7.2 10c-.3-.3-.3-.6-.1-1l1.7-2.4c.5-.6.5-1.5 0-2.2L6.5 1.6C5.8.8 4.6.7 3.8 1.5L1.4 3.9c-.4.3-.6.9-.6 1.4.3 4.7 2.4 9.1 5.5 12.3s7.6 5.2 12.3 5.5c.6 0 1.1-.2 1.4-.6l2.4-2.4c.9-.7.9-2 0-2.6z"
      }
    },
    campaign: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12 .4C5.6.4.4 5.6.4 12S5.6 23.6 12 23.6 23.6 18.4 23.6 12 18.4.4 12 .4zm0 20.9c-5.1 0-9.3-4.2-9.3-9.3S6.9 2.7 12 2.7s9.3 4.2 9.3 9.3-4.2 9.3-9.3 9.3zM12 5c-3.8 0-7 3.2-7 7s3.2 7 7 7 7-3.2 7-7-3.2-7-7-7zm0 11.7c-2.5 0-4.7-2.1-4.7-4.7S9.5 7.3 12 7.3s4.7 2.2 4.7 4.7-2.2 4.7-4.7 4.7zm0-7c-1.3 0-2.3 1.1-2.3 2.3s1.1 2.3 2.3 2.3 2.3-1.1 2.3-2.3-1-2.3-2.3-2.3z"
      }
    },
    cancel_file_request: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M14.9 7h2.8c.2 0 .3-.2.2-.4l-3-2.9c-.1-.1-.3 0-.3.1v2.8c-.1.2.1.4.3.4zm-.1 5.2c.9-.9 2.1-1.4 3.3-1.6V8.8c0-.3-.1-.4-.4-.4h-3.9c-.4 0-.7-.3-.7-.7v-4c0-.2-.2-.3-.4-.3H7.9c-.3 0-.6.2-.6.5v1.5c0 .1.1.2.2.4l2 2c.2.2.5.6.5 1.1.1.5-.1 1.1-.5 1.5l-.5.5c-.2.2-.4.3-.6.4.2.1.6.2.8.2 1 .1 1.7.9 1.7 1.9v.8c0 .5-.2 1-.6 1.3-.4.4-.9.5-1.4.5-.4-.1-.7-.1-1.1-.2-.3-.1-.5.1-.5.4v1.1c0 .2.3.5.6.5h5.3c-.4-2 .1-4 1.6-5.6zm-5.3 1.9v-.8c0-.2-.2-.4-.4-.4C7.2 12.7 5.5 11 5.5 9v-.4c0-.2.3-.4.5-.2l1.4 1.4c.1.2.4.2.5 0l.6-.5c.1-.2.1-.4 0-.6L5 5.3c-.1-.2-.4-.2-.5 0L1 8.8c-.1.1-.1.4 0 .5l.6.6c.1.1.4.2.5 0l1.5-1.4c.2-.2.6-.1.6.2v.7c0 2.6 2.2 4.9 4.9 5.1.2 0 .4-.2.4-.4z"
      }, {
        "d": "M21.9 13.3c-1.7-1.7-4.4-1.7-6.1 0-1.7 1.7-1.7 4.4 0 6.1 1.6 1.6 4.4 1.6 6.1 0 1.7-1.7 1.7-4.4 0-6.1zm-1.3 3.8c.2.1.2.4 0 .5l-.5.5c-.2.2-.3.2-.5 0l-.7-.7-.8.7c-.1.2-.3.2-.5 0l-.5-.5c-.2-.2-.2-.3-.1-.5l.8-.8-.7-.7c-.2-.2-.2-.4-.1-.5l.5-.5c.2-.2.5-.2.6-.1l.7.8.8-.8c.1-.1.4-.1.5 0l.5.5c.2.1.2.4 0 .6l-.8.7.8.8z"
      }]
    },
    cancel_transfer: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12.6 15c-.5-.3-1.1-.6-1.7-.8-1.1-.4-1.3-.9-1.3-1.4 0-.4.3-.8.6-1.2.7-.6 1.1-1.5 1.1-2.5 0-1.9-1.2-3.3-3.3-3.3-2.1 0-3.2 1.4-3.2 3.3 0 1 .3 1.9 1 2.5.4.4.7.8.7 1.2 0 .5-.2.9-1.4 1.4-1.6.7-3.3 1.5-3.3 3 .1 1 .9 1.9 1.8 1.9h7.6c0-1.5.5-2.9 1.4-4.1zm-.2-10V3.6c1.9 0 3.3 1.5 3.3 3.3h-1.3l2.1 2.7c.1.1.3.1.4 0L19 6.9h-1.4c0-2.9-2.4-5.2-5.2-5.2V.3L9.7 2.4c-.1.1-.1.3.1.4L12.4 5zM20.8 15.7c-1.8-1.9-4.8-1.9-6.6 0s-1.9 4.8 0 6.6 4.8 1.9 6.6 0 1.9-4.8 0-6.6zm-1.4 4.1c.2.1.2.4 0 .6l-.6.6c-.1.1-.3.1-.5-.1l-.8-.8-.8.9c-.2.1-.4.1-.5-.1l-.6-.5c-.2-.2-.2-.4-.1-.6l.9-.8-.8-.9c-.2-.1-.2-.4-.1-.5l.6-.6c.1-.1.4-.2.6 0l.8.8.8-.8c.2-.2.4-.2.6-.1l.6.6c.1.1.1.4-.1.6l-.8.8.8.9z"
      }
    },
    capslock: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M20.1 9.7l-7.5-8.5c-.3-.4-.9-.4-1.2 0L3.9 9.7c-.3.4-.1.9.4.9h3.5v5.8c0 .4.4.7.7.7h7c.3 0 .7-.3.7-.7v-5.8h3.5c.5 0 .7-.5.4-.9zm-4.6 10.1h-7c-.3 0-.7.4-.7.7v1.9c0 .4.4.7.7.7h7c.3 0 .7-.3.7-.7v-1.9c0-.3-.4-.7-.7-.7z"
      }
    },
    case: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M7.9 5.2h1.4c.2 0 .3-.1.3-.3v-1h4.8v1c0 .2.1.3.3.3H16c.2 0 .3-.1.3-.3v-1c0-1.1-.9-2.1-2-2.1H9.6c-1.1 0-2 1-2 2.1v1c0 .2.1.3.3.3zm12.2 2H3.9c-1.1 0-2.1 1-2.1 2.1v10.8c0 1.1 1 2.1 2.1 2.1h16.2c1.1 0 2.1-1 2.1-2.1V9.3c0-1.1-1-2.1-2.1-2.1z"
      }
    },
    cases: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M4.2 1.6c0-.4-.4-.7-.7-.7H1.6c-.4 0-.7.3-.7.7v14.3c0 .4.3.7.7.7h1.9c.3 0 .7-.3.7-.7V1.6zm18.9 0c0-.4-.3-.7-.7-.7h-1.9c-.3 0-.7.3-.7.7v14.3c0 .4.4.7.7.7h1.9c.4 0 .7-.3.7-.7V1.6zM17.3.9h-1.4c-.3 0-.7.4-.7.8v5.7c0 .2.1.3.3.4.8.4 1.5.9 2.1 1.5.1.2.4.1.4-.1V1.7c0-.4-.3-.8-.7-.8zM11.1 7h1.8c.3 0 .5-.2.5-.4V1.7c0-.4-.3-.8-.7-.8h-1.4c-.4 0-.7.4-.7.8v4.9c0 .2.2.5.5.4zM6.4 9.3c.6-.6 1.4-1.1 2.1-1.5.2-.1.3-.2.3-.4V1.7c0-.4-.4-.8-.7-.8H6.7c-.4 0-.7.4-.7.8v7.5c0 .2.2.3.4.1zm5.6-.5c-3.3 0-6 2.7-6 6 0 1 .3 2 .7 2.9L3.5 21c-.3.2-.3.6 0 .9l.9 1c.3.3.7.3 1 0l3.2-3.2c1 .7 2.2 1.1 3.4 1.1 3.3 0 6-2.7 6-6s-2.7-6-6-6zm0 9.2c-1.8 0-3.2-1.4-3.2-3.2s1.4-3.2 3.2-3.2 3.2 1.4 3.2 3.2S13.8 18 12 18z"
      }
    },
    center_align_text: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.2 3c0-.4-.4-.7-.7-.7h-19c-.3 0-.7.3-.7.7v1.4c0 .4.4.7.7.7h19c.3 0 .7-.3.7-.7V3zm-2.8 5.5c0-.3-.3-.7-.7-.7H5.3c-.4 0-.7.4-.7.7v1.4c0 .4.3.7.7.7h13.4c.4 0 .7-.3.7-.7V8.5zm-.9 11.1c0-.4-.4-.7-.7-.7H6.2c-.3 0-.7.3-.7.7V21c0 .4.4.7.7.7h11.6c.3 0 .7-.3.7-.7v-1.4zm3.7-5.5c0-.4-.4-.7-.7-.7h-19c-.3 0-.7.3-.7.7v1.4c0 .3.4.7.7.7h19c.3 0 .7-.4.7-.7v-1.4z"
      }
    },
    change_owner: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12.6 17.4c-1.4-.6-1.6-1.1-1.6-1.7 0-.5.4-1 .8-1.4.8-.7 1.2-1.8 1.2-3 0-2.2-1.3-3.9-3.8-3.9s-3.8 1.7-3.8 3.9c0 1.2.3 2.3 1.2 3 .4.4.8.9.8 1.4 0 .6-.2 1.1-1.6 1.7-2.1.8-4 1.7-4 3.5 0 1.2 1 2.2 2.1 2.2h10.6c1.2 0 2.1-1 2.1-2.2 0-1.7-2-2.7-4-3.5zm7.9-8.6c0-3.4-2.8-6.3-6.2-6.3V.9l-3.1 2.6c-.2.1-.1.3 0 .5l3.1 2.5V4.8c2.2 0 3.9 1.8 3.9 4h-1.6l2.6 3.1c.1.1.3.1.5 0l2.5-3.1h-1.7z"
      }
    },
    change_record_type: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M9.2 17.3c0-.4-.3-.7-.7-.7H1.6c-.4 0-.7.3-.7.7v5.1c0 .4.3.7.7.7h6.9c.4 0 .7-.3.7-.7v-5.1zm-5.5-7.1H1.5c-.5 0-.7.4-.4.6l3.7 3.8c.1.2.4.2.6 0l3.7-3.8c.3-.3 0-.6-.4-.6H6.5c0-2.4 2.3-4.7 4.6-4.7V2.8c-4.2 0-7.4 3.2-7.4 7.4zm15.6-.8c-.2-.2-.5-.2-.7 0L15 13.2c-.3.3-.1.6.4.6h2.2c0 2.8-1.9 4.7-4.7 4.7v2.7c4.2 0 7.5-3.2 7.5-7.4h2.2c.5 0 .7-.4.4-.6l-3.7-3.8zm3.8-7.8c0-.4-.3-.7-.7-.7h-6.9c-.4 0-.7.3-.7.7v5.1c0 .4.3.7.7.7h6.9c.4 0 .7-.3.7-.7V1.6z"
      }
    },
    chart: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M21 10.8L11.5 16c-.6.3-1.3-.1-1.3-.8V3.9c0-.5-.5-.9-.9-.7-4.6 1.3-8 5.8-7.4 10.9.5 4.6 4.2 8.4 8.9 8.9 6.2.7 11.4-4.1 11.4-10.1 0-.5-.1-1.1-.2-1.6s-.6-.7-1-.5zm-8.2 2.1l9.1-4.8c.5-.3.7-1 .3-1.5-2-2.9-5.3-5-9-5.6-.6-.1-1.2.4-1.2 1v10.5c0 .4.4.6.8.4z"
      }
    },
    chat: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12 1.8C5.9 1.8 1 6.4 1 12c0 1.7.5 3.4 1.3 4.8.1.3.2.6.1.8l-1.4 4c-.2.3.2.6.6.6l3.9-1.6c.3-.1.5 0 .8.1 1.7.9 3.7 1.5 5.8 1.5 6 0 11-4.5 11-10.2C23 6.4 18.1 1.8 12 1.8zm-5.5 12c-1.1 0-1.9-.8-1.9-1.8s.8-1.8 1.9-1.8 1.8.8 1.8 1.8-.8 1.8-1.8 1.8zm5.5 0c-1 0-1.8-.8-1.8-1.8s.8-1.8 1.8-1.8 1.8.8 1.8 1.8-.8 1.8-1.8 1.8zm5.5 0c-1 0-1.8-.8-1.8-1.8s.8-1.8 1.8-1.8 1.9.8 1.9 1.8-.8 1.8-1.9 1.8z"
      }
    },
    check: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M8.8 19.6L1.2 12c-.3-.3-.3-.8 0-1.1l1-1c.3-.3.8-.3 1 0L9 15.7c.1.2.5.2.6 0L20.9 4.4c.2-.3.7-.3 1 0l1 1c.3.3.3.7 0 1L9.8 19.6c-.2.3-.7.3-1 0z"
      }
    },
    checkin: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12 .9C7.2.9 3.2 4.8 3.2 9.7c0 6.1 6.3 11.7 8.2 13.2.4.3.8.3 1.2 0 1.9-1.5 8.2-7.1 8.2-13.2 0-4.9-4-8.8-8.8-8.8zm0 12.5c-2 0-3.7-1.7-3.7-3.7S10 6 12 6s3.7 1.7 3.7 3.7-1.7 3.7-3.7 3.7z"
      }
    },
    chevrondown: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22 8.2l-9.5 9.6c-.3.2-.7.2-1 0L2 8.2c-.2-.3-.2-.7 0-1l1-1c.3-.3.8-.3 1.1 0l7.4 7.5c.3.3.7.3 1 0l7.4-7.5c.3-.2.8-.2 1.1 0l1 1c.2.3.2.7 0 1z"
      }
    },
    chevronleft: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M15.8 22l-9.6-9.4c-.3-.3-.3-.8 0-1.1l9.6-9.4c.3-.3.7-.3 1 0l1 1c.3.3.3.7 0 1l-7.6 7.4c-.3.3-.3.8 0 1.1l7.5 7.4c.3.3.3.7 0 1l-1 1c-.2.2-.6.2-.9 0z"
      }
    },
    chevronright: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M8.3 2l9.5 9.5c.3.3.3.7 0 1L8.3 22c-.3.2-.8.2-1.1 0l-1-1c-.2-.3-.2-.8 0-1.1l7.6-7.4c.2-.3.2-.7 0-1L6.3 4.1C6 3.8 6 3.3 6.3 3l1-1c.3-.2.7-.2 1 0z"
      }
    },
    chevronup: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M2 15.8l9.5-9.6c.3-.2.7-.2 1 0l9.5 9.6c.2.3.2.7 0 1l-1 1c-.3.3-.8.3-1.1 0l-7.4-7.6c-.3-.2-.7-.2-1 0l-7.4 7.6c-.3.2-.8.2-1.1 0l-1-1c-.2-.3-.2-.7 0-1z"
      }
    },
    classic_interface: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M11.8 16.5v-3.9S10 15.2 8.9 17s-1 3.2-1 3.2c0 1.4 1.1 2.6 2.4 2.6.8 0 1.5-.4 1.9-1.1.4.6 1 1 1.8 1 1.3 0 2.3-1.2 2.3-2.7v-.4c0-1.9-4.3-7.1-4.3-7.1v4l.6 1.3v.2c0 .3-.2.6-.6.6-.3 0-.6-.3-.6-.6 0 0 0-.1.1-.2l.3-1.3m-4.5-3.4l3.7-1.4s-3-.8-5.1-1.2c-2.2-.4-3.4.3-3.4.3-1.3.5-2.1 1.8-1.7 3 .3.8 1 1.3 1.7 1.5-.4.6-.5 1.3-.2 2 .4 1.2 1.9 1.8 3.2 1.3.2 0 .3-.1.4-.2 1.9-.6 5.2-6.4 5.2-6.4l-3.6 1.3h-.1l-1.1 1c0 .1-.1.1-.1.1-.3.1-.7 0-.8-.4-.1-.3 0-.7.4-.8H6l1.3-.1m1.9-5.5l2.3 3.2s-.1-3.2-.3-5.3C11 3.4 10 2.3 10 2.3 9.1 1.2 7.6.8 6.6 1.6c-.6.5-.9 1.3-.9 2-.7-.2-1.4-.1-2 .3-1 .8-1.2 2.4-.3 3.5.1.1.2.3.2.4 1.2 1.5 7.8 3.1 7.8 3.1L9 7.8 7.7 7l-.1-.1c-.2-.3-.2-.7.1-.9.3-.2.7-.1.9.1 0 .1 0 .1.1.2l.5 1.3m7.5 5.5L13 11.7s3-.8 5.1-1.2c2.2-.4 3.4.3 3.4.3 1.3.5 2.1 1.8 1.7 3-.3.8-1 1.3-1.7 1.5.4.6.5 1.3.2 2-.4 1.2-1.9 1.8-3.2 1.3-.2 0-.3-.1-.4-.2-1.9-.6-5.2-6.4-5.2-6.4l3.6 1.3h.1l1.1 1c0 .1.1.1.1.1.3.1.7 0 .8-.4.1-.3 0-.7-.4-.8H18l-1.3-.1m-2.1-5.5l-2.3 3.2s.2-3.2.3-5.3 1.2-3.2 1.2-3.2c.9-1.1 2.4-1.5 3.4-.7.7.5.9 1.3.9 2 .7-.1 1.4 0 2 .4 1 .8 1.1 2.3.3 3.5l-.3.3c-1.1 1.5-7.6 3.1-7.6 3.1l2.3-3.1.1-.1 1.2-.7.1-.2c.2-.2.2-.6-.1-.8-.3-.2-.6-.2-.9.1 0 0 0 .1-.1.1l-.5 1.4"
      }
    },
    clear: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12 .9C5.9.9.9 5.9.9 12s5 11.1 11.1 11.1 11.1-5 11.1-11.1S18.1.9 12 .9zm2.3 11.5l3.6 3.6c.1.2.1.4 0 .6l-1.3 1.3c-.2.2-.5.2-.7 0l-3.6-3.6c-.2-.2-.4-.2-.6 0l-3.6 3.6c-.2.2-.5.2-.7 0l-1.3-1.3c-.1-.2-.1-.4 0-.6l3.6-3.6c.2-.2.2-.5 0-.7L6.1 8.1c-.2-.2-.2-.5 0-.7l1.3-1.3c.2-.1.4-.1.6 0l3.7 3.7c.2.2.4.2.6 0l3.6-3.6c.2-.2.5-.2.7 0l1.3 1.3c.1.2.1.4 0 .6l-3.6 3.6c-.2.2-.2.5 0 .7z"
      }
    },
    clock: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12 .9C5.9.9.9 5.9.9 12s5 11.1 11.1 11.1 11.1-5 11.1-11.1S18.1.9 12 .9zm0 19.4c-4.6 0-8.3-3.7-8.3-8.3S7.4 3.7 12 3.7s8.3 3.7 8.3 8.3-3.7 8.3-8.3 8.3zm1.6-8.2c-.2-.1-.2-.3-.2-.5V7.2c0-.4-.3-.7-.7-.7h-1.4c-.4 0-.7.3-.7.7v5.5c0 .2.1.4.2.5l3.4 3.5c.3.2.7.2 1 0l1-1c.2-.3.2-.7 0-1l-2.6-2.6z"
      }
    },
    close: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M14.3 11.7l6-6c.3-.3.3-.7 0-1l-.9-1c-.3-.2-.7-.2-1 0l-6 6.1c-.2.2-.5.2-.7 0l-6-6.1c-.3-.3-.7-.3-1 0l-1 1c-.2.2-.2.7 0 .9l6.1 6.1c.2.2.2.4 0 .6l-6.1 6.1c-.3.3-.3.7 0 1l1 1c.2.2.7.2.9 0l6.1-6.1c.2-.2.4-.2.6 0l6.1 6.1c.2.2.7.2.9 0l1-1c.3-.3.3-.7 0-1l-6-6c-.2-.2-.2-.5 0-.7z"
      }
    },
    collapse_all: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.2 4.4c0-.4-.4-.7-.7-.7h-19c-.3 0-.7.3-.7.7v1.4c0 .3.4.7.7.7h19c.3 0 .7-.4.7-.7V4.4zm0 13.8c0-.3-.4-.7-.7-.7h-19c-.3 0-.7.4-.7.7v1.4c0 .4.4.7.7.7h19c.3 0 .7-.3.7-.7v-1.4zm-6.3-4.8c.4 0 .7-.3.7-.7v-1.4c0-.4-.3-.7-.7-.7H8.1c-.4 0-.7.3-.7.7v1.4c0 .4.3.7.7.7h7.8z"
      }
    },
    color_swatch: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M16.4 4.4l3.2 3.2c.7.8.7 1.9 0 2.7l-8.5 8.5V7l2.6-2.6c.8-.7 1.9-.7 2.7 0zm6.7 12.2v4.6c0 1.1-.8 1.9-1.9 1.9H9.7l8.3-8.3h3.2c1.1 0 1.9.8 1.9 1.8zM.9 18.9V2.8C.9 1.7 1.7.9 2.8.9h4.6c1 0 1.8.8 1.8 1.9v16.1c0 2.3-1.8 4.2-4.1 4.2S.9 21.2.9 18.9zm4.2 1.9c1 0 1.8-.9 1.8-1.9s-.8-1.8-1.8-1.8-1.9.8-1.9 1.8.9 1.9 1.9 1.9z"
      }
    },
    comments: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.1 14.3c-.1-.2-.1-.4 0-.5.6-1.1 1-2.3 1-3.6 0-4.1-3.5-7.4-7.9-7.4-2 0-3.8.8-5.2 2 4.7.5 8.5 4.4 8.5 9.1 0 1.1-.3 2.3-.7 3.3.5-.2 1-.4 1.5-.7.2-.1.4-.1.5 0l2.9 1.1c.2.1.5-.2.4-.4l-1-2.9zM8.8 6.5C4.4 6.5.9 9.8.9 13.9c0 1.3.4 2.5 1 3.5.1.2.1.4 0 .6l-1 2.8c-.1.3.2.5.4.4l2.9-1.1c.1 0 .3 0 .5.1 1.2.7 2.6 1 4.1 1 4.3 0 7.8-3.3 7.8-7.4 0-4-3.5-7.3-7.8-7.3z"
      }
    },
    company: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M9.7 1.8H3.2c-.8 0-1.4.6-1.4 1.4v18.5c0 .2.3.5.5.5h1.9c.2 0 .4-.2.4-.5v-2.8c0-.3.2-.4.5-.4h2.7c.3 0 .5.1.5.4v2.8c0 .3.2.5.5.5h1.4c.5 0 .9-.5.9-1v-18c0-.8-.6-1.4-1.4-1.4zM5.5 16.4c0 .1-.1.2-.2.2H3.9c-.1 0-.2-.1-.2-.2v-2.3c0-.2.1-.3.2-.3h1.4c.1 0 .2.1.2.3v2.3zm0-4.6c0 .1-.1.2-.2.2H3.9c-.1 0-.2-.1-.2-.2V9.5c0-.2.1-.3.2-.3h1.4c.1 0 .2.1.2.3v2.3zm0-4.6c0 .1-.1.2-.2.2H3.9c-.1 0-.2-.1-.2-.2V4.8c0-.1.1-.2.2-.2h1.4c.1 0 .2.1.2.2v2.4zm3.7 9.2c0 .1-.1.2-.2.2H7.6c-.1 0-.2-.1-.2-.2v-2.3c0-.2.1-.3.2-.3H9c.1 0 .2.1.2.3v2.3zm0-4.6c0 .1-.1.2-.2.2H7.6c-.1 0-.2-.1-.2-.2V9.5c0-.2.1-.3.2-.3H9c.1 0 .2.1.2.3v2.3zm0-4.6c0 .1-.1.2-.2.2H7.6c-.1 0-.2-.1-.2-.2V4.8c0-.1.1-.2.2-.2H9c.1 0 .2.1.2.2v2.4zm11.6-.7h-6.5c-.8 0-1.4.6-1.4 1.3v13.9c0 .2.3.5.5.5h1.8c.3 0 .5-.2.5-.5v-2.8c0-.3.2-.4.5-.4h2.7c.3 0 .5.1.5.4v2.8c0 .3.2.5.4.5h1.4c.5 0 1-.5 1-1V7.8c0-.7-.6-1.3-1.4-1.3zm-4.2 9.9c0 .1-.1.2-.2.2H15c-.1 0-.2-.1-.2-.2v-2.3c0-.2.1-.3.2-.3h1.4c.1 0 .2.1.2.3v2.3zm0-4.6c0 .1-.1.2-.2.2H15c-.1 0-.2-.1-.2-.2V9.5c0-.2.1-.3.2-.3h1.4c.1 0 .2.1.2.3v2.3zm3.7 4.6c0 .1-.1.2-.2.2h-1.4c-.1 0-.2-.1-.2-.2v-2.3c0-.2.1-.3.2-.3h1.4c.1 0 .2.1.2.3v2.3zm0-4.6c0 .1-.1.2-.2.2h-1.4c-.1 0-.2-.1-.2-.2V9.5c0-.2.1-.3.2-.3h1.4c.1 0 .2.1.2.3v2.3z"
      }
    },
    connected_apps: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M11 14.4l-1.8 8.1c-.1.5.5.8.8.4l9.7-12c.3-.3.1-.7-.3-.7h-5.2c-.4 0-.6-.5-.4-.7L18.4 2c.2-.5-.1-1.1-.6-1.1H9.6c-.5 0-.9.3-1.1.8L4.7 12.9c-.2.5.1.9.6.9h5.3c.2 0 .5.3.4.6z"
      }
    },
    contract: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M13.7 11.1h7.1c.4 0 .6-.5.2-.9l-2.3-2.3 4.2-4.2c.2-.2.2-.7 0-.9l-1.7-1.7c-.2-.2-.6-.2-.9.1l-4.1 4.1L13.8 3c-.4-.3-.9-.2-.9.3v7.1c0 .3.4.7.8.7zm-3.4 1.8H3.2c-.4 0-.6.5-.2.9l2.3 2.3-4.2 4.2c-.2.2-.2.7 0 .9l1.7 1.7c.2.2.6.2.9 0l4.2-4.2 2.3 2.3c.4.4.9.2.9-.2v-7.1c0-.3-.4-.8-.8-.8zm2.6.8v7.1c0 .4.5.6.9.2l2.3-2.3 4.2 4.2c.2.2.7.2.9 0l1.7-1.7c.2-.2.2-.6-.1-.9l-4.1-4.1 2.3-2.4c.3-.4.2-.9-.3-.9h-7.1c-.3 0-.7.4-.7.8zm-1.8-3.4V3.2c0-.4-.5-.6-.9-.2L7.9 5.3 3.7 1.1c-.2-.2-.7-.2-.9 0L1.1 2.8c-.2.2-.2.6 0 .9l4.2 4.2L3 10.2c-.4.4-.2.9.2.9h7.1c.3 0 .8-.4.8-.8z"
      }
    },
    contract_alt: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M13.7 11h7.1c.4 0 .6-.5.2-.8l-2.3-2.4 4.2-4.2c.2-.2.2-.6 0-.8l-1.7-1.7c-.2-.2-.6-.2-.9 0l-4.1 4.2L13.8 3c-.4-.4-.9-.2-.9.2v7.1c0 .4.4.7.8.7zm-3.4 1.9H3.2c-.4 0-.6.5-.2.9l2.3 2.3-4.2 4.2c-.2.2-.2.7 0 .9l1.7 1.7c.2.2.6.2.9 0l4.2-4.2 2.3 2.3c.4.4.9.2.9-.2v-7.1c0-.3-.4-.8-.8-.8z"
      }
    },
    copy: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M20.3.9h-12c-1 0-1.8.9-1.8 1.9v.9h11c1.1 0 1.9.8 1.9 1.8v13h.9c1 0 1.9-.9 1.9-1.9V2.8c0-1-.9-1.9-1.9-1.9zm-2.8 6.5c0-1-.8-1.9-1.8-1.9h-12c-1 0-1.9.9-1.9 1.9v13.8c0 1 .9 1.9 1.9 1.9h12c1 0 1.8-.9 1.8-1.9V7.4zm-8.3 3.2c0 .3-.2.5-.4.5H5.1c-.3 0-.5-.2-.5-.5v-.9c0-.3.2-.5.5-.5h3.7c.2 0 .4.2.4.5v.9zm3.7 7.4c0 .3-.2.5-.4.5H5.1c-.3 0-.5-.2-.5-.5v-.9c0-.3.2-.5.5-.5h7.4c.2 0 .4.2.4.5v.9zm1.9-3.7c0 .3-.2.5-.5.5H5.1c-.3 0-.5-.2-.5-.5v-.9c0-.3.2-.5.5-.5h9.2c.3 0 .5.2.5.5v.9z"
      }
    },
    copy_to_clipboard: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M8 5.4h8c.4 0 .8-.4.8-.8V3.1c0-1.2-1-2.2-2.2-2.2H9.5c-1.2 0-2.2 1-2.2 2.2v1.5c0 .4.3.8.7.8zm12-2.6h-.8c-.2 0-.3.1-.3.3v1.5c0 1.6-1.3 3-2.9 3H8c-1.6 0-2.9-1.4-2.9-3V3.1c0-.2-.1-.3-.3-.3H4c-1.2 0-2.2 1-2.2 2.2v15.9c0 1.2 1 2.2 2.2 2.2h16c1.2 0 2.2-1 2.2-2.2V5c0-1.2-1-2.2-2.2-2.2z"
      }
    },
    crossfilter: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M16.2 4.2c-.8 0-1.6 0-2.3.3.9.7 1.6 1.5 2.2 2.4h.1c2.8 0 5 2.3 5 5.1s-2.2 5.1-5 5.1c-.7 0-1.4-.2-2-.4.3-.5.7-1.1.9-1.7.1-.2.2-.4.2-.6.3-.7.4-1.6.4-2.4 0-4.3-3.5-7.8-7.9-7.8S0 7.7 0 12s3.5 7.8 7.8 7.8c.8 0 1.6 0 2.3-.3-.9-.7-1.6-1.5-2.2-2.4h-.1c-2.8 0-5-2.3-5-5.1s2.2-5.1 5-5.1c.7 0 1.4.2 2.1.4-1 1.3-1.6 2.9-1.6 4.7 0 4.3 3.5 7.8 7.9 7.8S24 16.3 24 12s-3.5-7.8-7.8-7.8z"
      }
    },
    custom_apps: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.8 5.6c-.1-.2-.4-.3-.6-.1l-3.8 3.7c-.3.3-.7.3-1 0l-2.6-2.6c-.3-.3-.3-.7 0-1l3.8-3.8c.1-.1 0-.5-.2-.6-.6-.2-1.3-.3-2-.3-3.9 0-7 3.4-6.6 7.4.1.7.3 1.2.5 1.8l-8.6 8.5c-1.1 1.1-1.1 2.7 0 3.7.5.5 1.2.8 1.8.8s1.3-.3 1.9-.8l8.5-8.6c.6.2 1.2.4 1.8.5 4 .4 7.4-2.7 7.4-6.6 0-.7-.1-1.4-.3-2z"
      }
    },
    cut: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.8 14.5c-.8-.2-1.5-.1-2.2.1L6.4 1.1C6.3.9 6 .9 5.8 1l-.4.3c-.8.6-.9 1.7-.3 2.6l4.9 6.4c.2.3.2.6 0 .9l-2.7 3.4c-.6-.2-1.4-.2-2.1-.1-1.7.4-3.1 1.7-3.3 3.5-.4 2.7 2 5 4.8 4.6 1.7-.3 3-1.6 3.4-3.2.2-1.2 0-2.2-.5-3l1.9-2.6c.3-.4.8-.4 1.1 0l1.9 2.6c-.5.9-.7 1.9-.5 3 .3 1.6 1.7 2.9 3.4 3.2 2.8.4 5.2-1.9 4.8-4.6-.4-1.8-1.8-3.2-3.4-3.5zM6 19.9c-.8 0-1.4-.6-1.4-1.4s.6-1.4 1.4-1.4 1.3.6 1.3 1.4-.6 1.4-1.3 1.4zm12 0c-.8 0-1.4-.6-1.4-1.4s.6-1.4 1.4-1.4 1.3.6 1.3 1.4c0 .8-.6 1.4-1.3 1.4zM14.4 8.7c.2.3.6.3.8 0l3.7-4.8c.5-.7.4-1.6-.1-2.3h.1-.1c-.1-.1-.7-.6-.7-.6-.1-.1-.5-.1-.6.1l-4.1 5.4c-.2.2-.2.6 0 .8l1 1.4z"
      }
    },
    dash: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M23.1 12.7c0 .4-.3.7-.7.7H1.6c-.4 0-.7-.3-.7-.7v-1.4c0-.4.3-.7.7-.7h20.8c.4 0 .7.3.7.7v1.4z"
      }
    },
    database: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M21 4.2C21 2.4 16.9 1 12 1S3 2.4 3 4.2v1.1C3 7 7.1 8.4 12 8.4s9-1.4 9-3.1V4.2zM3 7.8c0 1.4 4.1 2.5 9 2.5s9-1.1 9-2.5v2.3c0 1.8-4.1 3.2-9 3.2s-9-1.4-9-3.2V7.8zm0 0c0 1.4 4.1 2.5 9 2.5s9-1.1 9-2.5v2.3c0 1.8-4.1 3.2-9 3.2s-9-1.4-9-3.2V7.8zm0 4.9c0 1.4 4.1 2.5 9 2.5s9-1.1 9-2.5V15c0 1.7-4.1 3.1-9 3.1S3 16.8 3 15v-2.3zm0 4.9c0 1.4 4.1 2.5 9 2.5s9-1.1 9-2.5v2.2c0 1.8-4.1 3.2-9 3.2s-9-1.4-9-3.2v-2.2z"
      }
    },
    datadotcom: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M19.6 22.7h-2.4c-.2-.9-.3-1.7-.3-2.4-1.2 1.9-3.1 2.8-5.6 2.8-2.3 0-4-.8-5.2-2.3-1.2-1.5-1.7-3.5-1.7-5.9 0-1.6.3-2.9.9-4.2s1.4-2.3 2.5-2.9c1.1-.8 2.4-1.2 3.9-1.2 2.1 0 3.8.7 5.1 2.1V1h2.6v18.2c0 1.2.1 2.3.2 3.5zM16.8 16v-5c-.6-.8-1.3-1.3-2.1-1.7-.8-.4-1.7-.6-2.7-.6-1.5 0-2.7.6-3.6 1.7-.9 1.2-1.3 2.7-1.3 4.5 0 1.9.4 3.3 1.3 4.4.8 1.1 2 1.7 3.5 1.7 1.4 0 2.6-.5 3.5-1.4.9-1 1.4-2.2 1.4-3.6z"
      }
    },
    dayview: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M20.3 3.2H18v-.9c0-.7-.6-1.4-1.4-1.4-.7 0-1.4.6-1.4 1.4v.9H8.8v-.9c0-.7-.6-1.4-1.4-1.4C6.6.9 6 1.5 6 2.3v.9H3.7c-1 0-1.9.9-1.9 1.9v1.1c0 .4.4.7.7.7h19c.3 0 .7-.3.7-.7V5.1c0-1-.9-1.9-1.9-1.9zm1.2 6h-19c-.3 0-.7.4-.7.7v11.3c0 1 .9 1.9 1.9 1.9h16.6c1 0 1.9-.9 1.9-1.9V9.9c0-.3-.4-.7-.7-.7zm-8.1 10.2v.1c0 .3-.5.8-.9.8s-1-.5-1-.9v-4.6l-.7.7c-.1.1-.2.2-.4.2-.4 0-.7-.3-.7-.7 0-.2.1-.4.2-.5l1.8-1.8c.2-.2.4-.3.7-.3.5 0 1 .4 1 .9v6.1z"
      }
    },
    delete: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M21 4.6h-5.8V2.8c0-1-.8-1.9-1.8-1.9h-2.8c-1 0-1.8.9-1.8 1.9v1.8H3c-.4 0-.7.3-.7.7v1.4c0 .4.3.7.7.7h18c.4 0 .7-.3.7-.7V5.3c0-.4-.3-.7-.7-.7zM10.6 3.2c0-.2.2-.4.5-.4h1.8c.3 0 .5.2.5.4v1.4h-2.8V3.2zm8.6 6H4.8c-.3 0-.6.4-.6.7v10.9c0 1.3 1 2.3 2.3 2.3h11c1.3 0 2.3-1 2.3-2.3V9.9c0-.3-.3-.7-.6-.7zm-8.6 10.2c0 .3-.2.4-.4.4h-1c-.2 0-.4-.1-.4-.4v-6.5c0-.3.2-.4.4-.4h1c.2 0 .4.1.4.4v6.5zm4.6 0c0 .3-.2.4-.4.4h-1c-.2 0-.4-.1-.4-.4v-6.5c0-.3.2-.4.4-.4h1c.2 0 .4.1.4.4v6.5z"
      }
    },
    deprecate: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.2 3.2H1.8c-.5 0-.9.4-.9 1v12c0 .5.4.9.9.9h7.5c.5 2.6 2.7 4.6 5.5 4.6s5-2 5.4-4.6h2c.5 0 .9-.4.9-.9v-12c0-.6-.4-1-.9-1zm-4 15.1l-1.3 1.3-2.1-2.2-2.2 2.2-1.2-1.3 2.1-2.1-2.1-2.2 1.2-1.3 2.2 2.2 2.1-2.2 1.3 1.3-2.1 2.2 2.1 2.1zm3-3.1h-1c-.4-2.6-2.7-4.6-5.4-4.6s-5.1 2-5.5 4.6H2.8V5.1h18.4v10.1z"
      }
    },
    description: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M20.3 1.8H3.7c-1 0-1.9.9-1.9 1.9v16.6c0 1 .9 1.9 1.9 1.9h16.6c1 0 1.9-.9 1.9-1.9V3.7c0-1-.9-1.9-1.9-1.9zM5.5 6.5c0-.3.2-.5.5-.5h4.6c.3 0 .5.2.5.5v4.6c0 .3-.2.4-.5.4H6c-.3 0-.5-.1-.5-.4V6.5zm11.1 12c0 .2-.2.4-.4.4H6c-.3 0-.5-.2-.5-.4v-1c0-.2.2-.4.5-.4h10.2c.2 0 .4.2.4.4v1zm1.9-3.7c0 .2-.2.4-.5.4H6c-.3 0-.5-.2-.5-.4v-1c0-.2.2-.4.5-.4h12c.3 0 .5.2.5.4v1zm0-3.7c0 .3-.2.4-.5.4h-4.6c-.3 0-.5-.1-.5-.4v-.9c0-.3.2-.5.5-.5H18c.3 0 .5.2.5.5v.9zm0-3.7c0 .3-.2.4-.5.4h-4.6c-.3 0-.5-.1-.5-.4v-.9c0-.3.2-.5.5-.5H18c.3 0 .5.2.5.5v.9z"
      }
    },
    desktop: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M23.1 2.8c0-1-.9-1.9-1.9-1.9H2.8C1.8.9.9 1.8.9 2.8v12c0 1 .9 1.8 1.9 1.8h18.4c1 0 1.9-.8 1.9-1.8v-12zm-2.8 10.4c0 .3-.3.6-.7.6H4.4c-.4 0-.7-.3-.7-.6V4.4c0-.4.3-.7.7-.7h15.2c.4 0 .7.3.7.7v8.8zm-5.1 7.1h-1.4c-.2 0-.4-.2-.4-.5v-.9c0-.3-.2-.4-.5-.4h-1.8c-.3 0-.5.1-.5.4v.9c0 .3-.2.5-.4.5H8.8c-1 0-1.9.8-1.9 1.9v.2c0 .4.3.7.7.7h8.8c.4 0 .7-.3.7-.7v-.2c0-1.1-.9-1.9-1.9-1.9z"
      }
    },
    dislike: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M5.5 13.6V4.2c0-1.1-.8-1.9-1.8-1.9H2.5c-.3 0-.7.3-.7.7v10.6c0 .4.4.7.7.7h2.3c.4 0 .7-.3.7-.7zM22.2 12V6.2c0-4-3.2-4.4-6.7-4.4-3.3 0-4.3 1.3-7.5 1.4-.3 0-.6.4-.6.7v9.3c0 .3.3.6.7.6 2.2 0 3.9 2.4 3.9 4.9v2.8c0 .3.3.7.7.7h1.1c1.1 0 1.9-.9 1.9-1.9v-4.6c0-1 .8-1.9 1.8-1.9h2.8c1 0 1.9-.8 1.9-1.8z"
      }
    },
    dock_panel: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M.9 16.2v-12C.9 2.4 2.3.9 4.1.9h12c1.8 0 3.2 1.5 3.2 3.3v1.3h-2.7V4.2c0-.3-.2-.5-.5-.5h-12c-.3 0-.5.2-.5.5v12c0 .2.2.4.5.4h1.4v2.8H4.1C2.3 19.4.9 18 .9 16.2zm20.3-8.8h-12c-1 0-1.9.8-1.9 1.8v12c0 1 .9 1.9 1.9 1.9h12c1 0 1.8-.9 1.8-1.9v-12c0-1-.8-1.8-1.8-1.8zM19.3 19c0 .2-.1.4-.4.4h-5.3c-.3 0-.5-.2-.5-.4v-.9c0-.2.2-.4.5-.4h2.2c.3 0 .4-.3.2-.5l-4.8-4.8c-.2-.1-.2-.4 0-.6l.6-.6c.2-.1.4-.1.6 0l4.8 4.8c.2.2.4.1.4-.2v-2.2c0-.2.3-.4.5-.4h.9c.2 0 .3.2.3.4V19z"
      }
    },
    down: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M3.8 6.5h16.4c.4 0 .8.6.4 1l-8 9.8c-.3.3-.9.3-1.2 0l-8-9.8c-.4-.4-.1-1 .4-1z"
      }
    },
    download: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.4 14.3H21c-.4 0-.7.3-.7.7v4.6c0 .4-.3.7-.7.7H4.4c-.4 0-.7-.3-.7-.7V15c0-.4-.3-.7-.7-.7H1.6c-.4 0-.7.3-.7.7v6.2c0 1 .9 1.9 1.9 1.9h18.4c1 0 1.9-.9 1.9-1.9V15c0-.4-.3-.7-.7-.7zm-10.9 3.1c.3.2.7.2 1 0l6.2-6.3c.3-.3.3-.7 0-.9l-.9-1c-.3-.3-.7-.3-1 0l-2.6 2.6c-.3.2-.8.1-.8-.4V1.6c0-.4-.4-.7-.7-.7h-1.4c-.4 0-.7.3-.7.7v9.8c0 .4-.5.6-.8.3L7.2 9.1c-.2-.2-.6-.2-.9 0l-1 1.1c-.3.2-.3.6 0 .9l6.2 6.3z"
      }
    },
    edit: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M4.4 15.4l4.1 4.1c.2.2.5.2.6 0L19.4 9.2c.2-.2.2-.4 0-.6l-4.1-4.1c-.2-.2-.4-.2-.6 0L4.4 14.8c-.2.2-.2.5 0 .6zM16.7 2.6c-.2.2-.2.5 0 .7l4 4c.2.2.5.2.7 0l1.1-1.1c.8-.7.8-1.8 0-2.6l-2.1-2.1c-.8-.8-1.9-.8-2.7 0l-1 1.1zM1 22.2c-.1.5.3.9.8.8l5-1.2c.2 0 .3-.1.4-.2l.1-.1c.1-.1.1-.4-.1-.6l-4.1-4.1c-.2-.2-.5-.2-.6-.1l-.1.1c-.1.1-.2.3-.2.4l-1.2 5z"
      }
    },
    edit_form: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M14.5 7.1h3.8c.3 0 .5-.3.5-.5s-.1-.3-.2-.4l-4.7-4.7c-.1-.1-.2-.1-.3-.1-.3 0-.5.2-.5.5v3.7c0 .8.6 1.5 1.4 1.5zm8.3 4.8l-.4-.5c-.2-.2-.7-.2-1 0l-5.5 5.5v1.3c0 .1 0 .2.1.2h1.4l5.4-5.5c.4-.3.4-.8 0-1zm-4.4 8.6h-3.3c-.7 0-1.3-.6-1.3-1.3v-2.5c0-.4.1-.8.4-1l4.4-4.4c.1-.1.2-.3.2-.5v-.9c0-.4-.3-.7-.7-.7h-5c-1.2 0-2.2-1-2.2-2.1v-5c0-.4-.3-.7-.7-.7H3C1.9 1.4.9 2.4.9 3.5v17c0 1.1 1 2.1 2.1 2.1h13.6c1 0 2-.7 2.1-1.7.1-.2-.1-.4-.3-.4zM3.8 7.8c0-.4.3-.7.7-.7h2.8c.5 0 .7.3.7.7v.6c0 .4-.3.7-.7.7H4.5c-.4 0-.7-.3-.7-.7v-.6zm7.1 9.1c0 .4-.3.7-.7.7H4.5c-.4 0-.7-.3-.7-.7v-.7c0-.3.3-.6.7-.6h5.7c.4 0 .7.3.7.6v.7zm1.5-4.2c0 .4-.4.7-.7.7H4.5c-.4 0-.7-.3-.7-.7V12c0-.4.3-.7.7-.7h7.1c.4 0 .7.3.7.7v.7z"
      }
    },
    email: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M11.5 13.9c.3.3.7.3 1 0l10.4-9.7c.2-.4.1-1-.6-1l-20.6.1c-.6 0-1.1.5-.6.9l10.4 9.7zM23.1 8c0-.5-.6-.8-.9-.4L14 15.1c-.6.5-1.3.8-2 .8s-1.4-.3-2-.8L1.9 7.6c-.4-.4-.9-.1-.9.4C.9 7.8.9 18.5.9 18.5c0 1 .9 1.8 1.9 1.8h18.4c1 0 1.9-.8 1.9-1.8V8z"
      }
    },
    emoji: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M23.1 12c0 6.1-5 11.1-11.1 11.1S.9 18.1.9 12 5.9.9 12 .9s11.1 5 11.1 11.1zM8.4 7.3c-1.1 0-1.9.9-1.9 2s.8 2 1.9 2 2-.9 2-2-.8-2-2-2zm7.2 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-.1 7.7c-.9.8-2.2 1.3-3.5 1.3-1.3 0-2.5-.5-3.5-1.3l-.4-.3c-.1-.1-.2-.2-.5-.2-.5 0-.9.5-.9.9 0 .2.1.5.3.7l.3.2c1.3 1.1 2.9 1.8 4.7 1.8 1.8 0 3.5-.7 4.7-1.8l.2-.2c.2-.2.3-.5.3-.7 0-.5-.4-.9-.9-.9-.2 0-.4.1-.5.2l-.3.3z"
      }
    },
    end_call: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.4 2.6l-1-1c-.3-.3-.8-.2-1.1.2L9.5 12.6 7.2 10c-.3-.3-.3-.6-.1-1l1.7-2.4c.5-.6.5-1.5 0-2.2L6.5 1.6C5.8.8 4.6.7 3.8 1.5L1.4 3.9c-.4.3-.6.9-.6 1.4.3 4.2 2 8.3 4.6 11.3l-3.6 3.7c-.4.3-.4.8-.2 1.1l1 1c.3.3.8.2 1.1-.2L22.2 3.7c.4-.3.5-.8.2-1.1zm0 14.9l-2.8-2.3c-.7-.5-1.6-.5-2.2 0L15 16.9c-.3.3-.7.2-1-.1l-1.1-1-3.9 4c2.8 1.8 6.1 3.1 9.6 3.3.6 0 1.1-.2 1.4-.6l2.4-2.4c.9-.7.9-2 0-2.6z"
      }
    },
    end_chat: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M13.1 13.9c2-2 5-2.4 7.4-1.3.4-1 .6-2 .6-3C21 4.5 16.6.4 11.2.4 5.7.4 1.3 4.5 1.3 9.5c0 1.5.5 3 1.2 4.3.2.2.2.5.1.7L1.3 18c-.1.4.2.6.6.6l3.5-1.3c.2-.1.5-.1.7.1 1.5.7 3.2 1.2 5 1.2 0-1.7.7-3.4 2-4.7zm3.1-6.1c.9 0 1.6.8 1.6 1.7s-.7 1.7-1.6 1.7-1.7-.8-1.7-1.7.7-1.7 1.7-1.7zm-10 3.4c-.9 0-1.6-.8-1.6-1.7s.7-1.7 1.6-1.7 1.7.8 1.7 1.7-.7 1.7-1.7 1.7zm5-3.4c.9 0 1.6.8 1.6 1.7s-.7 1.7-1.6 1.7-1.7-.8-1.7-1.7.8-1.7 1.7-1.7zm10 7.3c-1.9-1.9-5-1.9-7 0s-1.9 5.1 0 7 5.1 1.9 7 0 2-5.1 0-7zm-1.4 4.4c.2.2.2.4 0 .6l-.6.6c-.2.2-.4.2-.6-.1l-.9-.8-.9.9c-.2.2-.4.2-.6-.1l-.6-.6c-.1-.2-.1-.3 0-.5l.9-.9-.9-1c-.1-.2-.1-.3 0-.5l.6-.6c.2-.2.5-.2.6-.1l.9.9.9-.9c.1-.2.4-.2.6 0l.6.6c.1.2.1.4-.1.6l-.9.9 1 1z"
      }
    },
    erect_window: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M23.1 3c0 .4-.3.7-.7.7H1.6c-.4 0-.7-.3-.7-.7V1.6c0-.4.3-.7.7-.7h20.8c.4 0 .7.3.7.7V3z"
      }
    },
    error: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12 .9C5.9.9.9 5.9.9 12s5 11.1 11.1 11.1 11.1-5 11.1-11.1S18.1.9 12 .9zm5.5 11.9c-.1.3-.3.6-.7.6H7.2c-.4 0-.6-.2-.7-.6v-1.6c.1-.3.3-.6.7-.6h9.6c.4 0 .6.3.7.6v1.6z"
      }
    },
    event: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M21.5 9.2h-19c-.3 0-.7.4-.7.7v11.3c0 1 .9 1.9 1.9 1.9h16.6c1 0 1.9-.9 1.9-1.9V9.9c0-.3-.4-.7-.7-.7zM8.8 19.4c0 .3-.2.4-.5.4H6.5c-.3 0-.5-.1-.5-.4v-1.9c0-.2.2-.4.5-.4h1.8c.3 0 .5.2.5.4v1.9zm0-4.6c0 .2-.2.4-.5.4H6.5c-.3 0-.5-.2-.5-.4v-1.9c0-.3.2-.4.5-.4h1.8c.3 0 .5.1.5.4v1.9zm4.6 4.6c0 .3-.2.4-.5.4h-1.8c-.3 0-.5-.1-.5-.4v-1.9c0-.2.2-.4.5-.4h1.8c.3 0 .5.2.5.4v1.9zm0-4.6c0 .2-.2.4-.5.4h-1.8c-.3 0-.5-.2-.5-.4v-1.9c0-.3.2-.4.5-.4h1.8c.3 0 .5.1.5.4v1.9zm4.6 4.6c0 .3-.2.4-.5.4h-1.8c-.3 0-.5-.1-.5-.4v-1.9c0-.2.2-.4.5-.4h1.8c.3 0 .5.2.5.4v1.9zm0-4.6c0 .2-.2.4-.5.4h-1.8c-.3 0-.5-.2-.5-.4v-1.9c0-.3.2-.4.5-.4h1.8c.3 0 .5.1.5.4v1.9zm2.3-11.6H18v-.9c0-.7-.6-1.4-1.4-1.4-.7 0-1.4.6-1.4 1.4v.9H8.8v-.9c0-.7-.6-1.4-1.4-1.4C6.6.9 6 1.5 6 2.3v.9H3.7c-1 0-1.9.9-1.9 1.9v1.1c0 .4.4.7.7.7h19c.3 0 .7-.3.7-.7V5.1c0-1-.9-1.9-1.9-1.9z"
      }
    },
    expand: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.5.9h-7.1c-.5 0-.6.4-.3.8L17.4 4l-4.2 4.1c-.2.3-.2.6 0 .9l1.8 1.7c.2.2.6.2.8 0L20 6.5l2.3 2.3c.4.3.8.2.8-.3V1.4c0-.2-.3-.5-.6-.5zM1.6 23.1h7.1c.5 0 .6-.5.3-.9l-2.3-2.3 4.1-4.2c.3-.2.3-.7 0-.9l-1.7-1.7c-.2-.2-.6-.2-.8 0l-4.2 4.2L1.8 15c-.4-.4-.9-.2-.9.2v7.1c0 .4.4.8.7.8zm21.5-.6v-7.1c0-.5-.4-.6-.8-.3L20 17.4l-4.1-4.2c-.3-.2-.6-.2-.9 0L13.3 15c-.2.2-.2.6 0 .8l4.2 4.2-2.3 2.3c-.3.4-.2.8.3.8h7.1c.2 0 .5-.3.5-.6zM.9 1.6v7.1c0 .5.5.6.9.3l2.3-2.3 4.2 4.1c.2.3.7.3.9 0l1.7-1.7c.2-.2.2-.6 0-.8L6.7 4.1 9 1.8c.4-.4.2-.9-.2-.9H1.7c-.4 0-.8.4-.8.7z"
      }
    },
    expand_all: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.2 4.4c0-.4-.4-.7-.7-.7h-19c-.3 0-.7.3-.7.7v1.4c0 .3.4.7.7.7h19c.3 0 .7-.4.7-.7V4.4zm0 13.8c0-.3-.4-.7-.7-.7h-19c-.3 0-.7.4-.7.7v1.4c0 .4.4.7.7.7h19c.3 0 .7-.3.7-.7v-1.4zm-8.4-4.8h2.1c.4 0 .7-.3.7-.7v-1.4c0-.4-.3-.7-.7-.7h-2.1c-.2 0-.4-.2-.4-.4V8.1c0-.4-.3-.7-.7-.7h-1.4c-.4 0-.7.3-.7.7v2.1c0 .2-.2.4-.4.4H8.1c-.4 0-.7.3-.7.7v1.4c0 .4.3.7.7.7h2.1c.2 0 .4.2.4.4v2.1c0 .4.3.7.7.7h1.4c.4 0 .7-.3.7-.7v-2.1c0-.2.2-.4.4-.4z"
      }
    },
    expand_alt: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.5.9h-7.1c-.5 0-.6.4-.3.8L17.4 4l-4.2 4.1c-.2.3-.2.6 0 .9l1.8 1.7c.2.2.6.2.8 0L20 6.5l2.3 2.3c.4.3.8.2.8-.3V1.4c0-.2-.3-.5-.6-.5zM1.6 23.1h7.1c.5 0 .6-.5.3-.9l-2.3-2.3 4.1-4.2c.3-.2.3-.7 0-.9l-1.7-1.7c-.2-.2-.6-.2-.8 0l-4.2 4.2L1.8 15c-.4-.4-.9-.2-.9.2v7.1c0 .4.4.8.7.8z"
      }
    },
    fallback: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12.9 1.6l-1.4 6.8c0 .2.2.4.5.4h7.2c.5 0 .8.6.6 1l-7.9 12.9c-.3.7-1.3.4-1.3-.3l1.4-8c0-.2-.2-.1-.5-.1H3.9c-.5 0-.9-.8-.6-1.2l8.3-11.8c.4-.6 1.3-.4 1.3.3z"
      }
    },
    favorite: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12.6 1.4l2.2 7c.1.2.3.4.6.4h6.9c.7 0 1 .9.5 1.3l-5.7 4.2c-.2.1-.3.5-.2.7l2.7 7.2c.2.6-.5 1.2-1.1.7l-6-4.5c-.3-.2-.6-.2-.9 0l-6.1 4.5c-.5.5-1.3-.1-1-.7L7.1 15c.1-.2 0-.6-.3-.7l-5.6-4.2c-.6-.4-.2-1.3.4-1.3h6.9c.4 0 .6-.1.7-.4l2.2-7c.1-.7 1.1-.6 1.2 0z"
      }
    },
    feed: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M11.6 19.8c-.1 0-.3 0-.5-.1-.3-.1-.5-.5-.5-.7L7.9 8.3l-2.2 5.1c-.2.4-.5.6-.9.6H1.6c-.4 0-.7-.2-.7-.6v-.7c0-.4.3-.7.7-.7H4l3.2-7.2c.2-.4.6-.7 1.1-.6.4 0 .8.3.9.7l2.7 10.8 3.7-7.9c.1-.4.6-.6 1-.6.3.1.7.4.9.7l1.8 4.1h3.1c.4 0 .7.4.7.7v.7c0 .4-.3.7-.7.7h-3.8c-.4 0-.7-.3-.9-.6l-1.2-2.7-3.9 8.5c-.2.3-.5.5-1 .5z"
      }
    },
    file: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M4.5 16.7V5.2c-1.2 0-2.2 1-2.2 2.1v13.6c0 1.2 1 2.2 2.2 2.2h10.7c1.2 0 2.2-1 2.2-2.1H8.8c-2.4 0-4.3 0-4.3-4.3zM21 7.3h-3.6c-1.2 0-2.2-.9-2.2-2.1V1.6c0-.4-.3-.7-.7-.7H8.8C7.6.9 6.6 1.9 6.6 3v13.6c0 1.2 1 2.1 2.2 2.1h10.7c1.2 0 2.2-.9 2.2-2.1V8.1c0-.4-.3-.8-.7-.8zm.6-3l-3.4-3.2c-.1-.1-.2-.2-.3-.2-.3 0-.5.3-.5.5v2.4c0 .8.6 1.4 1.4 1.4h2.4c.3 0 .5-.2.5-.5 0-.1-.1-.2-.1-.4z"
      }
    },
    filter: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M11.3 14.7c-.3-.3-.7-.3-1 0l-1.7 1.6c-.2.3-.8.1-.8-.3V9.9c0-.3-.3-.7-.6-.7H5.8c-.4 0-.7.4-.7.7V16c0 .4-.5.6-.8.3l-1.7-1.6c-.2-.3-.7-.3-.9 0l-1.1 1c-.2.3-.2.7 0 1L6 22c.2.2.6.2.9 0l5.4-5.4c.3-.3.3-.7 0-1l-1-.9zM23.5 4.4c0-.4-.3-.7-.7-.7h-17c-.4 0-.7.3-.7.7v1.4c0 .3.3.7.7.7h17c.4 0 .7-.4.7-.7V4.4zm0 5.5c0-.3-.3-.7-.7-.7H10.4c-.4 0-.7.4-.7.7v1.4c0 .4.3.7.7.7h12.4c.4 0 .7-.3.7-.7V9.9zm0 5.6c0-.4-.3-.7-.7-.7H15c-.4 0-.7.3-.7.7v1.3c0 .4.3.7.7.7h7.8c.4 0 .7-.3.7-.7v-1.3z"
      }
    },
    filterlist: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.3 1.8H1.8c-.7 0-1 .8-.6 1.3l9 10.5c.2.3.4.8.4 1.2v6.7c0 .3.3.7.7.7h1.4c.4 0 .6-.4.6-.7v-6.7c0-.4.2-.9.5-1.2l9.1-10.5c.4-.5.1-1.3-.6-1.3z"
      }
    },
    flow: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M23 4.9c-.9-1.9-3.4-5.4-7.9-3.3-2.8 1.3-4.4 2-4.4 2L6.6 5.4c-1.1.5-3.6-.3-5-.8-.4-.1-.8.3-.6.7.9 1.9 3.4 5.4 7.9 3.3 2.8-1.3 8.5-3.7 8.5-3.7 1.1-.6 3.6.2 5 .7.4.1.8-.3.6-.7zm-9.7 5.9c-.5.3-2.5 1.2-2.5 1.2l-2.1.9c-1 .5-3.2-.2-4.5-.7-.3-.2-.6.3-.5.6.9 1.9 3 5.2 7 3.2 2.5-1.3 4.6-2.1 4.6-2.1 1-.6 3.2.2 4.5.7.3.1.6-.3.5-.7-.9-1.8-3-5.1-7-3.1zM11.8 19c-.4.2-1.1.6-1.1.6-.8.5-2.4-.1-3.4-.6-.2-.1-.5.3-.3.7.6 1.6 2.2 4.6 5.2 2.8l1.1-.7c.8-.4 2.4.2 3.4.6.2.2.5-.2.3-.6-.6-1.7-2.1-4.5-5.2-2.8zm.2-7.4"
      }
    },
    food_and_drink: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.9 11.1c-.5 3.6-3.4 6-6 6H7.4c-2.8 0-6-2.8-6-6.9V3.7c0-.5.4-.9.9-.9h18c1.5 0 2.8 1.2 2.8 2.7v2.8c0 1.5-1.3 2.8-2.8 2.8h-1.4zM18 2.8zm.7 15.7c.4 0 .7.3.7.6v.1c0 1.1-.9 2-2.1 2H3c-1.2 0-2.1-.9-2.1-2v-.1c0-.3.3-.6.7-.6h17.1zm.2-13.4v3.7h.9c.6 0 1-.4 1-1V6c0-.5-.4-.9-1-.9h-.9z"
      }
    },
    forward: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M1.6 13.4h15.3c.4 0 .6.5.3.8l-4.4 4.4c-.3.3-.3.7 0 1l1 1c.3.3.7.3 1 0l8-8.1c.3-.3.3-.7 0-1l-8-8.1c-.3-.3-.7-.3-1 0l-1 1c-.2.3-.2.7 0 1l4.5 4.4c.2.3.1.8-.4.8H1.6c-.4 0-.7.3-.7.7v1.3c0 .4.3.8.7.8z"
      }
    },
    frozen: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M12.5 1.4c.2 0 .4.2.4.4V23c0 .3-.2.5-.4.5h-1c-.2 0-.4-.2-.4-.5V1.8c0-.2.2-.4.4-.4h1zM12 7.9L8.3 4.2c-.2-.2-.2-.5 0-.6l.6-.7c.2-.2.5-.2.7 0L12 5.4l2.4-2.5c.2-.2.5-.2.7 0l.6.7c.2.1.2.4 0 .6L12 7.9m0 9l3.7 3.8c.2.2.2.4 0 .6l-.6.7c-.2.2-.5.2-.7 0L12 19.5 9.6 22c-.2.2-.5.2-.7 0l-.6-.7c-.2-.2-.2-.4 0-.6l3.7-3.8"
      }, {
        "d": "M21.7 7.2c.2.2.1.5-.1.6L3.3 18.6c-.2.1-.5.1-.6-.2l-.5-.8c-.1-.2-.1-.5.2-.6L20.6 6.2c.3-.2.5-.1.7.2l.4.8zm-5.8 3L17.2 5c0-.2.2-.4.5-.3l.9.2c.3.1.4.3.3.6L18 8.9l3.4.8c.3.1.4.3.3.6l-.2.9c0 .2-.3.4-.5.3l-5.1-1.3m-7.8 4.5l-1.3 5.1c0 .3-.2.5-.5.4l-.9-.3c-.3 0-.4-.2-.3-.5L6 16l-3.4-.9c-.3 0-.4-.2-.3-.5l.2-.9c0-.3.3-.4.5-.3l5.1 1.3"
      }, {
        "d": "M2.7 6.4c.2-.2.4-.3.7-.2L21.6 17c.2.2.3.4.2.7l-.5.8c-.1.2-.4.3-.6.1L2.4 7.8c-.2-.1-.3-.4-.2-.6l.5-.8zm5.4 3.8L3 11.5c-.3 0-.5-.1-.6-.3l-.2-.9c0-.3.1-.5.3-.6l3.4-.8L5 5.5c0-.3.1-.5.4-.6l.8-.2c.3 0 .5.1.6.3l1.3 5.2m7.7 4.5l5.2-1.3c.2-.1.5 0 .5.3l.2.9c.1.3 0 .5-.3.5L18 16l.9 3.4c.1.3 0 .5-.3.5l-.9.3c-.3 0-.5-.1-.5-.4l-1.4-5.1"
      }]
    },
    full_width_view: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.4 1.8H1.6c-.4 0-.7.4-.7.7v2.3c0 .4.3.7.7.7h20.8c.4 0 .7-.3.7-.7V2.5c-.1-.3-.3-.7-.7-.7zM4.9 7.4H1.7c-.4 0-.7.3-.7.7v13.7c0 .4.3.7.7.7h3.2c.4 0 .7-.3.7-.7V8.1c0-.4-.3-.7-.7-.7zm17.5 0h-3.2c-.4 0-.7.3-.7.7v13.7c0 .4.3.7.7.7h3.2c.4 0 .7-.3.7-.7V8.1c0-.4-.3-.7-.7-.7zm-6.5 0H8.2c-.4 0-.7.3-.7.7v13.7c0 .4.3.7.7.7h7.7c.4 0 .7-.3.7-.7V8.1c0-.4-.3-.7-.7-.7z"
      }
    },
    graph: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M.9 21c0 1 .9 1.8 1.9 1.8h19.5c.5 0 .8-.3.8-.7v-1.3c0-.4-.3-.7-.8-.7H4.4c-.4 0-.7-.3-.7-.7V1.9c0-.4-.3-.7-.7-.7H1.7c-.5 0-.8.3-.8.7V21zm22-14.5c0-.8-.6-1.4-1.3-1.4-.5 0-.8.2-1.1.4l-3.9 4-2.8-2.6-.1-.1s0-.1-.1-.1c0 0-.1 0-.1-.1h-.1-.2l-.1-.1h-.5c-.1 0-.1 0-.1.1H12.2c-.1.1-.1.1-.2.1v.1s-.1.1-.2.1l-5.2 5.3c-.3.3-.5.6-.5 1 0 .8.6 1.4 1.4 1.4.3 0 .6-.1.9-.3l4.5-4.5 2.6 2.6.1.1.1.1c.1 0 .1 0 .2.1h.1c0 .1.1.1.2.1s.2.1.3.1c.1 0 .2 0 .3-.1H17.1s0-.1.1-.1.1 0 .1-.1h.1l.1-.1 5-5c.3-.3.4-.6.4-1z"
      }
    },
    groups: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M7.3 12.9c-.6-.9-.9-2.1-.9-3.3 0-2.1.8-3.9 2.2-4.9-.4-.9-1.4-1.5-2.6-1.5-2 0-3.1 1.7-3.1 3.6 0 1 .3 1.9 1 2.5.3.3.7.8.7 1.3s-.2.9-1.4 1.4c-1.6.7-3.2 1.8-3.2 3.3 0 1 .7 1.8 1.7 1.8h1.5c.2 0 .4-.2.6-.4.7-1.3 2.1-2.2 3.3-2.8.4-.1.5-.7.2-1zm13.5-.9c-1.1-.5-1.3-.9-1.3-1.4s.3-1 .7-1.3c.7-.7 1-1.5 1-2.5 0-1.9-1.1-3.6-3.2-3.6-1.2 0-2.1.6-2.6 1.5 1.4 1 2.2 2.8 2.2 4.9 0 1.2-.3 2.4-.9 3.3-.3.4-.1.9.2 1 1.2.6 2.6 1.5 3.3 2.8.2.2.4.4.6.4h1.5c1 0 1.7-.8 1.7-1.8 0-1.5-1.5-2.6-3.2-3.3zm-5.7 3.4c-1.3-.6-1.5-1.1-1.5-1.6 0-.6.4-1.1.8-1.4.7-.7 1.2-1.7 1.2-2.8 0-2.1-1.3-3.9-3.6-3.9S8.5 7.5 8.5 9.6c0 1.1.5 2.1 1.2 2.8.4.4.8.9.8 1.4 0 .6-.2 1-1.5 1.6-1.8.8-3.6 1.6-3.6 3.3 0 1.1.8 2 1.8 2h9.6c1.1 0 1.9-.9 1.9-2 0-1.6-1.8-2.5-3.6-3.3z"
      }
    },
    help: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M13.1 17.5h-2.3c-.4 0-.6-.2-.6-.6v-.7c0-1.9 1.2-3.7 3-4.3.6-.2 1.1-.5 1.5-1 2.3-2.8.2-6.1-2.6-6.2-1 0-1.9.3-2.7 1-.6.6-1 1.3-1 2.1-.1.2-.4.5-.7.5H5.4c-.5 0-.8-.4-.7-.8.1-1.7.9-3.3 2.2-4.5C8.4 1.6 10.2.8 12.3.9c3.8.1 6.9 3.3 7.1 7.1.1 3.2-1.9 6.1-4.9 7.2-.4.2-.7.5-.7 1v.6c0 .5-.3.7-.7.7zm.7 4.9c0 .4-.3.7-.6.7h-2.4c-.3 0-.6-.3-.6-.7v-2.3c0-.4.3-.7.6-.7h2.4c.3 0 .6.3.6.7v2.3z"
      }
    },
    hide: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M23.9 11.6c-.7-1.5-1.7-2.8-2.9-3.9l-3.9 3.9v.4c0 2.8-2.3 5.1-5.1 5.1h-.4l-2.5 2.5c.9.2 1.9.3 2.9.3 5.2 0 9.7-3.1 11.9-7.4.1-.4.1-.6 0-.9zm-1.5-9l-1-1c-.3-.3-.8-.2-1.1.2l-3.4 3.3c-1.5-.6-3.1-.9-4.9-.9-5.2 0-9.7 3-11.9 7.4-.1.3-.1.6 0 .8 1 2.1 2.5 3.8 4.4 5.1l-2.7 2.8c-.4.3-.4.8-.2 1.1l1 1c.3.3.8.2 1.1-.2L22.2 3.7c.4-.3.5-.8.2-1.1zM6.9 12c0-2.8 2.3-5.1 5.1-5.1.9 0 1.8.3 2.5.7L13.1 9c-.4-.1-.7-.2-1.1-.2-1.8 0-3.2 1.4-3.2 3.2 0 .4.1.7.2 1.1l-1.4 1.4c-.4-.7-.7-1.6-.7-2.5z"
      }
    },
    hierarchy: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M10.7 10.6H5c-.3 0-.7.3-.7.6v4.9H2.4c-.3 0-.6.3-.6.6v4.6c0 .3.3.7.6.7h6.4c.3 0 .6-.4.6-.7v-4.6c0-.3-.3-.6-.6-.6H6.9v-3H17v3h-1.9c-.3 0-.7.3-.7.6v4.6c0 .3.4.7.7.7h6.3c.3 0 .6-.4.6-.7v-4.6c0-.3-.3-.6-.6-.6h-1.9v-4.9c0-.3-.3-.6-.7-.6h-5.6V7.7h1.9c.3 0 .6-.4.6-.7V2.4c0-.3-.3-.6-.6-.6H8.8c-.4 0-.7.3-.7.6V7c0 .3.3.7.7.7h1.9v2.9z"
      }
    },
    home: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.6 12.5h-2.3v10.1c0 .3-.2.5-.5.5h-4.6c-.2 0-.4-.2-.4-.5v-7.8H9.2v7.8c0 .3-.2.5-.4.5H4.2c-.3 0-.5-.2-.5-.5V12.5H1.4c-.2 0-.4-.1-.4-.3-.1-.2-.1-.4.1-.5L11.7 1.1c.2-.2.5-.2.6 0l10.6 10.6c.2.1.2.3.1.5s-.2.3-.4.3z"
      }
    },
    identity: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M21.2 3.7h-5.1s.1.3.1.5c0 1.8-1.5 3.2-3.3 3.2h-2.7C8.4 7.4 6.9 6 6.9 4.2c0-.2 0-.5.1-.5H2.8c-1 0-1.9.8-1.9 1.8v13.9c0 1 .9 1.8 1.9 1.8h18.4c1 0 1.9-.8 1.9-1.8V5.5c0-1-.9-1.8-1.9-1.8zM10 17.5H4.8c-.6 0-1.1-.5-1.1-1.1 0-.9 1-1.4 2-1.9.7-.2.8-.5.8-.8 0-.3-.2-.6-.5-.8-.4-.4-.6-.9-.6-1.5 0-1.2.7-2.2 1.9-2.2s2 1 2 2.2c0 .6-.3 1.1-.7 1.5-.2.2-.4.5-.4.8 0 .2.1.5.8.8 1 .5 2 1 2 1.9.1.6-.4 1.1-1 1.1zm10.3-1.8c0 .3-.2.5-.5.5h-6.4c-.3 0-.5-.2-.5-.5v-.9c0-.3.2-.5.5-.5h6.4c.3 0 .5.2.5.5v.9zm.9-3.7c0 .3-.2.5-.4.5h-7.4c-.3 0-.5-.2-.5-.5v-.9c0-.3.2-.5.5-.5h7.4c.2 0 .4.2.4.5v.9zm-11-6.5h2.7c.8 0 1.4-.6 1.4-1.3s-.6-1.4-1.4-1.4h-2.7c-.8 0-1.4.6-1.4 1.4s.6 1.3 1.4 1.3z"
      }
    },
    image: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M23.1 4.6c0-1-.9-1.8-1.9-1.8H2.8c-1 0-1.9.8-1.9 1.8v14.8c0 1 .9 1.8 1.9 1.8h18.4c1 0 1.9-.8 1.9-1.8V4.6zm-4.8 12.9H4.9c-.6 0-.9-.6-.6-1l4.1-7.1c.1-.3.6-.3.7 0l2.5 4.2c.2.3.6.3.8.1l2-2.9c.1-.3.6-.3.7 0l3.7 5.8c.3.4 0 .9-.5.9zm-1.2-8.3c-1 0-1.9-.8-1.9-1.8s.9-1.9 1.9-1.9 1.8.9 1.8 1.9-.8 1.8-1.8 1.8z"
      }
    },
    inbox: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M23.1 3.7c0-1-.9-1.9-1.9-1.9H2.8c-1 0-1.9.9-1.9 1.9v16.6c0 1 .9 1.9 1.9 1.9h18.4c1 0 1.9-.9 1.9-1.9V3.7zM8.8 16.2c0 .2-.2.4-.5.4H4.2c-.3 0-.5-.2-.5-.4v-1.9c0-.3.2-.5.5-.5h4.1c.3 0 .5.2.5.5v1.9zm0-4.7c0 .3-.2.5-.5.5H4.2c-.3 0-.5-.2-.5-.5V9.7c0-.3.2-.5.5-.5h4.1c.3 0 .5.2.5.5v1.8zm0-4.6c0 .3-.2.5-.5.5H4.2c-.3 0-.5-.2-.5-.5V5.1c0-.3.2-.5.5-.5h4.1c.3 0 .5.2.5.5v1.8zm11.5 12c0 .3-.2.5-.5.5h-8.7c-.3 0-.5-.2-.5-.5V5.1c0-.3.2-.5.5-.5h8.7c.3 0 .5.2.5.5v13.8z"
      }
    },
    info: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12 .9C5.9.9.9 5.9.9 12s5 11.1 11.1 11.1 11.1-5 11.1-11.1S18.1.9 12 .9zm0 5.6c.8 0 1.4.6 1.4 1.4s-.6 1.4-1.4 1.4-1.4-.6-1.4-1.4.6-1.4 1.4-1.4zm2.3 9.7c0 .2-.2.4-.5.4h-3.6c-.3 0-.5-.1-.5-.4v-.9c0-.3.2-.5.5-.5.2 0 .4-.2.4-.4v-1.9c0-.2-.2-.5-.4-.5-.3 0-.5-.1-.5-.4v-.9c0-.3.2-.5.5-.5h2.7c.3 0 .5.2.5.5v3.7c0 .2.2.4.4.4.3 0 .5.2.5.5v.9z"
      }
    },
    info_alt: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12 .9C5.9.9.9 5.9.9 12s5 11.1 11.1 11.1 11.1-5 11.1-11.1S18.1.9 12 .9zm0 19.4c-4.6 0-8.3-3.7-8.3-8.3S7.4 3.7 12 3.7s8.3 3.7 8.3 8.3-3.7 8.3-8.3 8.3zm0-13.8c.8 0 1.4.6 1.4 1.4s-.6 1.4-1.4 1.4-1.4-.6-1.4-1.4.6-1.4 1.4-1.4zm2.3 9.7c0 .2-.2.4-.5.4h-3.6c-.3 0-.5-.1-.5-.4v-.9c0-.3.2-.5.5-.5.2 0 .4-.2.4-.4v-1.9c0-.2-.2-.5-.4-.5-.3 0-.5-.1-.5-.4v-.9c0-.3.2-.5.5-.5h2.7c.3 0 .5.2.5.5v3.7c0 .2.2.4.4.4.3 0 .5.2.5.5v.9z"
      }
    },
    insert_tag_field: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M7.5 5.6l-1-.8c-.4-.3-.7-.2-1 0L.1 11.6c-.1.2-.1.6 0 .9l5.4 6.7c.3.2.7.3 1 0l1.1-.8c.3-.3.3-.7.1-1L3.3 12l4.4-5.4c.2-.3.1-.7-.2-1zm16.4 6l-5.4-6.7c-.3-.3-.7-.4-1-.1l-1.1.9c-.3.2-.3.7-.1.9l4.4 5.4-4.4 5.4c-.2.3-.1.8.1 1l1.1.9c.3.2.7.2 1-.1l5.4-6.7c.1-.4.1-.7 0-.9zM14.6 5l-1.4-.3c-.4-.1-.8.1-.9.5L8.9 18.3c-.1.3.1.7.5.8l1.4.3c.4.1.8-.1.9-.5l3.4-13.1c.1-.4-.1-.7-.5-.8z"
      }
    },
    insert_template: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.4 17.5h-2.1v-2c0-.4-.3-.7-.7-.7h-1.4c-.3 0-.7.3-.7.7v2h-2c-.4 0-.7.4-.7.7v1.4c0 .4.3.7.7.7h2v2.1c0 .4.4.7.7.7h1.4c.4 0 .7-.3.7-.7v-2.1h2.1c.4 0 .7-.3.7-.7v-1.4c0-.3-.3-.7-.7-.7zm-6.7-3.9c0-.4.3-.7.7-.7h1.1V2.8c0-1-.8-1.9-1.8-1.9H2.8C1.8.9.9 1.8.9 2.8v12.9c0 1 .9 1.8 1.9 1.8h10.1v-1.1c0-.4.3-.7.7-.7h2.1v-2.1zM7.4 5.1c0 .3-.2.4-.5.4H4.2c-.3 0-.5-.1-.5-.4v-.9c0-.3.2-.5.5-.5h2.7c.3 0 .5.2.5.5v.9zm5.5 7.4c0 .2-.2.4-.4.4H4.2c-.3 0-.5-.2-.5-.4v-1c0-.2.2-.4.5-.4h8.3c.2 0 .4.2.4.4v1zm1.9-3.7c0 .2-.2.4-.5.4H4.2c-.3 0-.5-.2-.5-.4v-1c0-.2.2-.4.5-.4h10.1c.3 0 .5.2.5.4v1z"
      }
    },
    internal_share: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M1.1 17.5v.1c0 .4.2.6.6.6.2 0 .3 0 .5-.2 0 0 4.6-5 10.4-3.5v5.1c0 .4.2.7.6.7.1 0 .2-.1.3-.1l9.3-7.9c.1-.2.2-.3.2-.5s-.1-.4-.2-.5l-9.2-7.5c-.1-.1-.3-.1-.4-.1-.4 0-.6.3-.6.6v4.8c-.1 0-9.2-1.4-11.5 8.4z"
      }
    },
    italic: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.5 5.7v-.6c0-.5-.4-.9-.9-.9h-6.4c-.6 0-1 .4-1 .9V6c0 .5.4.9 1 .9.7 0 1.3.8 1.2 1.5l-1.7 8.1c-.1.6-.7 1-1.2 1H7.4c-.5 0-.9.5-.9 1v.9c0 .5.4.9.9.9h6.4c.6 0 1-.4 1-.9v-.9c0-.5-.4-1-1-1-.7 0-1.3-.7-1.2-1.4l1.7-8.2c.1-.6.7-1 1.2-1h.8c.7 0 1.2-.5 1.2-1.2z"
      }
    },
    jump_to_bottom: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.7 14l-6.2 6.3c-.3.3-.7.3-1 0L5.3 14c-.3-.2-.3-.7 0-1l1-1c.3-.3.7-.3 1 0l4.2 4.3c.3.3.7.3 1 0l4.2-4.3c.3-.2.7-.2 1 0l1 1.1c.3.2.3.7 0 .9zm0-8.3L12.5 12c-.3.3-.7.3-1 0L5.3 5.7c-.3-.3-.3-.8 0-1l1-1.1c.3-.2.7-.2 1 0L11.5 8c.3.3.7.3 1 0l4.2-4.3c.3-.3.7-.3 1 0l1 1c.3.3.3.7 0 1z"
      }
    },
    jump_to_top: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M5.3 10l6.2-6.4c.3-.2.7-.2 1 0l6.2 6.4c.3.2.3.7 0 1l-1 1c-.3.3-.7.3-1 0l-4.2-4.3c-.3-.3-.7-.3-1 0L7.3 12c-.3.2-.7.2-1 0l-1-1.1c-.3-.2-.3-.7 0-.9zm0 8.3l6.2-6.3c.3-.3.7-.3 1 0l6.2 6.3c.3.3.3.8 0 1l-1 1.1c-.3.2-.7.2-1 0L12.5 16c-.3-.3-.7-.3-1 0l-4.2 4.3c-.3.3-.7.3-1 0l-1-1c-.3-.3-.3-.7 0-1z"
      }
    },
    justify_text: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.2 3c0-.4-.4-.7-.7-.7h-19c-.3 0-.7.3-.7.7v1.4c0 .4.4.7.7.7h19c.3 0 .7-.3.7-.7V3zm0 5.5c0-.3-.4-.7-.7-.7h-19c-.3 0-.7.4-.7.7v1.4c0 .4.4.7.7.7h19c.3 0 .7-.3.7-.7V8.5zm0 11.1c0-.4-.4-.7-.7-.7h-19c-.3 0-.7.3-.7.7V21c0 .4.4.7.7.7h19c.3 0 .7-.3.7-.7v-1.4zm0-5.5c0-.4-.4-.7-.7-.7h-19c-.3 0-.7.3-.7.7v1.4c0 .3.4.7.7.7h19c.3 0 .7-.4.7-.7v-1.4z"
      }
    },
    kanban: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M14.8 8.1c0-.4-.4-.7-.7-.7H9.9c-.3 0-.7.3-.7.7v12.4c0 .4.4.7.7.7h4.2c.3 0 .7-.3.7-.7V8.1zm-8.3 0c0-.4-.4-.7-.7-.7H1.6c-.4 0-.7.3-.7.7v14.3c0 .4.3.7.7.7h4.2c.3 0 .7-.3.7-.7V8.1zm16.6 0c0-.4-.3-.7-.7-.7h-4.2c-.3 0-.7.3-.7.7v10.6c0 .4.4.7.7.7h4.2c.4 0 .7-.3.7-.7V8.1zm0-6.5c0-.4-.3-.7-.7-.7H1.6c-.4 0-.7.3-.7.7v2.3c0 .4.3.7.7.7h20.8c.4 0 .7-.3.7-.7V1.6z"
      }
    },
    keyboard_dismiss: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.2 15.7c.5 0 .9-.4.9-.9v-12c0-.5-.4-.9-.9-.9H1.8c-.5 0-.9.4-.9.9v12c0 .5.4.9.9.9h20.4zM2.8 13.9V3.7h18.4v10.2H2.8zm3.5-7.7c0 .4-.3.7-.7.7h-.4c-.4 0-.7-.3-.7-.7v-.5c0-.3.3-.7.7-.7h.4c.4 0 .7.4.7.7v.5zM9 5.7c0-.3-.4-.7-.7-.7h-.5c-.4 0-.7.4-.7.7v.5c0 .4.3.7.7.7h.5c.3 0 .7-.3.7-.7v-.5zm5.3.5c0 .4-.4.7-.7.7h-.5c-.4 0-.7-.3-.7-.7v-.5c0-.3.3-.7.7-.7h.5c.3 0 .7.4.7.7v.5zm-2.7 0c0 .4-.3.7-.7.7h-.4c-.4 0-.7-.3-.7-.7v-.5c0-.3.3-.7.7-.7h.4c.4 0 .7.4.7.7v.5zm7.9-.5c0-.3-.3-.7-.6-.7h-.5c-.4 0-.7.4-.7.7v.5c0 .4.3.7.7.7h.5c.3 0 .6-.3.6-.7v-.5zm-2.6 0c0-.3-.3-.7-.7-.7h-.5c-.3 0-.6.4-.6.7v.5c0 .4.3.7.6.7h.5c.4 0 .7-.3.7-.7v-.5zM6.3 9c0 .3-.3.6-.7.6h-.4c-.4 0-.7-.3-.7-.6v-.5c0-.4.3-.7.7-.7h.4c.4 0 .7.3.7.7V9zM9 8.5c0-.4-.4-.7-.7-.7h-.5c-.4 0-.7.3-.7.7V9c0 .3.3.6.7.6h.5c.3 0 .7-.3.7-.6v-.5zm5.3.5c0 .3-.4.6-.7.6h-.5c-.4 0-.7-.3-.7-.6v-.5c0-.4.3-.7.7-.7h.5c.3 0 .7.3.7.7V9zm-2.7 0c0 .3-.3.6-.7.6h-.4c-.4 0-.7-.3-.7-.6v-.5c0-.4.3-.7.7-.7h.4c.4 0 .7.3.7.7V9zm7.9-.5c0-.4-.3-.7-.6-.7h-.5c-.4 0-.7.3-.7.7V9c0 .3.3.6.7.6h.5c.3 0 .6-.3.6-.6v-.5zm-2.6 0c0-.4-.3-.7-.7-.7h-.5c-.3 0-.6.3-.6.7V9c0 .3.3.6.6.6h.5c.4 0 .7-.3.7-.6v-.5zM6.3 11.7c0 .4-.3.7-.7.7h-.4c-.4 0-.7-.3-.7-.7v-.4c0-.4.3-.7.7-.7h.4c.4 0 .7.3.7.7v.4zm10.6-.4c0-.4-.3-.7-.7-.7H7.8c-.4 0-.7.3-.7.7v.4c0 .4.3.7.7.7h8.4c.4 0 .7-.3.7-.7v-.4zm2.6 0c0-.4-.3-.7-.6-.7h-.5c-.4 0-.7.3-.7.7v.4c0 .4.3.7.7.7h.5c.3 0 .6-.3.6-.7v-.4zM8.4 17.2h7.2c.3 0 .4.2.2.4L12.3 22c-.2.2-.4.2-.5 0l-3.6-4.4c-.2-.2-.1-.4.2-.4z"
      }
    },
    knowledge_base: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M4.4 16.2h6c.4 0 .7-.4.7-.7V4.6c0-.8-.9-1.4-1.5-1.4H4.4c-.4 0-.7.4-.7.7v11.6c0 .3.3.7.7.7zM22.7 5.4c-.3-.1-.5.1-.5.4v11.5c0 .4-.4.7-.7.7h-19c-.3 0-.7-.3-.7-.7V5.9c0-.4-.3-.6-.6-.5-.7.4-1.2 1.1-1.2 2V18c0 1 .8 1.8 1.8 1.8h7.7c.3 0 .7.4.7.7s.3.7.6.7h2.4c.3 0 .6-.3.6-.7s.4-.7.7-.7h7.7c1 0 1.8-.8 1.8-1.8V7.4c0-1-.3-1.8-1.3-2zm-9.1 10.8h6c.4 0 .7-.4.7-.7V3.9c0-.3-.3-.7-.7-.7h-5.2c-.7 0-1.5.6-1.5 1.4v10.9c0 .3.3.7.7.7z"
      }
    },
    layers: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M16.6 9.2c0-1-.8-1.8-1.8-1.8h-12c-1 0-1.9.8-1.9 1.8v12c0 1 .9 1.9 1.9 1.9h12c1 0 1.8-.9 1.8-1.9v-12zM19.8.9h-12C6 .9 4.6 2.4 4.6 4.2v1.3h12c1 0 1.9.9 1.9 1.9v12h1.3c1.8 0 3.3-1.4 3.3-3.2v-12c0-1.8-1.5-3.3-3.3-3.3z"
      }
    },
    layout: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.2 23.1H1.8c-.5 0-.9-.4-.9-.9V1.8c0-.5.4-.9.9-.9h20.4c.5 0 .9.4.9.9v20.4c0 .5-.4.9-.9.9zM2.8 21.2h18.4V2.8H2.8v18.4zM18 9.2H6c-.3 0-.5-.2-.5-.4V6c0-.3.2-.5.5-.5h12c.3 0 .5.2.5.5v2.8c0 .2-.2.4-.5.4zm-9.2 9.3H6c-.3 0-.5-.2-.5-.5v-5.5c0-.3.2-.5.5-.5h2.8c.2 0 .4.2.4.5V18c0 .3-.2.5-.4.5zm9.2 0h-5.5c-.3 0-.5-.2-.5-.5v-5.5c0-.3.2-.5.5-.5H18c.3 0 .5.2.5.5V18c0 .3-.2.5-.5.5z"
      }
    },
    left: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.5 3.8v16.4c0 .4-.6.8-1 .4l-9.8-8c-.3-.3-.3-.9 0-1.2l9.8-8c.4-.4 1-.1 1 .4z"
      }
    },
    left_align_text: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.2 3c0-.4-.4-.7-.7-.7h-19c-.3 0-.7.3-.7.7v1.4c0 .4.4.7.7.7h19c.3 0 .7-.3.7-.7V3zm-3.7 5.5c0-.3-.4-.7-.7-.7H2.5c-.3 0-.7.4-.7.7v1.4c0 .4.4.7.7.7h15.3c.3 0 .7-.3.7-.7V8.5zm0 11.1c0-.4-.4-.7-.7-.7H2.5c-.3 0-.7.3-.7.7V21c0 .4.4.7.7.7h15.3c.3 0 .7-.3.7-.7v-1.4zm3.7-5.5c0-.4-.4-.7-.7-.7h-19c-.3 0-.7.3-.7.7v1.4c0 .3.4.7.7.7h19c.3 0 .7-.4.7-.7v-1.4z"
      }
    },
    level_up: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M1.6 20.3c-.3 0-.7.3-.7.7v1.4c0 .4.4.7.7.7h11c.4 0 .8-.4.8-.7V7.1c0-.5.4-.6.8-.4l2.6 2.6c.2.3.6.3.9 0l1-.9c.3-.3.3-.7 0-1l-6.2-6.3c-.3-.3-.7-.3-1 0L5.3 7.3c-.3.3-.3.7 0 1l.9 1c.3.3.7.3 1 0l2.6-2.6c.3-.3.8-.1.8.3v12.6c0 .8-.7.7-.7.7H1.6z"
      }
    },
    light_bulb: {
      "path": {
        "d": "M11.1 1.2a7.4 7.4 0 0 0-6.6 6.6 7.3 7.3 0 0 0 2.7 6.3 2.3 2.3 0 0 1 .8 1.8 1.8 1.8 0 0 0 1.9 1.9h4.2a1.8 1.8 0 0 0 1.8-1.9 2.3 2.3 0 0 1 .9-1.8 7.3 7.3 0 0 0 2.7-5.6c.1-4.3-3.8-7.7-8.4-7.3zm4.1 18.7H8.8a.7.7 0 0 0-.8.7 2.2 2.2 0 0 0 2.2 2.2h3.6a2.2 2.2 0 0 0 2.2-2.2.7.7 0 0 0-.8-.7z"
      }
    },
    like: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M4.8 9.7H2.5c-.3 0-.7.3-.7.7V21c0 .4.4.7.7.7h1.2c1 0 1.8-.8 1.8-1.9v-9.4c0-.4-.3-.7-.7-.7zm15.5.5h-2.8c-1 0-1.8-.9-1.8-1.9V3.7c0-1-.8-1.9-1.9-1.9h-1.1c-.4 0-.7.4-.7.7v2.8c0 2.5-1.7 4.9-3.9 4.9-.4 0-.7.3-.7.6v9.3c0 .3.3.7.6.7 3.2.1 4.2 1.4 7.5 1.4 3.5 0 6.7-.4 6.7-4.4V12c0-1-.9-1.8-1.9-1.8z"
      }
    },
    link: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12.6 19.2l-1-.1s-.7-.1-1-.3c-.2 0-.4 0-.5.2l-.3.2c-1.3 1.3-3.5 1.5-4.9.3-1.5-1.4-1.6-3.8-.1-5.2l3.5-3.5c.4-.5 1-.7 1.5-.9.8-.2 1.6-.2 2.2.1.5.2.9.4 1.2.8.2.2.4.4.5.6.2.3.6.4.8.1l1.3-1.3c.2-.2.2-.5.1-.7-.2-.3-.4-.5-.7-.7-.3-.4-.7-.7-1.1-.9-.6-.4-1.4-.7-2.1-.8-1.5-.3-3-.1-4.3.6-.5.3-1.1.7-1.5 1.1l-3.3 3.3C.4 14.6.2 18.6 2.6 21c2.4 2.7 6.6 2.8 9.1.2l1.2-1.1c.3-.3.1-.8-.3-.9zM21 2.7C18.5.3 14.5.5 12.1 3l-1 1c-.3.3-.1.8.3.9.6 0 1.3.2 1.9.4.2 0 .5 0 .6-.2l.2-.2c1.4-1.3 3.5-1.5 4.9-.3 1.6 1.4 1.6 3.8.2 5.2l-3.5 3.5c-.5.5-1 .7-1.6.9-.7.2-1.5.2-2.2-.1-.4-.2-.8-.4-1.2-.8-.2-.2-.3-.4-.5-.6-.1-.3-.6-.4-.8-.1l-1.3 1.3c-.2.2-.2.5 0 .7.2.3.4.5.6.7.3.3.8.7 1.1.9.7.4 1.4.7 2.2.8 1.4.3 3 .1 4.2-.6.6-.3 1.1-.7 1.5-1.1l3.5-3.5c2.6-2.5 2.5-6.7-.2-9.1z"
      }
    },
    list: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M3.7 4.8c0-.3-.3-.6-.7-.6H1.6c-.4 0-.7.3-.7.6v1.4c0 .4.3.7.7.7H3c.4 0 .7-.3.7-.7V4.8zm19.4 0c0-.3-.3-.6-.7-.6H6.2c-.3 0-.7.3-.7.6v1.4c0 .4.4.7.7.7h16.2c.4 0 .7-.3.7-.7V4.8zM3.7 11.3c0-.4-.3-.7-.7-.7H1.6c-.4 0-.7.3-.7.7v1.4c0 .4.3.7.7.7H3c.4 0 .7-.3.7-.7v-1.4zm17.5 0c0-.4-.3-.7-.7-.7H6.2c-.3 0-.7.3-.7.7v1.4c0 .4.4.7.7.7h14.3c.4 0 .7-.3.7-.7v-1.4zM3.7 17.8c0-.4-.3-.7-.7-.7H1.6c-.4 0-.7.3-.7.7v1.4c0 .3.3.6.7.6H3c.4 0 .7-.3.7-.6v-1.4zm19.4 0c0-.4-.3-.7-.7-.7H6.2c-.3 0-.7.3-.7.7v1.4c0 .3.4.6.7.6h16.2c.4 0 .7-.3.7-.6v-1.4z"
      }
    },
    listen: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M23.4 13.9c0-6.6-5.1-12.1-11.3-12.1S.8 7.3.8 13.9c0 1.6.3 3.2.8 4.7.7 1.8 2.3 3 4.2 3.1.6 0 1-.5 1-1v-5.8c0-.5-.4-1-1-1-1 0-2 .4-2.7.9-.1-.3-.1-.6-.1-.9 0-5.5 4.1-9.8 9.1-9.8s9 4.4 9 9.8v.9c-.7-.6-1.7-1-2.7-1-.6 0-1 .5-1 1.1v5.7c0 .5.4 1 1 1 1.1 0 2.2-.4 3-1.2.8-.9 1.1-1.8 1.4-2.9.4-1.1.6-2.3.6-3.6z"
      }
    },
    location: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.5 4.4l-6.6-3.3c-.3-.2-.7-.2-1 0L8.8 4.2 2.6 1.1c-.4-.2-.8-.2-1.2 0-.3.2-.5.6-.5.9v16.6c0 .5.3.8.6 1l6.7 3.3c.3.2.7.2.9 0l6.2-3.1 6.2 3.1c.1.1.3.2.5.2s.4-.1.6-.2c.3-.2.5-.6.5-.9V5.4c0-.5-.2-.8-.6-1zm-1.7 2.1v8.8c0 .5-.5.9-1 .7-1.7-.7-.3-3.5-1.5-5.1-1.2-1.4-2.7 0-4.1-2.2-1.3-2.2.5-3.8 2.1-4.6.3-.1.5-.1.7 0l3.4 1.7c.3.2.4.4.4.7zm-9.3 12.8c-.3.2-.6.1-.8-.1-.5-.4-.9-1-.9-1.7 0-1.1-1.8-.7-1.8-2.9 0-1.8-2.1-2.3-3.9-2.1-.5.1-.8-.3-.8-.7V5c0-.5.5-.9 1-.6l4 2h.1l.1.1c1.7 1 1.3 1.8.6 3-.7 1.3-1.1 0-2.2-.4s-2.2.4-1.8 1.1 1.5 0 2.2.7.7 1.9 2.9 1.1 2.6-.3 3.4.4c.7.8 1.1 2.2 0 3.3-.7.7-1 2.1-1.2 3-.1.2-.2.4-.4.5l-.5.1z"
      }
    },
    lock: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M5.1 8.8h1.8c.3 0 .5-.2.5-.4v-.1c0-2.6 2.2-4.8 4.9-4.6 2.5.2 4.3 2.3 4.3 4.8v-.1c0 .2.2.4.5.4h1.8c.3 0 .5-.2.5-.4v-.1c0-4.2-3.5-7.6-7.8-7.4-3.9.2-6.9 3.5-7 7.5.1.2.2.4.5.4zm-.5-.4v.1-.1zm16.6 4.1c0-1.1-.8-1.9-1.8-1.9H4.6c-1 0-1.8.8-1.8 1.9v8.7c0 1 .8 1.9 1.8 1.9h14.8c1 0 1.8-.9 1.8-1.9v-8.7zm-7.1 7.2c.1.3-.1.6-.4.6h-3.4c-.3 0-.5-.3-.5-.6l.9-2.8c-.7-.4-1.1-1.3-1-2.2.2-.9.9-1.5 1.8-1.7 1.5-.3 2.8.8 2.8 2.1 0 .8-.4 1.5-1 1.8l.8 2.8z"
      }
    },
    log_a_call: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M19.8.9H6.2C5 .9 4 2 4 3.1v.8h-.7c-.8 0-1.5.6-1.5 1.5s.7 1.4 1.5 1.4H4v3.7h-.7c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5H4v3.7h-.7c-.8 0-1.5.6-1.5 1.4 0 .9.7 1.5 1.5 1.5H4v.8c0 1.1 1 2.2 2.2 2.2h13.6c1.2 0 2.4-1.1 2.4-2.3V3c0-1.2-1.2-2.1-2.4-2.1zm-1.2 14.9l-1.1 1c-.2.3-.5.4-.8.4-2.4-.2-4.6-1.3-6.2-2.9s-2.7-3.9-2.8-6.4c0-.3.1-.6.3-.8l1-1c.5-.5 1.2-.5 1.7.1l.9 1.2c.3.4.3 1 0 1.4l-.8 1.1c0 .2 0 .4.1.5l1.7 1.9 1.8 1.7c.1.1.3.1.5 0l1.1-.8c.4-.3.9-.3 1.4 0l1.1 1c.5.3.5 1.1.1 1.6z"
      }
    },
    logout: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M9.7 22.4V21c0-.4-.3-.7-.7-.7H4.4c-.4 0-.7-.3-.7-.7V4.4c0-.4.3-.7.7-.7H9c.4 0 .7-.3.7-.7V1.6c0-.4-.3-.7-.7-.7H2.8C1.8.9.9 1.8.9 2.8v18.4c0 1 .9 1.9 1.9 1.9H9c.4 0 .7-.3.7-.7zm13.2-9.9c.3-.3.3-.7 0-1l-6.2-6.2c-.3-.3-.7-.3-1 0l-1 .9c-.3.3-.3.7 0 1l2.6 2.6c.3.3.1.8-.3.8H7.2c-.4 0-.7.2-.7.6v1.4c0 .4.3.7.7.7h9.7c.5 0 .6.5.4.8l-2.6 2.6c-.3.3-.3.7 0 1l.9.9c.3.3.7.3 1 0l6.3-6.1z"
      }
    },
    lower_flag: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M3 2.4H1.9c-.2 0-.5.2-.5.5v16.8c0 .3.3.6.5.6H3c.3 0 .6-.3.6-.5V2.9c0-.3-.2-.5-.6-.5zm10.8 10.5c1.3-1.3 3.1-1.9 4.8-1.8V4.8c0-.3-.3-.5-.6-.3-6 3.2-5.3-3.3-12.5-.8-.2.1-.4.3-.4.5v8.7c0 .3.3.5.5.3 4-1.3 5.6.2 7.2 1.1.3-.5.6-1 1-1.4zM21.3 14c-1.8-1.8-4.6-1.8-6.4 0-1.7 1.7-1.7 4.6 0 6.4s4.6 1.7 6.4 0 1.8-4.7 0-6.4zM20 18c.1.1.1.4-.1.5l-.5.5c-.1.2-.3.2-.5 0l-.8-.8-.8.8c-.1.2-.3.2-.5 0l-.5-.5c-.1-.2-.2-.4-.1-.5l.9-.9-.8-.8c-.1-.1-.2-.3-.1-.5l.6-.5c.1-.2.4-.2.5-.1l.8.8.8-.8c.1-.1.4-.2.5 0l.5.5c.2.1.2.4 0 .5l-.8.8.9 1z"
      }
    },
    macros: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.2 18.6c-.1.1-.3.2-.5.2h-2.2c-.1 0-.3-.2-.3-.3 0-.1.1-.2.1-.2v-.1l.1-.1 4.8-5.7c.1-.2.1-.5 0-.7v-.1l-4.9-5.8c-.1-.1-.1-.2-.1-.2 0-.2.2-.3.3-.3h2.2c.2 0 .4 0 .5.2l5.1 6.2c.1.1.1.2.1.3 0 .1-.1.3-.1.4l-5.1 6.2zm-5.4 0c-.1.1-.3.2-.4.2H9.2c-.2 0-.3-.2-.3-.3v-.2l.1-.1v-.1l4.8-5.7c.1-.2.2-.5.1-.7l-.1-.1-4.9-5.8v-.2c0-.2.1-.3.3-.3h2.2c.1 0 .3 0 .4.2l5.1 6.2c.1.1.1.2.1.3 0 .1 0 .3-.1.4l-5.1 6.2zm-5.3 0c-.1.1-.3.2-.5.2H1.9c-.1 0-.3-.2-.3-.3 0-.1.1-.2.1-.2v-.1l.1-.1 4.8-5.7c.1-.2.1-.5 0-.7v-.1L1.7 5.8c-.1-.1-.1-.2-.1-.2 0-.2.2-.3.3-.3H6c.1 0 .3 0 .4.2l5.1 6.2c.1.1.1.2.1.3 0 .1 0 .3-.1.4l-5 6.2z"
      }
    },
    magicwand: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M13 9.7c-.2-.2-.4-.2-.6 0l-11.1 11c-.5.6-.5 1.4 0 2 .6.5 1.4.5 2 0l11-11.1c.2-.2.2-.4 0-.6L13 9.7zm3.2 0l1.5-1.5c.3-.3.3-.7 0-1l-.9-.9c-.3-.3-.7-.3-1 0l-1.5 1.5c-.2.1-.2.4 0 .6l1.3 1.3c.2.2.5.2.6 0zM4.8 5.4c1.8.5 3.1 1.8 3.7 3.6.1.3.5.3.5 0 .6-1.7 1.9-3.1 3.7-3.6.3-.1.3-.5 0-.6C11 4.2 9.6 2.9 9 1.1c0-.3-.4-.3-.5 0-.6 1.8-1.9 3.1-3.7 3.7-.2.1-.2.5 0 .6zm18.1 8.7c-1.6-.5-2.8-1.7-3.3-3.3-.1-.2-.4-.2-.5 0-.5 1.6-1.7 2.8-3.3 3.3-.2.1-.2.4 0 .5 1.6.5 2.8 1.7 3.3 3.3.1.2.4.2.5 0 .5-1.6 1.7-2.8 3.3-3.3.2-.1.2-.5 0-.5zM17.7 3.9c1.2.3 2.1 1.2 2.4 2.4.1.2.3.2.4 0 .4-1.2 1.2-2.1 2.4-2.4.2-.1.2-.3 0-.4-1.2-.4-2-1.2-2.4-2.4-.1-.2-.3-.2-.4 0-.3 1.2-1.2 2-2.4 2.4-.2.1-.2.3 0 .4z"
      }
    },
    mark_all_as_read: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M11.1 3.2l-.8-.8c-.2-.2-.6-.2-.8 0L4.6 7.3l-2-1.9c-.2-.3-.5-.3-.8 0l-.7.7c-.3.3-.3.6 0 .8l2.7 2.7c.2.3.5.4.8.4.2 0 .5-.1.8-.4L11.1 4c.2-.2.2-.5 0-.8zm11.2 5.3h-9.6c-.4 0-.7-.3-.7-.7V6.3c0-.4.3-.8.7-.8h9.6c.5 0 .8.4.8.8v1.5c0 .4-.3.7-.8.7zm0 6.6H4.5c-.4 0-.7-.3-.7-.7v-1.5c0-.4.3-.8.7-.8h17.8c.5 0 .8.4.8.8v1.5c0 .4-.3.7-.8.7zm0 6.6H4.5c-.4 0-.7-.3-.7-.7v-1.5c0-.4.3-.8.7-.8h17.8c.5 0 .8.4.8.8V21c0 .4-.3.7-.8.7z"
      }
    },
    matrix: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.2 1.6c0-.4-.4-.7-.7-.7H7.2c-.4 0-.7.3-.7.7v2.3c0 .4.3.7.7.7h14.3c.3 0 .7-.3.7-.7V1.6zM4.6 7.2c0-.4-.3-.7-.7-.7H2.5c-.3 0-.7.3-.7.7v6c0 .3.4.6.7.6h1.4c.4 0 .7-.3.7-.6v-6zm0 9.2c0-.4-.3-.7-.7-.7H2.5c-.3 0-.7.3-.7.7v6c0 .4.4.7.7.7h1.4c.4 0 .7-.3.7-.7v-6zm8.8-9.2c0-.4-.3-.7-.7-.7H7.2c-.4 0-.7.3-.7.7v1.3c0 .4.3.7.7.7h5.5c.4 0 .7-.3.7-.7V7.2zm8.8 0c0-.4-.4-.7-.7-.7h-5.6c-.3 0-.7.3-.7.7v1.3c0 .4.4.7.7.7h5.6c.3 0 .7-.3.7-.7V7.2zm-8.8 4.6c0-.4-.3-.7-.7-.7H7.2c-.4 0-.7.3-.7.7v1.4c0 .3.3.6.7.6h5.5c.4 0 .7-.3.7-.6v-1.4zm8.8 0c0-.4-.4-.7-.7-.7h-5.6c-.3 0-.7.3-.7.7v1.4c0 .3.4.6.7.6h5.6c.3 0 .7-.3.7-.6v-1.4zm-8.8 4.6c0-.4-.3-.7-.7-.7H7.2c-.4 0-.7.3-.7.7v1.4c0 .3.3.7.7.7h5.5c.4 0 .7-.4.7-.7v-1.4zm8.8 0c0-.4-.4-.7-.7-.7h-5.6c-.3 0-.7.3-.7.7v1.4c0 .3.4.7.7.7h5.6c.3 0 .7-.4.7-.7v-1.4zM13.4 21c0-.4-.3-.7-.7-.7H7.2c-.4 0-.7.3-.7.7v1.4c0 .4.3.7.7.7h5.5c.4 0 .7-.3.7-.7V21zm8.8 0c0-.4-.4-.7-.7-.7h-5.6c-.3 0-.7.3-.7.7v1.4c0 .4.4.7.7.7h5.6c.3 0 .7-.3.7-.7V21z"
      }
    },
    merge: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M19.5 20.3c-2.6-1.2-4.4-3.5-5.3-6-.4-.9-.6-2-.7-2.9V9.8h5c.3 0 .6-.4.3-.8l-6.5-7.9c-.3-.3-.8-.3-.9 0L5 9c-.2.2 0 .8.4.8h5v1.6c-.2 1-.4 2-.7 2.9-.9 2.5-2.8 4.8-5.4 6-.3.1-.5.6-.3.9l.6 1.5c.2.3.6.5.9.2 2.8-1.3 5-3.4 6.4-6 1.3 2.6 3.5 4.7 6.3 6 .4.2.9.2 1-.2l.6-1.5c.3-.3.1-.7-.3-.9z"
      }
    },
    merge_field: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M7.6 18.4h-.3c-1.1 0-1.5-.6-1.5-1.6 0-.5.1-.9.2-1.3 0-.5.1-1 .1-1.5 0-1.2-.5-1.8-1.3-2 .8-.2 1.3-.8 1.3-2 0-.5-.1-1-.1-1.5-.1-.4-.2-.8-.2-1.3 0-1 .4-1.6 1.5-1.6h.3c.3 0 .5-.2.5-.5s-.2-.5-.5-.5H5.9c-1.6 0-2.8.7-2.8 2.4 0 .5.1 1 .2 1.6.1.5.1 1 .1 1.6 0 .6-.1 1.2-1.1 1.3h-.1c-.3 0-.5.2-.5.5s.2.5.5.5h.1c1 .1 1.2.8 1.2 1.3 0 .6-.1 1.1-.2 1.6s-.1 1-.1 1.5c0 1.9 1.1 2.5 2.7 2.5h1.8c.2 0 .5-.2.5-.5-.1-.3-.3-.5-.6-.5zm8.8 0h.3c1.1 0 1.5-.6 1.5-1.6 0-.5-.1-.9-.2-1.3 0-.5-.1-1-.1-1.5 0-1.2.5-1.8 1.3-2-.8-.2-1.3-.8-1.3-2 0-.5.1-1 .1-1.5.1-.4.2-.8.2-1.3 0-1-.4-1.6-1.5-1.6h-.3c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h1.7c1.6 0 2.8.7 2.8 2.4 0 .5-.1 1-.2 1.6-.1.5-.1 1-.1 1.6 0 .6.1 1.2 1.1 1.3h.1c.3 0 .5.2.5.5s-.2.5-.5.5h-.1c-1 .1-1.2.8-1.2 1.3 0 .6.1 1.1.2 1.6s.1 1 .1 1.5c0 1.9-1.1 2.5-2.7 2.5h-1.8c-.2 0-.5-.2-.5-.5.1-.3.3-.5.6-.5z"
      }
    },
    metrics: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M20.7.9H3.3C2 .9.9 2 .9 3.3v17.4c0 1.3 1.1 2.4 2.4 2.4h17.4c1.3 0 2.3-1.1 2.3-2.4V3.3C23.1 2 22 .9 20.7.9zM7.2 18.3c0 .4-.3.8-.7.8h-.8c-.4 0-.8-.4-.8-.8V14c0-.4.4-.8.8-.8h.8c.4 0 .7.4.7.8v4.3zm4 0c0 .4-.4.8-.8.8h-.8c-.4 0-.7-.4-.7-.8V8c0-.4.3-.8.7-.8h.8c.4 0 .8.4.8.8v10.3zm4 0c0 .4-.4.8-.8.8h-.8c-.4 0-.8-.4-.8-.8V5.7c0-.4.4-.8.8-.8h.8c.4 0 .8.4.8.8v12.6zm3.9 0c0 .4-.4.8-.8.8h-.8c-.4 0-.7-.4-.7-.8v-7.5c0-.4.3-.8.7-.8h.8c.4 0 .8.4.8.8v7.5z"
      }
    },
    minimize_window: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M23.1 22.4c0 .4-.3.7-.7.7H1.6c-.4 0-.7-.3-.7-.7V21c0-.4.3-.7.7-.7h20.8c.4 0 .7.3.7.7v1.4z"
      }
    },
    moneybag: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M9.5 4.2c.1.3.3.4.6.4h3.7c.3 0 .6-.1.7-.4L16 1.5c.1-.3-.1-.6-.4-.6H8.4c-.3 0-.5.3-.3.5l1.4 2.8zm4.7 2.6H9.8c-3.6 0-6.6 3-6.6 6.7v7.4c0 1.2 1 2.2 2.2 2.2h13.2c1.2 0 2.2-1 2.2-2.2v-7.4c0-3.7-3-6.7-6.6-6.7zm-1.1 12.4v1.3c0 .2-.2.4-.5.4h-1.4c-.3 0-.3-.2-.3-.4v-1.2c-1.1-.2-2-.7-2.3-.9-.2-.3-.3-.5-.1-.9l.5-.7c0-.2.3-.3.5-.3.1 0 .3.1.4.1.8.5 1.4.7 1.9.7s.9-.3.9-.6c0-.2-.1-.6-1.5-1.1-1.3-.4-2.8-1.2-2.8-2.9 0-1 .6-2.1 2.5-2.5V9.1c0-.2.1-.4.3-.4h1.4c.3 0 .5.2.5.4v1.1c.7.1 1.5.5 1.8.7.1.1.2.3.3.5 0 .1-.1.3-.2.4l-.6.7c-.1.1-.4.3-.6.3-.1 0-.2-.1-.3-.1-.8-.4-1.4-.7-1.8-.7-.6 0-.9.3-.9.5 0 .3.2.6 1.4 1 1.6.5 3.3 1.4 3.3 3.1 0 1.2-1 2.3-2.4 2.6z"
      }
    },
    monthlyview: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M20.3 3.2H18v-.9c0-.7-.6-1.4-1.4-1.4-.7 0-1.4.6-1.4 1.4v.9H8.8v-.9c0-.7-.6-1.4-1.4-1.4C6.6.9 6 1.5 6 2.3v.9H3.7c-1 0-1.9.9-1.9 1.9v1.1c0 .4.4.7.7.7h19c.3 0 .7-.3.7-.7V5.1c0-1-.9-1.9-1.9-1.9zm1.2 6h-19c-.3 0-.7.4-.7.7v11.3c0 1 .9 1.9 1.9 1.9h16.6c1 0 1.9-.9 1.9-1.9V9.9c0-.3-.4-.7-.7-.7zM9.7 20.3c-1.1 0-2.3-.4-2.7-1 0-.1-.1-.2-.1-.3 0-.4.4-.8.8-.8.1 0 .2.1.4.1.5.3 1.1.5 1.6.5.9 0 1.4-.4 1.4-1s-.4-.9-1.5-.9c-.6.1-1-.1-1-.7 0-.4.3-.7.7-.7 1 .1 1.7-.2 1.7-.8 0-.6-.6-.9-1.4-.9-.5 0-1 .1-1.5.4-.1.1-.2.1-.3.1-.4 0-.7-.3-.7-.7 0-.2.1-.4.2-.5.6-.5 1.4-.8 2.5-.8 1.7 0 2.8.8 2.8 2.1 0 .9-.8 1.5-1.6 1.7.8.1 1.7.7 1.7 1.8 0 1.5-1.2 2.4-3 2.4zm7.4-.9c0 .4-.3.9-.7.9-.4 0-.7-.4-.7-.9v-4.7l-1 .9c-.1.1-.3.1-.5.1-.4 0-.7-.2-.7-.7 0-.1.1-.3.2-.4l1.8-1.8c.1-.2.4-.3.7-.3.5 0 .9.5.9 1v5.9z"
      }
    },
    move: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.9 11.7l-3.8-4.2c-.3-.3-.6 0-.6.4v2.7h-4.7c-.2 0-.4-.2-.4-.4V5.5h2.7c.5 0 .7-.4.4-.6l-4.1-3.8c-.2-.2-.5-.2-.7 0L7.6 4.9c-.3.3-.1.6.4.6h2.6v4.7c0 .2-.2.4-.4.4H5.5V7.9c0-.5-.4-.7-.6-.4l-3.8 4.1c-.2.2-.2.5 0 .7l3.8 4.1c.3.3.6.1.6-.4v-2.6h4.7c.2 0 .4.2.4.4v4.7H7.9c-.5 0-.7.4-.4.6l4.1 3.8c.2.2.5.2.7 0l4.1-3.8c.3-.3.1-.6-.4-.6h-2.6v-4.7c0-.2.2-.4.4-.4h4.7v2.7c0 .5.4.7.6.4l3.8-4.1c.2-.3.2-.5 0-.7z"
      }
    },
    muted: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.4 2.6l-1-1c-.3-.3-.8-.2-1.1.2l-4.6 4.6V4.6c0-2.1-1.6-3.7-3.7-3.7S8.3 2.5 8.3 4.6v6.7c0 .7.2 1.3.6 1.9l-1.7 1.6c-.7-1-1.2-2.2-1.2-3.5V9.4c0-.6-.5-1.1-1.2-1.1s-1.1.5-1.1 1.1v1.9c0 1.9.7 3.7 1.9 5.1l-3.8 3.9c-.4.3-.4.8-.2 1.1l1 1c.3.3.8.2 1.1-.2L22.2 3.7c.4-.3.5-.8.2-1.1zM18 10.7v.6c0 3.2-2.7 5.9-6 5.9h-.4l-1.8 1.9c.4.1.8.1 1.3.2v1.5H9c-.6 0-1.2.5-1.2 1.1s.6 1.2 1.2 1.2h6c.7 0 1.2-.5 1.2-1.2s-.6-1.1-1.2-1.1h-2.1v-1.5c4.2-.6 7.4-4 7.4-8V9.4c0-.3-.1-.5-.3-.7l-2 2z"
      }
    },
    new: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M19.8 4.2C15.5-.1 8.5-.1 4.2 4.2c-4.3 4.3-4.3 11.3 0 15.6 4.3 4.4 11.3 4.4 15.6 0 4.3-4.3 4.3-11.3 0-15.6zm-.4 8.7c0 .3-.2.5-.5.5h-5.1c-.2 0-.4.2-.4.4v5.1c0 .3-.2.5-.5.5h-1.8c-.3 0-.5-.2-.5-.5v-5.1c0-.2-.2-.4-.4-.4H5.1c-.3 0-.5-.2-.5-.5v-1.8c0-.3.2-.5.5-.5h5.1c.2 0 .4-.2.4-.4V5.1c0-.3.2-.5.5-.5h1.8c.3 0 .5.2.5.5v5.1c0 .2.2.4.4.4h5.1c.3 0 .5.2.5.5v1.8z"
      }
    },
    new_direct_message: {
      "path": {
        "d": "M21 7.8l-1.6 1.7c-.2.2-.4.6-.4.9v8.1c0 .3-.3.7-.7.7H5.9c-.4 0-.7-.4-.7-.7V6c0-.4.3-.7.7-.7h8c.4 0 .8-.1 1-.4l1.6-1.6c.3-.3.1-.8-.3-.8h-12c-1 0-1.8.9-1.8 1.9v15.7c0 1 .8 1.8 1.8 1.8h15.7c1.1 0 1.9-.8 1.9-1.8V8.2c0-.4-.5-.6-.8-.4zM8.7 14.2l1.7 1.7c.1.1.2.1.3 0l9-9.2c.1-.1.1-.2 0-.3L18 4.8c-.1-.1-.2-.1-.3 0l-9 9.1c-.1.1-.1.2 0 .3zM18.5 4c-.1.1-.1.2 0 .2l1.7 1.7c.1.1.2.1.2 0l1.2-1.1c.3-.3.3-.8 0-1.1l-.8-.8c-.4-.4-.8-.4-1.1 0-.1 0-1.2 1.1-1.2 1.1zM7.2 17c0 .2.1.4.3.4l.9-.3c.2 0 .5-.1.7-.2.2 0 .5-.1.6-.1.1-.1.3-.3.2-.4l-1.8-1.8c-.1-.1-.3 0-.3.1-.1.2-.2.5-.2.7-.1.2-.2.4-.2.7-.1.4-.1.7-.2.9z"
      }
    },
    new_window: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.5.9h-8.8c-.4 0-.8.3-.8.6v1.4c0 .4.3.8.8.8h3.6c.4 0 .7.5.3.7l-7.8 7.9c-.3.3-.3.7 0 .9l1 1c.2.3.6.3.9 0l7.9-7.8c.2-.3.7-.1.7.3v3.6c0 .4.4.8.7.8h1.4c.4 0 .7-.4.7-.8V1.6c0-.4-.3-.7-.6-.7zm-5.7 10.9l-1.6 1.6c-.3.3-.4.6-.4 1v5.2c0 .4-.4.7-.7.7H4.4c-.4 0-.7-.3-.7-.7V9.9c0-.3.3-.7.7-.7h5.3c.4 0 .7-.1 1-.4l1.5-1.6c.3-.2.1-.7-.3-.7H2.8c-1 0-1.9.8-1.9 1.8v12.9c0 1 .9 1.9 1.9 1.9h12.9c1 0 1.8-.9 1.8-1.9v-9.1c0-.4-.5-.6-.7-.3z"
      }
    },
    news: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M23.3 2.8H4.4c-.4 0-.7.3-.7.7v14c0 .6-.5 1.1-1.1 1-.4-.1-.8-.5-.8-1V7.4c0-.3-.1-.5-.4-.5H.7c-.4 0-.7.3-.7.7v11.8c0 1 .8 1.8 1.8 1.8h20.4c1 0 1.8-.8 1.8-1.8V3.5c0-.4-.3-.7-.7-.7zM12.9 16.2c0 .2-.2.4-.4.4H6.9c-.3 0-.4-.2-.4-.4v-1c0-.2.1-.4.4-.4h5.6c.2 0 .4.2.4.4v1zm0-3.7c0 .2-.2.4-.4.4H6.9c-.3 0-.4-.2-.4-.4v-1c0-.2.1-.4.4-.4h5.6c.2 0 .4.2.4.4v1zm8.3 3.7c0 .2-.2.4-.4.4h-5.6c-.2 0-.4-.2-.4-.4v-1c0-.2.2-.4.4-.4h5.6c.2 0 .4.2.4.4v1zm0-3.7c0 .2-.2.4-.4.4h-5.6c-.2 0-.4-.2-.4-.4v-1c0-.2.2-.4.4-.4h5.6c.2 0 .4.2.4.4v1zm0-3.7c0 .2-.2.4-.4.4H6.9c-.3 0-.4-.2-.4-.4V6c0-.3.1-.5.4-.5h13.9c.2 0 .4.2.4.5v2.8z"
      }
    },
    note: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M19.1 18.3l-.4.4c-.5.5-1.1.7-1.7.7h-1.2c-1.1 0-2.3-.8-2.3-2.4v-1.1c0-.9.4-1.5.6-1.8l5-5.1c.1-.1.3-.5.3-.6V4.5c0-1.2-1-2.2-2.2-2.2H5.4c-1.2 0-2.3 1.1-2.3 2.2h-.7C1.6 4.5.9 5.2.9 6s.7 1.5 1.5 1.5h.7v3h-.7c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.7v3h-.7c-.8 0-1.5.7-1.5 1.5s.7 1.4 1.5 1.4h.7c0 1.5 1.1 2.2 2.3 2.2h11.8c1.2 0 2.2-1 2.2-2.2v-.9c0-.3-.1-.3-.3-.2zM15.3 7.9c0 .4-.3.7-.7.7H7.2c-.4 0-.7-.3-.7-.7v-.7c0-.5.3-.8.7-.8h7.4c.4 0 .7.3.7.8v.7zM12 16.8c0 .5-.3.8-.7.8H7.2c-.4 0-.7-.3-.7-.8v-.7c0-.4.3-.7.7-.7h4.1c.4 0 .7.3.7.7v.7zm1.1-4.4c0 .4-.3.7-.7.7H7.2c-.4 0-.7-.3-.7-.7v-.8c0-.4.3-.7.7-.7h5.2c.4 0 .7.3.7.7v.8zm9.7-2.1l-.4-.4c-.3-.3-.8-.3-1 0l-5.7 5.8V17c0 .1 0 .2.1.2h1.3l5.7-5.8c.4-.3.4-.7 0-1.1z"
      }
    },
    notebook: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M20.3.9H6.5c-1.1 0-1.9.9-1.9 1.9v1.4H3.2c-.8 0-1.4.6-1.4 1.3s.6 1.4 1.4 1.4h1.4v3.7H3.2c-.8 0-1.4.6-1.4 1.4s.6 1.4 1.4 1.4h1.4v3.7H3.2c-.8 0-1.4.6-1.4 1.4s.6 1.3 1.4 1.3h1.4v1.4c0 1 .8 1.9 1.9 1.9h13.8c1 0 1.9-.9 1.9-1.9V2.8c0-1-.9-1.9-1.9-1.9zm-3.2 15.7c0 .3-.2.5-.5.5h-6.4c-.3 0-.5-.2-.5-.5v-.9c0-.3.2-.5.5-.5h6.4c.3 0 .5.2.5.5v.9zm.9-3.7c0 .3-.2.5-.5.5H9.2c-.2 0-.4-.2-.4-.5V12c0-.3.2-.5.4-.5h8.3c.3 0 .5.2.5.5v.9zm.9-4.6c0 .3-.2.5-.4.5H8.3c-.3 0-.5-.2-.5-.5V5.5c0-.2.2-.4.5-.4h10.2c.2 0 .4.2.4.4v2.8z"
      }
    },
    notification: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M21.2 15.2H21c-.9 0-1.6-.7-1.6-1.6V8.3c0-4.2-3.5-7.6-7.8-7.4-3.9.2-7 3.6-7 7.6v5.2c0 .8-.7 1.5-1.6 1.5h-.2c-1 0-1.9.9-1.9 1.9v.7c0 .3.3.7.7.7h20.8c.4 0 .7-.4.7-.7v-.7c0-1-.9-1.9-1.9-1.9zm-6.9 5.1H9.7c-.2 0-.5.3-.4.6.2 1.3 1.4 2.2 2.7 2.2s2.5-1 2.7-2.2c.1-.3-.2-.6-.4-.6z"
      }
    },
    office365: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": {
          "d": "M14.2 22.8c.3.1.6.1.9 0l5.5-1.8c.4-.1.6-.4.6-.8V3.6c0-.3-.2-.6-.4-.7L15.2 1c-.3-.1-.7-.1-.9 0L3.2 5.3c-.2.1-.4.3-.4.6v12.5c0 .3.2.6.4.7l11 3.7zm.6-3c0 .2-.3.5-.5.4L5.1 19c-.3-.1-.4-.3-.4-.5v-.2c0-.2.1-.3.3-.4l1.7-.8c.2-.1.3-.3.3-.4V6.8c0-.2.2-.4.4-.4l6.9-1.6c.3 0 .6.1.6.5v14.5z"
        }
      }
    },
    offline: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M16 16.7c.2-.3.2-.6 0-.9l-.8-.8c-.2-.2-.6-.2-.8 0l-2.1 2c-.1.2-.4.2-.5 0l-2.1-2c-.2-.2-.6-.2-.8 0l-.8.8c-.3.3-.3.6 0 .9l2 2c.1.1.1.4 0 .5l-2 2.1c-.3.2-.3.6 0 .8l.8.8c.2.3.6.3.8 0l2.1-2c.1-.1.4-.1.5 0l2.1 2c.2.3.6.3.8 0l.8-.8c.2-.2.2-.6 0-.8l-2-2.1c-.2-.1-.2-.4 0-.5l2-2zm6-11.3C19.5 2.5 15.9 1 12 1S4.6 2.5 2.1 5.4c-.2.1-.2.5 0 .6l1.4 1.2c.2.2.5.1.7 0C6.2 5 9 3.7 12 3.7s5.9 1.3 7.9 3.5c.2.1.5.1.7 0L22 6c.2-.2.2-.5 0-.6zm-10 2c-1.9 0-3.7.9-5 2.3-.2.2-.2.5 0 .7l1.5 1.1c.2.2.5.2.6 0 .8-.8 1.8-1.3 2.9-1.3s2.2.5 3 1.2c.1.2.4.2.6.1l1.4-1.1c.3-.2.3-.5.1-.7C15.8 8.3 14 7.4 12 7.4z"
      }
    },
    offline_cached: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.8 9.4c-.4-3-3.1-5.3-6.2-5.3-3.5 0-6.3 2.8-6.3 6.3v.5c-2.3.2-4.1 2.1-4.1 4.4 0 2.5 2 4.5 4.5 4.5H11l-3.8-3.7c-.1-.2-.1-.5 0-.6l.6-.6c.2-.2.5-.2.6 0l1.7 1.6c.1.2.5 0 .5-.2v-6.2c0-.2.2-.5.4-.5h.9c.2 0 .4.2.4.5v6.1c0 .3.4.4.5.2l1.6-1.6c.2-.2.5-.2.6 0l.6.6c.2.2.2.4 0 .6L12 19.8h5.7c2.8 0 5.1-2.4 5.1-5.2 0-2.8-2.2-5.1-5-5.2z"
      }
    },
    omni_channel: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M21.8 1.2H16c-.4 0-.5.4-.2.7l1.8 1.8.3.3-3.5 3.4c-.3.3-.3.7 0 1 0 0 2.3 2.4 2.1 5.1 0 3.9-2.8 7-6.7 7-2.9.3-5.1-2.4-5.1-2.4-.3-.2-.7-.2-1 0L2 19.8c-.3.3-.3.7 0 1l.5.6c.3.2.7.2 1 0l.7-.6c1.5 1.2 3.5 1.9 5.6 1.9 5.1 0 9.2-4.1 9.2-9.2 0-2.1-.7-4.1-1.9-5.7l2.3-2.3.4.3 1.8 1.9c.3.3.6.1.6-.2V1.7c0-.3-.2-.5-.4-.5z"
      },
      "circle": {
        "cx": "9.738",
        "cy": "13.615",
        "r": "4.569"
      }
    },
    open: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M3.7 16.2v-.3.5-.2zM21.2.9H2.8C1.8.9.9 1.8.9 2.8v16.6c0 1 .9 1.8 1.9 1.8h5.5c.3 0 .5-.2.5-.4v-1.9c0-.3-.2-.4-.5-.4H4.4c-.4 0-.7-.4-.7-.7V6.2c0-.3.3-.7.7-.7h15.2c.4 0 .7.4.7.7v11.6c0 .3-.3.7-.7.7h-3.9c-.3 0-.5.1-.5.4v1.9c0 .2.2.4.5.4h5.5c1 0 1.9-.8 1.9-1.8V2.8c0-1-.9-1.9-1.9-1.9zM17.3 16l1-1c.3-.3.3-.7 0-1l-5.8-5.8c-.3-.3-.7-.3-1 0L5.7 14c-.3.3-.3.7 0 1l1 .9c.3.3.7.3 1 0l2.1-2.1c.3-.3.8-.1.8.3v8.3c0 .4.3.7.7.7h1.3c.4 0 .8-.3.8-.7v-8.3c0-.4.4-.6.8-.3l2.1 2.2c.3.2.7.2 1 0z"
      }
    },
    open_folder: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M21.2 6.5H10.8c-.7 0-1.3-.4-1.7-1L7.5 2.8c-.3-.6-.9-1-1.6-1H2.8c-1 0-1.9.9-1.9 1.9v16.6c0 1 .9 1.9 1.9 1.9h18.4c1 0 1.9-.9 1.9-1.9v-12c0-1-.9-1.8-1.9-1.8zm0-3.7H10.1c-.2 0-.3.2-.2.3l.8 1.2c.1.2.2.3.4.3h10.1c.5 0 1 .1 1.5.3.1.1.4-.1.4-.3 0-1-.9-1.8-1.9-1.8z"
      }
    },
    opened_folder: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M20.3 6.9c0-1-.8-1.8-1.8-1.8h-6.8c-.9 0-1.6-.9-1.6-.9L8.9 2.8s-.5-1-1.6-1H5.5c-1 0-1.8.9-1.8 1.9v4.1h16.6v-.9zm1.3 2.8H2.4c-1 0-1.7.9-1.4 1.7l2.6 9.7c.2.6.7 1.1 1.4 1.1h14.1c.6 0 1.2-.5 1.3-1.1l2.7-9.7c.2-.8-.5-1.7-1.5-1.7z"
      }
    },
    overflow: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.2 4.6H7.3c-1 0-1.7.8-1.7 1.7v.3c0 .1.1.2.3.2h9c1 0 1.7.8 1.7 1.7v10.2c0 .2.2.3.3.3h.3c.9 0 1.7-.8 1.7-1.7v-11c0-.9-.8-1.7-1.7-1.7zM20.9.9H11c-1 0-1.7.8-1.7 1.7v.3c0 .1.1.3.3.3h9c1 0 1.7.8 1.7 1.7v10.2c0 .1.1.3.3.3h.3c.9 0 1.7-.8 1.7-1.7V2.6c0-.9-.8-1.7-1.7-1.7zM15 10.1c0-1-.7-1.7-1.7-1.7H3.1c-1 0-1.7.7-1.7 1.7v11.3c0 .9.8 1.7 1.7 1.7h10.2c1 0 1.7-.8 1.7-1.7V10.1z"
      }
    },
    package: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M20.5 11.1h-3.7l-1.5 1.8h5v2.8H3.7v-2.8h4.9l-1.5-1.8H3.5c-.9 0-1.7.7-1.7 1.6v9c0 .8.6 1.4 1.4 1.4h17.6c.8 0 1.4-.6 1.4-1.4v-9c0-.9-.8-1.6-1.7-1.6zm-9.9-9.5v5.8H7.4c-.4 0-.7.4-.4.6l4.6 5.7c.2.1.5.1.7 0L16.9 8c.3-.2 0-.6-.4-.6h-3.1V1.6c0-.4-.3-.7-.7-.7h-1.4c-.4 0-.7.3-.7.7z"
      }
    },
    package_org: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M20.5 10.6h-5.8l-1.8 1.9h7.4v2.7H3.7v-2.7h3.7l-1.8-1.9H3.5c-.9 0-1.7.8-1.7 1.7v8.9c0 .8.6 1.4 1.4 1.4h17.6c.8 0 1.4-.6 1.4-1.4v-8.9c0-.9-.8-1.7-1.7-1.7zm-11 1.3c.4.4.9.4 1.3 0l8.8-8.8c.2-.1.2-.4 0-.6l-1.3-1.3c-.2-.2-.5-.2-.7 0l-7.4 7.5-3.1-3.1c-.2-.2-.5-.2-.7 0L5.1 6.9c-.2.2-.2.4 0 .6l4.4 4.4z"
      }
    },
    package_org_beta: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M20.5 10.6h-2.7c-.2.7-.5 1.3-1 1.9h3.5v2.7H3.7v-2.7h2.8v-1.9h-3c-.9 0-1.7.8-1.7 1.7v8.9c0 .8.6 1.4 1.4 1.4h17.6c.8 0 1.4-.6 1.4-1.4v-8.9c0-.9-.8-1.7-1.7-1.7zm-4.3-6c0-1.8-1.6-3.2-3.4-3.2H9c-.4 0-.7.3-.7.7v9.7c0 .3.3.7.7.7h3.9c1.8 0 3.3-1.5 3.2-3.3 0-.9-.4-1.7-1-2.2.7-.7 1.1-1.5 1.1-2.4zm-6-1.4h2.7c.8 0 1.4.6 1.4 1.4 0 .8-.6 1.4-1.4 1.4h-2.7V3.2zm4.1 6c0 .8-.6 1.4-1.4 1.4h-2.7V7.8h2.7c.8 0 1.4.6 1.4 1.4z"
      }
    },
    page: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M20.5 8.8h-5.2c-1.2 0-1.9-.8-1.9-2V1.7c0-.5-.3-.8-.8-.8H5c-1.2 0-2.2 1-2.2 2.2v17.8c0 1.2 1 2.2 2.2 2.2h14c1.2 0 2.2-1 2.2-2.2V9.5c0-.4-.3-.7-.7-.7zm.6-2.8l-4.9-4.9c-.1-.1-.3-.2-.4-.2-.3 0-.6.3-.6.5v4c0 .8.8 1.5 1.6 1.5h3.9c.3 0 .5-.3.5-.5s0-.4-.1-.4z"
      }
    },
    palette: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.8 8C21.8 3.6 17.2.9 12.1.9 5.9.9.9 5.9.9 12s5 11.1 11.2 11.1c8.6 0 7.9-4.4 5.2-6.1-1.7-1-2.5-3.3-.9-5 3-3.1 7.8 1.8 6.4-4zM6 15.7c-1.3 0-2.3-1-2.3-2.3s1-2.3 2.3-2.3 2.3 1 2.3 2.3-1 2.3-2.3 2.3zm.5-8.8c0-1.3 1-2.3 2.3-2.3s2.3 1 2.3 2.3-1 2.3-2.3 2.3-2.3-1-2.3-2.3zm5 13.4c-1.3 0-2.3-1-2.3-2.3s1-2.3 2.3-2.3 2.3 1 2.3 2.3-1 2.3-2.3 2.3zm4.2-12c-1.3 0-2.3-1-2.3-2.3s1-2.3 2.3-2.3S18 4.7 18 6s-1 2.3-2.3 2.3z"
      }
    },
    paste: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M8.1 5.5h7.8c.4 0 .7-.3.7-.7v-2c0-1-.8-1.9-1.8-1.9H9.2c-1 0-1.8.9-1.8 1.9v2c0 .4.3.7.7.7zm12.2-2.7h-1.1c-.4 0-.7.3-.7.7v2c0 1.1-.9 1.9-1.9 1.9H7.4c-1 0-1.9-.8-1.9-1.9v-2c0-.4-.3-.7-.7-.7H3.7c-1 0-1.9.8-1.9 1.8v16.6c0 1 .9 1.9 1.9 1.9h16.6c1 0 1.9-.9 1.9-1.9V4.6c0-1-.9-1.8-1.9-1.8zm-2.8 16.1c0 .3-.1.5-.4.5H6.9c-.3 0-.4-.2-.4-.5V18c0-.3.1-.5.4-.5h10.2c.3 0 .4.2.4.5v.9zm0-3.7c0 .3-.1.5-.4.5H6.9c-.3 0-.4-.2-.4-.5v-.9c0-.3.1-.5.4-.5h10.2c.3 0 .4.2.4.5v.9zm0-3.7c0 .3-.1.5-.4.5H6.9c-.3 0-.4-.2-.4-.5v-.9c0-.3.1-.4.4-.4h10.2c.3 0 .4.1.4.4v.9z"
      }
    },
    pause: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M13.8 19.8c0 .5.5 1 1 1h1.8c.5 0 .9-.5.9-1V4.2c0-.5-.4-1-.9-1h-1.8c-.5 0-1 .5-1 1v15.6zm-7.3 0c0 .5.4 1 .9 1h1.8c.5 0 1-.5 1-1V4.2c0-.5-.5-1-1-1H7.4c-.5 0-.9.5-.9 1v15.6z"
      }
    },
    people: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M19.4 10.3c-1.3-.5-1.5-1-1.5-1.5s.4-1 .8-1.4c.8-.7 1.2-1.6 1.2-2.7 0-2-1.3-3.8-3.7-3.8-2.1 0-3.4 1.5-3.6 3.3 0 .2.1.3.2.4 1.8 1.1 2.8 3.1 2.8 5.4 0 1.8-.6 3.3-1.9 4.4-.1.1-.1.3 0 .4.3.2 1.1.6 1.5.8.2 0 .3.1.4.1h5.6c1 0 1.9-.9 1.9-1.9v-.2c0-1.6-1.8-2.5-3.7-3.3zm-6.2 6.4c-1.6-.6-1.8-1.2-1.8-1.8 0-.6.5-1.2 1-1.7.9-.7 1.4-1.8 1.4-3.1 0-2.4-1.6-4.5-4.4-4.5-2.8 0-4.5 2.1-4.5 4.5 0 1.3.5 2.4 1.5 3.1.5.5.9 1.1.9 1.7 0 .6-.2 1.2-1.8 1.8-2.3.9-4.6 2-4.6 3.9v.6c0 1 .9 1.9 1.9 1.9h12.8c1.1 0 1.9-.9 1.9-1.9v-.6c0-1.9-2-3-4.3-3.9z"
      }
    },
    phone_landscape: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M24 6c0-1-.8-1.8-1.8-1.8H1.8C.8 4.2 0 5 0 6v12c0 1 .8 1.8 1.8 1.8h20.4c1 0 1.8-.8 1.8-1.8V6zM2.3 13.4c-.8 0-1.4-.6-1.4-1.4s.6-1.4 1.4-1.4 1.4.6 1.4 1.4-.6 1.4-1.4 1.4zm18 3c0 .4-.3.7-.7.7H5.3c-.4 0-.7-.3-.7-.7V7.6c0-.4.3-.7.7-.7h14.3c.4 0 .7.3.7.7v8.8z"
      }
    },
    phone_portrait: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M19.8 1.8C19.8.8 19 0 18 0H6C5 0 4.2.8 4.2 1.8v20.4c0 1 .8 1.8 1.8 1.8h12c1 0 1.8-.8 1.8-1.8V1.8zM12 23.1c-.8 0-1.4-.6-1.4-1.4s.6-1.4 1.4-1.4 1.4.6 1.4 1.4-.6 1.4-1.4 1.4zm5.1-4.4c0 .4-.3.7-.7.7H7.6c-.4 0-.7-.3-.7-.7V4.4c0-.4.3-.7.7-.7h8.8c.4 0 .7.3.7.7v14.3z"
      }
    },
    photo: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12 9.2c-2 0-3.7 1.7-3.7 3.7s1.7 3.7 3.7 3.7 3.7-1.6 3.7-3.7S14 9.2 12 9.2zm9.2-2.7h-2.4c-.6 0-1.2-.4-1.5-.9L16.2 4c-.3-.8-1.1-1.2-1.9-1.2H9.7c-.8 0-1.6.4-1.9 1.2L6.7 5.6c-.3.5-.9.9-1.6.9H2.8c-1 0-1.9.8-1.9 1.8v11.1c0 1 .9 1.8 1.9 1.8h18.4c1 0 1.9-.8 1.9-1.8V8.3c0-1-.9-1.8-1.9-1.8zm-9.2 12c-3 0-5.5-2.5-5.5-5.6S9 7.4 12 7.4s5.5 2.5 5.5 5.5-2.5 5.6-5.5 5.6z"
      }
    },
    picklist: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.2 18.9c.5 0 .9-.4.9-.9V6c0-.5-.4-.9-.9-.9H1.8c-.5 0-.9.4-.9.9v12c0 .5.4.9.9.9h20.4zM2.8 17.1V6.9h18.4v10.2H2.8zM15 10.6h4.3c.1 0 .2.2.1.2l-2.1 2.5c-.1.1-.3.1-.4 0l-2.1-2.5s.1-.2.2-.2z"
      }
    },
    pin: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.8 7.1L16.6.9C16 .2 15 .2 14.3.9s-.6 1.6 0 2.3l.3.3-7.4 4.9-.3-.2c-.6-.6-1.6-.6-2.3 0s-.6 1.7 0 2.3l3.3 3.3-6.8 6.9c-.6.6-.6 1.7 0 2.3.7.7 1.7.7 2.4 0l6.8-6.8 2.9 2.9c.6.6 1.7.6 2.3 0s.7-1.7 0-2.3l-.2-.3L20.2 9l.3.3c.6.7 1.7.7 2.3 0 .6-.5.6-1.5 0-2.2z"
      }
    },
    pinned: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17 10.9h-.2l-1.6-7.3h.4c.8 0 1.4-.6 1.4-1.3S16.4 1 15.6 1H8.4C7.6 1 7 1.6 7 2.3s.6 1.3 1.4 1.3h.4l-1.6 7.3H7c-.7 0-1.3.6-1.3 1.4s.6 1.3 1.3 1.3h3.9v8c0 .8.6 1.4 1.4 1.4s1.4-.6 1.4-1.4v-7.9h3.4c.7 0 1.3-.6 1.3-1.4s-.6-1.4-1.4-1.4z"
      }
    },
    power: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M15.9 3.6c-.3-.2-.7 0-.7.4v1.7c0 .3.2.7.5.8 2.4 1.4 4 4.2 3.6 7.3-.3 3.3-3.1 6.1-6.5 6.5-4.4.5-8.2-3-8.2-7.4 0-2.7 1.5-5.1 3.7-6.4.3-.1.5-.5.5-.8V4c0-.4-.4-.6-.7-.4-3.9 1.6-6.6 5.6-6.2 10.2.4 4.8 4.2 8.7 8.9 9.2 6.1.7 11.4-4.1 11.4-10.1 0-4.2-2.6-7.8-6.3-9.3zm-2.5-2c0-.4-.3-.7-.7-.7h-1.4c-.4 0-.7.3-.7.7v7.9c0 .3.3.7.7.7h1.4c.4 0 .7-.4.7-.7V1.6z"
      }
    },
    preview: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M23.9 11.6C21.7 7.2 17.2 4.2 12 4.2S2.3 7.2.1 11.6c-.1.3-.1.6 0 .8 2.2 4.4 6.7 7.4 11.9 7.4s9.7-3 11.9-7.4c.1-.3.1-.5 0-.8zM12 17.1c-2.8 0-5.1-2.3-5.1-5.1S9.2 6.9 12 6.9s5.1 2.3 5.1 5.1-2.3 5.1-5.1 5.1zm0-8.3c-1.8 0-3.2 1.4-3.2 3.2s1.4 3.2 3.2 3.2 3.2-1.4 3.2-3.2-1.4-3.2-3.2-3.2z"
      }
    },
    priority: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M4.2 1.6c0-.4-.4-.7-.7-.7H2.1c-.4 0-.7.3-.7.7v20.8c0 .4.3.7.7.7h1.4c.3 0 .7-.3.7-.7V1.6zm17.7 2c-7.4 3.8-6.5-4.1-15.4-1-.3.1-.5.4-.5.6V14c0 .3.3.5.6.4 8.9-3 7.9 5.2 15.6.8.3-.1.4-.3.4-.6V3.9c0-.3-.4-.5-.7-.3z"
      }
    },
    privately_shared: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M16.4 18.2c-.3-1.9-2.2-2.8-3.8-3.5-.7-.3-1.7-.7-1.9-1.5-.2-.5-.1-1 .1-1.4.4-.4.8-.8 1.1-1.3.1-.1.1-.2.2-.3 1-1.4 1.1-3.2.5-4.8-.5-1.6-2-2.7-3.8-2.8h-.3c-1.8.1-3.2 1.2-3.8 2.8-.5 1.6-.4 3.4.5 4.8.1.1.2.2.2.3.4.5.8.9 1.2 1.3.1.4.2.9.1 1.4-.3.8-1.3 1.2-1.9 1.5-1.6.7-3.6 1.6-3.9 3.5-.3 1.6.8 3.2 2.4 3.2h10.9c1.5 0 2.6-1.6 2.2-3.2zm2.7-13.6c1.9-.1 3.4 1.4 3.4 3.2 0 .2-.1.2-.2.2h-.8c-.2 0-.2 0-.2-.2v.1c0-1.1-.9-2-1.9-2.1-1.2-.1-2.2.8-2.2 2 0 .1-.1.2-.2.2h-.8c-.1 0-.2-.1-.2-.2 0-1.7 1.4-3.1 3.1-3.2zm3.4 4.3H16c-.5 0-.9.3-.9.8v3.9c0 .4.4.8.9.8h6.5c.4 0 .8-.4.8-.8V9.7c0-.5-.4-.8-.8-.8zm-2.3 4c0 .1-.1.3-.2.3h-1.5c-.2 0-.3-.2-.2-.3l.3-1.2c-.3-.2-.5-.6-.4-1 .1-.4.4-.7.8-.8.7-.1 1.2.3 1.2 1 0 .3-.2.6-.4.8l.4 1.2z"
      }
    },
    process: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M7.5 10.7l3.9-4.9c.3-.4.8-.4 1.1 0l3.9 5c.2.1.4.3.6.3h4.4c.4 0 .8-.3.8-.7V3.7c0-1-.9-1.9-1.9-1.9H3.7c-1 0-1.9.9-1.9 1.9v6.7c0 .4.4.7.7.7h4.4c.3 0 .4-.2.6-.4zm9 2.6l-3.9 4.9c-.3.4-.9.4-1.2 0l-3.9-5c-.2-.1-.3-.3-.6-.3H2.5c-.3 0-.7.3-.7.7v6.7c0 1 .9 1.9 1.9 1.9h16.6c1 0 1.9-.9 1.9-1.9v-6.7c0-.4-.4-.7-.7-.7H17c-.2 0-.4.2-.5.4z"
      }
    },
    push: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M20.3.9H9.2c-1 0-1.8.9-1.8 1.9 0 .3.2.7.4.8.2.1 1.9 1.9 1.9 1.9.2.1.4 0 .4-.2 0-.4.3-.7.7-.7h7.8c.4 0 .8.3.8.7v12.5c0 .3-.4.6-.8.6h-7.8c-.4 0-.6-.3-.6-.6v-.1c0-.2-.3-.3-.4-.1 0 0-1.8 1.7-2 1.8-.2.2-.4.5-.4.9v.9c0 1 .8 1.8 1.8 1.8h11.1c1 0 1.9-.8 1.9-1.8V2.8c0-1-.9-1.9-1.9-1.9zm-5.5 21.3c-.8 0-1.4-.6-1.4-1.4s.6-1.4 1.4-1.4 1.4.6 1.4 1.4-.6 1.4-1.4 1.4zM12.7 11L7 5.3c-.3-.3-.7-.3-1 0l-1 .9c-.2.3-.2.7 0 1l2.2 2.1c.2.3 0 .8-.4.8H.7c-.4.1-.7.4-.7.7v1.4c0 .4.3.7.7.7h6.1c.4 0 .6.5.3.8L5 15.8c-.3.3-.3.7 0 1l1 1c.2.2.6.2.9 0l5.8-5.8c.3-.2.3-.7 0-1z"
      }
    },
    puzzle: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M20.8 17.7c-.1 1.3-.3 2.6-.5 3.9 0 .4-.5.8-.8.8-2.5.3-5 .5-7.5.5-2.4 0-4.9-.1-7.3-.5-.4 0-.8-.4-.9-.8-.3-2-.5-4.1-.5-6.2s.2-4.1.5-6.2c.1-.3.5-.7.9-.8 1.5-.2 3-.3 4.4-.4 0 0 1.2 0 1.1-1.2 0-1-1.8-1.7-1.8-3.4C8.4 2 9.8.9 12 .9c2.3 0 3.6 1.1 3.6 2.5 0 1.8-1.7 2.4-1.8 3.4C13.8 7.9 15 8 15 8c1.5.1 3 .2 4.5.4.3 0 .8.4.8.8.2 1.5.4 2.8.5 4.2 0 .4-.4.9-.8.9h-.4c-.4 0-1-.4-1.3-.7 0 0-1-1-2.1-1-1.7-.1-3 1.4-3 3s1.3 3.1 3 3.1c1-.1 2-1.1 2-1.1.4-.2 1-.5 1.4-.5h.4c.5 0 .8.3.8.6z"
      }
    },
    question: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M13.1 17.5h-2.3c-.4 0-.6-.2-.6-.6v-.7c0-1.9 1.2-3.7 3-4.3.6-.2 1.1-.5 1.5-1 2.3-2.8.2-6.1-2.6-6.2-1 0-1.9.3-2.7 1-.6.6-1 1.3-1 2.1-.1.2-.4.5-.7.5H5.4c-.5 0-.8-.4-.7-.8.1-1.7.9-3.3 2.2-4.5C8.4 1.6 10.2.8 12.3.9c3.8.1 6.9 3.3 7.1 7.1.1 3.2-1.9 6.1-4.9 7.2-.4.2-.7.5-.7 1v.6c0 .5-.3.7-.7.7zm.7 4.9c0 .4-.3.7-.6.7h-2.4c-.3 0-.6-.3-.6-.7v-2.3c0-.4.3-.7.6-.7h2.4c.3 0 .6.3.6.7v2.3z"
      }
    },
    question_mark: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12.3 19.8c.4 0 .7.3.7.6v1.5c0 .4-.3.7-.7.7h-1.5c-.3 0-.6-.3-.6-.7v-1.5c0-.3.3-.6.6-.6h1.5zm.7-3.6c0-1 .6-1.8 1.4-2.2h.1c2.4-1 4.1-3.3 4.1-6.1 0-3.6-3-6.6-6.6-6.6-3.3 0-6.1 2.5-6.6 5.7 0 .4.3.8.7.8h1.5c.4 0 .7-.3.7-.6.3-1.8 1.9-3 3.7-3 2 0 3.7 1.6 3.7 3.7 0 1-.4 1.8-1 2.5v.1c-.4.4-1 .7-1.5.9-1.9.6-3.1 2.4-3.1 4.3v.7c0 .4.2.7.6.7h1.5c.4 0 .7-.3.7-.7l.1-.2z"
      }
    },
    questions_and_answers: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M23.1 12.9c0-1.8-1.2-3.3-2.8-3.9C20.2 4.5 16.5.9 12 .9S3.8 4.5 3.7 9C2.1 9.6.9 11.1.9 12.9c0 2 1.4 3.6 3.1 4 1 3.6 4.2 6.2 8 6.2s7-2.6 8-6.2c1.7-.4 3.1-2 3.1-4zm-4.6-4.1l-.1-.1.2.1h-.1zM12 21.2c-3.6 0-6.5-3-6.5-6.6 0-.9.2-2.3.6-3.2 0-.1.1-.2.2-.4 1.4-.5 2.6-1.5 3.3-2.7 1.7 2 4.2 3.4 7 3.4H18c.1.6.3 1.3.4 2.1-.3 1.1-2.1 2.2-4.6 2.4-.1-.3-.4-.5-.7-.5h-2.3c-.4 0-.6.4-.6.7v1.4c0 .4.2.7.6.7h2.3c.3 0 .6-.2.7-.5 1.6 0 3.1-.5 4.2-1.2-.8 2.6-3.2 4.4-6 4.4z"
      }
    },
    quick_text: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12 1.5C5.8 1.5.7 6.2.7 11.9c0 1.8.5 3.5 1.4 5 .1.3.2.5.1.8l-1.5 4c-.1.4.2.7.6.6l4.1-1.5c.2-.1.5-.1.7.1 1.7.9 3.8 1.5 6 1.5 6.2-.1 11.3-4.7 11.3-10.4 0-5.8-5.1-10.5-11.4-10.5zm-5.2 10c0-.2.2-.4.4-.4h7.4c.2 0 .4.2.4.4v1c0 .2-.1.4-.4.4H7.2c-.2 0-.5-.2-.5-.4v-1zM17.4 16c0 .2-.2.4-.5.4H7.2c-.2 0-.5-.2-.5-.4v-.9c0-.2.2-.5.5-.5h9.7c.2 0 .5.2.5.5v.9zm0-7.1c0 .2-.2.5-.5.5H7.2c-.2 0-.5-.2-.5-.5V8c0-.2.2-.4.5-.4h9.7c.2 0 .5.2.5.4v.9z"
      }
    },
    quotation_marks: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M20.4 3c-4.1 0-7.3 3.2-7.3 7.4v9.9c0 .4.3.7.7.7h7.8c.4 0 .7-.3.7-.7v-7.8c0-.4-.3-.7-.7-.7h-5.7v-1.4c0-2.3 2.2-4.6 4.5-4.6h1.2c.4 0 .7-.4.7-.7V3.7c0-.4-.3-.7-.7-.7h-1.2zM9 3c-4.2 0-7.3 3.2-7.3 7.4v9.9c0 .4.3.7.7.7h7.8c.4 0 .7-.3.7-.7v-7.8c0-.4-.3-.7-.7-.7H4.4v-1.4c0-2.3 2.3-4.6 4.6-4.6h1.2c.4 0 .7-.4.7-.7V3.7c0-.4-.3-.7-.7-.7H9z"
      }
    },
    rating: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M13.3 19.8v2.4c0 .5-.4.9-.9.9h-.9c-.5 0-.9-.4-.9-.9v-2.4c0-.2.2-.4.4-.3 0 0 .5.1 1 .1s.9-.1.9-.1c.3-.1.5.1.4.3zM5.1 5V1.8c0-.5-.4-.9-.9-.9h-1c-.5 0-.9.4-.9.9V5C1.5 5.4.9 6.4.9 7.4c0 1.5 1.3 2.8 2.8 2.8s2.8-1.3 2.8-2.8c0-1-.6-2-1.4-2.4zm-.5 7.1s-.5.1-1 .1-.9-.1-.9-.1c-.2-.1-.4.1-.4.4v9.7c0 .5.4.9.9.9h.9c.5 0 .9-.4.9-.9v-9.7c.1-.3-.1-.5-.4-.4zm16.6 1.8s-.5.2-.9.2-1-.2-1-.2c-.2 0-.4.1-.4.4v7.9c0 .5.4.9.9.9h.9c.5 0 .9-.4.9-.9v-7.9c.1-.2-.1-.4-.4-.4zm.5-7.1v-5c0-.5-.4-.9-.9-.9h-1c-.5 0-.9.4-.9.9v5c-.8.5-1.4 1.4-1.4 2.4 0 1.6 1.3 2.8 2.8 2.8s2.8-1.2 2.8-2.8c0-1-.6-1.9-1.4-2.4zm-8.3 5.6V1.8c0-.5-.4-.9-.9-.9h-1c-.5 0-.9.4-.9.9v10.6c-.8.4-1.4 1.4-1.4 2.4 0 1.5 1.3 2.7 2.8 2.7s2.8-1.2 2.8-2.7c0-1-.6-2-1.4-2.4z"
      }
    },
    record: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12 3.7c4.6 0 8.3 3.7 8.3 8.3s-3.7 8.3-8.3 8.3-8.3-3.7-8.3-8.3S7.4 3.7 12 3.7z"
      }
    },
    record_create: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M8 5.4h8c.4 0 .8-.4.8-.8V3.1c0-1.2-1-2.2-2.2-2.2H9.5c-1.2 0-2.2 1-2.2 2.2v1.5c0 .4.3.8.7.8zm12-2.6h-.8c-.2 0-.3.1-.3.3v1.5c0 1.6-1.3 3-2.9 3H8c-1.6 0-2.9-1.4-2.9-3V3.1c0-.2-.1-.3-.3-.3H4c-1.2 0-2.2 1-2.2 2.2v15.9c0 1.2 1 2.2 2.2 2.2h16c1.2 0 2.2-1 2.2-2.2V5c0-1.2-1-2.2-2.2-2.2zM8 18.6c0 .5-.3.8-.7.8h-.7c-.5 0-.8-.3-.8-.8v-.7c0-.4.3-.7.8-.7h.7c.4 0 .7.3.7.7v.7zM8 15c0 .4-.3.7-.7.7h-.7c-.5 0-.8-.3-.8-.7v-.8c0-.4.3-.7.8-.7h.7c.4 0 .7.3.7.7v.8zm0-3.7c0 .4-.3.7-.7.7h-.7c-.5 0-.8-.3-.8-.7v-.8c0-.4.3-.7.8-.7h.7c.4 0 .7.3.7.7v.8zm10.2 7.3c0 .5-.3.8-.8.8h-7.2c-.4 0-.7-.3-.7-.8v-.7c0-.4.3-.7.7-.7h7.2c.5 0 .8.3.8.7v.7zm0-3.6c0 .4-.3.7-.8.7h-7.2c-.4 0-.7-.3-.7-.7v-.8c0-.4.3-.7.7-.7h7.2c.5 0 .8.3.8.7v.8zm0-3.7c0 .4-.3.7-.8.7h-7.2c-.4 0-.7-.3-.7-.7v-.8c0-.4.3-.7.7-.7h7.2c.5 0 .8.3.8.7v.8z"
      }
    },
    redo: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M16.4 5.8h.3c.5 0 .5-.4.2-.6l-2.3-2.3c-.2-.2-.2-.7 0-1l1-.9c.2-.3.7-.3 1 0l5.9 5.9c.3.3.3.6 0 .9l-6 6c-.3.2-.6.2-.9-.1l-1-1c-.2-.3-.3-.7 0-1l2.2-2.2c.4-.4.5-.6.1-.8-.1-.1-.5-.1-.5-.1H10c-3.3 0-5.9 2.7-5.9 5.9s2.6 5.9 5.9 5.9h3.7c.4 0 .7.4.7.7v1.5c0 .4-.3.7-.6.7H10c-4.8 0-8.8-3.9-8.8-8.8s4-8.7 8.8-8.7h6.4z"
      }
    },
    refresh: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M21.5 1.8h-1.4c-.4 0-.7.4-.7.7v3.3c0 .4-.2.6-.6.3-.1-.2-.2-.3-.4-.5-2.3-2.3-5.6-3.2-8.9-2.6-1.1.2-2.3.7-3.2 1.3-2.8 1.9-4.5 4.9-4.5 8.1 0 2.5.9 5 2.7 6.8 1.8 1.9 4.3 3 7 3 2.3 0 4.6-.8 6.3-2.3.3-.3.3-.7.1-1l-1-1c-.2-.2-.7-.3-.9 0-1.7 1.3-4 1.9-6.2 1.3-.6-.1-1.2-.4-1.8-.7-2.6-1.6-3.8-4.7-3.1-7.7.1-.6.4-1.2.7-1.8 1.3-2.2 3.6-3.5 6-3.5 1.8 0 3.6.8 4.9 2.1.2.2.4.4.5.6.2.4-.2.6-.6.6h-3.2c-.4 0-.7.3-.7.7v1.4c0 .4.3.6.7.6h8.4c.3 0 .6-.2.6-.6V2.5c0-.3-.4-.7-.7-.7z"
      }
    },
    relate: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M16.6 9.2c0-1-.8-1.8-1.8-1.8h-12c-1 0-1.9.8-1.9 1.8v12c0 1 .9 1.9 1.9 1.9h12c1 0 1.8-.9 1.8-1.9v-12zm-3.7 6.5c0 .2-.2.5-.4.5H9.7v2.7c0 .3-.2.5-.5.5h-.9c-.2 0-.5-.2-.5-.5v-2.7H5.1c-.3 0-.5-.3-.5-.5v-.9c0-.3.2-.5.5-.5h2.7v-2.8c0-.2.3-.4.5-.4h.9c.3 0 .5.2.5.4v2.8h2.8c.2 0 .4.2.4.5v.9zm6.9 3.7h-1.3v-2.8h1.3c.3 0 .5-.2.5-.4v-12c0-.3-.2-.5-.5-.5h-12c-.2 0-.4.2-.4.5v1.3H4.6V4.2C4.6 2.4 6 .9 7.8.9h12c1.8 0 3.3 1.5 3.3 3.3v12c0 1.8-1.5 3.2-3.3 3.2z"
      }
    },
    reminder: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M29.9 8.8V9v-.2z"
      }, {
        "d": "M23.2 3.5C22.9 2.1 21.8.9 20.4.7c-1.1-.1-2 .2-2.7.8-.3.2-.2.5.1.6 1.7.9 3.2 2.2 4.3 3.8.1.2.5.2.7 0 .4-.7.6-1.5.4-2.4zm-17-1.3c.3-.1.3-.5.1-.7C5.6.9 4.7.6 3.6.8 2.2 1 1 2.1.8 3.5c-.2.9 0 1.7.5 2.4.1.2.5.2.6 0C3 4.4 4.5 3 6.2 2.2zM12 3C6.4 3 1.8 7.6 1.8 13.2c0 2.2.8 4.3 2 6l-1.5 1.5c-.6.6-.6 1.5 0 2.1.3.3.7.5 1.1.5.3 0 .7-.2 1-.5L6 21.3c1.7 1.2 3.7 2 6 2s4.3-.8 6-2l1.5 1.5c.3.3.7.5 1.1.5.4 0 .8-.2 1.1-.5.6-.6.6-1.5 0-2.1l-1.5-1.5c1.2-1.7 2-3.8 2-6C22.2 7.5 17.6 3 12 3zM4.8 13.1C4.8 9.2 8.1 6 12 6s7.2 3.2 7.2 7.2-3.2 7.1-7.2 7.1-7.2-3.2-7.2-7.2zm8.4-.4v-3c0-.6-.6-1.1-1.2-1.1s-1.1.5-1.1 1.1v3.4c0 .3.1.6.4.8l2.6 2.6c.2.3.5.3.8.3.3 0 .5 0 .8-.3.4-.4.4-1.1 0-1.5l-2.3-2.3z"
      }]
    },
    remove_formatting: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M20.8 18.9l2.1-2.1c.2-.2.2-.5 0-.7l-1.3-1.3c-.1-.2-.4-.2-.6 0L18.9 17l-2-2c-.1-.2-.4-.2-.6 0L15 16.3c-.2.2-.2.5 0 .6l2 2-2 2c-.1.1-.1.4 0 .6l1.3 1.3c.2.2.5.2.7 0l1.9-1.9 2.1 2c.2.2.5.2.6 0l1.3-1.3c.2-.1.2-.4 0-.6l-2.1-2.1zM2.2 3.7h5L5.3 14.4c-.1.5.2.8.7.8h2.3c.3 0 .7-.2.7-.5l1.9-11H16c.3 0 .7-.2.7-.6l.2-1.4c.1-.4-.2-.8-.7-.8H2.4c-.3 0-.6.3-.6.6l-.3 1.4c-.1.4.3.8.7.8zm10.7 14.1c0-.4-.3-.7-.7-.7H1.6c-.4 0-.7.3-.7.7v1.4c0 .3.3.6.7.6h10.6c.4 0 .7-.3.7-.6v-1.4z"
      }
    },
    remove_link: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M11.1 16.9c-.3 0-.6-.1-.9-.1-.2-.1-.6-.2-.8-.3-.2 0-.4 0-.5.1l-.2.2c-1.1 1.2-3 1.3-4.3.2-1.3-1.2-1.4-3.2-.1-4.5l3-3c.5-.5.9-.7 1.4-.8.7-.2 1.4-.2 2 .1.3.2.7.4 1 .7.1.1.3.3.4.6.1.2.5.3.7.1L14 9c.2-.2.2-.4 0-.6-.2-.2-.3-.4-.5-.6-.3-.3-.7-.6-1-.8-.6-.4-1.2-.6-1.9-.8-1.2-.2-2.6 0-3.8.6-.4.3-.8.6-1.2 1l-3 2.9c-2.1 2.1-2.3 5.6-.2 7.8 2.2 2.3 5.8 2.4 8 .1l1-1c.3-.2.1-.7-.3-.7zm7.6-6.5c2.2-2.2 2.2-5.9-.1-8-2.3-2.1-5.7-1.9-7.8.2l-1 .9c-.2.3-.1.7.3.8.6 0 1.2.1 1.7.3.2.1.4 0 .5-.1l.2-.2c1.1-1.1 3-1.3 4.3-.2 1.3 1.2 1.4 3.3.1 4.5l-3.1 3.1c-.4.4-.8.6-1.3.8-.7.1-1.4.1-2-.2-.3-.1-.7-.3-1-.7-.1-.1-.3-.3-.4-.5-.1-.3-.5-.3-.7-.1l-1.1 1.1c-.2.2-.2.5-.1.6.2.3.4.5.6.7.3.3.6.5 1 .8.6.3 1.2.6 1.9.7 1.2.2 2.5.1 3.7-.6.5-.2.9-.5 1.3-.9l3-3zm2.1 8.5l2.1-2.1c.2-.2.2-.5 0-.6l-1.3-1.3c-.1-.2-.4-.2-.6 0L18.9 17l-2-2c-.1-.1-.4-.1-.6 0L15 16.3c-.2.2-.2.5 0 .7l2 2-2 1.9c-.1.2-.1.5 0 .7l1.3 1.2c.2.2.5.2.7 0l1.9-1.9L21 23c.2.2.5.2.6 0l1.3-1.3c.2-.2.2-.5 0-.7l-2.1-2.1z"
      }
    },
    replace: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M9.2 17.3c0-.4-.3-.7-.7-.7H1.6c-.4 0-.7.3-.7.7v5.1c0 .4.3.7.7.7h6.9c.4 0 .7-.3.7-.7v-5.1zm-5.5-7.1H1.5c-.5 0-.7.4-.4.6l3.7 3.8c.1.2.4.2.6 0l3.7-3.8c.3-.3 0-.6-.4-.6H6.5c0-2.4 2.3-4.7 4.6-4.7V2.8c-4.2 0-7.4 3.2-7.4 7.4zm15.6-.8c-.2-.2-.5-.2-.7 0L15 13.2c-.3.3-.1.6.4.6h2.2c0 2.8-1.9 4.7-4.7 4.7v2.7c4.2 0 7.5-3.2 7.5-7.4h2.2c.5 0 .7-.4.4-.6l-3.7-3.8zm3.8-7.8c0-.4-.3-.7-.7-.7h-6.9c-.4 0-.7.3-.7.7v5.1c0 .4.3.7.7.7h6.9c.4 0 .7-.3.7-.7V1.6z"
      }
    },
    reply: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M8.9 8.4s-.5-.6-.3-.8L11.2 5c.3-.3.3-.7 0-1l-1-1c-.2-.3-.6-.3-.9 0L3 9.2c-.2.3-.2.7 0 1l6.3 6.2c.3.3.7.3.9 0l1-.9c.3-.3.3-.7 0-1l-2.5-2.6c-.3-.3-.1-.7.2-.8 5.1.2 9.3 4.3 9.6 9.5 0 .4.3.7.7.7h1.4c.4 0 .6-.3.6-.8-.3-6.7-5.4-11.9-12.3-12.1z"
      }
    },
    reply_all: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M11.3 8.4s-.5-.6-.3-.8L13.6 5c.3-.3.3-.7 0-1l-1-1c-.2-.3-.6-.3-.9 0L5.4 9.2c-.2.3-.2.7 0 1l6.3 6.2c.3.3.7.3.9 0l1-.9c.3-.3.3-.7 0-1l-2.5-2.6c-.3-.3-.1-.7.2-.8 5.1.2 9.3 4.3 9.6 9.5 0 .4.3.7.7.7H23c.4 0 .6-.3.6-.8-.3-6.7-5.4-11.9-12.3-12.1zm-8.8 1l5.3-5.3c.3-.3.3-.7 0-1V3c-.3-.3-.7-.3-1 0L.6 9.2c-.3.3-.3.7 0 1l6.2 6.2c.3.3.7.3 1 0 .3-.3.3-.7 0-1l-5.3-5.3s-.3-.3 0-.7z"
      }
    },
    reset_password: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M19.4 10.6H4.6c-1 0-1.8.8-1.8 1.9v8.7c0 1 .8 1.9 1.8 1.9h14.8c1 0 1.8-.9 1.8-1.9v-8.7c0-1.1-.8-1.9-1.8-1.9zm-5.1 9.9c-.7.5-1.5.7-2.3.7-.3 0-.6 0-.8-.1-1.1-.2-2.1-.8-2.7-1.7l1.6-1c.3.5.8.8 1.4.9.6.2 1.2 0 1.8-.3 1.1-.7 1.3-2.2.6-3.2-.3-.5-.8-.9-1.4-1-.6-.1-1.2 0-1.8.4l-.3.3 1.6 1.6H7.8v-4.2L9 14.1c.2-.2.5-.3.6-.5 1-.6 2.1-.8 3.2-.6 1.1.2 2 .8 2.6 1.7 1.3 2 .8 4.5-1.1 5.8zM4.6 8.4v.1-.1zm.5.4h1.8c.3 0 .5-.2.5-.4v-.1c0-2.6 2.2-4.8 4.9-4.6 2.5.2 4.3 2.3 4.3 4.8v-.1c0 .2.2.4.5.4h1.8c.3 0 .5-.2.5-.4v-.1c0-4.2-3.5-7.6-7.8-7.4-3.9.2-6.9 3.5-7 7.5.1.2.2.4.5.4z"
      }
    },
    resource_absence: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M10.1 17.1c0-1.3.4-2.7 1.1-3.8.8-1.4 1.6-1.9 2.3-3 1.2-1.7 1.4-4.1.7-6-.8-1.9-2.5-3-4.6-2.9S6 2.7 5.3 4.6c-.7 2-.4 4.5 1.3 6.1.6.7 1.3 1.7.9 2.6-.3 1-1.4 1.4-2.2 1.7-1.8.8-4 1.9-4.3 4.1-.4 1.7.8 3.5 2.7 3.5h7.8c.4 0 .6-.4.4-.7-1.1-1.4-1.8-3.1-1.8-4.8zm11.3-3.9c-2.2-2.2-5.7-2.2-7.8 0-2.2 2.1-2.2 5.6 0 7.8 2.1 2.2 5.6 2.2 7.8 0s2.2-5.7 0-7.8zM19.8 18c.2.2.2.6 0 .7l-.7.7c-.2.2-.4.2-.6-.1l-1-.9-1 1c-.2.2-.4.2-.6-.1l-.7-.6c-.2-.2-.2-.4 0-.6l1-1-1-1c-.2-.2-.2-.5 0-.6l.6-.7c.2-.2.5-.2.7 0l1 .9 1-.9c.1-.2.5-.3.7-.1l.6.7c.2.2.2.5 0 .7l-1 .9 1 1z"
      }
    },
    resource_capacity: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.5 11.5c-3.1 0-5.6 2.6-5.6 5.7s2.5 5.6 5.6 5.6 5.6-2.6 5.6-5.6-2.5-5.7-5.6-5.7zm3.9 6.2h-4v-4.3s1.5-.1 2.9 1.4 1.1 2.9 1.1 2.9zm-11.2-.5c0-1.2.5-2.7 1.1-3.8.8-1.4 1.7-2 2.4-3 1.1-1.7 1.3-4.2.6-6.1-.7-1.9-2.5-3-4.6-2.9-2 0-3.7 1.3-4.3 3.2-.8 2.1-.5 4.6 1.2 6.2.7.6 1.3 1.7 1 2.7-.4.9-1.5 1.3-2.2 1.7-1.8.8-4.1 1.9-4.4 4-.4 1.8.8 3.6 2.7 3.6h7.9c.4 0 .6-.4.4-.7-1.1-1.4-1.8-3.1-1.8-4.9z"
      }
    },
    resource_territory: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12.3 13.4c.9-1.4 1.9-2 2.6-3 1.1-1.7 1.3-4.2.6-6-.7-1.9-2.5-3-4.5-3S7.3 2.7 6.6 4.6c-.7 2.1-.4 4.6 1.3 6.2.7.6 1.3 1.6 1 2.6-.4.9-1.5 1.3-2.3 1.7-1.8.8-3.9 1.9-4.3 4-.4 1.8.8 3.6 2.7 3.6h8.3c.4 0 .7-.5.5-.7-1.2-1.4-2.4-3.1-2.4-4.9 0-1.2.3-2.6.9-3.7zm5.1 4.8c-1 0-1.8-.8-1.8-1.8s.8-1.7 1.8-1.7 1.8.8 1.8 1.7c0 1-.8 1.8-1.8 1.8zm0-6c-2.4 0-4.2 1.9-4.2 4.2 0 2.9 3 5.7 3.9 6.4.2.1.4.1.6 0 .9-.8 3.9-3.5 3.9-6.4 0-2.3-1.8-4.2-4.2-4.2z"
      }
    },
    retweet: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M23.8 13.3l-1-1c-.2-.3-.6-.3-.9 0l-1.3 1.3c-.3.3-.8.1-.8-.4V5.5c0-1-.8-1.8-1.8-1.8h-6.7c-.4 0-.7.3-.7.7v1.4c0 .3.3.7.7.7h5.1c.4 0 .7.3.7.7v6c0 .5-.5.6-.9.4L15 12.4c-.2-.3-.7-.3-.9 0l-1 1c-.3.3-.3.7 0 1l4.9 4.8c.2.3.6.3.9 0l4.9-4.9c.2-.3.2-.7 0-1zm-11.1 4.2H7.6c-.4 0-.7-.3-.7-.7v-6c0-.5.5-.6.9-.4L9 11.6c.2.3.7.3.9 0l1-.9c.3-.3.3-.7 0-1L6.1 4.8c-.3-.3-.7-.3-1 0L.2 9.7c-.3.3-.3.7 0 1l1 .9c.2.3.6.3.9 0l1.3-1.2c.2-.3.8-.1.8.3v7.8c0 1 .8 1.8 1.8 1.8h6.7c.4 0 .7-.3.7-.7v-1.4c0-.3-.3-.7-.7-.7z"
      }
    },
    richtextbulletedlist: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M3.7 6.2c0 .4-.3.7-.7.7H1.6c-.4 0-.7-.3-.7-.7V4.8c0-.3.3-.6.7-.6H3c.4 0 .7.3.7.6v1.4zm19.4-1.4c0-.3-.3-.6-.7-.6H6.2c-.3 0-.7.3-.7.6v1.4c0 .4.4.7.7.7h16.2c.4 0 .7-.3.7-.7V4.8zM3.7 11.3c0-.4-.3-.7-.7-.7H1.6c-.4 0-.7.3-.7.7v1.4c0 .4.3.7.7.7H3c.4 0 .7-.3.7-.7v-1.4zm17.5 0c0-.4-.3-.7-.7-.7H6.2c-.3 0-.7.3-.7.7v1.4c0 .4.4.7.7.7h14.3c.4 0 .7-.3.7-.7v-1.4zM3.7 17.8c0-.4-.3-.7-.7-.7H1.6c-.4 0-.7.3-.7.7v1.4c0 .3.3.6.7.6H3c.4 0 .7-.3.7-.6v-1.4zm19.4 0c0-.4-.3-.7-.7-.7H6.2c-.3 0-.7.3-.7.7v1.4c0 .3.4.6.7.6h16.2c.4 0 .7-.3.7-.6v-1.4z"
      }
    },
    richtextindent: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M24 5.3c0-.4-.3-.7-.7-.7h-7.8c-.4 0-.7.3-.7.7v1.4c0 .4.3.7.7.7h7.8c.4 0 .7-.3.7-.7V5.3zm-1.8 11.1c0-.4-.4-.7-.7-.7h-6c-.4 0-.7.3-.7.7v1.4c0 .3.3.7.7.7h6c.3 0 .7-.4.7-.7v-1.4zm1.8-5.6c0-.3-.3-.6-.7-.6h-7.8c-.4 0-.7.3-.7.6v1.4c0 .4.3.7.7.7h7.8c.4 0 .7-.3.7-.7v-1.4zM12.9 2.5c0-.3-.3-.7-.7-.7h-1.4c-.3 0-.6.4-.6.7v19c0 .3.3.7.6.7h1.4c.4 0 .7-.4.7-.7v-19zM4.3 7.1c-.2-.3-.6-.1-.6.4v2.7h-3c-.4 0-.7.3-.7.6v1.4c0 .4.3.7.7.7h3v2.7c0 .5.4.7.6.5l3.9-4.2c.1-.2.1-.5 0-.6L4.3 7.1z"
      }
    },
    richtextnumberedlist: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M23.1 3v1.4c0 .4-.3.7-.7.7H9.9c-.3 0-.7-.3-.7-.7V3c0-.4.4-.7.7-.7h12.5c.4 0 .7.3.7.7zM9.9 9.7h8.3c.4 0 .7-.3.7-.7V7.6c0-.4-.3-.7-.7-.7H9.9c-.3 0-.7.3-.7.7V9c0 .4.4.7.7.7zm12.5 4.1H9.9c-.3 0-.7.4-.7.7v1.4c0 .4.4.7.7.7h12.5c.4 0 .7-.3.7-.7v-1.4c0-.3-.3-.7-.7-.7zm-4.2 4.7H9.9c-.3 0-.7.3-.7.7v1.3c0 .4.4.7.7.7h8.3c.4 0 .7-.3.7-.7v-1.3c0-.4-.3-.7-.7-.7zM1.6 3.7h1.2v5.8c0 .3.3.7.7.7h.4c.4 0 .7-.4.7-.7V2.8c0-.5-.4-1-.9-1H1.6c-.4 0-.7.4-.7.7V3c0 .4.3.7.7.7zm3.9 9.2H1.6c-.4 0-.7.3-.7.7v.5c0 .3.3.7.7.7h3v1.8H1.8c-.5 0-.9.4-.9.9v3.7c0 .5.4 1 .9 1h4c.3 0 .7-.4.7-.7V21c0-.4-.4-.7-.7-.7h-3v-1.8h2.7c.5 0 1-.5 1-1v-3.7c0-.5-.5-.9-1-.9z"
      }
    },
    richtextoutdent: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M7.6 10.2h-3V7.4c0-.4-.4-.7-.6-.4L.1 11.2c-.1.2-.1.4 0 .6L4 16c.2.2.6 0 .6-.4v-2.7h3c.3 0 .7-.3.7-.7v-1.4c0-.3-.4-.6-.7-.6zM24 5.3c0-.4-.3-.7-.7-.7h-7.8c-.4 0-.7.3-.7.7v1.4c0 .4.3.7.7.7h7.8c.4 0 .7-.3.7-.7V5.3zm-1.8 11.1c0-.4-.4-.7-.7-.7h-6c-.4 0-.7.3-.7.7v1.4c0 .3.3.7.7.7h6c.3 0 .7-.4.7-.7v-1.4zm1.8-5.6c0-.3-.3-.6-.7-.6h-7.8c-.4 0-.7.3-.7.6v1.4c0 .4.3.7.7.7h7.8c.4 0 .7-.3.7-.7v-1.4zM12.9 2.5c0-.3-.3-.7-.7-.7h-1.4c-.3 0-.6.4-.6.7v19c0 .3.3.7.6.7h1.4c.4 0 .7-.4.7-.7v-19z"
      }
    },
    right: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M6.5 20.2V3.8c0-.4.6-.8 1-.4l9.8 8c.3.3.3.9 0 1.2l-9.8 8c-.4.4-1 .1-1-.4z"
      }
    },
    right_align_text: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M21.5 2.3h-19c-.3 0-.7.3-.7.7v1.4c0 .4.4.7.7.7h19c.3 0 .7-.3.7-.7V3c0-.4-.4-.7-.7-.7zm0 5.5H6.2c-.3 0-.7.4-.7.7v1.4c0 .4.4.7.7.7h15.3c.3 0 .7-.3.7-.7V8.5c0-.3-.4-.7-.7-.7zm0 11.1H6.2c-.3 0-.7.3-.7.7V21c0 .4.4.7.7.7h15.3c.3 0 .7-.3.7-.7v-1.4c0-.4-.4-.7-.7-.7zm0-5.5h-19c-.3 0-.7.3-.7.7v1.4c0 .3.4.7.7.7h19c.3 0 .7-.4.7-.7v-1.4c0-.4-.4-.7-.7-.7z"
      }
    },
    rotate: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.4.9H21c-.4 0-.7.3-.7.7v3.2c0 .5-.5.7-.7.4-2.2-2.4-5.3-3.6-8.7-3.3-1.2.1-2.3.5-3.4 1-.5.3-1.1.6-1.5 1-.4.2-.4.7-.1 1l.9 1c.3.2.6.3.9.1.6-.4 1.2-.7 1.8-1 .3-.1.6-.2.9-.2 2.9-.6 5.7.6 7.3 2.4.5.7.1 1.1-.3 1.1h-3.3c-.3 0-.7.3-.7.7v1.4c0 .4.4.7.7.7h8.4c.3 0 .6-.3.6-.6V1.6c0-.4-.3-.7-.7-.7zm-4.2 16.4c-.3-.3-.7-.3-1 0-.7.7-1.6 1.3-2.7 1.7-.2.1-.6.2-.9.2-2.9.6-5.7-.6-7.2-2.4-.6-.7-.2-1.1.3-1.1h3.2c.4 0 .7-.3.7-.7v-1.4c0-.4-.3-.7-.7-.7H1.5c-.3 0-.6.3-.6.6v8.9c0 .4.3.7.7.7H3c.4 0 .7-.3.7-.7v-3.2c0-.5.5-.7.7-.4 2.2 2.4 5.3 3.6 8.7 3.3 1.2-.1 2.3-.5 3.4-1 1-.5 1.9-1.2 2.6-1.9.3-.3.3-.7 0-1l-.9-.9z"
      }
    },
    rows: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M21.5 6.5h-19c-.3 0-.7-.4-.7-.7V4.4c0-.4.4-.7.7-.7h19c.3 0 .7.3.7.7v1.4c0 .3-.4.7-.7.7zm0 6.8h-19c-.3 0-.7-.3-.7-.7v-1.3c0-.4.4-.7.7-.7h19c.3 0 .7.3.7.7v1.4c0 .3-.4.6-.7.6zm0 7h-19c-.3 0-.7-.3-.7-.7v-1.4c0-.3.4-.7.7-.7h19c.3 0 .7.4.7.7v1.4c0 .4-.4.7-.7.7z"
      }
    },
    rules: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M23.1 11.7L19.4 8c-.2-.2-.5-.2-.7 0l-.7.7c-.2.2-.2.5 0 .7l1.2 1.1c.1.2 0 .6-.3.6H8.7L14.8 5c.2-.2.6 0 .6.3v1.6c0 .3.2.5.4.5h1c.3 0 .5-.2.5-.5V1.6c0-.3-.2-.5-.5-.5h-5.3c-.2 0-.4.2-.4.5v.9c0 .3.2.5.4.5h1.7c.3 0 .4.3.2.6L6 11H1.4c-.3 0-.5.3-.5.5v1c0 .3.3.5.5.5H6l7.5 7.4c.2.2 0 .6-.3.6h-1.6c-.3 0-.5.2-.5.5v.9c0 .2.2.4.5.5h5.2c.3 0 .5-.2.5-.5v-5.3c0-.3-.2-.4-.5-.4h-.9c-.3 0-.5.1-.5.4v1.7c0 .3-.3.4-.5.2l-6.1-6H19c.2 0 .4.4.2.6L18 14.7c-.2.2-.2.5 0 .7l.7.7c.2.2.5.2.7 0l3.7-3.7c.2-.2.2-.5 0-.7z"
      }
    },
    salesforce1: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M10 5.5c.8-.8 1.9-1.3 3.1-1.3 1.5 0 2.9.9 3.7 2.2.6-.3 1.3-.5 2-.5 2.9 0 5.2 2.3 5.2 5.2s-2.3 5.1-5.2 5.1h-1c-.6 1.1-1.9 1.9-3.3 1.9-.6 0-1.2-.1-1.7-.4-.6 1.5-2.1 2.6-3.9 2.6-1.9 0-3.5-1.1-4.1-2.8-.3 0-.6.1-.8.1-2.2 0-4-1.8-4-4 0-1.5.7-2.8 1.9-3.5-.2-.5-.3-1.2-.3-1.8 0-2.6 2-4.7 4.6-4.7 1.6.1 3 .8 3.8 1.9"
      }
    },
    save: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.1 1.8v6.3c0 .5-.3.9-.9.9H6.4c-.4 0-.9-.4-.9-.9V1.8H3.7c-1 0-1.9.9-1.9 1.9v16.6c0 1 .9 1.9 1.9 1.9h16.6c1 0 1.9-.9 1.9-1.9V5.2l-3.4-3.4h-1.7zm3.3 17.6c0 .5-.4.9-.9.9H4.6c-.5 0-.9-.4-.9-.9v-7.7c0-.4.4-.9.9-.9h14.9c.4 0 .9.4.9.9v7.7zm-9-13.1c0 .4.4.9.9.9h2.1c.5 0 .9-.4.9-.9V1.8h-3.8l-.1 4.5z"
      }
    },
    search: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M22.9 20.9l-6.2-6.1c1.3-1.8 1.9-4 1.6-6.4-.6-3.9-3.8-7.1-7.8-7.4C5 .4.4 5 1 10.5c.3 4 3.5 7.3 7.4 7.8 2.4.3 4.6-.3 6.4-1.5l6.1 6.1c.3.3.7.3 1 0l.9-1c.3-.3.3-.7.1-1zM3.7 9.6c0-3.2 2.7-5.9 5.9-5.9 3.3 0 6 2.7 6 5.9 0 3.3-2.7 6-6 6-3.2 0-5.9-2.6-5.9-6z"
      }
    },
    settings: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12 8.8c-1.8 0-3.2 1.4-3.2 3.2s1.4 3.3 3.2 3.3 3.3-1.5 3.3-3.3-1.5-3.2-3.3-3.2zm9.7 6.2L20 13.5c.1-.5.2-1 .2-1.5s-.1-1.1-.2-1.6L21.7 9c.6-.5.8-1.3.4-2l-.7-1.3c-.3-.4-.8-.7-1.4-.7-.2 0-.3 0-.5.1l-2.1.8c-.8-.8-1.8-1.3-2.7-1.6l-.4-2.2c-.1-.7-.8-1.1-1.5-1.1h-1.5c-.7 0-1.4.4-1.5 1.1l-.4 2.1c-1 .4-1.9.9-2.8 1.6L4.5 5c-.2 0-.3-.1-.5-.1-.5 0-1 .3-1.3.8L1.9 7c-.3.6-.2 1.4.4 1.9L4 10.3c-.1.5-.1 1.1-.1 1.6 0 .6 0 1.1.1 1.6l-1.7 1.4c-.5.5-.7 1.3-.4 1.9l.8 1.3c.3.5.8.8 1.3.8.2 0 .4-.1.5-.1l2.1-.8c.9.7 1.8 1.2 2.8 1.6l.3 2.2c.2.7.8 1.2 1.6 1.2h1.4c.8 0 1.4-.5 1.6-1.3l.3-2.2c1.1-.3 2.1-.9 2.9-1.7l2 .8c.2 0 .3.1.5.1.6 0 1.1-.3 1.4-.7l.7-1.2c.4-.6.2-1.4-.4-1.8zM12 17.1c-2.8 0-5-2.2-5-5.1s2.2-5 5-5 5.1 2.2 5.1 5-2.2 5.1-5.1 5.1z"
      }
    },
    setup: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M21.6 15l-1.7-1.5c.1-.5.1-1 .1-1.5s0-1.1-.1-1.6L21.6 9c.6-.5.7-1.3.4-2l-.8-1.3c-.2-.5-.8-.8-1.3-.8-.2 0-.4.1-.5.1l-2.1.8c-.8-.7-1.7-1.2-2.7-1.6l-.3-2.1c-.2-.8-.8-1.2-1.6-1.2h-1.4c-.8 0-1.4.4-1.6 1.2l-.3 2.1c-1 .3-1.9.9-2.8 1.6l-2-.8c-.2-.1-.3-.1-.5-.1-.5 0-1.1.3-1.3.7L2 6.9c-.3.7-.2 1.5.4 2l1.7 1.4c-.1.5-.1 1.1-.1 1.6s0 1 .1 1.5l-1.7 1.5c-.6.4-.7 1.3-.4 1.9l.8 1.4c.2.4.8.7 1.3.7.2 0 .4 0 .5-.1l2.1-.8c.8.8 1.7 1.3 2.7 1.6l.3 2.2c.2.8.8 1.3 1.6 1.3h1.4c.8 0 1.4-.6 1.6-1.3l.3-2.2c1.1-.4 2-1 2.8-1.7l2 .7c.2.1.4.1.5.1.6 0 1.1-.2 1.4-.7l.7-1.2c.3-.6.2-1.4-.4-1.8zM12 17.1c-2.7 0-5-2.2-5-5.1s2.2-5 5-5 5.1 2.2 5.1 5-2.3 5.1-5.1 5.1zm1.4-8.8h-2.1c-.4 0-.6.2-.7.5l-1.3 3.3c-.1.2.1.5.3.5h2.2l-.8 2.8c-.1.2.3.4.4.2l3.3-3.8c.3-.3.1-.6-.3-.6h-1.6l1.5-2.3c.1-.2-.1-.5-.4-.5h-.5z"
      }
    },
    setup_assistant_guide: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M5.3 11.5c0-.2-.2-.3-.4-.2l-2 1.7c-.1.1-.1.2-.1.4v7.3c0 .5.6.7 1 .4l3.4-2.6c.1-.1.1-.2 0-.4-.8-1.2-1.6-3.3-1.9-6.6zm4.5 6.9c.1 0 .2.1.3.1h3.8c.1 0 .2-.1.3-.1.5-.4 2.7-2.2 2.7-8.5 0-2.9-.8-5-1.8-6.3C13.7 1.5 12 .9 12 .9s-1.8.6-3.2 2.7C7.8 5 7.1 7 7.1 9.9c0 6.3 2.1 8.1 2.7 8.5zM12 6c1.5 0 2.7 1.2 2.7 2.8s-1.2 2.7-2.7 2.7-2.8-1.2-2.8-2.7S10.4 6 12 6zm9.1 7l-2-1.7c-.2-.1-.4 0-.4.2-.3 3.3-1.1 5.4-1.9 6.7v.3l3.4 2.6c.4.4 1 .1 1-.3v-7.4c0-.2 0-.3-.1-.4zm-6.2 7.5c-.1-.1-.3-.2-.4-.2H9.4c-.1 0-.3.1-.4.2-.1.3-.4.8-.6 1.5-.1.5.3 1.1.9 1.1h5.3c.6 0 1-.6.9-1.1-.2-.7-.5-1.2-.6-1.5z"
      }
    },
    share: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.4 13.8H21c-.4 0-.7.4-.7.7v5.1c0 .4-.3.7-.7.7H4.4c-.4 0-.7-.3-.7-.7V9.9c0-.3.3-.7.7-.7h1.8c.4 0 .7-.3.7-.7V7.2c0-.4-.3-.7-.7-.7H2.8c-1 0-1.9.8-1.9 1.8v12.9c0 1 .9 1.9 1.9 1.9h18.4c1 0 1.9-.9 1.9-1.9v-6.7c0-.3-.3-.7-.7-.7zm-6.7-7.3c-4.6 0-8.8 4.1-9.2 8.9 0 .4.3.8.7.8h1.4c.4 0 .6-.3.7-.6.3-3.5 3.3-6.4 6.9-6.4h.7c.4 0 .6.5.3.8l-2.5 2.6c-.3.3-.3.7 0 1l.9.9c.3.3.7.3 1 0l6.3-6.2c.3-.3.3-.7 0-1l-6.2-6.2c-.3-.3-.7-.3-1 0l-1 1c-.3.3-.3.7 0 .9l2.6 2.6c.2.3.1.8-.4.8l-1.2.1z"
      }
    },
    share_file: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.9 7.3h3.6c.2 0 .3-.2.2-.4l-3.8-3.8c-.2-.1-.4 0-.4.2v3.6c0 .3.1.4.4.4zm3.7 1.9h-5.1c-.5 0-.9-.4-.9-.9V3.2c0-.3-.2-.5-.4-.5H9.9c-.3 0-.7.3-.7.7v1.9c0 .1.1.3.2.5L12 8.4c.4.3.6.8.7 1.4.1.7-.1 1.4-.6 2l-.7.7c-.3.2-.5.3-.8.5.3.1.7.2 1.1.2 1.2.1 2.1 1.2 2.1 2.4v1c0 .7-.3 1.3-.7 1.7-.5.5-1.2.7-1.8.6-.5 0-1-.1-1.5-.2-.3-.1-.6.1-.6.5v1.4c0 .4.4.7.7.7h12.5c.4 0 .7-.3.7-.7V9.7c0-.3-.2-.5-.5-.5zM12 16.5v-1c0-.3-.2-.5-.5-.5-2.5-.2-4.6-2.4-4.6-5v-.5c0-.3.4-.5.6-.3l1.8 1.9c.2.2.5.2.7 0l.7-.7c.2-.2.2-.5 0-.7L6.2 5.2c-.2-.2-.5-.2-.7 0L1.1 9.7c-.2.2-.2.5 0 .7l.7.7c.1.2.5.2.6 0l2-1.8c.2-.3.6-.1.6.2v.9c0 3.3 2.9 6.4 6.4 6.6.4 0 .6-.2.6-.5z"
      }
    },
    share_mobile: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M19.4 23.3c1 0 1.8-.9 1.8-1.9V9c0-1-.8-1.8-1.8-1.8h-3.5c-.4 0-.7.3-.7.7v1.3c0 .4.3.7.7.7h1.8c.4 0 .7.4.7.7v9.2c0 .4-.3.7-.7.7H6.2c-.4 0-.7-.3-.7-.7v-9.2c0-.3.3-.7.7-.7h1.9c.3 0 .7-.3.7-.7V7.9c0-.4-.4-.7-.7-.7H4.6c-1 0-1.8.8-1.8 1.8v12.4c0 1 .8 1.9 1.8 1.9h14.8zm-6-9v-9h2.7c.4 0 .7-.4.4-.6L12.3.8c-.1-.1-.4-.1-.6 0L7.5 4.7c-.2.2 0 .6.5.6h2.6v9c0 .3.3.7.7.7h1.4c.3 0 .7-.4.7-.7z"
      }
    },
    share_post: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12 1.8C5.9 1.8.9 6.4.9 12c0 1.8.5 3.5 1.4 5 .1.2.1.4.1.6l-1 3.2c-.2.6.4 1.1 1 .9l3.2-1.1c.2-.1.4-.1.6.1 1.7.9 3.7 1.5 5.8 1.5 6.2 0 11.1-4.5 11.1-10.2C23 6.4 18 1.8 12 1.8z"
      }
    },
    shield: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M2.2 6.5h19.6c.4 0 .8-.5.7-1-.5-1.5-1.1-2.9-2-4.1-.3-.4-.8-.4-1.1-.1-.8.8-2.1 1.3-3.4 1.3-1.4 0-2.6-.6-3.5-1.5-.3-.3-.8-.3-1.1 0-.9.9-2.1 1.5-3.5 1.5-1.3 0-2.5-.5-3.4-1.3-.3-.3-.9-.2-1.1.1-.9 1.2-1.6 2.6-2 4.1 0 .5.4 1 .8 1zm20.9 2.9c0-.4-.3-.6-.8-.6H1.7c-.5 0-.8.2-.8.6v.2c0 6.9 4.8 12.6 11.1 13.5 6.3-.9 11.1-6.6 11.1-13.5v-.2z"
      }
    },
    shopping_bag: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M29.9 8.8V9v-.2z"
      }, {
        "d": "M20.3 9c0-1-.8-1.8-1.8-1.8h-.4c-.2-3.1-2.8-5.6-6.1-5.6S6.2 4.1 6 7.2h-.5c-1 0-1.8.8-1.8 1.8l-.9 11.6c0 1 .8 1.8 1.8 1.8h14.8c1 0 1.8-.8 1.8-1.8L20.3 9zM12 4.3c1.8 0 3.1 1.3 3.4 2.9H8.7C9 5.6 10.4 4.3 12 4.3zm2.7 8.4H9.3c-.8 0-1.4-.6-1.4-1.3S8.6 10 9.3 10h5.4c.8 0 1.4.6 1.4 1.4s-.6 1.3-1.4 1.3z"
      }]
    },
    side_list: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.4 1.8H9.9c-.3 0-.7.4-.7.7v19c0 .3.4.7.7.7h12.5c.4 0 .7-.4.7-.7v-19c0-.3-.3-.7-.7-.7zm-15.7 0H1.6c-.4 0-.7.4-.7.7v2.3c0 .4.3.7.7.7h5.1c.4 0 .7-.3.7-.7V2.5c0-.3-.3-.7-.7-.7zm0 5.6H1.6c-.4 0-.7.3-.7.7v2.3c0 .4.3.7.7.7h5.1c.4 0 .7-.3.7-.7V8.1c0-.4-.3-.7-.7-.7zm0 5.5H1.6c-.4 0-.7.3-.7.7v2.3c0 .4.3.7.7.7h5.1c.4 0 .7-.3.7-.7v-2.3c0-.4-.3-.7-.7-.7zm0 5.6H1.6c-.4 0-.7.3-.7.7v2.3c0 .3.3.7.7.7h5.1c.4 0 .7-.4.7-.7v-2.3c0-.4-.3-.7-.7-.7z"
      }
    },
    signpost: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.8 4.2l-1.9-1.5c-.3-.2-.5-.3-.9-.3h-6.5v-.7c0-.5-.3-.8-.8-.8h-1.4c-.5 0-.8.3-.8.8v.7H3.1c-.4 0-.7.3-.7.7v3c0 .4.3.7.7.7H20c.4 0 .7-.1.9-.2l1.9-1.5c.4-.3.4-.7 0-.9zm-1.9 6.3h-7.4V9.4c0-.2-.2-.4-.4-.4h-2.2c-.2 0-.4.2-.4.4v1.1H4c-.4 0-.7.1-.9.3l-1.9 1.4c-.4.3-.4.7 0 1l1.9 1.4c.3.2.5.3.9.3h16.9c.4 0 .7-.3.7-.7v-3c0-.4-.3-.7-.7-.7zM13.5 20v-2.5c0-.2-.2-.3-.4-.3h-2.2c-.2 0-.4.1-.4.3V20c-1.5.4-2.3 1.3-2.5 2.4-.1.3.2.7.5.7h7c.4 0 .7-.3.6-.7-.3-1.1-1.1-2-2.6-2.4z"
      }
    },
    smiley_and_people: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M23.1 12c0 6.2-5 11.2-11.1 11.2S.9 18.2.9 12 5.9.9 12 .9s11.1 5 11.1 11.1zM7.8 6.9c-.7 0-1.3.8-1.3 1.9s.6 1.8 1.3 1.8 1.4-.8 1.4-1.8-.6-1.9-1.4-1.9zm8.4 0c-.8 0-1.4.8-1.4 1.9s.6 1.8 1.4 1.8 1.3-.8 1.3-1.8-.6-1.9-1.3-1.9zM5.1 13.4c.3 3.5 2.8 6.4 6.9 6.4 4 0 6.6-2.9 6.9-6.4H5.1z"
      }
    },
    sms: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12 1.8C5.9 1.8 1 6.4 1 12c0 1.7.5 3.4 1.3 4.8.1.3.2.6.1.8l-1.4 4c-.2.3.2.6.6.6l3.9-1.6c.3-.1.5 0 .8.1 1.7.9 3.7 1.5 5.8 1.5 6 0 11-4.6 11-10.2C23 6.4 18.1 1.8 12 1.8zM7.6 13.7c-.2.2-.3.4-.5.6s-.4.2-.7.3c-.2.1-.5.1-.8.1-.3 0-.7 0-1-.2-.3-.1-.6-.3-.9-.6l-.1-.1s0-.1.1-.2l.8-.7c.1-.1.2-.1.2 0s.1.1.1.1c.1.2.2.2.4.3.2.2.4.2.7.1.1 0 .1 0 .2-.1l.2-.1V13c0-.2 0-.2-.1-.3-.1-.1-.2-.1-.4-.2s-.4-.1-.6-.2l-.6-.3c-.3-.1-.4-.3-.5-.5-.2-.2-.3-.5-.3-.8 0-.4.1-.6.2-.9.2-.2.3-.4.5-.5.2-.2.4-.3.7-.3.6-.2 1.1-.2 1.7 0 .3.1.5.3.7.4l.1.1c.1 0 .1.1 0 .2l-.7.7c-.1.1-.3.1-.4 0l-.1-.1c-.3-.1-.6-.2-.9-.1h-.2l-.1.2v.2c0 .1 0 .2.1.2 0 .1.2.1.4.2s.3.2.6.2l.6.3c.2.1.4.3.5.5.2.2.3.5.3.9 0 .3-.1.5-.2.8zm7.6.6c0 .3-.2.5-.5.5h-.4c-.3 0-.5-.2-.5-.5v-2.7c0-.3-.3-.3-.4-.1l-.8 2.1c0 .2-.2.2-.4.2h-.3c-.2 0-.4-.1-.5-.2l-.8-2.1c-.1-.2-.4-.2-.4.1v2.7c0 .3-.3.5-.6.5h-.4c-.3 0-.4-.2-.4-.5V9.2c0-.2.2-.4.4-.4h1.2c.2 0 .4.1.4.2l.9 2.4c.1.2.4.2.4 0l1-2.4c0-.1.2-.2.4-.2h1.2c.3 0 .5.2.5.4v5.1zm4.9-.6c-.2.2-.3.5-.5.6-.2.1-.4.3-.7.4s-.5.1-.8.1c-.4 0-.7-.1-1-.2-.3-.2-.7-.3-.9-.6l-.1-.1c0-.1 0-.1.1-.2l.7-.7c.1-.1.2-.1.3-.1s.1.2.1.2l.3.3c.3.1.5.1.8.1.1-.1.2-.1.2-.1l.1-.2.1-.1c0-.2-.1-.3-.1-.3-.1-.1-.2-.2-.4-.2s-.4-.2-.6-.2c-.3-.1-.5-.2-.7-.3-.2-.1-.4-.3-.5-.5-.2-.2-.3-.5-.3-.9 0-.3.1-.6.2-.8.2-.3.3-.4.5-.6.2-.1.5-.3.7-.3.6-.1 1.1-.1 1.7 0 .3.1.5.3.7.5l.1.1c.1 0 .1.2 0 .3l-.7.7c-.1.1-.2.1-.3 0l-.2-.2c-.3-.1-.6-.2-.9-.1 0 0-.1 0-.1.1l-.2.1v.2c0 .1 0 .2.1.2.1.1.2.2.4.3.2 0 .4.1.6.2.2 0 .4.1.6.2.3.2.4.4.6.5.1.3.2.5.2.9.1.2 0 .5-.1.7z"
      }
    },
    snippet: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M6.7 2.8H1.6c-.4 0-.7.3-.7.7v6c0 .3.3.7.7.7h5.1c.4 0 .7-.4.7-.7v-6c0-.4-.3-.7-.7-.7zm15.7 0H9.9c-.3 0-.7.3-.7.7v1.3c0 .4.4.7.7.7h12.5c.4 0 .7-.3.7-.7V3.5c0-.4-.3-.7-.7-.7zM9.9 10.2h7.9c.3 0 .7-.4.7-.7V8.1c0-.4-.4-.7-.7-.7H9.9c-.3 0-.7.3-.7.7v1.4c0 .3.4.7.7.7zm-3.2 3.6H1.6c-.4 0-.7.4-.7.7v6c0 .4.3.7.7.7h5.1c.4 0 .7-.3.7-.7v-6c0-.3-.3-.7-.7-.7zm15.7 0H9.9c-.3 0-.7.4-.7.7v1.4c0 .4.4.7.7.7h12.5c.4 0 .7-.3.7-.7v-1.4c0-.3-.3-.7-.7-.7zm-4.6 4.7H9.9c-.3 0-.7.3-.7.7v1.3c0 .4.4.7.7.7h7.9c.3 0 .7-.3.7-.7v-1.3c0-.4-.4-.7-.7-.7z"
      }
    },
    socialshare: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.9 14.8c-1.2 0-2.3.5-3 1.3l-6.8-3.4c.1-.2.1-.5.1-.7 0-.3-.1-.6-.1-.8l6.8-3.4c.7.9 1.8 1.4 3 1.4 2.3 0 4.2-1.9 4.2-4.2S21.2.9 18.9.9 14.8 2.7 14.8 5v.3l-7 3.5c-.8-.6-1.7-1-2.8-1C2.7 7.8.9 9.7.9 12s1.8 4.2 4.1 4.2c1.1 0 2-.4 2.8-1.1l6.9 3.5v.3c0 2.3 1.9 4.2 4.2 4.2s4.1-1.9 4.1-4.2-1.8-4.1-4.1-4.1z"
      }
    },
    sort: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12.7 7.4c.3-.3.3-.7 0-1L7.4 1.1c-.2-.3-.7-.3-.9 0L1.2 6.4c-.3.3-.3.7 0 1l.9 1c.3.2.7.2 1 0l1.7-1.7c.2-.3.7-.1.7.3v9.8c0 .4.4.7.7.7h1.4c.4 0 .7-.4.7-.7V7c0-.4.5-.6.8-.3l1.7 1.7c.2.2.6.2.9 0l1-1zm10.1 9.2l-.9-.9c-.3-.3-.7-.3-1 0l-1.7 1.7c-.2.2-.7 0-.7-.4V7.2c0-.4-.4-.7-.7-.7h-1.4c-.4 0-.7.3-.7.7v9.7c0 .5-.5.6-.8.4l-1.7-1.7c-.2-.3-.6-.3-.9 0l-1 1c-.3.3-.3.7 0 1l5.3 5.3c.3.3.7.3 1 0l5.3-5.3c.2-.3.2-.8-.1-1z"
      }
    },
    spinner: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M7.4 12.7v-1.4c0-.4-.3-.7-.7-.7H1.6c-.4 0-.7.3-.7.7v1.4c0 .4.3.7.7.7h5.1c.4 0 .7-.3.7-.7zm.9 2.1c-.3-.3-.7-.3-1 0l-3.6 3.6c-.3.2-.3.7 0 .9l1 1c.2.3.7.3.9 0l3.6-3.6c.3-.3.3-.7 0-1l-.9-.9zm7.4-5.6c.3.3.7.3 1 0l3.6-3.6c.3-.2.3-.7 0-.9l-1-1c-.2-.3-.7-.3-.9 0l-3.6 3.5c-.3.3-.3.7 0 1l.9 1zM5.6 3.7c-.2-.3-.7-.3-.9 0l-1 1c-.3.2-.3.7 0 .9l3.6 3.6c.3.3.7.3 1 0l.9-.9c.3-.3.3-.7 0-1L5.6 3.7zm11.2 11.1c-.3-.3-.7-.3-1 0l-1 .9c-.3.3-.3.7 0 1l3.6 3.6c.2.3.7.3.9 0l1-1c.3-.2.3-.7 0-.9l-3.5-3.6zm-4.1 1.8h-1.4c-.4 0-.7.3-.7.7v5.1c0 .4.3.7.7.7h1.4c.4 0 .7-.3.7-.7v-5.1c0-.4-.3-.7-.7-.7zm9.7-6h-5.1c-.4 0-.7.3-.7.7v1.4c0 .4.3.7.7.7h5.1c.4 0 .7-.3.7-.7v-1.4c0-.4-.3-.7-.7-.7zM12.7.9h-1.4c-.4 0-.7.3-.7.7v5.1c0 .4.3.7.7.7h1.4c.4 0 .7-.3.7-.7V1.6c0-.4-.3-.7-.7-.7z"
      }
    },
    standard_objects: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M21.3 18l-8.7 4.9c-.4.3-1 .3-1.5 0L2.5 18c-.4-.2-.4-.7 0-.9l2-1.1c.2-.1.3-.1.5 0l5.2 3c.6.2 1.1.4 1.7.4s1.2-.2 1.7-.4l5.2-3c.2-.1.4-.1.5 0l2 1.1c.4.2.4.7 0 .9zm0-5.6l-8.7 5c-.4.2-1 .2-1.5 0l-8.6-5c-.4-.2-.4-.6 0-.8l2-1.2c.2-.1.3-.1.5 0l5.2 3c.6.3 1.1.4 1.7.4s1.2-.1 1.7-.4l5.2-3c.2-.1.4-.1.5 0l2 1.2c.4.2.4.6 0 .8zm-10.1-.6L2.5 6.9c-.3-.2-.3-.7 0-.9l8.7-4.9c.5-.3 1.1-.3 1.5 0L21.4 6c.4.2.4.7 0 .9l-8.7 4.9c-.4.2-1 .2-1.5 0z"
      }
    },
    stop: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M3.7 3.7h16.6v16.6H3.7V3.7z"
      }
    },
    strikethrough: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M5.6 8.4c-.1-.5-.2-1.1-.2-1.6 0-.6.2-1.3.5-2 .2-.6.7-1.3 1.3-1.8.5-.6 1.3-1.1 2.2-1.5.9-.3 2-.6 3.2-.6 1.2 0 2.3.2 3.4.5.8.3 1.6.7 2.3 1.4.3.2.3.7-.1 1L17 4.9c-.3.3-.7.3-1 0-.3-.3-.7-.6-1.1-.8-.6-.3-1.4-.5-2.3-.5-.7 0-1.4.1-1.9.3s-1 .5-1.3.9-.6.6-.7 1-.2.8-.2 1c0 .5.1 1 .2 1.3.2.3-.1.7-.4.7H6c-.2 0-.4-.3-.4-.4zm12.8 6.8h-2.3c-.3 0-.5.4-.4.6.1.3.2.7.2 1 0 .6-.2 1.1-.4 1.6-.3.4-.6.8-1 1.1-.4.3-.9.5-1.4.6-.5.2-1 .3-1.5.3-.8 0-1.7-.2-2.5-.6-.6-.3-1.1-.6-1.5-1.2-.3-.2-.7-.3-1 0l-1.3 1.1c-.3.2-.3.7 0 .9.6.8 1.4 1.3 2.4 1.7 1.2.5 2.5.7 3.9.7 1 0 2-.2 2.8-.5.9-.3 1.7-.7 2.4-1.3.6-.5 1.2-1.2 1.6-2 .3-.9.6-1.8.6-2.8 0-.3 0-.6-.1-.9-.1-.1-.3-.3-.5-.3zM23 11c-.1-.2-.3-.4-.6-.4H1.6c-.3 0-.5.2-.6.4-.1.1-.1.2-.1.3v1.3c0 .4.3.8.7.8h20.8c.4 0 .7-.4.7-.8v-1.3c0-.1 0-.2-.1-.3z"
      }
    },
    success: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12 .9C5.9.9.9 5.9.9 12s5 11.1 11.1 11.1 11.1-5 11.1-11.1S18.1.9 12 .9zm6.2 8.3l-7.1 7.2c-.3.3-.7.3-1 0l-3.9-3.9c-.2-.3-.2-.8 0-1.1l1-1c.3-.2.8-.2 1.1 0l2 2.1c.2.2.5.2.7 0l5.2-5.3c.2-.3.7-.3 1 0l1 1c.3.2.3.7 0 1z"
      }
    },
    summary: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.4.9H1.6c-.4 0-.7.3-.7.7v2.3c0 .4.3.7.7.7h20.8c.4 0 .7-.3.7-.7V1.6c0-.4-.3-.7-.7-.7zm0 5.6H6.2c-.3 0-.7.3-.7.7v1.3c0 .4.4.7.7.7h16.2c.4 0 .7-.3.7-.7V7.2c0-.4-.3-.7-.7-.7zm0 9.2H6.2c-.3 0-.7.3-.7.7v1.4c0 .3.4.7.7.7h16.2c.4 0 .7-.4.7-.7v-1.4c0-.4-.3-.7-.7-.7zm0 4.6h-18c-.4 0-.7-.3-.7-.7v-3.2c0-.4-.3-.7-.7-.7H1.6c-.4 0-.7.3-.7.7v6c0 .4.3.7.7.7h20.8c.4 0 .7-.3.7-.7V21c0-.4-.3-.7-.7-.7zm0-9.2h-18c-.4 0-.7-.3-.7-.7V7.2c0-.4-.3-.7-.7-.7H1.6c-.4 0-.7.3-.7.7v6c0 .3.3.6.7.6h20.8c.4 0 .7-.3.7-.6v-1.4c0-.4-.3-.7-.7-.7z"
      }
    },
    summarydetail: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.4.9H1.6c-.4 0-.7.3-.7.7v2.3c0 .4.3.7.7.7h20.8c.4 0 .7-.3.7-.7V1.6c0-.4-.3-.7-.7-.7zM9.5 6.5H6.2c-.3 0-.7.3-.7.7v1.3c0 .4.4.7.7.7h3.3c.3 0 .7-.3.7-.7V7.2c0-.4-.4-.7-.7-.7zm6.4 0h-3.2c-.4 0-.7.3-.7.7v1.3c0 .4.3.7.7.7h3.2c.4 0 .7-.3.7-.7V7.2c0-.4-.3-.7-.7-.7zm6.5 0h-3.2c-.4 0-.7.3-.7.7v1.3c0 .4.3.7.7.7h3.2c.4 0 .7-.3.7-.7V7.2c0-.4-.3-.7-.7-.7zM9.5 15.7H6.2c-.3 0-.7.3-.7.7v1.4c0 .3.4.7.7.7h3.3c.3 0 .7-.4.7-.7v-1.4c0-.4-.4-.7-.7-.7zm6.4 0h-3.2c-.4 0-.7.3-.7.7v1.4c0 .3.3.7.7.7h3.2c.4 0 .7-.4.7-.7v-1.4c0-.4-.3-.7-.7-.7zm6.5 0h-3.2c-.4 0-.7.3-.7.7v1.4c0 .3.3.7.7.7h3.2c.4 0 .7-.4.7-.7v-1.4c0-.4-.3-.7-.7-.7zm0 4.6h-18c-.4 0-.7-.3-.7-.7v-3.2c0-.4-.3-.7-.7-.7H1.6c-.4 0-.7.3-.7.7v6c0 .4.3.7.7.7h20.8c.4 0 .7-.3.7-.7V21c0-.4-.3-.7-.7-.7zm0-9.2h-18c-.4 0-.7-.3-.7-.7V7.2c0-.4-.3-.7-.7-.7H1.6c-.4 0-.7.3-.7.7v6c0 .3.3.6.7.6h20.8c.4 0 .7-.3.7-.6v-1.4c0-.4-.3-.7-.7-.7z"
      }
    },
    switch: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22 8.2l-9.5 9.6c-.3.2-.7.2-1 0L2 8.2c-.2-.3-.2-.7 0-1l1-1c.3-.3.8-.3 1.1 0l7.4 7.5c.3.3.7.3 1 0l7.4-7.5c.3-.3.8-.3 1.1 0l1 1c.2.3.2.7 0 1z"
      }
    },
    symbols: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M15.5 12.9l.4-1.8h1.4l-.5 1.8h-1.3zm-.4 1.4h1.4l-.3 1.4h1.3l.4-1.4h1.5v-1.4h-1.2l.5-1.8h1.4V9.7H19l.4-1.4H18l-.3 1.4h-1.4l.3-1.4h-1.4l-.3 1.4h-1.5v1.4h1.1l-.4 1.8h-1.6v1.4h1.2l-.3 1.4h1.4l.3-1.4zM1.8 2.8h20.4c.5 0 .9.4.9.9v16.6c0 .5-.4.9-.9.9H1.8c-.5 0-.9-.4-.9-.9V3.7c0-.5.4-.9.9-.9zm9.2 9.6c.3-.2.5-.4.7-.6.2-.1.3-.3.4-.6.2-.2.2-.5.2-.8 0-.5-.1-.8-.3-1.2-.2-.3-.5-.5-.9-.7-.3-.2-.8-.3-1.3-.3s-1 .1-1.4.3c-.5.2-.8.6-1.2 1v.1l.9.8.1-.1c.2-.3.5-.5.7-.6.2-.1.5-.2.8-.2.4 0 .6.1.8.3.2.1.2.3.2.6 0 .2 0 .4-.2.6-.1.1-.3.3-.6.5-.4.3-.6.5-.8.7-.2.2-.3.5-.3.9v.3h1.4v-.1c0-.2.1-.3.2-.4.1-.2.3-.3.6-.5zM4.6 8.3v5.1H6V8.3H4.6zm.7 7.6c.5 0 .9-.4.9-.9s-.4-.9-.9-.9-.9.4-.9.9.4.9.9.9zm4.2 0c.5 0 .9-.4.9-.9s-.4-.9-.9-.9-1 .4-1 .9.5.9 1 .9z"
      }
    },
    sync: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.1 13.5c0-.3-.3-.7-.7-.7h-1.6c-.4 0-.6.3-.6.7 0 .1 0 .2-.1.3-.1.6-.4 1.2-.7 1.7-1.3 2.3-3.5 3.5-5.9 3.5-1.9 0-3.6-.7-4.9-2-.3-.2-.4-.4-.6-.7-.1-.3.2-.5.6-.5h3.2c.4 0 .7-.3.7-.7v-1.4c0-.4-.2-.7-.6-.7H2.4c-.3 0-.6.3-.6.6V22c.1.4.4.7.8.7H4c.3 0 .7-.3.7-.7v-3.2c0-.4.2-.6.5-.3.2.1.3.3.5.4 2.3 2.3 5.5 3.3 8.8 2.7 1.2-.3 2.3-.7 3.3-1.4 2.4-1.6 3.9-4 4.3-6.6v-.1zm-20.2-3c0 .3.3.7.7.7h1.6c.4 0 .6-.3.6-.7 0-.1 0-.2.1-.3.1-.6.4-1.2.7-1.7C6.9 6.2 9.1 5 11.5 5c1.9 0 3.6.7 4.9 2 .3.2.4.4.6.7.1.3-.2.5-.6.5h-3.2c-.4 0-.7.3-.7.7v1.4c0 .4.2.7.6.7h8.5c.3 0 .6-.3.6-.6V2c-.1-.4-.4-.7-.8-.7H20c-.3 0-.7.3-.7.7v3.2c0 .4-.2.6-.5.3-.2-.1-.3-.3-.5-.4-2.3-2.3-5.5-3.3-8.8-2.7-1.2.3-2.3.7-3.3 1.4-2.4 1.6-3.9 4-4.3 6.6v.1z"
      }
    },
    table: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M21.5.9h-19c-.3 0-.7.3-.7.7v2.3c0 .4.4.7.7.7h19c.3 0 .7-.3.7-.7V1.6c0-.4-.4-.7-.7-.7zM6.7 6.5H2.5c-.3 0-.7.3-.7.7v1.3c0 .4.4.7.7.7h4.2c.4 0 .7-.3.7-.7V7.2c0-.4-.3-.7-.7-.7zm7.4 0H9.9c-.3 0-.7.3-.7.7v1.3c0 .4.4.7.7.7h4.2c.3 0 .7-.3.7-.7V7.2c0-.4-.4-.7-.7-.7zm7.4 0h-4.2c-.4 0-.7.3-.7.7v1.3c0 .4.3.7.7.7h4.2c.3 0 .7-.3.7-.7V7.2c0-.4-.4-.7-.7-.7zM6.7 11.1H2.5c-.3 0-.7.3-.7.7v1.4c0 .3.4.6.7.6h4.2c.4 0 .7-.3.7-.6v-1.4c0-.4-.3-.7-.7-.7zm7.4 0H9.9c-.3 0-.7.3-.7.7v1.4c0 .3.4.6.7.6h4.2c.3 0 .7-.3.7-.6v-1.4c0-.4-.4-.7-.7-.7zm7.4 0h-4.2c-.4 0-.7.3-.7.7v1.4c0 .3.3.6.7.6h4.2c.3 0 .7-.3.7-.6v-1.4c0-.4-.4-.7-.7-.7zM6.7 15.7H2.5c-.3 0-.7.3-.7.7v1.4c0 .3.4.7.7.7h4.2c.4 0 .7-.4.7-.7v-1.4c0-.4-.3-.7-.7-.7zm7.4 0H9.9c-.3 0-.7.3-.7.7v1.4c0 .3.4.7.7.7h4.2c.3 0 .7-.4.7-.7v-1.4c0-.4-.4-.7-.7-.7zm7.4 0h-4.2c-.4 0-.7.3-.7.7v1.4c0 .3.3.7.7.7h4.2c.3 0 .7-.4.7-.7v-1.4c0-.4-.4-.7-.7-.7zM6.7 20.3H2.5c-.3 0-.7.3-.7.7v1.4c0 .4.4.7.7.7h4.2c.4 0 .7-.3.7-.7V21c0-.4-.3-.7-.7-.7zm7.4 0H9.9c-.3 0-.7.3-.7.7v1.4c0 .4.4.7.7.7h4.2c.3 0 .7-.3.7-.7V21c0-.4-.4-.7-.7-.7zm7.4 0h-4.2c-.4 0-.7.3-.7.7v1.4c0 .4.3.7.7.7h4.2c.3 0 .7-.3.7-.7V21c0-.4-.4-.7-.7-.7z"
      }
    },
    tablet_landscape: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M23.1 4.6c0-1-.9-1.8-1.9-1.8H2.8c-1 0-1.9.8-1.9 1.8v14.8c0 1 .9 1.8 1.9 1.8h18.4c1 0 1.9-.8 1.9-1.8V4.6zM3.2 13.4c-.8 0-1.4-.6-1.4-1.4s.6-1.4 1.4-1.4 1.4.6 1.4 1.4-.7 1.4-1.4 1.4zm17.1 4.4c0 .3-.3.7-.7.7H6.2c-.3 0-.7-.4-.7-.7V6.2c0-.3.4-.7.7-.7h13.4c.4 0 .7.4.7.7v11.6z"
      }
    },
    tablet_portrait: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M21.2 2.8c0-1-.8-1.9-1.8-1.9H4.6c-1 0-1.8.9-1.8 1.9v18.4c0 1 .8 1.9 1.8 1.9h14.8c1 0 1.8-.9 1.8-1.9V2.8zM12 22.2c-.8 0-1.4-.6-1.4-1.4s.6-1.4 1.4-1.4 1.3.6 1.3 1.4-.6 1.4-1.3 1.4zm6.5-4.4c0 .3-.4.7-.7.7H6.2c-.3 0-.7-.4-.7-.7V4.4c0-.4.4-.7.7-.7h11.6c.3 0 .7.3.7.7v13.4z"
      }
    },
    tabset: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M14.6.9H9.4c-.3 0-.5.3-.5.6v1.2c0 .3.2.6.5.6h5.2c.3 0 .5-.3.5-.6V1.5c.1-.3-.2-.6-.5-.6zm7.9 0h-5.2c-.3 0-.6.3-.6.6v1.2c0 .3.3.6.6.6h5.2c.3-.1.6-.3.6-.6V1.5c0-.3-.3-.6-.6-.6zm0 3.9H7.8c-.3 0-.6-.3-.6-.6V1.5c0-.3-.2-.6-.6-.6H1.5c-.3 0-.6.3-.6.6v21c0 .3.3.6.6.6h21c.3 0 .6-.3.6-.6V5.4c0-.3-.3-.6-.6-.6z"
      }
    },
    task: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M11.1 3.2l-.8-.8c-.2-.2-.6-.2-.8 0L4.6 7.3l-2-1.9c-.2-.3-.5-.3-.8 0l-.7.7c-.3.3-.3.6 0 .8l2.7 2.7c.2.3.5.4.8.4.2 0 .5-.1.8-.4L11.1 4c.2-.2.2-.5 0-.8zm11.2 5.3h-9.6c-.4 0-.7-.3-.7-.7V6.3c0-.4.3-.8.7-.8h9.6c.5 0 .8.4.8.8v1.5c0 .4-.3.7-.8.7zm0 6.6H10.5c-.4 0-.8-.3-.8-.7v-1.5c0-.4.4-.8.8-.8h11.8c.5 0 .8.4.8.8v1.5c0 .4-.3.7-.8.7zM6 15.1H4.5c-.4 0-.7-.3-.7-.7v-1.5c0-.4.3-.8.7-.8H6c.4 0 .7.4.7.8v1.5c.1.4-.3.7-.7.7zm0 6.6H4.5c-.4 0-.7-.3-.7-.7v-1.5c0-.4.3-.8.7-.8H6c.4 0 .7.4.7.8V21c.1.4-.3.7-.7.7zm16.3 0H10.5c-.4 0-.8-.3-.8-.7v-1.5c0-.4.4-.8.8-.8h11.8c.5 0 .8.4.8.8V21c0 .4-.3.7-.8.7z"
      }
    },
    text_background_color: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12 7.4l1.9 4.6H9.8l1.8-4.6h.4zm10.2-3.7v16.6c0 1-.9 1.9-1.9 1.9H3.7c-1 0-1.9-.9-1.9-1.9V3.7c0-1 .9-1.9 1.9-1.9h16.6c1 0 1.9.9 1.9 1.9zm-2.6 15.1L14.1 5.1c-.2-.3-.4-.5-.7-.5h-3.3c-.3 0-.5.2-.6.5L4.4 18.8c-.1.3.1.6.4.6h1.9c.3 0 .5-.2.6-.5l1.5-4.1H15l1.6 4.1c.1.3.4.5.7.5h1.9c.3 0 .5-.3.4-.6z"
      }
    },
    text_color: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M4.8 16.6h1.9c.3 0 .5-.2.6-.5L8.8 12H15l1.6 4.1c.1.3.4.5.7.5h1.9c.3 0 .5-.3.4-.6L14 2.3c-.1-.3-.3-.5-.6-.5h-3.2c-.3 0-.6.2-.7.5L4.4 16c-.1.3.1.6.4.6zm6.8-12h.4l2 4.6H9.8l1.8-4.6zm10.8 14.8H1.6c-.4 0-.7.3-.7.7v1.4c0 .3.3.7.7.7h20.8c.4 0 .7-.4.7-.7v-1.4c0-.4-.3-.7-.7-.7z"
      }
    },
    threedots: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M3.7 9.2c1.5 0 2.8 1.3 2.8 2.8s-1.3 2.8-2.8 2.8S.9 13.5.9 12s1.3-2.8 2.8-2.8zm8.3 0c1.5 0 2.8 1.3 2.8 2.8s-1.3 2.8-2.8 2.8-2.8-1.3-2.8-2.8 1.3-2.8 2.8-2.8zm8.3 0c1.5 0 2.8 1.3 2.8 2.8s-1.3 2.8-2.8 2.8-2.8-1.3-2.8-2.8 1.3-2.8 2.8-2.8z"
      }
    },
    threedots_vertical: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M9.2 20.3c0-1.5 1.3-2.8 2.8-2.8s2.8 1.3 2.8 2.8-1.3 2.8-2.8 2.8-2.8-1.3-2.8-2.8zm0-8.3c0-1.5 1.3-2.8 2.8-2.8s2.8 1.3 2.8 2.8-1.3 2.8-2.8 2.8-2.8-1.3-2.8-2.8zm0-8.3C9.2 2.2 10.5.9 12 .9s2.8 1.3 2.8 2.8-1.3 2.8-2.8 2.8-2.8-1.3-2.8-2.8z"
      }
    },
    thunder: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M14 1.4c-.7-.6-1.7-.6-2.4 0L1.4 11.6c-.6.7-.6 1.7 0 2.4l5.4 5.4c.7.7 1.8.7 2.5 0L19.4 9.3c.7-.7.7-1.8 0-2.5L14 1.4zm-8.4.9c-.2-.2-.6-.2-.9 0L2.3 4.7c-.2.3-.2.7 0 .9l.9.9c.3.3.7.3.9 0l2.4-2.4c.3-.2.3-.6 0-.9l-.9-.9zm8.7 14.4c-.2.3-.2.7 0 .9l5.3 5.3c.2.2.6.2.9 0l2.4-2.4c.2-.3.2-.7 0-.9l-5.2-5.3c-.3-.2-.7-.2-1 0l-2.4 2.4z"
      }
    },
    tile_card_list: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M6.7 1.8H2.5c-.3 0-.7.4-.7.7v7.9c0 .4.4.7.7.7h4.2c.4 0 .7-.3.7-.7V2.5c0-.3-.3-.7-.7-.7zm7.4 0H9.9c-.3 0-.7.4-.7.7v7.9c0 .4.4.7.7.7h4.2c.3 0 .7-.3.7-.7V2.5c0-.3-.4-.7-.7-.7zm7.4 0h-4.2c-.4 0-.7.4-.7.7v7.9c0 .4.3.7.7.7h4.2c.3 0 .7-.3.7-.7V2.5c0-.3-.4-.7-.7-.7zM6.7 12.9H2.5c-.3 0-.7.3-.7.7v7.9c0 .3.4.7.7.7h4.2c.4 0 .7-.4.7-.7v-7.9c0-.4-.3-.7-.7-.7zm7.4 0H9.9c-.3 0-.7.3-.7.7v7.9c0 .3.4.7.7.7h4.2c.3 0 .7-.4.7-.7v-7.9c0-.4-.4-.7-.7-.7zm7.4 0h-4.2c-.4 0-.7.3-.7.7v7.9c0 .3.3.7.7.7h4.2c.3 0 .7-.4.7-.7v-7.9c0-.4-.4-.7-.7-.7z"
      }
    },
    topic: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M8 16.3c0-.1-.2-.3-.3-.3l-1-.3c-.2-.1-.4 0-.5.2l-1.8 3c-.4.9-.2 1.1.7.7l3-1.8c.2-.1.3-.3.3-.5l-.4-1zm8-8.6c0 .1.2.3.3.3l1 .3c.2.1.4 0 .5-.2L19.6 5c.4-.8.2-1.1-.7-.6l-3 1.7c-.2.1-.3.4-.3.5l.4 1.1zm-9.8.4c.1.2.3.3.5.3l1-.3c.1-.1.3-.2.3-.3l.3-1.1c.1-.1 0-.4-.2-.5l-3-1.8c-.9-.4-1.1-.2-.7.7l1.8 3zm11.6 7.8c-.1-.2-.3-.3-.5-.3l-1 .3c-.1.1-.3.2-.3.3l-.3 1.1c-.1.2 0 .4.2.5l3.1 1.8c.8.4 1.1.2.6-.7l-1.8-3zm4.7-4.3l-7.6-2c-.3 0-.5-.3-.5-.5l-2-7.6c-.3-.8-.6-.8-.8 0l-2 7.6c-.1.3-.3.5-.6.5l-7.5 2c-.8.3-.8.6 0 .8l7.6 2c.3.1.5.3.5.6l2 7.5c.3.8.6.8.8 0l2-7.5c.1-.3.3-.5.6-.6l7.5-2c.8-.2.8-.6 0-.8zM12 13.8c-1 0-1.8-.8-1.8-1.8s.8-1.8 1.8-1.8 1.8.8 1.8 1.8-.8 1.8-1.8 1.8z"
      }
    },
    touch_action: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.4 13.8l-3.7-1.3c-.3-.1-.5-.4-.5-.7V6.7c0-.7-.7-1.3-1.5-1.3h-.1c-.8 0-1.4.6-1.4 1.3v10c0 .8-1.1 1.2-1.6.4l-.9-2c-.5-.9-1.7-1.1-2.5-.5l-.6.4 3.2 7.6c.1.3.4.5.8.5h8.3c.5 0 .8-.3.9-.7l1.4-5.2c.4-1.5-.4-2.9-1.8-3.4zm-9.5-3.2v-4c.1-1.8 1.7-3.4 3.5-3.5h.4c1.9.1 3.4 1.7 3.5 3.5v4c0 .3.4.5.7.3 1-1.1 1.6-2.5 1.6-4 0-3.4-3-6.2-6.5-5.9-2.7.3-4.9 2.3-5.3 5-.3 1.8.3 3.6 1.5 4.9.2.2.6 0 .6-.3z"
      }
    },
    trail: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12.8.9c1.6 0 2.8 1.2 2.8 2.7s-1.3 2.8-2.8 2.8-2.7-1.2-2.7-2.8S11.3.9 12.8.9zm7 7.5c-.5-.1-1 .3-1.1.8l-.2 2.7c-.1 0-.2.1-.3.1h-2.5l-1.8-3.1c-.1-.3-.4-.5-.7-.5L10.5 8c-.4-.1-.9.2-1.1.6l-2 5.2c-.2.5 0 .9.4 1.1l5 3.4.4 3.9c0 .5.5.9 1 .9.6 0 1.1-.5 1-1l-.4-4.8c0-.2-.2-.5-.4-.6l-2.7-3.1 1-2.5 1.2 2.1c.2.3.5.6.9.6h3.5l-1 8.3c-.1.5.3.9.8 1 .1 0 .1-.1.1-.1.5 0 1-.3 1-.8l1.6-12.9c0-.4-.4-.9-1-.9zM5.6 12.8l1.7-4.4c.1-.3.3-.6.5-.8l-.3-.1c-1.5-.2-2.8.7-3.3 2.1L3.3 12c-.2.5.1 1.1.6 1.2l.4.1c.6.2 1.1-.1 1.3-.5zm.7 3.4l-2.1 6.2c-.1.4.1.6.5.6h1.1c.4 0 .8-.2 1-.6l2-4.5-2.3-1.4c0-.1-.1-.2-.2-.3z"
      }
    },
    travel_and_places: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M21.7 9.7l-2.1-5.6c-.3-1.1-1.3-1.8-2.4-1.8H6.8c-1.1 0-2.1.7-2.4 1.8L2.3 9.7c-1 .3-1.4 1.2-1.4 2.2v5.4c0 .9 1 1.8 1.9 2.1v1.8c0 .7.3 1 .9 1H6c.6 0 .9-.3.9-1v-1.8h10.2v1.8c0 .7.3 1 .9 1h2.3c.6 0 .9-.3.9-1v-1.8c.9-.3 1.9-1.1 1.9-2.1v-5.4c0-1-.4-1.9-1.4-2.2zm-16.6 6c-1.1 0-1.9-.8-1.9-1.9S4 12 5.1 12s1.8.8 1.8 1.8-.8 1.9-1.8 1.9zm7.6-6H5.4c-.2 0-.4-.2-.3-.5l1.4-4.1c0-.2.1-.5.4-.5h10.2c.3 0 .4.4.4.5l1.4 4.1c.1.3 0 .5-.4.5h-5.8zm6.2 6c-1 0-1.8-.8-1.8-1.9s.8-1.8 1.8-1.8 1.9.8 1.9 1.8-.8 1.9-1.9 1.9z"
      }
    },
    trending: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M23.1 14.1a.5.5 0 0 1-.9.4L19.7 12 14 16.9a1.6 1.6 0 0 1-2.3 0L8.3 13l-6.2 5.4a.5.5 0 0 1-.7 0l-.3-.3a.5.5 0 0 1 0-.8l6-8.2a1.6 1.6 0 0 1 2.3 0l3.5 3.4 3.5-4-2.3-2.1a.6.6 0 0 1 .4-.9H22a1.1 1.1 0 0 1 1.1 1.1z"
      }
    },
    turn_off_notifications: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M10.8 12.3c.3.3.6.3.9 0l9.9-9.1c.2-.3.1-.9-.6-.9H1.6c-.5 0-1 .5-.6.9l9.8 9.1zm3.1 5.1c.2-2.6 2.3-4.8 4.9-5 .3 0 .5-.1.7-.1.8 0 1.5.2 2.2.5V7.1c0-.5-.5-.7-.8-.4l-7.7 7.1c-.5.5-1.2.7-1.9.7s-1.4-.2-1.9-.7L1.8 6.7c-.4-.3-.9-.1-.9.4v9c0 1.2.9 2.1 2.1 2.1h10.9v-.8zm5.5-3.1c-2 0-3.7 1.7-3.7 3.7s1.7 3.7 3.7 3.7 3.7-1.7 3.7-3.7-1.6-3.7-3.7-3.7zm2.8 4.4c0 .1-.1.2-.2.2h-5.1c-.1 0-.2-.1-.2-.2v-1.4c0-.1.1-.2.2-.2H22c.1 0 .2.1.2.2v1.4z"
      }
    },
    type_tool: {
      "path": {
        "d": "M23.2 22L15.1 1.8a1.1 1.1 0 0 0-1-.6H9.3a1 1 0 0 0-1 .6L.9 22a.7.7 0 0 0 .6.8h2.8a1.1 1.1 0 0 0 .9-.7l2.2-6h9.1l2.3 6a1.1 1.1 0 0 0 1 .7h2.8a.7.7 0 0 0 .6-.8zM8.8 12l2.7-6.8h.5l2.9 6.8z"
      }
    },
    undelete: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M19.2 9.2H4.8c-.3 0-.6.4-.6.7v10.9c0 1.3 1 2.3 2.3 2.3h11c1.3 0 2.3-1 2.3-2.3V9.9c0-.3-.3-.7-.6-.7zm-7.2 12v-1.8c1.5 0 2.8-1.3 2.8-2.8s-1.3-2.8-2.8-2.8c-.7 0-1.4.4-1.9.9l1.1 1.1c.1.1 0 .4-.2.4H7.6c-.1 0-.2-.1-.2-.2v-3.4c0-.2.2-.3.4-.2l1 1c.8-.8 2-1.4 3.2-1.4 2.6 0 4.7 2.1 4.7 4.7s-2.2 4.5-4.7 4.5zm9-16.6h-5.8V2.8c0-1-.8-1.9-1.8-1.9h-2.8c-1 0-1.8.9-1.8 1.9v1.8H3c-.4 0-.7.3-.7.7v1.4c0 .4.3.7.7.7h18c.4 0 .7-.3.7-.7V5.3c0-.4-.3-.7-.7-.7zm-7.6 0h-2.8V3.2c0-.2.2-.4.5-.4h1.8c.3 0 .5.2.5.4v1.4z"
      }
    },
    undeprecate: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.2 3.2H1.8c-.5 0-.9.4-.9 1v12c0 .5.4.9.9.9h7.5c.5 2.6 2.7 4.6 5.5 4.6s5-2 5.4-4.6h2c.5 0 .9-.4.9-.9v-12c0-.6-.4-1-.9-1zm-8.1 15.9l-2.7-2.8 1.2-1.3 1.5 1.5 3.3-3.3 1.2 1.3-4.5 4.6zm7.1-3.9h-1c-.4-2.6-2.7-4.6-5.4-4.6s-5.1 2-5.5 4.6H2.8V5.1h18.4v10.1z"
      }
    },
    underline: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M20.5 19.4h-17c-.4 0-.7.3-.7.7v1.4c0 .3.3.7.7.7h17c.4 0 .7-.4.7-.7v-1.4c0-.4-.3-.7-.7-.7zm-8.8-1.9c-3.5-.1-6.2-3.1-6.2-6.6V4.6c0-.5.5-.9 1-.9h.9c.5 0 .9.4.9.9v6.3c0 2 1.5 3.7 3.5 3.9 2.1.1 3.9-1.6 3.9-3.7V4.6c0-.5.4-.9.9-.9h.9c.5 0 1 .4 1 .9v6.5c0 3.7-3.1 6.6-6.8 6.4z"
      }
    },
    undo: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M14 5.8c4.8 0 8.7 3.9 8.7 8.7s-3.9 8.8-8.7 8.8h-3.8c-.4 0-.6-.3-.6-.7v-1.5c0-.3.3-.7.6-.7H14c3.3 0 5.9-2.6 5.9-5.9S17.3 8.6 14 8.6H7.6s-.4 0-.5.1c-.4.2-.3.4 0 .8l2.3 2.2c.2.3.2.7-.1 1l-1 1c-.3.3-.6.3-.9.1l-6-6c-.2-.3-.2-.6 0-.9l6-5.9c.3-.3.7-.3 1 0l.9.9c.3.3.3.8 0 1L7.1 5.2c-.3.2-.3.6.1.6H14z"
      }
    },
    unlock: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M4.6 8.4v.1-.1zm14.8 2.2h-12V8.4c0-2.4 1.8-4.6 4.3-4.7 2.2-.1 4.1 1.3 4.7 3.3.1.2.3.4.5.4h1.9c.3 0 .5-.3.4-.6-.7-3.5-3.8-6.1-7.6-5.9-3.9.2-6.9 3.6-7 7.5v2.2c-1 0-1.8.8-1.8 1.9v8.7c0 1 .8 1.9 1.8 1.9h14.8c1 0 1.8-.9 1.8-1.9v-8.7c0-1.1-.8-1.9-1.8-1.9zm-5.3 9.1c.1.3-.1.6-.4.6h-3.4c-.3 0-.6-.3-.5-.6l.9-2.8c-.7-.4-1.1-1.3-1-2.2.2-.9.9-1.5 1.8-1.7 1.5-.3 2.8.8 2.8 2.1 0 .8-.4 1.5-1 1.8l.8 2.8z"
      }
    },
    unmuted: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M19.2 8.3c-.7 0-1.2.5-1.2 1.1v1.9c0 3.2-2.7 5.9-6 5.9s-6.1-2.7-6.1-5.9V9.4c0-.6-.5-1.1-1.1-1.1s-1.1.5-1.1 1.1v1.9c0 4.1 3.1 7.4 7.1 8v1.6H9c-.7 0-1.2.4-1.2 1.1s.5 1.1 1.2 1.1h6c.6 0 1.2-.5 1.2-1.1s-.6-1.1-1.2-1.1h-1.9v-1.6c4.1-.6 7.2-3.9 7.2-8V9.4c0-.6-.5-1.1-1.1-1.1zM12 15c2 0 3.7-1.7 3.7-3.7V4.6c0-2.1-1.6-3.7-3.7-3.7S8.3 2.5 8.3 4.6v6.7c0 2 1.7 3.7 3.7 3.7z"
      }
    },
    up: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M20.2 17.5H3.8c-.4 0-.8-.6-.4-1l8-9.8c.3-.3.9-.3 1.2 0l8 9.8c.4.4.1 1-.4 1z"
      }
    },
    upload: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.4 14.3H21c-.4 0-.7.4-.7.7v4.6c0 .4-.3.7-.7.7H4.4c-.4 0-.7-.3-.7-.7V15c0-.3-.3-.7-.7-.7H1.6c-.4 0-.7.4-.7.7v6.2c0 1 .9 1.9 1.9 1.9h18.4c1 0 1.9-.9 1.9-1.9V15c0-.3-.3-.7-.7-.7zM12.5 1.1c-.3-.3-.7-.3-1 0L5.3 7.3c-.3.3-.3.7 0 1l.9 1c.3.3.7.3 1 0l2.6-2.6c.3-.3.8-.1.8.3v9.8c0 .4.3.7.7.7h1.3c.4 0 .8-.4.8-.7V7.1c0-.5.4-.6.8-.4l2.6 2.6c.2.3.6.3.9 0l1-.9c.3-.3.3-.7 0-1l-6.2-6.3z"
      }
    },
    user: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M23.1 19.8v1.1c0 1.2-1 2.2-2.2 2.2H3.1c-1.2 0-2.2-1-2.2-2.2v-1.1c0-2.6 3.2-4.3 6.1-5.6l.3-.1c.2-.1.5-.1.7 0 1.2.8 2.5 1.2 4 1.2s2.8-.4 3.9-1.2c.3-.1.5-.1.7 0l.3.1c3 1.3 6.2 2.9 6.2 5.6zM12 .9c3 0 5.5 2.7 5.5 6.1S15 13.1 12 13.1 6.5 10.4 6.5 7 9 .9 12 .9z"
      }
    },
    user_role: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M10.1 16.6c0-1.2.5-2.7 1.1-3.8.8-1.4 1.7-1.9 2.4-2.9 1.1-1.7 1.3-4.2.6-6-.7-1.9-2.5-3-4.5-3S6 2.2 5.3 4.1c-.7 2.1-.4 4.6 1.3 6.1.7.7 1.3 1.7 1 2.7-.4.9-1.5 1.3-2.3 1.7-1.8.8-3.9 1.9-4.3 4-.4 1.8.8 3.6 2.7 3.6h7.9c.3 0 .6-.5.3-.8-1.1-1.3-1.8-3-1.8-4.8zm7.4-5.5c-3 0-5.5 2.5-5.5 5.5s2.5 5.6 5.5 5.6 5.6-2.5 5.6-5.6-2.5-5.5-5.6-5.5zm1 6c-.1 0-.3 0-.4-.1l-2.2 2.2c-.1.1-.3.2-.4.2-.2 0-.4-.1-.5-.2-.3-.3-.3-.7 0-1l2.1-2.1c0-.1 0-.3-.1-.4-.1-1 .7-1.9 1.7-1.9.1 0 .3 0 .5.1 0 0 .1.1 0 .1l-.9 1c-.1.1-.1.2 0 .2l.6.7c.1.1.2.1.3 0l.9-.9c.1-.1.2-.1.2 0v.5c0 1-.8 1.7-1.8 1.6z"
      }
    },
    video: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M21.6 6l-5 3.7V7.1c0-.7-.6-1.2-1.3-1.2H2.2c-.7 0-1.3.5-1.3 1.2v9.8c0 .7.6 1.3 1.3 1.3h13.2c.7 0 1.2-.6 1.2-1.3v-2.5l5 3.6c.4.3.9.1.9-.4V6.4c0-.4-.5-.7-.9-.4z"
      }
    },
    voicemail_drop: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18 6.8c-2.8 0-5.2 2.3-5.2 5.2 0 1 .4 2 .9 2.8h-3.4c.6-.8.9-1.7.9-2.8 0-2.8-2.3-5.2-5.2-5.2C3.2 6.8.8 9.1.8 12c0 2.8 2.3 5.2 5.2 5.2h12c2.8 0 5.1-2.3 5.1-5.2.1-2.9-2.2-5.2-5.1-5.2zM3.3 12c0-1.6 1.3-2.8 2.7-2.8 1.6 0 2.8 1.2 2.8 2.8S7.5 14.7 6 14.7 3.3 13.5 3.3 12zM18 14.8c-1.5 0-2.7-1.3-2.7-2.8s1.2-2.8 2.7-2.8c1.5 0 2.7 1.3 2.7 2.8.1 1.5-1.2 2.8-2.7 2.8z"
      }
    },
    volume_high: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M11.4 1.2L5.5 8.3H2.8c-1 0-1.9.8-1.9 1.9v3.6c0 1.1.9 1.9 1.9 1.9h2.7l5.9 7.1c.6.6 1.5.2 1.5-.6V1.8c0-.8-1-1.2-1.5-.6zM19.7 4c-.2-.2-.5-.2-.7 0l-.6.7c-.2.1-.2.5 0 .6 1.7 1.7 2.8 4.1 2.8 6.7 0 2.6-1.1 5-2.8 6.7-.2.2-.2.5 0 .6l.6.7c.2.2.5.2.7 0 2-2 3.4-4.9 3.4-8 0-3.1-1.3-6-3.4-8zm-2.9 3c-.2-.2-.5-.2-.7 0l-.6.6c-.2.2-.2.5 0 .7 1 .9 1.6 2.2 1.6 3.7s-.7 2.8-1.7 3.7c-.2.2-.2.5 0 .7l.7.6c.1.2.4.2.6 0 1.3-1.2 2.2-3 2.2-5s-.8-3.8-2.1-5z"
      }
    },
    volume_low: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M11.4 1.2L5.5 8.3H2.8c-1 0-1.9.8-1.9 1.9v3.6c0 1.1.9 1.9 1.9 1.9h2.7l5.9 7.1c.6.6 1.5.2 1.5-.6V1.8c0-.8-1-1.2-1.5-.6zM16.8 7c-.2-.2-.5-.2-.7 0l-.6.6c-.2.2-.2.5 0 .7 1 .9 1.6 2.2 1.6 3.7s-.7 2.8-1.7 3.7c-.2.2-.2.5 0 .7l.7.6c.1.2.4.2.6 0 1.3-1.2 2.2-3 2.2-5s-.8-3.8-2.1-5z"
      }
    },
    volume_off: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M11.4 1.2L5.5 8.3H2.8c-1 0-1.9.8-1.9 1.9v3.6c0 1.1.9 1.9 1.9 1.9h2.7l5.9 7.1c.6.6 1.5.2 1.5-.6V1.8c0-.8-1-1.2-1.5-.6zM20.7 12l2.2-2.3c.2-.1.2-.4 0-.6l-.6-.7c-.2-.1-.5-.1-.7 0l-2.2 2.3-2.3-2.3c-.2-.1-.4-.1-.6 0l-.7.7c-.2.2-.2.5 0 .6l2.3 2.3-2.3 2.3c-.2.1-.2.4 0 .6l.7.7c.2.1.4.1.6 0l2.3-2.3 2.2 2.3c.2.1.5.1.7 0l.6-.7c.2-.2.2-.5 0-.6L20.7 12z"
      }
    },
    warning: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M23.7 19.6L13.2 2.5c-.6-.9-1.8-.9-2.4 0L.3 19.6c-.7 1.1 0 2.6 1.1 2.6h21.2c1.1 0 1.8-1.5 1.1-2.6zM12 18.5c-.8 0-1.4-.6-1.4-1.4s.6-1.4 1.4-1.4 1.4.6 1.4 1.4-.6 1.4-1.4 1.4zm1.4-4.2c0 .3-.2.5-.5.5h-1.8c-.3 0-.5-.2-.5-.5v-6c0-.3.2-.5.5-.5h1.8c.3 0 .5.2.5.5v6z"
      }
    },
    weeklyview: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M20.3 3.2H18v-.9c0-.7-.6-1.4-1.4-1.4-.7 0-1.4.6-1.4 1.4v.9H8.8v-.9c0-.7-.6-1.4-1.4-1.4C6.6.9 6 1.5 6 2.3v.9H3.7c-1 0-1.9.9-1.9 1.9v1.1c0 .4.4.7.7.7h19c.3 0 .7-.3.7-.7V5.1c0-1-.9-1.9-1.9-1.9zm1.2 6h-19c-.3 0-.7.4-.7.7v11.3c0 1 .9 1.9 1.9 1.9h16.6c1 0 1.9-.9 1.9-1.9V9.9c0-.3-.4-.7-.7-.7zm-6.4 4.4l-2.9 6.2c-.1.3-.4.5-.8.5-.5 0-.9-.4-.9-.8 0-.1.1-.3.1-.4l2.5-5.3H9.6c-.5 0-.8-.2-.8-.6 0-.4.3-.7.8-.7h4.8c.4 0 .8.3.8.8 0 .1 0 .2-.1.3z"
      }
    },
    wifi: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22 7.3c-2.5-2.8-6.1-4.4-10-4.4S4.6 4.5 2.1 7.3c-.2.2-.2.5 0 .6l1.4 1.2c.2.2.5.2.7 0C6.2 6.9 9 5.7 12 5.7s5.9 1.2 7.9 3.4c.2.2.5.2.7 0L22 7.9c.2-.1.2-.4 0-.6zM12 9.4c-1.9 0-3.7.8-5 2.3-.2.2-.2.5 0 .7l1.5 1.1c.2.1.5.1.6-.1.8-.8 1.8-1.3 2.9-1.3s2.2.5 3 1.3c.1.2.4.2.6 0l1.4-1.1c.3-.2.3-.4.1-.7-1.3-1.4-3.1-2.2-5.1-2.2zm.1 6.4c1.2 0 2.3 1 2.3 2.3s-1 2.3-2.3 2.3-2.3-1-2.3-2.3 1-2.3 2.3-2.3z"
      }
    },
    work_order_type: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.1 12.4c0 .5-.4.9-.8.9H6.7c-.4 0-.8-.4-.8-.9v-.9c0-.4.4-.8.8-.8h10.6c.5 0 .9.4.9.8v.9h-.1zm-1.7 5.3c0 .4-.4.9-.9.9H6.7c-.4 0-.8-.5-.8-.9v-.9c0-.5.4-.9.8-.9h8.9c.4 0 .8.4.8.9v.9zM5.9 6.2c0-.4.4-.8.8-.8h8.9c.4 0 .8.4.8.8v.9c0 .5-.4.9-.8.9H6.7c-.4 0-.8-.4-.8-.9v-.9zM19 1.8H5C3.5 1.8 2.3 3 2.3 4.5v14.9c0 1.5 1.2 2.7 2.6 2.7H19c1.4 0 2.6-1.2 2.6-2.7V4.5c.1-1.5-1.1-2.7-2.6-2.7z"
      }
    },
    world: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12 .9C5.9.9.9 5.9.9 12s5 11.1 11.1 11.1 11.1-5 11.1-11.1S18.1.9 12 .9zm0 2.3zm.9.1h-.1.1zM12 20.8c-4.8 0-8.8-4-8.8-8.8 0-.5.1-1 .2-1.4.6.1 1.3.3 1.7.7.8.8 1.6 1.8 2.5 2 0 0-.1 0-.2.2-.1.1-.2.4-.2.9 0 2.1 2 .8 2 3s2.5 3 2.5 1.3 1.6-2.6 1.6-3.9-1.3-1.3-2-1.8c-.9-.4-1.3-1.1-2.9-.9-.8-.7-1.2-1.4-.9-2.1.4-.8 2.1-1 2.1-2.2S8.5 6.4 7.7 6.4c-.4 0-1.2-.3-1.8-.6.7-.8 1.7-1.4 2.7-1.9.8.3 2 .9 3.1.9 1.2 0 1.9-.9 1.7-1.5 2.1.3 3.9 1.4 5.2 2.9-.6.4-1.6.9-3.2.9-2.1 0-2.1 2.1-.9 2.5 1.3.5 2.6-.8 3 0 .5.9-3 .9-2.1 3 .9 2.1 1.7 0 2.6 2.1.9 2.1 2.6-.3 1.3-2-.6-.7-.4-3 .9-3h.4c.2.7.3 1.5.3 2.3-.1 4.8-4.1 8.8-8.9 8.8z"
      }
    },
    yubi_key: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": [{
          "d": "M17.8 6.5H.7c-.4 0-.7.3-.7.7v9.7c0 .4.3.7.7.7h17.1c.3 0 .7-.3.7-.7V7.2c0-.4-.4-.7-.7-.7zm-8.1 8.4c-1.6 0-2.8-1.3-2.8-2.9s1.2-2.8 2.8-2.8 2.8 1.3 2.8 2.8-1.2 2.9-2.8 2.9z"
        }, {
          "d": "M23.3 8.3h-6.7c-.4 0-.7.3-.7.7v6c0 .4.3.7.7.7h6.7c.4 0 .7-.3.7-.7V9c0-.4-.3-.7-.7-.7zm-1.6 1.9c.3 0 .5.1.5.4v.9h-3.7v-1.3h3.2zm0 3.6h-3.2v-1.2h3.7v.8c0 .3-.2.4-.5.4z"
        }],
        "circle": {
          "cx": "9.692",
          "cy": "12.046",
          "r": ".554"
        }
      }
    },
    zoomin: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M14.3 8.8h-2.8V6c0-.3-.1-.5-.4-.5H9.2c-.2 0-.4.2-.4.5v2.8H6c-.3 0-.5.2-.5.4v1.9c0 .3.2.4.5.4h2.8v2.8c0 .3.2.5.4.5h1.9c.3 0 .4-.2.4-.5v-2.8h2.8c.3 0 .5-.1.5-.4V9.2c0-.2-.2-.4-.5-.4zm8.6 12.1l-5.3-5.3c1.1-1.5 1.8-3.4 1.8-5.4 0-5.1-4.2-9.3-9.2-9.3S.9 5.1.9 10.2s4.2 9.2 9.3 9.2c2 0 3.9-.7 5.4-1.8l5.3 5.3c.3.3.7.3 1 0l.9-1c.3-.3.3-.7.1-1zm-12.7-4.3c-3.6 0-6.5-2.9-6.5-6.4s2.9-6.5 6.5-6.5 6.4 2.9 6.4 6.5-2.9 6.4-6.4 6.4z"
      }
    },
    zoomout: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M8.8 11.5h5.5c.3 0 .5-.1.5-.4V9.2c0-.2-.2-.4-.5-.4H8.8m0 0H6c-.3 0-.5.2-.5.4v1.9c0 .3.2.4.5.4h2.8"
      }, {
        "d": "M22.9 20.9l-5.3-5.3c1.1-1.5 1.8-3.4 1.8-5.4 0-5.1-4.2-9.3-9.2-9.3S.9 5.1.9 10.2s4.2 9.2 9.3 9.2c2 0 3.9-.7 5.4-1.8l5.3 5.3c.3.3.7.3 1 0l.9-1c.3-.3.3-.7.1-1zm-12.7-4.3c-3.6 0-6.5-2.9-6.5-6.4s2.9-6.5 6.5-6.5 6.4 2.9 6.4 6.5-2.9 6.4-6.4 6.4z"
      }]
    },
    viewBox: '0 0 24 24'
  };
}

/* harmony default export */ __webpack_exports__["a"] = (icons);

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
var icons = {};

if (false) {
  icons = {
    add_contact: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M21.2 4.2H2.8C1.5 4.2.5 5.2.5 6.5v11c0 1.3 1 2.3 2.3 2.3h18.4c1.3 0 2.3-1 2.3-2.3v-11c0-1.3-1-2.3-2.3-2.3zm-9.8 13H4.8c-.7 0-1.3-.8-1.3-1.6.1-1.2 1.3-1.8 2.5-2.4.9-.4 1-.7 1-1.1 0-.4-.2-.7-.5-1-.5-.5-.8-1.2-.8-1.9 0-1.5.9-2.7 2.4-2.7s2.4 1.3 2.4 2.7c0 .8-.3 1.5-.8 1.9-.3.3-.6.6-.6 1s.1.7 1.1 1.1c1.2.5 2.4 1.2 2.4 2.4.2.8-.4 1.6-1.2 1.6zm9-2.7c0 .4-.3.8-.7.8h-3.5c-.4 0-.8-.3-.8-.8v-1.2c0-.4.4-.7.8-.7h3.5c.4 0 .7.3.7.7v1.2zm0-4.2c0 .4-.3.8-.7.8h-5.8c-.4 0-.7-.3-.7-.8V9.1c0-.4.3-.7.7-.7h5.8c.4 0 .8.3.8.7v1.2z"
      }
    },
    add_file: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M4.5 16.7V5.2c-1.2 0-2.2 1-2.2 2.1v13.6c0 1.2 1 2.2 2.2 2.2h10.7c1.2 0 2.2-1 2.2-2.1H8.8c-2.4 0-4.3 0-4.3-4.3zM21 7.3h-3.6c-1.2 0-2.2-.9-2.2-2.1V1.6c0-.4-.3-.7-.7-.7H8.8C7.6.9 6.6 1.9 6.6 3v13.6c0 1.2 1 2.1 2.2 2.1h10.7c1.2 0 2.2-.9 2.2-2.1V8.1c0-.4-.3-.8-.7-.8zm.6-3l-3.4-3.2c-.1-.1-.2-.2-.3-.2-.3 0-.5.3-.5.5v2.4c0 .8.6 1.4 1.4 1.4h2.4c.3 0 .5-.2.5-.5 0-.1-.1-.2-.1-.4z"
      }
    },
    add_photo_video: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12 9.2c-2 0-3.7 1.7-3.7 3.7s1.7 3.7 3.7 3.7 3.7-1.6 3.7-3.7S14 9.2 12 9.2zm9.2-2.7h-2.4c-.6 0-1.2-.4-1.5-.9L16.2 4c-.3-.8-1.1-1.2-1.9-1.2H9.7c-.8 0-1.6.4-1.9 1.2L6.7 5.6c-.3.5-.9.9-1.6.9H2.8c-1 0-1.9.8-1.9 1.8v11.1c0 1 .9 1.8 1.9 1.8h18.4c1 0 1.9-.8 1.9-1.8V8.3c0-1-.9-1.8-1.9-1.8zm-9.2 12c-3 0-5.5-2.5-5.5-5.6S9 7.4 12 7.4s5.5 2.5 5.5 5.5-2.5 5.6-5.5 5.6z"
      }
    },
    add_relationship: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M16.6 9.2c0-1-.8-1.8-1.8-1.8h-12c-1 0-1.9.8-1.9 1.8v12c0 1 .9 1.9 1.9 1.9h12c1 0 1.8-.9 1.8-1.9v-12zm-3.7 6.5c0 .2-.2.5-.4.5H9.7v2.7c0 .3-.2.5-.5.5h-.9c-.2 0-.5-.2-.5-.5v-2.7H5.1c-.3 0-.5-.3-.5-.5v-.9c0-.3.2-.5.5-.5h2.7v-2.8c0-.2.3-.4.5-.4h.9c.3 0 .5.2.5.4v2.8h2.8c.2 0 .4.2.4.5v.9zm6.9 3.7h-1.3v-2.8h1.3c.3 0 .5-.2.5-.4v-12c0-.3-.2-.5-.5-.5h-12c-.2 0-.4.2-.4.5v1.3H4.6V4.2C4.6 2.4 6 .9 7.8.9h12c1.8 0 3.3 1.5 3.3 3.3v12c0 1.8-1.5 3.2-3.3 3.2z"
      }
    },
    announcement: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M10.5 21l-.6-.5c-.7-.5-.7-1.4-.7-1.9v-1.3c0-.4-.3-.7-.7-.7H5.8c-.4 0-.7.3-.7.7v3.6c0 1.2.7 2.2 1.9 2.2h2.2c1.4 0 1.5-.9 1.5-.9s.2-.9-.2-1.2zM20.8 8.3V2c0-1.1-1.4-1.4-2.2-.7l-4.1 3.9c-.6.5-1.4.8-2.3.8h-7C2.8 6 .9 8.1.9 10.5v.1c0 2.4 1.9 4.2 4.3 4.2h7c.9 0 1.7.3 2.4.9l4 4c.8.7 2.2.4 2.2-.7v-6.3c1.4 0 2.2-.9 2.2-2.2 0-1.2-.8-2.2-2.2-2.2z"
      }
    },
    apex: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.4 18.5H9.9c-.3 0-.7.3-.7.7v1.3c0 .4.4.7.7.7h12.5c.4 0 .7-.3.7-.7v-1.3c0-.4-.3-.7-.7-.7zm-10.7-8.4L2.8 2.9c-.3-.2-.7-.2-1 .1l-.7 1.2c-.3.3-.2.7.1.9l6.4 5.1c.2.2.2.6 0 .7L1.2 16c-.3.2-.4.7-.1 1l.7 1.2c.3.3.7.4 1 .1l8.9-7.1c.4-.3.4-.9 0-1.1z"
      }
    },
    approval: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M8.8 20.1l-7.6-7.6c-.3-.3-.3-.8 0-1.1l1-1c.2-.2.7-.2 1 0l5.7 5.8c.2.2.5.2.7 0L20.8 4.9c.3-.3.8-.3 1 0l1 1c.3.3.3.7 0 1l-13 13.2c-.3.3-.8.3-1 0z"
      }
    },
    back: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.4 10.2H7.1c-.5 0-.6-.6-.4-.8l4.5-4.5c.2-.2.2-.7 0-.9l-1-1c-.3-.3-.7-.3-1 0l-8.1 8c-.3.3-.3.7 0 1l8.1 8.1c.3.3.7.3 1 0l.9-1c.3-.3.3-.7 0-1l-4.4-4.4c-.3-.3-.1-.8.3-.8h15.3c.4 0 .7-.3.7-.7v-1.4c.1-.3-.2-.6-.6-.6z"
      }
    },
    call: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.4 17.4l-2.8-2.2c-.7-.5-1.6-.6-2.2-.1L15 16.9c-.3.2-.7.2-1-.1l-3.6-3.2L7.2 10c-.3-.3-.3-.7-.1-1l1.7-2.4c.5-.6.5-1.6 0-2.2L6.5 1.6c-.7-.9-1.9-1-2.7-.2L1.5 3.8c-.4.4-.6 1-.6 1.5.3 4.7 2.4 9.1 5.5 12.3 3.2 3.1 7.6 5.2 12.3 5.5.5 0 1.1-.2 1.4-.6l2.4-2.4c.8-.7.8-2-.1-2.7z"
      }
    },
    canvas: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M20.8 17.7c-.1 1.3-.3 2.6-.5 3.9 0 .4-.5.8-.8.8-2.5.3-5 .5-7.5.5-2.4 0-4.9-.1-7.3-.5-.4 0-.8-.4-.9-.8-.3-2-.5-4.1-.5-6.2s.2-4.1.5-6.2c.1-.3.5-.7.9-.8 1.5-.2 3-.3 4.4-.4 0 0 1.2 0 1.1-1.2 0-1-1.8-1.7-1.8-3.4C8.4 2 9.8.9 12 .9c2.3 0 3.6 1.1 3.6 2.5 0 1.8-1.7 2.4-1.8 3.4C13.8 7.9 15 8 15 8c1.5.1 3 .2 4.5.4.3 0 .8.4.8.8.2 1.5.4 2.8.5 4.2 0 .4-.4.9-.8.9h-.4c-.4 0-1-.4-1.3-.7 0 0-1-1-2.1-1-1.7-.1-3 1.4-3 3s1.3 3.1 3 3.1c1-.1 2-1.1 2-1.1.4-.2 1-.5 1.4-.5h.4c.5 0 .8.3.8.6z"
      }
    },
    change_owner: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12.6 17.4c-1.4-.6-1.6-1.1-1.6-1.7 0-.5.4-1 .8-1.4.8-.7 1.2-1.8 1.2-3 0-2.2-1.3-3.9-3.8-3.9s-3.8 1.7-3.8 3.9c0 1.2.3 2.3 1.2 3 .4.4.8.9.8 1.4 0 .6-.2 1.1-1.6 1.7-2.1.8-4 1.7-4 3.5 0 1.2 1 2.2 2.1 2.2h10.6c1.2 0 2.1-1 2.1-2.2 0-1.7-2-2.7-4-3.5zm7.9-8.6c0-3.4-2.8-6.3-6.2-6.3V.9l-3.1 2.6c-.2.1-.1.3 0 .5l3.1 2.5V4.8c2.2 0 3.9 1.8 3.9 4h-1.6l2.6 3.1c.1.1.3.1.5 0l2.5-3.1h-1.7z"
      }
    },
    change_record_type: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M9.2 17.3c0-.4-.3-.7-.7-.7H1.6c-.4 0-.7.3-.7.7v5.1c0 .4.3.7.7.7h6.9c.4 0 .7-.3.7-.7v-5.1zm-5.5-7.1H1.5c-.5 0-.7.4-.4.6l3.7 3.8c.1.2.4.2.6 0l3.7-3.8c.3-.3 0-.6-.4-.6H6.5c0-2.4 2.3-4.7 4.6-4.7V2.8c-4.2 0-7.4 3.2-7.4 7.4zm15.6-.8c-.2-.2-.5-.2-.7 0L15 13.2c-.3.3-.1.6.4.6h2.2c0 2.8-1.9 4.7-4.7 4.7v2.7c4.2 0 7.5-3.2 7.5-7.4h2.2c.5 0 .7-.4.4-.6l-3.7-3.8zm3.8-7.8c0-.4-.3-.7-.7-.7h-6.9c-.4 0-.7.3-.7.7v5.1c0 .4.3.7.7.7h6.9c.4 0 .7-.3.7-.7V1.6z"
      }
    },
    check: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M8.8 19.6L1.2 12c-.3-.3-.3-.8 0-1.1l1-1c.3-.3.8-.3 1 0L9 15.7c.1.2.5.2.6 0L20.9 4.4c.2-.3.7-.3 1 0l1 1c.3.3.3.7 0 1L9.8 19.6c-.2.3-.7.3-1 0z"
      }
    },
    clone: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M21.2.9H8.3c-1 0-1.8.9-1.8 1.9v1.1c0 .4.3.7.7.7h8.5c2 0 3.7 1.7 3.7 3.7v8.5c0 .4.3.7.7.7h1.1c1 0 1.9-.8 1.9-1.8V2.8c0-1-.9-1.9-1.9-1.9zm-5.5 5.6H2.8c-1 0-1.9.8-1.9 1.8v12.9c0 1 .9 1.9 1.9 1.9h12.9c1 0 1.8-.9 1.8-1.9V8.3c0-1-.8-1.8-1.8-1.8zm-1.9 12.4c0 .3-.1.5-.4.5H5.1c-.3 0-.5-.2-.5-.5V18c0-.3.2-.5.5-.5h8.3c.3 0 .4.2.4.5v.9zm0-3.7c0 .3-.1.5-.4.5H5.1c-.3 0-.5-.2-.5-.5v-.9c0-.3.2-.5.5-.5h8.3c.3 0 .4.2.4.5v.9zm0-3.7c0 .3-.1.5-.4.5H5.1c-.3 0-.5-.2-.5-.5v-.9c0-.3.2-.4.5-.4h8.3c.3 0 .4.1.4.4v.9z"
      }
    },
    close: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M14.6 11.9l6-6c.3-.3.3-.7 0-1l-.9-1c-.3-.3-.7-.3-1 0L12.6 10c-.1.2-.4.2-.6 0L6 3.9c-.3-.3-.7-.3-1 0l-1 .9c-.3.3-.3.7 0 1l6.1 6.1c.1.1.1.4 0 .6L4 18.6c-.3.3-.3.7 0 1l.9.9c.3.3.7.3 1 0l6.1-6c.2-.2.5-.2.6 0l6.1 6c.3.3.7.3 1 0l.9-.9c.3-.3.3-.7 0-1l-6-6c-.2-.2-.2-.5 0-.7z"
      }
    },
    defer: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12 .9C5.9.9.9 5.9.9 12s5 11.1 11.1 11.1 11.1-5 11.1-11.1S18.1.9 12 .9zm0 19.4c-4.6 0-8.3-3.7-8.3-8.3S7.4 3.7 12 3.7s8.3 3.7 8.3 8.3-3.7 8.3-8.3 8.3zm1.6-8.2c-.2-.1-.2-.3-.2-.5V7.2c0-.4-.3-.7-.7-.7h-1.4c-.4 0-.7.3-.7.7v5.5c0 .2.1.4.2.5l3.4 3.5c.3.2.7.2 1 0l1-1c.2-.3.2-.7 0-1l-2.6-2.6z"
      }
    },
    delete: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M21 4.6h-5.8V2.8c0-1-.8-1.9-1.8-1.9h-2.8c-1 0-1.8.9-1.8 1.9v1.8H3c-.4 0-.7.3-.7.7v1.4c0 .4.3.7.7.7h18c.4 0 .7-.3.7-.7V5.3c0-.4-.3-.7-.7-.7zM10.6 3.2c0-.2.2-.4.5-.4h1.8c.3 0 .5.2.5.4v1.4h-2.8V3.2zm8.6 6H4.8c-.3 0-.6.4-.6.7v10.9c0 1.3 1 2.3 2.3 2.3h11c1.3 0 2.3-1 2.3-2.3V9.9c0-.3-.3-.7-.6-.7zm-8.6 10.2c0 .3-.2.4-.4.4h-1c-.2 0-.4-.1-.4-.4v-6.5c0-.3.2-.4.4-.4h1c.2 0 .4.1.4.4v6.5zm4.6 0c0 .3-.2.4-.4.4h-1c-.2 0-.4-.1-.4-.4v-6.5c0-.3.2-.4.4-.4h1c.2 0 .4.1.4.4v6.5z"
      }
    },
    description: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M20.3 1.8H3.7c-1 0-1.9.9-1.9 1.9v16.6c0 1 .9 1.9 1.9 1.9h16.6c1 0 1.9-.9 1.9-1.9V3.7c0-1-.9-1.9-1.9-1.9zM5.5 6.5c0-.3.2-.5.5-.5h4.6c.3 0 .5.2.5.5v4.6c0 .3-.2.4-.5.4H6c-.3 0-.5-.1-.5-.4V6.5zm11.1 12c0 .2-.2.4-.4.4H6c-.3 0-.5-.2-.5-.4v-1c0-.2.2-.4.5-.4h10.2c.2 0 .4.2.4.4v1zm1.9-3.7c0 .2-.2.4-.5.4H6c-.3 0-.5-.2-.5-.4v-1c0-.2.2-.4.5-.4h12c.3 0 .5.2.5.4v1zm0-3.7c0 .3-.2.4-.5.4h-4.6c-.3 0-.5-.1-.5-.4v-.9c0-.3.2-.5.5-.5H18c.3 0 .5.2.5.5v.9zm0-3.7c0 .3-.2.4-.5.4h-4.6c-.3 0-.5-.1-.5-.4v-.9c0-.3.2-.5.5-.5H18c.3 0 .5.2.5.5v.9z"
      }
    },
    dial_in: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "circle": [{
          "cx": "4.615",
          "cy": "4.615",
          "r": "2.769"
        }, {
          "cx": "4.615",
          "cy": "12",
          "r": "2.769"
        }, {
          "cx": "12",
          "cy": "4.615",
          "r": "2.769"
        }, {
          "cx": "19.385",
          "cy": "4.615",
          "r": "2.769"
        }, {
          "cx": "12",
          "cy": "12",
          "r": "2.769"
        }, {
          "cx": "19.385",
          "cy": "12",
          "r": "2.769"
        }, {
          "cx": "4.615",
          "cy": "19.385",
          "r": "2.769"
        }, {
          "cx": "12",
          "cy": "19.385",
          "r": "2.769"
        }, {
          "cx": "19.385",
          "cy": "19.385",
          "r": "2.769"
        }]
      }
    },
    download: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.4 14.3H21c-.4 0-.7.3-.7.7v4.6c0 .4-.3.7-.7.7H4.4c-.4 0-.7-.3-.7-.7V15c0-.4-.3-.7-.7-.7H1.6c-.4 0-.7.3-.7.7v6.2c0 1 .9 1.9 1.9 1.9h18.4c1 0 1.9-.9 1.9-1.9V15c0-.4-.3-.7-.7-.7zm-10.9 3.1c.3.2.7.2 1 0l6.2-6.3c.3-.3.3-.7 0-.9l-.9-1c-.3-.3-.7-.3-1 0l-2.6 2.6c-.3.2-.8.1-.8-.4V1.6c0-.4-.4-.7-.7-.7h-1.4c-.4 0-.7.3-.7.7v9.8c0 .4-.5.6-.8.3L7.2 9.1c-.2-.2-.6-.2-.9 0l-1 1.1c-.3.2-.3.6 0 .9l6.2 6.3z"
      }
    },
    edit: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.5 3.4l-1.9-1.9c-.8-.8-1.9-.8-2.6 0L16.5 3c-.2.2-.2.5 0 .6l3.9 4c.2.2.5.2.6 0L22.6 6c.7-.7.7-1.8-.1-2.6zm-7.3 1.5c-.2-.1-.5-.1-.7 0L2.5 17 1 22.2c-.2.5.3 1 .8.9l5.3-1.5H7l12.1-12c.1-.2.1-.5 0-.7l-3.9-4z"
      }
    },
    edit_groups: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.2 14.5c-.1-.1-.3-.1-.4 0l-5.4 5.4-.8 2.7c-.1.3.2.5.5.5l2.7-.8 5.4-5.4c.1-.1.1-.3 0-.4l-2-2zm4.6-1.6l-1-1c-.4-.4-1-.4-1.4 0 0 0-.6.6-.9 1-.1.1-.1.3 0 .3l2 2c.1.1.2.1.3 0 .4-.3 1-.9 1-.9.4-.4.4-1 0-1.4zM12 6.3c0 1-.3 2-.8 2.8-.2.3-.1.7.2.9 1 .5 2.2 1.2 2.8 2.3.1.2.3.2.5.2H16c.8 0 1.4-.5 1.4-1.4 0-1.3-1.3-2.1-2.7-2.7-1-.4-1.1-.8-1.1-1.2 0-.4.2-.8.6-1.1.5-.5.8-1.3.8-2.1 0-1.7-1-3.1-2.7-3.1-1 0-1.8.5-2.2 1.3C11.3 3 12 4.5 12 6.3zm.7 7.7c-.1-1.5-1.5-2.1-3.1-2.8-1.1-.5-1.2-.9-1.2-1.4s.2-.9.6-1.2c.6-.6 1-1.4 1-2.4 0-1.8-1.1-3.4-3-3.4h-.2c-2 0-3 1.6-3 3.4 0 1 .3 1.8 1 2.4.3.3.6.8.6 1.2 0 .5-.2.9-1.2 1.4-1.6.7-3.1 1.4-3.1 2.8.1 1 .7 1.7 1.7 1.7h8.3c.9 0 1.6-.7 1.6-1.7z"
      }
    },
    edit_relationship: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M19.8 19.4h-1.3v-2.8h1.3c.3 0 .5-.2.5-.4v-12c0-.3-.2-.5-.5-.5h-12c-.2 0-.4.2-.4.5v1.3H4.6V4.2C4.6 2.4 6 .9 7.8.9h12c1.8 0 3.3 1.5 3.3 3.3v12c0 1.8-1.5 3.2-3.3 3.2zm-5-12h-12c-1 0-1.9.8-1.9 1.8v12c0 1 .9 1.9 1.9 1.9h12c1 0 1.8-.9 1.8-1.9v-12c0-1-.8-1.8-1.8-1.8zm-8 11.8c-.1 0-.1 0-.2.1l-2.1.5c-.2 0-.3-.1-.3-.3l.5-2.1s.1-.1.1-.2c.1-.1.2-.1.3 0l1.7 1.7c.1.1.1.3 0 .3zm5.1-5.1l-4.3 4.3c-.1.1-.2.1-.3 0l-1.7-1.7c-.1-.1-.1-.2 0-.3l4.3-4.3c.1-.1.2-.1.3 0l1.7 1.7v.3zm1.3-1.3l-.5.4c-.1.1-.2.1-.3 0l-1.7-1.7c-.1-.1-.1-.1 0-.2l.5-.5c.3-.3.8-.3 1.1 0l.9.9c.3.3.3.8 0 1.1z"
      }
    },
    email: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M11.5 13.9c.3.3.7.3 1 0l10.4-9.7c.2-.4.2-1-.6-1l-20.6.1c-.6 0-1.1.5-.6.9l10.4 9.7zM23.1 8c0-.5-.6-.8-.9-.4L14 15.1c-.6.5-1.3.8-2 .8s-1.4-.3-2-.8L1.9 7.6c-.4-.4-.9-.1-.9.4-.1 2.1-.1 7.7-.1 10.5 0 1 .9 1.8 1.9 1.8h18.4c1 0 1.9-.8 1.9-1.8V8z"
      }
    },
    fallback: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12.9 1.6l-1.4 6.8c0 .2.2.4.5.4h7.2c.5 0 .8.6.6 1l-7.9 12.9c-.3.7-1.3.4-1.3-.3l1.4-8c0-.2-.2-.1-.5-.1H3.9c-.5 0-.9-.8-.6-1.2l8.3-11.8c.4-.6 1.3-.4 1.3.3z"
      }
    },
    filter: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.2 1.8H1.8c-.7 0-1.1.8-.6 1.3l9 10.5c.2.3.4.8.4 1.2v6.7c0 .3.3.7.7.7h1.4c.4 0 .7-.4.7-.7v-6.7c0-.4.1-.9.4-1.2l9-10.5c.5-.5.1-1.3-.6-1.3z"
      }
    },
    flow: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M23 4.9c-.9-1.9-3.4-5.4-7.9-3.3-2.8 1.3-4.4 2-4.4 2L6.6 5.4c-1.1.5-3.6-.3-5-.8-.4-.1-.8.3-.6.7.9 1.9 3.4 5.4 7.9 3.3 2.8-1.3 8.5-3.7 8.5-3.7 1.1-.6 3.6.2 5 .7.4.1.8-.3.6-.7zm-9.7 5.9c-.5.3-2.5 1.2-2.5 1.2l-2.1.9c-1 .5-3.2-.2-4.5-.7-.3-.2-.6.3-.5.6.9 1.9 3 5.2 7 3.2 2.5-1.3 4.6-2.1 4.6-2.1 1-.6 3.2.2 4.5.7.3.1.6-.3.5-.7-.9-1.8-3-5.1-7-3.1zM11.8 19c-.4.2-1.1.6-1.1.6-.8.5-2.4-.1-3.4-.6-.2-.1-.5.3-.3.7.6 1.6 2.2 4.6 5.2 2.8l1.1-.7c.8-.4 2.4.2 3.4.6.2.2.5-.2.3-.6-.6-1.7-2.1-4.5-5.2-2.8z"
      }
    },
    follow: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M23.3 17.5h-2.1v-2c0-.4-.3-.7-.7-.7h-1.3c-.4 0-.7.3-.7.7v2h-2.1c-.4 0-.7.4-.7.7v1.4c0 .4.3.7.7.7h2.1v2.1c0 .4.3.7.7.7h1.3c.4 0 .7-.3.7-.7v-2.1h2.1c.4 0 .7-.3.7-.7v-1.4c0-.3-.3-.7-.7-.7zm-7.6-1.8h.5c.2 0 .4-.2.4-.5v-.4c0-1 .8-1.9 1.9-1.9h2c.4 0 .7-.3.7-.7V2.8c0-1-.8-1.9-1.8-1.9H2.8C1.8.9.9 1.8.9 2.8v16.6c0 1 .9 1.8 1.9 1.8h10.4c.4 0 .7-.3.6-.7v-3c0-1 .9-1.8 1.9-1.8zM12 5.1c0-.3.2-.5.5-.5h4.6c.3 0 .4.2.4.5V6c0 .3-.1.5-.4.5h-4.6c-.3 0-.5-.2-.5-.5v-.9zm0 3.7c0-.3.2-.5.5-.5h4.6c.3 0 .4.2.4.5v.9c0 .3-.1.5-.4.5h-4.6c-.3 0-.5-.2-.5-.5v-.9zM4.6 5.1c0-.3.2-.5.5-.5h4.6c.3 0 .5.2.5.5v4.6c0 .3-.2.5-.5.5H5.1c-.3 0-.5-.2-.5-.5V5.1zm7.4 12c0 .3-.2.4-.5.4H5.1c-.3 0-.5-.1-.5-.4v-.9c0-.3.2-.5.5-.5h6.4c.3 0 .5.2.5.5v.9zm-6.9-3.3c-.3 0-.5-.1-.5-.4v-.9c0-.3.2-.5.5-.5h9.2c.3 0 .5.2.5.5v.9c0 .3-.2.4-.5.4H5.1z"
      }
    },
    following: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.8 15.5l-1-1c-.2-.3-.7-.3-1 0l-4.3 4.4c-.2.2-.5.2-.7 0l-2-2.1c-.3-.2-.8-.2-1.1 0l-1 1.1c-.3.2-.3.7 0 1l3.9 3.9c.3.3.7.3 1 0l6.2-6.3c.3-.2.3-.7 0-1zm-11.4.1c.5-.5 1-.7 1.7-.8.7-.1 1.5.2 2 .7l1.1 1.1 3.3-3.4c.3-.4.8-.6 1.3-.7.2-.1.4-.3.4-.5V2.8c0-1-.8-1.9-1.9-1.9H2.8C1.8.9.9 1.8.9 2.8v16.6c0 1 .9 1.8 1.9 1.8h7.5c.5 0 .6-.5.4-.8l-.3-.2c-.9-1-.9-2.6 0-3.6l1-1zM12 5.1c0-.3.2-.5.5-.5h4.6c.3 0 .4.2.4.5V6c0 .3-.1.5-.4.5h-4.6c-.3 0-.5-.2-.5-.5v-.9zm0 3.7c0-.3.2-.5.5-.5h4.6c.3 0 .4.2.4.5v.9c0 .3-.1.5-.4.5h-4.6c-.3 0-.5-.2-.5-.5v-.9zM4.6 5.1c0-.3.2-.5.5-.5h4.6c.3 0 .5.2.5.5v4.6c0 .3-.2.5-.5.5H5.1c-.3 0-.5-.2-.5-.5V5.1zm3.7 12c0 .3-.2.4-.4.4H5.1c-.3 0-.4-.1-.4-.4v-.9c0-.3.1-.5.4-.5h2.8c.2 0 .4.2.4.5v.9zm-3.2-3.3c-.3 0-.5-.1-.5-.4v-.9c0-.3.2-.5.5-.5h9.2c.3 0 .5.2.5.5v.9c0 .3-.2.4-.5.4H5.1z"
      }
    },
    freeze_user: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M12.5 1.4c.2 0 .4.2.4.4V23c0 .3-.2.5-.4.5h-1c-.2 0-.4-.2-.4-.5V1.8c0-.2.2-.4.4-.4h1zM12 7.9L8.3 4.2c-.2-.2-.2-.5 0-.6l.6-.7c.2-.2.5-.2.7 0L12 5.4l2.4-2.5c.2-.2.5-.2.7 0l.6.7c.2.1.2.4 0 .6L12 7.9m0 9l3.7 3.8c.2.2.2.4 0 .6l-.6.7c-.2.2-.5.2-.7 0L12 19.5 9.6 22c-.2.2-.5.2-.7 0l-.6-.7c-.2-.2-.2-.4 0-.6l3.7-3.8"
      }, {
        "d": "M21.7 7.2c.2.2.1.5-.1.6L3.3 18.6c-.2.1-.5.1-.6-.2l-.5-.8c-.1-.2-.1-.5.2-.6L20.6 6.2c.3-.2.5-.1.7.2l.4.8zm-5.8 3L17.2 5c0-.2.2-.4.5-.3l.9.2c.3.1.4.3.3.6L18 8.9l3.4.8c.3.1.4.3.3.6l-.2.9c0 .2-.3.4-.5.3l-5.1-1.3m-7.8 4.5l-1.3 5.1c0 .3-.2.5-.5.4l-.9-.3c-.3 0-.4-.2-.3-.5L6 16l-3.4-.9c-.3 0-.4-.2-.3-.5l.2-.9c0-.3.3-.4.5-.3l5.1 1.3"
      }, {
        "d": "M2.7 6.4c.2-.2.4-.3.7-.2L21.6 17c.2.2.3.4.2.7l-.5.8c-.1.2-.4.3-.6.1L2.4 7.8c-.2-.1-.3-.4-.2-.6l.5-.8zm5.4 3.8L3 11.5c-.3 0-.5-.1-.6-.3l-.2-.9c0-.3.1-.5.3-.6l3.4-.8L5 5.5c0-.3.1-.5.4-.6l.8-.2c.3 0 .5.1.6.3l1.3 5.2m7.7 4.5l5.2-1.3c.2-.1.5 0 .5.3l.2.9c.1.3 0 .5-.3.5L18 16l.9 3.4c.1.3 0 .5-.3.5l-.9.3c-.3 0-.5-.1-.5-.4l-1.4-5.1"
      }]
    },
    goal: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M2.3.9C1.5.9.9 1.5.9 2.3v19.4c0 .7.6 1.4 1.4 1.4.7 0 1.4-.6 1.4-1.4V2.3c0-.8-.6-1.4-1.4-1.4zM22.5 3c-6 3.1-10.7-2.3-16.4-.2-.3.1-.6.4-.6.7v10.3c0 .6.6.9 1.1.8 5.4-1.6 10.2 3.5 16.1.3.2-.2.4-.4.4-.7V3.3c0-.3-.3-.4-.6-.3zm-1.3 10.5l-.2.1c-.5.2-1.2.2-2.4.2h-.1v-2.3c-.7 0-2-.1-2.8-.3v2.5c-.8-.2-1.5-.3-2.1-.5-.3 0-.5-.1-.7-.1v-2.6c-.8-.2-2-.4-2.7-.6v2.6c-.6-.1-.7-.1-1.3-.1h-.8l-.7.1V9.8c.4-.1 1-.1 1.6-.1.6 0 .6 0 1.2.1V7.1c-.6-.1-2.4-.1-2.8 0V4.2h.4c.5 0 1.8 0 2.4.2v2.7c.6.1 1.7.3 2.5.6h.2V5c.9.3 1.8.5 2.8.7v2.6c.8.1 2 .2 2.8.2V6h.1c.7 0 1.2-.2 2.1-.3l.6-.2v2.8c-.9.2-1.7.3-2.6.3h-.2v2.9h.1c.9 0 1.8-.3 2.7-.7v2.7zm-8.3-5.8v2.8c.2 0 .4.1.6.2.7.1 1.4.4 2.2.5V8.4c-1-.2-1.9-.5-2.8-.7z"
      }
    },
    google_news: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M23.2 2.4l-1.6 1.7c-.2.2-.5.2-.7 0L18.8 2c-.2-.2-.5-.2-.7 0l-1.6 1.6c-.2.2-.5.2-.7 0L14.2 2c-.2-.2-.5-.2-.7 0l-1.6 1.6c-.2.2-.5.2-.7 0L9.6 2c-.2-.2-.5-.2-.7 0L7.2 3.6c-.1.2-.4.2-.6 0L4.9 2c-.1-.2-.4-.2-.6 0L2.6 3.6c-.2.2-.4.2-.6 0L.8 2.4c-.3-.2-.8 0-.8.4v17.5c0 1 .8 1.9 1.8 1.9h20.4c1 0 1.8-.9 1.8-1.9V2.8c0-.4-.5-.6-.8-.4zM9.7 18.9c0 .3-.2.5-.5.5H3.7c-.3 0-.5-.2-.5-.5v-8.3c0-.3.2-.4.5-.4h5.5c.3 0 .5.1.5.4v8.3zm11.1 0c0 .3-.2.5-.5.5H12c-.3 0-.5-.2-.5-.5V18c0-.3.2-.5.5-.5h8.3c.3 0 .5.2.5.5v.9zm0-3.2h-9.3v-1.9h9.3v1.9zm0-4.2c0 .3-.2.5-.5.5H12c-.3 0-.5-.2-.5-.5v-.9c0-.3.2-.4.5-.4h8.3c.3 0 .5.1.5.4v.9zm0-3.7c0 .3-.2.5-.5.5H3.7c-.3 0-.5-.2-.5-.5v-.9c0-.3.2-.4.5-.4h16.6c.3 0 .5.1.5.4v.9z"
      }
    },
    info: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12 .9C5.9.9.9 5.9.9 12s5 11.1 11.1 11.1 11.1-5 11.1-11.1S18.1.9 12 .9zm0 5.6c.8 0 1.4.6 1.4 1.4s-.6 1.4-1.4 1.4-1.4-.6-1.4-1.4.6-1.4 1.4-1.4zm2.3 9.7c0 .2-.2.4-.5.4h-3.6c-.3 0-.5-.1-.5-.4v-.9c0-.3.2-.5.5-.5.2 0 .4-.2.4-.4v-1.9c0-.2-.2-.5-.4-.5-.3 0-.5-.1-.5-.4v-.9c0-.3.2-.5.5-.5h2.7c.3 0 .5.2.5.5v3.7c0 .2.2.4.4.4.3 0 .5.2.5.5v.9z"
      }
    },
    join_group: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M16.6 11c0-1.3-1.3-2-2.6-2.6-.9-.5-1.1-.8-1.1-1.2 0-.5.3-.8.5-1.2.6-.5.9-1.2.9-2.1 0-1.6-.9-3-2.6-3-1 0-1.7.5-2.2 1.3 1.2.8 1.9 2.4 1.9 4.1 0 1-.3 2-.8 2.8-.2.3-.1.7.2.9 1 .5 2.1 1.2 2.7 2.3.1.2.3.2.5.2h1.3c.8 0 1.3-.6 1.3-1.5zm-7.5.1c-1.1-.4-1.2-.9-1.2-1.3s.3-.9.6-1.3c.6-.6 1-1.4 1-2.4 0-1.8-1.1-3.3-2.9-3.3h-.2c-1.8 0-2.9 1.5-2.9 3.3 0 1 .3 1.8.9 2.4.4.4.7.8.7 1.3 0 .4-.2.9-1.2 1.3-1.5.7-3 1.4-3 2.8 0 1.1.7 1.8 1.6 1.8h8c.9 0 1.6-.7 1.6-1.7-.1-1.5-1.5-2.2-3-2.9zm13.3 4.6h-2.1v-2.1c0-.4-.3-.7-.7-.7h-1.4c-.3 0-.7.3-.7.7v2.1h-2c-.4 0-.7.3-.7.7v1.4c0 .3.3.7.7.7h2v2c0 .4.4.7.7.7h1.4c.4 0 .7-.3.7-.7v-2h2.1c.4 0 .7-.4.7-.7v-1.4c0-.4-.3-.7-.7-.7z"
      }
    },
    lead_convert: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12.7 13.1c-.2.2-.2.7 0 .9l1 1c.3.3.7.3 1 0l6.2-6.2c.3-.3.3-.7 0-1l-6.2-6.2c-.3-.3-.7-.3-.9 0l-1 .9c-.3.3-.3.7 0 1l2.6 2.6c.8.8-.4.8-.4.8h-3.7c-4.4 0-8.2 3.6-8.1 8 .1 4.3 3.6 7.7 7.9 7.7h1.6c.4 0 .7-.3.7-.7v-1.4c0-.3-.3-.7-.7-.7h-1.5c-2.6 0-4.9-1.9-5.2-4.5-.3-3.1 2.1-5.6 5.1-5.6H15c.4.1.5.5.3.8l-2.6 2.6z"
      }
    },
    leave_group: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M14 10.2c-.9-.4-1.1-.8-1.1-1.2 0-.4.3-.8.5-1.1.6-.5.9-1.3.9-2.1 0-1.6-.9-3-2.6-3-1 0-1.7.5-2.2 1.2 1.2.9 1.9 2.4 1.9 4.2 0 1-.3 2-.8 2.8-.2.3-.1.7.2.9 1 .5 2.1 1.1 2.7 2.2.1.2.3.3.5.3h1.3c.8 0 1.3-.6 1.3-1.5 0-1.3-1.3-2.1-2.6-2.7zM9.1 13c-1.1-.5-1.2-.9-1.2-1.4s.3-.9.6-1.2c.6-.6 1-1.4 1-2.4 0-1.8-1.1-3.4-2.9-3.4h-.2C4.5 4.6 3.5 6.2 3.5 8c0 1 .3 1.8.9 2.4.4.3.6.8.6 1.2 0 .5-.1.9-1.2 1.4-1.5.7-2.9 1.4-3 2.8.1 1 .8 1.7 1.7 1.7h8c.9 0 1.6-.7 1.6-1.7-.1-1.4-1.5-2.1-3-2.8zM14.8 19.6v-1.4c0-.3.3-.7.7-.7h6.9c.4 0 .7.4.7.7v1.4c0 .4-.3.7-.7.7h-6.9c-.4 0-.7-.3-.7-.7z"
      }
    },
    log_a_call: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M19.8.9H5.9C4.6.9 3.6 2 3.6 3.1v.8h-.7c-.9 0-1.5.6-1.5 1.5S2 6.8 2.9 6.8h.7v3.7h-.7c-.9 0-1.5.7-1.5 1.5s.6 1.5 1.5 1.5h.7v3.7h-.7c-.9 0-1.5.6-1.5 1.4 0 .9.6 1.5 1.5 1.5h.7v.8c0 1.1 1 2.2 2.3 2.2h13.9c1.2 0 2.4-1.1 2.4-2.3V3c0-1.2-1.2-2.1-2.4-2.1zm-1.3 14.9l-1.1 1c-.2.2-.5.4-.8.3-2.4-.1-4.7-1.2-6.4-2.8s-2.7-4-2.8-6.4c0-.3.1-.7.3-.8l1-1.1c.5-.4 1.3-.4 1.7.1l1 1.2c.3.5.3 1 0 1.4l-.8 1.2c-.1.2-.1.4.1.5l1.7 1.9 1.9 1.7c.1.1.3.1.4 0l1.2-.8c.4-.3 1-.3 1.4 0l1.2 1c.4.3.5 1.1 0 1.6z"
      }
    },
    log_event: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.9 18.6l-2.3.7c-.1 0-.4.1-.6.1-.6 0-1.2-.3-1.7-.8-.4-.6-.5-1.3-.3-1.9l.7-2.7 3.5-3.4c.1-.2 0-.4-.2-.4H2.5c-.3 0-.7.3-.7.6v8.6c0 1 .9 1.8 1.9 1.8h12.9c1 0 1.9-.8 1.9-1.8V19c0-.3-.4-.5-.6-.4zM2.5 8.3h15.3c.3 0 .7-.3.7-.7V6.5c0-1.1-.9-1.9-1.9-1.9h-1.4v-.4c0-.8-.6-1.4-1.4-1.4-.7 0-1.3.6-1.3 1.4v.4H7.8v-.4c0-.8-.6-1.4-1.3-1.4-.8 0-1.4.6-1.4 1.4v.4H3.7c-1 0-1.9.8-1.9 1.9v1.1c0 .4.4.7.7.7zm17.6 2.4c-.1-.1-.3-.1-.3 0L15.4 15l-.6 2.2c-.1.2.1.4.3.3l2.2-.6 4.3-4.3c.1-.1.1-.3 0-.4l-1.5-1.5zm3.7-1.4l-.9-.8c-.2-.3-.7-.3-1.1 0 0 0-.5.5-.7.8-.1.1-.1.2 0 .3l1.6 1.6c.1.1.2.1.3 0l.8-.8c.3-.2.3-.8 0-1.1z"
      }
    },
    manage_perm_sets: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M20.8.9H3.2C1.9.9.9 1.9.9 3.2v17.6c0 1.2 1 2.3 2.3 2.3h17.6c1.2 0 2.3-1 2.3-2.3V3.2c0-1.3-1-2.3-2.3-2.3zM20 20.8H4c-.4 0-.8-.4-.8-.8V4c0-.4.4-.8.8-.8h16c.4 0 .8.4.8.8v16c0 .4-.4.8-.8.8zM10.1 5.5H6.3c-.4 0-.8.3-.8.8v3.8c0 .4.3.8.8.8h3.8c.4 0 .8-.3.8-.8V6.3c-.1-.4-.4-.8-.8-.8zm7.6 0h-3.8c-.4 0-.8.3-.8.8v3.8c0 .4.3.8.8.8h3.8c.4 0 .8-.3.8-.8V6.3c0-.4-.4-.8-.8-.8zm-7.6 7.7H6.3c-.4 0-.8.3-.8.7v3.9c0 .4.3.8.8.8h3.8c.4 0 .8-.4.8-.8v-3.9c-.1-.4-.4-.7-.8-.7zm7.6 0h-3.8c-.4 0-.8.3-.8.7v3.9c0 .4.3.8.8.8h3.8c.4 0 .8-.4.8-.8v-3.9c0-.4-.4-.7-.8-.7z"
      }
    },
    map: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.5 4.4l-6.6-3.3c-.3-.2-.7-.2-1 0L8.8 4.2 2.6 1.1c-.4-.2-.8-.2-1.2 0-.3.2-.5.6-.5.9v16.6c0 .5.3.8.6 1l6.7 3.3c.3.2.7.2.9 0l6.2-3.1 6.2 3.1c.1.1.3.2.5.2s.4-.1.6-.2c.3-.2.5-.6.5-.9V5.4c0-.5-.2-.8-.6-1zm-1.7 2.1v8.8c0 .5-.5.9-1 .7-1.7-.7-.3-3.5-1.5-5.1-1.2-1.4-2.7 0-4.1-2.2-1.3-2.2.5-3.8 2.1-4.6.3-.1.5-.1.7 0l3.4 1.7c.3.2.4.4.4.7zm-9.3 12.8c-.3.2-.6.1-.8-.1-.5-.4-.9-1-.9-1.7 0-1.1-1.8-.7-1.8-2.9 0-1.8-2.1-2.3-3.9-2.1-.5.1-.8-.3-.8-.7V5c0-.5.5-.9 1-.6l4 2h.1l.1.1c1.7 1 1.3 1.8.6 3-.7 1.3-1.1 0-2.2-.4s-2.2.4-1.8 1.1 1.5 0 2.2.7.7 1.9 2.9 1.1 2.6-.3 3.4.4c.7.8 1.1 2.2 0 3.3-.7.7-1 2.1-1.2 3-.1.2-.2.4-.4.5l-.5.1z"
      }
    },
    more: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M3.7 9.2c1.5 0 2.8 1.3 2.8 2.8s-1.3 2.8-2.8 2.8S.9 13.5.9 12s1.3-2.8 2.8-2.8zm8.3 0c1.5 0 2.8 1.3 2.8 2.8s-1.3 2.8-2.8 2.8-2.8-1.3-2.8-2.8 1.3-2.8 2.8-2.8zm8.3 0c1.5 0 2.8 1.3 2.8 2.8s-1.3 2.8-2.8 2.8-2.8-1.3-2.8-2.8 1.3-2.8 2.8-2.8z"
      }
    },
    new: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M13.8 13.4h7.7c.3 0 .7-.3.7-.7v-1.4c0-.4-.4-.7-.7-.7h-7.7c-.2 0-.4-.2-.4-.4V2.5c0-.3-.3-.7-.7-.7h-1.4c-.4 0-.7.4-.7.7v7.7c0 .2-.2.4-.4.4H2.5c-.3 0-.7.3-.7.7v1.4c0 .4.4.7.7.7h7.7c.2 0 .4.2.4.4v7.7c0 .3.3.7.7.7h1.4c.4 0 .7-.4.7-.7v-7.7c0-.2.2-.4.4-.4z"
      }
    },
    new_account: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M23.1 12.4c0-.8-.6-1-.8-1H14c-.8 0-.8.8-.8.8v9h9.9v-8.8zm-5.7 6.5c0 .4-.4.8-.8.8h-.8c-.4 0-.8-.4-.8-.8v-.8c0-.4.3-.8.8-.8h.8c.4 0 .8.4.8.8v.8zm0-3.9c0 .4-.4.7-.8.7h-.8c-.4 0-.8-.3-.8-.7v-.8c0-.4.3-.8.8-.8h.8c.4 0 .8.4.8.8v.8zm3.8 3.9c0 .4-.3.8-.8.8h-.8c-.4 0-.8-.4-.8-.8v-.8c0-.4.4-.8.8-.8h.8c.4 0 .8.4.8.8v.8zm0-3.9c0 .4-.3.7-.8.7h-.8c-.4 0-.8-.3-.8-.7v-.8c0-.4.4-.8.8-.8h.8c.4 0 .8.4.8.8v.8zm-5.8-6.7V3.8c.1-.8-.5-1-.7-1H1.8c-.8 0-.9.8-.9.8v17.6h9.9V10s0-1 .9-1h3c.4 0 .7-.4.7-.7zM5.1 18.5c0 .4-.3.8-.8.8h-.7c-.4 0-.8-.4-.8-.8v-.8c0-.4.3-.8.8-.8h.8c.4 0 .8.4.8.8v.8zm0-4c0 .5-.3.8-.8.8h-.7c-.4 0-.8-.3-.8-.8v-.7c0-.5.3-.8.8-.8h.8c.4 0 .8.3.8.8v.7zm0-3.9c0 .4-.3.8-.8.8h-.7c-.4 0-.8-.4-.8-.8v-.8c0-.4.3-.8.8-.8h.8c.4 0 .8.4.8.8v.8zm0-3.9c0 .4-.3.8-.8.8h-.7c-.4 0-.8-.4-.8-.8v-.8c0-.4.3-.8.8-.8h.8c.4 0 .8.4.8.8v.8zm4.2 11.8c0 .4-.3.8-.8.8h-.7c-.5 0-.8-.4-.8-.8v-.8c0-.4.3-.8.8-.8h.7c.5 0 .8.4.8.8v.8zm0-4c0 .5-.3.8-.8.8h-.7c-.5 0-.8-.3-.8-.8v-.7c0-.5.3-.8.8-.8h.7c.5 0 .8.3.8.8v.7zm0-3.9c0 .4-.3.8-.8.8h-.7c-.5 0-.8-.4-.8-.8v-.8c0-.4.3-.8.8-.8h.7c.5 0 .8.4.8.8v.8zm0-3.9c0 .4-.3.8-.8.8h-.7c-.5 0-.8-.4-.8-.8v-.8c0-.4.3-.8.8-.8h.7c.5 0 .8.4.8.8v.8zm4.2 0c0 .4-.3.8-.8.8H12c-.4 0-.8-.4-.8-.8v-.8c0-.4.3-.8.8-.8h.8c.4 0 .8.4.8.8v.8z"
      }
    },
    new_campaign: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12 .9C5.9.9.9 5.9.9 12s5 11.1 11.1 11.1 11.1-5 11.1-11.1S18.1.9 12 .9zm0 19.4c-4.6 0-8.3-3.7-8.3-8.3S7.4 3.7 12 3.7s8.3 3.7 8.3 8.3-3.7 8.3-8.3 8.3zm0-14.8c-3.6 0-6.5 2.9-6.5 6.5s2.9 6.5 6.5 6.5 6.5-2.9 6.5-6.5-2.9-6.5-6.5-6.5zm0 10.2c-2 0-3.7-1.7-3.7-3.7S10 8.3 12 8.3s3.7 1.7 3.7 3.7-1.7 3.7-3.7 3.7zm0-5.5c-1 0-1.8.8-1.8 1.8s.8 1.8 1.8 1.8 1.8-.8 1.8-1.8-.8-1.8-1.8-1.8z"
      }
    },
    new_case: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M6.9 6h1.9c.2 0 .4-.2.4-.5v-.9h5.6v.9c0 .3.2.5.4.5h1.9c.3 0 .4-.2.4-.5V4.4c0-1.4-1.1-2.6-2.5-2.6H9C7.6 1.8 6.5 3 6.5 4.3v1.2c0 .3.1.5.4.5zm14.3 1.8H2.8c-1 0-1.9.9-1.9 1.9v10.6c0 1 .9 1.9 1.9 1.9h18.4c1 0 1.9-.9 1.9-1.9V9.7c0-1-.9-1.9-1.9-1.9z"
      }
    },
    new_child_case: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M6.9 5.1h1.9c.2 0 .4-.2.4-.5v-.9h4.6v.9c0 .3.2.5.5.5h1.9c.2 0 .4-.2.4-.5V3.5c0-1.4-1.1-2.6-2.5-2.6H9C7.6.9 6.5 2 6.5 3.4v1.2c0 .3.1.5.4.5zm7.9 10.6h.9v-.9c0-1 .8-1.9 1.8-1.9h2.8c.6 0 1.1.3 1.4.7.2.2.5.1.5-.1V8.8c0-1-.9-1.9-1.9-1.9H2.8c-1 0-1.9.9-1.9 1.9v10.6c0 1 .9 1.8 1.9 1.8h10c.2 0 .3-.1.3-.3-.1-.2-.2-.4-.2-.6v-2.8c0-1 .9-1.8 1.9-1.8zm7.6 1.8h-2.1v-2c0-.4-.3-.7-.7-.7h-1.4c-.3 0-.7.3-.7.7v2h-2c-.4 0-.7.4-.7.7v1.4c0 .4.3.7.7.7h2v2.1c0 .4.4.7.7.7h1.4c.4 0 .7-.3.7-.7v-2.1h2.1c.4 0 .7-.3.7-.7v-1.4c0-.3-.3-.7-.7-.7z"
      }
    },
    new_contact: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M21.2 4.2H2.8C1.5 4.2.5 5.2.5 6.5v11c0 1.3 1 2.3 2.3 2.3h18.4c1.3 0 2.3-1 2.3-2.3v-11c0-1.3-1-2.3-2.3-2.3zm-9.8 13H4.8c-.7 0-1.3-.8-1.3-1.6.1-1.2 1.3-1.8 2.5-2.4.9-.4 1-.7 1-1.1 0-.4-.2-.7-.5-1-.5-.5-.8-1.2-.8-1.9 0-1.5.9-2.7 2.4-2.7s2.4 1.3 2.4 2.7c0 .8-.3 1.5-.8 1.9-.3.3-.6.6-.6 1s.1.7 1.1 1.1c1.2.5 2.4 1.2 2.4 2.4.2.8-.4 1.6-1.2 1.6zm9-2.7c0 .4-.3.8-.7.8h-3.5c-.4 0-.8-.3-.8-.8v-1.2c0-.4.4-.7.8-.7h3.5c.4 0 .7.3.7.7v1.2zm0-4.2c0 .4-.3.8-.7.8h-5.8c-.4 0-.7-.3-.7-.8V9.1c0-.4.3-.7.7-.7h5.8c.4 0 .8.3.8.7v1.2z"
      }
    },
    new_custom1: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M13.6 21c-.9.9-2.3.9-3.2 0-2.7-2.8-7.8-8.2-7.8-8.2-2.3-2.4-2.3-6.3 0-8.7C3.7 3 5.2 2.3 6.8 2.3s3 .6 4.1 1.8l.5.6c.3.3.9.3 1.2 0l.4-.5c1.2-1.2 2.6-1.9 4.2-1.9 1.5 0 3 .6 4.1 1.8 2.3 2.4 2.3 6.3 0 8.7 0 0-5 5.4-7.7 8.2z"
      }
    },
    new_custom10: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M19.4 22.3c-3.5 1.4-9.1 1-12.1-2.2C0 12.3 6.4.9 15.2.9c1.5 0 2.8.3 4.2.9.5.2.6.9.1 1.2-2.8 2-4.7 5.3-4.7 9s1.9 7 4.7 9c.5.3.4 1.1-.1 1.3z"
      }
    },
    new_custom100: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M16.4 19.2H7.6c-.3 0-.4.2-.4.5.4 1.4 2.4 2.5 4.8 2.5s4.3-1.1 4.7-2.5c.1-.3-.1-.5-.3-.5zm4.5-17.4H3.1C1.9 1.8.9 2.9.9 4.1v10.5c0 1.3 1 2.3 2.2 2.3h17.8c1.2 0 2.2-1 2.2-2.3V4.1c0-1.2-1-2.3-2.2-2.3zm0 12.1c0 .4-.4.7-.8.7H3.9c-.4 0-.8-.3-.8-.7V4.8c0-.4.4-.7.8-.7h16.2c.4 0 .8.3.8.7v9.1z"
      }
    },
    new_custom11: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12.8 1.4l3 6.3 6.5 1c.8.1 1.1 1 .5 1.5L18 15.1l1.2 6.9c0 .8-.7 1.4-1.3 1L12 19.8 6.1 23c-.6.4-1.4-.2-1.3-1L6 15.1l-4.8-4.9c-.5-.5-.2-1.4.5-1.5l6.5-1 3-6.3c.3-.7 1.3-.7 1.6 0z"
      }
    },
    new_custom12: {
      "xmlns": "http://www.w3.org/2000/svg",
      "circle": {
        "cx": "12",
        "cy": "12",
        "r": "11.077"
      }
    },
    new_custom13: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M20.9 1.8H3.1C1.9 1.8.9 2.8.9 4v2.2c0 .4.3.7.8.7h20.6c.5 0 .8-.3.8-.7V4c0-1.2-1-2.2-2.2-2.2zm0 7.3H3.1c-.4 0-.7.3-.7.7V20c0 1.2 1 2.2 2.2 2.2h14.8c1.2 0 2.2-1 2.2-2.2V9.8c0-.4-.3-.7-.7-.7zm-4.8 3.3c0 .6-.5 1.1-1.1 1.1H9c-.6 0-1.1-.5-1.1-1.1 0-.6.5-1.1 1.1-1.1h6c.6 0 1.1.4 1.1 1.1z"
      }
    },
    new_custom14: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.3 5.4h-2.2c-.4 0-.9-.2-1.3-.6L17 3.3c-.3-.3-.8-.5-1.3-.5h-4.3c-.6 0-1.1.2-1.5.6L7.6 5.3c-.2.1-.2.5-.1.7l.7.6c.5.4 1.1.5 1.6.1l2-1.2c.3-.2.7-.1.8.1l6.4 6.3c.2.1.3.3.3.6v1.6c0 .5.3.9.7.9h2.2c.5 0 .8-.3.8-.7V6.1c.1-.4-.2-.7-.7-.7zm-6.2 6.7l-4-3.9-1.1.7c-.6.3-1.2.5-1.8.5-.8 0-1.6-.3-2.2-.9L5.5 7.4c-.3-.3-.5-.6-.6-1-.1-.4-.3-.6-.7-.6H1.7c-.5 0-.8.2-.8.6v6.8c0 .5.3.7.8.7h1.4c.1 0 .3-.4.5-.6.5-.7 1.3-1.1 2.2-1.3.9 0 1.8.3 2.5.9l4.6 4.3c.4.3.7.8.9 1.3 0 .2.4.3.6.1l1.7-1.8c.9-.8 1.6-3 .7-3.9l-.7-.8zm-9.3 2.8c-.5-.5-1.2-.4-1.6.1-.4.5-.3 1.3.2 1.7l4.6 4.2c.2.2.5.3.8.3.3-.1.6-.2.7-.5.5-.5.4-1.3-.1-1.7l-4.6-4.1z"
      }
    },
    new_custom15: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M19.4 10.6c-1.3-.6-1.5-1-1.5-1.6 0-.6.4-1 .8-1.4.8-.7 1.2-1.7 1.2-2.8 0-2.1-1.3-3.9-3.6-3.9-2 0-3.2 1.4-3.6 3.1 0 .1.1.2.2.3 1.6 1.2 2.7 3.2 2.7 5.6 0 1.7-.6 3.2-1.6 4.4-.2.1-.1.4.1.6.7.2 1.4.6 2.1 1 .3.1.5.2.8.2h4.2c1 0 1.9-.8 1.9-1.8V14c0-1.7-1.8-2.6-3.7-3.4zm-6.6 6.1c-1.6-.7-1.8-1.2-1.8-1.9s.5-1.2 1-1.7c.9-.8 1.4-1.9 1.4-3.2 0-2.5-1.6-4.5-4.3-4.5S4.8 7.5 4.8 9.9c0 1.3.5 2.4 1.4 3.2.5.5 1 1.1 1 1.7 0 .7-.3 1.2-1.8 1.9-2.3.9-4.4 1.9-4.4 3.9v.4c-.1 1.1.9 2.1 2.2 2.1H15c1.2 0 2.2-1 2.2-2.1v-.4c0-2-2.2-3-4.4-3.9z"
      }
    },
    new_custom16: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M20 19.4h-.4v-8.1c0-.5-.3-.8-.7-.8h-.8c-.4 0-.7.3-.7.8v8.1h-2.2v-8.1c0-.5-.3-.8-.7-.8h-.7c-.5 0-.8.3-.8.8v8.1h-2.2v-8.1c0-.5-.3-.8-.7-.8h-.7c-.4 0-.8.3-.8.8v8.1H6.5v-8.1c0-.5-.4-.8-.8-.8H5c-.4 0-.8.3-.8.8v8.1H4c-1.2 0-2.2 1-2.2 2.2v.7c0 .5.4.8.8.8h18.9c.4 0 .7-.3.7-.8v-.7c0-1.2-1-2.2-2.2-2.2zm1.8-13.2l-9-5c-.2-.2-.5-.3-.8-.3-.3 0-.6.1-.8.3l-9 5c-.2.2-.4.4-.4.7v.7c0 .4.4.7.8.7h18.9c.4 0 .7-.3.7-.7v-.7c0-.3-.2-.5-.4-.7zm-9.8.6c-1 0-1.8-.8-1.8-1.8S11 3.1 12 3.1s1.8.9 1.8 1.9S13 6.8 12 6.8z"
      }
    },
    new_custom17: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M9.5 4.2c.1.3.3.4.6.4h3.7c.3 0 .6-.1.7-.4L16 1.5c.1-.3-.1-.5-.4-.5H8.4c-.3 0-.5.2-.3.5l1.4 2.7zm4.7 2.6H9.8c-3.6 0-6.6 3-6.6 6.7v7.4c0 1.2 1 2.2 2.2 2.2h13.2c1.2 0 2.2-1 2.2-2.2v-7.4c0-3.7-3-6.7-6.6-6.7zm-1.1 12.4v1.3c0 .2-.2.4-.5.4h-1.4c-.3 0-.3-.2-.3-.4v-1.2c-1.1-.2-2-.7-2.3-.9-.2-.3-.3-.5-.1-.9l.5-.7c0-.2.3-.3.5-.3.1 0 .3.1.4.1.8.5 1.4.7 1.9.7s.9-.3.9-.6c0-.2-.1-.6-1.5-1.1-1.3-.4-2.8-1.2-2.8-2.9 0-1 .6-2.1 2.5-2.5V9.1c0-.2.1-.4.3-.4h1.4c.3 0 .5.2.5.4v1.1c.7.1 1.5.5 1.8.7.1.1.2.3.3.5 0 .1-.1.3-.2.4l-.5.7c-.1.1-.4.3-.6.3-.1 0-.2-.1-.3-.1-.8-.4-1.4-.7-1.8-.7-.6 0-.9.3-.9.5 0 .3.2.6 1.4 1 1.5.5 3.3 1.4 3.3 3.1-.1 1.3-1.1 2.3-2.5 2.6z"
      }
    },
    new_custom18: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M14.5 7.1h3.8c.3 0 .5-.3.5-.5s-.1-.3-.2-.4l-4.7-4.7c-.1-.1-.2-.1-.3-.1-.3 0-.5.2-.5.5v3.7c0 .8.6 1.5 1.4 1.5zm8.3 4.8l-.4-.5c-.2-.2-.7-.2-1 0l-5.5 5.5v1.3c0 .1 0 .2.1.2h1.4l5.4-5.5c.4-.3.4-.8 0-1zm-4.4 8.6h-3.3c-.7 0-1.3-.6-1.3-1.3v-2.5c0-.4.1-.8.4-1l4.4-4.4c.1-.1.2-.3.2-.5v-.9c0-.4-.3-.7-.7-.7h-5c-1.2 0-2.2-1-2.2-2.1v-5c0-.4-.3-.7-.7-.7H3C1.9 1.4.9 2.4.9 3.5v17c0 1.1 1 2.1 2.1 2.1h13.6c1 0 2-.7 2.1-1.7.1-.2-.1-.4-.3-.4zM3.8 7.8c0-.4.3-.7.7-.7h2.8c.5 0 .7.3.7.7v.6c0 .4-.3.7-.7.7H4.5c-.4 0-.7-.3-.7-.7v-.6zm7.1 9.1c0 .4-.3.7-.7.7H4.5c-.4 0-.7-.3-.7-.7v-.7c0-.3.3-.6.7-.6h5.7c.4 0 .7.3.7.6v.7zm1.5-4.2c0 .4-.4.7-.7.7H4.5c-.4 0-.7-.3-.7-.7V12c0-.4.3-.7.7-.7h7.1c.4 0 .7.3.7.7v.7z"
      }
    },
    new_custom19: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.8 5.6c-.1-.2-.4-.3-.6-.1l-3.8 3.7c-.3.3-.7.3-1 0l-2.6-2.6c-.3-.3-.3-.7 0-1l3.8-3.8c.1-.1 0-.5-.2-.6-.6-.2-1.3-.3-2-.3-3.9 0-7 3.4-6.6 7.4.1.7.3 1.2.5 1.8l-8.6 8.5c-1.1 1.1-1.1 2.7 0 3.7.5.5 1.2.8 1.8.8s1.3-.3 1.9-.8l8.5-8.6c.6.2 1.2.4 1.8.5 4 .4 7.4-2.7 7.4-6.6 0-.7-.1-1.4-.3-2z"
      }
    },
    new_custom2: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": {
          "d": "M15.4 1.6C14.3.9 10.2.2 8.7 2.7c-.7 1.2.2 3.4.9 4.8.1.3.5.5.9.3.4-.1 1-.2 1.6-.2.4 0 .7 0 1.1.1.3.1.6-.1.8-.4.3-.4.7-1 1.5-1.6 1.7-1.5 1-3.3-.1-4.1zm-2 14.6c-.4.1-.9.2-1.4.2-.5 0-.9-.1-1.3-.2-.3 0-.7.1-.8.4-.3.5-.7 1.1-1.5 1.7-1.8 1.5-1.1 3.3 0 4.1s5.2 1.4 6.7-1.1c.7-1.2-.1-3.3-.8-4.7-.2-.4-.5-.5-.9-.4zm7.9-7.6c-1.2-.7-3.4.2-4.8.9-.3.1-.5.5-.3.9.1.4.2 1 .2 1.6 0 .4 0 .7-.1 1.1-.1.3.1.7.4.8.4.3 1 .7 1.6 1.5 1.5 1.8 3.3 1.1 4 0s1.5-5.2-1-6.8zM7.8 13.4c-.1-.5-.2-.9-.2-1.4 0-.5.1-.9.2-1.3 0-.4-.1-.7-.4-.9-.5-.2-1.1-.7-1.7-1.4-1.5-1.8-3.3-1.1-4.1 0S.2 13.5 2.7 15c1.2.7 3.3 0 4.7-.7.4-.2.5-.6.4-.9z"
        },
        "circle": {
          "cx": "12",
          "cy": "12",
          "r": "2.215"
        }
      }
    },
    new_custom20: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M7.6 11.2c0-.3-.4-.5-.6-.3l-5.2 3.9c-.6.4-.9 1.1-.9 1.8v1.5c0 .3.3.5.5.4l5.7-2.2c.2-.1.4-.3.4-.7.1 0 .1-4.4.1-4.4zm8.1 10.3l-1.5-1.1V3.7c0-1-1-2.1-1.7-2.6-.3-.3-.7-.3-1 0-.6.5-1.7 1.6-1.7 2.6v16.8l-1.7 1.1c-.3.2-.5.6-.5.9v.3c0 .1.1.3.3.3h8.2c.1 0 .4-.2.4-.3-.1-.6-.3-1-.8-1.3zm6.5-6.7l-5.2-4c-.2-.1-.6 0-.6.3v4.5c0 .3.2.6.5.7l5.7 2.2c.3.1.5-.1.5-.3v-1.5c0-.8-.3-1.5-.9-1.9z"
      }
    },
    new_custom21: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M14.8 19.8c-.1-.3-.4-.4-.6-.4H9.9c-.3 0-.6.1-.7.4l-1 2.7c-.1.3.1.5.3.5h7c.2 0 .4-.2.3-.5l-1-2.7zM20.9.9H3.1C1.9.9.9 1.9.9 3.1V15c0 1.2 1 2.2 2.2 2.2h17.8c1.2 0 2.2-1 2.2-2.2V3.1c0-1.2-1-2.2-2.2-2.2zM12 16.4c-.6 0-1.1-.4-1.1-1.1s.5-1.1 1.1-1.1 1.1.5 1.1 1.1-.5 1.1-1.1 1.1zm8.9-3.7c0 .5-.4.8-.8.8H3.9c-.4 0-.8-.3-.8-.8V3.9c0-.4.4-.8.8-.8h16.2c.4 0 .8.4.8.8v8.8z"
      }
    },
    new_custom22: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.2 17.1l-2.3-1.8c-.8-.7-1.9-.7-2.7-.1L15 16.8c-.2.2-.6.1-.9-.1l-3.6-3.3-3.3-3.6c-.3-.2-.3-.6-.1-.9l1.6-2.2c.6-.8.5-1.9-.1-2.7L6.7 1.7C6 .7 4.5.6 3.6 1.5l-2 2.1c-.5.4-.7 1-.7 1.6.3 4.7 2.4 9.2 5.6 12.3s7.5 5.3 12.2 5.6c.7 0 1.2-.3 1.7-.7l2-2c1-.9.9-2.4-.2-3.3z"
      }
    },
    new_custom23: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M11.5 14.1c.3.3.7.3 1.1 0L23 4.6c.2-.4.1-.9-.6-.9H1.7c-.5 0-1 .5-.6 1l10.4 9.4zm11.6-5.4c0-.5-.6-.8-.9-.4L14 15.7c-.5.5-1.2.8-2 .8-.7 0-1.4-.3-1.9-.8L1.9 8.3c-.4-.3-.9-.1-.9.4v9.4c0 1.2 1 2.2 2.2 2.2h17.7c1.2 0 2.2-1 2.2-2.2V8.7z"
      }
    },
    new_custom24: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.6.9H5.4c-1.2 0-2.2 1-2.2 2.2 0 .5.4.8.8.8h16c.4 0 .8-.3.8-.8 0-1.2-1-2.2-2.2-2.2zm0 5.2H5.4c-.4 0-.7.3-.7.7v15.5c0 .5.3.8.7.8h4.1c.4 0 .7-.3.7-.8v-2.9c0-.4.4-.8.8-.8h2.1c.4 0 .8.4.8.8v2.9c0 .5.3.8.7.8h4c.5 0 .8-.3.8-.8V6.8c-.1-.4-.4-.7-.8-.7zm-7.7 10c0 .4-.3.7-.7.7H8.7c-.4 0-.8-.3-.8-.7v-1.5c0-.4.4-.8.8-.8h1.5c.4 0 .7.4.7.8v1.5zm0-5.2c0 .4-.3.7-.7.7H8.7c-.4 0-.8-.3-.8-.7V9.4c0-.4.4-.7.8-.7h1.5c.4 0 .7.3.7.7v1.5zm5.1 5.2c0 .4-.3.7-.7.7h-1.5c-.4 0-.7-.3-.7-.7v-1.5c0-.4.3-.8.7-.8h1.5c.4 0 .8.4.8.8v1.5zm0-5.2c0 .4-.3.7-.7.7h-1.5c-.4 0-.7-.3-.7-.7V9.4c0-.4.3-.7.7-.7h1.5c.4 0 .8.3.8.7v1.5z"
      }
    },
    new_custom25: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M23 3.6c-.3-1.4-1.4-2.5-2.8-2.7-1-.1-2 .2-2.7.8-.2.1-.1.4.1.6 1.7.9 3.2 2.2 4.3 3.7.1.3.4.3.6 0 .5-.6.7-1.5.5-2.4zM6.3 2.3c.3-.1.3-.5.1-.6-.7-.6-1.6-.9-2.6-.8-1.4.2-2.6 1.3-2.8 2.7-.2.9 0 1.8.4 2.4.2.2.5.2.7 0 1.1-1.5 2.5-2.8 4.2-3.7zm5.7.8c-5.5 0-10 4.5-10 10 0 2.2.8 4.3 2 5.9l-1.6 1.5c-.6.6-.6 1.6 0 2.2.3.2.7.4 1.1.4s.7-.1 1-.4L6 21.1c1.7 1.2 3.8 2 6 2s4.3-.8 5.9-2l1.5 1.6c.4.2.7.4 1.1.4s.7-.1 1-.4c.6-.6.6-1.6 0-2.2L20 19c1.2-1.6 1.9-3.7 1.9-5.9.1-5.5-4.4-10-9.9-10zm-7 10c0-3.9 3.1-7 7-7s7 3.1 7 7-3.1 7-7 7-7-3.1-7-7zm8.1-.5V9.8c0-.7-.5-1.1-1.1-1.1s-1.1.4-1.1 1.1v3.3c0 .3.1.6.3.8l2.6 2.6c.2.2.5.3.8.3s.5-.1.8-.3c.4-.5.4-1.2 0-1.6l-2.3-2.3z"
      }
    },
    new_custom26: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M3.1.9C1.9.9.9 1.9.9 3.1c0 .7.3 1.3.8 1.7v16.8c0 .8.6 1.5 1.4 1.5.9 0 1.5-.7 1.5-1.5V4.8c.5-.4.8-1 .8-1.7C5.4 1.9 4.3.9 3.1.9zm19.4 4c-5.8 3-9.7-2.2-15.2-.2-.3.1-.5.4-.5.7v9.5c0 .5.5.8 1 .7 5.3-1.6 9.2 3.4 14.9.2.2-.1.4-.3.4-.6V5.3c0-.4-.3-.5-.6-.4z"
      }
    },
    new_custom27: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M3 16.4h18c.4 0 .7-.3.7-.7V4.8c0-1.1-.9-2-2.1-2H4.4c-1.2 0-2.1.9-2.1 2v10.9c0 .5.3.7.7.7zM4.4 5.5c0-.4.3-.7.7-.7h13.8c.4 0 .7.3.7.7v8.2c0 .4-.3.7-.7.7H5.1c-.4 0-.7-.3-.7-.7V5.5zm18 13h-7.6c-.4 0-.7.3-.7.7s-.3.7-.7.7h-2.8c-.4 0-.7-.3-.7-.7s-.3-.7-.7-.7H1.6c-.4 0-.7.3-.7.7 0 1.1.9 2 2.1 2h18c1.2 0 2.1-.9 2.1-2 0-.4-.3-.7-.7-.7z"
      }
    },
    new_custom28: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.2.9H6.8c-1.2 0-2.2 1-2.2 2.2v17.8c0 1.2 1 2.2 2.2 2.2h10.4c1.2 0 2.2-1 2.2-2.2V3.1c0-1.2-1-2.2-2.2-2.2zM12 22.3c-.6 0-1.1-.4-1.1-1.1s.5-1.1 1.1-1.1 1.1.5 1.1 1.1-.5 1.1-1.1 1.1zm5.2-3.7c0 .5-.4.8-.8.8H7.6c-.4 0-.8-.3-.8-.8v-14c0-.4.4-.7.8-.7h8.8c.4 0 .8.3.8.7v14z"
      }
    },
    new_custom29: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M20.9 3.9h-.7c-.4 0-.8.3-.8.8v14.7s0 .1.1.1l.9 1.3c.1.1.2.1.3 0l.9-1.3c.1 0 .1 0 .1-.1V4.7c0-.5-.3-.8-.8-.8zM15 .9H4.5c-1.2 0-2.2 1-2.2 2.2v17.8c0 1.2 1 2.2 2.2 2.2H15c1.2 0 2.2-1 2.2-2.2V3.1c0-1.2-1-2.2-2.2-2.2zM9.8 22.3c-.7 0-1.1-.4-1.1-1.1s.4-1.1 1.1-1.1 1.1.5 1.1 1.1-.5 1.1-1.1 1.1zm5.2-3.7c0 .5-.3.8-.7.8h-9c-.4 0-.7-.3-.7-.8v-14c0-.4.3-.7.7-.7h9c.4 0 .7.3.7.7v14z"
      }
    },
    new_custom3: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12 7.6c-2.4 0-4.4 2-4.4 4.4s2 4.4 4.4 4.4 4.4-2 4.4-4.4-2-4.4-4.4-4.4zM23.1 12c0-1.3-3.1-1.9-3.6-3.1-.5-1.2 1.2-3.8.3-4.7s-3.5.8-4.7.3C13.9 4 13.3.9 12 .9S10.1 4 8.9 4.5c-1.2.5-3.8-1.2-4.7-.3s.8 3.5.3 4.7C4 10.1.9 10.7.9 12s3.1 1.9 3.6 3.1c.5 1.2-1.2 3.8-.3 4.7.8.9 3.5-.8 4.7-.3 1.1.5 1.8 3.6 3.1 3.6s1.9-3.1 3-3.6c1.2-.4 3.9 1.2 4.8.3.8-.8-.9-3.5-.4-4.7.6-1.2 3.7-1.8 3.7-3.1zM12 18.6c-3.6 0-6.6-3-6.6-6.6s3-6.6 6.6-6.6 6.6 3 6.6 6.6-3 6.6-6.6 6.6z"
      }
    },
    new_custom30: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M19.9 4.1C17.9 2 15.2.9 12.4.9c-.7 0-1.1.5-1.1 1.1s.4 1.1 1.1 1.1c2.2 0 4.4.9 6 2.5 1.6 1.6 2.5 3.8 2.5 6.1 0 .6.5 1.1 1.1 1.1s1.1-.5 1.1-1.1c0-2.9-1.1-5.6-3.2-7.6zm-7.5 1.3c-.7 0-1.1.4-1.1 1.1s.4 1.1 1.1 1.1c1 0 2.1.4 2.9 1.2.8.8 1.2 1.7 1.2 2.9 0 .6.4 1.1 1.1 1.1s1.1-.5 1.1-1.1c0-1.7-.7-3.3-1.9-4.5C15.6 6 14 5.4 12.4 5.4zM10.8 16l.9-2.6c.7.3 1.4.1 2-.4.7-.8.7-1.9 0-2.7-.8-.7-1.9-.7-2.7 0-.5.6-.6 1.4-.3 2.1l-2.4 1.1-4.4-4.4c-.3-.2-.8-.2-1 .1-2.8 3.3-2.6 8.3.5 11.4 3.1 3.1 8.1 3.3 11.4.5.3-.2.3-.7.1-1L10.8 16z"
      }
    },
    new_custom31: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M21.4 9.6L19.6 4c-.3-1-1.3-1.7-2.4-1.7H6.8C5.7 2.3 4.7 3 4.3 4L2.6 9.6c-1 .2-1.7 1-1.7 2v4.3c0 .9.7 1.7 1.5 2.1v3c0 .4.3.7.7.7h3c.4 0 .7-.3.7-.7v-2.9h10.4V21c0 .4.3.7.7.7h3c.4 0 .7-.3.7-.7v-3c.8-.3 1.5-1.1 1.5-2v-4.3c0-1.1-.7-1.9-1.7-2.1zm-16.8 6c-1 0-1.8-.8-1.8-1.8S3.6 12 4.6 12s1.9.8 1.9 1.8-.9 1.8-1.9 1.8zm8.1-6.1H5.4c-.2 0-.4-.2-.3-.5l1.4-4.2c0-.2.1-.3.3-.3h10.3c.2 0 .3.1.3.3l1.4 4.3c.1.2-.1.5-.3.5h-5.8zm6.3 6.1c-1 0-1.8-.8-1.8-1.8S18 12 19 12s1.9.8 1.9 1.8-.9 1.8-1.9 1.8z"
      }
    },
    new_custom32: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.5 6.6l-8.6 4.9c-.2.1-.4.1-.6.1-.4 0-.8-.2-1-.6-.3-.5 0-1.2.5-1.5l2.9-1.6V5.1c0-.3-.3-.5-.6-.3l-10.5 6c-.2 0-.4.1-.5.1-.4 0-.8-.2-1-.6-.3-.5-.1-1.2.4-1.5l1.8-1V1.7c.1-.5-.3-.8-.7-.8H1.7c-.5 0-.8.3-.8.8v19.2c0 1.2 1 2.2 2.2 2.2h6.3c.4 0 .8-.3.8-.8v-2.5c0-.5.3-.8.7-.8h2.2c.4 0 .7.3.7.8v2.5c0 .5.4.8.8.8h6.3c1.2 0 2.2-1 2.2-2.2v-14c0-.3-.3-.5-.6-.3zm-16 10.2c0 .4-.4.7-.8.7H5c-.4 0-.8-.3-.8-.7v-2.2c0-.4.4-.8.8-.8h.7c.4 0 .8.4.8.8v2.2zm4.4 0c0 .4-.3.7-.7.7h-.8c-.4 0-.7-.3-.7-.7v-2.2c0-.4.3-.8.7-.8h.8c.4 0 .7.4.7.8v2.2zm4.4 0c0 .4-.3.7-.7.7h-.8c-.4 0-.7-.3-.7-.7v-2.2c0-.4.3-.8.7-.8h.8c.4 0 .7.4.7.8v2.2zm4.5 0c0 .4-.4.7-.8.7h-.7c-.4 0-.8-.3-.8-.7v-2.2c0-.4.4-.8.8-.8h.7c.4 0 .8.4.8.8v2.2z"
      }
    },
    new_custom33: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.2 8.9h-10c-.4 0-.7.3-.7.7v2.7c0 .4.3.7.7.7h10c.4 0 .7-.3.7-.7V9.6c0-.4-.3-.7-.7-.7zM12.4 12c-.6 0-1-.5-1-1 0-.6.4-1 1-1s1 .4 1 1c0 .5-.5 1-1 1zm10-7.8H1.6c-.4 0-.7.3-.7.6v.7c0 .8.6 1.4 1.4 1.4v12.3c0 .3.3.6.7.6h.7c.4 0 .7-.3.7-.6V6.9H20v12.3c0 .3.3.6.7.6h.7c.3 0 .7-.3.7-.6V6.9h-.4c.7 0 1.4-.6 1.4-1.4v-.7c0-.3-.3-.6-.7-.6z"
      }
    },
    new_custom34: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M9 4.6h6c.4 0 .7-.4.6-.8C15.2 2.2 13.8.9 12 .9S8.8 2.2 8.4 3.8c-.1.4.2.8.6.8zm13 9.6c.6 0 1.1-.5 1.1-1.2-.1-.5-.6-1-1.2-1h-3.3v-1.8c2.2-.9 3.7-3.2 3.7-5.9 0-.6-.3-1-.9-1.2-.7-.1-1.3.5-1.3 1.1 0 1.6-.7 3-1.8 3.6-.4-.6-1.1-1-1.9-1H7.6c-.8 0-1.5.4-1.9 1-1.1-.6-1.8-1.9-1.8-3.5 0-.6-.5-1.2-1-1.2-.7-.1-1.2.5-1.2 1.1 0 2.7 1.5 5.1 3.7 5.9V12H2.1c-.6 0-1.1.4-1.2 1 0 .6.5 1.2 1.1 1.2h3.4V16c-2.2.8-3.7 3.2-3.7 5.9 0 .5.3 1 .9 1.1.7.1 1.3-.4 1.3-1.1 0-1.5.7-2.9 1.7-3.6.7 2.1 2.3 3.7 4.3 4.4.5.1 1-.3 1-.7v-8.8c0-.6.5-1.2 1-1.2.7 0 1.2.5 1.2 1.1V22c0 .5.5.8 1 .7 2-.6 3.6-2.3 4.3-4.3 1 .6 1.7 2 1.7 3.5 0 .6.5 1.1 1 1.2.7 0 1.2-.5 1.2-1.1 0-2.8-1.5-5.1-3.7-5.9v-1.9H22z"
      }
    },
    new_custom35: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M19.2 8.3c-.7 0-1.2.5-1.2 1.1v1.9c0 3.2-2.7 5.9-6 5.9s-6.1-2.7-6.1-5.9V9.4c0-.6-.5-1.1-1.1-1.1s-1.1.5-1.1 1.1v1.9c0 4.1 3.1 7.4 7.1 8v1.6H9c-.7 0-1.2.4-1.2 1.1s.5 1.1 1.2 1.1h6c.6 0 1.2-.5 1.2-1.1s-.6-1.1-1.2-1.1h-1.9v-1.6c4.1-.6 7.2-3.9 7.2-8V9.4c0-.6-.5-1.1-1.1-1.1zM12 15c2.1 0 3.8-1.7 3.8-3.7V4.6c0-2.1-1.7-3.7-3.8-3.7-2.1 0-3.8 1.6-3.8 3.7v6.7c0 2 1.7 3.7 3.8 3.7z"
      }
    },
    new_custom36: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M7.9 20.1H6.5c-.3 0-.5.2-.6.4l-.5.9c-.3.5-.2 1.2.2 1.5.2.1.4.2.6.2.4 0 .8-.2 1-.6l1-1.8c.2-.3 0-.6-.3-.6zm10.3.4c-.2-.2-.4-.4-.6-.4h-1.5c-.3 0-.5.3-.3.6l1 1.8c.3.4.6.6 1 .6.2 0 .4-.1.6-.2.4-.3.6-1 .2-1.5l-.4-.9zM18.1.9H5.9c-1.2 0-2.2 1-2.2 2.2v12.6c0 1.2 1 2.2 2.2 2.2h12.2c1.2 0 2.2-1 2.2-2.2V3.1c0-1.2-1-2.2-2.2-2.2zM6.9 16.4c-.6 0-1-.4-1-1.1s.4-1.1 1-1.1 1.1.5 1.1 1.1-.4 1.1-1.1 1.1zm10.2 0c-.6 0-1.1-.4-1.1-1.1s.5-1.1 1.1-1.1 1 .5 1 1.1-.4 1.1-1 1.1zm1-4.4c0 .4-.3.7-.7.7H6.6c-.4 0-.7-.3-.7-.7V4.6c0-.4.3-.7.7-.7h10.8c.5 0 .8.3.8.7V12z"
      }
    },
    new_custom37: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.4 14.1h-4.5V10c.9.8 2.1 1.3 3.5 1.3.6 0 1-.5 1-1s-.5-1-1-1c-1.9 0-3.5-1.7-3.5-3.8V4.4c.4 0 .7-.3.7-.7V3c0-.4-.3-.7-.7-.7h-2.1c-.3 0-.7.3-.7.7v.7c0 .4.4.7.7.7v1c0 2.1-1.7 3.8-3.8 3.8S8.3 7.5 8.3 5.4v-1c.3 0 .7-.3.7-.7V3c0-.4-.4-.7-.7-.7H6.2c-.4 0-.7.3-.7.7v.7c0 .4.3.7.7.7v1c0 2.1-1.6 3.8-3.5 3.8-.6 0-1 .4-1 1s.5 1 1 1c1.3 0 2.6-.5 3.5-1.3V14H1.6c-.4.1-.7.4-.7.8v1.6c0 .4.3.8.7.8H3V21c0 .3.3.7.7.7h2.1c.3 0 .7-.4.7-.7v-1.4c0-1.2.9-2.1 2-2.1h7c1.1 0 2 .9 2 2.1V21c0 .3.4.7.7.7h2.1c.4 0 .7-.4.7-.7v-3.8h1.4c.4 0 .7-.4.7-.8v-1.6c0-.4-.3-.7-.7-.7zM8.2 9.9c1 .9 2.4 1.4 3.8 1.4s2.8-.5 3.8-1.4v4.2H8.2V9.9z"
      }
    },
    new_custom38: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12 10.2c-1.6 0-3 1.3-3 2.9s1.4 3 3 3 3-1.4 3-3-1.4-2.9-3-2.9zm8.9-3.7h-3c-.3 0-.6-.2-.7-.5l-1-2c-.3-.8-1.1-1.2-1.9-1.2H9.7c-.8 0-1.6.4-1.9 1.2l-1 2c-.1.3-.4.5-.7.5h-3C1.9 6.5.9 7.5.9 8.7V19c0 1.2 1 2.2 2.2 2.2h17.8c1.2 0 2.2-1 2.2-2.2V8.7c0-1.2-1-2.2-2.2-2.2zM12 18.4c-2.9 0-5.2-2.3-5.2-5.2S9.1 8 12 8s5.2 2.3 5.2 5.2-2.3 5.2-5.2 5.2z"
      }
    },
    new_custom39: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17 4.1c-.1-.3-.4-.5-.7-.4L1.4 8.5c-.3.1-.5.5-.4.9l.6 2.3c.1.3.4.6.8.5l3.8-.5c.1.4.3.9.5 1.2l-3.2 8.7c-.2.6.1 1.2.7 1.4 0 0 .2.1.3.1.5 0 .9-.3 1-.8l3.1-8.2c.3.1.4.1.7.1s.5-.1.8-.1l3 8.2c.1.5.6.8 1 .8.1 0 .3-.1.4-.1.6-.2.9-.8.6-1.4l-3.2-8.8c.4-.6.7-1.3.7-2l5.2-.8c.3 0 .5-.4.4-.7L17 4.1zm6 5.2l-2-7.5c-.1-.6-.8-1-1.4-.9-.6.2-1 .8-.8 1.4l2 7.5c.2.6.8 1 1.4.9.6-.2 1-.8.8-1.4z"
      }
    },
    new_custom4: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M3 5.6l7.8-4.4c.7-.4 1.7-.4 2.4 0L21 5.6c.7.4 1.2 1.2 1.2 2v8.8c0 .8-.5 1.6-1.2 2l-7.8 4.4c-.7.4-1.6.4-2.4 0L3 18.4c-.6-.4-1.2-1.2-1.2-2V7.6c0-.8.6-1.6 1.2-2z"
      }
    },
    new_custom40: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M20.9 3.7H3.1C1.9 3.7.9 4.7.9 5.9v12.2c0 1.2 1 2.2 2.2 2.2h17.8c1.2 0 2.2-1 2.2-2.2V5.9c0-1.2-1-2.2-2.2-2.2zm0 2.2V8H3.1V5.9h17.8zM3.1 18.1v-6.5h17.8v6.5H3.1zm6.4-4.7c-.5 0-1 .3-1.2.7-.1.1-.2.1-.2 0-.3-.4-.7-.7-1.2-.7-.9 0-1.5.7-1.5 1.5 0 .7.6 1.4 1.5 1.4.5 0 .9-.2 1.2-.7h.2c.2.5.7.7 1.2.7.8 0 1.4-.6 1.4-1.4v-.1c0-.7-.7-1.4-1.4-1.4zm8.4.4h-4.4c-.4 0-.8.3-.8.7v.7c0 .4.4.8.8.8h4.4c.4 0 .7-.4.7-.8v-.7c0-.4-.3-.7-.7-.7z"
      }
    },
    new_custom41: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M21 5.1H3c-1.2 0-2.1.9-2.1 2v9.8c0 1.1.9 2 2.1 2h18c1.2 0 2.1-.9 2.1-2V7.1c0-1.1-.9-2-2.1-2zM5.4 16.9c0-1.3-1-2.4-2.4-2.4v-5c1.4 0 2.4-1.1 2.4-2.4h13.2c0 1.3 1.1 2.4 2.4 2.4v5c-1.3 0-2.4 1.1-2.4 2.4H5.4z"
      },
      "ellipse": {
        "cx": "12",
        "cy": "11.815",
        "rx": "3.462",
        "ry": "3.369"
      }
    },
    new_custom42: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M20.9 1.8H3.1C1.9 1.8.9 2.8.9 4v2.2c0 .4.3.7.8.7h20.6c.5 0 .8-.3.8-.7V4c0-1.2-1-2.2-2.2-2.2zm0 7.3H3.1c-.4 0-.7.3-.7.7V20c0 1.2 1 2.2 2.2 2.2h14.8c1.2 0 2.2-1 2.2-2.2V9.8c0-.4-.3-.7-.7-.7zm-4.8 3.3c0 .6-.5 1.1-1.1 1.1H9c-.6 0-1.1-.5-1.1-1.1 0-.6.5-1.1 1.1-1.1h6c.6 0 1.1.4 1.1 1.1z"
      }
    },
    new_custom43: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M23 9.8v-.7V9c0-.1 0 0-.1 0v-.1c0-.1-.1 0-.1 0l-4-5.7c-.2-.2-.4-.4-.8-.4H6c-.4 0-.7.2-.9.4l-4 5.6c0 .1-.1.1-.1.1V9c0 .1 0 0-.1 0V9.8c.1 0 .1.1.1.1v.1h.1l10.1 10.9v.1h.1s.1 0 .1.1v.1h.1v.1h.8v-.1h.1v-.1h.1V21h.1v-.1h.1L22.8 10v-.1h.1l.1-.1zM12 8.4h-1.6L12 5.7l1.6 2.7H12zm0 2h2l-2 6.5-2-6.5h2zm1.8-5.6h2.5l-.9 2.6-1.6-2.6zM8.7 7.4l-.9-2.6h2.5L8.7 7.4zm-.8 3l1.8 6-5.5-6h3.7zm8.2 0h3.7l-5.5 6 1.8-6zm4-2h-3l1-2.8 2 2.8zM5.9 5.6l1 2.8h-3l2-2.8z"
      }
    },
    new_custom44: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.8 4.2C16.9 1.8 15.3.9 12 .9c-1.5 0-3.3.6-4 .8 0-.5-.3-.8-.8-.8H5.8c-.4 0-.8.3-.8.8v2.9c0 .4.4.8.8.8h1.4c.4 0 .7-.4.7-.8h.9c.6 0 1 .5 1 1.1 0 .7.5 1.1 1.1 1.1v5.9c-.7 0-1.4.7-1.4 1.5v6.7c0 1.2 1 2.2 2.2 2.2h.7c1.2 0 2.2-1 2.2-2.2v-6.7c0-.8-.7-1.5-1.4-1.5V6.8c.6 0 1.1-.8 1.1-1.4 0-.6.4-1.1.9-1.1 1.5-.1 2.3.5 2.7.9.2.2.6.2.7 0 .4-.2.5-.7.2-1z"
      }
    },
    new_custom45: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M6.1 9.6h11.8v4.8H6.1zm17-.6V7.2c0-1.2-.9-2.1-2.1-2.1H3C1.8 5.1.9 6 .9 7.2V9c0 .2.2.5.4.6.8.5 1.4 1.4 1.4 2.4s-.6 1.9-1.4 2.4c-.2.1-.4.3-.4.6v1.8c0 1.2.9 2.1 2.1 2.1h18c1.2 0 2.1-.9 2.1-2.1V15c0-.2-.2-.5-.4-.6-.8-.5-1.4-1.4-1.4-2.4s.6-1.9 1.4-2.4c.2-.1.4-.3.4-.6zm-3.8 7.5H4.7c-.4 0-.7-.3-.7-.7V8.2c0-.4.3-.7.7-.7h14.5c.4 0 .7.3.7.7v7.6c0 .4-.2.7-.6.7z"
      }
    },
    new_custom46: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M16.1 7.2H7.9c-.4 0-.7.3-.7.7v8.2c0 .4.3.7.7.7h8.2c.4 0 .7-.3.7-.7V7.9c0-.4-.3-.7-.7-.7zm6.4-3.6c.3-.1.6-.4.6-.7V1.7c0-.5-.3-.8-.8-.8h-1.2c-.3 0-.6.3-.7.6-.2.7-.9 1.3-1.7 1.3s-1.5-.6-1.8-1.3c-.1-.3-.4-.6-.7-.6h-1.8c-.3 0-.6.3-.6.6-.2.7-1 1.3-1.8 1.3s-1.5-.6-1.8-1.3c-.1-.3-.3-.6-.7-.6H7.8c-.3 0-.6.3-.6.6-.3.7-1 1.3-1.8 1.3-.9 0-1.6-.6-1.8-1.3-.1-.3-.4-.6-.7-.6H1.7c-.5 0-.8.3-.8.8v1.2c0 .3.3.6.6.7.7.2 1.3.9 1.3 1.8s-.6 1.5-1.3 1.7c-.3.1-.6.4-.6.7v1.8c0 .3.3.6.6.6.7.2 1.3 1 1.3 1.8s-.6 1.5-1.3 1.8c-.3.1-.6.3-.6.7v1.7c0 .3.3.6.6.6.7.3 1.3 1 1.3 1.8 0 .9-.6 1.6-1.3 1.8-.3.1-.6.4-.6.7v1.2c0 .5.3.8.8.8h1.2c.3 0 .6-.3.7-.6.2-.7.9-1.3 1.7-1.3.8 0 1.5.6 1.8 1.3.1.3.3.6.7.6h1.7c.3 0 .6-.3.7-.6.2-.7.9-1.3 1.7-1.3s1.5.6 1.8 1.3c.1.3.3.6.7.6h1.8c.3 0 .6-.3.6-.6.3-.7 1-1.3 1.8-1.3s1.5.6 1.8 1.3c0 .3.3.6.6.6h1.2c.5 0 .8-.3.8-.8v-1.2c0-.3-.2-.6-.6-.7-.7-.2-1.3-.9-1.3-1.7s.6-1.5 1.3-1.8c.4-.1.6-.3.6-.7v-1.7c0-.3-.2-.6-.6-.7-.7-.2-1.3-.9-1.3-1.7 0-.8.6-1.5 1.3-1.8.4-.1.6-.3.6-.7V7.8c0-.3-.2-.6-.6-.6-.7-.3-1.3-1-1.3-1.8s.7-1.6 1.4-1.8zM19 16.8c0 1.2-1 2.2-2.2 2.2H7.2C6 19 5 18 5 16.8V7.2C5 6 6 5 7.2 5h9.6C18 5 19 6 19 7.2v9.6z"
      }
    },
    new_custom47: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M16.9 20.1H4.1c-1.2 0-2.3 1-2.3 2.2v.1c0 .4.4.7.7.7h15.9c.4 0 .7-.3.7-.7v-.1c.1-1.2-1-2.2-2.2-2.2zm5-11.7l-6-5.4 1-1.4c.1-.3 0-.5-.2-.6-1.9-.4-3 .9-3 .9C2.1 1.9 4 14.4 4.6 17.3c.1.3.3.6.7.6h10.2c.3 0 .5-.4.3-.6-2-2.5-3.1-5.3-3.8-7-.1-.3.2-.7.5-.5 2.7 1.4 3.9-.1 5.7 1 1 .6 2.1.5 2.8-.3l1-1c.2-.3.2-.7-.1-1.1zm-7.6-1.2c-.7 0-1.1-.5-1.1-1.1S13.7 5 14.3 5s1.1.4 1.1 1.1-.5 1.1-1.1 1.1z"
      }
    },
    new_custom48: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.3 2.4h-3.7v-.7c0-.5-.3-.8-.7-.8H6.1c-.4 0-.7.3-.7.8v.7H1.7c-.5 0-.8.3-.8.7v4.8c0 1.9 1.5 3.4 3.3 3.4H6c1 2.3 3.2 4 6 4 2.8.1 5.1-1.6 6.1-4h1.7c1.8 0 3.3-1.5 3.3-3.4V3.1c0-.4-.3-.7-.8-.7zM4.2 9c-.6 0-1.1-.4-1.1-1.1V4.6h2.3V9H4.2zm16.7-1.1c0 .7-.5 1.1-1.1 1.1h-1.2V4.6h2.3v3.3zm-5.2 13h-.4c-1.2 0-2.2-1.1-2.2-2.3v-.7c0-.2-.1-.4-.4-.4h-1.4c-.3 0-.4.2-.4.4v.7c0 1.2-1 2.3-2.2 2.3h-.4c-.4 0-.7.3-.7.7v.7c0 .5.3.8.7.8h7.4c.4 0 .7-.3.7-.8v-.7c0-.4-.3-.7-.7-.7z"
      }
    },
    new_custom49: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12 8.7c-1.8 0-3.3 1.5-3.3 3.3s1.5 3.3 3.3 3.3 3.3-1.5 3.3-3.3-1.5-3.3-3.3-3.3zm0 5.1c-1 0-1.8-.8-1.8-1.8s.8-1.8 1.8-1.8 1.8.8 1.8 1.8-.8 1.8-1.8 1.8zM12 .9C5.9.9.9 5.9.9 12s5 11.1 11.1 11.1 11.1-5 11.1-11.1S18.1.9 12 .9zm0 19.5c0 .5-.4.8-.8.8-4.5-.4-8-3.9-8.4-8.4 0-.4.3-.8.8-.8h.7c.4 0 .7.3.7.6.4 3.4 3 6 6.4 6.4.3 0 .6.3.6.7v.7zm0-2.9c-3 0-5.5-2.5-5.5-5.5S9 6.5 12 6.5 17.5 9 17.5 12 15 17.5 12 17.5zm8.4-5.5h-.7c-.4 0-.7-.3-.7-.6-.4-3.4-3-6-6.4-6.4-.3 0-.6-.3-.6-.7v-.7c0-.5.4-.8.8-.8 4.5.4 8.1 4 8.4 8.4 0 .4-.3.8-.8.8z"
      }
    },
    new_custom5: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.7 2.7c-3.8-1.5-8.2-1.8-12.1-.5-3.4 1.1-6.9 3.6-7.4 7.4-.1.8-.1 1.7.1 2.4l.3 1.2.3.6c-.1.2-.3.5-.4.6-1.1 1.7-1.8 3.6-2.3 5.5-.2.8-.6 2 .2 2.5.4.3.9.3 1.2.1.4-.3.5-.7.6-1.2.3-1.9 1-3.9 2.1-5.5.5-.8 1-1.6 1.7-2.4.5-.6 1.4-1.7 2.3-1.4.9.4.9 1.4.3 2s-1.2 1.1-1.2 2c0 .7.3 1.4.8 1.8.8.6 2.2.7 3.1.6 2-.1 3.6-.7 5.1-1.8 2.1-1.5 2.9-4 3.3-6.3.3-1.5.5-2.9 1-4.3.2-.6.5-1.2.8-1.7.2-.2.5-.5.5-.8.2-.4-.1-.7-.3-.8z"
      }
    },
    new_custom50: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M21.9 14.4c-.8.5-1.8.7-2.8.7-1.2 0-2.3-.3-3.3-.9-.1-.1-.3-.1-.4 0-1 .6-2.1.9-3.3.9s-2.4-.3-3.3-.9c-.1-.1-.3-.1-.4 0-1 .6-2.1.9-3.3.9-1 0-2-.2-2.8-.7-.3-.1-.6.1-.6.4v4.5c0 .9.5 1.7 1.3 2.1 1.9.8 3.9 1.4 6 1.7.5.1.8-.3.8-.8v-2.8c0-1.2 1-2.2 2.2-2.2 1.2 0 2.2 1 2.2 2.2v2.8c0 .5.4.8.8.8 2.1-.3 4.1-.9 6-1.7.8-.4 1.3-1.2 1.3-2.1v-4.5c.1-.3-.1-.5-.4-.4zM5 12.8c1.4 0 2.5-.5 3.3-1.4.1-.2.4-.2.5 0 .8.8 2 1.4 3.2 1.4 1.4 0 2.5-.5 3.3-1.4.1-.2.4-.2.5 0 .8.8 2 1.4 3.3 1.4 2 0 3.8-1.4 4-3.2 0-.3-.1-.6-.3-.7l-9.4-7.5c-.8-.7-2-.7-2.7 0L1.2 8.9c-.2.1-.3.4-.3.7.3 1.8 2.1 3.2 4.1 3.2z"
      }
    },
    new_custom51: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M8.5 3c1 .6 1.8 2.1 2.2 3.3.1.3.3.4.6.4.2.1.4.1.7.1.4 0 .7 0 1.1-.1.9-.3 1.7-.7 2.4-1.4 1.1-1.2 1.5-2.8 1.1-4.1-1.3-.5-2.9-.1-4 1.1-.4.3-.6.7-.8 1.1-.6-1-1.3-1.8-2.1-2.3-.6-.3-1.3-.1-1.6.4-.3.5 0 1.2.4 1.5zm11.2 5.4c-3.7-2.1-4.5.7-7.7.7s-4-2.8-7.7-.7c-3.6 2.1-2.5 8.9-1.1 11.4 1.3 2.3 3.6 4.6 8.5 2.4.2-.1.4-.1.6 0 4.8 2.2 7.2-.1 8.5-2.4 1.4-2.5 2.5-9.3-1.1-11.4z"
      }
    },
    new_custom52: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M23 6.5c.1-1.2 0-2.3-.2-3.5-.1-1-.8-1.7-1.8-1.8-1.2-.2-2.3-.3-3.5-.2-.3 0-.5.4-.3.6l5.2 5.2c.3.2.6 0 .6-.3zm-8.7-4.7c-.2-.2-.5-.3-.7-.2C10.8 2.4 8.2 3.8 6 6c-2.1 2.2-3.6 4.8-4.4 7.4-.1.3 0 .6.2.8l8 8c.2.2.5.3.8.2 2.6-.8 5.2-2.3 7.4-4.4 2.1-2.2 3.6-4.8 4.4-7.6.1-.3 0-.5-.2-.7l-7.9-7.9zm-3.1 14.4c-.4.5-1.1.5-1.6 0l-2-2c-.5-.5-.5-1.2 0-1.6.4-.5 1.1-.5 1.5 0l2.1 2.1c.5.4.5 1.1 0 1.5zm2.6-2.5c-.5.4-1.2.4-1.6 0l-2-2.1c-.5-.5-.5-1.2 0-1.6.4-.4 1.1-.4 1.5 0l2.1 2.1c.5.5.5 1.1 0 1.6zm2.6-2.6c-.5.4-1.2.4-1.6 0L12.7 9c-.4-.5-.4-1.2 0-1.6.5-.4 1.2-.4 1.6 0l2.1 2.1c.4.5.4 1.2 0 1.6zM1 17.3c-.1 1.2-.1 2.5.2 3.7.1 1 .8 1.8 1.8 1.9 1.2.2 2.5.3 3.8.2.3-.1.4-.4.3-.7L1.6 17c-.2-.2-.6-.1-.6.3z"
      }
    },
    new_custom53: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M21 14.6h-.3c-.8 0-1.5-.7-1.5-1.5V8.2c0-4.3-3.7-7.7-8-7.2-3.7.4-6.4 3.7-6.4 7.5v4.4c0 .9-.8 1.7-1.7 1.7H3c-.6 0-1.2.5-1.2 1.2v.9c0 .6.6 1.2 1.2 1.2h18c.6 0 1.2-.6 1.2-1.2v-.9c0-.7-.6-1.2-1.2-1.2zm-6.6 5.5H9.6c-.3 0-.6.3-.5.5.3 1.4 1.5 2.5 2.9 2.5s2.7-1 3-2.5c0-.2-.3-.5-.6-.5z"
      }
    },
    new_custom54: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M3.6 12.4C6 12 8.1 11 10.4 10c.7-.4 2.1-1 2.8-1.3.2-.1.3-.3.2-.6-.2-1-1-1.9-2.1-1.9h-.8V4.8c0-.4-.3-.7-.7-.7V2.6c0-.4-.3-.8-.8-.8H7.6c-.4 0-.8.4-.8.8v1.5c-.3 0-.7.3-.7.7v1.4h-.7c-1.2 0-2.3 1.1-2.3 2.3V12c0 .3.3.5.5.4zm16.5 7.3s2.7-4.1 3-10c0-.4-.3-.7-.8-.7-8.8.3-12.9 5.6-20.7 5.9-.4 0-.7.4-.7.7v2.8c0 1.2.9 2.1 2.1 2.2 3.9.3 12.2.8 16.9 1.6.5.1 1-.4.9-.8-.1-.6-.3-1.3-.7-1.7zm-.3-6.6c-.7 0-1.2-.5-1.2-1.1s.5-1.1 1.2-1.1 1.1.5 1.1 1.1-.5 1.1-1.1 1.1z"
      }
    },
    new_custom55: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M5.8 15.4h4.5c.4 0 .7-.4.7-.7V4.6c0-.8-.7-1.4-1.4-1.4H5.9c-.5 0-.8.4-.8.8v10.7c0 .3.3.7.7.7zM21 5.3v10.8c0 .7-.6 1.3-1.4 1.3H4.4c-.8 0-1.4-.6-1.4-1.3V5.3c-1.2 0-2.1.9-2.1 2v10.1c0 1.1.9 2 2.1 2h6.6c.3 0 .6.4.6.7s.4.7.7.7H13c.4 0 .7-.3.7-.7s.3-.7.7-.7H21c1.1 0 2-.9 2-2V7.3c.1-1.1-.8-2-2-2zm-7.2 10.1h4.3c.5 0 .8-.4.8-.8V3.9c0-.3-.3-.7-.7-.7h-3.8c-.6 0-1.3.6-1.3 1.4v10.1c-.1.3.2.7.7.7z"
      }
    },
    new_custom56: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M16.7 4.8c-2.3 2.3-5.1-.6-7.7 2l-7.4 7.4c-.9.8-.9 2.2 0 3.1l2.6 2.5 2.5 2.6c.9.9 2.3.9 3.1 0l7.5-7.4c2.5-2.6-.3-5.4 2-7.7l.6-.6c.2-.1.2-.4 0-.5l-2-2c-.2-.2-.4-.2-.5 0l-.7.6zm-1.8 9.4l-2.6 2.6c-.3.3-.7.3-1 0l-2.1-2.1-2-2.1c-.3-.2-.3-.7 0-1L9.7 9c.3-.2.8-.2 1.1 0l2 2.1 2.1 2.1c.3.3.3.7 0 1zm7.9-11.5l-.7-.8-.8-.8c-.3-.3-.8-.3-1 0l-1 1c-.1.1-.1.3 0 .5l2 2c.2.2.4.2.5 0l1-.9c.4-.2.4-.7 0-1z"
      }
    },
    new_custom57: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M13.1 13.4v9.3c0 .3.3.5.6.3 1.8-1 7.3-4.2 7.3-4.2.6-.4 1.1-1.2 1.1-2V8.4c0-.3-.3-.4-.5-.3l-8.1 4.6c-.2.2-.4.4-.4.7zm-.7-2.6l8.1-4.7c.3-.1.3-.5 0-.6-1.8-1-7.3-4.3-7.3-4.3-.7-.4-1.7-.4-2.4 0 0 0-5.5 3.2-7.3 4.3-.3.1-.3.5 0 .6l8.1 4.7c.3.1.5.1.8 0zm-1.9 1.9L2.4 8.1c-.2-.2-.6 0-.6.3v8.4c0 .8.5 1.6 1.2 2 0 0 5.5 3.2 7.3 4.2.3.2.5 0 .5-.3v-9.3c.1-.3-.1-.5-.3-.7z"
      }
    },
    new_custom58: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.2 10.5c-.6 0-1.1-.5-1.1-1.2.1-.6.6-1 1.2-1h3.2c.1 0 .3-.1.3-.2.3-.5.5-1 .7-1.5.1-.3-.1-.5-.3-.5h-2.4c-.6 0-1.1-.5-1.2-1 0-.7.5-1.2 1.2-1.2h2.9c.2 0 .4-.2.4-.4V2.4c0-.4-.3-.7-.8-.7h-3.9c-1.1 0-2 .8-2 1.9v.1c0 2.1-1.4 3.9-3.3 4.4v-3c.8-.5 1.3-1.3 1.1-2.3-.1-1-1-1.7-1.9-1.8-1.4-.2-2.5.8-2.5 2.2 0 .8.4 1.5 1.1 1.9v3.1C9 7.7 7.6 5.9 7.6 3.8v-.1c0-1.1-.9-2-2-2H1.7c-.5 0-.8.3-.8.7v1.2c0 .2.2.3.4.3h2.9c.6 0 1.1.5 1.2 1 0 .7-.5 1.2-1.2 1.2H1.8c-.2 0-.4.3-.3.5.2.5.4 1.1.7 1.6.1.1.2.2.3.2h3.2c.6 0 1.2.4 1.2 1 .1.6-.4 1.2-1.1 1.2h-.9c-.3 0-.5.4-.2.6 1.6 1.4 3.6 2.3 6.3 2.3v8.4c0 .6.4 1.1 1 1.2.6 0 1.2-.5 1.2-1.1v-8.5c2.7 0 4.7-1 6.3-2.3.3-.2.1-.6-.3-.6h-1z"
      }
    },
    new_custom59: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.3 5c.4 0 .6-.3.6-.7 0-.2-.1-.5-.4-.6-.5-.3-1.2-1.5-1.5-2.3-.1-.3-.3-.5-.6-.5H7.5c-.3 0-.6.2-.6.5-.3.7-1 2-1.5 2.3-.2.1-.3.4-.3.6 0 .4.3.7.6.7h12.6zM5.1 20.8c0 1.3.9 2.3 2.1 2.3h9.5c1.2 0 2.2-1 2.2-2.2v-.1c0-.4-.3-.7-.7-.7H5.7c-.3 0-.6.3-.6.7zm13.8-3.6V7.9c0-.4-.3-.7-.7-.7H5.8c-.4 0-.7.3-.7.7v9.3c0 .4.3.7.7.7h12.4c.4 0 .7-.3.7-.7z"
      }
    },
    new_custom6: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12 21.7H2.4c-1.2 0-1.8-1.3-1.2-2.3L10.7 3c.6-.9 1.9-.9 2.5 0l9.6 16.5c.6 1-.1 2.2-1.2 2.2H12z"
      }
    },
    new_custom60: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M23.1 10.2C22.2 5 17.6.9 12 .9S1.8 5 .9 10.2c0 .4.3.6.6.4.6-.4 1.3-.7 2.1-.7 1 0 1.9.4 2.5 1.2.1.2.5.2.6 0 .6-.8 1.5-1.2 2.5-1.2s1.9.4 2.5 1.2c.1.2.4.2.6 0 .6-.8 1.5-1.2 2.5-1.2s1.9.4 2.5 1.2c.1.2.4.2.6 0 .6-.8 1.4-1.2 2.5-1.2.7 0 1.5.3 2 .7.4.2.7 0 .7-.4zm-6.7 8.4c-.6 0-1.1.5-1.1 1.2s-.4 1.1-1.1 1.1-1.1-.5-1.1-1.1v-5.2c0-.7-.5-1.1-1.1-1.1s-1.1.4-1.1 1.1v5.2c0 1.8 1.5 3.3 3.3 3.3s3.3-1.5 3.3-3.3c0-.7-.4-1.2-1.1-1.2z"
      }
    },
    new_custom61: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M20.5.9H19c-.4 0-.7.3-.7.8v1.4c0 .5-.3.8-.8.8h-.7c-.4 0-.7-.3-.7-.8V1.7c0-.5-.3-.8-.8-.8h-1.5c-.4 0-.7.3-.7.8v1.4c0 .5-.3.8-.7.8h-.8c-.4 0-.7-.3-.7-.8V1.7c0-.5-.3-.8-.7-.8H8.7c-.4 0-.8.3-.8.8v1.4c0 .5-.3.8-.7.8h-.7c-.5 0-.8-.3-.8-.8V1.7c0-.5-.3-.8-.7-.8H3.5c-.4 0-.7.3-.7.8v3.7c0 1.2 1 2.2 2.2 2.2h14c1.2 0 2.2-1 2.2-2.2V1.7c0-.5-.3-.8-.7-.8zm-1.7 9.5c0-.4-.3-.7-.7-.7H5.9c-.4 0-.7.3-.7.7L3.5 22.2c-.1.5.3.8.7.8H9c.4 0 .8-.3.8-.7v-3.6c0-1.2.9-2.3 2.1-2.3 1.3 0 2.3 1 2.3 2.2v3.7c0 .5.4.8.8.8h4.8c.4 0 .8-.4.7-.9l-1.7-11.8z"
      }
    },
    new_custom62: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22 19H2c-.6 0-1.1.5-1.1 1.1 0 .6.5 1.1 1.1 1.1h20c.6 0 1.1-.4 1.1-1.1S22.6 19 22 19zM2.4 16.8H15v-1.5c0-.4.3-.7.7-.7h3.7c.4 0 .7.3.7.7v1.5h1.5c.4 0 .7-.3.7-.7V3.5c0-.4-.3-.7-.7-.7H2.4c-.4 0-.7.3-.7.7v12.6c0 .4.3.7.7.7zm3.3-9.6c0-.4.3-.7.8-.7h10.7c.4 0 .7.3.7.7v.7c0 .5-.3.8-.7.8H6.5c-.5 0-.8-.3-.8-.8v-.7zm0 4.4c0-.4.3-.7.8-.7h7c.4 0 .7.3.7.7v.8c0 .4-.3.7-.7.7h-7c-.5 0-.8-.3-.8-.7v-.8z"
      }
    },
    new_custom63: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M9 15.7h6c.4 0 .7-.3.7-.7V9c0-.4-.3-.7-.7-.7H9c-.4 0-.7.3-.7.7v6c0 .4.3.7.7.7zm13-2.6c.6 0 1.1-.5 1.1-1.1s-.5-1.1-1.1-1.1h-1.9V8.7H22c.6 0 1.1-.5 1.1-1.1s-.5-1.1-1.1-1.1h-1.9v-.4c0-1.2-1-2.2-2.2-2.2h-.4V2c0-.6-.4-1.1-1.1-1.1s-1.1.5-1.1 1.1v1.9h-2.2V2c0-.6-.5-1.1-1.1-1.1s-1.1.5-1.1 1.1v1.9H8.7V2c0-.6-.5-1.1-1.1-1.1S6.5 1.4 6.5 2v1.9h-.4c-1.2 0-2.2 1-2.2 2.2v.4H2c-.6 0-1.1.4-1.1 1.1S1.4 8.7 2 8.7h1.9v2.2H2c-.6 0-1.1.5-1.1 1.1s.5 1.1 1.1 1.1h1.9v2.2H2c-.6 0-1.1.5-1.1 1.1s.5 1.1 1.1 1.1h1.9v.4c0 1.2 1 2.2 2.2 2.2h.4V22c0 .6.4 1.1 1.1 1.1s1.1-.5 1.1-1.1v-1.9h2.2V22c0 .6.5 1.1 1.1 1.1s1.1-.5 1.1-1.1v-1.9h2.2V22c0 .6.5 1.1 1.1 1.1s1.1-.5 1.1-1.1v-1.9h.4c1.2 0 2.2-1 2.2-2.2v-.4H22c.6 0 1.1-.4 1.1-1.1s-.5-1.1-1.1-1.1h-1.9v-2.2H22zm-4.1 3.7c0 .6-.5 1.1-1.1 1.1H7.2c-.6 0-1.1-.5-1.1-1.1V7.2c0-.6.5-1.1 1.1-1.1h9.6c.6 0 1.1.5 1.1 1.1v9.6z"
      }
    },
    new_custom64: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12 .9C5.9.9.9 5.9.9 12s5 11.1 11.1 11.1 11.1-5 11.1-11.1S18.1.9 12 .9zm0 19.2c-4.5 0-8.1-3.6-8.1-8.1S7.5 3.9 12 3.9s8.1 3.6 8.1 8.1-3.6 8.1-8.1 8.1zm4.3-12.9l-6.1 2.3c-.4.1-.6.3-.7.7l-2.3 6.1c0 .3.2.6.5.5l6.1-2.3c.4-.1.6-.3.7-.7l2.3-6.1c.1-.3-.2-.6-.5-.5zM12 13.5c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5-.7 1.5-1.5 1.5z"
      }
    },
    new_custom65: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M19.6 17.9h-18c-.4 0-.7.3-.7.7 0 1.2 1 2.2 2.2 2.2h15c1.2 0 2.2-1 2.2-2.2v-.1c0-.3-.4-.6-.7-.6zm-.8-14.7H1.7c-.4 0-.7.4-.7.8-.1.9-.1 2.7.1 3.8.4 3.4 2.2 6.2 4.7 7.8H14c1.4-.9 2.6-2.3 3.4-3.8.4.1.9.2 1.4.2 2.3 0 4.3-2 4.3-4.4s-1.9-4.4-4.3-4.4zm0 6.6c-.2 0-.3-.1-.5-.1.3-1.2.5-2.4.5-3.7v-.6c1.2 0 2.2.9 2.2 2.2s-1 2.2-2.2 2.2z"
      }
    },
    new_custom66: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.4 14l-5.3-5.4c-.9-.8-2.2-.8-3.1 0L8.6 14c-.8.8-.8 2.2 0 3l5.4 5.4c.8.9 2.2.9 3 0l5.4-5.4c.9-.8.9-2.2 0-3zm-10.1 2.4c-.5.5-1.4.5-1.8 0-.5-.5-.5-1.3 0-1.8s1.3-.5 1.8 0 .4 1.3 0 1.8zm4.1 4.2c-.5.5-1.3.5-1.8 0s-.5-1.3 0-1.8 1.4-.5 1.8 0c.5.5.5 1.3 0 1.8zm0-8.3c-.5.5-1.3.5-1.8 0s-.5-1.4 0-1.8c.5-.5 1.4-.5 1.8 0 .5.4.5 1.3 0 1.8zm4.2 4.1c-.5.5-1.4.5-1.8 0-.5-.5-.5-1.3 0-1.8s1.3-.5 1.8 0 .5 1.3 0 1.8zM13.1 5.9V3.1c0-1.2-1-2.2-2.2-2.2H3.1C1.9.9.9 1.9.9 3.1v7.8c0 1.2 1 2.2 2.2 2.2h2.8c.2 0 .5-.1.6-.3.1-.1.3-.2.4-.4l5.5-5.5c.1-.1.2-.3.4-.4.2-.1.3-.4.3-.6zm-9 5.4c-.7 0-1.3-.6-1.3-1.3s.6-1.3 1.3-1.3 1.3.6 1.3 1.3-.6 1.3-1.3 1.3zm2.9-3c-.7 0-1.3-.6-1.3-1.3S6.3 5.7 7 5.7s1.3.6 1.3 1.3S7.7 8.3 7 8.3zm3-2.9c-.7 0-1.3-.6-1.3-1.3s.6-1.3 1.3-1.3c.7 0 1.3.6 1.3 1.3s-.6 1.3-1.3 1.3z"
      }
    },
    new_custom67: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M13.5 13.1l-.5-.8c-.2-.3-.4-.4-.8-.4-.1 0-.2 0-.3.1l-1.3.4c-.5-.4-1.1-.7-1.7-1l-.3-1.3c-.1-.5-.4-.7-.9-.7h-.9c-.5 0-.8.3-.9.8l-.3 1.2c-.6.3-1.1.6-1.7 1.1L2.6 12c-.1 0-.2-.1-.3-.1-.3 0-.6.2-.8.5l-.5.8c-.2.4-.1.8.2 1.2l1.2.8c-.1.4-.1.7-.1 1 0 .3 0 .6.1 1l-1.1.9c-.4.3-.5.8-.2 1.2l.4.8c.2.3.5.4.9.4 0 0 .2 0 .3-.1L4 20c.5.4 1 .8 1.7 1l.2 1.3c.1.5.5.8.9.8h1c.4 0 .8-.3.9-.8l.2-1.3c.7-.3 1.3-.6 1.8-1.1l1.2.5c.1 0 .2.1.3.1.4 0 .7-.2.9-.5l.4-.7c.3-.4.2-.9-.2-1.2l-1.1-.9c.1-.3.1-.6.1-1 0-.3 0-.6-.1-1l1.1-.8c.3-.4.4-.9.2-1.3zm-6.3 5.6c-1.3 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5 2.6 1.1 2.6 2.5-1.2 2.5-2.6 2.5zM22.8 7.9l-.8-.7c0-.3.1-.5.1-.8 0-.3-.1-.5-.1-.8l.8-.7c.3-.2.4-.6.2-.9l-.4-.7c-.1-.2-.4-.3-.6-.3h-.3l-1.1.4c-.4-.4-.8-.6-1.4-.8l-.1-1.1c-.1-.3-.4-.6-.8-.6h-.7c-.4 0-.7.3-.8.6l-.1 1.1c-.5.2-1 .4-1.4.8L14.2 3c-.1-.1-.2-.1-.3-.1-.2 0-.5.1-.6.4l-.4.6c-.2.3-.1.7.2.9l.8.7c0 .3-.1.5-.1.8 0 .3.1.6.1.8l-.8.7c-.3.2-.4.6-.2 1l.4.6c.1.2.4.4.6.4.1 0 .2 0 .3-.1l1.1-.4c.4.4.9.7 1.4.8l.1 1.1c.1.3.4.6.8.6h.7c.4 0 .7-.3.8-.6l.1-1.1c.6-.2 1.1-.5 1.5-.9l1 .4c.1.1.2.1.3.1.2 0 .5-.1.6-.4l.4-.6c.2-.2.1-.5-.2-.8zm-4.8.6c-1.2 0-2.1-.9-2.1-2s.9-2.1 2.1-2.1 2 1 2 2.1-.9 2-2 2z"
      }
    },
    new_custom68: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12 .9C5.9.9.9 5.9.9 12s5 11.1 11.1 11.1 11.1-5 11.1-11.1S18.1.9 12 .9zm8.8 10h-2.9c-.1-2.6-.7-4.9-1.6-6.7 2.4 1.4 4.1 3.8 4.5 6.7zm-9.9-7.3v7.3H8.4c.1-3.5 1.2-6.2 2.5-7.3zm0 9.5v7.3c-1.3-1.1-2.4-3.8-2.5-7.3h2.5zm2.2 7.3v-7.3h2.5c-.1 3.5-1.2 6.2-2.5 7.3zm0-9.5V3.6c1.3 1.1 2.4 3.8 2.5 7.3h-2.5zM7.7 4.2C6.8 6 6.3 8.3 6.1 10.9H3.2C3.6 8 5.3 5.6 7.7 4.2zm-4.5 8.9h2.9c.1 2.6.7 4.9 1.6 6.7-2.4-1.4-4.1-3.8-4.5-6.7zm13.1 6.7c.9-1.8 1.4-4.1 1.6-6.7h2.9c-.4 2.9-2.1 5.3-4.5 6.7z"
      }
    },
    new_custom69: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M13 10.2c-2.2-1.6-4.3-.8-5.7.5-.5.5-1.3.8-2.2 1-1 .3-2.1.7-2.8 1.5-2.2 2-1.7 4.5 1.1 7.3l.1.1c1.7 1.7 3.2 2.5 4.7 2.5 1 0 1.9-.4 2.8-1.2.8-.8 1.2-1.8 1.5-2.8.3-.9.6-1.7 1.1-2.2.8-.8 1.3-1.8 1.4-2.7.1-.7-.1-1.7-.9-2.8 0 0-.4-.6-1.1-1.2zm-4.6 8.9c-.2.2-.5.3-.7.3-.3 0-.5-.1-.7-.3l-2.1-2c-.4-.4-.4-1 0-1.5.4-.4 1-.4 1.4 0l2.1 2.1c.4.4.4 1 0 1.4zm1.8-3c-1.1 0-1.9-.8-1.9-1.8s.8-1.9 1.9-1.9 1.8.8 1.8 1.9-.8 1.8-1.8 1.8zM22.8 2.9l-1.7-1.7c-.2-.3-.8-.3-1.1 0L18.1 3c-.3.3-.3.9 0 1.2l.1.1-3.8 3.8c-.1.2-.1.4 0 .6.3.3.8.7 1.1 1 .1.1.3.1.5 0l3.8-3.8V6c.3.3.9.3 1.2 0l1.9-1.9c.3-.4.3-.9-.1-1.2z"
      }
    },
    new_custom7: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M3.3 23.1C2 23.1.9 22 .9 20.7V3.3C.9 2 2 .9 3.3.9h17.4c1.3 0 2.4 1.1 2.4 2.4v17.4c0 1.3-1.1 2.3-2.4 2.3H3.3z"
      }
    },
    new_custom70: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M11.3 17.1L7 12.9c-.9-.9-2.3-.9-3.2 0l-2.6 2.6c-.3.3-.3.8 0 1l.5.6.5.5 4.3 4.2.2.3.9.7c.2.3.8.3 1 0l2.7-2.6c.8-.8.8-2.2 0-3.1zm-7-1.6l.6-.5c.3-.3.7-.3 1 0l3.2 3.1c.3.3.3.8 0 1.1l-.5.5c-.3.2-.8.2-1 0l-3.3-3.2c-.3-.3-.3-.7 0-1zM9 11.7l3.4 3.3c.1.1.2.1.3.1h1.6c.1 0 .3-.1.3-.3v-1.4c0-.2.2-.3.4-.3l1.3-.1c.2 0 .4-.1.4-.3v-1.4c0-.2.1-.3.3-.3l1.4-.1c.2 0 .3-.1.3-.3l.1-1.4c0-.2.1-.3.3-.3h1.4c.2 0 .3-.2.3-.4l.1-1.3c0-.2.1-.3.2-.4l1.6-.2c.2 0 .4-.3.2-.6l-3.1-4.8c-.3-.3-.8-.4-1.2 0l-9.7 9.6c-.2.2-.2.6.1.9z"
      }
    },
    new_custom71: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M19.8 5c-2.1-2.1-5-3.2-8.1-3.2C5.8 2 .9 7 .9 12.9v3.4c0 1.2 1 2.2 2.2 2.2h1.5v1.8c0 .9.7 1.7 1.7 1.9 1.1 0 2-.8 2-1.8v-6.5c0-.9-.7-1.8-1.7-1.9-1.1-.1-2 .7-2 1.8v2.5h-.7c-.4 0-.8-.3-.8-.7v-2.7C3.1 8.1 7 4.2 11.7 4c2.5-.1 4.7.8 6.4 2.5 1.8 1.6 2.7 3.8 2.7 6.2v2.9c0 .4-.3.7-.7.7h-.7v-2.4c0-.9-.7-1.8-1.7-1.9-1.1-.1-2 .7-2 1.8v6.5c0 .9.7 1.7 1.7 1.9 1.1 0 2-.8 2-1.8v-1.8h1.5c1.2 0 2.2-1 2.2-2.2v-3.5c0-2.9-1.1-5.7-3.3-7.9z"
      }
    },
    new_custom72: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": {
          "d": "M22 .9H2C1.4.9.9 1.4.9 2S1.4 3.1 2 3.1h8.9v2.3c-4 .6-7 3.9-7 8V16c0 2.6 2.1 4.9 4.9 4.9h6.5c2.7 0 4.9-2.2 4.9-4.9v-2.6c0-4.1-3.1-7.5-7-8V3.1H22c.7 0 1.1-.4 1.1-1.1S22.6.9 22 .9zm-4.8 12.5c0 1-.9 1.9-2 1.9H8.8c-1.1 0-1.9-.8-2-1.9.1-2.8 2.3-5.1 5.1-5.1h.1c2.9 0 5.1 2.3 5.2 5.1z"
        },
        "circle": [{
          "cx": "3.138",
          "cy": "21.6",
          "r": "1.477"
        }, {
          "cx": "20.862",
          "cy": "21.6",
          "r": "1.477"
        }]
      }
    },
    new_custom73: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M2.2 6.5h19.6c.4 0 .8-.5.7-1-.5-1.5-1.1-2.9-2-4.1-.3-.4-.8-.4-1.1-.1-.8.8-2.1 1.3-3.4 1.3-1.4 0-2.6-.6-3.5-1.5-.3-.3-.8-.3-1.1 0-.9.9-2.1 1.5-3.5 1.5-1.3 0-2.5-.5-3.4-1.3-.3-.3-.8-.2-1 .1-.9 1.2-1.6 2.7-2 4.2-.1.4.3.9.7.9zm20.9 2.9c0-.4-.3-.7-.8-.7H1.7c-.5 0-.8.3-.8.7v.2c0 6.9 4.8 12.6 11.1 13.5 6.3-.9 11.1-6.6 11.1-13.5v-.2z"
      }
    },
    new_custom74: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M13.9 20.5h-3.8c-.4 0-.7.3-.7.7v1.1c0 .5.3.8.7.8h3.8c.4 0 .7-.3.7-.8v-1.1c0-.4-.3-.7-.7-.7zM12 .9C7.4.9 3.7 4.4 3.7 8.7c0 2.7 1.6 5.2 3.9 6.5.9.5 1.5 1.4 1.7 2.4.1.4.4.6.8.6H14c.4 0 .7-.2.7-.6.2-1 .8-1.9 1.7-2.4 2.3-1.4 3.9-3.8 3.9-6.5 0-4.3-3.7-7.8-8.3-7.8zM9.4 4.4c-.7 1.4-1.1 3-1.2 4.4 0 1.4.3 2.6.8 3.9.1.4-.2.7-.6.5C5 11.4 5.2 5.1 9 3.8c.3 0 .6.3.4.6zm2.9 8.8c-.1.3-.5.3-.7 0-.6-1.4-.7-3.1-.8-4.7.1-1.6.2-3.2.8-4.7.1-.3.6-.3.7 0 .6 1.4.8 3.1.8 4.7s-.2 3.2-.8 4.7zm3.1 0c-.3.2-.6-.1-.5-.4.5-1.4.7-2.8.8-4.2-.1-1.2-.5-2.8-1.2-4.2-.1-.2.1-.6.5-.5 3.7 1.2 3.9 7.6.4 9.3z"
      }
    },
    new_custom75: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12 .9c-.6 0-1.1.5-1.1 1.1v20c0 .6.5 1.1 1.1 1.1 6.1 0 11.1-5 11.1-11.1S18.1.9 12 .9zm8.8 10h-2.9c-.1-2.6-.7-4.9-1.6-6.7 2.4 1.4 4.1 3.8 4.5 6.7zm-7.7 9.5v-7.3h2.5c-.1 3.5-1.2 6.2-2.5 7.3zm0-9.5V3.6c1.3 1.1 2.4 3.8 2.5 7.3h-2.5zm3.2 8.9c.9-1.8 1.4-4.1 1.6-6.7h2.9c-.4 2.9-2.1 5.3-4.5 6.7zM5.9 8.3c.3.2.7.1 1-.1L9 5.9c.2-.3.2-.8-.1-1.1l-2-2c-.3-.3-.7-.3-.9-.1l-.5.3C2.8 5 .9 8.3.9 12s1.9 7 4.6 9l.5.3c.2.2.6.1.9-.1l2-2c.3-.3.3-.8.1-1.1l-2.1-2.3c-.3-.2-.7-.3-1-.1l-.8.6c-.8-1.2-1.2-2.7-1.2-4.3s.4-3 1.2-4.3l.8.6z"
      }
    },
    new_custom76: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12 14c-.1-.2-.5-.5-.8-.4h-.3c-4.2 0-7.5-3.4-7.5-7.5V6c0-.4-.5-.6-.7-.3-.3.4-.5.9-.6 1.3-.7 2.1.2 4.4 2 5.7.8.6 1.7.9 2.5 1l.3.7c.1.1.1.2.2.2l1.1.5c.2.1.3.3.2.5l-.4 1c-.1.2.1.4.2.5l.6.3c.2 0 .3.2.2.4L8.7 19c-.1.2 0 .3.2.4l.8.4c.2.1.3.3.2.5l-.3 1.1c0 .2 0 .4.2.5l2.6 1.1c.2.1.4 0 .5-.2l1.1-2.4c.1-.2.1-.4 0-.6L12 14zm9.9-.3l-6-6.2c.3-.9.3-2-.1-3-.7-2-2.5-3.4-4.7-3.6C7.9.8 5.3 3.5 5.6 6.7c.3 2.3 1.9 4.1 4.1 4.5 1 .2 2 .1 2.8-.2l.5.6c.1.1.2.1.3.1h1.3c.2 0 .4.1.4.3v1.2c0 .2.2.3.4.3h.8c.2 0 .3.2.3.4l.2 1.2c.1.2.2.3.4.3h.9c.2 0 .4.1.4.3l.2 1.2c0 .2.1.3.3.3h2.8c.3 0 .4-.1.4-.4v-2.7c.1-.2 0-.3-.2-.4zM10.1 7.2c-1.1 0-1.9-.8-1.9-1.8s.8-1.9 1.9-1.9 1.9.8 1.9 1.9-.8 1.8-1.9 1.8z"
      }
    },
    new_custom77: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M5.3 9h1.4c.3 0 .4-.1.4-.3v-.6c0-2.8 2.1-5 4.7-5s4.7 2.2 4.7 5v.6c0 .2.2.3.4.3h1.4c.3 0 .4-.1.4-.3v-.6c0-4-3-7.2-6.9-7.2S4.9 4.1 4.9 8.1v.6c0 .2.2.3.4.3zm13.8 2.3H4.9c-1.2 0-2.1 1-2.1 2.2v7.4c0 1.2.9 2.2 2.1 2.2h14.2c1.2 0 2.1-1 2.1-2.2v-7.4c0-1.2-.9-2.2-2.1-2.2zm-5.3 5.9c-.4.5-.6 1.1-.4 1.7l.2 1.1c.1.4-.2.9-.6.9h-2.3c-.5 0-.8-.5-.7-.9l.2-1.1c.2-.6 0-1.2-.3-1.7-.3-.4-.5-1-.4-1.6.2-.9.9-1.6 1.8-1.8 1.5-.3 2.8.8 2.8 2.2 0 .4-.2.8-.3 1.2z"
      }
    },
    new_custom78: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.4 4.4l-6.6-3.3c-.3-.2-.7-.2-1 0l-6.1 3-6.2-3c-.3-.2-.7-.2-1.1 0-.3.2-.5.6-.5.9v16.6c0 .5.3.9.7 1.1L8.2 23c.3.1.7.1 1 0l6.2-3.1 6.2 3.1c.1.1.3.1.4.1.2 0 .4-.1.6-.2.3-.2.5-.6.5-.9V5.4c0-.5-.3-.8-.7-1zm-1.5 2.1v8.8c0 .5-.5.9-1.1.7-1.7-.7-.3-3.5-1.5-5.1-1.2-1.4-2.7 0-4.1-2.2-1.4-2.2.5-3.8 2.1-4.6.3-.1.5-.1.7 0l3.4 1.8c.3.1.5.3.5.6zm-9.5 12.8c-.2.2-.6.1-.8-.1-.4-.4-.8-1-.8-1.7 0-1.1-1.9-.7-1.9-2.9 0-1.8-2.1-2.3-3.9-2.1-.5 0-.9-.3-.9-.8V5c0-.5.6-.9 1.1-.6l4 2h.1l.1.1c1.7 1 1.3 1.8.6 3-.7 1.3-1.1 0-2.2-.4s-2.2.4-1.8 1.1 1.5 0 2.2.7c.7.8.7 1.9 3 1.1 2.2-.7 2.5-.3 3.3.4.7.8 1.1 2.2 0 3.3-.7.7-.9 2-1.2 3-.1.2-.2.4-.4.5l-.5.1z"
      }
    },
    new_custom79: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M8.2 8.9c-1.3 0-2.4 1.1-2.4 2.4s1.1 2.4 2.4 2.4 2.4-1.1 2.4-2.4-1-2.4-2.4-2.4zm13.9 7.5h-6.6v-2.7h.7c.3 0 .6-.3.6-.7v-2c0-.4-.3-.7-.6-.7h-.8c-.6-3.4-3.5-6.1-7.1-6.1C4.2 4.1.9 7.4.9 11.4c.1 4 3.4 7.1 7.5 7.1H21v.7c0 .3.3.6.7.6h.7c.4 0 .7-.3.7-.6v-1.8c0-.5-.5-1-1-1zm-13.9-.7c-2.5 0-4.5-1.9-4.5-4.4s2-4.4 4.5-4.4 4.5 2 4.5 4.4-2 4.4-4.5 4.4z"
      }
    },
    new_custom8: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M10.9 1.4L2.2 11c-.5.5-.5 1.4 0 2l8.7 9.6c.6.7 1.6.7 2.2 0l8.7-9.6c.5-.5.5-1.4 0-2l-8.7-9.6c-.6-.6-1.6-.6-2.2 0z"
      }
    },
    new_custom80: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M4.5 15.6c-2 0-3.6 1.5-3.6 3.5s1.6 3.5 3.6 3.5S8 21 8 19.1s-1.5-3.5-3.5-3.5zm0 4.9c-.8 0-1.5-.7-1.5-1.4 0-.8.7-1.5 1.5-1.5s1.4.7 1.4 1.5c0 .7-.6 1.4-1.4 1.4zm15-4.9c-2 0-3.5 1.5-3.5 3.5s1.5 3.5 3.5 3.5 3.6-1.6 3.6-3.5-1.6-3.5-3.6-3.5zm0 4.9c-.8 0-1.4-.7-1.4-1.4 0-.8.6-1.5 1.4-1.5s1.5.7 1.5 1.5c0 .7-.7 1.4-1.5 1.4zm-.2-7.1c.8 0 1.5.1 2.3.4.3.1.7 0 .9-.4 1.8-3.4-1.1-5-3-5.9-.5-.3-1 .1-1 .6v2.1c0 .4-.3.8-.7.7-2.7-.4-5-3.1-7.9-3.1s-3.2 2.8-3.2 2.8c-2 0-4-.2-4.9-.4-.5 0-.9.3-.9.7 0 0 0 2.5 3.6 2.5 2.9 0 5.3 2.2 5.7 5.1 0 .7 0 1.5-.3 2.2-.1.2.1.5.4.5h3.3c.3 0 .5-.2.4-.5-.2-.7-.2-1.4-.2-2.1.3-2.8 2.6-5.1 5.5-5.2zM.9 10.9zm9.4-5.5c.1.3.3.6.5.6l3.8 1.3c.4.1.7 0 .9-.3l.3-.6c.2-.3 0-.5-.2-.6-1.2-.1-3.5-.5-2.8-1.7.6-1.1 1.8-.8 2.7-.5.3.2.6-.2.5-.5-.6-1.1-1.8-1.8-3.1-1.7-1.7.2-2.9 1.8-2.7 3.5l.1.5z"
      }
    },
    new_custom81: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M21.9.9c-.3 0-1.4.1-1.8.1-5.7.2-12.2 1.7-12.5 1.8-.5.1-.8.6-.8 1v12.1c-.3-.2-.9-.3-1.4-.3-2.5 0-4.5 1.7-4.5 3.7s2 3.7 4.5 3.7 4.4-1.6 4.4-3.7v-7.5c0-.3.2-.6.5-.7 1.8-.4 4.4-.9 9-1.2.5 0 .8.3.8.8v3.8c-.3-.1-.9-.2-1.5-.2-2.4 0-4.4 1.6-4.4 3.7s2 3.6 4.4 3.6 4.5-1.6 4.5-3.6V2c0-.6-.5-1.1-1.2-1.1zm-2.5 5.9c-4.5.3-6.8.7-8.7 1.1-.5.1-.9-.2-.9-.7V6c0-.3.2-.6.6-.7 1.9-.5 4.2-.9 8.9-1.2.5 0 .8.3.8.7V6c0 .5-.3.8-.7.8z"
      }
    },
    new_custom82: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.4 9.9h-7.3c-.4 0-.7.3-.7.7v.3c0 .6-.5 1.1-1.1 1.1-.5 0-1-.5-1-1.1v-.3c0-.4-.3-.7-.7-.7H9.8h.1c-2.1.1-3.9 1.3-4.8 3-.4-.2-.8-.2-1.1-.2-1.8 0-3.2 1.4-3.2 3.1s1.5 3.1 3.3 3.1c.3 0 .7 0 1.1-.2.9 1.7 2.7 2.9 4.8 3 3.3.2 6.2-2.5 6.2-5.9 0-.2 0-.4-.1-.6 0-.3.2-.7.6-.8l5.8-1.2c.3-.1.6-.4.6-.7v-1.9c0-.4-.3-.7-.7-.7zM4 16.8c-.6 0-1-.4-1-1s.4-1 1-1c.2 0 .3.1.4.1-.1.4-.1.9-.1 1.3 0 .2.1.4.1.6H4zm9.4-9.3c.6 0 1-.5 1-1V3.3c0-.5-.5-1-1-1-.6 0-1.1.5-1.1 1v3.2c0 .6.5 1 1.1 1zm-5 .3c.2.3.5.4.8.4.2 0 .5-.1.7-.3.4-.3.5-1 .1-1.4L7.9 4.1c-.4-.5-1.1-.5-1.5-.1-.4.4-.5 1-.1 1.4l2.1 2.4zm9.1.4c.3 0 .6-.2.8-.4l2.1-2.4c.4-.4.3-1.1-.1-1.4-.5-.4-1.1-.3-1.5.1l-2 2.4c-.4.5-.4 1.1 0 1.4.2.2.5.3.7.3z"
      }
    },
    new_custom83: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M21.1 8c.1.2.4.2.5 0l.5-.5c1.3-1.2 1.3-3.2.1-4.4l-1.6-1.6c-1.3-1-3-.5-4 .5l-.5.5c-.1.1-.1.4 0 .5l5 5zm-6.7-3.5c-.1-.1-.3-.1-.5 0L3.8 14.6c-.6.6-1 1.2-1.2 2l-1.6 5c-.1.3-.1.6.1.9.2.4.6.6.9.6.1 0 .3 0 .4-.1 0 0 3.4-1 5-1.5.8-.3 1.4-.7 2-1.2l10.1-10.1c.1-.2.1-.4 0-.6l-5.1-5.1zM6.7 19.3c-.7.3-1.9.7-3 1l1-3c.1-.5.3-.8.6-1.1l2.5 2.5c-.3.3-.7.5-1.1.6z"
      }
    },
    new_custom84: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M21 17.2H3c-.6 0-1.2.4-1.2 1.1s.5 1.1 1.2 1.1h1.4l.6 3.1c.1.3.4.6.7.6h11.9c.3 0 .6-.3.7-.6l.6-3.1H21c.6 0 1.2-.5 1.2-1.1s-.5-1.1-1.2-1.1zM5.8 15h5.1v-2.1c-.4-.3-.7-.8-.7-1.3 0-.8.6-1.4 1.4-1.4.8 0 1.4.6 1.4 1.4 0 .6-.3 1-.7 1.3V15h5.1c.4 0 .7-.4.7-.8v-1.1c0-2.3-2.1-3-3.8-3.7-1.1-.5-1.3-1-1.3-1.4s.3-.9.7-1.3c.7-.6 1.1-1.4 1.1-2.4 0-1.8-1.2-3.4-3.2-3.4S8.4 2.4 8.4 4.3c0 1 .4 1.8 1.1 2.4.3.4.7.8.7 1.3 0 .4-.2.9-1.3 1.4-1.7.7-3.8 1.5-3.8 3.7v1.1c0 .4.3.8.7.8z"
      }
    },
    new_custom85: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.3 2.4H3.9v-.7c0-.5-.3-.8-.8-.8H1.7c-.5 0-.8.3-.8.8v20.6c0 .5.3.8.8.8h1.4c.5 0 .8-.3.8-.8V5.4h18.4c.5 0 .8-.4.8-.8V3.1c0-.4-.3-.7-.8-.7zm-1.4 5.2H8.3c-1.2 0-2.2 1-2.2 2.2v8.1c0 1.2 1 2.2 2.2 2.2h12.6c1.2 0 2.2-1 2.2-2.2V9.8c0-1.2-1-2.2-2.2-2.2zm-2.1 6.2h-.9v3.7c0 .3-.1.4-.4.4h-1.4c-.3 0-.4-.1-.4-.4v-2.2c0-.2-.1-.3-.4-.3h-1.5c-.2 0-.3.1-.3.3v2.2c0 .3-.2.4-.4.4h-1.5c-.2 0-.3-.1-.3-.4v-3.7h-1c-.1 0-.2-.2-.1-.3l4.2-4c.1-.1.3-.1.5 0l4.1 4c.1.1 0 .3-.2.3z"
      }
    },
    new_custom86: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M7.6 4.6H9c.3 0 .4-.1.4-.4V3.1h5.2v1.1c0 .3.1.4.4.4h1.4c.3 0 .4-.1.4-.4V3.1c0-1.2-1-2.2-2.2-2.2H9.4c-1.2 0-2.2 1-2.2 2.2v1.1c0 .3.1.4.4.4zm13.3 2.2H3.1C1.9 6.8.9 7.8.9 9v11.9c0 1.2 1 2.2 2.2 2.2h17.8c1.2 0 2.2-1 2.2-2.2V9c0-1.2-1-2.2-2.2-2.2zM12 20.1c-2.9 0-5.2-2.3-5.2-5.1S9.1 9.8 12 9.8s5.2 2.3 5.2 5.2-2.3 5.1-5.2 5.1zm2.2-6.3h-1.1v-1.1c0-.4-.3-.7-.7-.7h-.8c-.4 0-.7.3-.7.7v1.1H9.8c-.4 0-.8.4-.8.8v.7c0 .4.4.8.8.8h1.1v1.1c0 .4.3.7.7.7h.8c.4 0 .7-.3.7-.7v-1.1h1.1c.4 0 .8-.4.8-.8v-.7c0-.4-.4-.8-.8-.8z"
      }
    },
    new_custom87: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M21 .9H3c-.7 0-1.2.5-1.2 1.1v17.8c0 .6.5 1.1 1.2 1.1h.3V22c0 .6.5 1.1 1.1 1.1h.8c.6 0 1.1-.5 1.1-1.1v-1.1h11.6V22c0 .6.4 1.1 1.1 1.1h.7c.6 0 1.1-.5 1.1-1.1v-1.1h.4c.6 0 1.1-.5 1.1-1.1V2c-.1-.6-.6-1.1-1.3-1.1zM5.1 18.6c-.6 0-1.1-.4-1.1-1.1V4.2c0-.6.5-1.1 1.1-1.1h13.8c.6 0 1.1.5 1.1 1.1v13.3c0 .7-.4 1.1-1.1 1.1H5.1zm12-13.2H6.9c-.4 0-.7.3-.7.7v9.6c0 .4.3.7.7.7h10.2c.4 0 .7-.3.7-.7V6.1c0-.4-.3-.7-.7-.7zM15.4 12h-3c-.4.7-1.3 1.5-2.3 1.5-1.4 0-2.4-1.2-2.4-2.6s1.1-2.6 2.4-2.6c1 0 1.9.7 2.3 1.5h2.9c.6 0 1 .5 1 1.1 0 .5-.4 1.1-.9 1.1z"
      }
    },
    new_custom88: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.4 19.4H1.6c-.4 0-.7.3-.7.6v.1c0 1.6 2.1 3 3.7 3h14.8c1.6 0 3.7-1.4 3.7-3V20c0-.3-.3-.6-.7-.6zM2 17.2h6.7c.4 0 .7-.4.7-.9V3.6c0-.1-.3-.2-.3 0l-7.4 13c-.1.2.1.6.3.6zm10.4 0h9.2c.5 0 .8-.4.7-.9C22 13.7 21.6 5.4 12.1 1c-.2-.1-.5 0-.5.3v15c0 .5.4.9.8.9z"
      }
    },
    new_custom89: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M14.9 9.6c-.1-.2-.5-.2-.5 0-.5.7-.9 1.6-.9 2.8v4c0 .6-.5 1.1-1.1 1.1-.6 0-1.1-.4-1.1-1.1V3.8C11.3 1 8.8.6 7 1.2c-.5.2-1 .5-1.3.9-.2.3-.4.4-.8.6-.7.1-1.8-.5-2.4-.9-.3-.1-.8 0-1 .2l-.4.7c-.3.3-.2.8.1 1C1.9 4.2 3 4.9 3.9 5c1.3.3 2.5-.2 3.4-1 .3-.2.7-.6 1-.2.7 1.1-2.2 6-2.2 13v.6c0 3 3 5.6 6 5.7 3.2.2 5.8-2.4 5.8-5.5 0-1.6.6-2.6 1.2-3.2.1-.2.1-.4 0-.6l-4.2-4.2zm7.1 3.5c-.3 0-.6-.1-.8-.4l-5.9-5.8c-.5-.5-.5-1.2 0-1.6.4-.5 1.1-.5 1.5 0l6 5.9c.4.5.4 1.2 0 1.6-.3.2-.6.3-.8.3z"
      }
    },
    new_custom9: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.8 8C21.8 3.6 17.2.9 12.1.9 5.9.9.9 5.9.9 12s5 11.1 11.2 11.1c8.6 0 7.9-4.4 5.2-6.1-1.7-1-2.5-3.3-.9-5 3-3.1 7.8 1.8 6.4-4zM6 15.7c-1.3 0-2.3-1-2.3-2.3s1-2.3 2.3-2.3 2.3 1 2.3 2.3-1 2.3-2.3 2.3zm.5-8.8c0-1.3 1-2.3 2.3-2.3s2.3 1 2.3 2.3-1 2.3-2.3 2.3-2.3-1-2.3-2.3zm5 13.4c-1.3 0-2.3-1-2.3-2.3s1-2.3 2.3-2.3 2.3 1 2.3 2.3-1 2.3-2.3 2.3zm4.2-12c-1.3 0-2.3-1-2.3-2.3s1-2.3 2.3-2.3S18 4.7 18 6s-1 2.3-2.3 2.3z"
      }
    },
    new_custom90: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.1 3.2l-9 1.3v12.7c0 .2-.1.3-.4.3h-1.4c-.3 0-.4-.1-.4-.3V4.8L2.2 6.1h-.1c-.6 0-1-.4-1.1-.9-.1-.6.3-1.2.8-1.3l6.9-1C9.4 1.8 10.6 1 12 1c1 0 1.9.4 2.5 1l7.3-1c.6-.1 1.2.3 1.2.9.1.6-.2 1.1-.9 1.3zM8.8 16.8c.3-.4.3-.8.2-1.2l-3-7c-.1-.4-.6-.6-1-.6s-.8.2-1 .6l-3 7c-.1.4-.1.7.1 1.1.1.1 1.5 2.3 3.8 2.3 1.4 0 2.7-.8 3.9-2.2zM5 11.9l1.6 3.8H3.4L5 11.9zm15-5.5c-.2-.4-.6-.6-1-.6s-.8.2-1 .6l-3 7c-.1.4 0 .7.1 1 .1.1 1.6 2.4 3.9 2.4 1.4 0 2.6-.8 3.8-2.3.3-.3.4-.7.2-1.1l-3-7zm-1 3.3l1.6 3.8h-3.2L19 9.7zm-7 10.1c-2.1 0-4.2.7-5.6 1.9-.2.2-.3.4-.3.6 0 .5.3.8.7.8h10.4c.4 0 .7-.3.7-.8 0-.2-.1-.4-.3-.6-1.4-1.2-3.5-1.9-5.6-1.9z"
      }
    },
    new_custom91: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.3 5.6c-1.1-.3-2.1-1.1-2.7-2.1-.5-.8-.5-2.6-1.7-2.6H6.1C4.9.9 4.9 2.7 4.4 3.5 3.6 4.7 2.7 5 1.5 5.7c-1.2.7-.1 3.6.2 4.7C2.8 14.5 5 18.3 8.4 21c1 .8 2 1.4 3.1 2 1 .5 2.7-.9 3.4-1.5 1.9-1.4 3.5-3.1 4.8-5.1 1-1.7 1.9-3.5 2.5-5.4l.6-2.4c.1-.6.4-1.7.2-2.3-.1-.3-.4-.6-.7-.7-1.7-.5.5.1 0 0zm-1.6 2.6c-1 4.9-3.7 9.5-8.1 12.2l-.6.4-.6-.4C6.1 17.2 4.1 12 3.3 8.1l-.1-.7.7-.4C5 6.3 6.1 5 6.7 3.7l.3-.6h10l.2.5c.6 1.3 1.7 2.7 3.1 3.5l.5.2v.1l-.1.8zm-9.1-2.8c-.8 0-2.9 0-3.3.3-.7.7-1.1 1.6-1.8 2.2-.8.6-.5 1.3-.2 2.2.5 1.6 1.2 3.1 2.2 4.4.5.7 1 1.4 1.7 2 .1.2 1.8 1.9 1.8.8V6.1c0-.4 0-.7-.4-.7z"
      }
    },
    new_custom92: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M20.8 14.4l-8.4-3.9c-.3-.1-.5-.1-.7 0l-8.5 3.9c-.4.2-.6.7-.3 1.2.9 1.2 1.4 2.8 1.7 3.6.1.2.3.4.6.5 2.9.7 5.3 2.4 6.3 3.1.3.3.7.3 1 0 1-.7 3.4-2.4 6.3-3.1.3-.1.5-.3.6-.5.3-.8.8-2.4 1.7-3.6.3-.4.1-1-.3-1.2zm-11 2c-.7 0-1.1-.6-1.1-1.4 0-.9.4-1.5 1.1-1.5s1.1.6 1.1 1.5c0 .8-.5 1.4-1.1 1.4zm4.4 0c-.6 0-1.1-.6-1.1-1.4 0-.9.5-1.5 1.1-1.5s1.1.6 1.1 1.5c0 .8-.4 1.4-1.1 1.4zm-8-5.8l4.6-2.1c.5-.3 1.1-.3 1.7-.2.3 0 .5.1.8.2l4.5 2.1c.2.1.5-.1.5-.3V8.6c0-.2-.1-.3-.3-.5-.2-.3-.8-.9-1.9-.9V5.1c0-.3-.2-.5-.4-.7-.4-.2-1.1-.5-2.2-.7v-2c0-.5-.3-.8-.8-.8h-1.4c-.5 0-.8.3-.8.8v1.9c-1.1.2-1.8.6-2.2.8-.2.1-.4.4-.4.6v2.2c-1.1 0-1.7.6-1.9.8-.2.2-.3.4-.3.5v1.7c0 .3.3.5.5.4z"
      }
    },
    new_custom93: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": {
          "d": "M9.3 12h11c.3 0 .7-.2.7-.6l2-6.8c.2-.5-.2-1-.7-1h-17l-.3-1c-.2-.4-.6-.8-1.1-.8H2.1c-.6 0-1.1.5-1.2 1.1C.9 3.5 1.4 4 2 4h1.1l3.5 11.6c.1.4.6.7 1.1.7h13c.6 0 1.1-.4 1.2-1 0-.6-.5-1.1-1.1-1.1H9.3c-.5 0-.9-.4-1-.8-.3-.7.3-1.4 1-1.4z"
        },
        "ellipse": [{
          "cx": "9.508",
          "cy": "20.354",
          "rx": "1.846",
          "ry": "1.8"
        }, {
          "cx": "18.508",
          "cy": "20.354",
          "rx": "1.846",
          "ry": "1.8"
        }]
      }
    },
    new_custom94: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M14.2 7.6V2c0-.6-.4-1.1-1.1-1.1h-1.5c-.6 0-1.1.5-1.1 1.1s.5 1.1 1.1 1.1h.4v4.5C12 10 10 12 7.6 12s-4.5-2-4.5-4.4V3.1h.4c.7 0 1.1-.4 1.1-1.1S4.2.9 3.5.9H2C1.4.9.9 1.4.9 2v5.6c0 3.6 3 6.6 6.7 6.6s6.6-3 6.6-6.6zm8.9 4.4c0-1.8-1.5-3.3-3.3-3.3s-3.4 1.5-3.4 3.3c0 1.4 1 2.7 2.2 3.1v.9c0 2.6-2.2 4.9-4.8 4.9h-.1c-2.3 0-4.3-1.7-4.8-3.9-.1-.3-.4-.6-.8-.6h-.7c-.5 0-.8.5-.8.9.6 3.3 3.6 5.8 7 5.8h.1c3.9 0 7.1-3.3 7.1-7.1v-.9c1.4-.4 2.3-1.7 2.3-3.1zm-3.3 1.1c-.7 0-1.2-.5-1.2-1.1s.5-1.1 1.2-1.1 1.1.5 1.1 1.1-.5 1.1-1.1 1.1z"
      }
    },
    new_custom95: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M13.1 4.7V3.1h.4c.6 0 1.1-.4 1.1-1.1 0-.6-.5-1.1-1.1-1.1h-3c-.6 0-1.1.5-1.1 1.1 0 .6.5 1.1 1.1 1.1h.4v1.6c-4.6.6-8.1 4.4-8.1 9.1 0 5.1 4.1 9.3 9.2 9.3s9.2-4.2 9.2-9.3c0-4.7-3.5-8.5-8.1-9.1zM12 20.9c-3.9 0-7-3.2-7-7.1s3.1-7 7-7 7 3.2 7 7-3.1 7.1-7 7.1zm2.4-10.8l-1.7 1.7c-.2-.1-.4-.2-.7-.2-1.2 0-2.2 1-2.2 2.2s1 2.3 2.2 2.3 2.2-1.1 2.2-2.3c0-.2 0-.5-.1-.7l1.7-1.7c.4-.4.4-1 0-1.3-.4-.4-1-.4-1.4 0z"
      }
    },
    new_custom96: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.8 4.2l-1.9-1.5c-.3-.2-.5-.3-.9-.3h-6.5v-.7c0-.5-.3-.8-.8-.8h-1.4c-.5 0-.8.3-.8.8v.7H3.1c-.4 0-.7.3-.7.7v3c0 .4.3.7.7.7H20c.4 0 .7-.1.9-.2l1.9-1.5c.4-.3.4-.7 0-.9zm-1.9 6.3h-7.4V9.4c0-.2-.2-.4-.4-.4h-2.2c-.2 0-.4.2-.4.4v1.1H4c-.4 0-.7.1-.9.3l-1.9 1.4c-.4.3-.4.7 0 1l1.9 1.4c.3.2.5.3.9.3h16.9c.4 0 .7-.3.7-.7v-3c0-.4-.3-.7-.7-.7zM13.5 20v-2.5c0-.2-.2-.3-.4-.3h-2.2c-.2 0-.4.1-.4.3V20c-1.5.4-2.3 1.3-2.5 2.4-.1.3.2.7.5.7h7c.4 0 .7-.3.6-.7-.3-1.1-1.1-2-2.6-2.4z"
      }
    },
    new_custom97: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M15.8 13.5V4.8c0-2.2-1.7-3.9-3.8-3.9-2.2 0-3.8 1.7-3.8 3.9v8.7c-1.1 1.1-1.7 2.5-1.7 4 0 3.1 2.5 5.6 5.5 5.6s5.5-2.5 5.5-5.6c0-1.5-.6-2.9-1.7-4zm-.9 4H9.1c-.3 0-.6-.3-.5-.6.1-.8.6-1.6 1.2-2.1.3-.2.4-.5.4-.8V4.8C10.2 3.7 11 3 12 3s1.7.8 1.7 1.8v.3h-1c-.6 0-1 .4-1 1s.4 1 1 1h1v1.4h-1c-.6 0-1 .5-1 1s.4 1 1 1h1v1.4h-1c-.6 0-1 .5-1 1s.4 1 1 1h1c.1.4.2.6.4.8.7.5 1.1 1.3 1.3 2.1.1.4-.2.7-.5.7z"
      }
    },
    new_custom98: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": [{
          "d": "M22.9 10.2l-2.7-2.7c-.2-.2-.4-.3-.5-.3h-2.8c-.4 0-.7.4-.7.7v5.6c0 .3.2.4.5.3.5-.2 1-.3 1.6-.3 1.5 0 2.9.9 3.6 2.2.1.2.4.2.5.1.4-.4.7-.9.7-1.6v-3.5c0-.2-.1-.4-.2-.5z"
        }, {
          "d": "M13.4 4.2H1.6c-.4 0-.7.3-.7.6v9.5c0 .6.3 1.2.7 1.5.2.2.4.1.5-.1.7-1.3 2.1-2.1 3.7-2.1 1.7 0 3.2 1 3.8 2.6 0 .1.2.2.3.2H12c1.2 0 2.1-.9 2.1-2.1V4.8c0-.3-.3-.6-.7-.6z"
        }],
        "ellipse": [{
          "cx": "18.231",
          "cy": "17.769",
          "rx": "2.077",
          "ry": "2.077"
        }, {
          "cx": "5.769",
          "cy": "17.769",
          "rx": "2.077",
          "ry": "2.077"
        }]
      }
    },
    new_custom99: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M20.9 7.7h-6.2c-.2-.5-.5-.8-.8-1.1l2.3-3c.4-.5.3-1.2-.2-1.5-.4-.4-1.2-.3-1.6.2l-2.5 3.2h-1.2L8.1 2.3c-.4-.5-1.1-.6-1.6-.2s-.5 1-.1 1.5l2.3 3c-.3.3-.6.6-.8 1.1H3.1C1.9 7.7.9 8.6.9 9.8V20c0 1.2 1 2.2 2.2 2.2h17.8c1.2 0 2.2-1 2.2-2.2V9.8c0-1.2-1-2.1-2.2-2.1zm-3 11.5c0 .5-.3.8-.7.8H3.9c-.4 0-.8-.3-.8-.8v-8.6c0-.4.4-.8.8-.8h13.3c.4 0 .7.4.7.8v8.6zm2.6-3.6c-.7 0-1.1-.4-1.1-1.1s.4-1.1 1.1-1.1 1.1.5 1.1 1.1-.5 1.1-1.1 1.1zm0-3.6c-.7 0-1.1-.5-1.1-1.1 0-.6.4-1.1 1.1-1.1s1.1.5 1.1 1.1c0 .6-.5 1.1-1.1 1.1z"
      }
    },
    new_event: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M21.5 9.2h-19c-.3 0-.7.4-.7.7v11.3c0 1 .9 1.9 1.9 1.9h16.6c1 0 1.9-.9 1.9-1.9V9.9c0-.3-.4-.7-.7-.7zM8.8 19.4c0 .3-.2.4-.5.4H6.5c-.3 0-.5-.1-.5-.4v-1.9c0-.2.2-.4.5-.4h1.8c.3 0 .5.2.5.4v1.9zm0-4.6c0 .2-.2.4-.5.4H6.5c-.3 0-.5-.2-.5-.4v-1.9c0-.3.2-.4.5-.4h1.8c.3 0 .5.1.5.4v1.9zm4.6 4.6c0 .3-.2.4-.5.4h-1.8c-.3 0-.5-.1-.5-.4v-1.9c0-.2.2-.4.5-.4h1.8c.3 0 .5.2.5.4v1.9zm0-4.6c0 .2-.2.4-.5.4h-1.8c-.3 0-.5-.2-.5-.4v-1.9c0-.3.2-.4.5-.4h1.8c.3 0 .5.1.5.4v1.9zm4.6 4.6c0 .3-.2.4-.5.4h-1.8c-.3 0-.5-.1-.5-.4v-1.9c0-.2.2-.4.5-.4h1.8c.3 0 .5.2.5.4v1.9zm0-4.6c0 .2-.2.4-.5.4h-1.8c-.3 0-.5-.2-.5-.4v-1.9c0-.3.2-.4.5-.4h1.8c.3 0 .5.1.5.4v1.9zm2.3-11.6H18v-.9c0-.7-.6-1.4-1.4-1.4-.7 0-1.4.6-1.4 1.4v.9H8.8v-.9c0-.7-.6-1.4-1.4-1.4C6.6.9 6 1.5 6 2.3v.9H3.7c-1 0-1.9.9-1.9 1.9v1.1c0 .4.4.7.7.7h19c.3 0 .7-.3.7-.7V5.1c0-1-.9-1.9-1.9-1.9z"
      }
    },
    new_group: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M7.3 12.9c-.7-.9-1-2.1-1-3.3 0-2.1.9-3.9 2.3-4.9-.5-.9-1.4-1.5-2.6-1.5-2 0-3.2 1.7-3.2 3.6 0 1 .3 1.9 1 2.5.4.3.7.8.7 1.3 0 .4-.2.9-1.3 1.4-1.7.7-3.2 1.8-3.2 3.3 0 1 .6 1.8 1.6 1.8h1.5c.3 0 .5-.2.6-.4.8-1.3 2.2-2.2 3.3-2.8.4-.1.5-.7.3-1zm13.5-.9c-1.2-.5-1.4-.9-1.4-1.4s.4-1 .7-1.3c.7-.7 1-1.5 1-2.5 0-1.9-1.1-3.6-3.1-3.6-1.2 0-2.2.6-2.7 1.5 1.4 1 2.3 2.8 2.3 4.9 0 1.2-.3 2.4-1 3.3-.2.4-.1.9.3 1 1.1.6 2.5 1.5 3.3 2.8.1.2.3.4.6.4h1.5c1 0 1.6-.8 1.6-1.8.1-1.5-1.5-2.6-3.1-3.3zM15 15.4c-1.2-.6-1.4-1.1-1.4-1.6 0-.6.3-1.1.8-1.4.7-.7 1.1-1.7 1.1-2.8 0-2.1-1.2-3.9-3.5-3.9S8.5 7.5 8.5 9.6c0 1.1.4 2.1 1.1 2.8.5.4.8.9.8 1.4 0 .6-.2 1-1.4 1.6-1.9.8-3.6 1.6-3.7 3.3 0 1.1.8 2 1.9 2h9.6c1.1 0 1.9-.9 1.9-2-.1-1.7-1.8-2.5-3.7-3.3z"
      }
    },
    new_lead: {
      "xmlns": "http://www.w3.org/2000/svg",
      "circle": {
        "cx": "12",
        "cy": "4.246",
        "r": "3.323"
      },
      "path": {
        "d": "M22.3 9.8H1.7c-.8 0-1.1.9-.5 1.3l5.4 3.5c.3.2.5.5.3.8l-2 6.8c-.2.7.8 1.2 1.3.6l5.3-5.5c.3-.3.8-.3 1.1 0l5.3 5.5c.5.6 1.4.1 1.3-.6l-2.1-6.8c-.1-.3 0-.7.3-.9l5.4-3.4c.6-.4.3-1.3-.5-1.3z"
      }
    },
    new_note: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M19.1 18.3l-.4.4c-.5.5-1.1.7-1.7.7h-1.2c-1.1 0-2.3-.8-2.3-2.4v-1.1c0-.9.4-1.5.6-1.8l5-5.1c.1-.1.3-.5.3-.6V4.5c0-1.2-1-2.2-2.2-2.2H5.4c-1.2 0-2.3 1.1-2.3 2.2h-.7C1.6 4.5.9 5.2.9 6s.7 1.5 1.5 1.5h.7v3h-.7c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.7v3h-.7c-.8 0-1.5.7-1.5 1.5s.7 1.4 1.5 1.4h.7c0 1.5 1.1 2.2 2.3 2.2h11.8c1.2 0 2.2-1 2.2-2.2v-.9c0-.3-.1-.3-.3-.2zM15.3 7.9c0 .4-.3.7-.7.7H7.2c-.4 0-.7-.3-.7-.7v-.7c0-.5.3-.8.7-.8h7.4c.4 0 .7.3.7.8v.7zM12 16.8c0 .5-.3.8-.7.8H7.2c-.4 0-.7-.3-.7-.8v-.7c0-.4.3-.7.7-.7h4.1c.4 0 .7.3.7.7v.7zm1.1-4.4c0 .4-.3.7-.7.7H7.2c-.4 0-.7-.3-.7-.7v-.8c0-.4.3-.7.7-.7h5.2c.4 0 .7.3.7.7v.8zm9.7-2.1l-.4-.4c-.3-.3-.8-.3-1 0l-5.7 5.8V17c0 .1 0 .2.1.2h1.3l5.7-5.8c.4-.3.4-.7 0-1.1z"
      }
    },
    new_notebook: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M20.3.9H6.5c-1.1 0-1.9.9-1.9 1.9v1.4H3.2c-.8 0-1.4.6-1.4 1.3s.6 1.4 1.4 1.4h1.4v3.7H3.2c-.8 0-1.4.6-1.4 1.4s.6 1.4 1.4 1.4h1.4v3.7H3.2c-.8 0-1.4.6-1.4 1.4s.6 1.3 1.4 1.3h1.4v1.4c0 1 .8 1.9 1.9 1.9h13.8c1 0 1.9-.9 1.9-1.9V2.8c0-1-.9-1.9-1.9-1.9zm-3.2 15.7c0 .3-.2.5-.5.5h-6.4c-.3 0-.5-.2-.5-.5v-.9c0-.3.2-.5.5-.5h6.4c.3 0 .5.2.5.5v.9zm.9-3.7c0 .3-.2.5-.5.5H9.2c-.2 0-.4-.2-.4-.5V12c0-.3.2-.5.4-.5h8.3c.3 0 .5.2.5.5v.9zm.9-4.6c0 .3-.2.5-.4.5H8.3c-.3 0-.5-.2-.5-.5V5.5c0-.2.2-.4.5-.4h10.2c.2 0 .4.2.4.4v2.8z"
      }
    },
    new_opportunity: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M19.3 18.9H4.7c-.4 0-.6.3-.6.7 0 1.2.9 2.1 2 2.1h11.8c1.2 0 2.1-.9 2.1-2.1-.1-.4-.3-.7-.7-.7zM21 4.7c-1.2 0-2.1.9-2.1 2.1 0 .6.3 1.2.8 1.6-.6 1.3-2 2.2-3.5 2.2-1.9-.1-3.4-1.6-3.5-3.4 0-.4 0-.6.1-.9.8-.3 1.3-1 1.3-2 0-1.1-.9-2-2.1-2s-2.1.9-2.1 2.1c0 .9.6 1.6 1.3 1.9.1.3.1.6.1.9-.1 1.8-1.6 3.3-3.4 3.4-1.6.1-3-.9-3.6-2.2.5-.4.8-1 .8-1.6 0-1.1-.9-2-2.1-2s-2.1.9-2.1 2S1.8 8.9 3 8.9l1 7.4c0 .3.3.5.6.5h14.8c.3 0 .6-.2.6-.5l1-7.4c1.2 0 2.1-.9 2.1-2.1s-.9-2.1-2.1-2.1z"
      }
    },
    new_person_account: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M19.2 15.3c-1.3-.5-1.5-1-1.5-1.6 0-.5.3-1.1.8-1.5.8-.7 1.2-1.7 1.2-2.8 0-2.2-1.4-4-3.8-4s-3.8 1.8-3.8 4c0 1.2.5 2.1 1.2 2.8.5.4.9 1 .9 1.5 0 .6-.3 1.1-1.6 1.6-2 .9-3.8 1.9-3.9 3.6 0 1.2.9 2.3 2 2.3H21c1.2 0 2-1.1 2-2.3.1-1.7-1.8-2.7-3.8-3.6zM10.4 17"
      }, {
        "d": "M10.8 12.5c-.1-.2-.9-1.1-.8-3.6 0-2.4 1.1-3 1.1-3V3.5c0-.5-.4-.7-.7-.7H1.6s-.7.3-.7.7v16.1h5c.1-4.1 4.9-5.8 4.9-5.8.6-.3.1-1.1 0-1.3zm-5.9 5.1c0 .4-.3.7-.7.7h-.8c-.4 0-.7-.3-.7-.7v-.8c0-.4.3-.7.7-.7h.8c.4 0 .7.3.7.7v.8zm0-3.7c0 .5-.3.8-.7.8h-.8c-.4 0-.7-.3-.7-.8v-.7c0-.4.3-.7.7-.7h.8c.4 0 .7.3.7.7v.7zm0-3.7c0 .5-.3.8-.7.8h-.8c-.4 0-.7-.3-.7-.8v-.7c0-.4.3-.7.7-.7h.8c.4 0 .7.3.7.7v.7zm0-3.6c0 .4-.3.7-.7.7h-.8c-.4 0-.7-.3-.7-.7v-.7c0-.5.3-.8.7-.8h.8c.4 0 .7.3.7.8v.7zM9 13.9c0 .5-.3.8-.7.8h-.7c-.4 0-.8-.3-.8-.8v-.7c0-.4.4-.7.8-.7h.7c.4 0 .7.3.7.7v.7zm0-3.7c0 .5-.3.8-.7.8h-.7c-.4 0-.8-.3-.8-.8v-.7c0-.4.4-.7.8-.7h.7c.4 0 .7.3.7.7v.7zm0-3.6c0 .4-.3.7-.7.7h-.7c-.4 0-.8-.3-.8-.7v-.7c0-.5.4-.8.8-.8h.7c.4 0 .7.3.7.8v.7z"
      }]
    },
    new_task: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M11.1 3.2l-.8-.8c-.2-.2-.6-.2-.8 0L4.6 7.3l-2-1.9c-.2-.3-.5-.3-.8 0l-.7.7c-.3.3-.3.6 0 .8l2.7 2.7c.2.3.5.4.8.4.2 0 .5-.1.8-.4L11.1 4c.2-.2.2-.5 0-.8zm11.2 5.3h-9.6c-.4 0-.7-.3-.7-.7V6.3c0-.4.3-.8.7-.8h9.6c.5 0 .8.4.8.8v1.5c0 .4-.3.7-.8.7zm0 6.6H10.5c-.4 0-.8-.3-.8-.7v-1.5c0-.4.4-.8.8-.8h11.8c.5 0 .8.4.8.8v1.5c0 .4-.3.7-.8.7zM6 15.1H4.5c-.4 0-.7-.3-.7-.7v-1.5c0-.4.3-.8.7-.8H6c.4 0 .7.4.7.8v1.5c.1.4-.3.7-.7.7zm0 6.6H4.5c-.4 0-.7-.3-.7-.7v-1.5c0-.4.3-.8.7-.8H6c.4 0 .7.4.7.8V21c.1.4-.3.7-.7.7zm16.3 0H10.5c-.4 0-.8-.3-.8-.7v-1.5c0-.4.4-.8.8-.8h11.8c.5 0 .8.4.8.8V21c0 .4-.3.7-.8.7z"
      }
    },
    password_unlock: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M4.6 8.4v.1-.1zm14.8 2.2h-12V8.4c0-2.4 1.8-4.6 4.3-4.7 2.2-.1 4.1 1.3 4.7 3.3.1.2.3.4.5.4h1.9c.3 0 .5-.3.4-.6-.7-3.5-3.8-6.1-7.6-5.9-3.9.2-6.9 3.6-7 7.5v2.2c-1 0-1.8.8-1.8 1.9v8.7c0 1 .8 1.9 1.8 1.9h14.8c1 0 1.8-.9 1.8-1.9v-8.7c0-1.1-.8-1.9-1.8-1.9zm-5.3 9.1c.1.3-.1.6-.4.6h-3.4c-.3 0-.6-.3-.5-.6l.9-2.8c-.7-.4-1.1-1.3-1-2.2.2-.9.9-1.5 1.8-1.7 1.5-.3 2.8.8 2.8 2.1 0 .8-.4 1.5-1 1.8l.8 2.8z"
      }
    },
    preview: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M23.9 11.6C21.7 7.2 17.2 4.2 12 4.2S2.3 7.2.1 11.6c-.1.3-.1.6 0 .8 2.2 4.4 6.7 7.4 11.9 7.4s9.7-3 11.9-7.4c.1-.3.1-.5 0-.8zM12 17.1c-2.8 0-5.1-2.3-5.1-5.1S9.2 6.9 12 6.9s5.1 2.3 5.1 5.1-2.3 5.1-5.1 5.1zm0-8.3c-1.8 0-3.2 1.4-3.2 3.2s1.4 3.2 3.2 3.2 3.2-1.4 3.2-3.2-1.4-3.2-3.2-3.2z"
      }
    },
    priority: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M4.2 1.6c0-.4-.4-.7-.7-.7H2.1c-.4 0-.7.3-.7.7v20.8c0 .4.3.7.7.7h1.4c.3 0 .7-.3.7-.7V1.6zm17.7 2c-7.4 3.8-6.5-4.1-15.4-1-.3.1-.5.4-.5.6V14c0 .3.3.5.6.4 8.9-3 7.9 5.2 15.6.8.3-.1.4-.3.4-.6V3.9c0-.3-.4-.5-.7-.3z"
      }
    },
    question_post_action: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M13.1 17.5h-2.3c-.4 0-.6-.2-.6-.6v-.7c0-1.9 1.2-3.7 3-4.3.6-.2 1.1-.5 1.5-1 2.3-2.8.2-6.1-2.6-6.2-1 0-1.9.3-2.7 1-.6.6-1 1.3-1 2.1-.1.2-.4.5-.7.5H5.4c-.5 0-.8-.4-.7-.8.1-1.7.9-3.3 2.2-4.5C8.4 1.6 10.2.8 12.3.9c3.8.1 6.9 3.3 7.1 7.1.1 3.2-1.9 6.1-4.9 7.2-.4.2-.7.5-.7 1v.6c0 .5-.3.7-.7.7zm.7 4.9c0 .4-.3.7-.6.7h-2.4c-.3 0-.6-.3-.6-.7v-2.3c0-.4.3-.7.6-.7h2.4c.3 0 .6.3.6.7v2.3z"
      }
    },
    quote: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M16.2 10.6H7.8c-.2 0-.4.2-.4.5v1.4c0 .2.2.4.4.4h8.4c.2 0 .4-.2.4-.4v-1.4c0-.3-.2-.5-.4-.5zm-1 4.2H8.8c-.3 0-.5.2-.5.4v1.4c0 .3.2.5.5.5h6.4c.3 0 .5-.2.5-.5v-1.4c0-.2-.2-.4-.5-.4zm5.9-9.1l-4.4-4.3c-.4-.3-.8-.5-1.3-.5H8.6c-.5 0-.9.2-1.3.5L2.9 5.7c-.4.3-.6.8-.6 1.3v14.2c0 1 .8 1.9 1.9 1.9h15.6c1.1 0 1.9-.9 1.9-1.9V7c0-.5-.2-1-.6-1.3zM12 2.3c1 0 1.8.8 1.8 1.9S13 6 12 6s-1.8-.8-1.8-1.8.8-1.9 1.8-1.9zm6.9 17.3c0 .4-.3.7-.7.7H5.8c-.4 0-.7-.3-.7-.7V8.1c0-.4.3-.7.7-.7h12.4c.4 0 .7.3.7.7v11.5z"
      }
    },
    recall: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M8.4 10.4c-.2-.2-.1-.7.2-.8h4.2c3.1 0 5.6 2.6 5.3 5.8-.3 2.7-2.7 4.8-5.5 4.8h-1.5c-.4 0-.8.3-.8.7v1.4c0 .4.4.8.8.8h1.6c4.5 0 8.1-3.6 8.2-8.1.1-4.5-3.8-8.3-8.3-8.3H8.7s-1.2 0-.4-.8L11 3.2c.3-.3.3-.8 0-1l-1-1c-.3-.3-.8-.3-1 0L2.5 7.7c-.3.2-.3.7 0 1L9 15.2c.3.3.7.3 1 0l1-1c.3-.3.3-.8 0-1l-2.6-2.8z"
      }
    },
    record: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M8 5.4h8c.4 0 .8-.4.8-.8V3.1c0-1.2-1-2.2-2.2-2.2H9.5c-1.2 0-2.2 1-2.2 2.2v1.5c0 .4.3.8.7.8zm12-2.6h-.8c-.2 0-.3.1-.3.3v1.5c0 1.6-1.3 3-2.9 3H8c-1.6 0-2.9-1.4-2.9-3V3.1c0-.2-.1-.3-.3-.3H4c-1.2 0-2.2 1-2.2 2.2v15.9c0 1.2 1 2.2 2.2 2.2h16c1.2 0 2.2-1 2.2-2.2V5c0-1.2-1-2.2-2.2-2.2zM8 18.6c0 .5-.3.8-.7.8h-.7c-.5 0-.8-.3-.8-.8v-.7c0-.4.3-.7.8-.7h.7c.4 0 .7.3.7.7v.7zM8 15c0 .4-.3.7-.7.7h-.7c-.5 0-.8-.3-.8-.7v-.8c0-.4.3-.7.8-.7h.7c.4 0 .7.3.7.7v.8zm0-3.7c0 .4-.3.7-.7.7h-.7c-.5 0-.8-.3-.8-.7v-.8c0-.4.3-.7.8-.7h.7c.4 0 .7.3.7.7v.8zm10.2 7.3c0 .5-.3.8-.8.8h-7.2c-.4 0-.7-.3-.7-.8v-.7c0-.4.3-.7.7-.7h7.2c.5 0 .8.3.8.7v.7zm0-3.6c0 .4-.3.7-.8.7h-7.2c-.4 0-.7-.3-.7-.7v-.8c0-.4.3-.7.7-.7h7.2c.5 0 .8.3.8.7v.8zm0-3.7c0 .4-.3.7-.8.7h-7.2c-.4 0-.7-.3-.7-.7v-.8c0-.4.3-.7.7-.7h7.2c.5 0 .8.3.8.7v.8z"
      }
    },
    refresh: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M21.5 1.8h-1.4c-.4 0-.7.4-.7.7v3.3c0 .4-.2.6-.6.3-.1-.2-.2-.3-.4-.5-2.3-2.3-5.6-3.2-8.9-2.6-1.1.2-2.3.7-3.2 1.3-2.8 1.9-4.5 4.9-4.5 8.1 0 2.5.9 5 2.7 6.8 1.8 1.9 4.3 3 7 3 2.3 0 4.6-.8 6.3-2.3.3-.3.3-.7.1-1l-1-1c-.2-.2-.7-.3-.9 0-1.7 1.3-4 1.9-6.2 1.3-.6-.1-1.2-.4-1.8-.7-2.6-1.6-3.8-4.7-3.1-7.7.1-.6.4-1.2.7-1.8 1.3-2.2 3.6-3.5 6-3.5 1.8 0 3.6.8 4.9 2.1.2.2.4.4.5.6.2.4-.2.6-.6.6h-3.2c-.4 0-.7.3-.7.7v1.4c0 .4.3.6.7.6h8.4c.3 0 .6-.2.6-.6V2.5c0-.3-.4-.7-.7-.7z"
      }
    },
    reject: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M14.6 11.9l6-6c.3-.3.3-.7 0-1l-.9-1c-.3-.3-.7-.3-1 0L12.6 10c-.1.2-.4.2-.6 0L6 3.9c-.3-.3-.7-.3-1 0l-1 .9c-.3.3-.3.7 0 1l6.1 6.1c.1.1.1.4 0 .6L4 18.6c-.3.3-.3.7 0 1l.9.9c.3.3.7.3 1 0l6.1-6c.2-.2.5-.2.6 0l6.1 6c.3.3.7.3 1 0l.9-.9c.3-.3.3-.7 0-1l-6-6c-.2-.2-.2-.5 0-.7z"
      }
    },
    remove: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M14.6 11.9l6-6c.3-.3.3-.7 0-1l-.9-1c-.3-.3-.7-.3-1 0L12.6 10c-.1.2-.4.2-.6 0L6 3.9c-.3-.3-.7-.3-1 0l-1 .9c-.3.3-.3.7 0 1l6.1 6.1c.1.1.1.4 0 .6L4 18.6c-.3.3-.3.7 0 1l.9.9c.3.3.7.3 1 0l6.1-6c.2-.2.5-.2.6 0l6.1 6c.3.3.7.3 1 0l.9-.9c.3-.3.3-.7 0-1l-6-6c-.2-.2-.2-.5 0-.7z"
      }
    },
    remove_relationship: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M16.6 9.2c0-1-.8-1.8-1.8-1.8h-12c-1 0-1.9.8-1.9 1.8v12c0 1 .9 1.9 1.9 1.9h12c1 0 1.8-.9 1.8-1.9v-12zm-11.5 7c-.3 0-.5-.3-.5-.5v-.9c0-.3.2-.5.5-.5h7.4c.2 0 .4.2.4.5v.9c0 .2-.2.5-.4.5H5.1zm14.7 3.2h-1.3v-2.8h1.3c.3 0 .5-.2.5-.4v-12c0-.3-.2-.5-.5-.5h-12c-.2 0-.4.2-.4.5v1.3H4.6V4.2C4.6 2.4 6 .9 7.8.9h12c1.8 0 3.3 1.5 3.3 3.3v12c0 1.8-1.5 3.2-3.3 3.2z"
      }
    },
    reset_password: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M21.5 1.8h-1.4c-.4 0-.7.4-.7.7v3.3c0 .4-.2.6-.6.3-.1-.2-.2-.3-.4-.5-2.3-2.3-5.6-3.2-8.9-2.6-1.1.2-2.3.7-3.2 1.3-2.8 1.9-4.5 4.9-4.5 8.1 0 2.5.9 5 2.7 6.8 1.8 1.9 4.3 3 7 3 2.3 0 4.6-.8 6.3-2.3.3-.3.3-.7.1-1l-1-1c-.2-.2-.7-.3-.9 0-1.7 1.3-4 1.9-6.2 1.3-.6-.1-1.2-.4-1.8-.7-2.6-1.6-3.8-4.7-3.1-7.7.1-.6.4-1.2.7-1.8 1.3-2.2 3.6-3.5 6-3.5 1.8 0 3.6.8 4.9 2.1.2.2.4.4.5.6.2.4-.2.6-.6.6h-3.2c-.4 0-.7.3-.7.7v1.4c0 .4.3.6.7.6h8.4c.3 0 .6-.2.6-.6V2.5c0-.3-.4-.7-.7-.7z"
      }
    },
    share: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.4 13.8H21c-.4 0-.7.4-.7.7v5.1c0 .4-.3.7-.7.7H4.4c-.4 0-.7-.3-.7-.7V9.9c0-.3.3-.7.7-.7h1.8c.4 0 .7-.3.7-.7V7.2c0-.4-.3-.7-.7-.7H2.8c-1 0-1.9.8-1.9 1.8v12.9c0 1 .9 1.9 1.9 1.9h18.4c1 0 1.9-.9 1.9-1.9v-6.7c0-.3-.3-.7-.7-.7zm-6.7-7.3c-4.6 0-8.8 4.1-9.2 8.9 0 .4.3.8.7.8h1.4c.4 0 .6-.3.7-.6.3-3.5 3.3-6.4 6.9-6.4h.7c.4 0 .6.5.3.8l-2.5 2.6c-.3.3-.3.7 0 1l.9.9c.3.3.7.3 1 0l6.3-6.2c.3-.3.3-.7 0-1l-6.2-6.2c-.3-.3-.7-.3-1 0l-1 1c-.3.3-.3.7 0 .9l2.6 2.6c.2.3.1.8-.4.8l-1.2.1z"
      }
    },
    share_file: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.9 7.4h3.6c.2 0 .3-.2.2-.4l-3.8-3.9c-.2-.1-.4 0-.4.2v3.6c0 .3.1.5.4.5zm3.7 1.8h-5.1c-.5 0-.9-.4-.9-.9V3.2c0-.2-.2-.4-.4-.4H9.9c-.3 0-.7.3-.7.7v1.8c0 .2.1.4.2.5L12 8.4c.4.4.6.9.7 1.4.1.8-.1 1.5-.6 2l-.7.7c-.3.2-.5.3-.8.5.3.1.7.2 1.1.2 1.2.1 2.1 1.2 2.1 2.4v1c0 .7-.3 1.3-.7 1.7-.5.5-1.2.7-1.8.6-.5 0-1-.1-1.5-.2-.3-.1-.6.1-.6.5v1.4c0 .4.4.7.7.7h12.5c.4 0 .7-.3.7-.7V9.7c0-.3-.2-.5-.5-.5zM12 16.6v-1c0-.3-.2-.5-.5-.6-2.5-.2-4.6-2.3-4.6-4.9v-.6c0-.3.4-.5.6-.2l1.8 1.8c.2.2.5.2.7 0l.7-.7c.2-.2.2-.5 0-.7L6.2 5.3c-.2-.2-.5-.2-.7 0L1.1 9.7c-.2.2-.2.5 0 .7l.7.7c.1.2.5.3.6.1l2-1.9c.2-.2.6 0 .6.3v.8c0 3.4 2.9 6.4 6.4 6.7.4 0 .6-.3.6-.5z"
      }
    },
    share_link: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12.6 19.2l-1-.1s-.7-.1-1-.3c-.2 0-.4 0-.5.2l-.3.2c-1.3 1.3-3.5 1.5-4.9.3-1.5-1.4-1.6-3.8-.1-5.2l3.5-3.5c.4-.5 1-.7 1.5-.9.8-.2 1.6-.2 2.2.1.5.2.9.4 1.2.8.2.2.4.4.5.6.2.3.6.4.8.1l1.3-1.3c.2-.2.2-.5.1-.7-.2-.3-.4-.5-.7-.7-.3-.4-.7-.7-1.1-.9-.6-.4-1.4-.7-2.1-.8-1.5-.3-3-.1-4.3.6-.5.3-1.1.7-1.5 1.1l-3.3 3.3C.4 14.6.2 18.6 2.6 21c2.4 2.7 6.6 2.8 9.1.2l1.2-1.1c.3-.3.1-.8-.3-.9zM21 2.7C18.5.3 14.5.5 12.1 3l-1 1c-.3.3-.1.8.3.9.6 0 1.3.2 1.9.4.2 0 .5 0 .6-.2l.2-.2c1.4-1.3 3.5-1.5 4.9-.3 1.6 1.4 1.6 3.8.2 5.2l-3.5 3.5c-.5.5-1 .7-1.6.9-.7.2-1.5.2-2.2-.1-.4-.2-.8-.4-1.2-.8-.2-.2-.3-.4-.5-.6-.1-.3-.6-.4-.8-.1l-1.3 1.3c-.2.2-.2.5 0 .7.2.3.4.5.6.7.3.3.8.7 1.1.9.7.4 1.4.7 2.2.8 1.4.3 3 .1 4.2-.6.6-.3 1.1-.7 1.5-1.1l3.5-3.5c2.6-2.5 2.5-6.7-.2-9.1z"
      }
    },
    share_poll: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M21.6.9H2.4C1.6.9.9 1.6.9 2.4v3c0 .8.7 1.4 1.5 1.4h19.2c.8 0 1.5-.6 1.5-1.4v-3c0-.8-.7-1.5-1.5-1.5zm-9.2 4.5v-3h9.2v3h-9.2zM21.6 9H2.4c-.8 0-1.5.7-1.5 1.5v3c0 .8.7 1.5 1.5 1.5h19.2c.8 0 1.5-.7 1.5-1.5v-3c0-.8-.7-1.5-1.5-1.5zM9 13.5v-3h12.6v3H9zm12.6 3.7H2.4c-.8 0-1.5.6-1.5 1.4v3c0 .8.7 1.5 1.5 1.5h19.2c.8 0 1.5-.7 1.5-1.5v-3c0-.8-.7-1.4-1.5-1.4zm-5.9 4.4v-3h5.9v3h-5.9z"
      }
    },
    share_post: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12 1.8C5.9 1.8.9 6.4.9 12c0 1.8.5 3.5 1.4 5 .1.2.1.4.1.6l-1 3.2c-.2.6.4 1.1 1 .9l3.2-1.1c.2-.1.4-.1.6.1 1.7.9 3.7 1.5 5.8 1.5 6.2 0 11.1-4.5 11.1-10.2C23 6.4 18 1.8 12 1.8z"
      }
    },
    share_thanks: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M20.9 6.5h-3.3c1-1.5.9-3.4-.2-4.6-.7-.6-1.5-1-2.4-1-1 0-1.9.5-2.6 1.2-.2.2-.3.3-.4.5-.1-.2-.2-.3-.4-.5C10.9 1.3 10 .9 9 .9c-.9 0-1.7.4-2.3 1C5.5 3.1 5.5 5 6.4 6.5H3.2C1.9 6.5.9 7.5.9 8.7v1.5c0 .4.3.7.8.7h20.6c.5 0 .8-.3.8-.7V8.7c0-1.2-1-2.2-2.2-2.2zm-10 0c-.8 0-1.9-.3-2.5-1-.6-.6-.6-1.6-.1-2 .2-.3.5-.3.7-.3.4 0 .7.2 1 .4.7.7.9 1.9.9 2.7v.2zm4.7-1c-.6.6-1.8 1-2.5 1v-.3c0-.7.3-1.9.9-2.6.3-.3.6-.5 1-.5.2 0 .5.1.7.3.5.6.5 1.5-.1 2.1zm5.3 7.6h-7.8v10h6.4c1.2 0 2.1-1 2.1-2.1v-7.2c0-.4-.3-.7-.7-.7zm-18.5.7v7.1c0 1.2 1 2.2 2.2 2.2h6.3v-10H3.1c-.4 0-.7.3-.7.7z"
      }
    },
    sort: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12.7 7.4c.3-.3.3-.7 0-1L7.4 1.1c-.2-.3-.7-.3-.9 0L1.2 6.4c-.3.3-.3.7 0 1l.9 1c.3.2.7.2 1 0l1.7-1.7c.2-.3.7-.1.7.3v9.8c0 .4.4.7.7.7h1.4c.4 0 .7-.4.7-.7V7c0-.4.5-.6.8-.3l1.7 1.7c.2.2.6.2.9 0l1-1zm10.1 9.2l-.9-.9c-.3-.3-.7-.3-1 0l-1.7 1.7c-.2.2-.7 0-.7-.4V7.2c0-.4-.4-.7-.7-.7h-1.4c-.4 0-.7.3-.7.7v9.7c0 .5-.5.6-.8.4l-1.7-1.7c-.2-.3-.6-.3-.9 0l-1 1c-.3.3-.3.7 0 1l5.3 5.3c.3.3.7.3 1 0l5.3-5.3c.2-.3.2-.8-.1-1z"
      }
    },
    submit_for_approval: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M20.9 13.5h-4.1c-1.2 0-2.2-1-2.2-2.2.2-3.3 1.7-3.5 1.8-5.6.2-2.2-1.2-4.2-3.4-4.7-2.8-.6-5.4 1.6-5.4 4.4 0 2.4 1.6 2.4 1.8 5.9 0 1.2-1 2.2-2.2 2.2H3.1c-1.2 0-2.2.9-2.2 2.2v1.5c0 .4.3.7.8.7h20.6c.5 0 .8-.3.8-.7v-1.5c0-1.3-1-2.2-2.2-2.2zm0 6.6H3.1c-.4 0-.7.3-.7.7v.1c0 1.2 1 2.2 2.2 2.2h14.8c1.2 0 2.2-1 2.2-2.2v-.1c0-.4-.3-.7-.7-.7z"
      }
    },
    update: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12 .9C5.9.9.9 5.9.9 12s5 11.1 11.1 11.1 11.1-5 11.1-11.1S18.1.9 12 .9zm4.2 7.2c0 .3-.4.7-.7.7h-4.4c-.3 0-.5.2-.5.4v1c0 .2.2.4.5.4h1.8c1.8 0 3.3 1.4 3.3 3.2v1c0 1.8-1.5 3.2-3.3 3.2h.5v.9c0 .5-.4.9-.9.9s-1-.4-1-.9V18h-3c-.3 0-.7-.3-.7-.7v-1.4c0-.3.4-.7.7-.7h4.4c.3 0 .5-.2.5-.4v-1c0-.2-.2-.4-.5-.4h-1.8c-1.8 0-3.3-1.4-3.3-3.2v-1C7.8 7.4 9.3 6 11.1 6h.4v-.9c0-.5.5-.9 1-.9s.9.4.9.9V6h2.1c.3 0 .7.3.7.7v1.4z"
      }
    },
    update_status: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M13.8 14.1l.7.8c.2.1.5.1.6 0l2.2-2.2c.1-.2.2-.4.2-.7V3.7c0-.8-.6-1.4-1.3-1.4H2.3c-.8 0-1.4.6-1.4 1.4v10.1c0 .8.6 1.4 1.4 1.4h6.3c.3 0 .5-.1.7-.2l.8-.8c.3-.4.8-.7 1.3-.8.8-.2 1.7.1 2.4.7zM4.6 6.5c0-.3.2-.5.5-.5h8.3c.3 0 .4.2.4.5v.9c0 .3-.1.4-.4.4H5.1c-.3 0-.5-.1-.5-.4v-.9zm.5 5c-.3 0-.5-.1-.5-.4v-.9c0-.3.2-.5.5-.5h6.4c.3 0 .5.2.5.5v.9c0 .3-.2.4-.5.4H5.1zm17.7 1.3l-1-1c-.2-.3-.7-.3-1 0l-5.7 5.7c-.1.2-.5.2-.7 0l-2-2.1c-.3-.3-.7-.3-1 0l-1 1c-.3.3-.3.8 0 1l3.9 4c.3.3.7.3 1 0l7.5-7.6c.4-.3.4-.7 0-1z"
      }
    },
    upload: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M22.4 14.3H21c-.4 0-.7.4-.7.7v4.6c0 .4-.3.7-.7.7H4.4c-.4 0-.7-.3-.7-.7V15c0-.3-.3-.7-.7-.7H1.6c-.4 0-.7.4-.7.7v6.2c0 1 .9 1.9 1.9 1.9h18.4c1 0 1.9-.9 1.9-1.9V15c0-.3-.3-.7-.7-.7zM12.5 1.1c-.3-.3-.7-.3-1 0L5.3 7.3c-.3.3-.3.7 0 1l.9 1c.3.3.7.3 1 0l2.6-2.6c.3-.3.8-.1.8.3v9.8c0 .4.3.7.7.7h1.3c.4 0 .8-.4.8-.7V7.1c0-.5.4-.6.8-.4l2.6 2.6c.2.3.6.3.9 0l1-.9c.3-.3.3-.7 0-1l-6.2-6.3z"
      }
    },
    user: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M23.1 19.8v1.1c0 1.2-1 2.2-2.2 2.2H3.1c-1.2 0-2.2-1-2.2-2.2v-1.1c0-2.6 3.2-4.3 6.1-5.6l.3-.1c.2-.1.5-.1.7 0 1.2.8 2.5 1.2 4 1.2s2.8-.4 3.9-1.2c.3-.1.5-.1.7 0l.3.1c3 1.3 6.2 2.9 6.2 5.6zM12 .9c3 0 5.5 2.7 5.5 6.1S15 13.1 12 13.1 6.5 10.4 6.5 7 9 .9 12 .9z"
      }
    },
    user_activation: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12.7 7.4c.3-.3.3-.7 0-1L7.4 1.1c-.2-.3-.7-.3-.9 0L1.2 6.4c-.3.3-.3.7 0 1l.9 1c.3.2.7.2 1 0l1.7-1.7c.2-.3.7-.1.7.3v9.8c0 .4.4.7.7.7h1.4c.4 0 .7-.4.7-.7V7c0-.4.5-.6.8-.3l1.7 1.7c.2.2.6.2.9 0l1-1zm10.1 9.2l-.9-.9c-.3-.3-.7-.3-1 0l-1.7 1.7c-.2.2-.7 0-.7-.4V7.2c0-.4-.4-.7-.7-.7h-1.4c-.4 0-.7.3-.7.7v9.7c0 .5-.5.6-.8.4l-1.7-1.7c-.2-.3-.6-.3-.9 0l-1 1c-.3.3-.3.7 0 1l5.3 5.3c.3.3.7.3 1 0l5.3-5.3c.2-.3.2-.8-.1-1zM7.4 21.2h-.9c-.5 0-1-.4-1-.9v-.9c0-.5.5-.9 1-.9h.9c.5 0 .9.4.9.9v.9c0 .5-.4.9-.9.9zM17.5 5.5h-.9c-.5 0-.9-.4-.9-.9v-.9c0-.5.4-.9.9-.9h.9c.5 0 1 .4 1 .9v.9c0 .5-.5.9-1 .9z"
      }
    },
    view_relationship: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M16.6 9.2c0-1-.8-1.8-1.8-1.8h-12c-1 0-1.9.8-1.9 1.8v12c0 1 .9 1.9 1.9 1.9h12c1 0 1.8-.9 1.8-1.9v-12zm3.2 10.2h-1.3v-2.8h1.3c.3 0 .5-.2.5-.4v-12c0-.3-.2-.5-.5-.5h-12c-.2 0-.4.2-.4.5v1.3H4.6V4.2C4.6 2.4 6 .9 7.8.9h12c1.8 0 3.3 1.5 3.3 3.3v12c0 1.8-1.5 3.2-3.3 3.2z"
      }
    },
    web_link: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12.5.9C6.3.9 1.4 5.9 1.4 12s4.9 11.1 11.1 11.1 11-5 11-11.1S18.6.9 12.5.9zm1.3 15.9c-.6.6-.9 2-1.2 2.9 0 .2-.1.4-.3.5l-.5.2c-.3.1-.6.1-.8-.1-.5-.5-.8-1.1-.8-1.7 0-1.2-1.9-.8-1.9-3 0-1.8-2.3-2.9-4-2.1-.1.1-.2.2-.4.2-.3.1-.5-.1-.6-.4 0-.4-.1-.8-.1-1.3 0-2.2.8-4.2 2.1-5.8 0-.1.1-.1.1-.1 1.1-1.3 2.5-2.3 4.2-2.8.4-.2.8.3.6.7-.2.2-.3.5-.3.8 0 .9-.9 1.5-1.3 1.4-.4-.2-1.4.5-.5 1l.5.2h.1l.2.1c1.6 1 1.3 1.8.6 3-.8 1.3-1.1 0-2.2-.4s-2.2.4-1.9 1.1c.4.8 1.5 0 2.3.8.7.7.7 1.8 2.9 1.1 2.2-.8 2.6-.4 3.3.3.7.8 1.1 2.2-.1 3.4zm5.9-.1c-.9-1.1 0-3.4-1.1-4.7-1.1-1.5-2.6 0-4-2.3-1.4-2.1.4-3.9 2.1-4.5.5-.2 1-.3 1.5-.3.1 0 .2.1.3.2 1.9 1.6 3.2 4.1 3.2 6.9 0 1.7-.5 3.2-1.2 4.6-.2.2-.6.3-.8.1z"
      }
    },
    viewBox: '0 0 24 24'
  };
}

/* harmony default export */ __webpack_exports__["a"] = (icons);

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
var icons = {};

if (false) {
  icons = {
    custom1: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M13 17.8c-.5.6-1.5.6-2.1 0-1.7-1.9-5-5.4-5-5.4-1.5-1.6-1.5-4.1 0-5.7.7-.8 1.7-1.2 2.7-1.2 1 0 2 .4 2.7 1.2l.3.4c.2.2.6.2.8 0l.2-.4h.1c.7-.8 1.7-1.2 2.7-1.2 1 0 2 .4 2.7 1.2 1.5 1.5 1.5 4.1 0 5.7 0 0-3.3 3.5-5.1 5.4z"
      }
    },
    custom10: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M16.8 18.7c-2.3.9-5.9.7-7.8-1.4-4.7-5.1-.6-12.5 5.1-12.5.9 0 1.8.2 2.7.5.3.2.3.7 0 .9-1.8 1.3-3 3.4-3 5.8s1.2 4.6 3 5.9c.3.2.3.7 0 .8z"
      }
    },
    custom100: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M14.9 17.3H9.1c-.1 0-.2.1-.2.3.2.9 1.5 1.6 3.1 1.6 1.5 0 2.8-.7 3-1.6.1-.2 0-.3-.1-.3zm2.9-11.1H6.2c-.8 0-1.4.7-1.4 1.5v6.7c0 .8.6 1.4 1.4 1.4h11.6c.8 0 1.4-.6 1.4-1.4V7.7c0-.8-.6-1.5-1.4-1.5zm0 7.7c0 .3-.3.5-.5.5H6.7c-.2 0-.5-.2-.5-.5V8.2c0-.3.3-.5.5-.5h10.6c.2 0 .5.2.5.5v5.7z"
      }
    },
    custom101: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M10.8 9.3c1 0 1.8.8 1.8 1.8s-.8 1.8-1.8 1.8S9 12.1 9 11.1c0-.5.2-1 .5-1.3.3-.3.8-.5 1.3-.5zm.1 7.5c.1 0 .3-.1.5-.2.4-.3.9-.5 1.4-.7-.2-.3-.3-.6-.4-.9v-.1c-.5.2-1.1.4-1.6.4-2.3 0-4.2-1.9-4.2-4.1-.1-2.3 1.7-4.2 4-4.3 2.2-.1 4.2 1.6 4.3 3.9 1 .1 1.5.5 1.8 1.1v-.8c.1-3.3-2.6-6-5.8-6-3.3-.1-6 2.5-6.1 5.8-.1 3.2 2.4 6 5.7 6.1.1 0 .3-.1.4-.2zm7.2.6c-.6-.3-1.4-.9-2.6-1.1.3-.4.5-.9.8-1.5.1-.4.1-.7.1-1.1 0-.3 0-.9-.1-1.1-.2-1-.9-1.3-1.7-1.3-.8 0-1.5.3-1.8 1.3v1.1c0 .4 0 .7.1 1.1.3.6.5 1.1.8 1.5-1.2.2-2 .8-2.6 1.1-1.1.5-1.1 1-1.1 1v1h9.2v-1s0-.5-1.1-1z"
      }
    },
    custom102: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M7.5 14.6H5.2c-.1.1-.1.2-.1.2v4.3c0 .1 0 .1.1.2 0 0 .1.1.2.1h2.1c.1 0 .1-.1.2-.1 0-.1.1-.1.1-.2v-4.3s-.1-.1-.1-.2h-.2zm3.9-1.3H9.3c-.2 0-.3.1-.3.2v5.6c0 .1 0 .2.1.2 0 .1.1.1.2.1h2.1s.1 0 .2-.1v-5.8-.2h-.2zm3.8-4.9h-2.1c-.1 0-.1.1-.2.1 0 .1-.1.1-.1.2v10.4c0 .1.1.2.1.2.1.1.1.1.2.1h2.1c.1 0 .2 0 .2-.1.1 0 .1-.1.1-.2V8.7c0-.1 0-.1-.1-.2 0 0-.1-.1-.2-.1zm3.9-3.3H17c-.1 0-.1 0-.2.1-.1 0-.1.1-.1.2v13.7c0 .1 0 .2.1.2.1.1.1.1.2.1h2.1c.1 0 .1 0 .2-.1 0 0 .1-.1.1-.2V5.4c0-.1-.1-.2-.1-.2-.1-.1-.1-.1-.2-.1z"
      }
    },
    custom103: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.3 13.2c-.4-.2-1-.7-1.8-.8.2-.3.3-.7.5-1.1.1-.3.1-.5.1-.8v-.9c-.2-.7-.7-.9-1.2-.9-.6 0-1.1.2-1.3 1v.8c0 .3 0 .5.1.8.2.5.4.8.6 1.1-.4.1-.8.2-1.2.4.4.2.8.4 1.2.7.2.1.4.2.5.2.7.3 1 .7 1.2 1h2.1V14s0-.4-.8-.8zm-10.1.5c.1 0 .3-.1.5-.2.4-.3.8-.5 1.2-.7-.4-.2-.8-.3-1.2-.4.2-.3.4-.7.6-1.1 0-.3.1-.5.1-.8 0-.3 0-.6-.1-.9-.2-.7-.6-.9-1.2-.9-.5 0-1 .2-1.2.9-.1.3 0 .6 0 .9 0 .2 0 .5.1.8.1.4.3.8.5 1.1-.8.1-1.4.6-1.8.8-.8.4-.8.8-.8.8v.7H7c.3-.5.7-.8 1.2-1zm7.4.5c-.6-.3-1.4-1-2.7-1.2.3-.4.6-1 .8-1.6.2-.4.1-.8.1-1.2 0-.4.1-1 0-1.3-.3-1-1-1.3-1.8-1.3-.9 0-1.6.3-1.8 1.3-.1.3-.1.9-.1 1.3s0 .8.2 1.2c.2.7.5 1.2.8 1.6-1.3.2-2.1.9-2.7 1.2-1.2.6-1.2 1.2-1.2 1.2v1h9.6v-1s0-.6-1.2-1.2z"
      }
    },
    custom104: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.5 4.9h-11c-.4 0-.7.4-.7.8v3.7h12.4V5.7c0-.4-.3-.8-.7-.8zm-6.6 5.2v9h6.6c.4 0 .7-.4.7-.8v-8.2h-7.3zm-5.1 0v8.2c0 .2.1.4.2.5.2.2.4.3.6.3h3.6v-9H5.8z"
      }
    },
    custom105: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.3 6.3H5.7c-.4 0-.8.4-.8.9v.6c0 .1 0 .1.1.2l6.3 5.1c.4.4 1 .4 1.4 0L19 8c.1-.1.1-.1.1-.2v-.6c0-.5-.4-.9-.8-.9zM4.9 9.1c0-.1 0-.2.1-.2h.2l3.1 2.8c.1 0 .1.1.1.1 0 .1 0 .1-.1.2l-3 2.9c-.1 0-.2.1-.3 0-.1 0-.1-.1-.1-.2V9.1zm0 7s0-.1.1-.1l3.8-3.6c.1-.1.2-.1.3 0l1.6 1.4c.7.7 1.8.7 2.6 0l1.6-1.4c.1-.1.2-.1.3 0l3.8 3.5c.1.1.1.1.1.2v.7c0 .2-.1.5-.3.6-.1.2-.3.3-.6.3H5.7c-.4 0-.8-.4-.8-.9v-.7zm14.2-1.4c0 .1 0 .2-.1.2h-.3l-3-2.9c-.1-.1-.1-.1-.1-.2s.1-.1.1-.1l3.1-2.8h.2c.1 0 .1.1.1.2v5.6z"
      }
    },
    custom106: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M11.9 4.9c-2.8 0-5.1 2.4-5.1 5.2 0 4.3 5.1 9 5.1 9s5.2-4.9 5.2-9c0-2.8-2.3-5.1-5.2-5.2zm0 7.5c-.9 0-1.7-.6-2.1-1.4-.3-.8-.1-1.8.5-2.4.6-.7 1.6-.9 2.4-.5.9.3 1.4 1.1 1.4 2 0 1.3-1 2.3-2.2 2.3z"
      }
    },
    custom107: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.7 12.4h-1.5v6.2c0 .1 0 .2-.1.3 0 0-.1.1-.2 0h-2.8c-.2 0-.3-.1-.3-.3v-4.8h-3.5v4.8c0 .2-.1.3-.2.3H7.2c-.1.1-.2 0-.2 0-.1-.1-.1-.2-.1-.3v-6.2H5.5c-.2 0-.3-.1-.3-.2 0-.2 0-.3.1-.3l6.6-6.6c.1-.2.3-.2.3 0l6.6 6.6c.2 0 .2.2.1.3-.1.1-.1.2-.2.2z"
      }
    },
    custom108: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": [{
          "d": "M11.5 14.5l.1-.7.9-.6-.2-.9h-.1l-1-.1-.4-.6.2-1.1-.7-.5-.1.1-.8.7-.6-.1-.6-1-.9.2v.1l-.1 1.1-.5.4-1.1-.3-.5.8.1.1.6.8v.7l-1 .6.2.9h.1l1 .1.4.5-.2 1.2.8.5.1-.1.7-.7.7.1.6 1 .8-.2v-.2l.1-1 .5-.4 1.2.3.4-.8-.1-.1-.6-.8zm-1.3.1c-.3.5-.6.7-1.1.9-.5.1-.9 0-1.3-.2-.9-.6-1.1-1.7-.6-2.6.2-.4.6-.7 1-.8.5-.1 1 0 1.4.2.8.6 1.1 1.7.6 2.5z"
        }, {
          "d": "M18.2 11.1l.1-.7.9-.6-.2-.9h-.1l-1-.1-.4-.5.2-1.2-.8-.5-.1.1-.7.7-.7-.1-.6-1-.8.2-.1.2v1l-.6.4-1.1-.2-.4.7.1.1.6.8-.1.7-.9.6.2.9h.1l1 .1.4.6-.2 1.1.7.5.1-.1.8-.6.6.1.6.9.9-.2V14l.1-1 .5-.5 1.1.3.5-.8-.1-.1-.6-.8zm-1.4.2c-.2.4-.6.7-1 .8-.5.1-1 0-1.4-.2-.8-.6-1.1-1.7-.6-2.5.3-.4.6-.7 1.1-.9.5-.1.9 0 1.3.3.9.5 1.1 1.6.6 2.5z"
        }]
      }
    },
    custom109: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M19.1 11.1l-.3-.5-1 .5c-1.3-2.1-3.6-3.6-6-3.6-3.5 0-6.9 3.3-6.9 6.8v.5h1.7v-.3-.2c0-2.8 2.3-5.1 5.2-5.1 1.9 0 3.6 1 4.5 2.5L13 13.2c-.6-.5-1.4-.6-2.1-.3-.5.2-.8.6-1 1.1-.1.5-.1 1 .2 1.5.5.9 1.6 1.2 2.5.7.7-.3 1.1-1 1.1-1.8l3.1-1.8c.2.5.3 1.1.3 1.7v.5h1.7v-.3-.2c0-.9-.2-1.8-.6-2.6l.9-.6z"
      }
    },
    custom11: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12.5 5.1l1.9 4.1 4.3.6c.5.1.7.7.3 1.1L15.9 14l.8 4.5c0 .5-.5.9-.9.6L12 17l-3.8 2.1c-.4.3-1-.1-.9-.6l.8-4.5L5 10.9c-.4-.4-.2-1 .3-1.1l4.3-.6 1.9-4.1c.2-.4.8-.4 1 0z"
      }
    },
    custom110: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M14.8 4.9H9.2c-.4-.1-.8.1-1 .4-.3.2-.5.6-.5 1v11.4c0 .8.7 1.4 1.5 1.4h5.6c.8 0 1.5-.6 1.5-1.4V6.3c0-.4-.2-.8-.5-1-.2-.3-.6-.5-1-.4zm-3.8.8h2c.1 0 .2 0 .2.1s-.1.1-.2.1h-2c-.1 0-.2 0-.2-.1s.1-.1.2-.1zm1.8 12.4c0 .1-.1.2-.2.2h-1.3c-.1 0-.1-.1-.1-.2v-.6l.1-.1h1.4s.1 0 .1.1v.6zm2.6-1.7v.1H8.7h-.1V6.9v-.2H15.3c.1 0 .1.1.1.2v9.5z"
      }
    },
    custom111: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": {
          "d": "M12.8 10.8c-.6-.2-1.4-.9-2.6-1.1.3-.3.6-.8.8-1.5.1-.3.1-.6.1-1s.1-.9 0-1.2c-.3-.9-1-1.2-1.7-1.2-.8 0-1.5.3-1.8 1.2-.1.3 0 .8 0 1.2 0 .4 0 .7.1 1 .3.7.5 1.2.8 1.5-1.2.2-2 .9-2.6 1.1-1.1.5-1.1 1.1-1.1 1.1v1.8h5.7c.3-1.2 1.2-2.3 2.3-2.9zM15.1 16.9c-1.1 0-1.9-.8-1.9-1.9 0-1 .8-1.8 1.9-1.8 1 0 1.8.8 1.8 1.8 0 .5-.2 1-.5 1.4-.4.3-.8.5-1.3.5zm4.1-1.4v-.9l-.1-.1-1-.3-.3-.6.5-1.1-.7-.7-.1.1-.9.5-.7-.3-.4-1.1h-.9v.1l-.4 1-.6.2-1.1-.5-.7.7.1.1.5 1-.3.6-1.1.4v.9l.1.1 1 .3.3.6-.6 1.2.7.6h.1l1-.5.6.2.4 1.2h.9l.1-.2.3-1 .7-.2 1 .5.7-.7-.1-.1-.4-.9.2-.7 1.2-.4z"
        }
      }
    },
    custom112: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12.3 12c-2.1-.4-4.2-.4-6.2 0-.7.3-1.2.9-1.2 1.6v1.3c0 .7.5 1.3 1.2 1.5.2.1.4.1.6.1l1.6 2.3c.3.4.5.4.5-.1v-1.9c1.2 0 2.3-.1 3.5-.4.7-.2 1.1-.8 1.2-1.5v-1.3c-.1-.7-.5-1.3-1.2-1.6zm5.6-6.6c-2.7-.7-5.6-.7-8.4 0-.7.2-1.2.9-1.2 1.6v2.2c0 .7.5 1.4 1.2 1.6 1.5.4 3.1.5 4.7.5v2.6c0 .5.2.6.5.2l2.2-3.1c.3 0 .7-.1 1-.2.7-.2 1.2-.9 1.2-1.6V7c0-.7-.5-1.4-1.2-1.6z"
      }
    },
    custom113: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": {
          "d": "M6.5 14.2h11c.1 0 .1-.1.1-.2V6.4c0-.1-.1-.2-.2-.2H6.7c-.2 0-.4.1-.4.2V14c0 .1.1.2.2.2zm1-6.7c0-.1 0-.2.1-.2h8.8c.1 0 .1.1.1.2v5.4c0 .1 0 .2-.1.2H7.6c-.1 0-.2-.1-.2-.2V7.5h.1zM19.1 17.6l-1.4-2.8c-.1-.1-.1-.1-.2-.1h-11c-.1 0-.1 0-.2.1l-1.4 2.8v.3c.1.1.2.1.3.1h13.6c.1 0 .2 0 .3-.1v-.3zm-5.7-.2h-2.9v-.1l.4-.8.1-.1h2l.1.1.4.8s0 .1-.1.1z"
        }
      }
    },
    custom12: {
      "xmlns": "http://www.w3.org/2000/svg",
      "circle": {
        "cx": "12",
        "cy": "12",
        "r": "7.2"
      }
    },
    custom13: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.8 5.3H6.2c-.8 0-1.4.6-1.4 1.4v1.5c0 .2.2.4.5.4h13.4c.3 0 .5-.2.5-.4V6.7c0-.8-.6-1.4-1.4-1.4zm0 4.8H6.2c-.2 0-.4.2-.4.5v6.7c0 .8.6 1.4 1.4 1.4h9.6c.8 0 1.4-.6 1.4-1.4v-6.7c0-.3-.2-.5-.4-.5zm-3.2 2.1c0 .4-.3.8-.7.8h-3.8c-.4 0-.7-.4-.7-.8 0-.3.3-.7.7-.7h3.8c.4 0 .7.3.7.7z"
      }
    },
    custom14: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.7 7.9h-1.4c-.3 0-.6-.1-.9-.3l-1.1-1c-.3-.2-.6-.4-.9-.4h-2.8c-.4 0-.7.2-1 .4L9.1 7.9c-.1.1-.1.3 0 .4l.5.4c.3.3.7.3 1 .1l1.3-.8c.2-.1.4-.1.6.1l4.1 4c.1.1.2.2.2.4v1.1c0 .2.2.6.5.6h1.4c.3 0 .5-.3.5-.5V8.4c0-.3-.2-.5-.5-.5zm-4.1 4.3L12 9.7l-.7.5c-.3.2-.7.3-1.1.3-.6 0-1.1-.2-1.5-.5l-.9-.8c-.2-.2-.4-.4-.4-.6 0-.3-.2-.4-.5-.4H5.3c-.3 0-.5.1-.5.4V13c0 .2.2.4.5.4h.9c.1 0 .2-.2.3-.3.4-.5.9-.8 1.5-.9.5 0 1.1.2 1.6.6l3 2.7c.2.3.4.5.5.9.1.1.3.2.4.1l1.1-1.2c.6-.5 1-1.9.5-2.5l-.5-.6zm-6 1.8c-.3-.3-.8-.2-1 .1-.3.3-.2.8.1 1.1l3 2.7c.1.2.3.2.5.2s.4-.1.5-.3c.3-.3.2-.8-.1-1.1l-3-2.7z"
      }
    },
    custom15: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M16.8 11.1c-.8-.4-1-.7-1-1 0-.4.3-.7.6-1 .5-.4.7-1.1.7-1.8 0-1.3-.8-2.5-2.3-2.5-1.3 0-2.1.9-2.3 2 0 .1 0 .2.1.2 1.1.8 1.7 2.1 1.7 3.6 0 1.1-.3 2.1-1 2.8-.1.2-.1.4.1.4.4.2.9.4 1.4.7.1.1.3.1.4.1H18c.7 0 1.2-.5 1.2-1.1v-.2c0-1.1-1.2-1.7-2.4-2.2zM12.5 15c-1-.4-1.1-.8-1.1-1.2 0-.4.2-.8.6-1.1.6-.5.9-1.2.9-2.1 0-1.6-1-2.9-2.8-2.9S7.3 9 7.3 10.6c0 .9.3 1.6.9 2.1.4.3.7.7.7 1.1 0 .4-.2.8-1.2 1.2-1.5.6-2.9 1.3-2.9 2.6v.2c0 .8.7 1.4 1.5 1.4h7.6c.8 0 1.5-.6 1.5-1.4v-.2c0-1.3-1.4-2-2.9-2.6z"
      }
    },
    custom16: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.3 16.8H17v-5.3c0-.2-.2-.5-.4-.5h-.5c-.3 0-.5.3-.5.5v5.3h-1.4v-5.3c0-.2-.3-.5-.5-.5h-.5c-.3 0-.5.3-.5.5v5.3h-1.4v-5.3c0-.2-.2-.5-.5-.5h-.5c-.2 0-.5.3-.5.5v5.3H8.4v-5.3c0-.2-.2-.5-.5-.5h-.5c-.2 0-.4.3-.4.5v5.3h-.3c-.8 0-1.4.6-1.4 1.4v.5c0 .3.2.5.5.5h12.4c.3 0 .5-.2.5-.5v-.5c0-.8-.6-1.4-1.4-1.4zm1.2-8.5L12.6 5c-.2-.1-.4-.2-.6-.2-.2 0-.4.1-.6.2L5.5 8.3c-.1.1-.2.2-.2.4v.4c0 .3.2.5.5.5h12.4c.3 0 .5-.2.5-.5v-.4c0-.2-.1-.3-.2-.4zm-6.5.3c-.7 0-1.2-.5-1.2-1.2s.5-1.2 1.2-1.2 1.2.6 1.2 1.2-.5 1.2-1.2 1.2z"
      }
    },
    custom17: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M10.3 6.9c.1.2.3.3.5.3h2.4c.2 0 .4-.1.4-.3l1-1.7c.1-.2-.1-.4-.2-.4H9.6c-.1 0-.3.2-.2.4l.9 1.7zm3.1 1.7h-2.8c-2.4 0-4.4 2-4.4 4.4v4.8c0 .8.7 1.4 1.5 1.4h8.6c.8 0 1.5-.6 1.5-1.4V13c0-2.4-2-4.4-4.4-4.4zm-.7 8.1v.8c0 .2-.1.3-.3.3h-.9c-.2 0-.2-.1-.2-.3v-.8c-.7-.1-1.3-.4-1.5-.6-.2-.1-.2-.3-.1-.5l.3-.5c.1-.1.2-.2.4-.2.1 0 .1 0 .2.1.5.3.9.4 1.3.4.3 0 .6-.2.6-.4 0-.1-.1-.3-1.1-.6-.8-.3-1.8-.8-1.8-1.9 0-.7.5-1.5 1.7-1.7v-.7c0-.2 0-.3.1-.3h1c.2 0 .3.1.3.3v.7c.5.1 1 .4 1.2.5.1 0 .1.1.1.3s0 .2-.1.3l-.3.4c-.1.1-.3.2-.4.2H13c-.5-.3-.9-.4-1.2-.4-.4 0-.6.2-.6.3 0 .2.1.3.9.6 1.1.4 2.2.9 2.2 2 0 .8-.6 1.5-1.6 1.7z"
      }
    },
    custom18: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M14.4 8.6h2.5c.2 0 .4-.1.4-.3 0-.1 0-.2-.1-.2L14 4.9c-.1-.1-.1-.1-.2-.1-.2 0-.4.1-.4.3v2.6c0 .5.5.9 1 .9zm5.6 3.3l-.3-.3c-.2-.2-.5-.2-.6 0l-3.7 3.7c-.1.1 0 .1 0 .1v.9h.9l3.7-3.7c.2-.2.2-.5 0-.7zm-3 5.9h-2.2c-.5 0-.9-.4-.9-1v-1.6c0-.3.1-.5.3-.7l2.9-3c.1-.1.2-.2.2-.3v-.6c0-.3-.2-.5-.5-.5h-3.4c-.8 0-1.4-.7-1.4-1.5V5.3c0-.3-.2-.5-.5-.5H6.7c-.8 0-1.4.6-1.4 1.4v11.6c0 .8.6 1.4 1.4 1.4h9.1c.7 0 1.3-.5 1.5-1.2 0-.1-.1-.2-.3-.2zM7.2 9.1c0-.2.2-.5.5-.5h1.9c.3 0 .5.3.5.5v.5c0 .3-.2.5-.5.5H7.7c-.3 0-.5-.2-.5-.5v-.5zm4.8 6.3c0 .2-.2.4-.5.4H7.7c-.3 0-.5-.2-.5-.4v-.5c0-.3.2-.5.5-.5h3.8c.3 0 .5.2.5.5v.5zm1-2.9c0 .2-.3.5-.5.5H7.7c-.3 0-.5-.3-.5-.5V12c0-.3.2-.5.5-.5h4.8c.2 0 .5.2.5.5v.5z"
      }
    },
    custom19: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M19 7.9c0-.2-.3-.2-.4-.1l-2.4 2.4c-.2.2-.5.2-.7 0l-1.7-1.7c-.2-.2-.2-.5 0-.7l2.4-2.4c.2-.1.1-.4 0-.4-.5-.1-.9-.2-1.3-.2-2.6 0-4.6 2.2-4.3 4.8 0 .4.1.8.3 1.1l-5.6 5.6c-.7.7-.7 1.8 0 2.4.3.4.7.5 1.2.5s.8-.1 1.2-.5l5.6-5.6c.3.2.7.3 1.1.3 2.6.3 4.8-1.7 4.8-4.3 0-.4-.1-.8-.2-1.2z"
      }
    },
    custom2: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": {
          "d": "M14.2 5.3c-.8-.5-3.4-1-4.4.7-.4.8.1 2.2.6 3.1.1.2.3.3.6.2.3-.1.6-.2 1-.2.2 0 .5 0 .7.1.2.1.5 0 .5-.2.2-.3.5-.7 1-1.1 1.2-.9.7-2.1 0-2.6zm-1.3 9.4c-.3.1-.6.2-.9.2-.3 0-.6-.1-.8-.1-.3-.1-.5 0-.6.2-.2.3-.4.7-.9 1.1-1.2.9-.7 2.2 0 2.6s3.3 1 4.3-.7c.4-.7-.1-2.1-.5-3-.1-.2-.4-.3-.6-.3zM18 9.8c-.8-.4-2.2.1-3.1.6-.2.1-.3.3-.2.6.1.3.2.6.2 1 0 .2 0 .5-.1.7-.1.2 0 .5.2.5.3.2.7.5 1.1 1 .9 1.2 2.1.7 2.6 0s1-3.4-.7-4.4zm-8.7 3.1c-.1-.3-.2-.6-.2-.9 0-.3.1-.6.1-.8.1-.3 0-.5-.2-.6-.3-.2-.7-.4-1.1-.9-.9-1.2-2.2-.7-2.6 0S4.3 13 6 14c.7.4 2.1-.1 3-.5.2-.1.3-.4.3-.6z"
        },
        "circle": {
          "cx": "12",
          "cy": "12",
          "r": "1.44"
        }
      }
    },
    custom20: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M9.1 11.4c0-.1-.2-.3-.4-.1l-3.3 2.5c-.4.3-.6.7-.6 1.2v1c0 .2.2.3.3.2l3.7-1.4c.2-.1.3-.2.3-.4v-3zm5.3 6.8l-1-.7V6.6c0-.6-.7-1.3-1.1-1.7-.2-.1-.4-.1-.6 0-.4.4-1.2 1.1-1.2 1.7v10.9l-1.1.7c-.2.2-.3.4-.3.6v.2c0 .1.1.2.2.2h5.3c.1 0 .3-.1.3-.2 0-.4-.2-.6-.5-.8zm4.2-4.4l-3.3-2.5c-.2-.2-.4 0-.4.1v3c0 .2.1.4.3.4l3.7 1.4c.2.1.3 0 .3-.2v-1c0-.5-.2-.9-.6-1.2z"
      }
    },
    custom21: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M13.8 17.1c0-.2-.2-.3-.4-.3h-2.8c-.2 0-.4.1-.4.3l-.7 1.7c0 .2.1.4.2.4h4.6c.1 0 .2-.2.2-.4l-.7-1.7zm4-12.3H6.2c-.8 0-1.4.6-1.4 1.4v7.7c0 .8.6 1.5 1.4 1.5h11.6c.8 0 1.4-.7 1.4-1.5V6.2c0-.8-.6-1.4-1.4-1.4zM12 14.9c-.4 0-.7-.3-.7-.7s.3-.8.7-.8.7.4.7.8-.3.7-.7.7zm5.8-2.4c0 .2-.3.5-.5.5H6.7c-.2 0-.5-.3-.5-.5V6.7c0-.2.3-.5.5-.5h10.6c.2 0 .5.3.5.5v5.8z"
      }
    },
    custom22: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.6 15.3l-1.4-1.2c-.5-.4-1.3-.4-1.8 0l-1.4 1c-.2.2-.5.1-.6 0L11 13l-2.1-2.4c-.2-.2-.2-.4 0-.6l1-1.4c.4-.6.3-1.3-.1-1.8L8.6 5.3c-.5-.6-1.5-.7-2.1-.1L5.2 6.5c-.3.3-.4.7-.4 1.1.1 3 1.5 5.9 3.6 8s4.9 3.4 8 3.6c.4 0 .8-.2 1-.5l1.3-1.3c.7-.5.6-1.5-.1-2.1z"
      }
    },
    custom23: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M11.7 13.4c.2.2.4.2.6 0l6.8-6.2c.1-.3.1-.7-.4-.7l-13.4.1c-.4 0-.6.3-.4.6l6.8 6.2zm7.5-3.6c0-.3-.4-.4-.6-.2l-5.3 4.9c-.3.3-.8.5-1.3.5s-.9-.2-1.3-.5L5.4 9.6c-.2-.2-.6-.1-.6.2v6.3c0 .8.7 1.4 1.5 1.4h11.5c.8 0 1.4-.6 1.4-1.4V9.8z"
      }
    },
    custom24: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M16.3 4.8H7.7c-.8 0-1.5.6-1.5 1.4 0 .3.3.5.5.5h10.6c.2 0 .5-.2.5-.5 0-.8-.7-1.4-1.5-1.4zm0 3.4H7.7c-.3 0-.5.2-.5.4v10.1c0 .3.2.5.5.5h2.6c.3 0 .5-.2.5-.5v-1.9c0-.3.2-.5.5-.5h1.4c.3 0 .5.2.5.5v1.9c0 .3.2.5.5.5h2.6c.3 0 .5-.2.5-.5V8.6c0-.2-.2-.4-.5-.4zm-5 6.4c0 .3-.2.5-.5.5h-1c-.2 0-.4-.2-.4-.5v-.9c0-.3.2-.5.4-.5h1c.3 0 .5.2.5.5v.9zm0-3.3c0 .2-.2.5-.5.5h-1c-.2 0-.4-.3-.4-.5v-1c0-.2.2-.5.4-.5h1c.3 0 .5.3.5.5v1zm3.3 3.3c0 .3-.2.5-.4.5h-1c-.3 0-.5-.2-.5-.5v-.9c0-.3.2-.5.5-.5h1c.2 0 .4.2.4.5v.9zm0-3.3c0 .2-.2.5-.4.5h-1c-.3 0-.5-.3-.5-.5v-1c0-.2.2-.5.5-.5h1c.2 0 .4.3.4.5v1z"
      }
    },
    custom25: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M19.2 6.6c-.2-.9-1-1.7-1.9-1.8-.6-.1-1.2.1-1.7.5-.1.1-.1.3.1.4 1.1.6 2 1.4 2.7 2.4.1.2.3.2.4 0 .4-.4.5-1 .4-1.5zM8.3 5.7c.1-.1.2-.3.1-.4-.5-.4-1.1-.6-1.8-.5-.9.1-1.6.9-1.8 1.8-.1.5 0 1.1.3 1.5.1.2.3.2.4 0 .8-1 1.7-1.8 2.8-2.4zm3.7.5c-3.6 0-6.5 2.9-6.5 6.5 0 1.5.5 2.8 1.3 3.9l-1 .9c-.4.4-.4 1 0 1.4.2.2.4.3.7.3s.5-.1.7-.3l.9-1c1.1.8 2.5 1.3 3.9 1.3s2.8-.5 3.8-1.3l1 1c.2.2.5.3.7.3s.5-.1.7-.3c.4-.4.4-1 0-1.4l-1-.9c.8-1.1 1.3-2.4 1.3-3.9 0-3.6-2.9-6.5-6.5-6.5zm-4.6 6.5c0-2.5 2.1-4.5 4.6-4.5s4.6 2 4.6 4.5-2.1 4.6-4.6 4.6-4.6-2.1-4.6-4.6zm5.3-.3v-1.8c0-.4-.3-.8-.7-.8s-.7.4-.7.8v2.1c0 .2.1.4.2.5l1.7 1.7c.1.1.3.2.5.2s.3-.1.5-.2c.3-.3.3-.7 0-1l-1.5-1.5z"
      }
    },
    custom26: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M6.2 4.8c-.8 0-1.4.6-1.4 1.4 0 .5.2.9.5 1.1v10.9c0 .6.4 1 .9 1s1-.4 1-1V7.3c.3-.2.5-.6.5-1.1 0-.8-.7-1.4-1.5-1.4zm12.6 2.6c-3.7 2-6.3-1.4-9.8-.1-.2 0-.4.2-.4.4v6.2c0 .3.4.6.7.5 3.4-1.1 5.9 2.2 9.7.1.1-.1.2-.2.2-.4V7.6c0-.2-.2-.3-.4-.2z"
      }
    },
    custom27: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M5.8 15.1h12.4c.3 0 .5-.2.5-.5V7c0-.8-.6-1.5-1.4-1.5H6.7c-.8 0-1.4.7-1.4 1.5v7.6c0 .3.2.5.5.5zm.9-7.7c0-.2.2-.4.5-.4h9.6c.3 0 .5.2.5.4v5.8c0 .3-.2.5-.5.5H7.2c-.3 0-.5-.2-.5-.5V7.4zm12.5 9.2h-5.3c-.2 0-.5.2-.5.4s-.2.5-.4.5h-2c-.2 0-.4-.2-.4-.5s-.3-.4-.5-.4H4.8c-.3 0-.5.2-.5.4 0 .8.7 1.5 1.5 1.5h12.4c.8 0 1.5-.7 1.5-1.5 0-.2-.2-.4-.5-.4z"
      }
    },
    custom28: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M15.4 4.8H8.6c-.8 0-1.4.6-1.4 1.4v11.6c0 .8.6 1.4 1.4 1.4h6.8c.8 0 1.4-.6 1.4-1.4V6.2c0-.8-.6-1.4-1.4-1.4zM12 18.7c-.4 0-.7-.3-.7-.7s.3-.7.7-.7.7.3.7.7-.3.7-.7.7zm3.4-2.4c0 .3-.3.5-.5.5H9.1c-.2 0-.5-.2-.5-.5V7.2c0-.3.3-.5.5-.5h5.8c.2 0 .5.2.5.5v9.1z"
      }
    },
    custom29: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.7 6.7h-.4c-.3 0-.5.3-.5.5v9.7l.6.8c.1.1.1.1.2 0l.6-.8V7.2c0-.2-.2-.5-.5-.5zm-3.8-1.9H7.2c-.8 0-1.4.6-1.4 1.4v11.6c0 .8.6 1.4 1.4 1.4h6.7c.8 0 1.5-.6 1.5-1.4V6.2c0-.8-.7-1.4-1.5-1.4zm-3.3 13.9c-.4 0-.8-.3-.8-.7s.4-.7.8-.7.7.3.7.7-.3.7-.7.7zm3.3-2.4c0 .3-.2.5-.5.5H7.7c-.3 0-.5-.2-.5-.5V7.2c0-.3.2-.5.5-.5h5.7c.3 0 .5.2.5.5v9.1z"
      }
    },
    custom3: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12 9.1c-1.6 0-2.9 1.3-2.9 2.9s1.3 2.9 2.9 2.9 2.9-1.3 2.9-2.9-1.3-2.9-2.9-2.9zm7.2 2.9c0-.8-2-1.3-2.3-2-.3-.8.8-2.5.2-3.1-.6-.6-2.3.5-3.1.2-.7-.3-1.2-2.3-2-2.3s-1.3 2-2 2.3c-.8.3-2.5-.8-3.1-.2-.6.6.5 2.3.2 3.1-.3.7-2.3 1.2-2.3 2s2 1.3 2.3 2c.3.8-.8 2.5-.2 3.1.6.6 2.3-.5 3.1-.2.7.3 1.2 2.3 2 2.3s1.3-2 2-2.3c.8-.3 2.5.8 3.1.2.6-.6-.5-2.3-.2-3.1.3-.7 2.3-1.2 2.3-2zM12 16.3c-2.4 0-4.3-1.9-4.3-4.3S9.6 7.7 12 7.7s4.3 1.9 4.3 4.3-1.9 4.3-4.3 4.3z"
      }
    },
    custom30: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.2 6.8c-1.4-1.3-3.1-2-5-2-.4 0-.7.3-.7.7s.3.7.7.7c1.5 0 2.9.6 4 1.6 1 1.1 1.6 2.5 1.6 4 0 .4.3.7.7.7s.7-.3.7-.7c0-1.9-.7-3.6-2-5zm-5 .9c-.4 0-.7.3-.7.7s.3.7.7.7c.7 0 1.4.3 1.9.8s.8 1.1.8 1.9c0 .4.3.7.7.7s.7-.3.7-.7c0-1.1-.4-2.2-1.2-2.9s-1.8-1.2-2.9-1.2zm-1 6.9l.6-1.7c.5.2.9.1 1.3-.3.5-.5.5-1.2 0-1.7s-1.2-.5-1.7 0c-.4.4-.4.9-.2 1.4l-1.6.7-2.8-2.8c-.2-.2-.5-.2-.7 0-1.8 2.1-1.7 5.4.4 7.4 2 2 5.2 2.1 7.3.3.3-.1.3-.5.1-.7l-2.7-2.6z"
      }
    },
    custom31: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.1 10.4l-1.2-3.7c-.2-.7-.8-1.2-1.5-1.2H8.6c-.7 0-1.3.5-1.6 1.2l-1.1 3.7c-.6.1-1.1.7-1.1 1.4v2.8c0 .7.4 1.2 1 1.4v2c0 .3.2.5.4.5h2c.2 0 .4-.2.4-.5v-1.9h6.8V18c0 .3.2.5.4.5h2c.2 0 .4-.2.4-.5v-2c.6-.2 1-.7 1-1.4v-2.8c0-.7-.5-1.3-1.1-1.4zm-10.9 4c-.7 0-1.2-.5-1.2-1.2S6.5 12 7.2 12s1.2.5 1.2 1.2-.5 1.2-1.2 1.2zm5.3-4.1H7.7c-.1 0-.3-.1-.2-.3l.9-2.9c0-.1.1-.1.2-.1h6.7c.1 0 .2 0 .3.1l.9 2.9c0 .2-.1.3-.3.3h-3.7zm4.1 4.1c-.7 0-1.2-.5-1.2-1.2s.5-1.2 1.2-1.2 1.2.5 1.2 1.2-.6 1.2-1.2 1.2z"
      }
    },
    custom32: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.8 8.5l-5.6 3.2c-.1 0-.2.1-.3.1-.3 0-.6-.2-.7-.4-.2-.4 0-.8.4-1l1.8-1.1V7.5c0-.2-.2-.3-.3-.2l-6.9 3.9c-.1.1-.2.1-.3.1-.3 0-.5-.1-.7-.4-.2-.3 0-.8.3-1l1.2-.6v-4c0-.3-.2-.5-.5-.5H5.3c-.3 0-.5.2-.5.5v12.5c0 .8.6 1.4 1.4 1.4h4.1c.3 0 .5-.2.5-.5V17c0-.2.2-.4.5-.4h1.4c.3 0 .5.2.5.4v1.7c0 .3.2.5.5.5h4.1c.8 0 1.4-.6 1.4-1.4V8.7c0-.2-.2-.3-.4-.2zM8.4 15.1c0 .3-.2.5-.5.5h-.5c-.2 0-.4-.2-.4-.5v-1.4c0-.3.2-.5.4-.5h.5c.3 0 .5.2.5.5v1.4zm2.9 0c0 .3-.2.5-.5.5h-.5c-.2 0-.5-.2-.5-.5v-1.4c0-.3.3-.5.5-.5h.5c.3 0 .5.2.5.5v1.4zm2.9 0c0 .3-.3.5-.5.5h-.5c-.3 0-.5-.2-.5-.5v-1.4c0-.3.2-.5.5-.5h.5c.2 0 .5.2.5.5v1.4zm2.8 0c0 .3-.2.5-.4.5h-.5c-.3 0-.5-.2-.5-.5v-1.4c0-.3.2-.5.5-.5h.5c.2 0 .4.2.4.5v1.4z"
      }
    },
    custom33: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M15.6 10.1h-7c-.2 0-.4.2-.4.5v1.9c0 .2.2.5.4.5h7c.3 0 .5-.3.5-.5v-1.9c0-.3-.2-.5-.5-.5zm-3.4 2.1c-.4 0-.7-.3-.7-.7s.3-.7.7-.7.8.3.8.7-.4.7-.8.7zm7-5.5H4.8c-.3 0-.5.2-.5.5v.5c0 .5.5.9 1 .9v8.7c0 .2.2.5.5.5h.4c.3 0 .5-.3.5-.5V8.6h10.8v8.7c0 .2.2.5.5.5h.5c.2 0 .5-.3.5-.5V8.6h-.3c.5 0 1-.4 1-.9v-.5c0-.3-.2-.5-.5-.5z"
      }
    },
    custom34: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M10.1 7.2h3.8c.3 0 .5-.3.5-.5-.3-1.1-1.2-1.9-2.4-1.9s-2.1.8-2.4 1.9c0 .2.2.5.5.5zm8.4 6.2c.4 0 .7-.3.7-.7 0-.4-.4-.7-.8-.7h-2.1v-1.2c1.4-.6 2.4-2 2.4-3.8 0-.4-.2-.7-.6-.8-.4 0-.8.3-.8.8 0 1-.5 1.9-1.2 2.3-.3-.4-.7-.7-1.2-.7H9.1c-.5 0-.9.3-1.2.7C7.2 8.9 6.7 8 6.7 7c0-.4-.3-.7-.7-.8-.4 0-.7.4-.7.8 0 1.7 1 3.2 2.4 3.8V12H5.6c-.4 0-.8.3-.8.7 0 .4.3.7.7.7h2.2v1.2c-1.4.6-2.4 2.1-2.4 3.9 0 .3.2.6.6.7.4.1.8-.3.8-.7 0-1 .5-1.9 1.2-2.3.4 1.3 1.4 2.4 2.8 2.8.3.1.6-.2.6-.5v-5.7c0-.4.3-.8.7-.8.4 0 .7.3.7.7v5.8c0 .4.3.6.6.5 1.4-.4 2.4-1.5 2.8-2.8.7.4 1.2 1.2 1.2 2.2 0 .4.3.8.7.8.4 0 .7-.3.7-.7 0-1.8-1-3.3-2.4-3.9v-1.2h2.2z"
      }
    },
    custom35: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M16.6 9.6c-.4 0-.8.3-.8.7v1.2c0 2.1-1.7 3.9-3.8 3.9s-3.8-1.8-3.8-3.9v-1.2c0-.4-.4-.7-.8-.7s-.7.3-.7.7v1.2c0 2.7 2 4.9 4.6 5.3v1h-1.2c-.4 0-.7.3-.7.7s.3.7.7.7h3.8c.4 0 .7-.3.7-.7s-.3-.7-.7-.7h-1.2v-1c2.6-.4 4.6-2.6 4.6-5.3v-1.2c0-.4-.3-.7-.7-.7zM12 13.9c1.3 0 2.4-1.1 2.4-2.4V7.2c0-1.3-1.1-2.4-2.4-2.4-1.3 0-2.4 1.1-2.4 2.4v4.3c0 1.3 1.1 2.4 2.4 2.4z"
      }
    },
    custom36: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M9.3 17.3h-1c-.2 0-.3.1-.4.2l-.3.6c-.2.3-.2.8.2 1 .1.1.2.1.4.1s.4-.1.6-.4l.7-1.2c.1-.1 0-.3-.2-.3zm6.8.2c-.1-.1-.2-.2-.4-.2h-1c-.2 0-.3.2-.2.3l.7 1.2c.2.3.4.4.6.4.2 0 .3 0 .4-.1.4-.2.4-.7.2-1l-.3-.6zm0-12.7H7.9c-.8 0-1.4.6-1.4 1.4v8.2c0 .8.6 1.4 1.4 1.4h8.2c.8 0 1.4-.6 1.4-1.4V6.2c0-.8-.6-1.4-1.4-1.4zM8.6 14.9c-.4 0-.7-.3-.7-.7s.3-.8.7-.8.8.4.8.8-.4.7-.8.7zm6.8 0c-.4 0-.8-.3-.8-.7s.4-.8.8-.8.7.4.7.8-.3.7-.7.7zm.7-2.9c0 .3-.2.5-.5.5H8.4c-.3 0-.5-.2-.5-.5V7.2c0-.3.2-.5.5-.5h7.2c.3 0 .5.2.5.5V12z"
      }
    },
    custom37: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M19.2 13.4h-3.1v-2.8c.6.6 1.5.9 2.4.9.4 0 .7-.3.7-.7s-.3-.7-.7-.7c-1.3 0-2.4-1.2-2.4-2.7v-.7c.2 0 .5-.2.5-.5v-.4c0-.3-.3-.5-.5-.5h-1.5c-.2 0-.4.2-.4.5v.4c0 .3.2.5.4.5v.7c0 1.5-1.1 2.7-2.6 2.7S9.4 8.9 9.4 7.4v-.7c.2 0 .4-.2.4-.5v-.4c0-.3-.2-.5-.4-.5H7.9c-.2 0-.5.2-.5.5v.4c0 .3.3.5.5.5v.7c0 1.5-1.1 2.7-2.4 2.7-.4 0-.7.3-.7.7s.3.7.7.7c.9 0 1.8-.3 2.4-.9v2.8H4.8c-.3 0-.5.3-.5.5v1.2c0 .2.2.5.5.5h1v2.6c0 .3.2.5.4.5h1.5c.2 0 .5-.2.5-.5v-1c0-.8.6-1.4 1.4-1.4h4.8c.8 0 1.4.6 1.4 1.4v1c0 .3.3.5.5.5h1.5c.2 0 .4-.2.4-.5v-2.6h1c.3 0 .5-.3.5-.5v-1.2c0-.2-.2-.5-.5-.5zm-9.8-2.9c.7.6 1.6 1 2.6 1s1.9-.3 2.6-1v2.9H9.4v-2.9z"
      }
    },
    custom38: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12 10.8c-1.1 0-1.9.9-1.9 1.9s.8 1.9 1.9 1.9 1.9-.8 1.9-1.9-.8-1.9-1.9-1.9zm5.8-2.4h-2c-.2 0-.3-.1-.4-.3l-.6-1.3c-.3-.5-.8-.8-1.3-.8h-3c-.5 0-1 .3-1.3.8l-.6 1.3c-.1.2-.2.3-.4.3h-2c-.8 0-1.4.6-1.4 1.4v6.8c0 .8.6 1.4 1.4 1.4h11.6c.8 0 1.4-.6 1.4-1.4V9.8c0-.8-.6-1.4-1.4-1.4zM12 16.1c-1.8 0-3.4-1.5-3.4-3.3s1.6-3.4 3.4-3.4 3.4 1.5 3.4 3.4-1.6 3.3-3.4 3.3z"
      }
    },
    custom39: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M15.3 6.9c-.1-.2-.3-.3-.5-.3L5.1 9.7c-.2.1-.3.4-.3.6l.4 1.5c.1.2.3.4.6.3l2.4-.3c.1.3.2.5.4.8l-2.1 5.6c-.2.4 0 .8.4 1h.3c.2 0 .5-.2.6-.5l2-5.4c.2.1.3.1.5.1s.3 0 .5-.1l1.9 5.4c.1.3.4.5.7.5h.3c.3-.2.5-.6.4-1L12 12.5c.3-.3.4-.8.4-1.3l3.4-.5c.2 0 .4-.2.3-.4l-.8-3.4zm3.9 3.3l-1.3-4.8c-.1-.4-.5-.7-.9-.6-.4.1-.7.5-.6.9l1.4 4.9c.1.4.5.6.8.5.4-.1.7-.5.6-.9z"
      }
    },
    custom4: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M6.3 7.8l5-2.8c.4-.3 1-.3 1.5 0l4.9 2.8c.5.3.8.8.8 1.3v5.8c0 .5-.3 1-.8 1.3L12.8 19c-.5.3-1.1.3-1.5 0l-5-2.8c-.5-.3-.8-.8-.8-1.3V9.1c0-.5.3-1 .8-1.3z"
      }
    },
    custom40: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.8 6.7H6.2c-.8 0-1.4.7-1.4 1.5v8.1c0 .8.6 1.5 1.4 1.5h11.6c.8 0 1.4-.7 1.4-1.5V8.2c0-.8-.6-1.5-1.4-1.5zm0 1.5v1.4H6.2V8.2h11.6zM6.2 16.3V12h11.6v4.3H6.2zm4.1-3.1c-.3 0-.6.2-.7.4-.1.1-.1.1-.2 0-.1-.2-.4-.4-.8-.4-.5 0-.9.4-.9 1s.4.9.9.9c.4 0 .7-.1.8-.4.1-.1.1-.1.2 0 .1.3.4.4.7.4h.1c.5 0 .9-.4.9-.9v-.1c0-.5-.4-.9-1-.9zm5.5.2H13c-.3 0-.5.3-.5.5v.5c0 .3.2.5.5.5h2.8c.3 0 .5-.2.5-.5v-.5c0-.2-.2-.5-.5-.5z"
      }
    },
    custom41: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": {
          "d": "M18.2 7H5.8c-.8 0-1.5.6-1.5 1.4v7c0 .8.7 1.4 1.5 1.4h12.4c.8 0 1.5-.6 1.5-1.4v-7c0-.8-.7-1.4-1.5-1.4zM7.4 15.4c0-1-.7-1.7-1.6-1.7v-3.6c.9 0 1.6-.8 1.6-1.7h9.2c0 .9.7 1.7 1.6 1.7v3.6c-.9 0-1.6.7-1.6 1.7H7.4z"
        },
        "circle": {
          "cx": "12",
          "cy": "11.76",
          "r": "2.4"
        }
      }
    },
    custom42: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.8 5.3H6.2c-.8 0-1.4.6-1.4 1.4v1.5c0 .2.2.4.5.4h13.4c.3 0 .5-.2.5-.4V6.7c0-.8-.6-1.4-1.4-1.4zm0 4.8H6.2c-.2 0-.4.2-.4.5v6.7c0 .8.6 1.4 1.4 1.4h9.6c.8 0 1.4-.6 1.4-1.4v-6.7c0-.3-.2-.5-.4-.5zm-3.2 2.1c0 .4-.3.8-.7.8h-3.8c-.4 0-.7-.4-.7-.8 0-.3.3-.7.7-.7h3.8c.4 0 .7.3.7.7z"
      }
    },
    custom43: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M19.6 10.4c0-.1.1-.1.1-.2v-.3l-.1-.1v-.1s-.1 0-.1-.1l-2.8-4c-.2-.2-.4-.3-.6-.3H7.4c-.2 0-.4.1-.6.3L4 9.7h-.1v.1c0 .1-.1.1-.1.1v.3c0 .1.1.1.1.2v.1H4v.1l7.2 7.9.1.1h.1v.1h.6v-.1h.1v-.1h.1l7.2-7.9v-.1l.2-.1zm-7.8-1h-1.2l1.2-2 1.1 2h-1.1zm0 1.4h1.4l-1.4 4.7-1.5-4.7h1.5zM13 6.7h1.8l-.7 1.9L13 6.7zM9.4 8.6l-.7-1.9h1.8L9.4 8.6zm-.6 2.2l1.4 4.3-4-4.3h2.6zm5.9 0h2.6l-3.9 4.3 1.3-4.3zm2.9-1.4h-2.2l.7-2.1 1.5 2.1zM7.4 7.3l.7 2.1H6l1.4-2.1z"
      }
    },
    custom44: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M16.7 6.9c-1.2-1.5-2.3-2.1-4.5-2.1-.9 0-2.1.4-2.6.5 0-.3-.2-.5-.5-.5h-.9c-.3 0-.5.2-.5.5v1.9c0 .3.2.5.5.5h.9c.3 0 .5-.2.5-.5h.5c.4 0 .7.3.7.7 0 .4.3.7.7.7v3.9c-.5 0-.9.4-.9.9v4.4c0 .8.6 1.4 1.4 1.4h.5c.8 0 1.4-.6 1.4-1.4v-4.4c0-.5-.4-.9-.9-.9V8.6c.4 0 .7-.5.7-.9s.3-.7.6-.7c1 0 1.5.3 1.8.6.1.1.4.1.5 0 .2-.2.3-.4.1-.7z"
      }
    },
    custom45: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M7.9 10.3h8.2v3.4H7.9zm11.8-.4V8.6c0-.8-.7-1.4-1.5-1.4H5.8c-.8 0-1.5.6-1.5 1.4v1.3c0 .2.1.3.3.4.5.4.9 1 .9 1.7s-.4 1.3-.9 1.6c-.2.1-.3.3-.3.4v1.4c0 .8.7 1.4 1.5 1.4h12.4c.8 0 1.5-.6 1.5-1.4v-1.3c0-.2-.1-.3-.3-.4-.5-.4-.9-1-.9-1.7s.4-1.3.9-1.6c.2-.2.3-.3.3-.5zM17 15.1H7c-.3 0-.5-.2-.5-.5V9.4c0-.3.2-.5.5-.5h10c.3 0 .5.2.5.5v5.2c0 .3-.2.5-.5.5z"
      }
    },
    custom46: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M14.6 8.9H9.4c-.3 0-.5.2-.5.5v5.2c0 .3.2.5.5.5h5.2c.3 0 .5-.2.5-.5V9.4c0-.3-.2-.5-.5-.5zm4.2-2.4c.3 0 .4-.2.4-.4v-.8c0-.3-.2-.5-.5-.5h-.8c-.2 0-.4.1-.4.4-.2.4-.6.8-1.2.8s-1-.4-1.1-.8c-.1-.3-.3-.4-.5-.4h-1.1c-.2 0-.4.1-.4.4-.2.4-.6.8-1.2.8s-1-.4-1.2-.8c0-.3-.2-.4-.4-.4H9.3c-.2 0-.4.1-.5.4-.1.4-.6.8-1.1.8-.5 0-1-.4-1.2-.8 0-.3-.2-.4-.4-.4h-.8c-.3 0-.5.2-.5.5v.8c0 .2.1.4.4.4.4.2.8.6.8 1.2s-.4 1-.8 1.1c-.3.1-.4.3-.4.5v1.1c0 .2.1.4.4.4.4.2.8.6.8 1.2s-.4 1-.8 1.2c-.3 0-.4.2-.4.4v1.1c0 .2.1.4.4.5.4.1.8.6.8 1.1s-.4 1-.8 1.2c-.3 0-.4.2-.4.4v.8c0 .3.2.5.5.5h.8c.2 0 .4-.1.4-.4.2-.4.6-.8 1.2-.8.5 0 1 .4 1.1.8.1.3.3.4.5.4h1.1c.2 0 .4-.1.4-.4.2-.4.6-.8 1.2-.8s1 .4 1.2.8c0 .3.2.4.4.4h1.1c.2 0 .4-.1.5-.4.1-.4.6-.8 1.1-.8s1 .4 1.2.8c0 .3.2.4.4.4h.8c.3 0 .5-.2.5-.5v-.8c0-.2-.1-.4-.4-.4-.4-.2-.8-.6-.8-1.2s.4-1 .8-1.1c.3-.1.4-.3.4-.5v-1.1c0-.2-.1-.4-.4-.4-.4-.2-.8-.6-.8-1.2s.4-1 .8-1.2c.3 0 .4-.2.4-.4V9.3c0-.2-.1-.4-.4-.5-.4-.1-.8-.6-.8-1.1s.4-1 .8-1.2zm-2.2 8.6c0 .8-.7 1.5-1.5 1.5H8.9c-.8 0-1.5-.7-1.5-1.5V8.9c0-.8.7-1.5 1.5-1.5h6.2c.8 0 1.5.7 1.5 1.5v6.2z"
      }
    },
    custom47: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M15.4 17.3H7.2c-.8 0-1.4.6-1.4 1.4 0 .3.2.5.4.5h10.1c.3 0 .5-.2.5-.5 0-.8-.6-1.4-1.4-1.4zm3.2-7.6l-3.8-3.6.6-.9c.1-.1 0-.3-.2-.4-1.1-.2-1.9.6-1.9.6-7.3 0-6.1 8.2-5.8 10.1.1.2.3.3.5.3h6.5c.2 0 .3-.2.2-.3-1.3-1.7-2-3.5-2.5-4.6 0-.2.2-.4.4-.3 1.7.9 2.4-.1 3.6.7.6.3 1.3.2 1.8-.3l.6-.6c.2-.2.2-.5 0-.7zm-4.9-.8c-.4 0-.7-.3-.7-.7s.3-.8.7-.8.7.4.7.8-.3.7-.7.7z"
      }
    },
    custom48: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.7 5.8h-2.4v-.5c0-.3-.2-.5-.5-.5H8.2c-.3 0-.5.2-.5.5v.5H5.3c-.3 0-.5.2-.5.4v3.2c0 1.2 1 2.1 2.2 2.1h1.1c.6 1.6 2.1 2.6 3.9 2.7 1.8 0 3.3-1.1 4-2.7h1c1.2 0 2.2-.9 2.2-2.1V6.2c0-.2-.2-.4-.5-.4zM7 10.1c-.4 0-.8-.3-.8-.7V7.2h1.5v2.9H7zm10.8-.7c0 .4-.4.7-.8.7h-.7V7.2h1.5v2.2zm-3.4 8.4h-.2c-.8 0-1.5-.7-1.5-1.5v-.5c0-.1-.1-.2-.2-.2h-1c-.1 0-.2.1-.2.2v.5c0 .8-.7 1.5-1.5 1.5h-.2c-.3 0-.5.2-.5.4v.5c0 .3.2.5.5.5h4.8c.3 0 .5-.2.5-.5v-.5c0-.2-.2-.4-.5-.4z"
      }
    },
    custom49: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12 9.8c-1.2 0-2.2 1-2.2 2.2s1 2.2 2.2 2.2 2.2-1 2.2-2.2-1-2.2-2.2-2.2zm0 3.4c-.7 0-1.2-.5-1.2-1.2s.5-1.2 1.2-1.2 1.2.5 1.2 1.2-.5 1.2-1.2 1.2zm0-8.4C8 4.8 4.8 8 4.8 12S8 19.2 12 19.2s7.2-3.2 7.2-7.2S16 4.8 12 4.8zm0 12.7c0 .3-.2.5-.5.5-2.9-.3-5.2-2.6-5.5-5.5 0-.3.2-.5.5-.5H7c.2 0 .4.2.5.4.2 2.2 1.9 3.9 4.1 4.1.2.1.4.3.4.5v.5zm0-1.9c-2 0-3.6-1.6-3.6-3.6S10 8.4 12 8.4s3.6 1.6 3.6 3.6-1.6 3.6-3.6 3.6zm5.5-3.6H17c-.2 0-.4-.2-.5-.4-.2-2.2-1.9-3.9-4.1-4.1-.2-.1-.4-.3-.4-.5v-.5c0-.3.2-.5.5-.5 2.9.3 5.2 2.6 5.5 5.5 0 .3-.2.5-.5.5z"
      }
    },
    custom5: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.9 6.1c-2.4-.9-5.3-1.1-7.8-.3-2.2.7-4.5 2.4-4.8 4.9-.1.5-.1 1.1 0 1.6.1.2.2.5.3.8 0 .1.1.2.1.3l-.2.5C5.8 15 5.3 16.2 5 17.4c-.1.6-.4 1.3.1 1.7.3.1.6.1.8 0 .3-.1.3-.4.4-.7.2-1.3.6-2.6 1.3-3.7.3-.5.7-1 1.1-1.5.4-.4.9-1.1 1.5-.9.6.2.6.9.2 1.3s-.8.7-.8 1.3c0 .4.2.8.6 1.1.5.4 1.4.5 2 .5 1.3-.1 2.3-.5 3.3-1.2 1.4-1 1.9-2.6 2.2-4.2.1-.9.3-1.9.6-2.8.1-.4.3-.8.5-1.1.1-.2.3-.4.4-.6 0-.2-.1-.4-.3-.5z"
      }
    },
    custom50: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.4 13.5c-.6.3-1.2.4-1.8.4-.8 0-1.6-.2-2.2-.6h-.2c-.7.4-1.4.6-2.2.6s-1.5-.2-2.2-.6h-.2c-.6.4-1.4.6-2.2.6-.6 0-1.2-.1-1.8-.4-.1-.1-.3.1-.3.2v2.9c0 .6.3 1.1.8 1.4 1.2.5 2.5.9 3.9 1.1.3 0 .6-.2.6-.5v-1.8c0-.8.6-1.4 1.4-1.4.8 0 1.4.6 1.4 1.4v1.8c0 .3.3.5.6.5 1.3-.2 2.6-.6 3.8-1.1.6-.3.9-.8.9-1.4v-2.9c0-.1-.2-.3-.3-.2zm-11-1c.9 0 1.6-.4 2.1-1 .1-.1.3-.1.4 0 .5.6 1.2 1 2.1 1 .8 0 1.6-.4 2.1-1 .1-.1.2-.1.3 0 .5.6 1.3 1 2.1 1 1.4 0 2.5-1 2.6-2.1.1-.2 0-.4-.2-.5l-6-4.8c-.6-.4-1.3-.4-1.8 0L5 9.9c-.2.1-.2.3-.2.5.2 1.2 1.3 2.1 2.6 2.1z"
      }
    },
    custom51: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M9.7 6.1c.6.5 1.2 1.4 1.5 2.2 0 .1.2.3.3.3h.5c.3 0 .5 0 .7-.1.6-.2 1.1-.4 1.6-.9.7-.7 1-1.8.7-2.7-.9-.2-1.9 0-2.7.7-.2.3-.3.5-.5.8-.4-.6-.8-1.2-1.4-1.5-.3-.2-.8-.1-1 .3-.1.3 0 .7.3.9zm7.4 3.5c-2.5-1.3-3 .5-5.1.5s-2.6-1.8-5.1-.5c-2.4 1.4-1.7 5.8-.7 7.5.8 1.5 2.4 3 5.6 1.5h.4c3.2 1.5 4.8 0 5.6-1.5 1-1.7 1.7-6.1-.7-7.5z"
      }
    },
    custom52: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M19.2 8.4c0-.7 0-1.5-.1-2.3-.1-.6-.6-1.1-1.2-1.2-.8-.1-1.6-.1-2.3-.1-.2 0-.3.3-.2.4l3.4 3.4c.1.1.4 0 .4-.2zm-5.7-3c-.1-.2-.3-.2-.4-.2-1.8.5-3.6 1.5-5 2.9s-2.3 3.1-2.8 4.8c-.1.2 0 .4.1.5l5.2 5.2c.1.2.3.2.5.2 1.7-.6 3.4-1.5 4.8-2.9s2.4-3.1 2.9-4.9c0-.2 0-.4-.1-.5l-5.2-5.1zm-2 9.4c-.3.3-.7.3-1 0l-1.4-1.4c-.2-.2-.2-.7 0-1 .3-.3.8-.3 1.1 0l1.3 1.4c.3.2.3.7 0 1zm1.7-1.7c-.3.3-.8.3-1 0l-1.4-1.3c-.3-.3-.3-.8 0-1 .3-.3.8-.3 1 0l1.4 1.3c.3.3.3.7 0 1zm1.7-1.7c-.3.3-.8.3-1.1 0l-1.3-1.3c-.3-.3-.3-.8 0-1.1.3-.2.7-.2 1 0l1.4 1.4c.2.3.2.7 0 1zm-10.1 4c0 .8 0 1.7.1 2.5.1.6.6 1.1 1.2 1.2.9.1 1.7.1 2.5.1.2 0 .3-.3.2-.4l-3.6-3.5c-.1-.2-.4-.1-.4.1z"
      }
    },
    custom53: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.9 13.7h-.1c-.6 0-1-.5-1-1V9.5c0-2.8-2.5-5-5.4-4.7-2.4.3-4.2 2.4-4.2 4.9v2.9c0 .6-.5 1.1-1.1 1.1-.5 0-.8.3-.8.8v.5c0 .5.3.8.8.8h11.8c.5 0 .8-.3.8-.8v-.5c0-.5-.3-.8-.8-.8zm-4.3 3.6h-3.2c-.2 0-.3.1-.3.3.2.9 1 1.6 1.9 1.6s1.8-.6 1.9-1.6c0-.2-.1-.3-.3-.3z"
      }
    },
    custom54: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M6.5 11.8c1.6-.3 3-.9 4.4-1.6.5-.2 1.4-.7 1.8-.9.2 0 .3-.2.2-.3-.1-.7-.7-1.3-1.4-1.3H11v-.9c0-.3-.2-.5-.4-.5v-1c0-.3-.3-.5-.5-.5h-1c-.2 0-.5.2-.5.5v1c-.2 0-.4.2-.4.5v.9h-.5c-.8 0-1.5.7-1.5 1.5v2.3c0 .2.2.3.3.3zm10.8 4.8s1.7-2.7 1.9-6.6c0-.3-.2-.5-.5-.5-5.7.2-8.4 3.7-13.4 3.9-.3 0-.5.3-.5.5v1.8c0 .8.6 1.4 1.3 1.5 2.6.2 8 .5 11.1 1 .3.1.6-.2.5-.5-.1-.4-.2-.8-.4-1.1zm-.3-4.4c-.4 0-.7-.3-.7-.7s.3-.7.7-.7.8.3.8.7-.4.7-.8.7z"
      }
    },
    custom55: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M7.7 14.6h3.1c.3 0 .5-.2.5-.4V7c0-.6-.5-1-1-1H7.8c-.4 0-.6.2-.6.6v7.6c0 .2.2.4.5.4zm10.5-7.2v7.7c0 .5-.4 1-.9 1H6.7c-.5 0-.9-.5-.9-1V7.4c-.8 0-1.5.7-1.5 1.5v7.2c0 .8.7 1.4 1.5 1.4h4.5c.3 0 .5.2.5.5s.2.5.5.5h1.4c.3 0 .5-.2.5-.5s.2-.5.5-.5h4.5c.8 0 1.5-.6 1.5-1.4V8.9c0-.8-.7-1.5-1.5-1.5zm-5 7.2h3c.4 0 .6-.2.6-.5V6.5c0-.3-.2-.5-.5-.5h-2.6c-.5 0-1 .4-1 1v7.2c0 .2.2.4.5.4z"
      }
    },
    custom56: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M15 7.3c-1.5 1.5-3.3-.4-5 1.3l-4.8 4.8c-.5.6-.5 1.5 0 2l1.7 1.7 1.7 1.7c.5.5 1.4.5 2 0l4.8-4.9c1.7-1.6-.2-3.5 1.4-5l.3-.4c.1-.1.1-.2 0-.3l-1.3-1.3c-.1-.1-.2-.1-.3 0l-.5.4zm-1.1 6.1l-1.7 1.7c-.2.2-.5.2-.7 0l-1.3-1.3-1.3-1.4c-.2-.2-.2-.4 0-.6l1.6-1.7c.2-.2.5-.2.7 0l1.4 1.3 1.3 1.4c.2.2.2.4 0 .6zm5.2-7.5l-.5-.5-.6-.5c-.1-.2-.4-.2-.6 0l-.6.6c-.1.1-.1.3 0 .4l1.3 1.3c.1.1.2.1.3 0l.6-.6c.2-.2.2-.5.1-.7z"
      }
    },
    custom57: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12.7 12.6v5.9c0 .2.2.3.4.2 1.1-.7 4.6-2.6 4.6-2.6.5-.3.8-.8.8-1.3V9.5c0-.2-.2-.3-.4-.2L13 12.2c-.2.1-.3.3-.3.4zm-.5-1.6l5.2-2.9c.2-.1.2-.3 0-.4C16.3 7 12.7 5 12.7 5c-.4-.2-1-.2-1.4 0 0 0-3.6 2-4.7 2.7-.2.1-.2.3 0 .4l5.2 2.9c.1.1.3.1.4 0zM11 12.2L5.9 9.3c-.2-.1-.4 0-.4.2v5.3c0 .5.3 1 .8 1.2 0 0 3.5 2 4.6 2.7.2.1.4-.1.4-.2v-5.9c0-.1-.1-.3-.3-.4z"
      }
    },
    custom58: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M16.1 11c-.4 0-.8-.3-.7-.7 0-.4.3-.7.7-.7h2.1c.1 0 .2 0 .2-.1.2-.4.3-.7.5-1 0-.2-.1-.3-.3-.3h-1.5c-.4 0-.7-.3-.8-.7 0-.4.4-.8.8-.8H19c.1 0 .2-.1.2-.2v-.7c0-.3-.2-.5-.5-.5h-2.5c-.7 0-1.3.6-1.3 1.3 0 1.3-.9 2.5-2.2 2.9v-2c.5-.3.8-.9.7-1.5-.1-.6-.6-1.1-1.2-1.2-.9-.1-1.6.6-1.6 1.4 0 .6.3 1 .7 1.3v2C10 9.2 9.1 8 9.1 6.6c0-.7-.5-1.3-1.3-1.3H5.3c-.3 0-.5.2-.5.5v.7c0 .1.1.2.2.2h1.9c.4 0 .8.3.8.7 0 .4-.3.8-.7.8H5.4c-.2 0-.3.2-.2.3.1.3.2.7.4 1 .1.1.2.1.3.1h2c.4 0 .8.3.8.7 0 .4-.3.8-.7.8h-.6c-.2 0-.3.3-.2.4 1.1.9 2.4 1.5 4.1 1.5v5.5c0 .3.3.7.7.7.4 0 .8-.3.8-.7V13c1.7 0 3-.7 4-1.5.2-.2.1-.5-.1-.5h-.6z"
      }
    },
    custom59: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M16.4 7.4c.2 0 .4-.2.4-.4 0-.1-.1-.3-.3-.4-.3-.2-.8-1-.9-1.5-.1-.2-.3-.3-.5-.3H9.3c-.2 0-.4.1-.4.3-.2.5-.7 1.3-1 1.5-.1.1-.2.2-.2.4 0 .3.2.4.4.4h8.3zM7.7 17.7c0 .9.6 1.5 1.4 1.5h6.3c.8 0 1.4-.6 1.4-1.4v-.1c0-.2-.2-.4-.5-.4H8.1c-.2 0-.4.2-.4.4zm9.1-2.3v-6c0-.3-.2-.5-.5-.5H8.2c-.3 0-.5.2-.5.5v6c0 .2.2.4.5.4h8.1c.3 0 .5-.2.5-.4z"
      }
    },
    custom6: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12 18.2H5.8c-.8 0-1.2-.8-.9-1.4l6.3-10.6c.3-.6 1.3-.6 1.6 0l6.3 10.6c.4.6-.1 1.4-.8 1.4H12z"
      }
    },
    custom60: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M19.2 10.9c-.6-3.5-3.6-6.1-7.2-6.1s-6.6 2.6-7.2 6.1c0 .2.2.4.4.2.3-.3.8-.5 1.3-.5.7 0 1.3.3 1.7.8.1.1.2.1.3 0 .4-.5 1-.8 1.7-.8s1.2.3 1.6.8c.1.1.3.1.4 0 .4-.5 1-.8 1.6-.8s1.3.3 1.7.8c.1.1.2.1.3 0 .4-.5 1-.8 1.7-.8.5 0 1 .2 1.3.5.2.2.4 0 .4-.2zm-4.3 5.4c-.4 0-.7.3-.7.7s-.4.8-.8.8-.7-.4-.7-.8v-3.3c0-.4-.3-.7-.7-.7s-.7.3-.7.7V17c0 1.2.9 2.2 2.1 2.2s2.2-1 2.2-2.2c0-.4-.3-.7-.7-.7z"
      }
    },
    custom61: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.5 4.8h-.9c-.3 0-.5.2-.5.5v.9c0 .3-.2.5-.5.5h-.5c-.2 0-.5-.2-.5-.5v-.9c0-.3-.2-.5-.4-.5h-1c-.3 0-.5.2-.5.5v.9c0 .3-.2.5-.5.5h-.4c-.3 0-.5-.2-.5-.5v-.9c0-.3-.2-.5-.5-.5h-1c-.2 0-.4.2-.4.5v.9c0 .3-.3.5-.5.5h-.5c-.3 0-.5-.2-.5-.5v-.9c0-.3-.2-.5-.5-.5h-.9c-.3 0-.5.2-.5.5v2.4c0 .8.6 1.4 1.4 1.4h9.2c.8 0 1.4-.6 1.4-1.4V5.3c0-.3-.2-.5-.5-.5zM16.4 11c0-.3-.2-.4-.4-.4H8c-.2 0-.4.1-.4.4l-1.1 7.6c-.1.3.2.6.5.6h3.1c.2 0 .5-.2.5-.5v-2.3c0-.8.6-1.5 1.4-1.5.8 0 1.4.6 1.4 1.4v2.4c0 .3.3.5.5.5H17c.3 0 .6-.2.5-.5L16.4 11z"
      }
    },
    custom62: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.5 16.8h-13c-.4 0-.7.3-.7.7 0 .4.3.7.7.7h13c.4 0 .7-.3.7-.7s-.3-.7-.7-.7zM5.8 15.4h8.1v-1c0-.3.2-.5.5-.5h2.4c.3 0 .5.2.5.5v1h.9c.3 0 .5-.3.5-.5V6.7c0-.2-.2-.5-.5-.5H5.8c-.3 0-.5.3-.5.5v8.2c0 .2.2.5.5.5zm2.1-6.3c0-.2.2-.5.5-.5h7c.2 0 .4.3.4.5v.5c0 .3-.2.5-.4.5h-7c-.3 0-.5-.2-.5-.5v-.5zm0 2.9c0-.3.2-.5.5-.5H13c.2 0 .4.2.4.5v.5c0 .2-.2.5-.4.5H8.4c-.3 0-.5-.3-.5-.5V12z"
      }
    },
    custom63: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M10.1 14.4h3.8c.3 0 .5-.2.5-.5v-3.8c0-.3-.2-.5-.5-.5h-3.8c-.3 0-.5.2-.5.5v3.8c0 .3.2.5.5.5zm8.4-1.7c.4 0 .7-.3.7-.7s-.3-.7-.7-.7h-1.2V9.8h1.2c.4 0 .7-.3.7-.7s-.3-.7-.7-.7h-1.2v-.2c0-.8-.7-1.5-1.5-1.5h-.2V5.5c0-.4-.3-.7-.7-.7s-.7.3-.7.7v1.2h-1.5V5.5c0-.4-.3-.7-.7-.7s-.7.3-.7.7v1.2H9.8V5.5c0-.4-.3-.7-.7-.7s-.7.3-.7.7v1.2h-.2c-.8 0-1.5.7-1.5 1.5v.2H5.5c-.4 0-.7.3-.7.7s.3.7.7.7h1.2v1.5H5.5c-.4 0-.7.3-.7.7s.3.7.7.7h1.2v1.5H5.5c-.4 0-.7.3-.7.7s.3.7.7.7h1.2v.2c0 .8.7 1.5 1.5 1.5h.2v1.2c0 .4.3.7.7.7s.7-.3.7-.7v-1.2h1.5v1.2c0 .4.3.7.7.7s.7-.3.7-.7v-1.2h1.5v1.2c0 .4.3.7.7.7s.7-.3.7-.7v-1.2h.2c.8 0 1.5-.7 1.5-1.5v-.2h1.2c.4 0 .7-.3.7-.7s-.3-.7-.7-.7h-1.2v-1.5h1.2zm-2.7 2.4c0 .4-.3.7-.7.7H8.9c-.4 0-.7-.3-.7-.7V8.9c0-.4.3-.7.7-.7h6.2c.4 0 .7.3.7.7v6.2z"
      }
    },
    custom64: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12 4.8C8 4.8 4.8 8 4.8 12S8 19.2 12 19.2s7.2-3.2 7.2-7.2S16 4.8 12 4.8zm0 12.5c-2.9 0-5.3-2.4-5.3-5.3S9.1 6.7 12 6.7s5.3 2.4 5.3 5.3-2.4 5.3-5.3 5.3zm2.8-8.4l-4 1.4c-.2.1-.4.3-.5.5l-1.4 4c-.1.2.1.4.3.3l4-1.4c.2-.1.4-.3.5-.5l1.4-4c.1-.2-.1-.4-.3-.3zM12 13c-.5 0-1-.5-1-1s.5-1 1-1 1 .5 1 1-.5 1-1 1z"
      }
    },
    custom65: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.3 16.1h-12c-.3 0-.5.2-.5.4v.1c0 .8.6 1.4 1.4 1.4h10.1c.8 0 1.5-.6 1.5-1.4v-.1c0-.2-.3-.4-.5-.4zm-.5-9.6H5.3c-.2 0-.4.2-.5.5 0 .6 0 1.8.1 2.5.3 2.2 1.5 4.1 3.1 5.1.1 0 .2.1.3.1h5c.1 0 .2-.1.2-.1 1-.6 1.8-1.4 2.3-2.5.3.1.6.1 1 .1 1.6 0 2.9-1.3 2.9-2.8s-1.3-2.9-2.9-2.9zm0 4.3h-.4c.3-.8.4-1.6.4-2.5v-.4c.8 0 1.4.7 1.4 1.5s-.6 1.4-1.4 1.4z"
      }
    },
    custom66: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.8 13.3l-3.5-3.5c-.6-.6-1.5-.6-2 0l-3.5 3.5c-.6.5-.6 1.4 0 2l3.5 3.5c.5.5 1.4.5 2 0l3.5-3.5c.5-.6.5-1.5 0-2zm-6.6 1.6c-.4.3-.9.3-1.2 0-.3-.4-.3-.9 0-1.2.3-.3.9-.3 1.2 0 .3.3.3.8 0 1.2zm2.7 2.7c-.4.3-.9.3-1.2 0-.3-.3-.3-.9 0-1.2.3-.3.9-.3 1.2 0 .3.3.3.9 0 1.2zm0-5.4c-.4.3-.9.3-1.2 0-.3-.4-.3-.9 0-1.2.3-.3.9-.3 1.2 0 .3.3.3.8 0 1.2zm2.7 2.7c-.3.3-.9.3-1.2 0-.3-.4-.3-.9 0-1.2.4-.3.9-.3 1.2 0 .3.3.3.8 0 1.2zM12.7 8V6.2c0-.8-.6-1.4-1.4-1.4H6.2c-.8 0-1.4.6-1.4 1.4v5.1c0 .8.6 1.4 1.4 1.4H8c.2 0 .3-.1.4-.1l.3-.3 3.5-3.6.3-.3c.1-.1.2-.2.2-.4zm-5.9 3.5c-.4 0-.8-.4-.8-.8s.4-.9.8-.9.9.4.9.9-.4.8-.9.8zm2-1.9c-.5 0-.9-.4-.9-.8s.4-.9.9-.9.8.4.8.9-.4.8-.8.8zm1.9-1.9c-.5 0-.9-.4-.9-.9s.4-.8.9-.8.8.4.8.8-.4.9-.8.9z"
      }
    },
    custom67: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M13 12.7l-.3-.5c-.1-.2-.3-.3-.6-.3 0 0-.1.1-.2.1l-.8.3c-.3-.3-.7-.5-1.1-.6l-.2-.9c0-.3-.3-.5-.6-.5h-.6c-.2 0-.5.2-.6.5l-.1.9c-.4.1-.8.3-1.1.6L6 12h-.3c-.2 0-.4.1-.5.3l-.3.5c-.1.2-.1.5.2.7l.7.6c-.1.2-.1.4-.1.6s0 .5.1.7l-.7.6c-.3.2-.3.5-.2.7l.3.5c.1.2.3.3.5.3H6l.8-.3c.3.3.7.5 1.1.6l.1.9c.1.3.4.5.6.5h.6c.3 0 .6-.2.6-.5l.2-.9c.4-.1.8-.4 1.1-.7l.8.3c.1.1.2.1.2.1.3 0 .5-.1.6-.3l.3-.5c.1-.2.1-.6-.2-.8l-.7-.5c.1-.3.1-.5.1-.7 0-.2 0-.4-.1-.6l.7-.6c.2-.2.3-.5.2-.8zm-4.1 3.7c-.9 0-1.6-.7-1.6-1.6s.7-1.7 1.6-1.7c.9 0 1.7.7 1.7 1.7s-.8 1.6-1.7 1.6zm10.1-7l-.5-.5v-.5-.5l.5-.5c.2-.1.2-.4.1-.6l-.2-.4c-.1-.1-.3-.2-.4-.2h-.2l-.7.3c-.3-.3-.6-.5-.9-.5l-.1-.8c-.1-.2-.3-.4-.5-.4h-.5c-.2 0-.4.2-.5.4l-.1.7c-.3.1-.6.3-.9.6l-.7-.4h-.1c-.2 0-.4.1-.5.3l-.2.4c-.1.2-.1.4.1.6l.6.4c-.1.2-.1.4-.1.6 0 .1 0 .3.1.5l-.6.4c-.2.2-.2.4-.1.6l.2.4c.1.2.3.3.5.3h.1l.7-.3c.3.2.6.4.9.5l.1.7c.1.2.3.4.5.4h.5c.2 0 .5-.2.5-.4l.1-.7c.3-.1.7-.3.9-.6l.7.3h.2c.1 0 .3-.1.4-.2l.2-.4c.1-.1.1-.4-.1-.5zm-3.1.3c-.8 0-1.4-.6-1.4-1.3s.6-1.3 1.4-1.3 1.3.6 1.3 1.3-.6 1.3-1.3 1.3z"
      }
    },
    custom68: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12 4.8C8 4.8 4.8 8 4.8 12S8 19.2 12 19.2s7.2-3.2 7.2-7.2S16 4.8 12 4.8zm5.7 6.5h-1.9c-.1-1.7-.4-3.2-1-4.3 1.6.8 2.7 2.4 2.9 4.3zm-6.4-4.7v4.7H9.6c.1-2.3.9-4.1 1.7-4.7zm0 6.1v4.7c-.8-.6-1.6-2.4-1.7-4.7h1.7zm1.4 4.7v-4.7h1.7c-.1 2.3-.9 4.1-1.7 4.7zm0-6.1V6.6c.8.6 1.6 2.4 1.7 4.7h-1.7zM9.2 7c-.6 1.1-.9 2.6-1 4.3H6.3C6.5 9.4 7.6 7.8 9.2 7zm-2.9 5.7h1.9c.1 1.7.4 3.2 1 4.3-1.6-.8-2.7-2.4-2.9-4.3zm8.5 4.3c.6-1.1.9-2.6 1-4.3h1.9c-.2 1.9-1.3 3.5-2.9 4.3z"
      }
    },
    custom69: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12.6 10.8c-1.3-1-2.7-.5-3.6.4-.4.3-.9.5-1.5.6-.7.2-1.4.5-1.9 1-1.3 1.3-1 2.9.8 4.7h.1v.1c1.1 1 2.1 1.6 3 1.6.7 0 1.3-.3 1.9-.8.5-.5.7-1.2.9-1.9.2-.5.4-1.1.7-1.4.6-.5.9-1.1.9-1.8.1-.4 0-1.1-.5-1.7 0 0-.3-.4-.8-.8zm-3 5.8c-.1.1-.2.2-.4.2s-.4-.1-.5-.2l-1.3-1.3c-.3-.3-.3-.7 0-.9s.7-.3.9 0l1.3 1.3c.3.2.3.6 0 .9zm1.2-2c-.7 0-1.2-.5-1.2-1.2s.5-1.2 1.2-1.2 1.2.6 1.2 1.2-.5 1.2-1.2 1.2zM19.1 6L18 4.9c-.2-.1-.6-.1-.8 0L16 6.2c-.2.2-.2.5 0 .7V7l-2.4 2.4c-.1.1-.1.3 0 .4.2.2.5.4.7.6.1.1.2.1.3 0L17 8h.1c.2.2.5.2.7 0l1.3-1.2c.1-.2.1-.5 0-.8z"
      }
    },
    custom7: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M6.7 18.7c-.8 0-1.4-.6-1.4-1.4V6.7c0-.8.6-1.4 1.4-1.4h10.6c.8 0 1.4.6 1.4 1.4v10.6c0 .8-.6 1.4-1.4 1.4H6.7z"
      }
    },
    custom70: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M11.5 15.3l-2.8-2.7c-.5-.6-1.5-.6-2 0l-1.8 1.7c-.1.2-.1.5 0 .7l.4.3.3.3 2.8 2.8.2.2.5.5c.2.1.5.1.7 0l1.7-1.7c.6-.6.6-1.5 0-2.1zm-4.5-1l.4-.3c.2-.2.4-.2.6 0l2.1 2c.2.2.2.5 0 .7l-.3.3c-.2.2-.5.2-.7 0L7 15c-.2-.2-.2-.5 0-.7zm3-2.5l2.2 2.2c.1 0 .1.1.2.1l1-.1c.2 0 .3-.1.3-.2v-.9c0-.1.1-.2.2-.2h.9c.1 0 .2-.1.2-.2v-.9c0-.1.1-.2.3-.2h.9c.1 0 .2-.1.2-.3v-.9c0-.1.1-.2.2-.2h.9c.2 0 .3-.1.3-.2v-.9c0-.1.1-.2.2-.2l1-.2c.1 0 .2-.2.1-.3L17 5c-.2-.2-.5-.2-.7 0L10 11.2c-.2.2-.2.4 0 .6z"
      }
    },
    custom71: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.1 7.4c-1.4-1.4-3.3-2.2-5.3-2.1-3.9.1-7 3.4-7 7.3v2.3c0 .8.6 1.4 1.4 1.4h1v1.2c0 .6.5 1.1 1.1 1.2.7.1 1.3-.5 1.3-1.2v-4.3c0-.6-.5-1.1-1.1-1.2-.7-.1-1.3.5-1.3 1.2v1.7h-.5c-.2 0-.5-.2-.5-.5v-1.8c0-3.1 2.6-5.8 5.6-5.9 1.6 0 3.1.5 4.2 1.7 1.1 1.1 1.8 2.5 1.8 4.1v1.9c0 .3-.3.5-.5.5h-.5v-1.7c0-.6-.5-1.1-1.1-1.2-.7-.1-1.3.5-1.3 1.2v4.3c0 .6.5 1.1 1.1 1.2.7.1 1.3-.5 1.3-1.2v-1.2h1c.8 0 1.4-.6 1.4-1.4v-2.3c0-1.9-.7-3.8-2.1-5.2z"
      }
    },
    custom72: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": {
          "d": "M18.5 4.8h-13c-.4 0-.7.3-.7.7s.3.7.7.7h5.8v1.5c-2.6.4-4.6 2.6-4.6 5.2v1.7c0 1.7 1.4 3.2 3.2 3.2h4.2c1.8 0 3.2-1.5 3.2-3.2v-1.7c0-2.7-2-4.9-4.6-5.2V6.2h5.8c.4 0 .7-.3.7-.7s-.3-.7-.7-.7zm-3.1 8.1c0 .7-.6 1.3-1.3 1.3H9.9c-.7 0-1.2-.6-1.3-1.3.1-1.8 1.5-3.3 3.4-3.3s3.3 1.5 3.4 3.3z"
        },
        "circle": [{
          "cx": "6.24",
          "cy": "18.24",
          "r": ".96"
        }, {
          "cx": "17.76",
          "cy": "18.24",
          "r": ".96"
        }]
      }
    },
    custom73: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M5.6 8.4h12.8c.3 0 .5-.3.4-.6-.3-1-.7-1.9-1.3-2.7-.1-.2-.5-.3-.7-.1-.6.6-1.3.9-2.2.9-.9 0-1.7-.4-2.3-1-.2-.1-.5-.1-.6 0-.6.6-1.5 1-2.3 1-.9 0-1.6-.3-2.2-.9-.3-.2-.6-.1-.7.1-.6.8-1.1 1.7-1.3 2.7-.1.3.1.6.4.6zm13.6 1.9c0-.2-.2-.5-.5-.5H5.3c-.3 0-.5.3-.5.5v.1c0 4.5 3.1 8.2 7.2 8.8 4.1-.6 7.2-4.3 7.2-8.8v-.1z"
      }
    },
    custom74: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M13.4 17.5H11c-.2 0-.4.2-.4.5v.7c0 .3.2.5.4.5h2.4c.3 0 .5-.2.5-.5V18c0-.3-.2-.5-.5-.5zM12.2 4.8C9.3 4.8 7 7.1 7 9.8c0 1.8.9 3.4 2.5 4.3.5.3.9.9 1 1.6.1.2.3.4.5.4h2.5c.3 0 .4-.2.5-.4.1-.7.5-1.3 1.1-1.6 1.4-.9 2.4-2.5 2.4-4.3 0-2.7-2.3-5-5.3-5zm-1.6 2.3c-.5.9-.7 1.9-.8 2.8 0 .9.2 1.8.5 2.6.1.2-.1.4-.3.3-2.2-1.1-2.1-5.3.3-6.1.2-.1.4.2.3.4zm1.9 5.7c-.1.2-.4.2-.5 0-.4-1-.5-2.1-.5-3.1s.1-2.1.5-3c.1-.2.4-.2.5 0 .3.9.4 2 .5 3-.1 1-.2 2.1-.5 3.1zm1.9 0c-.2.1-.4-.1-.3-.3.3-.9.4-1.8.5-2.7-.1-.8-.3-1.9-.8-2.7-.1-.2.1-.5.3-.4 2.4.8 2.5 5 .3 6.1z"
      }
    },
    custom75: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12 4.8c-.4 0-.7.3-.7.7v13c0 .4.3.7.7.7 4 0 7.2-3.2 7.2-7.2S16 4.8 12 4.8zm5.7 6.5h-1.9c-.1-1.7-.4-3.2-1-4.3 1.6.8 2.7 2.4 2.9 4.3zm-5 6.1v-4.7h1.7c-.1 2.3-.9 4.1-1.7 4.7zm0-6.1V6.6c.8.6 1.6 2.4 1.7 4.7h-1.7zm2.1 5.7c.6-1.1.9-2.6 1-4.3h1.9c-.2 1.9-1.3 3.5-2.9 4.3zM8 9.6c.2.1.5.1.7-.1L10 8c.2-.2.2-.5 0-.6L8.7 6c-.2-.1-.4-.1-.6 0-.1 0-.2.1-.3.1-1.8 1.3-3 3.5-3 5.9 0 2.4 1.2 4.6 3 5.9.1 0 .2.1.3.1.2.1.4.1.6 0l1.3-1.4c.2-.1.2-.4 0-.6l-1.3-1.5c-.2-.2-.5-.2-.7-.1l-.5.4C7 14 6.7 13 6.7 12s.3-2 .8-2.8l.5.4z"
      }
    },
    custom76: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12.7 13.3c-.1-.2-.3-.4-.5-.3H12c-2.6 0-4.8-2.2-4.8-4.8V8c0-.2-.3-.3-.4-.1-.2.2-.3.5-.4.8-.4 1.4.1 2.9 1.3 3.7.5.4 1 .6 1.6.7l.2.4c0 .1.1.1.1.2l.7.3c.1 0 .2.2.1.3l-.2.7c0 .1 0 .2.1.3l.4.1c.1.1.2.2.1.3l-.2.8c0 .1 0 .2.1.3l.6.2c.1.1.1.2.1.3l-.2.8c0 .1 0 .2.2.3l1.6.7c.1.1.2 0 .3-.1l.7-1.6c.1-.1.1-.3 0-.4l-1.3-3.7zm6.4-.3l-3.9-4c.2-.6.2-1.2 0-1.9-.5-1.3-1.7-2.2-3-2.3-2.1-.1-3.8 1.7-3.6 3.8.2 1.4 1.3 2.6 2.7 2.9.6.1 1.2 0 1.8-.1l.3.3c.1.1.1.1.2.1h.8c.1 0 .2.1.2.2l.1.8c0 .1.1.2.3.2h.4c.1 0 .2.1.2.2l.1.8c0 .1.1.2.3.2h.6c.1 0 .2.1.2.2l.1.8c0 .1.1.2.3.2H19c.1 0 .2-.1.2-.3v-1.7c0-.2 0-.3-.1-.4zm-7.6-4.1c-.7 0-1.2-.5-1.2-1.2s.5-1.2 1.2-1.2 1.2.5 1.2 1.2c0 .6-.5 1.2-1.2 1.2z"
      }
    },
    custom77: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M7.7 10.1h.9c.2 0 .3-.1.3-.3v-.3c0-1.8 1.3-3.3 3.1-3.3s3.1 1.5 3.1 3.3v.3c0 .2.1.3.3.3h.9c.2 0 .3-.1.3-.3v-.3c0-2.6-2-4.7-4.6-4.7S7.4 6.9 7.4 9.5v.3c0 .2.1.3.3.3zm9.1 1.4H7.4c-.8 0-1.4.7-1.4 1.5v4.8c0 .8.6 1.4 1.4 1.4h9.4c.8 0 1.4-.6 1.4-1.4V13c0-.8-.6-1.5-1.4-1.5zm-3.5 3.9c-.2.3-.4.7-.3 1.1l.2.7c0 .3-.1.6-.4.6h-1.6c-.3 0-.4-.3-.4-.6l.2-.7c.1-.4-.1-.8-.3-1.1-.2-.3-.3-.7-.2-1.1.1-.6.6-1 1.2-1.1 1-.2 1.8.5 1.8 1.4 0 .3-.1.5-.2.8z"
      }
    },
    custom78: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.8 7l-4.3-2.1c-.2-.1-.5-.1-.7 0l-4 2-4-2c-.2-.1-.4-.1-.7 0-.2.1-.3.4-.3.6v10.8c0 .3.1.5.4.7l4.3 2.1c.2.1.5.1.7 0l4-2 4 2c.1.1.2.1.3.1.1 0 .2 0 .4-.1s.3-.4.3-.6V7.7c0-.3-.1-.5-.4-.7zm-1 1.4v5.7c0 .3-.4.6-.7.5-1.1-.5-.2-2.3-1-3.3s-1.7 0-2.7-1.5c-.8-1.4.4-2.4 1.4-2.9.2-.1.3-.1.4 0L17.5 8c.2.1.3.2.3.4zm-6.2 8.4c-.1.1-.3 0-.5-.1-.3-.3-.5-.7-.5-1.1 0-.7-1.2-.5-1.2-1.9 0-1.2-1.5-1.5-2.6-1.4-.3 0-.6-.2-.6-.5V7.5c0-.4.4-.6.7-.5l2.6 1.3c.1 0 .1.1.1.1h.1c1.1.6.9 1.2.4 1.9-.5.9-.7 0-1.4-.2s-1.5.2-1.2.7.9 0 1.4.5.5 1.2 1.9.7 1.7-.2 2.2.2.7 1.5 0 2.2c-.4.4-.6 1.3-.8 1.9-.1.1-.1.3-.2.3l-.4.2z"
      }
    },
    custom79: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M9.4 9.8c-1 0-1.7.8-1.7 1.7s.7 1.7 1.7 1.7 1.6-.7 1.6-1.7-.7-1.7-1.6-1.7zm9.6 5.3h-4.6v-1.9h.5c.2 0 .5-.2.5-.5v-1.4c0-.3-.3-.5-.5-.5h-.6c-.4-2.4-2.4-4.3-4.9-4.3-2.8-.1-5.1 2.3-5.1 5.1.1 2.8 2.4 5 5.2 5h8.7v.4c0 .3.3.5.5.5h.5c.3 0 .5-.2.5-.5v-1.2c0-.4-.3-.7-.7-.7zm-9.6-.5c-1.8 0-3.2-1.4-3.2-3.1s1.4-3.1 3.2-3.1 3.1 1.4 3.1 3.1-1.4 3.1-3.1 3.1z"
      }
    },
    custom8: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M11.3 5.1l-5.8 6.3c-.3.3-.3.9 0 1.2l5.8 6.3c.4.4 1 .4 1.4 0l5.8-6.3c.3-.3.3-.9 0-1.2l-5.8-6.3c-.4-.4-1-.4-1.4 0z"
      }
    },
    custom80: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M7 14.4c-1.4 0-2.4 1.1-2.4 2.4s1 2.4 2.4 2.4 2.4-1.1 2.4-2.4-1.1-2.4-2.4-2.4zm0 3.4c-.6 0-1-.5-1-1s.4-1 1-1 .9.5.9 1-.4 1-.9 1zm10-3.4c-1.3 0-2.4 1.1-2.4 2.4s1.1 2.4 2.4 2.4 2.4-1.1 2.4-2.4-1-2.4-2.4-2.4zm0 3.4c-.5 0-.9-.5-.9-1s.4-1 .9-1 1 .5 1 1-.4 1-1 1zm-.1-4.8c.5-.1 1 0 1.5.2.2.1.5 0 .6-.2 1.3-2.4-.7-3.4-2-4.1-.3-.1-.7.1-.7.5v1.4c0 .2-.2.5-.5.5-1.7-.3-3.3-2.2-5.2-2.2S8.4 11 8.4 11c-1.3 0-2.7-.1-3.3-.2-.3-.1-.5.2-.5.5 0 0 0 1.7 2.4 1.7 1.9 0 3.6 1.4 3.8 3.4 0 .5 0 1-.2 1.5 0 .1.1.3.3.3h2.2c.2 0 .3-.2.3-.3-.2-.5-.2-1-.2-1.5.2-1.8 1.8-3.4 3.7-3.4zM4.6 11.3zm6.3-3.7c0 .2.1.3.3.4l2.6.8c.2.1.4 0 .6-.2l.2-.4c.1-.2-.1-.4-.2-.4-.8-.1-2.3-.4-1.9-1.2.4-.7 1.3-.5 1.8-.3.2.1.5-.1.4-.3-.4-.8-1.2-1.3-2.1-1.2-1.2.1-1.9 1.2-1.8 2.4l.1.4z"
      }
    },
    custom81: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.5 4.8h-1.2c-3.7.2-8 1.1-8.2 1.2-.3.1-.5.4-.5.7v7.8c-.2-.1-.6-.1-.9-.1-1.6 0-2.9 1-2.9 2.4s1.3 2.4 2.9 2.4 2.9-1.1 2.9-2.4v-4.9c0-.3.1-.5.3-.5 1.2-.3 2.8-.6 5.9-.8.3 0 .5.2.5.5v2.5c-.3-.1-.6-.2-1-.2-1.6 0-2.9 1.1-2.9 2.4s1.3 2.4 2.9 2.4 2.9-1.1 2.9-2.4V5.5c0-.4-.3-.7-.7-.7zm-1.7 3.8c-2.9.2-4.4.4-5.7.7-.3.1-.5-.1-.5-.4v-.8c0-.2.1-.4.3-.5 1.3-.3 2.8-.6 5.9-.8.3 0 .5.2.5.5v.8c0 .3-.2.5-.5.5z"
      }
    },
    custom82: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M19.2 10.6h-5c-.3 0-.5.2-.5.4v.3c0 .4-.3.7-.7.7-.4 0-.8-.3-.8-.7V11c0-.2-.2-.4-.4-.4h-1.2c-1.4 0-2.7.8-3.3 2-.3-.1-.5-.1-.8-.1-1.2 0-2.2.9-2.2 2.1s1 2.2 2.2 2.2c.3 0 .5 0 .8-.1.6 1.1 1.9 1.9 3.3 2 2.3.1 4.3-1.7 4.3-4.1v-.4c-.1-.2.1-.5.3-.5l4.1-.9c.2-.1.4-.2.4-.5V11c0-.2-.2-.4-.5-.4zM6.5 15.4c-.4 0-.7-.4-.7-.8s.3-.7.7-.7c.1 0 .2 0 .3.1-.1.3-.1.6-.1.9 0 .1 0 .3.1.4-.1 0-.2.1-.3.1zM13 8.9c.4 0 .7-.3.7-.7V6c0-.4-.3-.7-.7-.7s-.8.3-.8.7v2.2c0 .4.4.7.8.7zm-3.5.2c.2.2.4.3.6.3.1 0 .3-.1.5-.2.3-.3.3-.7 0-1L9.2 6.5c-.3-.3-.7-.3-1-.1-.3.3-.4.8-.1 1l1.4 1.7zm6.3.3c.2 0 .4-.1.6-.3l1.4-1.7c.3-.3.2-.7 0-1-.4-.2-.8-.2-1 .1l-1.5 1.7c-.3.3-.2.8.1 1 .1.1.3.2.4.2z"
      }
    },
    custom83: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.9 9.4c.1.1.2.1.3 0l.4-.3c.8-.8.8-2.1 0-2.9l-1-1c-.8-.7-2-.4-2.6.3l-.4.3c-.1.1-.1.2 0 .3l3.3 3.3zm-4.3-2.2c-.1-.1-.3-.1-.4 0l-6.6 6.5c-.3.4-.6.8-.7 1.3l-1.1 3.2c0 .2 0 .5.1.6.1.3.4.4.6.4h.2s2.2-.7 3.3-1.1c.5-.1.9-.4 1.3-.7l6.6-6.6c.1-.1.1-.2 0-.3l-3.3-3.3zm-5 9.6c-.5.1-1.3.4-2 .6l.6-2c.1-.2.3-.4.5-.6l1.6 1.6c-.2.2-.5.3-.7.4z"
      }
    },
    custom84: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18 15.4H6c-.4 0-.7.3-.7.7s.3.7.7.7h1l.4 2c0 .3.2.4.4.4h7.9c.2 0 .4-.1.5-.4l.4-2H18c.4 0 .7-.3.7-.7s-.3-.7-.7-.7zM7.9 13.9h3.4v-1.3c-.3-.2-.5-.5-.5-.8 0-.6.4-1 1-1s.9.4.9 1c0 .3-.2.6-.5.8v1.3h3.4c.3 0 .5-.2.5-.5v-.7c0-1.4-1.4-1.9-2.5-2.4-.8-.3-.9-.6-.9-.9 0-.3.2-.6.5-.8.4-.4.7-.9.7-1.6 0-1.2-.8-2.2-2.1-2.2-1.4 0-2.2 1-2.2 2.2 0 .7.3 1.2.7 1.6.3.2.5.5.5.8 0 .3-.1.6-.9.9-1.1.5-2.5 1-2.5 2.4v.7c0 .3.3.5.5.5z"
      }
    },
    custom85: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.7 5.8h-12v-.5c0-.3-.2-.5-.5-.5h-.9c-.3 0-.5.2-.5.5v13.4c0 .3.2.5.5.5h.9c.3 0 .5-.2.5-.5v-11h12c.3 0 .5-.2.5-.5v-1c0-.2-.2-.4-.5-.4zm-.9 3.3H9.6c-.8 0-1.4.7-1.4 1.5v5.2c0 .8.6 1.5 1.4 1.5h8.2c.8 0 1.4-.7 1.4-1.5v-5.2c0-.8-.6-1.5-1.4-1.5zm-1.4 4.1h-.6v2.4c0 .1-.1.2-.2.2h-1c-.1 0-.2-.1-.2-.2v-1.4c0-.2-.1-.3-.2-.3h-1c-.1 0-.2.1-.2.3v1.4c0 .1-.1.2-.3.2h-.9c-.2 0-.3-.1-.3-.2v-2.4h-.6c-.1 0-.1-.1-.1-.2l2.7-2.6c.1-.1.3-.1.3 0l2.7 2.6c.1.1.1.2-.1.2z"
      }
    },
    custom86: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M9.1 7.2h1c.1 0 .2-.1.2-.2v-.8h3.4V7c0 .1.1.2.2.2h1c.1 0 .2-.1.2-.2v-.8c0-.8-.6-1.4-1.4-1.4h-3.4c-.8 0-1.4.6-1.4 1.4V7c0 .1.1.2.2.2zm8.7 1.4H6.2c-.8 0-1.4.7-1.4 1.5v7.7c0 .8.6 1.4 1.4 1.4h11.6c.8 0 1.4-.6 1.4-1.4v-7.7c0-.8-.6-1.5-1.4-1.5zM12 17.3c-1.8 0-3.4-1.5-3.4-3.4s1.6-3.3 3.4-3.3 3.4 1.5 3.4 3.3-1.6 3.4-3.4 3.4zm1.4-4.1h-.7v-.7c0-.3-.2-.5-.5-.5h-.4c-.3 0-.5.2-.5.5v.7h-.7c-.3 0-.5.2-.5.5v.5c0 .2.2.4.5.4h.7v.8c0 .2.2.4.5.4h.4c.3 0 .5-.2.5-.4v-.8h.7c.3 0 .5-.2.5-.4v-.5c0-.3-.2-.5-.5-.5z"
      }
    },
    custom87: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18 4.8H6c-.4 0-.7.3-.7.7V17c0 .4.3.8.7.8h.2v.7c0 .4.4.7.8.7h.4c.4 0 .8-.3.8-.7v-.7h7.6v.7c0 .4.4.7.8.7h.4c.4 0 .8-.3.8-.7v-.7h.2c.4 0 .7-.4.7-.8V5.5c0-.4-.3-.7-.7-.7zM7.4 16.3c-.4 0-.7-.3-.7-.7V7c0-.4.3-.8.7-.8h9.2c.4 0 .7.4.7.8v8.6c0 .4-.3.7-.7.7H7.4zm8-8.6H8.6c-.2 0-.4.2-.4.5v6.2c0 .3.2.5.4.5h6.8c.2 0 .4-.2.4-.5V8.2c0-.3-.2-.5-.4-.5zM14.2 12h-2c-.2.5-.8 1-1.4 1-1 0-1.7-.8-1.7-1.7s.7-1.7 1.7-1.7c.6 0 1.2.5 1.4 1h2c.4 0 .7.3.7.7s-.3.7-.7.7z"
      }
    },
    custom88: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.7 16.8H5.3c-.3 0-.5.2-.5.4v.1c0 1 1.3 1.9 2.4 1.9h9.6c1.1 0 2.4-.9 2.4-1.9v-.1c0-.2-.2-.4-.5-.4zM5.5 15.4h4.3c.3 0 .5-.3.5-.6V6.6c0-.1-.1-.2-.2-.1L5.3 15c-.1.1 0 .4.2.4zm6.7 0h6c.3 0 .5-.3.5-.6-.2-1.7-.5-7.1-6.6-10-.1 0-.3 0-.3.2v9.8c0 .3.2.6.4.6z"
      }
    },
    custom89: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M13.9 10.4c-.1-.1-.3-.1-.4.1-.3.4-.5 1-.5 1.7v2.7c0 .4-.4.7-.8.7-.3 0-.7-.3-.7-.7V6.7c0-1.9-1.6-2.2-2.8-1.7-.3.1-.6.3-.8.5-.1.2-.3.3-.5.4-.4.1-1.2-.3-1.6-.5-.2-.1-.5-.1-.6.1l-.3.4c-.2.2-.1.6.1.7.5.3 1.2.8 1.7.9.9.1 1.7-.2 2.3-.7.1-.2.4-.4.6-.1.5.7-1.4 3.8-1.4 8.4v.4c0 1.9 1.9 3.6 3.9 3.7 2 .1 3.7-1.5 3.7-3.6 0-1 .4-1.7.8-2.1.1-.1.1-.2 0-.3l-2.7-2.8zm4.6 2.3c-.2 0-.4-.1-.5-.2l-3.9-3.8c-.3-.3-.3-.8 0-1 .3-.3.8-.3 1 0l3.9 3.8c.3.3.3.7 0 1-.2.1-.3.2-.5.2z"
      }
    },
    custom9: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M14.9 4.8h-4.1c-.6 0-1.1.4-1.3.9L7 12.2c-.2.5.1 1 .6 1h4.2l-1.6 5.4c-.1.5.5.8.8.4l6.4-7.5c.4-.4 0-1.2-.6-1.2h-3.1l2.7-4.4c.3-.5 0-1.1-.6-1.1h-.9z"
      }
    },
    custom90: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.6 6.2l-5.9.9v8.3c0 .1-.1.2-.2.2h-1c-.1 0-.2-.1-.2-.2V7.3l-5.7.9h-.1c-.3 0-.7-.3-.7-.7 0-.3.2-.7.6-.8L9.9 6c.4-.7 1.2-1.2 2.1-1.2.6 0 1.2.2 1.7.7l4.7-.7c.4 0 .8.2.8.6 0 .4-.2.8-.6.8zm-8.7 8.9c.2-.2.2-.5.1-.7L8.1 9.8c-.1-.3-.4-.4-.7-.4s-.5.1-.6.4l-2 4.6c0 .2 0 .4.1.6 0 .1 1 1.5 2.5 1.5.9 0 1.7-.4 2.5-1.4zm-2.5-3.2l1.1 2.5H6.4l1-2.5zm9.8-3.5c-.1-.3-.4-.5-.6-.5s-.6.2-.7.5L14 12.9c-.1.2-.1.5 0 .7.1.1 1 1.5 2.5 1.5.9 0 1.7-.5 2.5-1.4.2-.3.2-.5.1-.8l-1.9-4.5zm-.6 2.1l1 2.5h-2.1l1.1-2.5zM12 17c-1.3 0-2.7.5-3.7 1.3-.1.1-.1.3-.1.4 0 .3.2.5.4.5h6.8c.2 0 .4-.2.4-.5 0-.1 0-.3-.1-.4-1-.8-2.4-1.3-3.7-1.3z"
      }
    },
    custom91: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.7 7.8c-.7-.2-1.4-.7-1.8-1.3-.3-.5-.3-1.7-1.1-1.7H8.2c-.8 0-.8 1.2-1.1 1.7-.5.7-1.2.9-1.9 1.4-.8.5-.1 2.4.1 3 .7 2.7 2.1 5.2 4.3 6.9.7.5 1.3 1 2.1 1.3.6.4 1.7-.6 2.2-.9 1.2-.9 2.3-2 3.1-3.3.7-1.1 1.2-2.3 1.6-3.6.1-.5.3-1 .4-1.5.1-.4.3-1.1.1-1.5 0-.2-.2-.4-.4-.5-1.1-.3.3.1 0 0zm-1.1 1.7c-.6 3.2-2.4 6.2-5.2 8l-.4.2-.4-.2c-3.4-2.1-4.7-5.5-5.2-8L6.3 9l.4-.3c.8-.4 1.5-1.2 1.9-2.1l.2-.4h6.4l.2.3c.4.9 1.1 1.8 2 2.3l.3.2-.1.5zm-5.9-1.8c-.5 0-1.9 0-2.1.2-.5.4-.7 1-1.2 1.4-.5.5-.3.9-.1 1.5.3 1 .8 2 1.4 2.9.3.4.7.8 1.1 1.2.1.1 1.2 1.3 1.2.6V8.2c0-.3 0-.5-.3-.5z"
      }
    },
    custom92: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.7 13.5L12.2 11h-.4l-5.5 2.5c-.3.2-.4.5-.2.8.6.8.9 1.9 1.1 2.4 0 .2.2.3.4.3 1.9.5 3.4 1.6 4.1 2.1.2.1.4.1.6 0 .7-.5 2.2-1.6 4.1-2.1.2 0 .4-.1.4-.3.1-.5.5-1.6 1.1-2.4.2-.2.1-.6-.2-.8zm-7.1 1.4c-.4 0-.8-.5-.8-1s.4-.9.8-.9.7.4.7.9-.3 1-.7 1zm2.8 0c-.4 0-.7-.5-.7-1s.3-.9.7-.9.8.4.8.9-.4 1-.8 1zm-5.1-3.8l2.9-1.4c.3-.1.7-.2 1.1-.1.2 0 .4.1.5.1l2.9 1.4c.2.1.4-.1.4-.2V9.8c0-.1-.1-.2-.2-.3-.2-.3-.5-.6-1.3-.6V7.5c0-.2-.1-.4-.2-.4-.3-.2-.7-.4-1.4-.5V5.3c0-.3-.3-.5-.5-.5h-1c-.2 0-.5.2-.5.5v1.3c-.7.1-1.1.3-1.4.5-.1 0-.2.2-.2.4v1.4c-.8 0-1.1.3-1.3.5-.1.1-.2.2-.2.4v1c0 .2.2.3.4.3z"
      }
    },
    custom93: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": {
          "d": "M10.2 12h7.1c.2 0 .4-.1.4-.4L19 7.1c.1-.3-.1-.6-.4-.6h-11l-.2-.7c-.1-.3-.4-.5-.7-.5H5.6c-.4 0-.8.3-.8.7 0 .4.3.7.7.7h.7l2.2 7.7c.1.3.4.5.7.5h8.4c.4 0 .7-.3.8-.7 0-.4-.3-.8-.8-.8h-7.3c-.3 0-.6-.2-.7-.5-.1-.4.2-.9.7-.9z"
        },
        "circle": [{
          "cx": "10.32",
          "cy": "17.52",
          "r": "1.2"
        }, {
          "cx": "16.08",
          "cy": "17.52",
          "r": "1.2"
        }]
      }
    },
    custom94: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M13.4 9.1V5.5c0-.4-.3-.7-.7-.7h-.9c-.4 0-.8.3-.8.7s.4.7.8.7h.2v2.9c0 1.6-1.3 2.9-2.9 2.9s-2.9-1.3-2.9-2.9V6.2h.3c.4 0 .7-.3.7-.7s-.3-.7-.7-.7h-1c-.4 0-.7.3-.7.7v3.6c0 2.4 1.9 4.3 4.3 4.3s4.3-1.9 4.3-4.3zm5.8 2.9c0-1.2-1-2.2-2.2-2.2s-2.1 1-2.1 2.2c0 .9.6 1.7 1.4 2v.6c0 1.7-1.4 3.2-3.2 3.2-1.6 0-2.8-1.1-3.2-2.5 0-.3-.2-.4-.4-.4H9c-.3 0-.6.3-.5.6.4 2.1 2.3 3.7 4.5 3.7h.1c2.6 0 4.7-2.1 4.7-4.6V14c.8-.3 1.4-1.1 1.4-2zm-2.2.7c-.4 0-.7-.3-.7-.7s.3-.7.7-.7.8.3.8.7-.4.7-.8.7z"
      }
    },
    custom95: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12.7 7.2v-1h.3c.3 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-2c-.3 0-.7.3-.7.7 0 .4.3.7.7.7h.3v1c-3 .4-5.3 2.9-5.3 6 0 3.3 2.7 6 6 6s6-2.7 6-6c0-3.1-2.3-5.6-5.3-6zM12 17.8c-2.5 0-4.6-2.1-4.6-4.6S9.5 8.6 12 8.6s4.6 2.1 4.6 4.6-2.1 4.6-4.6 4.6zm1.6-7l-1.1 1.1c-.2-.1-.3-.1-.5-.1-.8 0-1.4.6-1.4 1.4s.6 1.4 1.4 1.4 1.4-.6 1.4-1.4c0-.2 0-.3-.1-.5l1.1-1.1c.3-.2.3-.6 0-.8-.2-.3-.6-.3-.8 0z"
      }
    },
    custom96: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M19.1 6.9L17.8 6c-.2-.2-.4-.2-.6-.2H13v-.5c0-.3-.3-.5-.5-.5h-1c-.2 0-.5.2-.5.5v.5H6.2c-.2 0-.4.2-.4.4v2c0 .2.2.4.4.4h11c.2 0 .4 0 .6-.2l1.2-.9c.2-.2.2-.4.1-.6zM17.8 11H13v-.7c0-.1-.1-.2-.3-.2h-1.4c-.2 0-.3.1-.3.2v.7H6.8c-.2 0-.4.1-.6.2l-1.2 1c-.2.1-.2.4 0 .6l1.2.9c.2.1.4.2.6.2h11c.2 0 .4-.2.4-.5v-1.9c0-.2-.2-.5-.4-.5zM13 17.2v-1.6c0-.1-.1-.2-.3-.2h-1.4c-.2 0-.3.1-.3.2v1.6c-.9.2-1.4.8-1.6 1.5-.1.3.1.5.3.5h4.6c.2 0 .4-.2.3-.5-.2-.7-.7-1.3-1.6-1.5z"
      }
    },
    custom97: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M14.4 13.1V7c0-1.5-1.2-2.7-2.6-2.7h-.1c-1.4 0-2.6 1.2-2.6 2.7v6.1c-.7.7-1.2 1.7-1.2 2.7 0 2.2 1.7 3.9 3.9 3.9s3.8-1.7 3.8-3.9c0-1-.4-2-1.2-2.7zm-.6 2.7H9.7c-.2 0-.3-.2-.3-.4.1-.6.4-1.1.8-1.4.2-.2.3-.4.3-.6V7c0-.7.6-1.2 1.2-1.2h.1c.6 0 1.1.5 1.1 1.2v.2h-.7c-.4 0-.7.3-.7.7s.3.7.7.7h.7v1h-.7c-.4 0-.7.3-.7.7s.3.7.7.7h.7v1h-.7c-.4 0-.7.3-.7.7s.3.7.7.7h.7c.1.3.2.4.3.6.5.3.8.9.9 1.4.1.2-.1.4-.3.4z"
      }
    },
    custom98: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "path": [{
          "d": "M19.5 11.1l-1.8-1.8c-.1-.1-.3-.2-.4-.2h-1.9c-.3 0-.5.2-.5.5v3.8c0 .2.1.3.3.3.4-.2.7-.3 1.1-.3 1.1 0 2 .6 2.5 1.5.1.1.3.2.4.1.3-.3.5-.6.5-1.1v-2.4c0-.1-.1-.3-.2-.4z"
        }, {
          "d": "M13 7H4.8c-.3 0-.5.2-.5.4v6.5c0 .5.2.8.5 1.1.1.1.3.1.4-.1.4-.9 1.4-1.5 2.5-1.5 1.2 0 2.2.8 2.6 1.8.1.1.2.2.3.2H12c.8 0 1.4-.7 1.4-1.5V7.4c0-.2-.2-.4-.4-.4z"
        }],
        "circle": [{
          "cx": "16.32",
          "cy": "16.32",
          "r": "1.44"
        }, {
          "cx": "7.68",
          "cy": "16.32",
          "r": "1.44"
        }]
      }
    },
    custom99: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.8 8.6h-4.1c-.1-.2-.3-.5-.5-.7L14.7 6c.3-.4.2-.8-.1-1.1s-.8-.1-1 .2l-1.7 2.1h-.8L9.5 5.1c-.3-.3-.7-.4-1.1-.2-.3.3-.3.7-.1 1.1l1.5 1.9c-.2.2-.3.5-.5.7H6.2c-.8 0-1.4.7-1.4 1.5v6.7c0 .8.6 1.4 1.4 1.4h11.6c.8 0 1.4-.6 1.4-1.4v-6.7c0-.8-.6-1.5-1.4-1.5zm-2 7.7c0 .3-.2.5-.4.5H6.7c-.2 0-.5-.2-.5-.5v-5.7c0-.3.3-.5.5-.5h8.7c.2 0 .4.2.4.5v5.7zm1.7-2.4c-.4 0-.7-.3-.7-.7s.3-.7.7-.7.7.3.7.7-.3.7-.7.7zm0-2.4c-.4 0-.7-.3-.7-.7s.3-.7.7-.7.7.3.7.7-.3.7-.7.7z"
      }
    },
    viewBox: '0 0 24 24'
  };
}

/* harmony default export */ __webpack_exports__["a"] = (icons);

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
var icons = {};

if (false) {
  icons = {
    ai: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#FFC35E"
      }, {
        "d": "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#FFB446"
      }, {
        "d": "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
        "opacity": ".5",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#fff"
      }, {
        "d": "M9.1 20.2c-.2 0-.3 0-.3-.2l-.4-.8H6.2l-.3.8c-.1.2-.2.2-.3.2-.2 0-.3-.1-.3-.3v-.1l1.6-3.9c0-.1.2-.3.4-.3s.4.2.5.3l1.5 3.9c0 .1.1.1.1.1 0 .2-.2.3-.3.3zm-1.8-3.9l-.9 2.4h1.9l-1-2.4zm3.2 3.9c-.1 0-.3-.1-.3-.3v-4c0-.1.2-.3.3-.3.2 0 .3.2.3.3v4c0 .2-.1.3-.3.3z",
        "fill": "#fff"
      }]
    },
    attachment: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M3.4 0c-1 0-1.9.8-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
          "fill": "#8199AF"
        }, {
          "d": "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
          "fill": "#617F9B"
        }, {
          "d": "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
          "opacity": ".5",
          "fill": "#fff"
        }]
      },
      "path": {
        "d": "M11.5 15.6c.4-.5.4-1.2 0-1.6s-1.1-.4-1.6 0l-3.4 3.4c-.4.5-.4 1.2 0 1.6s1.1.4 1.5 0l2.1-2.1c.2-.1.2-.3 0-.5s-.3-.1-.4 0l-1.3 1.4c-.2.2-.5.2-.7 0-.2-.2-.2-.5 0-.7L9 15.8c.5-.5 1.3-.5 1.8 0s.5 1.3 0 1.7l-2.1 2.2c-.8.7-2.1.7-2.9 0-.8-.8-.8-2.1 0-2.9l3.5-3.5c.8-.8 2-.8 2.8 0 .8.8.8 2.1 0 2.9l-.3.4c0-.4-.1-.7-.4-1l.1-.1z",
        "fill": "#fff"
      }
    },
    audio: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
          "fill": "#379FD3"
        }, {
          "d": "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.3 2.1h4.8z",
          "fill": "#2987C8"
        }, {
          "d": "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
          "opacity": ".5",
          "fill": "#fff"
        }, {
          "d": "M12.7 12.8l-5.3.6v5.1c-.3-.1-.6-.1-1 0-.7.1-1.2.6-1.1 1.1.2.4.9.7 1.6.5.7-.1 1.2-.5 1.2-.9v-4l3.9-.5v3.1c-.3-.1-.6-.1-1 0-.8.1-1.3.6-1.1 1.1.1.4.9.7 1.6.5.7-.1 1.2-.5 1.2-1v-5.6z",
          "fill": "#fff"
        }]
      }
    },
    box_notes: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "fill": "#277A84",
        "d": "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z"
      }, {
        "fill": "#1E5B60",
        "d": "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z"
      }, {
        "opacity": ".5",
        "fill": "#fff",
        "d": "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z"
      }, {
        "fill": "#fff",
        "d": "M11.7 14.8l.8-.8H5.4s-.1 0-.1.1v.5c0 .1.1.1.1.1h6.3zm-2.8 2.7l.8-.8H5.4s-.1 0-.1.1v.5l.1.2h3.5zM7 20.2l.1-.8H5.4s-.1 0-.1.2v.5c0 .1.1.1.1.1H7zm.3 0h.8c.1-.1.2-.1.2-.1l4.9-5s-.2.2-.6-.2c-.3-.3-.2-.5-.2-.5l-4.8 4.8c-.1.1-.1.2-.1.2 0 .1-.2.8-.2.8zm5.7-6.4l-.4.4v.2c0 .1.2.5.6.6 0 0 .1 0 .2-.1.1 0 .4-.4.4-.4s.1 0 0-.2c0-.2-.3-.5-.6-.6-.1 0-.2.1-.2.1z"
      }]
    },
    csv: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#45B058"
      }, {
        "d": "M9.1 16.2c.1.1.1.1.1.2s-.1.3-.3.3c0 0-.1-.1-.2-.1-.2-.3-.7-.5-1.1-.5-1 0-1.7.7-1.7 1.8s.7 1.8 1.7 1.8c.4 0 .9-.2 1.1-.5.1-.1.2-.1.2-.1.2 0 .3.2.3.3 0 .1 0 .1-.1.2-.3.3-.8.6-1.5.6-1.3 0-2.3-.9-2.3-2.3s1-2.3 2.3-2.3c.7 0 1.2.2 1.5.6zm2.6 4c-.7 0-1.2-.2-1.6-.5-.1-.1-.1-.2-.1-.2 0-.2.1-.3.3-.3h.1c.3.3.8.5 1.3.5.8 0 1-.4 1-.8 0-1.1-2.6-.5-2.6-2.1 0-.7.6-1.2 1.5-1.2.6 0 1.1.1 1.5.4 0 .1.1.2.1.2 0 .2-.2.3-.3.3h-.2c-.3-.3-.7-.4-1.1-.4-.6 0-.9.3-.9.7 0 1 2.6.4 2.6 2.1 0 .6-.4 1.3-1.6 1.3zM18 16l-1.5 3.9c-.1.2-.3.3-.5.3s-.4-.1-.4-.3L14 16v-.1c0-.1.1-.3.3-.3.1 0 .2.1.3.2l1.4 3.7 1.5-3.7c0-.1.1-.2.3-.2.1 0 .3.1.3.3 0 0 0 .1-.1.1z",
        "fill": "#fff"
      }],
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.3 2.1h4.8z",
          "fill": "#349C42"
        }, {
          "d": "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
          "opacity": ".5",
          "fill": "#fff"
        }]
      }
    },
    eps: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#FFC35E"
      }, {
        "d": "M8 20.2H5.7c-.2 0-.4-.2-.4-.4v-3.7c0-.2.2-.4.4-.4H8c.2 0 .3.1.3.3 0 .1-.1.2-.3.2H5.9v1.5H8c.1 0 .2.1.2.2 0 .2-.1.3-.2.3H5.9v1.5H8c.2 0 .3.1.3.3 0 .1-.1.2-.3.2zm3.1-1.8H9.9V20c0 .1-.2.3-.3.3-.2 0-.3-.2-.3-.3v-3.9c0-.2.2-.4.4-.4h1.4c.9 0 1.4.6 1.4 1.4 0 .7-.5 1.3-1.4 1.3zm-.1-2.2H9.9v1.7H11c.6 0 .9-.3.9-.8s-.3-.9-.9-.9zm3.9 4.1c-.7 0-1.2-.2-1.6-.6 0 0-.1-.1-.1-.2s.1-.2.3-.2h.2c.3.3.7.5 1.2.5.8 0 1.1-.4 1.1-.8 0-1.1-2.7-.5-2.7-2.1 0-.7.7-1.3 1.6-1.3.5 0 1 .2 1.4.5.1.1.1.2.1.2 0 .2-.1.3-.3.3 0 0-.1 0-.1-.1-.4-.2-.8-.4-1.2-.4-.5 0-.9.3-.9.8 0 1 2.7.4 2.7 2.1 0 .6-.5 1.3-1.7 1.3z",
        "fill": "#fff"
      }],
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M22.5 7.6V8h-4.8c-.9 0-2.4-.5-2.3-2.5 0 0 .1 2.1 2.3 2.1h4.8z",
          "fill": "#FFB446"
        }, {
          "d": "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
          "opacity": ".5",
          "fill": "#fff"
        }]
      }
    },
    excel: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#45B058"
      }, {
        "d": "M8.8 20.2c-.1 0-.2 0-.2-.1l-1.4-1.8-1.4 1.8c-.1.1-.1.1-.2.1-.2 0-.3-.1-.3-.2s0-.2.1-.2l1.4-1.9-1.3-1.8c-.1-.1-.1-.1-.1-.2s.1-.3.3-.3c.1 0 .1.1.2.1l1.3 1.8 1.3-1.8s.1-.1.2-.1.3.2.3.3c0 .1-.1.1-.1.2l-1.3 1.8L9 19.8l.1.1c0 .2-.2.3-.3.3zm3.7 0h-2c-.2 0-.4-.2-.4-.4v-3.9c0-.1.1-.3.3-.3.1 0 .2.2.2.3v3.8h1.9c.2 0 .3.1.3.2 0 .2-.1.3-.3.3zm2.6.1c-.6 0-1.1-.3-1.5-.6-.1-.1-.1-.1-.1-.2s.1-.3.2-.3.2 0 .2.1c.3.2.8.5 1.3.5.8 0 1-.5 1-.8 0-1.2-2.6-.5-2.6-2.1 0-.8.6-1.3 1.5-1.3.6 0 1.1.2 1.5.5v.2c0 .1-.1.3-.2.3s-.1-.1-.2-.1c-.3-.3-.7-.4-1.1-.4-.6 0-1 .3-1 .7 0 1 2.7.5 2.7 2.1 0 .7-.4 1.4-1.6 1.4z",
        "fill": "#fff"
      }, {
        "d": "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#349C42"
      }, {
        "d": "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
        "opacity": ".5",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#fff"
      }]
    },
    exe: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1.1.9 1.9 1.9 1.9h17.2c1 0 1.9-.8 1.9-1.9V7.6L15.4 0h-12z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#8199AF"
      }, {
        "d": "M8 20.2H5.7c-.2 0-.4-.2-.4-.4v-3.7c0-.2.2-.4.4-.4H8c.2 0 .3.1.3.3 0 .1-.1.2-.3.2H5.9v1.5H8c.1 0 .2.1.2.2 0 .2-.1.3-.2.3H5.9v1.5H8c.2 0 .3.1.3.3 0 .1-.1.2-.3.2zm4.6.1c-.1 0-.2-.1-.2-.1L11 18.3l-1.4 1.9c-.1 0-.1.1-.2.1-.2 0-.3-.1-.3-.3 0-.1 0-.1.1-.2l1.4-1.9-1.3-1.8c-.1 0-.1-.1-.1-.2s.1-.2.3-.2c.1 0 .1 0 .2.1l1.3 1.7 1.3-1.7c0-.1.1-.1.2-.1s.2.1.2.2v.2l-1.4 1.8 1.5 1.9c0 .1.1.1.1.2s-.2.3-.3.3zm4-.1h-2.3c-.2 0-.4-.2-.4-.4v-3.7c0-.2.2-.4.4-.4h2.3c.2 0 .3.1.3.3 0 .1-.1.2-.3.2h-2.2v1.5h2.2c.1 0 .2.1.2.2 0 .2-.1.3-.2.3h-2.2v1.5h2.2c.2 0 .3.1.3.3 0 .1-.1.2-.3.2z",
        "fill": "#fff"
      }],
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
          "fill": "#617F9B"
        }, {
          "d": "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
          "opacity": ".5",
          "fill": "#fff"
        }]
      }
    },
    flash: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#E53C3C"
      }, {
        "d": "M8 16.2H5.9v1.4H8c.1 0 .2.1.2.3 0 .1-.1.2-.2.2H5.9v1.8c0 .2-.2.3-.3.3-.2 0-.3-.1-.3-.3v-3.8c0-.3.2-.4.4-.4h2.4c.1 0 .2.1.2.2 0 .2-.1.3-.3.3zm3.6 4h-2c-.2 0-.4-.2-.4-.4v-3.9c0-.2.1-.3.3-.3.1 0 .2.1.2.3v3.8h1.9c.2 0 .3.1.3.2 0 .2-.1.3-.3.3zm4.6 0c-.1 0-.2-.1-.3-.2l-.3-.8h-2.2l-.4.8c0 .1-.1.2-.2.2-.2 0-.3-.1-.3-.3v-.1l1.5-3.9c.1-.2.3-.3.5-.3s.4.1.4.3l1.6 3.9v.1c0 .1-.1.3-.3.3zm-1.7-4l-1 2.5h1.9l-.9-2.5z",
        "fill": "#fff"
      }],
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
          "fill": "#DE2D2D"
        }, {
          "d": "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
          "opacity": ".5",
          "fill": "#fff"
        }]
      }
    },
    folder: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M20.8 5.8a1.7 1.7 0 0 1 1.7 1.7v11.6a1.7 1.7 0 0 1-1.7 1.7H3.2a1.7 1.7 0 0 1-1.7-1.7V4.9a1.7 1.7 0 0 1 1.7-1.7h4.3c1.4 0 1.6.4 2.5 1.7.8 1 2.7.9 3.9.9z",
        "fill": "#003462"
      }, {
        "d": "M20.8 6.8H5a1.7 1.7 0 0 0-1.7 1.7v1.1l1.6-2.5h15.9l1.7 2.5V8.5a1.7 1.7 0 0 0-1.7-1.7z",
        "fill": "#87c8f2"
      }, {
        "d": "M3.2 20.8h17.6a1.7 1.7 0 0 0 1.7-1.7V8.8a1.7 1.7 0 0 0-1.7-1.7H5a1.7 1.7 0 0 0-1.7 1.7v10.3a1.7 1.7 0 0 1 0 .3.9.9 0 0 1-1.8 0 1.7 1.7 0 0 0 1.7 1.4z",
        "fill": "#00a1e0"
      }]
    },
    gdoc: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#3C8CEA"
      }, {
        "d": "M5.3 14h8.1v.8H5.3zm0 1.8h8.1v.8H5.3zm0 1.8h8.1v.8H5.3zm0 1.8h4.6v.8H5.3z",
        "fill": "#fff"
      }],
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
          "fill": "#2D6FE4"
        }, {
          "d": "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
          "opacity": ".5",
          "fill": "#fff"
        }]
      }
    },
    gdocs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
          "fill": "#3C8CEA"
        }, {
          "d": "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
          "fill": "#2D6FE4"
        }, {
          "d": "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
          "opacity": ".5",
          "fill": "#fff"
        }, {
          "d": "M11 19.8l-1.2.3c-.5.1-.9.1-1.3.1-2.3 0-3.2-1.7-3.2-3 0-1.6 1.2-3.1 3.4-3.1.4 0 .8.1 1.2.2.6.2.9.4 1.1.5l-.7.7H10l.2-.3c-.2-.3-.8-.8-1.7-.8-1.3 0-2.3 1-2.3 2.5s1.1 3 2.9 3c.5 0 .8-.1 1.1-.2v-1.4l-1.3.1.7-.3h1.7l-.2.2-.1.1v1.4z",
          "fill": "#fff"
        }]
      }
    },
    gform: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "fill": "#673AB7",
        "d": "M3.4 0c-1 0-1.9.8-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z"
      }, {
        "fill": "#45317C",
        "d": "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z"
      }, {
        "opacity": ".5",
        "fill": "#fff",
        "d": "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z"
      }, {
        "fill": "#fff",
        "d": "M6.3 14.8c0-.2-.1-.3-.3-.3h-.5c-.1 0-.2.1-.2.3v.5c0 .1.1.2.2.2H6c.2 0 .3-.1.3-.2v-.5zm7 0c0-.2-.1-.3-.2-.3H7.2c-.2 0-.3.1-.3.3v.5c0 .1.1.2.3.2h5.9c.1 0 .2-.1.2-.2v-.5zm-7 2.3c0-.1-.1-.2-.3-.2h-.5c-.1 0-.2.1-.2.2v.5c0 .2.1.3.2.3H6c.2 0 .3-.1.3-.3v-.5zm7 0c0-.1-.1-.2-.3-.2H7.2c-.1 0-.3.1-.3.2v.5c0 .2.2.3.3.3H13c.2 0 .3-.1.3-.3v-.5zm-7 2.4c0-.2-.1-.3-.3-.3h-.5c-.1 0-.2.1-.2.3v.5c0 .1.1.2.2.2H6c.2 0 .3-.1.3-.2v-.5zm7 0c0-.2-.1-.3-.2-.3H7.2c-.2 0-.3.1-.3.3v.5c0 .1.1.2.3.2h5.9c.1 0 .2-.1.2-.2v-.5z"
      }]
    },
    gpres: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#F8BE46"
      }, {
        "d": "M5.3 14v4.5H10V14H5.3zm4.2 3.7H5.7v-2.8h3.8v2.8zm.3-2v.9h3.1v2.8H9.1v-1.1h-.4v1.9h4.7v-4.5H9.8z",
        "fill": "#fff"
      }],
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
          "fill": "#F6AD34"
        }, {
          "d": "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
          "opacity": ".5",
          "fill": "#fff"
        }]
      }
    },
    gsheet: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#20A971"
      }, {
        "d": "M5.3 14v6.2h8.1V14H5.3zm2.4 5.7H5.8v-1.3h1.9v1.3zm0-1.9H5.8v-1.3h1.9v1.3zm0-1.9H5.8v-1.3h1.9v1.3zm5.1 3.8H8.3v-1.3h4.5v1.3zm0-1.9H8.3v-1.3h4.5v1.3zm0-1.9H8.3v-1.3h4.5v1.3z",
        "fill": "#fff"
      }],
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
          "fill": "#189355"
        }, {
          "d": "M15.4 0v5.4c0 .7.4 2.2 2.3 2.2h4.8L15.4 0z",
          "opacity": ".5",
          "fill": "#fff"
        }]
      }
    },
    html: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#F7622C"
      }, {
        "d": "M8.6 19.1s-.1 0-.1-.1l-2.9-1.2c-.1-.1-.3-.3-.3-.5s.2-.4.3-.5l2.9-1.2c0-.1.1-.1.1-.1.2 0 .3.2.3.4 0 .1 0 .2-.2.3l-2.6 1.1 2.6 1.1c.2.1.2.2.2.3 0 .2-.1.4-.3.4zm3.2-4.2l-1.7 5c0 .2-.2.2-.3.2-.2 0-.4-.1-.4-.3 0 0 0-.1.1-.1l1.6-5c.1-.1.2-.2.4-.2s.3.1.3.3v.1zm3.8 2.9L12.8 19c-.1.1-.1.1-.2.1s-.3-.2-.3-.4c0-.1.1-.2.2-.3l2.6-1.1-2.6-1.1c-.1-.1-.2-.2-.2-.3 0-.2.2-.4.3-.4.1 0 .1 0 .2.1l2.8 1.2c.2.1.3.3.3.5s-.1.4-.3.5z",
        "fill": "#fff"
      }],
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
          "fill": "#F54921"
        }, {
          "d": "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
          "opacity": ".5",
          "fill": "#fff"
        }]
      }
    },
    image: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1.1.9 1.9 1.9 1.9h17.2c1 0 1.9-.8 1.9-1.9V7.6L15.4 0h-12z",
          "fill": "#49C9A7"
        }, {
          "d": "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
          "fill": "#37BB91"
        }, {
          "d": "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
          "opacity": ".5",
          "fill": "#fff"
        }]
      },
      "path": {
        "d": "M5.3 20.2v-7.9h7.8v7.9H5.3zm7-7.1H6.1v4.7h6.2v-4.7zm-3.5 3.1l1.4-1.9.5.8.5-.2.4 2.1H6.7L8 15.8l.8.4zm-1.5-1.3c-.3 0-.6-.3-.6-.6s.3-.6.6-.6.6.3.6.6-.3.6-.6.6z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#fff"
      }
    },
    keynote: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#DB7A2A"
      }, {
        "d": "M8.2 20.3c-.1 0-.2-.1-.2-.1l-1.7-2-.4.5V20c0 .1-.2.2-.3.2-.2 0-.3-.1-.3-.2v-4.1c0-.1.1-.2.3-.2.1 0 .3.1.3.2V18l1.9-2.2c.1-.1.1-.1.2-.1.2 0 .3.1.3.2s0 .1-.1.2l-1.5 1.7 1.7 2c0 .1.1.1.1.2s-.2.3-.3.3zm4.1-.1H9.9c-.2 0-.4-.2-.4-.4v-3.7c0-.2.2-.4.4-.4h2.4c.1 0 .2.1.2.3 0 .1-.1.2-.2.2h-2.2v1.5h2.1c.2 0 .3.1.3.2s-.1.3-.3.3h-2.1v1.5h2.2c.1 0 .2.1.2.3 0 .1-.1.2-.2.2zm4.6-4.1l-1.5 2.2V20c0 .1-.1.2-.3.2-.1 0-.3-.1-.3-.2v-1.7l-1.5-2.2v-.2c0-.1.1-.2.3-.2 0 0 .1 0 .2.1l1.3 2 1.4-2c0-.1.1-.1.2-.1s.3.1.3.2-.1.1-.1.2z",
        "fill": "#fff"
      }],
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
          "fill": "#D25B1F"
        }, {
          "d": "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
          "opacity": ".5",
          "fill": "#fff"
        }]
      }
    },
    library_folder: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "fill": "#003462",
        "d": "M20.8 5.8c1 0 1.7.8 1.7 1.7v11.6c0 1-.7 1.7-1.7 1.7H3.2c-.9 0-1.7-.7-1.7-1.7V4.9c0-1 .8-1.7 1.7-1.7h4.3c1.4 0 1.6.4 2.5 1.7.8 1 2.7.9 3.9.9h6.9z"
      }, {
        "fill": "#87C8F2",
        "d": "M20.8 6.8H4.9c-.9 0-1.6.7-1.6 1.7v1.1l1.6-2.5h15.9l1.7 2.5V8.5c0-1-.7-1.7-1.7-1.7z"
      }, {
        "fill": "#00A1E0",
        "d": "M3.2 20.8h17.6c1 0 1.7-.7 1.7-1.7V8.8c0-.9-.7-1.7-1.7-1.7H5c-.9 0-1.7.7-1.7 1.7v10.6c0 .5-.4.9-.9.9s-.9-.4-.9-.9c.2.8.9 1.4 1.7 1.4z"
      }, {
        "d": "M11.1 14.2h1.3v4.3h-1.3zm2.3 0h1.3v4.3h-1.3zm5.5-2.3l-5.6-2.3c-.2-.1-.3-.1-.4-.1-.1 0-.2 0-.5.1l-5.6 2.3c-.1.1-.2.2-.2.3v.4c0 .2.2.3.4.3h1.1v5.3c0 .1.1.3.3.3h1.7v-4.3h-.7c-.1 0-.2-.1-.2-.3v-.4c0-.2.1-.2.2-.2h6.9c.1 0 .2 0 .2.2v.4c0 .2-.1.3-.2.3h-.7v4.3h1.7c.2 0 .3-.2.3-.4v-5.2h1.1c.2 0 .3-.2.3-.3v-.3c.1-.2 0-.3-.1-.4zm-6 .2c-.5 0-.8-.3-.8-.7 0-.4.4-.7.8-.7s.7.3.7.7c0 .4-.3.7-.7.7z",
        "fill": "#fff"
      }]
    },
    link: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#0C8FE8"
      }, {
        "d": "M12.1 13.4c-.8-.8-2-.8-2.8 0l-1.2 1.1c-.8.8-.8 2 0 2.8.2.2.5.2.7 0 .2-.2.2-.4 0-.6-.5-.4-.5-1.1 0-1.5L9.9 14c.4-.4 1.1-.4 1.5 0 .5.4.5 1.1 0 1.5l-.5.6c.1.3.2.7.2 1.1l1-1c.8-.8.8-2.1 0-2.8zm-2.9 2.2c-.2.2-.2.5 0 .6.4.5.4 1.1 0 1.6l-1.1 1.1c-.5.4-1.1.4-1.6 0-.4-.4-.4-1.1 0-1.5l.6-.6c-.2-.3-.2-.7-.2-1.1l-1 1c-.8.8-.8 2.1 0 2.9.8.7 2 .7 2.8 0l1.2-1.2c.7-.8.7-2 0-2.8-.2-.2-.5-.2-.7 0z",
        "fill": "#fff"
      }],
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
          "fill": "#0973E2"
        }, {
          "d": "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
          "opacity": ".5",
          "fill": "#fff"
        }]
      }
    },
    mp4: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
          "fill": "#9B64B2"
        }, {
          "d": "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
          "fill": "#824B9E"
        }, {
          "d": "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
          "opacity": ".5",
          "fill": "#fff"
        }]
      },
      "path": {
        "d": "M9.4 20.2c-.1 0-.3-.1-.3-.3v-3.4l-1.5 3.6c0 .1 0 .1-.1.1s-.1 0-.1-.1l-1.5-3.6v3.4c0 .2-.2.3-.3.3-.2 0-.3-.1-.3-.3v-3.8c0-.3.2-.5.5-.5.1 0 .3.1.4.3L7.5 19l1.3-3.1c.1-.2.3-.3.4-.3.3 0 .5.2.5.5v3.8c0 .2-.1.3-.3.3zm3.3-1.8h-1.2v1.5c0 .2-.1.3-.3.3-.2 0-.3-.1-.3-.3v-3.8c0-.3.2-.4.4-.4h1.4c.9 0 1.4.6 1.4 1.3 0 .8-.5 1.4-1.4 1.4zm0-2.2h-1.2v1.7h1.2c.5 0 .9-.4.9-.9s-.4-.8-.9-.8zm5.2 2.8h-.5v.9c0 .2-.1.3-.2.3-.2 0-.3-.1-.3-.3V19H15c-.2 0-.3-.1-.3-.3 0 0 0-.1.1-.2l1.8-2.7c.1-.1.2-.2.4-.2s.4.2.4.5v2.4h.5c.1 0 .2.1.2.3 0 .1-.1.2-.2.2zm-1-2.8l-1.6 2.3h1.6v-2.3z",
        "fill": "#fff"
      }
    },
    overlay: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#A382D8"
      }, {
        "d": "M5.3 12.9v5.3h5.5v-5.3H5.3zm2 2v5.3h5.5v-5.3H7.3z",
        "fill": "#fff"
      }, {
        "fill": "#CBBBEF",
        "d": "M7.3 14.9h3.5v3.3H7.3z"
      }],
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
          "fill": "#8C62CE"
        }, {
          "d": "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
          "opacity": ".5",
          "fill": "#fff"
        }]
      }
    },
    pack: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#4E74B7"
      }, {
        "d": "M12.4 15.3v4.5c0 .2-.2.4-.4.4H5.7c-.2 0-.4-.2-.4-.4v-4.5-.1l.6-1.8c.1-.2.2-.3.4-.3h5.1c.2 0 .4.1.4.3l.6 1.8v.1zm-.9 0l-.4-1.3H6.7l-.5 1.3h5.3z",
        "fill": "#fff"
      }],
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
          "fill": "#3A57A5"
        }, {
          "d": "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
          "opacity": ".5",
          "fill": "#fff"
        }]
      }
    },
    pages: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M3.4 0c-1 0-1.9.8-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#6A6AE2"
      }, {
        "d": "M7.1 18.4H5.9v1.5c0 .2-.2.3-.3.3-.2 0-.3-.1-.3-.3v-3.8c0-.3.2-.4.4-.4h1.4c.9 0 1.4.6 1.4 1.3s-.5 1.4-1.4 1.4zM7 16.2H5.9v1.7H7c.6 0 .9-.4.9-.9s-.3-.8-.9-.8zm4.6 4.1c-1.3 0-2.4-1-2.4-2.4s1.1-2.3 2.4-2.3c.6 0 1.2.2 1.5.6.1.1.1.1.1.2s-.1.3-.3.3c0 0-.1-.1-.2-.1-.2-.3-.7-.5-1.1-.5-1 0-1.8.7-1.8 1.8s.8 1.9 1.8 1.9c.5 0 .9-.3 1.2-.5v-1h-1.4c-.1 0-.2-.1-.2-.2s.1-.2.2-.2h1.5c.3 0 .4.1.4.4v.8c0 .7-.9 1.2-1.7 1.2zm4.3-.1c-.7 0-1.2-.2-1.6-.5-.1-.1-.1-.1-.1-.2 0-.2.1-.3.3-.3 0 0 .1 0 .1.1.3.2.8.4 1.3.4.8 0 1.1-.4 1.1-.7 0-1.2-2.7-.5-2.7-2.2 0-.7.6-1.2 1.5-1.2.6 0 1.1.2 1.5.5 0 0 .1.1.1.2s-.1.2-.3.2h-.2c-.3-.3-.7-.4-1.1-.4-.6 0-.9.3-.9.7 0 1 2.6.4 2.6 2.1 0 .7-.4 1.3-1.6 1.3z",
        "fill": "#fff"
      }],
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
          "fill": "#4F4FDA"
        }, {
          "d": "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
          "opacity": ".5",
          "fill": "#fff"
        }]
      }
    },
    pdf: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "fill": "#8C181A",
        "d": "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z"
      }, {
        "fill": "#6B0D12",
        "d": "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.3 2.1h4.8z"
      }, {
        "opacity": ".5",
        "fill": "#fff",
        "d": "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z"
      }, {
        "fill": "#fff",
        "d": "M7.1 18.4H5.8v1.5c0 .2-.1.3-.3.3-.1 0-.2-.1-.2-.3v-3.8c0-.2.2-.4.4-.4h1.4c.9 0 1.4.6 1.4 1.3 0 .8-.5 1.4-1.4 1.4zM7 16.2H5.8v1.7H7c.6 0 .9-.3.9-.9s-.3-.8-.9-.8zm3.9 4H9.8c-.2 0-.4-.2-.4-.4v-3.7c0-.2.2-.4.4-.4h1.1c1.4 0 2.4.9 2.4 2.2s-.9 2.3-2.4 2.3zm0-4H10v3.5h.9c1.1 0 1.8-.8 1.8-1.8 0-.9-.6-1.7-1.8-1.7zm6.2 0h-2.2v1.4H17c.2 0 .3.1.3.3s-.2.2-.3.2h-2.1v1.8c0 .2-.1.3-.3.3-.2 0-.3-.1-.3-.3v-3.8c0-.2.2-.4.4-.4h2.4c.1 0 .2.1.2.2s-.1.3-.2.3z"
      }]
    },
    ppt: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#E34221"
      }, {
        "d": "M7.1 18.4H5.9v1.5c0 .2-.2.3-.3.3-.2 0-.3-.1-.3-.3v-3.8c0-.3.2-.4.4-.4h1.4c.9 0 1.4.6 1.4 1.3 0 .8-.5 1.4-1.4 1.4zM7 16.2H5.9v1.7H7c.6 0 .9-.4.9-.9s-.3-.8-.9-.8zm4.2 2.2H10v1.5c0 .2-.1.3-.3.3-.1 0-.3-.1-.3-.3v-3.8c0-.3.2-.4.4-.4h1.4c.9 0 1.5.6 1.5 1.3 0 .8-.6 1.4-1.5 1.4zm0-2.2H10v1.7h1.2c.5 0 .9-.4.9-.9s-.4-.8-.9-.8zm5.3 0h-1.3v3.7c0 .2-.1.3-.2.3-.2 0-.3-.1-.3-.3v-3.7h-1.2c-.2 0-.3-.1-.3-.3 0-.1.1-.2.3-.2h3c.1 0 .2.1.2.2 0 .2-.1.3-.2.3z",
        "fill": "#fff"
      }],
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
          "fill": "#DC3119"
        }, {
          "d": "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
          "opacity": ".5",
          "fill": "#fff"
        }]
      }
    },
    psd: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1.1.9 1.9 1.9 1.9h17.2c1 0 1.9-.8 1.9-1.9V7.6L15.4 0h-12z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#0C77C6"
      }, {
        "d": "M7.1 18.4H5.9v1.5c0 .2-.2.3-.3.3-.2 0-.3-.1-.3-.3v-3.8c0-.3.2-.4.4-.4h1.4c.9 0 1.4.6 1.4 1.3 0 .8-.5 1.4-1.4 1.4zM7 16.2H5.9v1.7H7c.6 0 .9-.4.9-.9s-.3-.8-.9-.8zm3.9 4.1c-.7 0-1.2-.3-1.6-.6-.1-.1-.1-.1-.1-.2s.1-.3.3-.3c0 0 .1 0 .1.1.4.2.8.4 1.3.4.8 0 1.1-.4 1.1-.7 0-1.2-2.7-.5-2.7-2.2 0-.7.7-1.2 1.5-1.2.6 0 1.1.2 1.5.5.1 0 .1.1.1.2s-.1.2-.3.2H12c-.4-.3-.8-.4-1.2-.4-.5 0-.9.3-.9.7 0 1 2.6.4 2.6 2.1 0 .7-.4 1.3-1.6 1.3zm4.2-.1H14c-.3 0-.4-.2-.4-.4v-3.7c0-.3.1-.4.4-.4h1.1c1.4 0 2.3.9 2.3 2.2 0 1.3-.9 2.3-2.3 2.3zm0-4h-1v3.5h1c1.1 0 1.7-.8 1.7-1.8s-.6-1.7-1.7-1.7z",
        "fill": "#fff"
      }],
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
          "fill": "#0959B7"
        }, {
          "d": "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
          "opacity": ".5",
          "fill": "#fff"
        }]
      }
    },
    quip_doc: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "fill": "#29B6F2",
        "d": "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z"
      }, {
        "fill": "#2987C8",
        "d": "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.3 2.1h4.8z"
      }, {
        "opacity": ".5",
        "fill": "#fff",
        "d": "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z"
      }, {
        "d": "M9.3 17.1c0-1.5-1.1-2.8-2.9-2.8s-2.9 1.3-2.9 2.8S4.6 20 6.4 20c.4 0 .7-.1 1-.2l.9.9.8-.8-.7-.7c.6-.6.9-1.3.9-2.1zm-1.8 1.2l-.3-.3h-.8v.8c-1 0-1.6-.8-1.6-1.7 0-.9.6-1.7 1.6-1.7s1.6.8 1.6 1.7c0 .4-.2.9-.5 1.2zm4.3.6c-.2 0-.4-.1-.5-.2-.1-.2-.2-.4-.2-.7v-1.9H10V18c0 .4 0 .7.1.9.1.2.2.4.3.5.2.2.4.3.7.4.2.1.5.1.7.1s.6 0 .8-.1c.3-.1.5-.2.7-.4.1-.1.2-.3.3-.5s.1-.5.1-.9v-1.9h-1.1V18c0 .3-.1.5-.2.7-.1.1-.3.2-.5.2h-.1zm2.6-2.9h1.2v3.8h-1.2zm4.3 0c-.5 0-1 .3-1.2.6v-.5h-1.1v5.4h1.1v-2.2c.2.3.7.6 1.2.6 1.1 0 1.8-.8 1.8-1.9 0-1.1-.7-2-1.8-2zm-.2 2.9c-.5 0-.9-.4-.9-.9 0-.6.4-1 .9-1s.9.5.9 1c-.1.5-.4.9-.9.9zM15 14.1c-.4 0-.7.3-.7.8s.3.7.7.7c.5 0 .8-.3.8-.7 0-.5-.3-.8-.8-.8z",
        "fill": "#fff"
      }]
    },
    quip_sheet: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "fill": "#30C85A",
        "d": "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z"
      }, {
        "fill": "#2AA848",
        "d": "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.3 2.1h4.8z"
      }, {
        "opacity": ".5",
        "fill": "#fff",
        "d": "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z"
      }, {
        "fill": "#fff",
        "d": "M9.3 17.1c0-1.5-1.1-2.8-2.9-2.8s-2.9 1.3-2.9 2.8S4.6 20 6.4 20c.4 0 .7-.1 1-.2l.9.9.8-.8-.7-.7c.6-.6.9-1.3.9-2.1zm-1.8 1.2l-.3-.3h-.8v.8c-1 0-1.6-.8-1.6-1.7 0-.9.6-1.7 1.6-1.7s1.6.8 1.6 1.7c0 .4-.2.9-.5 1.2zm4.3.6c-.2 0-.4-.1-.5-.2-.1-.2-.2-.4-.2-.7v-1.9H10V18c0 .4 0 .7.1.9.1.2.2.4.3.5.2.2.4.3.7.4.2.1.5.1.7.1s.6 0 .8-.1c.3-.1.5-.2.7-.4.1-.1.2-.3.3-.5.1-.2.1-.5.1-.9v-1.9h-1.1V18c0 .3-.1.5-.2.7-.1.1-.3.2-.5.2h-.1zm2.6-2.9h1.2v3.8h-1.2zm4.3 0c-.5 0-1 .3-1.2.6v-.5h-1.1v5.4h1.1v-2.2c.2.3.7.6 1.2.6 1.1 0 1.8-.8 1.8-1.9 0-1.1-.7-2-1.8-2zm-.2 2.9c-.5 0-.9-.4-.9-.9 0-.6.4-1 .9-1s.9.5.9 1c-.1.5-.4.9-.9.9zM15 14.1c-.4 0-.7.3-.7.8s.3.7.7.7c.5 0 .8-.3.8-.7 0-.5-.3-.8-.8-.8z"
      }]
    },
    rtf: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#00A1EE"
      }, {
        "d": "M7.4 18.3l.9 1.5.1.1c0 .2-.2.3-.3.3-.1 0-.2-.1-.2-.1l-1.1-1.7h-.9v1.5c0 .2-.2.3-.3.3-.2 0-.3-.1-.3-.3V16c0-.2.2-.4.4-.4h1.4c.8 0 1.4.6 1.4 1.4 0 .8-.5 1.3-1.1 1.3zm-1.5-2.2v1.8H7c.6 0 .9-.4.9-.9s-.3-.9-.9-.9H5.9zm6.5 0h-1.2v3.8c0 .2-.1.3-.3.3-.2 0-.3-.1-.3-.3v-3.8H9.4c-.1 0-.2-.1-.2-.2s.1-.3.2-.3h3c.1 0 .3.2.3.3 0 .1-.2.2-.3.2zm3.9 0h-2.2v1.5h2.1c.2 0 .3.1.3.3 0 .1-.1.2-.3.2h-2.1v1.8c0 .2-.1.3-.3.3-.2 0-.3-.1-.3-.3V16c0-.2.2-.4.4-.4h2.4c.1 0 .2.2.2.3 0 .1-.1.2-.2.2z",
        "fill": "#fff"
      }],
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
          "fill": "#0089E9"
        }, {
          "d": "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
          "opacity": ".5",
          "fill": "#fff"
        }]
      }
    },
    slide: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#1AB6D9"
      }, {
        "d": "M5.3 13v7.2h7.5V13H5.3zm6.8 5.8H6v-4.4h6.1v4.4z",
        "fill": "#fff"
      }, {
        "d": "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#13A3CF"
      }, {
        "d": "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
        "opacity": ".5",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#fff"
      }]
    },
    stypi: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
          "fill": "#DDD965"
        }, {
          "d": "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
          "fill": "#C1BC45"
        }, {
          "d": "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
          "opacity": ".5",
          "fill": "#fff"
        }, {
          "d": "M12.5 13.1H5.9c-.3 0-.6.2-.6.5v6c0 .4.3.6.6.6h5l2.2-2.2v-4.4c0-.3-.2-.5-.6-.5z",
          "fill": "#fff"
        }, {
          "fill": "#DBD75D",
          "d": "M6.7 16.3h5.1v.6H6.7zm0-1.3h5.1v.6H6.7zm0 2.7H10v.6H6.7z"
        }]
      }
    },
    txt: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M3.4 0c-1 0-1.9.8-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#F9CA06"
      }, {
        "d": "M8.5 16.1H7.3v3.8c0 .2-.1.3-.3.3-.1 0-.3-.1-.3-.3v-3.8H5.5c-.1 0-.2-.1-.2-.2s.1-.3.2-.3h3c.2 0 .3.2.3.3 0 .1-.1.2-.3.2zm4.4 4.1c-.1 0-.1 0-.2-.1l-1.4-1.9-1.4 1.9c0 .1-.1.1-.2.1s-.3-.1-.3-.3l.1-.1 1.5-2L9.6 16l-.1-.1c0-.2.2-.3.3-.3.1 0 .2 0 .2.1l1.3 1.7 1.3-1.7c.1-.1.1-.1.2-.1.2 0 .3.1.3.3 0 0 0 .1-.1.1l-1.3 1.8 1.4 2c.1 0 .1.1.1.1 0 .2-.1.3-.3.3zm4.2-4.1h-1.2v3.8c0 .2-.1.3-.3.3-.1 0-.3-.1-.3-.3v-3.8h-1.2c-.1 0-.2-.1-.2-.2s.1-.3.2-.3h3c.2 0 .3.2.3.3 0 .1-.1.2-.3.2z",
        "fill": "#fff"
      }],
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.3 2.1h4.8z",
          "fill": "#F7BC04"
        }, {
          "d": "M15.4 0v5.4c0 .7.4 2.2 2.3 2.2h4.8L15.4 0z",
          "opacity": ".5",
          "fill": "#fff"
        }]
      }
    },
    unknown: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
          "fill": "#8199AF"
        }, {
          "d": "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
          "fill": "#617F9B"
        }, {
          "d": "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
          "opacity": ".5",
          "fill": "#fff"
        }]
      }
    },
    video: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#8E4C9E"
      }, {
        "d": "M10.7 17.1c0 .1-.1.2-.2.3 0 .1-1.9 1.7-4.4 2.7h-.5c-.1-.1-.2-.2-.2-.4 0-.1-.1-1.3-.1-2.6s.1-2.6.1-2.6c0-.2.1-.3.2-.4.1-.1.2-.1.3-.1h.2c2.5 1 4.4 2.6 4.4 2.7.1.1.2.2.2.4z",
        "fill": "#fff"
      }],
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
          "fill": "#713985"
        }, {
          "d": "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
          "opacity": ".5",
          "fill": "#fff"
        }]
      }
    },
    visio: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#496AB3"
      }, {
        "d": "M9.3 16l-1.5 3.9c-.1.2-.3.3-.5.3s-.4-.1-.4-.3L5.3 16v-.1c0-.1.1-.3.3-.3.1 0 .2.1.3.2l1.4 3.7 1.5-3.7c0-.1.1-.2.3-.2.1 0 .3.1.3.3 0 0 0 .1-.1.1zm1.2 4.2c-.1 0-.3-.1-.3-.3v-4c0-.2.2-.3.3-.3.2 0 .3.1.3.3v4c0 .2-.1.3-.3.3zm3 0c-.7 0-1.2-.2-1.6-.5-.1-.1-.1-.2-.1-.2 0-.2.1-.3.3-.3h.1c.4.3.8.5 1.3.5.8 0 1.1-.4 1.1-.7 0-1.2-2.7-.6-2.7-2.2 0-.7.7-1.2 1.5-1.2.6 0 1.1.2 1.5.5.1 0 .1.1.1.2s-.1.2-.3.2h-.1c-.4-.3-.8-.4-1.2-.4-.5 0-.9.3-.9.7 0 1 2.6.4 2.6 2.1 0 .7-.4 1.3-1.6 1.3z",
        "fill": "#fff"
      }],
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
          "fill": "#374FA0"
        }, {
          "d": "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
          "opacity": ".5",
          "fill": "#fff"
        }]
      }
    },
    webex: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M3.4 0c-1 0-1.9.9-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
          "fill": "#80BC4B"
        }, {
          "d": "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
          "fill": "#60AB38"
        }, {
          "d": "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
          "opacity": ".5",
          "fill": "#fff"
        }]
      },
      "path": [{
        "d": "M9.2 20.2c1.9-.1 3.4-1.7 3.4-3.7 0-1.9-1.5-3.5-3.4-3.6v7.3z",
        "fill": "#CFE8AF"
      }, {
        "d": "M8.8 20.2c-2-.1-3.5-1.7-3.5-3.7s1.5-3.5 3.5-3.6v7.3z",
        "fill": "#fff"
      }]
    },
    word: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M3.4 0c-1 0-1.9.8-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#14A9DA"
      }, {
        "d": "M6.8 20.2H5.7c-.2 0-.4-.2-.4-.4v-3.7c0-.2.2-.4.4-.4h1.1c1.4 0 2.4 1 2.4 2.3 0 1.2-1 2.2-2.4 2.2zm0-4h-.9v3.5h.9c1.1 0 1.8-.8 1.8-1.7 0-1-.6-1.8-1.8-1.8zm5.4 4.1c-1.3 0-2.2-1-2.2-2.3s.9-2.4 2.2-2.4c1.4 0 2.3 1 2.3 2.4 0 1.3-.9 2.3-2.3 2.3zm0-4.2c-1 0-1.6.8-1.6 1.9 0 1 .6 1.8 1.6 1.8 1.1 0 1.7-.8 1.7-1.8 0-1.1-.6-1.9-1.7-1.9zm7 .2v.2c0 .1-.1.2-.2.2s-.2 0-.2-.1c-.3-.3-.7-.5-1.1-.5-1 0-1.8.8-1.8 1.9 0 1 .8 1.8 1.8 1.8.4 0 .8-.2 1.1-.5 0-.1.1-.1.2-.1s.2.1.2.3v.1c-.4.4-.9.7-1.5.7-1.3 0-2.4-1-2.4-2.4s1.1-2.3 2.4-2.3c.6 0 1.1.3 1.5.7z",
        "fill": "#fff"
      }],
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
          "fill": "#0F93D0"
        }, {
          "d": "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
          "opacity": ".5",
          "fill": "#fff"
        }]
      }
    },
    xml: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M3.4 0c-1 0-1.9.8-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#FC7B24"
      }, {
        "d": "M8.8 20.2c-.1 0-.2 0-.2-.1l-1.4-1.9-1.4 1.9c-.1.1-.2.1-.2.1-.2 0-.3-.1-.3-.3v-.1l1.5-2L5.4 16v-.1c0-.2.1-.3.3-.3 0 0 .1 0 .2.1l1.3 1.7 1.3-1.7c0-.1.1-.1.2-.1s.2.1.2.3v.1l-1.4 1.8 1.5 2v.1c0 .2-.1.3-.2.3zm5.4 0c-.2 0-.3-.1-.3-.3v-3.5l-1.5 3.7c0 .1-.1.1-.1.1-.1 0-.2 0-.2-.1l-1.5-3.7v3.5c0 .2-.1.3-.3.3-.1 0-.2-.1-.2-.3v-3.8c0-.3.2-.5.4-.5s.4.1.5.3l1.3 3.1 1.3-3.1c0-.2.2-.3.4-.3.3 0 .5.2.5.5v3.8c0 .2-.2.3-.3.3zm3.9-.1h-2c-.2 0-.4-.1-.4-.4v-3.8c0-.2.1-.3.3-.3.1 0 .2.1.2.3v3.7h1.9c.2 0 .3.2.3.3 0 .1-.1.2-.3.2z",
        "fill": "#fff"
      }],
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
          "fill": "#FB5C1B"
        }, {
          "d": "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
          "opacity": ".5",
          "fill": "#fff"
        }]
      }
    },
    zip: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M3.4 0c-1 0-1.9.8-1.9 1.9v20.2c0 1 .9 1.9 1.9 1.9h17.2c1 0 1.9-.9 1.9-1.9V7.6L15.4 0h-12z",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "#8199AF"
      }, {
        "d": "M8.4 20.2H5.6c-.2 0-.3-.1-.3-.3v-.2l2.6-3.5H5.5c-.1 0-.2-.1-.2-.2 0-.2.1-.3.2-.3h2.8c.2 0 .3.1.3.3 0 .1 0 .2-.1.2L6 19.7h2.4c.1 0 .3.1.3.3 0 .1-.2.2-.3.2zm1.5.1c-.1 0-.3-.2-.3-.3v-4.1c0-.1.2-.2.3-.2.2 0 .3.1.3.2V20c0 .1-.1.3-.3.3zm3.3-1.9H12V20c0 .1-.1.3-.3.3-.2 0-.3-.2-.3-.3v-3.9c0-.2.2-.4.4-.4h1.4c.9 0 1.4.6 1.4 1.4s-.5 1.3-1.4 1.3zm0-2.2H12v1.7h1.2c.5 0 .9-.3.9-.8s-.4-.9-.9-.9z",
        "fill": "#fff"
      }],
      "g": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "path": [{
          "d": "M22.5 7.6V8h-4.8s-2.4-.5-2.3-2.5c0 0 .1 2.1 2.2 2.1h4.9z",
          "fill": "#617F9B"
        }, {
          "d": "M15.4 0v5.5c0 .6.4 2.1 2.3 2.1h4.8L15.4 0z",
          "opacity": ".5",
          "fill": "#fff"
        }]
      }
    },
    viewBox: '0 0 24 24'
  };
}

/* harmony default export */ __webpack_exports__["a"] = (icons);

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
var icons = {};

if (false) {
  icons = {
    account: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M19 12.3c0-.5-.4-.7-.5-.7h-5.3c-.4 0-.5.5-.5.5v5.7H19v-5.5zm-3.6 4c0 .3-.3.5-.5.5h-.5c-.3 0-.5-.2-.5-.5v-.5c0-.2.2-.5.5-.5h.5c.2 0 .5.3.5.5v.5zm0-2.5c0 .3-.3.5-.5.5h-.5c-.3 0-.5-.2-.5-.5v-.4c0-.3.2-.5.5-.5h.5c.2 0 .5.2.5.5v.4zm2.4 2.5c0 .3-.3.5-.5.5h-.5c-.3 0-.5-.2-.5-.5v-.5c0-.2.2-.5.5-.5h.5c.2 0 .5.3.5.5v.5zm0-2.5c0 .3-.3.5-.5.5h-.5c-.3 0-.5-.2-.5-.5v-.4c0-.3.2-.5.5-.5h.5c.2 0 .5.2.5.5v.4zm-3.6-4.1V6.9c0-.5-.4-.7-.5-.7H5.6c-.5 0-.6.5-.6.6v11h6.3v-7.1s0-.5.5-.5h1.9s.5-.3.5-.5zm-6.5 6.4c0 .2-.2.4-.5.4h-.5c-.2 0-.5-.2-.5-.4v-.5c0-.3.3-.5.5-.5h.5c.3 0 .5.2.5.5v.5zm0-2.5c0 .2-.2.5-.5.5h-.5c-.2 0-.5-.3-.5-.5v-.5c0-.3.3-.5.5-.5h.5c.3 0 .5.2.5.5v.5zm0-2.5c0 .3-.2.5-.5.5h-.5c-.2 0-.5-.2-.5-.5v-.4c0-.3.3-.5.5-.5h.5c.3 0 .5.2.5.5v.4zm0-2.4c0 .3-.2.5-.5.5h-.5c-.2 0-.5-.2-.5-.5v-.5c0-.3.3-.5.5-.5h.5c.3 0 .5.2.5.5v.5zm2.6 7.4c0 .2-.2.4-.5.4h-.4c-.3 0-.5-.2-.5-.4v-.5c0-.3.2-.5.5-.5h.4c.3 0 .5.2.5.5v.5zm0-2.5c0 .2-.2.5-.5.5h-.4c-.3 0-.5-.3-.5-.5v-.5c0-.3.2-.5.5-.5h.4c.3 0 .5.2.5.5v.5zm0-2.5c0 .3-.2.5-.5.5h-.4c-.3 0-.5-.2-.5-.5v-.4c0-.3.2-.5.5-.5h.4c.3 0 .5.2.5.5v.4zm0-2.4c0 .3-.2.5-.5.5h-.4c-.3 0-.5-.2-.5-.5v-.5c0-.3.2-.5.5-.5h.4c.3 0 .5.2.5.5v.5zm2.7 0c0 .3-.3.5-.5.5H12c-.3 0-.5-.2-.5-.5v-.5c0-.3.2-.5.5-.5h.5c.2 0 .5.2.5.5v.5z"
      }
    },
    address: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M11.8 4.5a5.7 5.7 0 0 0-5.7 5.8c0 3.9 4 7.5 5.3 8.5a.6.6 0 0 0 .7 0c1.3-1 5.4-4.6 5.4-8.5a5.7 5.7 0 0 0-5.7-5.8zm0 8.1a2.4 2.4 0 1 1 2.4-2.4 2.4 2.4 0 0 1-2.4 2.4z"
      }
    },
    announcement: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M11 17.8l-.3-.3c-.5-.3-.5-.9-.5-1.2v-.8c0-.3-.2-.5-.4-.5H8c-.3 0-.5.2-.5.5v2.3c0 .8.5 1.4 1.2 1.4h1.5c.9 0 1-.6 1-.6s.1-.5-.2-.8zm6.8-8.2V5.5c0-.7-1-.9-1.4-.4l-2.7 2.5c-.5.3-1 .5-1.5.5H7.6C6 8.1 4.8 9.5 4.8 11v.1c0 1.5 1.2 2.7 2.8 2.7h4.6c.6 0 1.1.2 1.5.6l2.7 2.6c.4.4 1.4.3 1.4-.4v-4.1c.9 0 1.4-.6 1.4-1.5 0-.8-.6-1.4-1.4-1.4z"
      }
    },
    answer_best: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": [{
        "d": "M11.9 5.2c-4 0-7.2 3-7.2 6.7 0 1.2.3 2.3.9 3.3.1.1.1.2 0 .4L5 17.7c-.2.4.2.7.6.6l2.1-.8c.1 0 .3 0 .4.1 1.1.6 2.4 1 3.8 1 4 0 7.2-3 7.2-6.7s-3.2-6.7-7.2-6.7zm3.4 5.2l-3.6 3.7c-.2.1-.3.2-.5.2s-.4-.1-.5-.2l-1.8-1.8c-.2-.2-.2-.4 0-.5l.5-.5c.1-.2.3-.2.5 0l1.3 1.3 3.1-3.2c.2-.2.4-.2.5 0l.5.5c.2.1.2.4 0 .5z"
      }, {
        "fill-opacity": ".65",
        "d": "M24 24v-9.1L14.9 24H24zm-1-3.2l-.8.7v.1l.2 1.1c0 .1-.1.1-.1.1l-.9-.5c-.1-.1-.1-.1-.1 0l-1 .5s-.1 0-.1-.1l.2-1.1v-.1l-.8-.7c0-.1 0-.2.1-.2l1-.2h.1l.4-1c0-.1.1-.1.2 0l.4 1h.1l1 .2c.1 0 .1.1.1.2z"
      }]
    },
    answer_private: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": [{
        "fill-opacity": ".65",
        "d": "M21.4 20.2c-.3 0-.5.2-.5.4v.3h.9v-.3c0-.2-.2-.4-.4-.4z"
      }, {
        "fill-opacity": ".65",
        "d": "M24 24v-9.1L14.9 24H24zm-1.2-1.6c0 .2-.2.4-.4.4h-2.1c-.2 0-.4-.2-.4-.4v-1.2c0-.2.2-.3.4-.3h.1v-.3c0-.5.4-.9 1-.9s.9.4.9.9v.3h.1c.2 0 .4.1.4.3v1.2z"
      }, {
        "d": "M12 5.3c-4 0-7.2 3-7.2 6.7 0 1.2.3 2.3.9 3.3.1.1.1.3 0 .4l-.6 2.1c-.2.4.2.7.6.6l2.1-.7c.1-.1.3-.1.4 0 1.1.7 2.4 1 3.8 1 4 0 7.2-3 7.2-6.7S16 5.3 12 5.3zm3.5 5.2l-3.7 3.7c-.2.1-.3.2-.5.2s-.4-.1-.5-.2L9 12.4c-.1-.1-.1-.4 0-.5l.5-.5c.1-.1.4-.1.5 0l1.3 1.3 3.1-3.2c.2-.1.4-.1.6 0l.5.5c.1.2.1.4 0 .5z"
      }]
    },
    answer_public: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12 5.3c-4 0-7.2 3-7.2 6.7 0 1.2.3 2.3.9 3.3.1.1.1.3.1.4l-.7 2.1c-.1.4.2.7.6.6l2.1-.7c.2-.1.3-.1.4 0 1.1.7 2.4 1 3.8 1 4 0 7.2-3 7.2-6.7S16 5.3 12 5.3zm3.5 5.2l-3.7 3.7c-.2.1-.3.2-.5.2s-.4-.1-.5-.2L9 12.4c-.1-.1-.1-.4 0-.5l.5-.5c.1-.1.4-.1.5 0l1.3 1.3 3.1-3.2c.2-.1.4-.1.6 0l.5.5c.1.2.1.4 0 .5z"
      }
    },
    approval: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.8 13h-2.7c-.8 0-1.4-.7-1.4-1.5.1-2.1 1.1-2.2 1.2-3.6.1-1.4-.8-2.7-2.3-3.1-1.8-.3-3.5 1.1-3.5 2.9 0 1.6 1.1 1.6 1.2 3.8 0 .8-.6 1.5-1.4 1.5H6.2c-.8 0-1.4.6-1.4 1.4v1c0 .2.2.4.5.4h13.4c.3 0 .5-.2.5-.4v-1c0-.8-.6-1.4-1.4-1.4zm0 4.3H6.2c-.2 0-.4.2-.4.4v.1c0 .8.6 1.4 1.4 1.4h9.6c.8 0 1.4-.6 1.4-1.4v-.1c0-.2-.2-.4-.4-.4z"
      }
    },
    apps: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M7.7 4.8H5.8c-.6 0-1 .4-1 1v1.9c0 .5.4.9 1 .9h1.9c.5 0 .9-.4.9-.9V5.8c0-.6-.4-1-.9-1zm5.3 0h-2c-.5 0-.9.4-.9 1v1.9c0 .5.4.9.9.9h2c.5 0 .9-.4.9-.9V5.8c0-.6-.4-1-.9-1zm5.2 0h-1.9c-.5 0-.9.4-.9 1v1.9c0 .5.4.9.9.9h1.9c.6 0 1-.4 1-.9V5.8c0-.6-.4-1-1-1zM7.7 10.1H5.8c-.6 0-1 .4-1 .9v2c0 .5.4.9 1 .9h1.9c.5 0 .9-.4.9-.9v-2c0-.5-.4-.9-.9-.9zm5.3 0h-2c-.5 0-.9.4-.9.9v2c0 .5.4.9.9.9h2c.5 0 .9-.4.9-.9v-2c0-.5-.4-.9-.9-.9zm5.2 0h-1.9c-.5 0-.9.4-.9.9v2c0 .5.4.9.9.9h1.9c.6 0 1-.4 1-.9v-2c0-.5-.4-.9-1-.9zM7.7 15.4H5.8c-.6 0-1 .4-1 .9v1.9c0 .6.4 1 1 1h1.9c.5 0 .9-.4.9-1v-1.9c0-.5-.4-.9-.9-.9zm5.3 0h-2c-.5 0-.9.4-.9.9v1.9c0 .6.4 1 .9 1h2c.5 0 .9-.4.9-1v-1.9c0-.5-.4-.9-.9-.9zm5.2 0h-1.9c-.5 0-.9.4-.9.9v1.9c0 .6.4 1 .9 1h1.9c.6 0 1-.4 1-1v-1.9c0-.5-.4-.9-1-.9z"
      }
    },
    apps_admin: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.5 5h-11C5.7 5 5 5.7 5 6.5v11c0 .8.7 1.5 1.5 1.5h11c.8 0 1.5-.7 1.5-1.5v-11c0-.8-.7-1.5-1.5-1.5zM17 17.5H7c-.3 0-.5-.2-.5-.5V7c0-.3.2-.5.5-.5h10c.3 0 .5.2.5.5v10c0 .3-.2.5-.5.5zm-6.2-9.6H8.4c-.3 0-.5.2-.5.5v2.4c0 .3.2.5.5.5h2.4c.3 0 .5-.2.5-.5V8.4c0-.3-.2-.5-.5-.5zm4.8 0h-2.4c-.3 0-.5.2-.5.5v2.4c0 .3.2.5.5.5h2.4c.3 0 .5-.2.5-.5V8.4c0-.3-.2-.5-.5-.5zm-4.8 4.8H8.4c-.3 0-.5.2-.5.5v2.4c0 .3.2.5.5.5h2.4c.3 0 .5-.2.5-.5v-2.4c0-.3-.2-.5-.5-.5zm4.8 0h-2.4c-.3 0-.5.2-.5.5v2.4c0 .3.2.5.5.5h2.4c.3 0 .5-.2.5-.5v-2.4c0-.3-.2-.5-.5-.5z"
      }
    },
    article: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M7.7 14.2h3.1c.3 0 .5-.3.5-.5V6.5c0-.5-.5-1-1-1H7.8c-.4 0-.6.3-.6.6v7.6c0 .2.2.5.5.5zM18.2 7v7.6c0 .6-.4 1-.9 1H6.7c-.5 0-.9-.4-.9-1V7c-.8 0-1.5.6-1.5 1.4v7.2c0 .8.7 1.4 1.5 1.4h4.5c.3 0 .5.3.5.5s.2.5.5.5h1.4c.3 0 .5-.2.5-.5s.2-.5.5-.5h4.5c.8 0 1.5-.6 1.5-1.4V8.4c0-.8-.7-1.4-1.5-1.4zm-5 7.2h3c.4 0 .6-.3.6-.6V6c0-.3-.2-.5-.5-.5h-2.6c-.5 0-1 .5-1 1v7.2c0 .2.2.5.5.5z"
      }
    },
    asset_relationship: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.5 13.1V13c0-2.1-1.3-4-3.1-4.9v-.2c0-1.3-1.1-2.4-2.4-2.4S9.6 6.6 9.6 7.9v.2C7.8 9 6.5 10.9 6.5 13v.1c-1 .3-1.7 1.2-1.7 2.3 0 1.4 1 2.4 2.4 2.4.5 0 1-.1 1.4-.4.9.7 2.1 1.1 3.4 1.1s2.4-.4 3.3-1.1c.4.2.9.4 1.5.4 1.3 0 2.4-1 2.4-2.4 0-1-.7-2-1.7-2.3zm-8.2 3.4c.2-.3.3-.7.3-1.1 0-1.1-.9-2.1-2-2.3V13c0-1.6 1-3.1 2.4-3.9.4.7 1.1 1.2 2 1.2s1.6-.5 2-1.2c1.4.8 2.4 2.3 2.4 3.9v.1c-1.1.2-2 1.2-2 2.3 0 .4.1.8.3 1.1-.8.6-1.7.9-2.7.9s-1.9-.3-2.7-.9z"
      }
    },
    assigned_resource: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M12 4.8a6.1 6.1 0 1 0 6 6.1c0-3.3-2.7-6.1-6-6.1zm3.9 5.6l-2.5 2.4c-.2.2-.4 0-.4-.3v-1.4c-1.8 0-3 1.2-3 3.1H8.1A4.8 4.8 0 0 1 13 9.3V7.8c0-.3.3-.5.4-.3l2.5 2.5a.4.4 0 0 1 0 .4zm-9.7 5h-.3a1.1 1.1 0 0 0-1.1 1.1v1.6a1.1 1.1 0 0 0 1.1 1.1h12.2a1.1 1.1 0 0 0 1.1-1.1v-1.6a1.1 1.1 0 0 0-1.1-1.1h-.4a7.2 7.2 0 0 1-11.5 0z",
        "fill-rule": "evenodd"
      }
    },
    avatar: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M19.2 17.1v.7c0 .8-.6 1.4-1.4 1.4H6.2c-.8 0-1.4-.6-1.4-1.4v-.7c0-1.8 2-2.8 4-3.7 0 0 .1 0 .2-.1.1 0 .3 0 .4.1.8.5 1.7.8 2.6.8.9 0 1.8-.3 2.6-.8.1-.1.3-.1.4 0 .1 0 .2 0 .2.1 2 .8 4 1.8 4 3.6z"
      },
      "ellipse": {
        "cx": "12",
        "cy": "8.76",
        "rx": "3.576",
        "ry": "3.96"
      }
    },
    avatar_loading: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "opacity": ".5",
        "path": {
          "d": "M19.2 17.1v.7c0 .8-.6 1.4-1.4 1.4H6.2c-.8 0-1.4-.6-1.4-1.4v-.7c0-1.8 2-2.8 4-3.7 0 0 .1 0 .2-.1.1 0 .3 0 .4.1.8.5 1.7.8 2.6.8s1.8-.3 2.6-.8c.1-.1.3-.1.4 0 .1 0 .2 0 .2.1 2 .8 4 1.8 4 3.6z"
        },
        "ellipse": {
          "cx": "12",
          "cy": "8.76",
          "rx": "3.576",
          "ry": "3.96"
        }
      }
    },
    bot: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M11.9 6.2c1.7 0 3.1 1.4 3.1 3.1v.8c-1-.1-2.1-.2-3.1-.2s-2.1.1-3.1.2v-.8c0-1.7 1.4-3.1 3.1-3.1zm5.7 9.1l.3-2.7c.7.1 1.2.7 1.2 1.3 0 .8-.7 1.4-1.5 1.4zm-11.4 0c-.8 0-1.5-.6-1.5-1.4 0-.7.5-1.2 1.2-1.3l.3 2.7zm10.3-4.5c-1.6-.2-3.1-.3-4.6-.3s-3 .1-4.5.3c-.6 0-.9.5-.9 1l.5 4.7c.1.4.4.8.8.8 1.4.2 2.8.2 4.2.2s2.7 0 4.1-.2c.4 0 .7-.4.8-.8l.5-4.7c0-.5-.4-1-.9-1zM9.3 15c-.4 0-.7-.4-.7-.9s.3-.9.7-.9.6.4.6.9-.3.9-.6.9zm4 1l-.1.1s0 .1-.1.1h-2.4l-.1-.1v-.5c0-.1 0-.2.1-.2h.1c.1 0 .1.1.1.2v.2h2v-.2c0-.1.1-.2.2-.2s.2.1.2.2v.4zm1.2-1c-.3 0-.6-.4-.6-.9s.3-.9.6-.9.7.4.7.9-.3.9-.7.9z"
      }
    },
    business_hours: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M11.5 8.5h.8c.2 0 .4.1.4.4v3.3c0 .1-.1.2-.1.3l-2.2 2.2c-.1.1-.3.1-.5 0l-.5-.6c-.2-.1-.2-.3 0-.5l1.8-1.8V8.9c0-.2.1-.4.3-.4zm8.8 3.3h-1.2v-.3c-.3-3.9-3.7-6.8-7.7-6.6-3.9.4-6.9 3.8-6.6 7.7.3 3.7 3.4 6.6 7.1 6.6 2 .1 3.9-.7 5.3-2.2.1-.1.2-.2.1-.4l-.6-.7c-.2-.3-.4-.2-.6 0-1.2 1.3-3 2-4.7 1.8-2.5-.3-4.8-2.6-5.1-5-.3-3.1 2-5.9 5.1-6.2s5.8 2 6.1 5.1v.2h-1.1c-.2 0-.4.2-.4.4 0 .1.1.2.1.3l1.9 2.3c.2.2.5.2.6 0l1.9-2.3c.2-.2.2-.4 0-.6 0 0-.1-.1-.2-.1z"
      }
    },
    calibration: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M7.7 11.9c-.2.1-.3.1-.5.1-.1 0-.3 0-.5-.1-.1 0-.2.1-.2.3v6.5c0 .3.2.5.5.5h.4c.3 0 .5-.2.5-.5v-6.5c0-.2-.1-.3-.2-.3zm4.8 5.1h-1c-.1-.1-.2.1-.2.2v1.5c0 .3.2.5.5.5h.4c.3 0 .5-.2.5-.5v-1.5c0-.2-.1-.3-.2-.2zm4.8-3.6h-1c-.1-.1-.2.1-.2.2v5.1c0 .3.2.5.5.5h.4c.3 0 .5-.2.5-.5v-5.1c0-.2-.1-.3-.2-.2zm-9.4-6V5.3c0-.3-.2-.5-.5-.5H7c-.3 0-.5.2-.5.5v2.1c-.6.2-1 .8-1 1.5 0 .9.8 1.7 1.7 1.7s1.7-.8 1.7-1.7c0-.7-.4-1.3-1-1.5zm4.8 5V5.3c0-.3-.2-.5-.5-.5h-.4c-.3 0-.5.2-.5.5v7.1c-.6.3-1 .8-1 1.5 0 1 .8 1.7 1.7 1.7s1.7-.7 1.7-1.7c0-.7-.4-1.2-1-1.5zm4.8-3.6V5.3c0-.3-.2-.5-.5-.5h-.4c-.3 0-.5.2-.5.5v3.5c-.6.3-1 .8-1 1.5 0 1 .8 1.7 1.7 1.7s1.7-.7 1.7-1.7c0-.7-.4-1.2-1-1.5z"
      }
    },
    call: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.6 15.3l-1.4-1.2c-.5-.4-1.3-.4-1.8 0l-1.4 1c-.2.2-.5.1-.6 0L11 13l-2.1-2.4c-.2-.2-.2-.4 0-.6l1-1.4c.4-.6.3-1.3-.1-1.8L8.6 5.3c-.5-.6-1.5-.7-2.1-.1L5.2 6.5c-.3.3-.4.7-.4 1.1.1 3 1.5 5.9 3.6 8s4.9 3.4 8 3.6c.4 0 .8-.2 1-.5l1.3-1.3c.7-.5.6-1.5-.1-2.1z"
      }
    },
    call_history: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M6.7 11.5v.5H5.3v-.5h1.4zM12 5.3c-3.6 0-6.5 2.7-6.7 6.2v.3H4.2c-.3 0-.5.3-.3.5l1.8 2.2c.2.2.4.2.6 0l1.8-2.2c.2-.2 0-.5-.3-.5H6.7v-.3C7 8.8 9.2 6.7 12 6.7c3.1 0 5.6 2.7 5.2 5.9-.2 2.3-2.4 4.4-4.7 4.7-1.7.1-3.3-.5-4.4-1.7-.2-.2-.3-.3-.5 0l-.6.6c-.1.2 0 .3.1.4 1.3 1.4 3.1 2.1 5 2.1 3.4 0 6.3-2.8 6.6-6.2.3-3.9-2.8-7.2-6.7-7.2zm-.7 5c.2-.2.2-.6 0-.8l-.5-.6c-.2-.3-.7-.3-.9-.1l-.6.6c-.1.1-.2.3-.2.5.1 1.3.7 2.6 1.6 3.4s2.1 1.5 3.4 1.6c.2 0 .4 0 .5-.2l.6-.6c.2-.2.2-.7-.1-.9l-.6-.5c-.2-.2-.6-.2-.8 0l-.6.4c-.1.1-.2.1-.3 0l-1-.9-.9-1c-.1-.1-.1-.2 0-.3l.4-.6z"
      }
    },
    campaign: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12 4.8C8 4.8 4.8 8 4.8 12S8 19.2 12 19.2s7.2-3.2 7.2-7.2S16 4.8 12 4.8zm0 13c-3.2 0-5.8-2.6-5.8-5.8S8.8 6.2 12 6.2s5.8 2.6 5.8 5.8-2.6 5.8-5.8 5.8zm0-10.1c-2.4 0-4.3 1.9-4.3 4.3s1.9 4.3 4.3 4.3 4.3-1.9 4.3-4.3-1.9-4.3-4.3-4.3zm0 7.2c-1.6 0-2.9-1.3-2.9-2.9s1.3-2.9 2.9-2.9 2.9 1.3 2.9 2.9-1.3 2.9-2.9 2.9zm0-4.3c-.8 0-1.4.6-1.4 1.4s.6 1.4 1.4 1.4 1.4-.6 1.4-1.4-.6-1.4-1.4-1.4z"
      }
    },
    campaign_members: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "fill-opacity": ".65",
        "d": "M24 14.9V24h-9.1l9.1-9.1zm-1.9 6.6c-.3-.1-.3-.2-.3-.4 0-.1.1-.2.2-.3.2-.2.2-.4.2-.7 0-.5-.3-.9-.8-.9s-.9.5-.9.9c0 .3.1.5.3.7.1.1.2.2.2.3s-.1.3-.4.4c-.5.2-.9.4-.9.8 0 .3.2.5.5.5h2.4c.2 0 .4-.2.4-.5 0-.4-.4-.6-.9-.8z"
      }, {
        "d": "M12 4.8C8 4.8 4.8 8 4.8 12S8 19.2 12 19.2s7.2-3.2 7.2-7.2S16 4.8 12 4.8zm0 13c-3.2 0-5.8-2.6-5.8-5.8S8.8 6.2 12 6.2s5.8 2.6 5.8 5.8-2.6 5.8-5.8 5.8zm0-10.1c-2.4 0-4.3 1.9-4.3 4.3s1.9 4.3 4.3 4.3 4.3-1.9 4.3-4.3-1.9-4.3-4.3-4.3zm0 7.2c-1.6 0-2.9-1.3-2.9-2.9s1.3-2.9 2.9-2.9 2.9 1.3 2.9 2.9-1.3 2.9-2.9 2.9zm0-4.3c-.8 0-1.4.6-1.4 1.4s.6 1.4 1.4 1.4 1.4-.6 1.4-1.4-.6-1.4-1.4-1.4z"
      }]
    },
    canvas: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.7 15.8c0 .8-.1 1.7-.3 2.6 0 .2-.2.5-.5.5-1.6.2-3.3.3-4.9.3-1.6 0-3.2-.1-4.8-.3-.3 0-.6-.3-.6-.5-.2-1.4-.4-2.8-.4-4.1 0-1.4.2-2.7.4-4.1 0-.2.3-.5.5-.5 1-.1 2-.2 3-.2 0 0 .7-.1.7-.8 0-.7-1.2-1.1-1.2-2.3 0-.9.9-1.6 2.4-1.6 1.4 0 2.4.7 2.4 1.6 0 1.2-1.2 1.6-1.2 2.3-.1.7.7.8.7.8 1 0 2 .1 3 .2.2 0 .5.3.5.5.2 1 .3 1.8.3 2.7.1.3-.2.5-.5.5H17c-.3 0-.7-.2-.9-.4 0 0-.7-.6-1.3-.6-1.1-.1-2 .9-2 2s.8 2.1 1.9 2c.7 0 1.4-.7 1.4-.7.2-.1.6-.3.8-.3.1-.1.2-.1.3-.1.3.1.6.3.5.5z"
      }
    },
    carousel: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.3 9h-.6v6.5h.6a.9.9 0 0 0 .9-.9V9.9a.9.9 0 0 0-.9-.9zm-13.5.9v4.7a.9.9 0 0 0 .9.9h.6V9h-.6a.9.9 0 0 0-.9.9zM16 8.2H8a.9.9 0 0 0-.8.9v6.3a.9.9 0 0 0 .8.9h8a.9.9 0 0 0 .8-.9V9.1a.9.9 0 0 0-.8-.9zm-1.4 6.5H9.1a.3.3 0 0 1-.3-.4l1.7-3a.2.2 0 0 1 .3 0l1 1.8a.2.2 0 0 0 .4 0l.8-1.2a.2.2 0 0 1 .3 0l1.5 2.4a.2.2 0 0 1-.2.4zm-.1-3.4a.8.8 0 1 1 .7-.8.8.8 0 0 1-.7.8z"
      }
    },
    case: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M9.1 7h1c.1 0 .2-.1.2-.3V6h3.4v.7c0 .2.1.3.2.3h1c.1 0 .2-.1.2-.3V6c0-.8-.6-1.4-1.4-1.4h-3.4c-.8 0-1.4.6-1.4 1.4v.7c0 .2.1.3.2.3zm8.7 1.4H6.2c-.8 0-1.4.6-1.4 1.4v7.7c0 .8.6 1.5 1.4 1.5h11.6c.8 0 1.4-.7 1.4-1.5V9.8c0-.8-.6-1.4-1.4-1.4z"
      }
    },
    case_change_status: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M9.1 7.2h1c.1 0 .2-.1.2-.2v-.8h3.4V7c0 .1.1.2.2.2h1c.1 0 .2-.1.2-.2v-.8c0-.8-.6-1.4-1.4-1.4h-3.4c-.8 0-1.4.6-1.4 1.4V7c0 .1.1.2.2.2zm8.7 1.4H6.2c-.8 0-1.4.7-1.4 1.5v7.7c0 .8.6 1.4 1.4 1.4h11.6c.8 0 1.4-.6 1.4-1.4v-7.7c0-.8-.6-1.5-1.4-1.5zM14 13.9L11.5 17c-.1.1-.4 0-.3-.2l.6-2.2h-1.6c-.2 0-.4-.2-.3-.3l1-2.6c.1-.3.3-.4.5-.4h2c.2 0 .4.2.3.4l-1.1 1.7h1.2c.3 0 .4.4.2.5z"
      }
    },
    case_comment: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M9.1 7.2h1c.1 0 .2-.1.2-.2v-.8h3.4V7c0 .1.1.2.2.2h1c.1 0 .2-.1.2-.2v-.8c0-.8-.6-1.4-1.4-1.4h-3.4c-.8 0-1.4.6-1.4 1.4V7c0 .1.1.2.2.2zm8.7 1.4H6.2c-.8 0-1.4.7-1.4 1.5v7.7c0 .8.6 1.4 1.4 1.4h11.6c.8 0 1.4-.6 1.4-1.4v-7.7c0-.8-.6-1.5-1.4-1.5zm-5.6 7.7c-.5 0-1-.1-1.5-.4h-.1l-1 .4c-.1.1-.3-.1-.2-.2l.4-1c0-.1 0-.1-.1-.1-.2-.4-.3-.9-.3-1.3 0-1.5 1.3-2.7 2.8-2.7s2.8 1.2 2.8 2.7c0 1.4-1.2 2.6-2.8 2.6z"
      }
    },
    case_email: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M9.1 7.2h1c.1 0 .2-.1.2-.2v-.8h3.4V7c0 .1.1.2.2.2h1c.1 0 .2-.1.2-.2v-.8c0-.8-.6-1.4-1.4-1.4h-3.4c-.8 0-1.4.6-1.4 1.4V7c0 .1.1.2.2.2zm8.7 1.4H6.2c-.8 0-1.4.7-1.4 1.5v7.7c0 .8.6 1.4 1.4 1.4h11.6c.8 0 1.4-.6 1.4-1.4v-7.7c0-.8-.6-1.5-1.4-1.5zm-8.7 2.7h5.8c.2 0 .2.2.2.3l-3 2.7c0 .1-.1.1-.2 0l-3-2.7c-.1-.2 0-.3.2-.3zm6 4.1c0 .3-.4.7-.7.7H9.6c-.3 0-.7-.4-.7-.7v-2.7c0-.1.1-.2.2-.1l2.3 2.2c.2.1.4.2.6.2s.4-.1.6-.2l2.2-2.2c.1-.1.3 0 .3.1v2.7z"
      }
    },
    case_log_a_call: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M9.1 7.2h1c.1 0 .2-.1.2-.2v-.8h3.4V7c0 .1.1.2.2.2h1c.1 0 .2-.1.2-.2v-.8c0-.8-.6-1.4-1.4-1.4h-3.4c-.8 0-1.4.6-1.4 1.4V7c0 .1.1.2.2.2zm8.7 1.4H6.2c-.8 0-1.4.7-1.4 1.5v7.7c0 .8.6 1.4 1.4 1.4h11.6c.8 0 1.4-.6 1.4-1.4v-7.7c0-.8-.6-1.5-1.4-1.5zM15 15.9l-.6.5c-.1.1-.2.2-.4.2-1.2-.1-2.4-.7-3.2-1.5-.8-.8-1.4-1.9-1.4-3.2 0-.1 0-.3.1-.4l.6-.5c.2-.3.6-.2.8 0l.5.6c.2.2.2.5 0 .7l-.4.6v.2l.9 1 .9.8c.1.1.2.1.3 0l.5-.4c.2-.1.5-.1.7 0l.6.5c.3.2.3.6.1.9z"
      }
    },
    case_milestone: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M17.5 8.6H6c-.8 0-1.4.7-1.4 1.5v7.7c0 .8.6 1.4 1.4 1.4h11.5c.8 0 1.5-.6 1.5-1.4v-7.7c0-.8-.7-1.5-1.5-1.5zm-7.7 3.1v5.2c0 .3-.2.5-.4.5-.3 0-.4-.2-.4-.5v-5.2c-.2-.2-.3-.4-.3-.6 0-.3.3-.6.6-.7s.7.3.7.6v.2c0 .1 0 .3-.2.5zM15 15s-.1.1-.1.2c-1.7 1-2.6-.6-4.1-.1-.2 0-.3 0-.3-.1v-3.1c0-.1 0-.2.1-.2 1.6-.7 2.5 1 4.2 0h.2V15zM8.9 7.2h1c.1 0 .2-.1.2-.2v-.8h3.4V7c0 .1.1.2.2.2h1c.1 0 .2-.1.2-.2v-.8c0-.8-.6-1.4-1.4-1.4h-3.4c-.8 0-1.4.6-1.4 1.4V7c0 .1.1.2.2.2z"
      }
    },
    case_transcript: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M9.1 7.2h1c.1 0 .2-.1.2-.2v-.8h3.4V7c0 .1.1.2.2.2h1c.1 0 .2-.1.2-.2v-.8c0-.8-.6-1.4-1.4-1.4h-3.4c-.8 0-1.4.6-1.4 1.4V7c0 .1.1.2.2.2zm8.7 1.4H6.2c-.8 0-1.4.7-1.4 1.5v7.7c0 .8.6 1.4 1.4 1.4h11.6c.8 0 1.4-.6 1.4-1.4v-7.7c0-.8-.6-1.5-1.4-1.5zm-3.2 7.5c0 .4-.3.7-.7.7h-3.3c-.4 0-.8-.3-.8-.7v-4.6c0-.4.4-.7.8-.7h1.6c.2 0 .3.1.3.2v1.5c0 .2.2.5.5.5h1.4c.1 0 .2.1.2.2v2.9zm0-3.8c0 .1 0 .2-.1.2h-1.1c-.2 0-.4-.2-.4-.5v-1c0-.1 0-.2.1-.2h.1l1.4 1.4v.1z"
      }
    },
    channel_program_history: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M7.4 11.5c.2-2.6 2.4-4.6 5.1-4.6 3 0 5.4 2.6 5 5.7-.2 2.2-2.3 4.3-4.5 4.5-1.7.2-3.2-.4-4.3-1.6-.2-.2-.3-.3-.5-.1l-.6.7c-.1.1 0 .2.1.4 1.3 1.3 3 2 4.9 2 3.3 0 6.1-2.7 6.4-6 .2-3.8-2.8-7-6.5-7-3.5 0-6.3 2.7-6.5 6v.3H4.9c-.3 0-.4.3-.3.5l1.8 2.1c.1.2.4.2.5 0l1.8-2.1c.2-.2 0-.5-.3-.5H7.3l.1-.3zm5.1-2.4c-1.6 0-2.9 1.3-2.9 2.9s1.3 2.9 2.9 2.9 2.9-1.3 2.9-2.9-1.3-2.9-2.9-2.9zm2.3 2.6H14c0-.7-.2-1.3-.4-1.7.7.3 1.1 1 1.2 1.7zm-2.6-1.9v1.9h-.6c0-.9.3-1.6.6-1.9zm0 2.5v1.9c-.3-.3-.6-1-.6-1.9h.6zm.6 1.9v-1.9h.6c0 .9-.3 1.6-.6 1.9zm0-2.5V9.8c.3.3.6 1 .6 1.9h-.6zM11.4 10c-.2.5-.3 1-.4 1.7h-.7c0-.7.5-1.4 1.1-1.7zm-1.2 2.3h.8c0 .7.2 1.3.4 1.7-.6-.3-1.1-1-1.2-1.7zm3.4 1.7c.2-.5.4-1 .4-1.7h.8c-.1.7-.5 1.4-1.2 1.7z"
      }
    },
    channel_program_levels: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.7 11.3l-.9-.4c-.1-.1-.3-.1-.4 0l-2.6 1.3c.4-.2.8-.2 1.3-.2.7 0 1.4.2 2.1.5l.5-.2c.4-.3.4-.8 0-1zM4.8 8.9l6.5 3c.3.1.6.1.9 0l6.5-3c.4-.2.4-.7 0-.9l-6.5-3.1c-.3-.1-.6-.1-.9 0L4.8 8c-.4.2-.4.7 0 .9zm0 3.3l6.5 3.1c.1.1.3.1.5.1.3-1.2 1-2.1 1.9-2.8l-1.5.8c-.2.1-.6.1-.9 0l-5.2-2.5c-.1-.1-.2-.1-.4 0l-.9.4c-.4.2-.4.7 0 .9zm7 4.6h-.5l-5.2-2.5c-.1-.1-.3-.1-.4 0l-.9.4c-.3.2-.3.7 0 .9l6.5 3c.3.2.6.2.9 0h.2c-.4-.6-.6-1.1-.6-1.8zM16.1 13.5c-1.5 0-2.8 1.3-2.8 2.8s1.2 2.9 2.8 2.9 2.9-1.3 2.9-2.9-1.3-2.8-2.9-2.8zm2.3 2.6h-.8c0-.7-.2-1.3-.4-1.7.7.3 1.1.9 1.2 1.7zm-2.6-1.9v1.9h-.6c0-.9.3-1.6.6-1.9zm0 2.4v1.9c-.3-.3-.6-1-.6-1.9h.6zm.6 1.9v-1.9h.7c-.1.9-.4 1.6-.7 1.9zm0-2.4v-1.9c.3.2.6 1 .7 1.9h-.7zM15 14.4c-.2.4-.3 1-.4 1.7h-.7c0-.8.5-1.4 1.1-1.7zm-1.1 2.2h.7c0 .7.2 1.3.4 1.7-.6-.3-1.1-.9-1.1-1.7zm3.3 1.7c.3-.4.4-1 .4-1.7h.8c-.1.8-.5 1.4-1.2 1.7z"
      }
    },
    channel_program_members: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M11.7 16.3c0-1.4.7-2.6 1.7-3.4-.3-.2-.6-.3-.9-.5-1.1-.4-1.2-.8-1.2-1.2 0-.4.3-.8.6-1.1.6-.6.9-1.3.9-2.2 0-1.7-1-3.1-2.8-3.1-1.8 0-2.9 1.4-2.9 3.1 0 .9.4 1.6 1 2.2.3.3.6.7.6 1.1 0 .4-.2.8-1.2 1.2-1.5.7-2.9 1.4-2.9 2.7 0 .9.7 1.7 1.5 1.7H11.7v-.5zm4.4-2.8c-1.6 0-2.9 1.3-2.9 2.9s1.3 2.8 2.9 2.8 2.8-1.2 2.8-2.8-1.2-2.9-2.8-2.9zm2.3 2.6h-.8c0-.7-.2-1.3-.4-1.7.6.3 1.1 1 1.2 1.7zm-2.6-1.9v1.9h-.6c0-.9.3-1.6.6-1.9zm0 2.5v1.8c-.3-.2-.6-1-.6-1.8h.6zm.6 1.8v-1.8h.6c0 .8-.3 1.5-.6 1.8zm0-2.4v-1.9c.3.3.6 1 .6 1.9h-.6zM15 14.4c-.3.4-.4 1-.4 1.7h-.8c.1-.7.6-1.4 1.2-1.7zm-1.2 2.3h.8c0 .6.2 1.2.4 1.7-.6-.4-1.1-1-1.2-1.7zm3.4 1.7c.2-.5.3-1.1.4-1.7h.7c0 .7-.5 1.3-1.1 1.7z"
      }
    },
    channel_programs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M11.8 4.8c-4 0-7.2 3.2-7.2 7.2s3.2 7.2 7.2 7.2S19 16 19 12s-3.3-7.2-7.2-7.2zm5.7 6.5h-1.9c-.1-1.7-.5-3.2-1.1-4.3 1.6.8 2.7 2.4 3 4.3zM11 6.6v4.7H9.4c.1-2.3.8-4.1 1.6-4.7zm0 6.1v4.7c-.8-.6-1.5-2.4-1.6-4.7H11zm1.5 4.7v-4.7h1.6c-.1 2.3-.8 4.1-1.6 4.7zm0-6.1V6.6c.8.6 1.5 2.4 1.6 4.7h-1.6zM9 7c-.6 1.1-1 2.6-1.1 4.3H6C6.3 9.4 7.4 7.8 9 7zm-3 5.7h1.9c.1 1.7.5 3.2 1.1 4.3-1.6-.8-2.7-2.4-3-4.3zm8.5 4.3c.6-1.1 1-2.6 1.1-4.3h1.9c-.3 1.9-1.4 3.5-3 4.3z"
      }
    },
    client: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M10.8 14c.8-.5 1.7-.8 2.6-.8.3 0 .5.1.8.1.1 0 .1 0 0-.1-.4-.3-1-.5-1.5-.7-1-.5-1.2-.8-1.2-1.3 0-.4.3-.8.7-1.1.6-.5.9-1.3.9-2.2 0-1.6-1-3.1-2.9-3.1-1.8 0-2.8 1.5-2.8 3.1 0 .9.3 1.7.9 2.2.4.3.7.7.7 1.1 0 .4-.2.8-1.2 1.3-1.5.6-2.9 1.3-3 2.7 0 .9.7 1.6 1.6 1.6h3.4c.2 0 .4-.2.4-.4v-1.6c.1-.3.2-.6.6-.8zm7.8 1.4c-2.3.7-4.1-1.4-6.6-.4-.1 0-.2.2-.2.4V18c0 .3.2.6.6.5 2.4-.8 4.2 1.3 6.5.4.2-.1.3-.3.3-.5v-2.5c0-.3-.3-.6-.6-.5zm-3 2.4c-.6 0-1-.4-1-1s.4-.9 1-.9.9.4.9.9-.4 1-.9 1z"
      }
    },
    cms: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M14.5 7.2c-.5 0-.9 0-1.3.2.5.4.9.9 1.3 1.4 1.7 0 3 1.4 3 3.1s-1.3 3-3 3c-.4 0-.8 0-1.2-.2.2-.3.4-.7.5-1 .1-.1.2-.2.2-.4.1-.4.2-.9.2-1.4 0-2.6-2.1-4.7-4.7-4.7s-4.7 2.1-4.7 4.7 2.1 4.7 4.7 4.7c.5 0 .9-.1 1.3-.2-.5-.4-.9-.9-1.3-1.5-1.7 0-3-1.3-3-3s1.3-3.1 3-3.1c.4 0 .8.1 1.2.3-.5.7-.9 1.7-.9 2.8 0 2.6 2.1 4.7 4.7 4.7s4.7-2.1 4.7-4.7-2.1-4.7-4.7-4.7z"
      }
    },
    coaching: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M11.3 12.7c-.3 0-.6.1-.9.4-.4.4-.4 1.2 0 1.7.3.2.6.3.9.3.3 0 .6-.1.8-.3.5-.5.5-1.2 0-1.7-.2-.3-.5-.4-.8-.4zm7.8-5.4L17.5 5c-.2-.2-.5-.3-.7-.2l-8 5c-.8.5-1.4 1.1-1.9 2.2-.4 1-.5 2.1-.2 3.1-1.1.1-1.9 1-1.9 2.1s.9 2 2 2c.9 0 1.6-.5 1.9-1.2 1.9 1.2 4.4.9 6-.7 1.5-1.5 1.8-3.6.9-5.4-.2-.7-.1-1.4.5-1.8L19 8c.2-.1.2-.4.1-.7zM6.8 17.8c-.3 0-.6-.3-.6-.6s.3-.6.6-.6.6.2.6.6-.2.6-.6.6zm6.4-2c-.6.5-1.2.8-1.9.8s-1.4-.3-1.9-.8c-1-1-1-2.7 0-3.8.5-.5 1.2-.7 1.9-.7s1.3.2 1.9.7c1 1.1 1 2.8 0 3.8z"
      }
    },
    connected_apps: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.5 5h-11C5.7 5 5 5.7 5 6.5v11c0 .8.7 1.5 1.5 1.5h11c.8 0 1.5-.7 1.5-1.5v-11c0-.8-.7-1.5-1.5-1.5zM17 17.5H7c-.3 0-.5-.2-.5-.5V7c0-.3.2-.5.5-.5h10c.3 0 .5.2.5.5v10c0 .3-.2.5-.5.5zm-3-6.2h-1.5L13.8 9c.2-.2 0-.6-.3-.6h-2c-.2 0-.5.2-.6.5l-1.3 3.3c-.1.2.1.5.4.5h1.5l-.7 2.6c-.1.3.2.4.4.2l3.1-3.7c.2-.2.1-.5-.3-.5z"
      }
    },
    contact: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.8 7H6.2c-.8 0-1.4.6-1.4 1.4v7c0 .8.6 1.4 1.4 1.4h11.6c.8 0 1.4-.6 1.4-1.4v-7c0-.8-.6-1.4-1.4-1.4zm-6.1 8.1H7.5c-.4 0-.8-.5-.8-1 0-.7.8-1.1 1.6-1.5.5-.2.6-.4.6-.7s-.1-.4-.3-.6c-.3-.3-.5-.7-.5-1.2 0-.9.5-1.7 1.5-1.7s1.5.8 1.5 1.7c0 .5-.2.9-.5 1.2-.2.2-.4.4-.4.6s.1.5.7.7c.8.3 1.5.8 1.5 1.5.1.5-.3 1-.7 1zm5.6-1.7c0 .3-.2.5-.5.5h-2.2c-.2 0-.4-.2-.4-.5v-.7c0-.2.2-.5.4-.5h2.2c.3 0 .5.3.5.5v.7zm0-2.6c0 .3-.2.5-.5.5h-3.6c-.3 0-.5-.2-.5-.5v-.7c0-.3.2-.5.5-.5h3.6c.3 0 .5.2.5.5v.7z"
      }
    },
    contact_list: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M6.3 5.4c-1.1 0-2 .9-2 1.9V18c0 1 .9 1.8 2 1.8h10.5c1.1 0 1.9-.8 1.9-1.8V7.3c0-1-.8-1.9-1.9-1.9H6.3zm2.6 4.4c0 .4-.3.6-.6.6h-.7c-.3 0-.6-.2-.6-.6v-.6c0-.3.3-.6.6-.6h.7c.3 0 .6.3.6.6v.6zm7.2 0c0 .4-.3.6-.6.6h-4.6c-.4 0-.7-.2-.7-.6v-.6c0-.3.3-.6.7-.6h4.6c.3 0 .6.3.6.6v.6zM8.9 13c0 .3-.3.6-.6.6h-.7c-.3 0-.6-.3-.6-.6v-.7c0-.3.3-.6.6-.6h.7c.3 0 .6.3.6.6v.7zm6 0c0 .3-.3.6-.6.6h-3.4c-.4 0-.7-.3-.7-.6v-.7c0-.3.3-.6.7-.6h3.4c.3 0 .6.3.6.6v.7zm-6 3.1c0 .3-.3.6-.6.6h-.7c-.3 0-.6-.3-.6-.6v-.6c0-.4.3-.7.6-.7h.7c.3 0 .6.3.6.7v.6zm7.2 0c0 .3-.3.6-.6.6h-4.6c-.4 0-.7-.3-.7-.6v-.6c0-.4.3-.7.7-.7h4.6c.3 0 .6.3.6.7v.6z"
      }
    },
    contract: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.9 8.1l-3.2-3.2c0-.1-.1-.1-.2-.1-.2 0-.3.1-.3.3v2.6c0 .5.4.9.9.9h2.6c.2 0 .3-.1.3-.3 0-.1 0-.2-.1-.2zm-.4 2h-3.3c-.8 0-1.5-.7-1.5-1.5V5.3c0-.3-.2-.5-.5-.5H7.4c-.8 0-1.4.6-1.4 1.4v11.6c0 .8.6 1.4 1.4 1.4h9.2c.8 0 1.4-.6 1.4-1.4v-7.2c0-.3-.2-.5-.5-.5zM7.7 7.8l1.2-.1v-.1l.6-1.1h.1l.6 1.1v.1l1.2.1c.1 0 .1.1.1.2l-.9.8v.1l.2 1.2c0 .1-.1.1-.2.1l-1-.6h-.1l-1.1.6s-.1 0-.1-.1l.2-1.2-.1-.1-.8-.8c0-.1 0-.2.1-.2zm7.4 8c0 .3-.2.5-.5.5H8.4c-.3 0-.5-.2-.5-.5v-.4c0-.3.2-.5.5-.5h6.2c.3 0 .5.2.5.5v.4zm1-2.8c0 .2-.2.4-.5.4H8.4c-.3 0-.5-.2-.5-.4v-.5c0-.3.2-.5.5-.5h7.2c.3 0 .5.2.5.5v.5z"
      }
    },
    contract_line_item: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M15.1 8.6h2.6c.2 0 .3-.1.3-.3 0-.1 0-.2-.1-.2l-3.2-3.2c0-.1-.1-.1-.2-.1-.2 0-.3.1-.3.3v2.6c0 .5.4.9.9.9zm2.4 1.5h-3.3c-.8 0-1.5-.7-1.5-1.5V5.3c0-.3-.2-.5-.5-.5H7.4c-.8 0-1.4.6-1.4 1.4v11.6c0 .8.6 1.4 1.4 1.4h9.2c.8 0 1.4-.6 1.4-1.4v-7.2c0-.3-.2-.5-.5-.5zm-9.2 6.2c-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7.4 0 .7.3.7.7 0 .4-.3.7-.7.7zm0-2.8c-.4 0-.7-.4-.7-.8s.3-.7.7-.7c.4 0 .7.3.7.7 0 .5-.3.8-.7.8zm1.2-3.9l-1.1.6s-.1 0-.1-.1l.2-1.2-.1-.1-.8-.8c0-.1 0-.2.1-.2l1.2-.1v-.1l.6-1.1h.1l.6 1.1v.1l1.2.1c.1 0 .1.1.1.2l-.9.8v.1l.2 1.2c0 .1-.1.1-.2.1l-1-.6h-.1zm6.6 6.2c0 .3-.2.5-.5.5h-4.9c-.2 0-.5-.2-.5-.5v-.4c0-.3.3-.5.5-.5h4.9c.3 0 .5.2.5.5v.4zm0-2.8c0 .2-.2.4-.5.4h-4.9c-.2 0-.5-.2-.5-.4v-.5c0-.3.3-.5.5-.5h4.9c.3 0 .5.2.5.5v.5z"
      }
    },
    custom: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M19 7.9c0-.2-.3-.2-.4-.1l-2.4 2.4c-.2.2-.5.2-.7 0l-1.7-1.7c-.2-.2-.2-.5 0-.7l2.4-2.4c.2-.1.1-.4 0-.4-.5-.1-.9-.2-1.3-.2-2.6 0-4.6 2.2-4.3 4.8 0 .4.1.8.3 1.1l-5.6 5.6c-.7.7-.7 1.8 0 2.4.3.4.7.5 1.2.5s.8-.1 1.2-.5l5.6-5.6c.3.2.7.3 1.1.3 2.6.3 4.8-1.7 4.8-4.3 0-.4-.1-.8-.2-1.2z"
      }
    },
    custom_notification: {
      "path": {
        "d": "M12.9 5.2L12 9.6a.2.2 0 0 0 .3.3H17a.5.5 0 0 1 .3.7L12.2 19a.4.4 0 0 1-.8-.2l.9-5.2c0-.2-.1-.1-.3-.1H7.1c-.4 0-.6-.5-.4-.8L12.1 5a.4.4 0 0 1 .8.2z"
      }
    },
    customers: {
      "xmlns": "http://www.w3.org/2000/svg",
      "ellipse": {
        "cx": "9.912",
        "cy": "10.152",
        "rx": "2.928",
        "ry": "3.24"
      },
      "path": {
        "d": "M12.6 13.8c-.7.6-1.7 1.1-2.7 1.1-1 0-2-.5-2.7-1.1-1.3.6-2.6 1.3-2.6 2.5v.5c0 .6.4 1.1 1 1.1h8.6c.6 0 1.1-.5 1.1-1.1v-.5c0-1.2-1.3-1.9-2.7-2.5zm3.7-2.4l-.1-.1h-.3c-.5.3-1.1.5-1.7.5h-.3c-.1.3-.2.7-.4.9.1.1.2.1.3.2 1.4.6 2.4 1.3 3 2.3H18c.5 0 1-.4 1-.9v-.5c0-1.2-1.4-1.9-2.7-2.4zm-.2-3.2c0-1.2-.9-2.1-1.9-2.1-.6 0-1 .2-1.4.6.9.8 1.4 2.1 1.4 3.4v.2c1 0 1.9-.9 1.9-2.1z"
      }
    },
    dashboard: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12 4.8C8 4.8 4.8 8 4.8 12S8 19.2 12 19.2s7.2-3.2 7.2-7.2S16 4.8 12 4.8zm0 1.9c2.9 0 5.3 2.4 5.3 5.3 0 .2 0 .5-.1.7h-2.1c-.2 0-.4.2-.5.4-.2 1.3-1.3 2.3-2.6 2.3s-2.4-1-2.6-2.3c0-.2-.3-.4-.5-.4H6.8c-.1-.2-.1-.5-.1-.7 0-2.9 2.4-5.3 5.3-5.3zm-.6 7.1c.6.3 1.4 0 1.7-.5.4-.9 1.3-4.6 1.1-4.7-.2-.1-2.8 2.7-3.2 3.6-.4.5-.2 1.3.4 1.6z"
      }
    },
    datadotcom: {
      "path": {
        "d": "M17.1 19.2h-1.7c-.1-.6-.1-1.1-.1-1.6-.8 1.3-2.1 1.9-3.8 1.9-1.4 0-2.6-.5-3.4-1.5-.8-1-1.2-2.4-1.2-3.9 0-1.1.2-2 .6-2.8s1-1.5 1.7-2 1.6-.7 2.6-.7c1.4 0 2.5.4 3.4 1.3V4.8h1.7v12.1c0 .8.1 1.5.2 2.3zm-1.9-4.4v-3.3c-.4-.6-.9-.9-1.4-1.2-.5-.2-1.1-.4-1.8-.4-1 0-1.8.4-2.4 1.2s-.8 1.7-.8 2.9c0 1.3.2 2.2.8 3s1.3 1.1 2.3 1.1 1.8-.3 2.4-1c.6-.6.9-1.4.9-2.3z"
      }
    },
    default: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "opacity": ".5",
        "d": "M10.7 7.9c.5-.5 1.2-.8 1.9-.8 1.1 0 1.9.5 2.4 1.3.4-.1.9-.3 1.4-.3 1.8.1 3.3 1.5 3.3 3.3 0 1.8-1.5 3.3-3.3 3.3-.2 0-.5 0-.7-.1-.4.8-1.2 1.3-2.1 1.3-.4 0-.7-.1-1-.3-.5 1-1.4 1.7-2.6 1.7-1.2 0-2.2-.8-2.6-1.8-.2 0-.3.1-.5.1-1.4 0-2.6-1.2-2.6-2.6 0-.9.5-1.8 1.3-2.2-.2-.4-.2-.7-.2-1.2 0-1.6 1.3-2.9 2.9-2.9 1 0 1.9.5 2.4 1.2"
      }
    },
    document: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.5 10.1h-3.3c-.8 0-1.5-.7-1.5-1.5V5.3c0-.3-.2-.5-.5-.5H7.4c-.8 0-1.4.6-1.4 1.4v11.6c0 .8.6 1.4 1.4 1.4h9.2c.8 0 1.4-.6 1.4-1.4v-7.2c0-.3-.2-.5-.5-.5zm.4-2l-3.2-3.2c0-.1-.1-.1-.2-.1-.2 0-.3.1-.3.3v2.6c0 .5.4.9.9.9h2.6c.2 0 .3-.1.3-.3 0-.1 0-.2-.1-.2z"
      }
    },
    drafts: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.5 4.8H9.8c-.8 0-1.4.6-1.4 1.4v.3c0 .1.1.2.2.2h7c.8 0 1.4.7 1.4 1.5v7.4c0 .1.1.2.3.2h.2c.8 0 1.5-.6 1.5-1.4V6.2c0-.8-.7-1.4-1.5-1.4zm-3.3 3.4H6.5c-.8 0-1.5.6-1.5 1.4v8.2c0 .8.7 1.4 1.5 1.4h7.7c.8 0 1.4-.6 1.4-1.4V9.6c0-.8-.6-1.4-1.4-1.4zM7 10.6c0-.3.2-.5.4-.5h4.8c.3 0 .5.2.5.5v.4c0 .3-.2.5-.5.5H7.4c-.2 0-.4-.2-.4-.5v-.4zm5.7 6.2c0 .3-.2.5-.5.5H7.4c-.2 0-.4-.2-.4-.5v-.5c0-.2.2-.5.4-.5h4.8c.3 0 .5.3.5.5v.5zm1-2.9c0 .3-.2.5-.5.5H7.4c-.2 0-.4-.2-.4-.5v-.5c0-.2.2-.4.4-.4h5.8c.3 0 .5.2.5.4v.5z"
      }
    },
    email: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M11.7 13.2c.2.2.4.2.6 0l6.8-6.3c.1-.2.1-.6-.4-.6H5.3c-.4 0-.6.3-.4.6l6.8 6.3zm7.5-3.6c0-.3-.4-.5-.6-.3l-5.3 4.9c-.3.4-.8.5-1.3.5s-.9-.1-1.3-.5L5.4 9.3c-.2-.2-.6 0-.6.3v6.2c0 .8.7 1.5 1.5 1.5h11.5c.8 0 1.4-.7 1.4-1.5V9.6z"
      }
    },
    email_chatter: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M11.7 13.2c.2.2.4.2.6 0l6.8-6.3c.1-.2.1-.6-.4-.6H5.3c-.4 0-.6.3-.4.6l6.8 6.3zm7.5-3.6c0-.3-.4-.5-.6-.3l-5.3 4.9c-.3.4-.8.5-1.3.5s-.9-.1-1.3-.5L5.4 9.3c-.2-.2-.6 0-.6.3v6.2c0 .8.7 1.5 1.5 1.5h11.5c.8 0 1.4-.7 1.4-1.5V9.6z"
      }
    },
    empty: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "opacity": ".5",
        "d": "M17.3 18.7H6.7c-.8 0-1.4-.6-1.4-1.4V6.7c0-.8.6-1.4 1.4-1.4h10.6c.8 0 1.4.6 1.4 1.4v10.6c0 .8-.6 1.4-1.4 1.4zM6.7 7.2v9.6c0 .3.2.5.5.5h9.6c.3 0 .5-.2.5-.5V7.2c0-.3-.2-.5-.5-.5H7.2c-.3 0-.5.2-.5.5z"
      }
    },
    endorsement: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M6.7 10.1H5.3c-.3 0-.5.2-.5.5v7.7c0 .3.2.4.5.4h.5c.8 0 1.4-.6 1.4-1.4v-6.7c0-.3-.2-.5-.5-.5zm10.6.2h-1.5c-.8 0-1.4-.6-1.4-1.4V6c0-.8-.6-1.4-1.4-1.4h-1c-.3 0-.5.2-.5.4v2c0 1.6-.8 3.3-2.4 3.3-.2 0-.5.2-.5.5v6.7c0 .3.2.5.5.5 2.1.1 3.5.9 5.8.9 2.4 0 4.3-.7 4.3-3v-3.7c0-1-.9-1.9-1.9-1.9z"
      }
    },
    entitlement: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M17.3 4.8H8.4c-.8 0-1.6.8-1.6 1.6h-.6c-.6 0-1.1.5-1.1 1.2s.5 1.1 1.1 1.1h.6v2.2h-.6c-.6 0-1.1.5-1.1 1.1s.5 1.1 1.1 1.1h.6v2.2h-.6c-.6 0-1.1.5-1.1 1.1 0 .7.5 1.1 1.1 1.1h.6c0 1.1.8 1.7 1.6 1.7h8.9c.8 0 1.6-.8 1.6-1.7V6.4c0-.9-.8-1.6-1.6-1.6zm-1 12c0 .3-.2.5-.4.5H9.6c-.3 0-.5-.2-.5-.5v-.5c0-.2.2-.5.5-.5h6.3c.2 0 .4.3.4.5v.5zm-6.7-4.7l.5-.5c.1-.2.4-.2.5 0l1.3 1.2 3-3.1c.2-.1.4-.1.5 0l.5.5c.2.2.2.4 0 .6l-3.6 3.5c-.1.1-.3.2-.5.2s-.3-.1-.5-.2l-1.7-1.7c-.2-.2-.2-.4 0-.5zm6.7-4.3c0 .2-.2.5-.4.5H9.6c-.3 0-.5-.3-.5-.5v-.5c0-.3.2-.5.5-.5h6.3c.2 0 .4.2.4.5v.5z"
      }
    },
    entitlement_process: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M13.4 19.1v-4l2.3-2.5h3.2v4.8c0 1-.8 1.7-1.7 1.7h-3.8zm-1.4 0H8.4c-.8 0-1.6-.5-1.6-1.7h-.6c-.6 0-1.1-.4-1.1-1v-.1c0-.6.5-1.1 1.1-1.1h.6V13h-.6c-.6 0-1.1-.5-1.1-1.1 0-.6.5-1.1 1.1-1.1h.6V8.6h-.6c-.6 0-1.1-.5-1.1-1.1 0-.6.5-1.1 1.1-1.2h.6c0-.9.8-1.6 1.6-1.6h8.8c.9 0 1.7.7 1.7 1.6v4.9h-3.3L13 8.4c-.2-.2-.5-.2-.7 0l-2.9 3.2c-.2.2-.2.5 0 .7l2.6 2.8v4z"
      }
    },
    entitlement_template: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M16.9 4.7H8.1c-.9 0-1.6.7-1.6 1.6h-.6c-.6 0-1.1.5-1.1 1.1v.1c0 .6.5 1.1 1.1 1.1h.6v2.2h-.6c-.6 0-1.1.5-1.1 1.1 0 .6.5 1.1 1.1 1.1h.6v2.2h-.6c-.6 0-1.1.5-1.1 1.1 0 .6.5 1.1 1.1 1.1h.6c0 1.2.7 1.7 1.6 1.7h8.8c.9 0 1.7-.7 1.7-1.7V6.3c0-.9-.8-1.6-1.7-1.6zm-.8 10.8H8.8V8.3h7.3v7.2zm-6-4.7h4.8c.1 0 .1 0 .1-.1V9.6c0-.1 0-.2-.1-.2h-4.8c-.1 0-.2 0-.2.1v1.1c0 .1.1.2.2.2zm0 3.6h1.1c.1 0 .2 0 .2-.1v-2.2c0-.1-.1-.2-.2-.2h-1.1c-.1 0-.2.1-.2.1v2.2c0 .1.1.2.2.2zm4.7-2.5h-2.2c-.1 0-.2.1-.2.2v2.2c0 .1.1.1.2.1h2.2c.1 0 .2 0 .2-.1v-2.2c0-.1 0-.2-.1-.2h-.1z"
      }
    },
    entity: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M17.9 6.9c0-1.2-2.7-2.1-5.9-2.1s-5.9.9-5.9 2.1v.7c0 1.2 2.7 2.1 5.9 2.1s5.9-.9 5.9-2.1v-.7zM6.1 9.3c0 .9 2.7 1.6 5.9 1.6s5.9-.7 5.9-1.6v1.5c0 1.1-2.7 2.1-5.9 2.1s-5.9-1-5.9-2.1V9.3zm0 0c0 .9 2.7 1.6 5.9 1.6s5.9-.7 5.9-1.6v1.5c0 1.1-2.7 2.1-5.9 2.1s-5.9-1-5.9-2.1V9.3zm0 3.2c0 .9 2.7 1.6 5.9 1.6s5.9-.7 5.9-1.6v1.4c0 1.2-2.7 2.1-5.9 2.1s-5.9-.9-5.9-2v-1.5zm0 3.1c0 1 2.7 1.7 5.9 1.7s5.9-.7 5.9-1.7v1.5c0 1.2-2.7 2.1-5.9 2.1s-5.9-.9-5.9-2.1v-1.5z"
      }
    },
    entity_milestone: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M17.8 7.9l-5.1-2.8c-.4-.3-1-.3-1.5 0L6.1 7.9c-.4.3-.7.8-.7 1.3v5.7c0 .5.3 1 .7 1.3l5.1 2.9c.5.2 1.1.2 1.5 0l5.1-2.9c.5-.3.8-.8.8-1.3V9.2c0-.5-.3-1-.8-1.3zm-8 1.8v6c0 .3-.2.5-.5.5s-.5-.2-.5-.5v-6c-.2-.1-.3-.4-.3-.6 0-.4.4-.7.8-.7s.8.3.8.8c0 .2-.1.4-.3.5zm6.2 3.8c0 .1-.1.2-.2.2-2 1.1-3.1-.7-4.9-.1-.1.1-.3 0-.3-.2V10c0-.1.1-.2.2-.3 1.8-.7 3 1.2 5 .1h.1c0 .1.1.1.1.1v3.6z"
      }
    },
    environment_hub: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M10.3 11.3c.1-1 .4-2 .9-2.9.8-1.3 2.1-2.1 3.8-2.2.3-.8 1.1-1.4 2-1.4 1.2 0 2.2 1 2.2 2.2s-1 2.1-2.2 2.1c-.9 0-1.7-.6-2-1.4-1.9.1-3 1.6-3.2 3.6H15c.3-.9 1.1-1.5 2-1.5 1.2 0 2.2 1 2.2 2.2s-1 2.2-2.2 2.2c-.9 0-1.7-.6-2-1.5h-3.2c.2 2.2 1.2 3.6 3.2 3.6.3-.8 1.1-1.4 2-1.4 1.2 0 2.2.9 2.2 2.1s-1 2.2-2.2 2.2c-.9 0-1.7-.6-2-1.4-1.8 0-3.1-.8-3.9-2.2-.4-.9-.7-1.8-.8-2.9H9c-.3.9-1.1 1.5-2 1.5-1.2 0-2.2-1-2.2-2.2s1-2.2 2.2-2.2c.9 0 1.7.6 2 1.5h1.3zM17 7.7c.4 0 .8-.3.8-.7s-.4-.8-.8-.8-.7.4-.7.8.3.7.7.7zm0 10.1c.4 0 .8-.4.8-.8s-.4-.7-.8-.7-.7.3-.7.7.3.8.7.8zm0-5.1c.4 0 .8-.3.8-.7s-.4-.7-.8-.7-.7.3-.7.7.3.7.7.7zm-10 0c.4 0 .7-.3.7-.7s-.3-.7-.7-.7-.8.3-.8.7.4.7.8.7z"
      }
    },
    event: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.2 10.1H5.8c-.3 0-.5.2-.5.5v7.2c0 .8.6 1.4 1.4 1.4h10.6c.8 0 1.4-.6 1.4-1.4v-7.2c0-.3-.2-.5-.5-.5zm-8.6 6.7c0 .3-.2.5-.5.5h-.9c-.3 0-.5-.2-.5-.5v-1c0-.2.2-.4.5-.4h.9c.3 0 .5.2.5.4v1zm0-3.4c0 .3-.2.5-.5.5h-.9c-.3 0-.5-.2-.5-.5v-.9c0-.3.2-.5.5-.5h.9c.3 0 .5.2.5.5v.9zm3.4 3.4c0 .3-.3.5-.5.5h-1c-.2 0-.5-.2-.5-.5v-1c0-.2.3-.4.5-.4h1c.2 0 .5.2.5.4v1zm0-3.4c0 .3-.3.5-.5.5h-1c-.2 0-.5-.2-.5-.5v-.9c0-.3.3-.5.5-.5h1c.2 0 .5.2.5.5v.9zm3.3 3.4c0 .3-.2.5-.5.5h-.9c-.3 0-.5-.2-.5-.5v-1c0-.2.2-.4.5-.4h.9c.3 0 .5.2.5.4v1zm0-3.4c0 .3-.2.5-.5.5h-.9c-.3 0-.5-.2-.5-.5v-.9c0-.3.2-.5.5-.5h.9c.3 0 .5.2.5.5v.9zm1-7.2h-1.2v-.4c0-.6-.5-1-1-1s-.9.4-.9 1v.4H9.8v-.4c0-.6-.4-1-.9-1s-1 .4-1 1v.4H6.7c-.8 0-1.4.7-1.4 1.5v.5c0 .2.2.4.5.4h12.4c.3 0 .5-.2.5-.4v-.5c0-.8-.6-1.5-1.4-1.5z"
      }
    },
    feed: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M11.8 17.3c-.1 0-.3 0-.4-.1-.2-.1-.3-.3-.4-.5L9.2 9.2l-1.6 3.5c-.1.3-.4.5-.6.5H4.8c-.3 0-.5-.2-.5-.5v-.5c0-.2.2-.4.5-.4h1.7l2.2-5.1c.1-.3.4-.5.7-.5.3.1.6.3.7.6l1.9 7.6 2.4-5.6c.2-.3.5-.4.8-.4.2 0 .5.2.6.5l1.2 2.9h2.2c.3 0 .5.2.5.4v.5c0 .3-.2.5-.5.5h-2.6c-.3 0-.6-.2-.7-.4l-.8-1.9-2.7 5.9c-.1.3-.4.5-.6.5z"
      }
    },
    feedback: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M19 13.6v-.3c.4-.8.7-1.6.7-2.5 0-2.8-2.4-5-5.3-5-1.2 0-2.4.4-3.3 1.1 3 .6 5.2 3.2 5.2 6.3 0 .9-.1 1.7-.5 2.4.5-.1 1-.3 1.4-.5.1-.1.2-.1.3-.1l1.5.6c.3.1.5-.2.5-.5l-.5-1.5zM9.6 8.2c-2.9 0-5.3 2.2-5.3 5 0 .9.3 1.7.7 2.5 0 .1.1.2 0 .3l-.5 1.6c-.1.3.2.5.5.4l1.5-.5c.1-.1.2-.1.3 0 .8.5 1.8.7 2.8.7 2.9 0 5.3-2.2 5.3-5s-2.4-5-5.3-5zm-2.9 6c-.5 0-.9-.5-.9-1s.4-1 .9-1 1 .5 1 1-.5 1-1 1zm2.9 0c-.5 0-1-.5-1-1s.5-1 1-1 1 .5 1 1-.5 1-1 1zm2.9 0c-.5 0-1-.5-1-1s.5-1 1-1 .9.5.9 1-.4 1-.9 1z"
      }
    },
    file: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M7 15.1V7.4c-.8 0-1.5.7-1.5 1.5V18c0 .8.7 1.4 1.5 1.4h7.2c.8 0 1.4-.6 1.4-1.4H9.8C8.3 18 7 18 7 15.1zm11-6.2h-2.4c-.8 0-1.4-.7-1.4-1.5V5c0-.2-.3-.4-.5-.4H9.8c-.8 0-1.4.6-1.4 1.4v9.1c0 .8.6 1.5 1.4 1.5H17c.8 0 1.5-.7 1.5-1.5V9.4c0-.3-.2-.5-.5-.5zm.4-2l-2.2-2.2c-.1-.1-.2-.1-.3-.1-.2 0-.3.1-.3.3v1.6c0 .5.4.9 1 .9h1.5c.2 0 .4-.1.4-.3 0-.1 0-.2-.1-.2z"
      }
    },
    flow: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M19.2 7.4C18.6 6.1 17 3.9 14 5.2c-1.8.8-2.8 1.3-2.8 1.3L8.5 7.7c-.7.3-2.4-.2-3.3-.5-.2-.1-.5.2-.4.5.7 1.2 2.3 3.5 5.2 2.1 1.8-.8 5.5-2.4 5.5-2.4.7-.4 2.4.1 3.3.5.3 0 .5-.2.4-.5zm-6.4 3.8c-.3.2-1.6.8-1.6.8l-1.3.6c-.7.4-2.1-.1-2.9-.5-.3-.1-.5.2-.4.5.6 1.2 2 3.3 4.6 2 1.6-.8 2.9-1.3 2.9-1.3.7-.4 2.1.1 2.9.4.3.1.5-.2.4-.4-.6-1.2-2-3.4-4.6-2.1zm-.9 5.3c-.3.2-.7.5-.7.5-.5.3-1.6-.1-2.2-.4-.2-.1-.4.2-.3.4.4 1.1 1.5 3 3.4 1.8l.7-.4c.6-.3 1.6.1 2.2.4.2.1.4-.2.3-.5-.4-1-1.4-2.9-3.4-1.8z"
      }
    },
    folder: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18 8.3h-6.8c-.4 0-.8-.2-1.1-.6l-1-1.8c-.2-.4-.6-.6-1.1-.6H6c-.7 0-1.2.5-1.2 1.2v11c0 .7.5 1.2 1.2 1.2h12c.7 0 1.2-.5 1.2-1.2V9.6c0-.7-.5-1.3-1.2-1.3zm0-2.4h-7.2c-.1 0-.2.1-.1.2l.4.8c.1.1.2.2.3.2H18c.3 0 .7.1.9.2.2.1.3 0 .3-.2 0-.7-.5-1.2-1.2-1.2z"
      }
    },
    forecasts: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.6 7s-.8-1.7-2.7-1.7-2.7 1.8-2.7 1.8c-1.3-.6-2.4 0-2.4 0s-.9-1.8-2.7-1.8S5.4 7 5.4 7s-1.8 3.9-1.8 7.4c-.1 3.5 2.2 4.3 3.3 4.3 1.2 0 4.1-.5 3.9-4.4 0 0 .3-.7 1.1-.7 1 0 1.3.7 1.3.7-.1 3.9 2.7 4.4 3.9 4.4 1 0 3.4-.8 3.3-4.3 0-3.5-1.8-7.4-1.8-7.4zM7.2 17.2c-1.2 0-2.1-1-2.1-2.1S6 13 7.2 13s2 .9 2 2.1-.9 2.1-2 2.1zm9.6 0c-1.1 0-2-1-2-2.1s.9-2.1 2-2.1 2.1.9 2.1 2.1-.9 2.1-2.1 2.1z"
      }
    },
    generic_loading: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "opacity": ".15",
        "d": "M12.4 5.3h-.8c-.2 0-.3.1-.3.3v3.2c0 .2.1.3.3.3h.8c.2 0 .3-.1.3-.3V5.6c0-.2-.1-.3-.3-.3zm6 6h-3.2c-.2 0-.3.1-.3.3v.8c0 .2.1.3.3.3h3.2c.2 0 .3-.1.3-.3v-.8c0-.2-.1-.3-.3-.3zm-6 3.6h-.8c-.2 0-.3.1-.3.3v3.2c0 .2.1.3.3.3h.8c.2 0 .3-.1.3-.3v-3.2c0-.2-.1-.3-.3-.3zm-3.3-2.5v-.8c0-.2-.1-.3-.3-.3H5.6c-.2 0-.3.1-.3.3v.8c0 .2.1.3.3.3h3.2c.2 0 .3-.1.3-.3zm5.2-2.2c.1.2.3.2.5 0L17 8c.1-.1.1-.3 0-.5l-.5-.5c-.2-.1-.4-.1-.5 0l-2.2 2.2c-.2.2-.2.4 0 .5l.5.5zm.5 3.6c-.1-.2-.4-.2-.5 0l-.5.5c-.1.1-.1.3 0 .5L16 17c.2.1.4.1.5 0l.5-.5c.2-.2.2-.4 0-.5l-2.2-2.2zm-5.1 0c-.1-.2-.3-.2-.5 0L7 16c-.1.1-.1.3 0 .5l.5.5c.2.1.4.1.5 0l2.2-2.2c.2-.2.2-.4 0-.5l-.5-.5zM8 7c-.1-.2-.3-.2-.5 0l-.5.5c-.1.1-.1.3 0 .5l2.2 2.2c.2.1.4.1.5 0l.5-.5c.2-.1.2-.4 0-.5L8 7z"
      }
    },
    goals: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M6.2 4.8c-.8 0-1.4.6-1.4 1.4 0 .5.2.9.5 1.1v10.9c0 .6.4 1 .9 1s1-.4 1-1V7.3c.3-.2.5-.6.5-1.1 0-.8-.7-1.4-1.5-1.4zm12.2 2.6c-3.8 2-5.9-1.4-9.4-.1-.2 0-.4.2-.4.4v6.2c0 .3.4.6.7.5 3.4-1.1 5.5 2.2 9.2.1.1-.1.2-.2.2-.4V7.6c0-.2-.2-.3-.3-.2zm-1.1 3.3c-.5.1-.9.1-1.4.1h-.1v1.4h.1c.5 0 .9 0 1.4-.1v1.4c-.5.2-.9.2-1.4.2h-.1v-1.4c-.4 0-.9-.1-1.4-.2v1.4c-.3 0-.7-.1-1-.2-.2-.1-.3-.1-.4-.2v-1.4c-.6-.2-1-.3-1.5-.4v1.5c-.2-.1-.5-.1-.8-.1-.2 0-.4 0-.6.1v-1.5h1.4V10c-.2-.1-.5-.1-.8-.1h-.6V8.5c.2-.1.4-.1.6-.1.3 0 .6.1.8.1V10c.4.1.7.2 1.3.3 0 .1.1.1.2.1V9c.4.1.9.2 1.4.3v1.4c.5.1.9.1 1.4.1V9.4h.1c.5 0 .9 0 1.4-.1v1.4zm-4.3-.3v1.3c.1 0 .2.1.3.1.4.1.7.2 1.1.3v-1.4c-.5-.1-1-.2-1.4-.3z"
      }
    },
    group_loading: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "opacity": ".5",
        "d": "M8.8 12.6c-.4-.7-.6-1.4-.6-2.3 0-1.4.6-2.6 1.5-3.3-.3-.6-.9-1-1.8-1-1.4 0-2.1 1.1-2.1 2.4 0 .7.2 1.3.7 1.7.2.2.4.6.4.9 0 .3-.1.6-.9 1-1.1.5-2.1 1.1-2.2 2.2 0 .7.5 1.2 1.1 1.2H6c.1 0 .3-.1.4-.3.5-.9 1.4-1.5 2.2-1.9.3-.1.4-.4.2-.6zM18 12c-.8-.4-.9-.7-.9-1 0-.3.2-.7.4-.9.5-.4.7-1 .7-1.7 0-1.3-.7-2.4-2.1-2.4-.9 0-1.5.4-1.8 1 .9.7 1.5 1.9 1.5 3.3 0 .9-.2 1.6-.6 2.3-.2.2-.1.5.2.7.8.4 1.7.9 2.2 1.8.1.2.3.3.4.3h1.1c.6 0 1.1-.5 1.1-1.2-.1-1.1-1.1-1.7-2.2-2.2zm-3.9 2.3c-.9-.4-1-.7-1-1.1 0-.4.2-.7.5-1 .5-.4.8-1.1.8-1.9 0-1.4-.8-2.6-2.4-2.6s-2.4 1.2-2.4 2.6c0 .8.3 1.4.8 1.9.3.3.5.6.5 1s-.1.7-.9 1.1c-1.3.5-2.5 1.1-2.6 2.3 0 .7.6 1.4 1.3 1.4h6.6c.7 0 1.3-.7 1.3-1.4-.1-1.2-1.3-1.8-2.5-2.3z"
      }
    },
    groups: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M8.8 12.6c-.4-.7-.6-1.4-.6-2.3 0-1.4.6-2.6 1.5-3.3-.3-.6-.9-1-1.8-1-1.4 0-2.1 1.1-2.1 2.4 0 .7.2 1.3.7 1.7.2.2.4.6.4.9 0 .3-.1.6-.9 1-1.1.5-2.1 1.1-2.2 2.2 0 .7.5 1.2 1.1 1.2H6c.1 0 .3-.1.4-.3.5-.9 1.4-1.5 2.2-1.9.3-.1.4-.4.2-.6zM18 12c-.8-.4-.9-.7-.9-1 0-.3.2-.7.4-.9.5-.4.7-1 .7-1.7 0-1.3-.7-2.4-2.1-2.4-.9 0-1.5.4-1.8 1 .9.7 1.5 1.9 1.5 3.3 0 .9-.2 1.6-.6 2.3-.2.2-.1.5.2.7.8.4 1.7.9 2.2 1.8.1.2.3.3.4.3h1.1c.6 0 1.1-.5 1.1-1.2-.1-1.1-1.1-1.7-2.2-2.2zm-3.9 2.3c-.9-.4-1-.7-1-1.1 0-.4.2-.7.5-1 .5-.4.8-1.1.8-1.9 0-1.4-.8-2.6-2.4-2.6s-2.4 1.2-2.4 2.6c0 .8.3 1.4.8 1.9.3.3.5.6.5 1s-.1.7-.9 1.1c-1.3.5-2.5 1.1-2.6 2.3 0 .7.6 1.4 1.3 1.4h6.6c.7 0 1.3-.7 1.3-1.4-.1-1.2-1.3-1.8-2.5-2.3z"
      }
    },
    hierarchy: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M11.1 11.1h-4c-.3 0-.5.2-.5.5V15H5.2c-.2 0-.4.2-.4.4v3.4c0 .2.2.4.4.4h4.5c.3 0 .5-.2.5-.4v-3.4c0-.2-.2-.4-.5-.4H8.4v-2.1h7.2V15h-1.3c-.3 0-.5.2-.5.4v3.4c0 .2.2.4.5.4h4.5c.2 0 .4-.2.4-.4v-3.4c0-.2-.2-.4-.4-.4h-1.4v-3.4c0-.3-.2-.5-.5-.5h-4V9h1.3c.3 0 .5-.2.5-.4V5.3c0-.3-.2-.5-.5-.5H9.7c-.2 0-.4.2-.4.5v3.3c0 .2.2.4.4.4h1.4v2.1z"
      }
    },
    home: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.9 12.3h-1.5v6.6c0 .2-.1.3-.3.3h-3c-.2 0-.3-.1-.3-.3v-5.1h-3.6v5.1c0 .2-.1.3-.3.3h-3c-.2 0-.3-.1-.3-.3v-6.6H5.1c-.1 0-.3-.1-.3-.2s0-.2.1-.3l6.9-7c.1-.1.3-.1.4 0l7 7v.3c0 .1-.2.2-.3.2z"
      }
    },
    household: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12.4 4.9c-.3-.1-.6-.1-.8 0L5 11.1c-.4.3-.2.9.3.9h.9v5.8c0 .8.7 1.4 1.5 1.4h8.6c.8 0 1.5-.6 1.5-1.4V12h.9c.5 0 .7-.6.3-.9l-6.6-6.2zM8.9 15.3c-.1.1-.2.1-.3.1H8c-.3 0-.6-.2-.6-.6.1-.6.6-.9 1.3-1.1.4-.2.5-.4.5-.6 0-.2-.2-.4-.3-.5-.3-.2-.4-.6-.4-1 0-.7.5-1.3 1.2-1.3.5 0 .8.2 1 .5-.5.5-.9 1.1-.9 1.9 0 .5.2.9.4 1.3.1.1 0 .3-.1.3-.4.2-1 .5-1.2 1zm4.9 1.7h-3.6c-.4 0-.7-.3-.7-.8 0-.6.7-1 1.3-1.3.5-.2.6-.4.6-.6 0-.2-.1-.4-.3-.5-.3-.3-.4-.6-.4-1.1 0-.8.5-1.5 1.3-1.5s1.4.7 1.4 1.5c0 .5-.2.8-.5 1.1-.1.1-.3.3-.3.5s.1.4.6.6c.7.3 1.4.7 1.4 1.3-.1.5-.4.8-.8.8zm2.2-1.6h-.6c-.1 0-.2 0-.3-.1-.2-.5-.8-.7-1.2-.9-.1-.1-.2-.2-.1-.4.2-.3.4-.8.4-1.2 0-.8-.4-1.5-.9-1.9.2-.3.5-.6 1-.6.8 0 1.2.7 1.2 1.4 0 .4-.1.7-.4.9-.1.2-.2.4-.2.6s0 .3.5.5c.6.3 1.2.6 1.2 1.1 0 .4-.3.6-.6.6z"
      }
    },
    insights: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.8 6.5H7.4c-.2 0-.4.1-.4.4v8.4c0 .3-.3.6-.6.6-.3-.1-.5-.3-.5-.6V9.2c0-.1-.1-.2-.3-.2h-.4c-.2 0-.4.1-.4.4v7c0 .6.5 1.1 1.1 1.1h12.2c.6 0 1.1-.5 1.1-1.1V6.9c0-.3-.2-.4-.4-.4zm-6.2 8c0 .2-.2.3-.3.3H9c-.2 0-.3-.1-.3-.3v-.6c0-.1.1-.2.3-.2h3.3c.1 0 .3.1.3.2v.6zm0-2.2c0 .2-.2.3-.3.3H9c-.2 0-.3-.1-.3-.3v-.6c0-.1.1-.3.3-.3h3.3c.1 0 .3.2.3.3v.6zm4.9 2.2c0 .2-.1.3-.2.3h-3.4c-.1 0-.2-.1-.2-.3v-.6c0-.1.1-.2.2-.2h3.4c.1 0 .2.1.2.2v.6zm0-2.2c0 .2-.1.3-.2.3h-3.4c-.1 0-.2-.1-.2-.3v-.6c0-.1.1-.3.2-.3h3.4c.1 0 .2.2.2.3v.6zm0-2.2c0 .1-.1.2-.2.2H9c-.2 0-.3-.1-.3-.2V8.4c0-.2.1-.3.3-.3h8.3c.1 0 .2.1.2.3v1.7z"
      }
    },
    investment_account: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.8 6.5H6.2c-.8 0-1.4.6-1.4 1.4v8.2c0 .8.6 1.4 1.4 1.4h11.6c.8 0 1.4-.6 1.4-1.4V7.9c0-.8-.6-1.4-1.4-1.4zM16.6 13c0 .2-.3.3-.4.1L15 12l-2.5 2.2c-.3.3-.7.3-1 0L10 12.5l-2.8 2.4c-.1.1-.2.1-.3 0l-.1-.2c-.1-.1-.1-.2 0-.3l2.7-3.7c.2-.3.7-.3 1 0l1.5 1.6 1.6-1.8-1-.9c-.2-.2-.1-.5.1-.5h3.4c.2 0 .4.3.4.5V13z"
      }
    },
    iot_orchestrations: {
      "xmlns": "http://www.w3.org/2000/svg",
      "g": {
        "fill": "#FFF",
        "fill-rule": "evenodd",
        "circle": [{
          "cx": "9.36",
          "cy": "7.68",
          "r": "2.88"
        }, {
          "cx": "16.8",
          "cy": "12",
          "r": "2.88"
        }],
        "path": {
          "fill-rule": "nonzero",
          "d": "M9.4 17.8c.8 0 1.4-.7 1.4-1.5s-.6-1.4-1.4-1.4-1.5.6-1.5 1.4.7 1.5 1.5 1.5zm0 1.4c-1.6 0-2.9-1.3-2.9-2.9s1.3-2.9 2.9-2.9 2.8 1.3 2.8 2.9-1.2 2.9-2.8 2.9zM11 9.9c.8 1.1 2 1.7 3.4 1.9.2 0 .5-.2.5-.5 0-.2-.2-.5-.4-.5-1.2-.1-2.1-.6-2.8-1.5-.1-.2-.4-.2-.7-.1-.2.2-.2.5 0 .7zM6.7-12.5c.5-1.2.5-2.5.1-3.8-.1-.3-.4-.4-.6-.3-.3.1-.4.4-.3.6.4 1.1.3 2.1-.1 3.1-.1.3 0 .6.2.7.3.1.6 0 .7-.3zm4.8 18.7c.9-.5 1.9-.6 2.8-.2 1 .4 1.6 1.2 1.9 2 .1.4.1.6.1 1.5 0 .3.2.5.5.5s.5-.2.5-.5c0-1-.1-1.3-.2-1.8-.3-1-1.1-2-2.4-2.6-1.3-.5-2.5-.4-3.7.2-.2.2-.3.5-.1.7.1.2.4.3.6.2zm0 11.6c.9.5 1.9.6 2.8.2 1-.4 1.6-1.2 1.9-2 .1-.4.1-.6.1-1.5 0-.2.2-.5.5-.5s.5.3.5.5c0 1-.1 1.3-.2 1.8-.3 1-1.1 2-2.4 2.6-1.3.5-2.5.4-3.7-.2-.2-.2-.3-.5-.1-.7.1-.2.4-.3.6-.2z"
        }
      }
    },
    lead: {
      "xmlns": "http://www.w3.org/2000/svg",
      "circle": {
        "cx": "12",
        "cy": "6.96",
        "r": "2.16"
      },
      "path": {
        "d": "M18.7 10.6H5.3c-.5 0-.7.6-.3.8l3.5 2.3c.2.1.3.3.2.5l-1.3 4.4c-.2.5.5.8.8.5l3.4-3.6c.2-.3.6-.3.8 0l3.4 3.6c.3.3.9 0 .8-.5l-1.3-4.4c-.1-.2 0-.4.2-.5l3.5-2.3c.4-.2.2-.8-.3-.8z"
      }
    },
    lead_insights: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M12 5.3a6.7 6.7 0 1 0 0 13.4 6.7 6.7 0 0 0 0-13.4zm0 12.6c-3.3 0-5.9-2.6-5.9-5.9 0-3.3 2.6-5.9 5.9-5.9 3.3 0 5.9 2.6 5.9 5.9 0 3.3-2.6 5.9-5.9 5.9z"
      }, {
        "d": "M11.8 11.8c0 .6-.2 1.1-.4 1.5-.2.4-.5.7-1 1-.4.2-.9.3-1.5.3v-.5c.7 0 1.2-.2 1.6-.5s.6-.7.7-1.3c-.4.4-.9.6-1.4.6-.3 0-.5-.1-.8-.2s-.4-.3-.5-.6c-.2-.2-.2-.5-.2-.8 0-.3.1-.6.2-.8.1-.3.3-.5.6-.6.3-.2.6-.3.9-.3.6 0 1.1.2 1.4.6s.4.9.4 1.6zm-.6-.1c0-.5-.1-.9-.3-1.2-.1-.3-.5-.4-.9-.4-.3 0-.6.1-.8.3-.2.2-.3.5-.3.9s.1.6.3.8c.2.2.4.3.8.3.2 0 .4-.1.7-.2s.3-.3.5-.5zm4.7.1c0 .6-.2 1.1-.4 1.5-.2.4-.5.7-1 1-.4.2-.9.3-1.5.3v-.5c.7 0 1.2-.2 1.6-.5s.6-.7.7-1.3c-.4.4-.9.6-1.4.6-.3 0-.5-.1-.8-.2s-.4-.3-.5-.6c-.2-.2-.2-.5-.2-.8 0-.3.1-.6.2-.8.1-.3.3-.5.6-.6.3-.2.6-.3.9-.3.6 0 1.1.2 1.4.6s.4.9.4 1.6zm-.6-.1c0-.5-.1-.9-.3-1.2-.2-.3-.5-.4-.9-.4-.3 0-.6.1-.9.3-.1.2-.2.5-.2.9s.1.6.2.8c.2.2.5.3.8.3.3 0 .5-.1.7-.2s.4-.3.6-.5z"
      }]
    },
    lead_list: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M8.9 15h9.6c.2 0 .5.2.5.4v1c0 .3-.3.5-.5.5H8.9c-.3 0-.5-.2-.5-.5v-1c0-.2.2-.4.5-.4zM6 16.9H5c-.2 0-.4-.2-.4-.5v-1c0-.2.2-.4.4-.4h1c.3 0 .5.2.5.4v1c0 .2-.2.4-.5.5zm0-4.3H5c-.2 0-.4-.2-.4-.5v-1c0-.2.2-.4.4-.4h1c.3 0 .5.2.5.4v1c0 .2-.2.5-.5.5zm0-4.3H5c-.2 0-.4-.2-.4-.5v-1c0-.2.2-.4.4-.4h1c.3 0 .5.2.5.4v1c0 .2-.2.5-.5.5zm2.9 2.4h8.4c.3 0 .5.2.5.4v1c0 .3-.2.5-.5.5H8.9c-.3 0-.5-.2-.5-.5v-1c0-.2.2-.4.5-.4zm0-4.3h9.6c.2 0 .5.2.5.5v.9c0 .3-.3.5-.5.5H8.9c-.3 0-.5-.2-.5-.5v-.9c0-.3.2-.5.5-.5z"
      }
    },
    link: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12.4 16.7c-.3-.1-.4-.1-.7-.1-.2-.1-.4-.1-.6-.2-.1-.1-.3 0-.4.1l-.1.1c-.9.9-2.3 1-3.2.2-1-.9-1.1-2.4-.1-3.4l2.3-2.3c.2-.3.6-.5 1-.6.5-.1 1-.1 1.4.1.3.2.6.3.8.5.1.2.2.3.3.4.1.2.4.3.5.1l.9-.8c.1-.1.1-.3 0-.5-.1-.1-.3-.3-.4-.5-.2-.2-.5-.4-.7-.5-.5-.3-.9-.5-1.4-.6-1-.2-2 0-2.8.4-.4.2-.7.5-1 .7L6 12c-1.6 1.6-1.7 4.2-.2 5.8 1.6 1.8 4.3 1.8 6 .2l.7-.8c.3-.2.1-.5-.1-.5zm5.5-10.8c-1.7-1.5-4.2-1.4-5.8.2l-.7.6c-.2.2-.1.6.2.6.4 0 .9.1 1.3.3.1 0 .3 0 .3-.1l.2-.2c.9-.8 2.2-.9 3.2-.1 1 .9 1 2.4.1 3.3l-2.3 2.3c-.3.3-.6.5-1 .6-.5.1-1 .1-1.4-.1-.3-.1-.6-.3-.8-.5-.1-.1-.2-.2-.3-.4-.1-.2-.4-.2-.6 0l-.8.8c-.1.1-.1.3 0 .5.1.1.2.3.4.4.2.3.4.4.7.6.4.3.9.4 1.4.5.9.2 1.9.1 2.8-.4.3-.2.7-.4.9-.7l2.3-2.3c1.6-1.6 1.6-4.3-.1-5.9z"
      }
    },
    list_email: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M15.6 8.4H7.3c-.7 0-1.2.5-1.2 1.1v.2c0 .1.1.2.2.2H14c.7 0 1.2.5 1.2 1.2v5.5c0 .1.1.2.2.2h.2c.6 0 1.1-.6 1.1-1.2V9.5c0-.6-.5-1.1-1.1-1.1zm2.5-2.5H9.8c-.7 0-1.2.5-1.2 1.2v.1c0 .1.1.2.2.2h7.7c.7 0 1.2.6 1.2 1.2v5.5c0 .1.1.2.2.2h.1c.7 0 1.2-.5 1.2-1.1V7.1c0-.7-.5-1.2-1.1-1.2zm-8.9 9.5c.2.1.3.1.4 0l4.4-4.1c.1-.1.1-.4-.2-.4H5.1c-.2 0-.4.3-.3.5l4.4 4zm4.9-2.5c0-.2-.2-.3-.4-.2l-3.4 3.2c-.2.2-.5.3-.8.3-.4 0-.6-.1-.9-.3l-3.4-3.2c-.1-.1-.4 0-.4.2v4.4c0 .5.4.8.8.8h7.7c.5 0 .8-.4.8-.8v-4.4z"
      }
    },
    live_chat: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M11.9 5.3c-4 0-7.2 2.9-7.2 6.5 0 1.2.3 2.3.8 3.2.1.2.2.4.1.5l-.9 2.6c-.1.2.1.5.4.4l2.6-1c.1-.1.3 0 .5.1 1.1.6 2.4.9 3.8.9 3.9 0 7.1-2.9 7.1-6.6 0-3.7-3.2-6.6-7.2-6.6zm-3.6 7.8c-.7 0-1.2-.6-1.2-1.2 0-.7.5-1.2 1.2-1.2s1.2.5 1.2 1.2-.6 1.2-1.2 1.2zm3.6 0c-.7 0-1.2-.6-1.2-1.2 0-.7.5-1.2 1.2-1.2s1.2.5 1.2 1.2-.5 1.2-1.2 1.2zm3.6 0c-.7 0-1.2-.6-1.2-1.2 0-.7.6-1.2 1.2-1.2s1.2.5 1.2 1.2-.5 1.2-1.2 1.2z"
      }
    },
    location: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.6 6.8l-4.3-2.2a.8.8 0 0 0-.6 0l-4 2-4.1-2a.7.7 0 0 0-.7.1.7.7 0 0 0-.3.6v10.8a.7.7 0 0 0 .4.6l4.3 2.1a.8.8 0 0 0 .6 0l4-2 4 2a.6.6 0 0 0 .3.1.7.7 0 0 0 .4-.1.7.7 0 0 0 .4-.6V7.4a.7.7 0 0 0-.4-.6zm-1.1 1.4v5.7a.4.4 0 0 1-.6.4c-1.2-.4-.3-2.3-1.1-3.3-.7-.9-1.7 0-2.6-1.4-.9-1.4.3-2.5 1.4-3a.5.5 0 0 1 .4 0l2.2 1.1a.5.5 0 0 1 .3.5zm-6.1 8.3a.5.5 0 0 1-.5-.1 1.6 1.6 0 0 1-.6-1.1c0-.7-1.2-.4-1.2-1.9 0-1.2-1.3-1.5-2.5-1.3a.5.5 0 0 1-.5-.5V7.2a.4.4 0 0 1 .6-.4l2.6 1.3a.1.1 0 0 1 .1 0l.1.1c1.1.6.8 1.1.4 1.9-.5.9-.7 0-1.4-.3s-1.5.3-1.2.8.9 0 1.4.4.5 1.2 1.9.8 1.7-.3 2.2.2a1.5 1.5 0 0 1 0 2.2c-.4.4-.6 1.3-.8 1.9a.5.5 0 0 1-.2.3z"
      }
    },
    log_a_call: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M16.7 4.8h-9c-.8 0-1.5.7-1.5 1.4v.5h-.4c-.6 0-1 .5-1 1s.4.9 1 .9h.4V11h-.4c-.6 0-1 .5-1 1s.4 1 1 1h.4v2.4h-.4c-.6 0-1 .4-1 .9s.4 1 1 1h.4v.5c0 .7.7 1.4 1.5 1.4h9c.8 0 1.5-.7 1.5-1.5V6.2c0-.8-.7-1.4-1.5-1.4zm-.8 9.7l-.7.6c-.2.2-.4.3-.6.3-1.5-.1-3-.9-4.1-1.9-1-1-1.8-2.5-1.8-4.1 0-.2 0-.4.2-.6l.7-.6c.3-.4.8-.3 1.1 0l.6.8c.2.3.2.6 0 .9l-.5.8c-.1.1-.1.2 0 .3l1.1 1.2 1.2 1.1c.1.1.2.1.3 0l.8-.5c.2-.2.6-.2.9 0l.8.6c.3.2.3.8 0 1.1z"
      }
    },
    macros: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M15.5 16.2c0 .1-.1.1-.3.1h-1.4c-.1 0-.2-.1-.2-.2l.1-.1v-.1l3.1-3.7c.1-.1.1-.3 0-.4L13.7 8c-.1-.1-.1-.1-.1-.2s.2-.2.2-.2h1.4c.2 0 .3.1.3.2l3.3 4c.1 0 .1.1.1.2s-.1.1-.1.2l-3.3 4zm-3.4 0c-.1.1-.2.1-.3.1h-1.4c-.1 0-.2-.1-.2-.2V16l.1-.1 3-3.7c.1-.1.2-.3.1-.4L10.2 8v-.2c0-.1.1-.2.2-.2h1.4c.1 0 .2.1.3.2l3.3 4v.4l-3.3 4zm-3.5 0c0 .1-.1.1-.2.1H5.7c-.1 0-.2-.1-.2-.2V16h.1v-.1l3.1-3.7c.1-.1.1-.3 0-.4L5.6 8c-.1-.1-.1-.1-.1-.2s.1-.2.2-.2h2.6c.1 0 .3.1.3.2l3.3 4c.1 0 .1.1.1.2s-.1.1-.1.2l-3.3 4z"
      }
    },
    maintenance_asset: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M11.2 7.3c0 .1.1.2.2.2H18c.3 0 .7.1 1 .2.1.1.2 0 .2-.2 0-.7-.5-1.2-1.2-1.2h-7.2c-.1 0-.1 0-.1.1v.1l.5.8zM18 8.7h-6.8c-.4 0-.8-.2-1-.6L9.1 6.3c-.2-.4-.6-.6-1-.6H6c-.6 0-1.2.5-1.2 1.2v11c0 .7.5 1.2 1.2 1.2h12c.7 0 1.2-.5 1.2-1.2V10c0-.7-.5-1.2-1.2-1.3zm-3.1 8c-.3.3-.7.3-1 .1v-.1l-2.4-2.3c-.1 0-.3 0-.5.1-1 .1-1.9-.7-2-1.7v-.2-.5c.1 0 .1-.1.2-.1v.1l1 1c.1.1.3.1.3 0l.8-.7v-.3l-1.1-1v-.2h.1c.1-.1.3-.1.5-.1 1 0 1.8.8 1.8 1.9v.2c0 .1 0 .3-.1.4l2.4 2.4c.3.3.3.7.1 1-.1 0-.1.1-.1 0z"
      }
    },
    maintenance_plan: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M15.8 8.2h1.9c.2 0 .4-.2.4-.4 0-.1-.1-.3-.1-.3l-2.8-2.7c0-.1-.1-.1-.2-.1-.2 0-.4.2-.4.4V7c0 .6.5 1.1 1.2 1.2zm1.6 1.6h-2.9c-.9 0-1.7-.7-1.7-1.7V5.2c0-.3-.2-.5-.5-.5H7.6c-1 0-1.7.7-1.8 1.7v11c0 .9.8 1.7 1.8 1.7h8.7c.9 0 1.7-.8 1.7-1.7v-7c0-.3-.2-.6-.6-.6zm-1.6 7.4c-.2.2-.4.3-.7.3-.3 0-.6-.1-.7-.3L11 13.9c-.2.1-.4.2-.6.2-1.4.2-2.7-.9-2.8-2.2-.1-.4 0-.8.1-1.1 0-.1.1-.1.2 0l1.4 1.4c.1.1.3.1.4 0l1.1-1c.1-.1.1-.3 0-.4L9.3 9.3v-.2h.1c.2-.1.5-.1.7-.1 1.4 0 2.5 1.1 2.6 2.5 0 .1 0 .2-.1.3 0 .3 0 .5-.1.7l3.3 3.3c.4.4.4 1 0 1.4z"
      }
    },
    marketing_actions: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M11.4 6.2c-1.2.1-2.2 1.1-2.3 2.3.1-1.2 1.1-2.2 2.3-2.3zm2.5 2.3c-.1-1.2-1-2.2-2.3-2.3 1.3.1 2.3 1.1 2.3 2.3zm1.4 4.7l-2.5-.9c-.2-.1-.3-.2-.3-.4V8.6c0-.5-.4-.9-.9-.9h-.1c-.5 0-.9.4-.9.9V15c0 .6-.7.8-1 .3L9 14c-.4-.6-1.1-.7-1.7-.3L7 14l2 4.9c.1.2.3.3.6.3H15c.2 0 .5-.2.5-.4l1-3.5c.2-.9-.3-1.8-1.2-2.1zm-6.2-2.1V8.5c.1-1.2 1.1-2.2 2.3-2.3h.2c1.3.1 2.2 1.1 2.3 2.3v2.6c0 .2.3.3.4.2.7-.7 1.1-1.7 1.1-2.7 0-2.2-2-4-4.2-3.8C9.4 5 8 6.3 7.7 8c-.2 1.2.2 2.4 1 3.3.2.1.4 0 .4-.2z"
      }
    },
    merge: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M16.9 17.4c-1.7-.8-2.9-2.3-3.5-3.9-.2-.6-.3-1.3-.4-1.9v-1.1h3.2c.3 0 .5-.3.3-.5l-4.3-5.1c-.1-.2-.4-.2-.6 0L7.5 10c-.2.2 0 .5.2.5H11v1.1c-.1.6-.2 1.3-.4 1.9-.7 1.6-1.8 3.1-3.5 3.9-.3.1-.4.4-.3.6l.4.9c.1.3.4.4.7.2 1.8-.8 3.2-2.2 4.1-3.9.9 1.7 2.3 3.1 4.2 3.9.2.1.5.1.6-.2l.4-.9c.1-.2 0-.5-.3-.6z"
      }
    },
    messaging_conversation: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "fill": "#FFF",
        "d": "M13.1 17.1c2.6-.9 4.1-2.5 4.5-4.7 1.1.5 1.8 1.6 1.8 2.8 0 .6-.1 1.1-.3 1.5l.4 1.3c.1.3-.2.6-.5.5l-1.3-.5c-.5.3-1.1.5-1.7.5-1.2 0-2.2-.6-2.9-1.4zM10.6 5.3c3.2 0 5.8 2.4 5.8 5.4 0 3-2.6 5.4-5.8 5.4-1.1 0-2.2-.3-3-.8-.1-.1-.3-.1-.4-.1l-1.7.6c-.3.1-.6-.1-.5-.5l.6-1.7c0-.1 0-.2-.1-.3-.4-.8-.7-1.7-.7-2.6 0-3 2.6-5.4 5.8-5.4zM7.7 8.9c-.3 0-.5.2-.5.5v.4c0 .3.2.5.5.5h6.2c.3 0 .5-.2.5-.5v-.4c0-.3-.2-.5-.5-.5H7.7zm0 2.6c-.3 0-.5.2-.5.5v.5c0 .2.2.5.5.5H11c.3 0 .5-.3.5-.5V12c0-.3-.2-.5-.5-.5H7.7z"
      }
    },
    messaging_session: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "fill": "#FFF",
        "d": "M12 5.3c4 0 7.2 3 7.2 6.7S16 18.7 12 18.7c-1.4 0-2.7-.3-3.8-1-.1-.1-.2-.1-.4 0l-2.1.7c-.4.1-.7-.2-.6-.6l.7-2.1c0-.1 0-.3-.1-.4-.6-1-.9-2.1-.9-3.3C4.8 8.3 8 5.3 12 5.3zm3.1 5.5c.2 0 .3-.1.3-.2V9.1c0-.1-.1-.2-.3-.2H8.9c-.2 0-.3.1-.3.2v1.5c0 .1.1.2.3.2h6.2zm-4.8 4.8c.2 0 .3-.1.3-.2v-2.9c0-.2-.1-.3-.3-.3H8.9c-.2 0-.3.1-.3.3v2.9c0 .1.1.2.3.2h1.4zm4.8 0c.2 0 .3-.1.3-.2v-2.9c0-.2-.1-.3-.3-.3h-2.9c-.1 0-.2.1-.2.3v2.9c0 .1.1.2.2.2h2.9z"
      }
    },
    messaging_user: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "fill": "#FFF",
        "d": "M12 5.3c4 0 7.2 3 7.2 6.7S16 18.7 12 18.7c-1.4 0-2.7-.3-3.8-1-.1-.1-.2-.1-.4 0l-2.1.7c-.4.1-.7-.2-.6-.6l.7-2.1c0-.1 0-.3-.1-.4-.6-1-.9-2.1-.9-3.3C4.8 8.3 8 5.3 12 5.3zm2.1 10.1c.5 0 .8-.5.8-1 0-.8-.8-1.2-1.6-1.6-.6-.2-.6-.4-.6-.6 0-.3.1-.5.3-.7.4-.3.5-.7.5-1.2 0-.9-.5-1.7-1.5-1.7s-1.5.8-1.5 1.7c0 .5.2.9.5 1.2.2.2.3.4.3.7 0 .2-.1.4-.6.7-.8.3-1.6.7-1.6 1.5 0 .5.4 1 .8 1h4.2z"
      }
    },
    metrics: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.3 5.3H6.7c-.8 0-1.4.6-1.4 1.4v10.6c0 .8.6 1.4 1.4 1.4h10.6c.8 0 1.4-.6 1.4-1.4V6.7c0-.8-.6-1.4-1.4-1.4zM9.1 15.8c0 .3-.2.5-.5.5h-.4c-.3 0-.5-.2-.5-.5v-2.6c0-.3.2-.5.5-.5h.4c.3 0 .5.2.5.5v2.6zm2.4 0c0 .3-.2.5-.5.5h-.4c-.3 0-.5-.2-.5-.5V9.6c0-.3.2-.5.5-.5h.4c.3 0 .5.2.5.5v6.2zm2.4 0c0 .3-.2.5-.5.5H13c-.3 0-.5-.2-.5-.5V8.2c0-.3.2-.5.5-.5h.4c.3 0 .5.2.5.5v7.6zm2.4 0c0 .3-.2.5-.5.5h-.4c-.3 0-.5-.2-.5-.5v-4.5c0-.3.2-.5.5-.5h.4c.3 0 .5.2.5.5v4.5z"
      }
    },
    news: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.8 6.5H7.4c-.2 0-.4.1-.4.4v8.4c0 .3-.3.6-.6.6-.3-.1-.5-.3-.5-.6V9.2c0-.1-.1-.2-.3-.2h-.4c-.2 0-.4.1-.4.4v7c0 .6.5 1.1 1.1 1.1h12.2c.6 0 1.1-.5 1.1-1.1V6.9c0-.3-.2-.4-.4-.4zm-6.2 8c0 .2-.2.3-.3.3H9c-.2 0-.3-.1-.3-.3v-.6c0-.1.1-.2.3-.2h3.3c.1 0 .3.1.3.2v.6zm0-2.2c0 .2-.2.3-.3.3H9c-.2 0-.3-.1-.3-.3v-.6c0-.1.1-.3.3-.3h3.3c.1 0 .3.2.3.3v.6zm4.9 2.2c0 .2-.1.3-.2.3h-3.4c-.1 0-.2-.1-.2-.3v-.6c0-.1.1-.2.2-.2h3.4c.1 0 .2.1.2.2v.6zm0-2.2c0 .2-.1.3-.2.3h-3.4c-.1 0-.2-.1-.2-.3v-.6c0-.1.1-.3.2-.3h3.4c.1 0 .2.2.2.3v.6zm0-2.2c0 .1-.1.2-.2.2H9c-.2 0-.3-.1-.3-.2V8.4c0-.2.1-.3.3-.3h8.3c.1 0 .2.1.2.3v1.7z"
      }
    },
    note: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.1 16.1l-.3.2c-.2.3-.6.5-1.1.5H15c-.8 0-1.6-.6-1.6-1.6v-.7c0-.6.3-1 .5-1.2l3.2-3.2c.1-.1.2-.3.2-.4V7.2c0-.8-.7-1.4-1.5-1.4H8.2c-.8 0-1.5.7-1.5 1.4h-.5c-.5 0-.9.4-.9 1s.4.9.9.9h.5V11h-.5c-.5 0-.9.5-.9 1s.4 1 .9 1h.5v1.9h-.5c-.5 0-.9.4-.9.9s.4 1 .9 1h.5c0 1 .7 1.4 1.5 1.4h7.6c.8 0 1.5-.6 1.5-1.4v-.6c0-.2-.1-.2-.2-.1zm-2.5-6.7c0 .2-.2.4-.4.4H9.4c-.3 0-.5-.2-.5-.4v-.5c0-.3.2-.5.5-.5h4.8c.2 0 .4.2.4.5v.5zm-2.1 5.7c0 .3-.2.5-.5.5H9.4c-.3 0-.5-.2-.5-.5v-.5c0-.2.2-.4.5-.4H12c.3 0 .5.2.5.4v.5zm.7-2.9c0 .3-.2.5-.5.5H9.4c-.3 0-.5-.2-.5-.5v-.4c0-.3.2-.5.5-.5h3.3c.3 0 .5.2.5.5v.4zm6.3-1.3l-.3-.2c-.1-.2-.4-.2-.6 0l-3.7 3.7v.8c0 .1 0 .2.1.2h.7c.1 0 .1-.1.1-.1l3.7-3.7c.2-.2.2-.5 0-.7z"
      }
    },
    omni_supervisor: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M16.1 6.9c-1.5.7-2.3 2.2-2.4 4.6h2.4c.3-.8 1-1.4 1.9-1.4 1.1 0 1.9.8 1.9 1.9s-.8 1.9-1.9 1.9c-.9 0-1.6-.6-1.9-1.4h-2.4c.1 2.4.9 3.9 2.4 4.6.2-.9 1-1.5 1.9-1.5 1.1 0 1.9.9 1.9 1.9s-.8 1.9-1.9 1.9c-.9 0-1.6-.5-1.8-1.3-2.2-.7-3.4-2.6-3.5-5.6h-1.4c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h1.4c.1-3 1.3-4.9 3.5-5.6.2-.8.9-1.3 1.8-1.3 1.1 0 1.9.8 1.9 1.9s-.8 1.9-1.9 1.9c-.9 0-1.7-.6-1.9-1.5zm1.9.5c.5 0 1-.4 1-.9s-.5-1-1-1-1 .4-1 1 .5.9 1 .9zm0 11.1c.5 0 1-.4 1-1s-.5-.9-1-.9-1 .4-1 .9.5 1 1 1zm0-5.5c.5 0 1-.5 1-1s-.5-1-1-1-1 .5-1 1 .5 1 1 1zm-7.2 3.3H5.4c-.6 0-1.1-.6-1.1-1.2.1-1 1.1-1.5 2.1-1.9.7-.3.8-.6.8-.9 0-.3-.2-.6-.4-.8-.4-.4-.7-1-.7-1.6 0-1.2.8-2.2 2-2.2 1.3 0 2 1 2 2.2 0 .6-.2 1.2-.6 1.6-.3.2-.4.5-.4.8 0 .3.1.6.8.9 1 .4 2 .9 2.1 1.9-.1.6-.6 1.2-1.2 1.2z"
      }
    },
    operating_hours: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M12.7 12a.3.3 0 0 1-.1-.2v-2a.3.3 0 0 0-.3-.3h-.6a.3.3 0 0 0-.3.3v2.5a.4.4 0 0 0 .1.3l1.5 1.5a.3.3 0 0 0 .5 0l.4-.4a.3.3 0 0 0 0-.5zM12 6.9a5.1 5.1 0 1 0 5.1 5.1A5.1 5.1 0 0 0 12 6.9zm0 8.9a3.8 3.8 0 1 1 3.8-3.8 3.8 3.8 0 0 1-3.8 3.8zm-5.1-1.4a3.8 3.8 0 0 1 0-4.8l-.8-1a5 5 0 0 0 0 6.7zm10.2-4.8a3.8 3.8 0 0 1 0 4.8l.8 1a5 5 0 0 0 0-6.7z",
        "fill-rule": "evenodd"
      }
    },
    opportunity: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.1 16.6H6.9c-.2 0-.4.2-.4.4 0 .8.6 1.5 1.4 1.5h8.2c.8 0 1.4-.7 1.4-1.5 0-.2-.2-.4-.4-.4zm1.1-9.9c-.8 0-1.4.7-1.4 1.5 0 .4.2.8.5 1.1-.4.9-1.3 1.5-2.4 1.5-1.3-.1-2.3-1.1-2.4-2.4v-.6c.6-.2.9-.7.9-1.3 0-.8-.6-1.5-1.4-1.5s-1.4.7-1.4 1.5c0 .6.3 1.1.9 1.3v.6c-.1 1.3-1.1 2.3-2.4 2.4-1.1.1-2-.6-2.4-1.5.3-.3.5-.7.5-1.1 0-.8-.6-1.5-1.4-1.5s-1.5.7-1.5 1.5.7 1.4 1.5 1.4l.6 5.1c.1.3.2.4.5.4h10.2c.2 0 .4-.1.5-.4l.6-5.1c.8 0 1.5-.6 1.5-1.4s-.7-1.5-1.5-1.5z"
      }
    },
    opportunity_splits: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M16.6 6.5c-1.2-1.1-2.8-1.7-4.6-1.7C8 4.8 4.8 8 4.8 12c0 1.8.6 3.4 1.7 4.6L16.6 6.5zM8.2 18.1c1.1.7 2.4 1.1 3.8 1.1 4 0 7.2-3.2 7.2-7.2 0-1.4-.4-2.7-1.1-3.8l-9.9 9.9z"
      }
    },
    orders: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.9 14.9l-.9-.4c-.1-.1-.2-.1-.4 0l-5.1 2.4c-.3.2-.7.2-1 0l-5.1-2.4c-.2-.1-.3-.1-.4 0l-.9.4c-.4.2-.4.7 0 .9l6.4 3c.3.2.7.2 1 0l6.4-3c.4-.2.4-.7 0-.9zm0-3.4l-.9-.4h-.4l-5.1 2.5c-.3.1-.7.1-1 0l-5.1-2.5H6l-.9.4c-.4.2-.4.7 0 .9l6.4 3.1c.3.1.7.1 1 0l6.4-3c.4-.2.4-.8 0-1zM5.1 9.1l6.4 3c.3.2.7.2 1 0l6.4-3c.4-.2.4-.7 0-.9l-6.4-3.1c-.3-.1-.7-.1-1 0L5.1 8.2c-.4.2-.4.7 0 .9z"
      }
    },
    partner_fund_allocation: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M7.4 15.7l-1.9 2.1c-.1.1-.2 0-.2-.1v-.9c0-.1-.1-.3-.2-.3h-.4c-.1 0-.2.2-.2.3V19c0 .2.1.2.2.2H7c.1 0 .2 0 .2-.2v-.3c0-.1-.1-.2-.2-.2H6c-.1 0-.1-.1 0-.2l2.4-2.6h-1zm10.1 2.6c.1.1.1.2-.1.2h-.9c-.1 0-.2.1-.2.2v.3c0 .1.1.2.2.2h2.3c.1 0 .1 0 .1-.1v-2.3c0-.1 0-.2-.1-.2h-.4c-.1 0-.2.1-.2.2v.9c0 .1-.1.2-.2.1l-1.1-1c-.3.1-.6.1-.8.2l1.4 1.3zm-1-8.6C12.9 10.8 10 7.4 6 9c-.3.1-.5.4-.5.8v4.1c0 .6.5.9 1 .8 4-1.2 6.8 2.2 10.6.7.3-.2.5-.4.5-.8v-4.1c0-.5-.6-.9-1.1-.8zm-4.8 3.9c-.9 0-1.6-.7-1.6-1.6s.7-1.5 1.6-1.5 1.5.7 1.5 1.5-.7 1.6-1.5 1.6zm-.1-7.2c0-.1-.1-.2-.2-.1l-.6.7c-.1.1-.3 0-.3 0l-.3-.3v-.2l1.7-1.7h.2l1.6 1.7c.1 0 .1.1.1.2l-.3.3h-.3l-.6-.7c-.1-.1-.2 0-.2.1v1.7l-.8-.2V6.4z"
      }
    },
    partner_fund_claim: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M13.6 8.2h2.2c.2 0 .3-.2.3-.4v-.2l-2.9-2.7c0-.1-.1-.1-.2-.1-.2 0-.3.1-.3.3v2.2c0 .5.4.9.9.9zm-4.3 7.4c0-.8.4-1.6 1.2-1.9.6-.2 1.3-.4 1.9-.4 1 0 1.8.3 2.6.5.4.1.7.3 1.1.3l.1-4.3c0-.2-.2-.4-.5-.4h-3c-.7 0-1.2-.6-1.2-1.2v-3c0-.2-.2-.4-.5-.4H6.8c-.7 0-1.3.6-1.3 1.2v10.1c0 .7.6 1.3 1.3 1.3h2.5v-1.8zm8.1 0c-2.2.6-3.9-1.4-6.3-.4-.2 0-.3.2-.3.4v2.5c0 .3.3.5.6.4 2.4-.7 4.1 1.4 6.3.4.2 0 .3-.2.3-.4V16c0-.3-.3-.5-.6-.4zm-2.9 2.3c-.5 0-1-.4-1-.9s.4-1 1-1 .9.4.9 1-.4.9-.9.9z"
      }
    },
    partner_fund_request: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M10.5 14c.9-.5 1.7-.8 2.7-.8.2 0 .5.1.7.1.1 0 .2 0 0-.1-.4-.3-.9-.5-1.4-.7-1.1-.5-1.2-.8-1.2-1.3 0-.4.3-.8.6-1.1.6-.5.9-1.3.9-2.2 0-1.6-1-3.1-2.8-3.1S7.1 6.3 7.1 7.9c0 .9.3 1.7.9 2.2.4.3.7.7.7 1.1 0 .4-.2.8-1.2 1.3-1.5.6-2.9 1.3-2.9 2.7 0 .9.6 1.7 1.5 1.7h3.4c.2 0 .5-.2.5-.5v-1.6c0-.3.2-.6.5-.8zm7.8 1.4c-2.2.7-4-1.4-6.5-.4-.2.1-.3.2-.3.5V18c0 .4.3.6.6.5 2.4-.8 4.2 1.4 6.5.4.2-.1.4-.2.4-.4v-2.6c0-.3-.4-.6-.7-.5zm-3 2.4c-.5 0-1-.4-1-.9s.5-1 1-1 .9.4.9 1-.4.9-.9.9z"
      }
    },
    partner_marketing_budget: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.7 9.1c-4.4 1.3-7.8-2.8-12.6-.9-.3.2-.5.5-.5.9v5c0 .6.5 1.1 1.1.9 4.7-1.5 8.2 2.7 12.6.8.4-.1.6-.4.6-.9V10c.1-.6-.6-1.1-1.2-.9zm-5.8 4.6c-1 0-1.8-.8-1.8-1.8s.8-1.9 1.8-1.9 1.9.9 1.9 1.9-.9 1.8-1.9 1.8z"
      }
    },
    partners: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.5 7.6H17c-.3 0-.6-.1-.8-.4L15 6.3c-.2-.2-.5-.4-.8-.4h-2.8c-.4 0-.7.2-1 .4L8.9 7.6c-.1.1-.1.2 0 .4l.4.4c.3.2.8.3 1.1.1l1.3-.8c.2-.1.4-.1.5.1l4.2 4c.1.1.2.2.2.4v1c0 .3.2.6.4.6h1.5c.2 0 .5-.2.5-.5V8.1c0-.3-.3-.5-.5-.5zm-4.1 4.3l-2.6-2.5-.7.4c-.4.3-.8.4-1.2.4-.5 0-1-.2-1.4-.6l-1-.7c-.2-.2-.3-.4-.3-.6-.1-.3-.3-.5-.5-.5H5c-.2 0-.4.2-.4.5v4.3c0 .3.2.5.4.5h1c.1 0 .2-.2.3-.4.3-.4.9-.7 1.4-.8.6 0 1.2.2 1.6.6l3 2.7c.3.3.5.5.6.9.1.1.3.2.4.1l1.1-1.2c.6-.6 1-1.9.5-2.5l-.5-.6zm-6 1.8c-.3-.3-.8-.2-1 .1-.3.3-.2.8.1 1.1l3 2.7c.1.2.3.2.5.2s.4-.1.5-.3c.2-.3.2-.8-.1-1.1l-3-2.7zm10.5 4.4"
      }
    },
    past_chat: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M11.9 5.3c-4 0-7.2 2.9-7.2 6.5 0 1.2.3 2.3.8 3.2.1.2.2.4.1.5l-.9 2.6c-.1.2.1.5.4.4l2.6-1c.1-.1.3 0 .5.1 1.1.6 2.4.9 3.8.9 3.9 0 7.1-2.9 7.1-6.6 0-3.7-3.2-6.6-7.2-6.6zm2.8 9.7l-.3.3c-.2.2-.4.2-.6.2s-.3 0-.5-.2L11 13c-.1-.1-.2-.4-.2-.7V9c0-.4.3-.7.7-.7h.5c.4 0 .7.3.7.7v3l2 2c.1.1.2.3.2.5s-.1.3-.2.5z"
      }
    },
    people: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M19.2 17.1v.7c0 .8-.6 1.4-1.4 1.4H6.2c-.8 0-1.4-.6-1.4-1.4v-.7c0-1.8 2-2.8 4-3.7 0 0 .1 0 .2-.1.1 0 .3 0 .4.1.8.5 1.7.8 2.6.8.9 0 1.8-.3 2.6-.8.1-.1.3-.1.4 0 .1 0 .2 0 .2.1 2 .8 4 1.8 4 3.6z"
      },
      "ellipse": {
        "cx": "12",
        "cy": "8.76",
        "rx": "3.576",
        "ry": "3.96"
      }
    },
    performance: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M7.2 4.8h-.5c-.8 0-1.4.7-1.4 1.4v11.6c0 .7.6 1.4 1.4 1.4h.5c.3 0 .5-.2.5-.5V5.3c0-.3-.2-.5-.5-.5zm10.1 0H9.6c-.3 0-.5.2-.5.5v13.4c0 .3.2.5.5.5h7.7c.8 0 1.4-.6 1.4-1.4V6.2c0-.8-.6-1.4-1.4-1.4zm-.5 6.4l-1.3 1.3v.1l.2 1.8c.1.2-.1.3-.2.2l-1.5-.8c-.1-.1-.1-.1-.2 0l-1.5.8c-.2.1-.3 0-.3-.2l.3-1.8v-.1L11 11.2c-.1-.1 0-.2.1-.2l1.7-.3c.1 0 .1 0 .2-.1l.7-1.6c.1-.2.2-.2.3 0l.8 1.6c0 .1 0 .1.1.1l1.7.3c.2 0 .2.1.2.2z"
      }
    },
    person_account: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M16.7 14.2c-.9-.4-1-.7-1-1.1 0-.4.2-.7.5-1 .5-.4.8-1.1.8-1.8 0-1.4-.9-2.6-2.5-2.6s-2.4 1.2-2.4 2.6c0 .7.3 1.4.8 1.8.3.3.5.6.5 1s-.1.7-1 1.1c-1.3.5-2.5 1.2-2.5 2.3 0 .8.6 1.5 1.3 1.5h6.7c.7 0 1.3-.7 1.3-1.5 0-1.1-1.2-1.8-2.5-2.3zm-5.8 1.1"
      }, {
        "d": "M11.2 12.3c-.1-.1-.6-.7-.5-2.3 0-1.6.7-2 .7-2V6.5c0-.3-.3-.5-.5-.5H5.3s-.5.2-.5.5v10.4H8c.1-2.6 3.2-3.7 3.2-3.7.4-.2.1-.7 0-.9zm-3.8 3.3c0 .3-.2.5-.5.5h-.5c-.3 0-.5-.2-.5-.5v-.5c0-.2.2-.4.5-.4h.5c.3 0 .5.2.5.4v.5zm0-2.4c0 .3-.2.5-.5.5h-.5c-.3 0-.5-.2-.5-.5v-.4c0-.3.2-.5.5-.5h.5c.3 0 .5.2.5.5v.4zm0-2.3c0 .2-.2.5-.5.5h-.5c-.3 0-.5-.3-.5-.5v-.5c0-.3.2-.5.5-.5h.5c.3 0 .5.2.5.5v.5zm0-2.4c0 .3-.2.5-.5.5h-.5c-.3 0-.5-.2-.5-.5V8c0-.2.2-.5.5-.5h.5c.3 0 .5.3.5.5v.5zm2.7 4.7c0 .3-.3.5-.5.5h-.5c-.3 0-.5-.2-.5-.5v-.4c0-.3.2-.5.5-.5h.5c.2 0 .5.2.5.5v.4zm0-2.3c0 .2-.3.5-.5.5h-.5c-.3 0-.5-.3-.5-.5v-.5c0-.3.2-.5.5-.5h.5c.2 0 .5.2.5.5v.5zm0-2.4c0 .3-.3.5-.5.5h-.5c-.3 0-.5-.2-.5-.5V8c0-.2.2-.5.5-.5h.5c.2 0 .5.3.5.5v.5z"
      }]
    },
    photo: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M8.6 7.4h6.8c.2 0 .3-.2.2-.3l-.8-1.2c-.3-.5-.8-.8-1.3-.8h-3c-.5 0-1 .3-1.3.8l-.8 1.2c-.1.1 0 .3.2.3zm3.4 4.4c-1.1 0-1.9.8-1.9 1.9s.8 1.9 1.9 1.9 1.9-.9 1.9-1.9-.8-1.9-1.9-1.9zm5.8-2.9H6.2c-.8 0-1.4.6-1.4 1.4V17c0 .8.6 1.5 1.4 1.5h11.6c.8 0 1.4-.7 1.4-1.5v-6.7c0-.8-.6-1.4-1.4-1.4zM12 17c-1.8 0-3.4-1.5-3.4-3.3s1.6-3.4 3.4-3.4 3.4 1.5 3.4 3.4S13.8 17 12 17z"
      }
    },
    poll: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.2 4.8H5.8c-.6 0-1 .4-1 1v1.9c0 .5.4.9 1 .9h12.4c.6 0 1-.4 1-.9V5.8c0-.6-.4-1-1-1zm-6 2.9V5.8h6v1.9h-6zm6 2.4H5.8c-.6 0-1 .4-1 .9v2c0 .5.4.9 1 .9h12.4c.6 0 1-.4 1-.9v-2c0-.5-.4-.9-1-.9zM10.1 13v-2h8.1v2h-8.1zm8.1 2.4H5.8c-.6 0-1 .4-1 .9v1.9c0 .6.4 1 1 1h12.4c.6 0 1-.4 1-1v-1.9c0-.5-.4-.9-1-.9zm-3.8 2.8v-1.9h3.8v1.9h-3.8z"
      }
    },
    portal: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.3 5.3H6.7c-.8 0-1.4.6-1.4 1.4v10.6c0 .8.6 1.4 1.4 1.4h10.6c.8 0 1.4-.6 1.4-1.4V6.7c0-.8-.6-1.4-1.4-1.4zM14.2 15c0 .3-.2.6-.5.6h-3.4c-.3 0-.5-.3-.4-.6l.7-2.6c-.7-.5-1.1-1.5-1-2.5.2-1 1-1.7 1.9-1.9 1.6-.3 2.9.9 2.9 2.4 0 .8-.4 1.5-1 2l.8 2.6z"
      }
    },
    post: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M11.8 5.2c-4 0-7.2 3-7.2 6.7 0 1.2.3 2.3.9 3.3.1.1.1.3.1.4l-.7 2.1c-.1.4.2.8.6.6l2.1-.7c.2-.1.3 0 .4 0 1.1.7 2.4 1 3.8 1 4 0 7.2-3 7.2-6.7s-3.2-6.7-7.2-6.7z"
      }
    },
    pricebook: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.2 4.8h-9c-.8 0-1.5.7-1.5 1.4v.5h-.5c-.5 0-.9.5-.9 1s.4.9.9.9h.5V11h-.5c-.5 0-.9.5-.9 1s.4 1 .9 1h.5v2.4h-.5c-.5 0-.9.4-.9.9s.4 1 .9 1h.5v.4c0 .7.7 1.5 1.5 1.5h9c.8 0 1.5-.8 1.5-1.6V6.1c0-.8-.7-1.3-1.5-1.3zm-6.9 9.8c0 .2-.1.3-.2.3h-1c-.1 0-.2-.1-.2-.3V9.4c0-.2.1-.3.2-.3h1c.1 0 .2.1.2.3v5.2zm1.9 0c0 .2-.1.3-.2.3h-.5c-.1 0-.2-.1-.2-.3V9.4c0-.2.1-.3.2-.3h.5c.1 0 .2.1.2.3v5.2zm2.4 0c0 .2-.1.3-.2.3h-1c-.1 0-.2-.1-.2-.3V9.4c0-.2.1-.3.2-.3h1c.1 0 .2.1.2.3v5.2zm2 0c0 .2-.1.3-.3.3h-.5c-.1 0-.2-.1-.2-.3V9.4c0-.2.1-.3.2-.3h.5c.2 0 .3.1.3.3v5.2z"
      }
    },
    process: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M9 11.1l2.6-3.2c.2-.2.6-.2.8 0l2.6 3.2c0 .1.2.2.3.2h2.9c.3 0 .5-.2.5-.5V6.7c0-.8-.6-1.4-1.4-1.4H6.7c-.8 0-1.4.6-1.4 1.4v4.1c0 .3.2.5.5.5h2.8c.2 0 .3-.1.4-.2zm6 1.8l-2.6 3.2c-.2.2-.6.2-.8 0L9 12.9c-.1-.1-.2-.2-.4-.2H5.8c-.3 0-.5.2-.5.5v4.1c0 .8.6 1.4 1.4 1.4h10.6c.8 0 1.4-.6 1.4-1.4v-4.1c0-.3-.2-.5-.5-.5h-2.9c-.1 0-.3.1-.3.2z"
      }
    },
    product: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M5.3 15.8h1.2c.2 0 .5-.2.5-.4V7.9c0-.2-.3-.5-.5-.5H5.3c-.3 0-.5.3-.5.5v7.5c0 .2.2.4.5.4zm13.4-8.4h-1.2c-.2 0-.5.3-.5.5v7.5c0 .2.3.4.5.4h1.2c.3 0 .5-.2.5-.4V7.9c0-.2-.2-.5-.5-.5zm-6 8.4c.3 0 .5-.2.5-.4V7.9c0-.2-.2-.5-.5-.5h-1.4c-.3 0-.5.3-.5.5v7.5c0 .2.2.4.5.4h1.4zm2.9 0c.3 0 .5-.2.5-.4V7.9c0-.2-.2-.5-.5-.5h-.5c-.2 0-.5.3-.5.5v7.5c0 .2.3.4.5.4h.5zm-6.2 0c.2 0 .4-.2.4-.4V7.9c0-.2-.2-.5-.4-.5h-.5c-.3 0-.5.3-.5.5v7.5c0 .2.2.4.5.4h.5zm9.3 1.5H5.3c-.3 0-.5.2-.5.5v.4c0 .3.2.5.5.5h13.4c.3 0 .5-.2.5-.5v-.4c0-.3-.2-.5-.5-.5zm0-12.5H5.3c-.3 0-.5.2-.5.5v.5c0 .2.2.4.5.4h13.4c.3 0 .5-.2.5-.4v-.5c0-.3-.2-.5-.5-.5z"
      }
    },
    product_consumed: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.5 13.2h-.9a.5.5 0 0 0-.4.5v3a.5.5 0 0 1-.5.4H6.8a.5.5 0 0 1-.4-.4v-3a.5.5 0 0 0-.5-.5H5a.5.5 0 0 0-.4.5v4a1.2 1.2 0 0 0 1.2 1.2h12a1.2 1.2 0 0 0 1.2-1.2v-4a.5.5 0 0 0-.5-.5zm-7 2a.4.4 0 0 0 .6 0l4-4a.4.4 0 0 0 0-.7l-.6-.6a.4.4 0 0 0-.6 0l-1.7 1.7a.3.3 0 0 1-.5-.2V5a.5.5 0 0 0-.5-.5h-.9a.5.5 0 0 0-.4.5v6.4a.3.3 0 0 1-.5.2L8.7 9.9a.4.4 0 0 0-.7 0l-.6.6a.4.4 0 0 0 0 .7z"
      }
    },
    product_item: {
      "xmlns": "http://www.w3.org/2000/svg",
      "rect": [{
        "x": "4.56",
        "y": "4.541",
        "width": "14.4",
        "height": "3.84",
        "rx": ".96",
        "ry": ".96"
      }, {
        "x": "4.56",
        "y": "9.821",
        "width": "6.48",
        "height": "3.84",
        "rx": ".96",
        "ry": ".96"
      }, {
        "x": "4.56",
        "y": "15.101",
        "width": "6.48",
        "height": "3.84",
        "rx": ".96",
        "ry": ".96"
      }, {
        "x": "12.48",
        "y": "9.821",
        "width": "6.48",
        "height": "3.84",
        "rx": ".96",
        "ry": ".96"
      }, {
        "x": "12.48",
        "y": "15.101",
        "width": "6.48",
        "height": "3.84",
        "rx": ".96",
        "ry": ".96"
      }]
    },
    product_item_transaction: {
      "xmlns": "http://www.w3.org/2000/svg",
      "rect": [{
        "x": "4.56",
        "y": "4.541",
        "width": "14.4",
        "height": "3.84",
        "rx": ".96",
        "ry": ".96"
      }, {
        "x": "4.56",
        "y": "9.821",
        "width": "6.48",
        "height": "3.84",
        "rx": ".96",
        "ry": ".96"
      }, {
        "x": "4.56",
        "y": "15.101",
        "width": "6.48",
        "height": "3.84",
        "rx": ".96",
        "ry": ".96"
      }],
      "path": {
        "d": "M15.6 17.4a.3.3 0 0 0 .5 0l2.8-2.7a.3.3 0 0 0 0-.5l-2.8-2.8a.3.3 0 0 0-.5 0l-.5.5a.3.3 0 0 0 0 .5l.8.9a.2.2 0 0 1-.1.4h-2.9a.4.4 0 0 0-.4.3v.8a.4.4 0 0 0 .4.3h2.9a.2.2 0 0 1 .1.4l-.8.9a.3.3 0 0 0 0 .5z"
      }
    },
    product_request: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M18.6 18.7H9.7c-.3 0-.5-.2-.5-.5v-1.1c0-.3.2-.6.5-.6h8.9c.3 0 .5.3.5.6v1.1c.1.3-.2.5-.5.5zm-12.2 0H5.3c-.3 0-.6-.2-.6-.5v-1.1c0-.3.3-.6.6-.6h1.1c.3 0 .5.3.5.6v1.1c.1.3-.2.5-.5.5zm6.5-4.9c-.3 0-.5-.2-.5-.5v-1.1c0-.3.2-.6.5-.6h5.7c.3 0 .5.3.5.5v1.2c0 .3-.2.5-.5.5h-5.7zM15 8.9c-.3 0-.5-.2-.5-.5V7.2c0-.2.2-.5.5-.5h3.6c.3 0 .5.2.5.5v1.2c0 .2-.2.5-.5.5H15zM5 14c-.3-2.6 1.7-5.3 4.1-5.7l.7-.2c.1 0 .2-.1.2-.3l-.1-.1-1.6-1.1c-.2-.1-.2-.3-.1-.5l.4-.6c.1-.1.3-.2.5-.1L13 8c.1.1.2.4.1.5l-2.7 3.9c-.1.2-.3.2-.5.1l-.6-.4c-.2-.1-.2-.3-.1-.5l1.1-1.6c0-.1 0-.3-.1-.3 0-.1-.1-.1-.2-.1l-.4.1c-1.8.4-3.4 2.5-3.2 4.3 0 .2-.3.4-.5.4h-.5c-.2.1-.4-.2-.4-.4z"
      }
    },
    product_request_line_item: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M18.7 18.6H9.8c-.3 0-.6-.3-.6-.6v-1.1c0-.3.3-.5.6-.5h8.8c.3 0 .6.2.6.5V18c0 .3-.2.6-.5.6zm-12.2 0H5.4c-.3 0-.6-.3-.6-.6v-1.1c0-.3.2-.5.5-.5h1.2c.2 0 .5.2.5.5V18c0 .3-.2.6-.5.6zm-.6-7c1.6-2.8 5.5-4 8-2.8l.7.3c.3.1.5-.1.4-.4l-.6-2.2c-.1-.3 0-.5.2-.6l.9-.3c.1-.1.4 0 .5.2v.1l1.6 5.4c.1.2 0 .5-.3.6l-5.3 2c-.1.1-.4 0-.5-.1v-.1l-.2-.9c-.1-.2 0-.5.2-.5l2.2-.9c.2 0 .2-.2.2-.4 0-.1-.1-.1-.1-.2l-.5-.1c-1.9-1-5 0-6.2 2-.1.2-.5.2-.8.1l-.4-.4c-.2-.1-.2-.5 0-.8z"
      }
    },
    product_required: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "rect": [{
        "x": "10.543",
        "y": "16.385",
        "width": "8.657",
        "height": "1.918",
        "rx": ".48",
        "ry": ".48"
      }, {
        "x": "10.543",
        "y": "12.101",
        "width": "8.657",
        "height": "1.918",
        "rx": ".48",
        "ry": ".48"
      }, {
        "x": "11.981",
        "y": "7.817",
        "width": "7.219",
        "height": "1.918",
        "rx": ".48",
        "ry": ".48"
      }],
      "path": [{
        "d": "M8.1 18.3h-.9a.5.5 0 0 1-.5-.5v-.9a.5.5 0 0 1 .5-.5h.9a.5.5 0 0 1 .5.5v.9a.5.5 0 0 1-.5.5zm0-4.3h-.9a.5.5 0 0 1-.5-.5v-.9a.5.5 0 0 1 .5-.5h.9a.5.5 0 0 1 .5.5v.9a.5.5 0 0 1-.5.5z",
        "fill-rule": "evenodd"
      }, {
        "d": "M11.4 6.3l-.5-.5a.3.3 0 0 0-.5 0L7.2 9 5.9 7.7a.3.3 0 0 0-.5 0l-.5.5a.3.3 0 0 0 0 .5l1.8 1.8a.7.7 0 0 0 1 0l3.7-3.7a.4.4 0 0 0 0-.5z",
        "fill-rule": "evenodd"
      }]
    },
    product_return: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M5.3 5.4h8.8c.3 0 .6.2.6.5V7c0 .3-.3.6-.5.6H5.3c-.3 0-.6-.3-.6-.6V5.9c0-.3.2-.5.6-.5zm12.2 0h1.1c.3 0 .5.2.5.5V7c0 .3-.2.6-.5.6h-1.1c-.3 0-.6-.3-.6-.6V5.9c0-.3.2-.5.5-.5h.1zm-6.6 4.9c.3 0 .6.2.6.5v1.1c0 .3-.2.6-.5.6H5.3c-.3 0-.6-.3-.6-.5v-1.2c0-.3.3-.5.6-.5h5.6zm-2.1 4.9c.3 0 .6.2.6.5v1.1c0 .3-.3.6-.5.6H5.3c-.3 0-.6-.2-.6-.5v-1.2c0-.2.3-.5.6-.5h3.5zm10.1-5.1c.3 2.6-1.8 5.3-4.2 5.7l-.6.2c-.1 0-.2.1-.2.2s0 .2.1.2l1.6 1.1c.2.1.2.3.1.5l-.4.6c-.1.1-.4.2-.5.1l-3.9-2.6c-.2-.1-.2-.4-.1-.5l2.6-3.9c.1-.2.4-.3.5-.1l.6.4c.2.1.3.3.1.5l-1 1.6c-.1.1-.1.3 0 .3.1.1.2.1.2.1l.4-.1c1.9-.4 3.5-2.5 3.3-4.3 0-.2.3-.4.5-.5h.4c.2 0 .5.3.5.5z"
      }
    },
    product_return_line_item: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M5.3 5.5h8.9c.3 0 .6.3.6.6v1.1c0 .3-.3.6-.6.6H5.4c-.3 0-.6-.3-.6-.6V6.1c0-.3.2-.6.5-.6zm12.2 0h1.1c.3 0 .6.3.6.6v1.1c0 .3-.2.6-.5.6h-1.2c-.2 0-.5-.3-.5-.6V6.1c0-.3.2-.5.5-.6zm.6 7c-1.6 2.8-5.5 4.1-8 2.8l-.7-.3c-.3-.1-.5.1-.4.4l.6 2.2c.1.3 0 .5-.2.6l-.9.3c-.1.1-.4 0-.5-.2l-1.6-5.5c-.1-.2 0-.5.3-.6l5.3-2c.1-.1.4 0 .5.2l.2.9c.1.2 0 .5-.2.6l-2.2.8c-.2.1-.2.2-.2.4 0 .1.1.1.1.2l.5.2c1.9.9 5-.1 6.2-2.1.1-.1.5-.2.8-.1l.4.4c.2.1.2.6 0 .8z"
      }
    },
    product_transfer: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.1 4.9h-.8a.4.4 0 0 0-.4.5v1.9c0 .3-.3.5-.5.3a6.2 6.2 0 0 0-5.3-2.1 5.5 5.5 0 0 0-2.1.6 5.5 5.5 0 0 0-1 .6.5.5 0 0 0 0 .7l.6.6a.4.4 0 0 0 .5 0 6.9 6.9 0 0 1 1.1-.6c.2 0 .4-.1.6-.1a4.7 4.7 0 0 1 4.5 1.5c.3.4 0 .7-.2.7h-2a.5.5 0 0 0-.5.4v.8a.5.5 0 0 0 .5.5h5.1a.4.4 0 0 0 .4-.4V5.4a.4.4 0 0 0-.5-.5zM15.6 15a.4.4 0 0 0-.6 0 4.5 4.5 0 0 1-1.7 1c-.2.1-.3.1-.5.2a4.7 4.7 0 0 1-4.5-1.5c-.3-.4-.1-.7.2-.7h2a.4.4 0 0 0 .4-.4v-.9a.4.4 0 0 0-.4-.4H5.3a.4.4 0 0 0-.4.4v5.4a.4.4 0 0 0 .5.4h.8a.4.4 0 0 0 .5-.4v-2c0-.2.2-.4.4-.2a6.2 6.2 0 0 0 5.3 2.1 5.5 5.5 0 0 0 2.1-.7 6.2 6.2 0 0 0 1.6-1.1.4.4 0 0 0 0-.6z"
      }
    },
    question_best: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "g": {
        "path": [{
          "d": "M24 24v-9.1L14.9 24H24zm-.9-3.5l-.8.8v.1l.2 1.1s-.1.1-.2.1l-.9-.5c0-.1 0-.1 0 0l-1 .5c-.1 0-.1-.1-.1-.1l.1-1.1v-.1l-.7-.8c-.1 0 0-.1 0-.1l1.1-.2.5-1c0-.1.1-.1.2 0l.4 1h.1l1 .2c.1 0 .1.1.1.1z",
          "fill-opacity": ".65"
        }, {
          "d": "M12 5.3c-4 0-7.2 3-7.2 6.7 0 1.2.3 2.3.9 3.3.1.1.1.3 0 .4l-.6 2.1c-.2.4.2.7.6.6l2.1-.7c.1-.1.3-.1.4 0 1.1.7 2.4 1 3.8 1 4 0 7.2-3 7.2-6.7S16 5.3 12 5.3zm.7 10.8c0 .2-.2.5-.5.5h-.5c-.2 0-.4-.3-.4-.5v-.5c0-.3.2-.5.4-.5h.5c.3 0 .5.2.5.5v.5zm.2-3.1c-.1.1-.2.2-.2.3v.4c0 .2-.2.5-.5.5h-.4c-.3 0-.5-.3-.5-.5v-.4c0-.7.5-1.4 1.2-1.6.2-.1.5-.3.6-.5.8-1 0-2.3-1.1-2.3-.4 0-.7.1-1 .4-.2.2-.4.4-.4.7-.1.2-.3.3-.5.3h-.5c-.3 0-.5-.2-.5-.5.2-.6.4-1.1.9-1.5.5-.6 1.3-.9 2-.9 1.6.1 2.8 1.3 2.9 2.8 0 1.3-.8 2.4-2 2.8z"
        }]
      }
    },
    question_feed: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12 5.3c-4 0-7.2 3-7.2 6.7 0 1.2.3 2.3.9 3.3.1.1.1.3.1.4l-.7 2.1c-.1.4.2.7.6.6l2.1-.7c.2-.1.3-.1.4 0 1.1.7 2.4 1 3.8 1 4 0 7.2-3 7.2-6.7S16 5.3 12 5.3zm.7 10.8c0 .2-.2.5-.5.5h-.4c-.3 0-.5-.3-.5-.5v-.5c0-.3.2-.5.5-.5h.4c.3 0 .5.2.5.5v.5zm.2-3.1c-.1.1-.2.2-.2.3v.4c0 .2-.2.5-.5.5h-.4c-.3 0-.5-.3-.5-.5v-.4c0-.7.5-1.4 1.2-1.6.2-.1.5-.3.6-.5.8-1 0-2.3-1.1-2.3-.4 0-.7.1-1 .4-.2.2-.4.4-.4.7-.1.2-.3.3-.5.3h-.5c-.3 0-.5-.2-.5-.5.2-.6.4-1.1.9-1.5.5-.6 1.3-.9 2-.9 1.6.1 2.8 1.3 2.9 2.8 0 1.3-.8 2.4-2 2.8z"
      }
    },
    quick_text: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M11.9 5.2c-4 0-7.2 2.9-7.2 6.5 0 1.2.3 2.3.9 3.2.1.2.1.4 0 .5L4.7 18c-.1.2.1.5.4.4l2.6-1c.1-.1.3 0 .5.1 1.1.6 2.4.9 3.8.9 3.9 0 7.1-2.9 7.1-6.6 0-3.7-3.2-6.6-7.2-6.6zm-3.4 6.3c0-.1.2-.3.3-.3h4.7c.1 0 .3.2.3.3v.6c0 .1-.1.3-.3.3H8.8c-.1 0-.3-.2-.3-.3v-.6zm6.7 2.8c0 .1-.1.3-.2.3H8.8c-.1 0-.3-.1-.3-.3v-.5c0-.2.1-.3.3-.3H15c.1 0 .2.1.2.3v.5zm0-4.5c0 .2-.1.3-.2.3H8.8c-.1 0-.3-.1-.3-.3v-.5c0-.2.1-.3.3-.3H15c.1 0 .2.1.2.3v.5z"
      }
    },
    quip: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M19.1 17.9l-1.2 1.2c-.1.1-.4.1-.5 0L12 13.7V12h1.7l1.6 1.6V8.7H8.7v6.6H12l2.4 2.4H7.1c-.5 0-.8-.3-.8-.8V7.1c0-.5.3-.8.8-.8h9.8c.5 0 .9.3.9.8V16l1.3 1.4c.1.1.1.4 0 .5z"
      }
    },
    quip_sheet: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M7.7 9.3H5.3c-.3 0-.5.2-.5.5v7.6c0 .7.5 1.2 1.2 1.2h1.7c.2 0 .4-.2.4-.4V9.8c0-.3-.2-.5-.4-.5zm11 0h-9c-.2 0-.4.2-.4.5v8.4c0 .2.2.4.4.4H18c.7 0 1.2-.5 1.2-1.2V9.7c0-.2-.2-.4-.5-.4zM18 5.4H6c-.7 0-1.2.5-1.2 1.2v1.1c0 .2.2.4.5.4h13.4c.3 0 .5-.2.5-.4V6.6c0-.6-.5-1.2-1.2-1.2z"
      }
    },
    quotes: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.3 5.3H12c-.3 0-.6.1-.8.4l-6.5 6.4c-.5.6-.5 1.5 0 2.1l5.1 5c.6.6 1.5.6 2.1 0l6.5-6.5c.2-.2.3-.6.3-.9V6.7c0-.8-.6-1.4-1.4-1.4zm-5.2 10.5l-.3.4c-.2.2-.5.2-.7 0l-3.3-3.3c-.2-.2-.2-.5 0-.7l.4-.3c.2-.2.4-.2.6 0l3.3 3.3c.2.2.2.4 0 .6zm1.9-1.9l-.3.4c-.2.1-.5.1-.7 0L9.7 11c-.1-.2-.1-.5 0-.7l.4-.3c.2-.2.5-.2.7 0l3.2 3.2c.2.2.2.5 0 .7zm1.4-4.1c-.7 0-1.2-.5-1.2-1.2s.5-1.2 1.2-1.2 1.2.6 1.2 1.2-.6 1.2-1.2 1.2z"
      }
    },
    recent: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M6.7 11.5v.5H5.3v-.5h1.4zm5.7-2.9h-.8c-.2 0-.3.2-.3.4v3.1c0 .1 0 .2.1.3l2 2c.1.2.4.2.5 0l.5-.5c.1-.1.1-.3 0-.5l-1.7-1.7V9c0-.2-.1-.4-.3-.4zM12 5.3c-3.6 0-6.5 2.7-6.7 6.2v.3H4.2c-.3 0-.5.3-.3.5l1.8 2.2c.2.2.4.2.6 0l1.8-2.2c.2-.2 0-.5-.3-.5H6.7v-.3C7 8.8 9.2 6.7 12 6.7c3.1 0 5.6 2.7 5.2 5.9-.2 2.3-2.4 4.4-4.7 4.7-1.7.1-3.3-.5-4.4-1.7-.2-.2-.3-.3-.5 0l-.6.6c-.1.2 0 .3.1.4 1.3 1.4 3.1 2.1 5 2.1 3.4 0 6.3-2.8 6.6-6.2.3-3.9-2.8-7.2-6.7-7.2z"
      }
    },
    record: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M9.4 7.7h5.2c.3 0 .5-.2.5-.5v-1c0-.8-.6-1.4-1.4-1.4h-3.4c-.8 0-1.4.6-1.4 1.4v1c0 .3.2.5.5.5zM17.3 6h-.5c-.1 0-.2.1-.2.2v1c0 1.1-.9 1.9-2 1.9H9.4c-1.1 0-2-.8-2-1.9v-1c0-.1-.1-.2-.2-.2h-.5c-.8 0-1.4.6-1.4 1.4v10.4c0 .8.6 1.4 1.4 1.4h10.6c.8 0 1.4-.6 1.4-1.4V7.4c0-.8-.6-1.4-1.4-1.4zM9.4 16.3c0 .3-.3.5-.5.5h-.5c-.3 0-.5-.2-.5-.5v-.5c0-.2.2-.4.5-.4h.5c.2 0 .5.2.5.4v.5zm0-2.4c0 .3-.3.5-.5.5h-.5c-.3 0-.5-.2-.5-.5v-.5c0-.2.2-.4.5-.4h.5c.2 0 .5.2.5.4v.5zm0-2.4c0 .3-.3.5-.5.5h-.5c-.3 0-.5-.2-.5-.5V11c0-.2.2-.4.5-.4h.5c.2 0 .5.2.5.4v.5zm6.7 4.8c0 .3-.2.5-.5.5h-4.8c-.3 0-.5-.2-.5-.5v-.5c0-.2.2-.4.5-.4h4.8c.3 0 .5.2.5.4v.5zm0-2.4c0 .3-.2.5-.5.5h-4.8c-.3 0-.5-.2-.5-.5v-.5c0-.2.2-.4.5-.4h4.8c.3 0 .5.2.5.4v.5zm0-2.4c0 .3-.2.5-.5.5h-4.8c-.3 0-.5-.2-.5-.5V11c0-.2.2-.4.5-.4h4.8c.3 0 .5.2.5.4v.5z"
      }
    },
    related_list: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.8 4.8h-7.7c-.8 0-1.5.6-1.5 1.4v.3c0 .1.1.2.3.2h6.9c.8 0 1.5.7 1.5 1.5v7.4c0 .1.1.2.2.2.9 0 1.7-.7 1.7-1.6v-8c0-.8-.6-1.4-1.4-1.4zM6.7 8.2c-.8 0-1.4.6-1.4 1.4v8.2c0 .8.6 1.4 1.4 1.4h7.7c.8 0 1.4-.6 1.4-1.4V9.6c0-.8-.6-1.4-1.4-1.4H6.7zm1.9 3.3c0 .3-.2.5-.4.5h-.5c-.3 0-.5-.2-.5-.5V11c0-.2.2-.4.5-.4h.5c.2 0 .4.2.4.4v.5zm5.3 0c0 .3-.2.5-.5.5h-3.3c-.3 0-.5-.2-.5-.5V11c0-.2.2-.4.5-.4h3.3c.3 0 .5.2.5.4v.5zm-5.3 2.4c0 .3-.2.5-.4.5h-.5c-.3 0-.5-.2-.5-.5v-.5c0-.2.2-.4.5-.4h.5c.2 0 .4.2.4.4v.5zm5.3 0c0 .3-.2.5-.5.5h-3.3c-.3 0-.5-.2-.5-.5v-.5c0-.2.2-.4.5-.4h3.3c.3 0 .5.2.5.4v.5zm-5.3 2.4c0 .3-.2.5-.4.5h-.5c-.3 0-.5-.2-.5-.5v-.5c0-.2.2-.4.5-.4h.5c.2 0 .4.2.4.4v.5zm5.3 0c0 .3-.2.5-.5.5h-3.3c-.3 0-.5-.2-.5-.5v-.5c0-.2.2-.4.5-.4h3.3c.3 0 .5.2.5.4v.5z"
      }
    },
    relationship: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.1 16.8h-.9V15h.9c.2 0 .3-.1.3-.3V6.9c0-.2-.1-.3-.3-.3H9.3c-.2 0-.3.1-.3.3v.9H7.2v-.9c0-1.2.9-2.1 2.1-2.1h7.8c1.2 0 2.1.9 2.1 2.1v7.8c0 1.2-.9 2.1-2.1 2.1zM13.8 9H6c-.7 0-1.2.5-1.2 1.2V18c0 .7.5 1.2 1.2 1.2h7.8c.7 0 1.2-.5 1.2-1.2v-7.8c0-.7-.5-1.2-1.2-1.2z"
      }
    },
    report: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M9.4 7.7h5.2c.3 0 .5-.2.5-.5v-1c0-.8-.6-1.4-1.4-1.4h-3.4c-.8 0-1.4.6-1.4 1.4v1c0 .3.2.5.5.5zM17.3 6h-.5c-.1 0-.2.1-.2.2v1c0 1.1-.9 1.9-2 1.9H9.4c-1.1 0-2-.8-2-1.9v-1c0-.1-.1-.2-.2-.2h-.5c-.8 0-1.4.6-1.4 1.4v10.4c0 .8.6 1.4 1.4 1.4h10.6c.8 0 1.4-.6 1.4-1.4V7.4c0-.8-.6-1.4-1.4-1.4zm-7 9.8c0 .3-.2.5-.5.5h-.4c-.3 0-.5-.2-.5-.5v-2.4c0-.2.2-.4.5-.4h.4c.3 0 .5.2.5.4v2.4zm2.4 0c0 .3-.2.5-.5.5h-.4c-.3 0-.5-.2-.5-.5v-4.5c0-.3.2-.5.5-.5h.4c.3 0 .5.2.5.5v4.5zm2.4 0c0 .3-.2.5-.5.5h-.4c-.3 0-.5-.2-.5-.5v-3.6c0-.2.2-.4.5-.4h.4c.3 0 .5.2.5.4v3.6z"
      }
    },
    resource_absence: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M12 4.8a6.1 6.1 0 1 0 6 6.1c0-3.3-2.7-6.1-6-6.1zm4 9.1l-1.2 1.2-2.9-3-2.8 2.8L8 13.8l2.8-2.8-2.9-2.8L9.1 7l2.8 2.8 2.9-2.9L16 8l-3 3zm-9.8 1.5h-.3a1.1 1.1 0 0 0-1.1 1.1v1.6a1.1 1.1 0 0 0 1.1 1.1h12.2a1.1 1.1 0 0 0 1.1-1.1v-1.6a1.1 1.1 0 0 0-1.1-1.1h-.4a7.2 7.2 0 0 1-11.5 0z",
        "fill-rule": "evenodd"
      }
    },
    resource_capacity: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M12 4.8a6.1 6.1 0 1 0 6 6.1c0-3.3-2.7-6.1-6-6.1zm4.2 6.3h-4.4V6.5s1.7-.1 3.2 1.4 1.2 3.2 1.2 3.2zm-10 4.3h-.3a1.1 1.1 0 0 0-1.1 1.1v1.6a1.1 1.1 0 0 0 1.1 1.1h12.2a1.1 1.1 0 0 0 1.1-1.1v-1.6a1.1 1.1 0 0 0-1.1-1.1h-.4a7.2 7.2 0 0 1-11.5 0z",
        "fill-rule": "evenodd"
      }
    },
    resource_preference: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M12 4.8a6.1 6.1 0 1 0 6 6.1c0-3.3-2.7-6.1-6-6.1zm-2.6 8.6a.7.7 0 0 1-.7.6h-.5a.3.3 0 0 1-.2-.2v-3.5a.3.3 0 0 1 .2-.3h.9a.3.3 0 0 1 .3.3zm6.5-.7c0 1.4-1.2 1.5-2.6 1.5-1.3 0-1.7-.4-2.9-.5a.2.2 0 0 1-.3-.2v-3.1a.3.3 0 0 1 .3-.2 1.6 1.6 0 0 0 1.5-1.6v-.9a.3.3 0 0 1 .3-.3h.5a.7.7 0 0 1 .7.7v1.5a.7.7 0 0 0 .7.6h1.1a.7.7 0 0 1 .7.6zm-9.7 2.7h-.3a1.1 1.1 0 0 0-1.1 1.1v1.6a1.1 1.1 0 0 0 1.1 1.1h12.2a1.1 1.1 0 0 0 1.1-1.1v-1.6a1.1 1.1 0 0 0-1.1-1.1h-.4a7.2 7.2 0 0 1-11.5 0z",
        "fill-rule": "evenodd"
      }
    },
    resource_skill: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M10.5 10.9a1.4 1.4 0 1 0 2.9 0 1.4 1.4 0 1 0-2.9 0zM12 4.8a6.1 6.1 0 1 0 6 6.1c0-3.3-2.7-6.1-6-6.1zm4 8.1l-.3.4a.6.6 0 0 1-.5.3.7.7 0 0 1-.2 0l-.8-.3a3.4 3.4 0 0 1-1.1.6l-.2.9a.6.6 0 0 1-.5.5h-.6a.6.6 0 0 1-.6-.5l-.1-.9a2.9 2.9 0 0 1-1.1-.6l-.8.3a.7.7 0 0 1-.2.1.6.6 0 0 1-.5-.3l-.3-.5a.6.6 0 0 1 .1-.8l.7-.5a3 3 0 0 1-.1-.6 2.8 2.8 0 0 1 .1-.6l-.7-.6a.6.6 0 0 1-.1-.7l.3-.5a.6.6 0 0 1 .5-.3.7.7 0 0 1 .2 0l.8.3a3.3 3.3 0 0 1 1.1-.6l.1-.8a.6.6 0 0 1 .6-.5h.6a.6.6 0 0 1 .5.5l.2.8a3.3 3.3 0 0 1 1 .6l.9-.3a.7.7 0 0 1 .2 0 .6.6 0 0 1 .5.3l.3.4a.6.6 0 0 1-.2.8l-.7.5a2.9 2.9 0 0 1 .1.7 2.8 2.8 0 0 1-.1.6l.7.5a.6.6 0 0 1 .2.8zm-9.8 2.5h-.3a1.1 1.1 0 0 0-1.1 1.1v1.6a1.1 1.1 0 0 0 1.1 1.1h12.2a1.1 1.1 0 0 0 1.1-1.1v-1.6a1.1 1.1 0 0 0-1.1-1.1h-.4a7.2 7.2 0 0 1-11.5 0z",
        "fill-rule": "evenodd"
      }
    },
    reward: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M11.2 15.2l-2.8 4-.7-1.9H5.8l2.4-3.4c.5.3 1 .4 1.4.5h.3s.2.1.2.2c.3.2.7.5 1.1.6zm4.6-1.3c-.5.3-1 .4-1.4.5h-.3c-.1 0-.2.1-.3.2-.2.2-.6.5-1 .6l2.8 4 .7-1.9h1.9l-2.4-3.4zM12 7.7c-.9 0-1.7.7-1.7 1.7S11.1 11 12 11s1.7-.7 1.7-1.6-.8-1.7-1.7-1.7zm4.6 1.7c0 .5-.7 1-.9 1.5-.2.5-.1 1.3-.5 1.7-.4.4-1.1.3-1.7.5-.5.2-.9.8-1.5.8s-1-.6-1.5-.8c-.6-.2-1.3-.1-1.7-.5-.4-.4-.3-1.2-.5-1.7s-.9-1-.9-1.5c0-.6.7-1.1.9-1.6.2-.5.1-1.3.5-1.7.4-.3 1.1-.2 1.7-.5.5-.2.9-.8 1.5-.8s1 .6 1.5.8c.6.3 1.3.1 1.7.5.4.4.3 1.2.5 1.7s.9 1 .9 1.6zm-1.5 0c0-1.8-1.4-3.2-3.1-3.2S8.9 7.6 8.9 9.4s1.4 3.1 3.1 3.1 3.1-1.4 3.1-3.1z"
      }
    },
    rtc_presence: {
      "path": {
        "d": "M14.8 4.7c-2.7 0-4.9 2.1-4.9 4.7a4.5 4.5 0 0 0 .6 2.2.4.4 0 0 1 .1.3l-.5 1.5a.3.3 0 0 0 .4.4l1.4-.5a.4.4 0 0 1 .3 0 5 5 0 0 0 2.6.7c2.6 0 4.8-2.1 4.8-4.6s-2.2-4.7-4.8-4.7zM11 18.3v.3a.7.7 0 0 1-.7.7H5a.7.7 0 0 1-.6-.7v-.3c0-.8.9-1.3 1.8-1.7a.3.3 0 0 0 .1 0 .2.2 0 0 1 .2 0 2.2 2.2 0 0 0 1.2.3 2.2 2.2 0 0 0 1.2-.3.2.2 0 0 1 .2 0 .3.3 0 0 1 .1 0c.9.4 1.8.9 1.8 1.7z"
      },
      "ellipse": {
        "cx": "7.682",
        "cy": "14.462",
        "rx": "1.644",
        "ry": "1.819"
      }
    },
    sales_path: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M3.6 16.4l3.5-4.2c.1-.1.1-.3 0-.5l-3.5-4v-.2c0-.1.1-.2.2-.2h5c.2 0 .3 0 .3.1l3.6 4.4c.1.1.1.3 0 .5l-3.5 4.3c-.1.1-.2.2-.4.2H3.9c-.2 0-.3-.1-.3-.3v-.1zm7.6 0l3.4-4.2c.1-.1.1-.3 0-.5l-3.4-4v-.2c0-.1.1-.2.2-.2h5c.1 0 .2 0 .3.1l3.6 4.4c.1.1.1.3 0 .5l-3.6 4.3c0 .1-.2.2-.3.2h-5c-.1 0-.2-.1-.2-.3v-.1z"
      }
    },
    scan_card: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.8 7.2H6.2c-.8 0-1.4.6-1.4 1.4v6.8c0 .8.6 1.4 1.4 1.4h11.6c.8 0 1.4-.6 1.4-1.4V8.6c0-.8-.6-1.4-1.4-1.4zM6 12.7c-.4 0-.7-.3-.7-.7s.3-.7.7-.7.7.3.7.7-.3.7-.7.7zm11.3 2.2c0 .2-.2.5-.5.5H7.7c-.3 0-.5-.3-.5-.5V9.1c0-.2.2-.5.5-.5h9.1c.3 0 .5.3.5.5v5.8zm-1.9-4.8H9.1c-.2 0-.5.2-.5.5v2.8c0 .3.3.5.5.5h6.3c.2 0 .4-.2.4-.5v-2.8c0-.3-.2-.5-.4-.5z"
      }
    },
    service_appointment: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "rect": [{
        "x": "14.474",
        "y": "14.638",
        "width": "1.315",
        "height": "1.315",
        "rx": ".218",
        "ry": ".218"
      }, {
        "x": "14.474",
        "y": "16.829",
        "width": "1.315",
        "height": "1.315",
        "rx": ".218",
        "ry": ".218"
      }, {
        "x": "12.281",
        "y": "14.638",
        "width": "1.315",
        "height": "1.315",
        "rx": ".218",
        "ry": ".218"
      }, {
        "x": "12.281",
        "y": "16.829",
        "width": "1.315",
        "height": "1.315",
        "rx": ".218",
        "ry": ".218"
      }, {
        "x": "10.087",
        "y": "14.638",
        "width": "1.315",
        "height": "1.315",
        "rx": ".218",
        "ry": ".218"
      }, {
        "x": "10.087",
        "y": "16.829",
        "width": "1.315",
        "height": "1.315",
        "rx": ".218",
        "ry": ".218"
      }],
      "path": {
        "d": "M17.2 4.8H6.8a1.9 1.9 0 0 0-2 1.9v10.6a1.9 1.9 0 0 0 2 1.9h1.4a.9.9 0 0 1-.1-.4v-5.4a.3.3 0 0 1 .3-.3h9a.3.3 0 0 1 .3.3v5.4a.9.9 0 0 1 0 .4 1.9 1.9 0 0 0 1.5-1.9V6.7c0-1-.9-1.9-2-1.9zM7.4 8.7a.7.7 0 0 1-.7-.7v-.7a.7.7 0 0 1 .7-.6h3.4a.7.7 0 0 1 .6.6V8a.7.7 0 0 1-.6.7zm10.3 3.4a.3.3 0 0 1-.3.3h-9a.3.3 0 0 1-.3-.3v-.6a.9.9 0 0 1 .8-.9H10v-.4a.7.7 0 0 1 1.4 0v.4h3v-.4a.7.7 0 0 1 1.3 0v.4h1.1a.9.9 0 0 1 .9.9z",
        "fill-rule": "evenodd"
      }
    },
    service_contract: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M16.6 6.9l-3.2-3.1c-.1-.1-.1-.1-.2-.1-.2 0-.4.1-.4.3v2.6c0 .5.5.9 1 .9h2.5c.2 0 .4-.1.4-.3 0-.1 0-.2-.1-.3zm.1 2.5c0-.2-.2-.4-.5-.4h-3.4c-.8 0-1.4-.7-1.4-1.5V4.2c0-.3-.2-.5-.5-.5H6.1c-.8 0-1.4.6-1.4 1.4v11.5c0 .8.6 1.5 1.4 1.5H11s.5-.3.4-.7-.1-2.2 1.1-3.6 3.1-1.4 3.4-1.4c.3 0 .8-.1.8-.5V9.4zM6.4 6.7l1.1-.2h.1l.5-1.1c.1-.1.2-.1.2 0l.6 1.1 1.2.2c.1 0 .1.1.1.2l-.9.8v.1L9.5 9s-.1.1-.2.1l-1-.6h-.1l-1.1.6C7 9.1 6.9 9 7 9l.2-1.2s0-.1-.1-.1l-.8-.8c-.1-.1 0-.2.1-.2zm4.3 8c0 .3-.2.5-.5.5H7.1c-.3 0-.5-.2-.5-.5v-.5c0-.2.2-.4.5-.4h3.1c.3 0 .5.2.5.4v.5zm2.6-2.9c0 .3-.2.5-.5.5H7.1c-.3 0-.5-.2-.5-.5v-.4c0-.3.2-.5.5-.5h5.7c.3 0 .5.2.5.5v.4zm2.6 1.7c-1.9 0-3.4 1.5-3.4 3.4s1.5 3.5 3.4 3.5 3.4-1.6 3.4-3.5-1.5-3.4-3.4-3.4zm.6 3.7h-.3l-1.3 1.3c-.1.1-.2.1-.3.1-.1 0-.2 0-.3-.1-.1-.2-.1-.4 0-.6l1.3-1.3v-.3c0-.6.4-1.1 1-1.1h.3c.1 0 .1.1 0 .1l-.5.6c-.1 0-.1.1 0 .2l.4.4h.1l.6-.6h.1c0 .1.1.2.1.3-.1.6-.6 1.1-1.2 1z"
      }
    },
    service_crew: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M14.4 12.3h-.9v-1c0-1.5-.8-2.7-1.9-3.3v1.8c0 1-.8 1.8-1.7 1.8s-1.8-.8-1.8-1.8V8c-1.1.6-2 1.8-2 3.2v1.1h-.8c-.3 0-.5.2-.5.5s.2.5.5.5h9.1c.3 0 .5-.2.5-.5s-.2-.5-.5-.5zm-4.5-1.8c.4 0 .7-.3.7-.7V7.6H9.2v2.2c0 .4.3.7.7.7zM9.9 18.6c-2.2 0-3.9-1.9-3.9-4.3h1c0 1.8 1.3 3.3 2.9 3.3s2.9-1.5 2.9-3.3h.9c0 2.4-1.7 4.3-3.8 4.3zm5.8-11c.2 0 .5-.3.5-.5V5.5c-.2 0-.4-.1-.5-.1-.2 0-.3.1-.5.1v1.6c0 .2.2.5.5.5zm-.1 6.2v-1c1.1 0 1.9-.9 1.9-2.1h1c0 1.7-1.3 3.1-2.9 3.1zm3.1-5.1h-.5V8c0-.9-.5-1.8-1.3-2.2v1.3c0 .6-.6 1.2-1.2 1.2-.7 0-1.2-.6-1.2-1.2V5.7c-.8.4-1.4 1.3-1.4 2.2.5.5.8 1.1 1.1 1.8h4.5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5z"
      }
    },
    service_crew_member: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.6 10.9h-1.4V9.4c0-2-1.1-3.7-2.7-4.6v2.6c0 1.4-1.1 2.5-2.5 2.5S9.6 8.8 9.6 7.4V4.8c-1.7.8-2.9 2.6-2.9 4.6v1.5H5.4c-.3 0-.6.3-.6.7v.1c0 .4.2.7.6.7h13.1c.4 0 .7-.3.7-.7v-.1c0-.4-.3-.7-.6-.7zM12 8.4c.6 0 1-.4 1-1V4.3c-.3-.1-.6-.1-1-.1-.3 0-.6 0-1 .1v3.1c0 .6.5 1 1 1zM12 19.8c-3 0-5.5-2.7-5.5-6h1.4c0 2.5 1.8 4.6 4.1 4.6s4.1-2.1 4.1-4.6h1.4c0 3.3-2.5 6-5.5 6z"
      }
    },
    service_report: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M17.2 6h-.4a.2.2 0 0 0-.3.2v1a1.9 1.9 0 0 1-1.9 1.9H9.4a1.9 1.9 0 0 1-1.9-1.9v-1a.2.2 0 0 0-.3-.2h-.4a1.4 1.4 0 0 0-1.5 1.4v10.4a1.4 1.4 0 0 0 1.5 1.4h10.4a1.4 1.4 0 0 0 1.5-1.4V7.4A1.4 1.4 0 0 0 17.2 6zm-6.9 9.8a.5.5 0 0 1-.4.5h-.5a.5.5 0 0 1-.5-.5v-2.4a.5.5 0 0 1 .5-.4h.5a.5.5 0 0 1 .4.4zm2.4 0a.5.5 0 0 1-.5.5h-.4a.5.5 0 0 1-.5-.5v-4.5a.5.5 0 0 1 .5-.5h.4a.5.5 0 0 1 .5.5zm2.4 0a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.4-.5v-3.6a.5.5 0 0 1 .4-.4h.5a.5.5 0 0 1 .5.4zM9.4 7.7h5.2a.5.5 0 0 0 .5-.5v-1a1.4 1.4 0 0 0-1.4-1.4h-3.4a1.4 1.4 0 0 0-1.4 1.4v1a.5.5 0 0 0 .5.5z",
        "fill-rule": "evenodd"
      }
    },
    service_resource: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M17.2 4.8H6.8a1.9 1.9 0 0 0-2 1.9v10.6a1.9 1.9 0 0 0 2 1.9h2.6c.3-1.1 1.5-1.7 2.9-2.3 1-.4 1.2-.8 1.2-1.2s-.3-.8-.7-1.2a2.7 2.7 0 0 1-.9-2.1c0-1.6 1.1-3 2.9-3s2.9 1.4 2.9 3a2.9 2.9 0 0 1-1 2.1c-.3.4-.6.8-.6 1.2s.1.8 1.2 1.2a10 10 0 0 1 1.8 1 1.7 1.7 0 0 0 .1-.6V6.7c0-1-.9-1.9-2-1.9zM11.4 8a.7.7 0 0 1-.6.7H7.4a.7.7 0 0 1-.7-.7v-.7a.7.7 0 0 1 .7-.6h3.4a.7.7 0 0 1 .6.6z",
        "fill-rule": "evenodd"
      }
    },
    service_territory: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M13.6 14.9a1.8 1.8 0 0 1-1.8-1.7 1.7 1.7 0 0 1 1.8-1.8 1.7 1.7 0 1 1 0 3.5zm3.6-10.1H6.8a1.9 1.9 0 0 0-2 1.9v10.6a1.9 1.9 0 0 0 2 1.9h5.8c-1.2-1.1-3.2-3.3-3.2-5.6a4.2 4.2 0 0 1 8.3 0c0 2.3-2.1 4.5-3.3 5.6h2.8a1.9 1.9 0 0 0 2-1.9V6.7c0-1-.9-1.9-2-1.9zM11.4 8a.7.7 0 0 1-.6.7H7.4a.7.7 0 0 1-.7-.7v-.7a.7.7 0 0 1 .7-.6h3.4a.7.7 0 0 1 .6.6z",
        "fill-rule": "evenodd"
      }
    },
    service_territory_location: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M15.9 14.3c-.5 0-.9-.4-.9-1 0-.5.4-.9.9-.9s.9.4 1 .9c0 .5-.5 1-1 1zm-4.5 0c-.6 0-1-.4-1-1 0-.5.4-.9 1-.9s.9.4.9.9-.4 1-.9 1zm2.2 0c-.5 0-.9-.4-.9-1 0-.5.4-.9.9-.9s1 .4 1 .9-.4 1-1 1zm3.6-9.5H6.7c-1 0-1.9.9-1.9 1.9v10.7c0 1 .9 1.9 1.9 1.8h5.9c-1.2-1-3.3-3.3-3.3-5.6s1.9-4.1 4.2-4.1c2.3 0 4.1 1.8 4.1 4.1 0 2.4-2 4.6-3.2 5.6h2.8c1.1 0 1.9-.8 2-1.8V6.7c0-1-.9-1.9-2-1.9zM11.4 8c-.1.4-.4.7-.7.7H7.3c-.4 0-.7-.3-.7-.7v-.6c0-.4.3-.7.7-.7h3.4c.3 0 .7.3.7.7V8z"
      }
    },
    service_territory_member: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M10.3 10.1A1.7 1.7 0 0 1 12 8.4a1.7 1.7 0 1 1-1.7 1.7zM12 4.8a6.1 6.1 0 1 0 6 6.1c0-3.3-2.7-6.1-6-6.1zm.2 10.5a.3.3 0 0 1-.4 0c-.8-.5-3.3-2.8-3.3-5.1a3.5 3.5 0 0 1 7 0c0 2.3-2.5 4.5-3.3 5.1zm-6 .1h-.3a1.1 1.1 0 0 0-1.1 1.1v1.6a1.1 1.1 0 0 0 1.1 1.1h12.2a1.1 1.1 0 0 0 1.1-1.1v-1.6a1.1 1.1 0 0 0-1.1-1.1h-.4a7.2 7.2 0 0 1-11.5 0z",
        "fill-rule": "evenodd"
      }
    },
    shipment: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M12.7 12.9v5.8c0 .2.1.3.3.3 0 0 .1 0 .1-.1 1.1-.6 4.6-2.6 4.6-2.6.5-.3.8-.7.8-1.3V9.8c0-.2-.1-.3-.3-.3 0 0-.1 0-.1.1L13 12.5c-.2 0-.3.2-.3.4zm-.5-1.7l5.2-2.9c.1 0 .2-.2.1-.3l-.1-.1c-1.1-.6-4.7-2.6-4.7-2.6-.4-.3-1-.3-1.4 0 0 0-3.6 1.9-4.7 2.6-.1.1-.2.2-.1.4h.1l5.2 2.9c.1.1.3.1.4 0zM11 12.5L5.9 9.6c-.1-.1-.3-.1-.4 0V15c0 .5.3 1 .8 1.3 0 0 3.5 2 4.6 2.6.1.1.3 0 .4-.1V12.9c0-.2-.1-.4-.3-.4z"
      }
    },
    skill: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M10.5 11.2a1.3 1.3 0 1 1 1.3-1.3 1.3 1.3 0 0 1-1.3 1.3zm8.1 2.2l-1.8-2.6v-.2a5.8 5.8 0 0 0-5.7-5.8 5.3 5.3 0 0 0-1.4.2 5.7 5.7 0 0 0-4.3 5.6 5.3 5.3 0 0 0 .8 3c1 1.4 1.7 2.6 1.3 4.2a1.1 1.1 0 0 0 .2 1 1.1 1.1 0 0 0 .9.4h4.7a1.1 1.1 0 0 0 1.1-.9 1.2 1.2 0 0 0 0-.3.6.6 0 0 1 .6-.5h.4a1.1 1.1 0 0 0 1.1-.8 9.9 9.9 0 0 0 .3-2.3h1.3a.7.7 0 0 0 .5-.4.7.7 0 0 0 0-.6zm-4.8-2l-.2.3a.5.5 0 0 1-.5.3.6.6 0 0 1-.1-.1l-.7-.2a2.8 2.8 0 0 1-.9.5l-.1.7a.5.5 0 0 1-.5.4h-.5a.5.5 0 0 1-.5-.4l-.1-.7a2.4 2.4 0 0 1-.9-.5l-.6.3a.6.6 0 0 1-.2 0 .5.5 0 0 1-.4-.2l-.3-.4a.5.5 0 0 1 .2-.6l.5-.5a2.4 2.4 0 0 1 0-.5 2.3 2.3 0 0 1 0-.5l-.5-.4a.5.5 0 0 1-.2-.7l.3-.3a.5.5 0 0 1 .4-.3.6.6 0 0 1 .2.1l.7.2a2.8 2.8 0 0 1 .8-.5l.1-.7a.5.5 0 0 1 .5-.4h.5a.5.5 0 0 1 .5.4l.1.7a2.7 2.7 0 0 1 .9.5l.7-.3a.6.6 0 0 1 .1 0 .5.5 0 0 1 .5.2l.2.4a.5.5 0 0 1-.1.6l-.6.5a2.3 2.3 0 0 1 .1.5 2.3 2.3 0 0 1-.1.5l.6.4a.5.5 0 0 1 .1.7z",
        "fill-rule": "evenodd"
      }
    },
    skill_entity: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.6 13.4l-1.8-2.6v-.2c0-3.2-2.6-5.8-5.8-5.8-.4 0-.9 0-1.3.2-2.6.5-4.4 2.9-4.4 5.6 0 1.1.3 2.2.8 3 1.1 1.4 1.7 2.6 1.3 4.2-.1.3 0 .7.2 1 .2.3.6.4.9.4h4.7c.6 0 1.1-.4 1.2-.9V18c.1-.3.3-.5.6-.5h.3c.6 0 1-.3 1.2-.8.1-.5.3-1.3.3-2.3h1.3c.2 0 .4-.2.5-.4.1-.2.1-.5 0-.6zm-3.9-3.3c-.2.3-.5.5-1.1.5-2.9 0-3.2 2.1-3.2 3.2 0 .4-.3.8-.8.8h-.1c-.4 0-.7-.2-.8-.7-.1-.4-.4-.6-.7-.8-.2-.2-.4-.3-.5-.5-.3-.6-.5-1.2-.5-2.1C7 8.7 8.3 7 10 6.6c.4 0 .7-.1 1-.1 1.6 0 3.1 1 3.7 2.5.1 0 .3.6 0 1.1z"
      }
    },
    skill_requirement: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M12 13.9a1.6 1.6 0 1 1 1.6-1.6 1.6 1.6 0 0 1-1.6 1.6zm7.4-2.7h-1.3V6.4a1.6 1.6 0 0 0-1.7-1.6H7.6a1.6 1.6 0 0 0-1.7 1.6v4.8H4.6a.8.8 0 0 0 0 1.6h1.3v4.8a1.6 1.6 0 0 0 1.7 1.6h8.8a1.6 1.6 0 0 0 1.7-1.6v-4.8h1.3a.8.8 0 0 0 0-1.6zM16 14.3l-.3.4a.6.6 0 0 1-.5.3.7.7 0 0 1-.2 0l-.8-.3a3.4 3.4 0 0 1-1.1.6l-.1.9a.6.6 0 0 1-.6.5h-.6a.6.6 0 0 1-.6-.5l-.1-.9a2.9 2.9 0 0 1-1.1-.6l-.8.3a.7.7 0 0 1-.2.1.6.6 0 0 1-.6-.3l-.2-.5a.6.6 0 0 1 .1-.8l.7-.6a3.2 3.2 0 0 1-.1-.6 3 3 0 0 1 .1-.6l-.7-.6a.6.6 0 0 1-.1-.8l.2-.5a.6.6 0 0 1 .6-.3.7.7 0 0 1 .2.1l.8.3a3.3 3.3 0 0 1 1.1-.7l.1-.8a.6.6 0 0 1 .6-.5h.6a.6.6 0 0 1 .6.5l.1.8a3.3 3.3 0 0 1 1.1.6l.8-.3a.7.7 0 0 1 .2 0 .6.6 0 0 1 .5.3l.3.5a.6.6 0 0 1-.1.8l-.7.5a3 3 0 0 1 .1.7 3 3 0 0 1-.1.6l.7.6a.6.6 0 0 1 .1.8z",
        "fill-rule": "evenodd"
      }
    },
    social: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M16.8 13.7c-1.2 0-2.1.8-2.4 1.9h-3.1c-.2 0-.3.1-.3.3V16.8c-.1.1.1.2.2.2h3.4c.4.9 1.2 1.5 2.2 1.5 1.3 0 2.4-1.1 2.4-2.4s-1.1-2.4-2.4-2.4zm-6.4-2.8c-.3-.1-.6-.3-.8-.5-.1-.1-.3 0-.4.1l-1.7 3.2h-.3c-1.3 0-2.4 1.1-2.4 2.4s1.1 2.4 2.4 2.4 2.4-1.1 2.4-2.4c0-.7-.3-1.3-.7-1.8l1.6-3c.1-.2 0-.3-.1-.4zM12 9.8c.2 0 .5 0 .7-.1l1.6 3.1c.1.1.2.2.4.1.2-.2.5-.3.8-.4.1-.1.2-.2.1-.4l-1.7-3.2c.3-.4.5-.9.5-1.5C14.4 6.1 13.3 5 12 5S9.6 6.1 9.6 7.4s1.1 2.4 2.4 2.4z"
      }
    },
    solution: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M11.4 4.8C9.1 5.1 7.2 6.9 7 9.2c-.2 1.7.6 3.3 1.8 4.2.3.3.6.8.6 1.2 0 .7.5 1.3 1.2 1.3h2.8c.7 0 1.2-.6 1.2-1.3 0-.4.3-.9.6-1.2 1.1-.9 1.8-2.2 1.8-3.7 0-2.9-2.5-5.2-5.6-4.9zm2.8 12.5H9.8c-.2 0-.4.2-.4.5 0 .8.6 1.4 1.4 1.4h2.4c.8 0 1.4-.6 1.4-1.4 0-.3-.2-.5-.4-.5z"
      }
    },
    sossession: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M11.9 4.3c-4.2.1-7.6 3.6-7.6 7.8.1 4.2 3.6 7.6 7.8 7.6 4.2-.1 7.6-3.6 7.6-7.8-.1-4.2-3.6-7.6-7.8-7.6zm0 1c1.2 0 2.2.3 3.2.8L14 7.8c-.6-.3-1.3-.5-2-.5s-1.4.2-2 .5L8.9 6.1c.9-.5 1.9-.8 3-.8zM7.8 14l-1.7 1.1c-.5-.9-.8-1.9-.8-3 0-1.2.3-2.3.8-3.2l1.7 1c-.3.7-.5 1.4-.5 2.1s.2 1.4.5 2zm4.3 4.7c-1.2 0-2.2-.3-3.2-.8l1.1-1.7c.6.3 1.3.5 2 .5s1.4-.2 2-.5l1.1 1.7c-.9.5-1.9.8-3 .8zm-.1-3c-2 0-3.7-1.7-3.7-3.7S10 8.3 12 8.3s3.7 1.7 3.7 3.7-1.7 3.7-3.7 3.7zm4.2-1.7c.3-.6.5-1.3.5-2s-.2-1.4-.5-2l1.7-1.1c.5.9.8 1.9.8 3 0 1.2-.3 2.3-.8 3.2L16.2 14z"
      }
    },
    task: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M11.2 5.7l-.5-.5c-.2-.2-.4-.2-.5 0L7 8.4 5.7 7.1c-.1-.2-.3-.2-.5 0l-.5.5c-.1.1-.1.3 0 .5l1.8 1.8c.1.1.3.2.5.2s.4-.1.5-.2l3.7-3.7c.1-.1.1-.4 0-.5zm7.3 3.4h-6.3c-.2 0-.4-.2-.4-.5v-.9c0-.3.2-.5.4-.5h6.3c.2 0 .5.2.5.5v.9c0 .3-.3.5-.5.5zm0 4.3h-7.7c-.3 0-.5-.2-.5-.4v-1c0-.3.2-.5.5-.5h7.7c.2 0 .5.2.5.5v1c0 .2-.3.4-.5.4zm-10.6 0H7c-.3 0-.5-.2-.5-.4v-1c0-.3.2-.5.5-.5h.9c.3 0 .5.2.5.5v1c0 .2-.2.4-.5.4zm0 4.4H7c-.3 0-.5-.3-.5-.5v-1c0-.2.2-.5.5-.5h.9c.3 0 .5.3.5.5v1c0 .2-.2.5-.5.5zm10.6 0h-7.7c-.3 0-.5-.3-.5-.5v-1c0-.2.2-.5.5-.5h7.7c.2 0 .5.3.5.5v1c0 .2-.3.5-.5.5z"
      }
    },
    task2: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M10.2 17c-.3 0-.6-.1-.8-.3l-4.5-4.5c-.1-.2-.1-.5 0-.7l.9-.8c.2-.2.5-.2.7 0l3.7 3.7 7.3-7.3c.2-.2.5-.2.7 0l.9.9c.1.2.1.4 0 .6L11 16.7c-.2.2-.5.3-.8.3z"
      }
    },
    team_member: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": [{
        "d": "M13.7 10.6h-2.9c-.8 0-1.4.6-1.4 1.4v2.2c0 .2.1.5.2.6.2.2.5.3.7.3v2.2c0 .8.7 1.4 1.5 1.4h.9c.8 0 1.5-.6 1.5-1.4v-2.2c.2 0 .5-.1.6-.3.2-.1.3-.4.3-.6V12c0-.8-.6-1.4-1.4-1.4z"
      }, {
        "d": "M8.8 16c-.1 0-.1-.1-.2-.1-.4-.5-.7-1.1-.7-1.7V12c0-.8.3-1.5.8-2 .2-.1 0-.4-.2-.4H6.2c-.8 0-1.4.6-1.4 1.4v2.2c0 .3.1.5.3.7.2.1.4.3.7.3v2.1c0 .8.6 1.5 1.4 1.5h1c.2 0 .4-.1.5-.2.1 0 .2-.1.2-.2v-1.2c0-.1 0-.1-.1-.2z"
      }, {
        "d": "M18.2 9.6h-2.3c-.2 0-.3.2-.1.4.5.5.8 1.2.8 2v2.2c0 .6-.3 1.2-.7 1.7-.1 0-.1.1-.2.1-.1.1-.1.1-.1.2v1.2c0 .1 0 .2.1.2.2.1.4.2.6.2h1c.8 0 1.4-.7 1.4-1.5v-2.1c.3 0 .5-.1.7-.3.2-.2.3-.4.3-.7V11c0-.8-.7-1.4-1.5-1.4z"
      }],
      "circle": [{
        "cx": "12.24",
        "cy": "7.92",
        "r": "1.68"
      }, {
        "cx": "7.68",
        "cy": "6.96",
        "r": "1.68"
      }, {
        "cx": "16.8",
        "cy": "6.96",
        "r": "1.68"
      }]
    },
    template: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M17.7 4.8H6.3c-.8 0-1.5.7-1.5 1.5v11.4c0 .8.7 1.5 1.5 1.5h11.4c.8 0 1.5-.7 1.5-1.5V6.3c0-.8-.7-1.5-1.5-1.5zm-7.5 11.8c0 .2-.2.3-.4.3H7.3c-.2 0-.3-.2-.3-.4v-4.8c0-.2.2-.3.3-.3h2.5c.2 0 .4.2.4.4v4.8zm6.8 0c0 .2-.2.4-.4.4H12c-.2 0-.4-.2-.4-.4v-4.9c0-.2.2-.3.4-.3h4.7c.1 0 .3.2.3.4v4.8zm0-7c0 .2-.2.3-.4.3H7.3c-.2 0-.3-.2-.3-.4V7.4c0-.2.2-.4.3-.4h9.4c.2 0 .3.2.3.4v2.2z"
      }
    },
    thanks: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17.8 8.4h-2.1c.6-.9.5-2.2-.2-3-.4-.4-1-.6-1.6-.6-.6 0-1.2.3-1.7.8-.1.1-.1.2-.2.3-.1-.1-.1-.2-.2-.3-.5-.5-1.1-.8-1.7-.8-.6 0-1.1.2-1.6.6-.7.8-.7 2.1-.1 3H6.2c-.8 0-1.4.6-1.4 1.4v1c0 .3.2.5.5.5h13.4c.3 0 .5-.2.5-.5v-1c0-.8-.6-1.4-1.4-1.4zm-6.5 0c-.5 0-1.2-.2-1.7-.6-.3-.4-.4-1 0-1.3.1-.2.3-.2.5-.2s.4.1.6.3c.4.4.6 1.2.6 1.7v.1zm3.1-.6c-.5.4-1.2.6-1.7.6v-.1c0-.5.2-1.3.6-1.7.2-.2.4-.4.6-.4.2 0 .4.1.5.2.3.4.3 1 0 1.4zm3.4 4.9h-5.1v6.5h4.1c.8 0 1.4-.6 1.4-1.4v-4.6c0-.3-.2-.5-.4-.5zm-12 .5v4.6c0 .8.6 1.4 1.4 1.4h4.1v-6.5H6.2c-.2 0-.4.2-.4.5z"
      }
    },
    thanks_loading: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "opacity": ".5",
        "d": "M17.8 8.4h-2.1c.6-.9.5-2.2-.2-3-.4-.4-1-.6-1.6-.6-.6 0-1.2.3-1.7.8-.1.1-.1.2-.2.3-.1-.1-.1-.2-.2-.3-.5-.5-1.1-.8-1.7-.8-.6 0-1.1.2-1.6.6-.7.8-.7 2.1-.1 3H6.2c-.8 0-1.4.6-1.4 1.4v1c0 .3.2.5.5.5h13.4c.3 0 .5-.2.5-.5v-1c0-.8-.6-1.4-1.4-1.4zm-6.5 0c-.5 0-1.2-.2-1.7-.6-.3-.4-.4-1 0-1.3.1-.2.3-.2.5-.2s.4.1.6.3c.4.4.6 1.2.6 1.7v.1zm3.1-.6c-.5.4-1.2.6-1.7.6v-.1c0-.5.2-1.3.6-1.7.2-.2.4-.4.6-.4.2 0 .4.1.5.2.3.4.3 1 0 1.4zm3.4 4.9h-5.1v6.5h4.1c.8 0 1.4-.6 1.4-1.4v-4.6c0-.3-.2-.5-.4-.5zm-12 .5v4.6c0 .8.6 1.4 1.4 1.4h4.1v-6.5H6.2c-.2 0-.4.2-.4.5z"
      }
    },
    timesheet: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17 4.8H7c-1 0-1.9.8-1.9 1.9v10.6c0 1 .9 1.9 1.9 1.9h10c1 0 1.9-.9 1.9-1.9V6.7c0-1.1-.9-1.9-1.9-1.9zm-.6 11.3c0 .3-.3.6-.6.6H8.2c-.3 0-.6-.3-.6-.6v-.6c0-.4.3-.7.6-.7h7.5c.4 0 .7.3.7.7v.6zm0-3.8c0 .3-.3.6-.6.6H8.2c-.3 0-.6-.3-.6-.6v-.6c0-.3.3-.6.6-.6h7.5c.4 0 .7.3.7.6v.6zm0-3.7c0 .3-.3.6-.6.6H8.2c-.3 0-.6-.3-.6-.6v-.7c0-.3.3-.6.6-.6h7.5c.4 0 .7.3.7.6v.7z"
      }
    },
    timesheet_entry: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M17 4.8H7c-1 0-1.9.8-1.9 1.9v10.6c0 1 .9 1.9 1.9 1.9h10c1 0 1.9-.9 1.9-1.9V6.7c0-1.1-.9-1.9-1.9-1.9zm-.6 11.3c0 .3-.3.6-.6.6H8.2c-.3 0-.6-.3-.6-.6v-.6c0-.4.3-.7.6-.7h7.5c.4 0 .7.3.7.7v.6zM9.8 12l.4-.3c0-.1.2-.1.3 0l.9.8 2.1-2.1c.1-.1.3-.1.3 0l.4.3c.1.1.1.3 0 .3l-2.5 2.6c-.1.1-.2.1-.3.1-.1 0-.3 0-.4-.1l-1.2-1.2c-.1-.2-.1-.3 0-.4zm6.6-3.4c0 .3-.3.6-.6.6H8.2c-.3 0-.6-.3-.6-.6v-.7c0-.3.3-.6.6-.6h7.5c.4 0 .7.3.7.6v.7z"
      }
    },
    timeslot: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M17 4.8H7a1.9 1.9 0 0 0-1.9 1.9v10.6A1.9 1.9 0 0 0 7 19.2h10a1.9 1.9 0 0 0 1.9-1.9V6.7A1.9 1.9 0 0 0 17 4.8zM7.6 7.9a.6.6 0 0 1 .7-.6h3.2a.6.6 0 0 1 .6.6v.6a.6.6 0 0 1-.6.7H8.3a.6.6 0 0 1-.7-.7zm8.7 8.2a.6.6 0 0 1-.6.6h-3.2a.6.6 0 0 1-.6-.6v-.6a.6.6 0 0 1 .6-.7h3.2a.6.6 0 0 1 .6.7zm.1-3a.7.7 0 0 1-.6.6H8.3a.6.6 0 0 1-.7-.6v-2.2a.6.6 0 0 1 .7-.6h7.5a.6.6 0 0 1 .6.6z",
        "fill-rule": "evenodd"
      }
    },
    today: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M12 4.8C8 4.8 4.8 8 4.8 12S8 19.2 12 19.2s7.2-3.2 7.2-7.2S16 4.8 12 4.8zm0 13c-3.2 0-5.8-2.6-5.8-5.8S8.8 6.2 12 6.2s5.8 2.6 5.8 5.8-2.6 5.8-5.8 5.8zm.7-6.1V8.6c0-.2-.2-.4-.5-.4h-.4c-.3 0-.5.2-.5.4V12c0 .2.1.4.2.5l2.3 2.3c.2.2.5.2.7 0l.3-.3c.2-.2.2-.5 0-.7l-2.1-2.1z"
      }
    },
    topic: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M14.7 8.9c.1.2.2.3.4.4l.5.1c.1 0 .2 0 .3-.1l1.1-2c.3-.4.1-.6-.4-.3l-1.9 1.1c-.1.1-.2.2-.1.3l.1.5zm-6.6.4c.1.1.2.1.3.1l.5-.1c.2-.1.3-.2.4-.4l.1-.5c0-.1 0-.2-.1-.3L7.3 7c-.4-.3-.6-.1-.3.4l1.1 1.9zm7.8 5.4c-.1-.1-.2-.1-.3-.1l-.5.1c-.2.1-.3.2-.4.4l-.1.5c0 .1 0 .2.1.3l2 1.1c.4.3.6.1.3-.4l-1.1-1.9zm-6.6.4c-.1-.2-.2-.3-.4-.4l-.5-.1c-.1 0-.2 0-.3.1l-1.1 2c-.3.4-.1.6.4.3l1.9-1.1c.1-.1.2-.2.1-.3l-.1-.5zm9.5-3.3l-4.9-1.4c-.2 0-.3-.1-.3-.3l-1.4-4.9c-.1-.5-.3-.5-.5 0l-1.3 4.9c0 .2-.2.3-.3.3l-4.9 1.4c-.5.1-.5.3 0 .5l4.9 1.3c.2 0 .3.2.3.3l1.4 4.9c.1.5.3.5.5 0l1.3-4.9c0-.2.2-.3.3-.3l4.9-1.4c.5-.1.5-.3 0-.4zM12 13.2c-.7 0-1.2-.5-1.2-1.2s.5-1.2 1.2-1.2 1.2.5 1.2 1.2-.5 1.2-1.2 1.2z"
      }
    },
    topic2: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M18.8 8.2h-1.9l.8-3.1V5c0-.1-.1-.2-.3-.2h-1.5c-.1 0-.2.1-.2.2l-.8 3.2h-3.8l.8-3.1V5c0-.1-.1-.2-.2-.2h-1.5c-.2 0-.3.1-.3.2l-.8 3.2H7c-.2 0-.2.1-.3.2l-.4 1.4v.1c0 .1.1.2.3.2h2l-1 3.7h-2c-.1 0-.2 0-.2.1L5 15.4c0 .1.1.2.2.2h1.9l-.8 3.2v.1c0 .1.1.2.3.2h1.5c.1 0 .2-.1.2-.2l.8-3.3h3.8l-.8 3.2c0 .2.1.3.2.3h1.5c.2 0 .3-.1.3-.2l.8-3.3H17c.1 0 .2-.1.3-.2l.3-1.4v-.1c0-.1-.1-.2-.2-.2h-2l1-3.7h2c.1 0 .2 0 .2-.2l.4-1.4c0-.1-.1-.2-.2-.2zm-5.4 5.6H9.6l1-3.6h3.8l-1 3.6z"
      }
    },
    unmatched: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M15.8 11.2c-.1-.1-.2-.2-.3-.2h-7c-.1 0-.2.1-.3.2v1.6c.1.1.2.2.3.2h7c.1 0 .2-.1.3-.2V12v-.8zM12 4.8C8 4.8 4.8 8 4.8 12S8 19.2 12 19.2s7.2-3.2 7.2-7.2S16 4.8 12 4.8zm0 12.5c-2.9 0-5.3-2.4-5.3-5.3S9.1 6.7 12 6.7s5.3 2.4 5.3 5.3-2.4 5.3-5.3 5.3z"
      }
    },
    user: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M19.2 17.1v.7c0 .8-.6 1.4-1.4 1.4H6.2c-.8 0-1.4-.6-1.4-1.4v-.7c0-1.8 2-2.8 4-3.7 0 0 .1 0 .2-.1.1 0 .3 0 .4.1.8.5 1.7.8 2.6.8.9 0 1.8-.3 2.6-.8.1-.1.3-.1.4 0 .1 0 .2 0 .2.1 2 .8 4 1.8 4 3.6z"
      },
      "ellipse": {
        "cx": "12",
        "cy": "8.76",
        "rx": "3.576",
        "ry": "3.96"
      }
    },
    work_order: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M15.6 12.5c-.8.4-1.2 1.2-1.2 1.3-.1.2-.2.2-.2.2H9.9c-.1 0-.2-.1-.2-.2-.4-.8-1.2-1.4-2.2-1.4-.9 0-1.6.4-2 1.2-.1.1-.2.1-.3 0-.3-.2-.4-.5-.4-.9 0 0-.1-2.7.8-4.2.2-.2.3-.3.5-.3h9.1c.1 0 .2 0 .3.1 0 0 1 1.5 1.2 1.6.1.2.2.3.5.3.2.1 2 .7 2 .7v1.8c0 .4-.1.7-.3.9-.1.1-.2 0-.3-.1-.4-.7-1.1-1.2-2-1.2-.4 0-.7.1-1 .2"
      },
      "ellipse": [{
        "cx": "16.56",
        "cy": "14.664",
        "rx": "1.176",
        "ry": "1.176"
      }, {
        "cx": "7.56",
        "cy": "14.664",
        "rx": "1.176",
        "ry": "1.176"
      }]
    },
    work_order_item: {
      "xmlns": "http://www.w3.org/2000/svg",
      "path": {
        "d": "M9.4 7.7h5.2c.3 0 .5-.2.5-.5v-1c0-.8-.6-1.4-1.4-1.4h-3.4c-.8 0-1.4.6-1.4 1.4v1c0 .3.2.5.5.5zM17.3 6h-.5c-.1 0-.2.1-.2.2v1c0 1.1-.9 1.9-2 1.9H9.4c-1.1 0-2-.8-2-1.9v-1c0-.1-.1-.2-.2-.2h-.5c-.8 0-1.4.6-1.4 1.4v10.4c0 .8.6 1.4 1.4 1.4h10.6c.8 0 1.4-.6 1.4-1.4V7.4c0-.8-.6-1.4-1.4-1.4zM16 11.8l-4.6 4.6c-.1.1-.2.2-.4.2s-.3-.1-.5-.2L8 13.8c-.2-.1-.2-.3 0-.4l.5-.5c.1-.1.2-.1.4 0L11 15l4.1-4.1c.1-.1.3-.1.4 0l.5.5c.1.1.1.3 0 .4z"
      }
    },
    work_type: {
      "xmlns": "http://www.w3.org/2000/svg",
      "title": {},
      "path": {
        "d": "M18.2 7L16 4.9a.3.3 0 0 0-.2-.1.3.3 0 0 0-.3.3v1.6a.9.9 0 0 0 .9.9H18a.3.3 0 0 0 .3-.3.4.4 0 0 0-.1-.3zM7.1 15V7.6A1.4 1.4 0 0 0 5.7 9v8.8a1.4 1.4 0 0 0 1.4 1.4h7a1.4 1.4 0 0 0 1.4-1.4H9.9c-1.5 0-2.8 0-2.8-2.8zm10.7-6h-2.3a1.4 1.4 0 0 1-1.4-1.4V5.3a.4.4 0 0 0-.5-.5H9.9a1.4 1.4 0 0 0-1.4 1.4V15a1.4 1.4 0 0 0 1.4 1.4h7a1.4 1.4 0 0 0 1.4-1.4V9.5a.5.5 0 0 0-.5-.5zM12 14.9a.6.6 0 0 1-.6.6h-1.2a.6.6 0 0 1-.6-.6v-1.2a.6.6 0 0 1 .6-.6h1.2a.6.6 0 0 1 .6.6zm0-3.3a.6.6 0 0 1-.6.6h-1.2a.6.6 0 0 1-.6-.6v-1.2a.6.6 0 0 1 .6-.5h1.2a.6.6 0 0 1 .6.5zm3.3 3.3a.6.6 0 0 1-.6.6h-1.2a.6.6 0 0 1-.6-.6v-1.2a.6.6 0 0 1 .6-.6h1.2a.6.6 0 0 1 .6.6zm0-3.3a.6.6 0 0 1-.6.6h-1.2a.6.6 0 0 1-.6-.6v-1.2a.6.6 0 0 1 .6-.6h1.2a.6.6 0 0 1 .6.6z",
        "fill-rule": "evenodd"
      }
    },
    viewBox: '0 0 24 24'
  };
}

/* harmony default export */ __webpack_exports__["a"] = (icons);

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_warning_if_one_then_both_required_property__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities_warning_sunset_property__ = __webpack_require__(11);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable import/no-mutable-exports */



var checkProps = function checkProps() {};

if (false) {
  checkProps = function checkProps(COMPONENT, props) {
    /* eslint-disable max-len */
    // If iconName is set, iconCategory must also be set.
    ifOneThenBothRequiredProperty(COMPONENT, props, {
      iconName: props.iconName,
      iconCategory: props.iconCategory
    });

    if (typeof props.assistiveText === 'string') {
      sunsetProperty(COMPONENT, props.assistiveText, 'assistiveText', '`assistiveText` as a string has been deprecated and is now an object to allow for multiple uses in the component. Please use `assistiveText.icon` instead.');
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (checkProps);
//# sourceMappingURL=check-props.js.map

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.14.4
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';

var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
var timeoutDuration = 0;
for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
    timeoutDuration = 1;
    break;
  }
}

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var css = getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.right - result.left;
  var height = sizes.height || element.clientHeight || result.bottom - result.top;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop, 10);
    var marginLeft = parseFloat(styles.marginLeft, 10);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  return isFixed(getParentNode(element));
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var styles = getComputedStyle(element);
  var x = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
  var y = parseFloat(styles.marginLeft) + parseFloat(styles.marginRight);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicity asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  // Avoid blurry text by using full pixel integers.
  // For pixel-perfect positioning, top/bottom prefers rounded
  // values, while left/right prefers floored values.
  var offsets = {
    left: Math.floor(popper.left),
    top: Math.round(popper.top),
    bottom: Math.round(popper.bottom),
    right: Math.floor(popper.right)
  };

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
    var flippedVariation = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport'
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {HTMLElement|referenceObject} reference - The reference element used to position the popper
   * @param {HTMLElement} popper - The HTML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["a"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(17)))

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */



/*
 * This component mounts its children within a disconnected render tree (portal).
 */

var Portal =
/*#__PURE__*/
function (_Component) {
  _inherits(Portal, _Component);

  function Portal(props) {
    var _this;

    _classCallCheck(this, Portal);

    _this = _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).call(this, props));
    _this.portalNode = null;
    _this.state = {
      isOpen: false
    };
    return _this;
  }

  _createClass(Portal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.renderPortal();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.renderPortal();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unmountPortal();
    }
  }, {
    key: "getChildren",
    value: function getChildren() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    }
  }, {
    key: "getPortalParentNode",
    value: function getPortalParentNode() {
      var element;

      if (typeof this.props.renderTo === 'string') {
        element = document.querySelector(this.props.renderTo);
      } else {
        element = this.props.renderTo || document.body;
      }

      return element;
    }
  }, {
    key: "setupPortalNode",
    value: function setupPortalNode() {
      var parentParentNode = this.getPortalParentNode();
      this.portalNode = document.createElement(this.props.renderTag);
      parentParentNode.appendChild(this.portalNode);
      this.portalNodeInstance = this.props.onMount ? this.props.onMount(undefined, {
        portal: this.portalNode
      }) : this.portalNode;
    }
  }, {
    key: "unmountPortal",
    value: function unmountPortal() {
      if (this.portalNode) {
        __WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.unmountComponentAtNode(this.portalNode);
        this.portalNode.parentNode.removeChild(this.portalNode);
      }

      this.portalNode = null;
    }
  }, {
    key: "updatePortal",
    value: function updatePortal() {
      var _this2 = this;

      if (this.props.id) {
        this.portalNode.id = this.props.id;
      }

      if (this.props.className) {
        this.portalNode.className = this.props.className;
      }

      if (this.props.style) {
        Object.keys(this.props.style).forEach(function (key) {
          _this2.portalNode.style[key] = _this2.props.style[key];
        });
      }

      if (this.props.onUpdate) {
        this.portalNodeInstance = this.props.onUpdate(this.portalNodeInstance);
      }
    }
  }, {
    key: "renderPortal",
    value: function renderPortal() {
      var _this3 = this;

      // if no portal contents, then unmount
      if (!this.getChildren()) {
        this.unmountPortal();
        return;
      }

      if (!this.portalNode) {
        this.setupPortalNode();
      }

      if (this.props.portalMount) {
        this.props.portalMount({
          instance: this,
          reactElement: this.getChildren(),
          domContainerNode: this.portalNode,
          updateCallback: function updateCallback() {
            _this3.updatePortal(); // update after subtree renders

          }
        });
      } else {
        // actual render
        __WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.unstable_renderSubtreeIntoContainer(this, this.getChildren(), this.portalNode, function () {
          _this3.updatePortal(); // update after subtree renders


          if (_this3.state.isOpen === false) {
            if (_this3.props.onOpen) {
              _this3.props.onOpen(undefined, {
                portal: _this3.getChildren()
              });
            }

            _this3.setState({
              isOpen: true
            });
          }
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return Portal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Portal.displayName = 'Portal';
Portal.propTypes = {
  /*
   * What tag to use for the portal, defaults to `div`.
   */
  renderTag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /*
   * What node the portal is rendered to, defaults to `document.body`.
   */
  renderTo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,

  /*
   * React id prop.
   */
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /*
   * Accepts a _single_ element or component.
   */
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /*
   * ClassName added to .
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,

  /*
   * An object of styles that are applied to the portal.
   */
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /*
   * Triggers when Portal render tree mounts. Pass in an undefined event and `{ portal: [node] }``
   */
  onMount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /*
   * Triggers when the portal is mounted.
   */
  onOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /*
   * Triggers when Portal re-renders its tree.
   */
  onUpdate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /*
   * Triggers when Portal render tree unmounts.
   */
  onUnmount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * If a dialog is `positione="overflowBoundaryElement"`, it will be rendered in a portal or separate render tree. This `portalMount` callback will be triggered instead of the the default `ReactDOM.unstable_renderSubtreeIntoContainer` and the function will mount the portal itself. Consider the following code that bypasses the internal mount and uses an Enzyme wrapper to mount the React root tree to the DOM.
   *
   * ```
   * <Popover
   *   isOpen
   *   portalMount={({ instance, reactElement, domContainerNode }) => {
   *     portalWrapper = Enzyme.mount(reactElement, { attachTo: domContainerNode });
   *   }}
   *   onOpen={() => {
   *     expect(portalWrapper.find(`#my-heading`)).to.exist;
   *     done();
   *   }}
   * />
   * ```
   */
  portalMount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
Portal.defaultProps = {
  renderTag: 'span',
  renderTo: null,
  onMount: function onMount() {
    return null;
  },
  onOpen: function onOpen() {
    return null;
  },
  onUpdate: function onUpdate() {
    return null;
  },
  onUnmount: function onUnmount() {
    return null;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (Portal);
//# sourceMappingURL=portal.js.map

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */
function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();

  if (/input|select|textarea|button|object/.test(nodeName)) {
    return !element.disabled;
  } else if (nodeName === 'a') {
    return element.href || isTabIndexNotNaN;
  }

  return isTabIndexNotNaN;
}

function tabbable(element) {
  var tabIndex = element.getAttribute('tabindex');
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  return [].slice.call(element.querySelectorAll('*'), 0).filter(function (el) {
    return tabbable(el);
  });
}

/* harmony default export */ __webpack_exports__["a"] = (findTabbableDescendants);
//# sourceMappingURL=tabbable.js.map

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return canUseDOM; });
/* unused harmony export canUseEventListeners */
/* unused harmony export canUseViewport */
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var canUseEventListeners = canUseDOM && !!(window.addEventListener || window.attachEvent);
var canUseViewport = canUseDOM && !!window.screen;

//# sourceMappingURL=execution-environment.js.map

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getNubbinMargins; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getNubbinClassName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return mapPropToPopperPlacement; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
 // Translates the prop into a string popper can use https://popper.js.org/popper-documentation.html#Popper.placements

var mapPropToPopperPlacement = function mapPropToPopperPlacement(propString) {
  var placement;

  switch (propString) {
    case 'top left':
      placement = 'top-start';
      break;

    case 'top right':
      placement = 'top-end';
      break;

    case 'right top':
      placement = 'right-start';
      break;

    case 'right bottom':
      placement = 'right-end';
      break;

    case 'bottom left':
      placement = 'bottom-start';
      break;

    case 'bottom right':
      placement = 'bottom-end';
      break;

    case 'left top':
      placement = 'left-start';
      break;

    case 'left bottom':
      placement = 'left-end';
      break;

    default:
      placement = propString;
  }

  return placement;
};

var getNubbinClassName = function getNubbinClassName(align) {
  var popperData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (popperData.flipped) {
    return __WEBPACK_IMPORTED_MODULE_0_classnames___default()({
      'slds-nubbin--top': align === 'top',
      'slds-nubbin--top-left': align === 'top left',
      'slds-nubbin--top-right': align === 'top right',
      'slds-nubbin--bottom': align === 'bottom',
      'slds-nubbin--bottom-left': align === 'bottom left',
      'slds-nubbin--bottom-right': align === 'bottom right',
      'slds-nubbin--left': align === 'left',
      'slds-nubbin--left-bottom': align === 'left bottom',
      'slds-nubbin--left-top': align === 'left top',
      'slds-nubbin--right': align === 'right',
      'slds-nubbin--right-bottom': align === 'right bottom',
      'slds-nubbin--right-top': align === 'right top'
    });
  }

  return __WEBPACK_IMPORTED_MODULE_0_classnames___default()({
    'slds-nubbin--top': align === 'bottom',
    'slds-nubbin--top-left': align === 'bottom left',
    'slds-nubbin--top-right': align === 'bottom right',
    'slds-nubbin--bottom': align === 'top',
    'slds-nubbin--bottom-left': align === 'top left',
    'slds-nubbin--bottom-right': align === 'top right',
    'slds-nubbin--left': align === 'right',
    'slds-nubbin--left-bottom': align === 'right bottom',
    'slds-nubbin--left-top': align === 'right top',
    'slds-nubbin--right': align === 'left',
    'slds-nubbin--right-bottom': align === 'left bottom',
    'slds-nubbin--right-top': align === 'left top'
  });
};

var DISTANCE_OFFSET = 1.5; // 'rem'

var NUBBIN_SIZE = 1; // 'rem'

var ROTATED_HEIGHT = NUBBIN_SIZE / Math.sqrt(2); // 'rem'

/*
*
*
*
*
*/
// FIXME - still need to account for border shadow of 2px. probably only needs to be added to the rotated height.
// TODO - should we convert all rem to pixels right from the get go? Keep units consistent. Memoize the values for perf?

var getNubbinMargins = function getNubbinMargins() {
  var popperData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var placement = popperData.placement;
  var top = 0;
  var left = 0;
  var DISTANCE_OFFSET_PX = 16 * DISTANCE_OFFSET; // FIXME - actually do a real convert based on font size.

  var ROTATED_HEIGHT_PX = 16 * ROTATED_HEIGHT; // FIXME - actually do a real convert based on font size.

  var halfWidth = popperData.offsets.reference.width * 0.5;
  var halfHeight = popperData.offsets.reference.height * 0.5;

  if (placement === 'top') {
    top = ROTATED_HEIGHT_PX * -1;
  } else if (placement === 'top-end') {
    top = ROTATED_HEIGHT_PX * -1;
    left = DISTANCE_OFFSET_PX - halfWidth;
  } else if (placement === 'top-start') {
    top = ROTATED_HEIGHT_PX * -1;
    left = halfWidth - DISTANCE_OFFSET_PX;
  }

  if (placement === 'bottom') {
    top = ROTATED_HEIGHT_PX;
  } else if (placement === 'bottom-end') {
    top = ROTATED_HEIGHT_PX;
    left = DISTANCE_OFFSET_PX - halfWidth;
  } else if (placement === 'bottom-start') {
    top = ROTATED_HEIGHT_PX;
    left = halfWidth - DISTANCE_OFFSET_PX;
  }

  if (placement === 'right') {
    left = ROTATED_HEIGHT_PX;
  } else if (placement === 'right-end') {
    left = ROTATED_HEIGHT_PX;
    top = DISTANCE_OFFSET_PX - halfHeight;
  } else if (placement === 'right-start') {
    left = ROTATED_HEIGHT_PX;
    top = halfHeight - DISTANCE_OFFSET_PX;
  }

  if (placement === 'left') {
    left = ROTATED_HEIGHT_PX * -1;
  } else if (placement === 'left-end') {
    left = ROTATED_HEIGHT_PX * -1;
    top = DISTANCE_OFFSET_PX - halfHeight;
  } else if (placement === 'left-start') {
    left = ROTATED_HEIGHT_PX * -1;
    top = halfHeight - DISTANCE_OFFSET_PX;
  }

  return {
    left: left,
    top: top
  };
};


//# sourceMappingURL=dialog-helpers.js.map

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_warning_sunset_property__ = __webpack_require__(11);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable import/no-mutable-exports */


var checkProps = function checkProps() {};

if (false) {
  checkProps = function checkProps(COMPONENT, props) {
    if (typeof props.assistiveText === 'string') {
      sunsetProperty(COMPONENT, props.assistiveText, 'assistiveText', '`assistiveText` as a string has been deprecated and is now an object to allow for multiple uses in the component. Please use `assistiveText.label` instead.');
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (checkProps);
//# sourceMappingURL=check-props.js.map

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_warning_deprecated_property__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities_warning_deprecated_property_value__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_warning_is_trigger_tabbable__ = __webpack_require__(202);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable import/no-mutable-exports */




var checkProps = function checkProps() {};

if (false) {
  checkProps = function checkProps(COMPONENT, props) {
    if (props.variant === 'base') {
      isTriggerTabbable(COMPONENT, props.children, '');
    } // Deprecated and changed to another property


    deprecatedPropertyValue(COMPONENT, {
      propAsString: 'variant',
      propValue: props.variant,
      deprecatedPropValue: 'info',
      replacementPropAsString: 'theme',
      replacementPropAsValue: 'info'
    });
    deprecatedPropertyValue(COMPONENT, {
      propAsString: 'variant',
      propValue: props.variant,
      deprecatedPropValue: 'error',
      replacementPropAsString: 'theme',
      replacementPropAsValue: 'error'
    });
    deprecatedProperty(COMPONENT, props.openByDefault, 'openByDefault', 'isOpen');
    deprecatedProperty(COMPONENT, props.target, 'target', undefined, 'A new positioning library is being implmented under the hood. Please trigger tooltips to appear on their triggers with `isOpen` and not on other DOM elements.' // eslint-disable-line max-len
    );
    deprecatedProperty(COMPONENT, props.isInline, 'isInline', 'position="relative"');
  };
}

/* harmony default export */ __webpack_exports__["a"] = (checkProps);
//# sourceMappingURL=check-props.js.map

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable import/no-mutable-exports */

/* eslint-disable max-len */
// This function will deliver an error message to the browser console about the future of a removal and moving of a property's valid value to another prop. This makes the most sense to be used with `oneOf` prop types.


var deprecated = function deprecated() {};

if (false) {
  var hasWarned = {};

  deprecated = function deprecated(control, _ref, comment) {
    var propAsString = _ref.propAsString,
        propValue = _ref.propValue,
        deprecatedPropValue = _ref.deprecatedPropValue,
        replacementPropAsString = _ref.replacementPropAsString,
        replacementPropAsValue = _ref.replacementPropAsValue,
        log = _ref.log;
    var additionalComment = comment ? " ".concat(comment) : '';
    var warnOnFirstOccurrenceKey = control + propAsString + deprecatedPropValue;
    var triggerWarning = propValue === deprecatedPropValue;
    var replacementSentence = deprecatedPropValue && replacementPropAsString && replacementPropAsValue ? " Replace `".concat(propAsString, "=\"").concat(deprecatedPropValue, "\"` with `").concat(replacementPropAsString, "=\"").concat(replacementPropAsValue, "\"`.") : '';

    if (!hasWarned[warnOnFirstOccurrenceKey]) {
      var message = "[Design System React] The value of `".concat(deprecatedPropValue, "`, for prop `").concat(propAsString, "` will be removed in the next major version of ").concat(control, ". Please update your props.").concat(replacementSentence).concat(additionalComment);

      if (triggerWarning && log) {
        log({
          message: message
        });
      } else {
        warning(!triggerWarning, // false value triggers warning
        message);
      } // store global flag to limit warnings to first issue


      hasWarned[warnOnFirstOccurrenceKey] = triggerWarning;
    }
  };
}

/* unused harmony default export */ var _unused_webpack_default_export = (deprecated);
//# sourceMappingURL=deprecated-property-value.js.map

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities_constants__ = __webpack_require__(2);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable import/no-mutable-exports */
// This function will deliver an error message to the browser console about the removal of a property.


/* eslint-disable import/no-mutable-exports */

var isTriggerTabbable = function isTriggerTabbable() {};

if (false) {
  var hasWarned = {};

  isTriggerTabbable = function isTriggerTabbable(COMPONENT, trigger, comment) {
    var additionalComment = comment ? " ".concat(comment) : '';
    var childTabIndex = trigger.props.tabIndex;
    var elementIsTabbable = true;

    if ( // List of "native" HTML elements that are tabbable by default
    trigger.type !== 'button' && trigger.type !== 'input' && trigger.type !== 'select' && trigger.type !== 'textarea' && trigger.type !== 'a' && // List of components that are tabbable by default
    trigger.type.displayName !== BUTTON && trigger.type.displayName !== BUTTON_STATEFUL && trigger.type.displayName !== BUTTON_GROUP && trigger.type.displayName !== CHECKBOX && trigger.type.displayName !== DATE_PICKER && trigger.type.displayName !== INPUT && trigger.type.displayName !== LOOKUP && trigger.type.displayName !== TIME_PICKER) {
      // if it's not one of the above, then check to see if it has a tabIndex
      if (childTabIndex === '-1' || childTabIndex === undefined) {
        elementIsTabbable = false;

        if (!hasWarned[COMPONENT]) {
          /* eslint-disable max-len */
          warning(elementIsTabbable, "[Design System React] The element that triggers ".concat(COMPONENT, " must be tabbable for  keyboard users. Elements such as anchor, button, input or a DOM element with tabIndex=\"0\" specified are tabbable.").concat(additionalComment));
          /* eslint-enable max-len */

          hasWarned[COMPONENT] = !!elementIsTabbable;
        }
      }
    }
  };
}

/* unused harmony default export */ var _unused_webpack_default_export = (isTriggerTabbable);
//# sourceMappingURL=is-trigger-tabbable.js.map

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_warning_sunset_property__ = __webpack_require__(11);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable import/no-mutable-exports */


var checkProps = function checkProps() {};

if (false) {
  checkProps = function checkProps(COMPONENT, props) {
    /* eslint-disable max-len */
    sunsetProperty(COMPONENT, props.iconCategory, 'iconCategory', 'Use `Icon` instead.');
    sunsetProperty(COMPONENT, props.iconName, 'iconName', 'Use `Icon` instead.');
    sunsetProperty(COMPONENT, props.content, 'content', 'Use `labels.heading` and `labels.headingLink` instead.');
    sunsetProperty(COMPONENT, props.duration, 'duration', 'Only Toasts can auto-hide.');
    sunsetProperty(COMPONENT, props.isOpen, 'isOpen', 'Use a conditional outside of alert.');
    sunsetProperty(COMPONENT, props.isOpen, 'onDismiss', 'Use `onRequestClose` instead');
    sunsetProperty(COMPONENT, props.texture, 'texture');
    sunsetProperty(COMPONENT, props.theme, 'theme', 'Use `variant` instead.');
  };
}

/* harmony default export */ __webpack_exports__["a"] = (checkProps);
//# sourceMappingURL=check-props.js.map

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_warning_deprecated_property__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities_warning_one_of_component__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_constants__ = __webpack_require__(2);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable import/no-mutable-exports */




var checkProps = function checkProps() {};

if (false) {
  checkProps = function checkProps(COMPONENT, props) {
    if (COMPONENT === APP_LAUNCHER) {
      if (props.modalHeaderButton !== undefined) {
        oneOfComponent(COMPONENT, props, 'modalHeaderButton', ['SLDSButton']);
      }

      deprecatedProperty(COMPONENT, props.triggerAssistiveText, 'triggerAssistiveText', "assistiveText['trigger']");
    } else if (COMPONENT === APP_LAUNCHER_SECTION) {
      deprecatedProperty(COMPONENT, props.collapseSectionAssistiveText, 'collapseSectionAssistiveText', "assistiveText['collapseSection']");
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (checkProps);
//# sourceMappingURL=check-props.js.map

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_warning_deprecated_property__ = __webpack_require__(14);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable import/no-mutable-exports */

/* eslint-disable max-len */


var checkProps = function checkProps() {};

if (false) {
  checkProps = function checkProps(COMPONENT, props) {
    deprecatedProperty(COMPONENT, props.closeButtonAssistiveText, 'closeButtonAssistiveText', "assistiveText['closeButton']");
  };
}

/* harmony default export */ __webpack_exports__["a"] = (checkProps);
//# sourceMappingURL=check-props.js.map

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_settings__ = __webpack_require__(46);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable import/no-mutable-exports */



var checkAppElementIsSet = function checkAppElementIsSet() {};

if (false) {
  checkAppElementIsSet = function checkAppElementIsSet() {
    var appElement = Settings.getAppElement();
    /* eslint-disable max-len */

    warning(!!appElement, '[Design System React] App element is not defined. Please use Settings.setAppElement(el).' + ' By default, `Modal` will add `aria-hidden=true` to the `body` tag, but this disables some assistive technologies.' + ' To prevent this you can add Settings.setAppElement(el) to your application with `el` being the root node of your application' + ' that you would like to hide from assistive technologies when the `Modal` is open.');
  };
}

/* harmony default export */ __webpack_exports__["a"] = (checkAppElementIsSet);
//# sourceMappingURL=check-app-element-set.js.map

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_warning_sunset_property__ = __webpack_require__(11);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable import/no-mutable-exports */


var checkProps = function checkProps() {};

if (false) {
  checkProps = function checkProps(COMPONENT, props) {
    if (typeof props.assistiveText === 'string') {
      sunsetProperty(COMPONENT, props.assistiveText, 'assistiveText', '`assistiveText` as a string has been deprecated and is now an object to allow for multiple uses in the component. Please use `assistiveText.icon` instead.');
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (checkProps);
//# sourceMappingURL=check-props.js.map

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_warning_sunset_property__ = __webpack_require__(11);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable import/no-mutable-exports */


var checkProps = function checkProps() {};

if (false) {
  checkProps = function checkProps(COMPONENT, props) {
    if (typeof props.assistiveText === 'string') {
      sunsetProperty(COMPONENT, props.assistiveText, 'assistiveText', '`assistiveText` as a string has been deprecated and is now an object to allow for multiple uses in the component. Please use `assistiveText.icon` instead.');
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (checkProps);
//# sourceMappingURL=check-props.js.map

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_warning_sunset_property__ = __webpack_require__(11);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable import/no-mutable-exports */


var checkProps = function checkProps() {};

if (false) {
  checkProps = function checkProps(COMPONENT, props) {
    if (typeof props.assistiveText === 'string') {
      sunsetProperty(COMPONENT, props.assistiveText, 'assistiveText', '`assistiveText` as a string has been deprecated and is now an object to allow for multiple uses in the component. Please use `assistiveText.label` instead.');
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (checkProps);
//# sourceMappingURL=check-props.js.map

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export idSuffixes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__media_object__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_constants__ = __webpack_require__(2);
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// ### React

 // ### classNames
// [github.com/JedWatson/classnames](https://github.com/JedWatson/classnames)
// This project uses `classnames`, "a simple javascript utility for conditionally
// joining classNames together."

 // ## Children


 // Allow for predicatable DOM queries with `querySelectorAll(cssClasses.base)`

var idSuffixes = {
  headerActions: '__header-actions',
  heading: '__heading',
  filter: '__filter-input'
};

var renderFilter = function renderFilter(filter, id) {
  // allow id to be set by custom header component passed in
  var clonedFilter = __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(filter, {
    id: filter.props.id || id
  });
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "slds-input-has-icon slds-input-has-icon--left slds-size--1-of-3"
  }, clonedFilter);
};

renderFilter.displayName = 'renderFilter';
/**
 * Card Header is a private component and is not meant to be imported or used for Card's `header` prop. It just happens to have the same file name.
 */

var CardHeader = function CardHeader(props) {
  var title = null;

  if (typeof props.heading === 'string' || props.heading instanceof String) {
    title = props.heading;
  }

  var heading = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", {
    id: props.headingId,
    className: "slds-text-heading--small slds-truncate",
    title: title
  }, props.heading);
  var Header;

  if (props.header) {
    Header = __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(props.header, _objectSpread({
      figure: props.icon,
      body: heading,
      verticalCenter: true,
      canTruncate: true
    }, props.header.props));
  } else {
    Header = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__media_object__["a" /* default */], {
      figure: props.icon,
      body: heading,
      verticalCenter: true,
      canTruncate: true
    });
  }

  var hasFilter = props.filter ? true : null;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('slds-card__header', 'slds-grid')
  }, Header, props.filter ? renderFilter(props.filter, props.filterId) : null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    id: props.headerActionsId,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('slds-no-flex', {
      'slds-size--1-of-3': hasFilter,
      'slds-text-align--right': hasFilter
    })
  }, props.headerActions));
}; // ### Display Name
// Always use the canonical component name as the React display name.


CardHeader.displayName = __WEBPACK_IMPORTED_MODULE_4__utilities_constants__["q" /* CARD_HEADER */]; // ### Prop Types

CardHeader.propTypes = {
  /**
   * Adds a filter input to the card header
   */
  filter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * Set the HTML `id` of the card filter.
   */
  filterId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Allows a custom header (the media object with the icon in the first column). `icon`, `heading` and other props are passed in the media object from Card. Use `design-system-react/components/media-object` to create your own.
   */
  header: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * Actions performed on selected items or that relate to the entire group of items such as "Add Item.""
   */
  headerActions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * Set the HTML `id` of the card header actions.
   */
  headerActionsId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * The heading is the name of the related item group.
   */
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired,

  /**
   * Set the HTML `id` of the card heading.
   */
  headingId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Icon associated with grouped items
   */
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};
/* harmony default export */ __webpack_exports__["a"] = (CardHeader);

//# sourceMappingURL=header.js.map

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_constants__ = __webpack_require__(2);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// ### React

 // ### classNames
// [github.com/JedWatson/classnames](https://github.com/JedWatson/classnames)
// This project uses `classnames`, "a simple javascript utility for conditionally joining classNames together."




var CardBody = function CardBody(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('slds-card__body', props.className),
    id: props.id
  }, props.children);
};

CardBody.displayName = __WEBPACK_IMPORTED_MODULE_3__utilities_constants__["m" /* CARD_BODY */];
CardBody.propTypes = {
  /**
   * Elements to place in the body.
   */
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * CSS classes to be added to the card.
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * Set the HTML `id` of the body.
   */
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
/* harmony default export */ __webpack_exports__["a"] = (CardBody);
//# sourceMappingURL=body.js.map

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_constants__ = __webpack_require__(2);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// ### React




var CardFooter = function CardFooter(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "slds-card__footer"
  }, props.children);
};

CardFooter.displayName = __WEBPACK_IMPORTED_MODULE_2__utilities_constants__["p" /* CARD_FOOTER */];
CardFooter.propTypes = {
  /**
   * Elements to place in the footer.
   */
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};
/* harmony default export */ __webpack_exports__["a"] = (CardFooter);
//# sourceMappingURL=footer.js.map

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_warning_sunset_property__ = __webpack_require__(11);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable import/no-mutable-exports */


var checkProps = function checkProps() {};

if (false) {
  checkProps = function checkProps(COMPONENT, props) {
    if (typeof props.assistiveText === 'string') {
      sunsetProperty(COMPONENT, props.assistiveText, 'assistiveText', '`assistiveText` as a string has been deprecated and is now an object to allow for multiple uses in the component. Please use `assistiveText.label` instead.');
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (checkProps);
//# sourceMappingURL=check-props.js.map

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */



var propTypes = {
  /*
   * Assistive Text to use instead of a visible label
   */
  assistiveText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /*
   * Id of the input associated with this label
   */
  htmlFor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /*
   * Input Label
   */
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /*
   * Applies label styling for a required form element
   */
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Changes markup of label.
   */
  variant: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['base', 'static'])
};
var defaultProps = {
  variant: 'base'
};
/*
 * Form label. This returns null if there is no label text (hidden or shown)
 */

var Label = function Label(props) {
  var labelText = props.label || props.assistiveText && props.assistiveText.label; // One of these is required to pass accessibility tests

  var subRenders = {
    base: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", {
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('slds-form-element__label', {
        'slds-assistive-text': props.assistiveText && !props.label
      }),
      htmlFor: props.htmlFor
    }, props.required && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("abbr", {
      className: "slds-required",
      title: "required"
    }, "*"), labelText),
    static: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: "slds-form-element__label"
    }, labelText)
  };
  return labelText ? subRenders[props.variant] : null;
};

Label.displayName = 'Label';
Label.propTypes = propTypes;
Label.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Label);
//# sourceMappingURL=index.js.map

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_warning_deprecated_event_parameter__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities_warning_only_one_of_properties__ = __webpack_require__(52);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable import/no-mutable-exports */

/* eslint-disable max-len */



var checkProps = function checkProps() {};

if (false) {
  checkProps = function checkProps(COMPONENT, props) {
    deprecatedEventParameter(COMPONENT, {
      oldEventParameterOrder: props.oldEventParameterOrder,
      propAsString: 'onChange',
      propAsValue: props.onChange
    }, '`components/forms/checkbox` is deprecated. `components/checkbox` should be used. When this path update is made `onChange` event parameters will change from `onChange(value, event, { value }) to `onChange(event, { value }). Please update your event parameters when you change paths.` If you are using the CommonJS named import, `Checkbox` events will break at v1.0 and this warning will be present until then. Please review https://github.com/salesforce/design-system-react/releases when you upgrade.');

    if (props.variant === 'toggle' && props.indeterminate === true) {
      onlyOneOfProperties(COMPONENT, {
        variant: props.variant,
        indeterminate: props.indeterminate
      }, 'Currently SLDS does not support the `indeterminate` state in Checkbox Toggle. See SLDS documentation about [Checkbox Toggle](https://lightningdesignsystem.com/components/forms/#flavor-checkbox-toggle-checkbox-toggle) for more information.');
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (checkProps);
//# sourceMappingURL=check-props.js.map

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__low_priority_warning__ = __webpack_require__(54);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable import/no-mutable-exports */

/* eslint-disable max-len */
// This function will deliver a warning message to the browser console about an event parameter change.


var deprecated = function deprecated() {};

if (false) {
  var hasWarned = {};

  deprecated = function deprecated(control, _ref, comment) {
    var oldEventParameterOrder = _ref.oldEventParameterOrder,
        propAsString = _ref.propAsString,
        log = _ref.log;
    var additionalComment = comment ? " ".concat(comment) : '';
    var warnOnFirstOccurrenceKey = control + propAsString;
    var triggerWarning = oldEventParameterOrder !== undefined;

    if (!hasWarned[warnOnFirstOccurrenceKey]) {
      var message = "[Design System React] ".concat(additionalComment);

      if (triggerWarning && log) {
        log({
          message: message
        });
      } else {
        lowPriorityWarning(!triggerWarning, // false value triggers warning
        message);
      } // store global flag to limit warnings to first issue


      hasWarned[warnOnFirstOccurrenceKey] = triggerWarning;
    }
  };
}

/* unused harmony default export */ var _unused_webpack_default_export = (deprecated);
//# sourceMappingURL=deprecated-event-parameter.js.map

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to compose bitmasks for comparison styles. */
var UNORDERED_COMPARE_FLAG = 1,
    PARTIAL_COMPARE_FLAG = 2;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991,
    MAX_INTEGER = 1.7976931348623157e+308,
    NAN = 0 / 0;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object),
    nativeMax = Math.max;

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values ? values.length : 0;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, customizer, bitmask, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = arrayTag,
      othTag = arrayTag;

  if (!objIsArr) {
    objTag = getTag(object);
    objTag = objTag == argsTag ? objectTag : objTag;
  }
  if (!othIsArr) {
    othTag = getTag(other);
    othTag = othTag == argsTag ? objectTag : othTag;
  }
  var objIsObj = objTag == objectTag && !isHostObject(object),
      othIsObj = othTag == objectTag && !isHostObject(other),
      isSameTag = objTag == othTag;

  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
      : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
  }
  if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
}

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
  };
}

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!seen.has(othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
              return seen.add(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, customizer, bitmask, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= UNORDERED_COMPARE_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      objProps = keys(object),
      objLength = objProps.length,
      othProps = keys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = isKey(path, object) ? [path] : castPath(path);

  var result,
      index = -1,
      length = path.length;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result) {
    return result;
  }
  var length = object ? object.length : 0;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity]
 *  The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array ? array.length : 0;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = findIndex;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17), __webpack_require__(30)(module)))

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isequal__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isequal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__icon__ = __webpack_require__(9);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable jsx-a11y/interactive-supports-focus */





var propTypes = {
  /*
   * Active descendant in menu
   */
  activeOption: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /*
   * Index of active descendant in menu
   */
  activeOptionIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * CSS classes to be added to container `div` tag. Uses `classNames` [API](https://github.com/JedWatson/classnames).
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * CSS classes to be added to tag with `.slds-dropdown`. Uses `classNames` [API](https://github.com/JedWatson/classnames).
   */
  classNameMenu: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * CSS classes to be added to menu sub header `span` tag. Uses `classNames` [API](https://github.com/JedWatson/classnames).
   */
  classNameMenuSubHeader: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * Sets the dialog width to the width of one of the following:
   * `target`: (Menus attached to `input` typically follow this UX pattern),
   *  `menu`: Consider setting a menuMaxWidth if using this value. If not, width will be set to width of largest menu item.
   *  'none'
   */
  inheritWidthOf: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['target', 'menu', 'none']),

  /*
   * Id used for assistive technology
   */
  inputId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Determines the height of the menu based on SLDS CSS classes.
   */
  itemVisibleLength: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([5, 7, 10]),

  /**
   * **Text labels for internationalization**
   * This object is merged with the default props object on every render.
   * * `noOptionsFound`: Custom message that renders when no matches found. The default empty state is just text that says, 'No matches found.'.
   */
  labels: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    noOptionsFound: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
  }),

  /**
   * Accepts a custom menu item rendering function that becomes a custom component and is passed in the following props:
   * * `assistiveText`: Object, `assistiveText` prop that is passed into Combobox
   * * `option`: Object, option data for item being rendered that is passed into Combobox
   * * `selected`: Boolean, allows rendering of `assistiveText.optionSelectedInMenu` in Readonly Combobox
   *
   * _Tested with snapshot testing._
   */
  menuItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /*
   * Sets a maximum width that the menu will be if `inheritWidthOf` is menu.
   */
  maxWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /*
   * Menu options
   */
  options: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,

  /*
   * Callback to remove active descendent
   */
  resetActiveOption: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /*
   * Callback when option is selected with keyboard or mouse
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /*
   * Selected options
   */
  selection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,

  /**
   * Changes styles of the menu option
   */
  variant: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['icon-title-subtitle', 'checkbox']),
  isSelected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  assistiveText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
var defaultProps = {};

var Menu = function Menu(props) {
  var maxWidth = props.inheritWidthOf === 'menu' ? 'inherit' : undefined;
  maxWidth = props.inheritWidthOf === 'menu' && props.maxWidth ? props.maxWidth : maxWidth; // .slds-dropdown sets the menu to absolute positioning, since it has a relative parent. Absolute positioning removes clientHeight and clientWidth which Popper.js needs to absolute position the menu's wrapping div. Absolute positioning an already absolute positioned element doesn't work. Setting the menu's position to relative allows PopperJS to work it's magic.

  var menuOptions = props.options.map(function (optionData, index) {
    var active = index === props.activeOptionIndex && __WEBPACK_IMPORTED_MODULE_2_lodash_isequal___default()(optionData, props.activeOption);
    var selected = props.isSelected({
      selection: props.selection,
      option: optionData
    });
    var MenuItem = props.menuItem;

    if (optionData.type === 'separator') {
      return optionData.label ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
        className: "slds-dropdown__header slds-truncate",
        title: optionData.label,
        role: "separator",
        key: "menu-separator-".concat(optionData.id)
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('slds-text-title_caps', props.classNameMenuSubHeader)
      }, optionData.label)) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
        className: "slds-has-divider_top-space",
        role: "separator",
        key: "menu-separator-".concat(optionData.id)
      });
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
      className: "slds-listbox__item",
      key: "menu-option-".concat(optionData.id),
      role: "presentation"
    }, {
      'icon-title-subtitle': __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        // eslint-disable-line jsx-a11y/no-static-element-interactions
        "aria-selected": active,
        id: "".concat(props.inputId, "-listbox-option-").concat(optionData.id),
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('slds-media slds-listbox__option', 'slds-listbox__option_entity slds-listbox__option_has-meta', {
          'slds-has-focus': active
        }),
        onClick: function onClick(event) {
          props.onSelect(event, {
            option: optionData
          });
        },
        role: "option"
      }, optionData.icon && !props.menuItem ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "slds-media__figure"
      }, optionData.icon) : null, props.menuItem ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MenuItem, {
        assistiveText: props.assistiveText,
        selected: selected,
        option: optionData
      }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "slds-media__body"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "slds-listbox__option-text slds-listbox__option-text_entity"
      }, optionData.label), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "slds-listbox__option-meta slds-listbox__option-meta_entity"
      }, optionData.subTitle))),
      checkbox: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        // eslint-disable-line jsx-a11y/no-static-element-interactions
        "aria-selected": selected,
        id: "".concat(props.inputId, "-listbox-option-").concat(optionData.id),
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('slds-media slds-listbox__option', ' slds-listbox__option_plain slds-media_small slds-media_center', {
          'slds-has-focus': active,
          'slds-is-selected': selected
        }),
        onClick: function onClick(event) {
          props.onSelect(event, {
            selection: props.selection,
            option: optionData
          });
        },
        role: "option"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "slds-media__figure"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__icon__["a" /* default */], {
        className: "slds-listbox__icon-selected",
        category: "utility",
        name: "check",
        size: "x-small"
      })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "slds-media__body"
      }, props.menuItem ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MenuItem, {
        assistiveText: props.assistiveText,
        selected: selected,
        option: optionData
      }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "slds-truncate",
        title: optionData.label
      }, selected ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "slds-assistive-text"
      }, props.assistiveText.optionSelectedInMenu) : null, ' ', optionData.label)))
    }[props.variant]);
  });
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
    className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('slds-listbox slds-listbox_vertical slds-dropdown slds-dropdown_fluid', {
      'slds-dropdown_length-with-icon-5': props.itemVisibleLength === 5,
      'slds-dropdown_length-with-icon-7': props.itemVisibleLength === 7,
      'slds-dropdown_length-with-icon-10': props.itemVisibleLength === 10
    }, props.classNameMenu),
    role: "presentation",
    style: {
      width: props.inheritWidthOf === 'menu' ? 'auto' : undefined,
      maxWidth: maxWidth,
      position: props.menuPosition !== 'relative' ? 'relative' : undefined
    }
  }, menuOptions.length ? menuOptions : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
    className: "slds-listbox__item slds-listbox__status",
    role: "status",
    "aria-live": "polite"
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "slds-m-left--x-large slds-p-vertical--medium"
  }, props.labels.noOptionsFound)));
};

Menu.displayName = 'Menu';
Menu.propTypes = propTypes;
Menu.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Menu);
//# sourceMappingURL=menu.js.map

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */



var propTypes = {
  /*
   * Assistive Text to use instead of a visible label
   */
  assistiveText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /*
   * Id of the input associated with this label
   */
  htmlFor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /*
   * Input Label
   */
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /*
   * Applies label styling for a required form element
   */
  required: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Changes markup of label.
   */
  variant: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['base', 'static'])
};
var defaultProps = {
  variant: 'base'
};
/*
 * Form label. This returns null if there is no label text (hidden or shown)
 */

var Label = function Label(props) {
  var labelText = props.label || props.assistiveText && props.assistiveText.label; // One of these is required to pass accessibility tests

  var subRenders = {
    base: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", {
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('slds-form-element__label', {
        'slds-assistive-text': props.assistiveText && !props.label
      }),
      htmlFor: props.htmlFor
    }, props.required && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("abbr", {
      className: "slds-required",
      title: "required"
    }, "*"), labelText),
    static: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: "slds-form-element__label"
    }, labelText)
  };
  return labelText ? subRenders[props.variant] : null;
};

Label.displayName = 'Label';
Label.propTypes = propTypes;
Label.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Label);
//# sourceMappingURL=label.js.map

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isequal__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isequal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_pill__ = __webpack_require__(99);
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */





var propTypes = {
  /*
   * The option object within the selection prop that should have focus.
   */
  activeOption: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /*
   * The index of the option object within the selection prop that should have focus.
   */
  activeOptionIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * **Assistive text for accessibility**
   * This object is merged with the default props object on every render.
   * * `label`: This is used as a visually hidden label if, no `labels.label` is provided.
   * * `removePill`: Aids in keyboard interaction with Pills.
   */
  assistiveText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    removePill: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),

  /*
   * Callback called when pill is clicked, delete is pressed, or backspace is pressed.
   */
  events: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    onClickPill: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    onRequestFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    onRequestFocusOnNextPill: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    onRequestFocusOnPreviousPill: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    onRequestRemove: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
  }),

  /**
   * HTML id for Combobox
   */
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Adds inline (inside of input) styling
   */
  isInline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /*
   * Pill Label
   */
  labels: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    remove: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),

  /**
   * Changes styles of the input. Currently `entity` is not supported.
   */
  renderAtSelectionLength: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * Accepts an array of item objects.
   */
  selection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,

  /**
   * Requests that the active option set focus on render
   */
  listboxHasFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Changes styles of the input. Currently `entity` is not supported.
   */
  variant: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['base', 'inline-listbox', 'readonly'])
};
var defaultProps = {
  renderAtSelectionLength: 1
};

var SelectedListBox = function SelectedListBox(props) {
  return props.selection.length >= props.renderAtSelectionLength ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    // eslint-disable-line jsx-a11y/role-supports-aria-props
    id: "".concat(props.id, "-selected-listbox"),
    role: "listbox",
    "aria-orientation": "horizontal"
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('slds-listbox', {
      'slds-listbox--inline': props.isInline,
      'slds-listbox_horizontal': !props.isInline,
      'slds-p-top_xxx-small': !props.isInline
    }),
    role: "group",
    "aria-label": props.assistiveText.selectedListboxLabel
  }, props.selection.map(function (option, renderIndex) {
    var setActiveBasedOnstateFromParent = renderIndex === props.activeOptionIndex && __WEBPACK_IMPORTED_MODULE_3_lodash_isequal___default()(option, props.activeOption);
    var listboxRenderedForFirstTime = props.activeOptionIndex === -1 && renderIndex === 0 || props.variant === 'readonly' && props.selection.length !== 1 && renderIndex === 0;
    var active = setActiveBasedOnstateFromParent || listboxRenderedForFirstTime;
    var icon = option.icon ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(option.icon, {
      containerClassName: 'slds-pill__icon_container'
    }) : null;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
      role: "presentation",
      className: "slds-listbox__item",
      key: "".concat(props.id, "-list-item-").concat(option.id)
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__utilities_pill__["a" /* default */], {
      active: active,
      assistiveText: {
        remove: props.assistiveText.removePill
      },
      events: {
        onBlur: props.events.onBlurPill,
        onClick: function onClick(event, data) {
          props.events.onClickPill(event, _objectSpread({}, data, {
            index: renderIndex
          }));
        },
        onRequestFocusOnNextPill: props.events.onRequestFocusOnNextPill,
        onRequestFocusOnPreviousPill: props.events.onRequestFocusOnPreviousPill,
        onRequestRemove: function onRequestRemove(event, data) {
          props.events.onRequestRemove(event, _objectSpread({}, data, {
            index: renderIndex
          }));
        },
        onRequestFocus: props.events.onRequestFocus
      },
      eventData: {
        option: option
      },
      icon: icon,
      labels: {
        label: option.label,
        removeTitle: props.labels.removePillTitle
      },
      requestFocus: props.listboxHasFocus,
      tabIndex: active ? 0 : -1
    }));
  }))) : null;
};

SelectedListBox.displayName = 'SelectedListBox';
SelectedListBox.propTypes = propTypes;
SelectedListBox.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (SelectedListBox);
//# sourceMappingURL=selected-listbox.js.map

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_warning_component_is_prototype__ = __webpack_require__(56);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable import/no-mutable-exports */


var checkProps = function checkProps() {};

if (false) {
  checkProps = function checkProps(COMPONENT) {
    isPrototype(COMPONENT);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (checkProps);
//# sourceMappingURL=check-props.js.map

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_warning_deprecated_property__ = __webpack_require__(14);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable import/no-mutable-exports */


var checkProps = function checkProps() {};

if (false) {
  checkProps = function checkProps(COMPONENT, props) {
    /* eslint-disable max-len */
    deprecatedProperty(COMPONENT, props.isInline, 'isInline', 'menuPosition="relative"');
    /* eslint-enable max-len */
  };
}

/* harmony default export */ __webpack_exports__["a"] = (checkProps);
//# sourceMappingURL=check-props.js.map

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/**
 * This is a UX pattern recommendation for auto-complete search results that can contain multiple subheadings within the results. It inserts a subheading object based on `option.type === subheading.id` directly before a found option object and only inserts the subheading at the first occurence of that type of option.
 */
var addSubheadings = function addSubheadings(_ref) {
  var _ref2;

  var subheadings = _ref.subheadings,
      filteredOptions = _ref.filteredOptions;

  // Let's not mutate things we don't own.
  var subheadingsNotPresent = _toConsumableArray(subheadings);

  var filteredOptionsWithSubheadings = filteredOptions.map(function (option) {
    var subheadingRelatedToFilteredOption; // Remove subheadings that have been found from
    // `subheadingsNotPresent` and flag if they are
    // found.

    subheadingsNotPresent = subheadingsNotPresent.filter(function (subheading) {
      var subheadingNotPresentInFilteredOptions = true;

      if (option.type === subheading.id) {
        subheadingRelatedToFilteredOption = subheading;
        subheadingNotPresentInFilteredOptions = false;
      }

      return subheadingNotPresentInFilteredOptions;
    }); // So that they can be inserted into the current filtered
    // options in a child array with the first related option
    // OUTPUT
    // Array [
    //   0: Array [
    //     0: {id: "account", label: "Accounts", type: "separator"}
    //     1: {id: "1", label: "Acme", type: "account"}
    //   ]
    // ]

    return subheadingRelatedToFilteredOption ? [subheadingRelatedToFilteredOption, option] : [option];
  }); // flatten and remove child arrays, so that we have one array
  // `...` operates on each array item, not the array

  return (_ref2 = []).concat.apply(_ref2, _toConsumableArray(filteredOptionsWithSubheadings));
};

/* unused harmony default export */ var _unused_webpack_default_export = (addSubheadings);
//# sourceMappingURL=add-subheadings.js.map

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_warning_deprecated_property__ = __webpack_require__(14);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable import/no-mutable-exports */


var checkProps = function checkProps() {};

if (false) {
  checkProps = function checkProps(COMPONENT, props) {
    deprecatedProperty(COMPONENT, props.skipToContentAssistiveText, 'skipToContentAssistiveText', "assistiveText['skipToContent']");
    deprecatedProperty(COMPONENT, props.skipToNavAssistiveText, 'skipToNavAssistiveText', "assistiveText['skipToNav']");
  };
}

/* harmony default export */ __webpack_exports__["a"] = (checkProps);
//# sourceMappingURL=check-props.js.map

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DropdownNubbinPositions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_required_if__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_required_if___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_required_if__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isboolean__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isboolean___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_isboolean__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isfunction__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isfunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_isfunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shortid__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shortid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_shortid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utilities_dialog__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utilities_menu_list__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utilities_menu_list_item__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utilities_menu_list_item_label__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__button_trigger__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__check_props__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utilities_keyboard_navigable_menu__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utilities_event__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utilities_key_code__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utilities_constants__ = __webpack_require__(2);
/* unused harmony reexport ListItem */
/* unused harmony reexport ListItemLabel */
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// # Dropdown Component
// Implements the [Dropdown design pattern](https://www.lightningdesignsystem.com/components/menus/#flavor-dropdown) in React. Child elements that do not have the display name of the value of `MENU_DROPDOWN_TRIGGER` in `components/constants.js` will be considered custom content and rendered in the popover.
// Based on SLDS v2.1.0-rc.2
// ### React




 // ### classNames
// [github.com/JedWatson/classnames](https://github.com/JedWatson/classnames)
// This project uses `classnames`, "a simple javascript utility for conditionally
// joining classNames together."

 // ### isBoolean

 // ### isFunction

 // ### shortid
// [npmjs.com/package/shortid](https://www.npmjs.com/package/shortid)
// shortid is a short, non-sequential, url-friendly, unique id generator

 // ### Children




 // This is the the default Dropdown Trigger, which expects one button as a child.

 // This component's `checkProps` which issues warnings to developers about properties
// when in development mode (similar to React's built in development tools)

 // ### Traits
// #### KeyboardNavigable





var documentDefined = typeof document !== 'undefined'; // The overlay is an optional way to allow the dropdown to close on outside
// clicks even when those clicks are over areas that wouldn't normally fire
// click or touch events (for example, iframes). A single overlay is shared
// between all dropdowns in the app.

var overlay = documentDefined ? document.createElement('span') : {
  style: {}
};
overlay.style.top = 0;
overlay.style.left = 0;
overlay.style.width = '100%';
overlay.style.height = '100%';
overlay.style.position = 'absolute';
var currentOpenDropdown;
var DropdownNubbinPositions = ['top left', 'top', 'top right', 'bottom left', 'bottom', 'bottom right'];
/*
* Dropdowns with nubbins have a different API from other Dialogs
*
* Dialog receives an alignment position and whether it has a nubbin. The nubbin position is inferred from the align.
* Dropdowns have a nubbinPosition which dictates the align, but in an inverse fashion which then gets inversed back by the Dialog.
*
* Since Dialog is the future API and we don't want to break backwards compatability, we currently map to the Dialog api here. Even if Dialog will map it again.
* TODO - deprecate nubbinPosition in favor for additional `align` values and a flag to show a nubbin.
*/

var DropdownToDialogNubbinMapping = {
  top: 'bottom',
  'top left': 'bottom left',
  'top right': 'bottom right',
  bottom: 'top',
  'bottom left': 'top left',
  'bottom right': 'top right'
};
/**
 * The MenuDropdown component is a variant of the Lightning Design System Menu component. This component
 * may require a polyfill such as [classList](https://github.com/yola/classlist-polyfill) due to
 * [react-onclickoutside](https://github.com/Pomax/react-onclickoutside) if Internet Explorer 11
 * support is needed.
 *
 * This component is wrapped in a [higher order component to listen for clicks outside itself](https://github.com/kentor/react-click-outside) and thus requires use of `ReactDOM`.
 */

var MenuDropdown = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  // ### Display Name
  // Always use the canonical component name as the React display name.
  displayName: __WEBPACK_IMPORTED_MODULE_18__utilities_constants__["X" /* MENU_DROPDOWN */],
  // ### Prop Types
  propTypes: {
    /**
     * Aligns the right or left side of the menu with the respective side of the trigger. This is not intended for use with `nubbinPosition`.
     */
    align: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['left', 'right']),

    /**
     * This prop is passed onto the triggering `Button`. Text that is visually hidden but read aloud by screenreaders to tell the user what the icon means. You can omit this prop if you are using the `label` prop.
     */
    assistiveText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,

    /**
     * CSS classes to be added to triggering button.
     */
    buttonClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),

    /**
     * If true, button/icon is white. Meant for buttons or utility icons on dark backgrounds.
     */
    buttonInverse: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * This prop is passed onto the triggering `Button`. Determines variant of the Button component that triggers dropdown.
     */
    buttonVariant: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['base', 'neutral', 'brand', 'destructive', 'icon']),

    /**
     * If true, renders checkmark icon on the selected Menu Item.
     */
    checkmark: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * By default, any children passed into this component will be rendered inside the dropdown menu. If you only need a standard menu, use `options`. If you need custom list items markup, use `listItemRenderer` and `options`. `children` with a `List` should _only_ used if you have a listbox and additional content.
     *
     * If you need to modify the trigger button, import the module `design-system-react/dropdown/button-trigger` and render a grandchild of the element type `Button`. Any `props` specified on that `Button` will be assigned to the trigger button. Any `id` prop or event hanlders (`onBlur`, `onClick`, etc.) set on the button grandchild will be overwritten by `MenuDropdown` to enable functionality and accessibility. A custom trigger child will not be considered content for the dropdown menu.
     *
     * **List as a child is an experimental API.** If you need custom content _and_ a list, import 'design-system-react/components/menu-list/list' and pass in `<List>`.
     * ```
     * <Dropdown>
     *   <Trigger>
     *   <Button iconCategory="utility" iconName="settings" />
     *   </Trigger>
     *   <div>Look ma! This is Custom Content.</div>
     *   <List options={[myArray]}/>
     * </Dropdown>
     * ```
     */
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,

    /**
     * CSS classes to be added to dropdown menu.
     */
    className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),

    /**
     * By default, these class names will be added to the absolutely-positioned `Dialog` component.
     */
    containerClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),

    /**
     * This prop is passed onto the triggering `Button`. Prevent dropdown menu from opening. Also applies disabled styling to trigger button.
     */
    disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * Prevents the dropdown from changing position based on the viewport/window. If set to true your dropdowns can extend outside the viewport _and_ overflow outside of a scrolling parent. If this happens, you might want to consider making the dropdowns contents scrollable to fit the menu on the screen. `hasStaticAlignment` disables this behavior and allows this component to extend beyond boundary elements. _Not tested._
     */
    hasStaticAlignment: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * This prop is passed onto the triggering `Button`. Associates an icon button with another element on the page by changes the color of the SVG. Please reference <a href="http://www.lightningdesignsystem.com/components/buttons/#hint">Lightning Design System Buttons > Hint</a>.
     */
    hint: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * Delay on menu closing in milliseconds.
     */
    hoverCloseDelay: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,

    /**
     * Name of the icon category. Visit <a href="http://www.lightningdesignsystem.com/resources/icons">Lightning Design System Icons</a> to reference icon categories.
     */
    iconCategory: __WEBPACK_IMPORTED_MODULE_4_react_required_if___default()(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['action', 'custom', 'doctype', 'standard', 'utility']), function (props) {
      return !!props.iconName;
    }),

    /**
     * Name of the icon. Visit <a href="http://www.lightningdesignsystem.com/resources/icons">Lightning Design System Icons</a> to reference icon names.
     */
    iconName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * If omitted, icon position is centered.
     */
    iconPosition: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['left', 'right']),

    /**
     * For icon variants, please reference <a href="http://www.lightningdesignsystem.com/components/buttons/#icon">Lightning Design System Icons</a>.
     */
    iconVariant: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['bare', 'container', 'border', 'border-filled', 'small', 'more']),

    /**
     * Determines the size of the icon.
     */
    iconSize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['x-small', 'small', 'medium', 'large']),

    /**
     * A unique ID is needed in order to support keyboard navigation, ARIA support, and connect the dropdown to the triggering button.
     */
    id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * Forces the dropdown to be open or closed. See controlled/uncontrolled callback/prop pattern for more on suggested use view [Concepts and Best Practices](https://github.com/salesforce-ux/design-system-react/blob/master/CONTRIBUTING.md#concepts-and-best-practices)
     */
    isOpen: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * This prop is passed onto the triggering `Button`. Text within the trigger button.
     */
    label: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),

    /**
     * Custom element that overrides the default Menu Item component.
     */
    listItemRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * This prop is passed into the List for the menu. Pass null to make it the size of the content, or a string with an integer from here: https://www.lightningdesignsystem.com/components/menus/#flavor-dropdown-height
     */
    length: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf([null, '5', '7', '10']),

    /**
     * Please select one of the following:
     * * `absolute` - (default) The dialog will use `position: absolute` and style attributes to position itself. This allows inverted placement or flipping of the dialog.
     * * `overflowBoundaryElement` - The dialog will overflow scrolling parents. Use on elements that are aligned to the left or right of their target and don't care about the target being within a scrolling parent. Typically this is a popover or tooltip. Dropdown menus can usually open up and down if no room exists. In order to achieve this a portal element will be created and attached to `body`. This element will render into that detached render tree.
     * * `relative` - No styling or portals will be used. Menus will be positioned relative to their triggers. This is a great choice for HTML snapshot testing.
     */
    menuPosition: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['absolute', 'overflowBoundaryElement', 'relative']),

    /**
     * Style applied to menu element (that is the `.slds-dropdown` element)
     */
    menuStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,

    /**
     * Positions dropdown menu with a nubbin--that is the arrow notch. The placement options correspond to the placement of the nubbin. This is implemeted with CSS classes and is best used with a `Button` with "icon container" styling (`iconVariant="container"`). Use with `isInline` prop, since positioning is determined by CSS via absolute-relative positioning, and using an absolutely positioned menu will not position the menu correctly without manual offsets.
     */
    nubbinPosition: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['top left', 'top', 'top right', 'bottom left', 'bottom', 'bottom right']),

    /**
     * Is only called when `openOn` is set to `hover` and when the triggering button loses focus.
     */
    onBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * This prop is passed onto the triggering `Button`. Triggered when the trigger button is clicked.
     */
    onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Is only called when `openOn` is set to `hover` and when the triggering button gains focus.
     */
    onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Determines if mouse hover or click opens or closes the dropdown menu. The default of `click` opens the menu on click, touch, or keyboard navigation and is highly recommended to comply with accessibility standards. The other options are `hover` which opens when the mouse enters the focusable area, and `hybrid` which causes the menu to open on clicking of the trigger, but closes the menu when the mouse leaves the menu and trigger area. If you are planning on using `hover` or `hybrid`, please pause a moment and reconsider.
     */
    openOn: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['hover', 'click', 'hybrid']),

    /**
     * Called when a key pressed.
     */
    onKeyDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Called when mouse clicks down on the trigger button.
     */
    onMouseDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Called when mouse hovers over the trigger button. This is only called if `this.props.openOn` is set to `hover`.
     */
    onMouseEnter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Called when mouse hover leaves the trigger button. This is only called if `this.props.openOn` is set to `hover`.
     */
    onMouseLeave: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Triggered when an item in the menu is clicked.
     */
    onSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Triggered when the dropdown is opened.
     */
    onOpen: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Triggered when the dropdown is closed.
     */
    onClose: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * An array of menu item objects. `className` and `id` object keys are applied to the `li` DOM node. `divider` key can have a value of `top` or `bottom`. `rightIcon` and `leftIcon` are not actually `Icon` components, but prop objects that get passed to an `Icon` component. The `href` key will be added to the `a` and its default click event will be prevented. Here is a sample:
     * ```
     * [{
     *   className: 'custom-li-class',
     *     divider: 'bottom',
     *     label: 'A Header',
     *     type: 'header'
     *  }, {
     *     href: 'http://sfdc.co/',
     *     id: 'custom-li-id',
     *     label: 'Has a value',
     *   leftIcon: {
     *    name: 'settings',
     *    category: 'utility'
     *   },
     *   rightIcon: {
     *    name: 'settings',
     *    category: 'utility'
     *   },
     *     type: 'item',
     *     value: 'B0'
     *  }, {
     *   type: 'divider'
     * }]
     * ```
     */
    options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,

    /**
     * An object of CSS styles that are applied to the triggering button.
     */
    style: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,

    /**
     * Write <code>"-1"</code> if you don't want the user to tab to the button.
     */
    tabIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * If `true`, adds a transparent overlay when the menu is open to handle outside clicks. Allows clicks on iframes to be captured, but also forces a double-click to interact with other elements. If a function is passed, custom overlay logic may be defined by the app.
     */
    overlay: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func]),

    /**
     * Current selected menu item.
     */
    value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array]),

    /**
     * This prop is passed onto the triggering `Button`. It creates a tooltip with the content of the `node` provided.
     */
    tooltip: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,

    /**
     * CSS classes to be added to wrapping trigger `div` around the button.
     */
    triggerClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),

    /**
     * Whether this dropdown supports multi select.
     */
    multiple: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_15__utilities_keyboard_navigable_menu__["a" /* default */]],
  getDefaultProps: function getDefaultProps() {
    return {
      align: 'left',
      hoverCloseDelay: 300,
      length: '5',
      menuPosition: 'absolute',
      openOn: 'click'
    };
  },
  getInitialState: function getInitialState() {
    return {
      focusedIndex: -1,
      selectedIndex: -1,
      selectedIndices: []
    };
  },
  componentWillMount: function componentWillMount() {
    // `checkProps` issues warnings to developers about properties (similar to React's built in development tools)
    Object(__WEBPACK_IMPORTED_MODULE_14__check_props__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_18__utilities_constants__["X" /* MENU_DROPDOWN */], this.props);
    this.generatedId = __WEBPACK_IMPORTED_MODULE_8_shortid___default.a.generate();
    this.setCurrentSelectedIndices(this.props);
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, prevProps) {
    if (prevProps.value !== nextProps.value) {
      this.setCurrentSelectedIndices(nextProps);
    }

    if (prevProps.isOpen !== nextProps.isOpen) {
      this.setFocus();
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    if (currentOpenDropdown === this) {
      currentOpenDropdown = undefined;
    }

    this.isUnmounting = true;
    this.renderOverlay(false);
  },
  getId: function getId() {
    return this.props.id || this.generatedId;
  },
  getIsOpen: function getIsOpen() {
    return !!(__WEBPACK_IMPORTED_MODULE_6_lodash_isboolean___default()(this.props.isOpen) ? this.props.isOpen : this.state.isOpen);
  },
  getIndexByValue: function getIndexByValue(value, options) {
    var foundIndex = -1;

    if (options && options.length) {
      options.some(function (element, index) {
        if (element && element.value === value) {
          foundIndex = index;
          return true;
        }

        return false;
      });
    }

    return foundIndex;
  },
  getValueByIndex: function getValueByIndex(index) {
    return this.props.options[index];
  },
  getListItemRenderer: function getListItemRenderer() {
    return this.props.listItemRenderer ? this.props.listItemRenderer : __WEBPACK_IMPORTED_MODULE_12__utilities_menu_list_item_label__["a" /* default */];
  },
  setFocus: function setFocus() {
    if (!this.isHover && !this.isUnmounting && this.trigger) {
      __WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.findDOMNode(this.trigger).focus(); // eslint-disable-line react/no-find-dom-node
    }
  },
  getMenu: function getMenu() {
    return __WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.findDOMNode(this.list); // eslint-disable-line react/no-find-dom-node
  },
  getMenuItem: function getMenuItem(index) {
    if (index !== undefined && this.listItems) {
      return __WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.findDOMNode(this.listItems[index]); // eslint-disable-line react/no-find-dom-node
    }

    return undefined;
  },
  setCurrentSelectedIndices: function setCurrentSelectedIndices(nextProps) {
    var _this = this;

    if (this.props.multiple !== true) {
      this.setState({
        selectedIndex: this.getIndexByValue(nextProps.value, nextProps.options)
      });
    } else {
      var values = [];
      var currentIndices = [];

      if (!Array.isArray(nextProps.value)) {
        values.push(nextProps.value);
      } else {
        values = nextProps.value;
      }

      values = values.filter(function (value) {
        return _this.getIndexByValue(value, nextProps.options) !== -1;
      });
      currentIndices = values.map(function (value) {
        return _this.getIndexByValue(value, nextProps.options);
      });
      this.setState({
        selectedIndices: currentIndices
      });
    }
  },
  // Trigger opens, closes, and recieves focus on close
  saveRefToTrigger: function saveRefToTrigger(trigger) {
    this.trigger = trigger;

    if (!this.state.triggerRendered) {
      this.setState({
        triggerRendered: true
      });
    }
  },
  // TriggerContainer is the wrapping outer DOM element which may differ from the actual trigger which is most likely a `button`.
  saveRefToTriggerContainer: function saveRefToTriggerContainer(triggerContainer) {
    this.triggerContainer = triggerContainer;
    if (!this.trigger) this.trigger = triggerContainer;
  },
  saveRefToList: function saveRefToList(list) {
    this.list = list;
  },
  saveRefToListItem: function saveRefToListItem(listItem, index) {
    if (!this.listItems) {
      this.listItems = {};
    }

    this.listItems[index] = listItem;

    if (index === this.state.focusedIndex) {
      this.handleKeyboardFocus(this.state.focusedIndex);
    }
  },
  handleClose: function handleClose() {
    var isOpen = this.getIsOpen();

    if (isOpen) {
      if (currentOpenDropdown === this) {
        currentOpenDropdown = undefined;
      }

      this.setState({
        isOpen: false
      });
      this.isHover = false;

      if (this.props.onClose) {
        this.props.onClose();
      }
    }
  },
  handleOpen: function handleOpen() {
    var isOpen = this.getIsOpen();

    if (!isOpen) {
      if (currentOpenDropdown && __WEBPACK_IMPORTED_MODULE_7_lodash_isfunction___default()(currentOpenDropdown.handleClose)) {
        currentOpenDropdown.handleClose();
      }

      currentOpenDropdown = this;
      this.setState({
        isOpen: true
      });

      if (this.props.onOpen) {
        this.props.onOpen();
      }
    }
  },
  handleMouseEnter: function handleMouseEnter(event) {
    var isOpen = this.getIsOpen();
    this.isHover = true;

    if (!isOpen && this.props.openOn === 'hover') {
      this.handleOpen();
    } else {
      // we want this clear when openOn is hover or hybrid
      clearTimeout(this.isClosing);
    }

    if (this.props.onMouseEnter) {
      this.props.onMouseEnter(event);
    }
  },
  handleMouseLeave: function handleMouseLeave(event) {
    var _this2 = this;

    var isOpen = this.getIsOpen();

    if (isOpen) {
      this.isClosing = setTimeout(function () {
        _this2.handleClose();
      }, this.props.hoverCloseDelay);
    }

    if (this.props.onMouseLeave) {
      this.props.onMouseLeave(event);
    }
  },
  handleClick: function handleClick(event) {
    var isOpen = this.getIsOpen();

    if (!isOpen) {
      this.handleOpen();
      this.setFocus();
    } else {
      this.handleClose();
    }

    if (this.props.onClick) {
      this.props.onClick(event);
    }
  },
  handleFocus: function handleFocus(event) {
    var isOpen = this.getIsOpen();

    if (!isOpen) {
      this.handleOpen();
    }

    if (this.props.onFocus) {
      this.props.onFocus(event);
    }
  },
  handleClickCustomContent: function handleClickCustomContent() {
    this.setFocus();
    this.handleClose();

    if (this.props.onSelect) {
      this.props.onSelect();
    }
  },
  handleSelect: function handleSelect(index) {
    if (!this.props.multiple) {
      this.setState({
        selectedIndex: index
      });
      this.handleClose();
      this.setFocus();
    } else if (this.props.multiple && this.state.selectedIndices.indexOf(index) === -1) {
      var currentIndices = this.state.selectedIndices.concat(index);
      this.setState({
        selectedIndices: currentIndices
      });
    } else if (this.props.multiple) {
      var deselectIndex = this.state.selectedIndices.indexOf(index);
      var currentSelected = this.state.selectedIndices;
      currentSelected.splice(deselectIndex, 1);
      this.setState({
        selectedIndices: currentSelected
      });
    }

    if (this.props.onSelect) {
      var option = this.getValueByIndex(index);
      this.props.onSelect(option, {
        option: option,
        optionIndex: index
      });
    }
  },
  handleKeyDown: function handleKeyDown(event) {
    if (event.keyCode) {
      if (event.keyCode === __WEBPACK_IMPORTED_MODULE_17__utilities_key_code__["a" /* default */].ENTER || event.keyCode === __WEBPACK_IMPORTED_MODULE_17__utilities_key_code__["a" /* default */].SPACE || event.keyCode === __WEBPACK_IMPORTED_MODULE_17__utilities_key_code__["a" /* default */].DOWN || event.keyCode === __WEBPACK_IMPORTED_MODULE_17__utilities_key_code__["a" /* default */].UP) {
        __WEBPACK_IMPORTED_MODULE_16__utilities_event__["a" /* default */].trap(event);
      }

      if (event.keyCode !== __WEBPACK_IMPORTED_MODULE_17__utilities_key_code__["a" /* default */].TAB) {
        var isOpen = this.getIsOpen();
        this.handleKeyboardNavigate({
          event: event,
          isOpen: isOpen,
          key: event.key,
          keyCode: event.keyCode,
          onSelect: this.handleSelect,
          target: event.target,
          toggleOpen: this.toggleOpen
        });
      } else {
        this.handleCancel();
      }

      if (this.props.onKeyDown) {
        this.props.onKeyDown(event);
      }
    }
  },
  handleCancel: function handleCancel() {
    this.setFocus();
    this.handleClose();
  },
  handleClickOutside: function handleClickOutside() {
    this.handleClose();
  },
  toggleOpen: function toggleOpen() {
    var isOpen = this.getIsOpen();
    this.setFocus();

    if (isOpen) {
      this.handleClose();
    } else {
      this.handleOpen();
    }
  },
  renderDefaultMenuContent: function renderDefaultMenuContent(customListProps) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__utilities_menu_list__["a" /* default */], _extends({
      key: "".concat(this.getId(), "-dropdown-list"),
      checkmark: this.props.checkmark,
      getListItemId: this.getListItemId,
      itemRefs: this.saveRefToListItem,
      itemRenderer: this.getListItemRenderer(),
      onCancel: this.handleCancel,
      onSelect: this.handleSelect,
      options: this.props.options,
      ref: this.saveRefToList,
      selectedIndex: !this.props.multiple ? this.state.selectedIndex : undefined,
      selectedIndices: this.props.multiple ? this.state.selectedIndices : undefined,
      triggerId: this.getId(),
      length: this.props.length
    }, customListProps));
  },
  renderMenuContent: function renderMenuContent(customContent) {
    var _this3 = this;

    var customContentWithListPropInjection = []; // Dropdown can take a Trigger component as a child and then return it as the parent DOM element.

    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(customContent, function (child) {
      if (child && child.type.displayName === __WEBPACK_IMPORTED_MODULE_18__utilities_constants__["S" /* LIST */]) {
        customContentWithListPropInjection.push(_this3.renderDefaultMenuContent(child.props));
      } else if (child) {
        var clonedCustomContent = __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, {
          onClick: _this3.handleClickCustomContent,
          key: __WEBPACK_IMPORTED_MODULE_8_shortid___default.a.generate()
        });
        customContentWithListPropInjection.push(clonedCustomContent);
      }
    });

    if (customContentWithListPropInjection.length === 0) {
      customContentWithListPropInjection = null;
    }

    return customContentWithListPropInjection || this.renderDefaultMenuContent();
  },
  renderDialog: function renderDialog(customContent, isOpen, outsideClickIgnoreClass) {
    var _this4 = this;

    var align = 'bottom';
    var hasNubbin = false;
    var positionClassName = '';

    if (this.props.nubbinPosition) {
      hasNubbin = true;
      align = DropdownToDialogNubbinMapping[this.props.nubbinPosition];
    } else if (this.props.align) {
      align = "bottom ".concat(this.props.align);
    }

    var positions = DropdownToDialogNubbinMapping[align].split(' ');
    positionClassName = __WEBPACK_IMPORTED_MODULE_5_classnames___default()(positions.map(function (position) {
      return "slds-dropdown--".concat(position);
    })); // FOR BACKWARDS COMPATIBILITY

    var menuPosition = this.props.isInline ? 'relative' : this.props.menuPosition; // eslint-disable-line react/prop-types

    return isOpen ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__utilities_dialog__["a" /* default */], {
      align: align,
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(this.props.containerClassName),
      closeOnTabKey: true,
      contentsClassName: __WEBPACK_IMPORTED_MODULE_5_classnames___default()('slds-dropdown', 'ignore-react-onclickoutside', this.props.className, positionClassName),
      context: this.context,
      hasNubbin: hasNubbin,
      hasStaticAlignment: this.props.hasStaticAlignment,
      inheritWidthOf: this.props.inheritTargetWidth ? 'target' : 'none',
      offset: this.props.offset,
      onClose: this.handleClose,
      onKeyDown: this.handleKeyDown,
      onMouseEnter: this.props.openOn === 'hover' ? this.handleMouseEnter : null,
      onMouseLeave: this.props.openOn === 'hover' ? this.handleMouseLeave : null,
      outsideClickIgnoreClass: outsideClickIgnoreClass,
      position: menuPosition,
      style: this.props.menuStyle,
      onRequestTargetElement: function onRequestTargetElement() {
        return _this4.trigger;
      }
    }, this.renderMenuContent(customContent)) : null;
  },
  renderOverlay: function renderOverlay(isOpen) {
    if (__WEBPACK_IMPORTED_MODULE_7_lodash_isfunction___default()(overlay) && documentDefined) {
      overlay(isOpen, overlay);
    } else if (this.props.overlay && isOpen && !this.overlay && documentDefined) {
      this.overlay = overlay;
      document.querySelector('body').appendChild(this.overlay);
    } else if (!isOpen && this.overlay && this.overlay.parentNode) {
      this.overlay.parentNode.removeChild(this.overlay);
      this.overlay = undefined;
    }
  },
  render: function render() {
    // Dropdowns are used by other components. The default trigger is a button, but some other components use `li` elements. The following allows `MenuDropdown` to be extended by providing a child component with the displayName of `DropdownTrigger`.
    var CurrentTrigger = __WEBPACK_IMPORTED_MODULE_13__button_trigger__["a" /* default */];
    var CustomTriggerChildProps = {}; // Child elements that do not have the display name of the value of `MENU_DROPDOWN_TRIGGER` in `components/constants.js` will be considered custom content and rendered in the popover.

    var customContent = []; // Dropdown can take a Trigger component as a child and then return it as the parent DOM element.

    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(this.props.children, function (child) {
      if (child && child.type.displayName === __WEBPACK_IMPORTED_MODULE_18__utilities_constants__["Y" /* MENU_DROPDOWN_TRIGGER */]) {
        // `CustomTriggerChildProps` is not used by the default button Trigger, but by other triggers
        CustomTriggerChildProps = child.props;
        CurrentTrigger = child.type;
      } else {
        customContent.push(child);
      }
    });

    if (customContent.length === 0) {
      customContent = null;
    }

    var outsideClickIgnoreClass = "ignore-click-".concat(this.getId());
    var isOpen = !this.props.disabled && this.getIsOpen() && !!this.trigger;
    this.renderOverlay(isOpen);
    /* Below are three sections of props:
     - The first are the props that may be given by the dropdown component. These may get deprecated in the future.
     - The next set of props (`CustomTriggerChildProps`) are props that can be overwritten by the end developer.
     - The final set are props that should not be overwritten, since they are ones that tie the trigger to the dropdown menu.
    */

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CurrentTrigger, _extends({
      "aria-haspopup": true,
      assistiveText: this.props.assistiveText,
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(outsideClickIgnoreClass, this.props.buttonClassName),
      disabled: this.props.disabled,
      hint: this.props.hint,
      iconCategory: this.props.iconCategory,
      iconName: this.props.iconName,
      iconPosition: this.props.iconPosition,
      iconSize: this.props.iconSize,
      iconVariant: this.props.iconVariant,
      id: this.getId(),
      inverse: this.props.buttonInverse,
      isOpen: isOpen,
      label: this.props.label,
      menu: this.renderDialog(customContent, isOpen, outsideClickIgnoreClass),
      onBlur: this.props.onBlur,
      onClick: this.props.openOn === 'click' || this.props.openOn === 'hybrid' ? this.handleClick : this.props.onClick,
      onFocus: this.props.openOn === 'hover' ? this.handleFocus : null,
      onKeyDown: this.handleKeyDown,
      onMouseDown: this.props.onMouseDown,
      onMouseEnter: this.props.openOn === 'hover' || this.props.openOn === 'hybrid' ? this.handleMouseEnter : null,
      onMouseLeave: this.props.openOn === 'hover' || this.props.openOn === 'hybrid' ? this.handleMouseLeave : null,
      openOn: this.props.openOn,
      ref: this.saveRefToTriggerContainer,
      style: this.props.style,
      tabIndex: this.props.tabIndex || (isOpen ? '-1' : '0'),
      tooltip: this.props.tooltip,
      triggerClassName: this.props.triggerClassName,
      triggerRef: this.saveRefToTrigger,
      variant: this.props.buttonVariant
    }, CustomTriggerChildProps));
  }
});
MenuDropdown.contextTypes = {
  iconPath: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};
/* harmony default export */ __webpack_exports__["a"] = (MenuDropdown);

//# sourceMappingURL=menu-dropdown.js.map

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_warning_one_of_required_property__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities_warning_has_children_without_display_name_of__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_warning_sunset_property__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_warning_deprecated_property__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_constants__ = __webpack_require__(2);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable import/no-mutable-exports */






var checkProps = function checkProps() {};

if (false) {
  checkProps = function checkProps(COMPONENT, props) {
    sunsetProperty(COMPONENT, props.forceOpen, 'forceOpen', 'Please use isOpen instead. It provides a consistent prop that aligns with other componenents.');
    deprecatedProperty(COMPONENT, props.offset, 'offset', undefined, 'The manual setting of positional offset of dialog components has been deemed unreliable. Position logic has been re-written to deliver better and more reliable positioning. Please create an issue if you have an edge case not covered by the built-in logic.');
    oneOfRequiredProperty(COMPONENT, {
      options: props.options,
      children: props.children
    });

    if (!props.options) {
      hasChildrenWithoutDisplayNameOf(COMPONENT, props.children, MENU_DROPDOWN_TRIGGER);
    }

    deprecatedProperty(COMPONENT, props.isInline, 'isInline', 'menuPosition="relative"');
  };
}

/* harmony default export */ __webpack_exports__["a"] = (checkProps);
//# sourceMappingURL=check-props.js.map

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_warning__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_warning__);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable import/no-mutable-exports */
 // This function will deliver an error message to the browser console when all of the props passed in are undefined (falsey).



var hasChildrenWithoutDisplayNameOf = function hasChildrenWithoutDisplayNameOf() {};

if (false) {
  var hasWarned = {}; // TODO: allow `displayName` to be an array of displayNames

  hasChildrenWithoutDisplayNameOf = function hasChildrenWithoutDisplayNameOf(control, children, displayName, comment) {
    var additionalComment = comment ? " ".concat(comment) : '';
    var childrenWithoutSelectedDisplayName = [];
    React.Children.forEach(children, function (child) {
      if (child && child.type.displayName !== displayName) {
        childrenWithoutSelectedDisplayName.push(child);
      }
    });

    if (!hasWarned[control]) {
      var hasChildrenWithoutSelectedDisplayName = childrenWithoutSelectedDisplayName.length > 0;
      /* eslint-disable max-len */

      warning(hasChildrenWithoutSelectedDisplayName, "[Design System React] Unable to use child components specified within ".concat(control, ". Please use a child component with a `displayName` class property value of ").concat(displayName, ". Children without that class property are ignored. Please review `children` prop documentation.").concat(additionalComment));
      /* eslint-enable max-len */

      hasWarned[control] = !!hasChildrenWithoutSelectedDisplayName;
    }
  };
}

/* unused harmony default export */ var _unused_webpack_default_export = (hasChildrenWithoutDisplayNameOf);
//# sourceMappingURL=has-children-without-display-name-of.js.map

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__icon__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_event__ = __webpack_require__(7);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// Implements the [Lookup design pattern](https://latest-204.lightningdesignsystem.com/components/lookups) in React.
// Based on SLDS v2.1.0-dev



var displayName = 'LookupDefaultHeader';
var propTypes = {};
var defaultProps = {};

var DefaultHeader =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DefaultHeader, _React$Component);

  function DefaultHeader() {
    var _ref;

    var _temp, _this;

    _classCallCheck(this, DefaultHeader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_ref = DefaultHeader.__proto__ || Object.getPrototypeOf(DefaultHeader)).call.apply(_ref, [this].concat(args))), Object.defineProperty(_assertThisInitialized(_this), "handleClick", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        if (_this.props.onClose) {
          _this.props.onClose();
        }
      }
    }), _temp));
  }

  _createClass(DefaultHeader, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.isActive !== this.props.isActive && nextProps.isActive === true) {
        this.props.setFocus('searchRecords');
      }
    }
  }, {
    key: "render",
    value: function render() {
      var className = 'slds-lookup__item-action slds-lookup__item-action--label';
      if (this.props.isActive) className += ' slds-theme--shade';
      return (
        /* eslint-disable jsx-a11y/no-static-element-interactions */
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          className: "js-slds-lookup__item",
          onMouseDown: __WEBPACK_IMPORTED_MODULE_2__utilities_event__["a" /* default */].trapImmediate,
          onClick: this.handleClick
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
          id: "searchRecords",
          href: "javascript:void(0);",
          className: className
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
          className: "lookup__item-action-label"
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__icon__["a" /* default */], {
          name: "search",
          category: "utility",
          size: "x-small",
          className: "slds-icon-text-default"
        }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
          className: "slds-truncate"
        }, this.props.searchTerm))))
      );
    }
  }]);

  return DefaultHeader;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DefaultHeader.displayName = displayName;
DefaultHeader.propTypes = propTypes;
DefaultHeader.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (DefaultHeader);
//# sourceMappingURL=header.js.map

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__icon__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_event__ = __webpack_require__(7);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// Implements the [Lookup design pattern](https://latest-204.lightningdesignsystem.com/components/lookups) in React.
// Based on SLDS v2.1.0-dev



var displayName = 'LookupDefaultFooter';
var propTypes = {};
var defaultProps = {};

var DefaultFooter =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DefaultFooter, _React$Component);

  function DefaultFooter() {
    var _ref;

    var _temp, _this;

    _classCallCheck(this, DefaultFooter);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_ref = DefaultFooter.__proto__ || Object.getPrototypeOf(DefaultFooter)).call.apply(_ref, [this].concat(args))), Object.defineProperty(_assertThisInitialized(_this), "handleClick", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        if (_this.props.onClose) {
          _this.props.onClose();
        }
      }
    }), _temp));
  }

  _createClass(DefaultFooter, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.isActive !== this.props.isActive && nextProps.isActive === true) {
        this.props.setFocus('newItem');
      }
    }
  }, {
    key: "render",
    value: function render() {
      var className = 'slds-lookup__item-action slds-lookup__item-action--label';
      if (this.props.isActive) className += ' slds-theme--shade';
      return (
        /* eslint-disable jsx-a11y/no-static-element-interactions */
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          className: "js-slds-lookup__item",
          onClick: this.handleClick,
          onMouseDown: __WEBPACK_IMPORTED_MODULE_2__utilities_event__["a" /* default */].trapImmediate
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
          id: "newItem",
          href: "javascript:void(0);",
          className: className
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
          className: "lookup__item-action-label"
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__icon__["a" /* default */], {
          name: "add",
          category: "utility",
          size: "x-small",
          className: "slds-icon-text-default"
        }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
          className: "slds-truncate"
        }, this.props.newItemLabel ? this.props.newItemLabel : 'Add New Item'))))
      );
    }
  }]);

  return DefaultFooter;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DefaultFooter.displayName = displayName;
DefaultFooter.propTypes = propTypes;
DefaultFooter.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (DefaultFooter);
//# sourceMappingURL=footer.js.map

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */


var displayName = 'LookupDefaultSectionDivider';
var propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var DefaultSectionDivider = function DefaultSectionDivider(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
    className: "slds-p-around--x-small slds-lookup__divider",
    tabIndex: "-1"
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "slds-m-left--x-small"
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, props.data.label)));
};

DefaultSectionDivider.displayName = displayName;
DefaultSectionDivider.propTypes = propTypes;
/* harmony default export */ __webpack_exports__["a"] = (DefaultSectionDivider);
//# sourceMappingURL=section-divider.js.map

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_escaperegexp__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_escaperegexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_escaperegexp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isboolean__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isboolean___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isboolean__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isequal__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_isequal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__check_props__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utilities_dialog__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__icon__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__icon_input_icon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__input__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utilities_event__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utilities_key_code__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__menu__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utilities_constants__ = __webpack_require__(2);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable jsx-a11y/role-has-required-aria-props */
// # Lookup Component
// Implements the [Lookup design pattern](https://latest-204.lightningdesignsystem.com/components/lookups) in React.
// Based on SLDS v2.1.0-dev
// ## Dependencies
// ### React






 // This component's `checkProps` which issues warnings to developers about properties
// when in development mode (similar to React's built in development tools)

 // Children





 // ### Event Helpers





/**
 * A function that takes a term string and an item and returns a truthy value if the item should be kept.
 */

var defaultFilter = function defaultFilter(term, item) {
  if (!term) return true;
  return item.data && item.data.type === 'section' || item.label.match(new RegExp(__WEBPACK_IMPORTED_MODULE_3_lodash_escaperegexp___default()(term), 'ig'));
};
/**
 * ** Lookup is deprecated. Please use an auto-complete Combobox instead.**
 *
 * Lookup is an advanced inline search form. The lookup can parse through single or multi scoped datasets. The parsed dataset can be filtered by single or multi option selects.
 *
 * This component is wrapped in a [higher order component to listen for clicks outside itself](https://github.com/kentor/react-click-outside) and thus requires use of `ReactDOM`.
 */


var Lookup = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: __WEBPACK_IMPORTED_MODULE_16__utilities_constants__["V" /* LOOKUP */],
  propTypes: {
    /**
     * If present, the label associated with this `input` is overwritten
     * by this text and is visually not shown.
     */
    assistiveText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * Class names to be added to the tag classed with `slds-lookup`.
     */
    className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),

    /**
     * If true, constrains the menu to the scroll parent. Has no effect if `isInline` is `true`.
     */
    constrainToScrollParent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * ID for aria-describedby (e.g. for an error message or a description)
     */
    describedById: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * Please select one of the following:
     * * `absolute` - (default) The dialog will use `position: absolute` and style attributes to position itself. This allows inverted placement or flipping of the dialog.
     * * `overflowBoundaryElement` - The dialog will overflow scrolling parents. Use on elements that are aligned to the left or right of their target and don't care about the target being within a scrolling parent. Typically this is a popover or tooltip. Dropdown menus can usually open up and down if no room exists. In order to achieve this a portal element will be created and attached to `body`. This element will render into that detached render tree.
     * * `relative` - No styling or portals will be used. Menus will be positioned relative to their triggers. This is a great choice for HTML snapshot testing.
     */
    menuPosition: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * This prop is passed onto the `input`. Prevents dropdown menu from opening. Also applies disabled styling to input.
     */
    disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * Custom message that renders when no matches found. The default empty state is just text that says, 'No matches found.'.
     */
    emptyMessage: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element]),

    /**
     * Custom function to filter the Lookup items when typing into input field. The default function is case-insensitive and uses the searchTerm to filter Lookup items on their labels.
     */
    filterWith: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * If true, the menu is constrained to the window and may be flipped up. Has no effect if `isInline` is `true`. In other components, its opposite is used `hasStaticAlignment`.
     */
    flippable: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * Custom component for Lookup footer. The default footer allows user to add new item - see <a href='http://www.lightningdesignsystem.com/components/lookups/#base'>Lightning Design System Lookup > Base</a>. To use the default footer, pass in <code>Lookup.DefaultFooter</code>.
     */
    footerRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Custom component for Lookup header. The default header has a search icon and shows the search term - see <a href='http://www.lightningdesignsystem.com/components/lookups/#base'>Lightning Design System Lookup > Base</a>. To use the default header, pass in <code>Lookup.DefaultHeader</code>.
     */
    headerRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Please refer to <a href='http://www.lightningdesignsystem.com/resources/icons'>Lightning Design System Icons</a> to view categories.
     */
    iconCategory: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * If true, icon color is white. If false, icon color is the default text color.
     */
    iconInverse: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * Name of icon. Please refer to <a href='http://www.lightningdesignsystem.com/resources/icons'>Lightning Design System Icons</a> to view icon names.
     */
    iconName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * Determines whether the input's icon will display that icon on the left or the right.
     */
    iconPosition: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['left', 'right']),

    /**
     * Renders menu within the wrapping trigger as a sibling of the button. By default, you will have an absolutely positioned container at an elevated z-index.
     */
    isInline: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * Whether or not the dropdown menu is open. This overrides the default behavior.
     */
    isOpen: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * Form label for input.
     */
    label: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * Custom component that overrides the default Lookup Item component.
     */
    listItemLabelRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Triggered when input focus is removed.
     */
    onBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Triggered when the contents of the input changes.
     */
    onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Triggered when input is focused.
     */
    onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Function called when the lookup dropdown would like hide. This will turn the Lookup into into a controlled component. Please use with `isOpen`.
     */
    onRequestClose: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Function called when the lookup dropdown would like show. This will turn the Lookup into into a controlled component. Please use with `isOpen`.
     */
    onRequestOpen: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Triggered when the user scrolls in the dropdown menu.
     */
    onScroll: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Triggered when an item is selected from the dropdown menu.
     */
    onSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Triggered when an item is an item is removed from the input.
     */
    onUnselect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Item added to the dropdown menu.
     */
    options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired,

    /**
     * Text that will appear in an empty input.
     */
    placeholder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * If true, adds asterisk next to input label to indicate it is a required field.
     */
    required: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * Text passed on to header search input of dropdown menu.
     */
    searchTerm: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * Custom component that overrides the default section divider
     */
    sectionDividerRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Index of current selected item. To clear the selection, pass in -1.
     */
    selectedItem: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number
  },
  getDefaultProps: function getDefaultProps() {
    return {
      constrainToScrollParent: true,
      filterWith: defaultFilter,
      iconPosition: 'right',
      searchTerm: '',
      menuPosition: 'absolute'
    };
  },
  getInitialState: function getInitialState() {
    return {
      currentFocus: null,
      focusIndex: null,
      items: [],
      listLength: this.props.options.length,
      searchTerm: this.normalizeSearchTerm(this.props.searchTerm),
      selectedIndex: this.props.selectedItem
    };
  },
  componentWillMount: function componentWillMount() {
    // `checkProps` issues warnings to developers about properties (similar to React's built in development tools)
    Object(__WEBPACK_IMPORTED_MODULE_7__check_props__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_16__utilities_constants__["V" /* LOOKUP */], this.props); // Keeps track of references of children for keyboard navigation

    this.pills = [];
  },
  componentDidMount: function componentDidMount() {
    this.modifyItems(this.props.options);
  },
  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
    if (newProps.options) {
      this.modifyItems(newProps.options);
    }

    if (newProps.selectedItem !== this.props.selectedItem || !__WEBPACK_IMPORTED_MODULE_5_lodash_isequal___default()(newProps.options, this.props.options)) {
      this.setState({
        selectedIndex: newProps.selectedItem
      });
    }
  },
  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
    if (!isNaN(parseInt(prevState.selectedIndex, 10)) && isNaN(parseInt(this.state.selectedIndex, 10))) {
      if (this.input) {
        this.input.focus();
      }
    } else if (isNaN(parseInt(prevState.selectedIndex, 10)) && !isNaN(parseInt(this.state.selectedIndex, 10))) {
      if (this.pills[this.state.selectedIndex]) {
        this.pills[this.state.selectedIndex].focus();
      }
    }
  },
  getClassName: function getClassName() {
    return __WEBPACK_IMPORTED_MODULE_6_classnames___default()(this.props.className, 'slds-form-element slds-lookup', {
      'slds-has-selection': this.isSelected(),
      'slds-is-open': this.getIsOpen()
    });
  },
  setFirstIndex: function setFirstIndex() {
    var nextFocusIndex = 0;
    var filteredItem = this.state.items[0];

    if (this.menuComponent && this.menuComponent.getFilteredItemForIndex) {
      filteredItem = this.menuComponent.getFilteredItemForIndex(nextFocusIndex);
    }

    if (filteredItem && filteredItem.data.type === 'section') {
      nextFocusIndex += 1;
    }

    this.setState({
      focusIndex: nextFocusIndex
    });
  },
  getHeader: function getHeader() {
    var _this = this;

    var Header = this.props.headerRenderer;
    var headerActive = this.state.focusIndex === 0;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Header, _extends({
      ref: function ref(header) {
        _this.headerComponent = header;
      }
    }, this.props, {
      focusIndex: this.state.focusIndex,
      isActive: headerActive,
      onClose: this.handleClose,
      searchTerm: this.state.searchTerm,
      setFocus: this.setFocus
    }));
  },
  getFooter: function getFooter() {
    var _this2 = this;

    var Footer = this.props.footerRenderer;
    var numFocusable = this.getNumFocusableItems();
    var footerActive = this.state.focusIndex === numFocusable;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Footer, _extends({
      ref: function ref(footer) {
        _this2.footerComponent = footer;
      }
    }, this.props, {
      focusIndex: this.state.focusIndex,
      isActive: footerActive,
      onClose: this.handleClose,
      setFocus: this.setFocus
    }));
  },
  setFocus: function setFocus(id) {
    this.setState({
      currentFocus: id
    });
  },
  getIsOpen: function getIsOpen() {
    return !!(__WEBPACK_IMPORTED_MODULE_4_lodash_isboolean___default()(this.props.isOpen) ? this.props.isOpen : this.state.isOpen);
  },
  getListLength: function getListLength(qty) {
    if (qty !== this.state.listLength) {
      this.setState({
        listLength: qty
      });
    }
  },
  getNumFocusableItems: function getNumFocusableItems() {
    var offset = 0;

    if (this.footerComponent) {
      offset += 1;
    }

    if (this.headerComponent) {
      offset += 1;
    }

    return this.state.listLength - 1 + offset;
  },
  // =================================================
  // Using down/up keys, set Focus on list item and assign it to aria-activedescendant attribute in input.
  // Need to keep track of filtered list length to be able to increment/decrement the focus index so it's contained to the number of available list items.
  increaseIndex: function increaseIndex() {
    var numFocusable = this.getNumFocusableItems();
    var nextFocusIndex = this.state.focusIndex < numFocusable ? this.state.focusIndex + 1 : 0;
    var filteredItem = this.menuComponent.getFilteredItemForIndex(nextFocusIndex);

    if (filteredItem && filteredItem.data.type === 'section') {
      nextFocusIndex += 1;
    }

    this.setState({
      focusIndex: nextFocusIndex
    });
  },
  decreaseIndex: function decreaseIndex() {
    var numFocusable = this.getNumFocusableItems();
    var prevFocusIndex = this.state.focusIndex > 0 ? this.state.focusIndex - 1 : numFocusable;
    var filteredItem = this.menuComponent.getFilteredItemForIndex(prevFocusIndex);

    if (filteredItem && filteredItem.data.type === 'section') {
      prevFocusIndex = prevFocusIndex === 0 ? numFocusable : prevFocusIndex - 1;
    }

    this.setState({
      focusIndex: prevFocusIndex
    });
  },
  // =================================================
  // Select menu item (onClick or on key enter/space)
  selectItem: function selectItem(itemId) {
    if (itemId) {
      var index = itemId.replace('item-', '');
      this.selectItemByIndex(index);
    }
  },
  selectItemByIndex: function selectItemByIndex(index) {
    if (index >= 0 && index < this.state.items.length) {
      if (this.props.onRequestClose) {
        this.props.onRequestClose();
      }

      this.setState({
        isOpen: false,
        selectedIndex: index,
        searchTerm: ''
      });
      var data = this.state.items[index].data;

      if (this.props.onSelect) {
        this.props.onSelect(data);
      }
    }
  },
  handleDeleteSelected: function handleDeleteSelected() {
    if (this.props.onRequestOpen) {
      this.props.onRequestOpen();
    }

    this.setState({
      selectedIndex: null,
      isOpen: true
    });
    this.focusInput();

    if (this.props.onUnselect) {
      this.props.onUnselect();
    }
  },
  // =================================================
  // Event Listeners on Input
  handleClose: function handleClose() {
    if (this.props.onRequestClose) {
      this.props.onRequestClose();
    }

    this.setState({
      isOpen: false,
      focusIndex: null,
      currentFocus: null
    });
  },
  handleClickOutside: function handleClickOutside() {
    this.handleClose();
  },
  handleEscape: function handleEscape(event) {
    if (this.getIsOpen() && event) {
      __WEBPACK_IMPORTED_MODULE_13__utilities_event__["a" /* default */].trap(event);
    }

    this.handleClose();
  },
  handleCancel: function handleCancel() {
    this.handleClose();
  },
  handleClick: function handleClick() {
    if (this.props.onRequestOpen) {
      this.props.onRequestOpen();
    }

    this.setState({
      isOpen: true
    });
  },
  handleBlur: function handleBlur(event) {
    if (this.props.onBlur) {
      var target = event.target || event.currentTarget;
      this.props.onBlur(target.value);
    }
  },
  handleFocus: function handleFocus(event) {
    if (this.props.onFocus) {
      var target = event.target || event.currentTarget;
      this.props.onFocus(target.value);
    }

    if (this.props.onRequestOpen) {
      this.props.onRequestOpen();
    }

    this.setState({
      isOpen: true
    });
  },
  handleChange: function handleChange(event) {
    var target = event.target || event.currentTarget;
    this.setState({
      searchTerm: this.normalizeSearchTerm(target.value)
    });

    if (this.props.onChange) {
      this.props.onChange(target.value);
    }
  },
  handleKeyDown: function handleKeyDown(event) {
    var _this3 = this;

    if (event.keyCode) {
      // If user hits esc key or tab key, close menu
      if (event.keyCode === __WEBPACK_IMPORTED_MODULE_14__utilities_key_code__["a" /* default */].ESCAPE) {
        this.handleEscape(event);
      } else if (event.keyCode === __WEBPACK_IMPORTED_MODULE_14__utilities_key_code__["a" /* default */].TAB) {
        // remove the focus on input, tab focus shoud move to next tabbale elemnt
        setTimeout(function () {
          _this3.handleClose();
        }, 200);
        this.handleBlur(event);
      } else {
        this.handleClick();
      } // If user hits down key, advance aria activedescendant to next item


      if (event.keyCode === __WEBPACK_IMPORTED_MODULE_14__utilities_key_code__["a" /* default */].DOWN) {
        __WEBPACK_IMPORTED_MODULE_13__utilities_event__["a" /* default */].trapImmediate(event);

        if (this.state.focusIndex === null) {
          this.setFirstIndex();
        } else {
          this.increaseIndex();
        }
      } else if (event.keyCode === __WEBPACK_IMPORTED_MODULE_14__utilities_key_code__["a" /* default */].UP) {
        // If user hits up key, advance aria activedescendant to previous item
        __WEBPACK_IMPORTED_MODULE_13__utilities_event__["a" /* default */].trapImmediate(event);
        var numFocusable = this.getNumFocusableItems();

        if (this.state.focusIndex === null) {
          this.setState({
            focusIndex: numFocusable
          });
        } else {
          this.decreaseIndex();
        }
      } else if (event.keyCode === __WEBPACK_IMPORTED_MODULE_14__utilities_key_code__["a" /* default */].ENTER && this.state.focusIndex !== null) {
        // If user hits enter, select current activedescendant item
        __WEBPACK_IMPORTED_MODULE_13__utilities_event__["a" /* default */].trapImmediate(event); // If the focus is on the first fixed Action Item in Menu, click it

        if (this.headerComponent && this.state.focusIndex === 0) {
          this.headerComponent.handleClick();
        } else if (this.footerComponent && this.state.focusIndex === this.state.listLength + 1) {
          // If the focus is on the last fixed Action Item in Menu, click it
          this.footerComponent.handleClick();
        } else {
          // If not, then select menu item
          this.selectItem(this.state.currentFocus);
        }
      }
    }
  },
  handlePillKeyDown: function handlePillKeyDown(event) {
    if (event.keyCode) {
      if (event.keyCode === __WEBPACK_IMPORTED_MODULE_14__utilities_key_code__["a" /* default */].DELETE || event.keyCode === __WEBPACK_IMPORTED_MODULE_14__utilities_key_code__["a" /* default */].BACKSPACE) {
        __WEBPACK_IMPORTED_MODULE_13__utilities_event__["a" /* default */].trapImmediate(event);
        this.handleDeleteSelected();
      }
    }
  },
  normalizeSearchTerm: function normalizeSearchTerm(string) {
    return (string || '').toString().replace(/^\s+/, '');
  },
  inputRefId: function inputRefId() {
    return "".concat(this.props.label, "Lookup");
  },
  focusInput: function focusInput() {
    this.focusOnRender = true;
  },
  isSelected: function isSelected() {
    var hasSelection = !isNaN(parseInt(this.state.selectedIndex, 10)) && this.state.selectedIndex >= 0;
    return hasSelection;
  },
  modifyItems: function modifyItems(itemsToModify) {
    var items = itemsToModify.map(function (item, index) {
      return {
        id: "item-".concat(index),
        label: item.label,
        data: item
      };
    });
    this.setState({
      items: items
    });
  },
  // =================================================
  // Rendering Things
  renderMenuContent: function renderMenuContent() {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__menu__["a" /* default */], {
      ref: function ref(menu) {
        _this4.menuComponent = menu;
      },
      emptyMessage: this.props.emptyMessage,
      filterWith: this.props.filterWith,
      focusIndex: this.state.focusIndex,
      footer: this.props.footerRenderer ? this.getFooter() : null,
      getListLength: this.getListLength,
      header: this.props.headerRenderer ? this.getHeader() : null,
      iconCategory: this.props.iconCategory,
      iconInverse: this.props.iconInverse,
      iconName: this.props.iconName,
      items: this.state.items,
      label: this.props.label,
      listItemLabelRenderer: this.props.listItemLabelRenderer,
      listLength: this.state.listLength,
      onSelect: this.selectItem,
      searchTerm: this.state.searchTerm,
      sectionDividerRenderer: this.props.sectionDividerRenderer,
      setFocus: this.setFocus
    });
  },
  renderInlineMenu: function renderInlineMenu() {
    return this.getIsOpen() ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "ignore-react-onclickoutside slds-lookup__menu",
      role: "listbox"
    }, this.renderMenuContent()) : null;
  },
  renderSeparateMenu: function renderSeparateMenu() {
    var _this5 = this;

    // FOR BACKWARDS COMPATIBILITY
    var menuPosition = this.props.isInline ? 'relative' : this.props.menuPosition; // eslint-disable-line react/prop-types

    return this.getIsOpen() ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__utilities_dialog__["a" /* default */], {
      align: "bottom",
      className: "slds-lookup__menu slds-show",
      closeOnTabKey: true,
      contentsClassName: "slds-lookup__menu slds-show",
      context: this.context,
      inheritWidthOf: "target",
      onClose: this.handleCancel,
      hasStaticAlignement: !this.props.flippable,
      constrainToScrollParent: this.props.constrainToScrollParent,
      onRequestTargetElement: function onRequestTargetElement() {
        return _this5.input;
      },
      position: menuPosition
    }, this.renderMenuContent()) : null;
  },
  renderInput: function renderInput() {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__input__["a" /* default */], {
      "aria-activedescendant": this.state.currentFocus ? this.state.currentFocus : '',
      "aria-autocomplete": "list",
      "aria-describedby": this.props.describedById,
      "aria-expanded": !!this.getIsOpen(),
      assistiveText: this.props.assistiveText,
      className: "slds-lookup__search-input",
      disabled: this.props.disabled,
      iconRight: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__icon_input_icon__["a" /* default */], {
        assistiveText: {
          icon: 'Search'
        },
        category: "utility",
        name: "search"
      }),
      id: this.inputRefId(),
      onBlur: this.handleBlur,
      onChange: this.handleChange,
      onClick: this.handleClick,
      onFocus: this.handleFocus,
      onKeyDown: this.handleKeyDown,
      inputRef: function inputRef(component) {
        _this6.input = component;

        if (_this6.focusOnRender) {
          _this6.input.focus();

          _this6.focusOnRender = false;
        }
      },
      placeholder: this.props.placeholder,
      role: "combobox",
      type: "text",
      value: this.state.searchTerm
    });
  },
  renderSelectedItem: function renderSelectedItem() {
    var _this7 = this;

    var selectedItem = this.props.options[this.state.selectedIndex].label;
    var renderIcon = this.props.iconName ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__icon__["a" /* default */], {
      category: this.props.iconCategory,
      className: "slds-icon slds-pill__icon",
      inverse: this.props.iconInverse,
      name: this.props.iconName
    }) : null;
    var labelClassName = this.props.iconName ? 'slds-pill__label' : 'slds-pill__label slds-m-left--x-small'; // i18n

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "slds-pill__container"
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
      href: "javascript:void(0)",
      className: "slds-pill",
      ref: function ref(pill) {
        _this7.pills[_this7.state.selectedIndex] = pill;
      },
      onKeyDown: this.handlePillKeyDown
    }, renderIcon, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: labelClassName
    }, selectedItem), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__button__["a" /* default */], {
      assistiveText: "Press delete to remove",
      className: "slds-pill__remove slds-button--icon-bare",
      iconCategory: "utility",
      iconName: "close",
      onClick: this.handleDeleteSelected,
      tabIndex: "-1",
      variant: "icon"
    })));
  },
  renderLabel: function renderLabel() {
    var inputLabel;
    var required = this.props.required ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: "slds-required"
    }, "*") : null;

    if (this.isSelected()) {
      // inline style override
      inputLabel = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "slds-form-element__label",
        style: {
          width: '100%'
        }
      }, required, this.props.label);
    } else {
      inputLabel = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", {
        className: "slds-form-element__label",
        htmlFor: this.inputRefId(),
        style: {
          width: '100%'
        }
      }, required, this.props.label);
    }

    return inputLabel;
  },
  render: function render() {
    var isInline;
    /* eslint-disable react/prop-types */

    if (this.props.isInline) {
      isInline = true;
    } else if (this.props.modal !== undefined) {
      isInline = !this.props.modal;
    }
    /* eslint-enable react/prop-types */


    var formElementControlClasses = _defineProperty({
      'slds-form-element__control': true
    }, "slds-input-has-icon slds-input-has-icon--".concat(this.props.iconPosition), !this.isSelected());

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: this.getClassName(),
      "data-select": "single",
      "data-scope": "single",
      onScroll: this.props.onScroll
    }, this.props.label ? this.renderLabel() : null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(formElementControlClasses)
    }, this.isSelected() ? this.renderSelectedItem() : null, !this.isSelected() ? this.renderInput() : null), isInline ? this.renderInlineMenu() : this.renderSeparateMenu());
  }
});
Lookup.contextTypes = {
  iconPath: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};
/* harmony default export */ __webpack_exports__["a"] = (Lookup);
//# sourceMappingURL=lookup.js.map

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_warning_component_is_deprecated__ = __webpack_require__(33);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable import/no-mutable-exports */


var checkProps = function checkProps() {};

if (false) {
  checkProps = function checkProps(COMPONENT) {
    componentIsDeprecated(COMPONENT, 'Please use an auto-complete Combobox instead. It is more accessible and closer aligned to SLDS.');
  };
}

/* harmony default export */ __webpack_exports__["a"] = (checkProps);
//# sourceMappingURL=check-props.js.map

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__private_menu__ = __webpack_require__(234);
// Alias

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__private_menu__["a" /* default */]);
//# sourceMappingURL=index.js.map

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__item__ = __webpack_require__(235);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */



/* eslint-disable react/no-did-update-set-state */

var displayName = 'Lookup-Menu';
var propTypes = {
  boldRegex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(RegExp),
  emptyMessage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element]),
  filterWith: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  focusIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  getListLength: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  iconCategory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  listLength: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  searchTerm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  setFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
var defaultProps = {
  emptyMessage: 'No matches found.'
};

var Menu =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Menu, _React$Component);

  function Menu(props) {
    var _this;

    _classCallCheck(this, Menu);

    _this = _possibleConstructorReturn(this, (Menu.__proto__ || Object.getPrototypeOf(Menu)).call(this, props));
    Object.defineProperty(_assertThisInitialized(_this), "handleItemFocus", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(itemIndex, itemHeight) {
        if (_this.listRef) {
          _this.listRef.scrollTop = itemIndex * itemHeight;
        }
      }
    });
    _this.state = {
      filteredItems: _this.filteredItems()
    };
    return _this;
  } // Set filtered list length in parent to determine active indexes for aria-activedescendent


  _createClass(Menu, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // make an array of the children of the list but only count the actual items (but include section dividers)
      var childFilter = function childFilter(child) {
        return child.className.indexOf('js-slds-lookup__item') > -1 || child.className.indexOf('slds-lookup__divider') > -1;
      };

      var list = [].slice.call(this.listRef.children).filter(childFilter).length;
      this.props.getListLength(list);

      if (prevProps.items !== this.props.items || prevProps.filter !== this.props.filter || prevProps.searchTerm !== this.props.searchTerm) {
        // eslint-disable-next-line class-methods-use-this
        this.setState({
          filteredItems: this.filteredItems()
        });
      }
    }
  }, {
    key: "getFilteredItemForIndex",
    value: function getFilteredItemForIndex(i) {
      if (i > -1 && this.state.filteredItems && i < this.state.filteredItems.length) {
        return this.state.filteredItems[i];
      }

      return null;
    }
  }, {
    key: "filter",
    value: function filter(item) {
      return this.props.filterWith(this.props.searchTerm, item);
    } // eslint-disable-next-line class-methods-use-this

  }, {
    key: "filterEmptySections",
    value: function filterEmptySections(items) {
      var result = [];
      items.forEach(function (item, index) {
        if (item && item.data && item.data.type === 'section') {
          if (index + 1 < items.length) {
            var nextItem = items[index + 1];

            if (nextItem.data && nextItem.data.type !== 'section') {
              result.push(item);
            }
          }
        } else {
          result.push(item);
        }
      });
      return result;
    }
  }, {
    key: "filteredItems",
    value: function filteredItems() {
      return this.filterEmptySections(this.props.items.filter(this.filter, this));
    } // Scroll menu up/down when using mouse keys

  }, {
    key: "renderContent",
    value: function renderContent() {
      if (this.state.filteredItems.length === 0) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
          className: "slds-lookup__message",
          "aria-live": "polite"
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
          className: "slds-m-left--x-large slds-p-vertical--medium"
        }, this.props.emptyMessage));
      }

      return this.renderItems();
    }
  }, {
    key: "renderFooter",
    value: function renderFooter() {
      return this.props.footer;
    }
  }, {
    key: "renderHeader",
    value: function renderHeader() {
      return this.props.header;
    }
  }, {
    key: "renderItems",
    value: function renderItems() {
      var _this2 = this;

      var focusIndex = this.props.focusIndex;
      return this.state.filteredItems.map(function (component, i) {
        // isActive means it is aria-activedescendant
        var id = component.id;
        var isActive = false;

        if (_this2.props.header) {
          isActive = focusIndex === i + 1;
        } else {
          isActive = focusIndex === i;
        }

        if (component.data.type === 'section') {
          if (_this2.props.sectionDividerRenderer) {
            var SectionDivider = _this2.props.sectionDividerRenderer;
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SectionDivider, _extends({
              data: component.data,
              key: "section_header_".concat(id)
            }, _this2.props));
          }
        }

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__item__["a" /* default */], {
          boldRegex: _this2.props.boldRegex,
          data: component.data,
          handleItemFocus: _this2.handleItemFocus,
          iconCategory: _this2.props.iconCategory,
          iconInverse: _this2.props.iconInverse,
          iconName: _this2.props.iconName,
          id: id,
          index: i,
          isActive: isActive,
          key: id,
          listItemLabelRenderer: _this2.props.listItemLabelRenderer,
          onSelect: _this2.props.onSelect,
          searchTerm: _this2.props.searchTerm,
          setFocus: _this2.props.setFocus
        }, component);
      });
    }
  }, {
    key: "renderSectionDivider",
    value: function renderSectionDivider() {
      return this.props.sectionDivider;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section", {
        id: "menuContainer",
        className: "ignore-react-onclickoutside"
      }, this.renderHeader(), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
        id: "list",
        className: "slds-lookup__list",
        role: "presentation",
        ref: function ref(list) {
          if (list) {
            _this3.listRef = list;
          }
        }
      }, this.renderContent()), this.renderFooter());
    }
  }]);

  return Menu;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Menu.displayName = displayName;
Menu.propTypes = propTypes;
Menu.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Menu);
//# sourceMappingURL=menu.js.map

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__icon__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_event__ = __webpack_require__(7);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable jsx-a11y/role-has-required-aria-props */





var displayName = 'Lookup-Menu-Item';
var propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  handleItemFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  iconCategory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  index: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isDisabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  listItemLabelRenderer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  searchTerm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  setFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var Item =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Item, _React$Component);

  function Item() {
    var _ref;

    var _temp, _this;

    _classCallCheck(this, Item);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_ref = Item.__proto__ || Object.getPrototypeOf(Item)).call.apply(_ref, [this].concat(args))), Object.defineProperty(_assertThisInitialized(_this), "handleClick", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        return _this.props.onSelect(_this.props.id, _this.props.data);
      }
    }), _temp));
  }

  _createClass(Item, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.isActive !== this.props.isActive && nextProps.isActive === true) {
        this.scrollFocus();
        this.props.setFocus(this.props.id);
      }
    }
  }, {
    key: "getCustomLabel",
    value: function getCustomLabel() {
      var ListItemLabel = this.props.listItemLabelRenderer;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ListItemLabel, this.props);
    }
  }, {
    key: "getIcon",
    value: function getIcon() {
      if (this.props.iconName && !this.props.listItemLabelRenderer) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
          className: "slds-media__figure"
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__icon__["a" /* default */], {
          category: this.props.iconCategory,
          inverse: this.props.iconInverse,
          key: this.props.iconName,
          name: this.props.iconName,
          size: "small"
        }));
      }

      return null;
    }
  }, {
    key: "getLabel",
    value: function getLabel() {
      var label;

      if (this.props.children.data.subTitle) {
        label = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          className: "slds-media__body"
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          className: "slds-lookup__result-text"
        }, this.props.children.label), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
          className: "slds-lookup__result-meta slds-text-body--small"
        }, this.props.children.data.subTitle));
      } else {
        var labelClassName = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('slds-lookup__result-text', {
          'slds-m-left--x-small': !this.props.iconName
        });
        label = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          className: "slds-media__body"
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          className: labelClassName
        }, this.props.children.label));
      }

      return label;
    }
  }, {
    key: "scrollFocus",
    // Scroll menu item based on up/down mouse keys (assumes all items are the same height)
    value: function scrollFocus() {
      var height = this.itemRef.offsetHeight;

      if (height && this.props.handleItemFocus) {
        this.props.handleItemFocus(this.props.index, height);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var itemClassName = 'js-slds-lookup__item';
      var id = this.props.id;
      if (this.props.isActive) itemClassName += ' slds-theme--shade';
      return (// IMPORTANT: anchor id is used to set lookup's input's aria-activedescendant
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
          className: itemClassName,
          ref: function ref(li) {
            _this2.itemRef = li;
          }
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
          "aria-disabled": this.props.isDisabled,
          className: "slds-lookup__item-action slds-media slds-media--center",
          href: this.props.href,
          id: id,
          onClick: this.handleClick,
          onMouseDown: __WEBPACK_IMPORTED_MODULE_4__utilities_event__["a" /* default */].trapImmediate,
          ref: id,
          role: "option",
          tabIndex: "-1"
        }, this.getIcon(), this.props.listItemLabelRenderer ? this.getCustomLabel() : this.getLabel()))
      );
    }
  }]);

  return Item;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Item.displayName = displayName;
Item.propTypes = propTypes;
/* harmony default export */ __webpack_exports__["a"] = (Item);
//# sourceMappingURL=item.js.map

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__check_props__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_constants__ = __webpack_require__(2);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
// # Global Navigation Dropdown Component
// ## Dependencies
// ### React


 // ### classNames



 // ## Constants


/**
 *  The Dropdown Button Trigger renders the default trigger button for the dropdown menu. If this component has children, it does not render itself to the DOM. Instead, it renders its child element, `Button`, and all that child's properties. This component may be used as a template to create custom triggers that do not use `Button`.
 */

var GlobalNavigationDropdownTrigger = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  // ### Display Name
  // Always use the canonical component name (set in the core) as the React
  // display name.
  displayName: __WEBPACK_IMPORTED_MODULE_6__utilities_constants__["Y" /* MENU_DROPDOWN_TRIGGER */],
  // ### Prop Types
  propTypes: {
    /**
     * Whether the item is active or not.
     */
    active: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * Allows alignment of active item with active application background color.
     */
    activeBackgroundColor: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * **Assistive text for accessibility.**
     * This object is merged with the default props object on every render.
     * * `icon`: Text that is visually hidden but read aloud by screenreaders to tell the user what the icon means. If the button has an icon and a visible label, you can omit the <code>assistiveText.icon</code> prop and use the <code>label</code> prop.
     */
    assistiveText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
      icon: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
    }),

    /**
     * CSS classes to be added to the 'li'.
     */
    className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),

    /**
     * Determines position of separating bar.
     */
    dividerPosition: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['left', 'right']),

    /**
     * A unique ID is needed in order to support keyboard navigation, ARIA support, and connect the dropdown to the triggering button.
     */
    id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * Allows the dropdown menu to style itself accordingly when open since CSS hover rules cannot take effect if the menu is not inline.
     */
    isOpen: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * Visible label on the dropdown menu trigger button.
     */
    label: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * The dropdown menu.
     */
    menu: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,

    /**
     * Is only called when `openOn` is set to `hover` and when the triggering li loses focus.
     */
    onBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * This prop is passed onto the triggering `li`. Triggered when the trigger li is clicked.
     */
    onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Is only called when `openOn` is set to `hover` and when the triggering li gains focus.
     */
    onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Called when a key pressed.
     */
    onKeyDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Called when mouse clicks down on the trigger `li`.
     */
    onMouseDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Called when mouse hovers over the trigger `li`.
     */
    onMouseEnter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Called when mouse leaves trigger `li` or the menu.
     */
    onMouseLeave: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * The ref of the actual triggering button.
     */
    triggerRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
  },
  componentWillMount: function componentWillMount() {
    Object(__WEBPACK_IMPORTED_MODULE_4__check_props__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_6__utilities_constants__["Y" /* MENU_DROPDOWN_TRIGGER */], this.props);
  },
  // ### Render
  render: function render() {
    var _props = this.props,
        active = _props.active,
        activeBackgroundColor = _props.activeBackgroundColor,
        className = _props.className,
        dividerPosition = _props.dividerPosition,
        id = _props.id,
        isOpen = _props.isOpen,
        label = _props.label,
        menu = _props.menu,
        onBlur = _props.onBlur,
        onClick = _props.onClick,
        onFocus = _props.onFocus,
        onKeyDown = _props.onKeyDown,
        onMouseDown = _props.onMouseDown,
        onMouseEnter = _props.onMouseEnter,
        onMouseLeave = _props.onMouseLeave,
        triggerRef = _props.triggerRef,
        rest = _objectWithoutProperties(_props, ["active", "activeBackgroundColor", "className", "dividerPosition", "id", "isOpen", "label", "menu", "onBlur", "onClick", "onFocus", "onKeyDown", "onMouseDown", "onMouseEnter", "onMouseLeave", "triggerRef"]);

    var listItemstyle = {}; // TODO: This should eventually exist in a CSS class. Feature has been filed.

    var hoverBackgroundColor = '#f7f9fb';

    if (active) {
      listItemstyle.backgroundColor = activeBackgroundColor;
      listItemstyle.borderBottomColor = activeBackgroundColor;
    } // Per SLDS pattern, set trigger style like hover style, so that hover visuals and menu being open and closed are in same state


    if (isOpen) {
      listItemstyle.backgroundColor = hoverBackgroundColor;
    }

    return (
      /* eslint-disable jsx-a11y/no-static-element-interactions */
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
        "aria-haspopup": "true",
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('slds-context-bar__item slds-context-bar__dropdown-trigger slds-dropdown-trigger slds-dropdown-trigger--click', _defineProperty({
          'slds-is-open': isOpen,
          'slds-is-active': active
        }, "slds-context-bar__item--divider-".concat(dividerPosition), dividerPosition), className),
        id: id,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        ref: triggerRef,
        style: listItemstyle
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
        className: "slds-context-bar__label-action"
      }, label), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "slds-context-bar__icon-action slds-p-left--none"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__button__["a" /* default */], _extends({
        assistiveText: this.props.assistiveText
      }, rest, {
        className: "slds-context-bar__button slds-context-bar-action__trigger",
        "aria-haspopup": "true",
        iconCategory: "utility",
        iconName: "chevrondown",
        iconVariant: "bare",
        iconSize: "x-small",
        variant: "icon"
      }))), menu)
    );
  }
});
/* harmony default export */ __webpack_exports__["a"] = (GlobalNavigationDropdownTrigger);
//# sourceMappingURL=dropdown-trigger.js.map

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_warning_deprecated_property__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities_warning_sunset_property__ = __webpack_require__(11);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable import/no-mutable-exports */



var checkProps = function checkProps() {};

if (false) {
  checkProps = function checkProps(COMPONENT, props) {
    /* eslint-disable max-len */
    // Deprecated and changed to another property
    deprecatedProperty(COMPONENT, props.onChange, 'onChange', 'onRowChange', 'The callback parameters have been changed. `onRowChange` passes in `[event, { selection }` in order to align with other components.');
    deprecatedProperty(COMPONENT, props.compact, 'compact', undefined, 'compact has been deprecated as non-compact data tables do not exist in SLDS');
    deprecatedProperty(COMPONENT, props.collection, 'collection', 'items');
    deprecatedProperty(COMPONENT, props.onSelect, 'onSelect', 'onChange');
    deprecatedProperty(COMPONENT, props.onDeselect, 'onDeselect', 'onChange');
    sunsetProperty(COMPONENT, props.sortable, 'sortable', 'The table is sortable if one or more of its columns are sortable.'); // Deprecated and moved to a child

    sunsetProperty(COMPONENT, props.columns, 'columns', 'Please provide one or more children of the type <Column /> instead.');
    sunsetProperty(COMPONENT, props.bordered, 'bordered', 'All SLDS DataTables have row borders by default now. If you do not want row borders, please use `unborderedRow`');
    /* eslint-enable max-len */

    deprecatedProperty(COMPONENT, props.assistiveTextForActionsHeader, 'assistiveTextForActionsHeader', "assistiveText['actionsHeader']");
    deprecatedProperty(COMPONENT, props.assistiveTextForColumnSort, 'assistiveTextForColumnSort', "assistiveText['columnSort']");
    deprecatedProperty(COMPONENT, props.assistiveTextForColumnSortedAscending, 'assistiveTextForColumnSortedAscending', "assistiveText['columnSortedAscending']");
    deprecatedProperty(COMPONENT, props.assistiveTextForColumnSortedDescending, 'assistiveTextForColumnSortedDescending', "assistiveText['columnSortedDescending']");
    deprecatedProperty(COMPONENT, props.assistiveTextForSelectAllRows, 'assistiveTextForSelectAllRows', "assistiveText['selectAllRows']");
    deprecatedProperty(COMPONENT, props.assistiveTextForSelectRow, 'assistiveTextForSelectRow', "assistiveText['selectRow']");
  };
}

/* harmony default export */ __webpack_exports__["a"] = (checkProps);
//# sourceMappingURL=check-props.js.map

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__checkbox__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__header_cell__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_constants__ = __webpack_require__(2);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// ### React


 // ## Children


 // ## Constants


/**
 * Used internally, provides header row rendering to the DataTable.
 */

var DataTableHead = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  // ### Display Name
  // Always use the canonical component name as the React display name.
  displayName: __WEBPACK_IMPORTED_MODULE_5__utilities_constants__["w" /* DATA_TABLE_HEAD */],
  // ### Prop Types
  propTypes: {
    assistiveText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
      actionsHeader: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
      columnSort: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
      columnSortedAscending: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
      columnSortedDescending: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
      selectAllRows: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
      selectRow: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
    }),
    allSelected: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    indeterminateSelected: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    canSelectRows: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    columns: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
      Cell: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
      props: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
    })),
    id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    onToggleAll: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    onSort: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    showRowActions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
  },
  componentWillMount: function componentWillMount() {},
  // ### Render
  render: function render() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", {
      className: "slds-line-height_reset"
    }, this.props.canSelectRows ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", {
      className: "slds-text-align_right",
      scope: "col",
      style: {
        width: '3.25rem'
      }
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "slds-th__action slds-th__action--form"
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__checkbox__["a" /* default */], {
      assistiveText: {
        label: this.props.assistiveText.selectAllRows
      },
      checked: this.props.allSelected,
      indeterminate: this.props.indeterminateSelected,
      id: "".concat(this.props.id, "-SelectAll"),
      name: "SelectAll",
      onChange: this.props.onToggleAll
    }))) : null, this.props.columns.map(function (column) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__header_cell__["a" /* default */], _extends({
        assistiveText: _this.props.assistiveText,
        id: "".concat(_this.props.id, "-").concat(column.props.property),
        key: "".concat(_this.props.id, "-").concat(column.props.property),
        onSort: _this.props.onSort
      }, column.props));
    }), this.props.showRowActions ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", {
      scope: "col",
      style: {
        width: '3.25rem'
      }
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "slds-th__action"
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: "slds-assistive-text"
    }, this.props.assistiveText.actionsHeader))) : null));
  }
});
/* harmony default export */ __webpack_exports__["a"] = (DataTableHead);
//# sourceMappingURL=head.js.map

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isfunction__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isfunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isfunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__icon__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__column_check_props__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utilities_constants__ = __webpack_require__(2);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// ### React


 // ### classNames

 // ### isFunction

 // ## Children

 // This component's `checkProps` which issues warnings to developers about properties when in development mode (similar to React's built in development tools)

 // ## Constants


/**
 * Used internally, renders each individual column heading.
 */

var DataTableHeaderCell = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  // ### Display Name
  // Always use the canonical component name as the React display name.
  displayName: __WEBPACK_IMPORTED_MODULE_7__utilities_constants__["x" /* DATA_TABLE_HEADER_CELL */],
  // ### Prop Types
  propTypes: {
    assistiveText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
      actionsHeader: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
      columnSort: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
      columnSortedAscending: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
      columnSortedDescending: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
      selectAllRows: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
      selectRow: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
    }),
    id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,

    /**
     * Indicates if column is sorted.
     */
    isSorted: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * The column label.
     */
    label: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),

    /**
     * The function to execute on sort.
     */
    onSort: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * The property which corresponds to this column.
     */
    property: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * Whether or not the column is sortable.
     */
    sortable: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * The current sort direction.
     */
    sortDirection: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['desc', 'asc']),

    /**
     * Width of column. This is required for advanced/fixed layout tables. Please provide units. (`rems` are recommended)
     */
    width: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
  },
  getInitialState: function getInitialState() {
    return {
      sortDirection: null
    };
  },
  componentDidMount: function componentDidMount() {
    Object(__WEBPACK_IMPORTED_MODULE_6__column_check_props__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_7__utilities_constants__["v" /* DATA_TABLE_COLUMN */], this.props);
  },
  componentDidUpdate: function componentDidUpdate(prevProps) {
    // reset sort state when another column is sorted
    if (prevProps.isSorted === true && this.props.isSorted === false) {
      this.setState({
        sortDirection: null
      }); // eslint-disable-line react/no-did-update-set-state
    }
  },
  handleSort: function handleSort(e) {
    var oldSortDirection = this.props.sortDirection || this.state.sortDirection;
    var sortDirection = oldSortDirection === 'asc' ? 'desc' : 'asc';
    var data = {
      property: this.props.property,
      sortDirection: sortDirection
    };
    this.setState({
      sortDirection: sortDirection
    });

    if (__WEBPACK_IMPORTED_MODULE_4_lodash_isfunction___default()(this.props.onSort)) {
      this.props.onSort(data, e);
    }
  },
  // ### Render
  render: function render() {
    var _classNames;

    var _props = this.props,
        isSorted = _props.isSorted,
        label = _props.label,
        sortable = _props.sortable,
        width = _props.width;

    var labelType = _typeof(label);

    var sortDirection = this.props.sortDirection || this.state.sortDirection;
    var expandedSortDirection = sortDirection === 'desc' ? 'descending' : 'ascending';
    var ariaSort = isSorted ? expandedSortDirection : 'none';
    var fixedLayoutSubRenders = {
      sortable: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
        href: "javascript:void(0)" // eslint-disable-line no-script-url
        ,
        className: "slds-th__action slds-text-link_reset",
        onClick: this.handleSort,
        role: "button",
        tabIndex: "0"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "slds-assistive-text"
      }, this.props.assistiveTextForColumnSort || this.props.assistiveText.columnSort, ' '), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "slds-truncate",
        title: labelType === 'string' ? label : undefined
      }, label), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__icon__["a" /* default */], {
        className: "slds-is-sortable__icon",
        category: "utility",
        name: sortDirection === 'desc' ? 'arrowdown' : 'arrowup',
        size: "x-small"
      }), sortDirection ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "slds-assistive-text",
        "aria-live": "assertive",
        "aria-atomic": "true"
      }, sortDirection === 'asc' ? this.props.assistiveTextForColumnSortedAscending || this.props.assistiveText.columnSortedAscending : this.props.assistiveTextForColumnSortedDescending || this.props.assistiveText.columnSortedDescending) : null),
      notSortable: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "slds-p-horizontal_x-small",
        style: {
          display: 'flex'
        }
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "slds-truncate",
        title: labelType === 'string' ? label : undefined
      }, label))
    };
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", {
      "aria-label": labelType === 'string' ? label : undefined,
      "aria-sort": ariaSort,
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()((_classNames = {
        'slds-is-sortable': sortable,
        'slds-is-sorted': isSorted
      }, _defineProperty(_classNames, "slds-is-sorted_".concat(sortDirection), sortDirection), _defineProperty(_classNames, 'slds-is-sorted_asc', isSorted && !sortDirection), _classNames), 'slds-text-title_caps'),
      scope: "col",
      style: {
        width: width ? {
          width: width
        } : null
      }
    }, this.props.fixedLayout ? fixedLayoutSubRenders[sortable ? 'sortable' : 'notSortable'] : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "slds-truncate",
      title: labelType === 'string' ? label : undefined
    }, label));
  }
});
/* harmony default export */ __webpack_exports__["a"] = (DataTableHeaderCell);
//# sourceMappingURL=header-cell.js.map

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_warning_if_one_then_both_required_property__ = __webpack_require__(82);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable import/no-mutable-exports */


var checkProps = function checkProps() {};

if (false) {
  checkProps = function checkProps(COMPONENT, props) {
    /* eslint-disable max-len */
    // Deprecated and changed to another property
    ifOneThenBothRequiredProperty(COMPONENT, props, {
      isSorted: props.isSorted,
      sortDirection: props.sortDirection
    });
    /* eslint-enable max-len */
  };
}

/* harmony default export */ __webpack_exports__["a"] = (checkProps);
//# sourceMappingURL=column-check-props.js.map

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_find__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__checkbox__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_constants__ = __webpack_require__(2);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// ### React


 // ### classNames

 // ### find

 // ## Children

 // ## Constants


/**
 * Used internally, provides row rendering to the DataTable.
 */

var DataTableRow = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  // ### Display Name
  // Always use the canonical component name as the React display name.
  displayName: __WEBPACK_IMPORTED_MODULE_6__utilities_constants__["y" /* DATA_TABLE_ROW */],
  // ### Prop Types
  propTypes: {
    assistiveText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
      actionsHeader: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
      columnSort: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
      columnSortedAscending: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
      columnSortedDescending: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
      selectAllRows: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
      selectRow: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
    }),
    canSelectRows: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    columns: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
      Cell: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
      props: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
    })),

    /**
     * Use this if you are creating an advanced table (selectable, sortable, or resizable rows)
     */
    fixedLayout: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    item: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
    onToggle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    rowActions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element,
    selection: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array
  },
  isSelected: function isSelected() {
    return !!__WEBPACK_IMPORTED_MODULE_4_lodash_find___default()(this.props.selection, this.props.item);
  },
  handleToggle: function handleToggle(e, _ref) {
    var checked = _ref.checked;
    return this.props.onToggle(this.props.item, checked, e);
  },
  // ### Render
  render: function render() {
    var _this = this;

    var isSelected = this.isSelected(); // i18n

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()({
        'slds-hint-parent': this.props.rowActions,
        'slds-is-selected': this.props.canSelectRows && isSelected
      })
    }, this.props.canSelectRows ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", {
      role: this.props.fixedLayout ? 'gridcell' : null,
      className: "slds-text-align--right",
      "data-label": "Select Row",
      style: {
        width: '3.25rem'
      }
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__checkbox__["a" /* default */], {
      assistiveText: {
        label: this.props.assistiveText.selectRow
      },
      checked: isSelected,
      id: "".concat(this.props.id, "-SelectRow"),
      name: "SelectRow",
      onChange: this.handleToggle
    })) : null, this.props.columns.map(function (column) {
      var Cell = column.Cell;
      var cellId = "".concat(_this.props.id, "-").concat(__WEBPACK_IMPORTED_MODULE_6__utilities_constants__["u" /* DATA_TABLE_CELL */], "-").concat(column.props.property);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Cell, _extends({}, column.props, {
        className: column.props.truncate ? 'slds-truncate' : null,
        fixedLayout: _this.props.fixedLayout,
        rowHeader: column.props.primaryColumn,
        id: cellId,
        item: _this.props.item,
        key: cellId,
        width: column.props.width
      }), _this.props.item[column.props.property]);
    }), this.props.rowActions ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(this.props.rowActions, {
      id: "".concat(this.props.id, "-").concat(__WEBPACK_IMPORTED_MODULE_6__utilities_constants__["z" /* DATA_TABLE_ROW_ACTIONS */]),
      item: this.props.item
    }) : null);
  }
});
/* harmony default export */ __webpack_exports__["a"] = (DataTableRow);
//# sourceMappingURL=row.js.map

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_assign__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isboolean__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isboolean___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isboolean__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shortid__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shortid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_shortid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_dialog__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__private_calendar_wrapper__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__icon_input_icon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__input__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__check_props__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utilities_event__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utilities_key_code__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utilities_constants__ = __webpack_require__(2);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */


 // ### isBoolean

 // ### classNames
// [github.com/JedWatson/classnames](https://github.com/JedWatson/classnames)
// This project uses `classnames`, "a simple javascript utility for conditionally
// joining classNames together."

 // ### shortid
// [npmjs.com/package/shortid](https://www.npmjs.com/package/shortid)
// shortid is a short, non-sequential, url-friendly, unique id generator





 // This component's `checkProps` which issues warnings to developers about properties
// when in development mode (similar to React's built in development tools)





var propTypes = {
  /**
   * **Assistive text for accessibility**
   * This object is merged with the default props object on every render.
   * * `nextMonth`: Label for button to go to the next month _Tested with snapshot testing._
   * * `openCalendar`: Call to action label for calendar dialog trigger _Tested with snapshot testing._
   * * `previousMonth`: Label for button to go to the previous month _Tested with snapshot testing._
   */
  assistiveText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    nextMonth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    openCalendar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    previousMonth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),

  /**
   * Aligns the right or left side of the menu with the respective side of the trigger. _Tested with snapshot testing._
   */
  align: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['left', 'right']),

  /**
   * Pass in an `<Input />` component to customize it. Event handlers for the input (if needed) should be added here and not to this component. `<Input onKeyDown... />`.` _Tested with Mocha framework._
   */
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * CSS classes to be added to tag with `slds-datepicker`. If you are looking for the outer DOM node (slds-dropdown-trigger), please review `triggerClassName`. _Tested with snapshot testing._
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * Disable input and calendar. _Tested with Mocha framework._
   */
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * This function callback receives a data object with a key of `date`. Write your own validation and return `true` if the date should be disabled, otherwise please return `false`. The value of `date` is the day rendered in the calendar with the current local time and timezone.
   */
  dateDisabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Date formatting function. _Tested with snapshot testing._
   */
  formatter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Value of input that gets passed to `parser` prop. Set the `value` prop if using a `Date` object. Use an external library such as [MomentJS](https://github.com/moment/moment/) if additional date formatting or internationalization is needed. _Not tested._
   */
  formattedValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Prevents the dropdown from changing position based on the viewport/window. If set to true your dropdowns can extend outside the viewport _and_ overflow outside of a scrolling parent. If this happens, you might want to consider making the dropdowns contents scrollable to fit the menu on the screen. `hasStaticAlignment` disables this behavior and allows this component to extend beyond boundary elements. _Not tested._
   */
  hasStaticAlignment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * HTML id for component _Tested with snapshot testing._
   */
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * **Text labels for internationalization**
   * This object is merged with the default props object on every render.
   * * `abbreviatedWeekDays`: Three letter abbreviations of the days of the week, starting on Sunday. _Tested with snapshot testing._
   * * `months`: Names of the months. _Tested with snapshot testing._
   * * `label`: This label appears above the input.
   * * `placeholder`: Placeholder text for input. _Tested with snapshot testing._
   * * `today`: Label of shortcut to jump to today within the calendar. This is also used for assistive text on today's date. _Tested with snapshot testing._
   * * `weekDays`: Full names of the seven days of the week, starting on Sunday. _Tested with snapshot testing._
   */
  labels: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    abbreviatedWeekDays: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    months: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
    placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    today: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    weekDays: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
  }),

  /**
   * Forces the dropdown to be open or closed. See controlled/uncontrolled callback/prop pattern for more on suggested use view [Concepts and Best Practices](https://github.com/salesforce-ux/design-system-react/blob/master/CONTRIBUTING.md#concepts-and-best-practices)
   */
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Makes Monday the first day of the week. _Tested with snapshot testing._
   */
  isIsoWeekday: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Please select one of the following:
   * * `absolute` - (default) The dialog will use `position: absolute` and style attributes to position itself. This allows inverted placement or flipping of the dialog.
   * * `overflowBoundaryElement` - The dialog will overflow scrolling parents. Use on elements that are aligned to the left or right of their target and don't care about the target being within a scrolling parent. Typically this is a popover or tooltip. Dropdown menus can usually open up and down if no room exists. In order to achieve this a portal element will be created and attached to `body`. This element will render into that detached render tree.
   * * `relative` - No styling or portals will be used. Menus will be positioned relative to their triggers. This is a great choice for HTML snapshot testing.
   */
  menuPosition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['absolute', 'overflowBoundaryElement', 'relative']),

  /**
   * Triggered when the user wants to focus on a new day with the keyboard. If the target node is a day it will return the keyboard event a data object with the shape: `{date: [Date object]}`. Event will be `null` when new month is re-rendered.  _Tested with Mocha framework._
   */
  onCalendarFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Triggered when the date changes. `onChange` can be used for form validation if needed. It receives an event and a data object in the shape: `{date: [Date object], formattedDate: [string], timezoneOffset: [number]}`. `data.date` is Coordinated Universal Time (UTC), but the days of the calendar are in local time of the user. The `timezoneOffset` is the difference, in minutes, between UTC and the local time. Please note that this means that the offset is positive if the local timezone is behind UTC and negative if it is ahead. `timezoneOffset` is in minutes, for hours divide by `60`. _Tested with Mocha framework._
   */
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Triggered when the calendar is closed. _Tested with Mocha framework._
   */
  onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Triggered when the calendar has opened. _Tested with Mocha framework._
   */
  onOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Function called when the calendar dialog would like hide. This will turn the calendar dialog into into a controlled component. Please use with `isOpen`. _Tested with Mocha framework._
   */
  onRequestClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Function called when the calendar dialog would like show. This will turn the calendar dialog into into a controlled component. Please use with `isOpen`. _Tested with Mocha framework._
   */
  onRequestOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Custom function to parse date string into and return a `Date` object. Default function passes the input value to `Date()` and prays for a miracle. Use an external library such as [MomentJS](https://github.com/moment/moment/) if additional date parsing is needed. _Tested with snapshot testing._
   */
  parser: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Offset of year from current year that can be selected in the year selection dropdown. (2017 - 5 = 2012). _Tested with snapshot testing._
   */
  relativeYearFrom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * Offset of year from current year that can be selected in the year selection dropdown. (2017 + 5 = 2012). _Tested with snapshot testing._
   */
  relativeYearTo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * CSS classes to be added to tag with `slds-datepicker-trigger`. This is typically a wrapping `div` around the input. _Tested with snapshot testing._
   */
  triggerClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * Sets date with a `Date` ECMAScript object. _Tested with snapshot testing._
   */
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Date)
};
var defaultProps = {
  align: 'left',
  assistiveText: {
    nextMonth: 'Next month',
    openCalendar: 'Open Calendar',
    previousMonth: 'Previous month'
  },
  formatter: function formatter(date) {
    return date ? "".concat(date.getMonth() + 1, "/").concat(date.getDate(), "/").concat(date.getFullYear()) : '';
  },
  labels: {
    abbreviatedWeekDays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    placeholder: 'Pick a Date',
    today: 'Today',
    weekDays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
  },
  menuPosition: 'absolute',
  parser: function parser(str) {
    return new Date(str);
  },
  relativeYearFrom: -10,
  relativeYearTo: 10,
  dateDisabled: function dateDisabled() {
    return false;
  }
};
/**
 * A date picker is a non text input form element. You can select a single date from a popup or inline calendar. The date picker supplied by this library comes with an input by default, but other components could be passed in as children--however, pairing with other components is untested.
 *
 * The calendar is rendered with time/dates based on local browser time of the client. All dates are in local user timezones. Another way to put it is if a user selects a date, they are selecting midnight their time on that day and not mightnight in UTC. If this component is being used in conjuction with a timezone input, you may want to convert dates provided to UTC in that timezone.
 *
 * This component is wrapped in a [higher order component to listen for clicks outside itself](https://github.com/kentor/react-click-outside) and thus requires use of `ReactDOM`.
 */

var Datepicker =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Datepicker, _React$Component);

  function Datepicker(props) {
    var _this;

    _classCallCheck(this, Datepicker);

    _this = _possibleConstructorReturn(this, (Datepicker.__proto__ || Object.getPrototypeOf(Datepicker)).call(this, props)); // Please remove `strValue` on the next breaking change.

    var formattedValue = props.formattedValue || props.strValue; // eslint-disable-line react/prop-types

    var dateString = props.formatter(props.value);
    var initDate = props.value ? dateString : formattedValue;
    _this.getId = _this.getId.bind(_assertThisInitialized(_this));
    _this.getIsOpen = _this.getIsOpen.bind(_assertThisInitialized(_this));
    _this.handleCalendarChange = _this.handleCalendarChange.bind(_assertThisInitialized(_this));
    _this.handleClickOutside = _this.handleClickOutside.bind(_assertThisInitialized(_this));
    _this.handleRequestClose = _this.handleRequestClose.bind(_assertThisInitialized(_this));
    _this.openDialog = _this.openDialog.bind(_assertThisInitialized(_this));
    _this.parseDate = _this.parseDate.bind(_assertThisInitialized(_this));
    _this.handleClose = _this.handleClose.bind(_assertThisInitialized(_this));
    _this.handleOpen = _this.handleOpen.bind(_assertThisInitialized(_this));
    _this.getDialog = _this.getDialog.bind(_assertThisInitialized(_this));
    _this.getDatePicker = _this.getDatePicker.bind(_assertThisInitialized(_this));
    _this.handleInputChange = _this.handleInputChange.bind(_assertThisInitialized(_this));
    _this.handleKeyDown = _this.handleKeyDown.bind(_assertThisInitialized(_this));
    _this.state = {
      isOpen: false,
      value: props.value,
      formattedValue: initDate || '',
      inputValue: initDate || ''
    };
    return _this;
  }

  _createClass(Datepicker, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.generatedId = __WEBPACK_IMPORTED_MODULE_5_shortid___default.a.generate(); // `checkProps` issues warnings to developers about properties (similar to React's built in development tools)

      Object(__WEBPACK_IMPORTED_MODULE_10__check_props__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_13__utilities_constants__["A" /* DATE_PICKER */], this.props);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.value && this.props.value) {
        var currentDate = this.props.value.getTime();
        var nextDate = nextProps.value.getTime();

        if (currentDate !== nextDate) {
          this.setState({
            value: nextProps.value,
            formattedValue: this.props.formatter(nextProps.value),
            inputValue: this.props.formatter(nextProps.value)
          });
        }
      }
    }
  }, {
    key: "getDatePicker",
    value: function getDatePicker(_ref) {
      var _this2 = this;

      var labels = _ref.labels,
          assistiveText = _ref.assistiveText;
      var date = this.state.formattedValue ? this.parseDate(this.state.formattedValue) : this.state.value;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__private_calendar_wrapper__["a" /* default */] // Please remove `abbrWeekDayLabels` on the next breaking change.
      , {
        abbreviatedWeekDayLabels: this.props.abbreviatedWeekDayLabels || // eslint-disable-line react/prop-types
        this.props.abbrWeekDayLabels || // eslint-disable-line react/prop-types
        labels.abbreviatedWeekDays
        /* Remove || for assistiveText at next breaking change */
        ,
        assistiveTextNextMonth: this.props.assistiveTextNextMonth || assistiveText.nextMonth // eslint-disable-line react/prop-types
        ,
        assistiveTextPreviousMonth: this.props.assistiveTextPreviousMonth || assistiveText.previousMonth // eslint-disable-line react/prop-types
        ,
        id: this.getId(),
        isIsoWeekday: this.props.isIsoWeekday,
        monthLabels: this.props.monthLabels || labels.months // eslint-disable-line react/prop-types
        ,
        onCalendarFocus: this.props.onCalendarFocus,
        dateDisabled: this.props.dateDisabled,
        onRequestClose: this.handleRequestClose,
        onSelectDate: this.handleCalendarChange,
        relativeYearFrom: this.props.relativeYearFrom,
        relativeYearTo: this.props.relativeYearTo,
        selectedDate: date || new Date(),
        selectedDateRef: function selectedDateRef(component) {
          _this2.selectedDateCell = component;
        },
        todayLabel: this.props.todayLabel || labels.today // eslint-disable-line react/prop-types
        ,
        weekDayLabels: this.props.weekDayLabels || labels.weekDays // eslint-disable-line react/prop-types

      });
    }
  }, {
    key: "getDialog",
    value: function getDialog(_ref2) {
      var _this3 = this;

      var labels = _ref2.labels,
          assistiveText = _ref2.assistiveText;
      // FOR BACKWARDS COMPATIBILITY
      var menuPosition = this.props.isInline ? 'relative' : this.props.menuPosition; // eslint-disable-line react/prop-types
      // SLDS override

      var style = this.props.menuPosition !== 'relative' ? {
        transform: 'none'
      } : {};
      return !this.props.disabled && this.getIsOpen() ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__utilities_dialog__["a" /* default */], {
        align: "bottom ".concat(this.props.align),
        contentsClassName: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('slds-datepicker slds-dropdown', {
          'slds-dropdown--right': this.props.menuPosition === 'relative' && this.props.align === 'right',
          'slds-dropdown--left': this.props.menuPosition === 'relative' && this.props.align === 'left'
        }, this.props.className),
        context: this.context,
        hasStaticAlignment: this.props.hasStaticAlignment,
        style: style,
        onClose: this.handleClose,
        onOpen: this.handleOpen,
        onRequestTargetElement: function onRequestTargetElement() {
          return _this3.inputRef;
        },
        position: menuPosition,
        portalMount: this.props.portalMount
      }, this.getDatePicker({
        labels: labels,
        assistiveText: assistiveText
      })) : null;
    }
  }, {
    key: "getId",
    value: function getId() {
      return this.props.id || this.generatedId;
    }
  }, {
    key: "getIsOpen",
    value: function getIsOpen() {
      return !!(__WEBPACK_IMPORTED_MODULE_3_lodash_isboolean___default()(this.props.isOpen) ? this.props.isOpen : this.state.isOpen);
    }
  }, {
    key: "setInputRef",
    value: function setInputRef(component) {
      this.inputRef = component; // yes, this is a re-render triggered by a render.
      // Dialog/Popper.js cannot place the popover until
      // the trigger/target DOM node is mounted. This
      // way `findDOMNode` is not called and parent
      // DOM nodes are not queried.

      if (!this.state.inputRendered) {
        this.setState({
          inputRendered: true
        });
      }
    }
  }, {
    key: "handleCalendarChange",
    value: function handleCalendarChange(event, _ref3) {
      var date = _ref3.date;
      this.setState({
        value: date,
        formattedValue: this.props.formatter(date),
        inputValue: this.props.formatter(date)
      });
      this.handleRequestClose();

      if (this.props.onChange) {
        this.props.onChange(event, {
          date: date,
          formattedDate: this.props.formatter(date),
          timezoneOffset: date.getTimezoneOffset()
        });
      } // Please remove `onDateChange` on the next breaking change.

      /* eslint-disable react/prop-types */


      if (this.props.onDateChange) {
        this.props.onDateChange(date, this.props.formatter(date));
      }
      /* eslint-enable react/prop-types */

    }
  }, {
    key: "handleClickOutside",
    value: function handleClickOutside() {
      this.handleRequestClose();
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      if (this.props.onClose) {
        this.props.onClose();
      }
    }
  }, {
    key: "handleInputChange",
    value: function handleInputChange(event) {
      this.setState({
        formattedValue: event.target.value,
        inputValue: event.target.value
      });
      var date = this.props.parser(event.target.value);

      if (this.props.onChange) {
        this.props.onChange(event, {
          date: date,
          formattedDate: event.target.value,
          timezoneOffset: date.getTimezoneOffset()
        });
      }
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(event) {
      // Don't open if user is selecting text
      if (event.keyCode && !event.shiftKey && (event.keyCode === __WEBPACK_IMPORTED_MODULE_12__utilities_key_code__["a" /* default */].DOWN || event.keyCode === __WEBPACK_IMPORTED_MODULE_12__utilities_key_code__["a" /* default */].UP)) {
        __WEBPACK_IMPORTED_MODULE_11__utilities_event__["a" /* default */].trapEvent(event);
        this.setState({
          isOpen: true
        });
      } // Please remove `onKeyDown` on the next breaking change.

      /* eslint-disable react/prop-types */


      if (this.props.onKeyDown) {
        this.props.onKeyDown(event, {});
      }
      /* eslint-enable react/prop-types */

    }
  }, {
    key: "handleOpen",
    value: function handleOpen(event, _ref4) {
      var portal = _ref4.portal;

      if (this.props.onOpen) {
        this.props.onOpen(event, {
          portal: portal
        });
      }

      if (this.selectedDateCell) {
        this.selectedDateCell.focus();
      }
    }
  }, {
    key: "handleRequestClose",
    value: function handleRequestClose() {
      if (this.props.onRequestClose) {
        this.props.onRequestClose();
      }

      if (this.getIsOpen()) {
        this.setState({
          isOpen: false
        });

        if (this.inputRef) {
          this.inputRef.focus();
        }
      }
    }
  }, {
    key: "openDialog",
    value: function openDialog() {
      if (this.props.onRequestOpen) {
        this.props.onRequestOpen();
      } else {
        this.setState({
          isOpen: true
        });
      }
    }
  }, {
    key: "parseDate",
    value: function parseDate(formattedValue) {
      var parsedDate = this.props.parser(formattedValue);

      if (Object.prototype.toString.call(parsedDate) !== '[object Date]' || isNaN(parsedDate.getTime())) {
        parsedDate = new Date();
      }

      return parsedDate;
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      // Merge objects of strings with their default object
      var labels = __WEBPACK_IMPORTED_MODULE_2_lodash_assign___default()({}, defaultProps.labels, this.props.labels);
      var assistiveText = __WEBPACK_IMPORTED_MODULE_2_lodash_assign___default()({}, defaultProps.assistiveText, this.props.assistiveText);
      var clonedInputProps = {
        disabled: this.props.children && !!this.props.children.props.disabled || this.props.disabled,
        iconRight: this.props.children && !!this.props.children.props.iconRight || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__icon_input_icon__["a" /* default */] // Remove || for assistiveText at next breaking change
        , {
          assistiveText: {
            icon: this.props.assistiveTextOpenCalendar || assistiveText.openCalendar // eslint-disable-line react/prop-types

          },
          "aria-haspopup": true,
          "aria-expanded": this.getIsOpen(),
          category: "utility",
          name: "event",
          onClick: this.openDialog,
          type: "button"
        }),
        id: this.getId(),
        inputRef: function inputRef(component) {
          _this4.setInputRef(component);
        },
        label: this.props.children && this.props.children.props.label || this.props.label || // eslint-disable-line react/prop-types
        labels.label,
        onBlur: this.props.children && this.props.children.props.onBlur || this.props.onBlur,
        // eslint-disable-line react/prop-types
        onChange: this.handleInputChange,
        onClick: function onClick() {
          _this4.openDialog();

          if (_this4.props.children && _this4.props.children.props.onClick) {
            _this4.props.children.props.onClick();
          }
        },
        onFocus: this.props.children && this.props.children.props.onFocus || this.props.onFocus,
        // eslint-disable-line react/prop-types
        onKeyDown: this.props.children && this.props.children.props.onKeyDown || this.handleKeyDown,
        placeholder: this.props.children && this.props.children.props.placeholder || this.props.placeholder || // eslint-disable-line react/prop-types
        labels.placeholder,
        required: this.props.children && this.props.children.props.required || this.props.required,
        // eslint-disable-line react/prop-types
        value: this.props.children && this.props.children.props.value || this.state.inputValue
      };
      var clonedInput = this.props.children ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(this.props.children, _objectSpread({}, clonedInputProps)) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__input__["a" /* default */], clonedInputProps);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('slds-dropdown-trigger', 'slds-dropdown-trigger--click', 'ignore-react-onclickoutside', {
          'slds-is-open': this.getIsOpen()
        }, this.props.triggerClassName)
      }, clonedInput, this.getDialog({
        labels: labels,
        assistiveText: assistiveText
      }));
    }
  }]);

  return Datepicker;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Datepicker.contextTypes = {
  iconPath: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
Datepicker.displayName = __WEBPACK_IMPORTED_MODULE_13__utilities_constants__["A" /* DATE_PICKER */];
Datepicker.propTypes = propTypes;
Datepicker.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Datepicker);
//# sourceMappingURL=date-picker.js.map

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__calendar__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__navigation__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_event__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_key_code__ = __webpack_require__(8);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

 // ### classNames
// [github.com/JedWatson/classnames](https://github.com/JedWatson/classnames)
// This project uses `classnames`, "a simple javascript utility for conditionally
// joining classNames together."







var DatepickerCalendarWrapper =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DatepickerCalendarWrapper, _React$Component);

  function DatepickerCalendarWrapper() {
    var _ref;

    var _temp, _this;

    _classCallCheck(this, DatepickerCalendarWrapper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_ref = DatepickerCalendarWrapper.__proto__ || Object.getPrototypeOf(DatepickerCalendarWrapper)).call.apply(_ref, [this].concat(args))), Object.defineProperty(_assertThisInitialized(_this), "state", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: {
        initialDateForCalendarRender: _this.props.selectedDate,
        isCalendarFocused: true
      }
    }), Object.defineProperty(_assertThisInitialized(_this), "handleCalendarBlur", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(event, _ref2) {
        var direction = _ref2.direction;

        if (direction === 'next' && _this.previousMonthRef) {
          _this.setState({
            isCalendarFocused: false
          });

          if (_this.props.onCalendarFocus) {
            _this.props.onCalendarFocus(event, {
              direction: direction,
              isCalendarFocused: false,
              ref: _this.previousMonthRef
            });
          }

          _this.previousMonthRef.focus();
        } else if (direction === 'previous' && _this.todayRef) {
          _this.setState({
            isCalendarFocused: false
          });

          if (_this.props.onCalendarFocus) {
            _this.props.onCalendarFocus(event, {
              direction: direction,
              isCalendarFocused: false,
              ref: _this.todayRef
            });
          }

          _this.todayRef.focus();
        }
      }
    }), Object.defineProperty(_assertThisInitialized(_this), "handleFirstFocusableNodeKeyDown", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(event) {
        if (event.shiftKey && event.keyCode === __WEBPACK_IMPORTED_MODULE_6__utilities_key_code__["a" /* default */].TAB) {
          __WEBPACK_IMPORTED_MODULE_5__utilities_event__["a" /* default */].trapEvent(event);

          _this.setState({
            isCalendarFocused: true
          });
        }
      }
    }), Object.defineProperty(_assertThisInitialized(_this), "handleInitialDateForCalendarRenderChange", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(event, initialDateForCalendarRender) {
        _this.setState({
          initialDateForCalendarRender: initialDateForCalendarRender
        });
      }
    }), Object.defineProperty(_assertThisInitialized(_this), "handleKeyDown", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(event) {
        if (event.keyCode === __WEBPACK_IMPORTED_MODULE_6__utilities_key_code__["a" /* default */].ESCAPE) {
          __WEBPACK_IMPORTED_MODULE_5__utilities_event__["a" /* default */].trapEvent(event);

          _this.props.onRequestClose(event, {});
        }
      }
    }), Object.defineProperty(_assertThisInitialized(_this), "handleLastFocusableNodeKeyDown", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(event) {
        if (!event.shiftKey && event.keyCode === __WEBPACK_IMPORTED_MODULE_6__utilities_key_code__["a" /* default */].TAB) {
          __WEBPACK_IMPORTED_MODULE_5__utilities_event__["a" /* default */].trapEvent(event);

          _this.setState({
            isCalendarFocused: true
          });
        }
      }
    }), Object.defineProperty(_assertThisInitialized(_this), "handleRequestClose", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(event) {
        if (_this.props.onRequestClose) {
          _this.props.onRequestClose(event, {});
        }
      }
    }), Object.defineProperty(_assertThisInitialized(_this), "handleRequestFocusDate", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(event, data) {
        // will be called three times, due to re-render
        if (data.ref && _this.state.isCalendarFocused) {
          data.ref.focus();
        } // only call on actual DOM event and not on re-render


        if (_this.props.onCalendarFocus && data.triggerCallback) {
          var triggerCallback = data.triggerCallback,
              modifiedData = _objectWithoutProperties(data, ["triggerCallback"]); // eslint-disable-line no-unused-vars


          _this.props.onCalendarFocus(event, modifiedData);
        }
      }
    }), _temp));
  }

  _createClass(DatepickerCalendarWrapper, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        // eslint-disable-line jsx-a11y/no-static-element-interactions
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
          'slds-datepicker': this.props.isolated
        }, this.props.className),
        "aria-hidden": "false",
        "data-selection": "single",
        onKeyDown: this.handleKeyDown
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__navigation__["a" /* default */], {
        assistiveTextNextMonth: this.props.assistiveTextNextMonth,
        assistiveTextPreviousMonth: this.props.assistiveTextPreviousMonth,
        id: this.props.id,
        initialDateForCalendarRender: this.state.initialDateForCalendarRender,
        monthLabels: this.props.monthLabels,
        onChangeMonth: this.handleInitialDateForCalendarRenderChange,
        previousMonthRef: function previousMonthRef(component) {
          _this2.previousMonthRef = component;
        },
        onPreviousMonthKeyDown: this.handleFirstFocusableNodeKeyDown,
        relativeYearFrom: this.props.relativeYearFrom,
        relativeYearTo: this.props.relativeYearTo
      }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__calendar__["a" /* default */], {
        abbreviatedWeekDayLabels: this.props.abbreviatedWeekDayLabels,
        dateDisabled: this.props.dateDisabled,
        id: this.props.id,
        initialDateForCalendarRender: this.state.initialDateForCalendarRender,
        isIsoWeekday: this.props.isIsoWeekday,
        onCalendarBlur: this.handleCalendarBlur,
        onChangeMonth: this.handleInitialDateForCalendarRenderChange,
        onRequestClose: this.handleRequestClose,
        onRequestInternalFocusDate: this.handleRequestFocusDate,
        onSelectDate: this.props.onSelectDate,
        selectedDate: this.props.selectedDate,
        selectedDateRef: this.props.selectedDateRef,
        todayLabel: this.props.todayLabel,
        todayRef: function todayRef(component) {
          _this2.todayRef = component;
        },
        onLastFocusableNodeKeyDown: this.handleLastFocusableNodeKeyDown,
        weekDayLabels: this.props.weekDayLabels
      }));
    }
  }]);

  return DatepickerCalendarWrapper;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Object.defineProperty(DatepickerCalendarWrapper, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    selectedDate: new Date(),
    value: new Date()
  }
});
Object.defineProperty(DatepickerCalendarWrapper, "displayName", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: 'DatepickerCalendarWrapper'
});
Object.defineProperty(DatepickerCalendarWrapper, "propTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    /**
     * Label for button to go to the next month
     */
    assistiveTextNextMonth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,

    /**
     * Label for button to go to the previous month
     */
    assistiveTextPreviousMonth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,

    /**
     * One letter abbreviations of the days of the week, starting on Sunday.
     */
    abbreviatedWeekDayLabels: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,

    /**
     * CSS classes to be added to tag with `slds-datepicker`.
     */
    className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

    /**
     * dateDisabled() takes a date as input argument, returns true if given date should be disabled, otherwise returns false.
     */
    dateDisabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

    /**
     * HTML id for component
     */
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

    /**
     * Makes Monday the first day of the week
     */
    isIsoWeekday: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

    /**
     * For use of datepicker outside of dropdown.
     */
    isolated: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

    /**
     * Names of the months
     */
    monthLabels: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,

    /**
     * Triggered when the keyboard moves focus on the calendar. {date: [Date object], formattedDate: [string]}  _Tested with Mocha framework._
     */
    onCalendarFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

    /**
     * Triggered when the calendar is supposed to close.
     */
    onRequestClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,

    /**
     * Triggered when a date on the calendar is clicked.
     */
    onSelectDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,

    /**
     * The earliest year that can be selected in the year selection dropdown.
     */
    relativeYearFrom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,

    /**
     * The maximum year that can be selected in the year selection dropdown.
     */
    relativeYearTo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,

    /**
     * Currently selected date
     */
    selectedDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Date),

    /**
     * Component reference / DOM node for selected day.
     */
    selectedDateRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

    /**
     * Label of shortcut to jump to today within the calendar. Also used for assistive text for the current day.
     */
    todayLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,

    /**
     * Names of the seven days of the week, starting on Sunday.
     */
    weekDayLabels: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired
  }
});
/* harmony default export */ __webpack_exports__["a"] = (DatepickerCalendarWrapper);
//# sourceMappingURL=calendar-wrapper.js.map

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__week__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_date__ = __webpack_require__(41);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */





var DatepickerCalendar = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'SLDSDatepickerCalendar',
  propTypes: {
    /**
     * Three letter abbreviations of the days of the week, starting on Sunday.
     */
    abbreviatedWeekDayLabels: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired,

    /**
     * dateDisabled() takes a date as input argument, returns true if given date should be disabled, otherwise returns false.
     */
    dateDisabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * HTML id for component
     */
    id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,

    /**
     * Date used to create calendar that is displayed. This is typically the initial day focused when using the keyboard navigation. Focus will be set to this date if available.
     */
    initialDateForCalendarRender: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(Date).isRequired,

    /**
     * Makes Monday the first day of the week
     */
    isIsoWeekday: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * Triggered when the keyboard moves focus off the calendar.
     */
    onCalendarBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,

    /**
     * Displayed calendar has changed or re-rendered
     */
    onChangeMonth: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,

    /**
     * Internal callback that will eventually trigger when the keyboard moves focus on the calendar. `{date: [Date object], formattedDate: [string]}`.
     */
    onRequestInternalFocusDate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Triggered when the calendar is cancelled.
     */
    onRequestClose: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,

    /**
     * Triggered when a date on the calendar is clicked.
     */
    onSelectDate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,

    /**
     * Currently selected date. This should be present in the input field.
     */
    selectedDate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(Date),

    /**
     * Component reference / DOM node for selected day.
     */
    selectedDateRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Label of shortcut to jump to today within the calendar. This is also used for assistive text on today's date.
     */
    todayLabel: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,

    /**
     * For keyboard navigation. Listens for key presses on the last focusable DOM Node, the "Today" link, so that dialog focus can be trapped.
     */
    onLastFocusableNodeKeyDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Callback that passes in the DOM reference of the Today `a` DOM node within this component. Primary use is to allow `focus` to be called. You should still test if the node exists, since rendering is asynchronous. `buttonRef={(component) => { if(component) console.log(component); }}`
     */
    todayRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Names of the seven days of the week, starting on Sunday.
     */
    weekDayLabels: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired
  },
  getInitialState: function getInitialState() {
    return {
      focusedDate: this.props.initialDateForCalendarRender,
      calendarHasFocus: true,
      todayFocus: false
    };
  },
  componentDidUpdate: function componentDidUpdate(prevProps) {
    this.setCalendarRenderSeedDate(prevProps);
  },
  setCalendarRenderSeedDate: function setCalendarRenderSeedDate(prevProps) {
    // Set prop that sets focus in child component once it is rendered. This occurs when the month DOM has changed. This will trigger a re-render, but no DOM change will occur, just a DOM focus.
    if (!__WEBPACK_IMPORTED_MODULE_4__utilities_date__["a" /* default */].isEqual(this.props.initialDateForCalendarRender, prevProps.initialDateForCalendarRender)) {
      this.setState({
        focusedDate: this.props.initialDateForCalendarRender
      });
      this.props.onRequestInternalFocusDate(undefined, {
        date: this.props.initialDateForCalendarRender,
        triggerCallback: true
      });
    }
  },
  handleSelectDate: function handleSelectDate(event, _ref) {
    var date = _ref.date;

    if (!this.props.dateDisabled({
      date: date
    })) {
      this.setState({
        selected: date
      });
      this.props.onSelectDate(event, {
        date: date
      });
    }
  },
  handleRequestClose: function handleRequestClose(event) {
    if (this.props.onRequestClose) {
      this.props.onRequestClose(event, {});
    }
  },
  handleKeyboardNavigateToPreviousDay: function handleKeyboardNavigateToPreviousDay(event, _ref2) {
    var date = _ref2.date;
    var prevDate = __WEBPACK_IMPORTED_MODULE_4__utilities_date__["a" /* default */].addDays(date, -1);

    if (!__WEBPACK_IMPORTED_MODULE_4__utilities_date__["a" /* default */].isSameMonth(prevDate, date)) {
      this.props.onChangeMonth(event, prevDate);
    } else {
      this.setState({
        focusedDate: prevDate
      });
      this.props.onRequestInternalFocusDate(event, {
        date: prevDate,
        triggerCallback: true
      });
    }
  },
  handleKeyboardNavigateToNextDay: function handleKeyboardNavigateToNextDay(event, _ref3) {
    var date = _ref3.date;
    var nextDate = __WEBPACK_IMPORTED_MODULE_4__utilities_date__["a" /* default */].addDays(date, 1);

    if (!__WEBPACK_IMPORTED_MODULE_4__utilities_date__["a" /* default */].isSameMonth(nextDate, date)) {
      this.props.onChangeMonth(event, nextDate);
    } else {
      this.setState({
        focusedDate: nextDate
      });
      this.props.onRequestInternalFocusDate(event, {
        date: nextDate,
        triggerCallback: true
      });
    }
  },
  handleKeyboardNavigateToPreviousWeek: function handleKeyboardNavigateToPreviousWeek(event, _ref4) {
    var date = _ref4.date;
    var prevDate = __WEBPACK_IMPORTED_MODULE_4__utilities_date__["a" /* default */].addDays(date, -7);

    if (!__WEBPACK_IMPORTED_MODULE_4__utilities_date__["a" /* default */].isSameMonth(prevDate, date)) {
      this.props.onChangeMonth(event, prevDate);
    } else {
      this.setState({
        focusedDate: prevDate
      });
      this.props.onRequestInternalFocusDate(event, {
        date: prevDate,
        triggerCallback: true
      });
    }
  },
  handleKeyboardNavigateToNextWeek: function handleKeyboardNavigateToNextWeek(event, _ref5) {
    var date = _ref5.date;
    var nextDate = __WEBPACK_IMPORTED_MODULE_4__utilities_date__["a" /* default */].addDays(date, 7);

    if (!__WEBPACK_IMPORTED_MODULE_4__utilities_date__["a" /* default */].isSameMonth(nextDate, date)) {
      this.props.onChangeMonth(event, nextDate);
    } else {
      this.setState({
        focusedDate: nextDate
      });
      this.props.onRequestInternalFocusDate(event, {
        date: nextDate,
        triggerCallback: true
      });
    }
  },
  renderWeeks: function renderWeeks() {
    var firstDayOfWeekOffset = this.props.isIsoWeekday ? 1 : 0;
    var firstDayOfMonth = __WEBPACK_IMPORTED_MODULE_4__utilities_date__["a" /* default */].firstDayOfMonth(this.props.initialDateForCalendarRender);
    var firstDayOfWeek;

    if (firstDayOfMonth.getDay() > firstDayOfWeekOffset) {
      var prevWeek = __WEBPACK_IMPORTED_MODULE_4__utilities_date__["a" /* default */].addWeeks(firstDayOfMonth, -1);
      firstDayOfWeek = __WEBPACK_IMPORTED_MODULE_4__utilities_date__["a" /* default */].nearestWeekDay(prevWeek, firstDayOfWeekOffset);
    } else {
      firstDayOfWeek = firstDayOfMonth;
    }

    var weeks = [];
    var done = false;
    var monthIndex = firstDayOfWeek.getMonth();
    var count = 0;

    while (!done) {
      weeks.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__week__["a" /* default */], {
        calendarHasFocus: this.state.calendarHasFocus,
        dateDisabled: this.props.dateDisabled,
        firstDayOfWeek: firstDayOfWeek,
        key: firstDayOfWeek.toString(),
        focusedDate: this.state.focusedDate,
        initialDateForCalendarRender: this.props.initialDateForCalendarRender,
        onCalendarBlur: this.props.onCalendarBlur,
        onKeyboardNavigateToPreviousDay: this.handleKeyboardNavigateToPreviousDay,
        onKeyboardNavigateToNextDay: this.handleKeyboardNavigateToNextDay,
        onKeyboardNavigateToPreviousWeek: this.handleKeyboardNavigateToPreviousWeek,
        onKeyboardNavigateToNextWeek: this.handleKeyboardNavigateToNextWeek,
        onRequestClose: this.handleRequestClose,
        onRequestInternalFocusDate: this.props.onRequestInternalFocusDate,
        onSelectDate: this.handleSelectDate,
        selectedDate: this.props.selectedDate,
        selectedDateRef: this.props.selectedDateRef,
        todayLabel: this.props.todayLabel
      })); // create new weeks

      firstDayOfWeek = __WEBPACK_IMPORTED_MODULE_4__utilities_date__["a" /* default */].addWeeks(firstDayOfWeek, 1);
      done = count > 2 && monthIndex !== firstDayOfWeek.getMonth();
      count += 1;
      monthIndex = firstDayOfWeek.getMonth();
    }

    var extraWeeks = 0;

    while (weeks.length < 6) {
      extraWeeks += 1;
      weeks.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", {
        key: "extra_".concat(extraWeeks),
        className: "week"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", {
        "aria-disabled": "true",
        "aria-selected": "false",
        className: "slds-disabled-text"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "slds-day "
      }, "\xA0"))));
    }

    return weeks;
  },
  render: function render() {
    var _this = this;

    var sunday = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("abbr", {
      title: this.props.weekDayLabels[0]
    }, this.props.abbreviatedWeekDayLabels[0]));
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "calendar"
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table", {
      className: "datepicker__month",
      role: "grid",
      "aria-labelledby": "".concat(this.props.id, "-month")
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, this.props.isIsoWeekday ? null : sunday, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", {
      scope: "col"
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("abbr", {
      title: this.props.weekDayLabels[1]
    }, this.props.abbreviatedWeekDayLabels[1])), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", {
      scope: "col"
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("abbr", {
      title: this.props.weekDayLabels[2]
    }, this.props.abbreviatedWeekDayLabels[2])), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", {
      scope: "col"
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("abbr", {
      title: this.props.weekDayLabels[3]
    }, this.props.abbreviatedWeekDayLabels[3])), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", {
      scope: "col"
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("abbr", {
      title: this.props.weekDayLabels[4]
    }, this.props.abbreviatedWeekDayLabels[4])), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", {
      scope: "col"
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("abbr", {
      title: this.props.weekDayLabels[5]
    }, this.props.abbreviatedWeekDayLabels[5])), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th", {
      scope: "col"
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("abbr", {
      title: this.props.weekDayLabels[6]
    }, this.props.abbreviatedWeekDayLabels[6])), this.props.isIsoWeekday && sunday)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody", null, this.renderWeeks(), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", {
      colSpan: "7",
      role: "gridcell"
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
      href: "javascript:void(0)" // eslint-disable-line no-script-url
      ,
      tabIndex: "0",
      className: "slds-show--inline-block slds-p-bottom--x-small",
      onClick: function onClick(event) {
        _this.handleSelectDate(event, {
          date: new Date()
        });
      },
      onKeyDown: this.props.onLastFocusableNodeKeyDown,
      ref: this.props.todayRef
    }, this.props.todayLabel))))));
  }
});
/* harmony default export */ __webpack_exports__["a"] = (DatepickerCalendar);
//# sourceMappingURL=calendar.js.map

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__day__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_date__ = __webpack_require__(41);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */





var DatepickerWeek = function DatepickerWeek(props) {
  var days = [];
  var date = props.firstDayOfWeek;

  for (var i = 0; i < 7; i += 1) {
    days.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__day__["a" /* default */], {
      calendarHasFocus: props.calendarHasFocus,
      date: date,
      disabled: props.dateDisabled({
        date: date
      }),
      focusedDate: props.focusedDate,
      initialDateForCalendarRender: props.initialDateForCalendarRender,
      key: date.toString(),
      onKeyboardNavigateToNextDay: props.onKeyboardNavigateToNextDay,
      onKeyboardNavigateToNextWeek: props.onKeyboardNavigateToNextWeek,
      onKeyboardNavigateToPreviousDay: props.onKeyboardNavigateToPreviousDay,
      onKeyboardNavigateToPreviousWeek: props.onKeyboardNavigateToPreviousWeek,
      onCalendarBlur: props.onCalendarBlur,
      onRequestInternalFocusDate: props.onRequestInternalFocusDate,
      onSelectDate: props.onSelectDate,
      selectedDate: props.selectedDate,
      selectedDateRef: props.selectedDateRef,
      todayLabel: props.todayLabel
    }));
    date = __WEBPACK_IMPORTED_MODULE_3__utilities_date__["a" /* default */].addDays(date, 1);
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr", {
    className: "week",
    key: days[0].toString()
  }, days);
};

DatepickerWeek.propTypes = {
  /**
   * Date used to create calendar that is displayed. This is typically the initial day focused when using the keyboard navigation. Focus will be set to this date if available.
   */
  initialDateForCalendarRender: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Date).isRequired,

  /**
   * Is true if calendar day has focus.
   */
  calendarHasFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,

  /**
   * dateDisabled() takes a date as input argument, returns true if given date should be disabled, otherwise returns false.
   */
  dateDisabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * First day of week.
   */
  firstDayOfWeek: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Date).isRequired,

  /**
   * Date that has focus.
   */
  focusedDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Date).isRequired,

  /**
   * Triggered when the keyboard moves focus off the calendar.
   */
  onCalendarBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,

  /**
   * For keyboard navigation. Changes the focus to the next day on the calendar. Triggered when right arrow button is pressed.
   */
  onKeyboardNavigateToNextDay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,

  /**
   * For keyboard navigation. Changes the focus to the same day in the next week on the calendar. Triggered when down arrow button is pressed.
   */
  onKeyboardNavigateToNextWeek: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,

  /**
   * For keyboard navigation. Changes the focus to the previous day on the calendar. Triggered when left arrow button is pressed.
   */
  onKeyboardNavigateToPreviousDay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,

  /**
   * For keyboard navigation. Changes the focus to the same day in the previous week on the calendar. Triggered when up arrow button is pressed.
   */
  onKeyboardNavigateToPreviousWeek: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,

  /**
   * Triggered when the user wants to focus on a new day witht he keyboard. It returns the keyboard event a data object with the shape: `{date: [Date object]}`. Keyboard event is ommited if a new month is rendered.  _Tested with Mocha framework._
   */
  onRequestInternalFocusDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,

  /**
   * Triggered when a date on the calendar is clicked.
   */
  onSelectDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,

  /**
   * Currently selected date. This should be present in the input field.
   */
  selectedDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Date).isRequired,

  /**
   * Component reference / DOM node for selected day.
   */
  selectedDateRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,

  /**
   * Label of shortcut to jump to today within the calendar. Also used for assistive text for the current day.
   */
  todayLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};
DatepickerWeek.displayName = 'SLDSDatepickerWeek';
/* harmony default export */ __webpack_exports__["a"] = (DatepickerWeek);
//# sourceMappingURL=week.js.map

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_event__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_date__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_key_code__ = __webpack_require__(8);
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

 // ### classNames
// [github.com/JedWatson/classnames](https://github.com/JedWatson/classnames)
// This project uses `classnames`, "a simple javascript utility for conditionally
// joining classNames together."






var handleClick = function handleClick(event, _ref) {
  var date = _ref.date,
      onSelectDate = _ref.onSelectDate;
  onSelectDate(event, {
    date: date
  });
};

var handleKeyDown = function handleKeyDown(event, _ref2) {
  var _keyDownCallbacks;

  var date = _ref2.date,
      onCalendarBlur = _ref2.onCalendarBlur,
      onSelectDate = _ref2.onSelectDate,
      onKeyboardNavigateToPreviousDay = _ref2.onKeyboardNavigateToPreviousDay,
      onKeyboardNavigateToNextDay = _ref2.onKeyboardNavigateToNextDay,
      onKeyboardNavigateToPreviousWeek = _ref2.onKeyboardNavigateToPreviousWeek,
      onKeyboardNavigateToNextWeek = _ref2.onKeyboardNavigateToNextWeek;
  var keyDownCallbacks = (_keyDownCallbacks = {}, _defineProperty(_keyDownCallbacks, __WEBPACK_IMPORTED_MODULE_5__utilities_key_code__["a" /* default */].SPACE, function () {
    onSelectDate(event, {
      date: date
    });
  }), _defineProperty(_keyDownCallbacks, __WEBPACK_IMPORTED_MODULE_5__utilities_key_code__["a" /* default */].ENTER, function () {
    onSelectDate(event, {
      date: date
    });
  }), _defineProperty(_keyDownCallbacks, __WEBPACK_IMPORTED_MODULE_5__utilities_key_code__["a" /* default */].TAB, function () {
    onCalendarBlur(event, {
      direction: 'next'
    });
  }), _defineProperty(_keyDownCallbacks, __WEBPACK_IMPORTED_MODULE_5__utilities_key_code__["a" /* default */].LEFT, function () {
    onKeyboardNavigateToPreviousDay(event, {
      date: date
    });
  }), _defineProperty(_keyDownCallbacks, __WEBPACK_IMPORTED_MODULE_5__utilities_key_code__["a" /* default */].RIGHT, function () {
    onKeyboardNavigateToNextDay(event, {
      date: date
    });
  }), _defineProperty(_keyDownCallbacks, __WEBPACK_IMPORTED_MODULE_5__utilities_key_code__["a" /* default */].UP, function () {
    onKeyboardNavigateToPreviousWeek(event, {
      date: date
    });
  }), _defineProperty(_keyDownCallbacks, __WEBPACK_IMPORTED_MODULE_5__utilities_key_code__["a" /* default */].DOWN, function () {
    onKeyboardNavigateToNextWeek(event, {
      date: date
    });
  }), _keyDownCallbacks);

  var shiftKeyDownCallbacks = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_5__utilities_key_code__["a" /* default */].TAB, function () {
    onCalendarBlur(event, {
      direction: 'previous'
    });
  });

  if (event.keyCode) {
    if (event.shiftKey && keyDownCallbacks[event.keyCode]) {
      __WEBPACK_IMPORTED_MODULE_3__utilities_event__["a" /* default */].trapEvent(event);
      shiftKeyDownCallbacks[event.keyCode]();
    } else if (keyDownCallbacks[event.keyCode]) {
      __WEBPACK_IMPORTED_MODULE_3__utilities_event__["a" /* default */].trapEvent(event);
      keyDownCallbacks[event.keyCode]();
    }
  }
};

var DatepickerCalendarDay = function DatepickerCalendarDay(props) {
  var isCurrentMonth = __WEBPACK_IMPORTED_MODULE_4__utilities_date__["a" /* default */].isSameMonth(props.date, props.initialDateForCalendarRender);
  var isToday = __WEBPACK_IMPORTED_MODULE_4__utilities_date__["a" /* default */].isToday(props.date);
  var isSelectedDay = __WEBPACK_IMPORTED_MODULE_4__utilities_date__["a" /* default */].isSameDay(props.date, props.selectedDate);
  var isFirstDayOfMonth = __WEBPACK_IMPORTED_MODULE_4__utilities_date__["a" /* default */].isFirstDayOfMonth(props.date);
  var isDisabled = !isCurrentMonth || props.disabled;
  return (
    /* eslint-disable jsx-a11y/no-static-element-interactions */
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td", {
      "aria-disabled": isDisabled,
      "aria-selected": isSelectedDay,
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
        'slds-is-today': isToday,
        'slds-disabled-text': isDisabled,
        'slds-is-selected': isSelectedDay
      }),
      onClick: function onClick(event) {
        handleClick(event, {
          date: props.date,
          onSelectDate: props.onSelectDate
        });
      },
      onKeyDown: function onKeyDown(event) {
        handleKeyDown(event, _objectSpread({}, props));
      },
      ref: function ref(component) {
        if (isSelectedDay) {
          props.selectedDateRef(component);
        }

        if (props.calendarHasFocus && __WEBPACK_IMPORTED_MODULE_4__utilities_date__["a" /* default */].isSameDay(props.focusedDate, props.date) && isCurrentMonth) {
          props.onRequestInternalFocusDate(undefined, {
            date: props.date,
            ref: component
          });
        }
      },
      role: "gridcell",
      tabIndex: !props.calendarHasFocus && isFirstDayOfMonth && isCurrentMonth ? 0 : -1
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: "slds-day"
    }, isToday ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: "slds-assistive-text"
    }, props.todayLabel, ": ") : null, props.date.getDate()))
  );
};

DatepickerCalendarDay.displayName = 'SLDSDatepickerCalendarDay';
DatepickerCalendarDay.propTypes = {
  /**
   * If elements within the calendar have focus. This is helpful for keyboard event trapping.
   */
  calendarHasFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,

  /**
   * Date of day
   */
  date: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Date).isRequired,

  /**
   * If date is disabled
   */
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Date used to create calendar that is displayed. This is typically the initial day focused when using the keyboard navigation. Focus will be set to this date if available.
   */
  initialDateForCalendarRender: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Date).isRequired,

  /**
   * Triggered when the keyboard moves focus off the calendar.
   */
  onCalendarBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,

  /**
   * For keyboard navigation. Changes the focus to the next day on the calendar. Triggered when right arrow button is pressed.
   */
  onKeyboardNavigateToNextDay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,

  /**
   * For keyboard navigation. Changes the focus to the same day in the next week on the calendar. Triggered when down arrow button is pressed.
   */
  onKeyboardNavigateToNextWeek: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,

  /**
   * For keyboard navigation. Changes the focus to the previous day on the calendar. Triggered when left arrow button is pressed.
   */
  onKeyboardNavigateToPreviousDay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,

  /**
   * For keyboard navigation. Changes the focus to the same day in the previous week on the calendar. Triggered when up arrow button is pressed.
   */
  onKeyboardNavigateToPreviousWeek: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,

  /**
   * Triggered when a date on the calendar is clicked.
   */
  onSelectDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,

  /**
   * Currently selected date. This should be present in the input field.
   */
  selectedDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Date).isRequired,

  /**
   * Component reference / DOM node for selected day.
   */
  selectedDateRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,

  /**
   * Label of shortcut to jump to today within the calendar. Also used for assistive text for the current day.
   */
  todayLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  focusedDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Date),
  onRequestInternalFocusDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
/* harmony default export */ __webpack_exports__["a"] = (DatepickerCalendarDay);
//# sourceMappingURL=day.js.map

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__year_picklist__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_date__ = __webpack_require__(41);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */






var DatepickerMonthNavigation = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'SLDSDatepickerMonthNavigation',
  propTypes: {
    /**
     * Label for button to go to the next month
     */
    assistiveTextNextMonth: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,

    /**
     * Label for button to go to the previous month
     */
    assistiveTextPreviousMonth: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,

    /**
     * HTML id for component
     */
    id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * Date used to create calendar that is displayed. This is typically the initial day focused when using the keyboard navigation. Focus will be set to this date if available.
     */
    initialDateForCalendarRender: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(Date).isRequired,

    /**
     * Displayed calendar has changed or re-rendered
     */
    onChangeMonth: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,

    /**
     * Names of the months
     */
    monthLabels: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired,

    /**
     * For keyboard navigation. In order to trap focus within the dialog, the first DOM node with a tab index should be listened to.
     */
    onPreviousMonthKeyDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Callback that passes in the DOM reference of the `<button>` DOM node within this component. Primary use is to allow `focus` to be called. You should still test if the node exists, since rendering is asynchronous.
     */
    previousMonthRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,

    /**
     * Offset of year from current year that can be selected in the year selection dropdown. (2017 - 5 = 2012).
     */
    relativeYearFrom: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,

    /**
     * Offset of year from current year that can be selected in the year selection dropdown. (2017 + 5 = 2012).
     */
    relativeYearTo: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number
  },
  getMonthLabel: function getMonthLabel() {
    return this.props.monthLabels[new Date(this.props.initialDateForCalendarRender).getMonth()];
  },
  getYearLabel: function getYearLabel() {
    return new Date(this.props.initialDateForCalendarRender).getFullYear();
  },
  handleClick: function handleClick(event) {
    event.preventDefault();
    event.stopPropagation();
  },
  handleYearSelect: function handleYearSelect(initialDateForCalendarRender) {
    this.props.onChangeMonth(undefined, initialDateForCalendarRender);
  },
  previousMonthClicked: function previousMonthClicked() {
    this.props.onChangeMonth(undefined, __WEBPACK_IMPORTED_MODULE_5__utilities_date__["a" /* default */].addMonths(this.props.initialDateForCalendarRender, -1));
  },
  nextMonthClicked: function nextMonthClicked() {
    this.props.onChangeMonth(undefined, __WEBPACK_IMPORTED_MODULE_5__utilities_date__["a" /* default */].addMonths(this.props.initialDateForCalendarRender, 1));
  },
  render: function render() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "slds-datepicker__filter slds-grid"
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "slds-datepicker__filter--month slds-grid slds-grid--align-spread slds-grow",
      style: {
        flex: 1.75
      }
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "slds-align-middle"
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__button__["a" /* default */], {
      assistiveText: {
        icon: this.props.assistiveTextPreviousMonth
      },
      iconCategory: "utility",
      iconName: "left",
      iconVariant: "container",
      onKeyDown: this.props.onPreviousMonthKeyDown,
      onClick: this.previousMonthClicked,
      buttonRef: function buttonRef(component) {
        _this.props.previousMonthRef(component);
      },
      variant: "icon",
      type: "button"
    })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", {
      id: "".concat(this.props.id, "-month"),
      className: "slds-align-middle",
      "aria-live": "assertive",
      "aria-atomic": true
    }, this.getMonthLabel(), ' ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: "slds-assistive-text"
    }, this.getYearLabel())), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "slds-align-middle"
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__button__["a" /* default */], {
      assistiveText: {
        icon: this.props.assistiveTextNextMonth
      },
      iconCategory: "utility",
      iconName: "right",
      iconVariant: "container",
      onClick: this.nextMonthClicked,
      variant: "icon",
      type: "button"
    }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__year_picklist__["a" /* default */], {
      id: this.props.id,
      initialDateForCalendarRender: this.props.initialDateForCalendarRender,
      onChangeMonth: this.handleYearSelect,
      relativeYearFrom: this.props.relativeYearFrom,
      relativeYearTo: this.props.relativeYearTo
    }));
  }
});
/* harmony default export */ __webpack_exports__["a"] = (DatepickerMonthNavigation);
//# sourceMappingURL=navigation.js.map

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__combobox_combobox__ = __webpack_require__(97);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */




var DatepickerYearSelector = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'SLDSDatepickerYearSelector',
  propTypes: {
    /**
     * HTML id for component
     */
    id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * Date used to create calendar that is displayed. This is typically the initial day focused when using the keyboard navigation. Focus will be set to this date if available.
     */
    initialDateForCalendarRender: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(Date).isRequired,

    /**
     * Displayed calendar has changed or re-rendered
     */
    onChangeMonth: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,

    /**
     * Offset of year from current year that can be selected in the year selection dropdown. (2017 - 5 = 2012).
     */
    relativeYearFrom: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,

    /**
     * Offset of year from current year that can be selected in the year selection dropdown. (2017 + 5 = 2012).
     */
    relativeYearTo: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,

    /**
     * Callback that passes in the DOM reference of the `<button>` DOM node within this component. Primary use is to allow `focus` to be called. You should still test if the node exists, since rendering is asynchronous. `buttonRef={(component) => { if(component) console.log(component); }}`
     */
    yearPicklistButtonRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
  },
  getOptions: function getOptions() {
    var now = new Date();
    var fromYear = now.getFullYear() + this.props.relativeYearFrom;
    var toYear = now.getFullYear() + this.props.relativeYearTo;
    var opts = [];

    for (var year = fromYear; year < toYear; year += 1) {
      opts.push({
        label: "".concat(year),
        value: year,
        id: String(opts.length)
      });
    }

    return opts;
  },
  getSelectedValueOption: function getSelectedValueOption() {
    var selectedYear = this.props.initialDateForCalendarRender.getFullYear();
    return this.getOptions().filter(function (option) {
      return option.value === selectedYear;
    });
  },
  handleSelect: function handleSelect(event, _ref) {
    var selectedValues = _ref.selection;
    var selectedValue = selectedValues[0]; // safe since we are working with a single selection

    if (selectedValue) {
      this.props.onChangeMonth(new Date(this.props.initialDateForCalendarRender.setFullYear(parseInt(selectedValue.value, 10))));
    }
  },
  render: function render() {
    var selection = this.getSelectedValueOption();
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "slds-form-element slds-align-content-center"
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__combobox_combobox__["a" /* default */], {
      className: "slds-shrink-none",
      classNameMenu: "slds-datepicker",
      events: {
        onSelect: this.handleSelect
      },
      id: "".concat(this.props.id, "-year-picklist"),
      inheritWidthOf: "target",
      menuPosition: "relative",
      multiple: false,
      options: this.getOptions(),
      labels: {
        placeholder: 'Year'
      },
      selection: selection,
      value: selection.value,
      variant: "readonly"
    }));
  }
});
/* harmony default export */ __webpack_exports__["a"] = (DatepickerYearSelector);
//# sourceMappingURL=year-picklist.js.map

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_warning_deprecated_property__ = __webpack_require__(14);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable import/no-mutable-exports */

/* eslint-disable  max-len */


var checkProps = function checkProps() {};

if (false) {
  checkProps = function checkProps(COMPONENT, props) {
    deprecatedProperty(COMPONENT, props.onFocus, 'onFocus', undefined, 'Please see children prop description and add your own `Input` with this prop as a child of Datepicker.');
    deprecatedProperty(COMPONENT, props.onBlur, 'onBlur', undefined, 'Please see children prop description and add your own `Input` with this prop as a child of Datepicker.');
    deprecatedProperty(COMPONENT, props.onFocus, 'abbrWeekDayLabels', 'abbreviatedWeekDayLabels', 'Prop name has changed.');
    deprecatedProperty(COMPONENT, props.onFocus, 'onDateChange', 'onChange', 'Please see prop description for `onChange`. Parameters have changed. The callback recieves an event and a data object of the shape: `{date: [Date object], formattedDate: [string], timezoneOffset: [number]}`');
    deprecatedProperty(COMPONENT, props.onFocus, 'onKeyDown', undefined, 'Please see children prop description and add your own `Input` as a child of Datepicker.');
    deprecatedProperty(COMPONENT, props.onFocus, 'required', undefined, 'Please see children prop description and add your own `Input` as a child of Datepicker.');
    deprecatedProperty(COMPONENT, props.strValue, 'strValue', 'formattedValue');
    deprecatedProperty(COMPONENT, props.isInline, 'isInline', 'menuPosition="relative"');
  };
}

/* harmony default export */ __webpack_exports__["a"] = (checkProps);
//# sourceMappingURL=check-props.js.map

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_warning_one_of_required_property__ = __webpack_require__(40);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable import/no-mutable-exports */

/* import deprecatedPropertyValue from '../../utilities/warning/deprecated-property-value'; */

var checkProps = function checkProps() {};

if (false) {
  checkProps = function checkProps(COMPONENT, props) {
    /**
     * If illustration SVGs are added to SLDS in the future, we will deprecate the value
     * of internalIllustration being true and give a warning.
     *
    if (props.internalIllustration) {
    		deprecatedPropertyValue(COMPONENT, {
    			propAsString: 'internalIllustration',
    			propValue: props.internalIllustration,
    			deprecatedPropValue: true,
    			replacementPropAsValue: false,
    		},
    		'Using illustration SVGs from inside this repo is deprecated. Please update your assets/images path to use the SVGs found in the @salesforce/design-system npm module.');
    	}
     */
    if (props.illustration || props.path) {
      // An illustration image must be accompanied with a heading text
      oneOfRequiredProperty(COMPONENT, {
        heading: props.heading
      });
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (checkProps);
//# sourceMappingURL=check-props.js.map

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_warning_component_is_prototype__ = __webpack_require__(56);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable import/no-mutable-exports */


var checkProps = function checkProps() {};

if (false) {
  checkProps = function checkProps(COMPONENT) {
    isPrototype(COMPONENT);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (checkProps);
//# sourceMappingURL=check-props.js.map

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PopoverNubbinPositions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isboolean__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isboolean___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isboolean__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isfunction__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isfunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_isfunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shortid__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shortid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_shortid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__check_props__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utilities_dialog__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utilities_keyboard_navigable_dialog__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utilities_key_code__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utilities_constants__ = __webpack_require__(2);
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// # Popver Component
// Implements the [Popover design pattern](https://www.lightningdesignsystem.com/components/popovers) in React.
// ### React


 // ### classNames
// [github.com/JedWatson/classnames](https://github.com/JedWatson/classnames)
// This project uses `classnames`, "a simple javascript utility for conditionally
// joining classNames together."

 // ### isBoolean

 // ### isFunction

 // ### shortid
// [npmjs.com/package/shortid](https://www.npmjs.com/package/shortid)
// shortid is a short, non-sequential, url-friendly, unique id generator

 // This component's `checkProps` which issues warnings to developers about properties when in development mode (similar to React's built in development tools)


 // ### Children

 // #### KeyboardNavigable




var documentDefined = typeof document !== 'undefined'; // The overlay is an optional way to allow the popover to close on outside
// clicks even when those clicks are over areas that wouldn't normally fire
// click or touch events (for example, iframes). A single overlay is shared
// between all popovers in the app.

var overlay = documentDefined ? document.createElement('span') : {
  style: {}
};
overlay.style.top = 0;
overlay.style.left = 0;
overlay.style.width = '100%';
overlay.style.height = '100%';
overlay.style.position = 'absolute';
var currentOpenPopover; // FIXME - what is this exported for? Probably needs to be deprecated.

var PopoverNubbinPositions = ['top left', 'top', 'top right', 'bottom left', 'bottom', 'bottom right'];
var defaultProps = {
  align: 'right',
  assistiveText: {
    closeButton: 'Close dialog'
  },
  hoverCloseDelay: 300,
  openOn: 'click',
  position: 'absolute'
};
/**
 * The Popover component is a non-modal dialog. It should be paired with a clickable trigger such as a `Button`. It traps focus from the page and must be exited if focus needs to be outside the Popover. Use a `Tooltip` if there are no call to actions within the dialog. A `Tooltip` does not need to be clicked. Multiple popovers open at the same time, each with focus trap is not supported.
 */

var Popover = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  // ### Display Name
  // Always use the canonical component name as the React display name.
  displayName: __WEBPACK_IMPORTED_MODULE_12__utilities_constants__["_7" /* POPOVER */],
  // ### Prop Types
  propTypes: {
    /**
     * Aligns the popover with the respective side of the trigger. That is `top` will place the `Popover` above the trigger.
     */
    align: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['top', 'top left', 'top right', 'right', 'right top', 'right bottom', 'bottom', 'bottom left', 'bottom right', 'left', 'left top', 'left bottom']),

    /**
     * **Assistive text for accessibility.**
     * This object is merged with the default props object on every render.
     * * `closeButton`: This is a visually hidden label for the close button.
     */
    assistiveText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
      closeButton: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
    }),

    /**
     * HTML `id` of heading for popover. Only use if your header is within your popover body.
     */
    ariaLabelledby: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * The trigger of the component. This must be a **single node**. Many props will be passed into this trigger related to popover interactions. The child needs to be a clickable element, such as a `Button` or an anchor tag (`a`).
     */
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node.isRequired,

    /**
     * The contents of the popover. This should also accept arrays.
     */
    body: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array]).isRequired,

    /**
     * CSS classes to be added to the popover. That is the element with `.slds-popover` on it.
     */
    className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),

    /**
     * This prop is passed onto the triggering `Button`. Prevent popover from opening. Also applies disabled styling to trigger button.
     */
    disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * A footer is an optional. Buttons are often placed here.
     */
    footer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,

    /**
     * Prevents the Popover from changing position based on the viewport/window. If set to true your popover can extend outside the viewport _and_ overflow outside of a scrolling parent. If this happens, you might want to consider making the popover contents scrollable to fit the menu on the screen. When enabled, `position` `absolute` is used.
     */
    hasStaticAlignment: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * All popovers require a heading that labels the popover for assistive technology users. This text will be placed within a heading HTML tag. A heading is **highly recommended for accessibility reasons.** Please see `ariaLabelledby` prop.
     */
    heading: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),

    /**
     * By default, a unique ID will be created at render to support keyboard navigation, ARIA roles, and connect the popover to the triggering button. This ID will be applied to the triggering element. `${id}-popover`, `${id}-dialog-heading`, `${id}-dialog-body` are also created.
     */
    id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * Forces the popover to be open or closed. See controlled/uncontrolled callback/prop pattern for more on suggested use [](https://github.com/salesforce-ux/design-system-react/blob/master/CONTRIBUTING.md#concepts-and-best-practices) You will want this if Popover is to be a controlled component.
     */
    isOpen: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * This function is passed onto the triggering `Button`. Triggered when the trigger button is clicked. You will want this if Popover is to be a controlled component.
     */
    onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * This function is triggered when the dialog is closed. This occurs when the Dialog child component (that is the actual popover) is unmounted and removed from the DOM. This function returns `{event, { trigger, componentWillUnmount }`. Trigger can have the values `cancel`, `clickOutside`, or `newPopover`.
     */
    onClose: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Called when a key is pressed.
     */
    onKeyDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Called when mouse clicks down on the trigger button.
     */
    onMouseDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * This function is triggered when the Dialog child component (that is the actual popover) is mounted and added to the DOM. The parameters are `event, { portal: }`. `portal` can be used as a React tree root node.
     */
    onOpen: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * This function is triggered when the user clicks outside the Popover or clicks the close button. You will want to define this if Popover is to be a controlled component. Most of the time you will want wnat to set `isOpen` to `false` when this is triggered unless you need to validate something.
     */
    onRequestClose: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Please select one of the following:
     * * `absolute` - (default) The dialog will use `position: absolute` and style attributes to position itself. This allows inverted placement or flipping of the dialog.
     * * `overflowBoundaryElement` - The dialog will overflow scrolling parents. Use on elements that are aligned to the left or right of their target and don't care about the target being within a scrolling parent. Typically this is a popover or tooltip. Dropdown menus can usually open up and down if no room exists. In order to achieve this a portal element will be created and attached to `body`. This element will render into that detached render tree.
     * * `relative` - No styling or portals will be used. Menus will be positioned relative to their triggers. This is a great choice for HTML snapshot testing.
     */
    position: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['absolute', 'overflowBoundaryElement', 'relative']),

    /**
     * An object of CSS styles that are applied to the `slds-popover` DOM element.
     */
    style: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,

    /**
     * If `true`, adds a transparent overlay when the menu is open to handle outside clicks. Allows clicks on iframes to be captured, but also forces a double-click to interact with other elements. If a function is passed, custom overlay logic may be defined by the app.
     */
    overlay: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func]),

    /**
     * CSS classes to be added to wrapping trigger `div` around the button.
     */
    triggerClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string])
  },
  getDefaultProps: function getDefaultProps() {
    return defaultProps;
  },
  getInitialState: function getInitialState() {
    return {
      isOpen: false
    };
  },
  componentWillMount: function componentWillMount() {
    this.generatedId = __WEBPACK_IMPORTED_MODULE_6_shortid___default.a.generate(); // `checkProps` issues warnings to developers about properties (similar to React's built in development tools)

    Object(__WEBPACK_IMPORTED_MODULE_7__check_props__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_12__utilities_constants__["_7" /* POPOVER */], this.props);
  },
  componentWillUnmount: function componentWillUnmount() {
    if (currentOpenPopover === this) {
      currentOpenPopover = undefined;
    }

    this.isUnmounting = true;
    this.renderOverlay(false);
  },
  getId: function getId() {
    return this.props.id || this.generatedId;
  },
  getIsOpen: function getIsOpen() {
    return !this.props.disabled && !!(__WEBPACK_IMPORTED_MODULE_4_lodash_isboolean___default()(this.props.isOpen) ? this.props.isOpen : this.state.isOpen);
  },
  getMenu: function getMenu() {
    // needed by keyboard navigation
    return this.dialog;
  },
  setMenuRef: function setMenuRef(component) {
    this.dialog = component;
  },
  setContainerRef: function setContainerRef(component) {
    this.trigger = component; // yes, this is a re-render triggered by a render.
    // Dialog/Popper.js cannot place the popover until
    // the trigger/target DOM node is mounted. This
    // way `findDOMNode` is not called and parent
    // DOM nodes are not queried.

    if (!this.state.inputRendered) {
      this.setState({
        inputRendered: true
      });
    }
  },
  handleDialogClose: function handleDialogClose(event, data) {
    var componentWillUnmount = data && data.componentWillUnmount || false;

    if (currentOpenPopover === this) {
      currentOpenPopover = undefined;
    }

    if (this.props.onClose) {
      this.props.onClose(event, {
        // Breaking change: component object reference has been
        // removed (`this`), due to endless loop creation.
        componentWillUnmount: componentWillUnmount
      });
    }
  },
  handleClose: function handleClose(event, data) {
    var isOpen = this.getIsOpen();

    if (isOpen) {
      // call even if closed
      if (this.props.onRequestClose) {
        this.props.onRequestClose(event, data);
      }

      if (currentOpenPopover === this) {
        currentOpenPopover = undefined;
      }

      this.setState({
        isOpen: false
      });
      this.isHover = false;
    }
  },
  handleOpen: function handleOpen() {
    var isOpen = this.getIsOpen();

    if (!isOpen) {
      if (currentOpenPopover && __WEBPACK_IMPORTED_MODULE_5_lodash_isfunction___default()(currentOpenPopover.handleClose)) {
        currentOpenPopover.handleClose(undefined, {
          trigger: 'newPopover',
          id: currentOpenPopover.getId()
        });
      }

      currentOpenPopover = this;
      this.setState({
        isOpen: true
      });
    }
  },

  /* props.openOn is not a part of prop-types because it is not a supported feature, but may be needed for backwards compatibility with non-accessible dropdown/popover hybrids. */

  /* eslint-disable react/prop-types */
  handleMouseEnter: function handleMouseEnter(event) {
    var isOpen = this.getIsOpen();
    this.isHover = true;

    if (!isOpen && this.props.openOn === 'hover') {
      this.handleOpen();
    } else {
      // we want this clear when openOn is hover or hybrid
      clearTimeout(this.isClosing);
    }

    if (this.props.onMouseEnter) {
      this.props.onMouseEnter(event);
    }
  },
  handleMouseLeave: function handleMouseLeave(event) {
    var _this = this;

    var isOpen = this.getIsOpen();

    if (isOpen) {
      this.isClosing = setTimeout(function () {
        _this.handleClose();
      }, this.props.hoverCloseDelay);
    }

    if (this.props.onMouseLeave) {
      this.props.onMouseLeave(event);
    }
  },

  /* eslint-enable react/prop-types */
  handleClick: function handleClick(event, _ref) {
    var triggerOnClickCallback = _ref.triggerOnClickCallback;
    var isOpen = this.getIsOpen();

    if (!isOpen) {
      this.handleOpen();
    } else {
      this.handleClose();
    }

    if (this.props.onClick) {
      this.props.onClick(event);
    }

    if (triggerOnClickCallback) {
      triggerOnClickCallback(event);
    }
  },
  handleFocus: function handleFocus(event) {
    var isOpen = this.getIsOpen();

    if (!isOpen) {
      this.handleOpen();
    }

    if (this.props.onFocus) {
      this.props.onFocus(event);
    }
  },
  handleKeyDown: function handleKeyDown(event) {
    if (event.keyCode) {
      if (event.keyCode !== __WEBPACK_IMPORTED_MODULE_11__utilities_key_code__["a" /* default */].TAB) {
        var isOpen = this.getIsOpen();
        Object(__WEBPACK_IMPORTED_MODULE_10__utilities_keyboard_navigable_dialog__["a" /* default */])({
          event: event,
          isOpen: isOpen,
          handleClick: this.handleClick,
          key: event.key,
          keyCode: event.keyCode,
          targetTarget: event.target,
          toggleOpen: this.toggleOpenFromKeyboard,
          trigger: this.trigger
        });
      }

      if (this.props.onKeyDown) {
        this.props.onKeyDown(event);
      }
    }
  },
  handleCancel: function handleCancel(event) {
    this.handleClose(event, {
      trigger: 'cancel'
    });
  },
  handleClickOutside: function handleClickOutside(event) {
    this.handleClose(event, {
      trigger: 'clickOutside'
    });
  },
  toggleOpenFromKeyboard: function toggleOpenFromKeyboard(event) {
    var isOpen = this.getIsOpen();

    if (isOpen) {
      this.handleCancel(event);
    } else {
      this.handleOpen();
    }
  },
  renderDialog: function renderDialog(isOpen, outsideClickIgnoreClass) {
    var _this2 = this;

    var props = this.props;
    var offset = props.offset;

    var assistiveText = _objectSpread({}, defaultProps.assistiveText, this.props.assistiveText);

    var closeButtonAssistiveText = props.closeButtonAssistiveText || assistiveText.closeButton;
    return isOpen ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__utilities_dialog__["a" /* default */], {
      hasNubbin: true,
      align: props.align,
      contentsClassName: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(this.props.contentsClassName, 'ignore-react-onclickoutside', 'slds-popover', props.className),
      context: this.context,
      hasStaticAlignment: props.hasStaticAlignment,
      offset: offset,
      onCancel: this.handleClose,
      onClose: this.handleDialogClose,
      onOpen: this.props.onOpen,
      onKeyDown: this.handleKeyDown,
      onMouseEnter: props.openOn === 'hover' ? this.handleMouseEnter : null,
      onMouseLeave: props.openOn === 'hover' ? this.handleMouseLeave : null,
      outsideClickIgnoreClass: outsideClickIgnoreClass,
      onRequestTargetElement: function onRequestTargetElement() {
        return _this2.trigger;
      },
      position: this.props.position,
      style: this.props.style,
      variant: "popover",
      ref: this.setMenuRef,
      containerProps: {
        id: "".concat(this.getId(), "-popover"),
        'aria-labelledby': this.props.ariaLabelledby || "".concat(this.getId(), "-dialog-heading"),
        'aria-describedby': "".concat(this.getId(), "-dialog-body")
      }
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__button__["a" /* default */], {
      assistiveText: {
        icon: closeButtonAssistiveText
      },
      iconCategory: "utility",
      iconName: "close",
      iconSize: "small",
      className: "slds-button slds-button--icon-small slds-float--right slds-popover__close slds-button--icon",
      onClick: this.handleCancel,
      variant: "icon"
    }), this.props.heading ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("header", {
      className: "slds-popover__header"
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", {
      id: "".concat(this.getId(), "-dialog-heading"),
      className: "slds-text-heading--small"
    }, this.props.heading)) : null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      id: "".concat(this.getId(), "-dialog-body"),
      className: "slds-popover__body"
    }, props.body), this.props.footer ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("footer", {
      className: "slds-popover__footer"
    }, this.props.footer) : null) : null;
  },
  renderOverlay: function renderOverlay(isOpen) {
    if (__WEBPACK_IMPORTED_MODULE_5_lodash_isfunction___default()(overlay) && documentDefined) {
      overlay(isOpen, overlay);
    } else if (this.props.overlay && isOpen && !this.overlay && documentDefined) {
      this.overlay = overlay;
      document.querySelector('body').appendChild(this.overlay);
    } else if (!isOpen && this.overlay && this.overlay.parentNode) {
      this.overlay.parentNode.removeChild(this.overlay);
      this.overlay = undefined;
    }
  },
  render: function render() {
    var _this3 = this;

    var outsideClickIgnoreClass = "ignore-click-".concat(this.getId());
    var clonedTrigger = this.props.children ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(this.props.children, _objectSpread({
      id: this.getId(),
      onClick: this.props.openOn === 'click' || this.props.openOn === 'hybrid' ? function (event) {
        _this3.handleClick(event, {
          triggerOnClickCallback: _this3.props.children.props.onClick
        });
      } : this.children.props.onClick,
      onFocus: this.props.openOn === 'hover' ? this.handleFocus : null,
      onMouseDown: this.props.onMouseDown,
      onMouseEnter: this.props.openOn === 'hover' || this.props.openOn === 'hybrid' ? this.handleMouseEnter : null,
      onMouseLeave: this.props.openOn === 'hover' || this.props.openOn === 'hybrid' ? this.handleMouseLeave : null,
      tabIndex: this.props.children.props.tabIndex || '0'
    }, this.props.children.props)) : null;
    this.renderOverlay(this.getIsOpen());
    var containerStyles = {
      display: 'inline-block'
    };
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: this.props.triggerClassName,
      style: containerStyles,
      ref: this.setContainerRef
    }, clonedTrigger, this.renderDialog(this.getIsOpen(), outsideClickIgnoreClass));
  }
});
Popover.contextTypes = {
  iconPath: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};
/* harmony default export */ __webpack_exports__["a"] = (Popover);

//# sourceMappingURL=popover.js.map

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_warning_one_of_required_property__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities_warning_one_of_component__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_warning_deprecated_property__ = __webpack_require__(14);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable import/no-mutable-exports */

/* eslint-disable max-len */




var checkProps = function checkProps() {};

if (false) {
  checkProps = function checkProps(COMPONENT, props) {
    oneOfRequiredProperty(COMPONENT, {
      ariaLabelledby: props.ariaLabelledby,
      heading: props.heading
    });

    if (props.children !== undefined) {
      oneOfComponent(COMPONENT, props, 'children', ['SLDSButton', 'a', 'button']);
    }

    deprecatedProperty(COMPONENT, props.offset, 'offset', undefined, 'The manual setting of positional offset of dialog components has been deemed unreliable. Position logic has been re-written to deliver better and more reliable positioning. Please create an issue if you have an edge case not covered by the built-in logic.');
    deprecatedProperty(COMPONENT, props.isInline, 'isInline', 'position="relative"');
    deprecatedProperty(COMPONENT, props.closeButtonAssistiveText, 'closeButtonAssistiveText', "assistiveText['closeButton']");
  };
}

/* harmony default export */ __webpack_exports__["a"] = (checkProps);
//# sourceMappingURL=check-props.js.map

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__key_code__ = __webpack_require__(8);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// # Assistive Technology / Keyboard Navigable Trait for Dialogs with Tabbable content

/*
 * Guidelines for Popover
 *
 * - Focus is trapped. Tabbing to an index outside of the dialog is not allowed. Popover must be closed first via ESC.
 * - There should always be a focusable element inside, to place user focus on such as a close button
 * - Must be dismissible via ESC and a close button
 * - Uses tabIndex in wrapper and has tabbable items within it despite being outside document flow.
 * - Entire popover receives focus when opened and has a aria-labelledby that points to the header id, so it will read the heading,
 * - Must return focus to trigger after closing.
 * - F6 will allow the user to keep popover open and go back to tabbing in “app-context” instead of “dialog-context.” (not implemented, yet)
 */
// ## Dependencies
// ### React
 // ### Event Helpers


/* eslint-disable react/no-find-dom-node */

var internalHandleClick = function internalHandleClick(_ref) {
  var trigger = _ref.trigger,
      eventTarget = _ref.eventTarget,
      handleClick = _ref.handleClick;

  if (trigger && __WEBPACK_IMPORTED_MODULE_0_react_dom___default.a.findDOMNode(trigger) === eventTarget) {
    // eslint-disable-line react/no-find-dom-node
    handleClick(event);
  }
};

var KeyboardNavigableDialog = function KeyboardNavigableDialog(_ref2) {
  var isOpen = _ref2.isOpen,
      handleClick = _ref2.handleClick,
      keyCode = _ref2.keyCode,
      eventTarget = _ref2.eventTarget,
      trigger = _ref2.trigger,
      toggleOpen = _ref2.toggleOpen;

  switch (keyCode) {
    case __WEBPACK_IMPORTED_MODULE_1__key_code__["a" /* default */].ESCAPE:
      if (isOpen) {
        toggleOpen();
      }

      break;

    case __WEBPACK_IMPORTED_MODULE_1__key_code__["a" /* default */].ENTER:
      if (!isOpen) {
        internalHandleClick({
          trigger: trigger,
          eventTarget: eventTarget,
          handleClick: handleClick
        });
      }

      break;

    default:
      break;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (KeyboardNavigableDialog);
//# sourceMappingURL=keyboard-navigable-dialog.js.map

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__input__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities_warning_component_has_moved__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_constants__ = __webpack_require__(2);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// Alias



Object(__WEBPACK_IMPORTED_MODULE_1__utilities_warning_component_has_moved__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__utilities_constants__["R" /* INPUT */], {
  oldFileLocation: 'components/forms/input',
  newFileLocation: 'components/input'
});
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__input__["a" /* default */]);
//# sourceMappingURL=index.js.map

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_warning_component_is_deprecated__ = __webpack_require__(33);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable import/no-mutable-exports */

/* eslint-disable max-len */


var checkProps = function checkProps() {};

if (false) {
  checkProps = function checkProps(COMPONENT) {
    componentIsDeprecated(COMPONENT, 'For a multiple input form, please use the pattern located at https://www.lightningdesignsystem.com/components/form-element/#Record-Detail that swaps out a read-only `Input` with a base `Input`. For a single input, please use a `Popover` paired with `<Button	category="utility" iconName="edit" variant="icon" />` as the trigger.');
  };
}

/* harmony default export */ __webpack_exports__["a"] = (checkProps);
//# sourceMappingURL=inline-check-props.js.map

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_warning_component_is_deprecated__ = __webpack_require__(33);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable import/no-mutable-exports */


var checkProps = function checkProps() {};

if (false) {
  checkProps = function checkProps(COMPONENT) {
    componentIsDeprecated(COMPONENT, 'Please use an read-only Combobox instead. It is more accessible and closer aligned to SLDS.');
  };
}

/* harmony default export */ __webpack_exports__["a"] = (checkProps);
//# sourceMappingURL=check-props.js.map

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isfunction__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isfunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isfunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_constants__ = __webpack_require__(2);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

 // ### classNames
// [github.com/JedWatson/classnames](https://github.com/JedWatson/classnames)
// This project uses `classnames`, 'a simple javascript utility for conditionally
// joining classNames together.'

 // ### isFunction




var handleClick = function handleClick(event, props) {
  if (__WEBPACK_IMPORTED_MODULE_3_lodash_isfunction___default()(props.onSelect)) {
    props.onSelect(event, {
      item: props.item
    });
  }
};

var Item = function Item(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
      'slds-is-active': props.isSelected
    })
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    "data-id": props.item.id,
    href: props.item.url || 'javascript:void(0);' // eslint-disable-line no-script-url
    ,
    className: "slds-navigation-list--vertical__action slds-text-link--reset",
    "aria-describedby": props.categoryId,
    onClick: function onClick(event) {
      handleClick(event, props);
    }
  }, props.item.label));
}; // ### Display Name
// Always use the canonical component name as the React display name.


Item.displayName = __WEBPACK_IMPORTED_MODULE_4__utilities_constants__["_35" /* VERTICAL_NAVIGATION_ITEM */]; // ### Prop Types

Item.propTypes = {
  /**
   * Item to be rendered.
   */
  item: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    url: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),

  /**
   * Whether item is selected or not.
   */
  isSelected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * ID of the category this item belongs to.
   */
  categoryId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,

  /**
   * Function that will run whenever an item is selected.
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
Item.defaultProps = {
  isSelected: false
};
/* harmony default export */ __webpack_exports__["a"] = (Item);
//# sourceMappingURL=item.js.map

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_warning_component_is_deprecated__ = __webpack_require__(33);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable import/no-mutable-exports */


var checkProps = function checkProps() {};

if (false) {
  checkProps = function checkProps(COMPONENT) {
    componentIsDeprecated(COMPONENT, 'Please use Alert or Toast in the future. Notications is not the same component in SLDS any longer.');
  };
}

/* harmony default export */ __webpack_exports__["a"] = (checkProps);
//# sourceMappingURL=check-props.js.map

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_warning_component_is_prototype__ = __webpack_require__(56);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable import/no-mutable-exports */


var checkProps = function checkProps() {};

if (false) {
  checkProps = function checkProps(COMPONENT) {
    isPrototype(COMPONENT);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (checkProps);
//# sourceMappingURL=check-props.js.map

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_warning_deprecated_property__ = __webpack_require__(14);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable import/no-mutable-exports */


var checkProps = function checkProps() {};

if (false) {
  checkProps = function checkProps(COMPONENT, props) {
    deprecatedProperty(COMPONENT, props.assistiveTextCloseFilterPanel, 'assistiveTextCloseFilterPanel', "assistiveText['closeButton']");
  };
}

/* harmony default export */ __webpack_exports__["a"] = (checkProps);
//# sourceMappingURL=check-props.js.map

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__button__ = __webpack_require__(6);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// # Panel Filter Group Footer
// Implements the [Panel design pattern](https://www.lightningdesignsystem.com/components/panels) in React.
// Based on SLDS v2.2.0-rc.1
// ## Dependencies
// ### React



/**
 * A filtering panel contextual filtering options.
 */

var PanelFilterFooter = function PanelFilterFooter(_ref) {
  var addFilterLabel = _ref.addFilterLabel,
      onClickAdd = _ref.onClickAdd,
      onClickRemoveAll = _ref.onClickRemoveAll,
      removeAllLabel = _ref.removeAllLabel;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "slds-filters__footer slds-grid slds-shrink-none"
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__button__["a" /* default */], {
    label: addFilterLabel,
    onClick: onClickAdd,
    variant: "link"
  }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__button__["a" /* default */], {
    className: "slds-col--bump-left",
    label: removeAllLabel,
    onClick: onClickRemoveAll,
    variant: "link"
  }));
};

PanelFilterFooter.displayName = 'SLDSPanelFilterFooter';
PanelFilterFooter.propTypes = {
  /**
   * Localized description of the "Add Filter" button in the footer
   */
  addFilterLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,

  /**
   * Callback triggered when "Add Filter" is clicked. Recieves an `event`.
   */
  onClickAdd: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,

  /**
   * Callback triggered when "Remove All" is clicked. Recieves an `event`.
   */
  onClickRemoveAll: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,

  /**
   * Localized description of the "Remove All" button in the footer
   */
  removeAllLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (PanelFilterFooter);
//# sourceMappingURL=panel-footer.js.map

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__button__ = __webpack_require__(6);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// # Panel Filter Group Header
// Implements the [Panel design pattern](https://www.lightningdesignsystem.com/components/panels) in React.
// Based on SLDS v2.2.0-rc.1
// ## Dependencies
// ### React



/**
 * Header for a Filter Group within a Panel.
 */

var PanelFilterHeader = function PanelFilterHeader(_ref) {
  var assistiveText = _ref.assistiveText,
      cancelLabel = _ref.cancelLabel,
      heading = _ref.heading,
      modified = _ref.modified,
      onRequestCancel = _ref.onRequestCancel,
      onRequestClose = _ref.onRequestClose,
      onRequestSave = _ref.onRequestSave,
      saveLabel = _ref.saveLabel;
  return modified ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "slds-filters__header slds-grid slds-has-divider--bottom-space slds-grid--align-spread"
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__button__["a" /* default */], {
    label: cancelLabel,
    onClick: onRequestCancel,
    variant: "neutral"
  }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__button__["a" /* default */], {
    label: saveLabel,
    onClick: onRequestSave,
    variant: "brand"
  })) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "slds-filters__header slds-grid slds-has-divider--bottom-space"
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", {
    className: "slds-align-middle slds-text-heading--small"
  }, heading), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__button__["a" /* default */], {
    className: "slds-col--bump-left",
    assistiveText: {
      icon: assistiveText.closeButton
    },
    iconCategory: "utility",
    iconName: "forward",
    iconVariant: "bare",
    iconSize: "small",
    onClick: onRequestClose,
    title: assistiveText.closeButton,
    variant: "icon"
  }));
};

PanelFilterHeader.displayName = 'SLDSPanelFilterHeader';
PanelFilterHeader.propTypes = {
  /**
   * **Assistive text for accessibility.**
   * This object is merged with the default props object on every render.
   * * `closeButton`: Localized description of the close button for the panel for screen readers
   */
  assistiveText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    closeButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),

  /**
   * Label for button that cancels modified filters
   */
  cancelLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * The heading of the filtering panel
   */
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * Shows confirmation heading. Please see `onRequestCancel` and `onRequestSave`.
   */
  modified: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * When the panel's cancel button is clicked in order to reset filter panel to previous state.
   */
  onRequestCancel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * When the panel's close button is clicked. Please place Panel within another element to control position and visibility.
   */
  onRequestClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * When the panel's save button is clicked in order to confirm filter panel state.
   */
  onRequestSave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Label for button that saves modified filters
   */
  saveLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
/* harmony default export */ __webpack_exports__["a"] = (PanelFilterHeader);
//# sourceMappingURL=panel-header.js.map

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */



var displayName = 'PageHeaderInfo';
var propTypes = {
  /**
   * Contents of info section
   */
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * Optional class name
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var Info = function Info(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('slds-page-header__info', props.className)
  }, props.children);
};

Info.displayName = displayName;
Info.propTypes = propTypes;
/* harmony default export */ __webpack_exports__["a"] = (Info);
//# sourceMappingURL=info.js.map

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */



var displayName = 'PageHeaderTitle';
var propTypes = {
  /**
   * Sets whether the title will truncate its content responsively.
   */
  truncate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Sets the vertical alignment on the title
   */
  align: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['top', 'middle', 'bottom']),

  /**
   * The title string (required)
   */
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,

  /**
   * Optional class name
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
var defaultProps = {
  truncate: true,
  align: 'middle',
  title: 'Page Header Title',
  className: ''
};

var Title =
/*#__PURE__*/
function (_Component) {
  _inherits(Title, _Component);

  function Title() {
    _classCallCheck(this, Title);

    return _possibleConstructorReturn(this, (Title.__proto__ || Object.getPrototypeOf(Title)).apply(this, arguments));
  }

  _createClass(Title, [{
    key: "_getClassNames",
    // eslint-disable-next-line class-methods-use-this
    value: function _getClassNames(truncate, align, className) {
      return __WEBPACK_IMPORTED_MODULE_2_classnames___default()('slds-page-header__title slds-m-right--small', className, _defineProperty({
        'slds-truncate': truncate
      }, "slds-align-".concat(align), align));
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          children = _props.children,
          title = _props.title,
          truncate = _props.truncate,
          align = _props.align,
          className = _props.className;

      var classes = this._getClassNames(truncate, align, className);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1", {
        className: classes,
        title: title
      }, title, children);
    }
  }]);

  return Title;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Title.displayName = displayName;
Title.propTypes = propTypes;
Title.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Title);
//# sourceMappingURL=title.js.map

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__media_object__ = __webpack_require__(26);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */



var displayName = 'PageHeaderBase';
var propTypes = {
  /**
   * Icon node passed by PageHeader
   */
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * Title node passed by PageHeader
   */
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * Info node passed by PageHeader
   */
  info: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};

var Base = function Base(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__media_object__["a" /* default */], {
    body: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, props.title, props.info),
    figure: props.icon,
    verticalCenter: true
  });
};

Base.displayName = displayName;
Base.propTypes = propTypes;
/* harmony default export */ __webpack_exports__["a"] = (Base);
//# sourceMappingURL=index.js.map

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__detail_row__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__media_object__ = __webpack_require__(26);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */




var displayName = 'PageHeaderRecordHome';
var propTypes = {
  /**
   * Content to appear on the right hand side of the page header
   */
  contentRight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element]),

  /**
   * An array of detail blocks
   */
  details: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,

  /**
   * Icon node passed by PageHeader
   */
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * Info node passed by PageHeader
   */
  info: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * Heading above title
   */
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * Title node passed by PageHeader
   */
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};

var RecordHome = function RecordHome(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "slds-grid"
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "slds-col slds-has-flexi-truncate"
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__media_object__["a" /* default */], {
    body: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, props.label, props.title, props.info),
    className: "slds-no-space slds-grow",
    figure: props.icon
  })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "slds-col slds-no-flex slds-grid slds-align-top"
  }, props.contentRight)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__detail_row__["a" /* default */], {
    details: props.details
  }));
};

RecordHome.displayName = displayName;
RecordHome.propTypes = propTypes;
/* harmony default export */ __webpack_exports__["a"] = (RecordHome);
//# sourceMappingURL=index.js.map

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__media_object__ = __webpack_require__(26);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */



var displayName = 'PageHeaderObjectHome';
var propTypes = {
  /**
   * Content to appear on the right hand side of the page header
   */
  contentRight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element]),

  /**
   * Icon node passed by PageHeader
   */
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * Info node passed by PageHeader
   */
  info: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * Heading above title
   */
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * Nav content which appears in the upper right hand corner.
   */
  navRight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element]),

  /**
   * Title node passed by PageHeader
   */
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};

var ObjectHome = function ObjectHome(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "slds-grid"
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "slds-col slds-has-flexi-truncate"
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__media_object__["a" /* default */], {
    body: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, props.label, props.title),
    className: "slds-no-space slds-grow",
    figure: props.icon
  })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "slds-col slds-no-flex slds-grid slds-align-top slds-p-bottom--xx-small"
  }, props.navRight)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "slds-grid"
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "slds-col slds-align-bottom"
  }, props.info), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "slds-col slds-no-flex slds-grid slds-align-bottom"
  }, props.contentRight)));
};

ObjectHome.displayName = displayName;
ObjectHome.propTypes = propTypes;
/* harmony default export */ __webpack_exports__["a"] = (ObjectHome);
//# sourceMappingURL=index.js.map

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */


var displayName = 'PageHeaderRelatedList';
var propTypes = {
  /**
   * Icon node passed by PageHeader
   */
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * Title node passed by PageHeader
   */
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * Info node passed by PageHeader
   */
  info: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * Content to appear on the right hand side of the page header
   */
  contentRight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element]),

  /**
   * Nav content which appears in the upper right hand corner.
   */
  navRight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element])
};
var defaultProps = {};

var RelatedList =
/*#__PURE__*/
function (_Component) {
  _inherits(RelatedList, _Component);

  function RelatedList() {
    _classCallCheck(this, RelatedList);

    return _possibleConstructorReturn(this, (RelatedList.__proto__ || Object.getPrototypeOf(RelatedList)).apply(this, arguments));
  }

  _createClass(RelatedList, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "slds-grid"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "slds-col slds-has-flexi-truncate"
      }, this.props.label, this.props.title), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "slds-col slds-no-flex slds-grid slds-align-top"
      }, this.props.navRight)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "slds-grid"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "slds-col slds-align-bottom"
      }, this.props.info), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "slds-col slds-no-flex slds-grid slds-align-bottom"
      }, this.props.contentRight)));
    }
  }]);

  return RelatedList;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

RelatedList.displayName = displayName;
RelatedList.propTypes = propTypes;
RelatedList.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (RelatedList);
//# sourceMappingURL=index.js.map

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tooltip__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__icon_button_icon__ = __webpack_require__(28);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

 // ### classNames
// [github.com/JedWatson/classnames](https://github.com/JedWatson/classnames)
// This project uses `classnames`, 'a simple javascript utility for conditionally
// joining classNames together.'

 // Child component



 // ### Display Name

var displayName = __WEBPACK_IMPORTED_MODULE_4__utilities_constants__["_11" /* PROGRESS_INDICATOR_STEP */]; // ### Prop Types

var propTypes = {
  /**
   * **Assistive text for accessibility**
   * This object is merged with the default props object on every render.
   * * `completedStep`: Label for a completed step. The default is `Completed Step`
   * * `disabledStep`: Label for disabled step. The default is `Disabled Step`
   * * `errorStep`: Label for a step with an error. The default is `Error Step`
   * * `percentage`: Label for Progress Bar. The default is `Progress: [this.props.value]%`. You will need to calculate the percentage yourself if changing this string.
   * * `step`: Label for a step. It will be typically followed by the number of the step such as "Step 1".
   */
  assistiveText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    completedStep: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    disabledStep: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    percentage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    step: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),

  /**
   * Id for Steps, ranging in [0, steps.length).
   */
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * Index of step. Used for id's if no step ID exists
   */
  index: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * Determines if the step has been completed
   */
  isCompleted: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Determines if the step has been disabled
   */
  isDisabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Determines if the step contains an error
   */
  isError: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Determines if the step is currently selected (active)
   */
  isSelected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Label of tooltip attached to the step if applicable.
   */
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * Triggered when click on individual steps. By default, it receives an event and returns all info passed to that step.
   * users are able to re-define it by passing a function as a prop
   */
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Triggered when focus on individual steps. By default, it receives an event and returns all info passed to that step.
   * users are able to re-define it by passing a function as a prop
   */
  onFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Step object. This is passed into event callbacks.
   */
  step: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * Determines if the tooltip attached to step is always open.
   * This is mainly for dev test purpose.
   * Usually the tooltip should only show when hover.
   */
  tooltipIsOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
/**
 * Step renders a button icon and its tooltip if applied.
 * The button is applied with different css classes under different conditions.
 * Button icons have 4 types of status: completed (success), active (in progress), error (warning) and uncompleted (not approached)
 */

var Step =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Step, _React$Component);

  function Step() {
    _classCallCheck(this, Step);

    return _possibleConstructorReturn(this, (Step.__proto__ || Object.getPrototypeOf(Step)).apply(this, arguments));
  }

  _createClass(Step, [{
    key: "buttonIcon",

    /**
     * buttonIcon represents the button icon used for each step.
     * the button is applied with different css classes under different conditions.
     */
    value: function buttonIcon(renderIcon, status, props) {
      var data = {
        isSelected: props.isSelected,
        isError: props.isError,
        isCompleted: props.isCompleted,
        isDisabled: props.isDisabled,
        step: props.step
      };
      var icon = renderIcon ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__icon_button_icon__["a" /* default */], {
        category: "utility",
        name: this.props.isError ? 'error' : 'success'
      }) : null;

      var handleClick = function handleClick(event) {
        return props.onClick(event, data);
      };

      var handleFocus = function handleFocus(event) {
        return props.onFocus(event, data);
      };

      var stepButton = props.isDisabled ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('slds-button', {
          'slds-button_icon': renderIcon
        }, 'slds-progress__marker', {
          'slds-progress__marker_icon': renderIcon
        }),
        "aria-describedby": "progress-indicator-tooltip-".concat(this.props.step.id || this.props.index),
        tabIndex: 0,
        role: "button"
      }, icon, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "slds-assistive-text"
      }, this.props.step.assistiveText || "".concat(props.assistiveText.step, " ").concat(props.index + 1, ": ").concat(props.step.label, " - ").concat(status))) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('slds-button', {
          'slds-button_icon': renderIcon
        }, 'slds-progress__marker', {
          'slds-progress__marker_icon': renderIcon
        }),
        onClick: handleClick,
        onFocus: handleFocus,
        "aria-describedby": "progress-indicator-tooltip-".concat(this.props.step.id || this.props.index),
        "aria-current": this.props.isSelected ? 'step' : null
      }, icon, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "slds-assistive-text"
      }, this.props.step.assistiveText || "".concat(props.assistiveText.step, " ").concat(props.index + 1, ": ").concat(props.step.label).concat(status ? " - ".concat(status) : '')));
      return stepButton;
    }
  }, {
    key: "render",
    value: function render() {
      var renderIcon = this.props.isCompleted || this.props.isError;
      var status = '';

      if (this.props.isError) {
        status = this.props.assistiveText.errorStep;
      } else if (this.props.isCompleted) {
        status = this.props.assistiveText.completedStep;
      } else if (this.props.isDisabled) {
        status = this.props.assistiveText.disabledStep;
      }

      var tooltipProps = {
        align: 'top',
        id: "progress-indicator-tooltip-".concat(this.props.step.id || this.props.index),
        content: this.props.step.label,
        theme: 'info',
        triggerStyle: {
          display: !renderIcon ? 'flex' : ''
        }
      }; // This is mainly for dev test purpose.
      // `isOpen` is only set to true if tooltip is specified to be open
      // Do not set isOpen to false or undefined otherwise, because that will
      // disable any interaction with tooltips

      if (this.props.tooltipIsOpen) {
        tooltipProps.isOpen = true;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('slds-progress__item', {
          'slds-is-completed': this.props.isCompleted,
          'slds-is-active': this.props.isSelected && !this.props.isError,
          'slds-has-error': this.props.isError
        })
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__tooltip__["a" /* default */], tooltipProps, this.buttonIcon(renderIcon, status, this.props)));
    }
  }]);

  return Step;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Step.propTypes = propTypes;
Step.displayName = displayName;
/* harmony default export */ __webpack_exports__["a"] = (Step); // export is replaced with `ReactDOM.render(<Example />, mountNode);` at runtime
//# sourceMappingURL=step.js.map

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__progress_bar__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_constants__ = __webpack_require__(2);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

 // ### classNames
// [github.com/JedWatson/classnames](https://github.com/JedWatson/classnames)
// This project uses `classnames`, 'a simple javascript utility for conditionally
// joining classNames together.'



 // ### Prop Types

var propTypes = {
  /**
   * Assistive text for percentage
   */
  assistiveText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    percentage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),

  /**
   * Steps in the component
   */
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * CSS class names to be added to the container element.
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * HTML id for component.
   */
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,

  /**
   * Percentage of progress completion, ranging [0, 100]
   */
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,

  /**
   * Determines component style
   */
  variant: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['base', 'modal'])
};
/**
 * Progress renders all step buttons and a container wrapping these buttongs and a progress bar
 */

var Progress =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Progress, _React$Component);

  function Progress() {
    _classCallCheck(this, Progress);

    return _possibleConstructorReturn(this, (Progress.__proto__ || Object.getPrototypeOf(Progress)).apply(this, arguments));
  }

  _createClass(Progress, [{
    key: "getId",

    /**
     * Get the progress's HTML id. Generate a new one if no ID present.
     */
    value: function getId() {
      return this.props.id;
    }
  }, {
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        id: this.getId(),
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('slds-progress', {
          'slds-progress_shade': this.props.variant === 'modal'
        }, this.props.className)
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol", {
        className: "slds-progress__list"
      }, this.props.children), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__progress_bar__["a" /* default */], {
        value: this.props.value,
        assistiveText: this.props.assistiveText
      }));
    }
  }]);

  return Progress;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Progress.propTypes = propTypes;
Progress.displayName = __WEBPACK_IMPORTED_MODULE_4__utilities_constants__["_10" /* PROGRESS_INDICATOR_PROGRESS */];
/* harmony default export */ __webpack_exports__["a"] = (Progress);
//# sourceMappingURL=progress.js.map

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */


var propTypes = {
  /**
   * Assistive text for percentage
   */
  assistiveText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    percentage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),

  /**
   * Percentage of progress completion, with range of [0, 100]
   */
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};
/**
 * ProgressBar renders the blue/gray progress bar and dynamically updates its completion percentage
 */

var ProgressBar =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ProgressBar, _React$Component);

  function ProgressBar() {
    _classCallCheck(this, ProgressBar);

    return _possibleConstructorReturn(this, (ProgressBar.__proto__ || Object.getPrototypeOf(ProgressBar)).apply(this, arguments));
  }

  _createClass(ProgressBar, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "slds-progress-bar slds-progress-bar_x-small",
        "aria-valuemin": "0",
        "aria-valuemax": "100",
        "aria-valuenow": this.props.value,
        role: "progressbar"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "slds-progress-bar__value",
        style: {
          width: "".concat(this.props.value, "%")
        }
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "slds-assistive-text"
      }, this.props.assistiveText.percentage || "Progress: ".concat(this.props.value, "%"))));
    }
  }]);

  return ProgressBar;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ProgressBar.displayName = 'ProgressBar';
ProgressBar.propTypes = propTypes;
/* harmony default export */ __webpack_exports__["a"] = (ProgressBar);
//# sourceMappingURL=progress-bar.js.map

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// Implements the [Progress Ring design pattern](https://lightningdesignsystem.com/components/progress-ring/) in React.
// Based on SLDS v2.4.5



var PROGRESS_RING_SHAPE = 'SLDSProgressRingShape';
var propTypes = {
  /**
   * HTML id for component.
   */
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * CSS class names to be added to the container element. `array`, `object`, or `string` are accepted.
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * Decimal percentage drain of the ring [0.0 - 1.0]
   */
  fillPercentDecimal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};
var defaultProps = {
  fillPercentDecimal: 0
};
/**
 * Generates the string for the D value of the SVG path
 * @param isLong {number} a binary flag if the arc should 'take the long path' (used for > 50% fill)
 * @param arcX {decimal} the arc's x position
 * @param arcY {decimal} the arc's y position
 */

var getD = function getD(isLong, arcX, arcY) {
  return "M 1 0 A 1 1 0 ".concat(isLong, " 1 ").concat(arcX, " ").concat(arcY, " L 0 0");
};
/**
 * Calculates the fill part of the ring
 * @param fillPercent {decimal} Decimal percentage that represents the amount of the ring which is filled with color.
 */


var calculateD = function calculateD(fillPercent) {
  var isLong = fillPercent > 0.5 ? 1 : 0;
  var arcX = Math.cos(2 * Math.PI * fillPercent);
  var arcY = Math.sin(2 * Math.PI * fillPercent);
  return getD(isLong, arcX, arcY);
};
/**
 * Displays the progress ring shape.
 */


var ProgressRingShape = function ProgressRingShape(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    id: props.id,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('slds-progress-ring', props.className)
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "slds-progress-ring__progress",
    role: "progressbar",
    "aria-valuemin": "0",
    "aria-valuemax": "100",
    "aria-valuenow": props.fillPercentDecimal * 100
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
    viewBox: "-1 -1 2 2"
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    className: "slds-progress-ring__path",
    d: calculateD(props.fillPercentDecimal)
  }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "slds-progress-ring__content"
  }, props.children));
};

ProgressRingShape.displayName = PROGRESS_RING_SHAPE;
ProgressRingShape.propTypes = propTypes;
ProgressRingShape.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (ProgressRingShape);
//# sourceMappingURL=ring-shape.js.map

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DISPLAY_NAME */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TOGGLE_BUTTON_WIDTH; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__button__ = __webpack_require__(6);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */




var DISPLAY_NAME = 'SLDSSplitViewToggleButton';
var TOGGLE_BUTTON_WIDTH = '0.75rem';
var propsTypes = {
  /**
   * **Assistive text for accessibility**
   * * `toggleButtonOpen`: The button used to open the split view.
   * * `toggleButtonClose`: The button used to close the split view.
   */
  assistiveText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    toggleButtonOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    toggleButtonClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  }),

  /**
   * Unique html id placed on the button for aria-controls
   */
  ariaControls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,

  /**
   * Determines if the panel is open
   */
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,

  /**
   * **Event Callbacks**
   * * `onClick`: Called when the button is clicked.
   */
  events: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
  })
};
var defaultProps = {};

var SplitViewToggleButton = function SplitViewToggleButton(_ref) {
  var isOpen = _ref.isOpen,
      assistiveText = _ref.assistiveText,
      ariaControls = _ref.ariaControls,
      events = _ref.events;
  var toggleAssistiveText = isOpen ? assistiveText.toggleButtonOpen : assistiveText.toggleButtonClose;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__button__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('slds-button slds-button_icon slds-split-view__toggle-button', {
      'slds-is-open': isOpen
    }),
    "aria-expanded": isOpen,
    "aria-controls": ariaControls,
    title: toggleAssistiveText,
    variant: "base",
    iconName: "left",
    iconCategory: "utility",
    iconSize: "x-small",
    onClick: events.onClick,
    assistiveText: {
      icon: toggleAssistiveText
    }
  });
};

SplitViewToggleButton.displayName = DISPLAY_NAME;
SplitViewToggleButton.propTypes = propsTypes;
SplitViewToggleButton.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["b"] = (SplitViewToggleButton);
//# sourceMappingURL=toggle-button.js.map

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DISPLAY_NAME */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */


var DISPLAY_NAME = 'SLDSSplitViewListItemContent';
var propTypes = {
  /**
   * **Item to be displayed**
   * * `label`: The main label displayed on the top left.
   * * `topRightText`: The text displayed on the top right.
   * * `bottomLeftText`: The text displayed on the bottom left.
   * * `bottomRightText`: The text displayed on the bottom right.
   */
  item: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    topRightText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    bottomLeftText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    bottomRightText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  })
};
var defaultProps = {};

var SplitViewListItemContent = function SplitViewListItemContent(_ref) {
  var item = _ref.item;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "slds-grid slds-wrap"
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "slds-truncate slds-text-body_regular slds-text-color_default",
    title: item.label
  }, item.label), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "slds-truncate slds-col_bump-left",
    title: item.topRightText
  }, item.topRightText)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "slds-grid slds-wrap"
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "slds-truncate",
    title: item.bottomLeftText
  }, item.bottomLeftText), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "slds-truncate slds-col_bump-left",
    title: item.bottomLeftText
  }, item.bottomRightText)));
};

SplitViewListItemContent.displayName = DISPLAY_NAME;
SplitViewListItemContent.propTypes = propTypes;
SplitViewListItemContent.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (SplitViewListItemContent);
//# sourceMappingURL=list-item-content.js.map

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DISPLAY_NAME */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable class-methods-use-this */



var DISPLAY_NAME = 'SLDSSplitViewListItemWithContent';
var propsTypes = {
  /**
   * **Assistive text for accessibility**
   * * `unreadItem`: The unread indicator.
   */
  assistiveText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    unreadItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),

  /**
   * Item to be displayed
   */
  item: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,

  /**
   * Allows multiple item to be selection
   */
  multiple: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Shows the item as `focused`.
   */
  isFocused: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,

  /**
   * Shows the item as `selected`.
   */
  isSelected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,

  /**
   * Shows the item as `unread`.
   */
  isUnread: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * **Event Callbacks**
   * * `onClick`: Called when the item is clicked.
   * * * Event
   * * * Meta data
   * * * * `item`: The original item.
   * * * * `isSelected`: Is the item selected.
   * * * * `isUnread`: Is the item unread.
   */
  events: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
  }),

  /**
   * Reference to the list item component
   */
  listItemRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
var defaultProps = {
  assistiveText: {
    unreadItem: 'Unread Item'
  },
  events: {}
};
/**
 * HOC that wraps the list item content with selection and unread functionality.
 * @param ListItemContent {node} A React component
 * @returns {ListItemWithContent} A React component
 */

var listItemWithContent = function listItemWithContent(ListItemContent) {
  var ListItemWithContent =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(ListItemWithContent, _React$Component);

    function ListItemWithContent() {
      _classCallCheck(this, ListItemWithContent);

      return _possibleConstructorReturn(this, (ListItemWithContent.__proto__ || Object.getPrototypeOf(ListItemWithContent)).apply(this, arguments));
    }

    _createClass(ListItemWithContent, [{
      key: "onClick",
      value: function onClick(event) {
        this.props.events.onClick(event, {
          item: this.props.item,
          isSelected: this.props.isSelected,
          isUnread: this.props.isUnread
        });
      }
    }, {
      key: "unread",
      value: function unread() {
        return this.props.isUnread ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("abbr", {
          className: "slds-indicator_unread",
          title: this.props.assistiveText.unreadItem,
          "aria-label": this.props.assistiveText.unreadItem
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
          className: "slds-assistive-text"
        }, "\u25CF")) : null;
      }
    }, {
      key: "render",
      value: function render() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
          className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('slds-split-view__list-item', {
            'slds-is-unread': this.props.isUnread
          }),
          role: "presentation"
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
          className: "slds-split-view__list-item-action slds-grow slds-has-flexi-truncate",
          role: "option",
          ref: this.props.listItemRef,
          "aria-selected": this.props.multiple ? !!this.props.isSelected : this.props.isSelected,
          tabIndex: this.props.isFocused ? 0 : -1,
          href: "javascript:void(0);" // eslint-disable-line no-script-url
          ,
          onClick: function onClick(e) {
            return _this.onClick(e);
          }
        }, this.unread(), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ListItemContent, this.props)));
      }
    }]);

    return ListItemWithContent;
  }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

  Object.defineProperty(ListItemWithContent, "displayName", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: "".concat(DISPLAY_NAME, "(").concat(ListItemContent.displayName || ListItemContent.name || 'Component', ")")
  });
  Object.defineProperty(ListItemWithContent, "propTypes", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: propsTypes
  });
  Object.defineProperty(ListItemWithContent, "defaultProps", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: defaultProps
  });
  return ListItemWithContent;
};

/* harmony default export */ __webpack_exports__["a"] = (listItemWithContent);
//# sourceMappingURL=list-item-with-content.js.map

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_warning_only_one_of_properties__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities_warning_sunset_property__ = __webpack_require__(11);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable import/no-mutable-exports */

/* eslint-disable max-len */



var checkProps = function checkProps() {};

if (false) {
  checkProps = function checkProps(COMPONENT, props) {
    onlyOneOfProperties(COMPONENT, {
      assistiveText: props.assistiveText,
      label: props.label
    });

    if (typeof props.assistiveText === 'string') {
      sunsetProperty(COMPONENT, props.assistiveText, 'assistiveText', '`assistiveText` as a string has been deprecated and is now an object to allow for multiple uses in the component. Please use `assistiveText.label` instead.');
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (checkProps);
//# sourceMappingURL=check-props.js.map

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** `Object#toString` result references. */
var dateTag = '[object Date]';

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsDate = nodeUtil && nodeUtil.isDate;

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * The base implementation of `_.isDate` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
 */
function baseIsDate(value) {
  return isObjectLike(value) && objectToString.call(value) == dateTag;
}

/**
 * Checks if `value` is classified as a `Date` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
 * @example
 *
 * _.isDate(new Date);
 * // => true
 *
 * _.isDate('Mon April 23 2012');
 * // => false
 */
var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

module.exports = isDate;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17), __webpack_require__(30)(module)))

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_warning_deprecated_property__ = __webpack_require__(14);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable import/no-mutable-exports */


var checkProps = function checkProps() {};

if (false) {
  checkProps = function checkProps(COMPONENT, props) {
    deprecatedProperty(COMPONENT, props.isInline, 'isInline', 'menuPosition="relative"');
  };
}

/* harmony default export */ __webpack_exports__["a"] = (checkProps);
//# sourceMappingURL=check-props.js.map

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__input__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_key_code__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_constants__ = __webpack_require__(2);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// # Timepicker Dropdown Trigger
// ## Dependencies
// ### React


 // ### Children

 // ### Event Helpers

 // ## Constants


/**
 *  Component description.
 */

var TimepickerDropdownTrigger = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  // ### Display Name
  // Always use the canonical component name (set in the core) as the React
  // display name.
  displayName: __WEBPACK_IMPORTED_MODULE_5__utilities_constants__["Y" /* MENU_DROPDOWN_TRIGGER */],
  // ### Prop Types
  propTypes: {
    /**
     * Icon for right side of trigger
     */
    iconRight: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,

    /**
     * A unique ID is needed in order to support keyboard navigation, ARIA support, and connect the dropdown to the triggering input.
     */
    id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * This label appears above the input.
     */
    label: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * The dropdown menu.
     */
    menu: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,

    /**
     * Is only called when `openOn` is set to `hover` and when the triggering input loses focus.
     */
    onBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * This prop is passed onto the triggering `Input`. Triggered when the trigger input is clicked.
     */
    onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Is only called when `openOn` is set to `hover` and when the triggering input gains focus.
     */
    onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Called when a key pressed.
     */
    onKeyDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Called when mouse clicks down on the trigger input.
     */
    onMouseDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * The ref of the actual triggering input.
     */
    triggerRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

    /**
     * Date
     */
    value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
  },
  handleKeyDown: function handleKeyDown(event) {
    if (this.props.onKeyDown && event.keyCode) {
      if (event.keyCode === __WEBPACK_IMPORTED_MODULE_4__utilities_key_code__["a" /* default */].ENTER || event.keyCode === __WEBPACK_IMPORTED_MODULE_4__utilities_key_code__["a" /* default */].DOWN || event.keyCode === __WEBPACK_IMPORTED_MODULE_4__utilities_key_code__["a" /* default */].UP || event.keyCode === __WEBPACK_IMPORTED_MODULE_4__utilities_key_code__["a" /* default */].ESCAPE) {
        this.props.onKeyDown(event);
      }
    }
  },
  // ### Render
  render: function render() {
    var _props = this.props,
        iconRight = _props.iconRight,
        menu = _props.menu,
        onBlur = _props.onBlur,
        onFocus = _props.onFocus,
        onKeyDown = _props.onKeyDown,
        onMouseDown = _props.onMouseDown,
        triggerRef = _props.triggerRef,
        props = _objectWithoutProperties(_props, ["iconRight", "menu", "onBlur", "onFocus", "onKeyDown", "onMouseDown", "triggerRef"]);

    return (
      /* eslint-disable jsx-a11y/no-static-element-interactions */
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        onBlur: onBlur,
        onFocus: onFocus,
        onKeyDown: this.handleKeyDown,
        onMouseDown: onMouseDown
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__input__["a" /* default */], _extends({
        iconRight: iconRight
      }, props, {
        inputRef: triggerRef
      }), menu))
    );
  }
});
/* harmony default export */ __webpack_exports__["a"] = (TimepickerDropdownTrigger);
//# sourceMappingURL=dropdown-trigger.js.map

/***/ }),
/* 281 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
 * as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' ||
    (isObjectLike(value) && objectToString.call(value) == numberTag);
}

module.exports = isNumber;


/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_constants__ = __webpack_require__(2);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// # Tabs Component
// Implements the [Tabs design pattern](https://www.lightningdesignsystem.com/components/tabs/) in React.
// ## Dependencies
// ### React

 // ### classNames




var TabsList = function TabsList(_ref) {
  var id = _ref.id,
      className = _ref.className,
      children = _ref.children,
      variant = _ref.variant;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
    id: "".concat(id, "-slds-tabs__nav"),
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, {
      'slds-tabs--default__nav': variant === 'default',
      'slds-tabs--scoped__nav': variant === 'scoped'
    }),
    role: "tablist"
  }, children);
};

TabsList.displayName = __WEBPACK_IMPORTED_MODULE_3__utilities_constants__["_24" /* TABS_LIST */];
TabsList.propTypes = {
  /**
   * Inherits the `id` from the parent `<Tabs />` component and appends `-tabs__nav`. Becomes the HTML `id` attribute of UL element that has the class `.slds-tabs--default__nav` on it.
   */
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Class names to be added to the tabs list element.
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * The `children` are the actual tabs to be rendered as `li` elements. They get created by [tabs/index.jsx](./index.jsx) in the `renderTabsList` function.
   */
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array]),

  /**
   * If the Tabs should be scopped, defaults to false
   */
  variant: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['default', 'scoped'])
};
/* harmony default export */ __webpack_exports__["a"] = (TabsList);
//# sourceMappingURL=tabs-list.js.map

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_constants__ = __webpack_require__(2);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable jsx-a11y/no-interactive-element-to-noninteractive-role */
// # TabItem Component
// ## Dependencies
// ### React


 // ### classNames

 // ## Constants


/*
 * Disabled Tab CSS has been removed. If you'd like to use the styling, please import it in your module bundler.
 */
// import '!style-loader!css-loader!../../../styles/tabs/tab.css'; // eslint-disable-line import/no-unresolved

var Tab = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: __WEBPACK_IMPORTED_MODULE_4__utilities_constants__["_22" /* TAB */],
  propTypes: {
    /**
     * CSS classes to be added to the tab.
     */
    className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * The HTML ID of this tab. Also used by the `<TabPanel />` it controls as `tabId`.
     */
    id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * Whether to apply focus to this tab.
     */
    focus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * When `true`, the class `.slds-active` is applied.
     */
    selected: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * When `true`, the HTML attribute `aria-disabled` will be applied. Disabled Tab CSS has been removed. If you'd like to use the styling, please import it in your module bundler. `import 'css-loader!/node_modules/design-system-react/styles/tabs/tab.css';` This feature may be removed in the future due to disabled tabs being inaccessible.
     */
    disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

    /**
     * The CSS class to be applied when this tab is selected. Defaults to `.slds-active`. If another class is desired, it should be passed in _along with_ `.slds-active`, not _instead_ of it.
     */
    activeTabClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * The CSS class to be applied when this tab is disabled. Defaults to `.slds-disabled`. If another class is desired, it should be passed in _along with_ `.slds-disabled`, not _instead_ of it.
     */
    disabledTabClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * The HTML ID of `<TabPanel />` this tab controls.
     */
    panelId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,

    /**
     * The string or element that is shown as both the title and the label for this tab.
     */
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element]),

    /**
     * If the Tabs should be scopped, defaults to false
     */
    variant: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['default', 'scoped'])
  },
  getDefaultProps: function getDefaultProps() {
    return {
      focus: false,
      selected: false,
      activeTabClassName: 'slds-active',
      disabledTabClassName: 'slds-disabled',
      variant: 'default'
    };
  },
  componentDidMount: function componentDidMount() {
    this.checkFocus();
  },
  componentDidUpdate: function componentDidUpdate() {
    this.checkFocus();
  },
  checkFocus: function checkFocus() {
    if (this.props.selected && this.props.focus && this.node) {
      this.node.focus();
    }
  },
  render: function render() {
    var _classNames,
        _this = this,
        _classNames2;

    var _props = this.props,
        selected = _props.selected,
        disabled = _props.disabled,
        panelId = _props.panelId,
        activeTabClassName = _props.activeTabClassName,
        disabledTabClassName = _props.disabledTabClassName,
        className = _props.className,
        children = _props.children,
        id = _props.id,
        variant = _props.variant;
    var tabIndex;

    if (selected) {
      tabIndex = '0';
    } else if (disabled) {
      tabIndex = '-1';
    } else {
      tabIndex = null;
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('slds-text-title--caps', className, (_classNames = {}, _defineProperty(_classNames, activeTabClassName, selected), _defineProperty(_classNames, disabledTabClassName, disabled), _defineProperty(_classNames, 'slds-tabs--default__item', variant === 'default'), _defineProperty(_classNames, 'slds-tabs--scoped__item', variant === 'scoped'), _classNames)),
      role: "tab",
      ref: function ref(node) {
        _this.node = node;
      },
      "aria-selected": selected ? 'true' : 'false',
      "aria-disabled": disabled,
      "aria-controls": panelId,
      tabIndex: tabIndex,
      id: id,
      title: typeof children === 'string' ? children : null
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()((_classNames2 = {}, _defineProperty(_classNames2, activeTabClassName, selected), _defineProperty(_classNames2, disabledTabClassName, disabled), _defineProperty(_classNames2, 'slds-tabs--default__link', variant === 'default'), _defineProperty(_classNames2, 'slds-tabs--scoped__link', variant === 'scoped'), _classNames2)),
      href: "javascript:void(0);" // eslint-disable-line no-script-url
      ,
      role: "presentation",
      tabIndex: "-1",
      "aria-disabled": disabled
    }, children));
  }
});
/* harmony default export */ __webpack_exports__["a"] = (Tab);
//# sourceMappingURL=tab.js.map

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_constants__ = __webpack_require__(2);
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// # Tabs Component
// Implements the [Tabs design pattern](https://www.lightningdesignsystem.com/components/tabs/) in React.
// ## Dependencies
// ### React

 // ### classNames



/**
 * The containers of content that are shown and hidden by `Tabs`.
 */

var TabPanel = function TabPanel(_ref) {
  var className = _ref.className,
      children = _ref.children,
      variant = _ref.variant,
      selected = _ref.selected,
      id = _ref.id,
      tabId = _ref.tabId,
      attributes = _objectWithoutProperties(_ref, ["className", "children", "variant", "selected", "id", "tabId"]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    "aria-labelledby": tabId,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, {
      'slds-show': selected,
      'slds-hide': !selected,
      'slds-tabs--default__content': variant === 'default',
      'slds-tabs--scoped__content': variant === 'scoped'
    }),
    id: id,
    role: "tabpanel"
  }, children.props.children);
};

TabPanel.displayName = __WEBPACK_IMPORTED_MODULE_3__utilities_constants__["_26" /* TAB_PANEL */];
TabPanel.propTypes = {
  /**
   * The `children` are the contents of the tab panel.
   *
   * Note that the structure of the `<Tabs />` component **does not** correspond to the DOM structure that is rendered. The `<Tabs />` component requires one or more children of type `<TabsPanel />`, which themselves require a `label` property which will be what shows in the `<Tab />` and has `children`, which end up being the _contents of the tab's corresponding panel_.
   *
   * The component iterates through each `<TabsPanel />` and rendering one `<Tab />` and one `<TabPanel />` for each of them. The tab(s) end up being children of the `<TabsList />`.
   *
   * The tab panel component actually returns the _children_ of the _children_ which were provided by the `<TabsPanel />` component.
   *
   * Due to React's nature, the `<TabsPanel />` component wraps its children in a `div` element which we don't need nor want in our rendered DOM structure, so we just bypass it and get its kids via `{children.props.children}` in the render method below.
   * ```
   * <Tabs>
   * 	<TabsPanel label="Tab 1">
   * 		<h2 className="slds-text-heading--medium">This is my tab 1 contents!</h2>
   * 		<p>They show when you click the first tab.</p>
   * 	</TabsPanel>
   * 	<TabsPanel label="Tab 2">
   * 		<h2 className="slds-text-heading--medium">This is my tab 2 contents!</h2>
   * 		<p>They show when you click the second tab.</p>
   * 	</TabsPanel>
   * </Tabs>
   * ```
   */
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * CSS classes to be added to the tab panel.
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * The HTML ID of this tab panel. Also used by the `<Tab />`that controls it as `panelId`.
   */
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Whether this panel is hidden or shown. Uses the `.slds-show` and `.slds-hide` classes.
   */
  selected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * If the Tabs should be scopped, defaults to false
   */
  variant: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['default', 'scoped']),

  /**
   * The HTML ID of the `<Tab />` that controls this panel.
   */
  tabId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
TabPanel.defaultProps = {
  variant: 'default',
  selected: false
};
/* harmony default export */ __webpack_exports__["a"] = (TabPanel);
//# sourceMappingURL=tab-panel.js.map

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_warning_sunset_property__ = __webpack_require__(11);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable import/no-mutable-exports */


var checkProps = function checkProps() {};

if (false) {
  checkProps = function checkProps(COMPONENT, props) {
    /* eslint-disable max-len */
    sunsetProperty(COMPONENT, props.iconCategory, 'iconCategory', 'Use `Icon` instead.');
    sunsetProperty(COMPONENT, props.iconName, 'iconName', 'Use `Icon` instead.');
    sunsetProperty(COMPONENT, props.content, 'content', 'Use `labels.heading` and `labels.headingLink` instead.');
    sunsetProperty(COMPONENT, props.isOpen, 'isOpen', 'Use a conditional outside of alert.');
    sunsetProperty(COMPONENT, props.isOpen, 'onDismiss', 'Use `onRequestClose` instead');
    sunsetProperty(COMPONENT, props.texture, 'texture');
    sunsetProperty(COMPONENT, props.theme, 'theme', 'Use `variant` instead.');
  };
}

/* harmony default export */ __webpack_exports__["a"] = (checkProps);
//# sourceMappingURL=check-props.js.map

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shortid__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shortid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_shortid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__item__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__render_initial_branch__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__render_branch__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_constants__ = __webpack_require__(2);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// # Tree Branch Component


 // Child components





/**
 * A Tree Item is a non-branching node in a hierarchical list.
 */

var Branch = function Branch(props) {
  var treeIndex = '';
  var children;
  var treeId = props.treeId,
      level = props.level,
      onExpand = props.onExpand,
      searchTerm = props.searchTerm;

  if (Array.isArray(props.getNodes(props.node))) {
    children = props.getNodes(props.node).map(function (node, index) {
      var child;
      var htmlId = "".concat(props.treeId, "-").concat(node.id);
      treeIndex = "".concat(index);

      if (props.treeIndex) {
        treeIndex = "".concat(props.treeIndex, "-").concat(treeIndex);
      }

      if (node.type === 'branch') {
        child = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Branch, {
          getNodes: props.getNodes,
          htmlId: htmlId,
          key: node.id,
          label: node.label,
          level: level + 1,
          node: node,
          flattenedNodes: props.flattenedNodes,
          selectedNodeIndexes: props.selectedNodeIndexes,
          focusedNodeIndex: props.focusedNodeIndex,
          treeHasFocus: props.treeHasFocus,
          onNodeBlur: props.onNodeBlur,
          nodes: node.nodes,
          onSelect: props.onSelect,
          onExpand: onExpand,
          searchTerm: searchTerm,
          treeId: treeId,
          treeIndex: treeIndex,
          parent: props.node
        });
      } else {
        child = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__item__["a" /* default */], {
          label: node.label,
          htmlId: htmlId,
          key: __WEBPACK_IMPORTED_MODULE_2_shortid___default.a.generate(),
          level: level + 1,
          node: node,
          flattenedNodes: props.flattenedNodes,
          selectedNodeIndexes: props.selectedNodeIndexes,
          focusedNodeIndex: props.focusedNodeIndex,
          treeHasFocus: props.treeHasFocus,
          onNodeBlur: props.onNodeBlur,
          onSelect: props.onSelect,
          onExpand: onExpand,
          searchTerm: searchTerm,
          treeIndex: treeIndex,
          treeId: treeId,
          parent: props.node
        });
      }

      return child;
    });
  }

  var branch = props.level === 0 ? Object(__WEBPACK_IMPORTED_MODULE_4__render_initial_branch__["a" /* default */])(children, props) : Object(__WEBPACK_IMPORTED_MODULE_5__render_branch__["a" /* default */])(children, props);
  return branch;
}; // ### Display Name
// Always use the canonical component name as the React display name.


Branch.displayName = __WEBPACK_IMPORTED_MODULE_6__utilities_constants__["_32" /* TREE_BRANCH */]; // ### Prop Types

Branch.propTypes = {
  /**
   * A function that will be called by every branch to receive its child nodes. The parent `node` object with the branch data is passed into this function: `getNodes(node)`. If your state engine is Flux or Redux, then your tree data structure will probably be flattened or normalized within the store. This will allow you to build out your tree without transversing an actual tree of data and may be more performant.
   */
  getNodes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * HTML `id` of the wrapping container element joined with the `id` of the node. This will recursively increase as the tree depth increases.
   */
  htmlId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired,

  /**
   * All tree nodes must have a unique HTML `id` for users of assistive technology. If no `id` key is present in the  is provided, one will be generated.
   */
  index: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * Determines if nodes in the top-level of the tree.
   */
  initial: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /*
   * Class names to be added to the top-level `ul` element.
   */
  initalClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  initialStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * The text of the tree item.
   */
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * The number of nestings. Determines the ARIA level and style alignment.
   */
  level: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,

  /**
   * The current node that is being rendered.
   */
  node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,

  /**
   * Function that will run whenever an item or branch is selected (click or keyboard).
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * This function triggers when the expand or collapse icon is clicked.
   */
  onExpand: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,

  /**
   * Highlights term if found in node label
   */
  searchTerm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Unique id used for a prefix of all tree nodes. This is the prefix for subsequent `htmlId` props.
   */
  treeId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Location of node (zero index). First node is `0`. It's first child is `0-0`. This can be used to modify your nodes without searching for the node. This index is only valid if the `nodes` prop is the same as at the time of the event.
   */
  treeIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Flattened tree structure.
   */
  flattenedNodes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object),

  /**
   * Tree indexes of nodes that are currently selected.
   */
  selectedNodeIndexes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),

  /**
   * Tree index of the node that is currently focused.
   */
  focusedNodeIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Callback for when a node is blurred.
   */
  onNodeBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Sets focus on render.
   */
  treeHasFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * This node's parent.
   */
  parent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
Branch.defaultProps = {
  level: 0,
  label: '',
  treeIndex: '',
  selectedNodeIndexes: []
};
/* harmony default export */ __webpack_exports__["a"] = (Branch);
//# sourceMappingURL=branch.js.map

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isfunction__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isfunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isfunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_highlighter__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_event__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utilities_key_code__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utilities_key_callbacks__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utilities_constants__ = __webpack_require__(2);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// # Tree Item Component
// Implements the [Tree design pattern](https://www.lightningdesignsystem.com/components/tree/) in React.
// ### React











var handleSelect = function handleSelect(_ref) {
  var event = _ref.event,
      props = _ref.props,
      fromFocus = _ref.fromFocus;
  __WEBPACK_IMPORTED_MODULE_6__utilities_event__["a" /* default */].trap(event);

  if (__WEBPACK_IMPORTED_MODULE_3_lodash_isfunction___default()(props.onSelect)) {
    props.onSelect({
      event: event,
      data: {
        node: props.node,
        select: !props.node.selected,
        treeIndex: props.treeIndex
      },
      fromFocus: fromFocus
    });
  }
};

var findNextNode = function findNextNode(flattenedNodes, node) {
  var nodes = flattenedNodes.map(function (flattenedNode) {
    return flattenedNode.node;
  });
  var index = nodes.indexOf(node);
  return flattenedNodes[(index + 1) % flattenedNodes.length];
};

var findPreviousNode = function findPreviousNode(flattenedNodes, node) {
  var nodes = flattenedNodes.map(function (flattenedNode) {
    return flattenedNode.node;
  });
  var index = nodes.indexOf(node) - 1;

  if (index < 0) {
    index += flattenedNodes.length;
  }

  return flattenedNodes[index];
};

var handleKeyDownDown = function handleKeyDownDown(event, props) {
  if (props.focusedNodeIndex === props.treeIndex) {
    // Select the next visible node
    var flattenedNode = findNextNode(props.flattenedNodes, props.node);
    props.onSelect({
      event: event,
      data: {
        node: flattenedNode.node,
        select: true,
        treeIndex: flattenedNode.treeIndex
      },
      clearSelectedNodes: true
    });
  }
};

var handleKeyDownUp = function handleKeyDownUp(event, props) {
  if (props.focusedNodeIndex === props.treeIndex) {
    // Go to the previous visible node
    var flattenedNode = findPreviousNode(props.flattenedNodes, props.node);
    props.onSelect({
      event: event,
      data: {
        node: flattenedNode.node,
        select: true,
        treeIndex: flattenedNode.treeIndex
      },
      clearSelectedNodes: true
    });
  }
};

var handleKeyDownLeft = function handleKeyDownLeft(event, props) {
  var nodes = props.flattenedNodes.map(function (flattenedNode) {
    return flattenedNode.node;
  });
  var index = nodes.indexOf(props.parent);

  if (index !== -1) {
    props.onExpand({
      event: event,
      data: {
        node: props.parent,
        select: true,
        expand: !props.parent.expanded,
        treeIndex: props.flattenedNodes[index].treeIndex
      }
    });
  }
};

var handleKeyDownEnter = function handleKeyDownEnter(event, props) {
  handleSelect({
    event: event,
    props: props
  });
};

var handleKeyDown = function handleKeyDown(event, props) {
  var _callbacks;

  Object(__WEBPACK_IMPORTED_MODULE_8__utilities_key_callbacks__["a" /* default */])(event, {
    callbacks: (_callbacks = {}, _defineProperty(_callbacks, __WEBPACK_IMPORTED_MODULE_7__utilities_key_code__["a" /* default */].DOWN, {
      callback: function callback(evt) {
        return handleKeyDownDown(evt, props);
      }
    }), _defineProperty(_callbacks, __WEBPACK_IMPORTED_MODULE_7__utilities_key_code__["a" /* default */].UP, {
      callback: function callback(evt) {
        return handleKeyDownUp(evt, props);
      }
    }), _defineProperty(_callbacks, __WEBPACK_IMPORTED_MODULE_7__utilities_key_code__["a" /* default */].LEFT, {
      callback: function callback(evt) {
        return handleKeyDownLeft(evt, props);
      }
    }), _defineProperty(_callbacks, __WEBPACK_IMPORTED_MODULE_7__utilities_key_code__["a" /* default */].ENTER, {
      callback: function callback(evt) {
        return handleKeyDownEnter(evt, props);
      }
    }), _callbacks)
  });
};

var handleFocus = function handleFocus(event, props) {
  if (!props.treeHasFocus && !props.focusedNodeIndex && event.target === event.currentTarget) {
    handleSelect({
      event: event,
      props: props
    });
  }
};

var getTabIndex = function getTabIndex(props) {
  var initialFocus = props.selectedNodeIndexes.length === 0 && props.treeIndex === props.flattenedNodes[0].treeIndex;
  return props.treeIndex === props.focusedNodeIndex || initialFocus ? 0 : -1;
};
/**
 * A Tree Item is a non-branching node in a hierarchical list.
 */


var Item = function Item(props) {
  var isSelected = props.node.selected;
  var isFocused = props.treeIndex === props.focusedNodeIndex;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
    id: "".concat(props.treeId, "-").concat(props.node.id),
    role: "treeitem",
    "aria-level": props.level,
    "aria-selected": isSelected ? 'true' : 'false',
    tabIndex: getTabIndex(props),
    onKeyDown: function onKeyDown(event) {
      return handleKeyDown(event, props);
    },
    onFocus: function onFocus(event) {
      return handleFocus(event, props);
    },
    onBlur: props.onNodeBlur,
    ref: function ref(component) {
      if (props.treeHasFocus && component && isFocused) {
        component.focus();
      }
    }
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('slds-tree__item', {
      'slds-is-selected': isSelected
    }),
    onClick: function onClick(event) {
      handleSelect({
        event: event,
        props: props
      });
    }
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__button__["a" /* default */], {
    tabIndex: "-1",
    assistiveText: {
      icon: ''
    },
    role: "presentation",
    iconCategory: "utility",
    iconName: "chevronright",
    iconSize: "small",
    variant: "icon",
    className: "slds-m-right--small slds-is-disabled",
    disabled: true
  }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "slds-size_1-of-1"
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__utilities_highlighter__["a" /* default */], {
    search: props.searchTerm,
    className: "slds-tree__item-label slds-truncate"
  }, props.label))));
}; // ### Display Name
// Always use the canonical component name as the React display name.


Item.displayName = __WEBPACK_IMPORTED_MODULE_9__utilities_constants__["_33" /* TREE_ITEM */]; // ### Prop Types

Item.propTypes = {
  /**
   * HTML `id` of the wrapping container element joined with the `id` of the node. This will recursively increase as the tree depth increases.
   */
  htmlId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,

  /**
   * The text of the tree item.
   */
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired,

  /**
   * The number of nestings. Determines the ARIA level and style alignment.
   */
  level: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,

  /**
   * The current node that is being rendered.
   */
  node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,

  /**
   * This function triggers when the expand or collapse icon is clicked or due to keyboard navigation.
   */
  onExpand: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,

  /**
   * Function that will run whenever an item or branch is selected (click or keyboard).
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Highlights term if found in node label
   */
  searchTerm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Unique id used for a prefix of all tree nodes
   */
  treeId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Location of node (zero index). First node is `0`. It's first child is `0-0`. This can be used to modify your nodes without searching for the node. This index is only valid if the `nodes` prop is the same as at the time of the event.
   */
  treeIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Flattened tree structure.
   */
  flattenedNodes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object),

  /**
   * Tree indexes of nodes that are currently selected.
   */
  selectedNodeIndexes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),

  /**
   * Tree index of the node that is currently focused.
   */
  focusedNodeIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Callback for when a node is blurred.
   */
  onNodeBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Sets focus on render.
   */
  treeHasFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * This node's parent.
   */
  parent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
Item.defaultProps = {
  selected: false,
  selectedNodeIndexes: []
};
/* harmony default export */ __webpack_exports__["a"] = (Item);
//# sourceMappingURL=item.js.map

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);
var RegExpPropType = __webpack_require__(289);
var escapeStringRegexp = __webpack_require__(290);
var blacklist = __webpack_require__(291);
var createReactClass = __webpack_require__(4);
var PropTypes = __webpack_require__(1);

var Highlighter = createReactClass({
  displayName: 'Highlighter',
  count: 0,
  propTypes: {
    search: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.bool,
      RegExpPropType
    ]).isRequired,
    caseSensitive: PropTypes.bool,
    matchElement: PropTypes.string,
    matchClass: PropTypes.string,
    matchStyle: PropTypes.object
  },

  render: function() {
    var props = blacklist(
      this.props,
      'search',
      'caseSensitive',
      'matchElement',
      'matchClass',
      'matchStyle'
    );

    return React.createElement('span', props, this.renderElement(this.props.children));
  },

  /**
   * A wrapper to the highlight method to determine when the highlighting
   * process should occur.
   *
   * @param  {string} subject
   *   The body of text that will be searched for highlighted words.
   *
   * @return {Array}
   *   An array of ReactElements
   */
  renderElement: function(subject) {
    if (this.isScalar() && this.hasSearch()) {
      var search = this.getSearch();
      return this.highlightChildren(subject, search);
    }

    return this.props.children;
  },

  /**
   * Determine if props are valid types for processing.
   *
   * @return {Boolean}
   */
  isScalar: function() {
    return (/string|number|boolean/).test(typeof this.props.children);
  },

  /**
   * Determine if required search prop is defined and valid.
   *
   * @return {Boolean}
   */
  hasSearch: function() {
    return (typeof this.props.search !== 'undefined') && this.props.search;
  },

  /**
   * Get the search prop, but always in the form of a regular expression. Use
   * this as a proxy to this.props.search for consistency.
   *
   * @return {RegExp}
   */
  getSearch: function() {
    if (this.props.search instanceof RegExp) {
      return this.props.search;
    }

    var flags = '';
    if (!this.props.caseSensitive) {
      flags +='i';
    }

    var search = this.props.search;
    if (typeof this.props.search === 'string') {
      search = escapeStringRegexp(search);
    }

    return new RegExp(search, flags);
  },

  /**
   * Get the indexes of the first and last characters of the matched string.
   *
   * @param  {string} subject
   *   The string to search against.
   *
   * @param  {RegExp} search
   *   The regex search query.
   *
   * @return {Object}
   *   An object consisting of "first" and "last" properties representing the
   *   indexes of the first and last characters of a matching string.
   */
  getMatchBoundaries: function(subject, search) {
    var matches = search.exec(subject);
    if (matches) {
      return {
        first: matches.index,
        last: matches.index + matches[0].length
      };
    }
  },

  /**
   * Determines which strings of text should be highlighted or not.
   *
   * @param  {string} subject
   *   The body of text that will be searched for highlighted words.
   * @param  {string} search
   *   The search used to search for highlighted words.
   *
   * @return {Array}
   *   An array of ReactElements
   */
  highlightChildren: function(subject, search) {
    var children = [];
    var matchElement = this.props.matchElement;
    var remaining = subject;

    while (remaining) {
      if (!search.test(remaining)) {
        children.push(this.renderPlain(remaining));
        return children;
      }

      var boundaries = this.getMatchBoundaries(remaining, search);

      // Capture the string that leads up to a match...
      var nonMatch = remaining.slice(0, boundaries.first);
      if (nonMatch) {
        children.push(this.renderPlain(nonMatch));
      }

      // Now, capture the matching string...
      var match = remaining.slice(boundaries.first, boundaries.last);
      if (match) {
        children.push(this.renderHighlight(match, matchElement));
      }

      // And if there's anything left over, recursively run this method again.
      remaining = remaining.slice(boundaries.last);

    }

    return children;
  },

  /**
   * Responsible for rending a non-highlighted element.
   *
   * @param  {string} string
   *   A string value to wrap an element around.
   *
   * @return {ReactElement}
   */
  renderPlain: function(string) {
    this.count++;
    return React.createElement('span', { key: this.count, children: string });
  },

  /**
   * Responsible for rending a highlighted element.
   *
   * @param  {string} string
   *   A string value to wrap an element around.
   *
   * @return {ReactElement}
   */
  renderHighlight: function(string) {
    this.count++;
    return React.createElement(this.props.matchElement, {
      key: this.count,
      className: this.props.matchClass,
      style: this.props.matchStyle,
      children: string
    });
  }
});

Highlighter.defaultProps = {
  caseSensitive: false,
  matchElement: 'strong',
  matchClass: 'highlight',
  matchStyle: {}
};

module.exports = Highlighter;


/***/ }),
/* 289 */
/***/ (function(module, exports) {

var regExpPropType = function (props, propName, componentName, location) {
  if (!(props[propName] instanceof RegExp)) {
    var propType = typeof props[propName];

    return new Error(
      ("Invalid " + location + " `" + propName + "` of type `" + propType + "` ") +
        ("supplied to `" + componentName + "`, expected `RegExp`.")
    );
  }
};

module.exports = regExpPropType;


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var matchOperatorsRe = /[|\\{}()[\]^$+*?.]/g;

module.exports = function (str) {
	if (typeof str !== 'string') {
		throw new TypeError('Expected a string');
	}

	return str.replace(matchOperatorsRe, '\\$&');
};


/***/ }),
/* 291 */
/***/ (function(module, exports) {

module.exports = function blacklist (src) {
  var copy = {}
  var filter = arguments[1]

  if (typeof filter === 'string') {
    filter = {}
    for (var i = 1; i < arguments.length; i++) {
      filter[arguments[i]] = true
    }
  }

  for (var key in src) {
    // blacklist?
    if (filter[key]) continue

    copy[key] = src[key]
  }

  return copy
}


/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isfunction__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isfunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isfunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// # Tree Initial Branch




var propTypes = {
  /**
   * HTML `id` of the wrapping container element.
   */
  htmlId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired,

  /*
   * Class names to be added to the top-level `ul` element.
   */
  initalClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /*
   * Styles to be added to the top-level `ul` element. Useful for `overflow:hidden`.
   */
  initialStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var handleScroll = function handleScroll(event, props) {
  var percentage = event.target.scrollTop / (event.target.scrollHeight - event.target.clientHeight) * 100;

  if (__WEBPACK_IMPORTED_MODULE_2_lodash_isfunction___default()(props.onScroll)) {
    props.onScroll(event, {
      percentage: percentage
    });
  }
};

var renderInitialNode = function renderInitialNode(children, props) {
  return (// id intentionally not rendered here, and is present on
    // container that includes the header
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
      "aria-labelledby": "".concat(props.htmlId, "__heading"),
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('slds-tree', props.initalClassName),
      onScroll: function onScroll(event) {
        handleScroll(event, props);
      },
      role: "tree",
      style: props.initialStyle
    }, children)
  );
};

renderInitialNode.displayName = 'TreeInitialNode';
renderInitialNode.propTypes = propTypes;
/* harmony default export */ __webpack_exports__["a"] = (renderInitialNode);
//# sourceMappingURL=render-initial-branch.js.map

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isfunction__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isfunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isfunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__button__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_highlighter__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_event__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utilities_key_code__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utilities_key_callbacks__ = __webpack_require__(39);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */
// # Tree Branch Component
// Implements the [Tree design pattern](https://www.lightningdesignsystem.com/components/tree/) in React.
// ## Dependencies



 // Child components






var propTypes = {
  /**
   * HTML `id` of primary element that has `.slds-tree` on it. This component has a wrapping container element outside of `.slds-tree`.
   */
  htmlId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired,

  /**
   * The text of the tree item.
   */
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  /**
   * The number of nestings. Determines the ARIA level and style alignment.
   */
  level: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,

  /**
   * The current node that is being rendered.
   */
  node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,

  /**
   * This function triggers when the expand or collapse icon is clicked or due to keyboard navigation.
   */
  onExpand: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,

  /**
   * Function that will run whenever an item or branch is clicked.
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Highlights term if found in node label
   */
  searchTerm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Location of node (zero index). First node is `0`. It's first child is `0-0`. This can be used to modify your nodes without searching for the node. This index is only valid if the `nodes` prop is the same as at the time of the event.
   */
  treeIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Flattened tree structure.
   */
  flattenedNodes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object),

  /**
   * Tree indexes of nodes that are currently selected.
   */
  selectedNodeIndexes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),

  /**
   * Tree index of the node that is currently focused.
   */
  focusedNodeIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Callback for when a node is blurred.
   */
  onNodeBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Sets focus on render.
   */
  treeHasFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * This node's parent.
   */
  parent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var handleExpand = function handleExpand(event, props) {
  __WEBPACK_IMPORTED_MODULE_6__utilities_event__["a" /* default */].trap(event);

  if (__WEBPACK_IMPORTED_MODULE_2_lodash_isfunction___default()(props.onExpand)) {
    props.onExpand({
      event: event,
      data: {
        node: props.node,
        expand: !props.node.expanded,
        treeIndex: props.treeIndex
      }
    });
  }
};

var handleSelect = function handleSelect(_ref) {
  var event = _ref.event,
      props = _ref.props,
      fromFocus = _ref.fromFocus;
  __WEBPACK_IMPORTED_MODULE_6__utilities_event__["a" /* default */].trap(event);

  if (__WEBPACK_IMPORTED_MODULE_2_lodash_isfunction___default()(props.onSelect)) {
    props.onSelect({
      event: event,
      data: {
        node: props.node,
        select: !props.node.selected,
        treeIndex: props.treeIndex
      },
      fromFocus: fromFocus
    });
  }
};

var findNextNode = function findNextNode(flattenedNodes, node) {
  var nodes = flattenedNodes.map(function (flattenedNode) {
    return flattenedNode.node;
  });
  var index = nodes.indexOf(node);
  return flattenedNodes[(index + 1) % flattenedNodes.length];
};

var findPreviousNode = function findPreviousNode(flattenedNodes, node) {
  var nodes = flattenedNodes.map(function (flattenedNode) {
    return flattenedNode.node;
  });
  var index = nodes.indexOf(node) - 1;

  if (index < 0) {
    index += flattenedNodes.length;
  }

  return flattenedNodes[index];
};

var handleKeyDownDown = function handleKeyDownDown(event, props) {
  if (props.focusedNodeIndex === props.treeIndex) {
    // Select the next visible node
    var flattenedNode = findNextNode(props.flattenedNodes, props.node);
    props.onSelect({
      event: event,
      data: {
        node: flattenedNode.node,
        select: true,
        treeIndex: flattenedNode.treeIndex
      },
      clearSelectedNodes: true
    });
  }
};

var handleKeyDownUp = function handleKeyDownUp(event, props) {
  if (props.focusedNodeIndex === props.treeIndex) {
    // Go to the previous visible node
    var flattenedNode = findPreviousNode(props.flattenedNodes, props.node);
    props.onSelect({
      event: event,
      data: {
        node: flattenedNode.node,
        select: true,
        treeIndex: flattenedNode.treeIndex
      },
      clearSelectedNodes: true
    });
  }
};

var handleKeyDownRight = function handleKeyDownRight(event, props) {
  if (props.node.expanded) {
    if (props.getNodes(props.node) && props.getNodes(props.node).length > 0) {
      handleKeyDownDown(event, props);
    }
  } else {
    handleExpand(event, props);
  }
};

var handleKeyDownLeft = function handleKeyDownLeft(event, props) {
  if (props.node.expanded) {
    handleExpand(event, props);
  } else {
    var nodes = props.flattenedNodes.map(function (flattenedNode) {
      return flattenedNode.node;
    });
    var index = nodes.indexOf(props.parent);

    if (index !== -1) {
      props.onExpand({
        event: event,
        data: {
          node: props.parent,
          select: true,
          expand: !props.parent.expanded,
          treeIndex: props.flattenedNodes[index].treeIndex
        }
      });
    }
  }
};

var handleKeyDownEnter = function handleKeyDownEnter(event, props) {
  handleSelect({
    event: event,
    props: props
  });
};

var handleKeyDown = function handleKeyDown(event, props) {
  var _callbacks;

  Object(__WEBPACK_IMPORTED_MODULE_8__utilities_key_callbacks__["a" /* default */])(event, {
    callbacks: (_callbacks = {}, _defineProperty(_callbacks, __WEBPACK_IMPORTED_MODULE_7__utilities_key_code__["a" /* default */].DOWN, {
      callback: function callback(evt) {
        return handleKeyDownDown(evt, props);
      }
    }), _defineProperty(_callbacks, __WEBPACK_IMPORTED_MODULE_7__utilities_key_code__["a" /* default */].UP, {
      callback: function callback(evt) {
        return handleKeyDownUp(evt, props);
      }
    }), _defineProperty(_callbacks, __WEBPACK_IMPORTED_MODULE_7__utilities_key_code__["a" /* default */].RIGHT, {
      callback: function callback(evt) {
        return handleKeyDownRight(evt, props);
      }
    }), _defineProperty(_callbacks, __WEBPACK_IMPORTED_MODULE_7__utilities_key_code__["a" /* default */].LEFT, {
      callback: function callback(evt) {
        return handleKeyDownLeft(evt, props);
      }
    }), _defineProperty(_callbacks, __WEBPACK_IMPORTED_MODULE_7__utilities_key_code__["a" /* default */].ENTER, {
      callback: function callback(evt) {
        return handleKeyDownEnter(evt, props);
      }
    }), _callbacks)
  });
};

var handleFocus = function handleFocus(event, props) {
  if (!props.treeHasFocus && !props.focusedNodeIndex && event.target === event.currentTarget) {
    // did it happen by mouse?
    handleSelect({
      event: event,
      props: props,
      fromFocus: true
    });
  }
};

var getTabIndex = function getTabIndex(props) {
  var initialFocus = props.selectedNodeIndexes.length === 0 && props.treeIndex === props.flattenedNodes[0].treeIndex;
  return props.treeIndex === props.focusedNodeIndex || initialFocus ? 0 : -1;
}; // Most of these props come from the nodes array, not from the Tree props


var RenderBranch = function RenderBranch(children, props) {
  var isExpanded = props.node.expanded;
  var isSelected = props.node.selected;
  var isFocused = props.treeIndex === props.focusedNodeIndex;
  var isLoading = props.node.loading;
  var loader = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    style: {
      display: 'block',
      paddingLeft: "".concat(1.5 * props.level + 1.5, "rem"),
      marginTop: '.5rem'
    }
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    style: {
      borderRadius: '15rem',
      display: 'block',
      marginBottom: '.75rem',
      height: '.5rem',
      backgroundColor: 'rgb(224, 229, 238)',
      width: '40%'
    }
  }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    style: {
      borderRadius: '15rem',
      display: 'block',
      marginBottom: '.75rem',
      height: '.5rem',
      backgroundColor: 'rgb(224, 229, 238)',
      width: '80%'
    }
  }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    style: {
      borderRadius: '15rem',
      display: 'block',
      marginBottom: '.75rem',
      height: '.5rem',
      backgroundColor: 'rgb(224, 229, 238)',
      width: '60%'
    }
  }));
  var label = props.node.assistiveText || (typeof props.node.label === 'string' ? props.node.label : null);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
    id: props.htmlId,
    role: "treeitem",
    "aria-level": props.level,
    "aria-expanded": isExpanded ? 'true' : 'false',
    "aria-label": props.node.nodes && props.node.nodes.length > 0 ? label : null,
    tabIndex: getTabIndex(props),
    onKeyDown: function onKeyDown(event) {
      return handleKeyDown(event, props);
    },
    onFocus: function onFocus(event) {
      return handleFocus(event, props);
    },
    onBlur: props.onNodeBlur,
    ref: function ref(component) {
      if (props.treeHasFocus && component && isFocused) {
        component.focus();
      }
    }
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('slds-tree__item', {
      'slds-is-selected': isSelected
    }),
    onClick: function onClick(event) {
      handleSelect({
        event: event,
        props: props
      });
    }
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__button__["a" /* default */], {
    assistiveText: {
      icon: 'Toggle'
    },
    iconCategory: "utility",
    iconName: "chevronright",
    iconSize: "small",
    variant: "icon",
    className: "slds-m-right--small",
    role: "presentation",
    "aria-controls": props.htmlId,
    onClick: function onClick(event) {
      handleExpand(event, props);
    },
    tabIndex: "-1"
  }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "slds-size_1-of-1",
    id: "".concat(props.htmlId, "__label")
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__utilities_highlighter__["a" /* default */], {
    search: props.searchTerm,
    className: "slds-tree__item-label slds-truncate"
  }, props.label))), isLoading ? loader : null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
    className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()({
      'slds-is-expanded': isExpanded,
      'slds-is-collapsed': !isExpanded
    }),
    role: "group",
    "aria-labelledby": "".concat(props.htmlId, "__label")
  }, isExpanded && !isLoading ? children : null));
};

RenderBranch.displayName = 'Branch';
RenderBranch.propTypes = propTypes;
/* harmony default export */ __webpack_exports__["a"] = (RenderBranch);
//# sourceMappingURL=render-branch.js.map

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_warning_one_of_required_property__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities_warning_sunset_property__ = __webpack_require__(11);
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable import/no-mutable-exports */



var checkProps = function checkProps() {};

if (false) {
  checkProps = function checkProps(COMPONENT, props) {
    /* eslint-disable max-len */
    oneOfRequiredProperty(COMPONENT, {
      assistiveText: props.assistiveText,
      heading: props.heading
    });
    /* eslint-enable max-len */

    if (typeof props.assistiveText === 'string') {
      sunsetProperty(COMPONENT, props.assistiveText, 'assistiveText', '`assistiveText` as a string has been deprecated and is now an object to allow for multiple uses in the component. Please use `assistiveText.label` instead.');
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (checkProps);
//# sourceMappingURL=check-props.js.map

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */

/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

/* eslint-disable no-console */

/**
 * This is a wrapper utility for logging messages to the
	user. This is helpful in using the same examples
	for the documentation site as for the Storybook examples.
 * @param  {Function} options.action function that outputs
 *   messages to Storybook
 * @param  {Event} options.event the browser event
 * @param  {String} options.eventName the name of the event
 * @param  {Object} options.data callback payload and data object
 * @param  {Function} options.customLog Custom logging function. This
 *   is helpful for Node debugging and removing console log from tests.
 */
var log = function log(_ref) {
  var action = _ref.action,
      event = _ref.event,
      eventName = _ref.eventName,
      data = _ref.data,
      customLog = _ref.customLog;

  if (customLog && event) {
    customLog({
      eventName: eventName,
      event: event,
      data: data
    });
  } else if (action && event) {
    // https://github.com/storybooks/storybook/tree/master/addons/actions
    action(eventName)(event, data);
  } else if (console && console.log) {
    console.log(eventName, event, data);
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = (log);
//# sourceMappingURL=log.js.map

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__salesforce_design_system_react__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_browserContainer__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(27);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var propTypes={appStarted:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,accessible:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,nextFunc:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};var EmailScreen=function(_Component){_inherits(EmailScreen,_Component);function EmailScreen(){_classCallCheck(this,EmailScreen);return _possibleConstructorReturn(this,(EmailScreen.__proto__||Object.getPrototypeOf(EmailScreen)).apply(this,arguments));}_createClass(EmailScreen,[{key:'renderBannerImage',value:function renderBannerImage(){var blankImgSrc=this.props.accessible?'assets/images/emailBannerBlankAlt.png':'assets/images/image1.png';var alt=this.props.accessible?__WEBPACK_IMPORTED_MODULE_5__constants__["d" /* EMAIL_BANNER */]:null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'email-banner-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('db email-image',{'opacity-0':this.props.appStarted}),src:'assets/images/emailBanner.png',alt:alt,'aria-hidden':this.props.appStarted?'true':'false'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('db email-image',{'opacity-0':!this.props.appStarted}),src:blankImgSrc,alt:alt,'aria-hidden':!this.props.appStarted?'true':'false'}));}},{key:'renderDiscountImage',value:function renderDiscountImage(){var blankImgSrc=this.props.accessible?'assets/images/discountBlankAlt.png':'assets/images/image2.png';var alt=this.props.accessible?'Discount Code: '+__WEBPACK_IMPORTED_MODULE_5__constants__["b" /* DISCOUNT_CODE */]:null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'discount-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('db email-image',{'opacity-0':this.props.appStarted}),src:'assets/images/discount.png',alt:alt,'aria-hidden':this.props.appStarted?'true':'false'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('db email-image',{'opacity-0':!this.props.appStarted}),src:blankImgSrc,alt:alt,'aria-hidden':!this.props.appStarted?'true':'false'}));}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__containers_browserContainer__["a" /* default */],{label:'Email'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'pam f4 typography-email border-b-gray'},'Register for ',__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* CONFERENCE_NAME */],'!'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pas slds-media'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'slds-media__figure'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'assets/images/blankAvatar.png',alt:'',className:'bg-gray'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'f5 slds-media__body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* CONFERENCE_NAME */]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'phxs'},'<'+__WEBPACK_IMPORTED_MODULE_5__constants__["c" /* EMAIL_ADDRESS */]+'>')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'to me')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'ht-full bg-lightGray'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ht-full slds-clearfix horz-center slds-size_2-of-3 bg-white'},this.renderBannerImage(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fl pal slds-size_2-of-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mvl'},'Dear Codey,'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'mvl'},__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* CONFERENCE_NAME */],' is just around the corner! Register now so you don\'t miss out on this amazing conference! Because you\'re a VIP, you qualify for 75% off. Just use the discount code.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Excited to see you there!'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* CONFERENCE_NAME */],' Staff')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fr pvl prm mtl slds-size_1-of-3'},this.renderDiscountImage(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__salesforce_design_system_react__["c" /* Button */],{onClick:this.props.nextFunc,className:'mtm phm pvs db horz-center',disabled:!this.props.appStarted||this.props.nextDisabled,label:'Register Now',variant:'brand'})))));}}]);return EmailScreen;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);EmailScreen.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (EmailScreen);

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__salesforce_design_system_react__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_browserContainer__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(27);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FormScreen=function(_Component){_inherits(FormScreen,_Component);function FormScreen(props){_classCallCheck(this,FormScreen);var _this=_possibleConstructorReturn(this,(FormScreen.__proto__||Object.getPrototypeOf(FormScreen)).call(this,props));_this.handleDiscountOnChange=function(event){var targetValue=event.target.value;if(targetValue!==''){if(targetValue.toLowerCase()===__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* DISCOUNT_CODE */]){_this.setState(function(prevState,props){return{hasDiscountError:false};});}else{_this.setState(function(prevState,props){return{hasDiscountError:true};});}}else{console.log(targetValue);_this.setState(function(prevState,props){return{hasDiscountError:false};});}_this.setState({discountValue:targetValue});};_this.discountField=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.state={hasDiscountError:false,discountValue:'',ticketTypeValue:'',ticketTypeSelection:[]};return _this;}_createClass(FormScreen,[{key:'componentDidMount',value:function componentDidMount(){this.discountField.current.focus();}},{key:'render',value:function render(){var _this2=this;var discountApplied=this.state.discountValue.toLowerCase()===__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* DISCOUNT_CODE */];var ticketTypes=[{id:'type-1',label:'Speaker'},{id:'type-2',label:'Attendee'},{id:'type-3',label:'Coordinator'},{id:'type-4',label:'Volunteer'}];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__containers_browserContainer__["a" /* default */],{label:'Register for '+__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* CONFERENCE_NAME */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'assets/images/emailBanner.png',alt:__WEBPACK_IMPORTED_MODULE_4__constants__["d" /* EMAIL_BANNER */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mal pam slds-box bg-white'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'f3'},'Registration for '+__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* CONFERENCE_NAME */]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'mtl slds-grid'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__salesforce_design_system_react__["h" /* Input */],{className:'prl slds-col slds-size_1-of-2',id:'first-name',label:'First Name',value:'Codey'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__salesforce_design_system_react__["h" /* Input */],{className:'prl slds-col slds-size_1-of-2',id:'last-name',label:'Last Name',value:'Bear'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'mtl slds-grid'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__salesforce_design_system_react__["h" /* Input */],{className:'prl slds-col slds-size_1-of-2',id:'email',label:'Email',value:'codey.bear@salesforce.com'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__salesforce_design_system_react__["e" /* Combobox */],{id:'ticket-type',classNameContainer:'prl wi-full',events:{onSelect:function onSelect(event,data){console.log('onSelect',event,data);_this2.setState({ticketTypeValue:'',ticketTypeSelection:data.selection});}},labels:{label:'Attendee Type',placeholder:'Select Type'},selection:this.state.ticketTypeSelection,options:ticketTypes,variant:'readonly',value:this.state.ticketTypeValue})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'mtl slds-grid slds-form-element'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'prl slds-col slds-size_1-of-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'slds-form-element__label',htmlFor:'discountCode'},'Discount Code'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slds-form-element__control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:'discountCode',className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()('slds-input',{'error-animation border-error':this.state.hasDiscountError}),'aria-describedby':'discount-code-error',onChange:this.handleDiscountOnChange,ref:this.discountField,type:'text',value:this.state.discountValue})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()('slds-form-element__help text-error',{'error-animation':this.state.hasDiscountError,'opacity-0':!this.state.hasDiscountError}),id:'discount-code-error'},'Not a valid discount code.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'prl slds-col slds-size_1-of-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'slds-form-element__label'},'Total:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,discountApplied?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'slds-assistive-text'},'Old Price:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('del',null,'$500'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'slds-assistive-text'},'New Price:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'pls f3 bold'},'$125')):'$500'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__salesforce_design_system_react__["c" /* Button */],{className:'mvl horz-center',label:'Continue',onClick:this.props.nextFunc,variant:'brand'}))));}}]);return FormScreen;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (FormScreen);

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_recapContainer__ = __webpack_require__(43);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var propTypes={accessible:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,nextFunc:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};var AltTextRecap=function(_Component){_inherits(AltTextRecap,_Component);function AltTextRecap(){_classCallCheck(this,AltTextRecap);return _possibleConstructorReturn(this,(AltTextRecap.__proto__||Object.getPrototypeOf(AltTextRecap)).apply(this,arguments));}_createClass(AltTextRecap,[{key:'renderPause',value:function renderPause(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'pbs'},'Did you notice the images in the email fade away? You\'re now looking at a representation of what a blind or low-vision person using a screen reader would hear.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'pbs'},'Check out the screen of the person across from you. What\'s different about the images?'));}},{key:'renderRecap',value:function renderRecap(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Add a brief text description to image HTML or immediately below an image to communicate its meaning to screen reader users.'));}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_recapContainer__["a" /* default */],{title:'Alternative Text for Images',nextLabel:'Continue to Step 2',nextFunc:this.props.nextFunc,pause:this.renderPause(),recap:this.renderRecap()});}}]);return AltTextRecap;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);AltTextRecap.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (AltTextRecap);

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _CSSTransitionGroup = __webpack_require__(300);

var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);

var _TransitionGroup = __webpack_require__(146);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  TransitionGroup: _TransitionGroup2.default,
  CSSTransitionGroup: _CSSTransitionGroup2.default
};

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TransitionGroup = __webpack_require__(146);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _CSSTransitionGroupChild = __webpack_require__(303);

var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);

var _PropTypes = __webpack_require__(148);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  transitionName: _PropTypes.nameShape.isRequired,

  transitionAppear: _propTypes2.default.bool,
  transitionEnter: _propTypes2.default.bool,
  transitionLeave: _propTypes2.default.bool,
  transitionAppearTimeout: (0, _PropTypes.transitionTimeout)('Appear'),
  transitionEnterTimeout: (0, _PropTypes.transitionTimeout)('Enter'),
  transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)('Leave')
};

var defaultProps = {
  transitionAppear: false,
  transitionEnter: true,
  transitionLeave: true
};

var CSSTransitionGroup = function (_React$Component) {
  _inherits(CSSTransitionGroup, _React$Component);

  function CSSTransitionGroup() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
        name: _this.props.transitionName,
        appear: _this.props.transitionAppear,
        enter: _this.props.transitionEnter,
        leave: _this.props.transitionLeave,
        appearTimeout: _this.props.transitionAppearTimeout,
        enterTimeout: _this.props.transitionEnterTimeout,
        leaveTimeout: _this.props.transitionLeaveTimeout
      }, child);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // We need to provide this childFactory so that
  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
  // leave while it is leaving.


  CSSTransitionGroup.prototype.render = function render() {
    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
  };

  return CSSTransitionGroup;
}(_react2.default.Component);

CSSTransitionGroup.displayName = 'CSSTransitionGroup';


CSSTransitionGroup.propTypes =  false ? propTypes : {};
CSSTransitionGroup.defaultProps = defaultProps;

exports.default = CSSTransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 301 */
/***/ (function(module, exports) {


module.exports = function chain(){
  var len = arguments.length
  var args = [];

  for (var i = 0; i < len; i++)
    args[i] = arguments[i]

  args = args.filter(function(fn){ return fn != null })

  if (args.length === 0) return undefined
  if (args.length === 1) return args[0]

  return args.reduce(function(current, next){
    return function chainedFunction() {
      current.apply(this, arguments);
      next.apply(this, arguments);
    };
  })
}


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children) {
  if (!children) {
    return children;
  }
  var result = {};
  _react.Children.map(children, function (child) {
    return child;
  }).forEach(function (child) {
    result[child.key] = child;
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    if (next.hasOwnProperty(key)) {
      return next[key];
    }

    return prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = {};

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (next.hasOwnProperty(prevKey)) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending.hasOwnProperty(nextKey)) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _addClass = __webpack_require__(304);

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__(306);

var _removeClass2 = _interopRequireDefault(_removeClass);

var _requestAnimationFrame = __webpack_require__(307);

var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);

var _properties = __webpack_require__(308);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(13);

var _PropTypes = __webpack_require__(148);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var events = [];
if (_properties.transitionEnd) events.push(_properties.transitionEnd);
if (_properties.animationEnd) events.push(_properties.animationEnd);

function addEndListener(node, listener) {
  if (events.length) {
    events.forEach(function (e) {
      return node.addEventListener(e, listener, false);
    });
  } else {
    setTimeout(listener, 0);
  }

  return function () {
    if (!events.length) return;
    events.forEach(function (e) {
      return node.removeEventListener(e, listener, false);
    });
  };
}

var propTypes = {
  children: _propTypes2.default.node,
  name: _PropTypes.nameShape.isRequired,

  // Once we require timeouts to be specified, we can remove the
  // boolean flags (appear etc.) and just accept a number
  // or a bool for the timeout flags (appearTimeout etc.)
  appear: _propTypes2.default.bool,
  enter: _propTypes2.default.bool,
  leave: _propTypes2.default.bool,
  appearTimeout: _propTypes2.default.number,
  enterTimeout: _propTypes2.default.number,
  leaveTimeout: _propTypes2.default.number
};

var CSSTransitionGroupChild = function (_React$Component) {
  _inherits(CSSTransitionGroupChild, _React$Component);

  function CSSTransitionGroupChild() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroupChild);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
      if (_this.props.appear) {
        _this.transition('appear', done, _this.props.appearTimeout);
      } else {
        done();
      }
    }, _this.componentWillEnter = function (done) {
      if (_this.props.enter) {
        _this.transition('enter', done, _this.props.enterTimeout);
      } else {
        done();
      }
    }, _this.componentWillLeave = function (done) {
      if (_this.props.leave) {
        _this.transition('leave', done, _this.props.leaveTimeout);
      } else {
        done();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
    this.classNameAndNodeQueue = [];
    this.transitionTimeouts = [];
  };

  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounted = true;

    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.transitionTimeouts.forEach(function (timeout) {
      clearTimeout(timeout);
    });

    this.classNameAndNodeQueue.length = 0;
  };

  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
    var node = (0, _reactDom.findDOMNode)(this);

    if (!node) {
      if (finishCallback) {
        finishCallback();
      }
      return;
    }

    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
    var timer = null;
    var removeListeners = void 0;

    (0, _addClass2.default)(node, className);

    // Need to do this to actually trigger a transition.
    this.queueClassAndNode(activeClassName, node);

    // Clean-up the animation after the specified delay
    var finish = function finish(e) {
      if (e && e.target !== node) {
        return;
      }

      clearTimeout(timer);
      if (removeListeners) removeListeners();

      (0, _removeClass2.default)(node, className);
      (0, _removeClass2.default)(node, activeClassName);

      if (removeListeners) removeListeners();

      // Usually this optional callback is used for informing an owner of
      // a leave animation and telling it to remove the child.
      if (finishCallback) {
        finishCallback();
      }
    };

    if (timeout) {
      timer = setTimeout(finish, timeout);
      this.transitionTimeouts.push(timer);
    } else if (_properties.transitionEnd) {
      removeListeners = addEndListener(node, finish);
    }
  };

  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
    var _this2 = this;

    this.classNameAndNodeQueue.push({
      className: className,
      node: node
    });

    if (!this.rafHandle) {
      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
        return _this2.flushClassNameAndNodeQueue();
      });
    }
  };

  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
    if (!this.unmounted) {
      this.classNameAndNodeQueue.forEach(function (obj) {
        // This is for to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        /* eslint-disable no-unused-expressions */
        obj.node.scrollTop;
        /* eslint-enable no-unused-expressions */
        (0, _addClass2.default)(obj.node, obj.className);
      });
    }
    this.classNameAndNodeQueue.length = 0;
    this.rafHandle = null;
  };

  CSSTransitionGroupChild.prototype.render = function render() {
    var props = _extends({}, this.props);
    delete props.name;
    delete props.appear;
    delete props.enter;
    delete props.leave;
    delete props.appearTimeout;
    delete props.enterTimeout;
    delete props.leaveTimeout;
    delete props.children;
    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
  };

  return CSSTransitionGroupChild;
}(_react2.default.Component);

CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';


CSSTransitionGroupChild.propTypes =  false ? propTypes : {};

exports.default = CSSTransitionGroupChild;
module.exports = exports['default'];

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addClass;

var _hasClass = __webpack_require__(305);

var _hasClass2 = _interopRequireDefault(_hasClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass2.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}
module.exports = exports['default'];

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hasClass;
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
module.exports = exports["default"];

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(147);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
var cancel = 'clearTimeout';
var raf = fallback;
var compatRaf = void 0;

var getKey = function getKey(vendor, k) {
  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
};

if (_inDOM2.default) {
  vendors.some(function (vendor) {
    var rafKey = getKey(vendor, 'request');

    if (rafKey in window) {
      cancel = getKey(vendor, 'cancel');
      return raf = function raf(cb) {
        return window[rafKey](cb);
      };
    }
  });
}

/* https://github.com/component/raf */
var prev = new Date().getTime();
function fallback(fn) {
  var curr = new Date().getTime(),
      ms = Math.max(0, 16 - (curr - prev)),
      req = setTimeout(fn, ms);

  prev = curr;
  return req;
}

compatRaf = function compatRaf(cb) {
  return raf(cb);
};
compatRaf.cancel = function (id) {
  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
};
exports.default = compatRaf;
module.exports = exports['default'];

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = undefined;

var _inDOM = __webpack_require__(147);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transform = 'transform';
var prefix = void 0,
    transitionEnd = void 0,
    animationEnd = void 0;
var transitionProperty = void 0,
    transitionDuration = void 0,
    transitionTiming = void 0,
    transitionDelay = void 0;
var animationName = void 0,
    animationDuration = void 0,
    animationTiming = void 0,
    animationDelay = void 0;

if (_inDOM2.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;


  exports.transform = transform = prefix + '-' + transform;
  exports.transitionProperty = transitionProperty = prefix + '-transition-property';
  exports.transitionDuration = transitionDuration = prefix + '-transition-duration';
  exports.transitionDelay = transitionDelay = prefix + '-transition-delay';
  exports.transitionTiming = transitionTiming = prefix + '-transition-timing-function';

  exports.animationName = animationName = prefix + '-animation-name';
  exports.animationDuration = animationDuration = prefix + '-animation-duration';
  exports.animationTiming = animationTiming = prefix + '-animation-delay';
  exports.animationDelay = animationDelay = prefix + '-animation-timing-function';
}

exports.transform = transform;
exports.transitionProperty = transitionProperty;
exports.transitionTiming = transitionTiming;
exports.transitionDelay = transitionDelay;
exports.transitionDuration = transitionDuration;
exports.transitionEnd = transitionEnd;
exports.animationName = animationName;
exports.animationDuration = animationDuration;
exports.animationTiming = animationTiming;
exports.animationDelay = animationDelay;
exports.animationEnd = animationEnd;
exports.default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};


function getTransitionProperties() {
  var style = document.createElement('div').style;

  var vendorMap = {
    O: function O(e) {
      return 'o' + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return 'webkit' + e;
    },
    ms: function ms(e) {
      return 'MS' + e;
    }
  };

  var vendors = Object.keys(vendorMap);

  var transitionEnd = void 0,
      animationEnd = void 0;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + 'TransitionProperty' in style) {
      prefix = '-' + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';

  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';

  style = null;

  return { animationEnd: animationEnd, transitionEnd: transitionEnd, prefix: prefix };
}

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__salesforce_design_system_react__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_browserContainer__ = __webpack_require__(34);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Session=function(_Component){_inherits(Session,_Component);function Session(props){_classCallCheck(this,Session);var _this=_possibleConstructorReturn(this,(Session.__proto__||Object.getPrototypeOf(Session)).call(this,props));_this.state={showTranscript:false};return _this;}_createClass(Session,[{key:'renderInfo',value:function renderInfo(){var session=this.props.session;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dl',{className:'slds-list_horizontal slds-wrap pts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dt',{className:'slds-item_label ptxs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__salesforce_design_system_react__["f" /* Icon */],{assistiveText:{label:'Date & Time'},category:'utility',name:'clock',size:'small',title:'Date & Time'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dd',{className:'slds-item_detail ptxs'},session.date,' \xB7 ',session.time),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dt',{className:'slds-item_label ptxs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__salesforce_design_system_react__["f" /* Icon */],{assistiveText:{label:'Location'},category:'utility',name:'location',size:'small',title:'Location'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dd',{className:'slds-item_detail ptxs'},session.location),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dt',{className:'slds-item_label pvxs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__salesforce_design_system_react__["f" /* Icon */],{assistiveText:{label:'Description'},category:'utility',name:'description',size:'small',title:'Description'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dd',{className:'slds-item_detail pvxs'},session.blurb));}},{key:'renderCaptionTrack',value:function renderCaptionTrack(){if(this.props.accessible){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('track',{'default':true,kind:'captions',src:this.props.session.captionSrc,srclang:'English'});}return null;}},{key:'renderTranscript',value:function renderTranscript(){var _this2=this;if(this.props.accessible){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__salesforce_design_system_react__["a" /* Accordion */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__salesforce_design_system_react__["b" /* AccordionPanel */],{expanded:this.state.showTranscript,id:'transcript'+this.props.session.id,onTogglePanel:function onTogglePanel(){_this2.setState({showTranscript:!_this2.state.showTranscript});},summary:'Transcript'},this.props.session.transcript));}}},{key:'renderVideo',value:function renderVideo(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('video',{width:'100%',height:'auto',className:'pvm',controls:true,muted:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:this.props.session.videoSrc,type:'video/mp4'}),this.renderCaptionTrack(),'Whoops, your browser doesn\'t support embedded videos! Sorry about your luck.');}},{key:'render',value:function render(){var session=this.props.session;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',{className:'slds-box mas session bg-white'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,session.title),this.renderInfo(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'ptm slds-text-heading_medium'},'What to expect'),this.renderVideo(),this.renderTranscript(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__salesforce_design_system_react__["c" /* Button */],{className:'mvm pam slds-align_absolute-center',disabled:this.props.nextDisabled,iconCategory:'action',iconName:'log_event',iconPosition:'left',label:'Register for '+session.title,onClick:this.props.nextFunc}));}}]);return Session;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var KeynoteSelectorScreen=function(_Component2){_inherits(KeynoteSelectorScreen,_Component2);function KeynoteSelectorScreen(){_classCallCheck(this,KeynoteSelectorScreen);return _possibleConstructorReturn(this,(KeynoteSelectorScreen.__proto__||Object.getPrototypeOf(KeynoteSelectorScreen)).apply(this,arguments));}_createClass(KeynoteSelectorScreen,[{key:'render',value:function render(){var _this4=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__containers_browserContainer__["a" /* default */],{label:'Keynotes at '+__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* CONFERENCE_NAME */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pvm phl'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'slds-align_absolute-center pam'},'Day 2 Keynotes')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'slds-grid mas'},__WEBPACK_IMPORTED_MODULE_3__data__["c" /* keynotes */].map(function(session,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:i,className:'slds-col slds-size_1-of-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Session,{session:session,accessible:_this4.props.accessible,nextFunc:_this4.props.nextFunc,nextDisabled:_this4.props.nextDisabled}));}))));}}]);return KeynoteSelectorScreen;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (KeynoteSelectorScreen);

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_recapContainer__ = __webpack_require__(43);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CaptionsRecap=function(_Component){_inherits(CaptionsRecap,_Component);function CaptionsRecap(){_classCallCheck(this,CaptionsRecap);return _possibleConstructorReturn(this,(CaptionsRecap.__proto__||Object.getPrototypeOf(CaptionsRecap)).apply(this,arguments));}_createClass(CaptionsRecap,[{key:'renderPause',value:function renderPause(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Drat! *snaps*'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'The speaker is broken on this monitor! Were you still able to understand the videos?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Check out the screen of the person across from you. Notice anything different about their videos?'));}},{key:'renderRecap',value:function renderRecap(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Have you ever tried to watch the news in a loud airport or bar?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Closed captioning benefits everyone, especially the Deaf and Hard-of-Hearing community.'));}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__containers_recapContainer__["a" /* default */],{title:'Closed Captioning',nextLabel:'Continue to Step 3',nextFunc:this.props.nextFunc,pause:this.renderPause(),recap:this.renderRecap()});}}]);return CaptionsRecap;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CaptionsRecap);

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__salesforce_design_system_react__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_browserContainer__ = __webpack_require__(34);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ErrorText=function(_Component){_inherits(ErrorText,_Component);function ErrorText(){_classCallCheck(this,ErrorText);return _possibleConstructorReturn(this,(ErrorText.__proto__||Object.getPrototypeOf(ErrorText)).apply(this,arguments));}_createClass(ErrorText,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slds-has-error'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slds-form-element__help slds-has-error',id:this.props.idPrefix+'-error'},this.props.text));}}]);return ErrorText;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var AccessibleCombobox=function(_Component2){_inherits(AccessibleCombobox,_Component2);function AccessibleCombobox(props){_classCallCheck(this,AccessibleCombobox);var _this2=_possibleConstructorReturn(this,(AccessibleCombobox.__proto__||Object.getPrototypeOf(AccessibleCombobox)).call(this,props));_this2.state={inputValue:'',pickupTime:null,selection:[],showError:false};return _this2;}_createClass(AccessibleCombobox,[{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__salesforce_design_system_react__["e" /* Combobox */],{id:this.props.id,errorText:this.props.showError||this.state.showError?this.props.errorText:null,events:{onSelect:function onSelect(event,data){if(_this3.props.action){_this3.props.action('onSelect').apply(undefined,[event].concat(_toConsumableArray(Object.keys(data).map(function(key){return data[key];}))));}_this3.setState({inputValue:'',selection:data.selection});}},labels:{label:this.props.label,placeholder:this.props.placeholder},options:this.props.options,required:this.props.required,selection:this.state.selection,value:this.state.inputValue,variant:'readonly'});}}]);return AccessibleCombobox;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var InaccessibleCombobox=function(_Component3){_inherits(InaccessibleCombobox,_Component3);function InaccessibleCombobox(props){_classCallCheck(this,InaccessibleCombobox);var _this4=_possibleConstructorReturn(this,(InaccessibleCombobox.__proto__||Object.getPrototypeOf(InaccessibleCombobox)).call(this,props));_this4.state={inputValue:'',selection:[],showError:false};return _this4;}_createClass(InaccessibleCombobox,[{key:'renderRequiredIndicator',value:function renderRequiredIndicator(){if(this.props.required){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('abbr',{className:'slds-required',title:'required'},'*');}}},{key:'renderErrorMessage',value:function renderErrorMessage(){if(this.props.showError||this.state.showError){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ErrorText,{idPrefix:this.props.id,text:this.props.errorText});}return null;}},{key:'render',value:function render(){var _this5=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slds-form-element'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'slds-form-element__label',htmlFor:this.props.id},this.renderRequiredIndicator(),this.props.label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slds-form-element__control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slds-combobox_container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('slds-combobox slds-dropdown-trigger','slds-dropdown-trigger_click','ignore-react-onclickoutside',{'slds-has-error':this.props.showError||this.state.showError})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slds-combobox__form-element slds-input-has-icon slds-input-has-icon_right',role:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{'aria-describedby':this.state.showError?this.props.id+'-error':null,autoComplete:'off',className:'slds-input slds-combobox__input',id:this.props.id,placeholder:this.props.placeholder,onBlur:function onBlur(){if(_this5.props.required)_this5.setState({showError:true});},readOnly:'',required:this.props.required,type:'text',value:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__salesforce_design_system_react__["f" /* Icon */],{category:'utility',name:'down',size:'x-small',containerClassName:'slds-icon_container slds-input__icon slds-input__icon_right',className:''})))),this.renderErrorMessage()));}}]);return InaccessibleCombobox;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var LunchSelectorScreen=function(_Component4){_inherits(LunchSelectorScreen,_Component4);function LunchSelectorScreen(props){_classCallCheck(this,LunchSelectorScreen);var _this6=_possibleConstructorReturn(this,(LunchSelectorScreen.__proto__||Object.getPrototypeOf(LunchSelectorScreen)).call(this,props));_this6.state={inputValue:'',selection:[],idSuffix:Math.floor(Math.random()*Math.floor(100)),showMealError:false,showDrinkError:false,pickupTime:'11:00',focusTrap:true};_this6.continueButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this6.selectedRadio=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this6.drink=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this6.meal=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this6.submit=_this6.submit.bind(_this6);_this6.handleKeyDown=_this6.handleKeyDown.bind(_this6);return _this6;}_createClass(LunchSelectorScreen,[{key:'componentDidMount',value:function componentDidMount(){// Focus radio as first thing
__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(this.selectedRadio.current).querySelector('input').focus();}},{key:'renderPickupTime',value:function renderPickupTime(){var _this7=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__salesforce_design_system_react__["j" /* RadioGroup */],{labels:{label:'Pick-up Time'},onChange:function onChange(event){return _this7.setState({pickupTime:event.target.value});},required:true,name:'pickupTime',className:'radio-group-horizontal'},__WEBPACK_IMPORTED_MODULE_5__data__["d" /* lunchTimes */].map(function(value){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__salesforce_design_system_react__["i" /* Radio */],{ref:_this7.state.pickupTime===value?_this7.selectedRadio:null,key:value,checked:_this7.state.pickupTime===value,id:value+_this7.state.idSuffix,label:value,value:value,variant:'base'});})));}},{key:'renderMealSelector',value:function renderMealSelector(){var MealSelector=this.props.accessible?AccessibleCombobox:InaccessibleCombobox;var id=(this.props.accessible?'accessible-meal-':'inaccessible-meal-')+this.state.idSuffix;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MealSelector,{id:id,ref:this.meal,errorText:'Meal selection is required',label:'Meal',placeholder:'Select an Option',showError:this.state.showMealError,options:__WEBPACK_IMPORTED_MODULE_5__data__["e" /* mealOptions */],required:true}));}},{key:'renderDrinkSelector',value:function renderDrinkSelector(){var DrinkSelector=this.props.accessible?AccessibleCombobox:InaccessibleCombobox;var id=(this.props.accessible?'accessible-drink-':'inaccessible-drink-')+this.state.idSuffix;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DrinkSelector,{id:id,ref:this.drink,errorText:'Drink selection is required',label:'Drink',placeholder:'Select an Option',showError:this.state.showDrinkError,options:__WEBPACK_IMPORTED_MODULE_5__data__["b" /* drinkOptions */],required:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'ptxs slds-text-title'},'Note: Bring your reusable bottle to fill up on water!'));}},{key:'renderDessertSelector',value:function renderDessertSelector(){var DessertSelector=this.props.accessible?AccessibleCombobox:InaccessibleCombobox;var id=(this.props.accessible?'accessible-dessert-':'inaccessible-dessert-')+this.state.idSuffix;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DessertSelector,{id:id,label:'Dessert',placeholder:'Select an Option',options:__WEBPACK_IMPORTED_MODULE_5__data__["a" /* dessertOptions */]}));}},{key:'submit',value:function submit(){// This is the hackiest way to do this. Sorry not sorry.
var hasDrinkError=!__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(this.drink.current).querySelector('input').value;var hasMealError=!__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(this.meal.current).querySelector('input').value;var valid=!hasDrinkError&&!hasMealError;this.setState({showDrinkError:hasDrinkError,showMealError:hasMealError});if(valid||!this.props.accessible){this.setState({finished:true});this.props.nextFunc();}}},{key:'handleKeyDown',value:function handleKeyDown(e){if(e.key==='Escape'){this.setState({focusTrap:false});}else if(e.key==='Tab'&&this.state.focusTrap){var first=__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(this.selectedRadio.current).querySelector('input');var last=__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(this.continueButton.current);if(e.shiftKey){if(e.target===first){last.focus();e.preventDefault();}}else{if(e.target===last){first.focus();e.preventDefault();}}}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__containers_browserContainer__["a" /* default */],{label:'Lunch at '+__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* CONFERENCE_NAME */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bg-lightGray',onKeyDown:this.handleKeyDown},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slds-clearfix horz-center slds-size_2-of-3 bg-white'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'slds-align_absolute-center slds-size_4-of-4',alt:'',src:'assets/images/lunchBanner.png'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'slds-align_absolute-center slds-size_4-of-4 pam text-white slds-text-heading_medium',style:{backgroundColor:'#274301'}},'Lunch Sign-Up'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'ptm slds-align_absolute-center'},'Joining us for lunch? Select your preferences below!'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'no-pointer-events pvs phl'},this.renderPickupTime(),this.renderMealSelector(),this.renderDrinkSelector(),this.renderDessertSelector(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__salesforce_design_system_react__["k" /* Textarea */],{classNameContainer:'ptm',id:'dietary-'+this.state.idSuffix,label:'Any allergies or dietary constraints?'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slds-grid phl pvs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slds-col slds-size_4-of-12'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slds-col slds-size_4-of-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__salesforce_design_system_react__["c" /* Button */],{ref:this.continueButton,disabled:this.state.finished?true:null,label:'Continue',onClick:this.submit,variant:'brand',className:'mtl slds-align_absolute-center'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slds-col slds-size_4-of-12 slds-text-align_right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'Chef Astro',src:'assets/images/chefAstro.png',className:'slds-size_2-of-4'}))))));}}]);return LunchSelectorScreen;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (LunchSelectorScreen);

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_recapContainer__ = __webpack_require__(43);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var KeyboardRecap=function(_Component){_inherits(KeyboardRecap,_Component);function KeyboardRecap(){_classCallCheck(this,KeyboardRecap);return _possibleConstructorReturn(this,(KeyboardRecap.__proto__||Object.getPrototypeOf(KeyboardRecap)).apply(this,arguments));}_createClass(KeyboardRecap,[{key:'renderPause',value:function renderPause(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Did you successfully pick a delicious lunch option?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Check in with the person across from you. Did they have a similar experience?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'These lunch sign-up forms feature custom-built dropdown menus for selecting food options, and they work perfectly with a functional mouse. But only the developer for the form on ',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,this.props.accessible?'your':'the other person\'s',' screen'),' ','built it with both mouse and keyboard users in mind.'));}},{key:'renderRecap',value:function renderRecap(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Some people navigate primarily with a mouse, some primarily with a keyboard.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Ensure every user can complete their tasks regardless of which input device they use.'));}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__containers_recapContainer__["a" /* default */],{accessible:this.props.accessible,title:'Keyboard Interactivity',nextLabel:'Review',nextFunc:this.props.nextFunc,pause:this.renderPause(),recap:this.renderRecap()});}}]);return KeyboardRecap;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (KeyboardRecap);

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__salesforce_design_system_react__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_browserContainer__ = __webpack_require__(34);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Session=function(_Component){_inherits(Session,_Component);function Session(){_classCallCheck(this,Session);return _possibleConstructorReturn(this,(Session.__proto__||Object.getPrototypeOf(Session)).apply(this,arguments));}_createClass(Session,[{key:'renderColors',value:function renderColors(){if(!this.props.session.workshop){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'df df-vert-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'dib session-capacity border-gray-thick bg-track2'}),this.props.accessible?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'mls dib f4 text-track2 bold'},'General'):null);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'df df-vert-center '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'dib session-capacity border-gray-thick bg-track1'}),this.props.accessible?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'mls dib f4 text-track1 bold'},'Workshop'):null);}}},{key:'render',value:function render(){var session=this.props.session;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mlm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'mrs caps'},'Breakout'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__salesforce_design_system_react__["f" /* Icon */],{assistiveText:{label:'Date & Time'},category:'utility',className:'mrs',name:'clock',size:'small',title:'Date & Time'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'45 minutes')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'df df-vert-center f3 pvxs bold'},session.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'pbs measure'},session.blurb),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dl',{className:'slds-list_horizontal slds-wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dt',{className:'slds-item_label ptxs bold'},'Speaker:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dl',{className:'slds-item_detail ptxs pll'},session.speaker),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dt',{className:'slds-item_label ptxs bold'},'Location:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dl',{className:'slds-item_detail ptxs pll'},session.location),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dt',{className:'slds-item_label ptxs bold'},'Track:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('dl',{className:'slds-item_detail ptxs pll'},this.renderColors())));}}]);return Session;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;var SessionSelectorScreen=function(_Component2){_inherits(SessionSelectorScreen,_Component2);function SessionSelectorScreen(props){_classCallCheck(this,SessionSelectorScreen);var _this2=_possibleConstructorReturn(this,(SessionSelectorScreen.__proto__||Object.getPrototypeOf(SessionSelectorScreen)).call(this,props));_this2.handleCheckboxOnchange=function(session){return function(){_this2.setState({selection:[].concat(_toConsumableArray(_this2.state.selection),[session])});};};_this2.handleRegisterOnclick=function(){_this2.props.nextFunc();var workshops=[];var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=_this2.state.selection[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var session=_step.value;if(session.workshop)workshops.push(session);}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}console.log(workshops,_this2.state.selection);var correctSelection=workshops.length>=2;if(!correctSelection){_this2.setState(function(prevState,props){return{error:true};});}};_this2.state={error:false,selection:[]};return _this2;}_createClass(SessionSelectorScreen,[{key:'renderAlert',value:function renderAlert(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mbm slds-notify slds-notify_alert slds-theme_alert-texture slds-theme_error',role:'alert'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'f4 measure'},'Sign up for at least two workshops!'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slds-notify__close'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__salesforce_design_system_react__["c" /* Button */],{assistiveText:{label:'close'},iconCategory:'utility',className:'mrs',iconName:'close',iconSize:'small',inverse:true,variant:'icon'})));}},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__containers_browserContainer__["a" /* default */],{currentScreenIndex:this.props.currentScreenIndex,label:'Sessions at '+__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* CONFERENCE_NAME */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'mbl slds-box mas session bg-white'},this.state.error?this.renderAlert():null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pam df df-between bg-darkTeal text-white'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'f3'},'Thursday Sessions'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__salesforce_design_system_react__["c" /* Button */],{className:'',disabled:this.props.nextDisabled,iconCategory:'action',iconName:'log_event',iconPosition:'left',label:'Sign up',onClick:this.handleRegisterOnclick,variant:'neutral'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'mas'},__WEBPACK_IMPORTED_MODULE_3__data__["f" /* sessions */].map(function(session,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'df pvm border-b-gray session',key:'session-'+i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__salesforce_design_system_react__["d" /* Checkbox */],{assistiveText:{label:session.title},labels:{label:''},onChange:_this3.handleCheckboxOnchange(session)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Session,{accessible:_this3.props.accessible,currentScreenIndex:_this3.props.currentScreenIndex,nextFunc:_this3.props.nextFunc,nextDisabled:_this3.props.nextDisabled,session:session}));}))));}}]);return SessionSelectorScreen;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SessionSelectorScreen);

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_recapContainer__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var propTypes={accessible:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,nextFunc:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};var ColorRecap=function(_Component){_inherits(ColorRecap,_Component);function ColorRecap(){_classCallCheck(this,ColorRecap);return _possibleConstructorReturn(this,(ColorRecap.__proto__||Object.getPrototypeOf(ColorRecap)).apply(this,arguments));}_createClass(ColorRecap,[{key:'renderPause',value:function renderPause(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Based on your attendee type, you\'re only eligible to sign up for some of these sessions. What visual cues are there to let you know?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Check out the screen of the person across from you.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'On both screens, sessions have a blue or orange dot next to the session name. What does ',this.props.accessible?'your':'the other',' screen have that ',this.props.accessible?'the other screen':'yours',' doesn\'t?'));}},{key:'renderRecap',value:function renderRecap(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'You can use color to ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'help'),' convey status or categorization, but always paired it with text or iconography so everyone, including colorblind viewers, can understand your content.'));}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__containers_recapContainer__["a" /* default */],{title:'Color as Meaning',nextLabel:'Continue to Step 4',nextFunc:this.props.nextFunc,pause:this.renderPause(),recap:this.renderRecap()});}}]);return ColorRecap;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ColorRecap.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (ColorRecap);

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Finale=function(_Component){_inherits(Finale,_Component);function Finale(){_classCallCheck(this,Finale);return _possibleConstructorReturn(this,(Finale.__proto__||Object.getPrototypeOf(Finale)).apply(this,arguments));}_createClass(Finale,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-white finale'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'bold',style:{fontSize:'3rem'}},'Key Takeaways'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ol',{className:'plm f1 slds-list_ordered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'ptl'},'Add alternative text for images.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'ptl'},'Include captions or transcripts for videos.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'ptl'},'Use more than color to convey meaning.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'ptl'},'Allow interaction with any input device.')));}}]);return Finale;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Finale);

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("/include-every-customer",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl="/include-every-customer"+'/service-worker.js';if(isLocalhost){// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);// Add some additional logging to localhost, pointing developers to the
// service worker/PWA documentation.
navigator.serviceWorker.ready.then(function(){console.log('This web app is being served cache-first by a service '+'worker. To learn more, visit https://goo.gl/SC7cgQ');});}else{// Is not local host. Just register service worker
registerValidSW(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.4b46e340.js